var p6 = Object.defineProperty;
var c1 = (e) => {
  throw TypeError(e);
};
var h6 = (e, t, n) => t in e ? p6(e, t, { enumerable: !0, configurable: !0, writable: !0, value: n }) : e[t] = n;
var mi = (e, t, n) => h6(e, typeof t != "symbol" ? t + "" : t, n), f1 = (e, t, n) => t.has(e) || c1("Cannot " + n);
var d1 = (e, t, n) => (f1(e, t, "read from private field"), n ? n.call(e) : t.get(e)), p1 = (e, t, n) => t.has(e) ? c1("Cannot add the same private member more than once") : t instanceof WeakSet ? t.add(e) : t.set(e, n), lh = (e, t, n, r) => (f1(e, t, "write to private field"), r ? r.call(e, n) : t.set(e, n), n);
import * as ee from "react";
import H, { useState as Ke, createContext as He, useRef as ve, useLayoutEffect as m6, useEffect as ze, useId as oy, useContext as je, useInsertionEffect as ay, useMemo as Fe, useCallback as Le, Children as v6, isValidElement as QS, Fragment as sy, createElement as g6, forwardRef as fn, Component as Wd, useReducer as JS, cloneElement as XS, version as y6, memo as Lm, PureComponent as e$, useImperativeHandle as b6 } from "react";
import _6, { createPortal as ba, flushSync as ly, unstable_batchedUpdates as w6 } from "react-dom";
import x6, { keyframes as E6 } from "styled-components";
import { DndContext as S6, DndProvider as h1, useDrag as t$, useDrop as $6 } from "react-dnd";
import { HTML5Backend as k6 } from "react-dnd-html5-backend";
import { toast as Er } from "react-toastify";
import { useMutation as uy, useQuery as Zd, QueryClientProvider as T6 } from "@tanstack/react-query";
import { useField as O6 } from "formik";
import { Link as es } from "react-router-dom";
import { Outlet as P6 } from "react-router";
import * as cy from "@apollo/client";
import { gql as ui } from "@apollo/client";
import { pdfjs as m1, Document as A6, Page as D6 } from "react-pdf";
function fy(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
var Ec = { exports: {} }, Pl = {};
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var v1;
function C6() {
  if (v1) return Pl;
  v1 = 1;
  var e = H, t = Symbol.for("react.element"), n = Symbol.for("react.fragment"), r = Object.prototype.hasOwnProperty, i = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, o = { key: !0, ref: !0, __self: !0, __source: !0 };
  function a(s, l, u) {
    var c, f = {}, d = null, p = null;
    u !== void 0 && (d = "" + u), l.key !== void 0 && (d = "" + l.key), l.ref !== void 0 && (p = l.ref);
    for (c in l) r.call(l, c) && !o.hasOwnProperty(c) && (f[c] = l[c]);
    if (s && s.defaultProps) for (c in l = s.defaultProps, l) f[c] === void 0 && (f[c] = l[c]);
    return { $$typeof: t, type: s, key: d, ref: p, props: f, _owner: i.current };
  }
  return Pl.Fragment = n, Pl.jsx = a, Pl.jsxs = a, Pl;
}
var Al = {};
/**
 * @license React
 * react-jsx-runtime.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var g1;
function I6() {
  return g1 || (g1 = 1, process.env.NODE_ENV !== "production" && (function() {
    var e = H, t = Symbol.for("react.element"), n = Symbol.for("react.portal"), r = Symbol.for("react.fragment"), i = Symbol.for("react.strict_mode"), o = Symbol.for("react.profiler"), a = Symbol.for("react.provider"), s = Symbol.for("react.context"), l = Symbol.for("react.forward_ref"), u = Symbol.for("react.suspense"), c = Symbol.for("react.suspense_list"), f = Symbol.for("react.memo"), d = Symbol.for("react.lazy"), p = Symbol.for("react.offscreen"), h = Symbol.iterator, v = "@@iterator";
    function m(L) {
      if (L === null || typeof L != "object")
        return null;
      var ye = h && L[h] || L[v];
      return typeof ye == "function" ? ye : null;
    }
    var g = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function _(L) {
      {
        for (var ye = arguments.length, De = new Array(ye > 1 ? ye - 1 : 0), Qe = 1; Qe < ye; Qe++)
          De[Qe - 1] = arguments[Qe];
        x("error", L, De);
      }
    }
    function x(L, ye, De) {
      {
        var Qe = g.ReactDebugCurrentFrame, ht = Qe.getStackAddendum();
        ht !== "" && (ye += "%s", De = De.concat([ht]));
        var wt = De.map(function(it) {
          return String(it);
        });
        wt.unshift("Warning: " + ye), Function.prototype.apply.call(console[L], console, wt);
      }
    }
    var w = !1, $ = !1, k = !1, D = !1, E = !1, b;
    b = Symbol.for("react.module.reference");
    function y(L) {
      return !!(typeof L == "string" || typeof L == "function" || L === r || L === o || E || L === i || L === u || L === c || D || L === p || w || $ || k || typeof L == "object" && L !== null && (L.$$typeof === d || L.$$typeof === f || L.$$typeof === a || L.$$typeof === s || L.$$typeof === l || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      L.$$typeof === b || L.getModuleId !== void 0));
    }
    function S(L, ye, De) {
      var Qe = L.displayName;
      if (Qe)
        return Qe;
      var ht = ye.displayName || ye.name || "";
      return ht !== "" ? De + "(" + ht + ")" : De;
    }
    function P(L) {
      return L.displayName || "Context";
    }
    function M(L) {
      if (L == null)
        return null;
      if (typeof L.tag == "number" && _("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof L == "function")
        return L.displayName || L.name || null;
      if (typeof L == "string")
        return L;
      switch (L) {
        case r:
          return "Fragment";
        case n:
          return "Portal";
        case o:
          return "Profiler";
        case i:
          return "StrictMode";
        case u:
          return "Suspense";
        case c:
          return "SuspenseList";
      }
      if (typeof L == "object")
        switch (L.$$typeof) {
          case s:
            var ye = L;
            return P(ye) + ".Consumer";
          case a:
            var De = L;
            return P(De._context) + ".Provider";
          case l:
            return S(L, L.render, "ForwardRef");
          case f:
            var Qe = L.displayName || null;
            return Qe !== null ? Qe : M(L.type) || "Memo";
          case d: {
            var ht = L, wt = ht._payload, it = ht._init;
            try {
              return M(it(wt));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var T = Object.assign, V = 0, z, U, B, N, C, G, re;
    function ie() {
    }
    ie.__reactDisabledLog = !0;
    function X() {
      {
        if (V === 0) {
          z = console.log, U = console.info, B = console.warn, N = console.error, C = console.group, G = console.groupCollapsed, re = console.groupEnd;
          var L = {
            configurable: !0,
            enumerable: !0,
            value: ie,
            writable: !0
          };
          Object.defineProperties(console, {
            info: L,
            log: L,
            warn: L,
            error: L,
            group: L,
            groupCollapsed: L,
            groupEnd: L
          });
        }
        V++;
      }
    }
    function Se() {
      {
        if (V--, V === 0) {
          var L = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: T({}, L, {
              value: z
            }),
            info: T({}, L, {
              value: U
            }),
            warn: T({}, L, {
              value: B
            }),
            error: T({}, L, {
              value: N
            }),
            group: T({}, L, {
              value: C
            }),
            groupCollapsed: T({}, L, {
              value: G
            }),
            groupEnd: T({}, L, {
              value: re
            })
          });
        }
        V < 0 && _("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var me = g.ReactCurrentDispatcher, fe;
    function Q(L, ye, De) {
      {
        if (fe === void 0)
          try {
            throw Error();
          } catch (ht) {
            var Qe = ht.stack.trim().match(/\n( *(at )?)/);
            fe = Qe && Qe[1] || "";
          }
        return `
` + fe + L;
      }
    }
    var A = !1, O;
    {
      var R = typeof WeakMap == "function" ? WeakMap : Map;
      O = new R();
    }
    function j(L, ye) {
      if (!L || A)
        return "";
      {
        var De = O.get(L);
        if (De !== void 0)
          return De;
      }
      var Qe;
      A = !0;
      var ht = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var wt;
      wt = me.current, me.current = null, X();
      try {
        if (ye) {
          var it = function() {
            throw Error();
          };
          if (Object.defineProperty(it.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(it, []);
            } catch (Yn) {
              Qe = Yn;
            }
            Reflect.construct(L, [], it);
          } else {
            try {
              it.call();
            } catch (Yn) {
              Qe = Yn;
            }
            L.call(it.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (Yn) {
            Qe = Yn;
          }
          L();
        }
      } catch (Yn) {
        if (Yn && Qe && typeof Yn.stack == "string") {
          for (var tt = Yn.stack.split(`
`), jn = Qe.stack.split(`
`), Xt = tt.length - 1, sn = jn.length - 1; Xt >= 1 && sn >= 0 && tt[Xt] !== jn[sn]; )
            sn--;
          for (; Xt >= 1 && sn >= 0; Xt--, sn--)
            if (tt[Xt] !== jn[sn]) {
              if (Xt !== 1 || sn !== 1)
                do
                  if (Xt--, sn--, sn < 0 || tt[Xt] !== jn[sn]) {
                    var xr = `
` + tt[Xt].replace(" at new ", " at ");
                    return L.displayName && xr.includes("<anonymous>") && (xr = xr.replace("<anonymous>", L.displayName)), typeof L == "function" && O.set(L, xr), xr;
                  }
                while (Xt >= 1 && sn >= 0);
              break;
            }
        }
      } finally {
        A = !1, me.current = wt, Se(), Error.prepareStackTrace = ht;
      }
      var Ya = L ? L.displayName || L.name : "", Zo = Ya ? Q(Ya) : "";
      return typeof L == "function" && O.set(L, Zo), Zo;
    }
    function q(L, ye, De) {
      return j(L, !1);
    }
    function Y(L) {
      var ye = L.prototype;
      return !!(ye && ye.isReactComponent);
    }
    function ae(L, ye, De) {
      if (L == null)
        return "";
      if (typeof L == "function")
        return j(L, Y(L));
      if (typeof L == "string")
        return Q(L);
      switch (L) {
        case u:
          return Q("Suspense");
        case c:
          return Q("SuspenseList");
      }
      if (typeof L == "object")
        switch (L.$$typeof) {
          case l:
            return q(L.render);
          case f:
            return ae(L.type, ye, De);
          case d: {
            var Qe = L, ht = Qe._payload, wt = Qe._init;
            try {
              return ae(wt(ht), ye, De);
            } catch {
            }
          }
        }
      return "";
    }
    var te = Object.prototype.hasOwnProperty, ue = {}, Pe = g.ReactDebugCurrentFrame;
    function de(L) {
      if (L) {
        var ye = L._owner, De = ae(L.type, L._source, ye ? ye.type : null);
        Pe.setExtraStackFrame(De);
      } else
        Pe.setExtraStackFrame(null);
    }
    function Ee(L, ye, De, Qe, ht) {
      {
        var wt = Function.call.bind(te);
        for (var it in L)
          if (wt(L, it)) {
            var tt = void 0;
            try {
              if (typeof L[it] != "function") {
                var jn = Error((Qe || "React class") + ": " + De + " type `" + it + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof L[it] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw jn.name = "Invariant Violation", jn;
              }
              tt = L[it](ye, it, Qe, De, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (Xt) {
              tt = Xt;
            }
            tt && !(tt instanceof Error) && (de(ht), _("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", Qe || "React class", De, it, typeof tt), de(null)), tt instanceof Error && !(tt.message in ue) && (ue[tt.message] = !0, de(ht), _("Failed %s type: %s", De, tt.message), de(null));
          }
      }
    }
    var ce = Array.isArray;
    function Ue(L) {
      return ce(L);
    }
    function et(L) {
      {
        var ye = typeof Symbol == "function" && Symbol.toStringTag, De = ye && L[Symbol.toStringTag] || L.constructor.name || "Object";
        return De;
      }
    }
    function gn(L) {
      try {
        return ge(L), !1;
      } catch {
        return !0;
      }
    }
    function ge(L) {
      return "" + L;
    }
    function Ce(L) {
      if (gn(L))
        return _("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", et(L)), ge(L);
    }
    var Ye = g.ReactCurrentOwner, Xe = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, lt, F;
    function K(L) {
      if (te.call(L, "ref")) {
        var ye = Object.getOwnPropertyDescriptor(L, "ref").get;
        if (ye && ye.isReactWarning)
          return !1;
      }
      return L.ref !== void 0;
    }
    function W(L) {
      if (te.call(L, "key")) {
        var ye = Object.getOwnPropertyDescriptor(L, "key").get;
        if (ye && ye.isReactWarning)
          return !1;
      }
      return L.key !== void 0;
    }
    function le(L, ye) {
      typeof L.ref == "string" && Ye.current;
    }
    function pe(L, ye) {
      {
        var De = function() {
          lt || (lt = !0, _("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", ye));
        };
        De.isReactWarning = !0, Object.defineProperty(L, "key", {
          get: De,
          configurable: !0
        });
      }
    }
    function xe(L, ye) {
      {
        var De = function() {
          F || (F = !0, _("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", ye));
        };
        De.isReactWarning = !0, Object.defineProperty(L, "ref", {
          get: De,
          configurable: !0
        });
      }
    }
    var _e = function(L, ye, De, Qe, ht, wt, it) {
      var tt = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: t,
        // Built-in properties that belong on the element
        type: L,
        key: ye,
        ref: De,
        props: it,
        // Record the component responsible for creating this element.
        _owner: wt
      };
      return tt._store = {}, Object.defineProperty(tt._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(tt, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: Qe
      }), Object.defineProperty(tt, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: ht
      }), Object.freeze && (Object.freeze(tt.props), Object.freeze(tt)), tt;
    };
    function $e(L, ye, De, Qe, ht) {
      {
        var wt, it = {}, tt = null, jn = null;
        De !== void 0 && (Ce(De), tt = "" + De), W(ye) && (Ce(ye.key), tt = "" + ye.key), K(ye) && (jn = ye.ref, le(ye, ht));
        for (wt in ye)
          te.call(ye, wt) && !Xe.hasOwnProperty(wt) && (it[wt] = ye[wt]);
        if (L && L.defaultProps) {
          var Xt = L.defaultProps;
          for (wt in Xt)
            it[wt] === void 0 && (it[wt] = Xt[wt]);
        }
        if (tt || jn) {
          var sn = typeof L == "function" ? L.displayName || L.name || "Unknown" : L;
          tt && pe(it, sn), jn && xe(it, sn);
        }
        return _e(L, tt, jn, ht, Qe, Ye.current, it);
      }
    }
    var We = g.ReactCurrentOwner, ft = g.ReactDebugCurrentFrame;
    function Qt(L) {
      if (L) {
        var ye = L._owner, De = ae(L.type, L._source, ye ? ye.type : null);
        ft.setExtraStackFrame(De);
      } else
        ft.setExtraStackFrame(null);
    }
    var hi;
    hi = !1;
    function ur(L) {
      return typeof L == "object" && L !== null && L.$$typeof === t;
    }
    function io() {
      {
        if (We.current) {
          var L = M(We.current.type);
          if (L)
            return `

Check the render method of \`` + L + "`.";
        }
        return "";
      }
    }
    function oh(L) {
      return "";
    }
    var Tl = {};
    function ah(L) {
      {
        var ye = io();
        if (!ye) {
          var De = typeof L == "string" ? L : L.displayName || L.name;
          De && (ye = `

Check the top-level render call using <` + De + ">.");
        }
        return ye;
      }
    }
    function Ol(L, ye) {
      {
        if (!L._store || L._store.validated || L.key != null)
          return;
        L._store.validated = !0;
        var De = ah(ye);
        if (Tl[De])
          return;
        Tl[De] = !0;
        var Qe = "";
        L && L._owner && L._owner !== We.current && (Qe = " It was passed a child from " + M(L._owner.type) + "."), Qt(L), _('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', De, Qe), Qt(null);
      }
    }
    function s1(L, ye) {
      {
        if (typeof L != "object")
          return;
        if (Ue(L))
          for (var De = 0; De < L.length; De++) {
            var Qe = L[De];
            ur(Qe) && Ol(Qe, ye);
          }
        else if (ur(L))
          L._store && (L._store.validated = !0);
        else if (L) {
          var ht = m(L);
          if (typeof ht == "function" && ht !== L.entries)
            for (var wt = ht.call(L), it; !(it = wt.next()).done; )
              ur(it.value) && Ol(it.value, ye);
        }
      }
    }
    function o6(L) {
      {
        var ye = L.type;
        if (ye == null || typeof ye == "string")
          return;
        var De;
        if (typeof ye == "function")
          De = ye.propTypes;
        else if (typeof ye == "object" && (ye.$$typeof === l || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        ye.$$typeof === f))
          De = ye.propTypes;
        else
          return;
        if (De) {
          var Qe = M(ye);
          Ee(De, L.props, "prop", Qe, L);
        } else if (ye.PropTypes !== void 0 && !hi) {
          hi = !0;
          var ht = M(ye);
          _("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", ht || "Unknown");
        }
        typeof ye.getDefaultProps == "function" && !ye.getDefaultProps.isReactClassApproved && _("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function a6(L) {
      {
        for (var ye = Object.keys(L.props), De = 0; De < ye.length; De++) {
          var Qe = ye[De];
          if (Qe !== "children" && Qe !== "key") {
            Qt(L), _("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", Qe), Qt(null);
            break;
          }
        }
        L.ref !== null && (Qt(L), _("Invalid attribute `ref` supplied to `React.Fragment`."), Qt(null));
      }
    }
    var l1 = {};
    function u1(L, ye, De, Qe, ht, wt) {
      {
        var it = y(L);
        if (!it) {
          var tt = "";
          (L === void 0 || typeof L == "object" && L !== null && Object.keys(L).length === 0) && (tt += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var jn = oh();
          jn ? tt += jn : tt += io();
          var Xt;
          L === null ? Xt = "null" : Ue(L) ? Xt = "array" : L !== void 0 && L.$$typeof === t ? (Xt = "<" + (M(L.type) || "Unknown") + " />", tt = " Did you accidentally export a JSX literal instead of a component?") : Xt = typeof L, _("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", Xt, tt);
        }
        var sn = $e(L, ye, De, ht, wt);
        if (sn == null)
          return sn;
        if (it) {
          var xr = ye.children;
          if (xr !== void 0)
            if (Qe)
              if (Ue(xr)) {
                for (var Ya = 0; Ya < xr.length; Ya++)
                  s1(xr[Ya], L);
                Object.freeze && Object.freeze(xr);
              } else
                _("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              s1(xr, L);
        }
        if (te.call(ye, "key")) {
          var Zo = M(L), Yn = Object.keys(ye).filter(function(d6) {
            return d6 !== "key";
          }), sh = Yn.length > 0 ? "{key: someKey, " + Yn.join(": ..., ") + ": ...}" : "{key: someKey}";
          if (!l1[Zo + sh]) {
            var f6 = Yn.length > 0 ? "{" + Yn.join(": ..., ") + ": ...}" : "{}";
            _(`A props object containing a "key" prop is being spread into JSX:
  let props = %s;
  <%s {...props} />
React keys must be passed directly to JSX without using spread:
  let props = %s;
  <%s key={someKey} {...props} />`, sh, Zo, f6, Zo), l1[Zo + sh] = !0;
          }
        }
        return L === r ? a6(sn) : o6(sn), sn;
      }
    }
    function s6(L, ye, De) {
      return u1(L, ye, De, !0);
    }
    function l6(L, ye, De) {
      return u1(L, ye, De, !1);
    }
    var u6 = l6, c6 = s6;
    Al.Fragment = r, Al.jsx = u6, Al.jsxs = c6;
  })()), Al;
}
var y1;
function M6() {
  return y1 || (y1 = 1, process.env.NODE_ENV === "production" ? Ec.exports = C6() : Ec.exports = I6()), Ec.exports;
}
var I = M6();
function R6() {
  for (var e = 0, t, n, r = ""; e < arguments.length; )
    (t = arguments[e++]) && (n = n$(t)) && (r && (r += " "), r += n);
  return r;
}
function n$(e) {
  if (typeof e == "string")
    return e;
  for (var t, n = "", r = 0; r < e.length; r++)
    e[r] && (t = n$(e[r])) && (n && (n += " "), n += t);
  return n;
}
var dy = "-";
function N6(e) {
  var t = F6(e), n = e.conflictingClassGroups, r = e.conflictingClassGroupModifiers, i = r === void 0 ? {} : r;
  function o(s) {
    var l = s.split(dy);
    return l[0] === "" && l.length !== 1 && l.shift(), r$(l, t) || j6(s);
  }
  function a(s, l) {
    var u = n[s] || [];
    return l && i[s] ? [].concat(u, i[s]) : u;
  }
  return {
    getClassGroupId: o,
    getConflictingClassGroupIds: a
  };
}
function r$(e, t) {
  if (e.length === 0)
    return t.classGroupId;
  var n = e[0], r = t.nextPart.get(n), i = r ? r$(e.slice(1), r) : void 0;
  if (i)
    return i;
  if (t.validators.length !== 0) {
    var o = e.join(dy);
    return t.validators.find(function(a) {
      var s = a.validator;
      return s(o);
    })?.classGroupId;
  }
}
var b1 = /^\[(.+)\]$/;
function j6(e) {
  if (b1.test(e)) {
    var t = b1.exec(e)[1], n = t?.substring(0, t.indexOf(":"));
    if (n)
      return "arbitrary.." + n;
  }
}
function F6(e) {
  var t = e.theme, n = e.prefix, r = {
    nextPart: /* @__PURE__ */ new Map(),
    validators: []
  }, i = L6(Object.entries(e.classGroups), n);
  return i.forEach(function(o) {
    var a = o[0], s = o[1];
    Vm(s, r, a, t);
  }), r;
}
function Vm(e, t, n, r) {
  e.forEach(function(i) {
    if (typeof i == "string") {
      var o = i === "" ? t : _1(t, i);
      o.classGroupId = n;
      return;
    }
    if (typeof i == "function") {
      if (z6(i)) {
        Vm(i(r), t, n, r);
        return;
      }
      t.validators.push({
        validator: i,
        classGroupId: n
      });
      return;
    }
    Object.entries(i).forEach(function(a) {
      var s = a[0], l = a[1];
      Vm(l, _1(t, s), n, r);
    });
  });
}
function _1(e, t) {
  var n = e;
  return t.split(dy).forEach(function(r) {
    n.nextPart.has(r) || n.nextPart.set(r, {
      nextPart: /* @__PURE__ */ new Map(),
      validators: []
    }), n = n.nextPart.get(r);
  }), n;
}
function z6(e) {
  return e.isThemeGetter;
}
function L6(e, t) {
  return t ? e.map(function(n) {
    var r = n[0], i = n[1], o = i.map(function(a) {
      return typeof a == "string" ? t + a : typeof a == "object" ? Object.fromEntries(Object.entries(a).map(function(s) {
        var l = s[0], u = s[1];
        return [t + l, u];
      })) : a;
    });
    return [r, o];
  }) : e;
}
function V6(e) {
  if (e < 1)
    return {
      get: function() {
      },
      set: function() {
      }
    };
  var t = 0, n = /* @__PURE__ */ new Map(), r = /* @__PURE__ */ new Map();
  function i(o, a) {
    n.set(o, a), t++, t > e && (t = 0, r = n, n = /* @__PURE__ */ new Map());
  }
  return {
    get: function(a) {
      var s = n.get(a);
      if (s !== void 0)
        return s;
      if ((s = r.get(a)) !== void 0)
        return i(a, s), s;
    },
    set: function(a, s) {
      n.has(a) ? n.set(a, s) : i(a, s);
    }
  };
}
var i$ = "!";
function B6(e) {
  var t = e.separator || ":", n = t.length === 1, r = t[0], i = t.length;
  return function(a) {
    for (var s = [], l = 0, u = 0, c, f = 0; f < a.length; f++) {
      var d = a[f];
      if (l === 0) {
        if (d === r && (n || a.slice(f, f + i) === t)) {
          s.push(a.slice(u, f)), u = f + i;
          continue;
        }
        if (d === "/") {
          c = f;
          continue;
        }
      }
      d === "[" ? l++ : d === "]" && l--;
    }
    var p = s.length === 0 ? a : a.substring(u), h = p.startsWith(i$), v = h ? p.substring(1) : p, m = c && c > u ? c - u : void 0;
    return {
      modifiers: s,
      hasImportantModifier: h,
      baseClassName: v,
      maybePostfixModifierPosition: m
    };
  };
}
function K6(e) {
  if (e.length <= 1)
    return e;
  var t = [], n = [];
  return e.forEach(function(r) {
    var i = r[0] === "[";
    i ? (t.push.apply(t, n.sort().concat([r])), n = []) : n.push(r);
  }), t.push.apply(t, n.sort()), t;
}
function U6(e) {
  return {
    cache: V6(e.cacheSize),
    splitModifiers: B6(e),
    ...N6(e)
  };
}
var q6 = /\s+/;
function H6(e, t) {
  var n = t.splitModifiers, r = t.getClassGroupId, i = t.getConflictingClassGroupIds, o = /* @__PURE__ */ new Set();
  return e.trim().split(q6).map(function(a) {
    var s = n(a), l = s.modifiers, u = s.hasImportantModifier, c = s.baseClassName, f = s.maybePostfixModifierPosition, d = r(f ? c.substring(0, f) : c), p = !!f;
    if (!d) {
      if (!f)
        return {
          isTailwindClass: !1,
          originalClassName: a
        };
      if (d = r(c), !d)
        return {
          isTailwindClass: !1,
          originalClassName: a
        };
      p = !1;
    }
    var h = K6(l).join(":"), v = u ? h + i$ : h;
    return {
      isTailwindClass: !0,
      modifierId: v,
      classGroupId: d,
      originalClassName: a,
      hasPostfixModifier: p
    };
  }).reverse().filter(function(a) {
    if (!a.isTailwindClass)
      return !0;
    var s = a.modifierId, l = a.classGroupId, u = a.hasPostfixModifier, c = s + l;
    return o.has(c) ? !1 : (o.add(c), i(l, u).forEach(function(f) {
      return o.add(s + f);
    }), !0);
  }).reverse().map(function(a) {
    return a.originalClassName;
  }).join(" ");
}
function W6() {
  for (var e = arguments.length, t = new Array(e), n = 0; n < e; n++)
    t[n] = arguments[n];
  var r, i, o, a = s;
  function s(u) {
    var c = t[0], f = t.slice(1), d = f.reduce(function(p, h) {
      return h(p);
    }, c());
    return r = U6(d), i = r.cache.get, o = r.cache.set, a = l, l(u);
  }
  function l(u) {
    var c = i(u);
    if (c)
      return c;
    var f = H6(u, r);
    return o(u, f), f;
  }
  return function() {
    return a(R6.apply(null, arguments));
  };
}
function Dt(e) {
  var t = function(r) {
    return r[e] || [];
  };
  return t.isThemeGetter = !0, t;
}
var o$ = /^\[(?:([a-z-]+):)?(.+)\]$/i, Z6 = /^\d+\/\d+$/, G6 = /* @__PURE__ */ new Set(["px", "full", "screen"]), Y6 = /^(\d+(\.\d+)?)?(xs|sm|md|lg|xl)$/, Q6 = /\d+(%|px|r?em|[sdl]?v([hwib]|min|max)|pt|pc|in|cm|mm|cap|ch|ex|r?lh|cq(w|h|i|b|min|max))|\b(calc|min|max|clamp)\(.+\)|^0$/, J6 = /^-?((\d+)?\.?(\d+)[a-z]+|0)_-?((\d+)?\.?(\d+)[a-z]+|0)/;
function qr(e) {
  return sa(e) || G6.has(e) || Z6.test(e) || Bm(e);
}
function Bm(e) {
  return Ra(e, "length", iI);
}
function X6(e) {
  return Ra(e, "size", a$);
}
function eI(e) {
  return Ra(e, "position", a$);
}
function tI(e) {
  return Ra(e, "url", oI);
}
function Sc(e) {
  return Ra(e, "number", sa);
}
function sa(e) {
  return !Number.isNaN(Number(e));
}
function nI(e) {
  return e.endsWith("%") && sa(e.slice(0, -1));
}
function Dl(e) {
  return w1(e) || Ra(e, "number", w1);
}
function nt(e) {
  return o$.test(e);
}
function Cl() {
  return !0;
}
function oo(e) {
  return Y6.test(e);
}
function rI(e) {
  return Ra(e, "", aI);
}
function Ra(e, t, n) {
  var r = o$.exec(e);
  return r ? r[1] ? r[1] === t : n(r[2]) : !1;
}
function iI(e) {
  return Q6.test(e);
}
function a$() {
  return !1;
}
function oI(e) {
  return e.startsWith("url(");
}
function w1(e) {
  return Number.isInteger(Number(e));
}
function aI(e) {
  return J6.test(e);
}
function sI() {
  var e = Dt("colors"), t = Dt("spacing"), n = Dt("blur"), r = Dt("brightness"), i = Dt("borderColor"), o = Dt("borderRadius"), a = Dt("borderSpacing"), s = Dt("borderWidth"), l = Dt("contrast"), u = Dt("grayscale"), c = Dt("hueRotate"), f = Dt("invert"), d = Dt("gap"), p = Dt("gradientColorStops"), h = Dt("gradientColorStopPositions"), v = Dt("inset"), m = Dt("margin"), g = Dt("opacity"), _ = Dt("padding"), x = Dt("saturate"), w = Dt("scale"), $ = Dt("sepia"), k = Dt("skew"), D = Dt("space"), E = Dt("translate"), b = function() {
    return ["auto", "contain", "none"];
  }, y = function() {
    return ["auto", "hidden", "clip", "visible", "scroll"];
  }, S = function() {
    return ["auto", nt, t];
  }, P = function() {
    return [nt, t];
  }, M = function() {
    return ["", qr];
  }, T = function() {
    return ["auto", sa, nt];
  }, V = function() {
    return ["bottom", "center", "left", "left-bottom", "left-top", "right", "right-bottom", "right-top", "top"];
  }, z = function() {
    return ["solid", "dashed", "dotted", "double", "none"];
  }, U = function() {
    return ["normal", "multiply", "screen", "overlay", "darken", "lighten", "color-dodge", "color-burn", "hard-light", "soft-light", "difference", "exclusion", "hue", "saturation", "color", "luminosity", "plus-lighter"];
  }, B = function() {
    return ["start", "end", "center", "between", "around", "evenly", "stretch"];
  }, N = function() {
    return ["", "0", nt];
  }, C = function() {
    return ["auto", "avoid", "all", "avoid-page", "page", "left", "right", "column"];
  }, G = function() {
    return [sa, Sc];
  }, re = function() {
    return [sa, nt];
  };
  return {
    cacheSize: 500,
    theme: {
      colors: [Cl],
      spacing: [qr],
      blur: ["none", "", oo, nt],
      brightness: G(),
      borderColor: [e],
      borderRadius: ["none", "", "full", oo, nt],
      borderSpacing: P(),
      borderWidth: M(),
      contrast: G(),
      grayscale: N(),
      hueRotate: re(),
      invert: N(),
      gap: P(),
      gradientColorStops: [e],
      gradientColorStopPositions: [nI, Bm],
      inset: S(),
      margin: S(),
      opacity: G(),
      padding: P(),
      saturate: G(),
      scale: G(),
      sepia: N(),
      skew: re(),
      space: P(),
      translate: P()
    },
    classGroups: {
      // Layout
      /**
       * Aspect Ratio
       * @see https://tailwindcss.com/docs/aspect-ratio
       */
      aspect: [{
        aspect: ["auto", "square", "video", nt]
      }],
      /**
       * Container
       * @see https://tailwindcss.com/docs/container
       */
      container: ["container"],
      /**
       * Columns
       * @see https://tailwindcss.com/docs/columns
       */
      columns: [{
        columns: [oo]
      }],
      /**
       * Break After
       * @see https://tailwindcss.com/docs/break-after
       */
      "break-after": [{
        "break-after": C()
      }],
      /**
       * Break Before
       * @see https://tailwindcss.com/docs/break-before
       */
      "break-before": [{
        "break-before": C()
      }],
      /**
       * Break Inside
       * @see https://tailwindcss.com/docs/break-inside
       */
      "break-inside": [{
        "break-inside": ["auto", "avoid", "avoid-page", "avoid-column"]
      }],
      /**
       * Box Decoration Break
       * @see https://tailwindcss.com/docs/box-decoration-break
       */
      "box-decoration": [{
        "box-decoration": ["slice", "clone"]
      }],
      /**
       * Box Sizing
       * @see https://tailwindcss.com/docs/box-sizing
       */
      box: [{
        box: ["border", "content"]
      }],
      /**
       * Display
       * @see https://tailwindcss.com/docs/display
       */
      display: ["block", "inline-block", "inline", "flex", "inline-flex", "table", "inline-table", "table-caption", "table-cell", "table-column", "table-column-group", "table-footer-group", "table-header-group", "table-row-group", "table-row", "flow-root", "grid", "inline-grid", "contents", "list-item", "hidden"],
      /**
       * Floats
       * @see https://tailwindcss.com/docs/float
       */
      float: [{
        float: ["right", "left", "none"]
      }],
      /**
       * Clear
       * @see https://tailwindcss.com/docs/clear
       */
      clear: [{
        clear: ["left", "right", "both", "none"]
      }],
      /**
       * Isolation
       * @see https://tailwindcss.com/docs/isolation
       */
      isolation: ["isolate", "isolation-auto"],
      /**
       * Object Fit
       * @see https://tailwindcss.com/docs/object-fit
       */
      "object-fit": [{
        object: ["contain", "cover", "fill", "none", "scale-down"]
      }],
      /**
       * Object Position
       * @see https://tailwindcss.com/docs/object-position
       */
      "object-position": [{
        object: [].concat(V(), [nt])
      }],
      /**
       * Overflow
       * @see https://tailwindcss.com/docs/overflow
       */
      overflow: [{
        overflow: y()
      }],
      /**
       * Overflow X
       * @see https://tailwindcss.com/docs/overflow
       */
      "overflow-x": [{
        "overflow-x": y()
      }],
      /**
       * Overflow Y
       * @see https://tailwindcss.com/docs/overflow
       */
      "overflow-y": [{
        "overflow-y": y()
      }],
      /**
       * Overscroll Behavior
       * @see https://tailwindcss.com/docs/overscroll-behavior
       */
      overscroll: [{
        overscroll: b()
      }],
      /**
       * Overscroll Behavior X
       * @see https://tailwindcss.com/docs/overscroll-behavior
       */
      "overscroll-x": [{
        "overscroll-x": b()
      }],
      /**
       * Overscroll Behavior Y
       * @see https://tailwindcss.com/docs/overscroll-behavior
       */
      "overscroll-y": [{
        "overscroll-y": b()
      }],
      /**
       * Position
       * @see https://tailwindcss.com/docs/position
       */
      position: ["static", "fixed", "absolute", "relative", "sticky"],
      /**
       * Top / Right / Bottom / Left
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      inset: [{
        inset: [v]
      }],
      /**
       * Right / Left
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      "inset-x": [{
        "inset-x": [v]
      }],
      /**
       * Top / Bottom
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      "inset-y": [{
        "inset-y": [v]
      }],
      /**
       * Start
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      start: [{
        start: [v]
      }],
      /**
       * End
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      end: [{
        end: [v]
      }],
      /**
       * Top
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      top: [{
        top: [v]
      }],
      /**
       * Right
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      right: [{
        right: [v]
      }],
      /**
       * Bottom
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      bottom: [{
        bottom: [v]
      }],
      /**
       * Left
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      left: [{
        left: [v]
      }],
      /**
       * Visibility
       * @see https://tailwindcss.com/docs/visibility
       */
      visibility: ["visible", "invisible", "collapse"],
      /**
       * Z-Index
       * @see https://tailwindcss.com/docs/z-index
       */
      z: [{
        z: ["auto", Dl]
      }],
      // Flexbox and Grid
      /**
       * Flex Basis
       * @see https://tailwindcss.com/docs/flex-basis
       */
      basis: [{
        basis: S()
      }],
      /**
       * Flex Direction
       * @see https://tailwindcss.com/docs/flex-direction
       */
      "flex-direction": [{
        flex: ["row", "row-reverse", "col", "col-reverse"]
      }],
      /**
       * Flex Wrap
       * @see https://tailwindcss.com/docs/flex-wrap
       */
      "flex-wrap": [{
        flex: ["wrap", "wrap-reverse", "nowrap"]
      }],
      /**
       * Flex
       * @see https://tailwindcss.com/docs/flex
       */
      flex: [{
        flex: ["1", "auto", "initial", "none", nt]
      }],
      /**
       * Flex Grow
       * @see https://tailwindcss.com/docs/flex-grow
       */
      grow: [{
        grow: N()
      }],
      /**
       * Flex Shrink
       * @see https://tailwindcss.com/docs/flex-shrink
       */
      shrink: [{
        shrink: N()
      }],
      /**
       * Order
       * @see https://tailwindcss.com/docs/order
       */
      order: [{
        order: ["first", "last", "none", Dl]
      }],
      /**
       * Grid Template Columns
       * @see https://tailwindcss.com/docs/grid-template-columns
       */
      "grid-cols": [{
        "grid-cols": [Cl]
      }],
      /**
       * Grid Column Start / End
       * @see https://tailwindcss.com/docs/grid-column
       */
      "col-start-end": [{
        col: ["auto", {
          span: ["full", Dl]
        }, nt]
      }],
      /**
       * Grid Column Start
       * @see https://tailwindcss.com/docs/grid-column
       */
      "col-start": [{
        "col-start": T()
      }],
      /**
       * Grid Column End
       * @see https://tailwindcss.com/docs/grid-column
       */
      "col-end": [{
        "col-end": T()
      }],
      /**
       * Grid Template Rows
       * @see https://tailwindcss.com/docs/grid-template-rows
       */
      "grid-rows": [{
        "grid-rows": [Cl]
      }],
      /**
       * Grid Row Start / End
       * @see https://tailwindcss.com/docs/grid-row
       */
      "row-start-end": [{
        row: ["auto", {
          span: [Dl]
        }, nt]
      }],
      /**
       * Grid Row Start
       * @see https://tailwindcss.com/docs/grid-row
       */
      "row-start": [{
        "row-start": T()
      }],
      /**
       * Grid Row End
       * @see https://tailwindcss.com/docs/grid-row
       */
      "row-end": [{
        "row-end": T()
      }],
      /**
       * Grid Auto Flow
       * @see https://tailwindcss.com/docs/grid-auto-flow
       */
      "grid-flow": [{
        "grid-flow": ["row", "col", "dense", "row-dense", "col-dense"]
      }],
      /**
       * Grid Auto Columns
       * @see https://tailwindcss.com/docs/grid-auto-columns
       */
      "auto-cols": [{
        "auto-cols": ["auto", "min", "max", "fr", nt]
      }],
      /**
       * Grid Auto Rows
       * @see https://tailwindcss.com/docs/grid-auto-rows
       */
      "auto-rows": [{
        "auto-rows": ["auto", "min", "max", "fr", nt]
      }],
      /**
       * Gap
       * @see https://tailwindcss.com/docs/gap
       */
      gap: [{
        gap: [d]
      }],
      /**
       * Gap X
       * @see https://tailwindcss.com/docs/gap
       */
      "gap-x": [{
        "gap-x": [d]
      }],
      /**
       * Gap Y
       * @see https://tailwindcss.com/docs/gap
       */
      "gap-y": [{
        "gap-y": [d]
      }],
      /**
       * Justify Content
       * @see https://tailwindcss.com/docs/justify-content
       */
      "justify-content": [{
        justify: ["normal"].concat(B())
      }],
      /**
       * Justify Items
       * @see https://tailwindcss.com/docs/justify-items
       */
      "justify-items": [{
        "justify-items": ["start", "end", "center", "stretch"]
      }],
      /**
       * Justify Self
       * @see https://tailwindcss.com/docs/justify-self
       */
      "justify-self": [{
        "justify-self": ["auto", "start", "end", "center", "stretch"]
      }],
      /**
       * Align Content
       * @see https://tailwindcss.com/docs/align-content
       */
      "align-content": [{
        content: ["normal"].concat(B(), ["baseline"])
      }],
      /**
       * Align Items
       * @see https://tailwindcss.com/docs/align-items
       */
      "align-items": [{
        items: ["start", "end", "center", "baseline", "stretch"]
      }],
      /**
       * Align Self
       * @see https://tailwindcss.com/docs/align-self
       */
      "align-self": [{
        self: ["auto", "start", "end", "center", "stretch", "baseline"]
      }],
      /**
       * Place Content
       * @see https://tailwindcss.com/docs/place-content
       */
      "place-content": [{
        "place-content": [].concat(B(), ["baseline"])
      }],
      /**
       * Place Items
       * @see https://tailwindcss.com/docs/place-items
       */
      "place-items": [{
        "place-items": ["start", "end", "center", "baseline", "stretch"]
      }],
      /**
       * Place Self
       * @see https://tailwindcss.com/docs/place-self
       */
      "place-self": [{
        "place-self": ["auto", "start", "end", "center", "stretch"]
      }],
      // Spacing
      /**
       * Padding
       * @see https://tailwindcss.com/docs/padding
       */
      p: [{
        p: [_]
      }],
      /**
       * Padding X
       * @see https://tailwindcss.com/docs/padding
       */
      px: [{
        px: [_]
      }],
      /**
       * Padding Y
       * @see https://tailwindcss.com/docs/padding
       */
      py: [{
        py: [_]
      }],
      /**
       * Padding Start
       * @see https://tailwindcss.com/docs/padding
       */
      ps: [{
        ps: [_]
      }],
      /**
       * Padding End
       * @see https://tailwindcss.com/docs/padding
       */
      pe: [{
        pe: [_]
      }],
      /**
       * Padding Top
       * @see https://tailwindcss.com/docs/padding
       */
      pt: [{
        pt: [_]
      }],
      /**
       * Padding Right
       * @see https://tailwindcss.com/docs/padding
       */
      pr: [{
        pr: [_]
      }],
      /**
       * Padding Bottom
       * @see https://tailwindcss.com/docs/padding
       */
      pb: [{
        pb: [_]
      }],
      /**
       * Padding Left
       * @see https://tailwindcss.com/docs/padding
       */
      pl: [{
        pl: [_]
      }],
      /**
       * Margin
       * @see https://tailwindcss.com/docs/margin
       */
      m: [{
        m: [m]
      }],
      /**
       * Margin X
       * @see https://tailwindcss.com/docs/margin
       */
      mx: [{
        mx: [m]
      }],
      /**
       * Margin Y
       * @see https://tailwindcss.com/docs/margin
       */
      my: [{
        my: [m]
      }],
      /**
       * Margin Start
       * @see https://tailwindcss.com/docs/margin
       */
      ms: [{
        ms: [m]
      }],
      /**
       * Margin End
       * @see https://tailwindcss.com/docs/margin
       */
      me: [{
        me: [m]
      }],
      /**
       * Margin Top
       * @see https://tailwindcss.com/docs/margin
       */
      mt: [{
        mt: [m]
      }],
      /**
       * Margin Right
       * @see https://tailwindcss.com/docs/margin
       */
      mr: [{
        mr: [m]
      }],
      /**
       * Margin Bottom
       * @see https://tailwindcss.com/docs/margin
       */
      mb: [{
        mb: [m]
      }],
      /**
       * Margin Left
       * @see https://tailwindcss.com/docs/margin
       */
      ml: [{
        ml: [m]
      }],
      /**
       * Space Between X
       * @see https://tailwindcss.com/docs/space
       */
      "space-x": [{
        "space-x": [D]
      }],
      /**
       * Space Between X Reverse
       * @see https://tailwindcss.com/docs/space
       */
      "space-x-reverse": ["space-x-reverse"],
      /**
       * Space Between Y
       * @see https://tailwindcss.com/docs/space
       */
      "space-y": [{
        "space-y": [D]
      }],
      /**
       * Space Between Y Reverse
       * @see https://tailwindcss.com/docs/space
       */
      "space-y-reverse": ["space-y-reverse"],
      // Sizing
      /**
       * Width
       * @see https://tailwindcss.com/docs/width
       */
      w: [{
        w: ["auto", "min", "max", "fit", nt, t]
      }],
      /**
       * Min-Width
       * @see https://tailwindcss.com/docs/min-width
       */
      "min-w": [{
        "min-w": ["min", "max", "fit", nt, qr]
      }],
      /**
       * Max-Width
       * @see https://tailwindcss.com/docs/max-width
       */
      "max-w": [{
        "max-w": ["0", "none", "full", "min", "max", "fit", "prose", {
          screen: [oo]
        }, oo, nt]
      }],
      /**
       * Height
       * @see https://tailwindcss.com/docs/height
       */
      h: [{
        h: [nt, t, "auto", "min", "max", "fit"]
      }],
      /**
       * Min-Height
       * @see https://tailwindcss.com/docs/min-height
       */
      "min-h": [{
        "min-h": ["min", "max", "fit", nt, qr]
      }],
      /**
       * Max-Height
       * @see https://tailwindcss.com/docs/max-height
       */
      "max-h": [{
        "max-h": [nt, t, "min", "max", "fit"]
      }],
      // Typography
      /**
       * Font Size
       * @see https://tailwindcss.com/docs/font-size
       */
      "font-size": [{
        text: ["base", oo, Bm]
      }],
      /**
       * Font Smoothing
       * @see https://tailwindcss.com/docs/font-smoothing
       */
      "font-smoothing": ["antialiased", "subpixel-antialiased"],
      /**
       * Font Style
       * @see https://tailwindcss.com/docs/font-style
       */
      "font-style": ["italic", "not-italic"],
      /**
       * Font Weight
       * @see https://tailwindcss.com/docs/font-weight
       */
      "font-weight": [{
        font: ["thin", "extralight", "light", "normal", "medium", "semibold", "bold", "extrabold", "black", Sc]
      }],
      /**
       * Font Family
       * @see https://tailwindcss.com/docs/font-family
       */
      "font-family": [{
        font: [Cl]
      }],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-normal": ["normal-nums"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-ordinal": ["ordinal"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-slashed-zero": ["slashed-zero"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-figure": ["lining-nums", "oldstyle-nums"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-spacing": ["proportional-nums", "tabular-nums"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-fraction": ["diagonal-fractions", "stacked-fractons"],
      /**
       * Letter Spacing
       * @see https://tailwindcss.com/docs/letter-spacing
       */
      tracking: [{
        tracking: ["tighter", "tight", "normal", "wide", "wider", "widest", nt]
      }],
      /**
       * Line Clamp
       * @see https://tailwindcss.com/docs/line-clamp
       */
      "line-clamp": [{
        "line-clamp": ["none", sa, Sc]
      }],
      /**
       * Line Height
       * @see https://tailwindcss.com/docs/line-height
       */
      leading: [{
        leading: ["none", "tight", "snug", "normal", "relaxed", "loose", nt, qr]
      }],
      /**
       * List Style Image
       * @see https://tailwindcss.com/docs/list-style-image
       */
      "list-image": [{
        "list-image": ["none", nt]
      }],
      /**
       * List Style Type
       * @see https://tailwindcss.com/docs/list-style-type
       */
      "list-style-type": [{
        list: ["none", "disc", "decimal", nt]
      }],
      /**
       * List Style Position
       * @see https://tailwindcss.com/docs/list-style-position
       */
      "list-style-position": [{
        list: ["inside", "outside"]
      }],
      /**
       * Placeholder Color
       * @deprecated since Tailwind CSS v3.0.0
       * @see https://tailwindcss.com/docs/placeholder-color
       */
      "placeholder-color": [{
        placeholder: [e]
      }],
      /**
       * Placeholder Opacity
       * @see https://tailwindcss.com/docs/placeholder-opacity
       */
      "placeholder-opacity": [{
        "placeholder-opacity": [g]
      }],
      /**
       * Text Alignment
       * @see https://tailwindcss.com/docs/text-align
       */
      "text-alignment": [{
        text: ["left", "center", "right", "justify", "start", "end"]
      }],
      /**
       * Text Color
       * @see https://tailwindcss.com/docs/text-color
       */
      "text-color": [{
        text: [e]
      }],
      /**
       * Text Opacity
       * @see https://tailwindcss.com/docs/text-opacity
       */
      "text-opacity": [{
        "text-opacity": [g]
      }],
      /**
       * Text Decoration
       * @see https://tailwindcss.com/docs/text-decoration
       */
      "text-decoration": ["underline", "overline", "line-through", "no-underline"],
      /**
       * Text Decoration Style
       * @see https://tailwindcss.com/docs/text-decoration-style
       */
      "text-decoration-style": [{
        decoration: [].concat(z(), ["wavy"])
      }],
      /**
       * Text Decoration Thickness
       * @see https://tailwindcss.com/docs/text-decoration-thickness
       */
      "text-decoration-thickness": [{
        decoration: ["auto", "from-font", qr]
      }],
      /**
       * Text Underline Offset
       * @see https://tailwindcss.com/docs/text-underline-offset
       */
      "underline-offset": [{
        "underline-offset": ["auto", nt, qr]
      }],
      /**
       * Text Decoration Color
       * @see https://tailwindcss.com/docs/text-decoration-color
       */
      "text-decoration-color": [{
        decoration: [e]
      }],
      /**
       * Text Transform
       * @see https://tailwindcss.com/docs/text-transform
       */
      "text-transform": ["uppercase", "lowercase", "capitalize", "normal-case"],
      /**
       * Text Overflow
       * @see https://tailwindcss.com/docs/text-overflow
       */
      "text-overflow": ["truncate", "text-ellipsis", "text-clip"],
      /**
       * Text Indent
       * @see https://tailwindcss.com/docs/text-indent
       */
      indent: [{
        indent: P()
      }],
      /**
       * Vertical Alignment
       * @see https://tailwindcss.com/docs/vertical-align
       */
      "vertical-align": [{
        align: ["baseline", "top", "middle", "bottom", "text-top", "text-bottom", "sub", "super", nt]
      }],
      /**
       * Whitespace
       * @see https://tailwindcss.com/docs/whitespace
       */
      whitespace: [{
        whitespace: ["normal", "nowrap", "pre", "pre-line", "pre-wrap", "break-spaces"]
      }],
      /**
       * Word Break
       * @see https://tailwindcss.com/docs/word-break
       */
      break: [{
        break: ["normal", "words", "all", "keep"]
      }],
      /**
       * Hyphens
       * @see https://tailwindcss.com/docs/hyphens
       */
      hyphens: [{
        hyphens: ["none", "manual", "auto"]
      }],
      /**
       * Content
       * @see https://tailwindcss.com/docs/content
       */
      content: [{
        content: ["none", nt]
      }],
      // Backgrounds
      /**
       * Background Attachment
       * @see https://tailwindcss.com/docs/background-attachment
       */
      "bg-attachment": [{
        bg: ["fixed", "local", "scroll"]
      }],
      /**
       * Background Clip
       * @see https://tailwindcss.com/docs/background-clip
       */
      "bg-clip": [{
        "bg-clip": ["border", "padding", "content", "text"]
      }],
      /**
       * Background Opacity
       * @deprecated since Tailwind CSS v3.0.0
       * @see https://tailwindcss.com/docs/background-opacity
       */
      "bg-opacity": [{
        "bg-opacity": [g]
      }],
      /**
       * Background Origin
       * @see https://tailwindcss.com/docs/background-origin
       */
      "bg-origin": [{
        "bg-origin": ["border", "padding", "content"]
      }],
      /**
       * Background Position
       * @see https://tailwindcss.com/docs/background-position
       */
      "bg-position": [{
        bg: [].concat(V(), [eI])
      }],
      /**
       * Background Repeat
       * @see https://tailwindcss.com/docs/background-repeat
       */
      "bg-repeat": [{
        bg: ["no-repeat", {
          repeat: ["", "x", "y", "round", "space"]
        }]
      }],
      /**
       * Background Size
       * @see https://tailwindcss.com/docs/background-size
       */
      "bg-size": [{
        bg: ["auto", "cover", "contain", X6]
      }],
      /**
       * Background Image
       * @see https://tailwindcss.com/docs/background-image
       */
      "bg-image": [{
        bg: ["none", {
          "gradient-to": ["t", "tr", "r", "br", "b", "bl", "l", "tl"]
        }, tI]
      }],
      /**
       * Background Color
       * @see https://tailwindcss.com/docs/background-color
       */
      "bg-color": [{
        bg: [e]
      }],
      /**
       * Gradient Color Stops From Position
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-from-pos": [{
        from: [h]
      }],
      /**
       * Gradient Color Stops Via Position
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-via-pos": [{
        via: [h]
      }],
      /**
       * Gradient Color Stops To Position
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-to-pos": [{
        to: [h]
      }],
      /**
       * Gradient Color Stops From
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-from": [{
        from: [p]
      }],
      /**
       * Gradient Color Stops Via
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-via": [{
        via: [p]
      }],
      /**
       * Gradient Color Stops To
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-to": [{
        to: [p]
      }],
      // Borders
      /**
       * Border Radius
       * @see https://tailwindcss.com/docs/border-radius
       */
      rounded: [{
        rounded: [o]
      }],
      /**
       * Border Radius Start
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-s": [{
        "rounded-s": [o]
      }],
      /**
       * Border Radius End
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-e": [{
        "rounded-e": [o]
      }],
      /**
       * Border Radius Top
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-t": [{
        "rounded-t": [o]
      }],
      /**
       * Border Radius Right
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-r": [{
        "rounded-r": [o]
      }],
      /**
       * Border Radius Bottom
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-b": [{
        "rounded-b": [o]
      }],
      /**
       * Border Radius Left
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-l": [{
        "rounded-l": [o]
      }],
      /**
       * Border Radius Start Start
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-ss": [{
        "rounded-ss": [o]
      }],
      /**
       * Border Radius Start End
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-se": [{
        "rounded-se": [o]
      }],
      /**
       * Border Radius End End
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-ee": [{
        "rounded-ee": [o]
      }],
      /**
       * Border Radius End Start
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-es": [{
        "rounded-es": [o]
      }],
      /**
       * Border Radius Top Left
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-tl": [{
        "rounded-tl": [o]
      }],
      /**
       * Border Radius Top Right
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-tr": [{
        "rounded-tr": [o]
      }],
      /**
       * Border Radius Bottom Right
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-br": [{
        "rounded-br": [o]
      }],
      /**
       * Border Radius Bottom Left
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-bl": [{
        "rounded-bl": [o]
      }],
      /**
       * Border Width
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w": [{
        border: [s]
      }],
      /**
       * Border Width X
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-x": [{
        "border-x": [s]
      }],
      /**
       * Border Width Y
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-y": [{
        "border-y": [s]
      }],
      /**
       * Border Width Start
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-s": [{
        "border-s": [s]
      }],
      /**
       * Border Width End
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-e": [{
        "border-e": [s]
      }],
      /**
       * Border Width Top
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-t": [{
        "border-t": [s]
      }],
      /**
       * Border Width Right
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-r": [{
        "border-r": [s]
      }],
      /**
       * Border Width Bottom
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-b": [{
        "border-b": [s]
      }],
      /**
       * Border Width Left
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-l": [{
        "border-l": [s]
      }],
      /**
       * Border Opacity
       * @see https://tailwindcss.com/docs/border-opacity
       */
      "border-opacity": [{
        "border-opacity": [g]
      }],
      /**
       * Border Style
       * @see https://tailwindcss.com/docs/border-style
       */
      "border-style": [{
        border: [].concat(z(), ["hidden"])
      }],
      /**
       * Divide Width X
       * @see https://tailwindcss.com/docs/divide-width
       */
      "divide-x": [{
        "divide-x": [s]
      }],
      /**
       * Divide Width X Reverse
       * @see https://tailwindcss.com/docs/divide-width
       */
      "divide-x-reverse": ["divide-x-reverse"],
      /**
       * Divide Width Y
       * @see https://tailwindcss.com/docs/divide-width
       */
      "divide-y": [{
        "divide-y": [s]
      }],
      /**
       * Divide Width Y Reverse
       * @see https://tailwindcss.com/docs/divide-width
       */
      "divide-y-reverse": ["divide-y-reverse"],
      /**
       * Divide Opacity
       * @see https://tailwindcss.com/docs/divide-opacity
       */
      "divide-opacity": [{
        "divide-opacity": [g]
      }],
      /**
       * Divide Style
       * @see https://tailwindcss.com/docs/divide-style
       */
      "divide-style": [{
        divide: z()
      }],
      /**
       * Border Color
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color": [{
        border: [i]
      }],
      /**
       * Border Color X
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-x": [{
        "border-x": [i]
      }],
      /**
       * Border Color Y
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-y": [{
        "border-y": [i]
      }],
      /**
       * Border Color Top
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-t": [{
        "border-t": [i]
      }],
      /**
       * Border Color Right
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-r": [{
        "border-r": [i]
      }],
      /**
       * Border Color Bottom
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-b": [{
        "border-b": [i]
      }],
      /**
       * Border Color Left
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-l": [{
        "border-l": [i]
      }],
      /**
       * Divide Color
       * @see https://tailwindcss.com/docs/divide-color
       */
      "divide-color": [{
        divide: [i]
      }],
      /**
       * Outline Style
       * @see https://tailwindcss.com/docs/outline-style
       */
      "outline-style": [{
        outline: [""].concat(z())
      }],
      /**
       * Outline Offset
       * @see https://tailwindcss.com/docs/outline-offset
       */
      "outline-offset": [{
        "outline-offset": [nt, qr]
      }],
      /**
       * Outline Width
       * @see https://tailwindcss.com/docs/outline-width
       */
      "outline-w": [{
        outline: [qr]
      }],
      /**
       * Outline Color
       * @see https://tailwindcss.com/docs/outline-color
       */
      "outline-color": [{
        outline: [e]
      }],
      /**
       * Ring Width
       * @see https://tailwindcss.com/docs/ring-width
       */
      "ring-w": [{
        ring: M()
      }],
      /**
       * Ring Width Inset
       * @see https://tailwindcss.com/docs/ring-width
       */
      "ring-w-inset": ["ring-inset"],
      /**
       * Ring Color
       * @see https://tailwindcss.com/docs/ring-color
       */
      "ring-color": [{
        ring: [e]
      }],
      /**
       * Ring Opacity
       * @see https://tailwindcss.com/docs/ring-opacity
       */
      "ring-opacity": [{
        "ring-opacity": [g]
      }],
      /**
       * Ring Offset Width
       * @see https://tailwindcss.com/docs/ring-offset-width
       */
      "ring-offset-w": [{
        "ring-offset": [qr]
      }],
      /**
       * Ring Offset Color
       * @see https://tailwindcss.com/docs/ring-offset-color
       */
      "ring-offset-color": [{
        "ring-offset": [e]
      }],
      // Effects
      /**
       * Box Shadow
       * @see https://tailwindcss.com/docs/box-shadow
       */
      shadow: [{
        shadow: ["", "inner", "none", oo, rI]
      }],
      /**
       * Box Shadow Color
       * @see https://tailwindcss.com/docs/box-shadow-color
       */
      "shadow-color": [{
        shadow: [Cl]
      }],
      /**
       * Opacity
       * @see https://tailwindcss.com/docs/opacity
       */
      opacity: [{
        opacity: [g]
      }],
      /**
       * Mix Blend Mode
       * @see https://tailwindcss.com/docs/mix-blend-mode
       */
      "mix-blend": [{
        "mix-blend": U()
      }],
      /**
       * Background Blend Mode
       * @see https://tailwindcss.com/docs/background-blend-mode
       */
      "bg-blend": [{
        "bg-blend": U()
      }],
      // Filters
      /**
       * Filter
       * @deprecated since Tailwind CSS v3.0.0
       * @see https://tailwindcss.com/docs/filter
       */
      filter: [{
        filter: ["", "none"]
      }],
      /**
       * Blur
       * @see https://tailwindcss.com/docs/blur
       */
      blur: [{
        blur: [n]
      }],
      /**
       * Brightness
       * @see https://tailwindcss.com/docs/brightness
       */
      brightness: [{
        brightness: [r]
      }],
      /**
       * Contrast
       * @see https://tailwindcss.com/docs/contrast
       */
      contrast: [{
        contrast: [l]
      }],
      /**
       * Drop Shadow
       * @see https://tailwindcss.com/docs/drop-shadow
       */
      "drop-shadow": [{
        "drop-shadow": ["", "none", oo, nt]
      }],
      /**
       * Grayscale
       * @see https://tailwindcss.com/docs/grayscale
       */
      grayscale: [{
        grayscale: [u]
      }],
      /**
       * Hue Rotate
       * @see https://tailwindcss.com/docs/hue-rotate
       */
      "hue-rotate": [{
        "hue-rotate": [c]
      }],
      /**
       * Invert
       * @see https://tailwindcss.com/docs/invert
       */
      invert: [{
        invert: [f]
      }],
      /**
       * Saturate
       * @see https://tailwindcss.com/docs/saturate
       */
      saturate: [{
        saturate: [x]
      }],
      /**
       * Sepia
       * @see https://tailwindcss.com/docs/sepia
       */
      sepia: [{
        sepia: [$]
      }],
      /**
       * Backdrop Filter
       * @deprecated since Tailwind CSS v3.0.0
       * @see https://tailwindcss.com/docs/backdrop-filter
       */
      "backdrop-filter": [{
        "backdrop-filter": ["", "none"]
      }],
      /**
       * Backdrop Blur
       * @see https://tailwindcss.com/docs/backdrop-blur
       */
      "backdrop-blur": [{
        "backdrop-blur": [n]
      }],
      /**
       * Backdrop Brightness
       * @see https://tailwindcss.com/docs/backdrop-brightness
       */
      "backdrop-brightness": [{
        "backdrop-brightness": [r]
      }],
      /**
       * Backdrop Contrast
       * @see https://tailwindcss.com/docs/backdrop-contrast
       */
      "backdrop-contrast": [{
        "backdrop-contrast": [l]
      }],
      /**
       * Backdrop Grayscale
       * @see https://tailwindcss.com/docs/backdrop-grayscale
       */
      "backdrop-grayscale": [{
        "backdrop-grayscale": [u]
      }],
      /**
       * Backdrop Hue Rotate
       * @see https://tailwindcss.com/docs/backdrop-hue-rotate
       */
      "backdrop-hue-rotate": [{
        "backdrop-hue-rotate": [c]
      }],
      /**
       * Backdrop Invert
       * @see https://tailwindcss.com/docs/backdrop-invert
       */
      "backdrop-invert": [{
        "backdrop-invert": [f]
      }],
      /**
       * Backdrop Opacity
       * @see https://tailwindcss.com/docs/backdrop-opacity
       */
      "backdrop-opacity": [{
        "backdrop-opacity": [g]
      }],
      /**
       * Backdrop Saturate
       * @see https://tailwindcss.com/docs/backdrop-saturate
       */
      "backdrop-saturate": [{
        "backdrop-saturate": [x]
      }],
      /**
       * Backdrop Sepia
       * @see https://tailwindcss.com/docs/backdrop-sepia
       */
      "backdrop-sepia": [{
        "backdrop-sepia": [$]
      }],
      // Tables
      /**
       * Border Collapse
       * @see https://tailwindcss.com/docs/border-collapse
       */
      "border-collapse": [{
        border: ["collapse", "separate"]
      }],
      /**
       * Border Spacing
       * @see https://tailwindcss.com/docs/border-spacing
       */
      "border-spacing": [{
        "border-spacing": [a]
      }],
      /**
       * Border Spacing X
       * @see https://tailwindcss.com/docs/border-spacing
       */
      "border-spacing-x": [{
        "border-spacing-x": [a]
      }],
      /**
       * Border Spacing Y
       * @see https://tailwindcss.com/docs/border-spacing
       */
      "border-spacing-y": [{
        "border-spacing-y": [a]
      }],
      /**
       * Table Layout
       * @see https://tailwindcss.com/docs/table-layout
       */
      "table-layout": [{
        table: ["auto", "fixed"]
      }],
      /**
       * Caption Side
       * @see https://tailwindcss.com/docs/caption-side
       */
      caption: [{
        caption: ["top", "bottom"]
      }],
      // Transitions and Animation
      /**
       * Tranisition Property
       * @see https://tailwindcss.com/docs/transition-property
       */
      transition: [{
        transition: ["none", "all", "", "colors", "opacity", "shadow", "transform", nt]
      }],
      /**
       * Transition Duration
       * @see https://tailwindcss.com/docs/transition-duration
       */
      duration: [{
        duration: re()
      }],
      /**
       * Transition Timing Function
       * @see https://tailwindcss.com/docs/transition-timing-function
       */
      ease: [{
        ease: ["linear", "in", "out", "in-out", nt]
      }],
      /**
       * Transition Delay
       * @see https://tailwindcss.com/docs/transition-delay
       */
      delay: [{
        delay: re()
      }],
      /**
       * Animation
       * @see https://tailwindcss.com/docs/animation
       */
      animate: [{
        animate: ["none", "spin", "ping", "pulse", "bounce", nt]
      }],
      // Transforms
      /**
       * Transform
       * @see https://tailwindcss.com/docs/transform
       */
      transform: [{
        transform: ["", "gpu", "none"]
      }],
      /**
       * Scale
       * @see https://tailwindcss.com/docs/scale
       */
      scale: [{
        scale: [w]
      }],
      /**
       * Scale X
       * @see https://tailwindcss.com/docs/scale
       */
      "scale-x": [{
        "scale-x": [w]
      }],
      /**
       * Scale Y
       * @see https://tailwindcss.com/docs/scale
       */
      "scale-y": [{
        "scale-y": [w]
      }],
      /**
       * Rotate
       * @see https://tailwindcss.com/docs/rotate
       */
      rotate: [{
        rotate: [Dl, nt]
      }],
      /**
       * Translate X
       * @see https://tailwindcss.com/docs/translate
       */
      "translate-x": [{
        "translate-x": [E]
      }],
      /**
       * Translate Y
       * @see https://tailwindcss.com/docs/translate
       */
      "translate-y": [{
        "translate-y": [E]
      }],
      /**
       * Skew X
       * @see https://tailwindcss.com/docs/skew
       */
      "skew-x": [{
        "skew-x": [k]
      }],
      /**
       * Skew Y
       * @see https://tailwindcss.com/docs/skew
       */
      "skew-y": [{
        "skew-y": [k]
      }],
      /**
       * Transform Origin
       * @see https://tailwindcss.com/docs/transform-origin
       */
      "transform-origin": [{
        origin: ["center", "top", "top-right", "right", "bottom-right", "bottom", "bottom-left", "left", "top-left", nt]
      }],
      // Interactivity
      /**
       * Accent Color
       * @see https://tailwindcss.com/docs/accent-color
       */
      accent: [{
        accent: ["auto", e]
      }],
      /**
       * Appearance
       * @see https://tailwindcss.com/docs/appearance
       */
      appearance: ["appearance-none"],
      /**
       * Cursor
       * @see https://tailwindcss.com/docs/cursor
       */
      cursor: [{
        cursor: ["auto", "default", "pointer", "wait", "text", "move", "help", "not-allowed", "none", "context-menu", "progress", "cell", "crosshair", "vertical-text", "alias", "copy", "no-drop", "grab", "grabbing", "all-scroll", "col-resize", "row-resize", "n-resize", "e-resize", "s-resize", "w-resize", "ne-resize", "nw-resize", "se-resize", "sw-resize", "ew-resize", "ns-resize", "nesw-resize", "nwse-resize", "zoom-in", "zoom-out", nt]
      }],
      /**
       * Caret Color
       * @see https://tailwindcss.com/docs/just-in-time-mode#caret-color-utilities
       */
      "caret-color": [{
        caret: [e]
      }],
      /**
       * Pointer Events
       * @see https://tailwindcss.com/docs/pointer-events
       */
      "pointer-events": [{
        "pointer-events": ["none", "auto"]
      }],
      /**
       * Resize
       * @see https://tailwindcss.com/docs/resize
       */
      resize: [{
        resize: ["none", "y", "x", ""]
      }],
      /**
       * Scroll Behavior
       * @see https://tailwindcss.com/docs/scroll-behavior
       */
      "scroll-behavior": [{
        scroll: ["auto", "smooth"]
      }],
      /**
       * Scroll Margin
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-m": [{
        "scroll-m": P()
      }],
      /**
       * Scroll Margin X
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-mx": [{
        "scroll-mx": P()
      }],
      /**
       * Scroll Margin Y
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-my": [{
        "scroll-my": P()
      }],
      /**
       * Scroll Margin Start
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-ms": [{
        "scroll-ms": P()
      }],
      /**
       * Scroll Margin End
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-me": [{
        "scroll-me": P()
      }],
      /**
       * Scroll Margin Top
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-mt": [{
        "scroll-mt": P()
      }],
      /**
       * Scroll Margin Right
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-mr": [{
        "scroll-mr": P()
      }],
      /**
       * Scroll Margin Bottom
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-mb": [{
        "scroll-mb": P()
      }],
      /**
       * Scroll Margin Left
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-ml": [{
        "scroll-ml": P()
      }],
      /**
       * Scroll Padding
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-p": [{
        "scroll-p": P()
      }],
      /**
       * Scroll Padding X
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-px": [{
        "scroll-px": P()
      }],
      /**
       * Scroll Padding Y
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-py": [{
        "scroll-py": P()
      }],
      /**
       * Scroll Padding Start
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-ps": [{
        "scroll-ps": P()
      }],
      /**
       * Scroll Padding End
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pe": [{
        "scroll-pe": P()
      }],
      /**
       * Scroll Padding Top
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pt": [{
        "scroll-pt": P()
      }],
      /**
       * Scroll Padding Right
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pr": [{
        "scroll-pr": P()
      }],
      /**
       * Scroll Padding Bottom
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pb": [{
        "scroll-pb": P()
      }],
      /**
       * Scroll Padding Left
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pl": [{
        "scroll-pl": P()
      }],
      /**
       * Scroll Snap Align
       * @see https://tailwindcss.com/docs/scroll-snap-align
       */
      "snap-align": [{
        snap: ["start", "end", "center", "align-none"]
      }],
      /**
       * Scroll Snap Stop
       * @see https://tailwindcss.com/docs/scroll-snap-stop
       */
      "snap-stop": [{
        snap: ["normal", "always"]
      }],
      /**
       * Scroll Snap Type
       * @see https://tailwindcss.com/docs/scroll-snap-type
       */
      "snap-type": [{
        snap: ["none", "x", "y", "both"]
      }],
      /**
       * Scroll Snap Type Strictness
       * @see https://tailwindcss.com/docs/scroll-snap-type
       */
      "snap-strictness": [{
        snap: ["mandatory", "proximity"]
      }],
      /**
       * Touch Action
       * @see https://tailwindcss.com/docs/touch-action
       */
      touch: [{
        touch: ["auto", "none", "pinch-zoom", "manipulation", {
          pan: ["x", "left", "right", "y", "up", "down"]
        }]
      }],
      /**
       * User Select
       * @see https://tailwindcss.com/docs/user-select
       */
      select: [{
        select: ["none", "text", "all", "auto"]
      }],
      /**
       * Will Change
       * @see https://tailwindcss.com/docs/will-change
       */
      "will-change": [{
        "will-change": ["auto", "scroll", "contents", "transform", nt]
      }],
      // SVG
      /**
       * Fill
       * @see https://tailwindcss.com/docs/fill
       */
      fill: [{
        fill: [e, "none"]
      }],
      /**
       * Stroke Width
       * @see https://tailwindcss.com/docs/stroke-width
       */
      "stroke-w": [{
        stroke: [qr, Sc]
      }],
      /**
       * Stroke
       * @see https://tailwindcss.com/docs/stroke
       */
      stroke: [{
        stroke: [e, "none"]
      }],
      // Accessibility
      /**
       * Screen Readers
       * @see https://tailwindcss.com/docs/screen-readers
       */
      sr: ["sr-only", "not-sr-only"]
    },
    conflictingClassGroups: {
      overflow: ["overflow-x", "overflow-y"],
      overscroll: ["overscroll-x", "overscroll-y"],
      inset: ["inset-x", "inset-y", "start", "end", "top", "right", "bottom", "left"],
      "inset-x": ["right", "left"],
      "inset-y": ["top", "bottom"],
      flex: ["basis", "grow", "shrink"],
      gap: ["gap-x", "gap-y"],
      p: ["px", "py", "ps", "pe", "pt", "pr", "pb", "pl"],
      px: ["pr", "pl"],
      py: ["pt", "pb"],
      m: ["mx", "my", "ms", "me", "mt", "mr", "mb", "ml"],
      mx: ["mr", "ml"],
      my: ["mt", "mb"],
      "font-size": ["leading"],
      "fvn-normal": ["fvn-ordinal", "fvn-slashed-zero", "fvn-figure", "fvn-spacing", "fvn-fraction"],
      "fvn-ordinal": ["fvn-normal"],
      "fvn-slashed-zero": ["fvn-normal"],
      "fvn-figure": ["fvn-normal"],
      "fvn-spacing": ["fvn-normal"],
      "fvn-fraction": ["fvn-normal"],
      rounded: ["rounded-s", "rounded-e", "rounded-t", "rounded-r", "rounded-b", "rounded-l", "rounded-ss", "rounded-se", "rounded-ee", "rounded-es", "rounded-tl", "rounded-tr", "rounded-br", "rounded-bl"],
      "rounded-s": ["rounded-ss", "rounded-es"],
      "rounded-e": ["rounded-se", "rounded-ee"],
      "rounded-t": ["rounded-tl", "rounded-tr"],
      "rounded-r": ["rounded-tr", "rounded-br"],
      "rounded-b": ["rounded-br", "rounded-bl"],
      "rounded-l": ["rounded-tl", "rounded-bl"],
      "border-spacing": ["border-spacing-x", "border-spacing-y"],
      "border-w": ["border-w-s", "border-w-e", "border-w-t", "border-w-r", "border-w-b", "border-w-l"],
      "border-w-x": ["border-w-r", "border-w-l"],
      "border-w-y": ["border-w-t", "border-w-b"],
      "border-color": ["border-color-t", "border-color-r", "border-color-b", "border-color-l"],
      "border-color-x": ["border-color-r", "border-color-l"],
      "border-color-y": ["border-color-t", "border-color-b"],
      "scroll-m": ["scroll-mx", "scroll-my", "scroll-ms", "scroll-me", "scroll-mt", "scroll-mr", "scroll-mb", "scroll-ml"],
      "scroll-mx": ["scroll-mr", "scroll-ml"],
      "scroll-my": ["scroll-mt", "scroll-mb"],
      "scroll-p": ["scroll-px", "scroll-py", "scroll-ps", "scroll-pe", "scroll-pt", "scroll-pr", "scroll-pb", "scroll-pl"],
      "scroll-px": ["scroll-pr", "scroll-pl"],
      "scroll-py": ["scroll-pt", "scroll-pb"]
    },
    conflictingClassGroupModifiers: {
      "font-size": ["leading"]
    }
  };
}
var rr = /* @__PURE__ */ W6(sI);
function Yae(e) {
  const { className: t, children: n, ...r } = e;
  return /* @__PURE__ */ I.jsx("div", { className: rr("p-8", t), ...r, children: /* @__PURE__ */ I.jsxs("div", { className: "border border-orange-2 p-4 bg-orange-100", children: [
    /* @__PURE__ */ I.jsx("h2", { className: "text-2xl mb-4", children: e.heading || "Note" }),
    n
  ] }) });
}
const Qae = (e) => /* @__PURE__ */ I.jsx("div", { ...e });
function s$(e) {
  var t, n, r = "";
  if (typeof e == "string" || typeof e == "number") r += e;
  else if (typeof e == "object") if (Array.isArray(e)) {
    var i = e.length;
    for (t = 0; t < i; t++) e[t] && (n = s$(e[t])) && (r && (r += " "), r += n);
  } else for (n in e) e[n] && (r && (r += " "), r += n);
  return r;
}
function l$() {
  for (var e, t, n = 0, r = "", i = arguments.length; n < i; n++) (e = arguments[n]) && (t = s$(e)) && (r && (r += " "), r += t);
  return r;
}
const x1 = (e) => typeof e == "boolean" ? "".concat(e) : e === 0 ? "0" : e, E1 = l$, Lr = (e, t) => (n) => {
  var r;
  if (t?.variants == null) return E1(e, n?.class, n?.className);
  const { variants: i, defaultVariants: o } = t, a = Object.keys(i).map((u) => {
    const c = n?.[u], f = o?.[u];
    if (c === null) return null;
    const d = x1(c) || x1(f);
    return i[u][d];
  }), s = n && Object.entries(n).reduce((u, c) => {
    let [f, d] = c;
    return d === void 0 || (u[f] = d), u;
  }, {}), l = t == null || (r = t.compoundVariants) === null || r === void 0 ? void 0 : r.reduce((u, c) => {
    let { class: f, className: d, ...p } = c;
    return Object.entries(p).every((h) => {
      let [v, m] = h;
      return Array.isArray(m) ? m.includes({
        ...o,
        ...s
      }[v]) : {
        ...o,
        ...s
      }[v] === m;
    }) ? [
      ...u,
      f,
      d
    ] : u;
  }, []);
  return E1(e, a, l, n?.class, n?.className);
}, lI = Lr(
  [
    "z-0",
    "flex-grow-0",
    "px-4",
    "py-2",
    "text-sm",
    "text-white",
    "transition-all",
    "focus:outline-none",
    "focus:ring-2",
    "focus:ring-opacity-75",
    "disabled:opacity-50",
    "disabled:cursor-default"
  ],
  {
    variants: {
      variant: {
        green: "bg-green-400 focus:ring-green-400 hover:bg-green-500 disabled:bg-green-400",
        blue: "bg-blue-400",
        red: "bg-red-400 focus:ring-red-400 hover:bg-red-500 disabled:bg-red-400",
        gray: "text-black bg-neutral-200 focus:ring-gray-200 hover:bg-neutral-300 disabled:bg-neutral-200",
        black: "bg-black focus:ring-neutral-800 hover:bg-neutral-800 disabled:bg-neutral-800"
      }
    }
  }
), u$ = ({
  variant: e = "black",
  className: t,
  ...n
}) => /* @__PURE__ */ I.jsx(
  "button",
  {
    ...n,
    className: rr(lI({ variant: e }), t)
  }
);
/*!
 * Font Awesome Free 6.7.2 by @fontawesome - https://fontawesome.com
 * License - https://fontawesome.com/license/free (Icons: CC BY 4.0, Fonts: SIL OFL 1.1, Code: MIT License)
 * Copyright 2024 Fonticons, Inc.
 */
const uI = {
  prefix: "fas",
  iconName: "bars",
  icon: [448, 512, ["navicon"], "f0c9", "M0 96C0 78.3 14.3 64 32 64l384 0c17.7 0 32 14.3 32 32s-14.3 32-32 32L32 128C14.3 128 0 113.7 0 96zM0 256c0-17.7 14.3-32 32-32l384 0c17.7 0 32 14.3 32 32s-14.3 32-32 32L32 288c-17.7 0-32-14.3-32-32zM448 416c0 17.7-14.3 32-32 32L32 448c-17.7 0-32-14.3-32-32s14.3-32 32-32l384 0c17.7 0 32 14.3 32 32z"]
}, cI = {
  prefix: "fas",
  iconName: "chevron-up",
  icon: [512, 512, [], "f077", "M233.4 105.4c12.5-12.5 32.8-12.5 45.3 0l192 192c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0L256 173.3 86.6 342.6c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3l192-192z"]
}, fI = {
  prefix: "fas",
  iconName: "clipboard",
  icon: [384, 512, [128203], "f328", "M192 0c-41.8 0-77.4 26.7-90.5 64L64 64C28.7 64 0 92.7 0 128L0 448c0 35.3 28.7 64 64 64l256 0c35.3 0 64-28.7 64-64l0-320c0-35.3-28.7-64-64-64l-37.5 0C269.4 26.7 233.8 0 192 0zm0 64a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM112 192l160 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-160 0c-8.8 0-16-7.2-16-16s7.2-16 16-16z"]
}, dI = {
  prefix: "fas",
  iconName: "user-gear",
  icon: [640, 512, ["user-cog"], "f4fe", "M224 0a128 128 0 1 1 0 256A128 128 0 1 1 224 0zM178.3 304l91.4 0c11.8 0 23.4 1.2 34.5 3.3c-2.1 18.5 7.4 35.6 21.8 44.8c-16.6 10.6-26.7 31.6-20 53.3c4 12.9 9.4 25.5 16.4 37.6s15.2 23.1 24.4 33c15.7 16.9 39.6 18.4 57.2 8.7l0 .9c0 9.2 2.7 18.5 7.9 26.3L29.7 512C13.3 512 0 498.7 0 482.3C0 383.8 79.8 304 178.3 304zM436 218.2c0-7 4.5-13.3 11.3-14.8c10.5-2.4 21.5-3.7 32.7-3.7s22.2 1.3 32.7 3.7c6.8 1.5 11.3 7.8 11.3 14.8l0 30.6c7.9 3.4 15.4 7.7 22.3 12.8l24.9-14.3c6.1-3.5 13.7-2.7 18.5 2.4c7.6 8.1 14.3 17.2 20.1 27.2s10.3 20.4 13.5 31c2.1 6.7-1.1 13.7-7.2 17.2l-25 14.4c.4 4 .7 8.1 .7 12.3s-.2 8.2-.7 12.3l25 14.4c6.1 3.5 9.2 10.5 7.2 17.2c-3.3 10.6-7.8 21-13.5 31s-12.5 19.1-20.1 27.2c-4.8 5.1-12.5 5.9-18.5 2.4l-24.9-14.3c-6.9 5.1-14.3 9.4-22.3 12.8l0 30.6c0 7-4.5 13.3-11.3 14.8c-10.5 2.4-21.5 3.7-32.7 3.7s-22.2-1.3-32.7-3.7c-6.8-1.5-11.3-7.8-11.3-14.8l0-30.5c-8-3.4-15.6-7.7-22.5-12.9l-24.7 14.3c-6.1 3.5-13.7 2.7-18.5-2.4c-7.6-8.1-14.3-17.2-20.1-27.2s-10.3-20.4-13.5-31c-2.1-6.7 1.1-13.7 7.2-17.2l24.8-14.3c-.4-4.1-.7-8.2-.7-12.4s.2-8.3 .7-12.4L343.8 325c-6.1-3.5-9.2-10.5-7.2-17.2c3.3-10.6 7.7-21 13.5-31s12.5-19.1 20.1-27.2c4.8-5.1 12.4-5.9 18.5-2.4l24.8 14.3c6.9-5.1 14.5-9.4 22.5-12.9l0-30.5zm92.1 133.5a48.1 48.1 0 1 0 -96.1 0 48.1 48.1 0 1 0 96.1 0z"]
}, pI = dI, c$ = {
  prefix: "fas",
  iconName: "chevron-down",
  icon: [512, 512, [], "f078", "M233.4 406.6c12.5 12.5 32.8 12.5 45.3 0l192-192c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L256 338.7 86.6 169.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l192 192z"]
}, hI = {
  prefix: "fas",
  iconName: "x",
  icon: [384, 512, [120], "58", "M376.6 84.5c11.3-13.6 9.5-33.8-4.1-45.1s-33.8-9.5-45.1 4.1L192 206 56.6 43.5C45.3 29.9 25.1 28.1 11.5 39.4S-3.9 70.9 7.4 84.5L150.3 256 7.4 427.5c-11.3 13.6-9.5 33.8 4.1 45.1s33.8 9.5 45.1-4.1L192 306 327.4 468.5c11.3 13.6 31.5 15.4 45.1 4.1s15.4-31.5 4.1-45.1L233.7 256 376.6 84.5z"]
};
/*!
 * Font Awesome Free 6.7.2 by @fontawesome - https://fontawesome.com
 * License - https://fontawesome.com/license/free (Icons: CC BY 4.0, Fonts: SIL OFL 1.1, Code: MIT License)
 * Copyright 2024 Fonticons, Inc.
 */
function mI(e, t, n) {
  return (t = gI(t)) in e ? Object.defineProperty(e, t, {
    value: n,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[t] = n, e;
}
function S1(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function(i) {
      return Object.getOwnPropertyDescriptor(e, i).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function be(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? S1(Object(n), !0).forEach(function(r) {
      mI(e, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : S1(Object(n)).forEach(function(r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return e;
}
function vI(e, t) {
  if (typeof e != "object" || !e) return e;
  var n = e[Symbol.toPrimitive];
  if (n !== void 0) {
    var r = n.call(e, t);
    if (typeof r != "object") return r;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
function gI(e) {
  var t = vI(e, "string");
  return typeof t == "symbol" ? t : t + "";
}
const $1 = () => {
};
let py = {}, f$ = {}, d$ = null, p$ = {
  mark: $1,
  measure: $1
};
try {
  typeof window < "u" && (py = window), typeof document < "u" && (f$ = document), typeof MutationObserver < "u" && (d$ = MutationObserver), typeof performance < "u" && (p$ = performance);
} catch {
}
const {
  userAgent: k1 = ""
} = py.navigator || {}, Eo = py, Nt = f$, T1 = d$, $c = p$;
Eo.document;
const eo = !!Nt.documentElement && !!Nt.head && typeof Nt.addEventListener == "function" && typeof Nt.createElement == "function", h$ = ~k1.indexOf("MSIE") || ~k1.indexOf("Trident/");
var yI = /fa(s|r|l|t|d|dr|dl|dt|b|k|kd|ss|sr|sl|st|sds|sdr|sdl|sdt)?[\-\ ]/, bI = /Font ?Awesome ?([56 ]*)(Solid|Regular|Light|Thin|Duotone|Brands|Free|Pro|Sharp Duotone|Sharp|Kit)?.*/i, m$ = {
  classic: {
    fa: "solid",
    fas: "solid",
    "fa-solid": "solid",
    far: "regular",
    "fa-regular": "regular",
    fal: "light",
    "fa-light": "light",
    fat: "thin",
    "fa-thin": "thin",
    fab: "brands",
    "fa-brands": "brands"
  },
  duotone: {
    fa: "solid",
    fad: "solid",
    "fa-solid": "solid",
    "fa-duotone": "solid",
    fadr: "regular",
    "fa-regular": "regular",
    fadl: "light",
    "fa-light": "light",
    fadt: "thin",
    "fa-thin": "thin"
  },
  sharp: {
    fa: "solid",
    fass: "solid",
    "fa-solid": "solid",
    fasr: "regular",
    "fa-regular": "regular",
    fasl: "light",
    "fa-light": "light",
    fast: "thin",
    "fa-thin": "thin"
  },
  "sharp-duotone": {
    fa: "solid",
    fasds: "solid",
    "fa-solid": "solid",
    fasdr: "regular",
    "fa-regular": "regular",
    fasdl: "light",
    "fa-light": "light",
    fasdt: "thin",
    "fa-thin": "thin"
  }
}, _I = {
  GROUP: "duotone-group",
  PRIMARY: "primary",
  SECONDARY: "secondary"
}, v$ = ["fa-classic", "fa-duotone", "fa-sharp", "fa-sharp-duotone"], Mn = "classic", Gd = "duotone", wI = "sharp", xI = "sharp-duotone", g$ = [Mn, Gd, wI, xI], EI = {
  classic: {
    900: "fas",
    400: "far",
    normal: "far",
    300: "fal",
    100: "fat"
  },
  duotone: {
    900: "fad",
    400: "fadr",
    300: "fadl",
    100: "fadt"
  },
  sharp: {
    900: "fass",
    400: "fasr",
    300: "fasl",
    100: "fast"
  },
  "sharp-duotone": {
    900: "fasds",
    400: "fasdr",
    300: "fasdl",
    100: "fasdt"
  }
}, SI = {
  "Font Awesome 6 Free": {
    900: "fas",
    400: "far"
  },
  "Font Awesome 6 Pro": {
    900: "fas",
    400: "far",
    normal: "far",
    300: "fal",
    100: "fat"
  },
  "Font Awesome 6 Brands": {
    400: "fab",
    normal: "fab"
  },
  "Font Awesome 6 Duotone": {
    900: "fad",
    400: "fadr",
    normal: "fadr",
    300: "fadl",
    100: "fadt"
  },
  "Font Awesome 6 Sharp": {
    900: "fass",
    400: "fasr",
    normal: "fasr",
    300: "fasl",
    100: "fast"
  },
  "Font Awesome 6 Sharp Duotone": {
    900: "fasds",
    400: "fasdr",
    normal: "fasdr",
    300: "fasdl",
    100: "fasdt"
  }
}, $I = /* @__PURE__ */ new Map([["classic", {
  defaultShortPrefixId: "fas",
  defaultStyleId: "solid",
  styleIds: ["solid", "regular", "light", "thin", "brands"],
  futureStyleIds: [],
  defaultFontWeight: 900
}], ["sharp", {
  defaultShortPrefixId: "fass",
  defaultStyleId: "solid",
  styleIds: ["solid", "regular", "light", "thin"],
  futureStyleIds: [],
  defaultFontWeight: 900
}], ["duotone", {
  defaultShortPrefixId: "fad",
  defaultStyleId: "solid",
  styleIds: ["solid", "regular", "light", "thin"],
  futureStyleIds: [],
  defaultFontWeight: 900
}], ["sharp-duotone", {
  defaultShortPrefixId: "fasds",
  defaultStyleId: "solid",
  styleIds: ["solid", "regular", "light", "thin"],
  futureStyleIds: [],
  defaultFontWeight: 900
}]]), kI = {
  classic: {
    solid: "fas",
    regular: "far",
    light: "fal",
    thin: "fat",
    brands: "fab"
  },
  duotone: {
    solid: "fad",
    regular: "fadr",
    light: "fadl",
    thin: "fadt"
  },
  sharp: {
    solid: "fass",
    regular: "fasr",
    light: "fasl",
    thin: "fast"
  },
  "sharp-duotone": {
    solid: "fasds",
    regular: "fasdr",
    light: "fasdl",
    thin: "fasdt"
  }
}, TI = ["fak", "fa-kit", "fakd", "fa-kit-duotone"], O1 = {
  kit: {
    fak: "kit",
    "fa-kit": "kit"
  },
  "kit-duotone": {
    fakd: "kit-duotone",
    "fa-kit-duotone": "kit-duotone"
  }
}, OI = ["kit"], PI = {
  kit: {
    "fa-kit": "fak"
  }
}, AI = ["fak", "fakd"], DI = {
  kit: {
    fak: "fa-kit"
  }
}, P1 = {
  kit: {
    kit: "fak"
  },
  "kit-duotone": {
    "kit-duotone": "fakd"
  }
}, kc = {
  GROUP: "duotone-group",
  SWAP_OPACITY: "swap-opacity",
  PRIMARY: "primary",
  SECONDARY: "secondary"
}, CI = ["fa-classic", "fa-duotone", "fa-sharp", "fa-sharp-duotone"], II = ["fak", "fa-kit", "fakd", "fa-kit-duotone"], MI = {
  "Font Awesome Kit": {
    400: "fak",
    normal: "fak"
  },
  "Font Awesome Kit Duotone": {
    400: "fakd",
    normal: "fakd"
  }
}, RI = {
  classic: {
    "fa-brands": "fab",
    "fa-duotone": "fad",
    "fa-light": "fal",
    "fa-regular": "far",
    "fa-solid": "fas",
    "fa-thin": "fat"
  },
  duotone: {
    "fa-regular": "fadr",
    "fa-light": "fadl",
    "fa-thin": "fadt"
  },
  sharp: {
    "fa-solid": "fass",
    "fa-regular": "fasr",
    "fa-light": "fasl",
    "fa-thin": "fast"
  },
  "sharp-duotone": {
    "fa-solid": "fasds",
    "fa-regular": "fasdr",
    "fa-light": "fasdl",
    "fa-thin": "fasdt"
  }
}, NI = {
  classic: ["fas", "far", "fal", "fat", "fad"],
  duotone: ["fadr", "fadl", "fadt"],
  sharp: ["fass", "fasr", "fasl", "fast"],
  "sharp-duotone": ["fasds", "fasdr", "fasdl", "fasdt"]
}, Km = {
  classic: {
    fab: "fa-brands",
    fad: "fa-duotone",
    fal: "fa-light",
    far: "fa-regular",
    fas: "fa-solid",
    fat: "fa-thin"
  },
  duotone: {
    fadr: "fa-regular",
    fadl: "fa-light",
    fadt: "fa-thin"
  },
  sharp: {
    fass: "fa-solid",
    fasr: "fa-regular",
    fasl: "fa-light",
    fast: "fa-thin"
  },
  "sharp-duotone": {
    fasds: "fa-solid",
    fasdr: "fa-regular",
    fasdl: "fa-light",
    fasdt: "fa-thin"
  }
}, jI = ["fa-solid", "fa-regular", "fa-light", "fa-thin", "fa-duotone", "fa-brands"], Um = ["fa", "fas", "far", "fal", "fat", "fad", "fadr", "fadl", "fadt", "fab", "fass", "fasr", "fasl", "fast", "fasds", "fasdr", "fasdl", "fasdt", ...CI, ...jI], FI = ["solid", "regular", "light", "thin", "duotone", "brands"], y$ = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10], zI = y$.concat([11, 12, 13, 14, 15, 16, 17, 18, 19, 20]), LI = [...Object.keys(NI), ...FI, "2xs", "xs", "sm", "lg", "xl", "2xl", "beat", "border", "fade", "beat-fade", "bounce", "flip-both", "flip-horizontal", "flip-vertical", "flip", "fw", "inverse", "layers-counter", "layers-text", "layers", "li", "pull-left", "pull-right", "pulse", "rotate-180", "rotate-270", "rotate-90", "rotate-by", "shake", "spin-pulse", "spin-reverse", "spin", "stack-1x", "stack-2x", "stack", "ul", kc.GROUP, kc.SWAP_OPACITY, kc.PRIMARY, kc.SECONDARY].concat(y$.map((e) => "".concat(e, "x"))).concat(zI.map((e) => "w-".concat(e))), VI = {
  "Font Awesome 5 Free": {
    900: "fas",
    400: "far"
  },
  "Font Awesome 5 Pro": {
    900: "fas",
    400: "far",
    normal: "far",
    300: "fal"
  },
  "Font Awesome 5 Brands": {
    400: "fab",
    normal: "fab"
  },
  "Font Awesome 5 Duotone": {
    900: "fad"
  }
};
const qi = "___FONT_AWESOME___", qm = 16, b$ = "fa", _$ = "svg-inline--fa", _a = "data-fa-i2svg", Hm = "data-fa-pseudo-element", BI = "data-fa-pseudo-element-pending", hy = "data-prefix", my = "data-icon", A1 = "fontawesome-i2svg", KI = "async", UI = ["HTML", "HEAD", "STYLE", "SCRIPT"], w$ = (() => {
  try {
    return process.env.NODE_ENV === "production";
  } catch {
    return !1;
  }
})();
function Yu(e) {
  return new Proxy(e, {
    get(t, n) {
      return n in t ? t[n] : t[Mn];
    }
  });
}
const x$ = be({}, m$);
x$[Mn] = be(be(be(be({}, {
  "fa-duotone": "duotone"
}), m$[Mn]), O1.kit), O1["kit-duotone"]);
const qI = Yu(x$), Wm = be({}, kI);
Wm[Mn] = be(be(be(be({}, {
  duotone: "fad"
}), Wm[Mn]), P1.kit), P1["kit-duotone"]);
const D1 = Yu(Wm), Zm = be({}, Km);
Zm[Mn] = be(be({}, Zm[Mn]), DI.kit);
const vy = Yu(Zm), Gm = be({}, RI);
Gm[Mn] = be(be({}, Gm[Mn]), PI.kit);
Yu(Gm);
const HI = yI, E$ = "fa-layers-text", WI = bI, ZI = be({}, EI);
Yu(ZI);
const GI = ["class", "data-prefix", "data-icon", "data-fa-transform", "data-fa-mask"], uh = _I, YI = [...OI, ...LI], ru = Eo.FontAwesomeConfig || {};
function QI(e) {
  var t = Nt.querySelector("script[" + e + "]");
  if (t)
    return t.getAttribute(e);
}
function JI(e) {
  return e === "" ? !0 : e === "false" ? !1 : e === "true" ? !0 : e;
}
Nt && typeof Nt.querySelector == "function" && [["data-family-prefix", "familyPrefix"], ["data-css-prefix", "cssPrefix"], ["data-family-default", "familyDefault"], ["data-style-default", "styleDefault"], ["data-replacement-class", "replacementClass"], ["data-auto-replace-svg", "autoReplaceSvg"], ["data-auto-add-css", "autoAddCss"], ["data-auto-a11y", "autoA11y"], ["data-search-pseudo-elements", "searchPseudoElements"], ["data-observe-mutations", "observeMutations"], ["data-mutate-approach", "mutateApproach"], ["data-keep-original-source", "keepOriginalSource"], ["data-measure-performance", "measurePerformance"], ["data-show-missing-icons", "showMissingIcons"]].forEach((t) => {
  let [n, r] = t;
  const i = JI(QI(n));
  i != null && (ru[r] = i);
});
const S$ = {
  styleDefault: "solid",
  familyDefault: Mn,
  cssPrefix: b$,
  replacementClass: _$,
  autoReplaceSvg: !0,
  autoAddCss: !0,
  autoA11y: !0,
  searchPseudoElements: !1,
  observeMutations: !0,
  mutateApproach: "async",
  keepOriginalSource: !0,
  measurePerformance: !1,
  showMissingIcons: !0
};
ru.familyPrefix && (ru.cssPrefix = ru.familyPrefix);
const Cs = be(be({}, S$), ru);
Cs.autoReplaceSvg || (Cs.observeMutations = !1);
const Be = {};
Object.keys(S$).forEach((e) => {
  Object.defineProperty(Be, e, {
    enumerable: !0,
    set: function(t) {
      Cs[e] = t, iu.forEach((n) => n(Be));
    },
    get: function() {
      return Cs[e];
    }
  });
});
Object.defineProperty(Be, "familyPrefix", {
  enumerable: !0,
  set: function(e) {
    Cs.cssPrefix = e, iu.forEach((t) => t(Be));
  },
  get: function() {
    return Cs.cssPrefix;
  }
});
Eo.FontAwesomeConfig = Be;
const iu = [];
function XI(e) {
  return iu.push(e), () => {
    iu.splice(iu.indexOf(e), 1);
  };
}
const ao = qm, Si = {
  size: 16,
  x: 0,
  y: 0,
  rotate: 0,
  flipX: !1,
  flipY: !1
};
function eM(e) {
  if (!e || !eo)
    return;
  const t = Nt.createElement("style");
  t.setAttribute("type", "text/css"), t.innerHTML = e;
  const n = Nt.head.childNodes;
  let r = null;
  for (let i = n.length - 1; i > -1; i--) {
    const o = n[i], a = (o.tagName || "").toUpperCase();
    ["STYLE", "LINK"].indexOf(a) > -1 && (r = o);
  }
  return Nt.head.insertBefore(t, r), e;
}
const tM = "0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ";
function gu() {
  let e = 12, t = "";
  for (; e-- > 0; )
    t += tM[Math.random() * 62 | 0];
  return t;
}
function Xs(e) {
  const t = [];
  for (let n = (e || []).length >>> 0; n--; )
    t[n] = e[n];
  return t;
}
function gy(e) {
  return e.classList ? Xs(e.classList) : (e.getAttribute("class") || "").split(" ").filter((t) => t);
}
function $$(e) {
  return "".concat(e).replace(/&/g, "&amp;").replace(/"/g, "&quot;").replace(/'/g, "&#39;").replace(/</g, "&lt;").replace(/>/g, "&gt;");
}
function nM(e) {
  return Object.keys(e || {}).reduce((t, n) => t + "".concat(n, '="').concat($$(e[n]), '" '), "").trim();
}
function Yd(e) {
  return Object.keys(e || {}).reduce((t, n) => t + "".concat(n, ": ").concat(e[n].trim(), ";"), "");
}
function yy(e) {
  return e.size !== Si.size || e.x !== Si.x || e.y !== Si.y || e.rotate !== Si.rotate || e.flipX || e.flipY;
}
function rM(e) {
  let {
    transform: t,
    containerWidth: n,
    iconWidth: r
  } = e;
  const i = {
    transform: "translate(".concat(n / 2, " 256)")
  }, o = "translate(".concat(t.x * 32, ", ").concat(t.y * 32, ") "), a = "scale(".concat(t.size / 16 * (t.flipX ? -1 : 1), ", ").concat(t.size / 16 * (t.flipY ? -1 : 1), ") "), s = "rotate(".concat(t.rotate, " 0 0)"), l = {
    transform: "".concat(o, " ").concat(a, " ").concat(s)
  }, u = {
    transform: "translate(".concat(r / 2 * -1, " -256)")
  };
  return {
    outer: i,
    inner: l,
    path: u
  };
}
function iM(e) {
  let {
    transform: t,
    width: n = qm,
    height: r = qm,
    startCentered: i = !1
  } = e, o = "";
  return i && h$ ? o += "translate(".concat(t.x / ao - n / 2, "em, ").concat(t.y / ao - r / 2, "em) ") : i ? o += "translate(calc(-50% + ".concat(t.x / ao, "em), calc(-50% + ").concat(t.y / ao, "em)) ") : o += "translate(".concat(t.x / ao, "em, ").concat(t.y / ao, "em) "), o += "scale(".concat(t.size / ao * (t.flipX ? -1 : 1), ", ").concat(t.size / ao * (t.flipY ? -1 : 1), ") "), o += "rotate(".concat(t.rotate, "deg) "), o;
}
var oM = `:root, :host {
  --fa-font-solid: normal 900 1em/1 "Font Awesome 6 Free";
  --fa-font-regular: normal 400 1em/1 "Font Awesome 6 Free";
  --fa-font-light: normal 300 1em/1 "Font Awesome 6 Pro";
  --fa-font-thin: normal 100 1em/1 "Font Awesome 6 Pro";
  --fa-font-duotone: normal 900 1em/1 "Font Awesome 6 Duotone";
  --fa-font-duotone-regular: normal 400 1em/1 "Font Awesome 6 Duotone";
  --fa-font-duotone-light: normal 300 1em/1 "Font Awesome 6 Duotone";
  --fa-font-duotone-thin: normal 100 1em/1 "Font Awesome 6 Duotone";
  --fa-font-brands: normal 400 1em/1 "Font Awesome 6 Brands";
  --fa-font-sharp-solid: normal 900 1em/1 "Font Awesome 6 Sharp";
  --fa-font-sharp-regular: normal 400 1em/1 "Font Awesome 6 Sharp";
  --fa-font-sharp-light: normal 300 1em/1 "Font Awesome 6 Sharp";
  --fa-font-sharp-thin: normal 100 1em/1 "Font Awesome 6 Sharp";
  --fa-font-sharp-duotone-solid: normal 900 1em/1 "Font Awesome 6 Sharp Duotone";
  --fa-font-sharp-duotone-regular: normal 400 1em/1 "Font Awesome 6 Sharp Duotone";
  --fa-font-sharp-duotone-light: normal 300 1em/1 "Font Awesome 6 Sharp Duotone";
  --fa-font-sharp-duotone-thin: normal 100 1em/1 "Font Awesome 6 Sharp Duotone";
}

svg:not(:root).svg-inline--fa, svg:not(:host).svg-inline--fa {
  overflow: visible;
  box-sizing: content-box;
}

.svg-inline--fa {
  display: var(--fa-display, inline-block);
  height: 1em;
  overflow: visible;
  vertical-align: -0.125em;
}
.svg-inline--fa.fa-2xs {
  vertical-align: 0.1em;
}
.svg-inline--fa.fa-xs {
  vertical-align: 0em;
}
.svg-inline--fa.fa-sm {
  vertical-align: -0.0714285705em;
}
.svg-inline--fa.fa-lg {
  vertical-align: -0.2em;
}
.svg-inline--fa.fa-xl {
  vertical-align: -0.25em;
}
.svg-inline--fa.fa-2xl {
  vertical-align: -0.3125em;
}
.svg-inline--fa.fa-pull-left {
  margin-right: var(--fa-pull-margin, 0.3em);
  width: auto;
}
.svg-inline--fa.fa-pull-right {
  margin-left: var(--fa-pull-margin, 0.3em);
  width: auto;
}
.svg-inline--fa.fa-li {
  width: var(--fa-li-width, 2em);
  top: 0.25em;
}
.svg-inline--fa.fa-fw {
  width: var(--fa-fw-width, 1.25em);
}

.fa-layers svg.svg-inline--fa {
  bottom: 0;
  left: 0;
  margin: auto;
  position: absolute;
  right: 0;
  top: 0;
}

.fa-layers-counter, .fa-layers-text {
  display: inline-block;
  position: absolute;
  text-align: center;
}

.fa-layers {
  display: inline-block;
  height: 1em;
  position: relative;
  text-align: center;
  vertical-align: -0.125em;
  width: 1em;
}
.fa-layers svg.svg-inline--fa {
  transform-origin: center center;
}

.fa-layers-text {
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  transform-origin: center center;
}

.fa-layers-counter {
  background-color: var(--fa-counter-background-color, #ff253a);
  border-radius: var(--fa-counter-border-radius, 1em);
  box-sizing: border-box;
  color: var(--fa-inverse, #fff);
  line-height: var(--fa-counter-line-height, 1);
  max-width: var(--fa-counter-max-width, 5em);
  min-width: var(--fa-counter-min-width, 1.5em);
  overflow: hidden;
  padding: var(--fa-counter-padding, 0.25em 0.5em);
  right: var(--fa-right, 0);
  text-overflow: ellipsis;
  top: var(--fa-top, 0);
  transform: scale(var(--fa-counter-scale, 0.25));
  transform-origin: top right;
}

.fa-layers-bottom-right {
  bottom: var(--fa-bottom, 0);
  right: var(--fa-right, 0);
  top: auto;
  transform: scale(var(--fa-layers-scale, 0.25));
  transform-origin: bottom right;
}

.fa-layers-bottom-left {
  bottom: var(--fa-bottom, 0);
  left: var(--fa-left, 0);
  right: auto;
  top: auto;
  transform: scale(var(--fa-layers-scale, 0.25));
  transform-origin: bottom left;
}

.fa-layers-top-right {
  top: var(--fa-top, 0);
  right: var(--fa-right, 0);
  transform: scale(var(--fa-layers-scale, 0.25));
  transform-origin: top right;
}

.fa-layers-top-left {
  left: var(--fa-left, 0);
  right: auto;
  top: var(--fa-top, 0);
  transform: scale(var(--fa-layers-scale, 0.25));
  transform-origin: top left;
}

.fa-1x {
  font-size: 1em;
}

.fa-2x {
  font-size: 2em;
}

.fa-3x {
  font-size: 3em;
}

.fa-4x {
  font-size: 4em;
}

.fa-5x {
  font-size: 5em;
}

.fa-6x {
  font-size: 6em;
}

.fa-7x {
  font-size: 7em;
}

.fa-8x {
  font-size: 8em;
}

.fa-9x {
  font-size: 9em;
}

.fa-10x {
  font-size: 10em;
}

.fa-2xs {
  font-size: 0.625em;
  line-height: 0.1em;
  vertical-align: 0.225em;
}

.fa-xs {
  font-size: 0.75em;
  line-height: 0.0833333337em;
  vertical-align: 0.125em;
}

.fa-sm {
  font-size: 0.875em;
  line-height: 0.0714285718em;
  vertical-align: 0.0535714295em;
}

.fa-lg {
  font-size: 1.25em;
  line-height: 0.05em;
  vertical-align: -0.075em;
}

.fa-xl {
  font-size: 1.5em;
  line-height: 0.0416666682em;
  vertical-align: -0.125em;
}

.fa-2xl {
  font-size: 2em;
  line-height: 0.03125em;
  vertical-align: -0.1875em;
}

.fa-fw {
  text-align: center;
  width: 1.25em;
}

.fa-ul {
  list-style-type: none;
  margin-left: var(--fa-li-margin, 2.5em);
  padding-left: 0;
}
.fa-ul > li {
  position: relative;
}

.fa-li {
  left: calc(-1 * var(--fa-li-width, 2em));
  position: absolute;
  text-align: center;
  width: var(--fa-li-width, 2em);
  line-height: inherit;
}

.fa-border {
  border-color: var(--fa-border-color, #eee);
  border-radius: var(--fa-border-radius, 0.1em);
  border-style: var(--fa-border-style, solid);
  border-width: var(--fa-border-width, 0.08em);
  padding: var(--fa-border-padding, 0.2em 0.25em 0.15em);
}

.fa-pull-left {
  float: left;
  margin-right: var(--fa-pull-margin, 0.3em);
}

.fa-pull-right {
  float: right;
  margin-left: var(--fa-pull-margin, 0.3em);
}

.fa-beat {
  animation-name: fa-beat;
  animation-delay: var(--fa-animation-delay, 0s);
  animation-direction: var(--fa-animation-direction, normal);
  animation-duration: var(--fa-animation-duration, 1s);
  animation-iteration-count: var(--fa-animation-iteration-count, infinite);
  animation-timing-function: var(--fa-animation-timing, ease-in-out);
}

.fa-bounce {
  animation-name: fa-bounce;
  animation-delay: var(--fa-animation-delay, 0s);
  animation-direction: var(--fa-animation-direction, normal);
  animation-duration: var(--fa-animation-duration, 1s);
  animation-iteration-count: var(--fa-animation-iteration-count, infinite);
  animation-timing-function: var(--fa-animation-timing, cubic-bezier(0.28, 0.84, 0.42, 1));
}

.fa-fade {
  animation-name: fa-fade;
  animation-delay: var(--fa-animation-delay, 0s);
  animation-direction: var(--fa-animation-direction, normal);
  animation-duration: var(--fa-animation-duration, 1s);
  animation-iteration-count: var(--fa-animation-iteration-count, infinite);
  animation-timing-function: var(--fa-animation-timing, cubic-bezier(0.4, 0, 0.6, 1));
}

.fa-beat-fade {
  animation-name: fa-beat-fade;
  animation-delay: var(--fa-animation-delay, 0s);
  animation-direction: var(--fa-animation-direction, normal);
  animation-duration: var(--fa-animation-duration, 1s);
  animation-iteration-count: var(--fa-animation-iteration-count, infinite);
  animation-timing-function: var(--fa-animation-timing, cubic-bezier(0.4, 0, 0.6, 1));
}

.fa-flip {
  animation-name: fa-flip;
  animation-delay: var(--fa-animation-delay, 0s);
  animation-direction: var(--fa-animation-direction, normal);
  animation-duration: var(--fa-animation-duration, 1s);
  animation-iteration-count: var(--fa-animation-iteration-count, infinite);
  animation-timing-function: var(--fa-animation-timing, ease-in-out);
}

.fa-shake {
  animation-name: fa-shake;
  animation-delay: var(--fa-animation-delay, 0s);
  animation-direction: var(--fa-animation-direction, normal);
  animation-duration: var(--fa-animation-duration, 1s);
  animation-iteration-count: var(--fa-animation-iteration-count, infinite);
  animation-timing-function: var(--fa-animation-timing, linear);
}

.fa-spin {
  animation-name: fa-spin;
  animation-delay: var(--fa-animation-delay, 0s);
  animation-direction: var(--fa-animation-direction, normal);
  animation-duration: var(--fa-animation-duration, 2s);
  animation-iteration-count: var(--fa-animation-iteration-count, infinite);
  animation-timing-function: var(--fa-animation-timing, linear);
}

.fa-spin-reverse {
  --fa-animation-direction: reverse;
}

.fa-pulse,
.fa-spin-pulse {
  animation-name: fa-spin;
  animation-direction: var(--fa-animation-direction, normal);
  animation-duration: var(--fa-animation-duration, 1s);
  animation-iteration-count: var(--fa-animation-iteration-count, infinite);
  animation-timing-function: var(--fa-animation-timing, steps(8));
}

@media (prefers-reduced-motion: reduce) {
  .fa-beat,
.fa-bounce,
.fa-fade,
.fa-beat-fade,
.fa-flip,
.fa-pulse,
.fa-shake,
.fa-spin,
.fa-spin-pulse {
    animation-delay: -1ms;
    animation-duration: 1ms;
    animation-iteration-count: 1;
    transition-delay: 0s;
    transition-duration: 0s;
  }
}
@keyframes fa-beat {
  0%, 90% {
    transform: scale(1);
  }
  45% {
    transform: scale(var(--fa-beat-scale, 1.25));
  }
}
@keyframes fa-bounce {
  0% {
    transform: scale(1, 1) translateY(0);
  }
  10% {
    transform: scale(var(--fa-bounce-start-scale-x, 1.1), var(--fa-bounce-start-scale-y, 0.9)) translateY(0);
  }
  30% {
    transform: scale(var(--fa-bounce-jump-scale-x, 0.9), var(--fa-bounce-jump-scale-y, 1.1)) translateY(var(--fa-bounce-height, -0.5em));
  }
  50% {
    transform: scale(var(--fa-bounce-land-scale-x, 1.05), var(--fa-bounce-land-scale-y, 0.95)) translateY(0);
  }
  57% {
    transform: scale(1, 1) translateY(var(--fa-bounce-rebound, -0.125em));
  }
  64% {
    transform: scale(1, 1) translateY(0);
  }
  100% {
    transform: scale(1, 1) translateY(0);
  }
}
@keyframes fa-fade {
  50% {
    opacity: var(--fa-fade-opacity, 0.4);
  }
}
@keyframes fa-beat-fade {
  0%, 100% {
    opacity: var(--fa-beat-fade-opacity, 0.4);
    transform: scale(1);
  }
  50% {
    opacity: 1;
    transform: scale(var(--fa-beat-fade-scale, 1.125));
  }
}
@keyframes fa-flip {
  50% {
    transform: rotate3d(var(--fa-flip-x, 0), var(--fa-flip-y, 1), var(--fa-flip-z, 0), var(--fa-flip-angle, -180deg));
  }
}
@keyframes fa-shake {
  0% {
    transform: rotate(-15deg);
  }
  4% {
    transform: rotate(15deg);
  }
  8%, 24% {
    transform: rotate(-18deg);
  }
  12%, 28% {
    transform: rotate(18deg);
  }
  16% {
    transform: rotate(-22deg);
  }
  20% {
    transform: rotate(22deg);
  }
  32% {
    transform: rotate(-12deg);
  }
  36% {
    transform: rotate(12deg);
  }
  40%, 100% {
    transform: rotate(0deg);
  }
}
@keyframes fa-spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
.fa-rotate-90 {
  transform: rotate(90deg);
}

.fa-rotate-180 {
  transform: rotate(180deg);
}

.fa-rotate-270 {
  transform: rotate(270deg);
}

.fa-flip-horizontal {
  transform: scale(-1, 1);
}

.fa-flip-vertical {
  transform: scale(1, -1);
}

.fa-flip-both,
.fa-flip-horizontal.fa-flip-vertical {
  transform: scale(-1, -1);
}

.fa-rotate-by {
  transform: rotate(var(--fa-rotate-angle, 0));
}

.fa-stack {
  display: inline-block;
  vertical-align: middle;
  height: 2em;
  position: relative;
  width: 2.5em;
}

.fa-stack-1x,
.fa-stack-2x {
  bottom: 0;
  left: 0;
  margin: auto;
  position: absolute;
  right: 0;
  top: 0;
  z-index: var(--fa-stack-z-index, auto);
}

.svg-inline--fa.fa-stack-1x {
  height: 1em;
  width: 1.25em;
}
.svg-inline--fa.fa-stack-2x {
  height: 2em;
  width: 2.5em;
}

.fa-inverse {
  color: var(--fa-inverse, #fff);
}

.sr-only,
.fa-sr-only {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border-width: 0;
}

.sr-only-focusable:not(:focus),
.fa-sr-only-focusable:not(:focus) {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border-width: 0;
}

.svg-inline--fa .fa-primary {
  fill: var(--fa-primary-color, currentColor);
  opacity: var(--fa-primary-opacity, 1);
}

.svg-inline--fa .fa-secondary {
  fill: var(--fa-secondary-color, currentColor);
  opacity: var(--fa-secondary-opacity, 0.4);
}

.svg-inline--fa.fa-swap-opacity .fa-primary {
  opacity: var(--fa-secondary-opacity, 0.4);
}

.svg-inline--fa.fa-swap-opacity .fa-secondary {
  opacity: var(--fa-primary-opacity, 1);
}

.svg-inline--fa mask .fa-primary,
.svg-inline--fa mask .fa-secondary {
  fill: black;
}`;
function k$() {
  const e = b$, t = _$, n = Be.cssPrefix, r = Be.replacementClass;
  let i = oM;
  if (n !== e || r !== t) {
    const o = new RegExp("\\.".concat(e, "\\-"), "g"), a = new RegExp("\\--".concat(e, "\\-"), "g"), s = new RegExp("\\.".concat(t), "g");
    i = i.replace(o, ".".concat(n, "-")).replace(a, "--".concat(n, "-")).replace(s, ".".concat(r));
  }
  return i;
}
let C1 = !1;
function ch() {
  Be.autoAddCss && !C1 && (eM(k$()), C1 = !0);
}
var aM = {
  mixout() {
    return {
      dom: {
        css: k$,
        insertCss: ch
      }
    };
  },
  hooks() {
    return {
      beforeDOMElementCreation() {
        ch();
      },
      beforeI2svg() {
        ch();
      }
    };
  }
};
const Hi = Eo || {};
Hi[qi] || (Hi[qi] = {});
Hi[qi].styles || (Hi[qi].styles = {});
Hi[qi].hooks || (Hi[qi].hooks = {});
Hi[qi].shims || (Hi[qi].shims = []);
var $i = Hi[qi];
const T$ = [], O$ = function() {
  Nt.removeEventListener("DOMContentLoaded", O$), Kf = 1, T$.map((e) => e());
};
let Kf = !1;
eo && (Kf = (Nt.documentElement.doScroll ? /^loaded|^c/ : /^loaded|^i|^c/).test(Nt.readyState), Kf || Nt.addEventListener("DOMContentLoaded", O$));
function sM(e) {
  eo && (Kf ? setTimeout(e, 0) : T$.push(e));
}
function Qu(e) {
  const {
    tag: t,
    attributes: n = {},
    children: r = []
  } = e;
  return typeof e == "string" ? $$(e) : "<".concat(t, " ").concat(nM(n), ">").concat(r.map(Qu).join(""), "</").concat(t, ">");
}
function I1(e, t, n) {
  if (e && e[t] && e[t][n])
    return {
      prefix: t,
      iconName: n,
      icon: e[t][n]
    };
}
var fh = function(t, n, r, i) {
  var o = Object.keys(t), a = o.length, s = n, l, u, c;
  for (r === void 0 ? (l = 1, c = t[o[0]]) : (l = 0, c = r); l < a; l++)
    u = o[l], c = s(c, t[u], u, t);
  return c;
};
function lM(e) {
  const t = [];
  let n = 0;
  const r = e.length;
  for (; n < r; ) {
    const i = e.charCodeAt(n++);
    if (i >= 55296 && i <= 56319 && n < r) {
      const o = e.charCodeAt(n++);
      (o & 64512) == 56320 ? t.push(((i & 1023) << 10) + (o & 1023) + 65536) : (t.push(i), n--);
    } else
      t.push(i);
  }
  return t;
}
function Ym(e) {
  const t = lM(e);
  return t.length === 1 ? t[0].toString(16) : null;
}
function uM(e, t) {
  const n = e.length;
  let r = e.charCodeAt(t), i;
  return r >= 55296 && r <= 56319 && n > t + 1 && (i = e.charCodeAt(t + 1), i >= 56320 && i <= 57343) ? (r - 55296) * 1024 + i - 56320 + 65536 : r;
}
function M1(e) {
  return Object.keys(e).reduce((t, n) => {
    const r = e[n];
    return !!r.icon ? t[r.iconName] = r.icon : t[n] = r, t;
  }, {});
}
function Qm(e, t) {
  let n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
  const {
    skipHooks: r = !1
  } = n, i = M1(t);
  typeof $i.hooks.addPack == "function" && !r ? $i.hooks.addPack(e, M1(t)) : $i.styles[e] = be(be({}, $i.styles[e] || {}), i), e === "fas" && Qm("fa", t);
}
const {
  styles: yu,
  shims: cM
} = $i, P$ = Object.keys(vy), fM = P$.reduce((e, t) => (e[t] = Object.keys(vy[t]), e), {});
let by = null, A$ = {}, D$ = {}, C$ = {}, I$ = {}, M$ = {};
function dM(e) {
  return ~YI.indexOf(e);
}
function pM(e, t) {
  const n = t.split("-"), r = n[0], i = n.slice(1).join("-");
  return r === e && i !== "" && !dM(i) ? i : null;
}
const R$ = () => {
  const e = (r) => fh(yu, (i, o, a) => (i[a] = fh(o, r, {}), i), {});
  A$ = e((r, i, o) => (i[3] && (r[i[3]] = o), i[2] && i[2].filter((s) => typeof s == "number").forEach((s) => {
    r[s.toString(16)] = o;
  }), r)), D$ = e((r, i, o) => (r[o] = o, i[2] && i[2].filter((s) => typeof s == "string").forEach((s) => {
    r[s] = o;
  }), r)), M$ = e((r, i, o) => {
    const a = i[2];
    return r[o] = o, a.forEach((s) => {
      r[s] = o;
    }), r;
  });
  const t = "far" in yu || Be.autoFetchSvg, n = fh(cM, (r, i) => {
    const o = i[0];
    let a = i[1];
    const s = i[2];
    return a === "far" && !t && (a = "fas"), typeof o == "string" && (r.names[o] = {
      prefix: a,
      iconName: s
    }), typeof o == "number" && (r.unicodes[o.toString(16)] = {
      prefix: a,
      iconName: s
    }), r;
  }, {
    names: {},
    unicodes: {}
  });
  C$ = n.names, I$ = n.unicodes, by = Qd(Be.styleDefault, {
    family: Be.familyDefault
  });
};
XI((e) => {
  by = Qd(e.styleDefault, {
    family: Be.familyDefault
  });
});
R$();
function _y(e, t) {
  return (A$[e] || {})[t];
}
function hM(e, t) {
  return (D$[e] || {})[t];
}
function la(e, t) {
  return (M$[e] || {})[t];
}
function N$(e) {
  return C$[e] || {
    prefix: null,
    iconName: null
  };
}
function mM(e) {
  const t = I$[e], n = _y("fas", e);
  return t || (n ? {
    prefix: "fas",
    iconName: n
  } : null) || {
    prefix: null,
    iconName: null
  };
}
function So() {
  return by;
}
const j$ = () => ({
  prefix: null,
  iconName: null,
  rest: []
});
function vM(e) {
  let t = Mn;
  const n = P$.reduce((r, i) => (r[i] = "".concat(Be.cssPrefix, "-").concat(i), r), {});
  return g$.forEach((r) => {
    (e.includes(n[r]) || e.some((i) => fM[r].includes(i))) && (t = r);
  }), t;
}
function Qd(e) {
  let t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
  const {
    family: n = Mn
  } = t, r = qI[n][e];
  if (n === Gd && !e)
    return "fad";
  const i = D1[n][e] || D1[n][r], o = e in $i.styles ? e : null;
  return i || o || null;
}
function gM(e) {
  let t = [], n = null;
  return e.forEach((r) => {
    const i = pM(Be.cssPrefix, r);
    i ? n = i : r && t.push(r);
  }), {
    iconName: n,
    rest: t
  };
}
function R1(e) {
  return e.sort().filter((t, n, r) => r.indexOf(t) === n);
}
function Jd(e) {
  let t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
  const {
    skipLookups: n = !1
  } = t;
  let r = null;
  const i = Um.concat(II), o = R1(e.filter((f) => i.includes(f))), a = R1(e.filter((f) => !Um.includes(f))), s = o.filter((f) => (r = f, !v$.includes(f))), [l = null] = s, u = vM(o), c = be(be({}, gM(a)), {}, {
    prefix: Qd(l, {
      family: u
    })
  });
  return be(be(be({}, c), wM({
    values: e,
    family: u,
    styles: yu,
    config: Be,
    canonical: c,
    givenPrefix: r
  })), yM(n, r, c));
}
function yM(e, t, n) {
  let {
    prefix: r,
    iconName: i
  } = n;
  if (e || !r || !i)
    return {
      prefix: r,
      iconName: i
    };
  const o = t === "fa" ? N$(i) : {}, a = la(r, i);
  return i = o.iconName || a || i, r = o.prefix || r, r === "far" && !yu.far && yu.fas && !Be.autoFetchSvg && (r = "fas"), {
    prefix: r,
    iconName: i
  };
}
const bM = g$.filter((e) => e !== Mn || e !== Gd), _M = Object.keys(Km).filter((e) => e !== Mn).map((e) => Object.keys(Km[e])).flat();
function wM(e) {
  const {
    values: t,
    family: n,
    canonical: r,
    givenPrefix: i = "",
    styles: o = {},
    config: a = {}
  } = e, s = n === Gd, l = t.includes("fa-duotone") || t.includes("fad"), u = a.familyDefault === "duotone", c = r.prefix === "fad" || r.prefix === "fa-duotone";
  if (!s && (l || u || c) && (r.prefix = "fad"), (t.includes("fa-brands") || t.includes("fab")) && (r.prefix = "fab"), !r.prefix && bM.includes(n) && (Object.keys(o).find((d) => _M.includes(d)) || a.autoFetchSvg)) {
    const d = $I.get(n).defaultShortPrefixId;
    r.prefix = d, r.iconName = la(r.prefix, r.iconName) || r.iconName;
  }
  return (r.prefix === "fa" || i === "fa") && (r.prefix = So() || "fas"), r;
}
class xM {
  constructor() {
    this.definitions = {};
  }
  add() {
    for (var t = arguments.length, n = new Array(t), r = 0; r < t; r++)
      n[r] = arguments[r];
    const i = n.reduce(this._pullDefinitions, {});
    Object.keys(i).forEach((o) => {
      this.definitions[o] = be(be({}, this.definitions[o] || {}), i[o]), Qm(o, i[o]);
      const a = vy[Mn][o];
      a && Qm(a, i[o]), R$();
    });
  }
  reset() {
    this.definitions = {};
  }
  _pullDefinitions(t, n) {
    const r = n.prefix && n.iconName && n.icon ? {
      0: n
    } : n;
    return Object.keys(r).map((i) => {
      const {
        prefix: o,
        iconName: a,
        icon: s
      } = r[i], l = s[2];
      t[o] || (t[o] = {}), l.length > 0 && l.forEach((u) => {
        typeof u == "string" && (t[o][u] = s);
      }), t[o][a] = s;
    }), t;
  }
}
let N1 = [], os = {};
const xs = {}, EM = Object.keys(xs);
function SM(e, t) {
  let {
    mixoutsTo: n
  } = t;
  return N1 = e, os = {}, Object.keys(xs).forEach((r) => {
    EM.indexOf(r) === -1 && delete xs[r];
  }), N1.forEach((r) => {
    const i = r.mixout ? r.mixout() : {};
    if (Object.keys(i).forEach((o) => {
      typeof i[o] == "function" && (n[o] = i[o]), typeof i[o] == "object" && Object.keys(i[o]).forEach((a) => {
        n[o] || (n[o] = {}), n[o][a] = i[o][a];
      });
    }), r.hooks) {
      const o = r.hooks();
      Object.keys(o).forEach((a) => {
        os[a] || (os[a] = []), os[a].push(o[a]);
      });
    }
    r.provides && r.provides(xs);
  }), n;
}
function Jm(e, t) {
  for (var n = arguments.length, r = new Array(n > 2 ? n - 2 : 0), i = 2; i < n; i++)
    r[i - 2] = arguments[i];
  return (os[e] || []).forEach((a) => {
    t = a.apply(null, [t, ...r]);
  }), t;
}
function wa(e) {
  for (var t = arguments.length, n = new Array(t > 1 ? t - 1 : 0), r = 1; r < t; r++)
    n[r - 1] = arguments[r];
  (os[e] || []).forEach((o) => {
    o.apply(null, n);
  });
}
function $o() {
  const e = arguments[0], t = Array.prototype.slice.call(arguments, 1);
  return xs[e] ? xs[e].apply(null, t) : void 0;
}
function Xm(e) {
  e.prefix === "fa" && (e.prefix = "fas");
  let {
    iconName: t
  } = e;
  const n = e.prefix || So();
  if (t)
    return t = la(n, t) || t, I1(F$.definitions, n, t) || I1($i.styles, n, t);
}
const F$ = new xM(), $M = () => {
  Be.autoReplaceSvg = !1, Be.observeMutations = !1, wa("noAuto");
}, kM = {
  i2svg: function() {
    let e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    return eo ? (wa("beforeI2svg", e), $o("pseudoElements2svg", e), $o("i2svg", e)) : Promise.reject(new Error("Operation requires a DOM of some kind."));
  },
  watch: function() {
    let e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    const {
      autoReplaceSvgRoot: t
    } = e;
    Be.autoReplaceSvg === !1 && (Be.autoReplaceSvg = !0), Be.observeMutations = !0, sM(() => {
      OM({
        autoReplaceSvgRoot: t
      }), wa("watch", e);
    });
  }
}, TM = {
  icon: (e) => {
    if (e === null)
      return null;
    if (typeof e == "object" && e.prefix && e.iconName)
      return {
        prefix: e.prefix,
        iconName: la(e.prefix, e.iconName) || e.iconName
      };
    if (Array.isArray(e) && e.length === 2) {
      const t = e[1].indexOf("fa-") === 0 ? e[1].slice(3) : e[1], n = Qd(e[0]);
      return {
        prefix: n,
        iconName: la(n, t) || t
      };
    }
    if (typeof e == "string" && (e.indexOf("".concat(Be.cssPrefix, "-")) > -1 || e.match(HI))) {
      const t = Jd(e.split(" "), {
        skipLookups: !0
      });
      return {
        prefix: t.prefix || So(),
        iconName: la(t.prefix, t.iconName) || t.iconName
      };
    }
    if (typeof e == "string") {
      const t = So();
      return {
        prefix: t,
        iconName: la(t, e) || e
      };
    }
  }
}, _r = {
  noAuto: $M,
  config: Be,
  dom: kM,
  parse: TM,
  library: F$,
  findIconDefinition: Xm,
  toHtml: Qu
}, OM = function() {
  let e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
  const {
    autoReplaceSvgRoot: t = Nt
  } = e;
  (Object.keys($i.styles).length > 0 || Be.autoFetchSvg) && eo && Be.autoReplaceSvg && _r.dom.i2svg({
    node: t
  });
};
function Xd(e, t) {
  return Object.defineProperty(e, "abstract", {
    get: t
  }), Object.defineProperty(e, "html", {
    get: function() {
      return e.abstract.map((n) => Qu(n));
    }
  }), Object.defineProperty(e, "node", {
    get: function() {
      if (!eo) return;
      const n = Nt.createElement("div");
      return n.innerHTML = e.html, n.children;
    }
  }), e;
}
function PM(e) {
  let {
    children: t,
    main: n,
    mask: r,
    attributes: i,
    styles: o,
    transform: a
  } = e;
  if (yy(a) && n.found && !r.found) {
    const {
      width: s,
      height: l
    } = n, u = {
      x: s / l / 2,
      y: 0.5
    };
    i.style = Yd(be(be({}, o), {}, {
      "transform-origin": "".concat(u.x + a.x / 16, "em ").concat(u.y + a.y / 16, "em")
    }));
  }
  return [{
    tag: "svg",
    attributes: i,
    children: t
  }];
}
function AM(e) {
  let {
    prefix: t,
    iconName: n,
    children: r,
    attributes: i,
    symbol: o
  } = e;
  const a = o === !0 ? "".concat(t, "-").concat(Be.cssPrefix, "-").concat(n) : o;
  return [{
    tag: "svg",
    attributes: {
      style: "display: none;"
    },
    children: [{
      tag: "symbol",
      attributes: be(be({}, i), {}, {
        id: a
      }),
      children: r
    }]
  }];
}
function wy(e) {
  const {
    icons: {
      main: t,
      mask: n
    },
    prefix: r,
    iconName: i,
    transform: o,
    symbol: a,
    title: s,
    maskId: l,
    titleId: u,
    extra: c,
    watchable: f = !1
  } = e, {
    width: d,
    height: p
  } = n.found ? n : t, h = AI.includes(r), v = [Be.replacementClass, i ? "".concat(Be.cssPrefix, "-").concat(i) : ""].filter(($) => c.classes.indexOf($) === -1).filter(($) => $ !== "" || !!$).concat(c.classes).join(" ");
  let m = {
    children: [],
    attributes: be(be({}, c.attributes), {}, {
      "data-prefix": r,
      "data-icon": i,
      class: v,
      role: c.attributes.role || "img",
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 ".concat(d, " ").concat(p)
    })
  };
  const g = h && !~c.classes.indexOf("fa-fw") ? {
    width: "".concat(d / p * 16 * 0.0625, "em")
  } : {};
  f && (m.attributes[_a] = ""), s && (m.children.push({
    tag: "title",
    attributes: {
      id: m.attributes["aria-labelledby"] || "title-".concat(u || gu())
    },
    children: [s]
  }), delete m.attributes.title);
  const _ = be(be({}, m), {}, {
    prefix: r,
    iconName: i,
    main: t,
    mask: n,
    maskId: l,
    transform: o,
    symbol: a,
    styles: be(be({}, g), c.styles)
  }), {
    children: x,
    attributes: w
  } = n.found && t.found ? $o("generateAbstractMask", _) || {
    children: [],
    attributes: {}
  } : $o("generateAbstractIcon", _) || {
    children: [],
    attributes: {}
  };
  return _.children = x, _.attributes = w, a ? AM(_) : PM(_);
}
function j1(e) {
  const {
    content: t,
    width: n,
    height: r,
    transform: i,
    title: o,
    extra: a,
    watchable: s = !1
  } = e, l = be(be(be({}, a.attributes), o ? {
    title: o
  } : {}), {}, {
    class: a.classes.join(" ")
  });
  s && (l[_a] = "");
  const u = be({}, a.styles);
  yy(i) && (u.transform = iM({
    transform: i,
    startCentered: !0,
    width: n,
    height: r
  }), u["-webkit-transform"] = u.transform);
  const c = Yd(u);
  c.length > 0 && (l.style = c);
  const f = [];
  return f.push({
    tag: "span",
    attributes: l,
    children: [t]
  }), o && f.push({
    tag: "span",
    attributes: {
      class: "sr-only"
    },
    children: [o]
  }), f;
}
function DM(e) {
  const {
    content: t,
    title: n,
    extra: r
  } = e, i = be(be(be({}, r.attributes), n ? {
    title: n
  } : {}), {}, {
    class: r.classes.join(" ")
  }), o = Yd(r.styles);
  o.length > 0 && (i.style = o);
  const a = [];
  return a.push({
    tag: "span",
    attributes: i,
    children: [t]
  }), n && a.push({
    tag: "span",
    attributes: {
      class: "sr-only"
    },
    children: [n]
  }), a;
}
const {
  styles: dh
} = $i;
function ev(e) {
  const t = e[0], n = e[1], [r] = e.slice(4);
  let i = null;
  return Array.isArray(r) ? i = {
    tag: "g",
    attributes: {
      class: "".concat(Be.cssPrefix, "-").concat(uh.GROUP)
    },
    children: [{
      tag: "path",
      attributes: {
        class: "".concat(Be.cssPrefix, "-").concat(uh.SECONDARY),
        fill: "currentColor",
        d: r[0]
      }
    }, {
      tag: "path",
      attributes: {
        class: "".concat(Be.cssPrefix, "-").concat(uh.PRIMARY),
        fill: "currentColor",
        d: r[1]
      }
    }]
  } : i = {
    tag: "path",
    attributes: {
      fill: "currentColor",
      d: r
    }
  }, {
    found: !0,
    width: t,
    height: n,
    icon: i
  };
}
const CM = {
  found: !1,
  width: 512,
  height: 512
};
function IM(e, t) {
  !w$ && !Be.showMissingIcons && e && console.error('Icon with name "'.concat(e, '" and prefix "').concat(t, '" is missing.'));
}
function tv(e, t) {
  let n = t;
  return t === "fa" && Be.styleDefault !== null && (t = So()), new Promise((r, i) => {
    if (n === "fa") {
      const o = N$(e) || {};
      e = o.iconName || e, t = o.prefix || t;
    }
    if (e && t && dh[t] && dh[t][e]) {
      const o = dh[t][e];
      return r(ev(o));
    }
    IM(e, t), r(be(be({}, CM), {}, {
      icon: Be.showMissingIcons && e ? $o("missingIconAbstract") || {} : {}
    }));
  });
}
const F1 = () => {
}, nv = Be.measurePerformance && $c && $c.mark && $c.measure ? $c : {
  mark: F1,
  measure: F1
}, Ul = 'FA "6.7.2"', MM = (e) => (nv.mark("".concat(Ul, " ").concat(e, " begins")), () => z$(e)), z$ = (e) => {
  nv.mark("".concat(Ul, " ").concat(e, " ends")), nv.measure("".concat(Ul, " ").concat(e), "".concat(Ul, " ").concat(e, " begins"), "".concat(Ul, " ").concat(e, " ends"));
};
var xy = {
  begin: MM,
  end: z$
};
const df = () => {
};
function z1(e) {
  return typeof (e.getAttribute ? e.getAttribute(_a) : null) == "string";
}
function RM(e) {
  const t = e.getAttribute ? e.getAttribute(hy) : null, n = e.getAttribute ? e.getAttribute(my) : null;
  return t && n;
}
function NM(e) {
  return e && e.classList && e.classList.contains && e.classList.contains(Be.replacementClass);
}
function jM() {
  return Be.autoReplaceSvg === !0 ? pf.replace : pf[Be.autoReplaceSvg] || pf.replace;
}
function FM(e) {
  return Nt.createElementNS("http://www.w3.org/2000/svg", e);
}
function zM(e) {
  return Nt.createElement(e);
}
function L$(e) {
  let t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
  const {
    ceFn: n = e.tag === "svg" ? FM : zM
  } = t;
  if (typeof e == "string")
    return Nt.createTextNode(e);
  const r = n(e.tag);
  return Object.keys(e.attributes || []).forEach(function(o) {
    r.setAttribute(o, e.attributes[o]);
  }), (e.children || []).forEach(function(o) {
    r.appendChild(L$(o, {
      ceFn: n
    }));
  }), r;
}
function LM(e) {
  let t = " ".concat(e.outerHTML, " ");
  return t = "".concat(t, "Font Awesome fontawesome.com "), t;
}
const pf = {
  replace: function(e) {
    const t = e[0];
    if (t.parentNode)
      if (e[1].forEach((n) => {
        t.parentNode.insertBefore(L$(n), t);
      }), t.getAttribute(_a) === null && Be.keepOriginalSource) {
        let n = Nt.createComment(LM(t));
        t.parentNode.replaceChild(n, t);
      } else
        t.remove();
  },
  nest: function(e) {
    const t = e[0], n = e[1];
    if (~gy(t).indexOf(Be.replacementClass))
      return pf.replace(e);
    const r = new RegExp("".concat(Be.cssPrefix, "-.*"));
    if (delete n[0].attributes.id, n[0].attributes.class) {
      const o = n[0].attributes.class.split(" ").reduce((a, s) => (s === Be.replacementClass || s.match(r) ? a.toSvg.push(s) : a.toNode.push(s), a), {
        toNode: [],
        toSvg: []
      });
      n[0].attributes.class = o.toSvg.join(" "), o.toNode.length === 0 ? t.removeAttribute("class") : t.setAttribute("class", o.toNode.join(" "));
    }
    const i = n.map((o) => Qu(o)).join(`
`);
    t.setAttribute(_a, ""), t.innerHTML = i;
  }
};
function L1(e) {
  e();
}
function V$(e, t) {
  const n = typeof t == "function" ? t : df;
  if (e.length === 0)
    n();
  else {
    let r = L1;
    Be.mutateApproach === KI && (r = Eo.requestAnimationFrame || L1), r(() => {
      const i = jM(), o = xy.begin("mutate");
      e.map(i), o(), n();
    });
  }
}
let Ey = !1;
function B$() {
  Ey = !0;
}
function rv() {
  Ey = !1;
}
let Uf = null;
function V1(e) {
  if (!T1 || !Be.observeMutations)
    return;
  const {
    treeCallback: t = df,
    nodeCallback: n = df,
    pseudoElementsCallback: r = df,
    observeMutationsRoot: i = Nt
  } = e;
  Uf = new T1((o) => {
    if (Ey) return;
    const a = So();
    Xs(o).forEach((s) => {
      if (s.type === "childList" && s.addedNodes.length > 0 && !z1(s.addedNodes[0]) && (Be.searchPseudoElements && r(s.target), t(s.target)), s.type === "attributes" && s.target.parentNode && Be.searchPseudoElements && r(s.target.parentNode), s.type === "attributes" && z1(s.target) && ~GI.indexOf(s.attributeName))
        if (s.attributeName === "class" && RM(s.target)) {
          const {
            prefix: l,
            iconName: u
          } = Jd(gy(s.target));
          s.target.setAttribute(hy, l || a), u && s.target.setAttribute(my, u);
        } else NM(s.target) && n(s.target);
    });
  }), eo && Uf.observe(i, {
    childList: !0,
    attributes: !0,
    characterData: !0,
    subtree: !0
  });
}
function VM() {
  Uf && Uf.disconnect();
}
function BM(e) {
  const t = e.getAttribute("style");
  let n = [];
  return t && (n = t.split(";").reduce((r, i) => {
    const o = i.split(":"), a = o[0], s = o.slice(1);
    return a && s.length > 0 && (r[a] = s.join(":").trim()), r;
  }, {})), n;
}
function KM(e) {
  const t = e.getAttribute("data-prefix"), n = e.getAttribute("data-icon"), r = e.innerText !== void 0 ? e.innerText.trim() : "";
  let i = Jd(gy(e));
  return i.prefix || (i.prefix = So()), t && n && (i.prefix = t, i.iconName = n), i.iconName && i.prefix || (i.prefix && r.length > 0 && (i.iconName = hM(i.prefix, e.innerText) || _y(i.prefix, Ym(e.innerText))), !i.iconName && Be.autoFetchSvg && e.firstChild && e.firstChild.nodeType === Node.TEXT_NODE && (i.iconName = e.firstChild.data)), i;
}
function UM(e) {
  const t = Xs(e.attributes).reduce((i, o) => (i.name !== "class" && i.name !== "style" && (i[o.name] = o.value), i), {}), n = e.getAttribute("title"), r = e.getAttribute("data-fa-title-id");
  return Be.autoA11y && (n ? t["aria-labelledby"] = "".concat(Be.replacementClass, "-title-").concat(r || gu()) : (t["aria-hidden"] = "true", t.focusable = "false")), t;
}
function qM() {
  return {
    iconName: null,
    title: null,
    titleId: null,
    prefix: null,
    transform: Si,
    symbol: !1,
    mask: {
      iconName: null,
      prefix: null,
      rest: []
    },
    maskId: null,
    extra: {
      classes: [],
      styles: {},
      attributes: {}
    }
  };
}
function B1(e) {
  let t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {
    styleParser: !0
  };
  const {
    iconName: n,
    prefix: r,
    rest: i
  } = KM(e), o = UM(e), a = Jm("parseNodeAttributes", {}, e);
  let s = t.styleParser ? BM(e) : [];
  return be({
    iconName: n,
    title: e.getAttribute("title"),
    titleId: e.getAttribute("data-fa-title-id"),
    prefix: r,
    transform: Si,
    mask: {
      iconName: null,
      prefix: null,
      rest: []
    },
    maskId: null,
    symbol: !1,
    extra: {
      classes: i,
      styles: s,
      attributes: o
    }
  }, a);
}
const {
  styles: HM
} = $i;
function K$(e) {
  const t = Be.autoReplaceSvg === "nest" ? B1(e, {
    styleParser: !1
  }) : B1(e);
  return ~t.extra.classes.indexOf(E$) ? $o("generateLayersText", e, t) : $o("generateSvgReplacementMutation", e, t);
}
function WM() {
  return [...TI, ...Um];
}
function K1(e) {
  let t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null;
  if (!eo) return Promise.resolve();
  const n = Nt.documentElement.classList, r = (c) => n.add("".concat(A1, "-").concat(c)), i = (c) => n.remove("".concat(A1, "-").concat(c)), o = Be.autoFetchSvg ? WM() : v$.concat(Object.keys(HM));
  o.includes("fa") || o.push("fa");
  const a = [".".concat(E$, ":not([").concat(_a, "])")].concat(o.map((c) => ".".concat(c, ":not([").concat(_a, "])"))).join(", ");
  if (a.length === 0)
    return Promise.resolve();
  let s = [];
  try {
    s = Xs(e.querySelectorAll(a));
  } catch {
  }
  if (s.length > 0)
    r("pending"), i("complete");
  else
    return Promise.resolve();
  const l = xy.begin("onTree"), u = s.reduce((c, f) => {
    try {
      const d = K$(f);
      d && c.push(d);
    } catch (d) {
      w$ || d.name === "MissingIcon" && console.error(d);
    }
    return c;
  }, []);
  return new Promise((c, f) => {
    Promise.all(u).then((d) => {
      V$(d, () => {
        r("active"), r("complete"), i("pending"), typeof t == "function" && t(), l(), c();
      });
    }).catch((d) => {
      l(), f(d);
    });
  });
}
function ZM(e) {
  let t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null;
  K$(e).then((n) => {
    n && V$([n], t);
  });
}
function GM(e) {
  return function(t) {
    let n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    const r = (t || {}).icon ? t : Xm(t || {});
    let {
      mask: i
    } = n;
    return i && (i = (i || {}).icon ? i : Xm(i || {})), e(r, be(be({}, n), {}, {
      mask: i
    }));
  };
}
const YM = function(e) {
  let t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
  const {
    transform: n = Si,
    symbol: r = !1,
    mask: i = null,
    maskId: o = null,
    title: a = null,
    titleId: s = null,
    classes: l = [],
    attributes: u = {},
    styles: c = {}
  } = t;
  if (!e) return;
  const {
    prefix: f,
    iconName: d,
    icon: p
  } = e;
  return Xd(be({
    type: "icon"
  }, e), () => (wa("beforeDOMElementCreation", {
    iconDefinition: e,
    params: t
  }), Be.autoA11y && (a ? u["aria-labelledby"] = "".concat(Be.replacementClass, "-title-").concat(s || gu()) : (u["aria-hidden"] = "true", u.focusable = "false")), wy({
    icons: {
      main: ev(p),
      mask: i ? ev(i.icon) : {
        found: !1,
        width: null,
        height: null,
        icon: {}
      }
    },
    prefix: f,
    iconName: d,
    transform: be(be({}, Si), n),
    symbol: r,
    title: a,
    maskId: o,
    titleId: s,
    extra: {
      attributes: u,
      styles: c,
      classes: l
    }
  })));
};
var QM = {
  mixout() {
    return {
      icon: GM(YM)
    };
  },
  hooks() {
    return {
      mutationObserverCallbacks(e) {
        return e.treeCallback = K1, e.nodeCallback = ZM, e;
      }
    };
  },
  provides(e) {
    e.i2svg = function(t) {
      const {
        node: n = Nt,
        callback: r = () => {
        }
      } = t;
      return K1(n, r);
    }, e.generateSvgReplacementMutation = function(t, n) {
      const {
        iconName: r,
        title: i,
        titleId: o,
        prefix: a,
        transform: s,
        symbol: l,
        mask: u,
        maskId: c,
        extra: f
      } = n;
      return new Promise((d, p) => {
        Promise.all([tv(r, a), u.iconName ? tv(u.iconName, u.prefix) : Promise.resolve({
          found: !1,
          width: 512,
          height: 512,
          icon: {}
        })]).then((h) => {
          let [v, m] = h;
          d([t, wy({
            icons: {
              main: v,
              mask: m
            },
            prefix: a,
            iconName: r,
            transform: s,
            symbol: l,
            maskId: c,
            title: i,
            titleId: o,
            extra: f,
            watchable: !0
          })]);
        }).catch(p);
      });
    }, e.generateAbstractIcon = function(t) {
      let {
        children: n,
        attributes: r,
        main: i,
        transform: o,
        styles: a
      } = t;
      const s = Yd(a);
      s.length > 0 && (r.style = s);
      let l;
      return yy(o) && (l = $o("generateAbstractTransformGrouping", {
        main: i,
        transform: o,
        containerWidth: i.width,
        iconWidth: i.width
      })), n.push(l || i.icon), {
        children: n,
        attributes: r
      };
    };
  }
}, JM = {
  mixout() {
    return {
      layer(e) {
        let t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
        const {
          classes: n = []
        } = t;
        return Xd({
          type: "layer"
        }, () => {
          wa("beforeDOMElementCreation", {
            assembler: e,
            params: t
          });
          let r = [];
          return e((i) => {
            Array.isArray(i) ? i.map((o) => {
              r = r.concat(o.abstract);
            }) : r = r.concat(i.abstract);
          }), [{
            tag: "span",
            attributes: {
              class: ["".concat(Be.cssPrefix, "-layers"), ...n].join(" ")
            },
            children: r
          }];
        });
      }
    };
  }
}, XM = {
  mixout() {
    return {
      counter(e) {
        let t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
        const {
          title: n = null,
          classes: r = [],
          attributes: i = {},
          styles: o = {}
        } = t;
        return Xd({
          type: "counter",
          content: e
        }, () => (wa("beforeDOMElementCreation", {
          content: e,
          params: t
        }), DM({
          content: e.toString(),
          title: n,
          extra: {
            attributes: i,
            styles: o,
            classes: ["".concat(Be.cssPrefix, "-layers-counter"), ...r]
          }
        })));
      }
    };
  }
}, e5 = {
  mixout() {
    return {
      text(e) {
        let t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
        const {
          transform: n = Si,
          title: r = null,
          classes: i = [],
          attributes: o = {},
          styles: a = {}
        } = t;
        return Xd({
          type: "text",
          content: e
        }, () => (wa("beforeDOMElementCreation", {
          content: e,
          params: t
        }), j1({
          content: e,
          transform: be(be({}, Si), n),
          title: r,
          extra: {
            attributes: o,
            styles: a,
            classes: ["".concat(Be.cssPrefix, "-layers-text"), ...i]
          }
        })));
      }
    };
  },
  provides(e) {
    e.generateLayersText = function(t, n) {
      const {
        title: r,
        transform: i,
        extra: o
      } = n;
      let a = null, s = null;
      if (h$) {
        const l = parseInt(getComputedStyle(t).fontSize, 10), u = t.getBoundingClientRect();
        a = u.width / l, s = u.height / l;
      }
      return Be.autoA11y && !r && (o.attributes["aria-hidden"] = "true"), Promise.resolve([t, j1({
        content: t.innerHTML,
        width: a,
        height: s,
        transform: i,
        title: r,
        extra: o,
        watchable: !0
      })]);
    };
  }
};
const t5 = new RegExp('"', "ug"), U1 = [1105920, 1112319], q1 = be(be(be(be({}, {
  FontAwesome: {
    normal: "fas",
    400: "fas"
  }
}), SI), VI), MI), iv = Object.keys(q1).reduce((e, t) => (e[t.toLowerCase()] = q1[t], e), {}), n5 = Object.keys(iv).reduce((e, t) => {
  const n = iv[t];
  return e[t] = n[900] || [...Object.entries(n)][0][1], e;
}, {});
function r5(e) {
  const t = e.replace(t5, ""), n = uM(t, 0), r = n >= U1[0] && n <= U1[1], i = t.length === 2 ? t[0] === t[1] : !1;
  return {
    value: Ym(i ? t[0] : t),
    isSecondary: r || i
  };
}
function i5(e, t) {
  const n = e.replace(/^['"]|['"]$/g, "").toLowerCase(), r = parseInt(t), i = isNaN(r) ? "normal" : r;
  return (iv[n] || {})[i] || n5[n];
}
function H1(e, t) {
  const n = "".concat(BI).concat(t.replace(":", "-"));
  return new Promise((r, i) => {
    if (e.getAttribute(n) !== null)
      return r();
    const a = Xs(e.children).filter((d) => d.getAttribute(Hm) === t)[0], s = Eo.getComputedStyle(e, t), l = s.getPropertyValue("font-family"), u = l.match(WI), c = s.getPropertyValue("font-weight"), f = s.getPropertyValue("content");
    if (a && !u)
      return e.removeChild(a), r();
    if (u && f !== "none" && f !== "") {
      const d = s.getPropertyValue("content");
      let p = i5(l, c);
      const {
        value: h,
        isSecondary: v
      } = r5(d), m = u[0].startsWith("FontAwesome");
      let g = _y(p, h), _ = g;
      if (m) {
        const x = mM(h);
        x.iconName && x.prefix && (g = x.iconName, p = x.prefix);
      }
      if (g && !v && (!a || a.getAttribute(hy) !== p || a.getAttribute(my) !== _)) {
        e.setAttribute(n, _), a && e.removeChild(a);
        const x = qM(), {
          extra: w
        } = x;
        w.attributes[Hm] = t, tv(g, p).then(($) => {
          const k = wy(be(be({}, x), {}, {
            icons: {
              main: $,
              mask: j$()
            },
            prefix: p,
            iconName: _,
            extra: w,
            watchable: !0
          })), D = Nt.createElementNS("http://www.w3.org/2000/svg", "svg");
          t === "::before" ? e.insertBefore(D, e.firstChild) : e.appendChild(D), D.outerHTML = k.map((E) => Qu(E)).join(`
`), e.removeAttribute(n), r();
        }).catch(i);
      } else
        r();
    } else
      r();
  });
}
function o5(e) {
  return Promise.all([H1(e, "::before"), H1(e, "::after")]);
}
function a5(e) {
  return e.parentNode !== document.head && !~UI.indexOf(e.tagName.toUpperCase()) && !e.getAttribute(Hm) && (!e.parentNode || e.parentNode.tagName !== "svg");
}
function W1(e) {
  if (eo)
    return new Promise((t, n) => {
      const r = Xs(e.querySelectorAll("*")).filter(a5).map(o5), i = xy.begin("searchPseudoElements");
      B$(), Promise.all(r).then(() => {
        i(), rv(), t();
      }).catch(() => {
        i(), rv(), n();
      });
    });
}
var s5 = {
  hooks() {
    return {
      mutationObserverCallbacks(e) {
        return e.pseudoElementsCallback = W1, e;
      }
    };
  },
  provides(e) {
    e.pseudoElements2svg = function(t) {
      const {
        node: n = Nt
      } = t;
      Be.searchPseudoElements && W1(n);
    };
  }
};
let Z1 = !1;
var l5 = {
  mixout() {
    return {
      dom: {
        unwatch() {
          B$(), Z1 = !0;
        }
      }
    };
  },
  hooks() {
    return {
      bootstrap() {
        V1(Jm("mutationObserverCallbacks", {}));
      },
      noAuto() {
        VM();
      },
      watch(e) {
        const {
          observeMutationsRoot: t
        } = e;
        Z1 ? rv() : V1(Jm("mutationObserverCallbacks", {
          observeMutationsRoot: t
        }));
      }
    };
  }
};
const G1 = (e) => {
  let t = {
    size: 16,
    x: 0,
    y: 0,
    flipX: !1,
    flipY: !1,
    rotate: 0
  };
  return e.toLowerCase().split(" ").reduce((n, r) => {
    const i = r.toLowerCase().split("-"), o = i[0];
    let a = i.slice(1).join("-");
    if (o && a === "h")
      return n.flipX = !0, n;
    if (o && a === "v")
      return n.flipY = !0, n;
    if (a = parseFloat(a), isNaN(a))
      return n;
    switch (o) {
      case "grow":
        n.size = n.size + a;
        break;
      case "shrink":
        n.size = n.size - a;
        break;
      case "left":
        n.x = n.x - a;
        break;
      case "right":
        n.x = n.x + a;
        break;
      case "up":
        n.y = n.y - a;
        break;
      case "down":
        n.y = n.y + a;
        break;
      case "rotate":
        n.rotate = n.rotate + a;
        break;
    }
    return n;
  }, t);
};
var u5 = {
  mixout() {
    return {
      parse: {
        transform: (e) => G1(e)
      }
    };
  },
  hooks() {
    return {
      parseNodeAttributes(e, t) {
        const n = t.getAttribute("data-fa-transform");
        return n && (e.transform = G1(n)), e;
      }
    };
  },
  provides(e) {
    e.generateAbstractTransformGrouping = function(t) {
      let {
        main: n,
        transform: r,
        containerWidth: i,
        iconWidth: o
      } = t;
      const a = {
        transform: "translate(".concat(i / 2, " 256)")
      }, s = "translate(".concat(r.x * 32, ", ").concat(r.y * 32, ") "), l = "scale(".concat(r.size / 16 * (r.flipX ? -1 : 1), ", ").concat(r.size / 16 * (r.flipY ? -1 : 1), ") "), u = "rotate(".concat(r.rotate, " 0 0)"), c = {
        transform: "".concat(s, " ").concat(l, " ").concat(u)
      }, f = {
        transform: "translate(".concat(o / 2 * -1, " -256)")
      }, d = {
        outer: a,
        inner: c,
        path: f
      };
      return {
        tag: "g",
        attributes: be({}, d.outer),
        children: [{
          tag: "g",
          attributes: be({}, d.inner),
          children: [{
            tag: n.icon.tag,
            children: n.icon.children,
            attributes: be(be({}, n.icon.attributes), d.path)
          }]
        }]
      };
    };
  }
};
const ph = {
  x: 0,
  y: 0,
  width: "100%",
  height: "100%"
};
function Y1(e) {
  let t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !0;
  return e.attributes && (e.attributes.fill || t) && (e.attributes.fill = "black"), e;
}
function c5(e) {
  return e.tag === "g" ? e.children : [e];
}
var f5 = {
  hooks() {
    return {
      parseNodeAttributes(e, t) {
        const n = t.getAttribute("data-fa-mask"), r = n ? Jd(n.split(" ").map((i) => i.trim())) : j$();
        return r.prefix || (r.prefix = So()), e.mask = r, e.maskId = t.getAttribute("data-fa-mask-id"), e;
      }
    };
  },
  provides(e) {
    e.generateAbstractMask = function(t) {
      let {
        children: n,
        attributes: r,
        main: i,
        mask: o,
        maskId: a,
        transform: s
      } = t;
      const {
        width: l,
        icon: u
      } = i, {
        width: c,
        icon: f
      } = o, d = rM({
        transform: s,
        containerWidth: c,
        iconWidth: l
      }), p = {
        tag: "rect",
        attributes: be(be({}, ph), {}, {
          fill: "white"
        })
      }, h = u.children ? {
        children: u.children.map(Y1)
      } : {}, v = {
        tag: "g",
        attributes: be({}, d.inner),
        children: [Y1(be({
          tag: u.tag,
          attributes: be(be({}, u.attributes), d.path)
        }, h))]
      }, m = {
        tag: "g",
        attributes: be({}, d.outer),
        children: [v]
      }, g = "mask-".concat(a || gu()), _ = "clip-".concat(a || gu()), x = {
        tag: "mask",
        attributes: be(be({}, ph), {}, {
          id: g,
          maskUnits: "userSpaceOnUse",
          maskContentUnits: "userSpaceOnUse"
        }),
        children: [p, m]
      }, w = {
        tag: "defs",
        children: [{
          tag: "clipPath",
          attributes: {
            id: _
          },
          children: c5(f)
        }, x]
      };
      return n.push(w, {
        tag: "rect",
        attributes: be({
          fill: "currentColor",
          "clip-path": "url(#".concat(_, ")"),
          mask: "url(#".concat(g, ")")
        }, ph)
      }), {
        children: n,
        attributes: r
      };
    };
  }
}, d5 = {
  provides(e) {
    let t = !1;
    Eo.matchMedia && (t = Eo.matchMedia("(prefers-reduced-motion: reduce)").matches), e.missingIconAbstract = function() {
      const n = [], r = {
        fill: "currentColor"
      }, i = {
        attributeType: "XML",
        repeatCount: "indefinite",
        dur: "2s"
      };
      n.push({
        tag: "path",
        attributes: be(be({}, r), {}, {
          d: "M156.5,447.7l-12.6,29.5c-18.7-9.5-35.9-21.2-51.5-34.9l22.7-22.7C127.6,430.5,141.5,440,156.5,447.7z M40.6,272H8.5 c1.4,21.2,5.4,41.7,11.7,61.1L50,321.2C45.1,305.5,41.8,289,40.6,272z M40.6,240c1.4-18.8,5.2-37,11.1-54.1l-29.5-12.6 C14.7,194.3,10,216.7,8.5,240H40.6z M64.3,156.5c7.8-14.9,17.2-28.8,28.1-41.5L69.7,92.3c-13.7,15.6-25.5,32.8-34.9,51.5 L64.3,156.5z M397,419.6c-13.9,12-29.4,22.3-46.1,30.4l11.9,29.8c20.7-9.9,39.8-22.6,56.9-37.6L397,419.6z M115,92.4 c13.9-12,29.4-22.3,46.1-30.4l-11.9-29.8c-20.7,9.9-39.8,22.6-56.8,37.6L115,92.4z M447.7,355.5c-7.8,14.9-17.2,28.8-28.1,41.5 l22.7,22.7c13.7-15.6,25.5-32.9,34.9-51.5L447.7,355.5z M471.4,272c-1.4,18.8-5.2,37-11.1,54.1l29.5,12.6 c7.5-21.1,12.2-43.5,13.6-66.8H471.4z M321.2,462c-15.7,5-32.2,8.2-49.2,9.4v32.1c21.2-1.4,41.7-5.4,61.1-11.7L321.2,462z M240,471.4c-18.8-1.4-37-5.2-54.1-11.1l-12.6,29.5c21.1,7.5,43.5,12.2,66.8,13.6V471.4z M462,190.8c5,15.7,8.2,32.2,9.4,49.2h32.1 c-1.4-21.2-5.4-41.7-11.7-61.1L462,190.8z M92.4,397c-12-13.9-22.3-29.4-30.4-46.1l-29.8,11.9c9.9,20.7,22.6,39.8,37.6,56.9 L92.4,397z M272,40.6c18.8,1.4,36.9,5.2,54.1,11.1l12.6-29.5C317.7,14.7,295.3,10,272,8.5V40.6z M190.8,50 c15.7-5,32.2-8.2,49.2-9.4V8.5c-21.2,1.4-41.7,5.4-61.1,11.7L190.8,50z M442.3,92.3L419.6,115c12,13.9,22.3,29.4,30.5,46.1 l29.8-11.9C470,128.5,457.3,109.4,442.3,92.3z M397,92.4l22.7-22.7c-15.6-13.7-32.8-25.5-51.5-34.9l-12.6,29.5 C370.4,72.1,384.4,81.5,397,92.4z"
        })
      });
      const o = be(be({}, i), {}, {
        attributeName: "opacity"
      }), a = {
        tag: "circle",
        attributes: be(be({}, r), {}, {
          cx: "256",
          cy: "364",
          r: "28"
        }),
        children: []
      };
      return t || a.children.push({
        tag: "animate",
        attributes: be(be({}, i), {}, {
          attributeName: "r",
          values: "28;14;28;28;14;28;"
        })
      }, {
        tag: "animate",
        attributes: be(be({}, o), {}, {
          values: "1;0;1;1;0;1;"
        })
      }), n.push(a), n.push({
        tag: "path",
        attributes: be(be({}, r), {}, {
          opacity: "1",
          d: "M263.7,312h-16c-6.6,0-12-5.4-12-12c0-71,77.4-63.9,77.4-107.8c0-20-17.8-40.2-57.4-40.2c-29.1,0-44.3,9.6-59.2,28.7 c-3.9,5-11.1,6-16.2,2.4l-13.1-9.2c-5.6-3.9-6.9-11.8-2.6-17.2c21.2-27.2,46.4-44.7,91.2-44.7c52.3,0,97.4,29.8,97.4,80.2 c0,67.6-77.4,63.5-77.4,107.8C275.7,306.6,270.3,312,263.7,312z"
        }),
        children: t ? [] : [{
          tag: "animate",
          attributes: be(be({}, o), {}, {
            values: "1;0;0;0;0;1;"
          })
        }]
      }), t || n.push({
        tag: "path",
        attributes: be(be({}, r), {}, {
          opacity: "0",
          d: "M232.5,134.5l7,168c0.3,6.4,5.6,11.5,12,11.5h9c6.4,0,11.7-5.1,12-11.5l7-168c0.3-6.8-5.2-12.5-12-12.5h-23 C237.7,122,232.2,127.7,232.5,134.5z"
        }),
        children: [{
          tag: "animate",
          attributes: be(be({}, o), {}, {
            values: "0;0;1;1;0;0;"
          })
        }]
      }), {
        tag: "g",
        attributes: {
          class: "missing"
        },
        children: n
      };
    };
  }
}, p5 = {
  hooks() {
    return {
      parseNodeAttributes(e, t) {
        const n = t.getAttribute("data-fa-symbol"), r = n === null ? !1 : n === "" ? !0 : n;
        return e.symbol = r, e;
      }
    };
  }
}, h5 = [aM, QM, JM, XM, e5, s5, l5, u5, f5, d5, p5];
SM(h5, {
  mixoutsTo: _r
});
_r.noAuto;
_r.config;
_r.library;
_r.dom;
const ov = _r.parse;
_r.findIconDefinition;
_r.toHtml;
const m5 = _r.icon;
_r.layer;
_r.text;
_r.counter;
var Tc = { exports: {} }, Oc = { exports: {} }, mt = {};
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Q1;
function v5() {
  if (Q1) return mt;
  Q1 = 1;
  var e = typeof Symbol == "function" && Symbol.for, t = e ? Symbol.for("react.element") : 60103, n = e ? Symbol.for("react.portal") : 60106, r = e ? Symbol.for("react.fragment") : 60107, i = e ? Symbol.for("react.strict_mode") : 60108, o = e ? Symbol.for("react.profiler") : 60114, a = e ? Symbol.for("react.provider") : 60109, s = e ? Symbol.for("react.context") : 60110, l = e ? Symbol.for("react.async_mode") : 60111, u = e ? Symbol.for("react.concurrent_mode") : 60111, c = e ? Symbol.for("react.forward_ref") : 60112, f = e ? Symbol.for("react.suspense") : 60113, d = e ? Symbol.for("react.suspense_list") : 60120, p = e ? Symbol.for("react.memo") : 60115, h = e ? Symbol.for("react.lazy") : 60116, v = e ? Symbol.for("react.block") : 60121, m = e ? Symbol.for("react.fundamental") : 60117, g = e ? Symbol.for("react.responder") : 60118, _ = e ? Symbol.for("react.scope") : 60119;
  function x($) {
    if (typeof $ == "object" && $ !== null) {
      var k = $.$$typeof;
      switch (k) {
        case t:
          switch ($ = $.type, $) {
            case l:
            case u:
            case r:
            case o:
            case i:
            case f:
              return $;
            default:
              switch ($ = $ && $.$$typeof, $) {
                case s:
                case c:
                case h:
                case p:
                case a:
                  return $;
                default:
                  return k;
              }
          }
        case n:
          return k;
      }
    }
  }
  function w($) {
    return x($) === u;
  }
  return mt.AsyncMode = l, mt.ConcurrentMode = u, mt.ContextConsumer = s, mt.ContextProvider = a, mt.Element = t, mt.ForwardRef = c, mt.Fragment = r, mt.Lazy = h, mt.Memo = p, mt.Portal = n, mt.Profiler = o, mt.StrictMode = i, mt.Suspense = f, mt.isAsyncMode = function($) {
    return w($) || x($) === l;
  }, mt.isConcurrentMode = w, mt.isContextConsumer = function($) {
    return x($) === s;
  }, mt.isContextProvider = function($) {
    return x($) === a;
  }, mt.isElement = function($) {
    return typeof $ == "object" && $ !== null && $.$$typeof === t;
  }, mt.isForwardRef = function($) {
    return x($) === c;
  }, mt.isFragment = function($) {
    return x($) === r;
  }, mt.isLazy = function($) {
    return x($) === h;
  }, mt.isMemo = function($) {
    return x($) === p;
  }, mt.isPortal = function($) {
    return x($) === n;
  }, mt.isProfiler = function($) {
    return x($) === o;
  }, mt.isStrictMode = function($) {
    return x($) === i;
  }, mt.isSuspense = function($) {
    return x($) === f;
  }, mt.isValidElementType = function($) {
    return typeof $ == "string" || typeof $ == "function" || $ === r || $ === u || $ === o || $ === i || $ === f || $ === d || typeof $ == "object" && $ !== null && ($.$$typeof === h || $.$$typeof === p || $.$$typeof === a || $.$$typeof === s || $.$$typeof === c || $.$$typeof === m || $.$$typeof === g || $.$$typeof === _ || $.$$typeof === v);
  }, mt.typeOf = x, mt;
}
var vt = {};
/** @license React v16.13.1
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var J1;
function g5() {
  return J1 || (J1 = 1, process.env.NODE_ENV !== "production" && (function() {
    var e = typeof Symbol == "function" && Symbol.for, t = e ? Symbol.for("react.element") : 60103, n = e ? Symbol.for("react.portal") : 60106, r = e ? Symbol.for("react.fragment") : 60107, i = e ? Symbol.for("react.strict_mode") : 60108, o = e ? Symbol.for("react.profiler") : 60114, a = e ? Symbol.for("react.provider") : 60109, s = e ? Symbol.for("react.context") : 60110, l = e ? Symbol.for("react.async_mode") : 60111, u = e ? Symbol.for("react.concurrent_mode") : 60111, c = e ? Symbol.for("react.forward_ref") : 60112, f = e ? Symbol.for("react.suspense") : 60113, d = e ? Symbol.for("react.suspense_list") : 60120, p = e ? Symbol.for("react.memo") : 60115, h = e ? Symbol.for("react.lazy") : 60116, v = e ? Symbol.for("react.block") : 60121, m = e ? Symbol.for("react.fundamental") : 60117, g = e ? Symbol.for("react.responder") : 60118, _ = e ? Symbol.for("react.scope") : 60119;
    function x(j) {
      return typeof j == "string" || typeof j == "function" || // Note: its typeof might be other than 'symbol' or 'number' if it's a polyfill.
      j === r || j === u || j === o || j === i || j === f || j === d || typeof j == "object" && j !== null && (j.$$typeof === h || j.$$typeof === p || j.$$typeof === a || j.$$typeof === s || j.$$typeof === c || j.$$typeof === m || j.$$typeof === g || j.$$typeof === _ || j.$$typeof === v);
    }
    function w(j) {
      if (typeof j == "object" && j !== null) {
        var q = j.$$typeof;
        switch (q) {
          case t:
            var Y = j.type;
            switch (Y) {
              case l:
              case u:
              case r:
              case o:
              case i:
              case f:
                return Y;
              default:
                var ae = Y && Y.$$typeof;
                switch (ae) {
                  case s:
                  case c:
                  case h:
                  case p:
                  case a:
                    return ae;
                  default:
                    return q;
                }
            }
          case n:
            return q;
        }
      }
    }
    var $ = l, k = u, D = s, E = a, b = t, y = c, S = r, P = h, M = p, T = n, V = o, z = i, U = f, B = !1;
    function N(j) {
      return B || (B = !0, console.warn("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 17+. Update your code to use ReactIs.isConcurrentMode() instead. It has the exact same API.")), C(j) || w(j) === l;
    }
    function C(j) {
      return w(j) === u;
    }
    function G(j) {
      return w(j) === s;
    }
    function re(j) {
      return w(j) === a;
    }
    function ie(j) {
      return typeof j == "object" && j !== null && j.$$typeof === t;
    }
    function X(j) {
      return w(j) === c;
    }
    function Se(j) {
      return w(j) === r;
    }
    function me(j) {
      return w(j) === h;
    }
    function fe(j) {
      return w(j) === p;
    }
    function Q(j) {
      return w(j) === n;
    }
    function A(j) {
      return w(j) === o;
    }
    function O(j) {
      return w(j) === i;
    }
    function R(j) {
      return w(j) === f;
    }
    vt.AsyncMode = $, vt.ConcurrentMode = k, vt.ContextConsumer = D, vt.ContextProvider = E, vt.Element = b, vt.ForwardRef = y, vt.Fragment = S, vt.Lazy = P, vt.Memo = M, vt.Portal = T, vt.Profiler = V, vt.StrictMode = z, vt.Suspense = U, vt.isAsyncMode = N, vt.isConcurrentMode = C, vt.isContextConsumer = G, vt.isContextProvider = re, vt.isElement = ie, vt.isForwardRef = X, vt.isFragment = Se, vt.isLazy = me, vt.isMemo = fe, vt.isPortal = Q, vt.isProfiler = A, vt.isStrictMode = O, vt.isSuspense = R, vt.isValidElementType = x, vt.typeOf = w;
  })()), vt;
}
var X1;
function U$() {
  return X1 || (X1 = 1, process.env.NODE_ENV === "production" ? Oc.exports = v5() : Oc.exports = g5()), Oc.exports;
}
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/
var hh, e_;
function y5() {
  if (e_) return hh;
  e_ = 1;
  var e = Object.getOwnPropertySymbols, t = Object.prototype.hasOwnProperty, n = Object.prototype.propertyIsEnumerable;
  function r(o) {
    if (o == null)
      throw new TypeError("Object.assign cannot be called with null or undefined");
    return Object(o);
  }
  function i() {
    try {
      if (!Object.assign)
        return !1;
      var o = new String("abc");
      if (o[5] = "de", Object.getOwnPropertyNames(o)[0] === "5")
        return !1;
      for (var a = {}, s = 0; s < 10; s++)
        a["_" + String.fromCharCode(s)] = s;
      var l = Object.getOwnPropertyNames(a).map(function(c) {
        return a[c];
      });
      if (l.join("") !== "0123456789")
        return !1;
      var u = {};
      return "abcdefghijklmnopqrst".split("").forEach(function(c) {
        u[c] = c;
      }), Object.keys(Object.assign({}, u)).join("") === "abcdefghijklmnopqrst";
    } catch {
      return !1;
    }
  }
  return hh = i() ? Object.assign : function(o, a) {
    for (var s, l = r(o), u, c = 1; c < arguments.length; c++) {
      s = Object(arguments[c]);
      for (var f in s)
        t.call(s, f) && (l[f] = s[f]);
      if (e) {
        u = e(s);
        for (var d = 0; d < u.length; d++)
          n.call(s, u[d]) && (l[u[d]] = s[u[d]]);
      }
    }
    return l;
  }, hh;
}
var mh, t_;
function Sy() {
  if (t_) return mh;
  t_ = 1;
  var e = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
  return mh = e, mh;
}
var vh, n_;
function q$() {
  return n_ || (n_ = 1, vh = Function.call.bind(Object.prototype.hasOwnProperty)), vh;
}
var gh, r_;
function b5() {
  if (r_) return gh;
  r_ = 1;
  var e = function() {
  };
  if (process.env.NODE_ENV !== "production") {
    var t = /* @__PURE__ */ Sy(), n = {}, r = /* @__PURE__ */ q$();
    e = function(o) {
      var a = "Warning: " + o;
      typeof console < "u" && console.error(a);
      try {
        throw new Error(a);
      } catch {
      }
    };
  }
  function i(o, a, s, l, u) {
    if (process.env.NODE_ENV !== "production") {
      for (var c in o)
        if (r(o, c)) {
          var f;
          try {
            if (typeof o[c] != "function") {
              var d = Error(
                (l || "React class") + ": " + s + " type `" + c + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof o[c] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`."
              );
              throw d.name = "Invariant Violation", d;
            }
            f = o[c](a, c, l, s, null, t);
          } catch (h) {
            f = h;
          }
          if (f && !(f instanceof Error) && e(
            (l || "React class") + ": type specification of " + s + " `" + c + "` is invalid; the type checker function must return `null` or an `Error` but returned a " + typeof f + ". You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument)."
          ), f instanceof Error && !(f.message in n)) {
            n[f.message] = !0;
            var p = u ? u() : "";
            e(
              "Failed " + s + " type: " + f.message + (p ?? "")
            );
          }
        }
    }
  }
  return i.resetWarningCache = function() {
    process.env.NODE_ENV !== "production" && (n = {});
  }, gh = i, gh;
}
var yh, i_;
function _5() {
  if (i_) return yh;
  i_ = 1;
  var e = U$(), t = y5(), n = /* @__PURE__ */ Sy(), r = /* @__PURE__ */ q$(), i = /* @__PURE__ */ b5(), o = function() {
  };
  process.env.NODE_ENV !== "production" && (o = function(s) {
    var l = "Warning: " + s;
    typeof console < "u" && console.error(l);
    try {
      throw new Error(l);
    } catch {
    }
  });
  function a() {
    return null;
  }
  return yh = function(s, l) {
    var u = typeof Symbol == "function" && Symbol.iterator, c = "@@iterator";
    function f(C) {
      var G = C && (u && C[u] || C[c]);
      if (typeof G == "function")
        return G;
    }
    var d = "<<anonymous>>", p = {
      array: g("array"),
      bigint: g("bigint"),
      bool: g("boolean"),
      func: g("function"),
      number: g("number"),
      object: g("object"),
      string: g("string"),
      symbol: g("symbol"),
      any: _(),
      arrayOf: x,
      element: w(),
      elementType: $(),
      instanceOf: k,
      node: y(),
      objectOf: E,
      oneOf: D,
      oneOfType: b,
      shape: P,
      exact: M
    };
    function h(C, G) {
      return C === G ? C !== 0 || 1 / C === 1 / G : C !== C && G !== G;
    }
    function v(C, G) {
      this.message = C, this.data = G && typeof G == "object" ? G : {}, this.stack = "";
    }
    v.prototype = Error.prototype;
    function m(C) {
      if (process.env.NODE_ENV !== "production")
        var G = {}, re = 0;
      function ie(Se, me, fe, Q, A, O, R) {
        if (Q = Q || d, O = O || fe, R !== n) {
          if (l) {
            var j = new Error(
              "Calling PropTypes validators directly is not supported by the `prop-types` package. Use `PropTypes.checkPropTypes()` to call them. Read more at http://fb.me/use-check-prop-types"
            );
            throw j.name = "Invariant Violation", j;
          } else if (process.env.NODE_ENV !== "production" && typeof console < "u") {
            var q = Q + ":" + fe;
            !G[q] && // Avoid spamming the console because they are often not actionable except for lib authors
            re < 3 && (o(
              "You are manually calling a React.PropTypes validation function for the `" + O + "` prop on `" + Q + "`. This is deprecated and will throw in the standalone `prop-types` package. You may be seeing this warning due to a third-party PropTypes library. See https://fb.me/react-warning-dont-call-proptypes for details."
            ), G[q] = !0, re++);
          }
        }
        return me[fe] == null ? Se ? me[fe] === null ? new v("The " + A + " `" + O + "` is marked as required " + ("in `" + Q + "`, but its value is `null`.")) : new v("The " + A + " `" + O + "` is marked as required in " + ("`" + Q + "`, but its value is `undefined`.")) : null : C(me, fe, Q, A, O);
      }
      var X = ie.bind(null, !1);
      return X.isRequired = ie.bind(null, !0), X;
    }
    function g(C) {
      function G(re, ie, X, Se, me, fe) {
        var Q = re[ie], A = z(Q);
        if (A !== C) {
          var O = U(Q);
          return new v(
            "Invalid " + Se + " `" + me + "` of type " + ("`" + O + "` supplied to `" + X + "`, expected ") + ("`" + C + "`."),
            { expectedType: C }
          );
        }
        return null;
      }
      return m(G);
    }
    function _() {
      return m(a);
    }
    function x(C) {
      function G(re, ie, X, Se, me) {
        if (typeof C != "function")
          return new v("Property `" + me + "` of component `" + X + "` has invalid PropType notation inside arrayOf.");
        var fe = re[ie];
        if (!Array.isArray(fe)) {
          var Q = z(fe);
          return new v("Invalid " + Se + " `" + me + "` of type " + ("`" + Q + "` supplied to `" + X + "`, expected an array."));
        }
        for (var A = 0; A < fe.length; A++) {
          var O = C(fe, A, X, Se, me + "[" + A + "]", n);
          if (O instanceof Error)
            return O;
        }
        return null;
      }
      return m(G);
    }
    function w() {
      function C(G, re, ie, X, Se) {
        var me = G[re];
        if (!s(me)) {
          var fe = z(me);
          return new v("Invalid " + X + " `" + Se + "` of type " + ("`" + fe + "` supplied to `" + ie + "`, expected a single ReactElement."));
        }
        return null;
      }
      return m(C);
    }
    function $() {
      function C(G, re, ie, X, Se) {
        var me = G[re];
        if (!e.isValidElementType(me)) {
          var fe = z(me);
          return new v("Invalid " + X + " `" + Se + "` of type " + ("`" + fe + "` supplied to `" + ie + "`, expected a single ReactElement type."));
        }
        return null;
      }
      return m(C);
    }
    function k(C) {
      function G(re, ie, X, Se, me) {
        if (!(re[ie] instanceof C)) {
          var fe = C.name || d, Q = N(re[ie]);
          return new v("Invalid " + Se + " `" + me + "` of type " + ("`" + Q + "` supplied to `" + X + "`, expected ") + ("instance of `" + fe + "`."));
        }
        return null;
      }
      return m(G);
    }
    function D(C) {
      if (!Array.isArray(C))
        return process.env.NODE_ENV !== "production" && (arguments.length > 1 ? o(
          "Invalid arguments supplied to oneOf, expected an array, got " + arguments.length + " arguments. A common mistake is to write oneOf(x, y, z) instead of oneOf([x, y, z])."
        ) : o("Invalid argument supplied to oneOf, expected an array.")), a;
      function G(re, ie, X, Se, me) {
        for (var fe = re[ie], Q = 0; Q < C.length; Q++)
          if (h(fe, C[Q]))
            return null;
        var A = JSON.stringify(C, function(R, j) {
          var q = U(j);
          return q === "symbol" ? String(j) : j;
        });
        return new v("Invalid " + Se + " `" + me + "` of value `" + String(fe) + "` " + ("supplied to `" + X + "`, expected one of " + A + "."));
      }
      return m(G);
    }
    function E(C) {
      function G(re, ie, X, Se, me) {
        if (typeof C != "function")
          return new v("Property `" + me + "` of component `" + X + "` has invalid PropType notation inside objectOf.");
        var fe = re[ie], Q = z(fe);
        if (Q !== "object")
          return new v("Invalid " + Se + " `" + me + "` of type " + ("`" + Q + "` supplied to `" + X + "`, expected an object."));
        for (var A in fe)
          if (r(fe, A)) {
            var O = C(fe, A, X, Se, me + "." + A, n);
            if (O instanceof Error)
              return O;
          }
        return null;
      }
      return m(G);
    }
    function b(C) {
      if (!Array.isArray(C))
        return process.env.NODE_ENV !== "production" && o("Invalid argument supplied to oneOfType, expected an instance of array."), a;
      for (var G = 0; G < C.length; G++) {
        var re = C[G];
        if (typeof re != "function")
          return o(
            "Invalid argument supplied to oneOfType. Expected an array of check functions, but received " + B(re) + " at index " + G + "."
          ), a;
      }
      function ie(X, Se, me, fe, Q) {
        for (var A = [], O = 0; O < C.length; O++) {
          var R = C[O], j = R(X, Se, me, fe, Q, n);
          if (j == null)
            return null;
          j.data && r(j.data, "expectedType") && A.push(j.data.expectedType);
        }
        var q = A.length > 0 ? ", expected one of type [" + A.join(", ") + "]" : "";
        return new v("Invalid " + fe + " `" + Q + "` supplied to " + ("`" + me + "`" + q + "."));
      }
      return m(ie);
    }
    function y() {
      function C(G, re, ie, X, Se) {
        return T(G[re]) ? null : new v("Invalid " + X + " `" + Se + "` supplied to " + ("`" + ie + "`, expected a ReactNode."));
      }
      return m(C);
    }
    function S(C, G, re, ie, X) {
      return new v(
        (C || "React class") + ": " + G + " type `" + re + "." + ie + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + X + "`."
      );
    }
    function P(C) {
      function G(re, ie, X, Se, me) {
        var fe = re[ie], Q = z(fe);
        if (Q !== "object")
          return new v("Invalid " + Se + " `" + me + "` of type `" + Q + "` " + ("supplied to `" + X + "`, expected `object`."));
        for (var A in C) {
          var O = C[A];
          if (typeof O != "function")
            return S(X, Se, me, A, U(O));
          var R = O(fe, A, X, Se, me + "." + A, n);
          if (R)
            return R;
        }
        return null;
      }
      return m(G);
    }
    function M(C) {
      function G(re, ie, X, Se, me) {
        var fe = re[ie], Q = z(fe);
        if (Q !== "object")
          return new v("Invalid " + Se + " `" + me + "` of type `" + Q + "` " + ("supplied to `" + X + "`, expected `object`."));
        var A = t({}, re[ie], C);
        for (var O in A) {
          var R = C[O];
          if (r(C, O) && typeof R != "function")
            return S(X, Se, me, O, U(R));
          if (!R)
            return new v(
              "Invalid " + Se + " `" + me + "` key `" + O + "` supplied to `" + X + "`.\nBad object: " + JSON.stringify(re[ie], null, "  ") + `
Valid keys: ` + JSON.stringify(Object.keys(C), null, "  ")
            );
          var j = R(fe, O, X, Se, me + "." + O, n);
          if (j)
            return j;
        }
        return null;
      }
      return m(G);
    }
    function T(C) {
      switch (typeof C) {
        case "number":
        case "string":
        case "undefined":
          return !0;
        case "boolean":
          return !C;
        case "object":
          if (Array.isArray(C))
            return C.every(T);
          if (C === null || s(C))
            return !0;
          var G = f(C);
          if (G) {
            var re = G.call(C), ie;
            if (G !== C.entries) {
              for (; !(ie = re.next()).done; )
                if (!T(ie.value))
                  return !1;
            } else
              for (; !(ie = re.next()).done; ) {
                var X = ie.value;
                if (X && !T(X[1]))
                  return !1;
              }
          } else
            return !1;
          return !0;
        default:
          return !1;
      }
    }
    function V(C, G) {
      return C === "symbol" ? !0 : G ? G["@@toStringTag"] === "Symbol" || typeof Symbol == "function" && G instanceof Symbol : !1;
    }
    function z(C) {
      var G = typeof C;
      return Array.isArray(C) ? "array" : C instanceof RegExp ? "object" : V(G, C) ? "symbol" : G;
    }
    function U(C) {
      if (typeof C > "u" || C === null)
        return "" + C;
      var G = z(C);
      if (G === "object") {
        if (C instanceof Date)
          return "date";
        if (C instanceof RegExp)
          return "regexp";
      }
      return G;
    }
    function B(C) {
      var G = U(C);
      switch (G) {
        case "array":
        case "object":
          return "an " + G;
        case "boolean":
        case "date":
        case "regexp":
          return "a " + G;
        default:
          return G;
      }
    }
    function N(C) {
      return !C.constructor || !C.constructor.name ? d : C.constructor.name;
    }
    return p.checkPropTypes = i, p.resetWarningCache = i.resetWarningCache, p.PropTypes = p, p;
  }, yh;
}
var bh, o_;
function w5() {
  if (o_) return bh;
  o_ = 1;
  var e = /* @__PURE__ */ Sy();
  function t() {
  }
  function n() {
  }
  return n.resetWarningCache = t, bh = function() {
    function r(a, s, l, u, c, f) {
      if (f !== e) {
        var d = new Error(
          "Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types"
        );
        throw d.name = "Invariant Violation", d;
      }
    }
    r.isRequired = r;
    function i() {
      return r;
    }
    var o = {
      array: r,
      bigint: r,
      bool: r,
      func: r,
      number: r,
      object: r,
      string: r,
      symbol: r,
      any: r,
      arrayOf: i,
      element: r,
      elementType: r,
      instanceOf: i,
      node: r,
      objectOf: i,
      oneOf: i,
      oneOfType: i,
      shape: i,
      exact: i,
      checkPropTypes: n,
      resetWarningCache: t
    };
    return o.PropTypes = o, o;
  }, bh;
}
var a_;
function x5() {
  if (a_) return Tc.exports;
  if (a_ = 1, process.env.NODE_ENV !== "production") {
    var e = U$(), t = !0;
    Tc.exports = /* @__PURE__ */ _5()(e.isElement, t);
  } else
    Tc.exports = /* @__PURE__ */ w5()();
  return Tc.exports;
}
var E5 = /* @__PURE__ */ x5();
const Ne = /* @__PURE__ */ fy(E5);
function s_(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function(i) {
      return Object.getOwnPropertyDescriptor(e, i).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function vo(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? s_(Object(n), !0).forEach(function(r) {
      as(e, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : s_(Object(n)).forEach(function(r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return e;
}
function qf(e) {
  "@babel/helpers - typeof";
  return qf = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, qf(e);
}
function as(e, t, n) {
  return t in e ? Object.defineProperty(e, t, {
    value: n,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[t] = n, e;
}
function S5(e, t) {
  if (e == null) return {};
  var n = {}, r = Object.keys(e), i, o;
  for (o = 0; o < r.length; o++)
    i = r[o], !(t.indexOf(i) >= 0) && (n[i] = e[i]);
  return n;
}
function H$(e, t) {
  if (e == null) return {};
  var n = S5(e, t), r, i;
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    for (i = 0; i < o.length; i++)
      r = o[i], !(t.indexOf(r) >= 0) && Object.prototype.propertyIsEnumerable.call(e, r) && (n[r] = e[r]);
  }
  return n;
}
function av(e) {
  return $5(e) || k5(e) || T5(e) || O5();
}
function $5(e) {
  if (Array.isArray(e)) return sv(e);
}
function k5(e) {
  if (typeof Symbol < "u" && e[Symbol.iterator] != null || e["@@iterator"] != null) return Array.from(e);
}
function T5(e, t) {
  if (e) {
    if (typeof e == "string") return sv(e, t);
    var n = Object.prototype.toString.call(e).slice(8, -1);
    if (n === "Object" && e.constructor && (n = e.constructor.name), n === "Map" || n === "Set") return Array.from(e);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return sv(e, t);
  }
}
function sv(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var n = 0, r = new Array(t); n < t; n++) r[n] = e[n];
  return r;
}
function O5() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function P5(e) {
  var t, n = e.beat, r = e.fade, i = e.beatFade, o = e.bounce, a = e.shake, s = e.flash, l = e.spin, u = e.spinPulse, c = e.spinReverse, f = e.pulse, d = e.fixedWidth, p = e.inverse, h = e.border, v = e.listItem, m = e.flip, g = e.size, _ = e.rotation, x = e.pull, w = (t = {
    "fa-beat": n,
    "fa-fade": r,
    "fa-beat-fade": i,
    "fa-bounce": o,
    "fa-shake": a,
    "fa-flash": s,
    "fa-spin": l,
    "fa-spin-reverse": c,
    "fa-spin-pulse": u,
    "fa-pulse": f,
    "fa-fw": d,
    "fa-inverse": p,
    "fa-border": h,
    "fa-li": v,
    "fa-flip": m === !0,
    "fa-flip-horizontal": m === "horizontal" || m === "both",
    "fa-flip-vertical": m === "vertical" || m === "both"
  }, as(t, "fa-".concat(g), typeof g < "u" && g !== null), as(t, "fa-rotate-".concat(_), typeof _ < "u" && _ !== null && _ !== 0), as(t, "fa-pull-".concat(x), typeof x < "u" && x !== null), as(t, "fa-swap-opacity", e.swapOpacity), t);
  return Object.keys(w).map(function($) {
    return w[$] ? $ : null;
  }).filter(function($) {
    return $;
  });
}
function A5(e) {
  return e = e - 0, e === e;
}
function W$(e) {
  return A5(e) ? e : (e = e.replace(/[\-_\s]+(.)?/g, function(t, n) {
    return n ? n.toUpperCase() : "";
  }), e.substr(0, 1).toLowerCase() + e.substr(1));
}
var D5 = ["style"];
function C5(e) {
  return e.charAt(0).toUpperCase() + e.slice(1);
}
function I5(e) {
  return e.split(";").map(function(t) {
    return t.trim();
  }).filter(function(t) {
    return t;
  }).reduce(function(t, n) {
    var r = n.indexOf(":"), i = W$(n.slice(0, r)), o = n.slice(r + 1).trim();
    return i.startsWith("webkit") ? t[C5(i)] = o : t[i] = o, t;
  }, {});
}
function Z$(e, t) {
  var n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
  if (typeof t == "string")
    return t;
  var r = (t.children || []).map(function(l) {
    return Z$(e, l);
  }), i = Object.keys(t.attributes || {}).reduce(function(l, u) {
    var c = t.attributes[u];
    switch (u) {
      case "class":
        l.attrs.className = c, delete t.attributes.class;
        break;
      case "style":
        l.attrs.style = I5(c);
        break;
      default:
        u.indexOf("aria-") === 0 || u.indexOf("data-") === 0 ? l.attrs[u.toLowerCase()] = c : l.attrs[W$(u)] = c;
    }
    return l;
  }, {
    attrs: {}
  }), o = n.style, a = o === void 0 ? {} : o, s = H$(n, D5);
  return i.attrs.style = vo(vo({}, i.attrs.style), a), e.apply(void 0, [t.tag, vo(vo({}, i.attrs), s)].concat(av(r)));
}
var G$ = !1;
try {
  G$ = process.env.NODE_ENV === "production";
} catch {
}
function M5() {
  if (!G$ && console && typeof console.error == "function") {
    var e;
    (e = console).error.apply(e, arguments);
  }
}
function l_(e) {
  if (e && qf(e) === "object" && e.prefix && e.iconName && e.icon)
    return e;
  if (ov.icon)
    return ov.icon(e);
  if (e === null)
    return null;
  if (e && qf(e) === "object" && e.prefix && e.iconName)
    return e;
  if (Array.isArray(e) && e.length === 2)
    return {
      prefix: e[0],
      iconName: e[1]
    };
  if (typeof e == "string")
    return {
      prefix: "fas",
      iconName: e
    };
}
function _h(e, t) {
  return Array.isArray(t) && t.length > 0 || !Array.isArray(t) && t ? as({}, e, t) : {};
}
var R5 = ["forwardedRef"];
function yr(e) {
  var t = e.forwardedRef, n = H$(e, R5), r = n.icon, i = n.mask, o = n.symbol, a = n.className, s = n.title, l = n.titleId, u = n.maskId, c = l_(r), f = _h("classes", [].concat(av(P5(n)), av(a.split(" ")))), d = _h("transform", typeof n.transform == "string" ? ov.transform(n.transform) : n.transform), p = _h("mask", l_(i)), h = m5(c, vo(vo(vo(vo({}, f), d), p), {}, {
    symbol: o,
    title: s,
    titleId: l,
    maskId: u
  }));
  if (!h)
    return M5("Could not find icon", c), null;
  var v = h.abstract, m = {
    ref: t
  };
  return Object.keys(n).forEach(function(g) {
    yr.defaultProps.hasOwnProperty(g) || (m[g] = n[g]);
  }), N5(v[0], m);
}
yr.displayName = "FontAwesomeIcon";
yr.propTypes = {
  beat: Ne.bool,
  border: Ne.bool,
  beatFade: Ne.bool,
  bounce: Ne.bool,
  className: Ne.string,
  fade: Ne.bool,
  flash: Ne.bool,
  mask: Ne.oneOfType([Ne.object, Ne.array, Ne.string]),
  maskId: Ne.string,
  fixedWidth: Ne.bool,
  inverse: Ne.bool,
  flip: Ne.oneOf([!0, !1, "horizontal", "vertical", "both"]),
  icon: Ne.oneOfType([Ne.object, Ne.array, Ne.string]),
  listItem: Ne.bool,
  pull: Ne.oneOf(["right", "left"]),
  pulse: Ne.bool,
  rotation: Ne.oneOf([0, 90, 180, 270]),
  shake: Ne.bool,
  size: Ne.oneOf(["2xs", "xs", "sm", "lg", "xl", "2xl", "1x", "2x", "3x", "4x", "5x", "6x", "7x", "8x", "9x", "10x"]),
  spin: Ne.bool,
  spinPulse: Ne.bool,
  spinReverse: Ne.bool,
  symbol: Ne.oneOfType([Ne.bool, Ne.string]),
  title: Ne.string,
  titleId: Ne.string,
  transform: Ne.oneOfType([Ne.string, Ne.object]),
  swapOpacity: Ne.bool
};
yr.defaultProps = {
  border: !1,
  className: "",
  mask: null,
  maskId: null,
  fixedWidth: !1,
  inverse: !1,
  flip: !1,
  icon: null,
  listItem: !1,
  pull: null,
  pulse: !1,
  rotation: null,
  size: null,
  spin: !1,
  spinPulse: !1,
  spinReverse: !1,
  beat: !1,
  fade: !1,
  beatFade: !1,
  bounce: !1,
  shake: !1,
  symbol: !1,
  title: "",
  titleId: null,
  transform: null,
  swapOpacity: !1
};
var N5 = Z$.bind(null, H.createElement);
const j5 = Lr(
  [
    "absolute",
    "p-1",
    "text-sm",
    "-translate-y-1/2",
    "top-1/2",
    "left-full",
    "text-neutral-800",
    "dark:text-neutral-100",
    "z-[9999]",
    "transition-opacity"
  ],
  {
    variants: {
      visible: {
        true: "opacity-100",
        false: "opacity-0"
      }
    }
  }
), F5 = (e) => /* @__PURE__ */ I.jsx("p", { className: j5({ visible: e.visible }), children: "Copied!" }), Jae = ({
  text: e,
  onCopy: t,
  element: n,
  copyElement: r,
  disabled: i = !1,
  className: o = ""
}) => {
  const [a, s] = Ke(!1);
  return /* @__PURE__ */ I.jsxs(
    "button",
    {
      disabled: i,
      className: `${o} relative w-3 h-3`,
      onClick: () => {
        t?.(e), navigator.clipboard.writeText(e), s(!0), setTimeout(() => s(!1), 1500);
      },
      children: [
        n || /* @__PURE__ */ I.jsx(
          yr,
          {
            className: "w-full h-full p-1 cursor-pointer place-items-center aspect-square",
            icon: fI
          }
        ),
        /* @__PURE__ */ I.jsx(F5, { visible: a, children: r || "Copied!" })
      ]
    }
  );
}, bu = He({});
function $y(e) {
  const t = ve(null);
  return t.current === null && (t.current = e()), t.current;
}
const z5 = typeof window < "u", ep = z5 ? m6 : ze, tp = /* @__PURE__ */ He(null);
function ky(e, t) {
  e.indexOf(t) === -1 && e.push(t);
}
function Hf(e, t) {
  const n = e.indexOf(t);
  n > -1 && e.splice(n, 1);
}
const Ai = (e, t, n) => n > t ? t : n < e ? e : n;
function lv(e, t) {
  return t ? `${e}. For more information and steps for solving, visit https://motion.dev/troubleshooting/${t}` : e;
}
let el = () => {
}, Wi = () => {
};
typeof process < "u" && process.env?.NODE_ENV !== "production" && (el = (e, t, n) => {
  !e && typeof console < "u" && console.warn(lv(t, n));
}, Wi = (e, t, n) => {
  if (!e)
    throw new Error(lv(t, n));
});
const ko = {}, Y$ = (e) => /^-?(?:\d+(?:\.\d+)?|\.\d+)$/u.test(e), Q$ = (e) => typeof e == "object" && e !== null, J$ = (e) => /^0[^.\s]+$/u.test(e);
// @__NO_SIDE_EFFECTS__
function X$(e) {
  let t;
  return () => (t === void 0 && (t = e()), t);
}
const Mr = /* @__NO_SIDE_EFFECTS__ */ (e) => e, Ju = (...e) => e.reduce((t, n) => (r) => n(t(r))), _u = /* @__NO_SIDE_EFFECTS__ */ (e, t, n) => {
  const r = t - e;
  return r ? (n - e) / r : 1;
};
class Ty {
  constructor() {
    this.subscriptions = [];
  }
  add(t) {
    return ky(this.subscriptions, t), () => Hf(this.subscriptions, t);
  }
  notify(t, n, r) {
    const i = this.subscriptions.length;
    if (i)
      if (i === 1)
        this.subscriptions[0](t, n, r);
      else
        for (let o = 0; o < i; o++) {
          const a = this.subscriptions[o];
          a && a(t, n, r);
        }
  }
  getSize() {
    return this.subscriptions.length;
  }
  clear() {
    this.subscriptions.length = 0;
  }
}
const er = /* @__NO_SIDE_EFFECTS__ */ (e) => e * 1e3, Pr = /* @__NO_SIDE_EFFECTS__ */ (e) => e / 1e3, ek = /* @__NO_SIDE_EFFECTS__ */ (e, t) => t ? e * (1e3 / t) : 0, u_ = /* @__PURE__ */ new Set();
function Oy(e, t, n) {
  e || u_.has(t) || (console.warn(lv(t, n)), u_.add(t));
}
const tk = (e, t, n) => (((1 - 3 * n + 3 * t) * e + (3 * n - 6 * t)) * e + 3 * t) * e, L5 = 1e-7, V5 = 12;
function B5(e, t, n, r, i) {
  let o, a, s = 0;
  do
    a = t + (n - t) / 2, o = tk(a, r, i) - e, o > 0 ? n = a : t = a;
  while (Math.abs(o) > L5 && ++s < V5);
  return a;
}
// @__NO_SIDE_EFFECTS__
function Xu(e, t, n, r) {
  if (e === t && n === r)
    return Mr;
  const i = (o) => B5(o, 0, 1, e, n);
  return (o) => o === 0 || o === 1 ? o : tk(i(o), t, r);
}
const nk = /* @__NO_SIDE_EFFECTS__ */ (e) => (t) => t <= 0.5 ? e(2 * t) / 2 : (2 - e(2 * (1 - t))) / 2, rk = /* @__NO_SIDE_EFFECTS__ */ (e) => (t) => 1 - e(1 - t), ik = /* @__PURE__ */ Xu(0.33, 1.53, 0.69, 0.99), Py = /* @__PURE__ */ rk(ik), ok = /* @__PURE__ */ nk(Py), ak = (e) => e >= 1 ? 1 : (e *= 2) < 1 ? 0.5 * Py(e) : 0.5 * (2 - Math.pow(2, -10 * (e - 1))), Ay = (e) => 1 - Math.sin(Math.acos(e)), sk = /* @__PURE__ */ rk(Ay), lk = /* @__PURE__ */ nk(Ay), K5 = /* @__PURE__ */ Xu(0.42, 0, 1, 1), U5 = /* @__PURE__ */ Xu(0, 0, 0.58, 1), uk = /* @__PURE__ */ Xu(0.42, 0, 0.58, 1), q5 = /* @__NO_SIDE_EFFECTS__ */ (e) => Array.isArray(e) && typeof e[0] != "number", ck = /* @__NO_SIDE_EFFECTS__ */ (e) => Array.isArray(e) && typeof e[0] == "number", c_ = {
  linear: Mr,
  easeIn: K5,
  easeInOut: uk,
  easeOut: U5,
  circIn: Ay,
  circInOut: lk,
  circOut: sk,
  backIn: Py,
  backInOut: ok,
  backOut: ik,
  anticipate: ak
}, H5 = (e) => typeof e == "string", f_ = (e) => {
  if (/* @__PURE__ */ ck(e)) {
    Wi(e.length === 4, "Cubic bezier arrays must contain four numerical values.", "cubic-bezier-length");
    const [t, n, r, i] = e;
    return /* @__PURE__ */ Xu(t, n, r, i);
  } else if (H5(e))
    return Wi(c_[e] !== void 0, `Invalid easing type '${e}'`, "invalid-easing-type"), c_[e];
  return e;
}, Pc = [
  "setup",
  // Compute
  "read",
  // Read
  "resolveKeyframes",
  // Write/Read/Write/Read
  "preUpdate",
  // Compute
  "update",
  // Compute
  "preRender",
  // Compute
  "render",
  // Write
  "postRender"
  // Compute
];
function W5(e) {
  let t = /* @__PURE__ */ new Set(), n = /* @__PURE__ */ new Set(), r = !1, i = !1;
  const o = /* @__PURE__ */ new WeakSet();
  let a = {
    delta: 0,
    timestamp: 0,
    isProcessing: !1
  };
  function s(u) {
    o.has(u) && (l.schedule(u), e()), u(a);
  }
  const l = {
    /**
     * Schedule a process to run on the next frame.
     */
    schedule: (u, c = !1, f = !1) => {
      const p = f && r ? t : n;
      return c && o.add(u), p.add(u), u;
    },
    /**
     * Cancel the provided callback from running on the next frame.
     */
    cancel: (u) => {
      n.delete(u), o.delete(u);
    },
    /**
     * Execute all schedule callbacks.
     */
    process: (u) => {
      if (a = u, r) {
        i = !0;
        return;
      }
      r = !0;
      const c = t;
      t = n, n = c, t.forEach(s), t.clear(), r = !1, i && (i = !1, l.process(u));
    }
  };
  return l;
}
const Z5 = 40;
function fk(e, t) {
  let n = !1, r = !0;
  const i = {
    delta: 0,
    timestamp: 0,
    isProcessing: !1
  }, o = () => n = !0, a = Pc.reduce((x, w) => (x[w] = W5(o), x), {}), { setup: s, read: l, resolveKeyframes: u, preUpdate: c, update: f, preRender: d, render: p, postRender: h } = a, v = () => {
    const x = ko.useManualTiming, w = x ? i.timestamp : performance.now();
    n = !1, x || (i.delta = r ? 1e3 / 60 : Math.max(Math.min(w - i.timestamp, Z5), 1)), i.timestamp = w, i.isProcessing = !0, s.process(i), l.process(i), u.process(i), c.process(i), f.process(i), d.process(i), p.process(i), h.process(i), i.isProcessing = !1, n && t && (r = !1, e(v));
  }, m = () => {
    n = !0, r = !0, i.isProcessing || e(v);
  };
  return { schedule: Pc.reduce((x, w) => {
    const $ = a[w];
    return x[w] = (k, D = !1, E = !1) => (n || m(), $.schedule(k, D, E)), x;
  }, {}), cancel: (x) => {
    for (let w = 0; w < Pc.length; w++)
      a[Pc[w]].cancel(x);
  }, state: i, steps: a };
}
const { schedule: _t, cancel: To, state: En, steps: wh } = /* @__PURE__ */ fk(typeof requestAnimationFrame < "u" ? requestAnimationFrame : Mr, !0);
let hf;
function G5() {
  hf = void 0;
}
const Bn = {
  now: () => (hf === void 0 && Bn.set(En.isProcessing || ko.useManualTiming ? En.timestamp : performance.now()), hf),
  set: (e) => {
    hf = e, queueMicrotask(G5);
  }
}, dk = (e) => (t) => typeof t == "string" && t.startsWith(e), pk = /* @__PURE__ */ dk("--"), Y5 = /* @__PURE__ */ dk("var(--"), Dy = (e) => Y5(e) ? Q5.test(e.split("/*")[0].trim()) : !1, Q5 = /var\(--(?:[\w-]+\s*|[\w-]+\s*,(?:\s*[^)(\s]|\s*\((?:[^)(]|\([^)(]*\))*\))+\s*)\)$/iu;
function d_(e) {
  return typeof e != "string" ? !1 : e.split("/*")[0].includes("var(--");
}
const tl = {
  test: (e) => typeof e == "number",
  parse: parseFloat,
  transform: (e) => e
}, wu = {
  ...tl,
  transform: (e) => Ai(0, 1, e)
}, Ac = {
  ...tl,
  default: 1
}, ou = (e) => Math.round(e * 1e5) / 1e5, Cy = /-?(?:\d+(?:\.\d+)?|\.\d+)/gu;
function J5(e) {
  return e == null;
}
const X5 = /^(?:#[\da-f]{3,8}|(?:rgb|hsl)a?\((?:-?[\d.]+%?[,\s]+){2}-?[\d.]+%?\s*(?:[,/]\s*)?(?:\b\d+(?:\.\d+)?|\.\d+)?%?\))$/iu, Iy = (e, t) => (n) => !!(typeof n == "string" && X5.test(n) && n.startsWith(e) || t && !J5(n) && Object.prototype.hasOwnProperty.call(n, t)), hk = (e, t, n) => (r) => {
  if (typeof r != "string")
    return r;
  const [i, o, a, s] = r.match(Cy);
  return {
    [e]: parseFloat(i),
    [t]: parseFloat(o),
    [n]: parseFloat(a),
    alpha: s !== void 0 ? parseFloat(s) : 1
  };
}, eR = (e) => Ai(0, 255, e), xh = {
  ...tl,
  transform: (e) => Math.round(eR(e))
}, ua = {
  test: /* @__PURE__ */ Iy("rgb", "red"),
  parse: /* @__PURE__ */ hk("red", "green", "blue"),
  transform: ({ red: e, green: t, blue: n, alpha: r = 1 }) => "rgba(" + xh.transform(e) + ", " + xh.transform(t) + ", " + xh.transform(n) + ", " + ou(wu.transform(r)) + ")"
};
function tR(e) {
  let t = "", n = "", r = "", i = "";
  return e.length > 5 ? (t = e.substring(1, 3), n = e.substring(3, 5), r = e.substring(5, 7), i = e.substring(7, 9)) : (t = e.substring(1, 2), n = e.substring(2, 3), r = e.substring(3, 4), i = e.substring(4, 5), t += t, n += n, r += r, i += i), {
    red: parseInt(t, 16),
    green: parseInt(n, 16),
    blue: parseInt(r, 16),
    alpha: i ? parseInt(i, 16) / 255 : 1
  };
}
const uv = {
  test: /* @__PURE__ */ Iy("#"),
  parse: tR,
  transform: ua.transform
}, ec = /* @__NO_SIDE_EFFECTS__ */ (e) => ({
  test: (t) => typeof t == "string" && t.endsWith(e) && t.split(" ").length === 1,
  parse: parseFloat,
  transform: (t) => `${t}${e}`
}), ji = /* @__PURE__ */ ec("deg"), Ti = /* @__PURE__ */ ec("%"), Re = /* @__PURE__ */ ec("px"), nR = /* @__PURE__ */ ec("vh"), rR = /* @__PURE__ */ ec("vw"), p_ = {
  ...Ti,
  parse: (e) => Ti.parse(e) / 100,
  transform: (e) => Ti.transform(e * 100)
}, ss = {
  test: /* @__PURE__ */ Iy("hsl", "hue"),
  parse: /* @__PURE__ */ hk("hue", "saturation", "lightness"),
  transform: ({ hue: e, saturation: t, lightness: n, alpha: r = 1 }) => "hsla(" + Math.round(e) + ", " + Ti.transform(ou(t)) + ", " + Ti.transform(ou(n)) + ", " + ou(wu.transform(r)) + ")"
}, un = {
  test: (e) => ua.test(e) || uv.test(e) || ss.test(e),
  parse: (e) => ua.test(e) ? ua.parse(e) : ss.test(e) ? ss.parse(e) : uv.parse(e),
  transform: (e) => typeof e == "string" ? e : e.hasOwnProperty("red") ? ua.transform(e) : ss.transform(e),
  getAnimatableNone: (e) => {
    const t = un.parse(e);
    return t.alpha = 0, un.transform(t);
  }
}, iR = /(?:#[\da-f]{3,8}|(?:rgb|hsl)a?\((?:-?[\d.]+%?[,\s]+){2}-?[\d.]+%?\s*(?:[,/]\s*)?(?:\b\d+(?:\.\d+)?|\.\d+)?%?\))/giu;
function oR(e) {
  return isNaN(e) && typeof e == "string" && (e.match(Cy)?.length || 0) + (e.match(iR)?.length || 0) > 0;
}
const mk = "number", vk = "color", aR = "var", sR = "var(", h_ = "${}", lR = /var\s*\(\s*--(?:[\w-]+\s*|[\w-]+\s*,(?:\s*[^)(\s]|\s*\((?:[^)(]|\([^)(]*\))*\))+\s*)\)|#[\da-f]{3,8}|(?:rgb|hsl)a?\((?:-?[\d.]+%?[,\s]+){2}-?[\d.]+%?\s*(?:[,/]\s*)?(?:\b\d+(?:\.\d+)?|\.\d+)?%?\)|-?(?:\d+(?:\.\d+)?|\.\d+)/giu;
function Is(e) {
  const t = e.toString(), n = [], r = {
    color: [],
    number: [],
    var: []
  }, i = [];
  let o = 0;
  const s = t.replace(lR, (l) => (un.test(l) ? (r.color.push(o), i.push(vk), n.push(un.parse(l))) : l.startsWith(sR) ? (r.var.push(o), i.push(aR), n.push(l)) : (r.number.push(o), i.push(mk), n.push(parseFloat(l))), ++o, h_)).split(h_);
  return { values: n, split: s, indexes: r, types: i };
}
function uR(e) {
  return Is(e).values;
}
function gk({ split: e, types: t }) {
  const n = e.length;
  return (r) => {
    let i = "";
    for (let o = 0; o < n; o++)
      if (i += e[o], r[o] !== void 0) {
        const a = t[o];
        a === mk ? i += ou(r[o]) : a === vk ? i += un.transform(r[o]) : i += r[o];
      }
    return i;
  };
}
function cR(e) {
  return gk(Is(e));
}
const fR = (e) => typeof e == "number" ? 0 : un.test(e) ? un.getAnimatableNone(e) : e, dR = (e, t) => typeof e == "number" ? t?.trim().endsWith("/") ? e : 0 : fR(e);
function pR(e) {
  const t = Is(e);
  return gk(t)(t.values.map((r, i) => dR(r, t.split[i])));
}
const ni = {
  test: oR,
  parse: uR,
  createTransformer: cR,
  getAnimatableNone: pR
};
function Eh(e, t, n) {
  return n < 0 && (n += 1), n > 1 && (n -= 1), n < 1 / 6 ? e + (t - e) * 6 * n : n < 1 / 2 ? t : n < 2 / 3 ? e + (t - e) * (2 / 3 - n) * 6 : e;
}
function hR({ hue: e, saturation: t, lightness: n, alpha: r }) {
  e /= 360, t /= 100, n /= 100;
  let i = 0, o = 0, a = 0;
  if (!t)
    i = o = a = n;
  else {
    const s = n < 0.5 ? n * (1 + t) : n + t - n * t, l = 2 * n - s;
    i = Eh(l, s, e + 1 / 3), o = Eh(l, s, e), a = Eh(l, s, e - 1 / 3);
  }
  return {
    red: Math.round(i * 255),
    green: Math.round(o * 255),
    blue: Math.round(a * 255),
    alpha: r
  };
}
function Wf(e, t) {
  return (n) => n > 0 ? t : e;
}
const St = (e, t, n) => e + (t - e) * n, Sh = (e, t, n) => {
  const r = e * e, i = n * (t * t - r) + r;
  return i < 0 ? 0 : Math.sqrt(i);
}, mR = [uv, ua, ss], vR = (e) => mR.find((t) => t.test(e));
function m_(e) {
  const t = vR(e);
  if (el(!!t, `'${e}' is not an animatable color. Use the equivalent color code instead.`, "color-not-animatable"), !t)
    return !1;
  let n = t.parse(e);
  return t === ss && (n = hR(n)), n;
}
const v_ = (e, t) => {
  const n = m_(e), r = m_(t);
  if (!n || !r)
    return Wf(e, t);
  const i = { ...n };
  return (o) => (i.red = Sh(n.red, r.red, o), i.green = Sh(n.green, r.green, o), i.blue = Sh(n.blue, r.blue, o), i.alpha = St(n.alpha, r.alpha, o), ua.transform(i));
}, cv = /* @__PURE__ */ new Set(["none", "hidden"]);
function gR(e, t) {
  return cv.has(e) ? (n) => n <= 0 ? e : t : (n) => n >= 1 ? t : e;
}
function yR(e, t) {
  return (n) => St(e, t, n);
}
function My(e) {
  return typeof e == "number" ? yR : typeof e == "string" ? Dy(e) ? Wf : un.test(e) ? v_ : wR : Array.isArray(e) ? yk : typeof e == "object" ? un.test(e) ? v_ : bR : Wf;
}
function yk(e, t) {
  const n = [...e], r = n.length, i = e.map((o, a) => My(o)(o, t[a]));
  return (o) => {
    for (let a = 0; a < r; a++)
      n[a] = i[a](o);
    return n;
  };
}
function bR(e, t) {
  const n = { ...e, ...t }, r = {};
  for (const i in n)
    e[i] !== void 0 && t[i] !== void 0 && (r[i] = My(e[i])(e[i], t[i]));
  return (i) => {
    for (const o in r)
      n[o] = r[o](i);
    return n;
  };
}
function _R(e, t) {
  const n = [], r = { color: 0, var: 0, number: 0 };
  for (let i = 0; i < t.values.length; i++) {
    const o = t.types[i], a = e.indexes[o][r[o]], s = e.values[a] ?? 0;
    n[i] = s, r[o]++;
  }
  return n;
}
const wR = (e, t) => {
  const n = ni.createTransformer(t), r = Is(e), i = Is(t);
  return r.indexes.var.length === i.indexes.var.length && r.indexes.color.length === i.indexes.color.length && r.indexes.number.length >= i.indexes.number.length ? cv.has(e) && !i.values.length || cv.has(t) && !r.values.length ? gR(e, t) : Ju(yk(_R(r, i), i.values), n) : (el(!0, `Complex values '${e}' and '${t}' too different to mix. Ensure all colors are of the same type, and that each contains the same quantity of number and color values. Falling back to instant transition.`, "complex-values-different"), Wf(e, t));
};
function bk(e, t, n) {
  return typeof e == "number" && typeof t == "number" && typeof n == "number" ? St(e, t, n) : My(e)(e, t);
}
const xR = (e) => {
  const t = ({ timestamp: n }) => e(n);
  return {
    start: (n = !0) => _t.update(t, n),
    stop: () => To(t),
    /**
     * If we're processing this frame we can use the
     * framelocked timestamp to keep things in sync.
     */
    now: () => En.isProcessing ? En.timestamp : Bn.now()
  };
}, _k = (e, t, n = 10) => {
  let r = "";
  const i = Math.max(Math.round(t / n), 2);
  for (let o = 0; o < i; o++)
    r += Math.round(e(o / (i - 1)) * 1e4) / 1e4 + ", ";
  return `linear(${r.substring(0, r.length - 2)})`;
}, Zf = 2e4;
function Ry(e) {
  let t = 0;
  const n = 50;
  let r = e.next(t);
  for (; !r.done && t < Zf; )
    t += n, r = e.next(t);
  return t >= Zf ? 1 / 0 : t;
}
function ER(e, t = 100, n) {
  const r = n({ ...e, keyframes: [0, t] }), i = Math.min(Ry(r), Zf);
  return {
    type: "keyframes",
    ease: (o) => r.next(i * o).value / t,
    duration: /* @__PURE__ */ Pr(i)
  };
}
const qt = {
  // Default spring physics
  stiffness: 100,
  damping: 10,
  mass: 1,
  velocity: 0,
  // Default duration/bounce-based options
  duration: 800,
  // in ms
  bounce: 0.3,
  visualDuration: 0.3,
  // in seconds
  // Rest thresholds
  restSpeed: {
    granular: 0.01,
    default: 2
  },
  restDelta: {
    granular: 5e-3,
    default: 0.5
  },
  // Limits
  minDuration: 0.01,
  // in seconds
  maxDuration: 10,
  // in seconds
  minDamping: 0.05,
  maxDamping: 1
};
function fv(e, t) {
  return e * Math.sqrt(1 - t * t);
}
const SR = 12;
function $R(e, t, n) {
  let r = n;
  for (let i = 1; i < SR; i++)
    r = r - e(r) / t(r);
  return r;
}
const $h = 1e-3;
function kR({ duration: e = qt.duration, bounce: t = qt.bounce, velocity: n = qt.velocity, mass: r = qt.mass }) {
  let i, o;
  el(e <= /* @__PURE__ */ er(qt.maxDuration), "Spring duration must be 10 seconds or less", "spring-duration-limit");
  let a = 1 - t;
  a = Ai(qt.minDamping, qt.maxDamping, a), e = Ai(qt.minDuration, qt.maxDuration, /* @__PURE__ */ Pr(e)), a < 1 ? (i = (u) => {
    const c = u * a, f = c * e, d = c - n, p = fv(u, a), h = Math.exp(-f);
    return $h - d / p * h;
  }, o = (u) => {
    const f = u * a * e, d = f * n + n, p = Math.pow(a, 2) * Math.pow(u, 2) * e, h = Math.exp(-f), v = fv(Math.pow(u, 2), a);
    return (-i(u) + $h > 0 ? -1 : 1) * ((d - p) * h) / v;
  }) : (i = (u) => {
    const c = Math.exp(-u * e), f = (u - n) * e + 1;
    return -$h + c * f;
  }, o = (u) => {
    const c = Math.exp(-u * e), f = (n - u) * (e * e);
    return c * f;
  });
  const s = 5 / e, l = $R(i, o, s);
  if (e = /* @__PURE__ */ er(e), isNaN(l))
    return {
      stiffness: qt.stiffness,
      damping: qt.damping,
      duration: e
    };
  {
    const u = Math.pow(l, 2) * r;
    return {
      stiffness: u,
      damping: a * 2 * Math.sqrt(r * u),
      duration: e
    };
  }
}
const TR = ["duration", "bounce"], OR = ["stiffness", "damping", "mass"];
function g_(e, t) {
  return t.some((n) => e[n] !== void 0);
}
function PR(e) {
  let t = {
    velocity: qt.velocity,
    stiffness: qt.stiffness,
    damping: qt.damping,
    mass: qt.mass,
    isResolvedFromDuration: !1,
    ...e
  };
  if (!g_(e, OR) && g_(e, TR))
    if (t.velocity = 0, e.visualDuration) {
      const n = e.visualDuration, r = 2 * Math.PI / (n * 1.2), i = r * r, o = 2 * Ai(0.05, 1, 1 - (e.bounce || 0)) * Math.sqrt(i);
      t = {
        ...t,
        mass: qt.mass,
        stiffness: i,
        damping: o
      };
    } else {
      const n = kR({ ...e, velocity: 0 });
      t = {
        ...t,
        ...n,
        mass: qt.mass
      }, t.isResolvedFromDuration = !0;
    }
  return t;
}
function Gf(e = qt.visualDuration, t = qt.bounce) {
  const n = typeof e != "object" ? {
    visualDuration: e,
    keyframes: [0, 1],
    bounce: t
  } : e;
  let { restSpeed: r, restDelta: i } = n;
  const o = n.keyframes[0], a = n.keyframes[n.keyframes.length - 1], s = { done: !1, value: o }, { stiffness: l, damping: u, mass: c, duration: f, velocity: d, isResolvedFromDuration: p } = PR({
    ...n,
    velocity: -/* @__PURE__ */ Pr(n.velocity || 0)
  }), h = d || 0, v = u / (2 * Math.sqrt(l * c)), m = a - o, g = /* @__PURE__ */ Pr(Math.sqrt(l / c)), _ = Math.abs(m) < 5;
  r || (r = _ ? qt.restSpeed.granular : qt.restSpeed.default), i || (i = _ ? qt.restDelta.granular : qt.restDelta.default);
  let x, w, $, k, D, E;
  if (v < 1)
    $ = fv(g, v), k = (h + v * g * m) / $, x = (y) => {
      const S = Math.exp(-v * g * y);
      return a - S * (k * Math.sin($ * y) + m * Math.cos($ * y));
    }, D = v * g * k + m * $, E = v * g * m - k * $, w = (y) => Math.exp(-v * g * y) * (D * Math.sin($ * y) + E * Math.cos($ * y));
  else if (v === 1) {
    x = (S) => a - Math.exp(-g * S) * (m + (h + g * m) * S);
    const y = h + g * m;
    w = (S) => Math.exp(-g * S) * (g * y * S - h);
  } else {
    const y = g * Math.sqrt(v * v - 1);
    x = (T) => {
      const V = Math.exp(-v * g * T), z = Math.min(y * T, 300);
      return a - V * ((h + v * g * m) * Math.sinh(z) + y * m * Math.cosh(z)) / y;
    };
    const S = (h + v * g * m) / y, P = v * g * S - m * y, M = v * g * m - S * y;
    w = (T) => {
      const V = Math.exp(-v * g * T), z = Math.min(y * T, 300);
      return V * (P * Math.sinh(z) + M * Math.cosh(z));
    };
  }
  const b = {
    calculatedDuration: p && f || null,
    velocity: (y) => /* @__PURE__ */ er(w(y)),
    next: (y) => {
      if (!p && v < 1) {
        const P = Math.exp(-v * g * y), M = Math.sin($ * y), T = Math.cos($ * y), V = a - P * (k * M + m * T), z = /* @__PURE__ */ er(P * (D * M + E * T));
        return s.done = Math.abs(z) <= r && Math.abs(a - V) <= i, s.value = s.done ? a : V, s;
      }
      const S = x(y);
      if (p)
        s.done = y >= f;
      else {
        const P = /* @__PURE__ */ er(w(y));
        s.done = Math.abs(P) <= r && Math.abs(a - S) <= i;
      }
      return s.value = s.done ? a : S, s;
    },
    toString: () => {
      const y = Math.min(Ry(b), Zf), S = _k((P) => b.next(y * P).value, y, 30);
      return y + "ms " + S;
    },
    toTransition: () => {
    }
  };
  return b;
}
Gf.applyToOptions = (e) => {
  const t = ER(e, 100, Gf);
  return e.ease = t.ease, e.duration = /* @__PURE__ */ er(t.duration), e.type = "keyframes", e;
};
const AR = 5;
function wk(e, t, n) {
  const r = Math.max(t - AR, 0);
  return /* @__PURE__ */ ek(n - e(r), t - r);
}
function dv({ keyframes: e, velocity: t = 0, power: n = 0.8, timeConstant: r = 325, bounceDamping: i = 10, bounceStiffness: o = 500, modifyTarget: a, min: s, max: l, restDelta: u = 0.5, restSpeed: c }) {
  const f = e[0], d = {
    done: !1,
    value: f
  }, p = (E) => s !== void 0 && E < s || l !== void 0 && E > l, h = (E) => s === void 0 ? l : l === void 0 || Math.abs(s - E) < Math.abs(l - E) ? s : l;
  let v = n * t;
  const m = f + v, g = a === void 0 ? m : a(m);
  g !== m && (v = g - f);
  const _ = (E) => -v * Math.exp(-E / r), x = (E) => g + _(E), w = (E) => {
    const b = _(E), y = x(E);
    d.done = Math.abs(b) <= u, d.value = d.done ? g : y;
  };
  let $, k;
  const D = (E) => {
    p(d.value) && ($ = E, k = Gf({
      keyframes: [d.value, h(d.value)],
      velocity: wk(x, E, d.value),
      // TODO: This should be passing * 1000
      damping: i,
      stiffness: o,
      restDelta: u,
      restSpeed: c
    }));
  };
  return D(0), {
    calculatedDuration: null,
    next: (E) => {
      let b = !1;
      return !k && $ === void 0 && (b = !0, w(E), D(E)), $ !== void 0 && E >= $ ? k.next(E - $) : (!b && w(E), d);
    }
  };
}
function DR(e, t, n) {
  const r = [], i = n || ko.mix || bk, o = e.length - 1;
  for (let a = 0; a < o; a++) {
    let s = i(e[a], e[a + 1]);
    if (t) {
      const l = Array.isArray(t) ? t[a] || Mr : t;
      s = Ju(l, s);
    }
    r.push(s);
  }
  return r;
}
function CR(e, t, { clamp: n = !0, ease: r, mixer: i } = {}) {
  const o = e.length;
  if (Wi(o === t.length, "Both input and output ranges must be the same length", "range-length"), o === 1)
    return () => t[0];
  if (o === 2 && t[0] === t[1])
    return () => t[1];
  const a = e[0] === e[1];
  e[0] > e[o - 1] && (e = [...e].reverse(), t = [...t].reverse());
  const s = DR(t, r, i), l = s.length, u = (c) => {
    if (a && c < e[0])
      return t[0];
    let f = 0;
    if (l > 1)
      for (; f < e.length - 2 && !(c < e[f + 1]); f++)
        ;
    const d = /* @__PURE__ */ _u(e[f], e[f + 1], c);
    return s[f](d);
  };
  return n ? (c) => u(Ai(e[0], e[o - 1], c)) : u;
}
function IR(e, t) {
  const n = e[e.length - 1];
  for (let r = 1; r <= t; r++) {
    const i = /* @__PURE__ */ _u(0, t, r);
    e.push(St(n, 1, i));
  }
}
function MR(e) {
  const t = [0];
  return IR(t, e.length - 1), t;
}
function RR(e, t) {
  return e.map((n) => n * t);
}
function NR(e, t) {
  return e.map(() => t || uk).splice(0, e.length - 1);
}
function ls({ duration: e = 300, keyframes: t, times: n, ease: r = "easeInOut" }) {
  const i = /* @__PURE__ */ q5(r) ? r.map(f_) : f_(r), o = {
    done: !1,
    value: t[0]
  }, a = RR(
    // Only use the provided offsets if they're the correct length
    // TODO Maybe we should warn here if there's a length mismatch
    n && n.length === t.length ? n : MR(t),
    e
  ), s = CR(a, t, {
    ease: Array.isArray(i) ? i : NR(t, i)
  });
  return {
    calculatedDuration: e,
    next: (l) => (o.value = s(l), o.done = l >= e, o)
  };
}
const jR = (e) => e !== null;
function np(e, { repeat: t, repeatType: n = "loop" }, r, i = 1) {
  const o = e.filter(jR), s = i < 0 || t && n !== "loop" && t % 2 === 1 ? 0 : o.length - 1;
  return !s || r === void 0 ? o[s] : r;
}
const FR = {
  decay: dv,
  inertia: dv,
  tween: ls,
  keyframes: ls,
  spring: Gf
};
function xk(e) {
  typeof e.type == "string" && (e.type = FR[e.type]);
}
class Ny {
  constructor() {
    this.updateFinished();
  }
  get finished() {
    return this._finished;
  }
  updateFinished() {
    this._finished = new Promise((t) => {
      this.resolve = t;
    });
  }
  notifyFinished() {
    this.resolve();
  }
  /**
   * Allows the animation to be awaited.
   *
   * @deprecated Use `finished` instead.
   */
  then(t, n) {
    return this.finished.then(t, n);
  }
}
const zR = (e) => e / 100;
class Yf extends Ny {
  constructor(t) {
    super(), this.state = "idle", this.startTime = null, this.isStopped = !1, this.currentTime = 0, this.holdTime = null, this.playbackSpeed = 1, this.delayState = {
      done: !1,
      value: void 0
    }, this.stop = () => {
      const { motionValue: n } = this.options;
      n && n.updatedAt !== Bn.now() && this.tick(Bn.now()), this.isStopped = !0, this.state !== "idle" && (this.teardown(), this.options.onStop?.());
    }, this.options = t, this.initAnimation(), this.play(), t.autoplay === !1 && this.pause();
  }
  initAnimation() {
    const { options: t } = this;
    xk(t);
    const { type: n = ls, repeat: r = 0, repeatDelay: i = 0, repeatType: o, velocity: a = 0 } = t;
    let { keyframes: s } = t;
    const l = n || ls;
    process.env.NODE_ENV !== "production" && l !== ls && Wi(s.length <= 2, `Only two keyframes currently supported with spring and inertia animations. Trying to animate ${s}`, "spring-two-frames"), l !== ls && typeof s[0] != "number" && (this.mixKeyframes = Ju(zR, bk(s[0], s[1])), s = [0, 100]);
    const u = l({ ...t, keyframes: s });
    o === "mirror" && (this.mirroredGenerator = l({
      ...t,
      keyframes: [...s].reverse(),
      velocity: -a
    })), u.calculatedDuration === null && (u.calculatedDuration = Ry(u));
    const { calculatedDuration: c } = u;
    this.calculatedDuration = c, this.resolvedDuration = c + i, this.totalDuration = this.resolvedDuration * (r + 1) - i, this.generator = u;
  }
  updateTime(t) {
    const n = Math.round(t - this.startTime) * this.playbackSpeed;
    this.holdTime !== null ? this.currentTime = this.holdTime : this.currentTime = n;
  }
  tick(t, n = !1) {
    const { generator: r, totalDuration: i, mixKeyframes: o, mirroredGenerator: a, resolvedDuration: s, calculatedDuration: l } = this;
    if (this.startTime === null)
      return r.next(0);
    const { delay: u = 0, keyframes: c, repeat: f, repeatType: d, repeatDelay: p, type: h, onUpdate: v, finalKeyframe: m } = this.options;
    this.speed > 0 ? this.startTime = Math.min(this.startTime, t) : this.speed < 0 && (this.startTime = Math.min(t - i / this.speed, this.startTime)), n ? this.currentTime = t : this.updateTime(t);
    const g = this.currentTime - u * (this.playbackSpeed >= 0 ? 1 : -1), _ = this.playbackSpeed >= 0 ? g < 0 : g > i;
    this.currentTime = Math.max(g, 0), this.state === "finished" && this.holdTime === null && (this.currentTime = i);
    let x = this.currentTime, w = r;
    if (f) {
      const E = Math.min(this.currentTime, i) / s;
      let b = Math.floor(E), y = E % 1;
      !y && E >= 1 && (y = 1), y === 1 && b--, b = Math.min(b, f + 1), !!(b % 2) && (d === "reverse" ? (y = 1 - y, p && (y -= p / s)) : d === "mirror" && (w = a)), x = Ai(0, 1, y) * s;
    }
    let $;
    _ ? (this.delayState.value = c[0], $ = this.delayState) : $ = w.next(x), o && !_ && ($.value = o($.value));
    let { done: k } = $;
    !_ && l !== null && (k = this.playbackSpeed >= 0 ? this.currentTime >= i : this.currentTime <= 0);
    const D = this.holdTime === null && (this.state === "finished" || this.state === "running" && k);
    return D && h !== dv && ($.value = np(c, this.options, m, this.speed)), v && v($.value), D && this.finish(), $;
  }
  /**
   * Allows the returned animation to be awaited or promise-chained. Currently
   * resolves when the animation finishes at all but in a future update could/should
   * reject if its cancels.
   */
  then(t, n) {
    return this.finished.then(t, n);
  }
  get duration() {
    return /* @__PURE__ */ Pr(this.calculatedDuration);
  }
  get iterationDuration() {
    const { delay: t = 0 } = this.options || {};
    return this.duration + /* @__PURE__ */ Pr(t);
  }
  get time() {
    return /* @__PURE__ */ Pr(this.currentTime);
  }
  set time(t) {
    t = /* @__PURE__ */ er(t), this.currentTime = t, this.startTime === null || this.holdTime !== null || this.playbackSpeed === 0 ? this.holdTime = t : this.driver && (this.startTime = this.driver.now() - t / this.playbackSpeed), this.driver ? this.driver.start(!1) : (this.startTime = 0, this.state = "paused", this.holdTime = t, this.tick(t));
  }
  /**
   * Returns the generator's velocity at the current time in units/second.
   * Uses the analytical derivative when available (springs), avoiding
   * the MotionValue's frame-dependent velocity estimation.
   */
  getGeneratorVelocity() {
    const t = this.currentTime;
    if (t <= 0)
      return this.options.velocity || 0;
    if (this.generator.velocity)
      return this.generator.velocity(t);
    const n = this.generator.next(t).value;
    return wk((r) => this.generator.next(r).value, t, n);
  }
  get speed() {
    return this.playbackSpeed;
  }
  set speed(t) {
    const n = this.playbackSpeed !== t;
    n && this.driver && this.updateTime(Bn.now()), this.playbackSpeed = t, n && this.driver && (this.time = /* @__PURE__ */ Pr(this.currentTime));
  }
  play() {
    if (this.isStopped)
      return;
    const { driver: t = xR, startTime: n } = this.options;
    this.driver || (this.driver = t((i) => this.tick(i))), this.options.onPlay?.();
    const r = this.driver.now();
    this.state === "finished" ? (this.updateFinished(), this.startTime = r) : this.holdTime !== null ? this.startTime = r - this.holdTime : this.startTime || (this.startTime = n ?? r), this.state === "finished" && this.speed < 0 && (this.startTime += this.calculatedDuration), this.holdTime = null, this.state = "running", this.driver.start();
  }
  pause() {
    this.state = "paused", this.updateTime(Bn.now()), this.holdTime = this.currentTime;
  }
  complete() {
    this.state !== "running" && this.play(), this.state = "finished", this.holdTime = null;
  }
  finish() {
    this.notifyFinished(), this.teardown(), this.state = "finished", this.options.onComplete?.();
  }
  cancel() {
    this.holdTime = null, this.startTime = 0, this.tick(0), this.teardown(), this.options.onCancel?.();
  }
  teardown() {
    this.state = "idle", this.stopDriver(), this.startTime = this.holdTime = null;
  }
  stopDriver() {
    this.driver && (this.driver.stop(), this.driver = void 0);
  }
  sample(t) {
    return this.startTime = 0, this.tick(t, !0);
  }
  attachTimeline(t) {
    return this.options.allowFlatten && (this.options.type = "keyframes", this.options.ease = "linear", this.initAnimation()), this.driver?.stop(), t.observe(this);
  }
}
function LR(e) {
  for (let t = 1; t < e.length; t++)
    e[t] ?? (e[t] = e[t - 1]);
}
const ca = (e) => e * 180 / Math.PI, pv = (e) => {
  const t = ca(Math.atan2(e[1], e[0]));
  return hv(t);
}, VR = {
  x: 4,
  y: 5,
  translateX: 4,
  translateY: 5,
  scaleX: 0,
  scaleY: 3,
  scale: (e) => (Math.abs(e[0]) + Math.abs(e[3])) / 2,
  rotate: pv,
  rotateZ: pv,
  skewX: (e) => ca(Math.atan(e[1])),
  skewY: (e) => ca(Math.atan(e[2])),
  skew: (e) => (Math.abs(e[1]) + Math.abs(e[2])) / 2
}, hv = (e) => (e = e % 360, e < 0 && (e += 360), e), y_ = pv, b_ = (e) => Math.sqrt(e[0] * e[0] + e[1] * e[1]), __ = (e) => Math.sqrt(e[4] * e[4] + e[5] * e[5]), BR = {
  x: 12,
  y: 13,
  z: 14,
  translateX: 12,
  translateY: 13,
  translateZ: 14,
  scaleX: b_,
  scaleY: __,
  scale: (e) => (b_(e) + __(e)) / 2,
  rotateX: (e) => hv(ca(Math.atan2(e[6], e[5]))),
  rotateY: (e) => hv(ca(Math.atan2(-e[2], e[0]))),
  rotateZ: y_,
  rotate: y_,
  skewX: (e) => ca(Math.atan(e[4])),
  skewY: (e) => ca(Math.atan(e[1])),
  skew: (e) => (Math.abs(e[1]) + Math.abs(e[4])) / 2
};
function mv(e) {
  return e.includes("scale") ? 1 : 0;
}
function vv(e, t) {
  if (!e || e === "none")
    return mv(t);
  const n = e.match(/^matrix3d\(([-\d.e\s,]+)\)$/u);
  let r, i;
  if (n)
    r = BR, i = n;
  else {
    const s = e.match(/^matrix\(([-\d.e\s,]+)\)$/u);
    r = VR, i = s;
  }
  if (!i)
    return mv(t);
  const o = r[t], a = i[1].split(",").map(UR);
  return typeof o == "function" ? o(a) : a[o];
}
const KR = (e, t) => {
  const { transform: n = "none" } = getComputedStyle(e);
  return vv(n, t);
};
function UR(e) {
  return parseFloat(e.trim());
}
const nl = [
  "transformPerspective",
  "x",
  "y",
  "z",
  "translateX",
  "translateY",
  "translateZ",
  "scale",
  "scaleX",
  "scaleY",
  "rotate",
  "rotateX",
  "rotateY",
  "rotateZ",
  "skew",
  "skewX",
  "skewY"
], rl = /* @__PURE__ */ new Set([...nl, "pathRotation"]), w_ = (e) => e === tl || e === Re, qR = /* @__PURE__ */ new Set(["x", "y", "z"]), HR = nl.filter((e) => !qR.has(e));
function WR(e) {
  const t = [];
  return HR.forEach((n) => {
    const r = e.getValue(n);
    r !== void 0 && (t.push([n, r.get()]), r.set(n.startsWith("scale") ? 1 : 0));
  }), t;
}
const go = {
  // Dimensions
  width: ({ x: e }, { paddingLeft: t = "0", paddingRight: n = "0", boxSizing: r }) => {
    const i = e.max - e.min;
    return r === "border-box" ? i : i - parseFloat(t) - parseFloat(n);
  },
  height: ({ y: e }, { paddingTop: t = "0", paddingBottom: n = "0", boxSizing: r }) => {
    const i = e.max - e.min;
    return r === "border-box" ? i : i - parseFloat(t) - parseFloat(n);
  },
  top: (e, { top: t }) => parseFloat(t),
  left: (e, { left: t }) => parseFloat(t),
  bottom: ({ y: e }, { top: t }) => parseFloat(t) + (e.max - e.min),
  right: ({ x: e }, { left: t }) => parseFloat(t) + (e.max - e.min),
  // Transform
  x: (e, { transform: t }) => vv(t, "x"),
  y: (e, { transform: t }) => vv(t, "y")
};
go.translateX = go.x;
go.translateY = go.y;
const ha = /* @__PURE__ */ new Set();
let gv = !1, yv = !1, bv = !1;
function Ek() {
  if (yv) {
    const e = Array.from(ha).filter((r) => r.needsMeasurement), t = new Set(e.map((r) => r.element)), n = /* @__PURE__ */ new Map();
    t.forEach((r) => {
      const i = WR(r);
      i.length && (n.set(r, i), r.render());
    }), e.forEach((r) => r.measureInitialState()), t.forEach((r) => {
      r.render();
      const i = n.get(r);
      i && i.forEach(([o, a]) => {
        r.getValue(o)?.set(a);
      });
    }), e.forEach((r) => r.measureEndState()), e.forEach((r) => {
      r.suspendedScrollY !== void 0 && window.scrollTo(0, r.suspendedScrollY);
    });
  }
  yv = !1, gv = !1, ha.forEach((e) => e.complete(bv)), ha.clear();
}
function Sk() {
  ha.forEach((e) => {
    e.readKeyframes(), e.needsMeasurement && (yv = !0);
  });
}
function ZR() {
  bv = !0, Sk(), Ek(), bv = !1;
}
class jy {
  constructor(t, n, r, i, o, a = !1) {
    this.state = "pending", this.isAsync = !1, this.needsMeasurement = !1, this.unresolvedKeyframes = [...t], this.onComplete = n, this.name = r, this.motionValue = i, this.element = o, this.isAsync = a;
  }
  scheduleResolve() {
    this.state = "scheduled", this.isAsync ? (ha.add(this), gv || (gv = !0, _t.read(Sk), _t.resolveKeyframes(Ek))) : (this.readKeyframes(), this.complete());
  }
  readKeyframes() {
    const { unresolvedKeyframes: t, name: n, element: r, motionValue: i } = this;
    if (t[0] === null) {
      const o = i?.get(), a = t[t.length - 1];
      if (o !== void 0)
        t[0] = o;
      else if (r && n) {
        const s = r.readValue(n, a);
        s != null && (t[0] = s);
      }
      t[0] === void 0 && (t[0] = a), i && o === void 0 && i.set(t[0]);
    }
    LR(t);
  }
  setFinalKeyframe() {
  }
  measureInitialState() {
  }
  renderEndStyles() {
  }
  measureEndState() {
  }
  complete(t = !1) {
    this.state = "complete", this.onComplete(this.unresolvedKeyframes, this.finalKeyframe, t), ha.delete(this);
  }
  cancel() {
    this.state === "scheduled" && (ha.delete(this), this.state = "pending");
  }
  resume() {
    this.state === "pending" && this.scheduleResolve();
  }
}
const GR = (e) => e.startsWith("--");
function $k(e, t, n) {
  GR(t) ? e.style.setProperty(t, n) : e.style[t] = n;
}
const YR = {};
function kk(e, t) {
  const n = /* @__PURE__ */ X$(e);
  return () => YR[t] ?? n();
}
const QR = /* @__PURE__ */ kk(() => window.ScrollTimeline !== void 0, "scrollTimeline"), Tk = /* @__PURE__ */ kk(() => {
  try {
    document.createElement("div").animate({ opacity: 0 }, { easing: "linear(0, 1)" });
  } catch {
    return !1;
  }
  return !0;
}, "linearEasing"), ql = ([e, t, n, r]) => `cubic-bezier(${e}, ${t}, ${n}, ${r})`, x_ = {
  linear: "linear",
  ease: "ease",
  easeIn: "ease-in",
  easeOut: "ease-out",
  easeInOut: "ease-in-out",
  circIn: /* @__PURE__ */ ql([0, 0.65, 0.55, 1]),
  circOut: /* @__PURE__ */ ql([0.55, 0, 1, 0.45]),
  backIn: /* @__PURE__ */ ql([0.31, 0.01, 0.66, -0.59]),
  backOut: /* @__PURE__ */ ql([0.33, 1.53, 0.69, 0.99])
};
function Ok(e, t) {
  if (e)
    return typeof e == "function" ? Tk() ? _k(e, t) : "ease-out" : /* @__PURE__ */ ck(e) ? ql(e) : Array.isArray(e) ? e.map((n) => Ok(n, t) || x_.easeOut) : x_[e];
}
function JR(e, t, n, { delay: r = 0, duration: i = 300, repeat: o = 0, repeatType: a = "loop", ease: s = "easeOut", times: l } = {}, u = void 0) {
  const c = {
    [t]: n
  };
  l && (c.offset = l);
  const f = Ok(s, i);
  Array.isArray(f) && (c.easing = f);
  const d = {
    delay: r,
    duration: i,
    easing: Array.isArray(f) ? "linear" : f,
    fill: "both",
    iterations: o + 1,
    direction: a === "reverse" ? "alternate" : "normal"
  };
  return u && (d.pseudoElement = u), e.animate(c, d);
}
function Pk(e) {
  return typeof e == "function" && "applyToOptions" in e;
}
function XR({ type: e, ...t }) {
  return Pk(e) && Tk() ? e.applyToOptions(t) : (t.duration ?? (t.duration = 300), t.ease ?? (t.ease = "easeOut"), t);
}
class Ak extends Ny {
  constructor(t) {
    if (super(), this.finishedTime = null, this.isStopped = !1, this.manualStartTime = null, !t)
      return;
    const { element: n, name: r, keyframes: i, pseudoElement: o, allowFlatten: a = !1, finalKeyframe: s, onComplete: l } = t;
    this.isPseudoElement = !!o, this.allowFlatten = a, this.options = t, Wi(typeof t.type != "string", `Mini animate() doesn't support "type" as a string.`, "mini-spring");
    const u = XR(t);
    this.animation = JR(n, r, i, u, o), u.autoplay === !1 && this.animation.pause(), this.animation.onfinish = () => {
      if (this.finishedTime = this.time, !o) {
        const c = np(i, this.options, s, this.speed);
        this.updateMotionValue && this.updateMotionValue(c), $k(n, r, c), this.animation.cancel();
      }
      l?.(), this.notifyFinished();
    };
  }
  play() {
    this.isStopped || (this.manualStartTime = null, this.animation.play(), this.state === "finished" && this.updateFinished());
  }
  pause() {
    this.animation.pause();
  }
  complete() {
    this.animation.finish?.();
  }
  cancel() {
    try {
      this.animation.cancel();
    } catch {
    }
  }
  stop() {
    if (this.isStopped)
      return;
    this.isStopped = !0;
    const { state: t } = this;
    t === "idle" || t === "finished" || (this.updateMotionValue ? this.updateMotionValue() : this.commitStyles(), this.isPseudoElement || this.cancel());
  }
  /**
   * WAAPI doesn't natively have any interruption capabilities.
   *
   * In this method, we commit styles back to the DOM before cancelling
   * the animation.
   *
   * This is designed to be overridden by NativeAnimationExtended, which
   * will create a renderless JS animation and sample it twice to calculate
   * its current value, "previous" value, and therefore allow
   * Motion to also correctly calculate velocity for any subsequent animation
   * while deferring the commit until the next animation frame.
   */
  commitStyles() {
    const t = this.options?.element;
    !this.isPseudoElement && t?.isConnected && this.animation.commitStyles?.();
  }
  get duration() {
    const t = this.animation.effect?.getComputedTiming?.().duration || 0;
    return /* @__PURE__ */ Pr(Number(t));
  }
  get iterationDuration() {
    const { delay: t = 0 } = this.options || {};
    return this.duration + /* @__PURE__ */ Pr(t);
  }
  get time() {
    return /* @__PURE__ */ Pr(Number(this.animation.currentTime) || 0);
  }
  set time(t) {
    const n = this.finishedTime !== null;
    this.manualStartTime = null, this.finishedTime = null, this.animation.currentTime = /* @__PURE__ */ er(t), n && this.animation.pause();
  }
  /**
   * The playback speed of the animation.
   * 1 = normal speed, 2 = double speed, 0.5 = half speed.
   */
  get speed() {
    return this.animation.playbackRate;
  }
  set speed(t) {
    t < 0 && (this.finishedTime = null), this.animation.playbackRate = t;
  }
  get state() {
    return this.finishedTime !== null ? "finished" : this.animation.playState;
  }
  get startTime() {
    return this.manualStartTime ?? Number(this.animation.startTime);
  }
  set startTime(t) {
    this.manualStartTime = this.animation.startTime = t;
  }
  /**
   * Attaches a timeline to the animation, for instance the `ScrollTimeline`.
   */
  attachTimeline({ timeline: t, rangeStart: n, rangeEnd: r, observe: i }) {
    return this.allowFlatten && this.animation.effect?.updateTiming({ easing: "linear" }), this.animation.onfinish = null, t && QR() ? (this.animation.timeline = t, n && (this.animation.rangeStart = n), r && (this.animation.rangeEnd = r), Mr) : i(this);
  }
}
const Dk = {
  anticipate: ak,
  backInOut: ok,
  circInOut: lk
};
function eN(e) {
  return e in Dk;
}
function tN(e) {
  typeof e.ease == "string" && eN(e.ease) && (e.ease = Dk[e.ease]);
}
const kh = 10;
class nN extends Ak {
  constructor(t) {
    tN(t), xk(t), super(t), t.startTime !== void 0 && t.autoplay !== !1 && (this.startTime = t.startTime), this.options = t;
  }
  /**
   * WAAPI doesn't natively have any interruption capabilities.
   *
   * Rather than read committed styles back out of the DOM, we can
   * create a renderless JS animation and sample it twice to calculate
   * its current value, "previous" value, and therefore allow
   * Motion to calculate velocity for any subsequent animation.
   */
  updateMotionValue(t) {
    const { motionValue: n, onUpdate: r, onComplete: i, element: o, ...a } = this.options;
    if (!n)
      return;
    if (t !== void 0) {
      n.set(t);
      return;
    }
    const s = new Yf({
      ...a,
      autoplay: !1
    }), l = Math.max(kh, Bn.now() - this.startTime), u = Ai(0, kh, l - kh), c = s.sample(l).value, { name: f } = this.options;
    o && f && $k(o, f, c), n.setWithVelocity(s.sample(Math.max(0, l - u)).value, c, u), s.stop();
  }
}
const E_ = (e, t) => t === "zIndex" ? !1 : !!(typeof e == "number" || Array.isArray(e) || typeof e == "string" && // It's animatable if we have a string
(ni.test(e) || e === "0") && // And it contains numbers and/or colors
!e.startsWith("url("));
function rN(e) {
  const t = e[0];
  if (e.length === 1)
    return !0;
  for (let n = 0; n < e.length; n++)
    if (e[n] !== t)
      return !0;
}
function iN(e, t, n, r) {
  const i = e[0];
  if (i === null)
    return !1;
  if (t === "display" || t === "visibility")
    return !0;
  const o = e[e.length - 1], a = E_(i, t), s = E_(o, t);
  return el(a === s, `You are trying to animate ${t} from "${i}" to "${o}". "${a ? o : i}" is not an animatable value.`, "value-not-animatable"), !a || !s ? !1 : rN(e) || (n === "spring" || Pk(n)) && r;
}
function _v(e) {
  e.duration = 0, e.type = "keyframes";
}
const Ck = /* @__PURE__ */ new Set([
  "opacity",
  "clipPath",
  "filter",
  "transform"
  // TODO: Can be accelerated but currently disabled until https://issues.chromium.org/issues/41491098 is resolved
  // or until we implement support for linear() easing.
  // "background-color"
]), oN = /^(?:oklch|oklab|lab|lch|color|color-mix|light-dark)\(/;
function aN(e) {
  for (let t = 0; t < e.length; t++)
    if (typeof e[t] == "string" && oN.test(e[t]))
      return !0;
  return !1;
}
const sN = /* @__PURE__ */ new Set([
  "color",
  "backgroundColor",
  "outlineColor",
  "fill",
  "stroke",
  "borderColor",
  "borderTopColor",
  "borderRightColor",
  "borderBottomColor",
  "borderLeftColor"
]), lN = /* @__PURE__ */ X$(() => Object.hasOwnProperty.call(Element.prototype, "animate"));
function uN(e) {
  const { motionValue: t, name: n, repeatDelay: r, repeatType: i, damping: o, type: a, keyframes: s } = e;
  if (!(t?.owner?.current instanceof HTMLElement))
    return !1;
  const { onUpdate: u, transformTemplate: c } = t.owner.getProps();
  return lN() && n && /**
   * Force WAAPI for color properties with browser-only color formats
   * (oklch, oklab, lab, lch, etc.) that the JS animation path can't parse.
   */
  (Ck.has(n) || sN.has(n) && aN(s)) && (n !== "transform" || !c) && /**
   * If we're outputting values to onUpdate then we can't use WAAPI as there's
   * no way to read the value from WAAPI every frame.
   */
  !u && !r && i !== "mirror" && o !== 0 && a !== "inertia";
}
const cN = 40;
class fN extends Ny {
  constructor({ autoplay: t = !0, delay: n = 0, type: r = "keyframes", repeat: i = 0, repeatDelay: o = 0, repeatType: a = "loop", keyframes: s, name: l, motionValue: u, element: c, ...f }) {
    super(), this.stop = () => {
      this._animation && (this._animation.stop(), this.stopTimeline?.()), this.keyframeResolver?.cancel();
    }, this.createdAt = Bn.now();
    const d = {
      autoplay: t,
      delay: n,
      type: r,
      repeat: i,
      repeatDelay: o,
      repeatType: a,
      name: l,
      motionValue: u,
      element: c,
      ...f
    }, p = c?.KeyframeResolver || jy;
    this.keyframeResolver = new p(s, (h, v, m) => this.onKeyframesResolved(h, v, d, !m), l, u, c), this.keyframeResolver?.scheduleResolve();
  }
  onKeyframesResolved(t, n, r, i) {
    this.keyframeResolver = void 0;
    const { name: o, type: a, velocity: s, delay: l, isHandoff: u, onUpdate: c } = r;
    this.resolvedAt = Bn.now();
    let f = !0;
    iN(t, o, a, s) || (f = !1, (ko.instantAnimations || !l) && c?.(np(t, r, n)), t[0] = t[t.length - 1], _v(r), r.repeat = 0);
    const p = {
      startTime: i ? this.resolvedAt ? this.resolvedAt - this.createdAt > cN ? this.resolvedAt : this.createdAt : this.createdAt : void 0,
      finalKeyframe: n,
      ...r,
      keyframes: t
    }, h = f && !u && uN(p), v = p.motionValue?.owner?.current;
    let m;
    if (h)
      try {
        m = new nN({
          ...p,
          element: v
        });
      } catch {
        m = new Yf(p);
      }
    else
      m = new Yf(p);
    m.finished.then(() => {
      this.notifyFinished();
    }).catch(Mr), this.pendingTimeline && (this.stopTimeline = m.attachTimeline(this.pendingTimeline), this.pendingTimeline = void 0), this._animation = m;
  }
  get finished() {
    return this._animation ? this.animation.finished : this._finished;
  }
  then(t, n) {
    return this.finished.finally(t).then(() => {
    });
  }
  get animation() {
    return this._animation || (this.keyframeResolver?.resume(), ZR()), this._animation;
  }
  get duration() {
    return this.animation.duration;
  }
  get iterationDuration() {
    return this.animation.iterationDuration;
  }
  get time() {
    return this.animation.time;
  }
  set time(t) {
    this.animation.time = t;
  }
  get speed() {
    return this.animation.speed;
  }
  get state() {
    return this.animation.state;
  }
  set speed(t) {
    this.animation.speed = t;
  }
  get startTime() {
    return this.animation.startTime;
  }
  attachTimeline(t) {
    return this._animation ? this.stopTimeline = this.animation.attachTimeline(t) : this.pendingTimeline = t, () => this.stop();
  }
  play() {
    this.animation.play();
  }
  pause() {
    this.animation.pause();
  }
  complete() {
    this.animation.complete();
  }
  cancel() {
    this._animation && this.animation.cancel(), this.keyframeResolver?.cancel();
  }
}
function Ik(e, t, n, r = 0, i = 1) {
  const o = Array.from(e).sort((u, c) => u.sortNodePosition(c)).indexOf(t), a = e.size, s = (a - 1) * r;
  return typeof n == "function" ? n(o, a) : i === 1 ? o * r : s - o * r;
}
const S_ = 30, dN = (e) => !isNaN(parseFloat(e));
class pN {
  /**
   * @param init - The initiating value
   * @param config - Optional configuration options
   *
   * -  `transformer`: A function to transform incoming values with.
   */
  constructor(t, n = {}) {
    this.canTrackVelocity = null, this.events = {}, this.updateAndNotify = (r) => {
      const i = Bn.now();
      if (this.updatedAt !== i && this.setPrevFrameValue(), this.prev = this.current, this.setCurrent(r), this.current !== this.prev && (this.events.change?.notify(this.current), this.dependents))
        for (const o of this.dependents)
          o.dirty();
    }, this.hasAnimated = !1, this.setCurrent(t), this.owner = n.owner;
  }
  setCurrent(t) {
    this.current = t, this.updatedAt = Bn.now(), this.canTrackVelocity === null && t !== void 0 && (this.canTrackVelocity = dN(this.current));
  }
  setPrevFrameValue(t = this.current) {
    this.prevFrameValue = t, this.prevUpdatedAt = this.updatedAt;
  }
  /**
   * Adds a function that will be notified when the `MotionValue` is updated.
   *
   * It returns a function that, when called, will cancel the subscription.
   *
   * When calling `onChange` inside a React component, it should be wrapped with the
   * `useEffect` hook. As it returns an unsubscribe function, this should be returned
   * from the `useEffect` function to ensure you don't add duplicate subscribers..
   *
   * ```jsx
   * export const MyComponent = () => {
   *   const x = useMotionValue(0)
   *   const y = useMotionValue(0)
   *   const opacity = useMotionValue(1)
   *
   *   useEffect(() => {
   *     function updateOpacity() {
   *       const maxXY = Math.max(x.get(), y.get())
   *       const newOpacity = transform(maxXY, [0, 100], [1, 0])
   *       opacity.set(newOpacity)
   *     }
   *
   *     const unsubscribeX = x.on("change", updateOpacity)
   *     const unsubscribeY = y.on("change", updateOpacity)
   *
   *     return () => {
   *       unsubscribeX()
   *       unsubscribeY()
   *     }
   *   }, [])
   *
   *   return <motion.div style={{ x }} />
   * }
   * ```
   *
   * @param subscriber - A function that receives the latest value.
   * @returns A function that, when called, will cancel this subscription.
   *
   * @deprecated
   */
  onChange(t) {
    return process.env.NODE_ENV !== "production" && Oy(!1, 'value.onChange(callback) is deprecated. Switch to value.on("change", callback).'), this.on("change", t);
  }
  on(t, n) {
    this.events[t] || (this.events[t] = new Ty());
    const r = this.events[t].add(n);
    return t === "change" ? () => {
      r(), _t.read(() => {
        this.events.change.getSize() || this.stop();
      });
    } : r;
  }
  clearListeners() {
    for (const t in this.events)
      this.events[t].clear();
  }
  /**
   * Attaches a passive effect to the `MotionValue`.
   */
  attach(t, n) {
    this.passiveEffect = t, this.stopPassiveEffect = n;
  }
  /**
   * Sets the state of the `MotionValue`.
   *
   * @remarks
   *
   * ```jsx
   * const x = useMotionValue(0)
   * x.set(10)
   * ```
   *
   * @param latest - Latest value to set.
   * @param render - Whether to notify render subscribers. Defaults to `true`
   *
   * @public
   */
  set(t) {
    this.passiveEffect ? this.passiveEffect(t, this.updateAndNotify) : this.updateAndNotify(t);
  }
  setWithVelocity(t, n, r) {
    this.set(n), this.prev = void 0, this.prevFrameValue = t, this.prevUpdatedAt = this.updatedAt - r;
  }
  /**
   * Set the state of the `MotionValue`, stopping any active animations,
   * effects, and resets velocity to `0`.
   */
  jump(t, n = !0) {
    this.updateAndNotify(t), this.prev = t, this.prevUpdatedAt = this.prevFrameValue = void 0, n && this.stop(), this.stopPassiveEffect && this.stopPassiveEffect();
  }
  dirty() {
    this.events.change?.notify(this.current);
  }
  addDependent(t) {
    this.dependents || (this.dependents = /* @__PURE__ */ new Set()), this.dependents.add(t);
  }
  removeDependent(t) {
    this.dependents && this.dependents.delete(t);
  }
  /**
   * Returns the latest state of `MotionValue`
   *
   * @returns - The latest state of `MotionValue`
   *
   * @public
   */
  get() {
    return this.current;
  }
  /**
   * @public
   */
  getPrevious() {
    return this.prev;
  }
  /**
   * Returns the latest velocity of `MotionValue`
   *
   * @returns - The latest velocity of `MotionValue`. Returns `0` if the state is non-numerical.
   *
   * @public
   */
  getVelocity() {
    const t = Bn.now();
    if (!this.canTrackVelocity || this.prevFrameValue === void 0 || t - this.updatedAt > S_)
      return 0;
    const n = Math.min(this.updatedAt - this.prevUpdatedAt, S_);
    return /* @__PURE__ */ ek(parseFloat(this.current) - parseFloat(this.prevFrameValue), n);
  }
  /**
   * Registers a new animation to control this `MotionValue`. Only one
   * animation can drive a `MotionValue` at one time.
   *
   * ```jsx
   * value.start()
   * ```
   *
   * @param animation - A function that starts the provided animation
   */
  start(t) {
    return this.stop(), new Promise((n) => {
      this.hasAnimated = !0, this.animation = t(n), this.events.animationStart && this.events.animationStart.notify();
    }).then(() => {
      this.events.animationComplete && this.events.animationComplete.notify(), this.clearAnimation();
    });
  }
  /**
   * Stop the currently active animation.
   *
   * @public
   */
  stop() {
    this.animation && (this.animation.stop(), this.events.animationCancel && this.events.animationCancel.notify()), this.clearAnimation();
  }
  /**
   * Returns `true` if this value is currently animating.
   *
   * @public
   */
  isAnimating() {
    return !!this.animation;
  }
  clearAnimation() {
    delete this.animation;
  }
  /**
   * Destroy and clean up subscribers to this `MotionValue`.
   *
   * The `MotionValue` hooks like `useMotionValue` and `useTransform` automatically
   * handle the lifecycle of the returned `MotionValue`, so this method is only necessary if you've manually
   * created a `MotionValue` via the `motionValue` function.
   *
   * @public
   */
  destroy() {
    this.dependents?.clear(), this.events.destroy?.notify(), this.clearListeners(), this.stop(), this.stopPassiveEffect && this.stopPassiveEffect();
  }
}
function Ms(e, t) {
  return new pN(e, t);
}
function Mk(e, t) {
  if (e?.inherit && t) {
    const { inherit: n, ...r } = e;
    return { ...t, ...r };
  }
  return e;
}
function Fy(e, t) {
  const n = e?.[t] ?? e?.default ?? e;
  return n !== e ? Mk(n, e) : n;
}
const hN = {
  type: "spring",
  stiffness: 500,
  damping: 25,
  restSpeed: 10
}, mN = (e) => ({
  type: "spring",
  stiffness: 550,
  damping: e === 0 ? 2 * Math.sqrt(550) : 30,
  restSpeed: 10
}), vN = {
  type: "keyframes",
  duration: 0.8
}, gN = {
  type: "keyframes",
  ease: [0.25, 0.1, 0.35, 1],
  duration: 0.3
}, yN = (e, { keyframes: t }) => t.length > 2 ? vN : rl.has(e) ? e.startsWith("scale") ? mN(t[1]) : hN : gN, bN = /* @__PURE__ */ new Set([
  "when",
  "delay",
  "delayChildren",
  "staggerChildren",
  "staggerDirection",
  "repeat",
  "repeatType",
  "repeatDelay",
  "from",
  "elapsed"
]);
function _N(e) {
  for (const t in e)
    if (!bN.has(t))
      return !0;
  return !1;
}
const zy = (e, t, n, r = {}, i, o) => (a) => {
  const s = Fy(r, e) || {}, l = s.delay || r.delay || 0;
  let { elapsed: u = 0 } = r;
  u = u - /* @__PURE__ */ er(l);
  const c = {
    keyframes: Array.isArray(n) ? n : [null, n],
    ease: "easeOut",
    velocity: t.getVelocity(),
    ...s,
    delay: -u,
    onUpdate: (d) => {
      t.set(d), s.onUpdate && s.onUpdate(d);
    },
    onComplete: () => {
      a(), s.onComplete && s.onComplete();
    },
    name: e,
    motionValue: t,
    element: o ? void 0 : i
  };
  _N(s) || Object.assign(c, yN(e, c)), c.duration && (c.duration = /* @__PURE__ */ er(c.duration)), c.repeatDelay && (c.repeatDelay = /* @__PURE__ */ er(c.repeatDelay)), c.from !== void 0 && (c.keyframes[0] = c.from);
  let f = !1;
  if ((c.type === !1 || c.duration === 0 && !c.repeatDelay) && (_v(c), c.delay === 0 && (f = !0)), (ko.instantAnimations || ko.skipAnimations || i?.shouldSkipAnimations || s.skipAnimations) && (f = !0, _v(c), c.delay = 0), c.allowFlatten = !s.type && !s.ease, f && !o && t.get() !== void 0) {
    const d = np(c.keyframes, s);
    if (d !== void 0) {
      _t.update(() => {
        c.onUpdate(d), c.onComplete();
      });
      return;
    }
  }
  return s.isSync ? new Yf(c) : new fN(c);
}, wN = (
  // eslint-disable-next-line redos-detector/no-unsafe-regex -- false positive, as it can match a lot of words
  /^var\(--(?:([\w-]+)|([\w-]+), ?([a-zA-Z\d ()%#.,-]+))\)/u
);
function xN(e) {
  const t = wN.exec(e);
  if (!t)
    return [,];
  const [, n, r, i] = t;
  return [`--${n ?? r}`, i];
}
const EN = 4;
function Rk(e, t, n = 1) {
  Wi(n <= EN, `Max CSS variable fallback depth detected in property "${e}". This may indicate a circular fallback dependency.`, "max-css-var-depth");
  const [r, i] = xN(e);
  if (!r)
    return;
  const o = window.getComputedStyle(t).getPropertyValue(r);
  if (o) {
    const a = o.trim();
    return Y$(a) ? parseFloat(a) : a;
  }
  return Dy(i) ? Rk(i, t, n + 1) : i;
}
function $_(e) {
  const t = [{}, {}];
  return e?.values.forEach((n, r) => {
    t[0][r] = n.get(), t[1][r] = n.getVelocity();
  }), t;
}
function Ly(e, t, n, r) {
  if (typeof t == "function") {
    const [i, o] = $_(r);
    t = t(n !== void 0 ? n : e.custom, i, o);
  }
  if (typeof t == "string" && (t = e.variants && e.variants[t]), typeof t == "function") {
    const [i, o] = $_(r);
    t = t(n !== void 0 ? n : e.custom, i, o);
  }
  return t;
}
function ma(e, t, n) {
  const r = e.getProps();
  return Ly(r, t, n !== void 0 ? n : r.custom, e);
}
const Nk = /* @__PURE__ */ new Set([
  "width",
  "height",
  "top",
  "left",
  "right",
  "bottom",
  ...nl
]), wv = (e) => Array.isArray(e);
function SN(e, t, n) {
  e.hasValue(t) ? e.getValue(t).set(n) : e.addValue(t, Ms(n));
}
function $N(e) {
  return wv(e) ? e[e.length - 1] || 0 : e;
}
function kN(e, t) {
  const n = ma(e, t);
  let { transitionEnd: r = {}, transition: i = {}, ...o } = n || {};
  o = { ...o, ...r };
  for (const a in o) {
    const s = $N(o[a]);
    SN(e, a, s);
  }
}
const $n = (e) => !!(e && e.getVelocity);
function TN(e) {
  return !!($n(e) && e.add);
}
function xv(e, t) {
  const n = e.getValue("willChange");
  if (TN(n))
    return n.add(t);
  if (!n && ko.WillChange) {
    const r = new ko.WillChange("auto");
    e.addValue("willChange", r), r.add(t);
  }
}
function Vy(e) {
  return e.replace(/([A-Z])/g, (t) => `-${t.toLowerCase()}`);
}
const ON = "framerAppearId", jk = "data-" + Vy(ON);
function Fk(e) {
  return e.props[jk];
}
function PN({ protectedKeys: e, needsAnimating: t }, n) {
  const r = e.hasOwnProperty(n) && t[n] !== !0;
  return t[n] = !1, r;
}
function zk(e, t, { delay: n = 0, transitionOverride: r, type: i } = {}) {
  let { transition: o, transitionEnd: a, ...s } = t;
  const l = e.getDefaultTransition();
  o = o ? Mk(o, l) : l;
  const u = o?.reduceMotion, c = o?.skipAnimations;
  r && (o = r);
  const f = [], d = i && e.animationState && e.animationState.getState()[i], p = o?.path;
  p && p.animateVisualElement(e, s, o, n, f);
  for (const h in s) {
    const v = e.getValue(h, e.latestValues[h] ?? null), m = s[h];
    if (m === void 0 || d && PN(d, h))
      continue;
    const g = {
      delay: n,
      ...Fy(o || {}, h)
    };
    c && (g.skipAnimations = !0);
    const _ = v.get();
    if (_ !== void 0 && !v.isAnimating() && !Array.isArray(m) && m === _ && !g.velocity) {
      _t.update(() => v.set(m));
      continue;
    }
    let x = !1;
    if (window.MotionHandoffAnimation) {
      const k = Fk(e);
      if (k) {
        const D = window.MotionHandoffAnimation(k, h, _t);
        D !== null && (g.startTime = D, x = !0);
      }
    }
    xv(e, h);
    const w = u ?? e.shouldReduceMotion;
    v.start(zy(h, v, m, w && Nk.has(h) ? { type: !1 } : g, e, x));
    const $ = v.animation;
    $ && f.push($);
  }
  if (a) {
    const h = () => _t.update(() => {
      a && kN(e, a);
    });
    f.length ? Promise.all(f).then(h) : h();
  }
  return f;
}
function Ev(e, t, n = {}) {
  const r = ma(e, t, n.type === "exit" ? e.presenceContext?.custom : void 0);
  let { transition: i = e.getDefaultTransition() || {} } = r || {};
  n.transitionOverride && (i = n.transitionOverride);
  const o = r ? () => Promise.all(zk(e, r, n)) : () => Promise.resolve(), a = e.variantChildren && e.variantChildren.size ? (l = 0) => {
    const { delayChildren: u = 0, staggerChildren: c, staggerDirection: f } = i;
    return AN(e, t, l, u, c, f, n);
  } : () => Promise.resolve(), { when: s } = i;
  if (s) {
    const [l, u] = s === "beforeChildren" ? [o, a] : [a, o];
    return l().then(() => u());
  } else
    return Promise.all([o(), a(n.delay)]);
}
function AN(e, t, n = 0, r = 0, i = 0, o = 1, a) {
  const s = [];
  for (const l of e.variantChildren)
    l.notify("AnimationStart", t), s.push(Ev(l, t, {
      ...a,
      delay: n + (typeof r == "function" ? 0 : r) + Ik(e.variantChildren, l, r, i, o)
    }).then(() => l.notify("AnimationComplete", t)));
  return Promise.all(s);
}
function DN(e, t, n = {}) {
  e.notify("AnimationStart", t);
  let r;
  if (Array.isArray(t)) {
    const i = t.map((o) => Ev(e, o, n));
    r = Promise.all(i);
  } else if (typeof t == "string")
    r = Ev(e, t, n);
  else {
    const i = typeof t == "function" ? ma(e, t, n.custom) : t;
    r = Promise.all(zk(e, i, n));
  }
  return r.then(() => {
    e.notify("AnimationComplete", t);
  });
}
const CN = {
  test: (e) => e === "auto",
  parse: (e) => e
}, Lk = (e) => (t) => t.test(e), Vk = [tl, Re, Ti, ji, rR, nR, CN], k_ = (e) => Vk.find(Lk(e));
function IN(e) {
  return typeof e == "number" ? e === 0 : e !== null ? e === "none" || e === "0" || J$(e) : !0;
}
const MN = /* @__PURE__ */ new Set(["brightness", "contrast", "saturate", "opacity"]);
function RN(e) {
  const [t, n] = e.slice(0, -1).split("(");
  if (t === "drop-shadow")
    return e;
  const [r] = n.match(Cy) || [];
  if (!r)
    return e;
  const i = n.replace(r, "");
  let o = MN.has(t) ? 1 : 0;
  return r !== n && (o *= 100), t + "(" + o + i + ")";
}
const NN = /\b([a-z-]*)\(.*?\)/gu, Sv = {
  ...ni,
  getAnimatableNone: (e) => {
    const t = e.match(NN);
    return t ? t.map(RN).join(" ") : e;
  }
}, $v = {
  ...ni,
  getAnimatableNone: (e) => {
    const t = ni.parse(e);
    return ni.createTransformer(e)(t.map((r) => typeof r == "number" ? 0 : typeof r == "object" ? { ...r, alpha: 1 } : r));
  }
}, T_ = {
  ...tl,
  transform: Math.round
}, jN = {
  rotate: ji,
  /**
   * Internal channel for `transition.path` orientToPath. Composed onto
   * `rotate` at the transform-build sites so the user's `rotate` is
   * never read or overwritten. Not part of `transformPropOrder`.
   */
  pathRotation: ji,
  rotateX: ji,
  rotateY: ji,
  rotateZ: ji,
  scale: Ac,
  scaleX: Ac,
  scaleY: Ac,
  scaleZ: Ac,
  skew: ji,
  skewX: ji,
  skewY: ji,
  distance: Re,
  translateX: Re,
  translateY: Re,
  translateZ: Re,
  x: Re,
  y: Re,
  z: Re,
  perspective: Re,
  transformPerspective: Re,
  opacity: wu,
  originX: p_,
  originY: p_,
  originZ: Re
}, Qf = {
  // Border props
  borderWidth: Re,
  borderTopWidth: Re,
  borderRightWidth: Re,
  borderBottomWidth: Re,
  borderLeftWidth: Re,
  borderRadius: Re,
  borderTopLeftRadius: Re,
  borderTopRightRadius: Re,
  borderBottomRightRadius: Re,
  borderBottomLeftRadius: Re,
  // Positioning props
  width: Re,
  maxWidth: Re,
  height: Re,
  maxHeight: Re,
  top: Re,
  right: Re,
  bottom: Re,
  left: Re,
  inset: Re,
  insetBlock: Re,
  insetBlockStart: Re,
  insetBlockEnd: Re,
  insetInline: Re,
  insetInlineStart: Re,
  insetInlineEnd: Re,
  // Spacing props
  padding: Re,
  paddingTop: Re,
  paddingRight: Re,
  paddingBottom: Re,
  paddingLeft: Re,
  paddingBlock: Re,
  paddingBlockStart: Re,
  paddingBlockEnd: Re,
  paddingInline: Re,
  paddingInlineStart: Re,
  paddingInlineEnd: Re,
  margin: Re,
  marginTop: Re,
  marginRight: Re,
  marginBottom: Re,
  marginLeft: Re,
  marginBlock: Re,
  marginBlockStart: Re,
  marginBlockEnd: Re,
  marginInline: Re,
  marginInlineStart: Re,
  marginInlineEnd: Re,
  // Typography
  fontSize: Re,
  // Misc
  backgroundPositionX: Re,
  backgroundPositionY: Re,
  ...jN,
  zIndex: T_,
  // SVG
  fillOpacity: wu,
  strokeOpacity: wu,
  numOctaves: T_
}, FN = {
  ...Qf,
  // Color props
  color: un,
  backgroundColor: un,
  outlineColor: un,
  fill: un,
  stroke: un,
  // Border props
  borderColor: un,
  borderTopColor: un,
  borderRightColor: un,
  borderBottomColor: un,
  borderLeftColor: un,
  filter: Sv,
  WebkitFilter: Sv,
  mask: $v,
  WebkitMask: $v
}, Bk = (e) => FN[e], zN = /* @__PURE__ */ new Set([Sv, $v]);
function Kk(e, t) {
  let n = Bk(e);
  return zN.has(n) || (n = ni), n.getAnimatableNone ? n.getAnimatableNone(t) : void 0;
}
const LN = /* @__PURE__ */ new Set(["auto", "none", "0"]);
function VN(e, t, n) {
  let r = 0, i;
  for (; r < e.length && !i; ) {
    const o = e[r];
    typeof o == "string" && !LN.has(o) && Is(o).values.length && (i = e[r]), r++;
  }
  if (i && n)
    for (const o of t)
      e[o] = Kk(n, i);
}
class BN extends jy {
  constructor(t, n, r, i, o) {
    super(t, n, r, i, o, !0);
  }
  readKeyframes() {
    const { unresolvedKeyframes: t, element: n, name: r } = this;
    if (!n || !n.current)
      return;
    super.readKeyframes();
    for (let c = 0; c < t.length; c++) {
      let f = t[c];
      if (typeof f == "string" && (f = f.trim(), Dy(f))) {
        const d = Rk(f, n.current);
        d !== void 0 && (t[c] = d), c === t.length - 1 && (this.finalKeyframe = f);
      }
    }
    if (this.resolveNoneKeyframes(), !Nk.has(r) || t.length !== 2)
      return;
    const [i, o] = t, a = k_(i), s = k_(o), l = d_(i), u = d_(o);
    if (l !== u && go[r]) {
      this.needsMeasurement = !0;
      return;
    }
    if (a !== s)
      if (w_(a) && w_(s))
        for (let c = 0; c < t.length; c++) {
          const f = t[c];
          typeof f == "string" && (t[c] = parseFloat(f));
        }
      else go[r] && (this.needsMeasurement = !0);
  }
  resolveNoneKeyframes() {
    const { unresolvedKeyframes: t, name: n } = this, r = [];
    for (let i = 0; i < t.length; i++)
      (t[i] === null || IN(t[i])) && r.push(i);
    r.length && VN(t, r, n);
  }
  measureInitialState() {
    const { element: t, unresolvedKeyframes: n, name: r } = this;
    if (!t || !t.current)
      return;
    r === "height" && (this.suspendedScrollY = window.pageYOffset), this.measuredOrigin = go[r](t.measureViewportBox(), window.getComputedStyle(t.current)), n[0] = this.measuredOrigin;
    const i = n[n.length - 1];
    i !== void 0 && t.getValue(r, i).jump(i, !1);
  }
  measureEndState() {
    const { element: t, name: n, unresolvedKeyframes: r } = this;
    if (!t || !t.current)
      return;
    const i = t.getValue(n);
    i && i.jump(this.measuredOrigin, !1);
    const o = r.length - 1, a = r[o];
    r[o] = go[n](t.measureViewportBox(), window.getComputedStyle(t.current)), a !== null && this.finalKeyframe === void 0 && (this.finalKeyframe = a), this.removedTransforms?.length && this.removedTransforms.forEach(([s, l]) => {
      t.getValue(s).set(l);
    }), this.resolveNoneKeyframes();
  }
}
function Uk(e, t, n) {
  if (e == null)
    return [];
  if (e instanceof EventTarget)
    return [e];
  if (typeof e == "string") {
    let r = document;
    const i = n?.[e] ?? r.querySelectorAll(e);
    return i ? Array.from(i) : [];
  }
  return Array.from(e).filter((r) => r != null);
}
const kv = (e, t) => t && typeof e == "number" ? t.transform(e) : e;
function mf(e) {
  return Q$(e) && "offsetHeight" in e && !("ownerSVGElement" in e);
}
const { schedule: By } = /* @__PURE__ */ fk(queueMicrotask, !1), Gr = {
  x: !1,
  y: !1
};
function qk() {
  return Gr.x || Gr.y;
}
function KN(e) {
  return e === "x" || e === "y" ? Gr[e] ? null : (Gr[e] = !0, () => {
    Gr[e] = !1;
  }) : Gr.x || Gr.y ? null : (Gr.x = Gr.y = !0, () => {
    Gr.x = Gr.y = !1;
  });
}
function Hk(e, t) {
  const n = Uk(e), r = new AbortController(), i = {
    passive: !0,
    ...t,
    signal: r.signal
  };
  return [n, i, () => r.abort()];
}
function UN(e) {
  return !(e.pointerType === "touch" || qk());
}
function qN(e, t, n = {}) {
  const [r, i, o] = Hk(e, n);
  return r.forEach((a) => {
    let s = !1, l = !1, u;
    const c = () => {
      a.removeEventListener("pointerleave", h);
    }, f = (m) => {
      u && (u(m), u = void 0), c();
    }, d = (m) => {
      s = !1, window.removeEventListener("pointerup", d), window.removeEventListener("pointercancel", d), l && (l = !1, f(m));
    }, p = () => {
      s = !0, window.addEventListener("pointerup", d, i), window.addEventListener("pointercancel", d, i);
    }, h = (m) => {
      if (m.pointerType !== "touch") {
        if (s) {
          l = !0;
          return;
        }
        f(m);
      }
    }, v = (m) => {
      if (!UN(m))
        return;
      l = !1;
      const g = t(a, m);
      typeof g == "function" && (u = g, a.addEventListener("pointerleave", h, i));
    };
    a.addEventListener("pointerenter", v, i), a.addEventListener("pointerdown", p, i);
  }), o;
}
const Wk = (e, t) => t ? e === t ? !0 : Wk(e, t.parentElement) : !1, Ky = (e) => e.pointerType === "mouse" ? typeof e.button != "number" || e.button <= 0 : e.isPrimary !== !1, HN = /* @__PURE__ */ new Set([
  "BUTTON",
  "INPUT",
  "SELECT",
  "TEXTAREA",
  "A"
]);
function WN(e) {
  return HN.has(e.tagName) || e.isContentEditable === !0;
}
const ZN = /* @__PURE__ */ new Set(["INPUT", "SELECT", "TEXTAREA"]);
function GN(e) {
  return ZN.has(e.tagName) || e.isContentEditable === !0;
}
const vf = /* @__PURE__ */ new WeakSet();
function O_(e) {
  return (t) => {
    t.key === "Enter" && e(t);
  };
}
function Th(e, t) {
  e.dispatchEvent(new PointerEvent("pointer" + t, { isPrimary: !0, bubbles: !0 }));
}
const YN = (e, t) => {
  const n = e.currentTarget;
  if (!n)
    return;
  const r = O_(() => {
    if (vf.has(n))
      return;
    Th(n, "down");
    const i = O_(() => {
      Th(n, "up");
    }), o = () => Th(n, "cancel");
    n.addEventListener("keyup", i, t), n.addEventListener("blur", o, t);
  });
  n.addEventListener("keydown", r, t), n.addEventListener("blur", () => n.removeEventListener("keydown", r), t);
};
function P_(e) {
  return Ky(e) && !qk();
}
const A_ = /* @__PURE__ */ new WeakSet();
function QN(e, t, n = {}) {
  const [r, i, o] = Hk(e, n), a = (s) => {
    const l = s.currentTarget;
    if (!P_(s) || A_.has(s))
      return;
    vf.add(l), n.stopPropagation && A_.add(s);
    const u = t(l, s), c = { ...i, capture: !0 }, f = (h, v) => {
      window.removeEventListener("pointerup", d, c), window.removeEventListener("pointercancel", p, c), vf.has(l) && vf.delete(l), P_(h) && typeof u == "function" && u(h, { success: v });
    }, d = (h) => {
      f(h, l === window || l === document || n.useGlobalTarget || Wk(l, h.target));
    }, p = (h) => {
      f(h, !1);
    };
    window.addEventListener("pointerup", d, c), window.addEventListener("pointercancel", p, c);
  };
  return r.forEach((s) => {
    (n.useGlobalTarget ? window : s).addEventListener("pointerdown", a, i), mf(s) && (s.addEventListener("focus", (u) => YN(u, i)), !WN(s) && !s.hasAttribute("tabindex") && (s.tabIndex = 0));
  }), o;
}
function Uy(e) {
  return Q$(e) && "ownerSVGElement" in e;
}
const gf = /* @__PURE__ */ new WeakMap();
let yf;
const Zk = (e, t, n) => (r, i) => i && i[0] ? i[0][e + "Size"] : Uy(r) && "getBBox" in r ? r.getBBox()[t] : r[n], JN = /* @__PURE__ */ Zk("inline", "width", "offsetWidth"), XN = /* @__PURE__ */ Zk("block", "height", "offsetHeight");
function e8({ target: e, borderBoxSize: t }) {
  gf.get(e)?.forEach((n) => {
    n(e, {
      get width() {
        return JN(e, t);
      },
      get height() {
        return XN(e, t);
      }
    });
  });
}
function t8(e) {
  e.forEach(e8);
}
function n8() {
  typeof ResizeObserver > "u" || (yf = new ResizeObserver(t8));
}
function r8(e, t) {
  yf || n8();
  const n = Uk(e);
  return n.forEach((r) => {
    let i = gf.get(r);
    i || (i = /* @__PURE__ */ new Set(), gf.set(r, i)), i.add(t), yf?.observe(r);
  }), () => {
    n.forEach((r) => {
      const i = gf.get(r);
      i?.delete(t), i?.size || yf?.unobserve(r);
    });
  };
}
const bf = /* @__PURE__ */ new Set();
let us;
function i8() {
  us = () => {
    const e = {
      get width() {
        return window.innerWidth;
      },
      get height() {
        return window.innerHeight;
      }
    };
    bf.forEach((t) => t(e));
  }, window.addEventListener("resize", us);
}
function o8(e) {
  return bf.add(e), us || i8(), () => {
    bf.delete(e), !bf.size && typeof us == "function" && (window.removeEventListener("resize", us), us = void 0);
  };
}
function D_(e, t) {
  return typeof e == "function" ? o8(e) : r8(e, t);
}
function a8(e) {
  return Uy(e) && e.tagName === "svg";
}
const s8 = [...Vk, un, ni], l8 = (e) => s8.find(Lk(e)), C_ = () => ({
  translate: 0,
  scale: 1,
  origin: 0,
  originPoint: 0
}), cs = () => ({
  x: C_(),
  y: C_()
}), I_ = () => ({ min: 0, max: 0 }), pn = () => ({
  x: I_(),
  y: I_()
}), u8 = /* @__PURE__ */ new WeakMap();
function rp(e) {
  return e !== null && typeof e == "object" && typeof e.start == "function";
}
function xu(e) {
  return typeof e == "string" || Array.isArray(e);
}
const qy = [
  "animate",
  "whileInView",
  "whileFocus",
  "whileHover",
  "whileTap",
  "whileDrag",
  "exit"
], Hy = ["initial", ...qy];
function ip(e) {
  return rp(e.animate) || Hy.some((t) => xu(e[t]));
}
function Gk(e) {
  return !!(ip(e) || e.variants);
}
function c8(e, t, n) {
  for (const r in t) {
    const i = t[r], o = n[r];
    if ($n(i))
      e.addValue(r, i);
    else if ($n(o))
      e.addValue(r, Ms(i, { owner: e }));
    else if (o !== i)
      if (e.hasValue(r)) {
        const a = e.getValue(r);
        a.liveStyle === !0 ? a.jump(i) : a.hasAnimated || a.set(i);
      } else {
        const a = e.getStaticValue(r);
        e.addValue(r, Ms(a !== void 0 ? a : i, { owner: e }));
      }
  }
  for (const r in n)
    t[r] === void 0 && e.removeValue(r);
  return t;
}
const Tv = { current: null }, Yk = { current: !1 }, f8 = typeof window < "u";
function d8() {
  if (Yk.current = !0, !!f8)
    if (window.matchMedia) {
      const e = window.matchMedia("(prefers-reduced-motion)"), t = () => Tv.current = e.matches;
      e.addEventListener("change", t), t();
    } else
      Tv.current = !1;
}
const M_ = [
  "AnimationStart",
  "AnimationComplete",
  "Update",
  "BeforeLayoutMeasure",
  "LayoutMeasure",
  "LayoutAnimationStart",
  "LayoutAnimationComplete"
];
let Jf = {};
function Qk(e) {
  Jf = e;
}
function p8() {
  return Jf;
}
class h8 {
  /**
   * This method takes React props and returns found MotionValues. For example, HTML
   * MotionValues will be found within the style prop, whereas for Three.js within attribute arrays.
   *
   * This isn't an abstract method as it needs calling in the constructor, but it is
   * intended to be one.
   */
  scrapeMotionValuesFromProps(t, n, r) {
    return {};
  }
  constructor({ parent: t, props: n, presenceContext: r, reducedMotionConfig: i, skipAnimations: o, blockInitialAnimation: a, visualState: s }, l = {}) {
    this.current = null, this.children = /* @__PURE__ */ new Set(), this.isVariantNode = !1, this.isControllingVariants = !1, this.shouldReduceMotion = null, this.shouldSkipAnimations = !1, this.values = /* @__PURE__ */ new Map(), this.KeyframeResolver = jy, this.features = {}, this.valueSubscriptions = /* @__PURE__ */ new Map(), this.prevMotionValues = {}, this.hasBeenMounted = !1, this.events = {}, this.propEventSubscriptions = {}, this.notifyUpdate = () => this.notify("Update", this.latestValues), this.render = () => {
      this.current && (this.triggerBuild(), this.renderInstance(this.current, this.renderState, this.props.style, this.projection));
    }, this.renderScheduledAt = 0, this.scheduleRender = () => {
      const p = Bn.now();
      this.renderScheduledAt < p && (this.renderScheduledAt = p, _t.render(this.render, !1, !0));
    };
    const { latestValues: u, renderState: c } = s;
    this.latestValues = u, this.baseTarget = { ...u }, this.initialValues = n.initial ? { ...u } : {}, this.renderState = c, this.parent = t, this.props = n, this.presenceContext = r, this.depth = t ? t.depth + 1 : 0, this.reducedMotionConfig = i, this.skipAnimationsConfig = o, this.options = l, this.blockInitialAnimation = !!a, this.isControllingVariants = ip(n), this.isVariantNode = Gk(n), this.isVariantNode && (this.variantChildren = /* @__PURE__ */ new Set()), this.manuallyAnimateOnMount = !!(t && t.current);
    const { willChange: f, ...d } = this.scrapeMotionValuesFromProps(n, {}, this);
    for (const p in d) {
      const h = d[p];
      u[p] !== void 0 && $n(h) && h.set(u[p]);
    }
  }
  mount(t) {
    if (this.hasBeenMounted)
      for (const n in this.initialValues)
        this.values.get(n)?.jump(this.initialValues[n]), this.latestValues[n] = this.initialValues[n];
    this.current = t, u8.set(t, this), this.projection && !this.projection.instance && this.projection.mount(t), this.parent && this.isVariantNode && !this.isControllingVariants && (this.removeFromVariantTree = this.parent.addVariantChild(this)), this.values.forEach((n, r) => this.bindToMotionValue(r, n)), this.reducedMotionConfig === "never" ? this.shouldReduceMotion = !1 : this.reducedMotionConfig === "always" ? this.shouldReduceMotion = !0 : (Yk.current || d8(), this.shouldReduceMotion = Tv.current), process.env.NODE_ENV !== "production" && Oy(this.shouldReduceMotion !== !0, "You have Reduced Motion enabled on your device. Animations may not appear as expected.", "reduced-motion-disabled"), this.shouldSkipAnimations = this.skipAnimationsConfig ?? !1, this.parent?.addChild(this), this.update(this.props, this.presenceContext), this.hasBeenMounted = !0;
  }
  unmount() {
    this.projection && this.projection.unmount(), To(this.notifyUpdate), To(this.render), this.valueSubscriptions.forEach((t) => t()), this.valueSubscriptions.clear(), this.removeFromVariantTree && this.removeFromVariantTree(), this.parent?.removeChild(this);
    for (const t in this.events)
      this.events[t].clear();
    for (const t in this.features) {
      const n = this.features[t];
      n && (n.unmount(), n.isMounted = !1);
    }
    this.current = null;
  }
  addChild(t) {
    this.children.add(t), this.enteringChildren ?? (this.enteringChildren = /* @__PURE__ */ new Set()), this.enteringChildren.add(t);
  }
  removeChild(t) {
    this.children.delete(t), this.enteringChildren && this.enteringChildren.delete(t);
  }
  bindToMotionValue(t, n) {
    if (this.valueSubscriptions.has(t) && this.valueSubscriptions.get(t)(), n.accelerate && Ck.has(t) && this.current instanceof HTMLElement) {
      const { factory: a, keyframes: s, times: l, ease: u, duration: c } = n.accelerate, f = new Ak({
        element: this.current,
        name: t,
        keyframes: s,
        times: l,
        ease: u,
        duration: /* @__PURE__ */ er(c)
      }), d = a(f);
      this.valueSubscriptions.set(t, () => {
        d(), f.cancel();
      });
      return;
    }
    const r = rl.has(t);
    r && this.onBindTransform && this.onBindTransform();
    const i = n.on("change", (a) => {
      this.latestValues[t] = a, this.props.onUpdate && _t.preRender(this.notifyUpdate), r && this.projection && (this.projection.isTransformDirty = !0), this.scheduleRender();
    });
    let o;
    typeof window < "u" && window.MotionCheckAppearSync && (o = window.MotionCheckAppearSync(this, t, n)), this.valueSubscriptions.set(t, () => {
      i(), o && o();
    });
  }
  sortNodePosition(t) {
    return !this.current || !this.sortInstanceNodePosition || this.type !== t.type ? 0 : this.sortInstanceNodePosition(this.current, t.current);
  }
  updateFeatures() {
    let t = "animation";
    for (t in Jf) {
      const n = Jf[t];
      if (!n)
        continue;
      const { isEnabled: r, Feature: i } = n;
      if (!this.features[t] && i && r(this.props) && (this.features[t] = new i(this)), this.features[t]) {
        const o = this.features[t];
        o.isMounted ? o.update() : (o.mount(), o.isMounted = !0);
      }
    }
  }
  triggerBuild() {
    this.build(this.renderState, this.latestValues, this.props);
  }
  /**
   * Measure the current viewport box with or without transforms.
   * Only measures axis-aligned boxes, rotate and skew must be manually
   * removed with a re-render to work.
   */
  measureViewportBox() {
    return this.current ? this.measureInstanceViewportBox(this.current, this.props) : pn();
  }
  getStaticValue(t) {
    return this.latestValues[t];
  }
  setStaticValue(t, n) {
    this.latestValues[t] = n;
  }
  /**
   * Update the provided props. Ensure any newly-added motion values are
   * added to our map, old ones removed, and listeners updated.
   */
  update(t, n) {
    (t.transformTemplate || this.props.transformTemplate) && this.scheduleRender(), this.prevProps = this.props, this.props = t, this.prevPresenceContext = this.presenceContext, this.presenceContext = n;
    for (let r = 0; r < M_.length; r++) {
      const i = M_[r];
      this.propEventSubscriptions[i] && (this.propEventSubscriptions[i](), delete this.propEventSubscriptions[i]);
      const o = "on" + i, a = t[o];
      a && (this.propEventSubscriptions[i] = this.on(i, a));
    }
    this.prevMotionValues = c8(this, this.scrapeMotionValuesFromProps(t, this.prevProps || {}, this), this.prevMotionValues), this.handleChildMotionValue && this.handleChildMotionValue();
  }
  getProps() {
    return this.props;
  }
  /**
   * Returns the variant definition with a given name.
   */
  getVariant(t) {
    return this.props.variants ? this.props.variants[t] : void 0;
  }
  /**
   * Returns the defined default transition on this component.
   */
  getDefaultTransition() {
    return this.props.transition;
  }
  getTransformPagePoint() {
    return this.props.transformPagePoint;
  }
  getClosestVariantNode() {
    return this.isVariantNode ? this : this.parent ? this.parent.getClosestVariantNode() : void 0;
  }
  /**
   * Add a child visual element to our set of children.
   */
  addVariantChild(t) {
    const n = this.getClosestVariantNode();
    if (n)
      return n.variantChildren && n.variantChildren.add(t), () => n.variantChildren.delete(t);
  }
  /**
   * Add a motion value and bind it to this visual element.
   */
  addValue(t, n) {
    const r = this.values.get(t);
    n !== r && (r && this.removeValue(t), this.bindToMotionValue(t, n), this.values.set(t, n), this.latestValues[t] = n.get());
  }
  /**
   * Remove a motion value and unbind any active subscriptions.
   */
  removeValue(t) {
    this.values.delete(t);
    const n = this.valueSubscriptions.get(t);
    n && (n(), this.valueSubscriptions.delete(t)), delete this.latestValues[t], this.removeValueFromRenderState(t, this.renderState);
  }
  /**
   * Check whether we have a motion value for this key
   */
  hasValue(t) {
    return this.values.has(t);
  }
  getValue(t, n) {
    if (this.props.values && this.props.values[t])
      return this.props.values[t];
    let r = this.values.get(t);
    return r === void 0 && n !== void 0 && (r = Ms(n === null ? void 0 : n, { owner: this }), this.addValue(t, r)), r;
  }
  /**
   * If we're trying to animate to a previously unencountered value,
   * we need to check for it in our state and as a last resort read it
   * directly from the instance (which might have performance implications).
   */
  readValue(t, n) {
    let r = this.latestValues[t] !== void 0 || !this.current ? this.latestValues[t] : this.getBaseTargetFromProps(this.props, t) ?? this.readValueFromInstance(this.current, t, this.options);
    return r != null && (typeof r == "string" && (Y$(r) || J$(r)) ? r = parseFloat(r) : !l8(r) && ni.test(n) && (r = Kk(t, n)), this.setBaseTarget(t, $n(r) ? r.get() : r)), $n(r) ? r.get() : r;
  }
  /**
   * Set the base target to later animate back to. This is currently
   * only hydrated on creation and when we first read a value.
   */
  setBaseTarget(t, n) {
    this.baseTarget[t] = n;
  }
  /**
   * Find the base target for a value thats been removed from all animation
   * props.
   */
  getBaseTarget(t) {
    const { initial: n } = this.props;
    let r;
    if (typeof n == "string" || typeof n == "object") {
      const o = Ly(this.props, n, this.presenceContext?.custom);
      o && (r = o[t]);
    }
    if (n && r !== void 0)
      return r;
    const i = this.getBaseTargetFromProps(this.props, t);
    return i !== void 0 && !$n(i) ? i : this.initialValues[t] !== void 0 && r === void 0 ? void 0 : this.baseTarget[t];
  }
  on(t, n) {
    return this.events[t] || (this.events[t] = new Ty()), this.events[t].add(n);
  }
  notify(t, ...n) {
    this.events[t] && this.events[t].notify(...n);
  }
  scheduleRenderMicrotask() {
    By.render(this.render);
  }
}
class Jk extends h8 {
  constructor() {
    super(...arguments), this.KeyframeResolver = BN;
  }
  sortInstanceNodePosition(t, n) {
    return t.compareDocumentPosition(n) & 2 ? 1 : -1;
  }
  getBaseTargetFromProps(t, n) {
    const r = t.style;
    return r ? r[n] : void 0;
  }
  removeValueFromRenderState(t, { vars: n, style: r }) {
    delete n[t], delete r[t];
  }
  handleChildMotionValue() {
    this.childSubscription && (this.childSubscription(), delete this.childSubscription);
    const { children: t } = this.props;
    $n(t) && (this.childSubscription = t.on("change", (n) => {
      this.current && (this.current.textContent = `${n}`);
    }));
  }
}
class Fo {
  constructor(t) {
    this.isMounted = !1, this.node = t;
  }
  update() {
  }
}
function Xk({ top: e, left: t, right: n, bottom: r }) {
  return {
    x: { min: t, max: n },
    y: { min: e, max: r }
  };
}
function m8({ x: e, y: t }) {
  return { top: t.min, right: e.max, bottom: t.max, left: e.min };
}
function v8(e, t) {
  if (!t)
    return e;
  const n = t({ x: e.left, y: e.top }), r = t({ x: e.right, y: e.bottom });
  return {
    top: n.y,
    left: n.x,
    bottom: r.y,
    right: r.x
  };
}
function Oh(e) {
  return e === void 0 || e === 1;
}
function Ov({ scale: e, scaleX: t, scaleY: n }) {
  return !Oh(e) || !Oh(t) || !Oh(n);
}
function Xo(e) {
  return Ov(e) || eT(e) || e.z || e.rotate || e.rotateX || e.rotateY || e.skewX || e.skewY;
}
function eT(e) {
  return R_(e.x) || R_(e.y);
}
function R_(e) {
  return e && e !== "0%";
}
function Xf(e, t, n) {
  const r = e - n, i = t * r;
  return n + i;
}
function N_(e, t, n, r, i) {
  return i !== void 0 && (e = Xf(e, i, r)), Xf(e, n, r) + t;
}
function Pv(e, t = 0, n = 1, r, i) {
  e.min = N_(e.min, t, n, r, i), e.max = N_(e.max, t, n, r, i);
}
function tT(e, { x: t, y: n }) {
  Pv(e.x, t.translate, t.scale, t.originPoint), Pv(e.y, n.translate, n.scale, n.originPoint);
}
const j_ = 0.999999999999, F_ = 1.0000000000001;
function g8(e, t, n, r = !1) {
  const i = n.length;
  if (!i)
    return;
  t.x = t.y = 1;
  let o, a;
  for (let s = 0; s < i; s++) {
    o = n[s], a = o.projectionDelta;
    const { visualElement: l } = o.options;
    l && l.props.style && l.props.style.display === "contents" || (r && o.options.layoutScroll && o.scroll && o !== o.root && (wi(e.x, -o.scroll.offset.x), wi(e.y, -o.scroll.offset.y)), a && (t.x *= a.x.scale, t.y *= a.y.scale, tT(e, a)), r && Xo(o.latestValues) && _f(e, o.latestValues, o.layout?.layoutBox));
  }
  t.x < F_ && t.x > j_ && (t.x = 1), t.y < F_ && t.y > j_ && (t.y = 1);
}
function wi(e, t) {
  e.min += t, e.max += t;
}
function z_(e, t, n, r, i = 0.5) {
  const o = St(e.min, e.max, i);
  Pv(e, t, n, o, r);
}
function L_(e, t) {
  return typeof e == "string" ? parseFloat(e) / 100 * (t.max - t.min) : e;
}
function _f(e, t, n) {
  const r = n ?? e;
  z_(e.x, L_(t.x, r.x), t.scaleX, t.scale, t.originX), z_(e.y, L_(t.y, r.y), t.scaleY, t.scale, t.originY);
}
function nT(e, t) {
  return Xk(v8(e.getBoundingClientRect(), t));
}
function y8(e, t, n) {
  const r = nT(e, n), { scroll: i } = t;
  return i && (wi(r.x, i.offset.x), wi(r.y, i.offset.y)), r;
}
const b8 = {
  x: "translateX",
  y: "translateY",
  z: "translateZ",
  transformPerspective: "perspective"
}, _8 = nl.length;
function w8(e, t, n) {
  let r = "", i = !0;
  for (let a = 0; a < _8; a++) {
    const s = nl[a], l = e[s];
    if (l === void 0)
      continue;
    let u = !0;
    if (typeof l == "number")
      u = l === (s.startsWith("scale") ? 1 : 0);
    else {
      const c = parseFloat(l);
      u = s.startsWith("scale") ? c === 1 : c === 0;
    }
    if (!u || n) {
      const c = kv(l, Qf[s]);
      if (!u) {
        i = !1;
        const f = b8[s] || s;
        r += `${f}(${c}) `;
      }
      n && (t[s] = c);
    }
  }
  const o = e.pathRotation;
  return o && (i = !1, r += `rotate(${kv(o, Qf.pathRotation)}) `), r = r.trim(), n ? r = n(t, i ? "" : r) : i && (r = "none"), r;
}
function Wy(e, t, n) {
  const { style: r, vars: i, transformOrigin: o } = e;
  let a = !1, s = !1;
  for (const l in t) {
    const u = t[l];
    if (rl.has(l)) {
      a = !0;
      continue;
    } else if (pk(l)) {
      i[l] = u;
      continue;
    } else {
      const c = kv(u, Qf[l]);
      l.startsWith("origin") ? (s = !0, o[l] = c) : r[l] = c;
    }
  }
  if (t.transform || (a || n ? r.transform = w8(t, e.transform, n) : r.transform && (r.transform = "none")), s) {
    const { originX: l = "50%", originY: u = "50%", originZ: c = 0 } = o;
    r.transformOrigin = `${l} ${u} ${c}`;
  }
}
function rT(e, { style: t, vars: n }, r, i) {
  const o = e.style;
  let a;
  for (a in t)
    o[a] = t[a];
  i?.applyProjectionStyles(o, r);
  for (a in n)
    o.setProperty(a, n[a]);
}
function V_(e, t) {
  return t.max === t.min ? 0 : e / (t.max - t.min) * 100;
}
const Il = {
  correct: (e, t) => {
    if (!t.target)
      return e;
    if (typeof e == "string")
      if (Re.test(e))
        e = parseFloat(e);
      else
        return e;
    const n = V_(e, t.target.x), r = V_(e, t.target.y);
    return `${n}% ${r}%`;
  }
}, x8 = {
  correct: (e, { treeScale: t, projectionDelta: n }) => {
    const r = e, i = ni.parse(e);
    if (i.length > 5)
      return r;
    const o = ni.createTransformer(e), a = typeof i[0] != "number" ? 1 : 0, s = n.x.scale * t.x, l = n.y.scale * t.y;
    i[0 + a] /= s, i[1 + a] /= l;
    const u = St(s, l, 0.5);
    return typeof i[2 + a] == "number" && (i[2 + a] /= u), typeof i[3 + a] == "number" && (i[3 + a] /= u), o(i);
  }
}, Av = {
  borderRadius: {
    ...Il,
    applyTo: [
      "borderTopLeftRadius",
      "borderTopRightRadius",
      "borderBottomLeftRadius",
      "borderBottomRightRadius"
    ]
  },
  borderTopLeftRadius: Il,
  borderTopRightRadius: Il,
  borderBottomLeftRadius: Il,
  borderBottomRightRadius: Il,
  boxShadow: x8
};
function iT(e, { layout: t, layoutId: n }) {
  return rl.has(e) || e.startsWith("origin") || (t || n !== void 0) && (!!Av[e] || e === "opacity");
}
function Zy(e, t, n) {
  const r = e.style, i = t?.style, o = {};
  if (!r)
    return o;
  for (const a in r)
    ($n(r[a]) || i && $n(i[a]) || iT(a, e) || n?.getValue(a)?.liveStyle !== void 0) && (o[a] = r[a]);
  return o;
}
function E8(e) {
  return window.getComputedStyle(e);
}
class S8 extends Jk {
  constructor() {
    super(...arguments), this.type = "html", this.renderInstance = rT;
  }
  readValueFromInstance(t, n) {
    if (rl.has(n))
      return this.projection?.isProjecting ? mv(n) : KR(t, n);
    {
      const r = E8(t), i = (pk(n) ? r.getPropertyValue(n) : r[n]) || 0;
      return typeof i == "string" ? i.trim() : i;
    }
  }
  measureInstanceViewportBox(t, { transformPagePoint: n }) {
    return nT(t, n);
  }
  build(t, n, r) {
    Wy(t, n, r.transformTemplate);
  }
  scrapeMotionValuesFromProps(t, n, r) {
    return Zy(t, n, r);
  }
}
const $8 = {
  offset: "stroke-dashoffset",
  array: "stroke-dasharray"
}, k8 = {
  offset: "strokeDashoffset",
  array: "strokeDasharray"
};
function T8(e, t, n = 1, r = 0, i = !0) {
  e.pathLength = 1;
  const o = i ? $8 : k8;
  e[o.offset] = `${-r}`, e[o.array] = `${t} ${n}`;
}
const O8 = [
  "offsetDistance",
  "offsetPath",
  "offsetRotate",
  "offsetAnchor"
];
function oT(e, {
  attrX: t,
  attrY: n,
  attrScale: r,
  pathLength: i,
  pathSpacing: o = 1,
  pathOffset: a = 0,
  // This is object creation, which we try to avoid per-frame.
  ...s
}, l, u, c) {
  if (Wy(e, s, u), l) {
    e.style.viewBox && (e.attrs.viewBox = e.style.viewBox);
    return;
  }
  e.attrs = e.style, e.style = {};
  const { attrs: f, style: d } = e;
  f.transform && (d.transform = f.transform, delete f.transform), (d.transform || f.transformOrigin) && (d.transformOrigin = f.transformOrigin ?? "50% 50%", delete f.transformOrigin), d.transform && (d.transformBox = c?.transformBox ?? "fill-box", delete f.transformBox);
  for (const p of O8)
    f[p] !== void 0 && (d[p] = f[p], delete f[p]);
  t !== void 0 && (f.x = t), n !== void 0 && (f.y = n), r !== void 0 && (f.scale = r), i !== void 0 && T8(f, i, o, a, !1);
}
const aT = /* @__PURE__ */ new Set([
  "baseFrequency",
  "diffuseConstant",
  "kernelMatrix",
  "kernelUnitLength",
  "keySplines",
  "keyTimes",
  "limitingConeAngle",
  "markerHeight",
  "markerWidth",
  "numOctaves",
  "targetX",
  "targetY",
  "surfaceScale",
  "specularConstant",
  "specularExponent",
  "stdDeviation",
  "tableValues",
  "viewBox",
  "gradientTransform",
  "pathLength",
  "startOffset",
  "textLength",
  "lengthAdjust"
]), sT = (e) => typeof e == "string" && e.toLowerCase() === "svg";
function P8(e, t, n, r) {
  rT(e, t, void 0, r);
  for (const i in t.attrs)
    e.setAttribute(aT.has(i) ? i : Vy(i), t.attrs[i]);
}
function lT(e, t, n) {
  const r = Zy(e, t, n);
  for (const i in e)
    if ($n(e[i]) || $n(t[i])) {
      const o = nl.indexOf(i) !== -1 ? "attr" + i.charAt(0).toUpperCase() + i.substring(1) : i;
      r[o] = e[i];
    }
  return r;
}
class A8 extends Jk {
  constructor() {
    super(...arguments), this.type = "svg", this.isSVGTag = !1, this.measureInstanceViewportBox = pn;
  }
  getBaseTargetFromProps(t, n) {
    return t[n];
  }
  readValueFromInstance(t, n) {
    if (rl.has(n)) {
      const r = Bk(n);
      return r && r.default || 0;
    }
    return n = aT.has(n) ? n : Vy(n), t.getAttribute(n);
  }
  scrapeMotionValuesFromProps(t, n, r) {
    return lT(t, n, r);
  }
  build(t, n, r) {
    oT(t, n, this.isSVGTag, r.transformTemplate, r.style);
  }
  renderInstance(t, n, r, i) {
    P8(t, n, r, i);
  }
  mount(t) {
    this.isSVGTag = sT(t.tagName), super.mount(t);
  }
}
const D8 = Hy.length;
function uT(e) {
  if (!e)
    return;
  if (!e.isControllingVariants) {
    const n = e.parent ? uT(e.parent) || {} : {};
    return e.props.initial !== void 0 && (n.initial = e.props.initial), n;
  }
  const t = {};
  for (let n = 0; n < D8; n++) {
    const r = Hy[n], i = e.props[r];
    (xu(i) || i === !1) && (t[r] = i);
  }
  return t;
}
function cT(e, t) {
  if (!Array.isArray(t))
    return !1;
  const n = t.length;
  if (n !== e.length)
    return !1;
  for (let r = 0; r < n; r++)
    if (t[r] !== e[r])
      return !1;
  return !0;
}
const C8 = [...qy].reverse(), I8 = qy.length;
function M8(e) {
  return (t) => Promise.all(t.map(({ animation: n, options: r }) => DN(e, n, r)));
}
function R8(e) {
  let t = M8(e), n = B_(), r = !0, i = !1;
  const o = (u) => (c, f) => {
    const d = ma(e, f, u === "exit" ? e.presenceContext?.custom : void 0);
    if (d) {
      const { transition: p, transitionEnd: h, ...v } = d;
      c = { ...c, ...v, ...h };
    }
    return c;
  };
  function a(u) {
    t = u(e);
  }
  function s(u) {
    const { props: c } = e, f = uT(e.parent) || {}, d = [], p = /* @__PURE__ */ new Set();
    let h = {}, v = 1 / 0;
    for (let g = 0; g < I8; g++) {
      const _ = C8[g], x = n[_], w = c[_] !== void 0 ? c[_] : f[_], $ = xu(w), k = _ === u ? x.isActive : null;
      k === !1 && (v = g);
      let D = w === f[_] && w !== c[_] && $;
      if (D && (r || i) && e.manuallyAnimateOnMount && (D = !1), x.protectedKeys = { ...h }, // If it isn't active and hasn't *just* been set as inactive
      !x.isActive && k === null || // If we didn't and don't have any defined prop for this animation type
      !w && !x.prevProp || // Or if the prop doesn't define an animation
      rp(w) || typeof w == "boolean")
        continue;
      if (_ === "exit" && x.isActive && k !== !0) {
        x.prevResolvedValues && (h = {
          ...h,
          ...x.prevResolvedValues
        });
        continue;
      }
      const E = N8(x.prevProp, w);
      let b = E || // If we're making this variant active, we want to always make it active
      _ === u && x.isActive && !D && $ || // If we removed a higher-priority variant (i is in reverse order)
      g > v && $, y = !1;
      const S = Array.isArray(w) ? w : [w];
      let P = S.reduce(o(_), {});
      k === !1 && (P = {});
      const { prevResolvedValues: M = {} } = x, T = {
        ...M,
        ...P
      }, V = (B) => {
        b = !0, p.has(B) && (y = !0, p.delete(B)), x.needsAnimating[B] = !0;
        const N = e.getValue(B);
        N && (N.liveStyle = !1);
      };
      for (const B in T) {
        const N = P[B], C = M[B];
        if (h.hasOwnProperty(B))
          continue;
        let G = !1;
        wv(N) && wv(C) ? G = !cT(N, C) || E : G = N !== C, G ? N != null ? V(B) : p.add(B) : N !== void 0 && p.has(B) ? V(B) : x.protectedKeys[B] = !0;
      }
      x.prevProp = w, x.prevResolvedValues = P, x.isActive && (h = { ...h, ...P }), (r || i) && e.blockInitialAnimation && (b = !1);
      const z = D && E;
      b && (!z || y) && d.push(...S.map((B) => {
        const N = { type: _ };
        if (typeof B == "string" && (r || i) && !z && e.manuallyAnimateOnMount && e.parent) {
          const { parent: C } = e, G = ma(C, B);
          if (C.enteringChildren && G) {
            const { delayChildren: re } = G.transition || {};
            N.delay = Ik(C.enteringChildren, e, re);
          }
        }
        return {
          animation: B,
          options: N
        };
      }));
    }
    if (p.size) {
      const g = {};
      if (typeof c.initial != "boolean") {
        const _ = ma(e, Array.isArray(c.initial) ? c.initial[0] : c.initial);
        _ && _.transition && (g.transition = _.transition);
      }
      p.forEach((_) => {
        const x = e.getBaseTarget(_), w = e.getValue(_);
        w && (w.liveStyle = !0), g[_] = x ?? null;
      }), d.push({ animation: g });
    }
    let m = !!d.length;
    return r && (c.initial === !1 || c.initial === c.animate) && !e.manuallyAnimateOnMount && (m = !1), r = !1, i = !1, m ? t(d) : Promise.resolve();
  }
  function l(u, c) {
    if (n[u].isActive === c)
      return Promise.resolve();
    e.variantChildren?.forEach((d) => d.animationState?.setActive(u, c)), n[u].isActive = c;
    const f = s(u);
    for (const d in n)
      n[d].protectedKeys = {};
    return f;
  }
  return {
    animateChanges: s,
    setActive: l,
    setAnimateFunction: a,
    getState: () => n,
    reset: () => {
      n = B_(), i = !0;
    }
  };
}
function N8(e, t) {
  return typeof t == "string" ? t !== e : Array.isArray(t) ? !cT(t, e) : !1;
}
function Go(e = !1) {
  return {
    isActive: e,
    protectedKeys: {},
    needsAnimating: {},
    prevResolvedValues: {}
  };
}
function B_() {
  return {
    animate: Go(!0),
    whileInView: Go(),
    whileHover: Go(),
    whileTap: Go(),
    whileDrag: Go(),
    whileFocus: Go(),
    exit: Go()
  };
}
function Dv(e, t) {
  e.min = t.min, e.max = t.max;
}
function Hr(e, t) {
  Dv(e.x, t.x), Dv(e.y, t.y);
}
function K_(e, t) {
  e.translate = t.translate, e.scale = t.scale, e.originPoint = t.originPoint, e.origin = t.origin;
}
const fT = 1e-4, j8 = 1 - fT, F8 = 1 + fT, dT = 0.01, z8 = 0 - dT, L8 = 0 + dT;
function Kn(e) {
  return e.max - e.min;
}
function V8(e, t, n) {
  return Math.abs(e - t) <= n;
}
function U_(e, t, n, r = 0.5) {
  e.origin = r, e.originPoint = St(t.min, t.max, e.origin), e.scale = Kn(n) / Kn(t), e.translate = St(n.min, n.max, e.origin) - e.originPoint, (e.scale >= j8 && e.scale <= F8 || isNaN(e.scale)) && (e.scale = 1), (e.translate >= z8 && e.translate <= L8 || isNaN(e.translate)) && (e.translate = 0);
}
function au(e, t, n, r) {
  U_(e.x, t.x, n.x, r ? r.originX : void 0), U_(e.y, t.y, n.y, r ? r.originY : void 0);
}
function q_(e, t, n, r = 0) {
  const i = r ? St(n.min, n.max, r) : n.min;
  e.min = i + t.min, e.max = e.min + Kn(t);
}
function B8(e, t, n, r) {
  q_(e.x, t.x, n.x, r?.x), q_(e.y, t.y, n.y, r?.y);
}
function H_(e, t, n, r = 0) {
  const i = r ? St(n.min, n.max, r) : n.min;
  e.min = t.min - i, e.max = e.min + Kn(t);
}
function ed(e, t, n, r) {
  H_(e.x, t.x, n.x, r?.x), H_(e.y, t.y, n.y, r?.y);
}
function W_(e, t, n, r, i) {
  return e -= t, e = Xf(e, 1 / n, r), i !== void 0 && (e = Xf(e, 1 / i, r)), e;
}
function K8(e, t = 0, n = 1, r = 0.5, i, o = e, a = e) {
  if (Ti.test(t) && (t = parseFloat(t), t = St(a.min, a.max, t / 100) - a.min), typeof t != "number")
    return;
  let s = St(o.min, o.max, r);
  e === o && (s -= t), e.min = W_(e.min, t, n, s, i), e.max = W_(e.max, t, n, s, i);
}
function Z_(e, t, [n, r, i], o, a) {
  K8(e, t[n], t[r], t[i], t.scale, o, a);
}
const U8 = ["x", "scaleX", "originX"], q8 = ["y", "scaleY", "originY"];
function G_(e, t, n, r) {
  Z_(e.x, t, U8, n ? n.x : void 0, r ? r.x : void 0), Z_(e.y, t, q8, n ? n.y : void 0, r ? r.y : void 0);
}
function Y_(e) {
  return e.translate === 0 && e.scale === 1;
}
function pT(e) {
  return Y_(e.x) && Y_(e.y);
}
function Q_(e, t) {
  return e.min === t.min && e.max === t.max;
}
function H8(e, t) {
  return Q_(e.x, t.x) && Q_(e.y, t.y);
}
function J_(e, t) {
  return Math.round(e.min) === Math.round(t.min) && Math.round(e.max) === Math.round(t.max);
}
function hT(e, t) {
  return J_(e.x, t.x) && J_(e.y, t.y);
}
function X_(e) {
  return Kn(e.x) / Kn(e.y);
}
function ew(e, t) {
  return e.translate === t.translate && e.scale === t.scale && e.originPoint === t.originPoint;
}
function yi(e) {
  return [e("x"), e("y")];
}
function W8(e, t, n) {
  let r = "";
  const i = e.x.translate / t.x, o = e.y.translate / t.y, a = n?.z || 0;
  if ((i || o || a) && (r = `translate3d(${i}px, ${o}px, ${a}px) `), (t.x !== 1 || t.y !== 1) && (r += `scale(${1 / t.x}, ${1 / t.y}) `), n) {
    const { transformPerspective: u, rotate: c, pathRotation: f, rotateX: d, rotateY: p, skewX: h, skewY: v } = n;
    u && (r = `perspective(${u}px) ${r}`), c && (r += `rotate(${c}deg) `), f && (r += `rotate(${f}deg) `), d && (r += `rotateX(${d}deg) `), p && (r += `rotateY(${p}deg) `), h && (r += `skewX(${h}deg) `), v && (r += `skewY(${v}deg) `);
  }
  const s = e.x.scale * t.x, l = e.y.scale * t.y;
  return (s !== 1 || l !== 1) && (r += `scale(${s}, ${l})`), r || "none";
}
const mT = [
  "borderTopLeftRadius",
  "borderTopRightRadius",
  "borderBottomLeftRadius",
  "borderBottomRightRadius"
], Z8 = mT.length, tw = (e) => typeof e == "string" ? parseFloat(e) : e, nw = (e) => typeof e == "number" || Re.test(e);
function G8(e, t, n, r, i, o) {
  i ? (e.opacity = St(0, n.opacity ?? 1, Y8(r)), e.opacityExit = St(t.opacity ?? 1, 0, Q8(r))) : o && (e.opacity = St(t.opacity ?? 1, n.opacity ?? 1, r));
  for (let a = 0; a < Z8; a++) {
    const s = mT[a];
    let l = rw(t, s), u = rw(n, s);
    if (l === void 0 && u === void 0)
      continue;
    l || (l = 0), u || (u = 0), l === 0 || u === 0 || nw(l) === nw(u) ? (e[s] = Math.max(St(tw(l), tw(u), r), 0), (Ti.test(u) || Ti.test(l)) && (e[s] += "%")) : e[s] = u;
  }
  (t.rotate || n.rotate) && (e.rotate = St(t.rotate || 0, n.rotate || 0, r));
}
function rw(e, t) {
  return e[t] !== void 0 ? e[t] : e.borderRadius;
}
const Y8 = /* @__PURE__ */ vT(0, 0.5, sk), Q8 = /* @__PURE__ */ vT(0.5, 0.95, Mr);
function vT(e, t, n) {
  return (r) => r < e ? 0 : r > t ? 1 : n(/* @__PURE__ */ _u(e, t, r));
}
function J8(e, t, n) {
  const r = $n(e) ? e : Ms(e);
  return r.start(zy("", r, t, n)), r.animation;
}
function Eu(e, t, n, r = { passive: !0 }) {
  return e.addEventListener(t, n, r), () => e.removeEventListener(t, n, r);
}
const X8 = (e, t) => e.depth - t.depth;
class ej {
  constructor() {
    this.children = [], this.isDirty = !1;
  }
  add(t) {
    ky(this.children, t), this.isDirty = !0;
  }
  remove(t) {
    Hf(this.children, t), this.isDirty = !0;
  }
  forEach(t) {
    this.isDirty && this.children.sort(X8), this.isDirty = !1, this.children.forEach(t);
  }
}
function tj(e, t) {
  const n = Bn.now(), r = ({ timestamp: i }) => {
    const o = i - n;
    o >= t && (To(r), e(o - t));
  };
  return _t.setup(r, !0), () => To(r);
}
function wf(e) {
  return $n(e) ? e.get() : e;
}
class nj {
  constructor() {
    this.members = [];
  }
  add(t) {
    ky(this.members, t);
    for (let n = this.members.length - 1; n >= 0; n--) {
      const r = this.members[n];
      if (r === t || r === this.lead || r === this.prevLead)
        continue;
      const i = r.instance;
      (!i || i.isConnected === !1) && !r.snapshot && (Hf(this.members, r), r.unmount());
    }
    t.scheduleRender();
  }
  remove(t) {
    if (Hf(this.members, t), t === this.prevLead && (this.prevLead = void 0), t === this.lead) {
      const n = this.members[this.members.length - 1];
      n && this.promote(n);
    }
  }
  relegate(t) {
    for (let n = this.members.indexOf(t) - 1; n >= 0; n--) {
      const r = this.members[n];
      if (r.isPresent !== !1 && r.instance?.isConnected !== !1)
        return this.promote(r), !0;
    }
    return !1;
  }
  promote(t, n) {
    const r = this.lead;
    if (t !== r && (this.prevLead = r, this.lead = t, t.show(), r)) {
      r.updateSnapshot(), t.scheduleRender();
      const { layoutDependency: i } = r.options, { layoutDependency: o } = t.options;
      (i === void 0 || i !== o) && (t.resumeFrom = r, n && (r.preserveOpacity = !0), r.snapshot && (t.snapshot = r.snapshot, t.snapshot.latestValues = r.animationValues || r.latestValues), t.root?.isUpdating && (t.isLayoutDirty = !0)), t.options.crossfade === !1 && r.hide();
    }
  }
  exitAnimationComplete() {
    this.members.forEach((t) => {
      t.options.onExitComplete?.(), t.resumingFrom?.options.onExitComplete?.();
    });
  }
  scheduleRender() {
    this.members.forEach((t) => t.instance && t.scheduleRender(!1));
  }
  removeLeadSnapshot() {
    this.lead?.snapshot && (this.lead.snapshot = void 0);
  }
}
const xf = {
  /**
   * Global flag as to whether the tree has animated since the last time
   * we resized the window
   */
  hasAnimatedSinceResize: !0,
  /**
   * We set this to true once, on the first update. Any nodes added to the tree beyond that
   * update will be given a `data-projection-id` attribute.
   */
  hasEverUpdated: !1
}, Ph = ["", "X", "Y", "Z"], rj = 1e3;
let ij = 0;
function Ah(e, t, n, r) {
  const { latestValues: i } = t;
  i[e] && (n[e] = i[e], t.setStaticValue(e, 0), r && (r[e] = 0));
}
function gT(e) {
  if (e.hasCheckedOptimisedAppear = !0, e.root === e)
    return;
  const { visualElement: t } = e.options;
  if (!t)
    return;
  const n = Fk(t);
  if (window.MotionHasOptimisedAnimation(n, "transform")) {
    const { layout: i, layoutId: o } = e.options;
    window.MotionCancelOptimisedAnimation(n, "transform", _t, !(i || o));
  }
  const { parent: r } = e;
  r && !r.hasCheckedOptimisedAppear && gT(r);
}
function yT({ attachResizeListener: e, defaultParent: t, measureScroll: n, checkIsScrollRoot: r, resetTransform: i }) {
  return class {
    constructor(a = {}, s = t?.()) {
      this.id = ij++, this.animationId = 0, this.animationCommitId = 0, this.children = /* @__PURE__ */ new Set(), this.options = {}, this.isTreeAnimating = !1, this.isAnimationBlocked = !1, this.isLayoutDirty = !1, this.isProjectionDirty = !1, this.isSharedProjectionDirty = !1, this.isTransformDirty = !1, this.updateManuallyBlocked = !1, this.updateBlockedByResize = !1, this.isUpdating = !1, this.isSVG = !1, this.needsReset = !1, this.shouldResetTransform = !1, this.hasCheckedOptimisedAppear = !1, this.treeScale = { x: 1, y: 1 }, this.eventHandlers = /* @__PURE__ */ new Map(), this.hasTreeAnimated = !1, this.layoutVersion = 0, this.updateScheduled = !1, this.scheduleUpdate = () => this.update(), this.projectionUpdateScheduled = !1, this.checkUpdateFailed = () => {
        this.isUpdating && (this.isUpdating = !1, this.clearAllSnapshots());
      }, this.updateProjection = () => {
        this.projectionUpdateScheduled = !1, this.nodes.forEach(sj), this.nodes.forEach(pj), this.nodes.forEach(hj), this.nodes.forEach(lj);
      }, this.resolvedRelativeTargetAt = 0, this.linkedParentVersion = 0, this.hasProjected = !1, this.isVisible = !0, this.animationProgress = 0, this.sharedNodes = /* @__PURE__ */ new Map(), this.latestValues = a, this.root = s ? s.root || s : this, this.path = s ? [...s.path, s] : [], this.parent = s, this.depth = s ? s.depth + 1 : 0;
      for (let l = 0; l < this.path.length; l++)
        this.path[l].shouldResetTransform = !0;
      this.root === this && (this.nodes = new ej());
    }
    addEventListener(a, s) {
      return this.eventHandlers.has(a) || this.eventHandlers.set(a, new Ty()), this.eventHandlers.get(a).add(s);
    }
    notifyListeners(a, ...s) {
      const l = this.eventHandlers.get(a);
      l && l.notify(...s);
    }
    hasListeners(a) {
      return this.eventHandlers.has(a);
    }
    /**
     * Lifecycles
     */
    mount(a) {
      if (this.instance)
        return;
      this.isSVG = Uy(a) && !a8(a), this.instance = a;
      const { layoutId: s, layout: l, visualElement: u } = this.options;
      if (u && !u.current && u.mount(a), this.root.nodes.add(this), this.parent && this.parent.children.add(this), this.root.hasTreeAnimated && (l || s) && (this.isLayoutDirty = !0), e) {
        let c, f = 0;
        const d = () => this.root.updateBlockedByResize = !1;
        _t.read(() => {
          f = window.innerWidth;
        }), e(a, () => {
          const p = window.innerWidth;
          p !== f && (f = p, this.root.updateBlockedByResize = !0, c && c(), c = tj(d, 250), xf.hasAnimatedSinceResize && (xf.hasAnimatedSinceResize = !1, this.nodes.forEach(aw)));
        });
      }
      s && this.root.registerSharedNode(s, this), this.options.animate !== !1 && u && (s || l) && this.addEventListener("didUpdate", ({ delta: c, hasLayoutChanged: f, hasRelativeLayoutChanged: d, layout: p }) => {
        if (this.isTreeAnimationBlocked()) {
          this.target = void 0, this.relativeTarget = void 0;
          return;
        }
        const h = this.options.transition || u.getDefaultTransition() || bj, { onLayoutAnimationStart: v, onLayoutAnimationComplete: m } = u.getProps(), g = !this.targetLayout || !hT(this.targetLayout, p), _ = !f && d;
        if (this.options.layoutRoot || this.resumeFrom || _ || f && (g || !this.currentAnimation)) {
          this.resumeFrom && (this.resumingFrom = this.resumeFrom, this.resumingFrom.resumingFrom = void 0);
          const x = {
            ...Fy(h, "layout"),
            onPlay: v,
            onComplete: m
          };
          (u.shouldReduceMotion || this.options.layoutRoot) && (x.delay = 0, x.type = !1), this.startAnimation(x), this.setAnimationOrigin(c, _, x.path);
        } else
          f || aw(this), this.isLead() && this.options.onExitComplete && this.options.onExitComplete();
        this.targetLayout = p;
      });
    }
    unmount() {
      this.options.layoutId && this.willUpdate(), this.root.nodes.remove(this);
      const a = this.getStack();
      a && a.remove(this), this.parent && this.parent.children.delete(this), this.instance = void 0, this.eventHandlers.clear(), To(this.updateProjection);
    }
    // only on the root
    blockUpdate() {
      this.updateManuallyBlocked = !0;
    }
    unblockUpdate() {
      this.updateManuallyBlocked = !1;
    }
    isUpdateBlocked() {
      return this.updateManuallyBlocked || this.updateBlockedByResize;
    }
    isTreeAnimationBlocked() {
      return this.isAnimationBlocked || this.parent && this.parent.isTreeAnimationBlocked() || !1;
    }
    // Note: currently only running on root node
    startUpdate() {
      this.isUpdateBlocked() || (this.isUpdating = !0, this.nodes && this.nodes.forEach(mj), this.animationId++);
    }
    getTransformTemplate() {
      const { visualElement: a } = this.options;
      return a && a.getProps().transformTemplate;
    }
    willUpdate(a = !0) {
      if (this.root.hasTreeAnimated = !0, this.root.isUpdateBlocked()) {
        this.options.onExitComplete && this.options.onExitComplete();
        return;
      }
      if (window.MotionCancelOptimisedAnimation && !this.hasCheckedOptimisedAppear && gT(this), !this.root.isUpdating && this.root.startUpdate(), this.isLayoutDirty)
        return;
      this.isLayoutDirty = !0;
      for (let c = 0; c < this.path.length; c++) {
        const f = this.path[c];
        f.shouldResetTransform = !0, (typeof f.latestValues.x == "string" || typeof f.latestValues.y == "string") && (f.isLayoutDirty = !0), f.updateScroll("snapshot"), f.options.layoutRoot && f.willUpdate(!1);
      }
      const { layoutId: s, layout: l } = this.options;
      if (s === void 0 && !l)
        return;
      const u = this.getTransformTemplate();
      this.prevTransformTemplateValue = u ? u(this.latestValues, "") : void 0, this.updateSnapshot(), a && this.notifyListeners("willUpdate");
    }
    update() {
      if (this.updateScheduled = !1, this.isUpdateBlocked()) {
        const l = this.updateBlockedByResize;
        this.unblockUpdate(), this.updateBlockedByResize = !1, this.clearAllSnapshots(), l && this.nodes.forEach(cj), this.nodes.forEach(iw);
        return;
      }
      if (this.animationId <= this.animationCommitId) {
        this.nodes.forEach(ow);
        return;
      }
      this.animationCommitId = this.animationId, this.isUpdating ? (this.isUpdating = !1, this.nodes.forEach(fj), this.nodes.forEach(dj), this.nodes.forEach(oj), this.nodes.forEach(aj)) : this.nodes.forEach(ow), this.clearAllSnapshots();
      const s = Bn.now();
      En.delta = Ai(0, 1e3 / 60, s - En.timestamp), En.timestamp = s, En.isProcessing = !0, wh.update.process(En), wh.preRender.process(En), wh.render.process(En), En.isProcessing = !1;
    }
    didUpdate() {
      this.updateScheduled || (this.updateScheduled = !0, By.read(this.scheduleUpdate));
    }
    clearAllSnapshots() {
      this.nodes.forEach(uj), this.sharedNodes.forEach(vj);
    }
    scheduleUpdateProjection() {
      this.projectionUpdateScheduled || (this.projectionUpdateScheduled = !0, _t.preRender(this.updateProjection, !1, !0));
    }
    scheduleCheckAfterUnmount() {
      _t.postRender(() => {
        this.isLayoutDirty ? this.root.didUpdate() : this.root.checkUpdateFailed();
      });
    }
    /**
     * Update measurements
     */
    updateSnapshot() {
      this.snapshot || !this.instance || (this.snapshot = this.measure(), this.snapshot && !Kn(this.snapshot.measuredBox.x) && !Kn(this.snapshot.measuredBox.y) && (this.snapshot = void 0));
    }
    updateLayout() {
      if (!this.instance || (this.updateScroll(), !(this.options.alwaysMeasureLayout && this.isLead()) && !this.isLayoutDirty))
        return;
      if (this.resumeFrom && !this.resumeFrom.instance)
        for (let l = 0; l < this.path.length; l++)
          this.path[l].updateScroll();
      const a = this.layout;
      this.layout = this.measure(!1), this.layoutVersion++, this.layoutCorrected || (this.layoutCorrected = pn()), this.isLayoutDirty = !1, this.projectionDelta = void 0, this.notifyListeners("measure", this.layout.layoutBox);
      const { visualElement: s } = this.options;
      s && s.notify("LayoutMeasure", this.layout.layoutBox, a ? a.layoutBox : void 0);
    }
    updateScroll(a = "measure") {
      let s = !!(this.options.layoutScroll && this.instance);
      if (this.scroll && this.scroll.animationId === this.root.animationId && this.scroll.phase === a && (s = !1), s && this.instance) {
        const l = r(this.instance);
        this.scroll = {
          animationId: this.root.animationId,
          phase: a,
          isRoot: l,
          offset: n(this.instance),
          wasRoot: this.scroll ? this.scroll.isRoot : l
        };
      }
    }
    resetTransform() {
      if (!i)
        return;
      const a = this.isLayoutDirty || this.shouldResetTransform || this.options.alwaysMeasureLayout, s = this.projectionDelta && !pT(this.projectionDelta), l = this.getTransformTemplate(), u = l ? l(this.latestValues, "") : void 0, c = u !== this.prevTransformTemplateValue;
      a && this.instance && (s || Xo(this.latestValues) || c) && (i(this.instance, u), this.shouldResetTransform = !1, this.scheduleRender());
    }
    measure(a = !0) {
      const s = this.measurePageBox();
      let l = this.removeElementScroll(s);
      return a && (l = this.removeTransform(l)), _j(l), {
        animationId: this.root.animationId,
        measuredBox: s,
        layoutBox: l,
        latestValues: {},
        source: this.id
      };
    }
    measurePageBox() {
      const { visualElement: a } = this.options;
      if (!a)
        return pn();
      const s = a.measureViewportBox();
      if (!(this.scroll?.wasRoot || this.path.some(wj))) {
        const { scroll: u } = this.root;
        u && (wi(s.x, u.offset.x), wi(s.y, u.offset.y));
      }
      return s;
    }
    removeElementScroll(a) {
      const s = pn();
      if (Hr(s, a), this.scroll?.wasRoot)
        return s;
      for (let l = 0; l < this.path.length; l++) {
        const u = this.path[l], { scroll: c, options: f } = u;
        u !== this.root && c && f.layoutScroll && (c.wasRoot && Hr(s, a), wi(s.x, c.offset.x), wi(s.y, c.offset.y));
      }
      return s;
    }
    applyTransform(a, s = !1, l) {
      const u = l || pn();
      Hr(u, a);
      for (let c = 0; c < this.path.length; c++) {
        const f = this.path[c];
        !s && f.options.layoutScroll && f.scroll && f !== f.root && (wi(u.x, -f.scroll.offset.x), wi(u.y, -f.scroll.offset.y)), Xo(f.latestValues) && _f(u, f.latestValues, f.layout?.layoutBox);
      }
      return Xo(this.latestValues) && _f(u, this.latestValues, this.layout?.layoutBox), u;
    }
    removeTransform(a) {
      const s = pn();
      Hr(s, a);
      for (let l = 0; l < this.path.length; l++) {
        const u = this.path[l];
        if (!Xo(u.latestValues))
          continue;
        let c;
        u.instance && (Ov(u.latestValues) && u.updateSnapshot(), c = pn(), Hr(c, u.measurePageBox())), G_(s, u.latestValues, u.snapshot?.layoutBox, c);
      }
      return Xo(this.latestValues) && G_(s, this.latestValues), s;
    }
    setTargetDelta(a) {
      this.targetDelta = a, this.root.scheduleUpdateProjection(), this.isProjectionDirty = !0;
    }
    setOptions(a) {
      this.options = {
        ...this.options,
        ...a,
        crossfade: a.crossfade !== void 0 ? a.crossfade : !0
      };
    }
    clearMeasurements() {
      this.scroll = void 0, this.layout = void 0, this.snapshot = void 0, this.prevTransformTemplateValue = void 0, this.targetDelta = void 0, this.target = void 0, this.isLayoutDirty = !1;
    }
    forceRelativeParentToResolveTarget() {
      this.relativeParent && this.relativeParent.resolvedRelativeTargetAt !== En.timestamp && this.relativeParent.resolveTargetDelta(!0);
    }
    resolveTargetDelta(a = !1) {
      const s = this.getLead();
      this.isProjectionDirty || (this.isProjectionDirty = s.isProjectionDirty), this.isTransformDirty || (this.isTransformDirty = s.isTransformDirty), this.isSharedProjectionDirty || (this.isSharedProjectionDirty = s.isSharedProjectionDirty);
      const l = !!this.resumingFrom || this !== s;
      if (!(a || l && this.isSharedProjectionDirty || this.isProjectionDirty || this.parent?.isProjectionDirty || this.attemptToResolveRelativeTarget || this.root.updateBlockedByResize))
        return;
      const { layout: c, layoutId: f } = this.options;
      if (!this.layout || !(c || f))
        return;
      this.resolvedRelativeTargetAt = En.timestamp;
      const d = this.getClosestProjectingParent();
      d && this.linkedParentVersion !== d.layoutVersion && !d.options.layoutRoot && this.removeRelativeTarget(), !this.targetDelta && !this.relativeTarget && (this.options.layoutAnchor !== !1 && d && d.layout ? this.createRelativeTarget(d, this.layout.layoutBox, d.layout.layoutBox) : this.removeRelativeTarget()), !(!this.relativeTarget && !this.targetDelta) && (this.target || (this.target = pn(), this.targetWithTransforms = pn()), this.relativeTarget && this.relativeTargetOrigin && this.relativeParent && this.relativeParent.target ? (this.forceRelativeParentToResolveTarget(), B8(this.target, this.relativeTarget, this.relativeParent.target, this.options.layoutAnchor || void 0)) : this.targetDelta ? (this.resumingFrom ? this.applyTransform(this.layout.layoutBox, !1, this.target) : Hr(this.target, this.layout.layoutBox), tT(this.target, this.targetDelta)) : Hr(this.target, this.layout.layoutBox), this.attemptToResolveRelativeTarget && (this.attemptToResolveRelativeTarget = !1, this.options.layoutAnchor !== !1 && d && !!d.resumingFrom == !!this.resumingFrom && !d.options.layoutScroll && d.target && this.animationProgress !== 1 ? this.createRelativeTarget(d, this.target, d.target) : this.relativeParent = this.relativeTarget = void 0));
    }
    getClosestProjectingParent() {
      if (!(!this.parent || Ov(this.parent.latestValues) || eT(this.parent.latestValues)))
        return this.parent.isProjecting() ? this.parent : this.parent.getClosestProjectingParent();
    }
    isProjecting() {
      return !!((this.relativeTarget || this.targetDelta || this.options.layoutRoot) && this.layout);
    }
    createRelativeTarget(a, s, l) {
      this.relativeParent = a, this.linkedParentVersion = a.layoutVersion, this.forceRelativeParentToResolveTarget(), this.relativeTarget = pn(), this.relativeTargetOrigin = pn(), ed(this.relativeTargetOrigin, s, l, this.options.layoutAnchor || void 0), Hr(this.relativeTarget, this.relativeTargetOrigin);
    }
    removeRelativeTarget() {
      this.relativeParent = this.relativeTarget = void 0;
    }
    calcProjection() {
      const a = this.getLead(), s = !!this.resumingFrom || this !== a;
      let l = !0;
      if ((this.isProjectionDirty || this.parent?.isProjectionDirty) && (l = !1), s && (this.isSharedProjectionDirty || this.isTransformDirty) && (l = !1), this.resolvedRelativeTargetAt === En.timestamp && (l = !1), l)
        return;
      const { layout: u, layoutId: c } = this.options;
      if (this.isTreeAnimating = !!(this.parent && this.parent.isTreeAnimating || this.currentAnimation || this.pendingAnimation), this.isTreeAnimating || (this.targetDelta = this.relativeTarget = void 0), !this.layout || !(u || c))
        return;
      Hr(this.layoutCorrected, this.layout.layoutBox);
      const f = this.treeScale.x, d = this.treeScale.y;
      g8(this.layoutCorrected, this.treeScale, this.path, s), a.layout && !a.target && (this.treeScale.x !== 1 || this.treeScale.y !== 1) && (a.target = a.layout.layoutBox, a.targetWithTransforms = pn());
      const { target: p } = a;
      if (!p) {
        this.prevProjectionDelta && (this.createProjectionDeltas(), this.scheduleRender());
        return;
      }
      !this.projectionDelta || !this.prevProjectionDelta ? this.createProjectionDeltas() : (K_(this.prevProjectionDelta.x, this.projectionDelta.x), K_(this.prevProjectionDelta.y, this.projectionDelta.y)), au(this.projectionDelta, this.layoutCorrected, p, this.latestValues), (this.treeScale.x !== f || this.treeScale.y !== d || !ew(this.projectionDelta.x, this.prevProjectionDelta.x) || !ew(this.projectionDelta.y, this.prevProjectionDelta.y)) && (this.hasProjected = !0, this.scheduleRender(), this.notifyListeners("projectionUpdate", p));
    }
    hide() {
      this.isVisible = !1;
    }
    show() {
      this.isVisible = !0;
    }
    scheduleRender(a = !0) {
      if (this.options.visualElement?.scheduleRender(), a) {
        const s = this.getStack();
        s && s.scheduleRender();
      }
      this.resumingFrom && !this.resumingFrom.instance && (this.resumingFrom = void 0);
    }
    createProjectionDeltas() {
      this.prevProjectionDelta = cs(), this.projectionDelta = cs(), this.projectionDeltaWithTransform = cs();
    }
    setAnimationOrigin(a, s = !1, l) {
      const u = this.snapshot, c = u ? u.latestValues : {}, f = { ...this.latestValues }, d = cs();
      (!this.relativeParent || !this.relativeParent.options.layoutRoot) && (this.relativeTarget = this.relativeTargetOrigin = void 0), this.attemptToResolveRelativeTarget = !s;
      const p = pn(), h = u ? u.source : void 0, v = this.layout ? this.layout.source : void 0, m = h !== v, g = this.getStack(), _ = !g || g.members.length <= 1, x = !!(m && !_ && this.options.crossfade === !0 && !this.path.some(yj));
      this.animationProgress = 0;
      let w;
      const $ = l?.interpolateProjection(a);
      this.mixTargetDelta = (k) => {
        const D = k / 1e3, E = $?.(D);
        E ? (d.x.translate = E.x, d.x.scale = St(a.x.scale, 1, D), d.x.origin = a.x.origin, d.x.originPoint = a.x.originPoint, d.y.translate = E.y, d.y.scale = St(a.y.scale, 1, D), d.y.origin = a.y.origin, d.y.originPoint = a.y.originPoint) : (sw(d.x, a.x, D), sw(d.y, a.y, D)), this.setTargetDelta(d), this.relativeTarget && this.relativeTargetOrigin && this.layout && this.relativeParent && this.relativeParent.layout && (ed(p, this.layout.layoutBox, this.relativeParent.layout.layoutBox, this.options.layoutAnchor || void 0), gj(this.relativeTarget, this.relativeTargetOrigin, p, D), w && H8(this.relativeTarget, w) && (this.isProjectionDirty = !1), w || (w = pn()), Hr(w, this.relativeTarget)), m && (this.animationValues = f, G8(f, c, this.latestValues, D, x, _)), E && E.rotate !== void 0 && (this.animationValues || (this.animationValues = f), this.animationValues.pathRotation = E.rotate), this.root.scheduleUpdateProjection(), this.scheduleRender(), this.animationProgress = D;
      }, this.mixTargetDelta(this.options.layoutRoot ? 1e3 : 0);
    }
    startAnimation(a) {
      this.notifyListeners("animationStart"), this.currentAnimation?.stop(), this.resumingFrom?.currentAnimation?.stop(), this.pendingAnimation && (To(this.pendingAnimation), this.pendingAnimation = void 0), this.pendingAnimation = _t.update(() => {
        xf.hasAnimatedSinceResize = !0, this.motionValue || (this.motionValue = Ms(0)), this.motionValue.jump(0, !1), this.currentAnimation = J8(this.motionValue, [0, 1e3], {
          ...a,
          velocity: 0,
          isSync: !0,
          onUpdate: (s) => {
            this.mixTargetDelta(s), a.onUpdate && a.onUpdate(s);
          },
          onComplete: () => {
            a.onComplete && a.onComplete(), this.completeAnimation();
          }
        }), this.resumingFrom && (this.resumingFrom.currentAnimation = this.currentAnimation), this.pendingAnimation = void 0;
      });
    }
    completeAnimation() {
      this.resumingFrom && (this.resumingFrom.currentAnimation = void 0, this.resumingFrom.preserveOpacity = void 0);
      const a = this.getStack();
      a && a.exitAnimationComplete(), this.resumingFrom = this.currentAnimation = this.animationValues = void 0, this.notifyListeners("animationComplete");
    }
    finishAnimation() {
      this.currentAnimation && (this.mixTargetDelta && this.mixTargetDelta(rj), this.currentAnimation.stop()), this.completeAnimation();
    }
    applyTransformsToTarget() {
      const a = this.getLead();
      let { targetWithTransforms: s, target: l, layout: u, latestValues: c } = a;
      if (!(!s || !l || !u)) {
        if (this !== a && this.layout && u && bT(this.options.animationType, this.layout.layoutBox, u.layoutBox)) {
          l = this.target || pn();
          const f = Kn(this.layout.layoutBox.x);
          l.x.min = a.target.x.min, l.x.max = l.x.min + f;
          const d = Kn(this.layout.layoutBox.y);
          l.y.min = a.target.y.min, l.y.max = l.y.min + d;
        }
        Hr(s, l), _f(s, c), au(this.projectionDeltaWithTransform, this.layoutCorrected, s, c);
      }
    }
    registerSharedNode(a, s) {
      this.sharedNodes.has(a) || this.sharedNodes.set(a, new nj()), this.sharedNodes.get(a).add(s);
      const u = s.options.initialPromotionConfig;
      s.promote({
        transition: u ? u.transition : void 0,
        preserveFollowOpacity: u && u.shouldPreserveFollowOpacity ? u.shouldPreserveFollowOpacity(s) : void 0
      });
    }
    isLead() {
      const a = this.getStack();
      return a ? a.lead === this : !0;
    }
    getLead() {
      const { layoutId: a } = this.options;
      return a ? this.getStack()?.lead || this : this;
    }
    getPrevLead() {
      const { layoutId: a } = this.options;
      return a ? this.getStack()?.prevLead : void 0;
    }
    getStack() {
      const { layoutId: a } = this.options;
      if (a)
        return this.root.sharedNodes.get(a);
    }
    promote({ needsReset: a, transition: s, preserveFollowOpacity: l } = {}) {
      const u = this.getStack();
      u && u.promote(this, l), a && (this.projectionDelta = void 0, this.needsReset = !0), s && this.setOptions({ transition: s });
    }
    relegate() {
      const a = this.getStack();
      return a ? a.relegate(this) : !1;
    }
    resetSkewAndRotation() {
      const { visualElement: a } = this.options;
      if (!a)
        return;
      let s = !1;
      const { latestValues: l } = a;
      if ((l.z || l.rotate || l.rotateX || l.rotateY || l.rotateZ || l.skewX || l.skewY) && (s = !0), !s)
        return;
      const u = {};
      l.z && Ah("z", a, u, this.animationValues);
      for (let c = 0; c < Ph.length; c++)
        Ah(`rotate${Ph[c]}`, a, u, this.animationValues), Ah(`skew${Ph[c]}`, a, u, this.animationValues);
      a.render();
      for (const c in u)
        a.setStaticValue(c, u[c]), this.animationValues && (this.animationValues[c] = u[c]);
      a.scheduleRender();
    }
    applyProjectionStyles(a, s) {
      if (!this.instance || this.isSVG)
        return;
      if (!this.isVisible) {
        a.visibility = "hidden";
        return;
      }
      const l = this.getTransformTemplate();
      if (this.needsReset) {
        this.needsReset = !1, a.visibility = "", a.opacity = "", a.pointerEvents = wf(s?.pointerEvents) || "", a.transform = l ? l(this.latestValues, "") : "none";
        return;
      }
      const u = this.getLead();
      if (!this.projectionDelta || !this.layout || !u.target) {
        this.options.layoutId && (a.opacity = this.latestValues.opacity !== void 0 ? this.latestValues.opacity : 1, a.pointerEvents = wf(s?.pointerEvents) || ""), this.hasProjected && !Xo(this.latestValues) && (a.transform = l ? l({}, "") : "none", this.hasProjected = !1);
        return;
      }
      a.visibility = "";
      const c = u.animationValues || u.latestValues;
      this.applyTransformsToTarget();
      let f = W8(this.projectionDeltaWithTransform, this.treeScale, c);
      l && (f = l(c, f)), a.transform = f;
      const { x: d, y: p } = this.projectionDelta;
      a.transformOrigin = `${d.origin * 100}% ${p.origin * 100}% 0`, u.animationValues ? a.opacity = u === this ? c.opacity ?? this.latestValues.opacity ?? 1 : this.preserveOpacity ? this.latestValues.opacity : c.opacityExit : a.opacity = u === this ? c.opacity !== void 0 ? c.opacity : "" : c.opacityExit !== void 0 ? c.opacityExit : 0;
      for (const h in Av) {
        if (c[h] === void 0)
          continue;
        const { correct: v, applyTo: m, isCSSVariable: g } = Av[h], _ = f === "none" ? c[h] : v(c[h], u);
        if (m) {
          const x = m.length;
          for (let w = 0; w < x; w++)
            a[m[w]] = _;
        } else
          g ? this.options.visualElement.renderState.vars[h] = _ : a[h] = _;
      }
      this.options.layoutId && (a.pointerEvents = u === this ? wf(s?.pointerEvents) || "" : "none");
    }
    clearSnapshot() {
      this.resumeFrom = this.snapshot = void 0;
    }
    // Only run on root
    resetTree() {
      this.root.nodes.forEach((a) => a.currentAnimation?.stop()), this.root.nodes.forEach(iw), this.root.sharedNodes.clear();
    }
  };
}
function oj(e) {
  e.updateLayout();
}
function aj(e) {
  const t = e.resumeFrom?.snapshot || e.snapshot;
  if (e.isLead() && e.layout && t && e.hasListeners("didUpdate")) {
    const { layoutBox: n, measuredBox: r } = e.layout, { animationType: i } = e.options, o = t.source !== e.layout.source;
    if (i === "size")
      yi((c) => {
        const f = o ? t.measuredBox[c] : t.layoutBox[c], d = Kn(f);
        f.min = n[c].min, f.max = f.min + d;
      });
    else if (i === "x" || i === "y") {
      const c = i === "x" ? "y" : "x";
      Dv(o ? t.measuredBox[c] : t.layoutBox[c], n[c]);
    } else bT(i, t.layoutBox, n) && yi((c) => {
      const f = o ? t.measuredBox[c] : t.layoutBox[c], d = Kn(n[c]);
      f.max = f.min + d, e.relativeTarget && !e.currentAnimation && (e.isProjectionDirty = !0, e.relativeTarget[c].max = e.relativeTarget[c].min + d);
    });
    const a = cs();
    au(a, n, t.layoutBox);
    const s = cs();
    o ? au(s, e.applyTransform(r, !0), t.measuredBox) : au(s, n, t.layoutBox);
    const l = !pT(a);
    let u = !1;
    if (!e.resumeFrom) {
      const c = e.getClosestProjectingParent();
      if (c && !c.resumeFrom) {
        const { snapshot: f, layout: d } = c;
        if (f && d) {
          const p = e.options.layoutAnchor || void 0, h = pn();
          ed(h, t.layoutBox, f.layoutBox, p);
          const v = pn();
          ed(v, n, d.layoutBox, p), hT(h, v) || (u = !0), c.options.layoutRoot && (e.relativeTarget = v, e.relativeTargetOrigin = h, e.relativeParent = c);
        }
      }
    }
    e.notifyListeners("didUpdate", {
      layout: n,
      snapshot: t,
      delta: s,
      layoutDelta: a,
      hasLayoutChanged: l,
      hasRelativeLayoutChanged: u
    });
  } else if (e.isLead()) {
    const { onExitComplete: n } = e.options;
    n && n();
  }
  e.options.transition = void 0;
}
function sj(e) {
  e.parent && (e.isProjecting() || (e.isProjectionDirty = e.parent.isProjectionDirty), e.isSharedProjectionDirty || (e.isSharedProjectionDirty = !!(e.isProjectionDirty || e.parent.isProjectionDirty || e.parent.isSharedProjectionDirty)), e.isTransformDirty || (e.isTransformDirty = e.parent.isTransformDirty));
}
function lj(e) {
  e.isProjectionDirty = e.isSharedProjectionDirty = e.isTransformDirty = !1;
}
function uj(e) {
  e.clearSnapshot();
}
function iw(e) {
  e.clearMeasurements();
}
function cj(e) {
  e.isLayoutDirty = !0, e.updateLayout();
}
function ow(e) {
  e.isLayoutDirty = !1;
}
function fj(e) {
  e.isAnimationBlocked && e.layout && !e.isLayoutDirty && (e.snapshot = e.layout, e.isLayoutDirty = !0);
}
function dj(e) {
  const { visualElement: t } = e.options;
  t && t.getProps().onBeforeLayoutMeasure && t.notify("BeforeLayoutMeasure"), e.resetTransform();
}
function aw(e) {
  e.finishAnimation(), e.targetDelta = e.relativeTarget = e.target = void 0, e.isProjectionDirty = !0;
}
function pj(e) {
  e.resolveTargetDelta();
}
function hj(e) {
  e.calcProjection();
}
function mj(e) {
  e.resetSkewAndRotation();
}
function vj(e) {
  e.removeLeadSnapshot();
}
function sw(e, t, n) {
  e.translate = St(t.translate, 0, n), e.scale = St(t.scale, 1, n), e.origin = t.origin, e.originPoint = t.originPoint;
}
function lw(e, t, n, r) {
  e.min = St(t.min, n.min, r), e.max = St(t.max, n.max, r);
}
function gj(e, t, n, r) {
  lw(e.x, t.x, n.x, r), lw(e.y, t.y, n.y, r);
}
function yj(e) {
  return e.animationValues && e.animationValues.opacityExit !== void 0;
}
const bj = {
  duration: 0.45,
  ease: [0.4, 0, 0.1, 1]
}, uw = (e) => typeof navigator < "u" && navigator.userAgent && navigator.userAgent.toLowerCase().includes(e), cw = uw("applewebkit/") && !uw("chrome/") ? Math.round : Mr;
function fw(e) {
  e.min = cw(e.min), e.max = cw(e.max);
}
function _j(e) {
  fw(e.x), fw(e.y);
}
function bT(e, t, n) {
  return e === "position" || e === "preserve-aspect" && !V8(X_(t), X_(n), 0.2);
}
function wj(e) {
  return e !== e.root && e.scroll?.wasRoot;
}
const xj = yT({
  attachResizeListener: (e, t) => Eu(e, "resize", t),
  measureScroll: () => ({
    x: document.documentElement.scrollLeft || document.body?.scrollLeft || 0,
    y: document.documentElement.scrollTop || document.body?.scrollTop || 0
  }),
  checkIsScrollRoot: () => !0
}), Ej = (e) => !e.isLayoutDirty && e.willUpdate(!1);
function dw() {
  const e = /* @__PURE__ */ new Set(), t = /* @__PURE__ */ new WeakMap(), n = () => e.forEach(Ej);
  return {
    add: (r) => {
      e.add(r), t.set(r, r.addEventListener("willUpdate", n));
    },
    remove: (r) => {
      e.delete(r);
      const i = t.get(r);
      i && (i(), t.delete(r)), n();
    },
    dirty: n
  };
}
const Dh = {
  current: void 0
}, _T = yT({
  measureScroll: (e) => ({
    x: e.scrollLeft,
    y: e.scrollTop
  }),
  defaultParent: () => {
    if (!Dh.current) {
      const e = new xj({});
      e.mount(window), e.setOptions({ layoutScroll: !0 }), Dh.current = e;
    }
    return Dh.current;
  },
  resetTransform: (e, t) => {
    e.style.transform = t !== void 0 ? t : "none";
  },
  checkIsScrollRoot: (e) => window.getComputedStyle(e).position === "fixed"
}), Gy = He({
  transformPagePoint: (e) => e,
  isStatic: !1,
  reducedMotion: "never"
});
function pw(e, t) {
  if (typeof e == "function")
    return e(t);
  e != null && (e.current = t);
}
function Sj(...e) {
  return (t) => {
    let n = !1;
    const r = e.map((i) => {
      const o = pw(i, t);
      return !n && typeof o == "function" && (n = !0), o;
    });
    if (n)
      return () => {
        for (let i = 0; i < r.length; i++) {
          const o = r[i];
          typeof o == "function" ? o() : pw(e[i], null);
        }
      };
  };
}
function $j(...e) {
  return ee.useCallback(Sj(...e), e);
}
class kj extends ee.Component {
  getSnapshotBeforeUpdate(t) {
    const n = this.props.childRef.current;
    if (mf(n) && t.isPresent && !this.props.isPresent && this.props.pop !== !1) {
      const r = n.offsetParent, i = mf(r) && r.offsetWidth || 0, o = mf(r) && r.offsetHeight || 0, a = getComputedStyle(n), s = this.props.sizeRef.current;
      s.height = parseFloat(a.height), s.width = parseFloat(a.width), s.top = n.offsetTop, s.left = n.offsetLeft, s.right = i - s.width - s.left, s.bottom = o - s.height - s.top, s.direction = a.direction;
    }
    return null;
  }
  /**
   * Required with getSnapshotBeforeUpdate to stop React complaining.
   */
  componentDidUpdate() {
  }
  render() {
    return this.props.children;
  }
}
function Tj({ children: e, isPresent: t, anchorX: n, anchorY: r, root: i, pop: o }) {
  const a = oy(), s = ve(null), l = ve({
    width: 0,
    height: 0,
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    direction: "ltr"
  }), { nonce: u } = je(Gy), c = e.props?.ref ?? e?.ref, f = $j(s, c);
  return ay(() => {
    const { width: d, height: p, top: h, left: v, right: m, bottom: g, direction: _ } = l.current;
    if (t || o === !1 || !s.current || !d || !p)
      return;
    const x = _ === "rtl", w = n === "left" ? x ? `right: ${m}` : `left: ${v}` : x ? `left: ${v}` : `right: ${m}`, $ = r === "bottom" ? `bottom: ${g}` : `top: ${h}`;
    s.current.dataset.motionPopId = a;
    const k = document.createElement("style");
    u && (k.nonce = u);
    const D = i ?? document.head;
    return D.appendChild(k), k.sheet && k.sheet.insertRule(`
          [data-motion-pop-id="${a}"] {
            position: absolute !important;
            width: ${d}px !important;
            height: ${p}px !important;
            ${w}px !important;
            ${$}px !important;
          }
        `), () => {
      s.current?.removeAttribute("data-motion-pop-id"), D.contains(k) && D.removeChild(k);
    };
  }, [t]), I.jsx(kj, { isPresent: t, childRef: s, sizeRef: l, pop: o, children: o === !1 ? e : ee.cloneElement(e, { ref: f }) });
}
const Oj = ({ children: e, initial: t, isPresent: n, onExitComplete: r, custom: i, presenceAffectsLayout: o, mode: a, anchorX: s, anchorY: l, root: u }) => {
  const c = $y(Pj), f = oy(), d = ve(n), p = ve(r);
  ep(() => {
    d.current = n, p.current = r;
  });
  let h = !0, v = Fe(() => (h = !1, {
    id: f,
    initial: t,
    isPresent: n,
    custom: i,
    onExitComplete: (m) => {
      c.set(m, !0);
      for (const g of c.values())
        if (!g)
          return;
      r && r();
    },
    register: (m) => (c.set(m, !1), () => {
      c.delete(m), !d.current && !c.size && p.current?.();
    })
  }), [n, c, r]);
  return o && h && (v = { ...v }), Fe(() => {
    c.forEach((m, g) => c.set(g, !1));
  }, [n]), ee.useEffect(() => {
    !n && !c.size && r && r();
  }, [n]), e = I.jsx(Tj, { pop: a === "popLayout", isPresent: n, anchorX: s, anchorY: l, root: u, children: e }), I.jsx(tp.Provider, { value: v, children: e });
};
function Pj() {
  return /* @__PURE__ */ new Map();
}
function wT(e = !0) {
  const t = je(tp);
  if (t === null)
    return [!0, null];
  const { isPresent: n, onExitComplete: r, register: i } = t, o = oy();
  ze(() => {
    if (e)
      return i(o);
  }, [e]);
  const a = Le(() => e && r && r(o), [o, r, e]);
  return !n && r ? [!1, a] : [!0];
}
const Dc = (e) => e.key || "";
function hw(e) {
  const t = [];
  return v6.forEach(e, (n) => {
    QS(n) && t.push(n);
  }), t;
}
const Cv = ({ children: e, custom: t, initial: n = !0, onExitComplete: r, presenceAffectsLayout: i = !0, mode: o = "sync", propagate: a = !1, anchorX: s = "left", anchorY: l = "top", root: u }) => {
  const [c, f] = wT(a), d = Fe(() => hw(e), [e]), p = a && !c ? [] : d.map(Dc), h = ve(!0), v = ve(d), m = $y(() => /* @__PURE__ */ new Map()), g = ve(/* @__PURE__ */ new Set()), [_, x] = Ke(d), [w, $] = Ke(d);
  ep(() => {
    h.current = !1, v.current = d;
    for (let E = 0; E < w.length; E++) {
      const b = Dc(w[E]);
      p.includes(b) ? (m.delete(b), g.current.delete(b)) : m.get(b) !== !0 && m.set(b, !1);
    }
  }, [w, p.length, p.join("-")]);
  const k = [];
  if (d !== _) {
    let E = [...d];
    for (let b = 0; b < w.length; b++) {
      const y = w[b], S = Dc(y);
      p.includes(S) || (E.splice(b, 0, y), k.push(y));
    }
    return o === "wait" && k.length && (E = k), $(hw(E)), x(d), null;
  }
  process.env.NODE_ENV !== "production" && o === "wait" && w.length > 1 && console.warn(`You're attempting to animate multiple children within AnimatePresence, but its mode is set to "wait". This will lead to odd visual behaviour.`);
  const { forceRender: D } = je(bu);
  return I.jsx(I.Fragment, { children: w.map((E) => {
    const b = Dc(E), y = a && !c ? !1 : d === w || p.includes(b), S = () => {
      if (g.current.has(b))
        return;
      if (m.has(b))
        g.current.add(b), m.set(b, !0);
      else
        return;
      let P = !0;
      m.forEach((M) => {
        M || (P = !1);
      }), P && (D?.(), $(v.current), a && f?.(), r && r());
    };
    return I.jsx(Oj, { isPresent: y, initial: !h.current || n ? void 0 : !1, custom: t, presenceAffectsLayout: i, mode: o, root: u, onExitComplete: y ? void 0 : S, anchorX: s, anchorY: l, children: E }, b);
  }) });
}, Aj = He(null);
function Dj() {
  const e = ve(!1);
  return ep(() => (e.current = !0, () => {
    e.current = !1;
  }), []), e;
}
function Cj() {
  const e = Dj(), [t, n] = Ke(0), r = Le(() => {
    e.current && n(t + 1);
  }, [t]);
  return [Le(() => _t.postRender(r), [r]), t];
}
const xT = (e) => e === !0, Ij = (e) => xT(e === !0) || e === "id", Mj = ({ children: e, id: t, inherit: n = !0 }) => {
  const r = je(bu), i = je(Aj), [o, a] = Cj(), s = ve(null), l = r.id || i;
  s.current === null && (Ij(n) && l && (t = t ? l + "-" + t : l), s.current = {
    id: t,
    group: xT(n) && r.group || dw()
  });
  const u = Fe(() => ({ ...s.current, forceRender: o }), [a]);
  return I.jsx(bu.Provider, { value: u, children: e });
}, ET = He({ strict: !1 }), mw = {
  animation: [
    "animate",
    "variants",
    "whileHover",
    "whileTap",
    "exit",
    "whileInView",
    "whileFocus",
    "whileDrag"
  ],
  exit: ["exit"],
  drag: ["drag", "dragControls"],
  focus: ["whileFocus"],
  hover: ["whileHover", "onHoverStart", "onHoverEnd"],
  tap: ["whileTap", "onTap", "onTapStart", "onTapCancel"],
  pan: ["onPan", "onPanStart", "onPanSessionStart", "onPanEnd"],
  inView: ["whileInView", "onViewportEnter", "onViewportLeave"],
  layout: ["layout", "layoutId"]
};
let vw = !1;
function Rj() {
  if (vw)
    return;
  const e = {};
  for (const t in mw)
    e[t] = {
      isEnabled: (n) => mw[t].some((r) => !!n[r])
    };
  Qk(e), vw = !0;
}
function ST() {
  return Rj(), p8();
}
function Nj(e) {
  const t = ST();
  for (const n in e)
    t[n] = {
      ...t[n],
      ...e[n]
    };
  Qk(t);
}
const jj = /* @__PURE__ */ new Set([
  "animate",
  "exit",
  "variants",
  "initial",
  "style",
  "values",
  "variants",
  "transition",
  "transformTemplate",
  "custom",
  "inherit",
  "onBeforeLayoutMeasure",
  "onAnimationStart",
  "onAnimationComplete",
  "onUpdate",
  "onDragStart",
  "onDrag",
  "onDragEnd",
  "onMeasureDragConstraints",
  "onDirectionLock",
  "onDragTransitionEnd",
  "_dragX",
  "_dragY",
  "onHoverStart",
  "onHoverEnd",
  "onViewportEnter",
  "onViewportLeave",
  "globalTapTarget",
  "propagate",
  "ignoreStrict",
  "viewport"
]);
function td(e) {
  return e.startsWith("while") || e.startsWith("drag") && e !== "draggable" || e.startsWith("layout") || e.startsWith("onTap") || e.startsWith("onPan") || e.startsWith("onLayout") || jj.has(e);
}
let $T = (e) => !td(e);
function Fj(e) {
  typeof e == "function" && ($T = (t) => t.startsWith("on") ? !td(t) : e(t));
}
try {
  Fj(require("@emotion/is-prop-valid").default);
} catch {
}
function zj(e, t, n) {
  const r = {};
  for (const i in e)
    i === "values" && typeof e.values == "object" || $n(e[i]) || ($T(i) || n === !0 && td(i) || !t && !td(i) || // If trying to use native HTML drag events, forward drag listeners
    e.draggable && i.startsWith("onDrag")) && (r[i] = e[i]);
  return r;
}
const op = /* @__PURE__ */ He({});
function Lj(e, t) {
  if (ip(e)) {
    const { initial: n, animate: r } = e;
    return {
      initial: n === !1 || xu(n) ? n : void 0,
      animate: xu(r) ? r : void 0
    };
  }
  return e.inherit !== !1 ? t : {};
}
function Vj(e) {
  const { initial: t, animate: n } = Lj(e, je(op));
  return Fe(() => ({ initial: t, animate: n }), [gw(t), gw(n)]);
}
function gw(e) {
  return Array.isArray(e) ? e.join(" ") : e;
}
const Yy = () => ({
  style: {},
  transform: {},
  transformOrigin: {},
  vars: {}
});
function kT(e, t, n) {
  for (const r in t)
    !$n(t[r]) && !iT(r, n) && (e[r] = t[r]);
}
function Bj({ transformTemplate: e }, t) {
  return Fe(() => {
    const n = Yy();
    return Wy(n, t, e), Object.assign({}, n.vars, n.style);
  }, [t]);
}
function Kj(e, t) {
  const n = e.style || {}, r = {};
  return kT(r, n, e), Object.assign(r, Bj(e, t)), r;
}
function Uj(e, t) {
  const n = {}, r = Kj(e, t);
  return e.drag && e.dragListener !== !1 && (n.draggable = !1, r.userSelect = r.WebkitUserSelect = r.WebkitTouchCallout = "none", r.touchAction = e.drag === !0 ? "none" : `pan-${e.drag === "x" ? "y" : "x"}`), e.tabIndex === void 0 && (e.onTap || e.onTapStart || e.whileTap) && (n.tabIndex = 0), n.style = r, n;
}
const TT = () => ({
  ...Yy(),
  attrs: {}
});
function qj(e, t, n, r) {
  const i = Fe(() => {
    const o = TT();
    return oT(o, t, sT(r), e.transformTemplate, e.style), {
      ...o.attrs,
      style: { ...o.style }
    };
  }, [t]);
  if (e.style) {
    const o = {};
    kT(o, e.style, e), i.style = { ...o, ...i.style };
  }
  return i;
}
const Hj = [
  "animate",
  "circle",
  "defs",
  "desc",
  "ellipse",
  "g",
  "image",
  "line",
  "filter",
  "marker",
  "mask",
  "metadata",
  "path",
  "pattern",
  "polygon",
  "polyline",
  "rect",
  "stop",
  "switch",
  "symbol",
  "svg",
  "text",
  "tspan",
  "use",
  "view"
];
function Qy(e) {
  return (
    /**
     * If it's not a string, it's a custom React component. Currently we only support
     * HTML custom React components.
     */
    typeof e != "string" || /**
     * If it contains a dash, the element is a custom HTML webcomponent.
     */
    e.includes("-") ? !1 : (
      /**
       * If it's in our list of lowercase SVG tags, it's an SVG component
       */
      !!(Hj.indexOf(e) > -1 || /**
       * If it contains a capital letter, it's an SVG component
       */
      /[A-Z]/u.test(e))
    )
  );
}
function Wj(e, t, n, { latestValues: r }, i, o = !1, a) {
  const l = (a ?? Qy(e) ? qj : Uj)(t, r, i, e), u = zj(t, typeof e == "string", o), c = e !== sy ? { ...u, ...l, ref: n } : {}, { children: f } = t, d = Fe(() => $n(f) ? f.get() : f, [f]);
  return g6(e, {
    ...c,
    children: d
  });
}
function Zj({ scrapeMotionValuesFromProps: e, createRenderState: t }, n, r, i) {
  return {
    latestValues: Gj(n, r, i, e),
    renderState: t()
  };
}
function Gj(e, t, n, r) {
  const i = {}, o = r(e, {});
  for (const d in o)
    i[d] = wf(o[d]);
  let { initial: a, animate: s } = e;
  const l = ip(e), u = Gk(e);
  t && u && !l && e.inherit !== !1 && (a === void 0 && (a = t.initial), s === void 0 && (s = t.animate));
  let c = n ? n.initial === !1 : !1;
  c = c || a === !1;
  const f = c ? s : a;
  if (f && typeof f != "boolean" && !rp(f)) {
    const d = Array.isArray(f) ? f : [f];
    for (let p = 0; p < d.length; p++) {
      const h = Ly(e, d[p]);
      if (h) {
        const { transitionEnd: v, transition: m, ...g } = h;
        for (const _ in g) {
          let x = g[_];
          if (Array.isArray(x)) {
            const w = c ? x.length - 1 : 0;
            x = x[w];
          }
          x !== null && (i[_] = x);
        }
        for (const _ in v)
          i[_] = v[_];
      }
    }
  }
  return i;
}
const OT = (e) => (t, n) => {
  const r = je(op), i = je(tp), o = () => Zj(e, t, r, i);
  return n ? o() : $y(o);
}, Yj = /* @__PURE__ */ OT({
  scrapeMotionValuesFromProps: Zy,
  createRenderState: Yy
}), Qj = /* @__PURE__ */ OT({
  scrapeMotionValuesFromProps: lT,
  createRenderState: TT
}), Jj = Symbol.for("motionComponentSymbol");
function Xj(e, t, n) {
  const r = ve(n);
  ay(() => {
    r.current = n;
  });
  const i = ve(null);
  return Le((o) => {
    o && e.onMount?.(o), t && (o ? t.mount(o) : t.unmount());
    const a = r.current;
    if (typeof a == "function")
      if (o) {
        const s = a(o);
        typeof s == "function" && (i.current = s);
      } else i.current ? (i.current(), i.current = null) : a(o);
    else a && (a.current = o);
  }, [t]);
}
const PT = He({});
function ts(e) {
  return e && typeof e == "object" && Object.prototype.hasOwnProperty.call(e, "current");
}
function eF(e, t, n, r, i, o) {
  const { visualElement: a } = je(op), s = je(ET), l = je(tp), u = je(Gy), c = u.reducedMotion, f = u.skipAnimations, d = ve(null), p = ve(!1);
  r = r || s.renderer, !d.current && r && (d.current = r(e, {
    visualState: t,
    parent: a,
    props: n,
    presenceContext: l,
    blockInitialAnimation: l ? l.initial === !1 : !1,
    reducedMotionConfig: c,
    skipAnimations: f,
    isSVG: o
  }), p.current && d.current && (d.current.manuallyAnimateOnMount = !0));
  const h = d.current, v = je(PT);
  h && !h.projection && i && (h.type === "html" || h.type === "svg") && tF(d.current, n, i, v);
  const m = ve(!1);
  ay(() => {
    h && m.current && h.update(n, l);
  });
  const g = n[jk], _ = ve(!!g && typeof window < "u" && !window.MotionHandoffIsComplete?.(g) && window.MotionHasOptimisedAnimation?.(g));
  return ep(() => {
    p.current = !0, h && (m.current = !0, window.MotionIsMounted = !0, h.updateFeatures(), h.scheduleRenderMicrotask(), _.current && h.animationState && h.animationState.animateChanges());
  }), ze(() => {
    h && (!_.current && h.animationState && h.animationState.animateChanges(), _.current && (queueMicrotask(() => {
      window.MotionHandoffMarkAsComplete?.(g);
    }), _.current = !1), h.enteringChildren = void 0);
  }), h;
}
function tF(e, t, n, r) {
  const { layoutId: i, layout: o, drag: a, dragConstraints: s, layoutScroll: l, layoutRoot: u, layoutAnchor: c, layoutCrossfade: f } = t;
  e.projection = new n(e.latestValues, t["data-framer-portal-id"] ? void 0 : AT(e.parent)), e.projection.setOptions({
    layoutId: i,
    layout: o,
    alwaysMeasureLayout: !!a || s && ts(s),
    visualElement: e,
    /**
     * TODO: Update options in an effect. This could be tricky as it'll be too late
     * to update by the time layout animations run.
     * We also need to fix this safeToRemove by linking it up to the one returned by usePresence,
     * ensuring it gets called if there's no potential layout animations.
     *
     */
    animationType: typeof o == "string" ? o : "both",
    initialPromotionConfig: r,
    crossfade: f,
    layoutScroll: l,
    layoutRoot: u,
    layoutAnchor: c
  });
}
function AT(e) {
  if (e)
    return e.options.allowProjection !== !1 ? e.projection : AT(e.parent);
}
function Ch(e, { forwardMotionProps: t = !1, type: n } = {}, r, i) {
  r && Nj(r);
  const o = n ? n === "svg" : Qy(e), a = o ? Qj : Yj;
  function s(u, c) {
    let f;
    const d = {
      ...je(Gy),
      ...u,
      layoutId: nF(u)
    }, { isStatic: p } = d, h = Vj(u), v = a(u, p);
    if (!p && typeof window < "u") {
      rF(d, r);
      const m = iF(d);
      f = m.MeasureLayout, h.visualElement = eF(e, v, d, i, m.ProjectionNode, o);
    }
    return I.jsxs(op.Provider, { value: h, children: [f && h.visualElement ? I.jsx(f, { visualElement: h.visualElement, ...d }) : null, Wj(e, u, Xj(v, h.visualElement, c), v, p, t, o)] });
  }
  s.displayName = `motion.${typeof e == "string" ? e : `create(${e.displayName ?? e.name ?? ""})`}`;
  const l = fn(s);
  return l[Jj] = e, l;
}
function nF({ layoutId: e }) {
  const t = je(bu).id;
  return t && e !== void 0 ? t + "-" + e : e;
}
function rF(e, t) {
  const n = je(ET).strict;
  if (process.env.NODE_ENV !== "production" && t && n) {
    const r = "You have rendered a `motion` component within a `LazyMotion` component. This will break tree shaking. Import and render a `m` component instead.";
    e.ignoreStrict ? el(!1, r, "lazy-strict-mode") : Wi(!1, r, "lazy-strict-mode");
  }
}
function iF(e) {
  const t = ST(), { drag: n, layout: r } = t;
  if (!n && !r)
    return {};
  const i = { ...n, ...r };
  return {
    MeasureLayout: n?.isEnabled(e) || r?.isEnabled(e) ? i.MeasureLayout : void 0,
    ProjectionNode: i.ProjectionNode
  };
}
function oF(e, t) {
  if (typeof Proxy > "u")
    return Ch;
  const n = /* @__PURE__ */ new Map(), r = (o, a) => Ch(o, a, e, t), i = (o, a) => (process.env.NODE_ENV !== "production" && Oy(!1, "motion() is deprecated. Use motion.create() instead."), r(o, a));
  return new Proxy(i, {
    /**
     * Called when `motion` is referenced with a prop: `motion.div`, `motion.input` etc.
     * The prop name is passed through as `key` and we can use that to generate a `motion`
     * DOM component with that name.
     */
    get: (o, a) => a === "create" ? r : (n.has(a) || n.set(a, Ch(a, void 0, e, t)), n.get(a))
  });
}
const aF = (e, t) => t.isSVG ?? Qy(e) ? new A8(t) : new S8(t, {
  allowProjection: e !== sy
});
class sF extends Fo {
  /**
   * We dynamically generate the AnimationState manager as it contains a reference
   * to the underlying animation library. We only want to load that if we load this,
   * so people can optionally code split it out using the `m` component.
   */
  constructor(t) {
    super(t), t.animationState || (t.animationState = R8(t));
  }
  updateAnimationControlsSubscription() {
    const { animate: t } = this.node.getProps();
    rp(t) && (this.unmountControls = t.subscribe(this.node));
  }
  /**
   * Subscribe any provided AnimationControls to the component's VisualElement
   */
  mount() {
    this.updateAnimationControlsSubscription();
  }
  update() {
    const { animate: t } = this.node.getProps(), { animate: n } = this.node.prevProps || {};
    t !== n && this.updateAnimationControlsSubscription();
  }
  unmount() {
    this.node.animationState.reset(), this.unmountControls?.();
  }
}
let lF = 0;
class uF extends Fo {
  constructor() {
    super(...arguments), this.id = lF++, this.isExitComplete = !1;
  }
  update() {
    if (!this.node.presenceContext)
      return;
    const { isPresent: t, onExitComplete: n } = this.node.presenceContext, { isPresent: r } = this.node.prevPresenceContext || {};
    if (!this.node.animationState || t === r)
      return;
    if (t && r === !1) {
      if (this.isExitComplete) {
        const { initial: o, custom: a } = this.node.getProps();
        if (typeof o == "string" || typeof o == "object" && o !== null && !Array.isArray(o)) {
          const s = ma(this.node, o, a);
          if (s) {
            const { transition: l, transitionEnd: u, ...c } = s;
            for (const f in c)
              this.node.getValue(f)?.jump(c[f]);
          }
        }
        this.node.animationState.reset(), this.node.animationState.animateChanges();
      } else
        this.node.animationState.setActive("exit", !1);
      this.isExitComplete = !1;
      return;
    }
    const i = this.node.animationState.setActive("exit", !t);
    n && !t && i.then(() => {
      this.isExitComplete = !0, n(this.id);
    });
  }
  mount() {
    const { register: t, onExitComplete: n } = this.node.presenceContext || {};
    n && n(this.id), t && (this.unmount = t(this.id));
  }
  unmount() {
  }
}
const cF = {
  animation: {
    Feature: sF
  },
  exit: {
    Feature: uF
  }
};
function tc(e) {
  return {
    point: {
      x: e.pageX,
      y: e.pageY
    }
  };
}
const fF = (e) => (t) => Ky(t) && e(t, tc(t));
function su(e, t, n, r) {
  return Eu(e, t, fF(n), r);
}
const DT = ({ current: e }) => e ? e.ownerDocument.defaultView : null, yw = (e, t) => Math.abs(e - t);
function dF(e, t) {
  const n = yw(e.x, t.x), r = yw(e.y, t.y);
  return Math.sqrt(n ** 2 + r ** 2);
}
const bw = /* @__PURE__ */ new Set(["auto", "scroll"]);
class CT {
  constructor(t, n, { transformPagePoint: r, contextWindow: i = window, dragSnapToOrigin: o = !1, distanceThreshold: a = 3, element: s } = {}) {
    if (this.startEvent = null, this.lastMoveEvent = null, this.lastMoveEventInfo = null, this.lastRawMoveEventInfo = null, this.handlers = {}, this.contextWindow = window, this.scrollPositions = /* @__PURE__ */ new Map(), this.removeScrollListeners = null, this.onElementScroll = (h) => {
      this.handleScroll(h.target);
    }, this.onWindowScroll = () => {
      this.handleScroll(window);
    }, this.updatePoint = () => {
      if (!(this.lastMoveEvent && this.lastMoveEventInfo))
        return;
      this.lastRawMoveEventInfo && (this.lastMoveEventInfo = Cc(this.lastRawMoveEventInfo, this.transformPagePoint));
      const h = Ih(this.lastMoveEventInfo, this.history), v = this.startEvent !== null, m = dF(h.offset, { x: 0, y: 0 }) >= this.distanceThreshold;
      if (!v && !m)
        return;
      const { point: g } = h, { timestamp: _ } = En;
      this.history.push({ ...g, timestamp: _ });
      const { onStart: x, onMove: w } = this.handlers;
      v || (x && x(this.lastMoveEvent, h), this.startEvent = this.lastMoveEvent), w && w(this.lastMoveEvent, h);
    }, this.handlePointerMove = (h, v) => {
      this.lastMoveEvent = h, this.lastRawMoveEventInfo = v, this.lastMoveEventInfo = Cc(v, this.transformPagePoint), _t.update(this.updatePoint, !0);
    }, this.handlePointerUp = (h, v) => {
      this.end();
      const { onEnd: m, onSessionEnd: g, resumeAnimation: _ } = this.handlers;
      if ((this.dragSnapToOrigin || !this.startEvent) && _ && _(), !(this.lastMoveEvent && this.lastMoveEventInfo))
        return;
      const x = Ih(h.type === "pointercancel" ? this.lastMoveEventInfo : Cc(v, this.transformPagePoint), this.history);
      this.startEvent && m && m(h, x), g && g(h, x);
    }, !Ky(t))
      return;
    this.dragSnapToOrigin = o, this.handlers = n, this.transformPagePoint = r, this.distanceThreshold = a, this.contextWindow = i || window;
    const l = tc(t), u = Cc(l, this.transformPagePoint), { point: c } = u, { timestamp: f } = En;
    this.history = [{ ...c, timestamp: f }];
    const { onSessionStart: d } = n;
    d && d(t, Ih(u, this.history));
    const p = { passive: !0, capture: !0 };
    this.removeListeners = Ju(su(this.contextWindow, "pointermove", this.handlePointerMove, p), su(this.contextWindow, "pointerup", this.handlePointerUp, p), su(this.contextWindow, "pointercancel", this.handlePointerUp, p)), s && this.startScrollTracking(s);
  }
  /**
   * Start tracking scroll on ancestors and window.
   */
  startScrollTracking(t) {
    let n = t.parentElement;
    for (; n; ) {
      const r = getComputedStyle(n);
      (bw.has(r.overflowX) || bw.has(r.overflowY)) && this.scrollPositions.set(n, {
        x: n.scrollLeft,
        y: n.scrollTop
      }), n = n.parentElement;
    }
    this.scrollPositions.set(window, {
      x: window.scrollX,
      y: window.scrollY
    }), window.addEventListener("scroll", this.onElementScroll, {
      capture: !0
    }), window.addEventListener("scroll", this.onWindowScroll), this.removeScrollListeners = () => {
      window.removeEventListener("scroll", this.onElementScroll, {
        capture: !0
      }), window.removeEventListener("scroll", this.onWindowScroll);
    };
  }
  /**
   * Handle scroll compensation during drag.
   *
   * For element scroll: adjusts history origin since pageX/pageY doesn't change.
   * For window scroll: adjusts lastMoveEventInfo since pageX/pageY would change.
   */
  handleScroll(t) {
    const n = this.scrollPositions.get(t);
    if (!n)
      return;
    const r = t === window, i = r ? { x: window.scrollX, y: window.scrollY } : {
      x: t.scrollLeft,
      y: t.scrollTop
    }, o = { x: i.x - n.x, y: i.y - n.y };
    o.x === 0 && o.y === 0 || (r ? this.lastMoveEventInfo && (this.lastMoveEventInfo.point.x += o.x, this.lastMoveEventInfo.point.y += o.y) : this.history.length > 0 && (this.history[0].x -= o.x, this.history[0].y -= o.y), this.scrollPositions.set(t, i), _t.update(this.updatePoint, !0));
  }
  updateHandlers(t) {
    this.handlers = t;
  }
  end() {
    this.removeListeners && this.removeListeners(), this.removeScrollListeners && this.removeScrollListeners(), this.scrollPositions.clear(), To(this.updatePoint);
  }
}
function Cc(e, t) {
  return t ? { point: t(e.point) } : e;
}
function _w(e, t) {
  return { x: e.x - t.x, y: e.y - t.y };
}
function Ih({ point: e }, t) {
  return {
    point: e,
    delta: _w(e, IT(t)),
    offset: _w(e, pF(t)),
    velocity: hF(t, 0.1)
  };
}
function pF(e) {
  return e[0];
}
function IT(e) {
  return e[e.length - 1];
}
function hF(e, t) {
  if (e.length < 2)
    return { x: 0, y: 0 };
  let n = e.length - 1, r = null;
  const i = IT(e);
  for (; n >= 0 && (r = e[n], !(i.timestamp - r.timestamp > /* @__PURE__ */ er(t))); )
    n--;
  if (!r)
    return { x: 0, y: 0 };
  r === e[0] && e.length > 2 && i.timestamp - r.timestamp > /* @__PURE__ */ er(t) * 2 && (r = e[1]);
  const o = /* @__PURE__ */ Pr(i.timestamp - r.timestamp);
  if (o === 0)
    return { x: 0, y: 0 };
  const a = {
    x: (i.x - r.x) / o,
    y: (i.y - r.y) / o
  };
  return a.x === 1 / 0 && (a.x = 0), a.y === 1 / 0 && (a.y = 0), a;
}
function mF(e, { min: t, max: n }, r) {
  return t !== void 0 && e < t ? e = r ? St(t, e, r.min) : Math.max(e, t) : n !== void 0 && e > n && (e = r ? St(n, e, r.max) : Math.min(e, n)), e;
}
function ww(e, t, n) {
  return {
    min: t !== void 0 ? e.min + t : void 0,
    max: n !== void 0 ? e.max + n - (e.max - e.min) : void 0
  };
}
function vF(e, { top: t, left: n, bottom: r, right: i }) {
  return {
    x: ww(e.x, n, i),
    y: ww(e.y, t, r)
  };
}
function xw(e, t) {
  let n = t.min - e.min, r = t.max - e.max;
  return t.max - t.min < e.max - e.min && ([n, r] = [r, n]), { min: n, max: r };
}
function gF(e, t) {
  return {
    x: xw(e.x, t.x),
    y: xw(e.y, t.y)
  };
}
function yF(e, t) {
  let n = 0.5;
  const r = Kn(e), i = Kn(t);
  return i > r ? n = /* @__PURE__ */ _u(t.min, t.max - r, e.min) : r > i && (n = /* @__PURE__ */ _u(e.min, e.max - i, t.min)), Ai(0, 1, n);
}
function bF(e, t) {
  const n = {};
  return t.min !== void 0 && (n.min = t.min - e.min), t.max !== void 0 && (n.max = t.max - e.min), n;
}
const Iv = 0.35;
function _F(e = Iv) {
  return e === !1 ? e = 0 : e === !0 && (e = Iv), {
    x: Ew(e, "left", "right"),
    y: Ew(e, "top", "bottom")
  };
}
function Ew(e, t, n) {
  return {
    min: Sw(e, t),
    max: Sw(e, n)
  };
}
function Sw(e, t) {
  return typeof e == "number" ? e : e[t] || 0;
}
const wF = /* @__PURE__ */ new WeakMap();
class xF {
  constructor(t) {
    this.openDragLock = null, this.isDragging = !1, this.currentDirection = null, this.originPoint = { x: 0, y: 0 }, this.constraints = !1, this.hasMutatedConstraints = !1, this.elastic = pn(), this.latestPointerEvent = null, this.latestPanInfo = null, this.visualElement = t;
  }
  start(t, { snapToCursor: n = !1, distanceThreshold: r } = {}) {
    const { presenceContext: i } = this.visualElement;
    if (i && i.isPresent === !1)
      return;
    const o = (f) => {
      n && this.snapToCursor(tc(f).point), this.stopAnimation();
    }, a = (f, d) => {
      const { drag: p, dragPropagation: h, onDragStart: v } = this.getProps();
      if (p && !h && (this.openDragLock && this.openDragLock(), this.openDragLock = KN(p), !this.openDragLock))
        return;
      this.latestPointerEvent = f, this.latestPanInfo = d, this.isDragging = !0, this.currentDirection = null, this.resolveConstraints(), this.visualElement.projection && (this.visualElement.projection.isAnimationBlocked = !0, this.visualElement.projection.target = void 0), yi((g) => {
        let _ = this.getAxisMotionValue(g).get() || 0;
        if (Ti.test(_)) {
          const { projection: x } = this.visualElement;
          if (x && x.layout) {
            const w = x.layout.layoutBox[g];
            w && (_ = Kn(w) * (parseFloat(_) / 100));
          }
        }
        this.originPoint[g] = _;
      }), v && _t.update(() => v(f, d), !1, !0), xv(this.visualElement, "transform");
      const { animationState: m } = this.visualElement;
      m && m.setActive("whileDrag", !0);
    }, s = (f, d) => {
      this.latestPointerEvent = f, this.latestPanInfo = d;
      const { dragPropagation: p, dragDirectionLock: h, onDirectionLock: v, onDrag: m } = this.getProps();
      if (!p && !this.openDragLock)
        return;
      const { offset: g } = d;
      if (h && this.currentDirection === null) {
        this.currentDirection = SF(g), this.currentDirection !== null && v && v(this.currentDirection);
        return;
      }
      this.updateAxis("x", d.point, g), this.updateAxis("y", d.point, g), this.visualElement.render(), m && _t.update(() => m(f, d), !1, !0);
    }, l = (f, d) => {
      this.latestPointerEvent = f, this.latestPanInfo = d, this.stop(f, d), this.latestPointerEvent = null, this.latestPanInfo = null;
    }, u = () => {
      const { dragSnapToOrigin: f } = this.getProps();
      (f || this.constraints) && this.startAnimation({ x: 0, y: 0 });
    }, { dragSnapToOrigin: c } = this.getProps();
    this.panSession = new CT(t, {
      onSessionStart: o,
      onStart: a,
      onMove: s,
      onSessionEnd: l,
      resumeAnimation: u
    }, {
      transformPagePoint: this.visualElement.getTransformPagePoint(),
      dragSnapToOrigin: c,
      distanceThreshold: r,
      contextWindow: DT(this.visualElement),
      element: this.visualElement.current
    });
  }
  /**
   * @internal
   */
  stop(t, n) {
    const r = t || this.latestPointerEvent, i = n || this.latestPanInfo, o = this.isDragging;
    if (this.cancel(), !o || !i || !r)
      return;
    const { velocity: a } = i;
    this.startAnimation(a);
    const { onDragEnd: s } = this.getProps();
    s && _t.postRender(() => s(r, i));
  }
  /**
   * @internal
   */
  cancel() {
    this.isDragging = !1;
    const { projection: t, animationState: n } = this.visualElement;
    t && (t.isAnimationBlocked = !1), this.endPanSession();
    const { dragPropagation: r } = this.getProps();
    !r && this.openDragLock && (this.openDragLock(), this.openDragLock = null), n && n.setActive("whileDrag", !1);
  }
  /**
   * Clean up the pan session without modifying other drag state.
   * This is used during unmount to ensure event listeners are removed
   * without affecting projection animations or drag locks.
   * @internal
   */
  endPanSession() {
    this.panSession && this.panSession.end(), this.panSession = void 0;
  }
  updateAxis(t, n, r) {
    const { drag: i } = this.getProps();
    if (!r || !Ic(t, i, this.currentDirection))
      return;
    const o = this.getAxisMotionValue(t);
    let a = this.originPoint[t] + r[t];
    this.constraints && this.constraints[t] && (a = mF(a, this.constraints[t], this.elastic[t])), o.set(a);
  }
  resolveConstraints() {
    const { dragConstraints: t, dragElastic: n } = this.getProps(), r = this.visualElement.projection && !this.visualElement.projection.layout ? this.visualElement.projection.measure(!1) : this.visualElement.projection?.layout, i = this.constraints;
    t && ts(t) ? this.constraints || (this.constraints = this.resolveRefConstraints()) : t && r ? this.constraints = vF(r.layoutBox, t) : this.constraints = !1, this.elastic = _F(n), i !== this.constraints && !ts(t) && r && this.constraints && !this.hasMutatedConstraints && yi((o) => {
      this.constraints !== !1 && this.getAxisMotionValue(o) && (this.constraints[o] = bF(r.layoutBox[o], this.constraints[o]));
    });
  }
  resolveRefConstraints() {
    const { dragConstraints: t, onMeasureDragConstraints: n } = this.getProps();
    if (!t || !ts(t))
      return !1;
    const r = t.current;
    Wi(r !== null, "If `dragConstraints` is set as a React ref, that ref must be passed to another component's `ref` prop.", "drag-constraints-ref");
    const { projection: i } = this.visualElement;
    if (!i || !i.layout)
      return !1;
    i.root && (i.root.scroll = void 0, i.root.updateScroll());
    const o = y8(r, i.root, this.visualElement.getTransformPagePoint());
    let a = gF(i.layout.layoutBox, o);
    if (n) {
      const s = n(m8(a));
      this.hasMutatedConstraints = !!s, s && (a = Xk(s));
    }
    return a;
  }
  startAnimation(t) {
    const { drag: n, dragMomentum: r, dragElastic: i, dragTransition: o, dragSnapToOrigin: a, onDragTransitionEnd: s } = this.getProps(), l = this.constraints || {}, u = yi((c) => {
      if (!Ic(c, n, this.currentDirection))
        return;
      let f = l && l[c] || {};
      (a === !0 || a === c) && (f = { min: 0, max: 0 });
      const d = i ? 200 : 1e6, p = i ? 40 : 1e7, h = {
        type: "inertia",
        velocity: r ? t[c] : 0,
        bounceStiffness: d,
        bounceDamping: p,
        timeConstant: 750,
        restDelta: 1,
        restSpeed: 10,
        ...o,
        ...f
      };
      return this.startAxisValueAnimation(c, h);
    });
    return Promise.all(u).then(s);
  }
  startAxisValueAnimation(t, n) {
    const r = this.getAxisMotionValue(t);
    return xv(this.visualElement, t), r.start(zy(t, r, 0, n, this.visualElement, !1));
  }
  stopAnimation() {
    yi((t) => this.getAxisMotionValue(t).stop());
  }
  /**
   * Drag works differently depending on which props are provided.
   *
   * - If _dragX and _dragY are provided, we output the gesture delta directly to those motion values.
   * - Otherwise, we apply the delta to the x/y motion values.
   */
  getAxisMotionValue(t) {
    const n = `_drag${t.toUpperCase()}`, i = this.visualElement.getProps()[n];
    return i || this.visualElement.getValue(t, this.visualElement.latestValues[t] ?? 0);
  }
  snapToCursor(t) {
    yi((n) => {
      const { drag: r } = this.getProps();
      if (!Ic(n, r, this.currentDirection))
        return;
      const { projection: i } = this.visualElement, o = this.getAxisMotionValue(n);
      if (i && i.layout) {
        const { min: a, max: s } = i.layout.layoutBox[n], l = o.get() || 0;
        o.set(t[n] - St(a, s, 0.5) + l);
      }
    });
  }
  /**
   * When the viewport resizes we want to check if the measured constraints
   * have changed and, if so, reposition the element within those new constraints
   * relative to where it was before the resize.
   */
  scalePositionWithinConstraints() {
    if (!this.visualElement.current)
      return;
    const { drag: t, dragConstraints: n } = this.getProps(), { projection: r } = this.visualElement;
    if (!ts(n) || !r || !this.constraints)
      return;
    this.stopAnimation();
    const i = { x: 0, y: 0 };
    yi((a) => {
      const s = this.getAxisMotionValue(a);
      if (s && this.constraints !== !1) {
        const l = s.get();
        i[a] = yF({ min: l, max: l }, this.constraints[a]);
      }
    });
    const { transformTemplate: o } = this.visualElement.getProps();
    this.visualElement.current.style.transform = o ? o({}, "") : "none", r.root && r.root.updateScroll(), r.updateLayout(), this.constraints = !1, this.resolveConstraints(), yi((a) => {
      if (!Ic(a, t, null))
        return;
      const s = this.getAxisMotionValue(a), { min: l, max: u } = this.constraints[a];
      s.set(St(l, u, i[a]));
    }), this.visualElement.render();
  }
  addListeners() {
    if (!this.visualElement.current)
      return;
    wF.set(this.visualElement, this);
    const t = this.visualElement.current, n = su(t, "pointerdown", (u) => {
      const { drag: c, dragListener: f = !0 } = this.getProps(), d = u.target, p = d !== t && GN(d);
      c && f && !p && this.start(u);
    });
    let r;
    const i = () => {
      const { dragConstraints: u } = this.getProps();
      ts(u) && u.current && (this.constraints = this.resolveRefConstraints(), r || (r = EF(t, u.current, () => this.scalePositionWithinConstraints())));
    }, { projection: o } = this.visualElement, a = o.addEventListener("measure", i);
    o && !o.layout && (o.root && o.root.updateScroll(), o.updateLayout()), _t.read(i);
    const s = Eu(window, "resize", () => this.scalePositionWithinConstraints()), l = o.addEventListener("didUpdate", (({ delta: u, hasLayoutChanged: c }) => {
      this.isDragging && c && (yi((f) => {
        const d = this.getAxisMotionValue(f);
        d && (this.originPoint[f] += u[f].translate, d.set(d.get() + u[f].translate));
      }), this.visualElement.render());
    }));
    return () => {
      s(), n(), a(), l && l(), r && r();
    };
  }
  getProps() {
    const t = this.visualElement.getProps(), { drag: n = !1, dragDirectionLock: r = !1, dragPropagation: i = !1, dragConstraints: o = !1, dragElastic: a = Iv, dragMomentum: s = !0 } = t;
    return {
      ...t,
      drag: n,
      dragDirectionLock: r,
      dragPropagation: i,
      dragConstraints: o,
      dragElastic: a,
      dragMomentum: s
    };
  }
}
function $w(e) {
  let t = !0;
  return () => {
    if (t) {
      t = !1;
      return;
    }
    e();
  };
}
function EF(e, t, n) {
  const r = D_(e, $w(n)), i = D_(t, $w(n));
  return () => {
    r(), i();
  };
}
function Ic(e, t, n) {
  return (t === !0 || t === e) && (n === null || n === e);
}
function SF(e, t = 10) {
  let n = null;
  return Math.abs(e.y) > t ? n = "y" : Math.abs(e.x) > t && (n = "x"), n;
}
class $F extends Fo {
  constructor(t) {
    super(t), this.removeGroupControls = Mr, this.removeListeners = Mr, this.controls = new xF(t);
  }
  mount() {
    const { dragControls: t } = this.node.getProps();
    t && (this.removeGroupControls = t.subscribe(this.controls)), this.removeListeners = this.controls.addListeners() || Mr;
  }
  update() {
    const { dragControls: t } = this.node.getProps(), { dragControls: n } = this.node.prevProps || {};
    t !== n && (this.removeGroupControls(), t && (this.removeGroupControls = t.subscribe(this.controls)));
  }
  unmount() {
    this.removeGroupControls(), this.removeListeners(), this.controls.isDragging || this.controls.endPanSession();
  }
}
const Mh = (e) => (t, n) => {
  e && _t.update(() => e(t, n), !1, !0);
};
class kF extends Fo {
  constructor() {
    super(...arguments), this.removePointerDownListener = Mr;
  }
  onPointerDown(t) {
    this.session = new CT(t, this.createPanHandlers(), {
      transformPagePoint: this.node.getTransformPagePoint(),
      contextWindow: DT(this.node)
    });
  }
  createPanHandlers() {
    const { onPanSessionStart: t, onPanStart: n, onPan: r, onPanEnd: i } = this.node.getProps();
    return {
      onSessionStart: Mh(t),
      onStart: Mh(n),
      onMove: Mh(r),
      onEnd: (o, a) => {
        delete this.session, i && _t.postRender(() => i(o, a));
      }
    };
  }
  mount() {
    this.removePointerDownListener = su(this.node.current, "pointerdown", (t) => this.onPointerDown(t));
  }
  update() {
    this.session && this.session.updateHandlers(this.createPanHandlers());
  }
  unmount() {
    this.removePointerDownListener(), this.session && this.session.end();
  }
}
let Rh = !1;
class TF extends Wd {
  /**
   * This only mounts projection nodes for components that
   * need measuring, we might want to do it for all components
   * in order to incorporate transforms
   */
  componentDidMount() {
    const { visualElement: t, layoutGroup: n, switchLayoutGroup: r, layoutId: i } = this.props, { projection: o } = t;
    o && (n.group && n.group.add(o), r && r.register && i && r.register(o), Rh && o.root.didUpdate(), o.addEventListener("animationComplete", () => {
      this.safeToRemove();
    }), o.setOptions({
      ...o.options,
      layoutDependency: this.props.layoutDependency,
      onExitComplete: () => this.safeToRemove()
    })), xf.hasEverUpdated = !0;
  }
  getSnapshotBeforeUpdate(t) {
    const { layoutDependency: n, visualElement: r, drag: i, isPresent: o } = this.props, { projection: a } = r;
    return a && (a.isPresent = o, t.layoutDependency !== n && a.setOptions({
      ...a.options,
      layoutDependency: n
    }), Rh = !0, i || t.layoutDependency !== n || n === void 0 || t.isPresent !== o ? a.willUpdate() : this.safeToRemove(), t.isPresent !== o && (o ? a.promote() : a.relegate() || _t.postRender(() => {
      const s = a.getStack();
      (!s || !s.members.length) && this.safeToRemove();
    }))), null;
  }
  componentDidUpdate() {
    const { visualElement: t, layoutAnchor: n } = this.props, { projection: r } = t;
    r && (r.options.layoutAnchor = n, r.root.didUpdate(), By.postRender(() => {
      !r.currentAnimation && r.isLead() && this.safeToRemove();
    }));
  }
  componentWillUnmount() {
    const { visualElement: t, layoutGroup: n, switchLayoutGroup: r } = this.props, { projection: i } = t;
    Rh = !0, i && (i.scheduleCheckAfterUnmount(), n && n.group && n.group.remove(i), r && r.deregister && r.deregister(i));
  }
  safeToRemove() {
    const { safeToRemove: t } = this.props;
    t && t();
  }
  render() {
    return null;
  }
}
function MT(e) {
  const [t, n] = wT(), r = je(bu);
  return I.jsx(TF, { ...e, layoutGroup: r, switchLayoutGroup: je(PT), isPresent: t, safeToRemove: n });
}
const OF = {
  pan: {
    Feature: kF
  },
  drag: {
    Feature: $F,
    ProjectionNode: _T,
    MeasureLayout: MT
  }
};
function kw(e, t, n) {
  const { props: r } = e;
  e.animationState && r.whileHover && e.animationState.setActive("whileHover", n === "Start");
  const i = "onHover" + n, o = r[i];
  o && _t.postRender(() => o(t, tc(t)));
}
class PF extends Fo {
  mount() {
    const { current: t } = this.node;
    t && (this.unmount = qN(t, (n, r) => (kw(this.node, r, "Start"), (i) => kw(this.node, i, "End"))));
  }
  unmount() {
  }
}
class AF extends Fo {
  constructor() {
    super(...arguments), this.isActive = !1;
  }
  onFocus() {
    let t = !1;
    try {
      t = this.node.current.matches(":focus-visible");
    } catch {
      t = !0;
    }
    !t || !this.node.animationState || (this.node.animationState.setActive("whileFocus", !0), this.isActive = !0);
  }
  onBlur() {
    !this.isActive || !this.node.animationState || (this.node.animationState.setActive("whileFocus", !1), this.isActive = !1);
  }
  mount() {
    this.unmount = Ju(Eu(this.node.current, "focus", () => this.onFocus()), Eu(this.node.current, "blur", () => this.onBlur()));
  }
  unmount() {
  }
}
function Tw(e, t, n) {
  const { props: r } = e;
  if (e.current instanceof HTMLButtonElement && e.current.disabled)
    return;
  e.animationState && r.whileTap && e.animationState.setActive("whileTap", n === "Start");
  const i = "onTap" + (n === "End" ? "" : n), o = r[i];
  o && _t.postRender(() => o(t, tc(t)));
}
class DF extends Fo {
  mount() {
    const { current: t } = this.node;
    if (!t)
      return;
    const { globalTapTarget: n, propagate: r } = this.node.props;
    this.unmount = QN(t, (i, o) => (Tw(this.node, o, "Start"), (a, { success: s }) => Tw(this.node, a, s ? "End" : "Cancel")), {
      useGlobalTarget: n,
      stopPropagation: r?.tap === !1
    });
  }
  unmount() {
  }
}
const Mv = /* @__PURE__ */ new WeakMap(), Nh = /* @__PURE__ */ new WeakMap(), CF = (e) => {
  const t = Mv.get(e.target);
  t && t(e);
}, IF = (e) => {
  e.forEach(CF);
};
function MF({ root: e, ...t }) {
  const n = e || document;
  Nh.has(n) || Nh.set(n, {});
  const r = Nh.get(n), i = JSON.stringify(t);
  return r[i] || (r[i] = new IntersectionObserver(IF, { root: e, ...t })), r[i];
}
function RF(e, t, n) {
  const r = MF(t);
  return Mv.set(e, n), r.observe(e), () => {
    Mv.delete(e), r.unobserve(e);
  };
}
const NF = {
  some: 0,
  all: 1
};
class jF extends Fo {
  constructor() {
    super(...arguments), this.hasEnteredView = !1, this.isInView = !1;
  }
  startObserver() {
    this.stopObserver?.();
    const { viewport: t = {} } = this.node.getProps(), { root: n, margin: r, amount: i = "some", once: o } = t, a = {
      root: n ? n.current : void 0,
      rootMargin: r,
      threshold: typeof i == "number" ? i : NF[i]
    }, s = (l) => {
      const { isIntersecting: u } = l;
      if (this.isInView === u || (this.isInView = u, o && !u && this.hasEnteredView))
        return;
      u && (this.hasEnteredView = !0), this.node.animationState && this.node.animationState.setActive("whileInView", u);
      const { onViewportEnter: c, onViewportLeave: f } = this.node.getProps(), d = u ? c : f;
      d && d(l);
    };
    this.stopObserver = RF(this.node.current, a, s);
  }
  mount() {
    this.startObserver();
  }
  update() {
    if (typeof IntersectionObserver > "u")
      return;
    const { props: t, prevProps: n } = this.node;
    ["amount", "margin", "root"].some(FF(t, n)) && this.startObserver();
  }
  unmount() {
    this.stopObserver?.(), this.hasEnteredView = !1, this.isInView = !1;
  }
}
function FF({ viewport: e = {} }, { viewport: t = {} } = {}) {
  return (n) => e[n] !== t[n];
}
const zF = {
  inView: {
    Feature: jF
  },
  tap: {
    Feature: DF
  },
  focus: {
    Feature: AF
  },
  hover: {
    Feature: PF
  }
}, LF = {
  layout: {
    ProjectionNode: _T,
    MeasureLayout: MT
  }
}, VF = {
  ...cF,
  ...zF,
  ...OF,
  ...LF
}, BF = /* @__PURE__ */ oF(VF, aF), Un = BF, jh = [
  "Really?",
  "Sure?",
  "Certain?",
  "Positive?",
  "Confident?",
  "Right?",
  "Accurate?",
  "Correct?",
  "Definite?",
  "Absolutely?"
], KF = {
  y: "-200%",
  top: "50%",
  left: "50%",
  x: "-50%"
}, UF = {
  y: "-50%",
  top: "50%",
  left: "50%",
  x: "-50%"
}, qF = Lr(
  [
    "relative",
    "cursor-pointer",
    "focus:ring-white",
    "hover:bg-red-500",
    "disabled:bg-red-400",
    "z-0",
    "px-4",
    "py-2",
    "text-sm",
    "text-white",
    "transition-all",
    "focus:outline-none",
    "focus:ring-2",
    "focus:ring-opacity-75",
    "disabled:opacity-50",
    "disabled:cursor-default"
  ],
  {
    variants: {
      showConfirm: {
        true: ["bg-red-600"],
        false: ["bg-black"]
      }
    }
  }
), ese = ({
  onDelete: e,
  numberOfQuestions: t = 1,
  className: n = ""
}) => {
  let r = t;
  t > jh.length && (r = jh.length), t < 1 && (r = 1);
  const [i, o] = Ke(!1), [a, s] = Ke(0);
  return /* @__PURE__ */ I.jsxs(
    Un.button,
    {
      layout: !0,
      className: rr(qF({ showConfirm: i }), n),
      children: [
        /* @__PURE__ */ I.jsx("p", { className: "opacity-0", children: "Delete" }),
        /* @__PURE__ */ I.jsx(Cv, { children: /* @__PURE__ */ I.jsx(
          Un.p,
          {
            className: "absolute text-white",
            onClick: () => o(!0),
            exit: KF,
            initial: UF,
            children: !i && "Delete"
          }
        ) }),
        /* @__PURE__ */ I.jsx(Cv, { children: i && /* @__PURE__ */ I.jsx(
          Un.p,
          {
            className: "absolute text-white",
            onClick: () => {
              a < r - 1 ? s((l) => l + 1) : e();
            },
            initial: { y: "200%", top: "50%", left: "50%", x: "-50%" },
            animate: { y: "-50%", top: "50%", left: "50%", x: "-50%" },
            children: jh[a]
          }
        ) })
      ]
    }
  );
}, tse = () => /* @__PURE__ */ I.jsx("hr", { className: "w-full h-px border-t-neutral-600" }), HF = Lr(
  [
    "w-48",
    "h-screen",
    "fixed",
    "top-0",
    "left-[100vw]",
    "bg-white",
    "transition-transform"
  ],
  {
    variants: {
      visible: {
        true: "-translate-x-full",
        false: ""
      }
    }
  }
), nse = ({
  visible: e,
  children: t,
  onClose: n
}) => /* @__PURE__ */ I.jsxs(I.Fragment, { children: [
  e && /* @__PURE__ */ I.jsx(
    "div",
    {
      className: "fixed top-0 left-0 w-screen h-screen bg-black opacity-50",
      onClick: () => n()
    }
  ),
  /* @__PURE__ */ I.jsx("div", { className: HF({ visible: e }), children: t })
] }), Fn = 16, Rv = ({
  sideBarVisible: e,
  onClick: t,
  className: n = ""
}) => /* @__PURE__ */ I.jsxs(
  Un.svg,
  {
    className: `my-auto cursor-pointer ${n}`,
    width: Fn,
    height: Fn,
    viewBox: `0 0 ${Fn} ${Fn}`,
    animate: e ? "open" : "closed",
    onClick: () => t(),
    children: [
      /* @__PURE__ */ I.jsx(
        Un.path,
        {
          className: "fill-transparent stroke-2 stroke-white",
          variants: {
            closed: { d: `M 0 1 L ${Fn} 1` },
            open: { d: `M ${Fn} 0 L 0 ${Fn}` }
          }
        }
      ),
      /* @__PURE__ */ I.jsx(
        Un.path,
        {
          className: "fill-transparent stroke-2 stroke-white",
          d: `M 0 ${Fn / 2} L ${Fn} ${Fn / 2}`,
          variants: {
            closed: { opacity: 1 },
            open: { opacity: 0 }
          },
          transition: { duration: 0.1 }
        }
      ),
      /* @__PURE__ */ I.jsx(
        Un.path,
        {
          className: "fill-transparent stroke-2 stroke-white",
          variants: {
            closed: { d: `M 0 ${Fn - 1} L ${Fn} ${Fn - 1}` },
            open: { d: `M 0 0 L ${Fn} ${Fn}` }
          }
        }
      )
    ]
  }
);
function Na(...e) {
  return (...t) => {
    for (let n of e) typeof n == "function" && n(...t);
  };
}
const dt = typeof document < "u" ? H.useLayoutEffect : () => {
}, nd = {
  prefix: String(Math.round(Math.random() * 1e10)),
  current: 0
}, RT = /* @__PURE__ */ H.createContext(nd), WF = /* @__PURE__ */ H.createContext(!1);
let ZF = !!(typeof window < "u" && window.document && window.document.createElement), Fh = /* @__PURE__ */ new WeakMap();
function GF(e = !1) {
  let t = je(RT), n = ve(null);
  if (n.current === null && !e) {
    let r = (
      // @ts-ignore
      H.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED?.ReactCurrentOwner?.current
    );
    if (r) {
      let i = Fh.get(r);
      i == null ? Fh.set(r, {
        id: t.current,
        state: r.memoizedState
      }) : r.memoizedState !== i.state && (t.current = i.id, Fh.delete(r));
    }
    n.current = ++t.current;
  }
  return n.current;
}
function YF(e) {
  let t = je(RT);
  t === nd && !ZF && process.env.NODE_ENV !== "production" && console.warn("When server rendering, you must wrap your application in an <SSRProvider> to ensure consistent ids are generated between the client and server.");
  let n = GF(!!e), r = t === nd && process.env.NODE_ENV === "test" ? "react-aria" : `react-aria${t.prefix}`;
  return e || `${r}-${n}`;
}
function QF(e) {
  let t = H.useId(), [n] = Ke(nc()), r = n || process.env.NODE_ENV === "test" ? "react-aria" : `react-aria${nd.prefix}`;
  return e || `${r}-${t}`;
}
const JF = typeof H.useId == "function" ? QF : YF;
function XF() {
  return !1;
}
function ez() {
  return !0;
}
function tz(e) {
  return () => {
  };
}
function nc() {
  return typeof H.useSyncExternalStore == "function" ? H.useSyncExternalStore(tz, XF, ez) : je(WF);
}
function nz(e) {
  let [t, n] = Ke(e), r = ve(t), i = ve(null), o = ve(() => {
    if (!i.current) return;
    let s = i.current.next();
    if (s.done) {
      i.current = null;
      return;
    }
    r.current === s.value ? o.current() : n(s.value);
  });
  dt(() => {
    r.current = t, i.current && o.current();
  });
  let a = Le((s) => {
    i.current = s(r.current), o.current();
  }, [
    o
  ]);
  return [
    t,
    a
  ];
}
let rz = !!(typeof window < "u" && window.document && window.document.createElement), Es = /* @__PURE__ */ new Map(), Hl;
typeof FinalizationRegistry < "u" && (Hl = new FinalizationRegistry((e) => {
  Es.delete(e);
}));
function ir(e) {
  let [t, n] = Ke(e), r = ve(null), i = JF(t), o = ve(null);
  if (Hl && Hl.register(o, i), rz) {
    const a = Es.get(i);
    a && !a.includes(r) ? a.push(r) : Es.set(i, [
      r
    ]);
  }
  return dt(() => {
    let a = i;
    return () => {
      Hl && Hl.unregister(o), Es.delete(a);
    };
  }, [
    i
  ]), ze(() => {
    let a = r.current;
    return a && n(a), () => {
      a && (r.current = null);
    };
  }), i;
}
function iz(e, t) {
  if (e === t) return e;
  let n = Es.get(e);
  if (n)
    return n.forEach((i) => i.current = t), t;
  let r = Es.get(t);
  return r ? (r.forEach((i) => i.current = e), e) : t;
}
function va(e = []) {
  let t = ir(), [n, r] = nz(t), i = Le(() => {
    r(function* () {
      yield t, yield document.getElementById(t) ? t : void 0;
    });
  }, [
    t,
    r
  ]);
  return dt(i, [
    t,
    i,
    ...e
  ]), n;
}
function Jy(...e) {
  return e.length === 1 && e[0] ? e[0] : (t) => {
    let n = !1;
    const r = e.map((i) => {
      const o = Ow(i, t);
      return n || (n = typeof o == "function"), o;
    });
    if (n) return () => {
      r.forEach((i, o) => {
        typeof i == "function" ? i() : Ow(e[o], null);
      });
    };
  };
}
function Ow(e, t) {
  if (typeof e == "function") return e(t);
  e != null && (e.current = t);
}
function st(...e) {
  let t = {
    ...e[0]
  };
  for (let n = 1; n < e.length; n++) {
    let r = e[n];
    for (let i in r) {
      let o = t[i], a = r[i];
      typeof o == "function" && typeof a == "function" && // This is a lot faster than a regex.
      i[0] === "o" && i[1] === "n" && i.charCodeAt(2) >= /* 'A' */
      65 && i.charCodeAt(2) <= /* 'Z' */
      90 ? t[i] = Na(o, a) : (i === "className" || i === "UNSAFE_className") && typeof o == "string" && typeof a == "string" ? t[i] = l$(o, a) : i === "id" && o && a ? t.id = iz(o, a) : i === "ref" && o && a ? t.ref = Jy(o, a) : t[i] = a !== void 0 ? a : o;
    }
  }
  return t;
}
function il(e) {
  const t = ve(null), n = ve(void 0), r = Le((i) => {
    if (typeof e == "function") {
      const o = e, a = o(i);
      return () => {
        typeof a == "function" ? a() : o(null);
      };
    } else if (e)
      return e.current = i, () => {
        e.current = null;
      };
  }, [
    e
  ]);
  return Fe(() => ({
    get current() {
      return t.current;
    },
    set current(i) {
      t.current = i, n.current && (n.current(), n.current = void 0), i != null && (n.current = r(i));
    }
  }), [
    r
  ]);
}
const Xy = Symbol("default");
function ja({ values: e, children: t }) {
  for (let [n, r] of e)
    t = /* @__PURE__ */ H.createElement(n.Provider, {
      value: r
    }, t);
  return t;
}
function Vr(e) {
  let { className: t, style: n, children: r, defaultClassName: i, defaultChildren: o, defaultStyle: a, values: s, render: l } = e;
  return Fe(() => {
    let u, c, f;
    return typeof t == "function" ? u = t({
      ...s,
      defaultClassName: i
    }) : u = t, typeof n == "function" ? c = n({
      ...s,
      defaultStyle: a || {}
    }) : c = n, typeof r == "function" ? f = r({
      ...s,
      defaultChildren: o
    }) : r == null ? f = o : f = r, {
      className: u ?? i,
      style: c || a ? {
        ...a,
        ...c
      } : void 0,
      children: f ?? o,
      "data-rac": "",
      render: l ? (d) => l(d, s) : void 0
    };
  }, [
    t,
    n,
    r,
    i,
    o,
    a,
    s,
    l
  ]);
}
function ap(e, t) {
  let n = je(e);
  if (t === null)
    return null;
  if (n && typeof n == "object" && "slots" in n && n.slots) {
    let r = t || Xy;
    if (!n.slots[r]) {
      let i = new Intl.ListFormat().format(Object.keys(n.slots).map((a) => `"${a}"`)), o = t ? `Invalid slot "${t}".` : "A slot prop is required.";
      throw new Error(`${o} Valid slot names are ${i}.`);
    }
    return n.slots[r];
  }
  return n;
}
function Ii(e, t, n) {
  let r = ap(n, e.slot) || {}, { ref: i, ...o } = r, a = il(Fe(() => Jy(t, i), [
    t,
    i
  ])), s = st(o, e);
  return "style" in o && o.style && "style" in e && e.style && (typeof o.style == "function" || typeof e.style == "function" ? s.style = (l) => {
    let u = typeof o.style == "function" ? o.style(l) : o.style, c = {
      ...l.defaultStyle,
      ...u
    }, f = typeof e.style == "function" ? e.style({
      ...l,
      defaultStyle: c
    }) : e.style;
    return {
      ...c,
      ...f
    };
  } : s.style = {
    ...o.style,
    ...e.style
  }), [
    s,
    a
  ];
}
function eb(e = !0) {
  let [t, n] = Ke(e), r = ve(!1), i = Le((o) => {
    r.current = !0, n(!!o);
  }, []);
  return dt(() => {
    r.current || n(!1);
  }, []), [
    i,
    t
  ];
}
function oz(e) {
  const t = /^(data-.*)$/;
  let n = {};
  for (const r in e) t.test(r) || (n[r] = e[r]);
  return n;
}
function az(e, t, n) {
  let { render: r, ...i } = t, o = ve(null), a = Fe(() => Jy(n, o), [
    n,
    o
  ]);
  dt(() => {
    process.env.NODE_ENV !== "production" && r && (o.current ? o.current.localName !== e && console.warn(`Unexpected DOM element returned by custom \`render\` function. Expected <${e}>, got <${o.current.localName}>. This may break the component behavior and accessibility.`) : console.warn("Ref was not connected to DOM element returned by custom `render` function. Did you forget to pass through or merge the `ref`?"));
  }, [
    e,
    r
  ]);
  let s = {
    ...i,
    ref: a
  };
  return r ? r(s, void 0) : /* @__PURE__ */ H.createElement(e, s);
}
const Pw = {}, Hn = new Proxy({}, {
  get(e, t) {
    if (typeof t != "string") return;
    let n = Pw[t];
    return n || (n = /* @__PURE__ */ fn(az.bind(null, t)), Pw[t] = n), n;
  }
}), sz = "react-aria-clear-focus", lz = "react-aria-focus", ot = (e) => e?.ownerDocument ?? document, Pn = (e) => e && "window" in e && e.window === e ? e : ot(e).defaultView || window;
function uz(e) {
  return e !== null && typeof e == "object" && "nodeType" in e && typeof e.nodeType == "number";
}
function cz(e) {
  return uz(e) && e.nodeType === Node.DOCUMENT_FRAGMENT_NODE && "host" in e;
}
let fz = !1;
function Fi() {
  return fz;
}
function Je(e, t) {
  if (!Fi()) return t && e ? e.contains(t) : !1;
  if (!e || !t) return !1;
  let n = t;
  for (; n !== null; ) {
    if (n === e) return !0;
    n.tagName === "SLOT" && n.assignedSlot ? n = n.assignedSlot.parentNode : cz(n) ? n = n.host : n = n.parentNode;
  }
  return !1;
}
const Lt = (e = document) => {
  if (!Fi()) return e.activeElement;
  let t = e.activeElement;
  for (; t && "shadowRoot" in t && t.shadowRoot?.activeElement; ) t = t.shadowRoot.activeElement;
  return t;
};
function Ae(e) {
  if (Fi() && e.target instanceof Element && e.target.shadowRoot) {
    if ("composedPath" in e) return e.composedPath()[0] ?? null;
    if ("composedPath" in e.nativeEvent) return e.nativeEvent.composedPath()[0] ?? null;
  }
  return e.target;
}
function rd(e) {
  if (!e) return !1;
  let t = e.getRootNode(), n = Pn(e);
  if (!(t instanceof n.Document || t instanceof n.ShadowRoot)) return !1;
  let r = t.activeElement;
  return r != null && e.contains(r);
}
function NT(e) {
  let t = pz(ot(e));
  t !== e && (t && dz(t, e), e && jT(e, t));
}
function dz(e, t) {
  e.dispatchEvent(new FocusEvent("blur", {
    relatedTarget: t
  })), e.dispatchEvent(new FocusEvent("focusout", {
    bubbles: !0,
    relatedTarget: t
  }));
}
function jT(e, t) {
  e.dispatchEvent(new FocusEvent("focus", {
    relatedTarget: t
  })), e.dispatchEvent(new FocusEvent("focusin", {
    bubbles: !0,
    relatedTarget: t
  }));
}
function pz(e) {
  let t = Lt(e), n = t?.getAttribute("aria-activedescendant");
  return n && e.getElementById(n) || t;
}
function ai(e) {
  if (hz()) e.focus({
    preventScroll: !0
  });
  else {
    let t = mz(e);
    e.focus(), vz(t);
  }
}
let Mc = null;
function hz() {
  if (Mc == null) {
    Mc = !1;
    try {
      document.createElement("div").focus({
        get preventScroll() {
          return Mc = !0, !0;
        }
      });
    } catch {
    }
  }
  return Mc;
}
function mz(e) {
  let t = e.parentNode, n = [], r = document.scrollingElement || document.documentElement;
  for (; t instanceof HTMLElement && t !== r; )
    (t.offsetHeight < t.scrollHeight || t.offsetWidth < t.scrollWidth) && n.push({
      element: t,
      scrollTop: t.scrollTop,
      scrollLeft: t.scrollLeft
    }), t = t.parentNode;
  return r instanceof HTMLElement && n.push({
    element: r,
    scrollTop: r.scrollTop,
    scrollLeft: r.scrollLeft
  }), n;
}
function vz(e) {
  for (let { element: t, scrollTop: n, scrollLeft: r } of e)
    t.scrollTop = n, t.scrollLeft = r;
}
const gz = typeof Element < "u" && "checkVisibility" in Element.prototype;
function yz(e) {
  const t = Pn(e);
  if (!(e instanceof t.HTMLElement) && !(e instanceof t.SVGElement)) return !1;
  let { display: n, visibility: r } = e.style, i = n !== "none" && r !== "hidden" && r !== "collapse";
  if (i) {
    const { getComputedStyle: o } = Pn(e);
    let { display: a, visibility: s } = o(e);
    i = a !== "none" && s !== "hidden" && s !== "collapse";
  }
  return i;
}
function bz(e, t) {
  return !e.hasAttribute("hidden") && // Ignore HiddenSelect when tree walking.
  !e.hasAttribute("data-react-aria-prevent-focus") && (e.nodeName === "DETAILS" && t && t.nodeName !== "SUMMARY" ? e.hasAttribute("open") : !0);
}
function tb(e, t) {
  return gz ? e.checkVisibility({
    visibilityProperty: !0
  }) && !e.closest("[data-react-aria-prevent-focus]") : e.nodeName !== "#comment" && yz(e) && bz(e, t) && (!e.parentElement || tb(e.parentElement, e));
}
const nb = [
  "input:not([disabled]):not([type=hidden])",
  "select:not([disabled])",
  "textarea:not([disabled])",
  "button:not([disabled])",
  "a[href]",
  "area[href]",
  "summary",
  "iframe",
  "object",
  "embed",
  "audio[controls]",
  "video[controls]",
  '[contenteditable]:not([contenteditable^="false"])',
  "permission"
], _z = nb.join(":not([hidden]),") + ",[tabindex]:not([disabled]):not([hidden])";
nb.push('[tabindex]:not([tabindex="-1"]):not([disabled])');
const wz = nb.join(':not([hidden]):not([tabindex="-1"]),');
function FT(e, t) {
  return e.matches(_z) && !LT(e) && (t?.skipVisibilityCheck || tb(e));
}
function zT(e) {
  return e.matches(wz) && tb(e) && !LT(e);
}
function LT(e) {
  let t = e;
  for (; t != null; ) {
    if (t instanceof Pn(t).HTMLElement && t.inert) return !0;
    t = t.parentElement;
  }
  return !1;
}
function rb(e) {
  let t = e;
  return t.nativeEvent = e, t.isDefaultPrevented = () => t.defaultPrevented, t.isPropagationStopped = () => t.cancelBubble, t.persist = () => {
  }, t;
}
function VT(e, t) {
  Object.defineProperty(e, "target", {
    value: t
  }), Object.defineProperty(e, "currentTarget", {
    value: t
  });
}
function BT(e) {
  let t = ve({
    isFocused: !1,
    observer: null
  });
  return dt(() => {
    const n = t.current;
    return () => {
      n.observer && (n.observer.disconnect(), n.observer = null);
    };
  }, []), Le((n) => {
    let r = Ae(n);
    if (r instanceof HTMLButtonElement || r instanceof HTMLInputElement || r instanceof HTMLTextAreaElement || r instanceof HTMLSelectElement) {
      t.current.isFocused = !0;
      let i = r, o = (a) => {
        if (t.current.isFocused = !1, i.disabled) {
          let s = rb(a);
          e?.(s);
        }
        t.current.observer && (t.current.observer.disconnect(), t.current.observer = null);
      };
      i.addEventListener("focusout", o, {
        once: !0
      }), t.current.observer = new MutationObserver(() => {
        if (t.current.isFocused && i.disabled) {
          t.current.observer?.disconnect();
          let a = i === Lt() ? null : Lt();
          i.dispatchEvent(new FocusEvent("blur", {
            relatedTarget: a
          })), i.dispatchEvent(new FocusEvent("focusout", {
            bubbles: !0,
            relatedTarget: a
          }));
        }
      }), t.current.observer.observe(i, {
        attributes: !0,
        attributeFilter: [
          "disabled"
        ]
      });
    }
  }, [
    e
  ]);
}
let id = !1;
function Aw(e) {
  for (; e && !FT(e, {
    skipVisibilityCheck: !0
  }); ) e = e.parentElement;
  let t = Pn(e), n = t.document.activeElement;
  if (!n || n === e) return;
  id = !0;
  let r = !1, i = (c) => {
    (Ae(c) === n || r) && c.stopImmediatePropagation();
  }, o = (c) => {
    (Ae(c) === n || r) && (c.stopImmediatePropagation(), !e && !r && (r = !0, ai(n), l()));
  }, a = (c) => {
    (Ae(c) === e || r) && c.stopImmediatePropagation();
  }, s = (c) => {
    (Ae(c) === e || r) && (c.stopImmediatePropagation(), r || (r = !0, ai(n), l()));
  };
  t.addEventListener("blur", i, !0), t.addEventListener("focusout", o, !0), t.addEventListener("focusin", s, !0), t.addEventListener("focus", a, !0);
  let l = () => {
    cancelAnimationFrame(u), t.removeEventListener("blur", i, !0), t.removeEventListener("focusout", o, !0), t.removeEventListener("focusin", s, !0), t.removeEventListener("focus", a, !0), id = !1, r = !1;
  }, u = requestAnimationFrame(l);
  return l;
}
function sp(e) {
  if (typeof window > "u" || window.navigator == null) return !1;
  let t = window.navigator.userAgentData?.brands;
  return Array.isArray(t) && t.some((n) => e.test(n.brand)) || e.test(window.navigator.userAgent);
}
function ib(e) {
  return typeof window < "u" && window.navigator != null ? e.test(window.navigator.userAgentData?.platform || window.navigator.platform) : !1;
}
function to(e) {
  if (process.env.NODE_ENV === "test") return e;
  let t = null;
  return () => (t == null && (t = e()), t);
}
const xa = to(function() {
  return ib(/^Mac/i);
}), xz = to(function() {
  return ib(/^iPhone/i);
}), KT = to(function() {
  return ib(/^iPad/i) || // iPadOS 13 lies and says it's a Mac, but we can distinguish by detecting touch support.
  xa() && navigator.maxTouchPoints > 1;
}), rc = to(function() {
  return xz() || KT();
}), Ez = to(function() {
  return xa() || rc();
}), UT = to(function() {
  return sp(/AppleWebKit/i) && !qT();
}), qT = to(function() {
  return sp(/Chrome/i);
}), ob = to(function() {
  return sp(/Android/i);
}), Sz = to(function() {
  return sp(/Firefox/i);
});
function Nv(e) {
  return e.pointerType === "" && e.isTrusted ? !0 : ob() && e.pointerType ? e.type === "click" && e.buttons === 1 : e.detail === 0 && !e.pointerType;
}
function $z(e) {
  return !ob() && e.width === 0 && e.height === 0 || e.width === 1 && e.height === 1 && e.pressure === 0 && e.detail === 0 && e.pointerType === "mouse";
}
const kz = /* @__PURE__ */ He({
  isNative: !0,
  open: Pz,
  useHref: (e) => e
});
function lp() {
  return je(kz);
}
function Tz(e, t) {
  let n = e.getAttribute("target");
  return (!n || n === "_self") && e.origin === location.origin && !e.hasAttribute("download") && !t.metaKey && // open in new tab (mac)
  !t.ctrlKey && // open in new tab (windows)
  !t.altKey && // download
  !t.shiftKey;
}
function Zi(e, t, n = !0) {
  let { metaKey: r, ctrlKey: i, altKey: o, shiftKey: a } = t;
  Sz() && window.event?.type?.startsWith("key") && e.target === "_blank" && (xa() ? r = !0 : i = !0);
  let s = UT() && xa() && !KT() && process.env.NODE_ENV !== "test" ? new KeyboardEvent("keydown", {
    keyIdentifier: "Enter",
    metaKey: r,
    ctrlKey: i,
    altKey: o,
    shiftKey: a
  }) : new MouseEvent("click", {
    metaKey: r,
    ctrlKey: i,
    altKey: o,
    shiftKey: a,
    detail: 1,
    bubbles: !0,
    cancelable: !0
  });
  Zi.isOpening = n, ai(e), e.dispatchEvent(s), Zi.isOpening = !1;
}
Zi.isOpening = !1;
function Oz(e, t) {
  if (e instanceof HTMLAnchorElement) t(e);
  else if (e.hasAttribute("data-href")) {
    let n = document.createElement("a");
    n.href = e.getAttribute("data-href"), e.hasAttribute("data-target") && (n.target = e.getAttribute("data-target")), e.hasAttribute("data-rel") && (n.rel = e.getAttribute("data-rel")), e.hasAttribute("data-download") && (n.download = e.getAttribute("data-download")), e.hasAttribute("data-ping") && (n.ping = e.getAttribute("data-ping")), e.hasAttribute("data-referrer-policy") && (n.referrerPolicy = e.getAttribute("data-referrer-policy")), e.appendChild(n), t(n), e.removeChild(n);
  }
}
function Pz(e, t) {
  Oz(e, (n) => Zi(n, t));
}
function HT(e) {
  const n = lp().useHref(e?.href ?? "");
  let r = {};
  if (e)
    for (let i of [
      "href",
      "target",
      "rel",
      "download",
      "ping",
      "referrerPolicy"
    ]) i in e && (r[i] = i === "href" ? n : e[i]);
  return r;
}
function Az(e, t, n, r) {
  !t.isNative && e.currentTarget instanceof HTMLAnchorElement && e.currentTarget.href && // If props are applied to a router Link component, it may have already prevented default.
  !e.isDefaultPrevented() && Tz(e.currentTarget, e) && n && (e.preventDefault(), t.open(e.currentTarget, e, n, r));
}
let Fa = null;
const jv = /* @__PURE__ */ new Set();
let lu = /* @__PURE__ */ new Map(), Ea = !1, Fv = !1;
const Dz = {
  Tab: !0,
  Escape: !0
};
function up(e, t) {
  for (let n of jv) n(e, t);
}
function Cz(e) {
  return !(e.metaKey || !xa() && e.altKey || e.ctrlKey || e.key === "Control" || e.key === "Shift" || e.key === "Meta");
}
function od(e) {
  Ea = !0, !Zi.isOpening && Cz(e) && (Fa = "keyboard", up("keyboard", e));
}
function Sr(e) {
  Fa = "pointer", "pointerType" in e && e.pointerType, (e.type === "mousedown" || e.type === "pointerdown") && (Ea = !0, up("pointer", e));
}
function WT(e) {
  !Zi.isOpening && Nv(e) && (Ea = !0, Fa = "virtual");
}
function ZT(e) {
  let t = Pn(Ae(e)), n = ot(Ae(e));
  Ae(e) === t || Ae(e) === n || id || !e.isTrusted || (!Ea && !Fv && (Fa = "virtual", up("virtual", e)), Ea = !1, Fv = !1);
}
function GT() {
  id || (Ea = !1, Fv = !0);
}
function zv(e) {
  if (typeof window > "u" || typeof document > "u") return;
  const t = Pn(e), n = ot(e);
  if (lu.get(t)) return;
  let r = t.HTMLElement.prototype.focus;
  Reflect.defineProperty(t.HTMLElement.prototype, "focus", {
    configurable: !0,
    writable: !0,
    value: function() {
      Ea = !0, r.apply(this, arguments);
    }
  }), n.addEventListener("keydown", od, !0), n.addEventListener("keyup", od, !0), n.addEventListener("click", WT, !0), t.addEventListener("focus", ZT, !0), t.addEventListener("blur", GT, !1), typeof PointerEvent < "u" ? (n.addEventListener("pointerdown", Sr, !0), n.addEventListener("pointermove", Sr, !0), n.addEventListener("pointerup", Sr, !0)) : process.env.NODE_ENV === "test" && (n.addEventListener("mousedown", Sr, !0), n.addEventListener("mousemove", Sr, !0), n.addEventListener("mouseup", Sr, !0)), t.addEventListener("beforeunload", () => {
    YT(e);
  }, {
    once: !0
  }), lu.set(t, {
    focus: r
  });
}
const YT = (e, t) => {
  const n = Pn(e), r = ot(e);
  t && r.removeEventListener("DOMContentLoaded", t), lu.has(n) && (Reflect.defineProperty(n.HTMLElement.prototype, "focus", {
    configurable: !0,
    writable: !0,
    value: lu.get(n).focus
  }), r.removeEventListener("keydown", od, !0), r.removeEventListener("keyup", od, !0), r.removeEventListener("click", WT, !0), n.removeEventListener("focus", ZT, !0), n.removeEventListener("blur", GT, !1), typeof PointerEvent < "u" ? (r.removeEventListener("pointerdown", Sr, !0), r.removeEventListener("pointermove", Sr, !0), r.removeEventListener("pointerup", Sr, !0)) : process.env.NODE_ENV === "test" && (r.removeEventListener("mousedown", Sr, !0), r.removeEventListener("mousemove", Sr, !0), r.removeEventListener("mouseup", Sr, !0)), lu.delete(n));
};
function Iz(e) {
  const t = ot(e);
  let n;
  return t.readyState !== "loading" ? zv(e) : (n = () => {
    zv(e);
  }, t.addEventListener("DOMContentLoaded", n)), () => YT(e, n);
}
typeof document < "u" && Iz();
function Sa() {
  return Fa !== "pointer";
}
function Su() {
  return Fa;
}
function ad(e) {
  Fa = e, up(e, null);
}
const Mz = /* @__PURE__ */ new Set([
  "checkbox",
  "radio",
  "range",
  "color",
  "file",
  "image",
  "button",
  "submit",
  "reset"
]);
function Rz(e, t, n) {
  let r = n ? Ae(n) : void 0, i = ot(r), o = Pn(r);
  const a = typeof o < "u" ? o.HTMLInputElement : HTMLInputElement, s = typeof o < "u" ? o.HTMLTextAreaElement : HTMLTextAreaElement, l = typeof o < "u" ? o.HTMLElement : HTMLElement, u = typeof o < "u" ? o.KeyboardEvent : KeyboardEvent;
  let c = Lt(i);
  return e = e || c instanceof a && !Mz.has(c.type) || c instanceof s || c instanceof l && c.isContentEditable, !(e && t === "keyboard" && n instanceof u && !Dz[n.key]);
}
function Nz(e, t, n) {
  zv(), ze(() => {
    if (n?.enabled === !1) return;
    let r = (i, o) => {
      Rz(!!n?.isTextInput, i, o) && e(Sa());
    };
    return jv.add(r), () => {
      jv.delete(r);
    };
  }, t);
}
function ns(e) {
  return xa() ? e.metaKey : e.ctrlKey;
}
const jz = /* @__PURE__ */ new Set([
  "checkbox",
  "radio",
  "range",
  "color",
  "file",
  "image",
  "button",
  "submit",
  "reset"
]);
function zh(e) {
  return e instanceof HTMLInputElement && !jz.has(e.type) || e instanceof HTMLTextAreaElement || e instanceof HTMLElement && e.isContentEditable;
}
const Fz = H.useInsertionEffect ?? dt;
function Rr(e) {
  const t = ve(null);
  return Fz(() => {
    t.current = e;
  }, [
    e
  ]), Le((...n) => {
    const r = t.current;
    return r?.(...n);
  }, []);
}
function Rc(e, t, n, r) {
  let i = Rr(n), o = n == null;
  ze(() => {
    if (o || !e.current) return;
    let a = e.current;
    return a.addEventListener(t, i, r), () => {
      a.removeEventListener(t, i, r);
    };
  }, [
    e,
    t,
    r,
    o
  ]);
}
function QT(e, t) {
  let { id: n, "aria-label": r, "aria-labelledby": i } = e;
  return n = ir(n), i && r ? i = [
    .../* @__PURE__ */ new Set([
      n,
      ...i.trim().split(/\s+/)
    ])
  ].join(" ") : i && (i = i.trim().split(/\s+/).join(" ")), !r && !i && t && (r = t), {
    id: n,
    "aria-label": r,
    "aria-labelledby": i
  };
}
const zz = /* @__PURE__ */ new Set([
  "Arab",
  "Syrc",
  "Samr",
  "Mand",
  "Thaa",
  "Mend",
  "Nkoo",
  "Adlm",
  "Rohg",
  "Hebr"
]), Lz = /* @__PURE__ */ new Set([
  "ae",
  "ar",
  "arc",
  "bcc",
  "bqi",
  "ckb",
  "dv",
  "fa",
  "glk",
  "he",
  "ku",
  "mzn",
  "nqo",
  "pnb",
  "ps",
  "sd",
  "ug",
  "ur",
  "yi"
]);
function Vz(e) {
  if (Intl.Locale) {
    let n = new Intl.Locale(e).maximize(), r = (
      // @ts-ignore - this was implemented as a property by some browsers before it was standardized as a function.
      typeof n.getTextInfo == "function" ? n.getTextInfo() : n.textInfo
    );
    if (r) return r.direction === "rtl";
    if (n.script) return zz.has(n.script);
  }
  let t = e.split("-")[0];
  return Lz.has(t);
}
const JT = Symbol.for("react-aria.i18n.locale");
function XT() {
  let e = typeof window < "u" && window[JT] || // @ts-ignore
  typeof navigator < "u" && (navigator.language || navigator.userLanguage) || "en-US";
  try {
    Intl.DateTimeFormat.supportedLocalesOf([
      e
    ]);
  } catch {
    e = "en-US";
  }
  return {
    locale: e,
    direction: Vz(e) ? "rtl" : "ltr"
  };
}
let Lv = XT(), Wl = /* @__PURE__ */ new Set();
function Dw() {
  Lv = XT();
  for (let e of Wl) e(Lv);
}
function Bz() {
  let e = nc(), [t, n] = Ke(Lv);
  return ze(() => (Wl.size === 0 && window.addEventListener("languagechange", Dw), Wl.add(n), () => {
    Wl.delete(n), Wl.size === 0 && window.removeEventListener("languagechange", Dw);
  }), []), e ? {
    locale: typeof window < "u" && window[JT] || "en-US",
    direction: "ltr"
  } : t;
}
const Kz = /* @__PURE__ */ H.createContext(null);
function ol() {
  let e = Bz();
  return je(Kz) || e;
}
const Uz = Symbol.for("react-aria.i18n.locale"), qz = Symbol.for("react-aria.i18n.strings");
let Nc;
class cp {
  constructor(t, n = "en-US") {
    this.strings = Object.fromEntries(Object.entries(t).filter(([, r]) => r)), this.defaultLocale = n;
  }
  /** Returns a localized string for the given key and locale. */
  getStringForLocale(t, n) {
    let i = this.getStringsForLocale(n)[t];
    if (!i) throw new Error(`Could not find intl message ${t} in ${n} locale`);
    return i;
  }
  /** Returns all localized strings for the given locale. */
  getStringsForLocale(t) {
    let n = this.strings[t];
    return n || (n = Hz(t, this.strings, this.defaultLocale), this.strings[t] = n), n;
  }
  static getGlobalDictionaryForPackage(t) {
    if (typeof window > "u") return null;
    let n = window[Uz];
    if (Nc === void 0) {
      let i = window[qz];
      if (!i) return null;
      Nc = {};
      for (let o in i) Nc[o] = new cp({
        [n]: i[o]
      }, n);
    }
    let r = Nc?.[t];
    if (!r) throw new Error(`Strings for package "${t}" were not included by LocalizedStringProvider. Please add it to the list passed to createLocalizedStringDictionary.`);
    return r;
  }
}
function Hz(e, t, n = "en-US") {
  if (t[e]) return t[e];
  let r = Wz(e);
  if (t[r]) return t[r];
  for (let i in t)
    if (i.startsWith(r + "-")) return t[i];
  return t[n];
}
function Wz(e) {
  return Intl.Locale ? new Intl.Locale(e).language : e.split("-")[0];
}
const Cw = /* @__PURE__ */ new Map(), Iw = /* @__PURE__ */ new Map();
class Zz {
  constructor(t, n) {
    this.locale = t, this.strings = n;
  }
  /** Formats a localized string for the given key with the provided variables. */
  format(t, n) {
    let r = this.strings.getStringForLocale(t, this.locale);
    return typeof r == "function" ? r(n, this) : r;
  }
  plural(t, n, r = "cardinal") {
    let i = n["=" + t];
    if (i) return typeof i == "function" ? i() : i;
    let o = this.locale + ":" + r, a = Cw.get(o);
    a || (a = new Intl.PluralRules(this.locale, {
      type: r
    }), Cw.set(o, a));
    let s = a.select(t);
    return i = n[s] || n.other, typeof i == "function" ? i() : i;
  }
  number(t) {
    let n = Iw.get(this.locale);
    return n || (n = new Intl.NumberFormat(this.locale), Iw.set(this.locale, n)), n.format(t);
  }
  select(t, n) {
    let r = t[n] || t.other;
    return typeof r == "function" ? r() : r;
  }
}
const Mw = /* @__PURE__ */ new WeakMap();
function Gz(e) {
  let t = Mw.get(e);
  return t || (t = new cp(e), Mw.set(e, t)), t;
}
function Yz(e, t) {
  return t && cp.getGlobalDictionaryForPackage(t) || Gz(e);
}
function eO(e, t) {
  let { locale: n } = ol(), r = Yz(e, t);
  return Fe(() => new Zz(n, r), [
    n,
    r
  ]);
}
const Qz = typeof document < "u" ? H.useInsertionEffect ?? H.useLayoutEffect : () => {
};
function fp(e, t, n) {
  let [r, i] = Ke(e || t), o = ve(r), a = ve(e !== void 0), s = e !== void 0;
  ze(() => {
    let f = a.current;
    f !== s && process.env.NODE_ENV !== "production" && console.warn(`WARN: A component changed from ${f ? "controlled" : "uncontrolled"} to ${s ? "controlled" : "uncontrolled"}.`), a.current = s;
  }, [
    s
  ]);
  let l = s ? e : r;
  Qz(() => {
    o.current = l;
  });
  let [, u] = JS(() => ({}), {}), c = Le((f, ...d) => {
    let p = typeof f == "function" ? f(o.current) : f;
    Object.is(o.current, p) || (o.current = p, i(p), u(), n?.(p, ...d));
  }, [
    n
  ]);
  return [
    l,
    c
  ];
}
const Vv = /* @__PURE__ */ He(null), Jz = /* @__PURE__ */ He(null);
class al {
  constructor(t) {
    this.value = null, this.level = 0, this.hasChildNodes = !1, this.rendered = null, this.textValue = "", this["aria-label"] = void 0, this.index = 0, this.parentKey = null, this.prevKey = null, this.nextKey = null, this.firstChildKey = null, this.lastChildKey = null, this.props = {}, this.colSpan = null, this.colIndex = null, this.type = this.constructor.type, this.key = t;
  }
  get childNodes() {
    throw new Error("childNodes is not supported");
  }
  clone() {
    let t = new this.constructor(this.key);
    return t.value = this.value, t.level = this.level, t.hasChildNodes = this.hasChildNodes, t.rendered = this.rendered, t.textValue = this.textValue, t["aria-label"] = this["aria-label"], t.index = this.index, t.parentKey = this.parentKey, t.prevKey = this.prevKey, t.nextKey = this.nextKey, t.firstChildKey = this.firstChildKey, t.lastChildKey = this.lastChildKey, t.props = this.props, t.render = this.render, t.colSpan = this.colSpan, t.colIndex = this.colIndex, t;
  }
  filter(t, n, r) {
    let i = this.clone();
    return n.addDescendants(i, t), i;
  }
}
class tO extends al {
  filter(t, n, r) {
    let [i, o] = nO(t, n, this.firstChildKey, r), a = this.clone();
    return a.firstChildKey = i, a.lastChildKey = o, a;
  }
}
const t1 = class t1 extends al {
};
t1.type = "header";
let Rw = t1;
const n1 = class n1 extends al {
};
n1.type = "loader";
let Bv = n1;
const r1 = class r1 extends tO {
  filter(t, n, r) {
    if (r(this.textValue, this)) {
      let i = this.clone();
      return n.addDescendants(i, t), i;
    }
    return null;
  }
};
r1.type = "item";
let sd = r1;
const i1 = class i1 extends tO {
  filter(t, n, r) {
    let i = super.filter(t, n, r);
    if (i && i.lastChildKey !== null) {
      let o = t.getItem(i.lastChildKey);
      if (o && o.type !== "header") return i;
    }
    return null;
  }
};
i1.type = "section";
let Nw = i1;
class Xz {
  get size() {
    return this.itemCount;
  }
  getKeys() {
    return this.keyMap.keys();
  }
  *[Symbol.iterator]() {
    let t = this.firstKey != null ? this.keyMap.get(this.firstKey) : void 0;
    for (; t; )
      yield t, t = t.nextKey != null ? this.keyMap.get(t.nextKey) : void 0;
  }
  getChildren(t) {
    let n = this.keyMap;
    return {
      *[Symbol.iterator]() {
        let r = n.get(t), i = r?.firstChildKey != null ? n.get(r.firstChildKey) : null;
        for (; i; )
          yield i, i = i.nextKey != null ? n.get(i.nextKey) : void 0;
      }
    };
  }
  getKeyBefore(t) {
    let n = this.keyMap.get(t);
    if (!n) return null;
    if (n.prevKey != null) {
      for (n = this.keyMap.get(n.prevKey); n && n.type !== "item" && n.lastChildKey != null; ) n = this.keyMap.get(n.lastChildKey);
      return n?.key ?? null;
    }
    return n.parentKey;
  }
  getKeyAfter(t) {
    let n = this.keyMap.get(t);
    if (!n) return null;
    if (n.type !== "item" && n.firstChildKey != null) return n.firstChildKey;
    for (; n; ) {
      if (n.nextKey != null) return n.nextKey;
      if (n.parentKey != null) n = this.keyMap.get(n.parentKey);
      else return null;
    }
    return null;
  }
  getFirstKey() {
    return this.firstKey;
  }
  getLastKey() {
    let t = this.lastKey != null ? this.keyMap.get(this.lastKey) : null;
    for (; t?.lastChildKey != null; ) t = this.keyMap.get(t.lastChildKey);
    return t?.key ?? null;
  }
  getItem(t) {
    return this.keyMap.get(t) ?? null;
  }
  at() {
    throw new Error("Not implemented");
  }
  clone() {
    let t = this.constructor, n = new t();
    return n.keyMap = new Map(this.keyMap), n.firstKey = this.firstKey, n.lastKey = this.lastKey, n.itemCount = this.itemCount, n;
  }
  addNode(t) {
    if (this.frozen) throw new Error("Cannot add a node to a frozen collection");
    t.type === "item" && this.keyMap.get(t.key) == null && this.itemCount++, this.keyMap.set(t.key, t);
  }
  // Deeply add a node and its children to the collection from another collection, primarily used when filtering a collection
  addDescendants(t, n) {
    this.addNode(t);
    let r = n.getChildren(t.key);
    for (let i of r) this.addDescendants(i, n);
  }
  removeNode(t) {
    if (this.frozen) throw new Error("Cannot remove a node to a frozen collection");
    let n = this.keyMap.get(t);
    n != null && n.type === "item" && this.itemCount--, this.keyMap.delete(t);
  }
  commit(t, n, r = !1) {
    if (this.frozen) throw new Error("Cannot commit a frozen collection");
    this.firstKey = t, this.lastKey = n, this.frozen = !r;
  }
  filter(t) {
    let n = new this.constructor(), [r, i] = nO(this, n, this.firstKey, t);
    return n?.commit(r, i), n;
  }
  constructor() {
    this.keyMap = /* @__PURE__ */ new Map(), this.firstKey = null, this.lastKey = null, this.frozen = !1, this.itemCount = 0;
  }
}
function nO(e, t, n, r) {
  if (n == null) return [
    null,
    null
  ];
  let i = null, o = null, a = e.getItem(n);
  for (; a != null; ) {
    let s = a.filter(e, t, r);
    s != null && (s.nextKey = null, o && (s.prevKey = o.key, o.nextKey = s.key), i == null && (i = s), t.addNode(s), o = s), a = a.nextKey != null ? e.getItem(a.nextKey) : null;
  }
  if (o && o.type === "separator") {
    let s = o.prevKey;
    t.removeNode(o.key), s != null ? (o = t.getItem(s), o.nextKey = null) : o = null;
  }
  return [
    i?.key ?? null,
    o?.key ?? null
  ];
}
class rO {
  constructor(t) {
    this._firstChild = null, this._lastChild = null, this._previousSibling = null, this._nextSibling = null, this._parentNode = null, this._minInvalidChildIndex = null, this.ownerDocument = t;
  }
  *[Symbol.iterator]() {
    let t = this.firstChild;
    for (; t; )
      yield t, t = t.nextSibling;
  }
  get firstChild() {
    return this._firstChild;
  }
  set firstChild(t) {
    this._firstChild = t, this.ownerDocument.markDirty(this);
  }
  get lastChild() {
    return this._lastChild;
  }
  set lastChild(t) {
    this._lastChild = t, this.ownerDocument.markDirty(this);
  }
  get previousSibling() {
    return this._previousSibling;
  }
  set previousSibling(t) {
    this._previousSibling = t, this.ownerDocument.markDirty(this);
  }
  get nextSibling() {
    return this._nextSibling;
  }
  set nextSibling(t) {
    this._nextSibling = t, this.ownerDocument.markDirty(this);
  }
  get parentNode() {
    return this._parentNode;
  }
  set parentNode(t) {
    this._parentNode = t, this.ownerDocument.markDirty(this);
  }
  get isConnected() {
    return this.parentNode?.isConnected || !1;
  }
  invalidateChildIndices(t) {
    (this._minInvalidChildIndex == null || !this._minInvalidChildIndex.isConnected || t.index < this._minInvalidChildIndex.index) && (this._minInvalidChildIndex = t, this.ownerDocument.markDirty(this));
  }
  updateChildIndices() {
    let t = this._minInvalidChildIndex;
    for (; t; )
      t.index = t.previousSibling ? t.previousSibling.index + 1 : 0, t = t.nextSibling;
    this._minInvalidChildIndex = null;
  }
  appendChild(t) {
    t.parentNode && t.parentNode.removeChild(t), this.firstChild == null && (this.firstChild = t), this.lastChild ? (this.lastChild.nextSibling = t, t.index = this.lastChild.index + 1, t.previousSibling = this.lastChild) : (t.previousSibling = null, t.index = 0), t.parentNode = this, t.nextSibling = null, this.lastChild = t, this.ownerDocument.markDirty(this), this.isConnected && this.ownerDocument.queueUpdate();
  }
  insertBefore(t, n) {
    if (n == null) return this.appendChild(t);
    t.parentNode && t.parentNode.removeChild(t), t.nextSibling = n, t.previousSibling = n.previousSibling, t.index = n.index - 1, this.firstChild === n ? this.firstChild = t : n.previousSibling && (n.previousSibling.nextSibling = t), n.previousSibling = t, t.parentNode = n.parentNode, this.invalidateChildIndices(t), this.isConnected && this.ownerDocument.queueUpdate();
  }
  removeChild(t) {
    t.parentNode === this && (this._minInvalidChildIndex === t && (this._minInvalidChildIndex = null), t.nextSibling && (this.invalidateChildIndices(t.nextSibling), t.nextSibling.previousSibling = t.previousSibling), t.previousSibling && (t.previousSibling.nextSibling = t.nextSibling), this.firstChild === t && (this.firstChild = t.nextSibling), this.lastChild === t && (this.lastChild = t.previousSibling), t.parentNode = null, t.nextSibling = null, t.previousSibling = null, t.index = 0, this.ownerDocument.markDirty(t), this.isConnected && this.ownerDocument.queueUpdate());
  }
  addEventListener() {
  }
  removeEventListener() {
  }
  get previousVisibleSibling() {
    let t = this.previousSibling;
    for (; t && t.isHidden; ) t = t.previousSibling;
    return t;
  }
  get nextVisibleSibling() {
    let t = this.nextSibling;
    for (; t && t.isHidden; ) t = t.nextSibling;
    return t;
  }
  get firstVisibleChild() {
    let t = this.firstChild;
    for (; t && t.isHidden; ) t = t.nextSibling;
    return t;
  }
  get lastVisibleChild() {
    let t = this.lastChild;
    for (; t && t.isHidden; ) t = t.previousSibling;
    return t;
  }
}
class Ss extends rO {
  constructor(t, n) {
    super(n), this.nodeType = 8, this.isMutated = !0, this._index = 0, this.isHidden = !1, this.node = null;
  }
  get index() {
    return this._index;
  }
  set index(t) {
    this._index = t, this.ownerDocument.markDirty(this);
  }
  get level() {
    return this.parentNode instanceof Ss ? this.parentNode.level + (this.parentNode.node?.type === "item" ? 1 : 0) : 0;
  }
  /**
  * Lazily gets a mutable instance of a Node. If the node has already
  * been cloned during this update cycle, it just returns the existing one.
  */
  getMutableNode() {
    return this.node == null ? null : (this.isMutated || (this.node = this.node.clone(), this.isMutated = !0), this.ownerDocument.markDirty(this), this.node);
  }
  updateNode() {
    let t = this.nextVisibleSibling, n = this.getMutableNode();
    if (n != null && (n.index = this.index, n.level = this.level, n.parentKey = this.parentNode instanceof Ss ? this.parentNode.node?.key ?? null : null, n.prevKey = this.previousVisibleSibling?.node?.key ?? null, n.nextKey = t?.node?.key ?? null, n.hasChildNodes = !!this.firstChild, n.firstChildKey = this.firstVisibleChild?.node?.key ?? null, n.lastChildKey = this.lastVisibleChild?.node?.key ?? null, (n.colSpan != null || n.colIndex != null) && t)) {
      let r = (n.colIndex ?? n.index) + (n.colSpan ?? 1);
      if (t.node != null && r !== t.node.colIndex) {
        let i = t.getMutableNode();
        i.colIndex = r;
      }
    }
  }
  setProps(t, n, r, i, o) {
    let a, { value: s, textValue: l, id: u, ...c } = t;
    if (this.node == null ? (a = new r(u ?? `react-aria-${++this.ownerDocument.nodeId}`), this.node = a) : a = this.getMutableNode(), c.ref = n, a.props = c, a.rendered = i, a.render = o, a.value = s, t["aria-label"] && (a["aria-label"] = t["aria-label"]), a.textValue = l || (typeof c.children == "string" ? c.children : "") || t["aria-label"] || "", u != null && u !== a.key) throw new Error("Cannot change the id of an item");
    c.colSpan != null && (a.colSpan = c.colSpan), this.isConnected && this.ownerDocument.queueUpdate();
  }
  get style() {
    let t = this;
    return {
      get display() {
        return t.isHidden ? "none" : "";
      },
      set display(n) {
        let r = n === "none";
        if (t.isHidden !== r) {
          (t.parentNode?.firstVisibleChild === t || t.parentNode?.lastVisibleChild === t) && t.ownerDocument.markDirty(t.parentNode);
          let i = t.previousVisibleSibling, o = t.nextVisibleSibling;
          i && t.ownerDocument.markDirty(i), o && t.ownerDocument.markDirty(o), t.isHidden = r, t.ownerDocument.markDirty(t);
        }
      }
    };
  }
  hasAttribute() {
  }
  setAttribute() {
  }
  setAttributeNS() {
  }
  removeAttribute() {
  }
}
class e9 extends rO {
  constructor(t) {
    super(null), this.nodeType = 11, this.ownerDocument = this, this.dirtyNodes = /* @__PURE__ */ new Set(), this.isSSR = !1, this.nodeId = 0, this.nodesByProps = /* @__PURE__ */ new WeakMap(), this.nextCollection = null, this.subscriptions = /* @__PURE__ */ new Set(), this.queuedRender = !1, this.inSubscription = !1, this.collection = t, this.nextCollection = t;
  }
  get isConnected() {
    return !0;
  }
  createElement(t) {
    return new Ss(t, this);
  }
  getMutableCollection() {
    return this.nextCollection || (this.nextCollection = this.collection.clone()), this.nextCollection;
  }
  markDirty(t) {
    this.dirtyNodes.add(t);
  }
  addNode(t) {
    if (t.isHidden || t.node == null) return;
    let n = this.getMutableCollection();
    if (!n.getItem(t.node.key)) for (let r of t) this.addNode(r);
    n.addNode(t.node);
  }
  removeNode(t) {
    for (let n of t) this.removeNode(n);
    t.node && this.getMutableCollection().removeNode(t.node.key);
  }
  /** Finalizes the collection update, updating all nodes and freezing the collection. */
  getCollection() {
    return this.inSubscription ? this.collection : (this.queuedRender = !1, this.updateCollection(), this.collection);
  }
  updateCollection() {
    for (let t of this.dirtyNodes) t instanceof Ss && (!t.isConnected || t.isHidden) ? this.removeNode(t) : t.updateChildIndices();
    for (let t of this.dirtyNodes) t instanceof Ss ? (t.isConnected && !t.isHidden && (t.updateNode(), this.addNode(t)), t.node && this.dirtyNodes.delete(t), t.isMutated = !1) : this.dirtyNodes.delete(t);
    this.nextCollection && (this.nextCollection.commit(this.firstVisibleChild?.node?.key ?? null, this.lastVisibleChild?.node?.key ?? null, this.isSSR), this.isSSR || (this.collection = this.nextCollection, this.nextCollection = null));
  }
  queueUpdate() {
    if (!(this.dirtyNodes.size === 0 || this.queuedRender)) {
      this.queuedRender = !0, this.inSubscription = !0, this.isSSR || (this.collection = this.collection.clone());
      for (let t of this.subscriptions) t();
      this.inSubscription = !1;
    }
  }
  subscribe(t) {
    return this.subscriptions.add(t), () => this.subscriptions.delete(t);
  }
  resetAfterSSR() {
    this.isSSR && (this.isSSR = !1, this.firstChild = null, this.lastChild = null, this.nodeId = 0);
  }
}
function iO(e) {
  let { children: t, items: n, idScope: r, addIdAndValue: i, dependencies: o = [] } = e, a = Fe(() => process.env.NODE_ENV !== "production" && typeof t == "function" ? t.toString() : void 0, [
    t
  ]), s = Fe(() => /* @__PURE__ */ new WeakMap(), [
    ...o,
    a
  ]);
  return Fe(() => {
    if (n && typeof t == "function") {
      let l = [];
      for (let u of n) {
        let c = t9(u) ? u : null, f = c ? s.get(c) : null;
        if (!f) {
          f = t(u);
          let d = f.props.id ?? u?.key ?? u?.id;
          r != null && f.props.id == null && d != null && (d = r + ":" + d);
          let p = d ?? l.length;
          f = XS(f, i ? {
            key: p,
            id: d,
            value: u
          } : {
            key: p
          }), c && s.set(c, f);
        }
        l.push(f);
      }
      return l;
    } else if (typeof t != "function") return t;
  }, [
    t,
    n,
    s,
    r,
    i
  ]);
}
function t9(e) {
  switch (typeof e) {
    case "object":
      return e != null;
    case "function":
    case "symbol":
      return !0;
    default:
      return !1;
  }
}
let mo = /* @__PURE__ */ new Map(), Kv = /* @__PURE__ */ new Set();
function jw() {
  if (typeof window > "u") return;
  function e(r) {
    return "propertyName" in r;
  }
  let t = (r) => {
    let i = Ae(r);
    if (!e(r) || !i) return;
    let o = mo.get(i);
    o || (o = /* @__PURE__ */ new Set(), mo.set(i, o), i.addEventListener("transitioncancel", n, {
      once: !0
    })), o.add(r.propertyName);
  }, n = (r) => {
    let i = Ae(r);
    if (!e(r) || !i) return;
    let o = mo.get(i);
    if (o && (o.delete(r.propertyName), o.size === 0 && (i.removeEventListener("transitioncancel", n), mo.delete(i)), mo.size === 0)) {
      for (let a of Kv) a();
      Kv.clear();
    }
  };
  document.body.addEventListener("transitionrun", t), document.body.addEventListener("transitionend", n);
}
typeof document < "u" && (document.readyState !== "loading" ? jw() : document.addEventListener("DOMContentLoaded", jw));
function n9() {
  for (const [e] of mo)
    "isConnected" in e && !e.isConnected && mo.delete(e);
}
function oO(e) {
  requestAnimationFrame(() => {
    n9(), mo.size === 0 ? e() : Kv.add(e);
  });
}
function Rs(e) {
  if (!e.isConnected) return;
  const t = ot(e);
  if (Su() === "virtual") {
    let n = Lt(t);
    oO(() => {
      const r = Lt(t);
      (r === n || r === t.body) && e.isConnected && ai(e);
    });
  } else ai(e);
}
function ab(e) {
  let { isDisabled: t, onFocus: n, onBlur: r, onFocusChange: i } = e;
  const o = Le((l) => {
    if (Ae(l) === l.currentTarget)
      return r && r(l), i && i(!1), !0;
  }, [
    r,
    i
  ]), a = BT(o), s = Le((l) => {
    let u = Ae(l);
    const c = ot(u), f = c ? Lt(c) : Lt();
    u === l.currentTarget && u === f && (n && n(l), i && i(!0), a(l));
  }, [
    i,
    n,
    a
  ]);
  return {
    focusProps: {
      onFocus: !t && (n || i || r) ? s : void 0,
      onBlur: !t && (r || i) ? o : void 0
    }
  };
}
function Fw(e) {
  if (!e) return;
  let t = !0;
  return (n) => {
    let r = {
      ...n,
      preventDefault() {
        n.preventDefault();
      },
      isDefaultPrevented() {
        return n.isDefaultPrevented();
      },
      stopPropagation() {
        t && process.env.NODE_ENV !== "production" ? console.error("stopPropagation is now the default behavior for events in React Spectrum. You can use continuePropagation() to revert this behavior.") : t = !0;
      },
      continuePropagation() {
        t = !1, typeof n.continuePropagation == "function" && n.continuePropagation();
      },
      isPropagationStopped() {
        return t;
      }
    };
    e(r), t && n.stopPropagation();
  };
}
function sb(e) {
  return {
    keyboardProps: e.isDisabled ? {} : {
      onKeyDown: Fw(e.onKeyDown),
      onKeyUp: Fw(e.onKeyUp)
    }
  };
}
function lb(e, t) {
  dt(() => {
    if (e && e.ref && t)
      return e.ref.current = t.current, () => {
        e.ref && (e.ref.current = null);
      };
  });
}
let Uv = /* @__PURE__ */ H.createContext(null);
function r9(e) {
  let t = je(Uv) || {};
  lb(t, e);
  let { ref: n, ...r } = t;
  return r;
}
function aO(e, t) {
  let { focusProps: n } = ab(e), { keyboardProps: r } = sb(e), i = st(n, r), o = r9(t), a = e.isDisabled ? {} : o, s = ve(e.autoFocus);
  ze(() => {
    s.current && t.current && Rs(t.current), s.current = !1;
  }, [
    t
  ]);
  let l = e.excludeFromTabOrder ? -1 : 0;
  return e.isDisabled && (l = void 0), {
    focusableProps: st({
      ...i,
      tabIndex: l
    }, a)
  };
}
typeof HTMLTemplateElement < "u" && (Object.defineProperty(HTMLTemplateElement.prototype, "firstChild", {
  configurable: !0,
  enumerable: !0,
  get: function() {
    return this.content.firstChild;
  }
}), Object.defineProperty(HTMLTemplateElement.prototype, "appendChild", {
  configurable: !0,
  enumerable: !0,
  value: function(e) {
    return this.content.appendChild(e);
  }
}), Object.defineProperty(HTMLTemplateElement.prototype, "removeChild", {
  configurable: !0,
  enumerable: !0,
  value: function(e) {
    return this.content.removeChild(e);
  }
}), Object.defineProperty(HTMLTemplateElement.prototype, "insertBefore", {
  configurable: !0,
  enumerable: !0,
  value: function(e, t) {
    return this.content.insertBefore(e, t);
  }
}));
const ld = /* @__PURE__ */ He(!1);
function i9(e) {
  if (je(ld))
    return /* @__PURE__ */ H.createElement(H.Fragment, null, e.children);
  let n = /* @__PURE__ */ H.createElement(ld.Provider, {
    value: !0
  }, e.children);
  return /* @__PURE__ */ H.createElement("template", null, n);
}
function dp(e) {
  let t = (n, r) => je(ld) ? null : e(n, r);
  return t.displayName = e.displayName || e.name, fn(t);
}
function sO() {
  return je(ld);
}
var jc = { exports: {} }, Lh = {};
/**
 * @license React
 * use-sync-external-store-shim.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var zw;
function o9() {
  if (zw) return Lh;
  zw = 1;
  var e = H;
  function t(f, d) {
    return f === d && (f !== 0 || 1 / f === 1 / d) || f !== f && d !== d;
  }
  var n = typeof Object.is == "function" ? Object.is : t, r = e.useState, i = e.useEffect, o = e.useLayoutEffect, a = e.useDebugValue;
  function s(f, d) {
    var p = d(), h = r({ inst: { value: p, getSnapshot: d } }), v = h[0].inst, m = h[1];
    return o(
      function() {
        v.value = p, v.getSnapshot = d, l(v) && m({ inst: v });
      },
      [f, p, d]
    ), i(
      function() {
        return l(v) && m({ inst: v }), f(function() {
          l(v) && m({ inst: v });
        });
      },
      [f]
    ), a(p), p;
  }
  function l(f) {
    var d = f.getSnapshot;
    f = f.value;
    try {
      var p = d();
      return !n(f, p);
    } catch {
      return !0;
    }
  }
  function u(f, d) {
    return d();
  }
  var c = typeof window > "u" || typeof window.document > "u" || typeof window.document.createElement > "u" ? u : s;
  return Lh.useSyncExternalStore = e.useSyncExternalStore !== void 0 ? e.useSyncExternalStore : c, Lh;
}
var Vh = {};
/**
 * @license React
 * use-sync-external-store-shim.development.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Lw;
function a9() {
  return Lw || (Lw = 1, process.env.NODE_ENV !== "production" && (function() {
    function e(p, h) {
      return p === h && (p !== 0 || 1 / p === 1 / h) || p !== p && h !== h;
    }
    function t(p, h) {
      c || i.startTransition === void 0 || (c = !0, console.error(
        "You are using an outdated, pre-release alpha of React 18 that does not support useSyncExternalStore. The use-sync-external-store shim will not work correctly. Upgrade to a newer pre-release."
      ));
      var v = h();
      if (!f) {
        var m = h();
        o(v, m) || (console.error(
          "The result of getSnapshot should be cached to avoid an infinite loop"
        ), f = !0);
      }
      m = a({
        inst: { value: v, getSnapshot: h }
      });
      var g = m[0].inst, _ = m[1];
      return l(
        function() {
          g.value = v, g.getSnapshot = h, n(g) && _({ inst: g });
        },
        [p, v, h]
      ), s(
        function() {
          return n(g) && _({ inst: g }), p(function() {
            n(g) && _({ inst: g });
          });
        },
        [p]
      ), u(v), v;
    }
    function n(p) {
      var h = p.getSnapshot;
      p = p.value;
      try {
        var v = h();
        return !o(p, v);
      } catch {
        return !0;
      }
    }
    function r(p, h) {
      return h();
    }
    typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart == "function" && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart(Error());
    var i = H, o = typeof Object.is == "function" ? Object.is : e, a = i.useState, s = i.useEffect, l = i.useLayoutEffect, u = i.useDebugValue, c = !1, f = !1, d = typeof window > "u" || typeof window.document > "u" || typeof window.document.createElement > "u" ? r : t;
    Vh.useSyncExternalStore = i.useSyncExternalStore !== void 0 ? i.useSyncExternalStore : d, typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop == "function" && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop(Error());
  })()), Vh;
}
var Vw;
function s9() {
  return Vw || (Vw = 1, process.env.NODE_ENV === "production" ? jc.exports = o9() : jc.exports = a9()), jc.exports;
}
var lO = s9();
const uO = /* @__PURE__ */ He(!1), $u = /* @__PURE__ */ He(null);
function ub(e) {
  if (je($u))
    return e.content;
  let { collection: n, document: r } = f9(e.createCollection);
  return /* @__PURE__ */ H.createElement(H.Fragment, null, /* @__PURE__ */ H.createElement(i9, null, /* @__PURE__ */ H.createElement($u.Provider, {
    value: r
  }, e.content)), /* @__PURE__ */ H.createElement(l9, {
    render: e.children,
    collection: n
  }));
}
function l9({ collection: e, render: t }) {
  return t(e);
}
function u9(e, t, n) {
  let r = nc(), i = ve(r);
  i.current = r;
  let o = Le(() => i.current ? n() : t(), [
    t,
    n
  ]);
  return lO.useSyncExternalStore(e, o);
}
const c9 = typeof H.useSyncExternalStore == "function" ? H.useSyncExternalStore : u9;
function f9(e) {
  let [t] = Ke(() => new e9(e?.() || new Xz())), n = Le((a) => t.subscribe(a), [
    t
  ]), r = Le(() => {
    let a = t.getCollection();
    return t.isSSR && t.resetAfterSSR(), a;
  }, [
    t
  ]), i = Le(() => (t.isSSR = !0, t.getCollection()), [
    t
  ]);
  return {
    collection: c9(n, r, i),
    document: t
  };
}
const qv = /* @__PURE__ */ He(null);
function d9(e) {
  var n;
  return n = class extends al {
  }, n.type = e, n;
}
function p9(e, t, n, r, i, o) {
  typeof e == "string" && (e = d9(e));
  let a = Le((l) => {
    l?.setProps(t, n, e, r, o);
  }, [
    t,
    n,
    r,
    o,
    e
  ]), s = je(qv);
  if (s) {
    let l = s.ownerDocument.nodesByProps.get(t);
    return l || (l = s.ownerDocument.createElement(e.type), l.setProps(t, n, e, r, o), s.appendChild(l), s.ownerDocument.updateCollection(), s.ownerDocument.nodesByProps.set(t, l)), i ? /* @__PURE__ */ H.createElement(qv.Provider, {
      value: l
    }, i) : null;
  }
  return /* @__PURE__ */ H.createElement(e.type, {
    ref: a
  }, i);
}
function cb(e, t) {
  let n = ({ node: i }) => t(i.props, i.props.ref, i), r = fn((i, o) => {
    let a = je(Uv);
    if (!je(uO)) {
      if (t.length >= 3) throw new Error(t.name + " cannot be rendered outside a collection.");
      return t(i, o);
    }
    return p9(e, i, o, "children" in i ? i.children : null, null, (l) => (
      // Forward FocusableContext to real DOM tree so tooltips work.
      /* @__PURE__ */ H.createElement(Uv.Provider, {
        value: a
      }, /* @__PURE__ */ H.createElement(n, {
        node: l
      }))
    ));
  });
  return r.displayName = t.name, r;
}
function h9(e) {
  return iO({
    ...e,
    addIdAndValue: !0
  });
}
const Bw = /* @__PURE__ */ He(null);
function cO(e) {
  let t = je(Bw), n = (t?.dependencies || []).concat(e.dependencies), r = e.idScope ?? t?.idScope, i = h9({
    ...e,
    idScope: r,
    dependencies: n
  });
  return je($u) && (i = /* @__PURE__ */ H.createElement(m9, null, i)), t = Fe(
    () => ({
      dependencies: n,
      idScope: r
    }),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [
      r,
      ...n
    ]
  ), /* @__PURE__ */ H.createElement(Bw.Provider, {
    value: t
  }, i);
}
function m9({ children: e }) {
  let t = je($u), n = Fe(() => /* @__PURE__ */ H.createElement($u.Provider, {
    value: null
  }, /* @__PURE__ */ H.createElement(uO.Provider, {
    value: !0
  }, e)), [
    e
  ]);
  return nc() ? /* @__PURE__ */ H.createElement(qv.Provider, {
    value: t
  }, n) : /* @__PURE__ */ ba(n, t);
}
const fO = /* @__PURE__ */ He(null), v9 = {
  CollectionRoot({ collection: e, renderDropIndicator: t }) {
    return Kw(e, null, t);
  },
  CollectionBranch({ collection: e, parent: t, renderDropIndicator: n }) {
    return Kw(e, t, n);
  }
};
function Kw(e, t, n) {
  return iO({
    items: t ? e.getChildren(t.key) : e,
    dependencies: [
      n
    ],
    children(r) {
      if (r.type === "content") return /* @__PURE__ */ H.createElement(H.Fragment, null);
      let i = r.render(r);
      return !n || r.type !== "item" ? i : /* @__PURE__ */ H.createElement(H.Fragment, null, n({
        type: "item",
        key: r.key,
        dropPosition: "before"
      }), i, g9(e, r, n));
    }
  });
}
function g9(e, t, n) {
  let r = t.key, i = e.getKeyAfter(r), o = i != null ? e.getItem(i) : null;
  for (; o != null && o.type !== "item"; )
    i = e.getKeyAfter(o.key), o = i != null ? e.getItem(i) : null;
  let a = t.nextKey != null ? e.getItem(t.nextKey) : null;
  for (; a != null && a.type !== "item"; ) a = a.nextKey != null ? e.getItem(a.nextKey) : null;
  let s = [];
  if (a == null) {
    let l = t;
    for (; l?.type === "item" && (!o || l.parentKey !== o.parentKey && o.level < l.level); ) {
      let u = n({
        type: "item",
        key: l.key,
        dropPosition: "after"
      });
      /* @__PURE__ */ QS(u) && s.push(/* @__PURE__ */ XS(u, {
        key: `${l.key}-after`
      })), l = l.parentKey != null ? e.getItem(l.parentKey) : null;
    }
  }
  return s;
}
const sl = /* @__PURE__ */ He(v9);
function y9(e) {
  return Fe(() => e != null ? /* @__PURE__ */ new Set([
    e
  ]) : null, [
    e
  ]);
}
const b9 = /* @__PURE__ */ new Set([
  "id"
]), _9 = /* @__PURE__ */ new Set([
  "aria-label",
  "aria-labelledby",
  "aria-describedby",
  "aria-details"
]), w9 = /* @__PURE__ */ new Set([
  "href",
  "hrefLang",
  "target",
  "rel",
  "download",
  "ping",
  "referrerPolicy"
]), x9 = /* @__PURE__ */ new Set([
  "dir",
  "lang",
  "hidden",
  "inert",
  "translate"
]), Uw = /* @__PURE__ */ new Set([
  "onClick",
  "onAuxClick",
  "onContextMenu",
  "onDoubleClick",
  "onMouseDown",
  "onMouseEnter",
  "onMouseLeave",
  "onMouseMove",
  "onMouseOut",
  "onMouseOver",
  "onMouseUp",
  "onTouchCancel",
  "onTouchEnd",
  "onTouchMove",
  "onTouchStart",
  "onPointerDown",
  "onPointerMove",
  "onPointerUp",
  "onPointerCancel",
  "onPointerEnter",
  "onPointerLeave",
  "onPointerOver",
  "onPointerOut",
  "onGotPointerCapture",
  "onLostPointerCapture",
  "onScroll",
  "onWheel",
  "onAnimationStart",
  "onAnimationEnd",
  "onAnimationIteration",
  "onTransitionCancel",
  "onTransitionEnd",
  "onTransitionRun",
  "onTransitionStart"
]), E9 = /^(data-.*)$/;
function Dn(e, t = {}) {
  let { labelable: n, isLink: r, global: i, events: o = i, propNames: a } = t, s = {};
  for (const l in e) Object.prototype.hasOwnProperty.call(e, l) && (b9.has(l) || n && _9.has(l) || r && w9.has(l) || i && x9.has(l) || o && (Uw.has(l) || l.endsWith("Capture") && Uw.has(l.slice(0, -7))) || a?.has(l) || E9.test(l)) && (s[l] = e[l]);
  return s;
}
let fs = "default", Hv = "", Ef = /* @__PURE__ */ new WeakMap();
function qw(e) {
  if (rc()) {
    if (fs === "default") {
      const t = ot(e);
      Hv = t.documentElement.style.webkitUserSelect, t.documentElement.style.webkitUserSelect = "none";
    }
    fs = "disabled";
  } else if (e instanceof HTMLElement || e instanceof SVGElement) {
    let t = "userSelect" in e.style ? "userSelect" : "webkitUserSelect";
    Ef.set(e, e.style[t]), e.style[t] = "none";
  }
}
function Bh(e) {
  if (rc()) {
    if (fs !== "disabled") return;
    fs = "restoring", setTimeout(() => {
      oO(() => {
        if (fs === "restoring") {
          const t = ot(e);
          t.documentElement.style.webkitUserSelect === "none" && (t.documentElement.style.webkitUserSelect = Hv || ""), Hv = "", fs = "default";
        }
      });
    }, 300);
  } else if ((e instanceof HTMLElement || e instanceof SVGElement) && e && Ef.has(e)) {
    let t = Ef.get(e), n = "userSelect" in e.style ? "userSelect" : "webkitUserSelect";
    e.style[n] === "none" && (e.style[n] = t), e.getAttribute("style") === "" && e.removeAttribute("style"), Ef.delete(e);
  }
}
function Hw(e) {
  return e?.defaultView?.__webpack_nonce__ || globalThis.__webpack_nonce__ || void 0;
}
let Kh = /* @__PURE__ */ new WeakMap();
function dO(e) {
  let t = e ?? (typeof document < "u" ? document : void 0);
  if (!t) return Hw(t);
  if (Kh.has(t)) return Kh.get(t);
  let n = t.querySelector('meta[property="csp-nonce"]'), r = n && n instanceof Pn(n).HTMLMetaElement && (n.nonce || n.content) || Hw(t) || void 0;
  return r !== void 0 && Kh.set(t, r), r;
}
const ku = H.createContext({
  register: () => {
  }
});
ku.displayName = "PressResponderContext";
function pp() {
  let e = ve(/* @__PURE__ */ new Map()), t = Le((i, o, a, s) => {
    let l = s?.once ? (...u) => {
      e.current.delete(a), a(...u);
    } : a;
    e.current.set(a, {
      type: o,
      eventTarget: i,
      fn: l,
      options: s
    }), i.addEventListener(o, l, s);
  }, []), n = Le((i, o, a, s) => {
    let l = e.current.get(a)?.fn || a;
    i.removeEventListener(o, l, s), e.current.delete(a);
  }, []), r = Le(() => {
    e.current.forEach((i, o) => {
      n(i.eventTarget, i.type, o, i.options);
    });
  }, [
    n
  ]);
  return ze(() => r, [
    r
  ]), {
    addGlobalListener: t,
    removeGlobalListener: n,
    removeAllGlobalListeners: r
  };
}
function S9(e) {
  let t = je(ku);
  if (t) {
    let { register: n, ref: r, ...i } = t;
    e = st(i, e), n();
  }
  return lb(t, e.ref), e;
}
var Ds;
class Fc {
  constructor(t, n, r, i) {
    p1(this, Ds);
    lh(this, Ds, !0);
    const a = (i?.target ?? r.currentTarget)?.getBoundingClientRect();
    let s, l = 0, u, c = null;
    r.clientX != null && r.clientY != null && (u = r.clientX, c = r.clientY), a && (u != null && c != null ? (s = u - a.left, l = c - a.top) : (s = a.width / 2, l = a.height / 2)), this.type = t, this.pointerType = n, this.target = r.currentTarget, this.shiftKey = r.shiftKey, this.metaKey = r.metaKey, this.ctrlKey = r.ctrlKey, this.altKey = r.altKey, this.x = s, this.y = l, this.key = r.key;
  }
  continuePropagation() {
    lh(this, Ds, !1);
  }
  get shouldStopPropagation() {
    return d1(this, Ds);
  }
}
Ds = new WeakMap();
const Ww = Symbol("linkClicked"), Zw = "react-aria-pressable-style", Gw = "data-react-aria-pressable";
function hp(e) {
  let { onPress: t, onPressChange: n, onPressStart: r, onPressEnd: i, onPressUp: o, onClick: a, isDisabled: s, isPressed: l, preventFocusOnPress: u, shouldCancelOnPointerExit: c, allowTextSelectionOnPress: f, ref: d, ...p } = S9(e), [h, v] = Ke(!1), m = ve({
    isPressed: !1,
    ignoreEmulatedMouseEvents: !1,
    didFirePressStart: !1,
    isTriggeringEvent: !1,
    activePointerId: null,
    target: null,
    isOverTarget: !1,
    pointerType: null,
    disposables: []
  }), { addGlobalListener: g, removeAllGlobalListeners: _ } = pp(), x = Le((T, V) => {
    let z = m.current;
    if (s || z.didFirePressStart) return !1;
    let U = !0;
    if (z.isTriggeringEvent = !0, r) {
      let B = new Fc("pressstart", V, T);
      r(B), U = B.shouldStopPropagation;
    }
    return n && n(!0), z.isTriggeringEvent = !1, z.didFirePressStart = !0, v(!0), U;
  }, [
    s,
    r,
    n
  ]), w = Le((T, V, z = !0) => {
    let U = m.current;
    if (!U.didFirePressStart) return !1;
    U.didFirePressStart = !1, U.isTriggeringEvent = !0;
    let B = !0;
    if (i) {
      let N = new Fc("pressend", V, T);
      i(N), B = N.shouldStopPropagation;
    }
    if (n && n(!1), v(!1), t && z && !s) {
      let N = new Fc("press", V, T);
      t(N), B && (B = N.shouldStopPropagation);
    }
    return U.isTriggeringEvent = !1, B;
  }, [
    s,
    i,
    n,
    t
  ]), $ = Rr(w), k = Le((T, V) => {
    let z = m.current;
    if (s) return !1;
    if (o) {
      z.isTriggeringEvent = !0;
      let U = new Fc("pressup", V, T);
      return o(U), z.isTriggeringEvent = !1, U.shouldStopPropagation;
    }
    return !0;
  }, [
    s,
    o
  ]), D = Rr(k), E = Le((T) => {
    let V = m.current;
    if (V.isPressed && V.target) {
      V.didFirePressStart && V.pointerType != null && w(Yo(V.target, T), V.pointerType, !1), V.isPressed = !1, V.isOverTarget = !1, V.activePointerId = null, V.pointerType = null, _(), f || Bh(V.target);
      for (let z of V.disposables) z();
      V.disposables = [];
    }
  }, [
    f,
    _,
    w
  ]), b = Rr(E);
  ze(() => {
    s && m.current.isPressed && b({
      currentTarget: m.current.target,
      shiftKey: !1,
      ctrlKey: !1,
      metaKey: !1,
      altKey: !1
    });
  }, [
    s
  ]);
  let y = Le((T) => {
    c && E(T);
  }, [
    c,
    E
  ]), S = Le((T) => {
    s || a?.(T);
  }, [
    s,
    a
  ]), P = Le((T, V) => {
    if (!s && a) {
      let z = new MouseEvent("click", T);
      VT(z, V), a(rb(z));
    }
  }, [
    s,
    a
  ]), M = Fe(() => {
    let T = m.current, V = {
      onKeyDown(U) {
        if (Uh(U.nativeEvent, U.currentTarget) && Je(U.currentTarget, Ae(U))) {
          Jw(Ae(U), U.key) && U.preventDefault();
          let B = !0;
          !T.isPressed && !U.repeat && (T.target = U.currentTarget, T.isPressed = !0, T.pointerType = "keyboard", B = x(U, "keyboard"));
          let N = U.currentTarget, C = (G) => {
            Uh(G, N) && !G.repeat && Je(N, Ae(G)) && T.target && D(Yo(T.target, G), "keyboard");
          };
          g(ot(U.currentTarget), "keyup", Na(C, z), !0), B && U.stopPropagation(), U.metaKey && xa() && T.metaKeyEvents?.set(U.key, U.nativeEvent);
        } else U.key === "Meta" && (T.metaKeyEvents = /* @__PURE__ */ new Map());
      },
      onClick(U) {
        if (!(U && !Je(U.currentTarget, Ae(U))) && U && U.button === 0 && !T.isTriggeringEvent && !Zi.isOpening) {
          let B = !0;
          if (s && U.preventDefault(), !T.ignoreEmulatedMouseEvents && !T.isPressed && (T.pointerType === "virtual" || Nv(U.nativeEvent))) {
            let N = x(U, "virtual"), C = D(U, "virtual"), G = $(U, "virtual");
            S(U), B = N && C && G;
          } else if (T.isPressed && T.pointerType !== "keyboard") {
            let N = T.pointerType || U.nativeEvent.pointerType || "virtual", C = D(Yo(U.currentTarget, U), N), G = $(Yo(U.currentTarget, U), N, !0);
            B = C && G, T.isOverTarget = !1, S(U), b(U);
          }
          T.ignoreEmulatedMouseEvents = !1, B && U.stopPropagation();
        }
      }
    }, z = (U) => {
      if (T.isPressed && T.target && Uh(U, T.target)) {
        Jw(Ae(U), U.key) && U.preventDefault();
        let B = Ae(U), N = Je(T.target, B);
        $(Yo(T.target, U), "keyboard", N), N && P(U, T.target), _(), U.key !== "Enter" && fb(T.target) && Je(T.target, B) && !U[Ww] && (U[Ww] = !0, Zi(T.target, U, !1)), T.isPressed = !1, T.metaKeyEvents?.delete(U.key);
      } else if (U.key === "Meta" && T.metaKeyEvents?.size) {
        let B = T.metaKeyEvents;
        T.metaKeyEvents = void 0;
        for (let N of B.values()) T.target?.dispatchEvent(new KeyboardEvent("keyup", N));
      }
    };
    if (typeof PointerEvent < "u") {
      V.onPointerDown = (N) => {
        if (N.button !== 0 || !Je(N.currentTarget, Ae(N))) return;
        if ($z(N.nativeEvent)) {
          T.pointerType = "virtual";
          return;
        }
        T.pointerType = N.pointerType;
        let C = !0;
        if (!T.isPressed) {
          T.isPressed = !0, T.isOverTarget = !0, T.activePointerId = N.pointerId, T.target = N.currentTarget, f || qw(T.target), C = x(N, T.pointerType);
          let G = Ae(N);
          "releasePointerCapture" in G && ("hasPointerCapture" in G ? G.hasPointerCapture(N.pointerId) && G.releasePointerCapture(N.pointerId) : G.releasePointerCapture(N.pointerId)), g(ot(N.currentTarget), "pointerup", U, !1), g(ot(N.currentTarget), "pointercancel", B, !1);
        }
        C && N.stopPropagation();
      }, V.onMouseDown = (N) => {
        if (Je(N.currentTarget, Ae(N)) && N.button === 0) {
          if (u) {
            let C = Aw(N.target);
            C && T.disposables.push(C);
          }
          N.stopPropagation();
        }
      }, V.onPointerUp = (N) => {
        !Je(N.currentTarget, Ae(N)) || T.pointerType === "virtual" || N.button === 0 && !T.isPressed && D(N, T.pointerType || N.pointerType);
      }, V.onPointerEnter = (N) => {
        N.pointerId === T.activePointerId && T.target && !T.isOverTarget && T.pointerType != null && (T.isOverTarget = !0, x(Yo(T.target, N), T.pointerType));
      }, V.onPointerLeave = (N) => {
        N.pointerId === T.activePointerId && T.target && T.isOverTarget && T.pointerType != null && (T.isOverTarget = !1, $(Yo(T.target, N), T.pointerType, !1), y(N));
      };
      let U = (N) => {
        if (N.pointerId === T.activePointerId && T.isPressed && N.button === 0 && T.target) {
          if (Je(T.target, Ae(N)) && T.pointerType != null) {
            let C = !1, G = setTimeout(() => {
              T.isPressed && T.target instanceof HTMLElement && (C ? b(N) : (ai(T.target), T.target.click()));
            }, 80);
            g(N.currentTarget, "click", () => C = !0, !0), T.disposables.push(() => clearTimeout(G));
          } else
            b(N);
          T.isOverTarget = !1;
        }
      }, B = (N) => {
        b(N);
      };
      V.onDragStart = (N) => {
        Je(N.currentTarget, Ae(N)) && b(N);
      };
    } else if (process.env.NODE_ENV === "test") {
      V.onMouseDown = (N) => {
        if (N.button !== 0 || !Je(N.currentTarget, Ae(N))) return;
        if (T.ignoreEmulatedMouseEvents) {
          N.stopPropagation();
          return;
        }
        if (T.isPressed = !0, T.isOverTarget = !0, T.target = N.currentTarget, T.pointerType = Nv(N.nativeEvent) ? "virtual" : "mouse", ly(() => x(N, T.pointerType)) && N.stopPropagation(), u) {
          let G = Aw(N.target);
          G && T.disposables.push(G);
        }
        g(ot(N.currentTarget), "mouseup", U, !1);
      }, V.onMouseEnter = (N) => {
        if (!Je(N.currentTarget, Ae(N))) return;
        let C = !0;
        T.isPressed && !T.ignoreEmulatedMouseEvents && T.pointerType != null && (T.isOverTarget = !0, C = x(N, T.pointerType)), C && N.stopPropagation();
      }, V.onMouseLeave = (N) => {
        if (!Je(N.currentTarget, Ae(N))) return;
        let C = !0;
        T.isPressed && !T.ignoreEmulatedMouseEvents && T.pointerType != null && (T.isOverTarget = !1, C = $(N, T.pointerType, !1), y(N)), C && N.stopPropagation();
      }, V.onMouseUp = (N) => {
        Je(N.currentTarget, Ae(N)) && !T.ignoreEmulatedMouseEvents && N.button === 0 && !T.isPressed && D(N, T.pointerType || "mouse");
      };
      let U = (N) => {
        if (N.button === 0) {
          if (T.ignoreEmulatedMouseEvents) {
            T.ignoreEmulatedMouseEvents = !1;
            return;
          }
          T.target && Je(T.target, Ae(N)) && T.pointerType != null || b(N), T.isOverTarget = !1;
        }
      };
      V.onTouchStart = (N) => {
        if (!Je(N.currentTarget, Ae(N))) return;
        let C = $9(N.nativeEvent);
        if (!C) return;
        T.activePointerId = C.identifier, T.ignoreEmulatedMouseEvents = !0, T.isOverTarget = !0, T.isPressed = !0, T.target = N.currentTarget, T.pointerType = "touch", f || qw(T.target), x(so(T.target, N), T.pointerType) && N.stopPropagation(), g(Pn(N.currentTarget), "scroll", B, !0);
      }, V.onTouchMove = (N) => {
        if (!Je(N.currentTarget, Ae(N))) return;
        if (!T.isPressed) {
          N.stopPropagation();
          return;
        }
        let C = Yw(N.nativeEvent, T.activePointerId), G = !0;
        C && Qw(C, N.currentTarget) ? !T.isOverTarget && T.pointerType != null && (T.isOverTarget = !0, G = x(so(T.target, N), T.pointerType)) : T.isOverTarget && T.pointerType != null && (T.isOverTarget = !1, G = $(so(T.target, N), T.pointerType, !1), y(so(T.target, N))), G && N.stopPropagation();
      }, V.onTouchEnd = (N) => {
        if (!Je(N.currentTarget, Ae(N))) return;
        if (!T.isPressed) {
          N.stopPropagation();
          return;
        }
        let C = Yw(N.nativeEvent, T.activePointerId), G = !0;
        C && Qw(C, N.currentTarget) && T.pointerType != null ? (D(so(T.target, N), T.pointerType), G = $(so(T.target, N), T.pointerType), P(N.nativeEvent, T.target)) : T.isOverTarget && T.pointerType != null && (G = $(so(T.target, N), T.pointerType, !1)), G && N.stopPropagation(), T.isPressed = !1, T.activePointerId = null, T.isOverTarget = !1, T.ignoreEmulatedMouseEvents = !0, T.target && !f && Bh(T.target), _();
      }, V.onTouchCancel = (N) => {
        Je(N.currentTarget, Ae(N)) && (N.stopPropagation(), T.isPressed && b(so(T.target, N)));
      };
      let B = (N) => {
        T.isPressed && Je(Ae(N), T.target) && b({
          currentTarget: T.target,
          shiftKey: !1,
          ctrlKey: !1,
          metaKey: !1,
          altKey: !1
        });
      };
      V.onDragStart = (N) => {
        Je(N.currentTarget, Ae(N)) && b(N);
      };
    }
    return V;
  }, [
    g,
    s,
    u,
    _,
    f,
    y,
    x,
    S,
    P
  ]);
  return ze(() => {
    if (!d || process.env.NODE_ENV === "test") return;
    const T = ot(d.current);
    if (!T || !T.head || T.getElementById(Zw)) return;
    const V = T.createElement("style");
    V.id = Zw;
    let z = dO(T);
    z && (V.nonce = z), V.textContent = `
@layer {
  [${Gw}] {
    touch-action: pan-x pan-y pinch-zoom;
  }
}
    `.trim(), T.head.prepend(V);
  }, [
    d
  ]), ze(() => {
    let T = m.current;
    return () => {
      f || Bh(T.target ?? void 0);
      for (let V of T.disposables) V();
      T.disposables = [];
    };
  }, [
    f
  ]), {
    isPressed: l || h,
    pressProps: st(p, M, {
      [Gw]: !0
    })
  };
}
function fb(e) {
  return e.tagName === "A" && e.hasAttribute("href");
}
function Uh(e, t) {
  const { key: n, code: r } = e, i = t, o = i.getAttribute("role");
  return (n === "Enter" || n === " " || n === "Spacebar" || r === "Space") && !(i instanceof Pn(i).HTMLInputElement && !pO(i, n) || i instanceof Pn(i).HTMLTextAreaElement || i.isContentEditable) && // Links should only trigger with Enter key
  !((o === "link" || !o && fb(i)) && n !== "Enter");
}
function $9(e) {
  const { targetTouches: t } = e;
  return t.length > 0 ? t[0] : null;
}
function Yw(e, t) {
  const n = e.changedTouches;
  for (let r = 0; r < n.length; r++) {
    const i = n[r];
    if (i.identifier === t) return i;
  }
  return null;
}
function so(e, t) {
  let n = 0, r = 0;
  return t.targetTouches && t.targetTouches.length === 1 && (n = t.targetTouches[0].clientX, r = t.targetTouches[0].clientY), {
    currentTarget: e,
    shiftKey: t.shiftKey,
    ctrlKey: t.ctrlKey,
    metaKey: t.metaKey,
    altKey: t.altKey,
    clientX: n,
    clientY: r
  };
}
function Yo(e, t) {
  let n = t.clientX, r = t.clientY;
  return {
    currentTarget: e,
    shiftKey: t.shiftKey,
    ctrlKey: t.ctrlKey,
    metaKey: t.metaKey,
    altKey: t.altKey,
    clientX: n,
    clientY: r,
    key: t.key
  };
}
function k9(e) {
  let t = 0, n = 0;
  return e.width !== void 0 ? t = e.width / 2 : e.radiusX !== void 0 && (t = e.radiusX), e.height !== void 0 ? n = e.height / 2 : e.radiusY !== void 0 && (n = e.radiusY), {
    top: e.clientY - n,
    right: e.clientX + t,
    bottom: e.clientY + n,
    left: e.clientX - t
  };
}
function T9(e, t) {
  return !(e.left > t.right || t.left > e.right || e.top > t.bottom || t.top > e.bottom);
}
function Qw(e, t) {
  let n = t.getBoundingClientRect(), r = k9(e);
  return T9(n, r);
}
function O9(e) {
  return e instanceof HTMLInputElement ? !1 : e instanceof HTMLButtonElement ? e.type !== "submit" && e.type !== "reset" : !fb(e);
}
function Jw(e, t) {
  return e instanceof HTMLInputElement ? !pO(e, t) : O9(e);
}
const P9 = /* @__PURE__ */ new Set([
  "checkbox",
  "radio",
  "range",
  "color",
  "file",
  "image",
  "button",
  "submit",
  "reset"
]);
function pO(e, t) {
  return e.type === "checkbox" || e.type === "radio" ? t === " " : P9.has(e.type);
}
function mp(e) {
  let { isDisabled: t, onBlurWithin: n, onFocusWithin: r, onFocusWithinChange: i } = e, o = ve({
    isFocusWithin: !1
  }), { addGlobalListener: a, removeAllGlobalListeners: s } = pp(), l = Le((f) => {
    Je(f.currentTarget, Ae(f)) && o.current.isFocusWithin && !Je(f.currentTarget, f.relatedTarget) && (o.current.isFocusWithin = !1, s(), n && n(f), i && i(!1));
  }, [
    n,
    i,
    o,
    s
  ]), u = BT(l), c = Le((f) => {
    if (!Je(f.currentTarget, Ae(f))) return;
    let d = Ae(f);
    const p = ot(d), h = Lt(p);
    if (!o.current.isFocusWithin && h === d) {
      r && r(f), i && i(!0), o.current.isFocusWithin = !0, u(f);
      let v = f.currentTarget;
      a(p, "focus", (m) => {
        let g = Ae(m);
        if (o.current.isFocusWithin && !Je(v, g)) {
          let _ = new p.defaultView.FocusEvent("blur", {
            relatedTarget: g
          });
          VT(_, v);
          let x = rb(_);
          l(x);
        }
      }, {
        capture: !0
      });
    }
  }, [
    r,
    i,
    u,
    a,
    l
  ]);
  return t ? {
    focusWithinProps: {
      // These cannot be null, that would conflict in mergeProps
      onFocus: void 0,
      onBlur: void 0
    }
  } : {
    focusWithinProps: {
      onFocus: c,
      onBlur: l
    }
  };
}
function vp(e = {}) {
  let { autoFocus: t = !1, isTextInput: n, within: r } = e, i = ve({
    isFocused: !1,
    isFocusVisible: t || Sa()
  }), [o, a] = Ke(!1), [s, l] = Ke(() => i.current.isFocused && i.current.isFocusVisible), u = Le(() => l(i.current.isFocused && i.current.isFocusVisible), []), c = Le((p) => {
    i.current.isFocused = p, i.current.isFocusVisible = Sa(), a(p), u();
  }, [
    u
  ]);
  Nz((p) => {
    i.current.isFocusVisible = p, u();
  }, [
    n,
    o
  ], {
    enabled: o,
    isTextInput: n
  });
  let { focusProps: f } = ab({
    isDisabled: r,
    onFocusChange: c
  }), { focusWithinProps: d } = mp({
    isDisabled: !r,
    onFocusWithinChange: c
  });
  return {
    isFocused: o,
    isFocusVisible: s,
    focusProps: r ? d : f
  };
}
let ud = !1, zc = 0;
function Wv() {
  ud = !0, setTimeout(() => {
    ud = !1;
  }, 500);
}
function Xw(e) {
  e.pointerType === "touch" && Wv();
}
function A9() {
  let e = ot(null);
  if (!(typeof e > "u"))
    return zc === 0 && (typeof PointerEvent < "u" ? e.addEventListener("pointerup", Xw) : process.env.NODE_ENV === "test" && e.addEventListener("touchend", Wv)), zc++, () => {
      zc--, !(zc > 0) && (typeof PointerEvent < "u" ? e.removeEventListener("pointerup", Xw) : process.env.NODE_ENV === "test" && e.removeEventListener("touchend", Wv));
    };
}
function ll(e) {
  let { onHoverStart: t, onHoverChange: n, onHoverEnd: r, isDisabled: i } = e, [o, a] = Ke(!1), s = ve({
    isHovered: !1,
    ignoreEmulatedMouseEvents: !1,
    pointerType: "",
    target: null
  }).current;
  ze(A9, []);
  let { addGlobalListener: l, removeAllGlobalListeners: u } = pp(), { hoverProps: c, triggerHoverEnd: f } = Fe(() => {
    let d = (v, m) => {
      if (s.pointerType = m, i || m === "touch" || s.isHovered || !Je(v.currentTarget, Ae(v))) return;
      s.isHovered = !0;
      let g = v.currentTarget;
      s.target = g, l(ot(Ae(v)), "pointerover", (_) => {
        s.isHovered && s.target && !Je(s.target, Ae(_)) && p(_, _.pointerType);
      }, {
        capture: !0
      }), t && t({
        type: "hoverstart",
        target: g,
        pointerType: m
      }), n && n(!0), a(!0);
    }, p = (v, m) => {
      let g = s.target;
      s.pointerType = "", s.target = null, !(m === "touch" || !s.isHovered || !g) && (s.isHovered = !1, u(), r && r({
        type: "hoverend",
        target: g,
        pointerType: m
      }), n && n(!1), a(!1));
    }, h = {};
    return typeof PointerEvent < "u" ? (h.onPointerEnter = (v) => {
      ud && v.pointerType === "mouse" || d(v, v.pointerType);
    }, h.onPointerLeave = (v) => {
      !i && Je(v.currentTarget, Ae(v)) && p(v, v.pointerType);
    }) : process.env.NODE_ENV === "test" && (h.onTouchStart = () => {
      s.ignoreEmulatedMouseEvents = !0;
    }, h.onMouseEnter = (v) => {
      !s.ignoreEmulatedMouseEvents && !ud && d(v, "mouse"), s.ignoreEmulatedMouseEvents = !1;
    }, h.onMouseLeave = (v) => {
      !i && Je(v.currentTarget, Ae(v)) && p(v, "mouse");
    }), {
      hoverProps: h,
      triggerHoverEnd: p
    };
  }, [
    t,
    n,
    r,
    i,
    s,
    l,
    u
  ]);
  return ze(() => {
    i && f({
      currentTarget: s.target
    }, s.pointerType);
  }, [
    i
  ]), {
    hoverProps: c,
    isHovered: o
  };
}
const db = /* @__PURE__ */ He({}), D9 = /* @__PURE__ */ dp(function(t, n) {
  [t, n] = Ii(t, n, db);
  let { elementType: r = "label", ...i } = t, o = Hn[r];
  return /* @__PURE__ */ H.createElement(o, {
    className: "react-aria-Label",
    ...i,
    ref: n
  });
});
function hO(e) {
  let { id: t, label: n, "aria-labelledby": r, "aria-label": i, labelElementType: o = "label" } = e;
  t = ir(t);
  let a = ir(), s = {};
  n ? (r = r ? `${a} ${r}` : a, s = {
    id: a,
    htmlFor: o === "label" ? t : void 0
  }) : !r && !i && process.env.NODE_ENV !== "production" && console.warn("If you do not provide a visible label, you must specify an aria-label or aria-labelledby attribute for accessibility");
  let l = QT({
    id: t,
    "aria-label": i,
    "aria-labelledby": r
  });
  return {
    labelProps: s,
    fieldProps: l
  };
}
function Zv(e, t = -1 / 0, n = 1 / 0) {
  return Math.min(Math.max(e, t), n);
}
const C9 = /* @__PURE__ */ He(null), mO = 7e3;
let Qa = null;
function ex(e, t = "assertive", n = mO) {
  Qa ? Qa.announce(e, t, n) : (Qa = new I9(), (typeof IS_REACT_ACT_ENVIRONMENT == "boolean" ? IS_REACT_ACT_ENVIRONMENT : typeof jest < "u") ? Qa.announce(e, t, n) : setTimeout(() => {
    Qa?.isAttached() && Qa?.announce(e, t, n);
  }, 100));
}
class I9 {
  constructor() {
    this.node = null, this.assertiveLog = null, this.politeLog = null, typeof document < "u" && (this.node = document.createElement("div"), this.node.dataset.liveAnnouncer = "true", Object.assign(this.node.style, {
      border: 0,
      clip: "rect(0 0 0 0)",
      clipPath: "inset(50%)",
      height: "1px",
      margin: "-1px",
      overflow: "hidden",
      padding: 0,
      position: "absolute",
      width: "1px",
      whiteSpace: "nowrap"
    }), this.assertiveLog = this.createLog("assertive"), this.node.appendChild(this.assertiveLog), this.politeLog = this.createLog("polite"), this.node.appendChild(this.politeLog), document.body.prepend(this.node));
  }
  isAttached() {
    return this.node?.isConnected;
  }
  createLog(t) {
    let n = document.createElement("div");
    return n.setAttribute("role", "log"), n.setAttribute("aria-live", t), n.setAttribute("aria-relevant", "additions"), n;
  }
  destroy() {
    this.node && (document.body.removeChild(this.node), this.node = null);
  }
  announce(t, n = "assertive", r = mO) {
    if (!this.node) return;
    let i = document.createElement("div");
    typeof t == "object" ? (i.setAttribute("role", "img"), i.setAttribute("aria-labelledby", t["aria-labelledby"])) : i.textContent = t, n === "assertive" ? this.assertiveLog?.appendChild(i) : this.politeLog?.appendChild(i), t !== "" && setTimeout(() => {
      i.remove();
    }, r);
  }
  clear(t) {
    this.node && ((!t || t === "assertive") && this.assertiveLog && (this.assertiveLog.innerHTML = ""), (!t || t === "polite") && this.politeLog && (this.politeLog.innerHTML = ""));
  }
}
function M9(e, t) {
  let { elementType: n = "button", isDisabled: r, onPress: i, onPressStart: o, onPressEnd: a, onPressUp: s, onPressChange: l, preventFocusOnPress: u, allowFocusWhenDisabled: c, onClick: f, href: d, target: p, rel: h, type: v = "button" } = e, m;
  n === "button" ? m = {
    type: v,
    disabled: r,
    form: e.form,
    formAction: e.formAction,
    formEncType: e.formEncType,
    formMethod: e.formMethod,
    formNoValidate: e.formNoValidate,
    formTarget: e.formTarget,
    name: e.name,
    value: e.value
  } : m = {
    role: "button",
    href: n === "a" && !r ? d : void 0,
    target: n === "a" ? p : void 0,
    type: n === "input" ? v : void 0,
    disabled: n === "input" ? r : void 0,
    "aria-disabled": !r || n === "input" ? void 0 : r,
    rel: n === "a" ? h : void 0
  };
  let { pressProps: g, isPressed: _ } = hp({
    onPressStart: o,
    onPressEnd: a,
    onPressChange: l,
    onPress: i,
    onPressUp: s,
    onClick: f,
    isDisabled: r,
    preventFocusOnPress: u,
    ref: t
  }), { focusableProps: x } = aO(e, t);
  c && (x.tabIndex = r ? -1 : x.tabIndex);
  let w = st(x, g, Dn(e, {
    labelable: !0
  }));
  return {
    isPressed: _,
    buttonProps: st(m, w, {
      "aria-haspopup": e["aria-haspopup"],
      "aria-expanded": e["aria-expanded"],
      "aria-controls": e["aria-controls"],
      "aria-pressed": e["aria-pressed"],
      "aria-current": e["aria-current"],
      "aria-disabled": e["aria-disabled"]
    })
  };
}
const pb = /* @__PURE__ */ He({}), hb = /* @__PURE__ */ dp(function(t, n) {
  [t, n] = Ii(t, n, pb);
  let r = t, { isPending: i } = r, { buttonProps: o, isPressed: a } = M9(t, n);
  o = N9(o, i);
  let { focusProps: s, isFocused: l, isFocusVisible: u } = vp(t), { hoverProps: c, isHovered: f } = ll({
    ...t,
    isDisabled: t.isDisabled || i
  }), d = {
    isHovered: f,
    isPressed: (r.isPressed || a) && !i,
    isFocused: l,
    isFocusVisible: u,
    isDisabled: t.isDisabled || !1,
    isPending: i ?? !1
  }, p = Vr({
    ...t,
    values: d,
    defaultClassName: "react-aria-Button"
  }), h = ir(o.id), v = ir(), m = o["aria-labelledby"];
  i && (m ? m = `${m} ${v}` : o["aria-label"] && (m = `${h} ${v}`));
  let g = ve(i);
  ze(() => {
    let x = {
      "aria-labelledby": m || h
    };
    (!g.current && l && i || g.current && l && !i) && ex(x, "assertive"), g.current = i;
  }, [
    i,
    l,
    m,
    h
  ]);
  let _ = Dn(t, {
    global: !0
  });
  return delete _.onClick, /* @__PURE__ */ H.createElement(Hn.button, {
    ...st(_, p, o, s, c),
    // When the button is in a pending state, we want to stop implicit form submission (ie. when the user presses enter on a text input).
    // We do this by changing the button's type to button.
    type: o.type === "submit" && i ? "button" : o.type,
    id: h,
    ref: n,
    "aria-labelledby": m,
    slot: t.slot || void 0,
    "aria-disabled": i ? "true" : o["aria-disabled"],
    "data-disabled": t.isDisabled || void 0,
    "data-pressed": d.isPressed || void 0,
    "data-hovered": f || void 0,
    "data-focused": l || void 0,
    "data-pending": i || void 0,
    "data-focus-visible": u || void 0
  }, /* @__PURE__ */ H.createElement(C9.Provider, {
    value: {
      id: v
    }
  }, p.children));
}), R9 = /Focus|Blur|Hover|Pointer(Enter|Leave|Over|Out)|Mouse(Enter|Leave|Over|Out)/;
function N9(e, t) {
  if (t) {
    for (const n in e) n.startsWith("on") && !R9.test(n) && (e[n] = void 0);
    e.href = void 0, e.target = void 0;
  }
  return e;
}
const gp = /* @__PURE__ */ He({});
function Ns(e, t) {
  if (!e) return !1;
  let n = window.getComputedStyle(e), r = document.scrollingElement || document.documentElement, i = /(auto|scroll)/.test(n.overflow + n.overflowX + n.overflowY);
  return e === r && n.overflow !== "hidden" && (i = !0), i && t && (i = e.scrollHeight !== e.clientHeight || e.scrollWidth !== e.clientWidth), i;
}
function mb(e, t) {
  let n = e;
  for (Ns(n, t) && (n = n.parentElement); n && !Ns(n, t); ) n = n.parentElement;
  return n || document.scrollingElement || document.documentElement;
}
function qh(e, t) {
  let n = [], r = document.scrollingElement || document.documentElement;
  for (; e && (Ns(e, t) && n.push(e), e !== r); )
    e = e.parentElement;
  return n;
}
function Sf(e, t, n = {}) {
  let { block: r = "nearest", inline: i = "nearest" } = n;
  if (e === t) return;
  let o = e.scrollTop, a = e.scrollLeft, s = t.getBoundingClientRect(), l = e.getBoundingClientRect(), u = window.getComputedStyle(t), c = window.getComputedStyle(e), f = document.scrollingElement || document.documentElement, d = e === f, p = e === f ? 0 : l.top, h = e === f ? e.clientHeight : l.bottom, v = e === f ? 0 : l.left, m = e === f ? e.clientWidth : l.right, g = parseFloat(u.scrollMarginTop) || 0, _ = parseFloat(u.scrollMarginBottom) || 0, x = parseFloat(u.scrollMarginLeft) || 0, w = parseFloat(u.scrollMarginRight) || 0, $ = parseFloat(c.scrollPaddingTop) || 0, k = parseFloat(c.scrollPaddingBottom) || 0, D = parseFloat(c.scrollPaddingLeft) || 0, E = parseFloat(c.scrollPaddingRight) || 0, b = parseFloat(c.borderTopWidth) || 0, y = parseFloat(c.borderBottomWidth) || 0, S = parseFloat(c.borderLeftWidth) || 0, P = parseFloat(c.borderRightWidth) || 0, M = s.top - g, T = s.bottom + _, V = s.left - x, z = s.right + w, U = e === f ? 0 : S + P, B = e === f ? 0 : b + y, N = e === f ? 0 : e.offsetWidth - e.clientWidth - U, C = e === f ? 0 : e.offsetHeight - e.clientHeight - B, G = p + (d ? 0 : b) + $, re = h - (d ? 0 : y) - k - C, ie = v + (d ? 0 : S) + D, X = m - (d ? 0 : P) - E;
  c.direction === "rtl" && !rc() ? ie += N : X -= N;
  let Se = M < G || T > re, me = V < ie || z > X;
  if (Se && r === "start") o += M - G;
  else if (Se && r === "center") o += (M + T) / 2 - (G + re) / 2;
  else if (Se && r === "end") o += T - re;
  else if (Se && r === "nearest") {
    let fe = M - G, Q = T - re;
    o += Math.abs(fe) <= Math.abs(Q) ? fe : Q;
  }
  if (me && i === "start") a += V - ie;
  else if (me && i === "center") a += (V + z) / 2 - (ie + X) / 2;
  else if (me && i === "end") a += z - X;
  else if (me && i === "nearest") {
    let fe = V - ie, Q = z - X;
    a += Math.abs(fe) <= Math.abs(Q) ? fe : Q;
  }
  if (process.env.NODE_ENV === "test") {
    e.scrollLeft = a, e.scrollTop = o;
    return;
  }
  e.scrollTo({
    left: a,
    top: o
  });
}
function tx(e, t = {}) {
  let { containingElement: n } = t;
  if (e && e.isConnected) {
    let r = document.scrollingElement || document.documentElement;
    if (window.getComputedStyle(r).overflow === "hidden") {
      let { left: o, top: a } = e.getBoundingClientRect(), s = qh(e, !0);
      for (let c of s) Sf(c, e);
      let { left: l, top: u } = e.getBoundingClientRect();
      if (Math.abs(o - l) > 1 || Math.abs(a - u) > 1) {
        s = n ? qh(n, !0) : [];
        for (let c of s) Sf(c, n, {
          block: "center",
          inline: "center"
        });
        for (let c of qh(e, !0)) Sf(c, e);
      }
    } else {
      let { left: o, top: a } = e.getBoundingClientRect();
      e?.scrollIntoView?.({
        block: "nearest"
      });
      let { left: s, top: l } = e.getBoundingClientRect();
      (Math.abs(o - s) > 1 || Math.abs(a - l) > 1) && (n?.scrollIntoView?.({
        block: "center",
        inline: "center"
      }), e.scrollIntoView?.({
        block: "nearest"
      }));
    }
  }
}
let j9 = 0;
const Hh = /* @__PURE__ */ new Map();
function F9(e) {
  let [t, n] = Ke();
  return dt(() => {
    if (!e) return;
    let r = Hh.get(e);
    if (r)
      n(r.element.id);
    else {
      let i = `react-aria-description-${j9++}`;
      n(i);
      let o = document.createElement("div");
      o.id = i, o.style.display = "none", o.textContent = e, document.body.appendChild(o), r = {
        refCount: 0,
        element: o
      }, Hh.set(e, r);
    }
    return r.refCount++, () => {
      r && --r.refCount === 0 && (r.element.remove(), Hh.delete(e));
    };
  }, [
    e
  ]), {
    "aria-describedby": e ? t : void 0
  };
}
const nx = {
  border: 0,
  clip: "rect(0 0 0 0)",
  clipPath: "inset(50%)",
  height: "1px",
  margin: "-1px",
  overflow: "hidden",
  padding: 0,
  position: "absolute",
  width: "1px",
  whiteSpace: "nowrap"
};
function vO(e = {}) {
  let { style: t, isFocusable: n } = e, [r, i] = Ke(!1), { focusWithinProps: o } = mp({
    isDisabled: !n,
    onFocusWithinChange: (s) => i(s)
  }), a = Fe(() => r ? t : t ? {
    ...nx,
    ...t
  } : nx, [
    r
  ]);
  return {
    visuallyHiddenProps: {
      ...o,
      style: a
    }
  };
}
function z9(e) {
  let { children: t, elementType: n = "div", isFocusable: r, style: i, ...o } = e, { visuallyHiddenProps: a } = vO(e);
  return /* @__PURE__ */ H.createElement(n, st(o, a), t);
}
const L9 = /* @__PURE__ */ He(null), gO = {
  badInput: !1,
  customError: !1,
  patternMismatch: !1,
  rangeOverflow: !1,
  rangeUnderflow: !1,
  stepMismatch: !1,
  tooLong: !1,
  tooShort: !1,
  typeMismatch: !1,
  valueMissing: !1,
  valid: !0
}, yO = {
  ...gO,
  customError: !0,
  valid: !1
}, Ml = {
  isInvalid: !1,
  validationDetails: gO,
  validationErrors: []
}, V9 = He({}), rx = "__reactAriaFormValidationState";
function B9(e) {
  if (e[rx]) {
    let { realtimeValidation: t, displayValidation: n, updateValidation: r, resetValidation: i, commitValidation: o } = e[rx];
    return {
      realtimeValidation: t,
      displayValidation: n,
      updateValidation: r,
      resetValidation: i,
      commitValidation: o
    };
  }
  return K9(e);
}
function K9(e) {
  let { isInvalid: t, validationState: n, name: r, value: i, builtinValidation: o, validate: a, validationBehavior: s = "aria" } = e;
  n && (t || (t = n === "invalid"));
  let l = t !== void 0 ? {
    isInvalid: t,
    validationErrors: [],
    validationDetails: yO
  } : null, u = Fe(() => {
    if (!a || i == null) return null;
    let y = U9(a, i);
    return ix(y);
  }, [
    a,
    i
  ]);
  o?.validationDetails.valid && (o = void 0);
  let c = je(V9), f = Fe(() => r ? Array.isArray(r) ? r.flatMap((y) => Gv(c[y])) : Gv(c[r]) : [], [
    c,
    r
  ]), [d, p] = Ke(c), [h, v] = Ke(!1);
  c !== d && (p(c), v(!1));
  let m = Fe(() => ix(h ? [] : f), [
    h,
    f
  ]), g = ve(Ml), [_, x] = Ke(Ml), w = ve(Ml), $ = () => {
    if (!k) return;
    D(!1);
    let y = u || o || g.current;
    Wh(y, w.current) || (w.current = y, x(y));
  }, [k, D] = Ke(!1);
  return ze($), {
    realtimeValidation: l || m || u || o || Ml,
    displayValidation: s === "native" ? l || m || _ : l || m || u || o || _,
    updateValidation(y) {
      s === "aria" && !Wh(_, y) ? x(y) : g.current = y;
    },
    resetValidation() {
      let y = Ml;
      Wh(y, w.current) || (w.current = y, x(y)), s === "native" && D(!1), v(!0);
    },
    commitValidation() {
      s === "native" && D(!0), v(!0);
    }
  };
}
function Gv(e) {
  return e ? Array.isArray(e) ? e : [
    e
  ] : [];
}
function U9(e, t) {
  if (typeof e == "function") {
    let n = e(t);
    if (n && typeof n != "boolean") return Gv(n);
  }
  return [];
}
function ix(e) {
  return e.length ? {
    isInvalid: !0,
    validationErrors: e,
    validationDetails: yO
  } : null;
}
function Wh(e, t) {
  return e === t ? !0 : !!e && !!t && e.isInvalid === t.isInvalid && e.validationErrors.length === t.validationErrors.length && e.validationErrors.every((n, r) => n === t.validationErrors[r]) && Object.entries(e.validationDetails).every(([n, r]) => t.validationDetails[n] === r);
}
const q9 = /* @__PURE__ */ He(null);
function H9(e) {
  let { description: t, errorMessage: n, isInvalid: r, validationState: i } = e, { labelProps: o, fieldProps: a } = hO(e), s = va([
    !!t,
    !!n,
    r,
    i
  ]), l = va([
    !!t,
    !!n,
    r,
    i
  ]);
  return a = st(a, {
    "aria-describedby": [
      s,
      // Use aria-describedby for error message because aria-errormessage is unsupported using VoiceOver or NVDA. See https://github.com/adobe/react-spectrum/issues/1346#issuecomment-740136268
      l,
      e["aria-describedby"]
    ].filter(Boolean).join(" ") || void 0
  }), {
    labelProps: o,
    fieldProps: a,
    descriptionProps: {
      id: s
    },
    errorMessageProps: {
      id: l
    }
  };
}
function W9(e, t, n) {
  let r = Rr((i) => {
    n && !i.defaultPrevented && n(t);
  });
  ze(() => {
    let i = e?.current?.form;
    return i?.addEventListener("reset", r), () => {
      i?.removeEventListener("reset", r);
    };
  }, [
    e
  ]);
}
function Z9(e, t, n) {
  let { validationBehavior: r, focus: i } = e;
  dt(() => {
    if (r === "native" && n?.current && "setCustomValidity" in n.current && !n.current.disabled) {
      let u = t.realtimeValidation.isInvalid ? t.realtimeValidation.validationErrors.join(" ") || "Invalid value." : "";
      n.current.setCustomValidity(u), n.current.hasAttribute("title") || (n.current.title = ""), t.realtimeValidation.isInvalid || t.updateValidation(Y9(n.current));
    }
  });
  let o = ve(!1), a = Rr(() => {
    o.current || t.resetValidation();
  }), s = Rr((u) => {
    t.displayValidation.isInvalid || t.commitValidation();
    let c = n?.current?.form;
    !u.defaultPrevented && n && c && Q9(c) === n.current && (i ? i() : n.current?.focus(), ad("keyboard")), u.preventDefault();
  }), l = Rr(() => {
    t.commitValidation();
  });
  ze(() => {
    let u = n?.current;
    if (!u) return;
    let c = u.form, f = c?.reset;
    return c && (c.reset = () => {
      o.current = !window.event || window.event.type === "message" && Ae(window.event) instanceof MessagePort, f?.call(c), o.current = !1;
    }), u.addEventListener("invalid", s), u.addEventListener("change", l), c?.addEventListener("reset", a), () => {
      u.removeEventListener("invalid", s), u.removeEventListener("change", l), c?.removeEventListener("reset", a), c && (c.reset = f);
    };
  }, [
    n,
    r
  ]);
}
function G9(e) {
  let t = e.validity;
  return {
    badInput: t.badInput,
    customError: t.customError,
    patternMismatch: t.patternMismatch,
    rangeOverflow: t.rangeOverflow,
    rangeUnderflow: t.rangeUnderflow,
    stepMismatch: t.stepMismatch,
    tooLong: t.tooLong,
    tooShort: t.tooShort,
    typeMismatch: t.typeMismatch,
    valueMissing: t.valueMissing,
    valid: t.valid
  };
}
function Y9(e) {
  return {
    isInvalid: !e.validity.valid,
    validationDetails: G9(e),
    validationErrors: e.validationMessage ? [
      e.validationMessage
    ] : []
  };
}
function Q9(e) {
  for (let t = 0; t < e.elements.length; t++) {
    let n = e.elements[t];
    if (n.validity?.valid === !1) return n;
  }
  return null;
}
const J9 = /* @__PURE__ */ He({});
let X9 = (e) => {
  let { onHoverStart: t, onHoverChange: n, onHoverEnd: r, ...i } = e;
  return i;
};
const eL = /* @__PURE__ */ dp(function(t, n) {
  [t, n] = Ii(t, n, J9);
  let { hoverProps: r, isHovered: i } = ll({
    ...t,
    isDisabled: t.disabled
  }), { isFocused: o, isFocusVisible: a, focusProps: s } = vp({
    isTextInput: !0,
    autoFocus: t.autoFocus
  }), l = !!t["aria-invalid"] && t["aria-invalid"] !== "false", u = Vr({
    ...t,
    values: {
      isHovered: i,
      isFocused: o,
      isFocusVisible: a,
      isDisabled: t.disabled || !1,
      isInvalid: l
    },
    defaultClassName: "react-aria-Input"
  });
  return /* @__PURE__ */ H.createElement(Hn.input, {
    ...st(X9(t), s, r),
    ...u,
    ref: n,
    "data-focused": o || void 0,
    "data-disabled": t.disabled || void 0,
    "data-hovered": i || void 0,
    "data-focus-visible": a || void 0,
    "data-invalid": l || void 0
  });
}), yp = /* @__PURE__ */ He({}), bO = /* @__PURE__ */ He(null), tL = /* @__PURE__ */ fn(function(t, n) {
  let { render: r } = je(bO);
  return /* @__PURE__ */ H.createElement(H.Fragment, null, r(t, n));
});
function _O(e, t) {
  let n = e?.renderDropIndicator, r = e?.isVirtualDragging?.(), i = Le(
    (o) => {
      if (r || t?.isDropTarget(o)) return n ? n(o) : /* @__PURE__ */ H.createElement(tL, {
        target: o
      });
    },
    // We invalidate whenever the target changes.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [
      t?.target,
      r,
      n
    ]
  );
  return e?.useDropIndicator ? i : void 0;
}
function nL(e, t, n) {
  let r = e.focusedKey, i = null;
  if (t?.isVirtualDragging?.() && n?.target?.type === "item" && (i = n.target.key, n.target.dropPosition === "after")) {
    let o = n.collection.getKeyAfter(i), a = null;
    if (o != null) {
      let s = n.collection.getItem(i)?.level ?? 0;
      for (; o != null; ) {
        let l = n.collection.getItem(o);
        if (!l) break;
        if (l.type !== "item") {
          o = n.collection.getKeyAfter(o);
          continue;
        }
        if ((l.level ?? 0) <= s) break;
        a = o, o = n.collection.getKeyAfter(o);
      }
    }
    i = o ?? a ?? i;
  }
  return Fe(() => new Set([
    r,
    i
  ].filter((o) => o != null)), [
    r,
    i
  ]);
}
const wO = /* @__PURE__ */ He({}), rL = /* @__PURE__ */ He(null);
function xO(e) {
  let t = ve({});
  return /* @__PURE__ */ H.createElement(rL.Provider, {
    value: t
  }, e.children);
}
const EO = /* @__PURE__ */ He({
  isSelected: !1
}), SO = /* @__PURE__ */ He({}), o1 = class o1 extends al {
  filter(t, n) {
    let r = n.getItem(this.prevKey);
    if (r && r.type !== "separator") {
      let i = this.clone();
      return n.addDescendants(i, t), i;
    }
    return null;
  }
};
o1.type = "separator";
let ox = o1;
const vb = /* @__PURE__ */ new WeakMap();
function iL(e) {
  return typeof e == "string" ? e.replace(/\s*/g, "") : "" + e;
}
function oL(e, t) {
  let n = vb.get(e);
  if (!n) throw new Error("Unknown list");
  return `${n.id}-option-${iL(t)}`;
}
class aL {
  constructor(t, n, r, i) {
    this._walkerStack = [], this._currentSetFor = /* @__PURE__ */ new Set(), this._acceptNode = (a) => {
      if (a.nodeType === Node.ELEMENT_NODE) {
        const s = a.shadowRoot;
        if (s) {
          const l = this._doc.createTreeWalker(s, this.whatToShow, {
            acceptNode: this._acceptNode
          });
          return this._walkerStack.unshift(l), NodeFilter.FILTER_ACCEPT;
        } else {
          if (typeof this.filter == "function") return this.filter(a);
          if (this.filter?.acceptNode) return this.filter.acceptNode(a);
          if (this.filter === null) return NodeFilter.FILTER_ACCEPT;
        }
      }
      return NodeFilter.FILTER_SKIP;
    }, this._doc = t, this.root = n, this.filter = i ?? null, this.whatToShow = r ?? NodeFilter.SHOW_ALL, this._currentNode = n, this._walkerStack.unshift(t.createTreeWalker(n, r, this._acceptNode));
    const o = n.shadowRoot;
    if (o) {
      const a = this._doc.createTreeWalker(o, this.whatToShow, {
        acceptNode: this._acceptNode
      });
      this._walkerStack.unshift(a);
    }
  }
  get currentNode() {
    return this._currentNode;
  }
  set currentNode(t) {
    if (!Je(this.root, t)) throw new Error("Cannot set currentNode to a node that is not contained by the root node.");
    const n = [];
    let r = t, i = t;
    for (this._currentNode = t; r && r !== this.root; ) if (r.nodeType === Node.DOCUMENT_FRAGMENT_NODE) {
      const a = r, s = this._doc.createTreeWalker(a, this.whatToShow, {
        acceptNode: this._acceptNode
      });
      n.push(s), s.currentNode = i, this._currentSetFor.add(s), r = i = a.host;
    } else r = r.parentNode;
    const o = this._doc.createTreeWalker(this.root, this.whatToShow, {
      acceptNode: this._acceptNode
    });
    n.push(o), o.currentNode = i, this._currentSetFor.add(o), this._walkerStack = n;
  }
  get doc() {
    return this._doc;
  }
  firstChild() {
    let t = this.currentNode, n = this.nextNode();
    return Je(t, n) ? (n && (this.currentNode = n), n) : (this.currentNode = t, null);
  }
  lastChild() {
    let n = this._walkerStack[0].lastChild();
    return n && (this.currentNode = n), n;
  }
  nextNode() {
    const t = this._walkerStack[0].nextNode();
    if (t) {
      if (t.shadowRoot) {
        let r;
        if (typeof this.filter == "function" ? r = this.filter(t) : this.filter?.acceptNode && (r = this.filter.acceptNode(t)), r === NodeFilter.FILTER_ACCEPT)
          return this.currentNode = t, t;
        let i = this.nextNode();
        return i && (this.currentNode = i), i;
      }
      return t && (this.currentNode = t), t;
    } else if (this._walkerStack.length > 1) {
      this._walkerStack.shift();
      let n = this.nextNode();
      return n && (this.currentNode = n), n;
    } else return null;
  }
  previousNode() {
    const t = this._walkerStack[0];
    if (t.currentNode === t.root) {
      if (this._currentSetFor.has(t))
        if (this._currentSetFor.delete(t), this._walkerStack.length > 1) {
          this._walkerStack.shift();
          let r = this.previousNode();
          return r && (this.currentNode = r), r;
        } else return null;
      return null;
    }
    const n = t.previousNode();
    if (n) {
      if (n.shadowRoot) {
        let i;
        if (typeof this.filter == "function" ? i = this.filter(n) : this.filter?.acceptNode && (i = this.filter.acceptNode(n)), i === NodeFilter.FILTER_ACCEPT)
          return n && (this.currentNode = n), n;
        let o = this.lastChild();
        return o && (this.currentNode = o), o;
      }
      return n && (this.currentNode = n), n;
    } else if (this._walkerStack.length > 1) {
      this._walkerStack.shift();
      let r = this.previousNode();
      return r && (this.currentNode = r), r;
    } else return null;
  }
  /**
  * @deprecated
  */
  nextSibling() {
    return null;
  }
  /**
  * @deprecated
  */
  previousSibling() {
    return null;
  }
  /**
  * @deprecated
  */
  parentNode() {
    return null;
  }
}
function $O(e, t, n, r) {
  return Fi() ? new aL(e, t, n, r) : e.createTreeWalker(t, n, r);
}
const ax = /* @__PURE__ */ H.createContext(null), Yv = "react-aria-focus-scope-restore";
let kt = null;
function gb(e) {
  let { children: t, contain: n, restoreFocus: r, autoFocus: i } = e, o = ve(null), a = ve(null), s = ve([]), { parentNode: l } = je(ax) || {}, u = Fe(() => new Jv({
    scopeRef: s
  }), [
    s
  ]);
  dt(() => {
    let d = l || cn.root;
    if (cn.getTreeNode(d.scopeRef) && kt && !cd(kt, d.scopeRef)) {
      let p = cn.getTreeNode(kt);
      p && (d = p);
    }
    d.addChild(u), cn.addNode(u);
  }, [
    u,
    l
  ]), dt(() => {
    let d = cn.getTreeNode(s);
    d && (d.contain = !!n);
  }, [
    n
  ]), dt(() => {
    let d = o.current?.nextSibling, p = [], h = (v) => v.stopPropagation();
    for (; d && d !== a.current; )
      p.push(d), d.addEventListener(Yv, h), d = d.nextSibling;
    return s.current = p, () => {
      for (let v of p) v.removeEventListener(Yv, h);
    };
  }, [
    t
  ]), pL(s, r, n), cL(s, n), hL(s, r, n), dL(s, i), ze(() => {
    const d = Lt(ot(s.current ? s.current[0] : void 0));
    let p = null;
    if (Fr(d, s.current)) {
      for (let h of cn.traverse()) h.scopeRef && Fr(d, h.scopeRef.current) && (p = h);
      p === cn.getTreeNode(s) && (kt = p.scopeRef);
    }
  }, [
    s
  ]), dt(() => () => {
    let d = cn.getTreeNode(s)?.parent?.scopeRef ?? null;
    (s === kt || cd(s, kt)) && (!d || cn.getTreeNode(d)) && (kt = d), cn.removeTreeNode(s);
  }, [
    s
  ]);
  let c = Fe(() => sL(s), []), f = Fe(() => ({
    focusManager: c,
    parentNode: u
  }), [
    u,
    c
  ]);
  return /* @__PURE__ */ H.createElement(ax.Provider, {
    value: f
  }, /* @__PURE__ */ H.createElement("span", {
    "data-focus-scope-start": !0,
    hidden: !0,
    ref: o
  }), t, /* @__PURE__ */ H.createElement("span", {
    "data-focus-scope-end": !0,
    hidden: !0,
    ref: a
  }));
}
function sL(e) {
  return {
    focusNext(t = {}) {
      let n = e.current, { from: r, tabbable: i, wrap: o, accept: a } = t, s = r || Lt(ot(n[0] ?? void 0)), l = n[0].previousElementSibling, u = fa(n), c = Bi(u, {
        tabbable: i,
        accept: a
      }, n);
      c.currentNode = Fr(s, n) ? s : l;
      let f = c.nextNode();
      return !f && o && (c.currentNode = l, f = c.nextNode()), f && Vi(f, !0), f;
    },
    focusPrevious(t = {}) {
      let n = e.current, { from: r, tabbable: i, wrap: o, accept: a } = t, s = r || Lt(ot(n[0] ?? void 0)), l = n[n.length - 1].nextElementSibling, u = fa(n), c = Bi(u, {
        tabbable: i,
        accept: a
      }, n);
      c.currentNode = Fr(s, n) ? s : l;
      let f = c.previousNode();
      return !f && o && (c.currentNode = l, f = c.previousNode()), f && Vi(f, !0), f;
    },
    focusFirst(t = {}) {
      let n = e.current, { tabbable: r, accept: i } = t, o = fa(n), a = Bi(o, {
        tabbable: r,
        accept: i
      }, n);
      a.currentNode = n[0].previousElementSibling;
      let s = a.nextNode();
      return s && Vi(s, !0), s;
    },
    focusLast(t = {}) {
      let n = e.current, { tabbable: r, accept: i } = t, o = fa(n), a = Bi(o, {
        tabbable: r,
        accept: i
      }, n);
      a.currentNode = n[n.length - 1].nextElementSibling;
      let s = a.previousNode();
      return s && Vi(s, !0), s;
    }
  };
}
function fa(e) {
  return e[0].parentElement;
}
function Zl(e) {
  let t = cn.getTreeNode(kt);
  for (; t && t.scopeRef !== e; ) {
    if (t.contain) return !1;
    t = t.parent;
  }
  return !0;
}
function lL(e) {
  if (!e.form)
    return Array.from(ot(e).querySelectorAll(`input[type="radio"][name="${CSS.escape(e.name)}"]`)).filter((r) => !r.form);
  const t = e.form.elements.namedItem(e.name);
  let n = Pn(e);
  return t instanceof n.RadioNodeList ? Array.from(t).filter((r) => r instanceof n.HTMLInputElement) : t instanceof n.HTMLInputElement ? [
    t
  ] : [];
}
function uL(e) {
  if (e.checked) return !0;
  const t = lL(e);
  return t.length > 0 && !t.some((n) => n.checked);
}
function cL(e, t) {
  let n = ve(void 0), r = ve(void 0);
  dt(() => {
    let i = e.current;
    if (!t) {
      r.current && (cancelAnimationFrame(r.current), r.current = void 0);
      return;
    }
    const o = ot(i ? i[0] : void 0);
    let a = (u) => {
      if (u.key !== "Tab" || u.altKey || u.ctrlKey || u.metaKey || !Zl(e) || u.isComposing) return;
      let c = Lt(o), f = e.current;
      if (!f || !Fr(c, f)) return;
      let d = fa(f), p = Bi(d, {
        tabbable: !0
      }, f);
      if (!c) return;
      p.currentNode = c;
      let h = u.shiftKey ? p.previousNode() : p.nextNode();
      h || (p.currentNode = u.shiftKey ? f[f.length - 1].nextElementSibling : f[0].previousElementSibling, h = u.shiftKey ? p.previousNode() : p.nextNode()), u.preventDefault(), h && (Vi(h, !0), h instanceof Pn(h).HTMLInputElement && h.select());
    }, s = (u) => {
      (!kt || cd(kt, e)) && Fr(Ae(u), e.current) ? (kt = e, n.current = Ae(u)) : Zl(e) && !yo(Ae(u), e) ? n.current ? n.current.focus() : kt && kt.current && Qv(kt.current) : Zl(e) && (n.current = Ae(u));
    }, l = (u) => {
      r.current && cancelAnimationFrame(r.current), r.current = requestAnimationFrame(() => {
        let c = Su(), f = (c === "virtual" || c === null) && ob() && qT(), d = Lt(o);
        if (!f && d && Zl(e) && !yo(d, e)) {
          kt = e;
          let p = Ae(u);
          p && p.isConnected ? (n.current = p, n.current?.focus()) : kt.current && Qv(kt.current);
        }
      });
    };
    return o.addEventListener("keydown", a, !1), o.addEventListener("focusin", s, !1), i?.forEach((u) => u.addEventListener("focusin", s, !1)), i?.forEach((u) => u.addEventListener("focusout", l, !1)), () => {
      o.removeEventListener("keydown", a, !1), o.removeEventListener("focusin", s, !1), i?.forEach((u) => u.removeEventListener("focusin", s, !1)), i?.forEach((u) => u.removeEventListener("focusout", l, !1));
    };
  }, [
    e,
    t
  ]), dt(() => () => {
    r.current && cancelAnimationFrame(r.current);
  }, [
    r
  ]);
}
function kO(e) {
  return yo(e);
}
function Fr(e, t) {
  return !e || !t ? !1 : t.some((n) => Je(n, e));
}
function yo(e, t = null) {
  if (e instanceof Element && e.closest("[data-react-aria-top-layer]")) return !0;
  for (let { scopeRef: n } of cn.traverse(cn.getTreeNode(t)))
    if (n && Fr(e, n.current)) return !0;
  return !1;
}
function fL(e) {
  return yo(e, kt);
}
function cd(e, t) {
  let n = cn.getTreeNode(t)?.parent;
  for (; n; ) {
    if (n.scopeRef === e) return !0;
    n = n.parent;
  }
  return !1;
}
function Vi(e, t = !1) {
  if (e != null && !t) try {
    Rs(e);
  } catch {
  }
  else if (e != null) try {
    e.focus();
  } catch {
  }
}
function TO(e, t = !0) {
  let n = e[0].previousElementSibling, r = fa(e), i = Bi(r, {
    tabbable: t
  }, e);
  i.currentNode = n;
  let o = i.nextNode();
  return t && !o && (r = fa(e), i = Bi(r, {
    tabbable: !1
  }, e), i.currentNode = n, o = i.nextNode()), o;
}
function Qv(e, t = !0) {
  Vi(TO(e, t));
}
function dL(e, t) {
  const n = H.useRef(t);
  ze(() => {
    if (n.current) {
      kt = e;
      const r = ot(e.current ? e.current[0] : void 0);
      !Fr(Lt(r), kt.current) && e.current && Qv(e.current);
    }
    n.current = !1;
  }, [
    e
  ]);
}
function pL(e, t, n) {
  dt(() => {
    if (t || n) return;
    let r = e.current;
    const i = ot(r ? r[0] : void 0);
    let o = (a) => {
      let s = Ae(a);
      Fr(s, e.current) ? kt = e : kO(s) || (kt = null);
    };
    return i.addEventListener("focusin", o, !1), r?.forEach((a) => a.addEventListener("focusin", o, !1)), () => {
      i.removeEventListener("focusin", o, !1), r?.forEach((a) => a.removeEventListener("focusin", o, !1));
    };
  }, [
    e,
    t,
    n
  ]);
}
function sx(e) {
  let t = cn.getTreeNode(kt);
  for (; t && t.scopeRef !== e; ) {
    if (t.nodeToRestore) return !1;
    t = t.parent;
  }
  return t?.scopeRef === e;
}
function hL(e, t, n) {
  const r = ve(typeof document < "u" ? Lt(ot(e.current ? e.current[0] : void 0)) : null);
  dt(() => {
    let i = e.current;
    const o = ot(i ? i[0] : void 0);
    if (!t || n) return;
    let a = () => {
      (!kt || cd(kt, e)) && Fr(Lt(o), e.current) && (kt = e);
    };
    return o.addEventListener("focusin", a, !1), i?.forEach((s) => s.addEventListener("focusin", a, !1)), () => {
      o.removeEventListener("focusin", a, !1), i?.forEach((s) => s.removeEventListener("focusin", a, !1));
    };
  }, [
    e,
    n
  ]), dt(() => {
    const i = ot(e.current ? e.current[0] : void 0);
    if (!t) return;
    let o = (a) => {
      if (a.key !== "Tab" || a.altKey || a.ctrlKey || a.metaKey || !Zl(e) || a.isComposing) return;
      let s = i.activeElement;
      if (!yo(s, e) || !sx(e)) return;
      let l = cn.getTreeNode(e);
      if (!l) return;
      let u = l.nodeToRestore, c = Bi(i.body, {
        tabbable: !0
      });
      c.currentNode = s;
      let f = a.shiftKey ? c.previousNode() : c.nextNode();
      if ((!u || !u.isConnected || u === i.body) && (u = void 0, l.nodeToRestore = void 0), (!f || !yo(f, e)) && u) {
        c.currentNode = u;
        do
          f = a.shiftKey ? c.previousNode() : c.nextNode();
        while (yo(f, e));
        a.preventDefault(), a.stopPropagation(), f ? Vi(f, !0) : kO(u) ? Vi(u, !0) : s.blur();
      }
    };
    return n || i.addEventListener("keydown", o, !0), () => {
      n || i.removeEventListener("keydown", o, !0);
    };
  }, [
    e,
    t,
    n
  ]), dt(() => {
    const i = ot(e.current ? e.current[0] : void 0);
    if (!t) return;
    let o = cn.getTreeNode(e);
    if (o)
      return o.nodeToRestore = r.current ?? void 0, () => {
        let a = cn.getTreeNode(e);
        if (!a) return;
        let s = a.nodeToRestore, l = Lt(i);
        if (t && s && (l && yo(l, e) || l === i.body && sx(e))) {
          let u = cn.clone();
          requestAnimationFrame(() => {
            if (i.activeElement === i.body) {
              let c = u.getTreeNode(e);
              for (; c; ) {
                if (c.nodeToRestore && c.nodeToRestore.isConnected) {
                  lx(c.nodeToRestore);
                  return;
                }
                c = c.parent;
              }
              for (c = u.getTreeNode(e); c; ) {
                if (c.scopeRef && // TODO: this is probably a false positive based on naming, it's not a real ref, rename.
                // oxlint-disable-next-line react-hooks/exhaustive-deps
                c.scopeRef.current && cn.getTreeNode(c.scopeRef)) {
                  let f = TO(c.scopeRef.current, !0);
                  lx(f);
                  return;
                }
                c = c.parent;
              }
            }
          });
        }
      };
  }, [
    e,
    t
  ]);
}
function lx(e) {
  e.dispatchEvent(new CustomEvent(Yv, {
    bubbles: !0,
    cancelable: !0
  })) && Vi(e);
}
function Bi(e, t, n) {
  let r = t?.tabbable ? zT : FT, i = e?.nodeType === Node.ELEMENT_NODE ? e : null, o = ot(i), a = $O(o, e || o, NodeFilter.SHOW_ELEMENT, {
    acceptNode(s) {
      return Je(t?.from, s) || t?.tabbable && s.tagName === "INPUT" && s.getAttribute("type") === "radio" && (!uL(s) || a.currentNode.tagName === "INPUT" && a.currentNode.type === "radio" && a.currentNode.name === s.name) ? NodeFilter.FILTER_REJECT : r(s) && (!n || Fr(s, n)) && (!t?.accept || t.accept(s)) ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_SKIP;
    }
  });
  return t?.from && (a.currentNode = t.from), a;
}
class yb {
  constructor() {
    this.fastMap = /* @__PURE__ */ new Map(), this.root = new Jv({
      scopeRef: null
    }), this.fastMap.set(null, this.root);
  }
  get size() {
    return this.fastMap.size;
  }
  getTreeNode(t) {
    return this.fastMap.get(t);
  }
  addTreeNode(t, n, r) {
    let i = this.fastMap.get(n ?? null);
    if (!i) return;
    let o = new Jv({
      scopeRef: t
    });
    i.addChild(o), o.parent = i, this.fastMap.set(t, o), r && (o.nodeToRestore = r);
  }
  addNode(t) {
    this.fastMap.set(t.scopeRef, t);
  }
  removeTreeNode(t) {
    if (t === null) return;
    let n = this.fastMap.get(t);
    if (!n) return;
    let r = n.parent;
    for (let o of this.traverse()) o !== n && n.nodeToRestore && o.nodeToRestore && n.scopeRef && n.scopeRef.current && Fr(o.nodeToRestore, n.scopeRef.current) && (o.nodeToRestore = n.nodeToRestore);
    let i = n.children;
    r && (r.removeChild(n), i.size > 0 && i.forEach((o) => r && r.addChild(o))), this.fastMap.delete(n.scopeRef);
  }
  // Pre Order Depth First
  *traverse(t = this.root) {
    if (t.scopeRef != null && (yield t), t.children.size > 0) for (let n of t.children) yield* this.traverse(n);
  }
  clone() {
    let t = new yb();
    for (let n of this.traverse()) t.addTreeNode(n.scopeRef, n.parent?.scopeRef ?? null, n.nodeToRestore);
    return t;
  }
}
class Jv {
  constructor(t) {
    this.children = /* @__PURE__ */ new Set(), this.contain = !1, this.scopeRef = t.scopeRef;
  }
  addChild(t) {
    this.children.add(t), t.parent = this;
  }
  removeChild(t) {
    this.children.delete(t), t.parent = void 0;
  }
}
let cn = new yb();
function Xv(e) {
  return Ez() ? e.altKey : e.ctrlKey;
}
function ga(e, t) {
  let n = `[data-key="${CSS.escape(String(t))}"]`, r = e.current?.dataset.collection;
  return r && (n = `[data-collection="${CSS.escape(r)}"]${n}`), e.current?.querySelector(n);
}
const OO = /* @__PURE__ */ new WeakMap();
function mL(e) {
  let t = ir();
  return OO.set(e, t), t;
}
function vL(e) {
  return OO.get(e);
}
const ux = 1e3;
function PO(e) {
  let { keyboardDelegate: t, selectionManager: n, onTypeSelect: r } = e, i = ve({
    search: "",
    timeout: void 0
  }), o = (s) => {
    if (i.current.search.length > 0 && s.key === " ") {
      if (s.preventDefault(), (!("continuePropagation" in s) || "continuePropagation" in s && !s.isPropagationStopped()) && s.stopPropagation(), i.current.search += " ", t.getKeyForSearch != null) {
        let l = t.getKeyForSearch(i.current.search, n.focusedKey);
        l == null && (l = t.getKeyForSearch(i.current.search)), l != null && (n.setFocusedKey(l), r && r(l));
      }
      clearTimeout(i.current.timeout), i.current.timeout = setTimeout(() => {
        i.current.search = "";
      }, ux);
    }
  }, a = (s) => {
    let l = gL(s.key);
    if (!(!l || s.ctrlKey || s.metaKey || s.altKey || !Je(s.currentTarget, Ae(s)) || i.current.search.length === 0 && l === " ")) {
      if (i.current.search += l, t.getKeyForSearch != null) {
        let u = t.getKeyForSearch(i.current.search, n.focusedKey);
        if (u == null && (u = t.getKeyForSearch(i.current.search)), u != null)
          n.setFocusedKey(u), r && r(u), s.preventDefault(), "continuePropagation" in s || s.stopPropagation();
        else {
          i.current.search = "", clearTimeout(i.current.timeout), i.current.timeout = void 0;
          return;
        }
      }
      clearTimeout(i.current.timeout), i.current.timeout = setTimeout(() => {
        i.current.search = "";
      }, ux);
    }
  };
  return ze(() => {
    let s = i.current.timeout;
    return () => {
      clearTimeout(s);
    };
  }, [
    i
  ]), {
    typeSelectProps: {
      // Using a capturing listener to catch the keydown event before
      // other hooks in order to handle the Spacebar event.
      onKeyDownCapture: t.getKeyForSearch ? o : void 0,
      onKeyDown: t.getKeyForSearch ? a : void 0
    }
  };
}
function gL(e) {
  return e.length === 1 || !/^[A-Z]/i.test(e) ? e : "";
}
function cx(e, t) {
  const n = ve(!0), r = ve(null);
  dt(() => (n.current = !0, () => {
    n.current = !1;
  }), []), dt(() => {
    n.current ? n.current = !1 : (!r.current || t.some((i, o) => !Object.is(i, r[o]))) && e(), r.current = t;
  }, t);
}
function yL(e) {
  let { selectionManager: t, keyboardDelegate: n, ref: r, autoFocus: i = !1, shouldFocusWrap: o = !1, disallowEmptySelection: a = !1, disallowSelectAll: s = !1, escapeKeyBehavior: l = "clearSelection", selectOnFocus: u = t.selectionBehavior === "replace", disallowTypeAhead: c = !1, shouldUseVirtualFocus: f, allowsTabNavigation: d = !1, scrollRef: p = r, linkBehavior: h = "action", UNSTABLE_focusOnEntry: v } = e, { direction: m } = ol(), g = lp(), _ = (z) => {
    if (z.altKey && z.key === "Tab" && z.preventDefault(), !r.current || !Je(r.current, Ae(z))) return;
    const U = (B, N) => {
      if (B != null) {
        if (t.isLink(B) && h === "selection" && u && !Xv(z)) {
          ly(() => {
            t.setFocusedKey(B, N);
          });
          let C = ga(r, B), G = t.getItemProps(B);
          C && g.open(C, z, G.href, G.routerOptions);
          return;
        }
        if (t.setFocusedKey(B, N), t.isLink(B) && h === "override") return;
        z.shiftKey && t.selectionMode === "multiple" ? t.extendSelection(B) : u && !Xv(z) && t.replaceSelection(B);
      }
    };
    switch (z.key) {
      case "ArrowDown":
        if (n.getKeyBelow) {
          let B = t.focusedKey != null ? n.getKeyBelow?.(t.focusedKey) : n.getFirstKey?.();
          B == null && o && (B = n.getFirstKey?.(t.focusedKey)), B != null && (z.preventDefault(), U(B));
        }
        break;
      case "ArrowUp":
        if (n.getKeyAbove) {
          let B = t.focusedKey != null ? n.getKeyAbove?.(t.focusedKey) : n.getLastKey?.();
          B == null && o && (B = n.getLastKey?.(t.focusedKey)), B != null && (z.preventDefault(), U(B));
        }
        break;
      case "ArrowLeft":
        if (n.getKeyLeftOf) {
          let B = t.focusedKey != null ? n.getKeyLeftOf?.(t.focusedKey) : n.getFirstKey?.();
          B == null && o && (B = m === "rtl" ? n.getFirstKey?.(t.focusedKey) : n.getLastKey?.(t.focusedKey)), B != null && (z.preventDefault(), U(B, m === "rtl" ? "first" : "last"));
        }
        break;
      case "ArrowRight":
        if (n.getKeyRightOf) {
          let B = t.focusedKey != null ? n.getKeyRightOf?.(t.focusedKey) : n.getFirstKey?.();
          B == null && o && (B = m === "rtl" ? n.getLastKey?.(t.focusedKey) : n.getFirstKey?.(t.focusedKey)), B != null && (z.preventDefault(), U(B, m === "rtl" ? "last" : "first"));
        }
        break;
      case "Home":
        if (n.getFirstKey) {
          if (t.focusedKey === null && z.shiftKey) return;
          z.preventDefault();
          let B = n.getFirstKey(t.focusedKey, ns(z));
          t.setFocusedKey(B), B != null && (ns(z) && z.shiftKey && t.selectionMode === "multiple" ? t.extendSelection(B) : u && t.replaceSelection(B));
        }
        break;
      case "End":
        if (n.getLastKey) {
          if (t.focusedKey === null && z.shiftKey) return;
          z.preventDefault();
          let B = n.getLastKey(t.focusedKey, ns(z));
          t.setFocusedKey(B), B != null && (ns(z) && z.shiftKey && t.selectionMode === "multiple" ? t.extendSelection(B) : u && t.replaceSelection(B));
        }
        break;
      case "PageDown":
        if (n.getKeyPageBelow && t.focusedKey != null) {
          let B = n.getKeyPageBelow(t.focusedKey);
          B != null && (z.preventDefault(), U(B));
        }
        break;
      case "PageUp":
        if (n.getKeyPageAbove && t.focusedKey != null) {
          let B = n.getKeyPageAbove(t.focusedKey);
          B != null && (z.preventDefault(), U(B));
        }
        break;
      case "a":
        ns(z) && t.selectionMode === "multiple" && s !== !0 && (z.preventDefault(), t.selectAll());
        break;
      case "Escape":
        l === "clearSelection" && !a && t.selectedKeys.size !== 0 && (z.stopPropagation(), z.preventDefault(), t.clearSelection());
        break;
      case "Tab":
        if (!d) {
          if (z.shiftKey) r.current.focus();
          else {
            let B = Bi(r.current, {
              tabbable: !0
            }), N, C;
            do
              C = B.lastChild(), C && (N = C);
            while (C);
            let G = Lt();
            N && (!rd(N) || G && !zT(G)) && ai(N);
          }
          break;
        }
    }
  }, x = ve({
    top: 0,
    left: 0
  });
  Rc(p, "scroll", () => {
    x.current = {
      top: p.current?.scrollTop ?? 0,
      left: p.current?.scrollLeft ?? 0
    };
  });
  let w = (z) => {
    if (t.isFocused) {
      Je(z.currentTarget, Ae(z)) || t.setFocused(!1);
      return;
    }
    if (!Je(z.currentTarget, Ae(z))) return;
    let U = Su();
    t.setFocused(!0);
    let B = (N) => {
      N != null && (t.setFocusedKey(N), u && !t.isSelected(N) && t.replaceSelection(N));
    };
    if (v && (U === "keyboard" || U === "virtual"))
      B(v === "first" ? n.getFirstKey?.() : n.getLastKey?.());
    else if (t.focusedKey == null) {
      let N = z.relatedTarget;
      N && z.currentTarget.compareDocumentPosition(N) & Node.DOCUMENT_POSITION_FOLLOWING ? B(t.lastSelectedKey ?? n.getLastKey?.()) : B(t.firstSelectedKey ?? n.getFirstKey?.());
    } else p.current && (p.current.scrollTop = x.current.top, p.current.scrollLeft = x.current.left);
    if (t.focusedKey != null && p.current) {
      let N = ga(r, t.focusedKey);
      N instanceof HTMLElement && (!rd(N) && !f && ai(N), (U === "keyboard" || v && U === "virtual") && tx(N, {
        containingElement: r.current
      }));
    }
  }, $ = (z) => {
    Je(z.currentTarget, z.relatedTarget) || t.setFocused(!1);
  }, k = ve(!1);
  Rc(r, lz, f ? (z) => {
    let { detail: U } = z;
    z.stopPropagation(), t.setFocused(!0), U?.focusStrategy === "first" && (k.current = !0);
  } : void 0);
  let D = n.getFirstKey?.() ?? null;
  cx(() => {
    if (k.current)
      if (D == null) {
        let z = Lt();
        NT(r.current), jT(z, null), t.collection.size > 0 && (k.current = !1);
      } else
        t.setFocusedKey(D), k.current = !1;
  }, [
    D,
    t.collection.size
  ]), cx(() => {
    t.collection.size > 0 && (k.current = !1);
  }, [
    t.focusedKey
  ]), Rc(r, sz, f ? (z) => {
    z.stopPropagation(), t.setFocused(!1), z.detail?.clearFocusKey && t.setFocusedKey(null);
  } : void 0);
  const E = ve(i), b = ve(!1);
  ze(() => {
    if (E.current) {
      let z = null;
      i === "first" && (z = n.getFirstKey?.() ?? null), i === "last" && (z = n.getLastKey?.() ?? null);
      let U = t.selectedKeys;
      if (U.size) {
        for (let B of U) if (t.canSelectItem(B)) {
          z = B;
          break;
        }
      }
      t.setFocused(!0), t.setFocusedKey(z), z == null && !f && r.current && Rs(r.current), t.collection.size > 0 && (E.current = !1, b.current = !0);
    }
  });
  let y = ve(t.focusedKey), S = ve(null);
  ze(() => {
    if (t.isFocused && t.focusedKey != null && (t.focusedKey !== y.current || b.current) && p.current && r.current) {
      let z = Su(), U = ga(r, t.focusedKey);
      if (!(U instanceof HTMLElement))
        return;
      (z === "keyboard" || b.current) && (S.current && cancelAnimationFrame(S.current), S.current = requestAnimationFrame(() => {
        p.current && (Sf(p.current, U), z !== "virtual" && tx(U, {
          containingElement: r.current
        }));
      }));
    }
    !f && t.isFocused && t.focusedKey == null && y.current != null && r.current && Rs(r.current), y.current = t.focusedKey, b.current = !1;
  }), ze(() => () => {
    S.current && cancelAnimationFrame(S.current);
  }, []), Rc(r, "react-aria-focus-scope-restore", (z) => {
    z.preventDefault(), t.setFocused(!0);
  });
  let P = {
    onKeyDown: _,
    onFocus: w,
    onBlur: $,
    onMouseDown(z) {
      p.current === Ae(z) && z.preventDefault();
    }
  }, { typeSelectProps: M } = PO({
    keyboardDelegate: n,
    selectionManager: t
  });
  c || (P = st(M, P));
  let T;
  f || (T = t.focusedKey == null ? 0 : -1);
  let V = mL(t.collection);
  return {
    collectionProps: st(P, {
      tabIndex: T,
      "data-collection": V
    })
  };
}
class fx {
  constructor(t) {
    this.ref = t;
  }
  getItemRect(t) {
    let n = this.ref.current;
    if (!n) return null;
    let r = t != null ? ga(this.ref, t) : null;
    if (!r) return null;
    let i = n.getBoundingClientRect(), o = r.getBoundingClientRect();
    return {
      x: o.left - i.left - n.clientLeft + n.scrollLeft,
      y: o.top - i.top - n.clientTop + n.scrollTop,
      width: o.width,
      height: o.height
    };
  }
  getContentSize() {
    let t = this.ref.current;
    return {
      width: t?.scrollWidth ?? 0,
      height: t?.scrollHeight ?? 0
    };
  }
  getVisibleRect() {
    let t = this.ref.current;
    return {
      x: t?.scrollLeft ?? 0,
      y: t?.scrollTop ?? 0,
      width: t?.clientWidth ?? 0,
      height: t?.clientHeight ?? 0
    };
  }
}
class bb {
  constructor(...t) {
    if (t.length === 1) {
      let n = t[0];
      this.collection = n.collection, this.ref = n.ref, this.collator = n.collator, this.disabledKeys = n.disabledKeys || /* @__PURE__ */ new Set(), this.disabledBehavior = n.disabledBehavior || "all", this.orientation = n.orientation || "vertical", this.direction = n.direction, this.layout = n.layout || "stack", this.layoutDelegate = n.layoutDelegate || new fx(n.ref);
    } else
      this.collection = t[0], this.disabledKeys = t[1], this.ref = t[2], this.collator = t[3], this.layout = "stack", this.orientation = "vertical", this.disabledBehavior = "all", this.layoutDelegate = new fx(this.ref);
    this.layout === "stack" && this.orientation === "vertical" && (this.getKeyLeftOf = void 0, this.getKeyRightOf = void 0);
  }
  isDisabled(t) {
    return this.disabledBehavior === "all" && (t.props?.isDisabled || this.disabledKeys.has(t.key)) && t.props?.disabledBehavior !== "selection";
  }
  findNextNonDisabled(t, n, r = !1) {
    let i = t;
    for (; i != null; ) {
      let o = this.collection.getItem(i);
      if (o?.type === "item" && (r || !this.isDisabled(o))) return i;
      i = n(i);
    }
    return null;
  }
  getNextKey(t, n) {
    let r = t;
    return r = this.collection.getKeyAfter(r), this.findNextNonDisabled(r, (i) => this.collection.getKeyAfter(i), n?.includeDisabled);
  }
  getPreviousKey(t, n) {
    let r = t;
    return r = this.collection.getKeyBefore(r), this.findNextNonDisabled(r, (i) => this.collection.getKeyBefore(i), n?.includeDisabled);
  }
  findKey(t, n, r) {
    let i = t, o = this.layoutDelegate.getItemRect(i);
    if (!o || i == null) return null;
    let a = o;
    do {
      if (i = n(i), i == null) break;
      o = this.layoutDelegate.getItemRect(i);
    } while (o && r(a, o) && i != null);
    return i;
  }
  isSameRow(t, n) {
    return t.y === n.y || t.x !== n.x;
  }
  isSameColumn(t, n) {
    return t.x === n.x || t.y !== n.y;
  }
  // checks to see if the next/prev key is spatially above/below the current key. If not, that means we are in
  // a reversed column layout and need to adjust appropriately
  // TODO: still need to see how this works with virtualizer once there is handling for the reverse layout
  // this felt like a simpler approach then changing getKeyAbove/Below to be purely spatial calculations
  isReversed(t) {
    let n = this.getNextKey(t), r = ga(this.ref, t);
    if (n != null) {
      let o = ga(this.ref, n);
      return !r || !o ? !1 : r.getBoundingClientRect().top > o.getBoundingClientRect().top;
    }
    let i = this.getPreviousKey(t);
    if (i != null) {
      let o = ga(this.ref, i);
      return !r || !o ? !1 : o.getBoundingClientRect().top > r.getBoundingClientRect().top;
    }
    return !1;
  }
  getKeyBelow(t, n) {
    return this.layout === "grid" && this.orientation === "vertical" ? this.findKey(t, (r) => this.getNextKey(r, n), this.isSameRow) : this.orientation === "vertical" ? this.isReversed(t) ? this.getPreviousKey(t, n) : this.getNextKey(t, n) : this.getNextKey(t, n);
  }
  getKeyAbove(t, n) {
    return this.layout === "grid" && this.orientation === "vertical" ? this.findKey(t, (r) => this.getPreviousKey(r, n), this.isSameRow) : this.orientation === "vertical" ? this.isReversed(t) ? this.getNextKey(t, n) : this.getPreviousKey(t, n) : this.getPreviousKey(t, n);
  }
  getNextColumn(t, n, r) {
    return n ? this.getPreviousKey(t, r) : this.getNextKey(t, r);
  }
  getKeyRightOf(t, n) {
    let r = this.direction === "ltr" ? "getKeyRightOf" : "getKeyLeftOf";
    return this.layoutDelegate[r] ? (t = this.layoutDelegate[r](t), this.findNextNonDisabled(t, (i) => this.layoutDelegate[r](i), n?.includeDisabled)) : this.layout === "grid" ? this.orientation === "vertical" ? this.getNextColumn(t, this.direction === "rtl", n) : this.findKey(t, (i) => this.getNextColumn(i, this.direction === "rtl", n), this.isSameColumn) : this.orientation === "horizontal" ? this.getNextColumn(t, this.direction === "rtl", n) : null;
  }
  getKeyLeftOf(t, n) {
    let r = this.direction === "ltr" ? "getKeyLeftOf" : "getKeyRightOf";
    return this.layoutDelegate[r] ? (t = this.layoutDelegate[r](t), this.findNextNonDisabled(t, (i) => this.layoutDelegate[r](i), n?.includeDisabled)) : this.layout === "grid" ? this.orientation === "vertical" ? this.getNextColumn(t, this.direction === "ltr", n) : this.findKey(t, (i) => this.getNextColumn(i, this.direction === "ltr", n), this.isSameColumn) : this.orientation === "horizontal" ? this.getNextColumn(t, this.direction === "ltr", n) : null;
  }
  getFirstKey() {
    let t = this.collection.getFirstKey();
    return this.findNextNonDisabled(t, (n) => this.collection.getKeyAfter(n));
  }
  getLastKey() {
    let t = this.collection.getLastKey();
    return this.findNextNonDisabled(t, (n) => this.collection.getKeyBefore(n));
  }
  getKeyPageAbove(t) {
    let n = this.ref.current, r = this.layoutDelegate.getItemRect(t);
    if (!r) return null;
    let i = this.isReversed(t);
    if (n && !Ns(n)) return this.getFirstKey();
    let o = t;
    if (this.orientation === "horizontal") {
      let a = Math.max(0, r.x + r.width - this.layoutDelegate.getVisibleRect().width);
      for (; r && r.x > a && o != null; )
        o = this.getKeyAbove(o), r = o == null ? null : this.layoutDelegate.getItemRect(o);
    } else {
      let a = this.layoutDelegate.getVisibleRect(), s = i ? r.y - a.height : Math.max(0, r.y + r.height - a.height);
      for (; r && r.y > s && o != null; )
        o = this.getKeyAbove(o), r = o == null ? null : this.layoutDelegate.getItemRect(o);
    }
    return o ?? (i ? this.getLastKey() : this.getFirstKey());
  }
  getKeyPageBelow(t) {
    let n = this.ref.current, r = this.layoutDelegate.getItemRect(t);
    if (!r) return null;
    let i = this.isReversed(t);
    if (n && !Ns(n)) return this.getLastKey();
    let o = t;
    if (this.orientation === "horizontal") {
      let a = Math.min(this.layoutDelegate.getContentSize().width, r.x - r.width + this.layoutDelegate.getVisibleRect().width);
      for (; r && r.x < a && o != null; )
        o = this.getKeyBelow(o), r = o == null ? null : this.layoutDelegate.getItemRect(o);
    } else {
      let a = Math.min(this.layoutDelegate.getContentSize().height, r.y - r.height + this.layoutDelegate.getVisibleRect().height);
      for (; r && r.y < a && o != null; )
        o = this.getKeyBelow(o), r = o == null ? null : this.layoutDelegate.getItemRect(o);
    }
    return o ?? (i ? this.getFirstKey() : this.getLastKey());
  }
  getKeyForSearch(t, n) {
    if (!this.collator) return null;
    let r = this.collection, i = n || this.getFirstKey();
    for (; i != null; ) {
      let o = r.getItem(i);
      if (!o) return null;
      let a = o.textValue.slice(0, t.length);
      if (o.textValue && this.collator.compare(a, t) === 0) return i;
      i = this.getNextKey(i);
    }
    return null;
  }
}
let Zh = /* @__PURE__ */ new Map();
function _b(e) {
  let { locale: t } = ol(), n = t + (e ? Object.entries(e).sort((i, o) => i[0] < o[0] ? -1 : 1).join() : "");
  if (Zh.has(n)) return Zh.get(n);
  let r = new Intl.Collator(t, e);
  return Zh.set(n, r), r;
}
function AO(e) {
  let { selectionManager: t, collection: n, disabledKeys: r, ref: i, keyboardDelegate: o, layoutDelegate: a, orientation: s } = e, l = _b({
    usage: "search",
    sensitivity: "base"
  }), u = t.disabledBehavior, c = Fe(() => o || new bb({
    collection: n,
    disabledKeys: r,
    disabledBehavior: u,
    ref: i,
    collator: l,
    layoutDelegate: a,
    orientation: s
  }), [
    o,
    a,
    n,
    r,
    i,
    l,
    u,
    s
  ]), { collectionProps: f } = yL({
    ...e,
    ref: i,
    selectionManager: t,
    keyboardDelegate: c
  });
  return {
    listProps: f
  };
}
function bL(e, t, n) {
  let r = Dn(e, {
    labelable: !0
  }), i = e.selectionBehavior || "toggle", o = e.orientation || "vertical", a = e.linkBehavior || (i === "replace" ? "action" : "override");
  i === "toggle" && a === "action" && (a = "override");
  let { listProps: s } = AO({
    ...e,
    ref: n,
    selectionManager: t.selectionManager,
    collection: t.collection,
    disabledKeys: t.disabledKeys,
    linkBehavior: a
  }), { focusWithinProps: l } = mp({
    onFocusWithin: e.onFocus,
    onBlurWithin: e.onBlur,
    onFocusWithinChange: e.onFocusChange
  }), u = ir(e.id);
  vb.set(t, {
    id: u,
    shouldUseVirtualFocus: e.shouldUseVirtualFocus,
    shouldSelectOnPressUp: e.shouldSelectOnPressUp,
    shouldFocusOnHover: e.shouldFocusOnHover,
    isVirtualized: e.isVirtualized,
    onAction: e.onAction,
    linkBehavior: a,
    // @ts-ignore
    UNSTABLE_itemBehavior: e.UNSTABLE_itemBehavior
  });
  let { labelProps: c, fieldProps: f } = hO({
    ...e,
    id: u,
    // listbox is not an HTML input element so it
    // shouldn't be labeled by a <label> element.
    labelElementType: "span"
  });
  return {
    labelProps: c,
    listBoxProps: st(r, l, t.selectionManager.selectionMode === "multiple" ? {
      "aria-multiselectable": "true"
    } : {}, {
      role: "listbox",
      "aria-orientation": o,
      ...st(f, s)
    })
  };
}
const _L = 500;
function DO(e) {
  let { isDisabled: t, onLongPressStart: n, onLongPressEnd: r, onLongPress: i, threshold: o = _L, accessibilityDescription: a } = e;
  const s = ve(void 0);
  let { addGlobalListener: l, removeGlobalListener: u } = pp(), { pressProps: c } = hp({
    isDisabled: t,
    onPressStart(d) {
      if (d.continuePropagation(), (d.pointerType === "mouse" || d.pointerType === "touch") && (n && n({
        ...d,
        type: "longpressstart"
      }), s.current = setTimeout(() => {
        d.target.dispatchEvent(new PointerEvent("pointercancel", {
          bubbles: !0
        })), ot(d.target).activeElement !== d.target && ai(d.target), i && i({
          ...d,
          type: "longpress"
        }), s.current = void 0;
      }, o), d.pointerType === "touch")) {
        let p = (v) => {
          v.preventDefault();
        }, h = Pn(d.target);
        l(d.target, "contextmenu", p, {
          once: !0
        }), l(h, "pointerup", () => {
          setTimeout(() => {
            u(d.target, "contextmenu", p);
          }, 30);
        }, {
          once: !0
        });
      }
    },
    onPressEnd(d) {
      s.current && clearTimeout(s.current), r && (d.pointerType === "mouse" || d.pointerType === "touch") && r({
        ...d,
        type: "longpressend"
      });
    }
  }), f = F9(i && !t ? a : void 0);
  return {
    longPressProps: st(c, f)
  };
}
function CO(e) {
  let { id: t, selectionManager: n, key: r, ref: i, shouldSelectOnPressUp: o, shouldUseVirtualFocus: a, focus: s, isDisabled: l, onAction: u, allowsDifferentPressOrigin: c, linkBehavior: f = "action" } = e, d = lp();
  t = ir(t);
  let p = (C) => {
    if (C.pointerType === "keyboard" && Xv(C)) n.toggleSelection(r);
    else {
      if (n.selectionMode === "none") return;
      if (n.isLink(r)) {
        if (f === "selection" && i.current) {
          let G = n.getItemProps(r);
          d.open(i.current, C, G.href, G.routerOptions), n.setSelectedKeys(n.selectedKeys);
          return;
        } else if (f === "override" || f === "none") return;
      }
      n.selectionMode === "single" ? n.isSelected(r) && !n.disallowEmptySelection ? n.toggleSelection(r) : n.replaceSelection(r) : C && C.shiftKey ? n.extendSelection(r) : n.selectionBehavior === "toggle" || C && (ns(C) || C.pointerType === "touch" || C.pointerType === "virtual") ? n.toggleSelection(r) : n.replaceSelection(r);
    }
  };
  ze(() => {
    r === n.focusedKey && n.isFocused && (a ? NT(i.current) : s ? s() : Lt() !== i.current && i.current && Rs(i.current));
  }, [
    i,
    r,
    n.focusedKey,
    n.childFocusStrategy,
    n.isFocused,
    a
  ]), l = l || n.isDisabled(r);
  let h = {};
  !a && !l ? h = {
    tabIndex: r === n.focusedKey ? 0 : -1,
    onFocus(C) {
      Ae(C) === i.current && n.setFocusedKey(r);
    }
  } : l && (h.onMouseDown = (C) => {
    C.preventDefault();
  }), ze(() => {
    l && n.focusedKey === r && n.setFocusedKey(null);
  }, [
    n,
    l,
    r
  ]);
  let v = n.isLink(r) && f === "override", m = u && e.UNSTABLE_itemBehavior === "action", g = n.isLink(r) && f !== "selection" && f !== "none", _ = !l && n.canSelectItem(r) && !v && !m, x = (u || g) && !l, w = x && (n.selectionBehavior === "replace" ? !_ : !_ || n.isEmpty), $ = x && _ && n.selectionBehavior === "replace", k = w || $, D = ve(null), E = k && _, b = ve(!1), y = ve(!1), S = n.getItemProps(r), P = (C) => {
    u && (u(), i.current?.dispatchEvent(new CustomEvent("react-aria-item-action", {
      bubbles: !0
    }))), g && i.current && d.open(i.current, C, S.href, S.routerOptions);
  }, M = {
    ref: i
  };
  if (o ? (M.onPressStart = (C) => {
    D.current = C.pointerType, b.current = E, C.pointerType === "keyboard" && (!k || px(C.key)) && p(C);
  }, c ? (M.onPressUp = w ? void 0 : (C) => {
    C.pointerType === "mouse" && _ && p(C);
  }, M.onPress = w ? P : (C) => {
    C.pointerType !== "keyboard" && C.pointerType !== "mouse" && _ && p(C);
  }) : M.onPress = (C) => {
    if (w || $ && C.pointerType !== "mouse") {
      if (C.pointerType === "keyboard" && !dx(C.key)) return;
      P(C);
    } else C.pointerType !== "keyboard" && _ && p(C);
  }) : (M.onPressStart = (C) => {
    D.current = C.pointerType, b.current = E, y.current = w, _ && (C.pointerType === "mouse" && !w || C.pointerType === "keyboard" && (!x || px(C.key))) && p(C);
  }, M.onPress = (C) => {
    (C.pointerType === "touch" || C.pointerType === "pen" || C.pointerType === "virtual" || C.pointerType === "keyboard" && k && dx(C.key) || C.pointerType === "mouse" && y.current) && (k ? P(C) : _ && p(C));
  }), h["data-collection"] = vL(n.collection), h["data-key"] = r, M.preventFocusOnPress = a, a && (M = st(M, {
    onPressStart(C) {
      C.pointerType !== "touch" && (n.setFocused(!0), n.setFocusedKey(r));
    },
    onPress(C) {
      C.pointerType === "touch" && (n.setFocused(!0), n.setFocusedKey(r));
    }
  })), S)
    for (let C of [
      "onPressStart",
      "onPressEnd",
      "onPressChange",
      "onPress",
      "onPressUp",
      "onClick"
    ]) S[C] && (M[C] = Na(M[C], S[C]));
  let { pressProps: T, isPressed: V } = hp(M), z = $ ? (C) => {
    D.current === "mouse" && (C.stopPropagation(), C.preventDefault(), P(C));
  } : void 0, { longPressProps: U } = DO({
    isDisabled: !E,
    onLongPress(C) {
      C.pointerType === "touch" && (p(C), n.setSelectionBehavior("toggle"));
    }
  }), B = (C) => {
    D.current === "touch" && b.current && C.preventDefault();
  }, N = f !== "none" && n.isLink(r) ? (C) => {
    Zi.isOpening || C.preventDefault();
  } : void 0;
  return {
    itemProps: st(
      h,
      _ || w || a && !l ? T : {},
      E ? U : {},
      {
        onDoubleClick: z,
        onDragStartCapture: B,
        onClick: N,
        id: t
      },
      // Prevent DOM focus from moving on mouse down when using virtual focus
      a ? {
        onMouseDown: (C) => C.preventDefault()
      } : void 0
    ),
    isPressed: V,
    isSelected: n.isSelected(r),
    isFocused: n.isFocused && n.focusedKey === r,
    isDisabled: l,
    allowsSelection: _,
    hasAction: k
  };
}
function dx(e) {
  return e === "Enter";
}
function px(e) {
  return e === " ";
}
function IO(e, t) {
  return typeof t.getChildren == "function" ? t.getChildren(e.key) : e.childNodes;
}
function wL(e) {
  return xL(e);
}
function xL(e, t) {
  for (let n of e)
    return n;
}
function Gh(e, t, n) {
  if (t.parentKey === n.parentKey) return t.index - n.index;
  let r = [
    ...hx(e, t),
    t
  ], i = [
    ...hx(e, n),
    n
  ], o = r.slice(0, i.length).findIndex((a, s) => a !== i[s]);
  return o !== -1 ? (t = r[o], n = i[o], t.index - n.index) : r.findIndex((a) => a === n) >= 0 ? 1 : (i.findIndex((a) => a === t) >= 0, -1);
}
function hx(e, t) {
  let n = [], r = t;
  for (; r?.parentKey != null; )
    r = e.getItem(r.parentKey), r && n.unshift(r);
  return n;
}
const mx = /* @__PURE__ */ new WeakMap();
function MO(e) {
  let t = mx.get(e);
  if (t != null) return t;
  let n = 0, r = (i) => {
    for (let o of i)
      o.type === "section" ? r(IO(o, e)) : o.type === "item" && n++;
  };
  return r(e), mx.set(e, n), n;
}
function EL(e, t, n) {
  let { key: r } = e, i = vb.get(t), o = e.isDisabled ?? t.selectionManager.isDisabled(r), a = e.isSelected ?? t.selectionManager.isSelected(r), s = e.shouldSelectOnPressUp ?? i?.shouldSelectOnPressUp, l = e.shouldFocusOnHover ?? i?.shouldFocusOnHover, u = e.shouldUseVirtualFocus ?? i?.shouldUseVirtualFocus, c = e.isVirtualized ?? i?.isVirtualized, f = va(), d = va(), p = {
    role: "option",
    "aria-disabled": o || void 0,
    "aria-selected": t.selectionManager.selectionMode !== "none" ? a : void 0,
    "aria-label": e["aria-label"],
    "aria-labelledby": f,
    "aria-describedby": d
  }, h = t.collection.getItem(r);
  if (c) {
    let b = Number(h?.index);
    p["aria-posinset"] = Number.isNaN(b) ? void 0 : b + 1, p["aria-setsize"] = MO(t.collection);
  }
  let v = i?.onAction ? () => i?.onAction?.(r) : void 0, m = oL(t, r), { itemProps: g, isPressed: _, isFocused: x, hasAction: w, allowsSelection: $ } = CO({
    selectionManager: t.selectionManager,
    key: r,
    ref: n,
    shouldSelectOnPressUp: s,
    allowsDifferentPressOrigin: s && l,
    isVirtualized: c,
    shouldUseVirtualFocus: u,
    isDisabled: o,
    onAction: v || h?.props?.onAction ? Na(h?.props?.onAction, v) : void 0,
    linkBehavior: i?.linkBehavior,
    // @ts-ignore
    UNSTABLE_itemBehavior: i?.UNSTABLE_itemBehavior,
    id: m
  }), { hoverProps: k } = ll({
    isDisabled: o || !l,
    onHoverStart() {
      Sa() || (t.selectionManager.setFocused(!0), t.selectionManager.setFocusedKey(r));
    }
  }), D = Dn(h?.props);
  delete D.id;
  let E = HT(h?.props);
  return {
    optionProps: {
      ...p,
      ...st(D, g, k, E),
      id: m
    },
    labelProps: {
      id: f
    },
    descriptionProps: {
      id: d
    },
    isFocused: x,
    isFocusVisible: x && t.selectionManager.isFocused && Sa(),
    isSelected: a,
    isDisabled: o,
    isPressed: _,
    allowsSelection: $,
    hasAction: w
  };
}
function SL(e) {
  let { heading: t, "aria-label": n } = e, r = ir();
  return {
    itemProps: {
      role: "presentation"
    },
    headingProps: t ? {
      // Technically, listbox cannot contain headings according to ARIA.
      // We hide the heading from assistive technology, using role="presentation",
      // and only use it as a visual label for the nested group.
      id: r,
      role: "presentation",
      onMouseDown: (i) => {
        i.preventDefault();
      }
    } : {},
    groupProps: {
      role: "group",
      "aria-label": n,
      "aria-labelledby": t ? r : void 0
    }
  };
}
function $L(e) {
  const t = y6.split(".");
  return parseInt(t[0], 10) >= 19 ? e : e ? "true" : void 0;
}
class vx {
  constructor(t) {
    this.keyMap = /* @__PURE__ */ new Map(), this.firstKey = null, this.lastKey = null, this.iterable = t;
    let n = (a) => {
      if (this.keyMap.set(a.key, a), a.childNodes && a.type === "section") for (let s of a.childNodes) n(s);
    };
    for (let a of t) n(a);
    let r = null, i = 0, o = 0;
    for (let [a, s] of this.keyMap)
      r ? (r.nextKey = a, s.prevKey = r.key) : (this.firstKey = a, s.prevKey = void 0), s.type === "item" && (s.index = i++), (s.type === "section" || s.type === "item") && o++, r = s, r.nextKey = void 0;
    this._size = o, this.lastKey = r?.key ?? null;
  }
  *[Symbol.iterator]() {
    yield* this.iterable;
  }
  get size() {
    return this._size;
  }
  getKeys() {
    return this.keyMap.keys();
  }
  getKeyBefore(t) {
    let n = this.keyMap.get(t);
    return n ? n.prevKey ?? null : null;
  }
  getKeyAfter(t) {
    let n = this.keyMap.get(t);
    return n ? n.nextKey ?? null : null;
  }
  getFirstKey() {
    return this.firstKey;
  }
  getLastKey() {
    return this.lastKey;
  }
  getItem(t) {
    return this.keyMap.get(t) ?? null;
  }
  at(t) {
    const n = [
      ...this.getKeys()
    ];
    return this.getItem(n[t]);
  }
  getChildren(t) {
    return this.keyMap.get(t)?.childNodes || [];
  }
}
class Qr extends Set {
  constructor(t, n, r) {
    super(t), t instanceof Qr ? (this.anchorKey = n ?? t.anchorKey, this.currentKey = r ?? t.currentKey) : (this.anchorKey = n ?? null, this.currentKey = r ?? null);
  }
}
function kL(e, t) {
  if (e.size !== t.size) return !1;
  for (let n of e)
    if (!t.has(n)) return !1;
  return !0;
}
function wb(e) {
  let { selectionMode: t = "none", disallowEmptySelection: n = !1, allowDuplicateSelectionEvents: r, selectionBehavior: i = "toggle", disabledBehavior: o = "all" } = e, a = ve(!1), [, s] = Ke(!1), l = ve(null), u = ve(null), [, c] = Ke(null), f = Fe(() => gx(e.selectedKeys), [
    e.selectedKeys
  ]), d = Fe(() => gx(e.defaultSelectedKeys, new Qr()), [
    e.defaultSelectedKeys
  ]), [p, h] = fp(f, d, e.onSelectionChange), v = Fe(() => e.disabledKeys ? new Set(e.disabledKeys) : /* @__PURE__ */ new Set(), [
    e.disabledKeys
  ]), [m, g] = Ke(i);
  i === "replace" && m === "toggle" && typeof p == "object" && p.size === 0 && g("replace");
  let _ = ve(i);
  return ze(() => {
    i !== _.current && (g(i), _.current = i);
  }, [
    i
  ]), {
    selectionMode: t,
    disallowEmptySelection: n,
    selectionBehavior: m,
    setSelectionBehavior: g,
    get isFocused() {
      return a.current;
    },
    setFocused(x) {
      a.current = x, s(x);
    },
    get focusedKey() {
      return l.current;
    },
    get childFocusStrategy() {
      return u.current;
    },
    setFocusedKey(x, w = "first") {
      l.current = x, u.current = w, c(x);
    },
    selectedKeys: p,
    setSelectedKeys(x) {
      (r || !kL(x, p)) && h(x);
    },
    disabledKeys: v,
    disabledBehavior: o
  };
}
function gx(e, t) {
  return e ? e === "all" ? "all" : new Qr(e) : t;
}
class ic {
  constructor(t, n, r) {
    this.collection = t, this.state = n, this.allowsCellSelection = r?.allowsCellSelection ?? !1, this._isSelectAll = null, this.layoutDelegate = r?.layoutDelegate || null, this.fullCollection = r?.fullCollection || null;
  }
  /**
  * The type of selection that is allowed in the collection.
  */
  get selectionMode() {
    return this.state.selectionMode;
  }
  /**
  * Whether the collection allows empty selection.
  */
  get disallowEmptySelection() {
    return this.state.disallowEmptySelection;
  }
  /**
  * The selection behavior for the collection.
  */
  get selectionBehavior() {
    return this.state.selectionBehavior;
  }
  /**
  * Sets the selection behavior for the collection.
  */
  setSelectionBehavior(t) {
    this.state.setSelectionBehavior(t);
  }
  /**
  * Whether the collection is currently focused.
  */
  get isFocused() {
    return this.state.isFocused;
  }
  /**
  * Sets whether the collection is focused.
  */
  setFocused(t) {
    this.state.setFocused(t);
  }
  /**
  * The current focused key in the collection.
  */
  get focusedKey() {
    return this.state.focusedKey;
  }
  /** Whether the first or last child of the focused key should receive focus. */
  get childFocusStrategy() {
    return this.state.childFocusStrategy;
  }
  /**
  * Sets the focused key.
  */
  setFocusedKey(t, n) {
    (t == null || this.collection.getItem(t)) && this.state.setFocusedKey(t, n);
  }
  /**
  * The currently selected keys in the collection.
  */
  get selectedKeys() {
    return this.state.selectedKeys === "all" ? new Set(this.getSelectAllKeys()) : this.state.selectedKeys;
  }
  /**
  * The raw selection value for the collection.
  * Either 'all' for select all, or a set of keys.
  */
  get rawSelection() {
    return this.state.selectedKeys;
  }
  /**
  * Returns whether a key is selected.
  */
  isSelected(t) {
    if (this.state.selectionMode === "none") return !1;
    let n = this.getKey(t);
    return n == null ? !1 : this.state.selectedKeys === "all" ? this.canSelectItem(n) : this.state.selectedKeys.has(n);
  }
  /**
  * Whether the selection is empty.
  */
  get isEmpty() {
    return this.state.selectedKeys !== "all" && this.state.selectedKeys.size === 0;
  }
  /**
  * Whether all items in the collection are selected.
  */
  get isSelectAll() {
    if (this.isEmpty) return !1;
    if (this.state.selectedKeys === "all") return !0;
    if (this._isSelectAll != null) return this._isSelectAll;
    let t = this.getSelectAllKeys(), n = this.state.selectedKeys;
    return this._isSelectAll = t.every((r) => n.has(r)), this._isSelectAll;
  }
  get firstSelectedKey() {
    let t = null;
    for (let n of this.state.selectedKeys) {
      let r = this.collection.getItem(n);
      (!t || r && Gh(this.collection, r, t) < 0) && (t = r);
    }
    return t?.key ?? null;
  }
  get lastSelectedKey() {
    let t = null;
    for (let n of this.state.selectedKeys) {
      let r = this.collection.getItem(n);
      (!t || r && Gh(this.collection, r, t) > 0) && (t = r);
    }
    return t?.key ?? null;
  }
  get disabledKeys() {
    return this.state.disabledKeys;
  }
  get disabledBehavior() {
    return this.state.disabledBehavior;
  }
  /**
  * Extends the selection to the given key.
  */
  extendSelection(t) {
    if (this.selectionMode === "none") return;
    if (this.selectionMode === "single") {
      this.replaceSelection(t);
      return;
    }
    let n = this.getKey(t);
    if (n == null) return;
    let r;
    if (this.state.selectedKeys === "all") r = new Qr([
      n
    ], n, n);
    else {
      let i = this.state.selectedKeys, o = i.anchorKey ?? n;
      r = new Qr(i, o, n);
      for (let a of this.getKeyRange(o, i.currentKey ?? n)) r.delete(a);
      for (let a of this.getKeyRange(n, o)) this.canSelectItem(a) && r.add(a);
    }
    this.state.setSelectedKeys(r);
  }
  getKeyRange(t, n) {
    let r = this.collection.getItem(t), i = this.collection.getItem(n);
    return r && i ? Gh(this.collection, r, i) <= 0 ? this.getKeyRangeInternal(t, n) : this.getKeyRangeInternal(n, t) : [];
  }
  getKeyRangeInternal(t, n) {
    if (this.layoutDelegate?.getKeyRange) return this.layoutDelegate.getKeyRange(t, n);
    let r = [], i = t;
    for (; i != null; ) {
      let o = this.collection.getItem(i);
      if (o && (o.type === "item" || o.type === "cell" && this.allowsCellSelection) && r.push(i), i === n) return r;
      i = this.collection.getKeyAfter(i);
    }
    return [];
  }
  getKey(t) {
    let n = this.collection.getItem(t);
    if (!n || n.type === "cell" && this.allowsCellSelection) return t;
    for (; n && n.type !== "item" && n.parentKey != null; ) n = this.collection.getItem(n.parentKey);
    return !n || n.type !== "item" ? null : n.key;
  }
  /**
  * Toggles whether the given key is selected.
  */
  toggleSelection(t) {
    if (this.selectionMode === "none") return;
    if (this.selectionMode === "single" && !this.isSelected(t)) {
      this.replaceSelection(t);
      return;
    }
    let n = this.getKey(t);
    if (n == null) return;
    let r = new Qr(this.state.selectedKeys === "all" ? this.getSelectAllKeys() : this.state.selectedKeys);
    r.has(n) ? r.delete(n) : this.canSelectItem(n) && (r.add(n), r.anchorKey = n, r.currentKey = n), !(this.disallowEmptySelection && r.size === 0) && this.state.setSelectedKeys(r);
  }
  /**
  * Replaces the selection with only the given key.
  */
  replaceSelection(t) {
    if (this.selectionMode === "none") return;
    let n = this.getKey(t);
    if (n == null) return;
    let r = this.canSelectItem(n) ? new Qr([
      n
    ], n, n) : new Qr();
    this.state.setSelectedKeys(r);
  }
  /**
  * Replaces the selection with the given keys.
  */
  setSelectedKeys(t) {
    if (this.selectionMode === "none") return;
    let n = new Qr();
    for (let r of t) {
      let i = this.getKey(r);
      if (i != null && (n.add(i), this.selectionMode === "single"))
        break;
    }
    this.state.setSelectedKeys(n);
  }
  getSelectAllKeys() {
    let t = this.fullCollection ?? this.collection, n = [], r = (i) => {
      for (; i != null; ) {
        if (this.canSelectItemIn(i, t)) {
          let o = t.getItem(i);
          o?.type === "item" && n.push(i), o?.hasChildNodes && (this.allowsCellSelection || o.type !== "item") && r(wL(IO(o, t))?.key ?? null);
        }
        i = t.getKeyAfter(i);
      }
    };
    return r(t.getFirstKey()), n;
  }
  /**
  * Selects all items in the collection.
  */
  selectAll() {
    !this.isSelectAll && this.selectionMode === "multiple" && this.state.setSelectedKeys("all");
  }
  /**
  * Removes all keys from the selection.
  */
  clearSelection() {
    !this.disallowEmptySelection && (this.state.selectedKeys === "all" || this.state.selectedKeys.size > 0) && this.state.setSelectedKeys(new Qr());
  }
  /**
  * Toggles between select all and an empty selection.
  */
  toggleSelectAll() {
    this.isSelectAll ? this.clearSelection() : this.selectAll();
  }
  select(t, n) {
    this.selectionMode !== "none" && (this.selectionMode === "single" ? this.isSelected(t) && !this.disallowEmptySelection ? this.toggleSelection(t) : this.replaceSelection(t) : this.selectionBehavior === "toggle" || n && (n.pointerType === "touch" || n.pointerType === "virtual") ? this.toggleSelection(t) : this.replaceSelection(t));
  }
  /**
  * Returns whether the current selection is equal to the given selection.
  */
  isSelectionEqual(t) {
    if (t === this.state.selectedKeys) return !0;
    let n = this.selectedKeys;
    if (t.size !== n.size) return !1;
    for (let r of t)
      if (!n.has(r)) return !1;
    for (let r of n)
      if (!t.has(r)) return !1;
    return !0;
  }
  canSelectItem(t) {
    return this.canSelectItemIn(t, this.collection);
  }
  canSelectItemIn(t, n) {
    if (this.state.selectionMode === "none" || this.state.disabledKeys.has(t)) return !1;
    let r = n.getItem(t);
    return !(!r || r?.props?.isDisabled || r.type === "cell" && !this.allowsCellSelection);
  }
  isDisabled(t) {
    let n = this.collection.getItem(t);
    return this.state.disabledBehavior === "all" && (this.state.disabledKeys.has(t) || !!n?.props?.isDisabled) && n?.props?.disabledBehavior !== "selection";
  }
  isLink(t) {
    return !!this.collection.getItem(t)?.props?.href;
  }
  getItemProps(t) {
    return this.collection.getItem(t)?.props;
  }
  withCollection(t) {
    return new ic(t, this.state, {
      allowsCellSelection: this.allowsCellSelection,
      layoutDelegate: this.layoutDelegate || void 0,
      fullCollection: this.fullCollection ?? this.collection
    });
  }
}
class TL {
  build(t, n) {
    return this.context = n, yx(() => this.iterateCollection(t));
  }
  *iterateCollection(t) {
    let { children: n, items: r } = t;
    if (H.isValidElement(n) && n.type === H.Fragment) yield* this.iterateCollection({
      children: n.props.children,
      items: r
    });
    else if (typeof n == "function") {
      if (!r) throw new Error("props.children was a function but props.items is missing");
      let i = 0;
      for (let o of r)
        yield* this.getFullNode({
          value: o,
          index: i
        }, {
          renderer: n
        }), i++;
    } else {
      let i = [];
      H.Children.forEach(n, (a) => {
        a && i.push(a);
      });
      let o = 0;
      for (let a of i) {
        let s = this.getFullNode({
          element: a,
          index: o
        }, {});
        for (let l of s)
          o++, yield l;
      }
    }
  }
  getKey(t, n, r, i) {
    if (t.key != null) return t.key;
    if (n.type === "cell" && n.key != null) return `${i}${n.key}`;
    let o = n.value;
    if (o != null) {
      let a = o.key ?? o.id;
      if (a == null) throw new Error("No key found for item");
      return a;
    }
    return i ? `${i}.${n.index}` : `$.${n.index}`;
  }
  getChildState(t, n) {
    return {
      renderer: n.renderer || t.renderer
    };
  }
  *getFullNode(t, n, r, i) {
    if (H.isValidElement(t.element) && t.element.type === H.Fragment) {
      let l = [];
      H.Children.forEach(t.element.props.children, (c) => {
        l.push(c);
      });
      let u = t.index ?? 0;
      for (const c of l) yield* this.getFullNode({
        element: c,
        index: u++
      }, n, r, i);
      return;
    }
    let o = t.element;
    if (!o && t.value && n && n.renderer) {
      let l = this.cache.get(t.value);
      if (l && (!l.shouldInvalidate || !l.shouldInvalidate(this.context))) {
        l.index = t.index, l.parentKey = i ? i.key : null, yield l;
        return;
      }
      o = n.renderer(t.value);
    }
    if (H.isValidElement(o)) {
      let l = o.type;
      if (typeof l != "function" && typeof l.getCollectionNode != "function") {
        let d = o.type;
        throw new Error(`Unknown element <${d}> in collection.`);
      }
      let u = l.getCollectionNode(o.props, this.context), c = t.index ?? 0, f = u.next();
      for (; !f.done && f.value; ) {
        let d = f.value;
        t.index = c;
        let p = d.key ?? null;
        p == null && (p = d.element ? null : this.getKey(o, t, n, r));
        let v = [
          ...this.getFullNode({
            ...d,
            key: p,
            index: c,
            wrapper: OL(t.wrapper, d.wrapper)
          }, this.getChildState(n, d), r ? `${r}${o.key}` : o.key, i)
        ];
        for (let m of v) {
          if (m.value = d.value ?? t.value ?? null, m.value && this.cache.set(m.value, m), t.type && m.type !== t.type) throw new Error(`Unsupported type <${Yh(m.type)}> in <${Yh(i?.type ?? "unknown parent type")}>. Only <${Yh(t.type)}> is supported.`);
          c++, yield m;
        }
        f = u.next(v);
      }
      return;
    }
    if (t.key == null || t.type == null) return;
    let a = this, s = {
      type: t.type,
      props: t.props,
      key: t.key,
      parentKey: i ? i.key : null,
      value: t.value ?? null,
      level: (i?.level ?? 0) + (i?.type === "item" ? 1 : 0),
      index: t.index,
      rendered: t.rendered,
      textValue: t.textValue ?? "",
      "aria-label": t["aria-label"],
      wrapper: t.wrapper,
      shouldInvalidate: t.shouldInvalidate,
      hasChildNodes: t.hasChildNodes || !1,
      childNodes: yx(function* () {
        if (!t.hasChildNodes || !t.childNodes) return;
        let l = 0;
        for (let u of t.childNodes()) {
          u.key != null && (u.key = `${s.key}${u.key}`);
          let c = a.getFullNode({
            ...u,
            index: l
          }, a.getChildState(n, u), s.key, s);
          for (let f of c)
            l++, yield f;
        }
      })
    };
    yield s;
  }
  constructor() {
    this.cache = /* @__PURE__ */ new WeakMap();
  }
}
function yx(e) {
  let t = [], n = null;
  return {
    *[Symbol.iterator]() {
      for (let r of t) yield r;
      n || (n = e());
      for (let r of n)
        t.push(r), yield r;
    }
  };
}
function OL(e, t) {
  if (e && t) return (n) => e(t(n));
  if (e) return e;
  if (t) return t;
}
function Yh(e) {
  return e[0].toUpperCase() + e.slice(1);
}
function RO(e, t, n) {
  let r = Fe(() => new TL(), []), { children: i, items: o, collection: a } = e;
  return Fe(() => {
    if (a) return a;
    let l = r.build({
      children: i,
      items: o
    }, n);
    return t(l);
  }, [
    r,
    i,
    o,
    a,
    n,
    t
  ]);
}
function NO(e) {
  let { filter: t, layoutDelegate: n } = e, r = wb(e), i = Fe(() => e.disabledKeys ? new Set(e.disabledKeys) : /* @__PURE__ */ new Set(), [
    e.disabledKeys
  ]), o = Le((u) => t ? new vx(t(u)) : new vx(u), [
    t
  ]), a = Fe(() => ({
    suppressTextValueWarning: e.suppressTextValueWarning
  }), [
    e.suppressTextValueWarning
  ]), s = RO(e, o, a), l = Fe(() => new ic(s, r, {
    layoutDelegate: n
  }), [
    s,
    r,
    n
  ]);
  return jO(s, l), {
    collection: s,
    disabledKeys: i,
    selectionManager: l
  };
}
function PL(e, t) {
  let n = Fe(() => t ? e.collection.filter(t) : e.collection, [
    e.collection,
    t
  ]), r = e.selectionManager.withCollection(n);
  return jO(n, r), {
    collection: n,
    selectionManager: r,
    disabledKeys: e.disabledKeys
  };
}
function jO(e, t) {
  const n = ve(null);
  ze(() => {
    if (t.focusedKey != null && !e.getItem(t.focusedKey) && n.current) {
      let r = n.current.getKeyAfter(t.focusedKey), i = null;
      for (; r != null; ) {
        let o = e.getItem(r);
        if (o && o.type === "item" && !t.isDisabled(r)) {
          i = r;
          break;
        }
        r = n.current.getKeyAfter(r);
      }
      if (i == null)
        for (r = n.current.getKeyBefore(t.focusedKey); r != null; ) {
          let o = e.getItem(r);
          if (o && o.type === "item" && !t.isDisabled(r)) {
            i = r;
            break;
          }
          r = n.current.getKeyBefore(r);
        }
      t.setFocusedKey(i);
    }
    n.current = e;
  }, [
    e,
    t
  ]);
}
function AL(e, t) {
  let { collection: n, onLoadMore: r, scrollOffset: i = 1 } = e, o = ve(null), a = Rr((s) => {
    for (let l of s)
      l.isIntersecting && r && r();
  });
  dt(() => (t.current && (o.current = new IntersectionObserver(a, {
    root: mb(t?.current),
    rootMargin: `0px ${100 * i}% ${100 * i}% ${100 * i}%`
  }), o.current.observe(t.current)), () => {
    o.current && o.current.disconnect();
  }), [
    n,
    t,
    i
  ]);
}
const xb = /* @__PURE__ */ He(null), ul = /* @__PURE__ */ He(null), DL = /* @__PURE__ */ fn(function(t, n) {
  [t, n] = Ii(t, n, xb);
  let r = je(ul);
  return r ? /* @__PURE__ */ H.createElement(FO, {
    state: r,
    props: t,
    listBoxRef: n
  }) : /* @__PURE__ */ H.createElement(ub, {
    content: /* @__PURE__ */ H.createElement(cO, t)
  }, (i) => /* @__PURE__ */ H.createElement(CL, {
    props: t,
    listBoxRef: n,
    collection: i
  }));
});
function CL({ props: e, listBoxRef: t, collection: n }) {
  e = {
    ...e,
    collection: n,
    children: null,
    items: null
  };
  let { layoutDelegate: r } = je(sl), i = NO({
    ...e,
    layoutDelegate: r
  });
  return /* @__PURE__ */ H.createElement(FO, {
    state: i,
    props: e,
    listBoxRef: t
  });
}
function FO({ state: e, props: t, listBoxRef: n }) {
  [t, n] = Ii(t, n, Vv);
  let { dragAndDropHooks: r, layout: i = "stack", orientation: o = "vertical", filter: a } = t, s = PL(e, a), { collection: l, selectionManager: u } = s, c = !!r?.useDraggableCollectionState, f = !!r?.useDroppableCollectionState, { direction: d } = ol(), { disabledBehavior: p, disabledKeys: h } = u, v = _b({
    usage: "search",
    sensitivity: "base"
  }), { isVirtualized: m, layoutDelegate: g, dropTargetDelegate: _, CollectionRoot: x } = je(sl), w = Fe(() => t.keyboardDelegate || new bb({
    collection: l,
    collator: v,
    ref: n,
    disabledKeys: h,
    disabledBehavior: p,
    layout: i,
    orientation: o,
    direction: d,
    layoutDelegate: g
  }), [
    l,
    v,
    n,
    p,
    h,
    o,
    d,
    t.keyboardDelegate,
    i,
    g
  ]), { listBoxProps: $ } = bL({
    ...t,
    shouldSelectOnPressUp: c || t.shouldSelectOnPressUp,
    keyboardDelegate: w,
    isVirtualized: m
  }, s, n), k = ve(c), D = ve(f);
  ze(() => {
    process.env.NODE_ENV !== "production" && (k.current !== c && console.warn("Drag hooks were provided during one render, but not another. This should be avoided as it may produce unexpected behavior."), D.current !== f && console.warn("Drop hooks were provided during one render, but not another. This should be avoided as it may produce unexpected behavior."));
  }, [
    c,
    f
  ]);
  let E, b, y, S = !1, P = null, M = ve(null);
  if (c && r) {
    E = r.useDraggableCollectionState({
      collection: l,
      selectionManager: u,
      preview: r.renderDragPreview ? M : void 0
    }), r.useDraggableCollection({}, E, n);
    let re = r.DragPreview;
    P = r.renderDragPreview ? /* @__PURE__ */ H.createElement(re, {
      ref: M
    }, r.renderDragPreview) : null;
  }
  if (f && r) {
    b = r.useDroppableCollectionState({
      collection: l,
      selectionManager: u
    });
    let re = r.dropTargetDelegate || _ || new r.ListDropTargetDelegate(l, n, {
      orientation: o,
      layout: i,
      direction: d
    });
    y = r.useDroppableCollection({
      keyboardDelegate: w,
      dropTargetDelegate: re
    }, b, n), S = b.isDropTarget({
      type: "root"
    });
  }
  let { focusProps: T, isFocused: V, isFocusVisible: z } = vp(), U = s.collection.size === 0, B = {
    isDropTarget: S,
    isEmpty: U,
    isFocused: V,
    isFocusVisible: z,
    layout: t.layout || "stack",
    orientation: o,
    state: s
  }, N = Vr({
    ...t,
    children: void 0,
    defaultClassName: "react-aria-ListBox",
    values: B
  }), C = null;
  U && t.renderEmptyState && (C = /* @__PURE__ */ H.createElement("div", {
    // eslint-disable-next-line
    role: "option",
    style: {
      display: "contents"
    }
  }, t.renderEmptyState(B)));
  let G = Dn(t, {
    global: !0
  });
  return /* @__PURE__ */ H.createElement(gb, null, /* @__PURE__ */ H.createElement(Hn.div, {
    ...st(G, N, $, T, y?.collectionProps),
    ref: n,
    slot: t.slot || void 0,
    onScroll: t.onScroll,
    "data-drop-target": S || void 0,
    "data-empty": U || void 0,
    "data-focused": V || void 0,
    "data-focus-visible": z || void 0,
    "data-layout": t.layout || "stack",
    "data-orientation": o
  }, /* @__PURE__ */ H.createElement(ja, {
    values: [
      [
        xb,
        t
      ],
      [
        ul,
        s
      ],
      [
        yp,
        {
          dragAndDropHooks: r,
          dragState: E,
          dropState: b
        }
      ],
      [
        SO,
        {
          elementType: "div"
        }
      ],
      [
        bO,
        {
          render: RL
        }
      ],
      [
        fO,
        {
          name: "ListBoxSection",
          render: IL
        }
      ]
    ]
  }, /* @__PURE__ */ H.createElement(xO, null, /* @__PURE__ */ H.createElement(x, {
    collection: l,
    scrollRef: n,
    persistedKeys: nL(u, r, b),
    renderDropIndicator: _O(r, b)
  }))), C, P));
}
function IL(e, t, n, r = "react-aria-ListBoxSection") {
  let i = je(ul), { dragAndDropHooks: o, dropState: a } = je(yp), { CollectionBranch: s } = je(sl), [l, u] = eb(), { headingProps: c, groupProps: f } = SL({
    heading: u,
    "aria-label": e["aria-label"] ?? void 0
  }), d = Vr({
    ...e,
    id: void 0,
    children: void 0,
    defaultClassName: r,
    values: void 0
  }), p = Dn(e, {
    global: !0
  });
  return delete p.id, /* @__PURE__ */ H.createElement(Hn.section, {
    ...st(p, d, f),
    ref: t
  }, /* @__PURE__ */ H.createElement(wO.Provider, {
    value: {
      ...c,
      ref: l
    }
  }, /* @__PURE__ */ H.createElement(s, {
    collection: i.collection,
    parent: n,
    renderDropIndicator: _O(o, a)
  })));
}
const ML = /* @__PURE__ */ cb(sd, function(t, n, r) {
  let i = il(n), o = je(ul), { dragAndDropHooks: a, dragState: s, dropState: l } = je(yp), u = s && !(s.isDisabled || s.selectionManager.isDisabled(r.key)), { optionProps: c, labelProps: f, descriptionProps: d, ...p } = EL({
    key: r.key,
    "aria-label": t?.["aria-label"]
  }, o, i), { hoverProps: h, isHovered: v } = ll({
    isDisabled: !p.allowsSelection && !p.hasAction && !u,
    onHoverStart: r.props.onHoverStart,
    onHoverChange: r.props.onHoverChange,
    onHoverEnd: r.props.onHoverEnd
  }), { keyboardProps: m } = sb(t), { focusProps: g } = ab(t), _ = null;
  s && a && (_ = a.useDraggableItem({
    key: r.key,
    hasAction: p.hasAction
  }, s));
  let x = null;
  l && a && (x = a.useDroppableItem({
    target: {
      type: "item",
      key: r.key,
      dropPosition: "on"
    }
  }, l, i));
  let w = s && s.isDragging(r.key), $ = Vr({
    ...t,
    id: void 0,
    children: t.children,
    defaultClassName: "react-aria-ListBoxItem",
    values: {
      ...p,
      isHovered: v,
      selectionMode: o.selectionManager.selectionMode,
      selectionBehavior: o.selectionManager.selectionBehavior,
      allowsDragging: !!s,
      isDragging: w,
      isDropTarget: x?.isDropTarget
    }
  });
  ze(() => {
    !r.textValue && process.env.NODE_ENV !== "production" && console.warn("A `textValue` prop is required for <ListBoxItem> elements with non-plain text children in order to support accessibility features such as type to select.");
  }, [
    r.textValue
  ]);
  let k = t.href ? Hn.a : Hn.div, D = Dn(t, {
    global: !0
  });
  return delete D.id, delete D.onClick, t.href && c.tabIndex == null && (c.tabIndex = -1), /* @__PURE__ */ H.createElement(k, {
    ...st(D, $, c, h, m, g, _?.dragProps, x?.dropProps),
    ref: i,
    "data-allows-dragging": !!s || void 0,
    "data-selected": p.isSelected || void 0,
    "data-disabled": p.isDisabled || void 0,
    "data-hovered": v || void 0,
    "data-focused": p.isFocused || void 0,
    "data-focus-visible": p.isFocusVisible || void 0,
    "data-pressed": p.isPressed || void 0,
    "data-dragging": w || void 0,
    "data-drop-target": x?.isDropTarget || void 0,
    "data-selection-mode": o.selectionManager.selectionMode === "none" ? void 0 : o.selectionManager.selectionMode
  }, /* @__PURE__ */ H.createElement(ja, {
    values: [
      [
        gp,
        {
          slots: {
            [Xy]: f,
            label: f,
            description: d
          }
        }
      ],
      [
        EO,
        {
          isSelected: p.isSelected
        }
      ]
    ]
  }, $.children));
});
function RL(e, t) {
  t = il(t);
  let { dragAndDropHooks: n, dropState: r } = je(yp), { dropIndicatorProps: i, isHidden: o, isDropTarget: a } = n.useDropIndicator(e, r, t);
  return o ? null : /* @__PURE__ */ H.createElement(jL, {
    ...e,
    dropIndicatorProps: i,
    isDropTarget: a,
    ref: t
  });
}
function NL(e, t) {
  let { dropIndicatorProps: n, isDropTarget: r, ...i } = e, o = Vr({
    ...i,
    defaultClassName: "react-aria-DropIndicator",
    values: {
      isDropTarget: r
    }
  });
  return /* @__PURE__ */ H.createElement(H.Fragment, null, /* @__PURE__ */ H.createElement(Hn.div, {
    ...n,
    ...o,
    role: "option",
    ref: t,
    "data-drop-target": r || void 0
  }));
}
const jL = /* @__PURE__ */ fn(NL);
cb(Bv, function(t, n, r) {
  let i = je(ul), { isLoading: o, onLoadMore: a, scrollOffset: s, ...l } = t, u = ve(null), c = Fe(() => ({
    onLoadMore: a,
    collection: i?.collection,
    sentinelRef: u,
    scrollOffset: s
  }), [
    a,
    s,
    i?.collection
  ]);
  AL(c, u);
  let f = Vr({
    ...l,
    id: void 0,
    children: r.rendered,
    defaultClassName: "react-aria-ListBoxLoadingIndicator",
    values: void 0
  }), d = {
    // For Android talkback
    tabIndex: -1
  };
  return /* @__PURE__ */ H.createElement(H.Fragment, null, /* @__PURE__ */ H.createElement("div", {
    style: {
      position: "relative",
      width: 0,
      height: 0
    },
    inert: $L(!0)
  }, /* @__PURE__ */ H.createElement("div", {
    "data-testid": "loadMoreSentinel",
    ref: u,
    style: {
      position: "absolute",
      height: 1,
      width: 1
    }
  })), o && f.children && /* @__PURE__ */ H.createElement(H.Fragment, null, /* @__PURE__ */ H.createElement(Hn.div, {
    ...st(Dn(t, {
      global: !0
    }), d),
    ...f,
    // aria-selected isn't needed here since this option is not selectable.
    role: "option",
    ref: n
  }, f.children)));
});
const FL = /* @__PURE__ */ He({
  placement: "bottom"
}), zL = typeof HTMLElement < "u" && "inert" in HTMLElement.prototype;
function bx(e) {
  return e.dataset.liveAnnouncer === "true" || e.dataset.reactAriaTopLayer !== void 0;
}
let Rl = /* @__PURE__ */ new WeakMap(), Qn = [];
function LL(e, t) {
  let n = Pn(e?.[0]), r = t instanceof n.Element ? {
    root: t
  } : t, i = r?.root ?? document.body, o = r?.shouldUseInert && zL, a = new Set(e), s = /* @__PURE__ */ new Set(), l = (m) => o && m instanceof n.HTMLElement ? m.inert : m.getAttribute("aria-hidden") === "true", u = (m, g) => {
    o && m instanceof n.HTMLElement ? m.inert = g : g ? m.setAttribute("aria-hidden", "true") : (m.removeAttribute("aria-hidden"), m instanceof n.HTMLElement && (m.inert = !1));
  }, c = /* @__PURE__ */ new Set();
  if (Fi())
    for (let m of e) {
      let g = m;
      for (; g && g !== i; ) {
        let _ = g.getRootNode();
        "shadowRoot" in _ && c.add(_.shadowRoot), g = _.parentNode;
      }
    }
  let f = (m) => {
    for (let w of m.querySelectorAll("[data-live-announcer], [data-react-aria-top-layer]")) a.add(w);
    let g = (w) => {
      if (s.has(w) || a.has(w) || w.parentElement && s.has(w.parentElement) && w.parentElement.getAttribute("role") !== "row") return NodeFilter.FILTER_REJECT;
      for (let $ of a)
        if (Je(w, $)) return NodeFilter.FILTER_SKIP;
      return NodeFilter.FILTER_ACCEPT;
    }, _ = $O(ot(m), m, NodeFilter.SHOW_ELEMENT, {
      acceptNode: g
    }), x = g(m);
    if (x === NodeFilter.FILTER_ACCEPT && d(m), x !== NodeFilter.FILTER_REJECT) {
      let w = _.nextNode();
      for (; w != null; )
        d(w), w = _.nextNode();
    }
  }, d = (m) => {
    let g = Rl.get(m) ?? 0;
    l(m) && g === 0 || (g === 0 && u(m, !0), s.add(m), Rl.set(m, g + 1));
  };
  Qn.length && Qn[Qn.length - 1].disconnect(), f(i);
  let p = new MutationObserver((m) => {
    for (let g of m)
      if (g.type === "childList") {
        if (g.target.isConnected && ![
          ...a,
          ...s
        ].some((_) => Je(_, g.target))) for (let _ of g.addedNodes)
          (_ instanceof HTMLElement || _ instanceof SVGElement) && bx(_) ? a.add(_) : _ instanceof Element && f(_);
        if (Fi()) {
          for (let _ of c) if (!_.isConnected) {
            p.disconnect();
            break;
          }
        }
      }
  });
  p.observe(i, {
    childList: !0,
    subtree: !0
  });
  let h = /* @__PURE__ */ new Set();
  if (Fi()) for (let m of c) {
    let g = new MutationObserver((_) => {
      for (let x of _)
        if (x.type === "childList") {
          if (x.target.isConnected && ![
            ...a,
            ...s
          ].some((w) => Je(w, x.target))) for (let w of x.addedNodes)
            (w instanceof HTMLElement || w instanceof SVGElement) && bx(w) ? a.add(w) : w instanceof Element && f(w);
          if (Fi()) {
            for (let w of c) if (!w.isConnected) {
              p.disconnect();
              break;
            }
          }
        }
    });
    g.observe(m, {
      childList: !0,
      subtree: !0
    }), h.add(g);
  }
  let v = {
    visibleNodes: a,
    hiddenNodes: s,
    observe() {
      p.observe(i, {
        childList: !0,
        subtree: !0
      });
    },
    disconnect() {
      p.disconnect();
    }
  };
  return Qn.push(v), () => {
    if (p.disconnect(), Fi()) for (let m of h) m.disconnect();
    for (let m of s) {
      let g = Rl.get(m);
      g != null && (g === 1 ? (u(m, !1), Rl.delete(m)) : Rl.set(m, g - 1));
    }
    v === Qn[Qn.length - 1] ? (Qn.pop(), Qn.length && Qn[Qn.length - 1].observe()) : Qn.splice(Qn.indexOf(v), 1);
  };
}
function VL(e) {
  let t = Qn[Qn.length - 1];
  if (t && !t.visibleNodes.has(e))
    return t.visibleNodes.add(e), () => {
      t.visibleNodes.delete(e);
    };
}
const $r = {
  top: "top",
  bottom: "top",
  left: "left",
  right: "left"
}, fd = {
  top: "bottom",
  bottom: "top",
  left: "right",
  right: "left"
}, BL = {
  top: "left",
  left: "top"
}, eg = {
  top: "height",
  left: "width"
}, zO = {
  width: "totalWidth",
  height: "totalHeight"
}, Lc = {};
let KL = () => typeof document < "u" ? window.visualViewport : null;
function _x(e, t) {
  let n = 0, r = 0, i = 0, o = 0, a = 0, s = 0, l = {}, u = (t?.scale ?? 1) > 1;
  if (e.tagName === "BODY" || e.tagName === "HTML") {
    let c = document.documentElement;
    i = c.clientWidth, o = c.clientHeight, n = t?.width ?? i, r = t?.height ?? o, l.top = c.scrollTop || e.scrollTop, l.left = c.scrollLeft || e.scrollLeft, t && (a = t.offsetTop, s = t.offsetLeft);
  } else
    ({ width: n, height: r, top: a, left: s } = Tu(e, !1)), l.top = e.scrollTop, l.left = e.scrollLeft, i = n, o = r;
  return UT() && (e.tagName === "BODY" || e.tagName === "HTML") && u && (l.top = 0, l.left = 0, a = t?.pageTop ?? 0, s = t?.pageLeft ?? 0), {
    width: n,
    height: r,
    totalWidth: i,
    totalHeight: o,
    scroll: l,
    top: a,
    left: s
  };
}
function UL(e) {
  return {
    top: e.scrollTop,
    left: e.scrollLeft,
    width: e.scrollWidth,
    height: e.scrollHeight
  };
}
function wx(e, t, n, r, i, o, a) {
  let s = i.scroll[e] ?? 0, l = r[eg[e]], u = a[e] + r.scroll[$r[e]] + o, c = a[e] + r.scroll[$r[e]] + l - o, f = t - s + r.scroll[$r[e]] + a[e] - r[$r[e]], d = t - s + n + r.scroll[$r[e]] + a[e] - r[$r[e]];
  return f < u ? u - f : d > c ? Math.max(c - d, u - f) : 0;
}
function qL(e) {
  let t = window.getComputedStyle(e);
  return {
    top: parseInt(t.marginTop, 10) || 0,
    bottom: parseInt(t.marginBottom, 10) || 0,
    left: parseInt(t.marginLeft, 10) || 0,
    right: parseInt(t.marginRight, 10) || 0
  };
}
function xx(e) {
  if (Lc[e]) return Lc[e];
  let [t, n] = e.split(" "), r = $r[t] || "right", i = BL[r];
  $r[n] || (n = "center");
  let o = eg[r], a = eg[i];
  return Lc[e] = {
    placement: t,
    crossPlacement: n,
    axis: r,
    crossAxis: i,
    size: o,
    crossSize: a
  }, Lc[e];
}
function Qh(e, t, n, r, i, o, a, s, l, u, c) {
  let { placement: f, crossPlacement: d, axis: p, crossAxis: h, size: v, crossSize: m } = r, g = {};
  g[h] = e[h] ?? 0, d === "center" ? g[h] += ((e[m] ?? 0) - (n[m] ?? 0)) / 2 : d !== h && (g[h] += (e[m] ?? 0) - (n[m] ?? 0)), g[h] += o;
  const _ = e[h] - n[m] + l + u, x = e[h] + e[m] - l - u;
  if (g[h] = Zv(g[h], _, x), f === p) {
    let w = s ? c[v] : c[zO[v]];
    g[fd[p]] = Math.floor(w - e[p] + i);
  } else g[p] = Math.floor(e[p] + e[v] + i);
  return g;
}
function HL(e, t, n, r, i, o, a, s, l, u, c) {
  let f = (e.top != null ? e.top : l[zO.height] - (e.bottom ?? 0) - a) - (l.scroll.top ?? 0), d = u ? n.top : 0, p = {
    // This should be boundary top in container coord system vs viewport top in container coord system
    // For the viewport top, there are several cases
    // 1. pinchzoom case where we want the viewports offset top as top here
    // 2. case where container is offset from the boundary and is contained by the boundary. In this case the top we want here is NOT 0, we want to take boundary's top even though is is a negative number OR the visual viewport, whichever is more restrictive
    top: Math.max(t.top + d, (c?.offsetTop ?? t.top) + d),
    bottom: Math.min(t.top + t.height + d, (c?.offsetTop ?? 0) + (c?.height ?? 0))
  };
  return s !== "top" ? Math.max(0, p.bottom - // this is the bottom of the boundary
  f - // this is the top of the overlay
  ((i.top ?? 0) + (i.bottom ?? 0) + o)) : Math.max(0, f + a - // this is the bottom of the overlay
  p.top - // this is the top of the boundary
  ((i.top ?? 0) + (i.bottom ?? 0) + o));
}
function Ex(e, t, n, r, i, o, a, s) {
  let { placement: l, axis: u, size: c } = o;
  return l === u ? Math.max(0, n[u] - // trigger start
  (a.scroll[u] ?? 0) - // transform trigger position to be with respect to viewport 0,0
  (e[u] + (s ? t[u] : 0)) - // boundary start
  (r[u] ?? 0) - // margins usually for arrows or other decorations
  r[fd[u]] - i) : Math.max(0, e[c] + e[u] + (s ? t[u] : 0) - n[u] - n[c] + (a.scroll[u] ?? 0) - (r[u] ?? 0) - r[fd[u]] - i);
}
function WL(e, t, n, r, i, o, a, s, l, u, c, f, d, p, h, v, m, g) {
  let _ = xx(e), { size: x, crossAxis: w, crossSize: $, placement: k, crossPlacement: D } = _, E = Qh(t, s, n, _, c, f, u, d, h, v, l), b = c, y = Ex(s, u, t, i, o + c, _, l, m);
  if (a && n[x] > y) {
    let Se = xx(`${fd[k]} ${D}`), me = Qh(t, s, n, Se, c, f, u, d, h, v, l);
    Ex(s, u, t, i, o + c, Se, l, m) > y && (_ = Se, E = me, b = c);
  }
  let S = "bottom";
  _.axis === "top" ? _.placement === "top" ? S = "top" : _.placement === "bottom" && (S = "bottom") : _.crossAxis === "top" && (_.crossPlacement === "top" ? S = "bottom" : _.crossPlacement === "bottom" && (S = "top"));
  let P = wx(w, E[w], n[$], s, l, o, u);
  E[w] += P;
  let M = HL(E, s, u, d, i, o, n.height, S, l, m, g);
  p && p < M && (M = p), n.height = Math.min(n.height, M), E = Qh(t, s, n, _, b, f, u, d, h, v, l), P = wx(w, E[w], n[$], s, l, o, u), E[w] += P;
  let T = {}, V = t[w] - E[w] - i[$r[w]], z = V + 0.5 * t[$];
  const U = h / 2 + v, B = $r[w] === "left" ? (i.left ?? 0) + (i.right ?? 0) : (i.top ?? 0) + (i.bottom ?? 0), N = n[$] - B - h / 2 - v, C = t[w] + h / 2 - (E[w] + i[$r[w]]), G = t[w] + t[$] - h / 2 - (E[w] + i[$r[w]]), re = Zv(z, C, G);
  T[w] = Zv(re, U, N), { placement: k, crossPlacement: D } = _, h ? V = T[w] : D === "right" ? V += t[$] : D === "center" && (V += t[$] / 2);
  let ie = k === "left" || k === "top" ? n[x] : 0, X = {
    x: k === "top" || k === "bottom" ? V : ie,
    y: k === "left" || k === "right" ? V : ie
  };
  return {
    position: E,
    maxHeight: M,
    arrowOffsetLeft: T.left,
    arrowOffsetTop: T.top,
    placement: k,
    triggerAnchorPoint: X
  };
}
function ZL(e) {
  let { placement: t, targetNode: n, overlayNode: r, scrollNode: i, padding: o, shouldFlip: a, boundaryElement: s, offset: l, crossOffset: u, maxHeight: c, arrowSize: f = 0, arrowBoundaryOffset: d = 0, targetRect: p } = e, h = KL(), v = r instanceof HTMLElement ? GL(r) : document.documentElement, m = v === document.documentElement;
  const g = window.getComputedStyle(v).position;
  let _ = !!g && g !== "static", x = m ? Tu(n, !1, p) : Sx(n, v, !1, p);
  if (!m) {
    let { marginTop: S, marginLeft: P } = window.getComputedStyle(n);
    x.top += parseInt(S, 10) || 0, x.left += parseInt(P, 10) || 0;
  }
  let w = Tu(r, !0), $ = qL(r);
  w.width += ($.left ?? 0) + ($.right ?? 0), w.height += ($.top ?? 0) + ($.bottom ?? 0);
  let k = UL(i), D = _x(s, h), E = _x(v, h), b;
  if ((s.tagName === "BODY" || s.tagName === "HTML") && !m) {
    let S = bp(v, !1);
    b = {
      top: -(S.top - D.top),
      left: -(S.left - D.left),
      width: 0,
      height: 0
    };
  } else (s.tagName === "BODY" || s.tagName === "HTML") && m ? b = {
    top: 0,
    left: 0,
    width: 0,
    height: 0
  } : b = Sx(s, v, !1);
  let y = Je(s, v);
  return WL(t, x, w, k, $, o, a, D, E, b, l, u, _, c, f, d, y, h);
}
function bp(e, t) {
  let { top: n, left: r, width: i, height: o } = e.getBoundingClientRect();
  return t && e instanceof e.ownerDocument.defaultView.HTMLElement && (i = e.offsetWidth, o = e.offsetHeight), {
    top: n,
    left: r,
    width: i,
    height: o
  };
}
function Tu(e, t, n) {
  let { top: r, left: i, width: o, height: a } = n || bp(e, t), { scrollTop: s, scrollLeft: l, clientTop: u, clientLeft: c } = document.documentElement;
  return {
    top: r + s - u,
    left: i + l - c,
    width: o,
    height: a
  };
}
function Sx(e, t, n, r) {
  let i = window.getComputedStyle(e), o;
  if (i.position === "fixed") o = r || bp(e, n);
  else {
    o = Tu(e, n, r);
    let a = Tu(t, n), s = window.getComputedStyle(t);
    a.top += (parseInt(s.borderTopWidth, 10) || 0) - t.scrollTop, a.left += (parseInt(s.borderLeftWidth, 10) || 0) - t.scrollLeft, o.top -= a.top, o.left -= a.left;
  }
  return o.top -= parseInt(i.marginTop, 10) || 0, o.left -= parseInt(i.marginLeft, 10) || 0, o;
}
function GL(e) {
  let t = e.offsetParent;
  if (t && t === document.body && window.getComputedStyle(t).position === "static" && !$x(t) && (t = document.documentElement), t == null)
    for (t = e.parentElement; t && !$x(t); ) t = t.parentElement;
  return t || document.documentElement;
}
function $x(e) {
  let t = window.getComputedStyle(e);
  return t.transform !== "none" || /transform|perspective/.test(t.willChange) || t.filter !== "none" || t.contain === "paint" || "backdropFilter" in t && t.backdropFilter !== "none" || "WebkitBackdropFilter" in t && t.WebkitBackdropFilter !== "none";
}
const LO = /* @__PURE__ */ new WeakMap();
function YL(e) {
  let { triggerRef: t, isOpen: n, onClose: r } = e;
  ze(() => {
    if (!n || r === null) return;
    let i = (o) => {
      let a = Ae(o);
      if (!t.current || a instanceof Node && !Je(a, t.current) || a instanceof HTMLInputElement || a instanceof HTMLTextAreaElement) return;
      let s = r || LO.get(t.current);
      s && s();
    };
    return window.addEventListener("scroll", i, !0), () => {
      window.removeEventListener("scroll", i, !0);
    };
  }, [
    n,
    r,
    t
  ]);
}
function QL() {
  return typeof window.ResizeObserver < "u";
}
function tg(e) {
  const { ref: t, box: n, onResize: r } = e;
  let i = Rr(r);
  ze(() => {
    let o = t?.current;
    if (o)
      if (QL()) {
        const a = new window.ResizeObserver((s) => {
          s.length && i();
        });
        return a.observe(o, {
          box: n
        }), () => {
          o && a.unobserve(o);
        };
      } else
        return window.addEventListener("resize", i, !1), () => {
          window.removeEventListener("resize", i, !1);
        };
  }, [
    t,
    n
  ]);
}
let Qo = typeof document < "u" ? window.visualViewport : null;
function JL(e) {
  let { direction: t } = ol(), { arrowSize: n, targetRef: r, overlayRef: i, arrowRef: o, scrollRef: a = i, placement: s = "bottom", containerPadding: l = 12, shouldFlip: u = !0, boundaryElement: c = typeof document < "u" ? document.body : null, offset: f = 0, crossOffset: d = 0, shouldUpdatePosition: p = !0, isOpen: h = !0, onClose: v, maxHeight: m, arrowBoundaryOffset: g = 0, getTargetRect: _ } = e, [x, w] = Ke(null), $ = [
    p,
    s,
    i.current,
    r.current,
    o?.current,
    a.current,
    l,
    u,
    c,
    f,
    d,
    h,
    t,
    m,
    g,
    n
  ], k = ve(Qo?.scale);
  ze(() => {
    h && (k.current = Qo?.scale);
  }, [
    h
  ]);
  let D = Le(() => {
    if (p === !1 || !h || !i.current || !r.current || !c || Qo?.scale !== k.current) return;
    let y = null;
    if (a.current && rd(a.current)) {
      let T = Lt()?.getBoundingClientRect(), V = a.current.getBoundingClientRect();
      y = {
        type: "top",
        offset: (T?.top ?? 0) - V.top
      }, y.offset > V.height / 2 && (y.type = "bottom", y.offset = (T?.bottom ?? 0) - V.bottom);
    }
    let S = i.current;
    !m && i.current && (S.style.top = "0px", S.style.bottom = "", S.style.maxHeight = (window.visualViewport?.height ?? window.innerHeight) + "px");
    let P = ZL({
      placement: eV(s, t),
      overlayNode: i.current,
      targetNode: r.current,
      scrollNode: a.current || i.current,
      padding: l,
      shouldFlip: u,
      boundaryElement: c,
      offset: f,
      crossOffset: d,
      maxHeight: m,
      arrowSize: n ?? (o?.current ? bp(o.current, !0).width : 0),
      arrowBoundaryOffset: g,
      targetRect: _?.(r.current)
    });
    if (!P.position) return;
    S.style.top = "", S.style.bottom = "", S.style.left = "", S.style.right = "", Object.keys(P.position).forEach((T) => S.style[T] = P.position[T] + "px"), S.style.maxHeight = P.maxHeight != null ? P.maxHeight + "px" : "";
    let M = Lt();
    if (y && M && a.current) {
      let T = M.getBoundingClientRect(), V = a.current.getBoundingClientRect(), z = T[y.type] - V[y.type];
      a.current.scrollTop += z - y.offset;
    }
    w(P);
  }, $);
  dt(D, $), XL(D), tg({
    ref: i,
    onResize: D
  }), tg({
    ref: r,
    onResize: D
  });
  let E = ve(!1);
  dt(() => {
    let y, S = () => {
      E.current = !0, clearTimeout(y), y = setTimeout(() => {
        E.current = !1;
      }, 500), D();
    }, P = () => {
      E.current && S();
    };
    return Qo?.addEventListener("resize", S), Qo?.addEventListener("scroll", P), () => {
      Qo?.removeEventListener("resize", S), Qo?.removeEventListener("scroll", P);
    };
  }, [
    D
  ]);
  let b = Le(() => {
    E.current || v?.();
  }, [
    v,
    E
  ]);
  return YL({
    triggerRef: r,
    isOpen: h,
    onClose: v && b
  }), {
    overlayProps: {
      style: {
        position: x ? "absolute" : "fixed",
        top: x ? void 0 : 0,
        left: x ? void 0 : 0,
        zIndex: 1e5,
        ...x?.position,
        maxHeight: x?.maxHeight ?? "100vh"
      }
    },
    placement: x?.placement ?? null,
    triggerAnchorPoint: x?.triggerAnchorPoint ?? null,
    arrowProps: {
      "aria-hidden": "true",
      role: "presentation",
      style: {
        left: x?.arrowOffsetLeft,
        top: x?.arrowOffsetTop
      }
    },
    updatePosition: D
  };
}
function XL(e) {
  dt(() => (window.addEventListener("resize", e, !1), () => {
    window.removeEventListener("resize", e, !1);
  }), [
    e
  ]);
}
function eV(e, t) {
  return t === "rtl" ? e.replace("start", "right").replace("end", "left") : e.replace("start", "left").replace("end", "right");
}
function tV(e) {
  let { ref: t, onInteractOutside: n, isDisabled: r, onInteractOutsideStart: i } = e, o = ve({
    isPointerDown: !1,
    ignoreEmulatedMouseEvents: !1
  }), a = Rr((l) => {
    n && Vc(l, t) && (i && i(l), o.current.isPointerDown = !0);
  }), s = Rr((l) => {
    n && n(l);
  });
  ze(() => {
    let l = o.current;
    if (r) return;
    const u = t.current, c = ot(u);
    if (typeof PointerEvent < "u") {
      let f = (d) => {
        l.isPointerDown && Vc(d, t) && s(d), l.isPointerDown = !1;
      };
      return c.addEventListener("pointerdown", a, !0), c.addEventListener("click", f, !0), () => {
        c.removeEventListener("pointerdown", a, !0), c.removeEventListener("click", f, !0);
      };
    } else if (process.env.NODE_ENV === "test") {
      let f = (p) => {
        l.ignoreEmulatedMouseEvents ? l.ignoreEmulatedMouseEvents = !1 : l.isPointerDown && Vc(p, t) && s(p), l.isPointerDown = !1;
      }, d = (p) => {
        l.ignoreEmulatedMouseEvents = !0, l.isPointerDown && Vc(p, t) && s(p), l.isPointerDown = !1;
      };
      return c.addEventListener("mousedown", a, !0), c.addEventListener("mouseup", f, !0), c.addEventListener("touchstart", a, !0), c.addEventListener("touchend", d, !0), () => {
        c.removeEventListener("mousedown", a, !0), c.removeEventListener("mouseup", f, !0), c.removeEventListener("touchstart", a, !0), c.removeEventListener("touchend", d, !0);
      };
    }
  }, [
    t,
    r
  ]);
}
function Vc(e, t) {
  if (e.button > 0) return !1;
  let n = Ae(e);
  if (n) {
    const r = n.ownerDocument;
    if (!r || !Je(r.documentElement, n) || n.closest("[data-react-aria-top-layer]")) return !1;
  }
  return t.current ? !e.composedPath().includes(t.current) : !1;
}
const vi = [];
function nV(e, t) {
  let { onClose: n, shouldCloseOnBlur: r, isOpen: i, isDismissable: o = !1, isKeyboardDismissDisabled: a = !1, shouldCloseOnInteractOutside: s } = e, l = ve(void 0);
  ze(() => {
    if (i && !vi.includes(t))
      return vi.push(t), () => {
        let h = vi.indexOf(t);
        h >= 0 && vi.splice(h, 1);
      };
  }, [
    i,
    t
  ]);
  let u = () => {
    vi[vi.length - 1] === t && n && n();
  }, c = (h) => {
    const v = vi[vi.length - 1];
    l.current = v, (!s || s(Ae(h))) && v === t && h.stopPropagation();
  }, f = (h) => {
    (!s || s(Ae(h))) && (vi[vi.length - 1] === t && h.stopPropagation(), l.current === t && u()), l.current = void 0;
  }, d = (h) => {
    h.key === "Escape" && !a && !h.nativeEvent.isComposing && (h.stopPropagation(), h.preventDefault(), u());
  };
  tV({
    ref: t,
    onInteractOutside: o && i ? f : void 0,
    onInteractOutsideStart: c
  });
  let { focusWithinProps: p } = mp({
    isDisabled: !r,
    onBlurWithin: (h) => {
      !h.relatedTarget || fL(h.relatedTarget) || (!s || s(h.relatedTarget)) && n?.();
    }
  });
  return {
    overlayProps: {
      onKeyDown: d,
      ...p
    },
    underlayProps: {}
  };
}
const uu = typeof document < "u" && window.visualViewport;
let Bc = 0, Jh;
function rV(e = {}) {
  let { isDisabled: t } = e;
  dt(() => {
    if (!t)
      return Bc++, Bc === 1 && (rc() ? Jh = oV() : Jh = iV()), () => {
        Bc--, Bc === 0 && Jh();
      };
  }, [
    t
  ]);
}
function iV() {
  let e = window.innerWidth - document.documentElement.clientWidth;
  return Na(e > 0 && // Use scrollbar-gutter when supported because it also works for fixed positioned elements.
  ("scrollbarGutter" in document.documentElement.style ? $f(document.documentElement, "scrollbarGutter", "stable") : $f(document.documentElement, "paddingRight", `${e}px`)), $f(document.documentElement, "overflow", "hidden"));
}
function oV() {
  let e = $f(document.documentElement, "overflow", "hidden"), t, n = !1, r = (c) => {
    let f = Ae(c);
    t = Ns(f) ? f : mb(f, !0), n = !1;
    let d = f.ownerDocument.defaultView.getSelection();
    d && !d.isCollapsed && d.containsNode(f, !0) && (n = !0), c.composedPath().some((p) => p instanceof HTMLInputElement && p.type === "range") && (n = !0), "selectionStart" in f && "selectionEnd" in f && f.selectionStart < f.selectionEnd && f.ownerDocument.activeElement === f && (n = !0);
  }, i = document.createElement("style"), o = dO();
  o && (i.nonce = o), i.textContent = `
@layer {
  * {
    overscroll-behavior: contain;
  }
}`.trim(), document.head.prepend(i);
  let a = (c) => {
    if (!(c.touches.length === 2 || n)) {
      if (!t || t === document.documentElement || t === document.body) {
        c.preventDefault();
        return;
      }
      t.scrollHeight === t.clientHeight && t.scrollWidth === t.clientWidth && c.preventDefault();
    }
  }, s = (c) => {
    let f = Ae(c), d = c.relatedTarget;
    d && zh(d) ? (d.focus({
      preventScroll: !0
    }), kx(d, zh(f))) : d || f.parentElement?.closest("[tabindex]")?.focus({
      preventScroll: !0
    });
  }, l = HTMLElement.prototype.focus;
  HTMLElement.prototype.focus = function(c) {
    let f = Lt(), d = f != null && zh(f);
    l.call(this, {
      ...c,
      preventScroll: !0
    }), (!c || !c.preventScroll) && kx(this, d);
  };
  let u = Na(Xh(document, "touchstart", r, {
    passive: !1,
    capture: !0
  }), Xh(document, "touchmove", a, {
    passive: !1,
    capture: !0
  }), Xh(document, "blur", s, !0));
  return () => {
    e(), u(), i.remove(), HTMLElement.prototype.focus = l;
  };
}
function $f(e, t, n) {
  let r = e.style[t];
  return e.style[t] = n, () => {
    e.style[t] = r;
  };
}
function Xh(e, t, n, r) {
  return e.addEventListener(t, n, r), () => {
    e.removeEventListener(t, n, r);
  };
}
function kx(e, t) {
  t || !uu ? Tx(e) : uu.addEventListener("resize", () => Tx(e), {
    once: !0
  });
}
function Tx(e) {
  let t = document.scrollingElement || document.documentElement, n = e;
  for (; n && n !== t; ) {
    let r = mb(n);
    if (r !== document.documentElement && r !== document.body && r !== n) {
      let i = r.getBoundingClientRect(), o = n.getBoundingClientRect();
      if (o.top < i.top || o.bottom > i.top + n.clientHeight) {
        let a = i.bottom;
        uu && (a = Math.min(a, uu.offsetTop + uu.height));
        let s = o.top - i.top - ((a - i.top) / 2 - o.height / 2);
        r.scrollTo({
          // Clamp to the valid range to prevent over-scrolling.
          top: Math.max(0, Math.min(r.scrollHeight - r.clientHeight, r.scrollTop + s)),
          behavior: "smooth"
        });
      }
    }
    n = r.parentElement;
  }
}
function aV(e, t) {
  let { triggerRef: n, popoverRef: r, groupRef: i, isNonModal: o, isKeyboardDismissDisabled: a, shouldCloseOnInteractOutside: s, ...l } = e, u = l.trigger === "SubmenuTrigger", { overlayProps: c, underlayProps: f } = nV({
    isOpen: t.isOpen,
    onClose: t.close,
    shouldCloseOnBlur: !0,
    isDismissable: !o || u,
    isKeyboardDismissDisabled: a,
    shouldCloseOnInteractOutside: s
  }, i ?? r), { overlayProps: d, arrowProps: p, placement: h, triggerAnchorPoint: v } = JL({
    ...l,
    targetRef: n,
    overlayRef: r,
    isOpen: t.isOpen,
    onClose: o && !u ? t.close : null
  });
  return rV({
    isDisabled: o || !t.isOpen
  }), ze(() => {
    if (t.isOpen && r.current)
      return o ? VL(i?.current ?? r.current) : LL([
        i?.current ?? r.current
      ], {
        shouldUseInert: !0
      });
  }, [
    o,
    t.isOpen,
    r,
    i
  ]), {
    popoverProps: st(c, d),
    arrowProps: p,
    underlayProps: f,
    placement: h,
    triggerAnchorPoint: v
  };
}
var VO = {};
VO = {
  dismiss: "تجاهل"
};
var BO = {};
BO = {
  dismiss: "Отхвърляне"
};
var KO = {};
KO = {
  dismiss: "Odstranit"
};
var UO = {};
UO = {
  dismiss: "Luk"
};
var qO = {};
qO = {
  dismiss: "Schließen"
};
var HO = {};
HO = {
  dismiss: "Απόρριψη"
};
var WO = {};
WO = {
  dismiss: "Dismiss"
};
var ZO = {};
ZO = {
  dismiss: "Descartar"
};
var GO = {};
GO = {
  dismiss: "Lõpeta"
};
var YO = {};
YO = {
  dismiss: "Hylkää"
};
var QO = {};
QO = {
  dismiss: "Rejeter"
};
var JO = {};
JO = {
  dismiss: "התעלם"
};
var XO = {};
XO = {
  dismiss: "Odbaci"
};
var eP = {};
eP = {
  dismiss: "Elutasítás"
};
var tP = {};
tP = {
  dismiss: "Ignora"
};
var nP = {};
nP = {
  dismiss: "閉じる"
};
var rP = {};
rP = {
  dismiss: "무시"
};
var iP = {};
iP = {
  dismiss: "Atmesti"
};
var oP = {};
oP = {
  dismiss: "Nerādīt"
};
var aP = {};
aP = {
  dismiss: "Lukk"
};
var sP = {};
sP = {
  dismiss: "Negeren"
};
var lP = {};
lP = {
  dismiss: "Zignoruj"
};
var uP = {};
uP = {
  dismiss: "Descartar"
};
var cP = {};
cP = {
  dismiss: "Dispensar"
};
var fP = {};
fP = {
  dismiss: "Revocare"
};
var dP = {};
dP = {
  dismiss: "Пропустить"
};
var pP = {};
pP = {
  dismiss: "Zrušiť"
};
var hP = {};
hP = {
  dismiss: "Opusti"
};
var mP = {};
mP = {
  dismiss: "Odbaci"
};
var vP = {};
vP = {
  dismiss: "Avvisa"
};
var gP = {};
gP = {
  dismiss: "Kapat"
};
var yP = {};
yP = {
  dismiss: "Скасувати"
};
var bP = {};
bP = {
  dismiss: "取消"
};
var _P = {};
_P = {
  dismiss: "關閉"
};
var wP = {};
wP = {
  "ar-AE": VO,
  "bg-BG": BO,
  "cs-CZ": KO,
  "da-DK": UO,
  "de-DE": qO,
  "el-GR": HO,
  "en-US": WO,
  "es-ES": ZO,
  "et-EE": GO,
  "fi-FI": YO,
  "fr-FR": QO,
  "he-IL": JO,
  "hr-HR": XO,
  "hu-HU": eP,
  "it-IT": tP,
  "ja-JP": nP,
  "ko-KR": rP,
  "lt-LT": iP,
  "lv-LV": oP,
  "nb-NO": aP,
  "nl-NL": sP,
  "pl-PL": lP,
  "pt-BR": uP,
  "pt-PT": cP,
  "ro-RO": fP,
  "ru-RU": dP,
  "sk-SK": pP,
  "sl-SI": hP,
  "sr-SP": mP,
  "sv-SE": vP,
  "tr-TR": gP,
  "uk-UA": yP,
  "zh-CN": bP,
  "zh-TW": _P
};
function sV(e) {
  return e && e.__esModule ? e.default : e;
}
function Ox(e) {
  let { onDismiss: t, ...n } = e, r = eO(sV(wP), "@react-aria/overlays"), i = QT(n, r.format("dismiss")), o = () => {
    t && t();
  };
  return /* @__PURE__ */ H.createElement(z9, null, /* @__PURE__ */ H.createElement("button", {
    ...i,
    tabIndex: -1,
    onClick: o,
    style: {
      width: 1,
      height: 1
    }
  }));
}
const xP = /* @__PURE__ */ H.forwardRef(({ children: e, ...t }, n) => {
  let r = ve(!1), i = je(ku), o = st(i || {}, {
    ...t,
    register() {
      r.current = !0, i && i.register();
    }
  });
  return o.ref = il(n || i?.ref), lb(i, o.ref), ze(() => {
    r.current || (process.env.NODE_ENV !== "production" && console.warn("A PressResponder was rendered without a pressable child. Either call the usePress hook, or wrap your DOM node with <Pressable> component."), r.current = !0);
  }, []), /* @__PURE__ */ H.createElement(ku.Provider, {
    value: o
  }, e);
});
function lV({ children: e }) {
  let t = Fe(() => ({
    register: () => {
    }
  }), []);
  return /* @__PURE__ */ H.createElement(ku.Provider, {
    value: t
  }, e);
}
const uV = /* @__PURE__ */ He({});
function cV() {
  return je(uV) ?? {};
}
const fV = /* @__PURE__ */ H.createContext(null);
function Px(e) {
  let t = nc(), { portalContainer: n = t ? null : document.body, isExiting: r } = e, [i, o] = Ke(!1), a = Fe(() => ({
    contain: i,
    setContain: o
  }), [
    i,
    o
  ]), { getContainer: s } = cV();
  if (!e.portalContainer && s && (n = s()), !n) return null;
  let l = e.children;
  return e.disableFocusManagement || (l = /* @__PURE__ */ H.createElement(gb, {
    restoreFocus: !0,
    contain: (e.shouldContainFocus || i) && !r
  }, l)), l = /* @__PURE__ */ H.createElement(fV.Provider, {
    value: a
  }, /* @__PURE__ */ H.createElement(lV, null, l)), /* @__PURE__ */ _6.createPortal(l, n);
}
function Eb(e) {
  let [t, n] = fp(e.isOpen, e.defaultOpen || !1, e.onOpenChange);
  const r = Le(() => {
    n(!0);
  }, [
    n
  ]), i = Le(() => {
    n(!1);
  }, [
    n
  ]), o = Le(() => {
    n(!t);
  }, [
    n,
    t
  ]);
  return {
    isOpen: t,
    setOpen: n,
    open: r,
    close: i,
    toggle: o
  };
}
function dV(e, t = !0) {
  let [n, r] = Ke(!0), i = n && t;
  return dt(() => {
    if (i && e.current && "getAnimations" in e.current)
      for (let o of e.current.getAnimations()) o instanceof CSSTransition && o.cancel();
  }, [
    e,
    i
  ]), EP(e, i, Le(() => r(!1), [])), i;
}
function pV(e, t) {
  let [n, r] = Ke(t ? "open" : "closed");
  switch (n) {
    case "open":
      t || r("exiting");
      break;
    case "closed":
    case "exiting":
      t && r("open");
      break;
  }
  let i = n === "exiting";
  return EP(e, i, Le(() => {
    r((o) => o === "exiting" ? "closed" : o);
  }, [])), i;
}
function EP(e, t, n) {
  dt(() => {
    if (t && e.current) {
      if (!("getAnimations" in e.current)) {
        n();
        return;
      }
      let r = e.current.getAnimations();
      if (r.length === 0) {
        n();
        return;
      }
      let i = !1;
      return Promise.allSettled(r.map((o) => o.finished)).then(() => {
        i || ly(() => {
          n();
        });
      }), () => {
        i = !0;
      };
    }
  }, [
    e,
    t,
    n
  ]);
}
const Sb = /* @__PURE__ */ He(null), Ax = /* @__PURE__ */ He(null), SP = /* @__PURE__ */ fn(function(t, n) {
  [t, n] = Ii(t, n, Sb);
  let r = je(kb), i = Eb(t), o = t.isOpen != null || t.defaultOpen != null || !r ? i : r, a = pV(n, o.isOpen) || t.isExiting || !1, s = sO(), { direction: l } = ol();
  if (s) {
    let u = t.children;
    return typeof u == "function" && (u = u({
      trigger: t.trigger || null,
      placement: "bottom",
      isEntering: !1,
      isExiting: !1,
      defaultChildren: null
    })), /* @__PURE__ */ H.createElement(H.Fragment, null, u);
  }
  return o && !o.isOpen && !a ? null : /* @__PURE__ */ H.createElement(hV, {
    ...t,
    triggerRef: t.triggerRef,
    state: o,
    popoverRef: n,
    isExiting: a,
    dir: l
  });
});
function hV({ state: e, isExiting: t, UNSTABLE_portalContainer: n, clearContexts: r, ...i }) {
  let o = ve(null), a = ve(null), s = je(Ax), l = s && i.trigger === "SubmenuTrigger", { popoverProps: u, underlayProps: c, arrowProps: f, placement: d, triggerAnchorPoint: p } = aV({
    ...i,
    offset: i.offset ?? 8,
    arrowRef: o,
    // If this is a submenu/subdialog, use the root popover's container
    // to detect outside interaction and add aria-hidden.
    groupRef: l ? s : a
  }, e), h = i.popoverRef, v = dV(h, !!d) || i.isEntering || !1, m = Vr({
    ...i,
    defaultClassName: "react-aria-Popover",
    values: {
      trigger: i.trigger || null,
      placement: d,
      isEntering: v,
      isExiting: t
    }
  }), g = !i.isNonModal || i.trigger === "SubmenuTrigger", [_, x] = Ke(!1);
  dt(() => {
    h.current && x(g && !h.current.querySelector("[role=dialog]"));
  }, [
    h,
    g
  ]), ze(() => {
    _ && (i.trigger !== "SubmenuTrigger" || Su() !== "pointer") && h.current && !rd(h.current) && Rs(h.current);
  }, [
    _,
    h,
    i.trigger
  ]);
  let w = Fe(() => {
    let y = m.children;
    if (r) for (let S of r) y = /* @__PURE__ */ H.createElement(S.Provider, {
      value: null
    }, y);
    return y;
  }, [
    m.children,
    r
  ]), [$, k] = Ke(null), D = Le(() => {
    i.triggerRef.current && k(i.triggerRef.current.getBoundingClientRect().width + "px");
  }, [
    i.triggerRef
  ]);
  dt(D, [
    D
  ]), tg({
    ref: m.style?.["--trigger-width"] ? void 0 : i.triggerRef,
    onResize: D
  });
  let E = {
    ...u.style,
    "--trigger-anchor-point": p ? `${p.x}px ${p.y}px` : void 0,
    ...m.style,
    "--trigger-width": m.style?.["--trigger-width"] || $
  }, b = /* @__PURE__ */ H.createElement(Hn.div, {
    ...st(Dn(i, {
      global: !0
    }), u),
    ...m,
    role: _ ? "dialog" : void 0,
    tabIndex: _ ? -1 : void 0,
    "aria-label": i["aria-label"],
    "aria-labelledby": i["aria-labelledby"],
    ref: h,
    slot: i.slot || void 0,
    style: E,
    dir: i.dir,
    "data-trigger": i.trigger,
    "data-placement": d,
    "data-entering": v || void 0,
    "data-exiting": t || void 0
  }, !i.isNonModal && /* @__PURE__ */ H.createElement(Ox, {
    onDismiss: e.close
  }), /* @__PURE__ */ H.createElement(FL.Provider, {
    value: {
      ...f,
      placement: d,
      ref: o
    }
  }, w), /* @__PURE__ */ H.createElement(Ox, {
    onDismiss: e.close
  }));
  return l ? /* @__PURE__ */ H.createElement(Px, {
    ...i,
    shouldContainFocus: _,
    isExiting: t,
    portalContainer: n ?? s?.current ?? void 0
  }, b) : /* @__PURE__ */ H.createElement(Px, {
    ...i,
    shouldContainFocus: _,
    isExiting: t,
    portalContainer: n
  }, !i.isNonModal && e.isOpen && /* @__PURE__ */ H.createElement("div", {
    "data-testid": "underlay",
    ...c,
    style: {
      position: "fixed",
      inset: 0
    }
  }), /* @__PURE__ */ H.createElement("div", {
    ref: a,
    style: {
      display: "contents"
    }
  }, /* @__PURE__ */ H.createElement(Ax.Provider, {
    value: a
  }, b)));
}
const mV = /* @__PURE__ */ He({});
var $P = {};
$P = {
  longPressMessage: "اضغط مطولاً أو اضغط على Alt + السهم لأسفل لفتح القائمة"
};
var kP = {};
kP = {
  longPressMessage: "Натиснете продължително или натиснете Alt+ стрелка надолу, за да отворите менюто"
};
var TP = {};
TP = {
  longPressMessage: "Dlouhým stiskem nebo stisknutím kláves Alt + šipka dolů otevřete nabídku"
};
var OP = {};
OP = {
  longPressMessage: "Langt tryk eller tryk på Alt + pil ned for at åbne menuen"
};
var PP = {};
PP = {
  longPressMessage: "Drücken Sie lange oder drücken Sie Alt + Nach-unten, um das Menü zu öffnen"
};
var AP = {};
AP = {
  longPressMessage: "Πιέστε παρατεταμένα ή πατήστε Alt + κάτω βέλος για να ανοίξετε το μενού"
};
var DP = {};
DP = {
  longPressMessage: "Long press or press Alt + ArrowDown to open menu"
};
var CP = {};
CP = {
  longPressMessage: "Mantenga pulsado o pulse Alt + flecha abajo para abrir el menú"
};
var IP = {};
IP = {
  longPressMessage: "Menüü avamiseks vajutage pikalt või vajutage klahve Alt + allanool"
};
var MP = {};
MP = {
  longPressMessage: "Avaa valikko painamalla pohjassa tai näppäinyhdistelmällä Alt + Alanuoli"
};
var RP = {};
RP = {
  longPressMessage: "Appuyez de manière prolongée ou appuyez sur Alt + Flèche vers le bas pour ouvrir le menu."
};
var NP = {};
NP = {
  longPressMessage: "לחץ לחיצה ארוכה או הקש Alt + ArrowDown כדי לפתוח את התפריט"
};
var jP = {};
jP = {
  longPressMessage: "Dugo pritisnite ili pritisnite Alt + strelicu prema dolje za otvaranje izbornika"
};
var FP = {};
FP = {
  longPressMessage: "Nyomja meg hosszan, vagy nyomja meg az Alt + lefele nyíl gombot a menü megnyitásához"
};
var zP = {};
zP = {
  longPressMessage: "Premi a lungo o premi Alt + Freccia giù per aprire il menu"
};
var LP = {};
LP = {
  longPressMessage: "長押しまたは Alt+下矢印キーでメニューを開く"
};
var VP = {};
VP = {
  longPressMessage: "길게 누르거나 Alt + 아래쪽 화살표를 눌러 메뉴 열기"
};
var BP = {};
BP = {
  longPressMessage: "Norėdami atidaryti meniu, nuspaudę palaikykite arba paspauskite „Alt + ArrowDown“."
};
var KP = {};
KP = {
  longPressMessage: "Lai atvērtu izvēlni, turiet nospiestu vai nospiediet taustiņu kombināciju Alt + lejupvērstā bultiņa"
};
var UP = {};
UP = {
  longPressMessage: "Langt trykk eller trykk Alt + PilNed for å åpne menyen"
};
var qP = {};
qP = {
  longPressMessage: "Druk lang op Alt + pijl-omlaag of druk op Alt om het menu te openen"
};
var HP = {};
HP = {
  longPressMessage: "Naciśnij i przytrzymaj lub naciśnij klawisze Alt + Strzałka w dół, aby otworzyć menu"
};
var WP = {};
WP = {
  longPressMessage: "Pressione e segure ou pressione Alt + Seta para baixo para abrir o menu"
};
var ZP = {};
ZP = {
  longPressMessage: "Prima continuamente ou prima Alt + Seta Para Baixo para abrir o menu"
};
var GP = {};
GP = {
  longPressMessage: "Apăsați lung sau apăsați pe Alt + săgeată în jos pentru a deschide meniul"
};
var YP = {};
YP = {
  longPressMessage: "Нажмите и удерживайте или нажмите Alt + Стрелка вниз, чтобы открыть меню"
};
var QP = {};
QP = {
  longPressMessage: "Ponuku otvoríte dlhým stlačením alebo stlačením klávesu Alt + klávesu so šípkou nadol"
};
var JP = {};
JP = {
  longPressMessage: "Za odprtje menija pritisnite in držite gumb ali pritisnite Alt+puščica navzdol"
};
var XP = {};
XP = {
  longPressMessage: "Dugo pritisnite ili pritisnite Alt + strelicu prema dole da otvorite meni"
};
var e4 = {};
e4 = {
  longPressMessage: "Håll nedtryckt eller tryck på Alt + pil nedåt för att öppna menyn"
};
var t4 = {};
t4 = {
  longPressMessage: "Menüyü açmak için uzun basın veya Alt + Aşağı Ok tuşuna basın"
};
var n4 = {};
n4 = {
  longPressMessage: "Довго або звичайно натисніть комбінацію клавіш Alt і стрілка вниз, щоб відкрити меню"
};
var r4 = {};
r4 = {
  longPressMessage: "长按或按 Alt + 向下方向键以打开菜单"
};
var i4 = {};
i4 = {
  longPressMessage: "長按或按 Alt+向下鍵以開啟功能表"
};
var o4 = {};
o4 = {
  "ar-AE": $P,
  "bg-BG": kP,
  "cs-CZ": TP,
  "da-DK": OP,
  "de-DE": PP,
  "el-GR": AP,
  "en-US": DP,
  "es-ES": CP,
  "et-EE": IP,
  "fi-FI": MP,
  "fr-FR": RP,
  "he-IL": NP,
  "hr-HR": jP,
  "hu-HU": FP,
  "it-IT": zP,
  "ja-JP": LP,
  "ko-KR": VP,
  "lt-LT": BP,
  "lv-LV": KP,
  "nb-NO": UP,
  "nl-NL": qP,
  "pl-PL": HP,
  "pt-BR": WP,
  "pt-PT": ZP,
  "ro-RO": GP,
  "ru-RU": YP,
  "sk-SK": QP,
  "sl-SI": JP,
  "sr-SP": XP,
  "sv-SE": e4,
  "tr-TR": t4,
  "uk-UA": n4,
  "zh-CN": r4,
  "zh-TW": i4
};
function vV(e, t, n) {
  let { type: r } = e, { isOpen: i } = t;
  ze(() => {
    n && n.current && LO.set(n.current, t.close);
  });
  let o;
  r === "menu" ? o = !0 : r === "listbox" && (o = "listbox");
  let a = ir();
  return {
    triggerProps: {
      "aria-haspopup": o,
      "aria-expanded": i,
      "aria-controls": i ? a : void 0,
      onPress: t.toggle
    },
    overlayProps: {
      id: a
    }
  };
}
function gV(e) {
  return e && e.__esModule ? e.default : e;
}
function a4(e, t, n) {
  let { type: r = "menu", isDisabled: i, trigger: o = "press" } = e, a = ir(), { triggerProps: s, overlayProps: l } = vV({
    type: r
  }, t, n), u = (p) => {
    if (!i && !(o === "longPress" && !p.altKey) && n && n.current)
      switch (p.key) {
        case "Enter":
        case " ":
          if (o === "longPress" || p.isDefaultPrevented()) return;
        // fallthrough
        case "ArrowDown":
          "continuePropagation" in p || p.stopPropagation(), p.preventDefault(), t.toggle("first");
          break;
        case "ArrowUp":
          "continuePropagation" in p || p.stopPropagation(), p.preventDefault(), t.toggle("last");
          break;
        default:
          "continuePropagation" in p && p.continuePropagation();
      }
  }, c = eO(gV(o4), "@react-aria/menu"), { longPressProps: f } = DO({
    isDisabled: i || o !== "longPress",
    accessibilityDescription: c.format("longPressMessage"),
    onLongPressStart() {
      t.close();
    },
    onLongPress() {
      t.open("first");
    }
  }), d = {
    preventFocusOnPress: !0,
    onPressStart(p) {
      p.pointerType !== "touch" && p.pointerType !== "keyboard" && !i && (ai(p.target), t.open(p.pointerType === "virtual" ? "first" : null));
    },
    onPress(p) {
      p.pointerType === "touch" && !i && (ai(p.target), t.toggle());
    }
  };
  return delete s.onPress, {
    // @ts-ignore - TODO we pass out both DOMAttributes AND AriaButtonProps, but useButton will discard the longPress event handlers, it's only through PressResponder magic that this works for RSP and RAC. it does not work in aria examples
    menuTriggerProps: {
      ...s,
      ...o === "press" ? d : f,
      id: a,
      onKeyDown: u
    },
    menuProps: {
      ...l,
      "aria-labelledby": a,
      autoFocus: t.focusStrategy || !0,
      onClose: t.close
    }
  };
}
const s4 = /* @__PURE__ */ new WeakMap();
function yV(e, t, n) {
  let { shouldFocusWrap: r = !0, onKeyDown: i, onKeyUp: o, ...a } = e;
  !e["aria-label"] && !e["aria-labelledby"] && process.env.NODE_ENV !== "production" && console.warn("An aria-label or aria-labelledby prop is required for accessibility.");
  let s = Dn(e, {
    labelable: !0
  }), { listProps: l } = AO({
    ...a,
    ref: n,
    selectionManager: t.selectionManager,
    collection: t.collection,
    disabledKeys: t.disabledKeys,
    shouldFocusWrap: r,
    linkBehavior: "override"
  });
  return s4.set(t, {
    onClose: e.onClose,
    onAction: e.onAction,
    shouldUseVirtualFocus: e.shouldUseVirtualFocus
  }), {
    menuProps: st(s, {
      onKeyDown: i,
      onKeyUp: o
    }, {
      role: "menu",
      ...l,
      onKeyDown: (u) => {
        (u.key !== "Escape" || e.shouldUseVirtualFocus) && l.onKeyDown?.(u);
      }
    })
  };
}
function bV(e, t, n) {
  let { id: r, key: i, closeOnSelect: o, shouldCloseOnSelect: a, isVirtualized: s, "aria-haspopup": l, onPressStart: u, onPressUp: c, onPress: f, onPressChange: d, onPressEnd: p, onClick: h, onHoverStart: v, onHoverChange: m, onHoverEnd: g, onKeyDown: _, onKeyUp: x, onFocus: w, onFocusChange: $, onBlur: k, selectionManager: D = t.selectionManager } = e, E = !!l, b = E && e["aria-expanded"] === "true", y = e.isDisabled ?? D.isDisabled(i), S = e.isSelected ?? D.isSelected(i), P = s4.get(t), M = t.collection.getItem(i), T = e.onClose || P.onClose, V = lp(), z = () => {
    if (!E && (M?.props?.onAction ? M.props.onAction() : e.onAction && e.onAction(i), P.onAction)) {
      let te = P.onAction;
      te(i, M?.value);
    }
  }, U = "menuitem";
  E || (D.selectionMode === "single" ? U = "menuitemradio" : D.selectionMode === "multiple" && (U = "menuitemcheckbox"));
  let B = va(), N = va(), C = va(), G = {
    id: r,
    "aria-disabled": y || void 0,
    role: U,
    "aria-label": e["aria-label"],
    "aria-labelledby": B,
    "aria-describedby": [
      e["aria-describedby"],
      N,
      C
    ].filter(Boolean).join(" ") || void 0,
    "aria-controls": e["aria-controls"],
    "aria-haspopup": l,
    "aria-expanded": e["aria-expanded"]
  };
  if (D.selectionMode !== "none" && !E && (G["aria-checked"] = S), s) {
    let te = Number(M?.index);
    G["aria-posinset"] = Number.isNaN(te) ? void 0 : te + 1, G["aria-setsize"] = MO(t.collection);
  }
  let re = ve(!1), ie = (te) => {
    d?.(te), re.current = te;
  }, X = ve(null), Se = (te) => {
    te.pointerType !== "keyboard" && (X.current = {
      pointerType: te.pointerType
    }), te.pointerType === "mouse" && (re.current || te.target.click()), c?.(te);
  }, me = (te) => {
    h?.(te), z(), Az(te, V, M.props.href, M?.props.routerOptions);
    let ue = X.current?.pointerType === "keyboard" ? X.current?.key === "Enter" || D.selectionMode === "none" || D.isLink(i) : D.selectionMode !== "multiple" || D.isLink(i);
    ue = a ?? o ?? ue, T && !E && ue && T(), X.current = null;
  }, { itemProps: fe, isFocused: Q } = CO({
    id: r,
    selectionManager: D,
    key: i,
    ref: n,
    shouldSelectOnPressUp: !0,
    allowsDifferentPressOrigin: !0,
    // Disable all handling of links in useSelectable item
    // because we handle it ourselves. The behavior of menus
    // is slightly different from other collections because
    // actions are performed on key down rather than key up.
    linkBehavior: "none",
    shouldUseVirtualFocus: P.shouldUseVirtualFocus
  }), { pressProps: A, isPressed: O } = hp({
    onPressStart: u,
    onPress: f,
    onPressUp: Se,
    onPressChange: ie,
    onPressEnd: p,
    isDisabled: y
  }), { hoverProps: R } = ll({
    isDisabled: y,
    onHoverStart(te) {
      !Sa() && !(b && l) && (D.setFocused(!0), D.setFocusedKey(i)), v?.(te);
    },
    onHoverChange: m,
    onHoverEnd: g
  }), { keyboardProps: j } = sb({
    onKeyDown: (te) => {
      if (te.repeat) {
        te.continuePropagation();
        return;
      }
      switch (te.key) {
        case " ":
          X.current = {
            pointerType: "keyboard",
            key: " "
          }, Ae(te).click(), ad("keyboard");
          break;
        case "Enter":
          X.current = {
            pointerType: "keyboard",
            key: "Enter"
          }, Ae(te).tagName !== "A" && Ae(te).click(), ad("keyboard");
          break;
        default:
          E || te.continuePropagation(), _?.(te);
          break;
      }
    },
    onKeyUp: x
  }), { focusableProps: q } = aO({
    onBlur: k,
    onFocus: w,
    onFocusChange: $
  }, n), Y = Dn(M?.props);
  delete Y.id;
  let ae = HT(M?.props);
  return {
    menuItemProps: {
      ...G,
      ...st(
        Y,
        ae,
        E ? {
          onFocus: fe.onFocus,
          "data-collection": fe["data-collection"],
          "data-key": fe["data-key"]
        } : fe,
        A,
        R,
        j,
        q,
        // Prevent DOM focus from moving on mouse down when using virtual focus or this is a submenu/subdialog trigger.
        P.shouldUseVirtualFocus || E ? {
          onMouseDown: (te) => te.preventDefault()
        } : void 0,
        y ? void 0 : {
          onClick: me
        }
      ),
      // If a submenu is expanded, set the tabIndex to -1 so that shift tabbing goes out of the menu instead of the parent menu item.
      tabIndex: fe.tabIndex != null && b && !P.shouldUseVirtualFocus ? -1 : fe.tabIndex
    },
    labelProps: {
      id: B
    },
    descriptionProps: {
      id: N
    },
    keyboardShortcutProps: {
      id: C
    },
    isFocused: Q,
    isFocusVisible: Q && D.isFocused && Sa() && !b,
    isSelected: S,
    isPressed: O,
    isDisabled: y
  };
}
function _V(e) {
  let { heading: t, "aria-label": n } = e, r = ir();
  return {
    itemProps: {
      role: "presentation"
    },
    headingProps: t ? {
      // Techincally, menus cannot contain headings according to ARIA.
      // We hide the heading from assistive technology, using role="presentation",
      // and only use it as a label for the nested group.
      id: r,
      role: "presentation"
    } : {},
    groupProps: {
      role: "group",
      "aria-label": n,
      "aria-labelledby": t ? r : void 0
    }
  };
}
function l4(e) {
  let t = Eb(e), [n, r] = Ke(null), [i, o] = Ke([]), a = () => {
    o([]), t.close();
  };
  return {
    focusStrategy: n,
    ...t,
    open(u = null) {
      r(u), t.open();
    },
    toggle(u = null) {
      r(u), t.toggle();
    },
    close() {
      a();
    },
    expandedKeysStack: i,
    openSubmenu: (u, c) => {
      o((f) => c > f.length ? f : [
        ...f.slice(0, c),
        u
      ]);
    },
    closeSubmenu: (u, c) => {
      o((f) => f[c] === u ? f.slice(0, c) : f);
    }
  };
}
class wV {
  constructor(t, { expandedKeys: n } = {}) {
    this.keyMap = /* @__PURE__ */ new Map(), this.firstKey = null, this.lastKey = null, this.iterable = t, n = n || /* @__PURE__ */ new Set();
    let r = (a) => {
      if (this.keyMap.set(a.key, a), a.childNodes && (a.type === "section" || n.has(a.key))) for (let s of a.childNodes) r(s);
    };
    for (let a of t) r(a);
    let i = null, o = 0;
    for (let [a, s] of this.keyMap)
      i ? (i.nextKey = a, s.prevKey = i.key) : (this.firstKey = a, s.prevKey = void 0), s.type === "item" && (s.index = o++), i = s, i.nextKey = void 0;
    this.lastKey = i?.key ?? null;
  }
  *[Symbol.iterator]() {
    yield* this.iterable;
  }
  get size() {
    return this.keyMap.size;
  }
  getKeys() {
    return this.keyMap.keys();
  }
  getKeyBefore(t) {
    let n = this.keyMap.get(t);
    return n ? n.prevKey ?? null : null;
  }
  getKeyAfter(t) {
    let n = this.keyMap.get(t);
    return n ? n.nextKey ?? null : null;
  }
  getFirstKey() {
    return this.firstKey;
  }
  getLastKey() {
    return this.lastKey;
  }
  getItem(t) {
    return this.keyMap.get(t) ?? null;
  }
  at(t) {
    const n = [
      ...this.getKeys()
    ];
    return this.getItem(n[t]);
  }
}
function xV(e) {
  let { onExpandedChange: t } = e, [n, r] = fp(e.expandedKeys ? new Set(e.expandedKeys) : void 0, e.defaultExpandedKeys ? new Set(e.defaultExpandedKeys) : /* @__PURE__ */ new Set(), t), i = wb(e), o = Fe(() => e.disabledKeys ? new Set(e.disabledKeys) : /* @__PURE__ */ new Set(), [
    e.disabledKeys
  ]), a = RO(e, Le((l) => new wV(l, {
    expandedKeys: n
  }), [
    n
  ]), null);
  return ze(() => {
    i.focusedKey != null && !a.getItem(i.focusedKey) && i.setFocusedKey(null);
  }, [
    a,
    i.focusedKey
  ]), {
    collection: a,
    expandedKeys: n,
    disabledKeys: o,
    toggleKey: (l) => {
      r(EV(n, l));
    },
    setExpandedKeys: r,
    selectionManager: new ic(a, i)
  };
}
function EV(e, t) {
  let n = new Set(e);
  return n.has(t) ? n.delete(t) : n.add(t), n;
}
const u4 = /* @__PURE__ */ He(null), $b = /* @__PURE__ */ He(null), ng = /* @__PURE__ */ He(null), dd = /* @__PURE__ */ He(null);
function SV(e) {
  let t = l4(e), n = ve(null), { menuTriggerProps: r, menuProps: i } = a4({
    ...e,
    type: "menu"
  }, t, n), o = ve(null);
  return sO() ? null : /* @__PURE__ */ H.createElement(ja, {
    values: [
      [
        u4,
        {
          ...i,
          ref: o
        }
      ],
      [
        kb,
        t
      ],
      [
        ng,
        t
      ],
      [
        Sb,
        {
          trigger: "MenuTrigger",
          triggerRef: n,
          scrollRef: o,
          placement: "bottom start",
          "aria-labelledby": i["aria-labelledby"]
        }
      ]
    ]
  }, /* @__PURE__ */ H.createElement(xP, {
    ...r,
    ref: n,
    isPressed: t.isOpen
  }, e.children));
}
const $V = /* @__PURE__ */ He(null), a1 = class a1 extends al {
  filter(t, n, r) {
    let i = t.getItem(this.firstChildKey);
    if (i && r(i.textValue, this)) {
      let o = this.clone();
      return n.addDescendants(o, t), o;
    }
    return null;
  }
};
a1.type = "submenutrigger";
let Dx = a1;
const kV = /* @__PURE__ */ fn(function(t, n) {
  return [t, n] = Ii(t, n, u4), /* @__PURE__ */ H.createElement(ub, {
    content: /* @__PURE__ */ H.createElement(cO, t)
  }, (r) => /* @__PURE__ */ H.createElement(TV, {
    props: t,
    collection: r,
    menuRef: n
  }));
});
function TV({ props: e, collection: t, menuRef: n }) {
  [e, n] = Ii(e, n, Vv);
  let { filter: r, ...i } = e, o = Fe(() => r ? t.filter(r) : t, [
    t,
    r
  ]), a = xV({
    ...e,
    collection: o,
    children: void 0
  }), s = je(ng), { isVirtualized: l, CollectionRoot: u } = je(sl), { menuProps: c } = yV({
    ...e,
    isVirtualized: l,
    onClose: e.onClose || s?.close
  }, a, n), f = Vr({
    ...e,
    children: void 0,
    defaultClassName: "react-aria-Menu",
    values: {
      isEmpty: a.collection.size === 0
    }
  }), d = null;
  a.collection.size === 0 && e.renderEmptyState && (d = /* @__PURE__ */ H.createElement("div", {
    role: "menuitem",
    style: {
      display: "contents"
    }
  }, e.renderEmptyState()));
  let p = Dn(e, {
    global: !0
  });
  return /* @__PURE__ */ H.createElement(gb, null, /* @__PURE__ */ H.createElement(Hn.div, {
    ...st(p, f, c),
    ref: n,
    slot: e.slot || void 0,
    "data-empty": a.collection.size === 0 || void 0,
    onScroll: e.onScroll
  }, /* @__PURE__ */ H.createElement(ja, {
    values: [
      [
        $b,
        a
      ],
      [
        SO,
        {
          elementType: "div"
        }
      ],
      [
        fO,
        {
          name: "MenuSection",
          render: PV
        }
      ],
      [
        $V,
        {
          parentMenuRef: n,
          shouldUseVirtualFocus: i?.shouldUseVirtualFocus
        }
      ],
      [
        Ou,
        {
          shouldCloseOnSelect: e.shouldCloseOnSelect
        }
      ],
      [
        Vv,
        null
      ],
      [
        Jz,
        null
      ],
      [
        dd,
        a.selectionManager
      ],
      /* Ensure root MenuTriggerState is defined, in case Menu is rendered outside a MenuTrigger. */
      /* We assume the context can never change between defined and undefined. */
      /* eslint-disable-next-line react-hooks/rules-of-hooks */
      [
        ng,
        s ?? l4({})
      ]
    ]
  }, /* @__PURE__ */ H.createElement(xO, null, /* @__PURE__ */ H.createElement(u, {
    collection: a.collection,
    persistedKeys: y9(a.selectionManager.focusedKey),
    scrollRef: n
  }))), d));
}
class OV extends ic {
  constructor(t, n) {
    super(t.collection, n), this.parent = t;
  }
  get focusedKey() {
    return this.parent.focusedKey;
  }
  get isFocused() {
    return this.parent.isFocused;
  }
  setFocusedKey(t, n) {
    return this.parent.setFocusedKey(t, n);
  }
  setFocused(t) {
    this.parent.setFocused(t);
  }
  get childFocusStrategy() {
    return this.parent.childFocusStrategy;
  }
}
function PV(e, t, n, r = "react-aria-MenuSection") {
  let i = je($b), { CollectionBranch: o } = je(sl), [a, s] = eb(), { headingProps: l, groupProps: u } = _V({
    heading: s,
    "aria-label": n.props["aria-label"] ?? void 0
  }), c = Vr({
    ...e,
    id: void 0,
    children: void 0,
    defaultClassName: r,
    className: n.props?.className,
    style: n.props?.style,
    values: void 0
  }), f = je(dd), d = wb(e), p = e.selectionMode != null ? new OV(f, d) : f, h = ap(Ou)?.shouldCloseOnSelect, v = Dn(e, {
    global: !0
  });
  return delete v.id, /* @__PURE__ */ H.createElement(Hn.section, {
    ...st(v, c, u),
    ref: t
  }, /* @__PURE__ */ H.createElement(ja, {
    values: [
      [
        wO,
        {
          ...l,
          ref: a
        }
      ],
      [
        dd,
        p
      ],
      [
        Ou,
        {
          shouldCloseOnSelect: e.shouldCloseOnSelect ?? h
        }
      ]
    ]
  }, /* @__PURE__ */ H.createElement(o, {
    collection: i.collection,
    parent: n
  })));
}
const Ou = /* @__PURE__ */ He(null), AV = /* @__PURE__ */ cb(sd, function(t, n, r) {
  [t, n] = Ii(t, n, Ou);
  let i = ap(Ou)?.id, o = je($b), a = il(n), s = je(dd), { isVirtualized: l } = je(sl), { menuItemProps: u, labelProps: c, descriptionProps: f, keyboardShortcutProps: d, ...p } = bV({
    ...t,
    id: i,
    key: r.key,
    selectionManager: s,
    isVirtualized: l
  }, o, a), { hoverProps: h, isHovered: v } = ll({
    isDisabled: p.isDisabled
  }), m = Vr({
    ...t,
    id: void 0,
    children: r.rendered,
    defaultClassName: "react-aria-MenuItem",
    values: {
      ...p,
      isHovered: v,
      isFocusVisible: p.isFocusVisible,
      selectionMode: s.selectionMode,
      selectionBehavior: s.selectionBehavior,
      hasSubmenu: !!t["aria-haspopup"],
      isOpen: t["aria-expanded"] === "true"
    }
  }), g = t.href ? Hn.a : Hn.div, _ = Dn(t, {
    global: !0
  });
  return delete _.id, delete _.onClick, /* @__PURE__ */ H.createElement(g, {
    ...st(_, m, u, h),
    ref: a,
    "data-disabled": p.isDisabled || void 0,
    "data-hovered": v || void 0,
    "data-focused": p.isFocused || void 0,
    "data-focus-visible": p.isFocusVisible || void 0,
    "data-pressed": p.isPressed || void 0,
    "data-selected": p.isSelected || void 0,
    "data-selection-mode": s.selectionMode === "none" ? void 0 : s.selectionMode,
    "data-has-submenu": !!t["aria-haspopup"] || void 0,
    "data-open": t["aria-expanded"] === "true" || void 0
  }, /* @__PURE__ */ H.createElement(ja, {
    values: [
      [
        gp,
        {
          slots: {
            [Xy]: c,
            label: c,
            description: f
          }
        }
      ],
      [
        mV,
        d
      ],
      [
        EO,
        {
          isSelected: p.isSelected
        }
      ]
    ]
  }, m.children));
}), kb = /* @__PURE__ */ He(null), DV = /* @__PURE__ */ fn(function(t, n) {
  let { onSelect: r, acceptedFileTypes: i, allowsMultiple: o, defaultCamera: a, children: s, acceptDirectory: l, ...u } = t, c = il(n), f = Dn(u, {
    global: !0
  });
  return /* @__PURE__ */ H.createElement(H.Fragment, null, /* @__PURE__ */ H.createElement(xP, {
    onPress: () => {
      c.current?.value && (c.current.value = ""), c.current?.click();
    }
  }, s), /* @__PURE__ */ H.createElement(eL, {
    ...f,
    className: "",
    type: "file",
    ref: c,
    style: {
      display: "none"
    },
    accept: i?.toString(),
    onChange: (d) => r?.(Ae(d).files),
    capture: a,
    multiple: o,
    // @ts-expect-error
    webkitdirectory: l ? "" : void 0
  }));
}), Tb = /* @__PURE__ */ new WeakMap();
function CV(e, t, n) {
  let { keyboardDelegate: r, isDisabled: i, isRequired: o, name: a, form: s, validationBehavior: l = "aria" } = e, u = _b({
    usage: "search",
    sensitivity: "base"
  }), c = Fe(() => r || new bb(t.collection, t.disabledKeys, n, u), [
    r,
    t.collection,
    t.disabledKeys,
    u,
    n
  ]), { menuTriggerProps: f, menuProps: d } = a4({
    isDisabled: i,
    type: "listbox"
  }, t, n), p = (b) => {
    if (t.selectionManager.selectionMode !== "multiple")
      switch (b.key) {
        case "ArrowLeft": {
          b.preventDefault();
          let y = t.selectedKey != null ? c.getKeyAbove?.(t.selectedKey) : c.getFirstKey?.();
          y != null && t.setSelectedKey(y);
          break;
        }
        case "ArrowRight": {
          b.preventDefault();
          let y = t.selectedKey != null ? c.getKeyBelow?.(t.selectedKey) : c.getFirstKey?.();
          y != null && t.setSelectedKey(y);
          break;
        }
      }
  }, { typeSelectProps: h } = PO({
    keyboardDelegate: c,
    selectionManager: t.selectionManager,
    onTypeSelect(b) {
      t.setSelectedKey(b);
    }
  }), { isInvalid: v, validationErrors: m, validationDetails: g } = t.displayValidation, { labelProps: _, fieldProps: x, descriptionProps: w, errorMessageProps: $ } = H9({
    ...e,
    labelElementType: "span",
    isInvalid: v,
    errorMessage: e.errorMessage || m
  });
  t.selectionManager.selectionMode === "multiple" && (h = {});
  let k = Dn(e, {
    labelable: !0
  }), D = st(h, f, x), E = ir();
  return Tb.set(t, {
    isDisabled: i,
    isRequired: o,
    name: a,
    form: s,
    validationBehavior: l
  }), {
    labelProps: {
      ..._,
      onClick: () => {
        e.isDisabled || (n.current?.focus(), ad("keyboard"));
      }
    },
    triggerProps: st(k, {
      ...D,
      isDisabled: i,
      onKeyDown: Na(D.onKeyDown, p, e.onKeyDown),
      onKeyUp: e.onKeyUp,
      "aria-labelledby": [
        E,
        D["aria-labelledby"],
        D["aria-label"] && !D["aria-labelledby"] ? D.id : null
      ].filter(Boolean).join(" "),
      onFocus(b) {
        t.isFocused || (e.onFocus && e.onFocus(b), e.onFocusChange && e.onFocusChange(!0), t.setFocused(!0));
      },
      onBlur(b) {
        t.isOpen || (e.onBlur && e.onBlur(b), e.onFocusChange && e.onFocusChange(!1), t.setFocused(!1));
      }
    }),
    valueProps: {
      id: E
    },
    menuProps: {
      ...d,
      onAction: void 0,
      autoFocus: t.focusStrategy || !0,
      shouldSelectOnPressUp: !0,
      shouldFocusOnHover: !0,
      disallowEmptySelection: !0,
      linkBehavior: "selection",
      onBlur: (b) => {
        Je(b.currentTarget, b.relatedTarget) || (e.onBlur && e.onBlur(b), e.onFocusChange && e.onFocusChange(!1), t.setFocused(!1));
      },
      "aria-labelledby": [
        x["aria-labelledby"],
        D["aria-label"] && !x["aria-labelledby"] ? D.id : null
      ].filter(Boolean).join(" ")
    },
    descriptionProps: w,
    errorMessageProps: $,
    isInvalid: v,
    validationErrors: m,
    validationDetails: g,
    hiddenSelectProps: {
      isDisabled: i,
      name: a,
      label: e.label,
      state: t,
      triggerRef: n,
      form: s
    }
  };
}
function IV(e, t, n) {
  let r = Tb.get(t) || {}, { autoComplete: i, name: o = r.name, form: a = r.form, isDisabled: s = r.isDisabled } = e, { validationBehavior: l, isRequired: u } = r, { visuallyHiddenProps: c } = vO({
    style: {
      // Prevent page scrolling.
      position: "fixed",
      top: 0,
      left: 0
    }
  });
  W9(e.selectRef, t.defaultValue, t.setValue), Z9({
    validationBehavior: l,
    focus: () => n.current?.focus()
  }, t, e.selectRef);
  let f = t.setValue, d = Le((p) => {
    let h = Ae(p);
    h.multiple ? f(Array.from(h.selectedOptions, (v) => v.value)) : f(p.currentTarget.value);
  }, [
    f
  ]);
  return {
    containerProps: {
      ...c,
      "aria-hidden": !0,
      // @ts-ignore
      "data-react-aria-prevent-focus": !0,
      // @ts-ignore
      "data-a11y-ignore": "aria-hidden-focus"
    },
    inputProps: {
      style: {
        display: "none"
      }
    },
    selectProps: {
      tabIndex: -1,
      autoComplete: i,
      disabled: s,
      multiple: t.selectionManager.selectionMode === "multiple",
      required: l === "native" && u,
      name: o,
      form: a,
      value: t.value ?? "",
      onChange: d,
      onInput: d
    }
  };
}
function MV(e) {
  let { state: t, triggerRef: n, label: r, name: i, form: o, isDisabled: a } = e, s = ve(null), l = ve(null), { containerProps: u, selectProps: c } = IV({
    ...e,
    selectRef: t.collection.size <= 300 ? s : l
  }, t, n), f = Array.isArray(t.value) ? t.value : [
    t.value
  ];
  if (t.collection.size <= 300) return /* @__PURE__ */ H.createElement("div", {
    ...u,
    "data-testid": "hidden-select-container"
  }, /* @__PURE__ */ H.createElement("label", null, r, /* @__PURE__ */ H.createElement("select", {
    ...c,
    ref: s
  }, /* @__PURE__ */ H.createElement("option", {
    value: "",
    label: " "
  }, " "), [
    ...t.collection.getKeys()
  ].map((d) => {
    let p = t.collection.getItem(d);
    if (p && p.type === "item") return /* @__PURE__ */ H.createElement("option", {
      key: p.key,
      value: p.key
    }, p.textValue);
  }), t.collection.size === 0 && i && f.map((d, p) => /* @__PURE__ */ H.createElement("option", {
    key: p,
    value: d ?? ""
  })))));
  if (i) {
    let d = Tb.get(t) || {}, { validationBehavior: p } = d;
    f.length === 0 && (f = [
      null
    ]);
    let h = f.map((v, m) => {
      let g = {
        type: "hidden",
        autoComplete: c.autoComplete,
        name: i,
        form: o,
        disabled: a,
        value: v ?? ""
      };
      return p === "native" ? /* @__PURE__ */ H.createElement("input", {
        key: m,
        ...g,
        ref: m === 0 ? l : null,
        style: {
          display: "none"
        },
        type: "text",
        required: m === 0 ? c.required : !1,
        onChange: () => {
        }
      }) : /* @__PURE__ */ H.createElement("input", {
        key: m,
        ...g,
        ref: m === 0 ? l : null
      });
    });
    return /* @__PURE__ */ H.createElement(H.Fragment, null, h);
  }
  return null;
}
function RV(e) {
  let { selectionMode: t = "single", shouldCloseOnSelect: n = t === "single" } = e, r = Eb(e), [i, o] = Ke(null), a = Fe(() => e.defaultValue !== void 0 ? e.defaultValue : t === "single" ? e.defaultSelectedKey ?? null : [], [
    e.defaultValue,
    e.defaultSelectedKey,
    t
  ]), s = Fe(() => e.value !== void 0 ? e.value : t === "single" ? e.selectedKey : void 0, [
    e.value,
    e.selectedKey,
    t
  ]), [l, u] = fp(s, a, e.onChange), c = t === "single" && Array.isArray(l) ? l[0] : l, f = (x) => {
    if (t === "single") {
      let w = Array.isArray(x) ? x[0] ?? null : x;
      u(w), w !== c && e.onSelectionChange?.(w);
    } else {
      let w = [];
      Array.isArray(x) ? w = x : x != null && (w = [
        x
      ]), u(w);
    }
  }, d = NO({
    ...e,
    selectionMode: t,
    disallowEmptySelection: t === "single",
    allowDuplicateSelectionEvents: !0,
    selectedKeys: Fe(() => NV(c), [
      c
    ]),
    onSelectionChange: (x) => {
      if (x !== "all") {
        if (t === "single") {
          let w = x.values().next().value ?? null;
          f(w);
        } else f([
          ...x
        ]);
        n && r.close(), v.commitValidation();
      }
    }
  }), p = d.selectionManager.firstSelectedKey, h = Fe(() => [
    ...d.selectionManager.selectedKeys
  ].map((x) => d.collection.getItem(x)).filter((x) => x != null), [
    d.selectionManager.selectedKeys,
    d.collection
  ]), v = B9({
    ...e,
    value: Array.isArray(c) && c.length === 0 ? null : c
  }), [m, g] = Ke(!1), [_] = Ke(c);
  return {
    ...v,
    ...d,
    ...r,
    value: c,
    defaultValue: a ?? _,
    setValue: f,
    selectedKey: p,
    setSelectedKey: f,
    selectedItem: h[0] ?? null,
    selectedItems: h,
    defaultSelectedKey: e.defaultSelectedKey ?? (e.selectionMode === "single" ? _ : null),
    focusStrategy: i,
    open(x = null) {
      (d.collection.size !== 0 || e.allowsEmptyCollection) && (o(x), r.open());
    },
    toggle(x = null) {
      (d.collection.size !== 0 || e.allowsEmptyCollection) && (o(x), r.toggle());
    },
    isFocused: m,
    setFocused: g
  };
}
function NV(e) {
  if (e !== void 0)
    return e === null ? [] : Array.isArray(e) ? e : [
      e
    ];
}
const c4 = /* @__PURE__ */ He(null), jV = /* @__PURE__ */ He(null), FV = /* @__PURE__ */ dp(function(t, n) {
  [t, n] = Ii(t, n, c4);
  let { children: r, isDisabled: i = !1, isInvalid: o = !1, isRequired: a = !1 } = t, s = Fe(() => typeof r == "function" ? r({
    isOpen: !1,
    isDisabled: i,
    isInvalid: o,
    isRequired: a,
    isFocused: !1,
    isFocusVisible: !1,
    defaultChildren: null
  }) : r, [
    r,
    i,
    o,
    a
  ]);
  return /* @__PURE__ */ H.createElement(ub, {
    content: s
  }, (l) => /* @__PURE__ */ H.createElement(LV, {
    props: t,
    collection: l,
    selectRef: n
  }));
}), zV = [
  db,
  pb,
  gp
];
function LV({ props: e, selectRef: t, collection: n }) {
  let { validationBehavior: r } = ap(q9) || {}, i = e.validationBehavior ?? r ?? "native", o = RV({
    ...e,
    collection: n,
    children: void 0,
    validationBehavior: i
  }), { isFocusVisible: a, focusProps: s } = vp({
    within: !0
  }), l = ve(null), [u, c] = eb(!e["aria-label"] && !e["aria-labelledby"]), { labelProps: f, triggerProps: d, valueProps: p, menuProps: h, descriptionProps: v, errorMessageProps: m, hiddenSelectProps: g, ..._ } = CV({
    ...oz(e),
    label: c,
    validationBehavior: i
  }, o, l), x = Fe(() => ({
    isOpen: o.isOpen,
    isFocused: o.isFocused,
    isFocusVisible: a,
    isDisabled: e.isDisabled || !1,
    isInvalid: _.isInvalid || !1,
    isRequired: e.isRequired || !1
  }), [
    o.isOpen,
    o.isFocused,
    a,
    e.isDisabled,
    _.isInvalid,
    e.isRequired
  ]), w = Vr({
    ...e,
    values: x,
    defaultClassName: "react-aria-Select"
  }), $ = Dn(e, {
    global: !0
  });
  delete $.id;
  let k = ve(null);
  return /* @__PURE__ */ H.createElement(ja, {
    values: [
      [
        c4,
        e
      ],
      [
        jV,
        o
      ],
      [
        VV,
        p
      ],
      [
        db,
        {
          ...f,
          ref: u,
          elementType: "span"
        }
      ],
      [
        pb,
        {
          ...d,
          ref: l,
          isPressed: o.isOpen,
          autoFocus: e.autoFocus
        }
      ],
      [
        kb,
        o
      ],
      [
        Sb,
        {
          trigger: "Select",
          triggerRef: l,
          scrollRef: k,
          placement: "bottom start",
          "aria-labelledby": h["aria-labelledby"],
          clearContexts: zV
        }
      ],
      [
        xb,
        {
          ...h,
          ref: k
        }
      ],
      [
        ul,
        o
      ],
      [
        gp,
        {
          slots: {
            description: v,
            errorMessage: m
          }
        }
      ],
      [
        L9,
        _
      ]
    ]
  }, /* @__PURE__ */ H.createElement(Hn.div, {
    ...st($, w, s),
    ref: t,
    slot: e.slot || void 0,
    "data-focused": o.isFocused || void 0,
    "data-focus-visible": a || void 0,
    "data-open": o.isOpen || void 0,
    "data-disabled": e.isDisabled || void 0,
    "data-invalid": _.isInvalid || void 0,
    "data-required": e.isRequired || void 0
  }, w.children, /* @__PURE__ */ H.createElement(MV, {
    ...g,
    autoComplete: e.autoComplete
  })));
}
const VV = /* @__PURE__ */ He(null), rse = ({
  options: e,
  onSelect: t,
  label: n,
  className: r = ""
}) => /* @__PURE__ */ I.jsxs(
  FV,
  {
    className: r,
    onSelectionChange: (i) => {
      t(i);
    },
    children: [
      /* @__PURE__ */ I.jsx(hb, { children: /* @__PURE__ */ I.jsxs("span", { "aria-hidden": "true", children: [
        n && /* @__PURE__ */ I.jsx(D9, { children: n }),
        /* @__PURE__ */ I.jsx(yr, { className: "px-2", icon: c$, size: "sm" })
      ] }) }),
      /* @__PURE__ */ I.jsx(SP, { className: "bg-white border border-black", children: /* @__PURE__ */ I.jsx(DL, { children: e.map((i) => /* @__PURE__ */ I.jsx(ML, { id: i.id, children: /* @__PURE__ */ I.jsx("span", { className: "p-1 bg-white w-full block cursor-auto focus:outline-2 focus:outline-neutral-800 ", children: i.label }) }, `dropdown-${i.id}`)) }) })
    ]
  }
), pd = fn(({ className: e, ...t }, n) => /* @__PURE__ */ I.jsx("input", { ref: n, className: rr(
  "bg-neutral-200 p-2 block h-auto max-h-8 my-2 border-black border dark:bg-neutral-500 dark:text-neutral-100 placeholder-neutral-400 dark:placeholder-neutral-400",
  e
), ...t })), BV = fn(({ className: e, ...t }, n) => /* @__PURE__ */ I.jsx("select", { ref: n, ...t, className: rr("bg-neutral-200 rounded-md p-2 block h-auto", e) })), ise = fn(({ field: e, onChange: t, other: n, ...r }, i) => {
  const [o, a] = Ke(!1);
  switch (e.type) {
    case "textarea":
      return /* @__PURE__ */ I.jsx(
        "textarea",
        {
          ref: i,
          onChange: t,
          ...r
        }
      );
    case "select":
      return /* @__PURE__ */ I.jsxs(I.Fragment, { children: [
        /* @__PURE__ */ I.jsxs(
          BV,
          {
            ref: i,
            required: !e.optional,
            onChange: (s) => {
              s.target.value === "other" ? a(!0) : a(!1), t && t(s);
            },
            ...r,
            children: [
              e.options.map((s, l) => /* @__PURE__ */ I.jsx("option", { value: s, children: s }, l)),
              e?.allowOther && /* @__PURE__ */ I.jsx("option", { value: "other", children: "Other" })
            ]
          }
        ),
        o && n?.()
      ] });
    case "submit":
      return /* @__PURE__ */ I.jsx(
        u$,
        {
          ref: i,
          onChange: t,
          ...r,
          type: "submit",
          children: e.text
        }
      );
    case "email":
      return /* @__PURE__ */ I.jsx(
        pd,
        {
          required: !e.optional,
          ref: i,
          onChange: t,
          type: "email",
          ...r
        }
      );
    default:
      return /* @__PURE__ */ I.jsx(
        pd,
        {
          required: !e.optional,
          ref: i,
          onChange: t,
          ...r
        }
      );
  }
}), KV = E6`
    0% {
        opacity: 0;
    }
    50% {
        opacity: 1;
    }
    100% {
        opacity: 0;
    }
`, em = x6.span`
  animation: ${KV} 3s linear infinite;
  animation-delay: ${({ index: e }) => e * 0.1}s;
`, ose = () => /* @__PURE__ */ I.jsxs(I.Fragment, { children: [
  /* @__PURE__ */ I.jsx(em, { index: 0, children: "." }),
  /* @__PURE__ */ I.jsx(em, { index: 1, children: "." }),
  /* @__PURE__ */ I.jsx(em, { index: 2, children: "." })
] }), UV = (e) => /* @__PURE__ */ I.jsx("p", { ...e, className: "text-red-500 text-sm" });
class ase extends Wd {
  constructor() {
    super(...arguments);
    mi(this, "state", {
      hasError: !1
    });
  }
  static getDerivedStateFromError(n) {
    return { hasError: !0 };
  }
  componentDidCatch(n, r) {
    console.error("Uncaught error:", n, r);
  }
  render() {
    return this.state.hasError ? /* @__PURE__ */ I.jsx("h1", { children: "Sorry.. there was an error" }) : this.props.children;
  }
}
function ne(e, t, n) {
  function r(s, l) {
    if (s._zod || Object.defineProperty(s, "_zod", {
      value: {
        def: l,
        constr: a,
        traits: /* @__PURE__ */ new Set()
      },
      enumerable: !1
    }), s._zod.traits.has(e))
      return;
    s._zod.traits.add(e), t(s, l);
    const u = a.prototype, c = Object.keys(u);
    for (let f = 0; f < c.length; f++) {
      const d = c[f];
      d in s || (s[d] = u[d].bind(s));
    }
  }
  const i = n?.Parent ?? Object;
  class o extends i {
  }
  Object.defineProperty(o, "name", { value: e });
  function a(s) {
    var l;
    const u = n != null && n.Parent ? new o() : this;
    r(u, s), (l = u._zod).deferred ?? (l.deferred = []);
    for (const c of u._zod.deferred)
      c();
    return u;
  }
  return Object.defineProperty(a, "init", { value: r }), Object.defineProperty(a, Symbol.hasInstance, {
    value: (s) => {
      var l, u;
      return n != null && n.Parent && s instanceof n.Parent ? !0 : (u = (l = s?._zod) == null ? void 0 : l.traits) == null ? void 0 : u.has(e);
    }
  }), Object.defineProperty(a, "name", { value: e }), a;
}
let $s = class extends Error {
  constructor() {
    super("Encountered Promise during synchronous parse. Use .parseAsync() instead.");
  }
}, f4 = class extends Error {
  constructor(t) {
    super(`Encountered unidirectional transform during encode: ${t}`), this.name = "ZodEncodeError";
  }
};
const d4 = {};
function Oo(e) {
  return d4;
}
function p4(e) {
  const t = Object.values(e).filter((n) => typeof n == "number");
  return Object.entries(e).filter(([n, r]) => t.indexOf(+n) === -1).map(([n, r]) => r);
}
function rg(e, t) {
  return typeof t == "bigint" ? t.toString() : t;
}
function Ob(e) {
  return {
    get value() {
      {
        const t = e();
        return Object.defineProperty(this, "value", { value: t }), t;
      }
    }
  };
}
function Pb(e) {
  return e == null;
}
function Ab(e) {
  const t = e.startsWith("^") ? 1 : 0, n = e.endsWith("$") ? e.length - 1 : e.length;
  return e.slice(t, n);
}
function qV(e, t) {
  const n = (e.toString().split(".")[1] || "").length, r = t.toString();
  let i = (r.split(".")[1] || "").length;
  if (i === 0 && /\d?e-\d?/.test(r)) {
    const l = r.match(/\d?e-(\d?)/);
    l != null && l[1] && (i = Number.parseInt(l[1]));
  }
  const o = n > i ? n : i, a = Number.parseInt(e.toFixed(o).replace(".", "")), s = Number.parseInt(t.toFixed(o).replace(".", ""));
  return a % s / 10 ** o;
}
const Cx = Symbol("evaluating");
function at(e, t, n) {
  let r;
  Object.defineProperty(e, t, {
    get() {
      if (r !== Cx)
        return r === void 0 && (r = Cx, r = n()), r;
    },
    set(i) {
      Object.defineProperty(e, t, {
        value: i
        // configurable: true,
      });
    },
    configurable: !0
  });
}
function za(e, t, n) {
  Object.defineProperty(e, t, {
    value: n,
    writable: !0,
    enumerable: !0,
    configurable: !0
  });
}
function zo(...e) {
  const t = {};
  for (const n of e) {
    const r = Object.getOwnPropertyDescriptors(n);
    Object.assign(t, r);
  }
  return Object.defineProperties({}, t);
}
function Ix(e) {
  return JSON.stringify(e);
}
function HV(e) {
  return e.toLowerCase().trim().replace(/[^\w\s-]/g, "").replace(/[\s_-]+/g, "-").replace(/^-+|-+$/g, "");
}
const h4 = "captureStackTrace" in Error ? Error.captureStackTrace : (...e) => {
};
function hd(e) {
  return typeof e == "object" && e !== null && !Array.isArray(e);
}
const WV = Ob(() => {
  var e;
  if (typeof navigator < "u" && (e = navigator?.userAgent) != null && e.includes("Cloudflare"))
    return !1;
  try {
    const t = Function;
    return new t(""), !0;
  } catch {
    return !1;
  }
});
function js(e) {
  if (hd(e) === !1)
    return !1;
  const t = e.constructor;
  if (t === void 0 || typeof t != "function")
    return !0;
  const n = t.prototype;
  return !(hd(n) === !1 || Object.prototype.hasOwnProperty.call(n, "isPrototypeOf") === !1);
}
function m4(e) {
  return js(e) ? { ...e } : Array.isArray(e) ? [...e] : e;
}
const ZV = /* @__PURE__ */ new Set(["string", "number", "symbol"]);
function Fs(e) {
  return e.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
}
function Lo(e, t, n) {
  const r = new e._zod.constr(t ?? e._zod.def);
  return (!t || n != null && n.parent) && (r._zod.parent = e), r;
}
function Ve(e) {
  const t = e;
  if (!t)
    return {};
  if (typeof t == "string")
    return { error: () => t };
  if (t?.message !== void 0) {
    if (t?.error !== void 0)
      throw new Error("Cannot specify both `message` and `error` params");
    t.error = t.message;
  }
  return delete t.message, typeof t.error == "string" ? { ...t, error: () => t.error } : t;
}
function GV(e) {
  return Object.keys(e).filter((t) => e[t]._zod.optin === "optional" && e[t]._zod.optout === "optional");
}
const YV = {
  safeint: [Number.MIN_SAFE_INTEGER, Number.MAX_SAFE_INTEGER],
  int32: [-2147483648, 2147483647],
  uint32: [0, 4294967295],
  float32: [-34028234663852886e22, 34028234663852886e22],
  float64: [-Number.MAX_VALUE, Number.MAX_VALUE]
};
function QV(e, t) {
  const n = e._zod.def, r = n.checks;
  if (r && r.length > 0)
    throw new Error(".pick() cannot be used on object schemas containing refinements");
  const i = zo(e._zod.def, {
    get shape() {
      const o = {};
      for (const a in t) {
        if (!(a in n.shape))
          throw new Error(`Unrecognized key: "${a}"`);
        t[a] && (o[a] = n.shape[a]);
      }
      return za(this, "shape", o), o;
    },
    checks: []
  });
  return Lo(e, i);
}
function JV(e, t) {
  const n = e._zod.def, r = n.checks;
  if (r && r.length > 0)
    throw new Error(".omit() cannot be used on object schemas containing refinements");
  const i = zo(e._zod.def, {
    get shape() {
      const o = { ...e._zod.def.shape };
      for (const a in t) {
        if (!(a in n.shape))
          throw new Error(`Unrecognized key: "${a}"`);
        t[a] && delete o[a];
      }
      return za(this, "shape", o), o;
    },
    checks: []
  });
  return Lo(e, i);
}
function XV(e, t) {
  if (!js(t))
    throw new Error("Invalid input to extend: expected a plain object");
  const n = e._zod.def.checks;
  if (n && n.length > 0) {
    const i = e._zod.def.shape;
    for (const o in t)
      if (Object.getOwnPropertyDescriptor(i, o) !== void 0)
        throw new Error("Cannot overwrite keys on object schemas containing refinements. Use `.safeExtend()` instead.");
  }
  const r = zo(e._zod.def, {
    get shape() {
      const i = { ...e._zod.def.shape, ...t };
      return za(this, "shape", i), i;
    }
  });
  return Lo(e, r);
}
function e7(e, t) {
  if (!js(t))
    throw new Error("Invalid input to safeExtend: expected a plain object");
  const n = zo(e._zod.def, {
    get shape() {
      const r = { ...e._zod.def.shape, ...t };
      return za(this, "shape", r), r;
    }
  });
  return Lo(e, n);
}
function t7(e, t) {
  const n = zo(e._zod.def, {
    get shape() {
      const r = { ...e._zod.def.shape, ...t._zod.def.shape };
      return za(this, "shape", r), r;
    },
    get catchall() {
      return t._zod.def.catchall;
    },
    checks: []
    // delete existing checks
  });
  return Lo(e, n);
}
function n7(e, t, n) {
  const r = t._zod.def.checks;
  if (r && r.length > 0)
    throw new Error(".partial() cannot be used on object schemas containing refinements");
  const i = zo(t._zod.def, {
    get shape() {
      const o = t._zod.def.shape, a = { ...o };
      if (n)
        for (const s in n) {
          if (!(s in o))
            throw new Error(`Unrecognized key: "${s}"`);
          n[s] && (a[s] = e ? new e({
            type: "optional",
            innerType: o[s]
          }) : o[s]);
        }
      else
        for (const s in o)
          a[s] = e ? new e({
            type: "optional",
            innerType: o[s]
          }) : o[s];
      return za(this, "shape", a), a;
    },
    checks: []
  });
  return Lo(t, i);
}
function r7(e, t, n) {
  const r = zo(t._zod.def, {
    get shape() {
      const i = t._zod.def.shape, o = { ...i };
      if (n)
        for (const a in n) {
          if (!(a in o))
            throw new Error(`Unrecognized key: "${a}"`);
          n[a] && (o[a] = new e({
            type: "nonoptional",
            innerType: i[a]
          }));
        }
      else
        for (const a in i)
          o[a] = new e({
            type: "nonoptional",
            innerType: i[a]
          });
      return za(this, "shape", o), o;
    }
  });
  return Lo(t, r);
}
function ds(e, t = 0) {
  var n;
  if (e.aborted === !0)
    return !0;
  for (let r = t; r < e.issues.length; r++)
    if (((n = e.issues[r]) == null ? void 0 : n.continue) !== !0)
      return !0;
  return !1;
}
function ps(e, t) {
  return t.map((n) => {
    var r;
    return (r = n).path ?? (r.path = []), n.path.unshift(e), n;
  });
}
function Kc(e) {
  return typeof e == "string" ? e : e?.message;
}
function Po(e, t, n) {
  var r, i, o, a, s, l;
  const u = { ...e, path: e.path ?? [] };
  if (!e.message) {
    const c = Kc((o = (i = (r = e.inst) == null ? void 0 : r._zod.def) == null ? void 0 : i.error) == null ? void 0 : o.call(i, e)) ?? Kc((a = t?.error) == null ? void 0 : a.call(t, e)) ?? Kc((s = n.customError) == null ? void 0 : s.call(n, e)) ?? Kc((l = n.localeError) == null ? void 0 : l.call(n, e)) ?? "Invalid input";
    u.message = c;
  }
  return delete u.inst, delete u.continue, t != null && t.reportInput || delete u.input, u;
}
function Db(e) {
  return Array.isArray(e) ? "array" : typeof e == "string" ? "string" : "unknown";
}
function Pu(...e) {
  const [t, n, r] = e;
  return typeof t == "string" ? {
    message: t,
    code: "custom",
    input: n,
    inst: r
  } : { ...t };
}
const v4 = (e, t) => {
  e.name = "$ZodError", Object.defineProperty(e, "_zod", {
    value: e._zod,
    enumerable: !1
  }), Object.defineProperty(e, "issues", {
    value: t,
    enumerable: !1
  }), e.message = JSON.stringify(t, rg, 2), Object.defineProperty(e, "toString", {
    value: () => e.message,
    enumerable: !1
  });
}, g4 = ne("$ZodError", v4), y4 = ne("$ZodError", v4, { Parent: Error });
function i7(e, t = (n) => n.message) {
  const n = {}, r = [];
  for (const i of e.issues)
    i.path.length > 0 ? (n[i.path[0]] = n[i.path[0]] || [], n[i.path[0]].push(t(i))) : r.push(t(i));
  return { formErrors: r, fieldErrors: n };
}
function o7(e, t = (n) => n.message) {
  const n = { _errors: [] }, r = (i) => {
    for (const o of i.issues)
      if (o.code === "invalid_union" && o.errors.length)
        o.errors.map((a) => r({ issues: a }));
      else if (o.code === "invalid_key")
        r({ issues: o.issues });
      else if (o.code === "invalid_element")
        r({ issues: o.issues });
      else if (o.path.length === 0)
        n._errors.push(t(o));
      else {
        let a = n, s = 0;
        for (; s < o.path.length; ) {
          const l = o.path[s];
          s === o.path.length - 1 ? (a[l] = a[l] || { _errors: [] }, a[l]._errors.push(t(o))) : a[l] = a[l] || { _errors: [] }, a = a[l], s++;
        }
      }
  };
  return r(e), n;
}
const Cb = (e) => (t, n, r, i) => {
  const o = r ? Object.assign(r, { async: !1 }) : { async: !1 }, a = t._zod.run({ value: n, issues: [] }, o);
  if (a instanceof Promise)
    throw new $s();
  if (a.issues.length) {
    const s = new (i?.Err ?? e)(a.issues.map((l) => Po(l, o, Oo())));
    throw h4(s, i?.callee), s;
  }
  return a.value;
}, Ib = (e) => async (t, n, r, i) => {
  const o = r ? Object.assign(r, { async: !0 }) : { async: !0 };
  let a = t._zod.run({ value: n, issues: [] }, o);
  if (a instanceof Promise && (a = await a), a.issues.length) {
    const s = new (i?.Err ?? e)(a.issues.map((l) => Po(l, o, Oo())));
    throw h4(s, i?.callee), s;
  }
  return a.value;
}, _p = (e) => (t, n, r) => {
  const i = r ? { ...r, async: !1 } : { async: !1 }, o = t._zod.run({ value: n, issues: [] }, i);
  if (o instanceof Promise)
    throw new $s();
  return o.issues.length ? {
    success: !1,
    error: new (e ?? g4)(o.issues.map((a) => Po(a, i, Oo())))
  } : { success: !0, data: o.value };
}, a7 = /* @__PURE__ */ _p(y4), wp = (e) => async (t, n, r) => {
  const i = r ? Object.assign(r, { async: !0 }) : { async: !0 };
  let o = t._zod.run({ value: n, issues: [] }, i);
  return o instanceof Promise && (o = await o), o.issues.length ? {
    success: !1,
    error: new e(o.issues.map((a) => Po(a, i, Oo())))
  } : { success: !0, data: o.value };
}, s7 = /* @__PURE__ */ wp(y4), l7 = (e) => (t, n, r) => {
  const i = r ? Object.assign(r, { direction: "backward" }) : { direction: "backward" };
  return Cb(e)(t, n, i);
}, u7 = (e) => (t, n, r) => Cb(e)(t, n, r), c7 = (e) => async (t, n, r) => {
  const i = r ? Object.assign(r, { direction: "backward" }) : { direction: "backward" };
  return Ib(e)(t, n, i);
}, f7 = (e) => async (t, n, r) => Ib(e)(t, n, r), d7 = (e) => (t, n, r) => {
  const i = r ? Object.assign(r, { direction: "backward" }) : { direction: "backward" };
  return _p(e)(t, n, i);
}, p7 = (e) => (t, n, r) => _p(e)(t, n, r), h7 = (e) => async (t, n, r) => {
  const i = r ? Object.assign(r, { direction: "backward" }) : { direction: "backward" };
  return wp(e)(t, n, i);
}, m7 = (e) => async (t, n, r) => wp(e)(t, n, r), v7 = /^[cC][^\s-]{8,}$/, g7 = /^[0-9a-z]+$/, y7 = /^[0-9A-HJKMNP-TV-Za-hjkmnp-tv-z]{26}$/, b7 = /^[0-9a-vA-V]{20}$/, _7 = /^[A-Za-z0-9]{27}$/, w7 = /^[a-zA-Z0-9_-]{21}$/, x7 = /^P(?:(\d+W)|(?!.*W)(?=\d|T\d)(\d+Y)?(\d+M)?(\d+D)?(T(?=\d)(\d+H)?(\d+M)?(\d+([.,]\d+)?S)?)?)$/, E7 = /^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12})$/, Mx = (e) => e ? new RegExp(`^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-${e}[0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12})$`) : /^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$/, S7 = /^(?!\.)(?!.*\.\.)([A-Za-z0-9_'+\-\.]*)[A-Za-z0-9_+-]@([A-Za-z0-9][A-Za-z0-9\-]*\.)+[A-Za-z]{2,}$/, $7 = "^(\\p{Extended_Pictographic}|\\p{Emoji_Component})+$";
function k7() {
  return new RegExp($7, "u");
}
const T7 = /^(?:(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])\.){3}(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])$/, O7 = /^(([0-9a-fA-F]{1,4}:){7}[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,7}:|([0-9a-fA-F]{1,4}:){1,6}:[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,5}(:[0-9a-fA-F]{1,4}){1,2}|([0-9a-fA-F]{1,4}:){1,4}(:[0-9a-fA-F]{1,4}){1,3}|([0-9a-fA-F]{1,4}:){1,3}(:[0-9a-fA-F]{1,4}){1,4}|([0-9a-fA-F]{1,4}:){1,2}(:[0-9a-fA-F]{1,4}){1,5}|[0-9a-fA-F]{1,4}:((:[0-9a-fA-F]{1,4}){1,6})|:((:[0-9a-fA-F]{1,4}){1,7}|:))$/, P7 = /^((25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])\.){3}(25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])\/([0-9]|[1-2][0-9]|3[0-2])$/, A7 = /^(([0-9a-fA-F]{1,4}:){7}[0-9a-fA-F]{1,4}|::|([0-9a-fA-F]{1,4})?::([0-9a-fA-F]{1,4}:?){0,6})\/(12[0-8]|1[01][0-9]|[1-9]?[0-9])$/, D7 = /^$|^(?:[0-9a-zA-Z+/]{4})*(?:(?:[0-9a-zA-Z+/]{2}==)|(?:[0-9a-zA-Z+/]{3}=))?$/, b4 = /^[A-Za-z0-9_-]*$/, C7 = /^\+[1-9]\d{6,14}$/, _4 = "(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))", I7 = /* @__PURE__ */ new RegExp(`^${_4}$`);
function w4(e) {
  const t = "(?:[01]\\d|2[0-3]):[0-5]\\d";
  return typeof e.precision == "number" ? e.precision === -1 ? `${t}` : e.precision === 0 ? `${t}:[0-5]\\d` : `${t}:[0-5]\\d\\.\\d{${e.precision}}` : `${t}(?::[0-5]\\d(?:\\.\\d+)?)?`;
}
function M7(e) {
  return new RegExp(`^${w4(e)}$`);
}
function R7(e) {
  const t = w4({ precision: e.precision }), n = ["Z"];
  e.local && n.push(""), e.offset && n.push("([+-](?:[01]\\d|2[0-3]):[0-5]\\d)");
  const r = `${t}(?:${n.join("|")})`;
  return new RegExp(`^${_4}T(?:${r})$`);
}
const N7 = (e) => {
  const t = e ? `[\\s\\S]{${e?.minimum ?? 0},${e?.maximum ?? ""}}` : "[\\s\\S]*";
  return new RegExp(`^${t}$`);
}, j7 = /^-?\d+$/, x4 = /^-?\d+(?:\.\d+)?$/, F7 = /^(?:true|false)$/i, z7 = /^[^A-Z]*$/, L7 = /^[^a-z]*$/, sr = /* @__PURE__ */ ne("$ZodCheck", (e, t) => {
  var n;
  e._zod ?? (e._zod = {}), e._zod.def = t, (n = e._zod).onattach ?? (n.onattach = []);
}), E4 = {
  number: "number",
  bigint: "bigint",
  object: "date"
}, S4 = /* @__PURE__ */ ne("$ZodCheckLessThan", (e, t) => {
  sr.init(e, t);
  const n = E4[typeof t.value];
  e._zod.onattach.push((r) => {
    const i = r._zod.bag, o = (t.inclusive ? i.maximum : i.exclusiveMaximum) ?? Number.POSITIVE_INFINITY;
    t.value < o && (t.inclusive ? i.maximum = t.value : i.exclusiveMaximum = t.value);
  }), e._zod.check = (r) => {
    (t.inclusive ? r.value <= t.value : r.value < t.value) || r.issues.push({
      origin: n,
      code: "too_big",
      maximum: typeof t.value == "object" ? t.value.getTime() : t.value,
      input: r.value,
      inclusive: t.inclusive,
      inst: e,
      continue: !t.abort
    });
  };
}), $4 = /* @__PURE__ */ ne("$ZodCheckGreaterThan", (e, t) => {
  sr.init(e, t);
  const n = E4[typeof t.value];
  e._zod.onattach.push((r) => {
    const i = r._zod.bag, o = (t.inclusive ? i.minimum : i.exclusiveMinimum) ?? Number.NEGATIVE_INFINITY;
    t.value > o && (t.inclusive ? i.minimum = t.value : i.exclusiveMinimum = t.value);
  }), e._zod.check = (r) => {
    (t.inclusive ? r.value >= t.value : r.value > t.value) || r.issues.push({
      origin: n,
      code: "too_small",
      minimum: typeof t.value == "object" ? t.value.getTime() : t.value,
      input: r.value,
      inclusive: t.inclusive,
      inst: e,
      continue: !t.abort
    });
  };
}), V7 = /* @__PURE__ */ ne("$ZodCheckMultipleOf", (e, t) => {
  sr.init(e, t), e._zod.onattach.push((n) => {
    var r;
    (r = n._zod.bag).multipleOf ?? (r.multipleOf = t.value);
  }), e._zod.check = (n) => {
    if (typeof n.value != typeof t.value)
      throw new Error("Cannot mix number and bigint in multiple_of check.");
    (typeof n.value == "bigint" ? n.value % t.value === BigInt(0) : qV(n.value, t.value) === 0) || n.issues.push({
      origin: typeof n.value,
      code: "not_multiple_of",
      divisor: t.value,
      input: n.value,
      inst: e,
      continue: !t.abort
    });
  };
}), B7 = /* @__PURE__ */ ne("$ZodCheckNumberFormat", (e, t) => {
  var n;
  sr.init(e, t), t.format = t.format || "float64";
  const r = (n = t.format) == null ? void 0 : n.includes("int"), i = r ? "int" : "number", [o, a] = YV[t.format];
  e._zod.onattach.push((s) => {
    const l = s._zod.bag;
    l.format = t.format, l.minimum = o, l.maximum = a, r && (l.pattern = j7);
  }), e._zod.check = (s) => {
    const l = s.value;
    if (r) {
      if (!Number.isInteger(l)) {
        s.issues.push({
          expected: i,
          format: t.format,
          code: "invalid_type",
          continue: !1,
          input: l,
          inst: e
        });
        return;
      }
      if (!Number.isSafeInteger(l)) {
        l > 0 ? s.issues.push({
          input: l,
          code: "too_big",
          maximum: Number.MAX_SAFE_INTEGER,
          note: "Integers must be within the safe integer range.",
          inst: e,
          origin: i,
          inclusive: !0,
          continue: !t.abort
        }) : s.issues.push({
          input: l,
          code: "too_small",
          minimum: Number.MIN_SAFE_INTEGER,
          note: "Integers must be within the safe integer range.",
          inst: e,
          origin: i,
          inclusive: !0,
          continue: !t.abort
        });
        return;
      }
    }
    l < o && s.issues.push({
      origin: "number",
      input: l,
      code: "too_small",
      minimum: o,
      inclusive: !0,
      inst: e,
      continue: !t.abort
    }), l > a && s.issues.push({
      origin: "number",
      input: l,
      code: "too_big",
      maximum: a,
      inclusive: !0,
      inst: e,
      continue: !t.abort
    });
  };
}), K7 = /* @__PURE__ */ ne("$ZodCheckMaxLength", (e, t) => {
  var n;
  sr.init(e, t), (n = e._zod.def).when ?? (n.when = (r) => {
    const i = r.value;
    return !Pb(i) && i.length !== void 0;
  }), e._zod.onattach.push((r) => {
    const i = r._zod.bag.maximum ?? Number.POSITIVE_INFINITY;
    t.maximum < i && (r._zod.bag.maximum = t.maximum);
  }), e._zod.check = (r) => {
    const i = r.value;
    if (i.length <= t.maximum)
      return;
    const o = Db(i);
    r.issues.push({
      origin: o,
      code: "too_big",
      maximum: t.maximum,
      inclusive: !0,
      input: i,
      inst: e,
      continue: !t.abort
    });
  };
}), U7 = /* @__PURE__ */ ne("$ZodCheckMinLength", (e, t) => {
  var n;
  sr.init(e, t), (n = e._zod.def).when ?? (n.when = (r) => {
    const i = r.value;
    return !Pb(i) && i.length !== void 0;
  }), e._zod.onattach.push((r) => {
    const i = r._zod.bag.minimum ?? Number.NEGATIVE_INFINITY;
    t.minimum > i && (r._zod.bag.minimum = t.minimum);
  }), e._zod.check = (r) => {
    const i = r.value;
    if (i.length >= t.minimum)
      return;
    const o = Db(i);
    r.issues.push({
      origin: o,
      code: "too_small",
      minimum: t.minimum,
      inclusive: !0,
      input: i,
      inst: e,
      continue: !t.abort
    });
  };
}), q7 = /* @__PURE__ */ ne("$ZodCheckLengthEquals", (e, t) => {
  var n;
  sr.init(e, t), (n = e._zod.def).when ?? (n.when = (r) => {
    const i = r.value;
    return !Pb(i) && i.length !== void 0;
  }), e._zod.onattach.push((r) => {
    const i = r._zod.bag;
    i.minimum = t.length, i.maximum = t.length, i.length = t.length;
  }), e._zod.check = (r) => {
    const i = r.value, o = i.length;
    if (o === t.length)
      return;
    const a = Db(i), s = o > t.length;
    r.issues.push({
      origin: a,
      ...s ? { code: "too_big", maximum: t.length } : { code: "too_small", minimum: t.length },
      inclusive: !0,
      exact: !0,
      input: r.value,
      inst: e,
      continue: !t.abort
    });
  };
}), xp = /* @__PURE__ */ ne("$ZodCheckStringFormat", (e, t) => {
  var n, r;
  sr.init(e, t), e._zod.onattach.push((i) => {
    const o = i._zod.bag;
    o.format = t.format, t.pattern && (o.patterns ?? (o.patterns = /* @__PURE__ */ new Set()), o.patterns.add(t.pattern));
  }), t.pattern ? (n = e._zod).check ?? (n.check = (i) => {
    t.pattern.lastIndex = 0, !t.pattern.test(i.value) && i.issues.push({
      origin: "string",
      code: "invalid_format",
      format: t.format,
      input: i.value,
      ...t.pattern ? { pattern: t.pattern.toString() } : {},
      inst: e,
      continue: !t.abort
    });
  }) : (r = e._zod).check ?? (r.check = () => {
  });
}), H7 = /* @__PURE__ */ ne("$ZodCheckRegex", (e, t) => {
  xp.init(e, t), e._zod.check = (n) => {
    t.pattern.lastIndex = 0, !t.pattern.test(n.value) && n.issues.push({
      origin: "string",
      code: "invalid_format",
      format: "regex",
      input: n.value,
      pattern: t.pattern.toString(),
      inst: e,
      continue: !t.abort
    });
  };
}), W7 = /* @__PURE__ */ ne("$ZodCheckLowerCase", (e, t) => {
  t.pattern ?? (t.pattern = z7), xp.init(e, t);
}), Z7 = /* @__PURE__ */ ne("$ZodCheckUpperCase", (e, t) => {
  t.pattern ?? (t.pattern = L7), xp.init(e, t);
}), G7 = /* @__PURE__ */ ne("$ZodCheckIncludes", (e, t) => {
  sr.init(e, t);
  const n = Fs(t.includes), r = new RegExp(typeof t.position == "number" ? `^.{${t.position}}${n}` : n);
  t.pattern = r, e._zod.onattach.push((i) => {
    const o = i._zod.bag;
    o.patterns ?? (o.patterns = /* @__PURE__ */ new Set()), o.patterns.add(r);
  }), e._zod.check = (i) => {
    i.value.includes(t.includes, t.position) || i.issues.push({
      origin: "string",
      code: "invalid_format",
      format: "includes",
      includes: t.includes,
      input: i.value,
      inst: e,
      continue: !t.abort
    });
  };
}), Y7 = /* @__PURE__ */ ne("$ZodCheckStartsWith", (e, t) => {
  sr.init(e, t);
  const n = new RegExp(`^${Fs(t.prefix)}.*`);
  t.pattern ?? (t.pattern = n), e._zod.onattach.push((r) => {
    const i = r._zod.bag;
    i.patterns ?? (i.patterns = /* @__PURE__ */ new Set()), i.patterns.add(n);
  }), e._zod.check = (r) => {
    r.value.startsWith(t.prefix) || r.issues.push({
      origin: "string",
      code: "invalid_format",
      format: "starts_with",
      prefix: t.prefix,
      input: r.value,
      inst: e,
      continue: !t.abort
    });
  };
}), Q7 = /* @__PURE__ */ ne("$ZodCheckEndsWith", (e, t) => {
  sr.init(e, t);
  const n = new RegExp(`.*${Fs(t.suffix)}$`);
  t.pattern ?? (t.pattern = n), e._zod.onattach.push((r) => {
    const i = r._zod.bag;
    i.patterns ?? (i.patterns = /* @__PURE__ */ new Set()), i.patterns.add(n);
  }), e._zod.check = (r) => {
    r.value.endsWith(t.suffix) || r.issues.push({
      origin: "string",
      code: "invalid_format",
      format: "ends_with",
      suffix: t.suffix,
      input: r.value,
      inst: e,
      continue: !t.abort
    });
  };
}), J7 = /* @__PURE__ */ ne("$ZodCheckOverwrite", (e, t) => {
  sr.init(e, t), e._zod.check = (n) => {
    n.value = t.tx(n.value);
  };
});
let X7 = class {
  constructor(t = []) {
    this.content = [], this.indent = 0, this && (this.args = t);
  }
  indented(t) {
    this.indent += 1, t(this), this.indent -= 1;
  }
  write(t) {
    if (typeof t == "function") {
      t(this, { execution: "sync" }), t(this, { execution: "async" });
      return;
    }
    const n = t.split(`
`).filter((o) => o), r = Math.min(...n.map((o) => o.length - o.trimStart().length)), i = n.map((o) => o.slice(r)).map((o) => " ".repeat(this.indent * 2) + o);
    for (const o of i)
      this.content.push(o);
  }
  compile() {
    const t = Function, n = this == null ? void 0 : this.args, r = [...((this == null ? void 0 : this.content) ?? [""]).map((i) => `  ${i}`)];
    return new t(...n, r.join(`
`));
  }
};
const eB = {
  major: 4,
  minor: 3,
  patch: 6
}, Ot = /* @__PURE__ */ ne("$ZodType", (e, t) => {
  var n, r;
  e ?? (e = {}), e._zod.def = t, e._zod.bag = e._zod.bag || {}, e._zod.version = eB;
  const i = [...e._zod.def.checks ?? []];
  e._zod.traits.has("$ZodCheck") && i.unshift(e);
  for (const o of i)
    for (const a of o._zod.onattach)
      a(e);
  if (i.length === 0)
    (r = e._zod).deferred ?? (r.deferred = []), (n = e._zod.deferred) == null || n.push(() => {
      e._zod.run = e._zod.parse;
    });
  else {
    const o = (s, l, u) => {
      let c = ds(s), f;
      for (const d of l) {
        if (d._zod.def.when) {
          if (!d._zod.def.when(s))
            continue;
        } else if (c)
          continue;
        const p = s.issues.length, h = d._zod.check(s);
        if (h instanceof Promise && u?.async === !1)
          throw new $s();
        if (f || h instanceof Promise)
          f = (f ?? Promise.resolve()).then(async () => {
            await h, s.issues.length !== p && (c || (c = ds(s, p)));
          });
        else {
          if (s.issues.length === p)
            continue;
          c || (c = ds(s, p));
        }
      }
      return f ? f.then(() => s) : s;
    }, a = (s, l, u) => {
      if (ds(s))
        return s.aborted = !0, s;
      const c = o(l, i, u);
      if (c instanceof Promise) {
        if (u.async === !1)
          throw new $s();
        return c.then((f) => e._zod.parse(f, u));
      }
      return e._zod.parse(c, u);
    };
    e._zod.run = (s, l) => {
      if (l.skipChecks)
        return e._zod.parse(s, l);
      if (l.direction === "backward") {
        const c = e._zod.parse({ value: s.value, issues: [] }, { ...l, skipChecks: !0 });
        return c instanceof Promise ? c.then((f) => a(f, s, l)) : a(c, s, l);
      }
      const u = e._zod.parse(s, l);
      if (u instanceof Promise) {
        if (l.async === !1)
          throw new $s();
        return u.then((c) => o(c, i, l));
      }
      return o(u, i, l);
    };
  }
  at(e, "~standard", () => ({
    validate: (o) => {
      var a;
      try {
        const s = a7(e, o);
        return s.success ? { value: s.data } : { issues: (a = s.error) == null ? void 0 : a.issues };
      } catch {
        return s7(e, o).then((s) => {
          var l;
          return s.success ? { value: s.data } : { issues: (l = s.error) == null ? void 0 : l.issues };
        });
      }
    },
    vendor: "zod",
    version: 1
  }));
}), Mb = /* @__PURE__ */ ne("$ZodString", (e, t) => {
  var n;
  Ot.init(e, t), e._zod.pattern = [...((n = e?._zod.bag) == null ? void 0 : n.patterns) ?? []].pop() ?? N7(e._zod.bag), e._zod.parse = (r, i) => {
    if (t.coerce)
      try {
        r.value = String(r.value);
      } catch {
      }
    return typeof r.value == "string" || r.issues.push({
      expected: "string",
      code: "invalid_type",
      input: r.value,
      inst: e
    }), r;
  };
}), Bt = /* @__PURE__ */ ne("$ZodStringFormat", (e, t) => {
  xp.init(e, t), Mb.init(e, t);
}), tB = /* @__PURE__ */ ne("$ZodGUID", (e, t) => {
  t.pattern ?? (t.pattern = E7), Bt.init(e, t);
}), nB = /* @__PURE__ */ ne("$ZodUUID", (e, t) => {
  if (t.version) {
    const n = {
      v1: 1,
      v2: 2,
      v3: 3,
      v4: 4,
      v5: 5,
      v6: 6,
      v7: 7,
      v8: 8
    }[t.version];
    if (n === void 0)
      throw new Error(`Invalid UUID version: "${t.version}"`);
    t.pattern ?? (t.pattern = Mx(n));
  } else
    t.pattern ?? (t.pattern = Mx());
  Bt.init(e, t);
}), rB = /* @__PURE__ */ ne("$ZodEmail", (e, t) => {
  t.pattern ?? (t.pattern = S7), Bt.init(e, t);
}), iB = /* @__PURE__ */ ne("$ZodURL", (e, t) => {
  Bt.init(e, t), e._zod.check = (n) => {
    try {
      const r = n.value.trim(), i = new URL(r);
      t.hostname && (t.hostname.lastIndex = 0, t.hostname.test(i.hostname) || n.issues.push({
        code: "invalid_format",
        format: "url",
        note: "Invalid hostname",
        pattern: t.hostname.source,
        input: n.value,
        inst: e,
        continue: !t.abort
      })), t.protocol && (t.protocol.lastIndex = 0, t.protocol.test(i.protocol.endsWith(":") ? i.protocol.slice(0, -1) : i.protocol) || n.issues.push({
        code: "invalid_format",
        format: "url",
        note: "Invalid protocol",
        pattern: t.protocol.source,
        input: n.value,
        inst: e,
        continue: !t.abort
      })), t.normalize ? n.value = i.href : n.value = r;
      return;
    } catch {
      n.issues.push({
        code: "invalid_format",
        format: "url",
        input: n.value,
        inst: e,
        continue: !t.abort
      });
    }
  };
}), oB = /* @__PURE__ */ ne("$ZodEmoji", (e, t) => {
  t.pattern ?? (t.pattern = k7()), Bt.init(e, t);
}), aB = /* @__PURE__ */ ne("$ZodNanoID", (e, t) => {
  t.pattern ?? (t.pattern = w7), Bt.init(e, t);
}), sB = /* @__PURE__ */ ne("$ZodCUID", (e, t) => {
  t.pattern ?? (t.pattern = v7), Bt.init(e, t);
}), lB = /* @__PURE__ */ ne("$ZodCUID2", (e, t) => {
  t.pattern ?? (t.pattern = g7), Bt.init(e, t);
}), uB = /* @__PURE__ */ ne("$ZodULID", (e, t) => {
  t.pattern ?? (t.pattern = y7), Bt.init(e, t);
}), cB = /* @__PURE__ */ ne("$ZodXID", (e, t) => {
  t.pattern ?? (t.pattern = b7), Bt.init(e, t);
}), fB = /* @__PURE__ */ ne("$ZodKSUID", (e, t) => {
  t.pattern ?? (t.pattern = _7), Bt.init(e, t);
}), dB = /* @__PURE__ */ ne("$ZodISODateTime", (e, t) => {
  t.pattern ?? (t.pattern = R7(t)), Bt.init(e, t);
}), pB = /* @__PURE__ */ ne("$ZodISODate", (e, t) => {
  t.pattern ?? (t.pattern = I7), Bt.init(e, t);
}), hB = /* @__PURE__ */ ne("$ZodISOTime", (e, t) => {
  t.pattern ?? (t.pattern = M7(t)), Bt.init(e, t);
}), mB = /* @__PURE__ */ ne("$ZodISODuration", (e, t) => {
  t.pattern ?? (t.pattern = x7), Bt.init(e, t);
}), vB = /* @__PURE__ */ ne("$ZodIPv4", (e, t) => {
  t.pattern ?? (t.pattern = T7), Bt.init(e, t), e._zod.bag.format = "ipv4";
}), gB = /* @__PURE__ */ ne("$ZodIPv6", (e, t) => {
  t.pattern ?? (t.pattern = O7), Bt.init(e, t), e._zod.bag.format = "ipv6", e._zod.check = (n) => {
    try {
      new URL(`http://[${n.value}]`);
    } catch {
      n.issues.push({
        code: "invalid_format",
        format: "ipv6",
        input: n.value,
        inst: e,
        continue: !t.abort
      });
    }
  };
}), yB = /* @__PURE__ */ ne("$ZodCIDRv4", (e, t) => {
  t.pattern ?? (t.pattern = P7), Bt.init(e, t);
}), bB = /* @__PURE__ */ ne("$ZodCIDRv6", (e, t) => {
  t.pattern ?? (t.pattern = A7), Bt.init(e, t), e._zod.check = (n) => {
    const r = n.value.split("/");
    try {
      if (r.length !== 2)
        throw new Error();
      const [i, o] = r;
      if (!o)
        throw new Error();
      const a = Number(o);
      if (`${a}` !== o)
        throw new Error();
      if (a < 0 || a > 128)
        throw new Error();
      new URL(`http://[${i}]`);
    } catch {
      n.issues.push({
        code: "invalid_format",
        format: "cidrv6",
        input: n.value,
        inst: e,
        continue: !t.abort
      });
    }
  };
});
function k4(e) {
  if (e === "")
    return !0;
  if (e.length % 4 !== 0)
    return !1;
  try {
    return atob(e), !0;
  } catch {
    return !1;
  }
}
const _B = /* @__PURE__ */ ne("$ZodBase64", (e, t) => {
  t.pattern ?? (t.pattern = D7), Bt.init(e, t), e._zod.bag.contentEncoding = "base64", e._zod.check = (n) => {
    k4(n.value) || n.issues.push({
      code: "invalid_format",
      format: "base64",
      input: n.value,
      inst: e,
      continue: !t.abort
    });
  };
});
function wB(e) {
  if (!b4.test(e))
    return !1;
  const t = e.replace(/[-_]/g, (r) => r === "-" ? "+" : "/"), n = t.padEnd(Math.ceil(t.length / 4) * 4, "=");
  return k4(n);
}
const xB = /* @__PURE__ */ ne("$ZodBase64URL", (e, t) => {
  t.pattern ?? (t.pattern = b4), Bt.init(e, t), e._zod.bag.contentEncoding = "base64url", e._zod.check = (n) => {
    wB(n.value) || n.issues.push({
      code: "invalid_format",
      format: "base64url",
      input: n.value,
      inst: e,
      continue: !t.abort
    });
  };
}), EB = /* @__PURE__ */ ne("$ZodE164", (e, t) => {
  t.pattern ?? (t.pattern = C7), Bt.init(e, t);
});
function SB(e, t = null) {
  try {
    const n = e.split(".");
    if (n.length !== 3)
      return !1;
    const [r] = n;
    if (!r)
      return !1;
    const i = JSON.parse(atob(r));
    return !("typ" in i && i?.typ !== "JWT" || !i.alg || t && (!("alg" in i) || i.alg !== t));
  } catch {
    return !1;
  }
}
const $B = /* @__PURE__ */ ne("$ZodJWT", (e, t) => {
  Bt.init(e, t), e._zod.check = (n) => {
    SB(n.value, t.alg) || n.issues.push({
      code: "invalid_format",
      format: "jwt",
      input: n.value,
      inst: e,
      continue: !t.abort
    });
  };
}), T4 = /* @__PURE__ */ ne("$ZodNumber", (e, t) => {
  Ot.init(e, t), e._zod.pattern = e._zod.bag.pattern ?? x4, e._zod.parse = (n, r) => {
    if (t.coerce)
      try {
        n.value = Number(n.value);
      } catch {
      }
    const i = n.value;
    if (typeof i == "number" && !Number.isNaN(i) && Number.isFinite(i))
      return n;
    const o = typeof i == "number" ? Number.isNaN(i) ? "NaN" : Number.isFinite(i) ? void 0 : "Infinity" : void 0;
    return n.issues.push({
      expected: "number",
      code: "invalid_type",
      input: i,
      inst: e,
      ...o ? { received: o } : {}
    }), n;
  };
}), kB = /* @__PURE__ */ ne("$ZodNumberFormat", (e, t) => {
  B7.init(e, t), T4.init(e, t);
}), TB = /* @__PURE__ */ ne("$ZodBoolean", (e, t) => {
  Ot.init(e, t), e._zod.pattern = F7, e._zod.parse = (n, r) => {
    if (t.coerce)
      try {
        n.value = !!n.value;
      } catch {
      }
    const i = n.value;
    return typeof i == "boolean" || n.issues.push({
      expected: "boolean",
      code: "invalid_type",
      input: i,
      inst: e
    }), n;
  };
}), OB = /* @__PURE__ */ ne("$ZodAny", (e, t) => {
  Ot.init(e, t), e._zod.parse = (n) => n;
}), PB = /* @__PURE__ */ ne("$ZodUnknown", (e, t) => {
  Ot.init(e, t), e._zod.parse = (n) => n;
}), AB = /* @__PURE__ */ ne("$ZodNever", (e, t) => {
  Ot.init(e, t), e._zod.parse = (n, r) => (n.issues.push({
    expected: "never",
    code: "invalid_type",
    input: n.value,
    inst: e
  }), n);
}), DB = /* @__PURE__ */ ne("$ZodDate", (e, t) => {
  Ot.init(e, t), e._zod.parse = (n, r) => {
    if (t.coerce)
      try {
        n.value = new Date(n.value);
      } catch {
      }
    const i = n.value, o = i instanceof Date;
    return o && !Number.isNaN(i.getTime()) || n.issues.push({
      expected: "date",
      code: "invalid_type",
      input: i,
      ...o ? { received: "Invalid Date" } : {},
      inst: e
    }), n;
  };
});
function Rx(e, t, n) {
  e.issues.length && t.issues.push(...ps(n, e.issues)), t.value[n] = e.value;
}
const CB = /* @__PURE__ */ ne("$ZodArray", (e, t) => {
  Ot.init(e, t), e._zod.parse = (n, r) => {
    const i = n.value;
    if (!Array.isArray(i))
      return n.issues.push({
        expected: "array",
        code: "invalid_type",
        input: i,
        inst: e
      }), n;
    n.value = Array(i.length);
    const o = [];
    for (let a = 0; a < i.length; a++) {
      const s = i[a], l = t.element._zod.run({
        value: s,
        issues: []
      }, r);
      l instanceof Promise ? o.push(l.then((u) => Rx(u, n, a))) : Rx(l, n, a);
    }
    return o.length ? Promise.all(o).then(() => n) : n;
  };
});
function md(e, t, n, r, i) {
  if (e.issues.length) {
    if (i && !(n in r))
      return;
    t.issues.push(...ps(n, e.issues));
  }
  e.value === void 0 ? n in r && (t.value[n] = void 0) : t.value[n] = e.value;
}
function O4(e) {
  var t, n, r, i;
  const o = Object.keys(e.shape);
  for (const s of o)
    if (!((i = (r = (n = (t = e.shape) == null ? void 0 : t[s]) == null ? void 0 : n._zod) == null ? void 0 : r.traits) != null && i.has("$ZodType")))
      throw new Error(`Invalid element at key "${s}": expected a Zod schema`);
  const a = GV(e.shape);
  return {
    ...e,
    keys: o,
    keySet: new Set(o),
    numKeys: o.length,
    optionalKeys: new Set(a)
  };
}
function P4(e, t, n, r, i, o) {
  const a = [], s = i.keySet, l = i.catchall._zod, u = l.def.type, c = l.optout === "optional";
  for (const f in t) {
    if (s.has(f))
      continue;
    if (u === "never") {
      a.push(f);
      continue;
    }
    const d = l.run({ value: t[f], issues: [] }, r);
    d instanceof Promise ? e.push(d.then((p) => md(p, n, f, t, c))) : md(d, n, f, t, c);
  }
  return a.length && n.issues.push({
    code: "unrecognized_keys",
    keys: a,
    input: t,
    inst: o
  }), e.length ? Promise.all(e).then(() => n) : n;
}
const IB = /* @__PURE__ */ ne("$ZodObject", (e, t) => {
  Ot.init(e, t);
  const n = Object.getOwnPropertyDescriptor(t, "shape");
  if (!(n != null && n.get)) {
    const s = t.shape;
    Object.defineProperty(t, "shape", {
      get: () => {
        const l = { ...s };
        return Object.defineProperty(t, "shape", {
          value: l
        }), l;
      }
    });
  }
  const r = Ob(() => O4(t));
  at(e._zod, "propValues", () => {
    const s = t.shape, l = {};
    for (const u in s) {
      const c = s[u]._zod;
      if (c.values) {
        l[u] ?? (l[u] = /* @__PURE__ */ new Set());
        for (const f of c.values)
          l[u].add(f);
      }
    }
    return l;
  });
  const i = hd, o = t.catchall;
  let a;
  e._zod.parse = (s, l) => {
    a ?? (a = r.value);
    const u = s.value;
    if (!i(u))
      return s.issues.push({
        expected: "object",
        code: "invalid_type",
        input: u,
        inst: e
      }), s;
    s.value = {};
    const c = [], f = a.shape;
    for (const d of a.keys) {
      const p = f[d], h = p._zod.optout === "optional", v = p._zod.run({ value: u[d], issues: [] }, l);
      v instanceof Promise ? c.push(v.then((m) => md(m, s, d, u, h))) : md(v, s, d, u, h);
    }
    return o ? P4(c, u, s, l, r.value, e) : c.length ? Promise.all(c).then(() => s) : s;
  };
}), MB = /* @__PURE__ */ ne("$ZodObjectJIT", (e, t) => {
  IB.init(e, t);
  const n = e._zod.parse, r = Ob(() => O4(t)), i = (f) => {
    var d;
    const p = new X7(["shape", "payload", "ctx"]), h = r.value, v = (x) => {
      const w = Ix(x);
      return `shape[${w}]._zod.run({ value: input[${w}], issues: [] }, ctx)`;
    };
    p.write("const input = payload.value;");
    const m = /* @__PURE__ */ Object.create(null);
    let g = 0;
    for (const x of h.keys)
      m[x] = `key_${g++}`;
    p.write("const newResult = {};");
    for (const x of h.keys) {
      const w = m[x], $ = Ix(x), k = f[x], D = ((d = k?._zod) == null ? void 0 : d.optout) === "optional";
      p.write(`const ${w} = ${v(x)};`), D ? p.write(`
        if (${w}.issues.length) {
          if (${$} in input) {
            payload.issues = payload.issues.concat(${w}.issues.map(iss => ({
              ...iss,
              path: iss.path ? [${$}, ...iss.path] : [${$}]
            })));
          }
        }
        
        if (${w}.value === undefined) {
          if (${$} in input) {
            newResult[${$}] = undefined;
          }
        } else {
          newResult[${$}] = ${w}.value;
        }
        
      `) : p.write(`
        if (${w}.issues.length) {
          payload.issues = payload.issues.concat(${w}.issues.map(iss => ({
            ...iss,
            path: iss.path ? [${$}, ...iss.path] : [${$}]
          })));
        }
        
        if (${w}.value === undefined) {
          if (${$} in input) {
            newResult[${$}] = undefined;
          }
        } else {
          newResult[${$}] = ${w}.value;
        }
        
      `);
    }
    p.write("payload.value = newResult;"), p.write("return payload;");
    const _ = p.compile();
    return (x, w) => _(f, x, w);
  };
  let o;
  const a = hd, s = !d4.jitless, l = s && WV.value, u = t.catchall;
  let c;
  e._zod.parse = (f, d) => {
    c ?? (c = r.value);
    const p = f.value;
    return a(p) ? s && l && d?.async === !1 && d.jitless !== !0 ? (o || (o = i(t.shape)), f = o(f, d), u ? P4([], p, f, d, c, e) : f) : n(f, d) : (f.issues.push({
      expected: "object",
      code: "invalid_type",
      input: p,
      inst: e
    }), f);
  };
});
function Nx(e, t, n, r) {
  for (const o of e)
    if (o.issues.length === 0)
      return t.value = o.value, t;
  const i = e.filter((o) => !ds(o));
  return i.length === 1 ? (t.value = i[0].value, i[0]) : (t.issues.push({
    code: "invalid_union",
    input: t.value,
    inst: n,
    errors: e.map((o) => o.issues.map((a) => Po(a, r, Oo())))
  }), t);
}
const RB = /* @__PURE__ */ ne("$ZodUnion", (e, t) => {
  Ot.init(e, t), at(e._zod, "optin", () => t.options.some((i) => i._zod.optin === "optional") ? "optional" : void 0), at(e._zod, "optout", () => t.options.some((i) => i._zod.optout === "optional") ? "optional" : void 0), at(e._zod, "values", () => {
    if (t.options.every((i) => i._zod.values))
      return new Set(t.options.flatMap((i) => Array.from(i._zod.values)));
  }), at(e._zod, "pattern", () => {
    if (t.options.every((i) => i._zod.pattern)) {
      const i = t.options.map((o) => o._zod.pattern);
      return new RegExp(`^(${i.map((o) => Ab(o.source)).join("|")})$`);
    }
  });
  const n = t.options.length === 1, r = t.options[0]._zod.run;
  e._zod.parse = (i, o) => {
    if (n)
      return r(i, o);
    let a = !1;
    const s = [];
    for (const l of t.options) {
      const u = l._zod.run({
        value: i.value,
        issues: []
      }, o);
      if (u instanceof Promise)
        s.push(u), a = !0;
      else {
        if (u.issues.length === 0)
          return u;
        s.push(u);
      }
    }
    return a ? Promise.all(s).then((l) => Nx(l, i, e, o)) : Nx(s, i, e, o);
  };
}), NB = /* @__PURE__ */ ne("$ZodIntersection", (e, t) => {
  Ot.init(e, t), e._zod.parse = (n, r) => {
    const i = n.value, o = t.left._zod.run({ value: i, issues: [] }, r), a = t.right._zod.run({ value: i, issues: [] }, r);
    return o instanceof Promise || a instanceof Promise ? Promise.all([o, a]).then(([s, l]) => jx(n, s, l)) : jx(n, o, a);
  };
});
function ig(e, t) {
  if (e === t)
    return { valid: !0, data: e };
  if (e instanceof Date && t instanceof Date && +e == +t)
    return { valid: !0, data: e };
  if (js(e) && js(t)) {
    const n = Object.keys(t), r = Object.keys(e).filter((o) => n.indexOf(o) !== -1), i = { ...e, ...t };
    for (const o of r) {
      const a = ig(e[o], t[o]);
      if (!a.valid)
        return {
          valid: !1,
          mergeErrorPath: [o, ...a.mergeErrorPath]
        };
      i[o] = a.data;
    }
    return { valid: !0, data: i };
  }
  if (Array.isArray(e) && Array.isArray(t)) {
    if (e.length !== t.length)
      return { valid: !1, mergeErrorPath: [] };
    const n = [];
    for (let r = 0; r < e.length; r++) {
      const i = e[r], o = t[r], a = ig(i, o);
      if (!a.valid)
        return {
          valid: !1,
          mergeErrorPath: [r, ...a.mergeErrorPath]
        };
      n.push(a.data);
    }
    return { valid: !0, data: n };
  }
  return { valid: !1, mergeErrorPath: [] };
}
function jx(e, t, n) {
  const r = /* @__PURE__ */ new Map();
  let i;
  for (const s of t.issues)
    if (s.code === "unrecognized_keys") {
      i ?? (i = s);
      for (const l of s.keys)
        r.has(l) || r.set(l, {}), r.get(l).l = !0;
    } else
      e.issues.push(s);
  for (const s of n.issues)
    if (s.code === "unrecognized_keys")
      for (const l of s.keys)
        r.has(l) || r.set(l, {}), r.get(l).r = !0;
    else
      e.issues.push(s);
  const o = [...r].filter(([, s]) => s.l && s.r).map(([s]) => s);
  if (o.length && i && e.issues.push({ ...i, keys: o }), ds(e))
    return e;
  const a = ig(t.value, n.value);
  if (!a.valid)
    throw new Error(`Unmergable intersection. Error path: ${JSON.stringify(a.mergeErrorPath)}`);
  return e.value = a.data, e;
}
const jB = /* @__PURE__ */ ne("$ZodRecord", (e, t) => {
  Ot.init(e, t), e._zod.parse = (n, r) => {
    const i = n.value;
    if (!js(i))
      return n.issues.push({
        expected: "record",
        code: "invalid_type",
        input: i,
        inst: e
      }), n;
    const o = [], a = t.keyType._zod.values;
    if (a) {
      n.value = {};
      const s = /* @__PURE__ */ new Set();
      for (const u of a)
        if (typeof u == "string" || typeof u == "number" || typeof u == "symbol") {
          s.add(typeof u == "number" ? u.toString() : u);
          const c = t.valueType._zod.run({ value: i[u], issues: [] }, r);
          c instanceof Promise ? o.push(c.then((f) => {
            f.issues.length && n.issues.push(...ps(u, f.issues)), n.value[u] = f.value;
          })) : (c.issues.length && n.issues.push(...ps(u, c.issues)), n.value[u] = c.value);
        }
      let l;
      for (const u in i)
        s.has(u) || (l = l ?? [], l.push(u));
      l && l.length > 0 && n.issues.push({
        code: "unrecognized_keys",
        input: i,
        inst: e,
        keys: l
      });
    } else {
      n.value = {};
      for (const s of Reflect.ownKeys(i)) {
        if (s === "__proto__")
          continue;
        let l = t.keyType._zod.run({ value: s, issues: [] }, r);
        if (l instanceof Promise)
          throw new Error("Async schemas not supported in object keys currently");
        if (typeof s == "string" && x4.test(s) && l.issues.length) {
          const c = t.keyType._zod.run({ value: Number(s), issues: [] }, r);
          if (c instanceof Promise)
            throw new Error("Async schemas not supported in object keys currently");
          c.issues.length === 0 && (l = c);
        }
        if (l.issues.length) {
          t.mode === "loose" ? n.value[s] = i[s] : n.issues.push({
            code: "invalid_key",
            origin: "record",
            issues: l.issues.map((c) => Po(c, r, Oo())),
            input: s,
            path: [s],
            inst: e
          });
          continue;
        }
        const u = t.valueType._zod.run({ value: i[s], issues: [] }, r);
        u instanceof Promise ? o.push(u.then((c) => {
          c.issues.length && n.issues.push(...ps(s, c.issues)), n.value[l.value] = c.value;
        })) : (u.issues.length && n.issues.push(...ps(s, u.issues)), n.value[l.value] = u.value);
      }
    }
    return o.length ? Promise.all(o).then(() => n) : n;
  };
}), FB = /* @__PURE__ */ ne("$ZodEnum", (e, t) => {
  Ot.init(e, t);
  const n = p4(t.entries), r = new Set(n);
  e._zod.values = r, e._zod.pattern = new RegExp(`^(${n.filter((i) => ZV.has(typeof i)).map((i) => typeof i == "string" ? Fs(i) : i.toString()).join("|")})$`), e._zod.parse = (i, o) => {
    const a = i.value;
    return r.has(a) || i.issues.push({
      code: "invalid_value",
      values: n,
      input: a,
      inst: e
    }), i;
  };
}), zB = /* @__PURE__ */ ne("$ZodLiteral", (e, t) => {
  if (Ot.init(e, t), t.values.length === 0)
    throw new Error("Cannot create literal schema with no valid values");
  const n = new Set(t.values);
  e._zod.values = n, e._zod.pattern = new RegExp(`^(${t.values.map((r) => typeof r == "string" ? Fs(r) : r ? Fs(r.toString()) : String(r)).join("|")})$`), e._zod.parse = (r, i) => {
    const o = r.value;
    return n.has(o) || r.issues.push({
      code: "invalid_value",
      values: t.values,
      input: o,
      inst: e
    }), r;
  };
}), LB = /* @__PURE__ */ ne("$ZodTransform", (e, t) => {
  Ot.init(e, t), e._zod.parse = (n, r) => {
    if (r.direction === "backward")
      throw new f4(e.constructor.name);
    const i = t.transform(n.value, n);
    if (r.async)
      return (i instanceof Promise ? i : Promise.resolve(i)).then((o) => (n.value = o, n));
    if (i instanceof Promise)
      throw new $s();
    return n.value = i, n;
  };
});
function Fx(e, t) {
  return e.issues.length && t === void 0 ? { issues: [], value: void 0 } : e;
}
const A4 = /* @__PURE__ */ ne("$ZodOptional", (e, t) => {
  Ot.init(e, t), e._zod.optin = "optional", e._zod.optout = "optional", at(e._zod, "values", () => t.innerType._zod.values ? /* @__PURE__ */ new Set([...t.innerType._zod.values, void 0]) : void 0), at(e._zod, "pattern", () => {
    const n = t.innerType._zod.pattern;
    return n ? new RegExp(`^(${Ab(n.source)})?$`) : void 0;
  }), e._zod.parse = (n, r) => {
    if (t.innerType._zod.optin === "optional") {
      const i = t.innerType._zod.run(n, r);
      return i instanceof Promise ? i.then((o) => Fx(o, n.value)) : Fx(i, n.value);
    }
    return n.value === void 0 ? n : t.innerType._zod.run(n, r);
  };
}), VB = /* @__PURE__ */ ne("$ZodExactOptional", (e, t) => {
  A4.init(e, t), at(e._zod, "values", () => t.innerType._zod.values), at(e._zod, "pattern", () => t.innerType._zod.pattern), e._zod.parse = (n, r) => t.innerType._zod.run(n, r);
}), BB = /* @__PURE__ */ ne("$ZodNullable", (e, t) => {
  Ot.init(e, t), at(e._zod, "optin", () => t.innerType._zod.optin), at(e._zod, "optout", () => t.innerType._zod.optout), at(e._zod, "pattern", () => {
    const n = t.innerType._zod.pattern;
    return n ? new RegExp(`^(${Ab(n.source)}|null)$`) : void 0;
  }), at(e._zod, "values", () => t.innerType._zod.values ? /* @__PURE__ */ new Set([...t.innerType._zod.values, null]) : void 0), e._zod.parse = (n, r) => n.value === null ? n : t.innerType._zod.run(n, r);
}), KB = /* @__PURE__ */ ne("$ZodDefault", (e, t) => {
  Ot.init(e, t), e._zod.optin = "optional", at(e._zod, "values", () => t.innerType._zod.values), e._zod.parse = (n, r) => {
    if (r.direction === "backward")
      return t.innerType._zod.run(n, r);
    if (n.value === void 0)
      return n.value = t.defaultValue, n;
    const i = t.innerType._zod.run(n, r);
    return i instanceof Promise ? i.then((o) => zx(o, t)) : zx(i, t);
  };
});
function zx(e, t) {
  return e.value === void 0 && (e.value = t.defaultValue), e;
}
const UB = /* @__PURE__ */ ne("$ZodPrefault", (e, t) => {
  Ot.init(e, t), e._zod.optin = "optional", at(e._zod, "values", () => t.innerType._zod.values), e._zod.parse = (n, r) => (r.direction === "backward" || n.value === void 0 && (n.value = t.defaultValue), t.innerType._zod.run(n, r));
}), qB = /* @__PURE__ */ ne("$ZodNonOptional", (e, t) => {
  Ot.init(e, t), at(e._zod, "values", () => {
    const n = t.innerType._zod.values;
    return n ? new Set([...n].filter((r) => r !== void 0)) : void 0;
  }), e._zod.parse = (n, r) => {
    const i = t.innerType._zod.run(n, r);
    return i instanceof Promise ? i.then((o) => Lx(o, e)) : Lx(i, e);
  };
});
function Lx(e, t) {
  return !e.issues.length && e.value === void 0 && e.issues.push({
    code: "invalid_type",
    expected: "nonoptional",
    input: e.value,
    inst: t
  }), e;
}
const HB = /* @__PURE__ */ ne("$ZodCatch", (e, t) => {
  Ot.init(e, t), at(e._zod, "optin", () => t.innerType._zod.optin), at(e._zod, "optout", () => t.innerType._zod.optout), at(e._zod, "values", () => t.innerType._zod.values), e._zod.parse = (n, r) => {
    if (r.direction === "backward")
      return t.innerType._zod.run(n, r);
    const i = t.innerType._zod.run(n, r);
    return i instanceof Promise ? i.then((o) => (n.value = o.value, o.issues.length && (n.value = t.catchValue({
      ...n,
      error: {
        issues: o.issues.map((a) => Po(a, r, Oo()))
      },
      input: n.value
    }), n.issues = []), n)) : (n.value = i.value, i.issues.length && (n.value = t.catchValue({
      ...n,
      error: {
        issues: i.issues.map((o) => Po(o, r, Oo()))
      },
      input: n.value
    }), n.issues = []), n);
  };
}), WB = /* @__PURE__ */ ne("$ZodPipe", (e, t) => {
  Ot.init(e, t), at(e._zod, "values", () => t.in._zod.values), at(e._zod, "optin", () => t.in._zod.optin), at(e._zod, "optout", () => t.out._zod.optout), at(e._zod, "propValues", () => t.in._zod.propValues), e._zod.parse = (n, r) => {
    if (r.direction === "backward") {
      const o = t.out._zod.run(n, r);
      return o instanceof Promise ? o.then((a) => Uc(a, t.in, r)) : Uc(o, t.in, r);
    }
    const i = t.in._zod.run(n, r);
    return i instanceof Promise ? i.then((o) => Uc(o, t.out, r)) : Uc(i, t.out, r);
  };
});
function Uc(e, t, n) {
  return e.issues.length ? (e.aborted = !0, e) : t._zod.run({ value: e.value, issues: e.issues }, n);
}
const ZB = /* @__PURE__ */ ne("$ZodReadonly", (e, t) => {
  Ot.init(e, t), at(e._zod, "propValues", () => t.innerType._zod.propValues), at(e._zod, "values", () => t.innerType._zod.values), at(e._zod, "optin", () => {
    var n, r;
    return (r = (n = t.innerType) == null ? void 0 : n._zod) == null ? void 0 : r.optin;
  }), at(e._zod, "optout", () => {
    var n, r;
    return (r = (n = t.innerType) == null ? void 0 : n._zod) == null ? void 0 : r.optout;
  }), e._zod.parse = (n, r) => {
    if (r.direction === "backward")
      return t.innerType._zod.run(n, r);
    const i = t.innerType._zod.run(n, r);
    return i instanceof Promise ? i.then(Vx) : Vx(i);
  };
});
function Vx(e) {
  return e.value = Object.freeze(e.value), e;
}
const GB = /* @__PURE__ */ ne("$ZodLazy", (e, t) => {
  Ot.init(e, t), at(e._zod, "innerType", () => t.getter()), at(e._zod, "pattern", () => {
    var n, r;
    return (r = (n = e._zod.innerType) == null ? void 0 : n._zod) == null ? void 0 : r.pattern;
  }), at(e._zod, "propValues", () => {
    var n, r;
    return (r = (n = e._zod.innerType) == null ? void 0 : n._zod) == null ? void 0 : r.propValues;
  }), at(e._zod, "optin", () => {
    var n, r;
    return ((r = (n = e._zod.innerType) == null ? void 0 : n._zod) == null ? void 0 : r.optin) ?? void 0;
  }), at(e._zod, "optout", () => {
    var n, r;
    return ((r = (n = e._zod.innerType) == null ? void 0 : n._zod) == null ? void 0 : r.optout) ?? void 0;
  }), e._zod.parse = (n, r) => e._zod.innerType._zod.run(n, r);
}), YB = /* @__PURE__ */ ne("$ZodCustom", (e, t) => {
  sr.init(e, t), Ot.init(e, t), e._zod.parse = (n, r) => n, e._zod.check = (n) => {
    const r = n.value, i = t.fn(r);
    if (i instanceof Promise)
      return i.then((o) => Bx(o, n, r, e));
    Bx(i, n, r, e);
  };
});
function Bx(e, t, n, r) {
  if (!e) {
    const i = {
      code: "custom",
      input: n,
      inst: r,
      // incorporates params.error into issue reporting
      path: [...r._zod.def.path ?? []],
      // incorporates params.error into issue reporting
      continue: !r._zod.def.abort
      // params: inst._zod.def.params,
    };
    r._zod.def.params && (i.params = r._zod.def.params), t.issues.push(Pu(i));
  }
}
var Kx;
let QB = class {
  constructor() {
    this._map = /* @__PURE__ */ new WeakMap(), this._idmap = /* @__PURE__ */ new Map();
  }
  add(t, ...n) {
    const r = n[0];
    return this._map.set(t, r), r && typeof r == "object" && "id" in r && this._idmap.set(r.id, t), this;
  }
  clear() {
    return this._map = /* @__PURE__ */ new WeakMap(), this._idmap = /* @__PURE__ */ new Map(), this;
  }
  remove(t) {
    const n = this._map.get(t);
    return n && typeof n == "object" && "id" in n && this._idmap.delete(n.id), this._map.delete(t), this;
  }
  get(t) {
    const n = t._zod.parent;
    if (n) {
      const r = { ...this.get(n) ?? {} };
      delete r.id;
      const i = { ...r, ...this._map.get(t) };
      return Object.keys(i).length ? i : void 0;
    }
    return this._map.get(t);
  }
  has(t) {
    return this._map.has(t);
  }
};
function JB() {
  return new QB();
}
(Kx = globalThis).__zod_globalRegistry ?? (Kx.__zod_globalRegistry = JB());
const Gl = globalThis.__zod_globalRegistry;
// @__NO_SIDE_EFFECTS__
function XB(e, t) {
  return new e({
    type: "string",
    ...Ve(t)
  });
}
// @__NO_SIDE_EFFECTS__
function eK(e, t) {
  return new e({
    type: "string",
    format: "email",
    check: "string_format",
    abort: !1,
    ...Ve(t)
  });
}
// @__NO_SIDE_EFFECTS__
function Ux(e, t) {
  return new e({
    type: "string",
    format: "guid",
    check: "string_format",
    abort: !1,
    ...Ve(t)
  });
}
// @__NO_SIDE_EFFECTS__
function tK(e, t) {
  return new e({
    type: "string",
    format: "uuid",
    check: "string_format",
    abort: !1,
    ...Ve(t)
  });
}
// @__NO_SIDE_EFFECTS__
function nK(e, t) {
  return new e({
    type: "string",
    format: "uuid",
    check: "string_format",
    abort: !1,
    version: "v4",
    ...Ve(t)
  });
}
// @__NO_SIDE_EFFECTS__
function rK(e, t) {
  return new e({
    type: "string",
    format: "uuid",
    check: "string_format",
    abort: !1,
    version: "v6",
    ...Ve(t)
  });
}
// @__NO_SIDE_EFFECTS__
function iK(e, t) {
  return new e({
    type: "string",
    format: "uuid",
    check: "string_format",
    abort: !1,
    version: "v7",
    ...Ve(t)
  });
}
// @__NO_SIDE_EFFECTS__
function oK(e, t) {
  return new e({
    type: "string",
    format: "url",
    check: "string_format",
    abort: !1,
    ...Ve(t)
  });
}
// @__NO_SIDE_EFFECTS__
function aK(e, t) {
  return new e({
    type: "string",
    format: "emoji",
    check: "string_format",
    abort: !1,
    ...Ve(t)
  });
}
// @__NO_SIDE_EFFECTS__
function sK(e, t) {
  return new e({
    type: "string",
    format: "nanoid",
    check: "string_format",
    abort: !1,
    ...Ve(t)
  });
}
// @__NO_SIDE_EFFECTS__
function lK(e, t) {
  return new e({
    type: "string",
    format: "cuid",
    check: "string_format",
    abort: !1,
    ...Ve(t)
  });
}
// @__NO_SIDE_EFFECTS__
function uK(e, t) {
  return new e({
    type: "string",
    format: "cuid2",
    check: "string_format",
    abort: !1,
    ...Ve(t)
  });
}
// @__NO_SIDE_EFFECTS__
function cK(e, t) {
  return new e({
    type: "string",
    format: "ulid",
    check: "string_format",
    abort: !1,
    ...Ve(t)
  });
}
// @__NO_SIDE_EFFECTS__
function fK(e, t) {
  return new e({
    type: "string",
    format: "xid",
    check: "string_format",
    abort: !1,
    ...Ve(t)
  });
}
// @__NO_SIDE_EFFECTS__
function dK(e, t) {
  return new e({
    type: "string",
    format: "ksuid",
    check: "string_format",
    abort: !1,
    ...Ve(t)
  });
}
// @__NO_SIDE_EFFECTS__
function pK(e, t) {
  return new e({
    type: "string",
    format: "ipv4",
    check: "string_format",
    abort: !1,
    ...Ve(t)
  });
}
// @__NO_SIDE_EFFECTS__
function hK(e, t) {
  return new e({
    type: "string",
    format: "ipv6",
    check: "string_format",
    abort: !1,
    ...Ve(t)
  });
}
// @__NO_SIDE_EFFECTS__
function mK(e, t) {
  return new e({
    type: "string",
    format: "cidrv4",
    check: "string_format",
    abort: !1,
    ...Ve(t)
  });
}
// @__NO_SIDE_EFFECTS__
function vK(e, t) {
  return new e({
    type: "string",
    format: "cidrv6",
    check: "string_format",
    abort: !1,
    ...Ve(t)
  });
}
// @__NO_SIDE_EFFECTS__
function gK(e, t) {
  return new e({
    type: "string",
    format: "base64",
    check: "string_format",
    abort: !1,
    ...Ve(t)
  });
}
// @__NO_SIDE_EFFECTS__
function yK(e, t) {
  return new e({
    type: "string",
    format: "base64url",
    check: "string_format",
    abort: !1,
    ...Ve(t)
  });
}
// @__NO_SIDE_EFFECTS__
function bK(e, t) {
  return new e({
    type: "string",
    format: "e164",
    check: "string_format",
    abort: !1,
    ...Ve(t)
  });
}
// @__NO_SIDE_EFFECTS__
function _K(e, t) {
  return new e({
    type: "string",
    format: "jwt",
    check: "string_format",
    abort: !1,
    ...Ve(t)
  });
}
// @__NO_SIDE_EFFECTS__
function wK(e, t) {
  return new e({
    type: "string",
    format: "datetime",
    check: "string_format",
    offset: !1,
    local: !1,
    precision: null,
    ...Ve(t)
  });
}
// @__NO_SIDE_EFFECTS__
function xK(e, t) {
  return new e({
    type: "string",
    format: "date",
    check: "string_format",
    ...Ve(t)
  });
}
// @__NO_SIDE_EFFECTS__
function EK(e, t) {
  return new e({
    type: "string",
    format: "time",
    check: "string_format",
    precision: null,
    ...Ve(t)
  });
}
// @__NO_SIDE_EFFECTS__
function SK(e, t) {
  return new e({
    type: "string",
    format: "duration",
    check: "string_format",
    ...Ve(t)
  });
}
// @__NO_SIDE_EFFECTS__
function $K(e, t) {
  return new e({
    type: "number",
    checks: [],
    ...Ve(t)
  });
}
// @__NO_SIDE_EFFECTS__
function kK(e, t) {
  return new e({
    type: "number",
    coerce: !0,
    checks: [],
    ...Ve(t)
  });
}
// @__NO_SIDE_EFFECTS__
function TK(e, t) {
  return new e({
    type: "number",
    check: "number_format",
    abort: !1,
    format: "safeint",
    ...Ve(t)
  });
}
// @__NO_SIDE_EFFECTS__
function OK(e, t) {
  return new e({
    type: "boolean",
    ...Ve(t)
  });
}
// @__NO_SIDE_EFFECTS__
function PK(e) {
  return new e({
    type: "any"
  });
}
// @__NO_SIDE_EFFECTS__
function AK(e) {
  return new e({
    type: "unknown"
  });
}
// @__NO_SIDE_EFFECTS__
function DK(e, t) {
  return new e({
    type: "never",
    ...Ve(t)
  });
}
// @__NO_SIDE_EFFECTS__
function CK(e, t) {
  return new e({
    type: "date",
    ...Ve(t)
  });
}
// @__NO_SIDE_EFFECTS__
function qx(e, t) {
  return new S4({
    check: "less_than",
    ...Ve(t),
    value: e,
    inclusive: !1
  });
}
// @__NO_SIDE_EFFECTS__
function kf(e, t) {
  return new S4({
    check: "less_than",
    ...Ve(t),
    value: e,
    inclusive: !0
  });
}
// @__NO_SIDE_EFFECTS__
function Hx(e, t) {
  return new $4({
    check: "greater_than",
    ...Ve(t),
    value: e,
    inclusive: !1
  });
}
// @__NO_SIDE_EFFECTS__
function Tf(e, t) {
  return new $4({
    check: "greater_than",
    ...Ve(t),
    value: e,
    inclusive: !0
  });
}
// @__NO_SIDE_EFFECTS__
function Wx(e, t) {
  return new V7({
    check: "multiple_of",
    ...Ve(t),
    value: e
  });
}
// @__NO_SIDE_EFFECTS__
function D4(e, t) {
  return new K7({
    check: "max_length",
    ...Ve(t),
    maximum: e
  });
}
// @__NO_SIDE_EFFECTS__
function vd(e, t) {
  return new U7({
    check: "min_length",
    ...Ve(t),
    minimum: e
  });
}
// @__NO_SIDE_EFFECTS__
function C4(e, t) {
  return new q7({
    check: "length_equals",
    ...Ve(t),
    length: e
  });
}
// @__NO_SIDE_EFFECTS__
function IK(e, t) {
  return new H7({
    check: "string_format",
    format: "regex",
    ...Ve(t),
    pattern: e
  });
}
// @__NO_SIDE_EFFECTS__
function MK(e) {
  return new W7({
    check: "string_format",
    format: "lowercase",
    ...Ve(e)
  });
}
// @__NO_SIDE_EFFECTS__
function RK(e) {
  return new Z7({
    check: "string_format",
    format: "uppercase",
    ...Ve(e)
  });
}
// @__NO_SIDE_EFFECTS__
function NK(e, t) {
  return new G7({
    check: "string_format",
    format: "includes",
    ...Ve(t),
    includes: e
  });
}
// @__NO_SIDE_EFFECTS__
function jK(e, t) {
  return new Y7({
    check: "string_format",
    format: "starts_with",
    ...Ve(t),
    prefix: e
  });
}
// @__NO_SIDE_EFFECTS__
function FK(e, t) {
  return new Q7({
    check: "string_format",
    format: "ends_with",
    ...Ve(t),
    suffix: e
  });
}
// @__NO_SIDE_EFFECTS__
function cl(e) {
  return new J7({
    check: "overwrite",
    tx: e
  });
}
// @__NO_SIDE_EFFECTS__
function zK(e) {
  return /* @__PURE__ */ cl((t) => t.normalize(e));
}
// @__NO_SIDE_EFFECTS__
function LK() {
  return /* @__PURE__ */ cl((e) => e.trim());
}
// @__NO_SIDE_EFFECTS__
function VK() {
  return /* @__PURE__ */ cl((e) => e.toLowerCase());
}
// @__NO_SIDE_EFFECTS__
function BK() {
  return /* @__PURE__ */ cl((e) => e.toUpperCase());
}
// @__NO_SIDE_EFFECTS__
function KK() {
  return /* @__PURE__ */ cl((e) => HV(e));
}
// @__NO_SIDE_EFFECTS__
function UK(e, t, n) {
  return new e({
    type: "array",
    element: t,
    // get element() {
    //   return element;
    // },
    ...Ve(n)
  });
}
// @__NO_SIDE_EFFECTS__
function qK(e, t, n) {
  return new e({
    type: "custom",
    check: "custom",
    fn: t,
    ...Ve(n)
  });
}
// @__NO_SIDE_EFFECTS__
function HK(e) {
  const t = /* @__PURE__ */ WK((n) => (n.addIssue = (r) => {
    if (typeof r == "string")
      n.issues.push(Pu(r, n.value, t._zod.def));
    else {
      const i = r;
      i.fatal && (i.continue = !1), i.code ?? (i.code = "custom"), i.input ?? (i.input = n.value), i.inst ?? (i.inst = t), i.continue ?? (i.continue = !t._zod.def.abort), n.issues.push(Pu(i));
    }
  }, e(n.value, n)));
  return t;
}
// @__NO_SIDE_EFFECTS__
function WK(e, t) {
  const n = new sr({
    check: "custom",
    ...Ve(t)
  });
  return n._zod.check = e, n;
}
function I4(e) {
  let t = e?.target ?? "draft-2020-12";
  return t === "draft-4" && (t = "draft-04"), t === "draft-7" && (t = "draft-07"), {
    processors: e.processors ?? {},
    metadataRegistry: e?.metadata ?? Gl,
    target: t,
    unrepresentable: e?.unrepresentable ?? "throw",
    override: e?.override ?? (() => {
    }),
    io: e?.io ?? "output",
    counter: 0,
    seen: /* @__PURE__ */ new Map(),
    cycles: e?.cycles ?? "ref",
    reused: e?.reused ?? "inline",
    external: e?.external ?? void 0
  };
}
function nn(e, t, n = { path: [], schemaPath: [] }) {
  var r, i, o;
  const a = e._zod.def, s = t.seen.get(e);
  if (s)
    return s.count++, n.schemaPath.includes(e) && (s.cycle = n.path), s.schema;
  const l = { schema: {}, count: 1, cycle: void 0, path: n.path };
  t.seen.set(e, l);
  const u = (i = (r = e._zod).toJSONSchema) == null ? void 0 : i.call(r);
  if (u)
    l.schema = u;
  else {
    const f = {
      ...n,
      schemaPath: [...n.schemaPath, e],
      path: n.path
    };
    if (e._zod.processJSONSchema)
      e._zod.processJSONSchema(t, l.schema, f);
    else {
      const p = l.schema, h = t.processors[a.type];
      if (!h)
        throw new Error(`[toJSONSchema]: Non-representable type encountered: ${a.type}`);
      h(e, t, p, f);
    }
    const d = e._zod.parent;
    d && (l.ref || (l.ref = d), nn(d, t, f), t.seen.get(d).isParent = !0);
  }
  const c = t.metadataRegistry.get(e);
  return c && Object.assign(l.schema, c), t.io === "input" && zn(e) && (delete l.schema.examples, delete l.schema.default), t.io === "input" && l.schema._prefault && ((o = l.schema).default ?? (o.default = l.schema._prefault)), delete l.schema._prefault, t.seen.get(e).schema;
}
function M4(e, t) {
  var n, r, i, o;
  const a = e.seen.get(t);
  if (!a)
    throw new Error("Unprocessed schema. This is a bug in Zod.");
  const s = /* @__PURE__ */ new Map();
  for (const c of e.seen.entries()) {
    const f = (n = e.metadataRegistry.get(c[0])) == null ? void 0 : n.id;
    if (f) {
      const d = s.get(f);
      if (d && d !== c[0])
        throw new Error(`Duplicate schema id "${f}" detected during JSON Schema conversion. Two different schemas cannot share the same id when converted together.`);
      s.set(f, c[0]);
    }
  }
  const l = (c) => {
    var f;
    const d = e.target === "draft-2020-12" ? "$defs" : "definitions";
    if (e.external) {
      const v = (f = e.external.registry.get(c[0])) == null ? void 0 : f.id, m = e.external.uri ?? ((_) => _);
      if (v)
        return { ref: m(v) };
      const g = c[1].defId ?? c[1].schema.id ?? `schema${e.counter++}`;
      return c[1].defId = g, { defId: g, ref: `${m("__shared")}#/${d}/${g}` };
    }
    if (c[1] === a)
      return { ref: "#" };
    const p = `#/${d}/`, h = c[1].schema.id ?? `__schema${e.counter++}`;
    return { defId: h, ref: p + h };
  }, u = (c) => {
    if (c[1].schema.$ref)
      return;
    const f = c[1], { ref: d, defId: p } = l(c);
    f.def = { ...f.schema }, p && (f.defId = p);
    const h = f.schema;
    for (const v in h)
      delete h[v];
    h.$ref = d;
  };
  if (e.cycles === "throw")
    for (const c of e.seen.entries()) {
      const f = c[1];
      if (f.cycle)
        throw new Error(`Cycle detected: #/${(r = f.cycle) == null ? void 0 : r.join("/")}/<root>

Set the \`cycles\` parameter to \`"ref"\` to resolve cyclical schemas with defs.`);
    }
  for (const c of e.seen.entries()) {
    const f = c[1];
    if (t === c[0]) {
      u(c);
      continue;
    }
    if (e.external) {
      const d = (i = e.external.registry.get(c[0])) == null ? void 0 : i.id;
      if (t !== c[0] && d) {
        u(c);
        continue;
      }
    }
    if ((o = e.metadataRegistry.get(c[0])) != null && o.id) {
      u(c);
      continue;
    }
    if (f.cycle) {
      u(c);
      continue;
    }
    if (f.count > 1 && e.reused === "ref") {
      u(c);
      continue;
    }
  }
}
function R4(e, t) {
  var n, r, i;
  const o = e.seen.get(t);
  if (!o)
    throw new Error("Unprocessed schema. This is a bug in Zod.");
  const a = (u) => {
    const c = e.seen.get(u);
    if (c.ref === null)
      return;
    const f = c.def ?? c.schema, d = { ...f }, p = c.ref;
    if (c.ref = null, p) {
      a(p);
      const v = e.seen.get(p), m = v.schema;
      if (m.$ref && (e.target === "draft-07" || e.target === "draft-04" || e.target === "openapi-3.0") ? (f.allOf = f.allOf ?? [], f.allOf.push(m)) : Object.assign(f, m), Object.assign(f, d), u._zod.parent === p)
        for (const g in f)
          g === "$ref" || g === "allOf" || g in d || delete f[g];
      if (m.$ref && v.def)
        for (const g in f)
          g === "$ref" || g === "allOf" || g in v.def && JSON.stringify(f[g]) === JSON.stringify(v.def[g]) && delete f[g];
    }
    const h = u._zod.parent;
    if (h && h !== p) {
      a(h);
      const v = e.seen.get(h);
      if (v != null && v.schema.$ref && (f.$ref = v.schema.$ref, v.def))
        for (const m in f)
          m === "$ref" || m === "allOf" || m in v.def && JSON.stringify(f[m]) === JSON.stringify(v.def[m]) && delete f[m];
    }
    e.override({
      zodSchema: u,
      jsonSchema: f,
      path: c.path ?? []
    });
  };
  for (const u of [...e.seen.entries()].reverse())
    a(u[0]);
  const s = {};
  if (e.target === "draft-2020-12" ? s.$schema = "https://json-schema.org/draft/2020-12/schema" : e.target === "draft-07" ? s.$schema = "http://json-schema.org/draft-07/schema#" : e.target === "draft-04" ? s.$schema = "http://json-schema.org/draft-04/schema#" : e.target, (n = e.external) != null && n.uri) {
    const u = (r = e.external.registry.get(t)) == null ? void 0 : r.id;
    if (!u)
      throw new Error("Schema is missing an `id` property");
    s.$id = e.external.uri(u);
  }
  Object.assign(s, o.def ?? o.schema);
  const l = ((i = e.external) == null ? void 0 : i.defs) ?? {};
  for (const u of e.seen.entries()) {
    const c = u[1];
    c.def && c.defId && (l[c.defId] = c.def);
  }
  e.external || Object.keys(l).length > 0 && (e.target === "draft-2020-12" ? s.$defs = l : s.definitions = l);
  try {
    const u = JSON.parse(JSON.stringify(s));
    return Object.defineProperty(u, "~standard", {
      value: {
        ...t["~standard"],
        jsonSchema: {
          input: gd(t, "input", e.processors),
          output: gd(t, "output", e.processors)
        }
      },
      enumerable: !1,
      writable: !1
    }), u;
  } catch {
    throw new Error("Error converting schema to JSON.");
  }
}
function zn(e, t) {
  const n = t ?? { seen: /* @__PURE__ */ new Set() };
  if (n.seen.has(e))
    return !1;
  n.seen.add(e);
  const r = e._zod.def;
  if (r.type === "transform")
    return !0;
  if (r.type === "array")
    return zn(r.element, n);
  if (r.type === "set")
    return zn(r.valueType, n);
  if (r.type === "lazy")
    return zn(r.getter(), n);
  if (r.type === "promise" || r.type === "optional" || r.type === "nonoptional" || r.type === "nullable" || r.type === "readonly" || r.type === "default" || r.type === "prefault")
    return zn(r.innerType, n);
  if (r.type === "intersection")
    return zn(r.left, n) || zn(r.right, n);
  if (r.type === "record" || r.type === "map")
    return zn(r.keyType, n) || zn(r.valueType, n);
  if (r.type === "pipe")
    return zn(r.in, n) || zn(r.out, n);
  if (r.type === "object") {
    for (const i in r.shape)
      if (zn(r.shape[i], n))
        return !0;
    return !1;
  }
  if (r.type === "union") {
    for (const i of r.options)
      if (zn(i, n))
        return !0;
    return !1;
  }
  if (r.type === "tuple") {
    for (const i of r.items)
      if (zn(i, n))
        return !0;
    return !!(r.rest && zn(r.rest, n));
  }
  return !1;
}
const ZK = (e, t = {}) => (n) => {
  const r = I4({ ...n, processors: t });
  return nn(e, r), M4(r, e), R4(r, e);
}, gd = (e, t, n = {}) => (r) => {
  const { libraryOptions: i, target: o } = r ?? {}, a = I4({ ...i ?? {}, target: o, io: t, processors: n });
  return nn(e, a), M4(a, e), R4(a, e);
}, GK = {
  guid: "uuid",
  url: "uri",
  datetime: "date-time",
  json_string: "json-string",
  regex: ""
  // do not set
}, YK = (e, t, n, r) => {
  const i = n;
  i.type = "string";
  const { minimum: o, maximum: a, format: s, patterns: l, contentEncoding: u } = e._zod.bag;
  if (typeof o == "number" && (i.minLength = o), typeof a == "number" && (i.maxLength = a), s && (i.format = GK[s] ?? s, i.format === "" && delete i.format, s === "time" && delete i.format), u && (i.contentEncoding = u), l && l.size > 0) {
    const c = [...l];
    c.length === 1 ? i.pattern = c[0].source : c.length > 1 && (i.allOf = [
      ...c.map((f) => ({
        ...t.target === "draft-07" || t.target === "draft-04" || t.target === "openapi-3.0" ? { type: "string" } : {},
        pattern: f.source
      }))
    ]);
  }
}, QK = (e, t, n, r) => {
  const i = n, { minimum: o, maximum: a, format: s, multipleOf: l, exclusiveMaximum: u, exclusiveMinimum: c } = e._zod.bag;
  typeof s == "string" && s.includes("int") ? i.type = "integer" : i.type = "number", typeof c == "number" && (t.target === "draft-04" || t.target === "openapi-3.0" ? (i.minimum = c, i.exclusiveMinimum = !0) : i.exclusiveMinimum = c), typeof o == "number" && (i.minimum = o, typeof c == "number" && t.target !== "draft-04" && (c >= o ? delete i.minimum : delete i.exclusiveMinimum)), typeof u == "number" && (t.target === "draft-04" || t.target === "openapi-3.0" ? (i.maximum = u, i.exclusiveMaximum = !0) : i.exclusiveMaximum = u), typeof a == "number" && (i.maximum = a, typeof u == "number" && t.target !== "draft-04" && (u <= a ? delete i.maximum : delete i.exclusiveMaximum)), typeof l == "number" && (i.multipleOf = l);
}, JK = (e, t, n, r) => {
  n.type = "boolean";
}, XK = (e, t, n, r) => {
  n.not = {};
}, eU = (e, t, n, r) => {
}, tU = (e, t, n, r) => {
}, nU = (e, t, n, r) => {
  if (t.unrepresentable === "throw")
    throw new Error("Date cannot be represented in JSON Schema");
}, rU = (e, t, n, r) => {
  const i = e._zod.def, o = p4(i.entries);
  o.every((a) => typeof a == "number") && (n.type = "number"), o.every((a) => typeof a == "string") && (n.type = "string"), n.enum = o;
}, iU = (e, t, n, r) => {
  const i = e._zod.def, o = [];
  for (const a of i.values)
    if (a === void 0) {
      if (t.unrepresentable === "throw")
        throw new Error("Literal `undefined` cannot be represented in JSON Schema");
    } else if (typeof a == "bigint") {
      if (t.unrepresentable === "throw")
        throw new Error("BigInt literals cannot be represented in JSON Schema");
      o.push(Number(a));
    } else
      o.push(a);
  if (o.length !== 0) if (o.length === 1) {
    const a = o[0];
    n.type = a === null ? "null" : typeof a, t.target === "draft-04" || t.target === "openapi-3.0" ? n.enum = [a] : n.const = a;
  } else
    o.every((a) => typeof a == "number") && (n.type = "number"), o.every((a) => typeof a == "string") && (n.type = "string"), o.every((a) => typeof a == "boolean") && (n.type = "boolean"), o.every((a) => a === null) && (n.type = "null"), n.enum = o;
}, oU = (e, t, n, r) => {
  if (t.unrepresentable === "throw")
    throw new Error("Custom types cannot be represented in JSON Schema");
}, aU = (e, t, n, r) => {
  if (t.unrepresentable === "throw")
    throw new Error("Transforms cannot be represented in JSON Schema");
}, sU = (e, t, n, r) => {
  const i = n, o = e._zod.def, { minimum: a, maximum: s } = e._zod.bag;
  typeof a == "number" && (i.minItems = a), typeof s == "number" && (i.maxItems = s), i.type = "array", i.items = nn(o.element, t, { ...r, path: [...r.path, "items"] });
}, lU = (e, t, n, r) => {
  var i;
  const o = n, a = e._zod.def;
  o.type = "object", o.properties = {};
  const s = a.shape;
  for (const c in s)
    o.properties[c] = nn(s[c], t, {
      ...r,
      path: [...r.path, "properties", c]
    });
  const l = new Set(Object.keys(s)), u = new Set([...l].filter((c) => {
    const f = a.shape[c]._zod;
    return t.io === "input" ? f.optin === void 0 : f.optout === void 0;
  }));
  u.size > 0 && (o.required = Array.from(u)), ((i = a.catchall) == null ? void 0 : i._zod.def.type) === "never" ? o.additionalProperties = !1 : a.catchall ? a.catchall && (o.additionalProperties = nn(a.catchall, t, {
    ...r,
    path: [...r.path, "additionalProperties"]
  })) : t.io === "output" && (o.additionalProperties = !1);
}, uU = (e, t, n, r) => {
  const i = e._zod.def, o = i.inclusive === !1, a = i.options.map((s, l) => nn(s, t, {
    ...r,
    path: [...r.path, o ? "oneOf" : "anyOf", l]
  }));
  o ? n.oneOf = a : n.anyOf = a;
}, cU = (e, t, n, r) => {
  const i = e._zod.def, o = nn(i.left, t, {
    ...r,
    path: [...r.path, "allOf", 0]
  }), a = nn(i.right, t, {
    ...r,
    path: [...r.path, "allOf", 1]
  }), s = (u) => "allOf" in u && Object.keys(u).length === 1, l = [
    ...s(o) ? o.allOf : [o],
    ...s(a) ? a.allOf : [a]
  ];
  n.allOf = l;
}, fU = (e, t, n, r) => {
  const i = n, o = e._zod.def;
  i.type = "object";
  const a = o.keyType, s = a._zod.bag, l = s?.patterns;
  if (o.mode === "loose" && l && l.size > 0) {
    const c = nn(o.valueType, t, {
      ...r,
      path: [...r.path, "patternProperties", "*"]
    });
    i.patternProperties = {};
    for (const f of l)
      i.patternProperties[f.source] = c;
  } else
    (t.target === "draft-07" || t.target === "draft-2020-12") && (i.propertyNames = nn(o.keyType, t, {
      ...r,
      path: [...r.path, "propertyNames"]
    })), i.additionalProperties = nn(o.valueType, t, {
      ...r,
      path: [...r.path, "additionalProperties"]
    });
  const u = a._zod.values;
  if (u) {
    const c = [...u].filter((f) => typeof f == "string" || typeof f == "number");
    c.length > 0 && (i.required = c);
  }
}, dU = (e, t, n, r) => {
  const i = e._zod.def, o = nn(i.innerType, t, r), a = t.seen.get(e);
  t.target === "openapi-3.0" ? (a.ref = i.innerType, n.nullable = !0) : n.anyOf = [o, { type: "null" }];
}, pU = (e, t, n, r) => {
  const i = e._zod.def;
  nn(i.innerType, t, r);
  const o = t.seen.get(e);
  o.ref = i.innerType;
}, hU = (e, t, n, r) => {
  const i = e._zod.def;
  nn(i.innerType, t, r);
  const o = t.seen.get(e);
  o.ref = i.innerType, n.default = JSON.parse(JSON.stringify(i.defaultValue));
}, mU = (e, t, n, r) => {
  const i = e._zod.def;
  nn(i.innerType, t, r);
  const o = t.seen.get(e);
  o.ref = i.innerType, t.io === "input" && (n._prefault = JSON.parse(JSON.stringify(i.defaultValue)));
}, vU = (e, t, n, r) => {
  const i = e._zod.def;
  nn(i.innerType, t, r);
  const o = t.seen.get(e);
  o.ref = i.innerType;
  let a;
  try {
    a = i.catchValue(void 0);
  } catch {
    throw new Error("Dynamic catch values are not supported in JSON Schema");
  }
  n.default = a;
}, gU = (e, t, n, r) => {
  const i = e._zod.def, o = t.io === "input" ? i.in._zod.def.type === "transform" ? i.out : i.in : i.out;
  nn(o, t, r);
  const a = t.seen.get(e);
  a.ref = o;
}, yU = (e, t, n, r) => {
  const i = e._zod.def;
  nn(i.innerType, t, r);
  const o = t.seen.get(e);
  o.ref = i.innerType, n.readOnly = !0;
}, N4 = (e, t, n, r) => {
  const i = e._zod.def;
  nn(i.innerType, t, r);
  const o = t.seen.get(e);
  o.ref = i.innerType;
}, bU = (e, t, n, r) => {
  const i = e._zod.innerType;
  nn(i, t, r);
  const o = t.seen.get(e);
  o.ref = i;
}, _U = /* @__PURE__ */ ne("ZodISODateTime", (e, t) => {
  dB.init(e, t), Gt.init(e, t);
});
function wU(e) {
  return /* @__PURE__ */ wK(_U, e);
}
const xU = /* @__PURE__ */ ne("ZodISODate", (e, t) => {
  pB.init(e, t), Gt.init(e, t);
});
function EU(e) {
  return /* @__PURE__ */ xK(xU, e);
}
const SU = /* @__PURE__ */ ne("ZodISOTime", (e, t) => {
  hB.init(e, t), Gt.init(e, t);
});
function $U(e) {
  return /* @__PURE__ */ EK(SU, e);
}
const kU = /* @__PURE__ */ ne("ZodISODuration", (e, t) => {
  mB.init(e, t), Gt.init(e, t);
});
function TU(e) {
  return /* @__PURE__ */ SK(kU, e);
}
const OU = (e, t) => {
  g4.init(e, t), e.name = "ZodError", Object.defineProperties(e, {
    format: {
      value: (n) => o7(e, n)
      // enumerable: false,
    },
    flatten: {
      value: (n) => i7(e, n)
      // enumerable: false,
    },
    addIssue: {
      value: (n) => {
        e.issues.push(n), e.message = JSON.stringify(e.issues, rg, 2);
      }
      // enumerable: false,
    },
    addIssues: {
      value: (n) => {
        e.issues.push(...n), e.message = JSON.stringify(e.issues, rg, 2);
      }
      // enumerable: false,
    },
    isEmpty: {
      get() {
        return e.issues.length === 0;
      }
      // enumerable: false,
    }
  });
}, Br = ne("ZodError", OU, {
  Parent: Error
}), PU = /* @__PURE__ */ Cb(Br), AU = /* @__PURE__ */ Ib(Br), DU = /* @__PURE__ */ _p(Br), CU = /* @__PURE__ */ wp(Br), IU = /* @__PURE__ */ l7(Br), MU = /* @__PURE__ */ u7(Br), RU = /* @__PURE__ */ c7(Br), NU = /* @__PURE__ */ f7(Br), jU = /* @__PURE__ */ d7(Br), FU = /* @__PURE__ */ p7(Br), zU = /* @__PURE__ */ h7(Br), LU = /* @__PURE__ */ m7(Br), Pt = /* @__PURE__ */ ne("ZodType", (e, t) => (Ot.init(e, t), Object.assign(e["~standard"], {
  jsonSchema: {
    input: gd(e, "input"),
    output: gd(e, "output")
  }
}), e.toJSONSchema = ZK(e, {}), e.def = t, e.type = t.type, Object.defineProperty(e, "_def", { value: t }), e.check = (...n) => e.clone(zo(t, {
  checks: [
    ...t.checks ?? [],
    ...n.map((r) => typeof r == "function" ? { _zod: { check: r, def: { check: "custom" }, onattach: [] } } : r)
  ]
}), {
  parent: !0
}), e.with = e.check, e.clone = (n, r) => Lo(e, n, r), e.brand = () => e, e.register = ((n, r) => (n.add(e, r), e)), e.parse = (n, r) => PU(e, n, r, { callee: e.parse }), e.safeParse = (n, r) => DU(e, n, r), e.parseAsync = async (n, r) => AU(e, n, r, { callee: e.parseAsync }), e.safeParseAsync = async (n, r) => CU(e, n, r), e.spa = e.safeParseAsync, e.encode = (n, r) => IU(e, n, r), e.decode = (n, r) => MU(e, n, r), e.encodeAsync = async (n, r) => RU(e, n, r), e.decodeAsync = async (n, r) => NU(e, n, r), e.safeEncode = (n, r) => jU(e, n, r), e.safeDecode = (n, r) => FU(e, n, r), e.safeEncodeAsync = async (n, r) => zU(e, n, r), e.safeDecodeAsync = async (n, r) => LU(e, n, r), e.refine = (n, r) => e.check(Lq(n, r)), e.superRefine = (n) => e.check(Vq(n)), e.overwrite = (n) => e.check(/* @__PURE__ */ cl(n)), e.optional = () => Qx(e), e.exactOptional = () => kq(e), e.nullable = () => Jx(e), e.nullish = () => Qx(Jx(e)), e.nonoptional = (n) => Cq(e, n), e.array = () => mn(e), e.or = (n) => no([e, n]), e.and = (n) => yq(e, n), e.transform = (n) => Xx(e, Sq(n)), e.default = (n) => Pq(e, n), e.prefault = (n) => Dq(e, n), e.catch = (n) => Mq(e, n), e.pipe = (n) => Xx(e, n), e.readonly = () => jq(e), e.describe = (n) => {
  const r = e.clone();
  return Gl.add(r, { description: n }), r;
}, Object.defineProperty(e, "description", {
  get() {
    var n;
    return (n = Gl.get(e)) == null ? void 0 : n.description;
  },
  configurable: !0
}), e.meta = (...n) => {
  if (n.length === 0)
    return Gl.get(e);
  const r = e.clone();
  return Gl.add(r, n[0]), r;
}, e.isOptional = () => e.safeParse(void 0).success, e.isNullable = () => e.safeParse(null).success, e.apply = (n) => n(e), e)), j4 = /* @__PURE__ */ ne("_ZodString", (e, t) => {
  Mb.init(e, t), Pt.init(e, t), e._zod.processJSONSchema = (r, i, o) => YK(e, r, i);
  const n = e._zod.bag;
  e.format = n.format ?? null, e.minLength = n.minimum ?? null, e.maxLength = n.maximum ?? null, e.regex = (...r) => e.check(/* @__PURE__ */ IK(...r)), e.includes = (...r) => e.check(/* @__PURE__ */ NK(...r)), e.startsWith = (...r) => e.check(/* @__PURE__ */ jK(...r)), e.endsWith = (...r) => e.check(/* @__PURE__ */ FK(...r)), e.min = (...r) => e.check(/* @__PURE__ */ vd(...r)), e.max = (...r) => e.check(/* @__PURE__ */ D4(...r)), e.length = (...r) => e.check(/* @__PURE__ */ C4(...r)), e.nonempty = (...r) => e.check(/* @__PURE__ */ vd(1, ...r)), e.lowercase = (r) => e.check(/* @__PURE__ */ MK(r)), e.uppercase = (r) => e.check(/* @__PURE__ */ RK(r)), e.trim = () => e.check(/* @__PURE__ */ LK()), e.normalize = (...r) => e.check(/* @__PURE__ */ zK(...r)), e.toLowerCase = () => e.check(/* @__PURE__ */ VK()), e.toUpperCase = () => e.check(/* @__PURE__ */ BK()), e.slugify = () => e.check(/* @__PURE__ */ KK());
}), VU = /* @__PURE__ */ ne("ZodString", (e, t) => {
  Mb.init(e, t), j4.init(e, t), e.email = (n) => e.check(/* @__PURE__ */ eK(BU, n)), e.url = (n) => e.check(/* @__PURE__ */ oK(KU, n)), e.jwt = (n) => e.check(/* @__PURE__ */ _K(iq, n)), e.emoji = (n) => e.check(/* @__PURE__ */ aK(UU, n)), e.guid = (n) => e.check(/* @__PURE__ */ Ux(Zx, n)), e.uuid = (n) => e.check(/* @__PURE__ */ tK(qc, n)), e.uuidv4 = (n) => e.check(/* @__PURE__ */ nK(qc, n)), e.uuidv6 = (n) => e.check(/* @__PURE__ */ rK(qc, n)), e.uuidv7 = (n) => e.check(/* @__PURE__ */ iK(qc, n)), e.nanoid = (n) => e.check(/* @__PURE__ */ sK(qU, n)), e.guid = (n) => e.check(/* @__PURE__ */ Ux(Zx, n)), e.cuid = (n) => e.check(/* @__PURE__ */ lK(HU, n)), e.cuid2 = (n) => e.check(/* @__PURE__ */ uK(WU, n)), e.ulid = (n) => e.check(/* @__PURE__ */ cK(ZU, n)), e.base64 = (n) => e.check(/* @__PURE__ */ gK(tq, n)), e.base64url = (n) => e.check(/* @__PURE__ */ yK(nq, n)), e.xid = (n) => e.check(/* @__PURE__ */ fK(GU, n)), e.ksuid = (n) => e.check(/* @__PURE__ */ dK(YU, n)), e.ipv4 = (n) => e.check(/* @__PURE__ */ pK(QU, n)), e.ipv6 = (n) => e.check(/* @__PURE__ */ hK(JU, n)), e.cidrv4 = (n) => e.check(/* @__PURE__ */ mK(XU, n)), e.cidrv6 = (n) => e.check(/* @__PURE__ */ vK(eq, n)), e.e164 = (n) => e.check(/* @__PURE__ */ bK(rq, n)), e.datetime = (n) => e.check(wU(n)), e.date = (n) => e.check(EU(n)), e.time = (n) => e.check($U(n)), e.duration = (n) => e.check(TU(n));
});
function we(e) {
  return /* @__PURE__ */ XB(VU, e);
}
const Gt = /* @__PURE__ */ ne("ZodStringFormat", (e, t) => {
  Bt.init(e, t), j4.init(e, t);
}), BU = /* @__PURE__ */ ne("ZodEmail", (e, t) => {
  rB.init(e, t), Gt.init(e, t);
}), Zx = /* @__PURE__ */ ne("ZodGUID", (e, t) => {
  tB.init(e, t), Gt.init(e, t);
}), qc = /* @__PURE__ */ ne("ZodUUID", (e, t) => {
  nB.init(e, t), Gt.init(e, t);
}), KU = /* @__PURE__ */ ne("ZodURL", (e, t) => {
  iB.init(e, t), Gt.init(e, t);
}), UU = /* @__PURE__ */ ne("ZodEmoji", (e, t) => {
  oB.init(e, t), Gt.init(e, t);
}), qU = /* @__PURE__ */ ne("ZodNanoID", (e, t) => {
  aB.init(e, t), Gt.init(e, t);
}), HU = /* @__PURE__ */ ne("ZodCUID", (e, t) => {
  sB.init(e, t), Gt.init(e, t);
}), WU = /* @__PURE__ */ ne("ZodCUID2", (e, t) => {
  lB.init(e, t), Gt.init(e, t);
}), ZU = /* @__PURE__ */ ne("ZodULID", (e, t) => {
  uB.init(e, t), Gt.init(e, t);
}), GU = /* @__PURE__ */ ne("ZodXID", (e, t) => {
  cB.init(e, t), Gt.init(e, t);
}), YU = /* @__PURE__ */ ne("ZodKSUID", (e, t) => {
  fB.init(e, t), Gt.init(e, t);
}), QU = /* @__PURE__ */ ne("ZodIPv4", (e, t) => {
  vB.init(e, t), Gt.init(e, t);
}), JU = /* @__PURE__ */ ne("ZodIPv6", (e, t) => {
  gB.init(e, t), Gt.init(e, t);
}), XU = /* @__PURE__ */ ne("ZodCIDRv4", (e, t) => {
  yB.init(e, t), Gt.init(e, t);
}), eq = /* @__PURE__ */ ne("ZodCIDRv6", (e, t) => {
  bB.init(e, t), Gt.init(e, t);
}), tq = /* @__PURE__ */ ne("ZodBase64", (e, t) => {
  _B.init(e, t), Gt.init(e, t);
}), nq = /* @__PURE__ */ ne("ZodBase64URL", (e, t) => {
  xB.init(e, t), Gt.init(e, t);
}), rq = /* @__PURE__ */ ne("ZodE164", (e, t) => {
  EB.init(e, t), Gt.init(e, t);
}), iq = /* @__PURE__ */ ne("ZodJWT", (e, t) => {
  $B.init(e, t), Gt.init(e, t);
}), Rb = /* @__PURE__ */ ne("ZodNumber", (e, t) => {
  T4.init(e, t), Pt.init(e, t), e._zod.processJSONSchema = (r, i, o) => QK(e, r, i), e.gt = (r, i) => e.check(/* @__PURE__ */ Hx(r, i)), e.gte = (r, i) => e.check(/* @__PURE__ */ Tf(r, i)), e.min = (r, i) => e.check(/* @__PURE__ */ Tf(r, i)), e.lt = (r, i) => e.check(/* @__PURE__ */ qx(r, i)), e.lte = (r, i) => e.check(/* @__PURE__ */ kf(r, i)), e.max = (r, i) => e.check(/* @__PURE__ */ kf(r, i)), e.int = (r) => e.check(Gx(r)), e.safe = (r) => e.check(Gx(r)), e.positive = (r) => e.check(/* @__PURE__ */ Hx(0, r)), e.nonnegative = (r) => e.check(/* @__PURE__ */ Tf(0, r)), e.negative = (r) => e.check(/* @__PURE__ */ qx(0, r)), e.nonpositive = (r) => e.check(/* @__PURE__ */ kf(0, r)), e.multipleOf = (r, i) => e.check(/* @__PURE__ */ Wx(r, i)), e.step = (r, i) => e.check(/* @__PURE__ */ Wx(r, i)), e.finite = () => e;
  const n = e._zod.bag;
  e.minValue = Math.max(n.minimum ?? Number.NEGATIVE_INFINITY, n.exclusiveMinimum ?? Number.NEGATIVE_INFINITY) ?? null, e.maxValue = Math.min(n.maximum ?? Number.POSITIVE_INFINITY, n.exclusiveMaximum ?? Number.POSITIVE_INFINITY) ?? null, e.isInt = (n.format ?? "").includes("int") || Number.isSafeInteger(n.multipleOf ?? 0.5), e.isFinite = !0, e.format = n.format ?? null;
});
function hr(e) {
  return /* @__PURE__ */ $K(Rb, e);
}
const oq = /* @__PURE__ */ ne("ZodNumberFormat", (e, t) => {
  kB.init(e, t), Rb.init(e, t);
});
function Gx(e) {
  return /* @__PURE__ */ TK(oq, e);
}
const aq = /* @__PURE__ */ ne("ZodBoolean", (e, t) => {
  TB.init(e, t), Pt.init(e, t), e._zod.processJSONSchema = (n, r, i) => JK(e, n, r);
});
function Zt(e) {
  return /* @__PURE__ */ OK(aq, e);
}
const sq = /* @__PURE__ */ ne("ZodAny", (e, t) => {
  OB.init(e, t), Pt.init(e, t), e._zod.processJSONSchema = (n, r, i) => eU();
});
function lq() {
  return /* @__PURE__ */ PK(sq);
}
const uq = /* @__PURE__ */ ne("ZodUnknown", (e, t) => {
  PB.init(e, t), Pt.init(e, t), e._zod.processJSONSchema = (n, r, i) => tU();
});
function Yx() {
  return /* @__PURE__ */ AK(uq);
}
const cq = /* @__PURE__ */ ne("ZodNever", (e, t) => {
  AB.init(e, t), Pt.init(e, t), e._zod.processJSONSchema = (n, r, i) => XK(e, n, r);
});
function fq(e) {
  return /* @__PURE__ */ DK(cq, e);
}
const dq = /* @__PURE__ */ ne("ZodDate", (e, t) => {
  DB.init(e, t), Pt.init(e, t), e._zod.processJSONSchema = (r, i, o) => nU(e, r), e.min = (r, i) => e.check(/* @__PURE__ */ Tf(r, i)), e.max = (r, i) => e.check(/* @__PURE__ */ kf(r, i));
  const n = e._zod.bag;
  e.minDate = n.minimum ? new Date(n.minimum) : null, e.maxDate = n.maximum ? new Date(n.maximum) : null;
});
function pq(e) {
  return /* @__PURE__ */ CK(dq, e);
}
const hq = /* @__PURE__ */ ne("ZodArray", (e, t) => {
  CB.init(e, t), Pt.init(e, t), e._zod.processJSONSchema = (n, r, i) => sU(e, n, r, i), e.element = t.element, e.min = (n, r) => e.check(/* @__PURE__ */ vd(n, r)), e.nonempty = (n) => e.check(/* @__PURE__ */ vd(1, n)), e.max = (n, r) => e.check(/* @__PURE__ */ D4(n, r)), e.length = (n, r) => e.check(/* @__PURE__ */ C4(n, r)), e.unwrap = () => e.element;
});
function mn(e, t) {
  return /* @__PURE__ */ UK(hq, e, t);
}
const mq = /* @__PURE__ */ ne("ZodObject", (e, t) => {
  MB.init(e, t), Pt.init(e, t), e._zod.processJSONSchema = (n, r, i) => lU(e, n, r, i), at(e, "shape", () => t.shape), e.keyof = () => _q(Object.keys(e._zod.def.shape)), e.catchall = (n) => e.clone({ ...e._zod.def, catchall: n }), e.passthrough = () => e.clone({ ...e._zod.def, catchall: Yx() }), e.loose = () => e.clone({ ...e._zod.def, catchall: Yx() }), e.strict = () => e.clone({ ...e._zod.def, catchall: fq() }), e.strip = () => e.clone({ ...e._zod.def, catchall: void 0 }), e.extend = (n) => XV(e, n), e.safeExtend = (n) => e7(e, n), e.merge = (n) => t7(e, n), e.pick = (n) => QV(e, n), e.omit = (n) => JV(e, n), e.partial = (...n) => n7(F4, e, n[0]), e.required = (...n) => r7(z4, e, n[0]);
});
function Ge(e, t) {
  const n = {
    type: "object",
    shape: e ?? {},
    ...Ve(t)
  };
  return new mq(n);
}
const vq = /* @__PURE__ */ ne("ZodUnion", (e, t) => {
  RB.init(e, t), Pt.init(e, t), e._zod.processJSONSchema = (n, r, i) => uU(e, n, r, i), e.options = t.options;
});
function no(e, t) {
  return new vq({
    type: "union",
    options: e,
    ...Ve(t)
  });
}
const gq = /* @__PURE__ */ ne("ZodIntersection", (e, t) => {
  NB.init(e, t), Pt.init(e, t), e._zod.processJSONSchema = (n, r, i) => cU(e, n, r, i);
});
function yq(e, t) {
  return new gq({
    type: "intersection",
    left: e,
    right: t
  });
}
const bq = /* @__PURE__ */ ne("ZodRecord", (e, t) => {
  jB.init(e, t), Pt.init(e, t), e._zod.processJSONSchema = (n, r, i) => fU(e, n, r, i), e.keyType = t.keyType, e.valueType = t.valueType;
});
function yd(e, t, n) {
  return new bq({
    type: "record",
    keyType: e,
    valueType: t,
    ...Ve(n)
  });
}
const bd = /* @__PURE__ */ ne("ZodEnum", (e, t) => {
  FB.init(e, t), Pt.init(e, t), e._zod.processJSONSchema = (r, i, o) => rU(e, r, i), e.enum = t.entries, e.options = Object.values(t.entries);
  const n = new Set(Object.keys(t.entries));
  e.extract = (r, i) => {
    const o = {};
    for (const a of r)
      if (n.has(a))
        o[a] = t.entries[a];
      else
        throw new Error(`Key ${a} not found in enum`);
    return new bd({
      ...t,
      checks: [],
      ...Ve(i),
      entries: o
    });
  }, e.exclude = (r, i) => {
    const o = { ...t.entries };
    for (const a of r)
      if (n.has(a))
        delete o[a];
      else
        throw new Error(`Key ${a} not found in enum`);
    return new bd({
      ...t,
      checks: [],
      ...Ve(i),
      entries: o
    });
  };
});
function _q(e, t) {
  const n = Array.isArray(e) ? Object.fromEntries(e.map((r) => [r, r])) : e;
  return new bd({
    type: "enum",
    entries: n,
    ...Ve(t)
  });
}
function wq(e, t) {
  return new bd({
    type: "enum",
    entries: e,
    ...Ve(t)
  });
}
const xq = /* @__PURE__ */ ne("ZodLiteral", (e, t) => {
  zB.init(e, t), Pt.init(e, t), e._zod.processJSONSchema = (n, r, i) => iU(e, n, r), e.values = new Set(t.values), Object.defineProperty(e, "value", {
    get() {
      if (t.values.length > 1)
        throw new Error("This schema contains multiple valid literal values. Use `.values` instead.");
      return t.values[0];
    }
  });
});
function Rn(e, t) {
  return new xq({
    type: "literal",
    values: Array.isArray(e) ? e : [e],
    ...Ve(t)
  });
}
const Eq = /* @__PURE__ */ ne("ZodTransform", (e, t) => {
  LB.init(e, t), Pt.init(e, t), e._zod.processJSONSchema = (n, r, i) => aU(e, n), e._zod.parse = (n, r) => {
    if (r.direction === "backward")
      throw new f4(e.constructor.name);
    n.addIssue = (o) => {
      if (typeof o == "string")
        n.issues.push(Pu(o, n.value, t));
      else {
        const a = o;
        a.fatal && (a.continue = !1), a.code ?? (a.code = "custom"), a.input ?? (a.input = n.value), a.inst ?? (a.inst = e), n.issues.push(Pu(a));
      }
    };
    const i = t.transform(n.value, n);
    return i instanceof Promise ? i.then((o) => (n.value = o, n)) : (n.value = i, n);
  };
});
function Sq(e) {
  return new Eq({
    type: "transform",
    transform: e
  });
}
const F4 = /* @__PURE__ */ ne("ZodOptional", (e, t) => {
  A4.init(e, t), Pt.init(e, t), e._zod.processJSONSchema = (n, r, i) => N4(e, n, r, i), e.unwrap = () => e._zod.def.innerType;
});
function Qx(e) {
  return new F4({
    type: "optional",
    innerType: e
  });
}
const $q = /* @__PURE__ */ ne("ZodExactOptional", (e, t) => {
  VB.init(e, t), Pt.init(e, t), e._zod.processJSONSchema = (n, r, i) => N4(e, n, r, i), e.unwrap = () => e._zod.def.innerType;
});
function kq(e) {
  return new $q({
    type: "optional",
    innerType: e
  });
}
const Tq = /* @__PURE__ */ ne("ZodNullable", (e, t) => {
  BB.init(e, t), Pt.init(e, t), e._zod.processJSONSchema = (n, r, i) => dU(e, n, r, i), e.unwrap = () => e._zod.def.innerType;
});
function Jx(e) {
  return new Tq({
    type: "nullable",
    innerType: e
  });
}
const Oq = /* @__PURE__ */ ne("ZodDefault", (e, t) => {
  KB.init(e, t), Pt.init(e, t), e._zod.processJSONSchema = (n, r, i) => hU(e, n, r, i), e.unwrap = () => e._zod.def.innerType, e.removeDefault = e.unwrap;
});
function Pq(e, t) {
  return new Oq({
    type: "default",
    innerType: e,
    get defaultValue() {
      return typeof t == "function" ? t() : m4(t);
    }
  });
}
const Aq = /* @__PURE__ */ ne("ZodPrefault", (e, t) => {
  UB.init(e, t), Pt.init(e, t), e._zod.processJSONSchema = (n, r, i) => mU(e, n, r, i), e.unwrap = () => e._zod.def.innerType;
});
function Dq(e, t) {
  return new Aq({
    type: "prefault",
    innerType: e,
    get defaultValue() {
      return typeof t == "function" ? t() : m4(t);
    }
  });
}
const z4 = /* @__PURE__ */ ne("ZodNonOptional", (e, t) => {
  qB.init(e, t), Pt.init(e, t), e._zod.processJSONSchema = (n, r, i) => pU(e, n, r, i), e.unwrap = () => e._zod.def.innerType;
});
function Cq(e, t) {
  return new z4({
    type: "nonoptional",
    innerType: e,
    ...Ve(t)
  });
}
const Iq = /* @__PURE__ */ ne("ZodCatch", (e, t) => {
  HB.init(e, t), Pt.init(e, t), e._zod.processJSONSchema = (n, r, i) => vU(e, n, r, i), e.unwrap = () => e._zod.def.innerType, e.removeCatch = e.unwrap;
});
function Mq(e, t) {
  return new Iq({
    type: "catch",
    innerType: e,
    catchValue: typeof t == "function" ? t : () => t
  });
}
const Rq = /* @__PURE__ */ ne("ZodPipe", (e, t) => {
  WB.init(e, t), Pt.init(e, t), e._zod.processJSONSchema = (n, r, i) => gU(e, n, r, i), e.in = t.in, e.out = t.out;
});
function Xx(e, t) {
  return new Rq({
    type: "pipe",
    in: e,
    out: t
    // ...util.normalizeParams(params),
  });
}
const Nq = /* @__PURE__ */ ne("ZodReadonly", (e, t) => {
  ZB.init(e, t), Pt.init(e, t), e._zod.processJSONSchema = (n, r, i) => yU(e, n, r, i), e.unwrap = () => e._zod.def.innerType;
});
function jq(e) {
  return new Nq({
    type: "readonly",
    innerType: e
  });
}
const Fq = /* @__PURE__ */ ne("ZodLazy", (e, t) => {
  GB.init(e, t), Pt.init(e, t), e._zod.processJSONSchema = (n, r, i) => bU(e, n, r, i), e.unwrap = () => e._zod.def.getter();
});
function Nb(e) {
  return new Fq({
    type: "lazy",
    getter: e
  });
}
const zq = /* @__PURE__ */ ne("ZodCustom", (e, t) => {
  YB.init(e, t), Pt.init(e, t), e._zod.processJSONSchema = (n, r, i) => oU(e, n);
});
function Lq(e, t = {}) {
  return /* @__PURE__ */ qK(zq, e, t);
}
function Vq(e) {
  return /* @__PURE__ */ HK(e);
}
function Bq(e) {
  return /* @__PURE__ */ kK(Rb, e);
}
const Kq = Ge({
  id: hr(),
  name: we(),
  labId: hr(),
  status: we(),
  ipAddress: we().nullable(),
  lastLogin: pq().nullable()
});
Ge({
  tinkerboxes: mn(Kq)
});
const Uq = Ge({
  key: we(),
  name: we(),
  isFolder: Zt(),
  bucket: we(),
  fullPath: we()
});
Ge({
  contents: mn(Uq)
});
Ge({
  buckets: mn(
    Ge({
      id: hr().int(),
      bucket: we(),
      region: we(),
      prefix: we().nullish()
    })
  )
});
const qq = Ge({
  name: we(),
  type: Rn("select"),
  options: mn(we()),
  optional: Zt().optional(),
  allowOther: Zt().optional(),
  validate: we().optional(),
  question: we().optional()
}), Hq = Ge({
  name: we(),
  type: no([Rn("text"), Rn("textarea")]),
  optional: Zt().optional(),
  validate: we().optional(),
  question: we().optional()
}), Wq = Ge({
  name: we(),
  type: Rn("email"),
  optional: Zt().optional(),
  validate: we().optional(),
  question: we().optional()
}), Zq = Ge({
  name: we(),
  type: Rn("submit"),
  text: we().optional(),
  optional: Zt().optional(),
  validate: we().optional(),
  question: we().optional()
});
mn(
  Ge({
    name: we(),
    value: we()
  })
);
no([
  qq,
  Hq,
  Wq,
  Zq
]);
const Gq = Ge({
  content: we(),
  is_error: Zt(),
  show: Zt()
}), Yq = Ge({
  id: we(),
  results: mn(Gq).nullish(),
  cell_type: we(),
  metadata: Ge({
    collapsed: Zt().nullish(),
    trusted: Zt().nullish()
  }),
  source: no([we(), mn(we())]),
  outputs: mn(lq()).nullish(),
  execution_count: hr().nullish()
}), Qq = Ge({
  kernelspec: Ge({
    display_name: we(),
    language: we(),
    name: we()
  }),
  language_info: Ge({
    codemirror_mode: Ge({
      name: we(),
      version: hr()
    }),
    file_extension: we(),
    mimetype: we(),
    name: we(),
    nbconvert_exporter: we(),
    pygments_lexer: we(),
    version: we()
  })
});
Ge({
  cells: mn(Yq),
  metadata: Qq,
  nbformat_minor: hr(),
  nbformat: hr()
});
var Vn = /* @__PURE__ */ ((e) => (e.ALL = "all", e.NONE = "none", e.FILE = "file", e.DIR = "dir", e.FILE_LIST = "file_list", e.DIR_LIST = "dir_list", e))(Vn || {});
const Jq = Ge({
  _type: Rn("string"),
  _validation: we().optional(),
  _value: we().optional(),
  _optional: Zt().optional()
}), Xq = Ge({
  _type: Rn("boolean"),
  _value: Zt().optional(),
  _optional: Zt().optional()
}), eH = Ge({
  _type: Rn("selection"),
  _options: mn(we()),
  _optional: Zt().optional(),
  _value: we().optional()
}), L4 = Ge({
  bucketId: hr(),
  isFolder: Zt(),
  path: we()
}), tH = wq(Vn), $a = Nb(
  () => no([
    iH,
    nH,
    eH,
    Jq,
    rH,
    Xq
  ])
), nH = Ge({
  _type: Rn("path"),
  _value: no([mn(L4), mn(we())]).optional(),
  // _value: z.array(s3PathSchema).optional(),
  _regexp: we().optional(),
  _optional: Zt().optional(),
  _pathType: tH
}), rH = Nb(
  () => Ge({
    _type: Rn("list"),
    _value: mn($a).optional(),
    _optional: Zt().optional(),
    _schema: $a
  })
), iH = Nb(
  () => Ge({
    _type: Rn("object"),
    _optional: Zt().optional(),
    _fields: yd(we(), $a),
    _value: yd(we(), $a).optional(),
    _order: mn(we()).optional()
  })
);
yd(
  Bq(),
  $a
);
yd(
  we(),
  $a
);
const oH = Ge({
  type: Rn("pattern"),
  pattern: we()
}), aH = Ge({
  type: Rn("value"),
  value: no([we(), hr(), Zt(), mn(L4)])
}), sH = Ge({
  type: Rn("code"),
  codeBase64: we()
}), lH = no([
  oH,
  aH,
  sH
]);
$a.and(
  Ge({
    _actionData: lH.optional()
  })
);
const V4 = Ge({
  permissions: we(),
  links: we(),
  owner: we(),
  group: we(),
  size: we(),
  month: we(),
  date: we(),
  yearOrTime: we(),
  name: we(),
  fullPath: we()
}), uH = mn(V4);
Ge({
  url: we()
});
Ge({
  socketId: we(),
  hasSavedSession: Zt().nullish()
});
Ge({
  path: we()
});
Ge({
  directory: we(),
  contents: uH
});
Ge({
  syncPwd: Zt()
});
Ge({
  defaultDirectory: we(),
  termState: we().nullish()
});
Ge({
  path: we()
});
Ge({
  query: we()
});
Ge({
  results: mn(V4),
  date: we(),
  query: we()
});
Ge({
  id: we(),
  command: we()
});
const cH = no([
  Rn("action"),
  Rn("code")
]);
Ge({
  id: we(),
  resultType: cH,
  results: mn(
    Ge({
      content: we(),
      isError: Zt()
    })
  ),
  exitCode: hr()
});
Ge({
  tinkerBoxId: hr(),
  rows: hr(),
  cols: hr(),
  syncPwd: Zt().nullish()
});
Ge({
  path: we()
});
Ge({
  path: we()
});
Ge({
  termState: we()
});
var fH = {
  0: "Invalid value for configuration 'enforceActions', expected 'never', 'always' or 'observed'",
  1: function(t, n) {
    return "Cannot apply '" + t + "' to '" + n.toString() + "': Field not found.";
  },
  /*
  2(prop) {
      return `invalid decorator for '${prop.toString()}'`
  },
  3(prop) {
      return `Cannot decorate '${prop.toString()}': action can only be used on properties with a function value.`
  },
  4(prop) {
      return `Cannot decorate '${prop.toString()}': computed can only be used on getter properties.`
  },
  */
  5: "'keys()' can only be used on observable objects, arrays, sets and maps",
  6: "'values()' can only be used on observable objects, arrays, sets and maps",
  7: "'entries()' can only be used on observable objects, arrays and maps",
  8: "'set()' can only be used on observable objects, arrays and maps",
  9: "'remove()' can only be used on observable objects, arrays and maps",
  10: "'has()' can only be used on observable objects, arrays and maps",
  11: "'get()' can only be used on observable objects, arrays and maps",
  12: "Invalid annotation",
  13: "Dynamic observable objects cannot be frozen. If you're passing observables to 3rd party component/function that calls Object.freeze, pass copy instead: toJS(observable)",
  14: "Intercept handlers should return nothing or a change object",
  15: "Observable arrays cannot be frozen. If you're passing observables to 3rd party component/function that calls Object.freeze, pass copy instead: toJS(observable)",
  16: "Modification exception: the internal structure of an observable array was changed.",
  17: function(t, n) {
    return "[mobx.array] Index out of bounds, " + t + " is larger than " + n;
  },
  18: "mobx.map requires Map polyfill for the current browser. Check babel-polyfill or core-js/es6/map.js",
  19: function(t) {
    return "Cannot initialize from classes that inherit from Map: " + t.constructor.name;
  },
  20: function(t) {
    return "Cannot initialize map from " + t;
  },
  21: function(t) {
    return "Cannot convert to map from '" + t + "'";
  },
  22: "mobx.set requires Set polyfill for the current browser. Check babel-polyfill or core-js/es6/set.js",
  23: "It is not possible to get index atoms from arrays",
  24: function(t) {
    return "Cannot obtain administration from " + t;
  },
  25: function(t, n) {
    return "the entry '" + t + "' does not exist in the observable map '" + n + "'";
  },
  26: "please specify a property",
  27: function(t, n) {
    return "no observable property '" + t.toString() + "' found on the observable object '" + n + "'";
  },
  28: function(t) {
    return "Cannot obtain atom from " + t;
  },
  29: "Expecting some object",
  30: "invalid action stack. did you forget to finish an action?",
  31: "missing option for computed: get",
  32: function(t, n) {
    return "Cycle detected in computation " + t + ": " + n;
  },
  33: function(t) {
    return "The setter of computed value '" + t + "' is trying to update itself. Did you intend to update an _observable_ value, instead of the computed property?";
  },
  34: function(t) {
    return "[ComputedValue '" + t + "'] It is not possible to assign a new value to a computed value.";
  },
  35: "There are multiple, different versions of MobX active. Make sure MobX is loaded only once or use `configure({ isolateGlobalState: true })`",
  36: "isolateGlobalState should be called before MobX is running any reactions",
  37: function(t) {
    return "[mobx] `observableArray." + t + "()` mutates the array in-place, which is not allowed inside a derivation. Use `array.slice()." + t + "()` instead";
  },
  38: "'ownKeys()' can only be used on observable objects",
  39: "'defineProperty()' can only be used on observable objects"
}, dH = process.env.NODE_ENV !== "production" ? fH : {};
function Te(e) {
  for (var t = arguments.length, n = new Array(t > 1 ? t - 1 : 0), r = 1; r < t; r++)
    n[r - 1] = arguments[r];
  if (process.env.NODE_ENV !== "production") {
    var i = typeof e == "string" ? e : dH[e];
    throw typeof i == "function" && (i = i.apply(null, n)), new Error("[MobX] " + i);
  }
  throw new Error(typeof e == "number" ? "[MobX] minified error nr: " + e + (n.length ? " " + n.map(String).join(",") : "") + ". Find the full error at: https://github.com/mobxjs/mobx/blob/main/packages/mobx/src/errors.ts" : "[MobX] " + e);
}
var pH = {};
function Ep() {
  return typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : pH;
}
var B4 = Object.assign, _d = Object.getOwnPropertyDescriptor, Oi = Object.defineProperty, Sp = Object.prototype, wd = [];
Object.freeze(wd);
var K4 = {};
Object.freeze(K4);
var hH = typeof Proxy < "u", mH = /* @__PURE__ */ Object.toString();
function U4() {
  hH || Te(process.env.NODE_ENV !== "production" ? "`Proxy` objects are not available in the current environment. Please configure MobX to enable a fallback implementation.`" : "Proxy not available");
}
function Nl(e) {
  process.env.NODE_ENV !== "production" && he.verifyProxies && Te("MobX is currently configured to be able to run in ES5 mode, but in ES5 MobX won't be able to " + e);
}
function ci() {
  return ++he.mobxGuid;
}
function jb(e) {
  var t = !1;
  return function() {
    if (!t)
      return t = !0, e.apply(this, arguments);
  };
}
var hs = function() {
};
function vn(e) {
  return typeof e == "function";
}
function ka(e) {
  var t = typeof e;
  switch (t) {
    case "string":
    case "symbol":
    case "number":
      return !0;
  }
  return !1;
}
function $p(e) {
  return e !== null && typeof e == "object";
}
function mr(e) {
  if (!$p(e))
    return !1;
  var t = Object.getPrototypeOf(e);
  if (t == null)
    return !0;
  var n = Object.hasOwnProperty.call(t, "constructor") && t.constructor;
  return typeof n == "function" && n.toString() === mH;
}
function q4(e) {
  var t = e?.constructor;
  return t ? t.name === "GeneratorFunction" || t.displayName === "GeneratorFunction" : !1;
}
function oc(e, t, n) {
  Oi(e, t, {
    enumerable: !1,
    writable: !0,
    configurable: !0,
    value: n
  });
}
function H4(e, t, n) {
  Oi(e, t, {
    enumerable: !1,
    writable: !1,
    configurable: !0,
    value: n
  });
}
function La(e, t) {
  var n = "isMobX" + e;
  return t.prototype[n] = !0, function(r) {
    return $p(r) && r[n] === !0;
  };
}
function fl(e) {
  return e != null && Object.prototype.toString.call(e) === "[object Map]";
}
function vH(e) {
  var t = Object.getPrototypeOf(e), n = Object.getPrototypeOf(t), r = Object.getPrototypeOf(n);
  return r === null;
}
function zi(e) {
  return e != null && Object.prototype.toString.call(e) === "[object Set]";
}
var W4 = typeof Object.getOwnPropertySymbols < "u";
function gH(e) {
  var t = Object.keys(e);
  if (!W4)
    return t;
  var n = Object.getOwnPropertySymbols(e);
  return n.length ? [].concat(t, n.filter(function(r) {
    return Sp.propertyIsEnumerable.call(e, r);
  })) : t;
}
var zs = typeof Reflect < "u" && Reflect.ownKeys ? Reflect.ownKeys : W4 ? function(e) {
  return Object.getOwnPropertyNames(e).concat(Object.getOwnPropertySymbols(e));
} : (
  /* istanbul ignore next */
  Object.getOwnPropertyNames
);
function og(e) {
  return typeof e == "string" ? e : typeof e == "symbol" ? e.toString() : new String(e).toString();
}
function Z4(e) {
  return e === null ? null : typeof e == "object" ? "" + e : e;
}
function Nr(e, t) {
  return Sp.hasOwnProperty.call(e, t);
}
var yH = Object.getOwnPropertyDescriptors || function(t) {
  var n = {};
  return zs(t).forEach(function(r) {
    n[r] = _d(t, r);
  }), n;
};
function cr(e, t) {
  return !!(e & t);
}
function fr(e, t, n) {
  return n ? e |= t : e &= ~t, e;
}
function eE(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var n = 0, r = Array(t); n < t; n++) r[n] = e[n];
  return r;
}
function bH(e, t, n) {
  if (G4()) return Reflect.construct.apply(null, arguments);
  var r = [null];
  r.push.apply(r, t);
  var i = new (e.bind.apply(e, r))();
  return n && Au(i, n.prototype), i;
}
function _H(e, t) {
  for (var n = 0; n < t.length; n++) {
    var r = t[n];
    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, EH(r.key), r);
  }
}
function dl(e, t, n) {
  return t && _H(e.prototype, t), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}
function ms(e, t) {
  var n = typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (n) return (n = n.call(e)).next.bind(n);
  if (Array.isArray(e) || (n = SH(e)) || t) {
    n && (e = n);
    var r = 0;
    return function() {
      return r >= e.length ? {
        done: !0
      } : {
        done: !1,
        value: e[r++]
      };
    };
  }
  throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function Gi() {
  return Gi = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n) ({}).hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, Gi.apply(null, arguments);
}
function ag(e) {
  return ag = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(t) {
    return t.__proto__ || Object.getPrototypeOf(t);
  }, ag(e);
}
function Fb(e, t) {
  e.prototype = Object.create(t.prototype), e.prototype.constructor = e, Au(e, t);
}
function wH(e) {
  try {
    return Function.toString.call(e).indexOf("[native code]") !== -1;
  } catch {
    return typeof e == "function";
  }
}
function G4() {
  try {
    var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch {
  }
  return (G4 = function() {
    return !!e;
  })();
}
function Au(e, t) {
  return Au = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(n, r) {
    return n.__proto__ = r, n;
  }, Au(e, t);
}
function xH(e, t) {
  if (typeof e != "object" || !e) return e;
  var n = e[Symbol.toPrimitive];
  if (n !== void 0) {
    var r = n.call(e, t);
    if (typeof r != "object") return r;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return String(e);
}
function EH(e) {
  var t = xH(e, "string");
  return typeof t == "symbol" ? t : t + "";
}
function SH(e, t) {
  if (e) {
    if (typeof e == "string") return eE(e, t);
    var n = {}.toString.call(e).slice(8, -1);
    return n === "Object" && e.constructor && (n = e.constructor.name), n === "Map" || n === "Set" ? Array.from(e) : n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n) ? eE(e, t) : void 0;
  }
}
function sg(e) {
  var t = typeof Map == "function" ? /* @__PURE__ */ new Map() : void 0;
  return sg = function(n) {
    if (n === null || !wH(n)) return n;
    if (typeof n != "function") throw new TypeError("Super expression must either be null or a function");
    if (t !== void 0) {
      if (t.has(n)) return t.get(n);
      t.set(n, r);
    }
    function r() {
      return bH(n, arguments, ag(this).constructor);
    }
    return r.prototype = Object.create(n.prototype, {
      constructor: {
        value: r,
        enumerable: !1,
        writable: !0,
        configurable: !0
      }
    }), Au(r, n);
  }, sg(e);
}
var Xn = /* @__PURE__ */ Symbol("mobx-stored-annotations");
function Pi(e) {
  function t(n, r) {
    if (sc(r))
      return e.decorate_20223_(n, r);
    ac(n, r, e);
  }
  return Object.assign(t, e);
}
function ac(e, t, n) {
  if (Nr(e, Xn) || oc(e, Xn, Gi({}, e[Xn])), process.env.NODE_ENV !== "production" && Ed(n) && !Nr(e[Xn], t)) {
    var r = e.constructor.name + ".prototype." + t.toString();
    Te("'" + r + "' is decorated with 'override', but no such decorated member was found on prototype.");
  }
  $H(e, n, t), Ed(n) || (e[Xn][t] = n);
}
function $H(e, t, n) {
  if (process.env.NODE_ENV !== "production" && !Ed(t) && Nr(e[Xn], n)) {
    var r = e.constructor.name + ".prototype." + n.toString(), i = e[Xn][n].annotationType_, o = t.annotationType_;
    Te("Cannot apply '@" + o + "' to '" + r + "':" + (`
The field is already decorated with '@` + i + "'.") + `
Re-decorating fields is not allowed.
Use '@override' decorator for methods overridden by subclass.`);
  }
}
function kH(e) {
  return Nr(e, Xn) || oc(e, Xn, Gi({}, e[Xn])), e[Xn];
}
function sc(e) {
  return typeof e == "object" && typeof e.kind == "string";
}
function kp(e, t) {
  process.env.NODE_ENV !== "production" && !t.includes(e.kind) && Te("The decorator applied to '" + String(e.name) + "' cannot be used on a " + e.kind + " element");
}
var Ze = /* @__PURE__ */ Symbol("mobx administration"), Vo = /* @__PURE__ */ (function() {
  function e(n) {
    n === void 0 && (n = process.env.NODE_ENV !== "production" ? "Atom@" + ci() : "Atom"), this.name_ = void 0, this.flags_ = 0, this.observers_ = /* @__PURE__ */ new Set(), this.lastAccessedBy_ = 0, this.lowestObserverState_ = ct.NOT_TRACKING_, this.onBOL = void 0, this.onBUOL = void 0, this.name_ = n;
  }
  var t = e.prototype;
  return t.onBO = function() {
    this.onBOL && this.onBOL.forEach(function(r) {
      return r();
    });
  }, t.onBUO = function() {
    this.onBUOL && this.onBUOL.forEach(function(r) {
      return r();
    });
  }, t.reportObserved = function() {
    return fA(this);
  }, t.reportChanged = function() {
    Ar(), dA(this), Dr();
  }, t.toString = function() {
    return this.name_;
  }, dl(e, [{
    key: "isBeingObserved",
    get: function() {
      return cr(this.flags_, e.isBeingObservedMask_);
    },
    set: function(r) {
      this.flags_ = fr(this.flags_, e.isBeingObservedMask_, r);
    }
  }, {
    key: "isPendingUnobservation",
    get: function() {
      return cr(this.flags_, e.isPendingUnobservationMask_);
    },
    set: function(r) {
      this.flags_ = fr(this.flags_, e.isPendingUnobservationMask_, r);
    }
  }, {
    key: "diffValue",
    get: function() {
      return cr(this.flags_, e.diffValueMask_) ? 1 : 0;
    },
    set: function(r) {
      this.flags_ = fr(this.flags_, e.diffValueMask_, r === 1);
    }
  }]);
})();
Vo.isBeingObservedMask_ = 1;
Vo.isPendingUnobservationMask_ = 2;
Vo.diffValueMask_ = 4;
var zb = /* @__PURE__ */ La("Atom", Vo);
function Y4(e, t, n) {
  t === void 0 && (t = hs), n === void 0 && (n = hs);
  var r = new Vo(e);
  return t !== hs && LW(r, t), n !== hs && yA(r, n), r;
}
function TH(e, t) {
  return AA(e, t);
}
function OH(e, t) {
  return Object.is ? Object.is(e, t) : e === t ? e !== 0 || 1 / e === 1 / t : e !== e && t !== t;
}
var xd = {
  structural: TH,
  default: OH
};
function Ta(e, t, n) {
  return Iu(e) ? e : Array.isArray(e) ? hn.array(e, {
    name: n
  }) : mr(e) ? hn.object(e, void 0, {
    name: n
  }) : fl(e) ? hn.map(e, {
    name: n
  }) : zi(e) ? hn.set(e, {
    name: n
  }) : typeof e == "function" && !Aa(e) && !Cu(e) ? q4(e) ? Ls(e) : Du(n, e) : e;
}
function PH(e, t, n) {
  if (e == null || pl(e) || Ip(e) || Bo(e) || xi(e))
    return e;
  if (Array.isArray(e))
    return hn.array(e, {
      name: n,
      deep: !1
    });
  if (mr(e))
    return hn.object(e, void 0, {
      name: n,
      deep: !1
    });
  if (fl(e))
    return hn.map(e, {
      name: n,
      deep: !1
    });
  if (zi(e))
    return hn.set(e, {
      name: n,
      deep: !1
    });
  process.env.NODE_ENV !== "production" && Te("The shallow modifier / decorator can only used in combination with arrays, objects, maps and sets");
}
function Tp(e) {
  return e;
}
function AH(e, t) {
  return process.env.NODE_ENV !== "production" && Iu(e) && Te("observable.struct should not be used with observable values"), AA(e, t) ? t : e;
}
var DH = "override";
function Ed(e) {
  return e.annotationType_ === DH;
}
function lc(e, t) {
  return {
    annotationType_: e,
    options_: t,
    make_: CH,
    extend_: IH,
    decorate_20223_: MH
  };
}
function CH(e, t, n, r) {
  var i;
  if ((i = this.options_) != null && i.bound)
    return this.extend_(e, t, n, !1) === null ? 0 : 1;
  if (r === e.target_)
    return this.extend_(e, t, n, !1) === null ? 0 : 2;
  if (Aa(n.value))
    return 1;
  var o = Q4(e, this, t, n, !1);
  return Oi(r, t, o), 2;
}
function IH(e, t, n, r) {
  var i = Q4(e, this, t, n);
  return e.defineProperty_(t, i, r);
}
function MH(e, t) {
  process.env.NODE_ENV !== "production" && kp(t, ["method", "field"]);
  var n = t.kind, r = t.name, i = t.addInitializer, o = this, a = function(u) {
    var c, f, d, p;
    return Oa((c = (f = o.options_) == null ? void 0 : f.name) != null ? c : r.toString(), u, (d = (p = o.options_) == null ? void 0 : p.autoAction) != null ? d : !1);
  };
  if (n == "field")
    return function(l) {
      var u, c = l;
      return Aa(c) || (c = a(c)), (u = o.options_) != null && u.bound && (c = c.bind(this), c.isMobxAction = !0), c;
    };
  if (n == "method") {
    var s;
    return Aa(e) || (e = a(e)), (s = this.options_) != null && s.bound && i(function() {
      var l = this, u = l[r].bind(l);
      u.isMobxAction = !0, l[r] = u;
    }), e;
  }
  Te("Cannot apply '" + o.annotationType_ + "' to '" + String(r) + "' (kind: " + n + "):" + (`
'` + o.annotationType_ + "' can only be used on properties with a function value."));
}
function RH(e, t, n, r) {
  var i = t.annotationType_, o = r.value;
  process.env.NODE_ENV !== "production" && !vn(o) && Te("Cannot apply '" + i + "' to '" + e.name_ + "." + n.toString() + "':" + (`
'` + i + "' can only be used on properties with a function value."));
}
function Q4(e, t, n, r, i) {
  var o, a, s, l, u, c, f;
  i === void 0 && (i = he.safeDescriptors), RH(e, t, n, r);
  var d = r.value;
  if ((o = t.options_) != null && o.bound) {
    var p;
    d = d.bind((p = e.proxy_) != null ? p : e.target_);
  }
  return {
    value: Oa(
      (a = (s = t.options_) == null ? void 0 : s.name) != null ? a : n.toString(),
      d,
      (l = (u = t.options_) == null ? void 0 : u.autoAction) != null ? l : !1,
      // https://github.com/mobxjs/mobx/discussions/3140
      (c = t.options_) != null && c.bound ? (f = e.proxy_) != null ? f : e.target_ : void 0
    ),
    // Non-configurable for classes
    // prevents accidental field redefinition in subclass
    configurable: i ? e.isPlainObject_ : !0,
    // https://github.com/mobxjs/mobx/pull/2641#issuecomment-737292058
    enumerable: !1,
    // Non-obsevable, therefore non-writable
    // Also prevents rewriting in subclass constructor
    writable: !i
  };
}
function J4(e, t) {
  return {
    annotationType_: e,
    options_: t,
    make_: NH,
    extend_: jH,
    decorate_20223_: FH
  };
}
function NH(e, t, n, r) {
  var i;
  if (r === e.target_)
    return this.extend_(e, t, n, !1) === null ? 0 : 2;
  if ((i = this.options_) != null && i.bound && (!Nr(e.target_, t) || !Cu(e.target_[t])) && this.extend_(e, t, n, !1) === null)
    return 0;
  if (Cu(n.value))
    return 1;
  var o = X4(e, this, t, n, !1, !1);
  return Oi(r, t, o), 2;
}
function jH(e, t, n, r) {
  var i, o = X4(e, this, t, n, (i = this.options_) == null ? void 0 : i.bound);
  return e.defineProperty_(t, o, r);
}
function FH(e, t) {
  var n;
  process.env.NODE_ENV !== "production" && kp(t, ["method"]);
  var r = t.name, i = t.addInitializer;
  return Cu(e) || (e = Ls(e)), (n = this.options_) != null && n.bound && i(function() {
    var o = this, a = o[r].bind(o);
    a.isMobXFlow = !0, o[r] = a;
  }), e;
}
function zH(e, t, n, r) {
  var i = t.annotationType_, o = r.value;
  process.env.NODE_ENV !== "production" && !vn(o) && Te("Cannot apply '" + i + "' to '" + e.name_ + "." + n.toString() + "':" + (`
'` + i + "' can only be used on properties with a generator function value."));
}
function X4(e, t, n, r, i, o) {
  o === void 0 && (o = he.safeDescriptors), zH(e, t, n, r);
  var a = r.value;
  if (Cu(a) || (a = Ls(a)), i) {
    var s;
    a = a.bind((s = e.proxy_) != null ? s : e.target_), a.isMobXFlow = !0;
  }
  return {
    value: a,
    // Non-configurable for classes
    // prevents accidental field redefinition in subclass
    configurable: o ? e.isPlainObject_ : !0,
    // https://github.com/mobxjs/mobx/pull/2641#issuecomment-737292058
    enumerable: !1,
    // Non-obsevable, therefore non-writable
    // Also prevents rewriting in subclass constructor
    writable: !o
  };
}
function Lb(e, t) {
  return {
    annotationType_: e,
    options_: t,
    make_: LH,
    extend_: VH,
    decorate_20223_: BH
  };
}
function LH(e, t, n) {
  return this.extend_(e, t, n, !1) === null ? 0 : 1;
}
function VH(e, t, n, r) {
  return KH(e, this, t, n), e.defineComputedProperty_(t, Gi({}, this.options_, {
    get: n.get,
    set: n.set
  }), r);
}
function BH(e, t) {
  process.env.NODE_ENV !== "production" && kp(t, ["getter"]);
  var n = this, r = t.name, i = t.addInitializer, o;
  function a(s, l) {
    var u = Gi({}, n.options_, {
      get: e,
      context: s
    });
    return u.name || (u.name = process.env.NODE_ENV !== "production" ? l.name_ + "." + r.toString() : "ObservableObject." + r.toString()), new tr(u);
  }
  return i(function() {
    var s, l = Ba(this)[Ze], u = this, c = l.values_.get(r);
    c instanceof tr && c.derivation !== e && l.values_.delete(r), ((s = l.lazyComputedKeys_) != null ? s : l.lazyComputedKeys_ = /* @__PURE__ */ new Map()).set(r, function() {
      return a(u, l);
    });
  }), function() {
    var s = this[Ze], l = s.values_.get(r);
    if (l instanceof tr && l.derivation !== e) {
      var u, c = (u = o) == null ? void 0 : u.get(this);
      if (!c) {
        var f;
        c = a(this, s), ((f = o) != null ? f : o = /* @__PURE__ */ new WeakMap()).set(this, c);
      }
      return c.get();
    }
    return s.getObservablePropValue_(r);
  };
}
function KH(e, t, n, r) {
  var i = t.annotationType_, o = r.get;
  process.env.NODE_ENV !== "production" && !o && Te("Cannot apply '" + i + "' to '" + e.name_ + "." + n.toString() + "':" + (`
'` + i + "' can only be used on getter(+setter) properties."));
}
function Op(e, t) {
  return {
    annotationType_: e,
    options_: t,
    make_: UH,
    extend_: qH,
    decorate_20223_: HH
  };
}
function UH(e, t, n) {
  return this.extend_(e, t, n, !1) === null ? 0 : 1;
}
function qH(e, t, n, r) {
  var i, o;
  return WH(e, this, t, n), e.defineObservableProperty_(t, n.value, (i = (o = this.options_) == null ? void 0 : o.enhancer) != null ? i : Ta, r);
}
function HH(e, t) {
  if (process.env.NODE_ENV !== "production") {
    if (t.kind === "field")
      throw Te("Please use `@observable accessor " + String(t.name) + "` instead of `@observable " + String(t.name) + "`");
    kp(t, ["accessor"]);
  }
  var n = this, r = t.kind, i = t.name;
  if (r !== "accessor")
    return;
  function o(a, s) {
    var l, u = Ba(a)[Ze];
    return ((l = u.lazyObservableKeys_) != null ? l : u.lazyObservableKeys_ = /* @__PURE__ */ new Map()).set(i, function() {
      var c, f;
      return new ya(s, (c = (f = n.options_) == null ? void 0 : f.enhancer) != null ? c : Ta, process.env.NODE_ENV !== "production" ? u.name_ + "." + i.toString() : "ObservableObject." + i.toString(), !1);
    }), u;
  }
  return {
    get: function() {
      var s, l = (s = this[Ze]) != null ? s : o(this, e.get.call(this));
      return l.getObservablePropValue_(i);
    },
    set: function(s) {
      var l, u = (l = this[Ze]) != null ? l : o(this, s);
      return u.setObservablePropValue_(i, s);
    },
    init: function(s) {
      return o(this, s), s;
    }
  };
}
function WH(e, t, n, r) {
  var i = t.annotationType_;
  process.env.NODE_ENV !== "production" && !("value" in r) && Te("Cannot apply '" + i + "' to '" + e.name_ + "." + n.toString() + "':" + (`
'` + i + "' cannot be used on getter/setter properties"));
}
var ZH = "true", GH = /* @__PURE__ */ eA();
function eA(e) {
  return {
    annotationType_: ZH,
    options_: e,
    make_: YH,
    extend_: QH,
    decorate_20223_: JH
  };
}
function YH(e, t, n, r) {
  var i, o;
  if (n.get)
    return Pp.make_(e, t, n, r);
  if (n.set) {
    var a = Aa(n.set) ? n.set : Oa(t.toString(), n.set);
    return r === e.target_ ? e.defineProperty_(t, {
      configurable: he.safeDescriptors ? e.isPlainObject_ : !0,
      set: a
    }) === null ? 0 : 2 : (Oi(r, t, {
      configurable: !0,
      set: a
    }), 2);
  }
  if (r !== e.target_ && typeof n.value == "function") {
    var s;
    if (q4(n.value)) {
      var l, u = (l = this.options_) != null && l.autoBind ? Ls.bound : Ls;
      return u.make_(e, t, n, r);
    }
    var c = (s = this.options_) != null && s.autoBind ? Du.bound : Du;
    return c.make_(e, t, n, r);
  }
  var f = ((i = this.options_) == null ? void 0 : i.deep) === !1 ? hn.ref : hn;
  if (typeof n.value == "function" && (o = this.options_) != null && o.autoBind) {
    var d;
    n.value = n.value.bind((d = e.proxy_) != null ? d : e.target_);
  }
  return f.make_(e, t, n, r);
}
function QH(e, t, n, r) {
  var i, o;
  if (n.get)
    return Pp.extend_(e, t, n, r);
  if (n.set)
    return e.defineProperty_(t, {
      configurable: he.safeDescriptors ? e.isPlainObject_ : !0,
      set: Oa(t.toString(), n.set)
    }, r);
  if (typeof n.value == "function" && (i = this.options_) != null && i.autoBind) {
    var a;
    n.value = n.value.bind((a = e.proxy_) != null ? a : e.target_);
  }
  var s = ((o = this.options_) == null ? void 0 : o.deep) === !1 ? hn.ref : hn;
  return s.extend_(e, t, n, r);
}
function JH(e, t) {
  Te("'" + this.annotationType_ + "' cannot be used as a decorator");
}
var XH = "observable", eW = "observable.ref", tW = "observable.shallow", nW = "observable.struct", tA = {
  deep: !0,
  name: void 0,
  defaultDecorator: void 0,
  proxy: !0
};
Object.freeze(tA);
function Hc(e) {
  return e || tA;
}
var lg = /* @__PURE__ */ Op(XH), rW = /* @__PURE__ */ Op(eW, {
  enhancer: Tp
}), iW = /* @__PURE__ */ Op(tW, {
  enhancer: PH
}), oW = /* @__PURE__ */ Op(nW, {
  enhancer: AH
}), nA = /* @__PURE__ */ Pi(lg);
function Wc(e) {
  return e.deep === !0 ? Ta : e.deep === !1 ? Tp : sW(e.defaultDecorator);
}
function aW(e) {
  var t;
  return e ? (t = e.defaultDecorator) != null ? t : eA(e) : void 0;
}
function sW(e) {
  var t, n;
  return e && (t = (n = e.options_) == null ? void 0 : n.enhancer) != null ? t : Ta;
}
function rA(e, t, n) {
  if (sc(t))
    return lg.decorate_20223_(e, t);
  if (ka(t)) {
    ac(e, t, lg);
    return;
  }
  return Iu(e) ? e : mr(e) ? hn.object(e, t, n) : Array.isArray(e) ? hn.array(e, t) : fl(e) ? hn.map(e, t) : zi(e) ? hn.set(e, t) : typeof e == "object" && e !== null ? e : hn.box(e, t);
}
B4(rA, nA);
var lW = {
  box: function(t, n) {
    var r = Hc(n);
    return new ya(t, Wc(r), r.name, !0, r.equals);
  },
  array: function(t, n) {
    var r = Hc(n);
    return (he.useProxies === !1 || r.proxy === !1 ? pZ : rZ)(t, Wc(r), r.name);
  },
  map: function(t, n) {
    var r = Hc(n);
    return new SA(t, Wc(r), r.name);
  },
  set: function(t, n) {
    var r = Hc(n);
    return new $A(t, Wc(r), r.name);
  },
  object: function(t, n, r) {
    return Ko(function() {
      return _A(he.useProxies === !1 || r?.proxy === !1 ? Ba({}, r) : JW({}, r), t, n);
    });
  },
  ref: /* @__PURE__ */ Pi(rW),
  shallow: /* @__PURE__ */ Pi(iW),
  deep: nA,
  struct: /* @__PURE__ */ Pi(oW)
}, hn = /* @__PURE__ */ B4(rA, lW), iA = "computed", uW = "computed.struct", ug = /* @__PURE__ */ Lb(iA), cW = /* @__PURE__ */ Lb(uW, {
  equals: xd.structural
}), Pp = function(t, n) {
  if (sc(n))
    return ug.decorate_20223_(t, n);
  if (ka(n))
    return ac(t, n, ug);
  if (mr(t))
    return Pi(Lb(iA, t));
  process.env.NODE_ENV !== "production" && (vn(t) || Te("First argument to `computed` should be an expression."), vn(n) && Te("A setter as second argument is no longer supported, use `{ set: fn }` option instead"));
  var r = mr(n) ? n : {};
  return r.get = t, r.name || (r.name = t.name || ""), new tr(r);
};
Object.assign(Pp, ug);
Pp.struct = /* @__PURE__ */ Pi(cW);
var tE, nE, Sd = 0, fW = 1, dW = (tE = (nE = /* @__PURE__ */ _d(function() {
}, "name")) == null ? void 0 : nE.configurable) != null ? tE : !1, rE = {
  value: "action",
  configurable: !0,
  writable: !1,
  enumerable: !1
};
function Oa(e, t, n, r) {
  n === void 0 && (n = !1), process.env.NODE_ENV !== "production" && (vn(t) || Te("`action` can only be invoked on functions"), (typeof e != "string" || !e) && Te("actions should have valid names, got: '" + e + "'"));
  function i() {
    return pW(e, n, t, r || this, arguments);
  }
  return i.isMobxAction = !0, i.toString = function() {
    return t.toString();
  }, dW && (rE.value = e, Oi(i, "name", rE)), i;
}
function pW(e, t, n, r, i) {
  var o = hW(e, t, r, i);
  try {
    return n.apply(r, i);
  } catch (a) {
    throw o.error_ = a, a;
  } finally {
    mW(o);
  }
}
function hW(e, t, n, r) {
  var i = process.env.NODE_ENV !== "production" && kn() && !!e, o = 0;
  if (process.env.NODE_ENV !== "production" && i) {
    o = Date.now();
    var a = r ? Array.from(r) : wd;
    vr({
      type: Bb,
      name: e,
      object: n,
      arguments: a
    });
  }
  var s = he.trackingDerivation, l = !t || !s;
  Ar();
  var u = he.allowStateChanges;
  l && (Va(), u = Ap(!0));
  var c = Vb(!0), f = {
    runAsAction_: l,
    prevDerivation_: s,
    prevAllowStateChanges_: u,
    prevAllowStateReads_: c,
    notifySpy_: i,
    startTime_: o,
    actionId_: fW++,
    parentActionId_: Sd
  };
  return Sd = f.actionId_, f;
}
function mW(e) {
  Sd !== e.actionId_ && Te(30), Sd = e.parentActionId_, e.error_ !== void 0 && (he.suppressReactionErrors = !0), Dp(e.prevAllowStateChanges_), cu(e.prevAllowStateReads_), Dr(), e.runAsAction_ && Ki(e.prevDerivation_), process.env.NODE_ENV !== "production" && e.notifySpy_ && gr({
    time: Date.now() - e.startTime_
  }), he.suppressReactionErrors = !1;
}
function vW(e, t) {
  var n = Ap(e);
  try {
    return t();
  } finally {
    Dp(n);
  }
}
function Ap(e) {
  var t = he.allowStateChanges;
  return he.allowStateChanges = e, t;
}
function Dp(e) {
  he.allowStateChanges = e;
}
var gW = "create", ya = /* @__PURE__ */ (function(e) {
  function t(r, i, o, a, s) {
    var l;
    if (o === void 0 && (o = process.env.NODE_ENV !== "production" ? "ObservableValue@" + ci() : "ObservableValue"), a === void 0 && (a = !0), s === void 0 && (s = xd.default), l = e.call(this, o) || this, l.enhancer = void 0, l.name_ = void 0, l.equals = void 0, l.hasUnreportedChange_ = !1, l.interceptors_ = void 0, l.changeListeners_ = void 0, l.value_ = void 0, l.dehancer = void 0, l.enhancer = i, l.name_ = o, l.equals = s, l.value_ = i(r, void 0, o), process.env.NODE_ENV !== "production" && a && kn()) {
      var u;
      Pa({
        type: gW,
        object: l,
        observableKind: "value",
        debugObjectName: l.name_,
        newValue: "" + ((u = l.value_) == null ? void 0 : u.toString())
      });
    }
    return l;
  }
  Fb(t, e);
  var n = t.prototype;
  return n.dehanceValue = function(i) {
    return this.dehancer !== void 0 ? this.dehancer(i) : i;
  }, n.set = function(i) {
    var o = this.value_;
    if (i = this.prepareNewValue_(i), i !== he.UNCHANGED) {
      var a = kn();
      process.env.NODE_ENV !== "production" && a && vr({
        type: ti,
        object: this,
        observableKind: "value",
        debugObjectName: this.name_,
        newValue: i,
        oldValue: o
      }), this.setNewValue_(i), process.env.NODE_ENV !== "production" && a && gr();
    }
  }, n.prepareNewValue_ = function(i) {
    if (ki(this), Tr(this)) {
      var o = Or(this, {
        object: this,
        type: ti,
        newValue: i
      });
      if (!o)
        return he.UNCHANGED;
      i = o.newValue;
    }
    return i = this.enhancer(i, this.value_, this.name_), this.equals(this.value_, i) ? he.UNCHANGED : i;
  }, n.setNewValue_ = function(i) {
    var o = this.value_;
    this.value_ = i, this.reportChanged(), ri(this) && ii(this, {
      type: ti,
      object: this,
      newValue: i,
      oldValue: o
    });
  }, n.get = function() {
    return this.reportObserved(), this.dehanceValue(this.value_);
  }, n.intercept_ = function(i) {
    return uc(this, i);
  }, n.observe_ = function(i, o) {
    return o && i({
      observableKind: "value",
      debugObjectName: this.name_,
      object: this,
      type: ti,
      newValue: this.value_,
      oldValue: void 0
    }), cc(this, i);
  }, n.raw = function() {
    return this.value_;
  }, n.toJSON = function() {
    return this.get();
  }, n.toString = function() {
    return this.name_ + "[" + this.value_ + "]";
  }, n.valueOf = function() {
    return Z4(this.get());
  }, n[Symbol.toPrimitive] = function() {
    return this.valueOf();
  }, t;
})(Vo), tr = /* @__PURE__ */ (function() {
  function e(n) {
    this.dependenciesState_ = ct.NOT_TRACKING_, this.observing_ = [], this.newObserving_ = null, this.observers_ = /* @__PURE__ */ new Set(), this.runId_ = 0, this.lastAccessedBy_ = 0, this.lowestObserverState_ = ct.UP_TO_DATE_, this.unboundDepsCount_ = 0, this.value_ = new $d(null), this.name_ = void 0, this.triggeredBy_ = void 0, this.flags_ = 0, this.derivation = void 0, this.setter_ = void 0, this.isTracing_ = jr.NONE, this.scope_ = void 0, this.equals_ = void 0, this.requiresReaction_ = void 0, this.keepAlive_ = void 0, this.onBOL = void 0, this.onBUOL = void 0, n.get || Te(31), this.derivation = n.get, this.name_ = n.name || (process.env.NODE_ENV !== "production" ? "ComputedValue@" + ci() : "ComputedValue"), n.set && (this.setter_ = Oa(process.env.NODE_ENV !== "production" ? this.name_ + "-setter" : "ComputedValue-setter", n.set)), this.equals_ = n.equals || (n.compareStructural || n.struct ? xd.structural : xd.default), this.scope_ = n.context, this.requiresReaction_ = n.requiresReaction, this.keepAlive_ = !!n.keepAlive;
  }
  var t = e.prototype;
  return t.onBecomeStale_ = function() {
    $W(this);
  }, t.onBO = function() {
    this.onBOL && this.onBOL.forEach(function(r) {
      return r();
    });
  }, t.onBUO = function() {
    this.onBUOL && this.onBUOL.forEach(function(r) {
      return r();
    });
  }, t.get = function() {
    if (this.isComputing && Te(32, this.name_, this.derivation), he.inBatch === 0 && // !globalState.trackingDerivatpion &&
    this.observers_.size === 0 && !this.keepAlive_)
      cg(this) && (this.warnAboutUntrackedRead_(), Ar(), this.value_ = this.computeValue_(!1), Dr());
    else if (fA(this), cg(this)) {
      var r = he.trackingContext;
      this.keepAlive_ && !r && (he.trackingContext = this), this.trackAndCompute() && SW(this), he.trackingContext = r;
    }
    var i = this.value_;
    if (Of(i))
      throw i.cause;
    return i;
  }, t.set = function(r) {
    if (this.setter_) {
      this.isRunningSetter && Te(33, this.name_), this.isRunningSetter = !0;
      try {
        this.setter_.call(this.scope_, r);
      } finally {
        this.isRunningSetter = !1;
      }
    } else
      Te(34, this.name_);
  }, t.trackAndCompute = function() {
    var r = this.value_, i = (
      /* see #1208 */
      this.dependenciesState_ === ct.NOT_TRACKING_
    ), o = this.computeValue_(!0), a = i || Of(r) || Of(o) || !this.equals_(r, o);
    return a && (this.value_ = o, process.env.NODE_ENV !== "production" && kn() && Pa({
      observableKind: "computed",
      debugObjectName: this.name_,
      object: this.scope_,
      type: "update",
      oldValue: r,
      newValue: o
    })), a;
  }, t.computeValue_ = function(r) {
    this.isComputing = !0;
    var i = Ap(!1), o;
    if (r)
      o = oA(this, this.derivation, this.scope_);
    else if (he.disableErrorBoundaries === !0)
      o = this.derivation.call(this.scope_);
    else
      try {
        o = this.derivation.call(this.scope_);
      } catch (a) {
        o = new $d(a);
      }
    return Dp(i), this.isComputing = !1, o;
  }, t.suspend_ = function() {
    this.keepAlive_ || (fg(this), this.value_ = void 0, process.env.NODE_ENV !== "production" && this.isTracing_ !== jr.NONE && console.log("[mobx.trace] Computed value '" + this.name_ + "' was suspended and it will recompute on the next access."));
  }, t.observe_ = function(r, i) {
    var o = this, a = !0, s = void 0;
    return RW(function() {
      var l = o.get();
      if (!a || i) {
        var u = Va();
        r({
          observableKind: "computed",
          debugObjectName: o.name_,
          type: ti,
          object: o,
          newValue: l,
          oldValue: s
        }), Ki(u);
      }
      a = !1, s = l;
    });
  }, t.warnAboutUntrackedRead_ = function() {
    process.env.NODE_ENV !== "production" && (this.isTracing_ !== jr.NONE && console.log("[mobx.trace] Computed value '" + this.name_ + "' is being read outside a reactive context. Doing a full recompute."), (typeof this.requiresReaction_ == "boolean" ? this.requiresReaction_ : he.computedRequiresReaction) && console.warn("[mobx] Computed value '" + this.name_ + "' is being read outside a reactive context. Doing a full recompute."));
  }, t.toString = function() {
    return this.name_ + "[" + this.derivation.toString() + "]";
  }, t.valueOf = function() {
    return Z4(this.get());
  }, t[Symbol.toPrimitive] = function() {
    return this.valueOf();
  }, dl(e, [{
    key: "isComputing",
    get: function() {
      return cr(this.flags_, e.isComputingMask_);
    },
    set: function(r) {
      this.flags_ = fr(this.flags_, e.isComputingMask_, r);
    }
  }, {
    key: "isRunningSetter",
    get: function() {
      return cr(this.flags_, e.isRunningSetterMask_);
    },
    set: function(r) {
      this.flags_ = fr(this.flags_, e.isRunningSetterMask_, r);
    }
  }, {
    key: "isBeingObserved",
    get: function() {
      return cr(this.flags_, e.isBeingObservedMask_);
    },
    set: function(r) {
      this.flags_ = fr(this.flags_, e.isBeingObservedMask_, r);
    }
  }, {
    key: "isPendingUnobservation",
    get: function() {
      return cr(this.flags_, e.isPendingUnobservationMask_);
    },
    set: function(r) {
      this.flags_ = fr(this.flags_, e.isPendingUnobservationMask_, r);
    }
  }, {
    key: "diffValue",
    get: function() {
      return cr(this.flags_, e.diffValueMask_) ? 1 : 0;
    },
    set: function(r) {
      this.flags_ = fr(this.flags_, e.diffValueMask_, r === 1);
    }
  }]);
})();
tr.isComputingMask_ = 1;
tr.isRunningSetterMask_ = 2;
tr.isBeingObservedMask_ = 4;
tr.isPendingUnobservationMask_ = 8;
tr.diffValueMask_ = 16;
var Cp = /* @__PURE__ */ La("ComputedValue", tr), ct;
(function(e) {
  e[e.NOT_TRACKING_ = -1] = "NOT_TRACKING_", e[e.UP_TO_DATE_ = 0] = "UP_TO_DATE_", e[e.POSSIBLY_STALE_ = 1] = "POSSIBLY_STALE_", e[e.STALE_ = 2] = "STALE_";
})(ct || (ct = {}));
var jr;
(function(e) {
  e[e.NONE = 0] = "NONE", e[e.LOG = 1] = "LOG", e[e.BREAK = 2] = "BREAK";
})(jr || (jr = {}));
var $d = function(t) {
  this.cause = void 0, this.cause = t;
};
function Of(e) {
  return e instanceof $d;
}
function cg(e) {
  switch (e.dependenciesState_) {
    case ct.UP_TO_DATE_:
      return !1;
    case ct.NOT_TRACKING_:
    case ct.STALE_:
      return !0;
    case ct.POSSIBLY_STALE_: {
      for (var t = Vb(!0), n = Va(), r = e.observing_, i = r.length, o = 0; o < i; o++) {
        var a = r[o];
        if (Cp(a)) {
          if (he.disableErrorBoundaries)
            a.get();
          else
            try {
              a.get();
            } catch {
              return Ki(n), cu(t), !0;
            }
          if (e.dependenciesState_ === ct.STALE_)
            return Ki(n), cu(t), !0;
        }
      }
      return sA(e), Ki(n), cu(t), !1;
    }
  }
}
function ki(e) {
  if (process.env.NODE_ENV !== "production") {
    var t = e.observers_.size > 0;
    !he.allowStateChanges && (t || he.enforceActions === "always") && console.warn("[MobX] " + (he.enforceActions ? "Since strict-mode is enabled, changing (observed) observable values without using an action is not allowed. Tried to modify: " : "Side effects like changing state are not allowed at this point. Are you trying to modify state from, for example, a computed value or the render function of a React component? You can wrap side effects in 'runInAction' (or decorate functions with 'action') if needed. Tried to modify: ") + e.name_);
  }
}
function yW(e) {
  process.env.NODE_ENV !== "production" && !he.allowStateReads && he.observableRequiresReaction && console.warn("[mobx] Observable '" + e.name_ + "' being read outside a reactive context.");
}
function oA(e, t, n) {
  var r = Vb(!0);
  sA(e), e.newObserving_ = new Array(
    // Reserve constant space for initial dependencies, dynamic space otherwise.
    // See https://github.com/mobxjs/mobx/pull/3833
    e.runId_ === 0 ? 100 : e.observing_.length
  ), e.unboundDepsCount_ = 0, e.runId_ = ++he.runId;
  var i = he.trackingDerivation;
  he.trackingDerivation = e, he.inBatch++;
  var o;
  if (he.disableErrorBoundaries === !0)
    o = t.call(n);
  else
    try {
      o = t.call(n);
    } catch (a) {
      o = new $d(a);
    }
  return he.inBatch--, he.trackingDerivation = i, _W(e), bW(e), cu(r), o;
}
function bW(e) {
  process.env.NODE_ENV !== "production" && e.observing_.length === 0 && (typeof e.requiresObservable_ == "boolean" ? e.requiresObservable_ : he.reactionRequiresObservable) && console.warn("[mobx] Derivation '" + e.name_ + "' is created/updated without reading any observable value.");
}
function _W(e) {
  for (var t = e.observing_, n = e.observing_ = e.newObserving_, r = ct.UP_TO_DATE_, i = 0, o = e.unboundDepsCount_, a = 0; a < o; a++) {
    var s = n[a];
    s.diffValue === 0 && (s.diffValue = 1, i !== a && (n[i] = s), i++), s.dependenciesState_ > r && (r = s.dependenciesState_);
  }
  for (n.length = i, e.newObserving_ = null, o = t.length; o--; ) {
    var l = t[o];
    l.diffValue === 0 && uA(l, e), l.diffValue = 0;
  }
  for (; i--; ) {
    var u = n[i];
    u.diffValue === 1 && (u.diffValue = 0, EW(u, e));
  }
  r !== ct.UP_TO_DATE_ && (e.dependenciesState_ = r, e.onBecomeStale_());
}
function fg(e) {
  var t = e.observing_;
  e.observing_ = [];
  for (var n = t.length; n--; )
    uA(t[n], e);
  e.dependenciesState_ = ct.NOT_TRACKING_;
}
function aA(e) {
  var t = Va();
  try {
    return e();
  } finally {
    Ki(t);
  }
}
function Va() {
  var e = he.trackingDerivation;
  return he.trackingDerivation = null, e;
}
function Ki(e) {
  he.trackingDerivation = e;
}
function Vb(e) {
  var t = he.allowStateReads;
  return he.allowStateReads = e, t;
}
function cu(e) {
  he.allowStateReads = e;
}
function sA(e) {
  if (e.dependenciesState_ !== ct.UP_TO_DATE_) {
    e.dependenciesState_ = ct.UP_TO_DATE_;
    for (var t = e.observing_, n = t.length; n--; )
      t[n].lowestObserverState_ = ct.UP_TO_DATE_;
  }
}
var Pf = function() {
  this.version = 6, this.UNCHANGED = {}, this.trackingDerivation = null, this.trackingContext = null, this.runId = 0, this.mobxGuid = 0, this.inBatch = 0, this.pendingUnobservations = [], this.pendingReactions = [], this.isRunningReactions = !1, this.allowStateChanges = !1, this.allowStateReads = !0, this.enforceActions = !0, this.spyListeners = [], this.globalReactionErrorHandlers = [], this.computedRequiresReaction = !1, this.reactionRequiresObservable = !1, this.observableRequiresReaction = !1, this.disableErrorBoundaries = !1, this.suppressReactionErrors = !1, this.useProxies = !0, this.verifyProxies = !1, this.safeDescriptors = !0;
}, Af = !0, lA = !1, he = /* @__PURE__ */ (function() {
  var e = /* @__PURE__ */ Ep();
  return e.__mobxInstanceCount > 0 && !e.__mobxGlobals && (Af = !1), e.__mobxGlobals && e.__mobxGlobals.version !== new Pf().version && (Af = !1), Af ? e.__mobxGlobals ? (e.__mobxInstanceCount += 1, e.__mobxGlobals.UNCHANGED || (e.__mobxGlobals.UNCHANGED = {}), e.__mobxGlobals) : (e.__mobxInstanceCount = 1, e.__mobxGlobals = /* @__PURE__ */ new Pf()) : (setTimeout(function() {
    lA || Te(35);
  }, 1), new Pf());
})();
function wW() {
  if ((he.pendingReactions.length || he.inBatch || he.isRunningReactions) && Te(36), lA = !0, Af) {
    var e = Ep();
    --e.__mobxInstanceCount === 0 && (e.__mobxGlobals = void 0), he = new Pf();
  }
}
function xW() {
  return he;
}
function EW(e, t) {
  e.observers_.add(t), e.lowestObserverState_ > t.dependenciesState_ && (e.lowestObserverState_ = t.dependenciesState_);
}
function uA(e, t) {
  e.observers_.delete(t), e.observers_.size === 0 && cA(e);
}
function cA(e) {
  e.isPendingUnobservation === !1 && (e.isPendingUnobservation = !0, he.pendingUnobservations.push(e));
}
function Ar() {
  he.inBatch++;
}
function Dr() {
  if (--he.inBatch === 0) {
    mA();
    for (var e = he.pendingUnobservations, t = 0; t < e.length; t++) {
      var n = e[t];
      n.isPendingUnobservation = !1, n.observers_.size === 0 && (n.isBeingObserved && (n.isBeingObserved = !1, n.onBUO()), n instanceof tr && n.suspend_());
    }
    he.pendingUnobservations = [];
  }
}
function fA(e) {
  yW(e);
  var t = he.trackingDerivation;
  return t !== null ? (t.runId_ !== e.lastAccessedBy_ && (e.lastAccessedBy_ = t.runId_, t.newObserving_[t.unboundDepsCount_++] = e, !e.isBeingObserved && he.trackingContext && (e.isBeingObserved = !0, e.onBO())), e.isBeingObserved) : (e.observers_.size === 0 && he.inBatch > 0 && cA(e), !1);
}
function dA(e) {
  e.lowestObserverState_ !== ct.STALE_ && (e.lowestObserverState_ = ct.STALE_, e.observers_.forEach(function(t) {
    t.dependenciesState_ === ct.UP_TO_DATE_ && (process.env.NODE_ENV !== "production" && t.isTracing_ !== jr.NONE && pA(t, e), t.onBecomeStale_()), t.dependenciesState_ = ct.STALE_;
  }));
}
function SW(e) {
  e.lowestObserverState_ !== ct.STALE_ && (e.lowestObserverState_ = ct.STALE_, e.observers_.forEach(function(t) {
    t.dependenciesState_ === ct.POSSIBLY_STALE_ ? (t.dependenciesState_ = ct.STALE_, process.env.NODE_ENV !== "production" && t.isTracing_ !== jr.NONE && pA(t, e)) : t.dependenciesState_ === ct.UP_TO_DATE_ && (e.lowestObserverState_ = ct.UP_TO_DATE_);
  }));
}
function $W(e) {
  e.lowestObserverState_ === ct.UP_TO_DATE_ && (e.lowestObserverState_ = ct.POSSIBLY_STALE_, e.observers_.forEach(function(t) {
    t.dependenciesState_ === ct.UP_TO_DATE_ && (t.dependenciesState_ = ct.POSSIBLY_STALE_, t.onBecomeStale_());
  }));
}
function pA(e, t) {
  if (console.log("[mobx.trace] '" + e.name_ + "' is invalidated due to a change in: '" + t.name_ + "'"), e.isTracing_ === jr.BREAK) {
    var n = [];
    hA(wA(e), n, 1), new Function(`debugger;
/*
Tracing '` + e.name_ + `'

You are entering this break point because derivation '` + e.name_ + "' is being traced and '" + t.name_ + `' is now forcing it to update.
Just follow the stacktrace you should now see in the devtools to see precisely what piece of your code is causing this update
The stackframe you are looking for is at least ~6-8 stack-frames up.

` + (e instanceof tr ? e.derivation.toString().replace(/[*]\//g, "/") : "") + `

The dependencies for this derivation are:

` + n.join(`
`) + `
*/
    `)();
  }
}
function hA(e, t, n) {
  if (t.length >= 1e3) {
    t.push("(and many more)");
    return;
  }
  t.push("" + "	".repeat(n - 1) + e.name), e.dependencies && e.dependencies.forEach(function(r) {
    return hA(r, t, n + 1);
  });
}
var Di = /* @__PURE__ */ (function() {
  function e(n, r, i, o) {
    n === void 0 && (n = process.env.NODE_ENV !== "production" ? "Reaction@" + ci() : "Reaction"), this.name_ = void 0, this.onInvalidate_ = void 0, this.errorHandler_ = void 0, this.requiresObservable_ = void 0, this.observing_ = [], this.newObserving_ = [], this.dependenciesState_ = ct.NOT_TRACKING_, this.runId_ = 0, this.unboundDepsCount_ = 0, this.flags_ = 0, this.isTracing_ = jr.NONE, this.name_ = n, this.onInvalidate_ = r, this.errorHandler_ = i, this.requiresObservable_ = o;
  }
  var t = e.prototype;
  return t.onBecomeStale_ = function() {
    this.schedule_();
  }, t.schedule_ = function() {
    this.isScheduled || (this.isScheduled = !0, he.pendingReactions.push(this), mA());
  }, t.runReaction_ = function() {
    if (!this.isDisposed) {
      Ar(), this.isScheduled = !1;
      var r = he.trackingContext;
      if (he.trackingContext = this, cg(this)) {
        this.isTrackPending = !0;
        try {
          this.onInvalidate_(), process.env.NODE_ENV !== "production" && this.isTrackPending && kn() && Pa({
            name: this.name_,
            type: "scheduled-reaction"
          });
        } catch (i) {
          this.reportExceptionInDerivation_(i);
        }
      }
      he.trackingContext = r, Dr();
    }
  }, t.track = function(r) {
    if (!this.isDisposed) {
      Ar();
      var i = kn(), o;
      process.env.NODE_ENV !== "production" && i && (o = Date.now(), vr({
        name: this.name_,
        type: "reaction"
      })), this.isRunning = !0;
      var a = he.trackingContext;
      he.trackingContext = this;
      var s = oA(this, r, void 0);
      he.trackingContext = a, this.isRunning = !1, this.isTrackPending = !1, this.isDisposed && fg(this), Of(s) && this.reportExceptionInDerivation_(s.cause), process.env.NODE_ENV !== "production" && i && gr({
        time: Date.now() - o
      }), Dr();
    }
  }, t.reportExceptionInDerivation_ = function(r) {
    var i = this;
    if (this.errorHandler_) {
      this.errorHandler_(r, this);
      return;
    }
    if (he.disableErrorBoundaries)
      throw r;
    var o = process.env.NODE_ENV !== "production" ? "[mobx] Encountered an uncaught exception that was thrown by a reaction or observer component, in: '" + this + "'" : "[mobx] uncaught error in '" + this + "'";
    he.suppressReactionErrors ? process.env.NODE_ENV !== "production" && console.warn("[mobx] (error in reaction '" + this.name_ + "' suppressed, fix error of causing action below)") : console.error(o, r), process.env.NODE_ENV !== "production" && kn() && Pa({
      type: "error",
      name: this.name_,
      message: o,
      error: "" + r
    }), he.globalReactionErrorHandlers.forEach(function(a) {
      return a(r, i);
    });
  }, t.dispose = function() {
    this.isDisposed || (this.isDisposed = !0, this.isRunning || (Ar(), fg(this), Dr()));
  }, t.getDisposer_ = function(r) {
    var i = this, o = function a() {
      i.dispose(), r == null || r.removeEventListener == null || r.removeEventListener("abort", a);
    };
    return r == null || r.addEventListener == null || r.addEventListener("abort", o), o[Ze] = this, "dispose" in Symbol && typeof Symbol.dispose == "symbol" && (o[Symbol.dispose] = o), o;
  }, t.toString = function() {
    return "Reaction[" + this.name_ + "]";
  }, t.trace = function(r) {
    r === void 0 && (r = !1), GW(this, r);
  }, dl(e, [{
    key: "isDisposed",
    get: function() {
      return cr(this.flags_, e.isDisposedMask_);
    },
    set: function(r) {
      this.flags_ = fr(this.flags_, e.isDisposedMask_, r);
    }
  }, {
    key: "isScheduled",
    get: function() {
      return cr(this.flags_, e.isScheduledMask_);
    },
    set: function(r) {
      this.flags_ = fr(this.flags_, e.isScheduledMask_, r);
    }
  }, {
    key: "isTrackPending",
    get: function() {
      return cr(this.flags_, e.isTrackPendingMask_);
    },
    set: function(r) {
      this.flags_ = fr(this.flags_, e.isTrackPendingMask_, r);
    }
  }, {
    key: "isRunning",
    get: function() {
      return cr(this.flags_, e.isRunningMask_);
    },
    set: function(r) {
      this.flags_ = fr(this.flags_, e.isRunningMask_, r);
    }
  }, {
    key: "diffValue",
    get: function() {
      return cr(this.flags_, e.diffValueMask_) ? 1 : 0;
    },
    set: function(r) {
      this.flags_ = fr(this.flags_, e.diffValueMask_, r === 1);
    }
  }]);
})();
Di.isDisposedMask_ = 1;
Di.isScheduledMask_ = 2;
Di.isTrackPendingMask_ = 4;
Di.isRunningMask_ = 8;
Di.diffValueMask_ = 16;
var iE = 100, dg = function(t) {
  return t();
};
function mA() {
  he.inBatch > 0 || he.isRunningReactions || dg(kW);
}
function kW() {
  he.isRunningReactions = !0;
  for (var e = he.pendingReactions, t = 0; e.length > 0; ) {
    ++t === iE && (console.error(process.env.NODE_ENV !== "production" ? "Reaction doesn't converge to a stable state after " + iE + " iterations." + (" Probably there is a cycle in the reactive function: " + e[0]) : "[mobx] cycle in reaction: " + e[0]), e.splice(0));
    for (var n = e.splice(0), r = 0, i = n.length; r < i; r++)
      n[r].runReaction_();
  }
  he.isRunningReactions = !1;
}
var kd = /* @__PURE__ */ La("Reaction", Di);
function TW(e) {
  var t = dg;
  dg = function(r) {
    return e(function() {
      return t(r);
    });
  };
}
function kn() {
  return process.env.NODE_ENV !== "production" && !!he.spyListeners.length;
}
function Pa(e) {
  if (process.env.NODE_ENV !== "production" && he.spyListeners.length)
    for (var t = he.spyListeners, n = 0, r = t.length; n < r; n++)
      t[n](e);
}
function vr(e) {
  if (process.env.NODE_ENV !== "production") {
    var t = Gi({}, e, {
      spyReportStart: !0
    });
    Pa(t);
  }
}
var OW = {
  type: "report-end",
  spyReportEnd: !0
};
function gr(e) {
  process.env.NODE_ENV !== "production" && Pa(e ? Gi({}, e, {
    type: "report-end",
    spyReportEnd: !0
  }) : OW);
}
function PW(e) {
  return process.env.NODE_ENV === "production" ? (console.warn("[mobx.spy] Is a no-op in production builds"), function() {
  }) : (he.spyListeners.push(e), jb(function() {
    he.spyListeners = he.spyListeners.filter(function(t) {
      return t !== e;
    });
  }));
}
var Bb = "action", AW = "action.bound", vA = "autoAction", DW = "autoAction.bound", CW = "<unnamed action>", pg = /* @__PURE__ */ lc(Bb), IW = /* @__PURE__ */ lc(AW, {
  bound: !0
}), hg = /* @__PURE__ */ lc(vA, {
  autoAction: !0
}), MW = /* @__PURE__ */ lc(DW, {
  autoAction: !0,
  bound: !0
});
function gA(e) {
  var t = function(r, i) {
    if (vn(r))
      return Oa(r.name || CW, r, e);
    if (vn(i))
      return Oa(r, i, e);
    if (sc(i))
      return (e ? hg : pg).decorate_20223_(r, i);
    if (ka(i))
      return ac(r, i, e ? hg : pg);
    if (ka(r))
      return Pi(lc(e ? vA : Bb, {
        name: r,
        autoAction: e
      }));
    process.env.NODE_ENV !== "production" && Te("Invalid arguments for `action`");
  };
  return t;
}
var vs = /* @__PURE__ */ gA(!1);
Object.assign(vs, pg);
var Du = /* @__PURE__ */ gA(!0);
Object.assign(Du, hg);
vs.bound = /* @__PURE__ */ Pi(IW);
Du.bound = /* @__PURE__ */ Pi(MW);
function Aa(e) {
  return vn(e) && e.isMobxAction === !0;
}
function RW(e, t) {
  var n, r, i, o;
  t === void 0 && (t = K4), process.env.NODE_ENV !== "production" && (vn(e) || Te("Autorun expects a function as first argument"), Aa(e) && Te("Autorun does not accept actions since actions are untrackable"));
  var a = (n = (r = t) == null ? void 0 : r.name) != null ? n : process.env.NODE_ENV !== "production" ? e.name || "Autorun@" + ci() : "Autorun", s = !t.scheduler && !t.delay, l;
  if (s)
    l = new Di(a, function() {
      this.track(f);
    }, t.onError, t.requiresObservable);
  else {
    var u = jW(t), c = !1;
    l = new Di(a, function() {
      c || (c = !0, u(function() {
        c = !1, l.isDisposed || l.track(f);
      }));
    }, t.onError, t.requiresObservable);
  }
  function f() {
    e(l);
  }
  return (i = t) != null && (i = i.signal) != null && i.aborted || l.schedule_(), l.getDisposer_((o = t) == null ? void 0 : o.signal);
}
var NW = function(t) {
  return t();
};
function jW(e) {
  return e.scheduler ? e.scheduler : e.delay ? function(t) {
    return setTimeout(t, e.delay);
  } : NW;
}
var FW = "onBO", zW = "onBUO";
function LW(e, t, n) {
  return bA(FW, e, t, n);
}
function yA(e, t, n) {
  return bA(zW, e, t, n);
}
function bA(e, t, n, r) {
  var i = Vs(t), o = vn(r) ? r : n, a = e + "L";
  return i[a] ? i[a].add(o) : i[a] = /* @__PURE__ */ new Set([o]), function() {
    var s = i[a];
    s && (s.delete(o), s.size === 0 && delete i[a]);
  };
}
var VW = "never", Zc = "always", BW = "observed";
function KW(e) {
  e.isolateGlobalState === !0 && wW();
  var t = e.useProxies, n = e.enforceActions;
  if (t !== void 0 && (he.useProxies = t === Zc ? !0 : t === VW ? !1 : typeof Proxy < "u"), t === "ifavailable" && (he.verifyProxies = !0), n !== void 0) {
    var r = n === Zc ? Zc : n === BW;
    he.enforceActions = r, he.allowStateChanges = !(r === !0 || r === Zc);
  }
  ["computedRequiresReaction", "reactionRequiresObservable", "observableRequiresReaction", "disableErrorBoundaries", "safeDescriptors"].forEach(function(i) {
    i in e && (he[i] = !!e[i]);
  }), he.allowStateReads = !he.observableRequiresReaction, process.env.NODE_ENV !== "production" && he.disableErrorBoundaries === !0 && console.warn("WARNING: Debug feature only. MobX will NOT recover from errors when `disableErrorBoundaries` is enabled."), e.reactionScheduler && TW(e.reactionScheduler);
}
function _A(e, t, n, r) {
  process.env.NODE_ENV !== "production" && (arguments.length > 4 && Te("'extendObservable' expected 2-4 arguments"), typeof e != "object" && Te("'extendObservable' expects an object as first argument"), Bo(e) && Te("'extendObservable' should not be used on maps, use map.merge instead"), mr(t) || Te("'extendObservable' only accepts plain objects as second argument"), (Iu(t) || Iu(n)) && Te("Extending an object with another observable (object) is not supported"));
  var i = yH(t);
  return Ko(function() {
    var o = Ba(e, r)[Ze];
    zs(i).forEach(function(a) {
      o.extend_(
        a,
        i[a],
        // must pass "undefined" for { key: undefined }
        n && a in n ? n[a] : !0
      );
    });
  }), e;
}
function wA(e, t) {
  return xA(Vs(e, t));
}
function xA(e) {
  var t = {
    name: e.name_
  };
  return e.observing_ && e.observing_.length > 0 && (t.dependencies = UW(e.observing_).map(xA)), t;
}
function UW(e) {
  return Array.from(new Set(e));
}
var qW = 0, HW = /* @__PURE__ */ (function(e) {
  function t() {
    var r;
    return r = e.call(this, "FLOW_CANCELLED") || this, Object.setPrototypeOf(r, (this instanceof t ? this.constructor : void 0).prototype), r.name = "FlowCancellationError", r;
  }
  Fb(t, e);
  var n = t.prototype;
  return n.toString = function() {
    return "Error: " + this.message;
  }, t;
})(/* @__PURE__ */ sg(Error)), tm = /* @__PURE__ */ J4("flow"), WW = /* @__PURE__ */ J4("flow.bound", {
  bound: !0
}), Ls = /* @__PURE__ */ Object.assign(function(t, n) {
  if (sc(n))
    return tm.decorate_20223_(t, n);
  if (ka(n))
    return ac(t, n, tm);
  process.env.NODE_ENV !== "production" && arguments.length !== 1 && Te("Flow expects single argument with generator function");
  var r = t, i = r.name || "<unnamed flow>", o = function() {
    var s = this, l = arguments, u = ++qW, c = vs(i + " - runid: " + u + " - init", r).apply(s, l), f, d = void 0, p = new Promise(function(h, v) {
      var m = 0;
      f = v;
      function g(w) {
        d = void 0;
        var $;
        try {
          $ = vs(i + " - runid: " + u + " - yield " + m++, c.next).call(c, w);
        } catch (k) {
          return v(k);
        }
        x($);
      }
      function _(w) {
        d = void 0;
        var $;
        try {
          $ = vs(i + " - runid: " + u + " - yield " + m++, c.throw).call(c, w);
        } catch (k) {
          return v(k);
        }
        x($);
      }
      function x(w) {
        if (vn(w?.then)) {
          w.then(x, v);
          return;
        }
        return w.done ? h(w.value) : (d = Promise.resolve(w.value), d.then(g, _));
      }
      g(void 0);
    });
    return p.cancel = vs(i + " - runid: " + u + " - cancel", function() {
      try {
        d && oE(d);
        var h = c.return(void 0), v = Promise.resolve(h.value);
        v.then(hs, hs), oE(v), f(new HW());
      } catch (m) {
        f(m);
      }
    }), p;
  };
  return o.isMobXFlow = !0, o;
}, tm);
Ls.bound = /* @__PURE__ */ Pi(WW);
function oE(e) {
  vn(e.cancel) && e.cancel();
}
function Cu(e) {
  return e?.isMobXFlow === !0;
}
function ZW(e, t) {
  return e ? pl(e) || !!e[Ze] || zb(e) || kd(e) || Cp(e) : !1;
}
function Iu(e) {
  return process.env.NODE_ENV !== "production" && arguments.length !== 1 && Te("isObservable expects only 1 argument. Use isObservableProp to inspect the observability of a property"), ZW(e);
}
function GW() {
  if (process.env.NODE_ENV !== "production") {
    for (var e = !1, t = arguments.length, n = new Array(t), r = 0; r < t; r++)
      n[r] = arguments[r];
    typeof n[n.length - 1] == "boolean" && (e = n.pop());
    var i = YW(n);
    if (!i)
      return Te("'trace(break?)' can only be used inside a tracked computed value or a Reaction. Consider passing in the computed value or reaction explicitly");
    i.isTracing_ === jr.NONE && console.log("[mobx.trace] '" + i.name_ + "' tracing enabled"), i.isTracing_ = e ? jr.BREAK : jr.LOG;
  }
}
function YW(e) {
  switch (e.length) {
    case 0:
      return he.trackingDerivation;
    case 1:
      return Vs(e[0]);
    case 2:
      return Vs(e[0], e[1]);
  }
}
function Li(e, t) {
  t === void 0 && (t = void 0), Ar();
  try {
    return e.apply(t);
  } finally {
    Dr();
  }
}
function Jo(e) {
  return e[Ze];
}
var QW = {
  has: function(t, n) {
    return process.env.NODE_ENV !== "production" && he.trackingDerivation && Nl("detect new properties using the 'in' operator. Use 'has' from 'mobx' instead."), Jo(t).has_(n);
  },
  get: function(t, n) {
    return Jo(t).get_(n);
  },
  set: function(t, n, r) {
    var i;
    return ka(n) ? (process.env.NODE_ENV !== "production" && !Jo(t).values_.has(n) && Nl("add a new observable property through direct assignment. Use 'set' from 'mobx' instead."), (i = Jo(t).set_(n, r, !0)) != null ? i : !0) : !1;
  },
  deleteProperty: function(t, n) {
    var r;
    return process.env.NODE_ENV !== "production" && Nl("delete properties from an observable object. Use 'remove' from 'mobx' instead."), ka(n) ? (r = Jo(t).delete_(n, !0)) != null ? r : !0 : !1;
  },
  defineProperty: function(t, n, r) {
    var i;
    return process.env.NODE_ENV !== "production" && Nl("define property on an observable object. Use 'defineProperty' from 'mobx' instead."), (i = Jo(t).defineProperty_(n, r)) != null ? i : !0;
  },
  ownKeys: function(t) {
    return process.env.NODE_ENV !== "production" && he.trackingDerivation && Nl("iterate keys to detect added / removed properties. Use 'keys' from 'mobx' instead."), Jo(t).ownKeys_();
  },
  preventExtensions: function(t) {
    Te(13);
  }
};
function JW(e, t) {
  var n, r;
  return U4(), e = Ba(e, t), (r = (n = e[Ze]).proxy_) != null ? r : n.proxy_ = new Proxy(e, QW);
}
function Tr(e) {
  return e.interceptors_ !== void 0 && e.interceptors_.length > 0;
}
function uc(e, t) {
  var n = e.interceptors_ || (e.interceptors_ = []);
  return n.push(t), jb(function() {
    var r = n.indexOf(t);
    r !== -1 && n.splice(r, 1);
  });
}
function Or(e, t) {
  var n = Va();
  try {
    for (var r = [].concat(e.interceptors_ || []), i = 0, o = r.length; i < o && (t = r[i](t), t && !t.type && Te(14), !!t); i++)
      ;
    return t;
  } finally {
    Ki(n);
  }
}
function ri(e) {
  return e.changeListeners_ !== void 0 && e.changeListeners_.length > 0;
}
function cc(e, t) {
  var n = e.changeListeners_ || (e.changeListeners_ = []);
  return n.push(t), jb(function() {
    var r = n.indexOf(t);
    r !== -1 && n.splice(r, 1);
  });
}
function ii(e, t) {
  var n = Va(), r = e.changeListeners_;
  if (r) {
    r = r.slice();
    for (var i = 0, o = r.length; i < o; i++)
      r[i](t);
    Ki(n);
  }
}
function XW(e, t, n) {
  return Ko(function() {
    var r, i = Ba(e, n)[Ze];
    process.env.NODE_ENV !== "production" && t && e[Xn] && Te("makeObservable second arg must be nullish when using decorators. Mixing @decorator syntax with annotations is not supported."), (r = t) != null || (t = kH(e)), zs(t).forEach(function(o) {
      return i.make_(o, t[o]);
    });
  }), e;
}
var nm = /* @__PURE__ */ Symbol("mobx-keys");
function eZ(e, t, n) {
  return process.env.NODE_ENV !== "production" && (!mr(e) && !mr(Object.getPrototypeOf(e)) && Te("'makeAutoObservable' can only be used for classes that don't have a superclass"), pl(e) && Te("makeAutoObservable can only be used on objects not already made observable")), mr(e) ? _A(e, e, t, n) : (Ko(function() {
    var r = Ba(e, n)[Ze];
    if (!e[nm]) {
      var i = Object.getPrototypeOf(e), o = new Set([].concat(zs(e), zs(i)));
      o.delete("constructor"), o.delete(Ze), oc(i, nm, o);
    }
    e[nm].forEach(function(a) {
      return r.make_(
        a,
        // must pass "undefined" for { key: undefined }
        t && a in t ? t[a] : !0
      );
    });
  }), e);
}
var aE = "splice", ti = "update", tZ = 1e4, nZ = {
  get: function(t, n) {
    var r = t[Ze];
    return n === Ze ? r : n === "length" ? r.getArrayLength_() : typeof n == "string" && !isNaN(n) ? r.get_(parseInt(n)) : Nr(Td, n) ? Td[n] : t[n];
  },
  set: function(t, n, r) {
    var i = t[Ze];
    return n === "length" && i.setArrayLength_(r), typeof n == "symbol" || isNaN(n) ? t[n] = r : i.set_(parseInt(n), r), !0;
  },
  preventExtensions: function() {
    Te(15);
  }
}, Kb = /* @__PURE__ */ (function() {
  function e(n, r, i, o) {
    n === void 0 && (n = process.env.NODE_ENV !== "production" ? "ObservableArray@" + ci() : "ObservableArray"), this.owned_ = void 0, this.legacyMode_ = void 0, this.atom_ = void 0, this.values_ = [], this.interceptors_ = void 0, this.changeListeners_ = void 0, this.enhancer_ = void 0, this.dehancer = void 0, this.proxy_ = void 0, this.lastKnownLength_ = 0, this.owned_ = i, this.legacyMode_ = o, this.atom_ = new Vo(n), this.enhancer_ = function(a, s) {
      return r(a, s, process.env.NODE_ENV !== "production" ? n + "[..]" : "ObservableArray[..]");
    };
  }
  var t = e.prototype;
  return t.dehanceValue_ = function(r) {
    return this.dehancer !== void 0 ? this.dehancer(r) : r;
  }, t.dehanceValues_ = function(r) {
    return this.dehancer !== void 0 && r.length > 0 ? r.map(this.dehancer) : r;
  }, t.intercept_ = function(r) {
    return uc(this, r);
  }, t.observe_ = function(r, i) {
    return i === void 0 && (i = !1), i && r({
      observableKind: "array",
      object: this.proxy_,
      debugObjectName: this.atom_.name_,
      type: "splice",
      index: 0,
      added: this.values_.slice(),
      addedCount: this.values_.length,
      removed: [],
      removedCount: 0
    }), cc(this, r);
  }, t.getArrayLength_ = function() {
    return this.atom_.reportObserved(), this.values_.length;
  }, t.setArrayLength_ = function(r) {
    (typeof r != "number" || isNaN(r) || r < 0) && Te("Out of range: " + r);
    var i = this.values_.length;
    if (r !== i)
      if (r > i) {
        for (var o = new Array(r - i), a = 0; a < r - i; a++)
          o[a] = void 0;
        this.spliceWithArray_(i, 0, o);
      } else
        this.spliceWithArray_(r, i - r);
  }, t.updateArrayLength_ = function(r, i) {
    r !== this.lastKnownLength_ && Te(16), this.lastKnownLength_ += i, this.legacyMode_ && i > 0 && OA(r + i + 1);
  }, t.spliceWithArray_ = function(r, i, o) {
    var a = this;
    ki(this.atom_);
    var s = this.values_.length;
    if (r === void 0 ? r = 0 : r > s ? r = s : r < 0 && (r = Math.max(0, s + r)), arguments.length === 1 ? i = s - r : i == null ? i = 0 : i = Math.max(0, Math.min(i, s - r)), o === void 0 && (o = wd), Tr(this)) {
      var l = Or(this, {
        object: this.proxy_,
        type: aE,
        index: r,
        removedCount: i,
        added: o
      });
      if (!l)
        return wd;
      i = l.removedCount, o = l.added;
    }
    if (o = o.length === 0 ? o : o.map(function(f) {
      return a.enhancer_(f, void 0);
    }), this.legacyMode_ || process.env.NODE_ENV !== "production") {
      var u = o.length - i;
      this.updateArrayLength_(s, u);
    }
    var c = this.spliceItemsIntoValues_(r, i, o);
    return (i !== 0 || o.length !== 0) && this.notifyArraySplice_(r, o, c), this.dehanceValues_(c);
  }, t.spliceItemsIntoValues_ = function(r, i, o) {
    if (o.length < tZ) {
      var a;
      return (a = this.values_).splice.apply(a, [r, i].concat(o));
    } else {
      var s = this.values_.slice(r, r + i), l = this.values_.slice(r + i);
      this.values_.length += o.length - i;
      for (var u = 0; u < o.length; u++)
        this.values_[r + u] = o[u];
      for (var c = 0; c < l.length; c++)
        this.values_[r + o.length + c] = l[c];
      return s;
    }
  }, t.notifyArrayChildUpdate_ = function(r, i, o) {
    var a = !this.owned_ && kn(), s = ri(this), l = s || a ? {
      observableKind: "array",
      object: this.proxy_,
      type: ti,
      debugObjectName: this.atom_.name_,
      index: r,
      newValue: i,
      oldValue: o
    } : null;
    process.env.NODE_ENV !== "production" && a && vr(l), this.atom_.reportChanged(), s && ii(this, l), process.env.NODE_ENV !== "production" && a && gr();
  }, t.notifyArraySplice_ = function(r, i, o) {
    var a = !this.owned_ && kn(), s = ri(this), l = s || a ? {
      observableKind: "array",
      object: this.proxy_,
      debugObjectName: this.atom_.name_,
      type: aE,
      index: r,
      removed: o,
      added: i,
      removedCount: o.length,
      addedCount: i.length
    } : null;
    process.env.NODE_ENV !== "production" && a && vr(l), this.atom_.reportChanged(), s && ii(this, l), process.env.NODE_ENV !== "production" && a && gr();
  }, t.get_ = function(r) {
    if (this.legacyMode_ && r >= this.values_.length) {
      console.warn(process.env.NODE_ENV !== "production" ? "[mobx.array] Attempt to read an array index (" + r + ") that is out of bounds (" + this.values_.length + "). Please check length first. Out of bound indices will not be tracked by MobX" : "[mobx] Out of bounds read: " + r);
      return;
    }
    return this.atom_.reportObserved(), this.dehanceValue_(this.values_[r]);
  }, t.set_ = function(r, i) {
    var o = this.values_;
    if (this.legacyMode_ && r > o.length && Te(17, r, o.length), r < o.length) {
      ki(this.atom_);
      var a = o[r];
      if (Tr(this)) {
        var s = Or(this, {
          type: ti,
          object: this.proxy_,
          // since "this" is the real array we need to pass its proxy
          index: r,
          newValue: i
        });
        if (!s)
          return;
        i = s.newValue;
      }
      i = this.enhancer_(i, a);
      var l = i !== a;
      l && (o[r] = i, this.notifyArrayChildUpdate_(r, i, a));
    } else {
      for (var u = new Array(r + 1 - o.length), c = 0; c < u.length - 1; c++)
        u[c] = void 0;
      u[u.length - 1] = i, this.spliceWithArray_(o.length, 0, u);
    }
  }, e;
})();
function rZ(e, t, n, r) {
  return n === void 0 && (n = process.env.NODE_ENV !== "production" ? "ObservableArray@" + ci() : "ObservableArray"), r === void 0 && (r = !1), U4(), Ko(function() {
    var i = new Kb(n, t, r, !1);
    H4(i.values_, Ze, i);
    var o = new Proxy(i.values_, nZ);
    return i.proxy_ = o, e && e.length && i.spliceWithArray_(0, 0, e), o;
  });
}
var Td = {
  clear: function() {
    return this.splice(0);
  },
  replace: function(t) {
    var n = this[Ze];
    return n.spliceWithArray_(0, n.values_.length, t);
  },
  // Used by JSON.stringify
  toJSON: function() {
    return this.slice();
  },
  /*
   * functions that do alter the internal structure of the array, (based on lib.es6.d.ts)
   * since these functions alter the inner structure of the array, the have side effects.
   * Because the have side effects, they should not be used in computed function,
   * and for that reason the do not call dependencyState.notifyObserved
   */
  splice: function(t, n) {
    for (var r = arguments.length, i = new Array(r > 2 ? r - 2 : 0), o = 2; o < r; o++)
      i[o - 2] = arguments[o];
    var a = this[Ze];
    switch (arguments.length) {
      case 0:
        return [];
      case 1:
        return a.spliceWithArray_(t);
      case 2:
        return a.spliceWithArray_(t, n);
    }
    return a.spliceWithArray_(t, n, i);
  },
  spliceWithArray: function(t, n, r) {
    return this[Ze].spliceWithArray_(t, n, r);
  },
  push: function() {
    for (var t = this[Ze], n = arguments.length, r = new Array(n), i = 0; i < n; i++)
      r[i] = arguments[i];
    return t.spliceWithArray_(t.values_.length, 0, r), t.values_.length;
  },
  pop: function() {
    return this.splice(Math.max(this[Ze].values_.length - 1, 0), 1)[0];
  },
  shift: function() {
    return this.splice(0, 1)[0];
  },
  unshift: function() {
    for (var t = this[Ze], n = arguments.length, r = new Array(n), i = 0; i < n; i++)
      r[i] = arguments[i];
    return t.spliceWithArray_(0, 0, r), t.values_.length;
  },
  reverse: function() {
    return he.trackingDerivation && Te(37, "reverse"), this.replace(this.slice().reverse()), this;
  },
  sort: function() {
    he.trackingDerivation && Te(37, "sort");
    var t = this.slice();
    return t.sort.apply(t, arguments), this.replace(t), this;
  },
  remove: function(t) {
    var n = this[Ze], r = n.dehanceValues_(n.values_).indexOf(t);
    return r > -1 ? (this.splice(r, 1), !0) : !1;
  }
};
At("at", wr);
At("concat", wr);
At("flat", wr);
At("includes", wr);
At("indexOf", wr);
At("join", wr);
At("lastIndexOf", wr);
At("slice", wr);
At("toString", wr);
At("toLocaleString", wr);
At("toSorted", wr);
At("toSpliced", wr);
At("with", wr);
At("every", fi);
At("filter", fi);
At("find", fi);
At("findIndex", fi);
At("findLast", fi);
At("findLastIndex", fi);
At("flatMap", fi);
At("forEach", fi);
At("map", fi);
At("some", fi);
At("toReversed", fi);
At("reduce", EA);
At("reduceRight", EA);
function At(e, t) {
  typeof Array.prototype[e] == "function" && (Td[e] = t(e));
}
function wr(e) {
  return function() {
    var t = this[Ze];
    t.atom_.reportObserved();
    var n = t.dehanceValues_(t.values_);
    return n[e].apply(n, arguments);
  };
}
function fi(e) {
  return function(t, n) {
    var r = this, i = this[Ze];
    i.atom_.reportObserved();
    var o = i.dehanceValues_(i.values_);
    return o[e](function(a, s) {
      return t.call(n, a, s, r);
    });
  };
}
function EA(e) {
  return function() {
    var t = this, n = this[Ze];
    n.atom_.reportObserved();
    var r = n.dehanceValues_(n.values_), i = arguments[0];
    return arguments[0] = function(o, a, s) {
      return i(o, a, s, t);
    }, r[e].apply(r, arguments);
  };
}
var iZ = /* @__PURE__ */ La("ObservableArrayAdministration", Kb);
function Ip(e) {
  return $p(e) && iZ(e[Ze]);
}
var oZ = {}, bo = "add", Od = "delete", SA = /* @__PURE__ */ (function() {
  function e(n, r, i) {
    var o = this;
    r === void 0 && (r = Ta), i === void 0 && (i = process.env.NODE_ENV !== "production" ? "ObservableMap@" + ci() : "ObservableMap"), this.enhancer_ = void 0, this.name_ = void 0, this[Ze] = oZ, this.data_ = void 0, this.hasMap_ = void 0, this.keysAtom_ = void 0, this.interceptors_ = void 0, this.changeListeners_ = void 0, this.dehancer = void 0, this.enhancer_ = r, this.name_ = i, vn(Map) || Te(18), Ko(function() {
      o.keysAtom_ = Y4(process.env.NODE_ENV !== "production" ? o.name_ + ".keys()" : "ObservableMap.keys()"), o.data_ = /* @__PURE__ */ new Map(), o.hasMap_ = /* @__PURE__ */ new Map(), n && o.merge(n);
    });
  }
  var t = e.prototype;
  return t.has_ = function(r) {
    return this.data_.has(r);
  }, t.has = function(r) {
    var i = this;
    if (!he.trackingDerivation)
      return this.has_(r);
    var o = this.hasMap_.get(r);
    if (!o) {
      var a = o = new ya(this.has_(r), Tp, process.env.NODE_ENV !== "production" ? this.name_ + "." + og(r) + "?" : "ObservableMap.key?", !1);
      this.hasMap_.set(r, a), yA(a, function() {
        return i.hasMap_.delete(r);
      });
    }
    return o.get();
  }, t.set = function(r, i) {
    var o = this.has_(r);
    if (Tr(this)) {
      var a = Or(this, {
        type: o ? ti : bo,
        object: this,
        newValue: i,
        name: r
      });
      if (!a)
        return this;
      i = a.newValue;
    }
    return o ? this.updateValue_(r, i) : this.addValue_(r, i), this;
  }, t.delete = function(r) {
    var i = this;
    if (ki(this.keysAtom_), Tr(this)) {
      var o = Or(this, {
        type: Od,
        object: this,
        name: r
      });
      if (!o)
        return !1;
    }
    if (this.has_(r)) {
      var a = kn(), s = ri(this), l = s || a ? {
        observableKind: "map",
        debugObjectName: this.name_,
        type: Od,
        object: this,
        oldValue: this.data_.get(r).value_,
        name: r
      } : null;
      return process.env.NODE_ENV !== "production" && a && vr(l), Li(function() {
        var u;
        i.keysAtom_.reportChanged(), (u = i.hasMap_.get(r)) == null || u.setNewValue_(!1);
        var c = i.data_.get(r);
        c.setNewValue_(void 0), i.data_.delete(r);
      }), s && ii(this, l), process.env.NODE_ENV !== "production" && a && gr(), !0;
    }
    return !1;
  }, t.updateValue_ = function(r, i) {
    var o = this.data_.get(r);
    if (i = o.prepareNewValue_(i), i !== he.UNCHANGED) {
      var a = kn(), s = ri(this), l = s || a ? {
        observableKind: "map",
        debugObjectName: this.name_,
        type: ti,
        object: this,
        oldValue: o.value_,
        name: r,
        newValue: i
      } : null;
      process.env.NODE_ENV !== "production" && a && vr(l), o.setNewValue_(i), s && ii(this, l), process.env.NODE_ENV !== "production" && a && gr();
    }
  }, t.addValue_ = function(r, i) {
    var o = this;
    ki(this.keysAtom_), Li(function() {
      var u, c = new ya(i, o.enhancer_, process.env.NODE_ENV !== "production" ? o.name_ + "." + og(r) : "ObservableMap.key", !1);
      o.data_.set(r, c), i = c.value_, (u = o.hasMap_.get(r)) == null || u.setNewValue_(!0), o.keysAtom_.reportChanged();
    });
    var a = kn(), s = ri(this), l = s || a ? {
      observableKind: "map",
      debugObjectName: this.name_,
      type: bo,
      object: this,
      name: r,
      newValue: i
    } : null;
    process.env.NODE_ENV !== "production" && a && vr(l), s && ii(this, l), process.env.NODE_ENV !== "production" && a && gr();
  }, t.get = function(r) {
    return this.has(r) ? this.dehanceValue_(this.data_.get(r).get()) : this.dehanceValue_(void 0);
  }, t.getOrInsert = function(r, i) {
    return this.has(r) || this.set(r, i), this.get(r);
  }, t.getOrInsertComputed = function(r, i) {
    return this.has(r) || this.set(r, i(r)), this.get(r);
  }, t.dehanceValue_ = function(r) {
    return this.dehancer !== void 0 ? this.dehancer(r) : r;
  }, t.keys = function() {
    return this.keysAtom_.reportObserved(), this.data_.keys();
  }, t.values = function() {
    var r = this, i = this.keys();
    return sE({
      next: function() {
        var a = i.next(), s = a.done, l = a.value;
        return {
          done: s,
          value: s ? void 0 : r.get(l)
        };
      }
    });
  }, t.entries = function() {
    var r = this, i = this.keys();
    return sE({
      next: function() {
        var a = i.next(), s = a.done, l = a.value;
        return {
          done: s,
          value: s ? void 0 : [l, r.get(l)]
        };
      }
    });
  }, t[Symbol.iterator] = function() {
    return this.entries();
  }, t.forEach = function(r, i) {
    for (var o = ms(this), a; !(a = o()).done; ) {
      var s = a.value, l = s[0], u = s[1];
      r.call(i, u, l, this);
    }
  }, t.merge = function(r) {
    var i = this;
    return Bo(r) && (r = new Map(r)), Li(function() {
      mr(r) ? gH(r).forEach(function(o) {
        return i.set(o, r[o]);
      }) : Array.isArray(r) ? r.forEach(function(o) {
        var a = o[0], s = o[1];
        return i.set(a, s);
      }) : fl(r) ? (vH(r) || Te(19, r), r.forEach(function(o, a) {
        return i.set(a, o);
      })) : r != null && Te(20, r);
    }), this;
  }, t.clear = function() {
    var r = this;
    Li(function() {
      aA(function() {
        for (var i = ms(r.keys()), o; !(o = i()).done; ) {
          var a = o.value;
          r.delete(a);
        }
      });
    });
  }, t.replace = function(r) {
    var i = this;
    return Li(function() {
      for (var o = aZ(r), a = /* @__PURE__ */ new Map(), s = !1, l = ms(i.data_.keys()), u; !(u = l()).done; ) {
        var c = u.value;
        if (!o.has(c)) {
          var f = i.delete(c);
          if (f)
            s = !0;
          else {
            var d = i.data_.get(c);
            a.set(c, d);
          }
        }
      }
      for (var p = ms(o.entries()), h; !(h = p()).done; ) {
        var v = h.value, m = v[0], g = v[1], _ = i.data_.has(m);
        if (i.set(m, g), i.data_.has(m)) {
          var x = i.data_.get(m);
          a.set(m, x), _ || (s = !0);
        }
      }
      if (!s)
        if (i.data_.size !== a.size)
          i.keysAtom_.reportChanged();
        else
          for (var w = i.data_.keys(), $ = a.keys(), k = w.next(), D = $.next(); !k.done; ) {
            if (k.value !== D.value) {
              i.keysAtom_.reportChanged();
              break;
            }
            k = w.next(), D = $.next();
          }
      i.data_ = a;
    }), this;
  }, t.toString = function() {
    return "[object ObservableMap]";
  }, t.toJSON = function() {
    return Array.from(this);
  }, t.observe_ = function(r, i) {
    return process.env.NODE_ENV !== "production" && i === !0 && Te("`observe` doesn't support fireImmediately=true in combination with maps."), cc(this, r);
  }, t.intercept_ = function(r) {
    return uc(this, r);
  }, dl(e, [{
    key: "size",
    get: function() {
      return this.keysAtom_.reportObserved(), this.data_.size;
    }
  }, {
    key: Symbol.toStringTag,
    get: function() {
      return "Map";
    }
  }]);
})(), Bo = /* @__PURE__ */ La("ObservableMap", SA);
function sE(e) {
  return e[Symbol.toStringTag] = "MapIterator", qb(e);
}
function aZ(e) {
  if (fl(e) || Bo(e))
    return e;
  if (Array.isArray(e))
    return new Map(e);
  if (mr(e)) {
    var t = /* @__PURE__ */ new Map();
    for (var n in e)
      t.set(n, e[n]);
    return t;
  } else
    return Te(21, e);
}
var sZ = {}, $A = /* @__PURE__ */ (function() {
  function e(n, r, i) {
    var o = this;
    r === void 0 && (r = Ta), i === void 0 && (i = process.env.NODE_ENV !== "production" ? "ObservableSet@" + ci() : "ObservableSet"), this.name_ = void 0, this[Ze] = sZ, this.data_ = /* @__PURE__ */ new Set(), this.atom_ = void 0, this.changeListeners_ = void 0, this.interceptors_ = void 0, this.dehancer = void 0, this.enhancer_ = void 0, this.name_ = i, vn(Set) || Te(22), this.enhancer_ = function(a, s) {
      return r(a, s, i);
    }, Ko(function() {
      o.atom_ = Y4(o.name_), n && o.replace(n);
    });
  }
  var t = e.prototype;
  return t.dehanceValue_ = function(r) {
    return this.dehancer !== void 0 ? this.dehancer(r) : r;
  }, t.clear = function() {
    var r = this;
    Li(function() {
      aA(function() {
        for (var i = ms(r.data_.values()), o; !(o = i()).done; ) {
          var a = o.value;
          r.delete(a);
        }
      });
    });
  }, t.forEach = function(r, i) {
    for (var o = ms(this), a; !(a = o()).done; ) {
      var s = a.value;
      r.call(i, s, s, this);
    }
  }, t.add = function(r) {
    var i = this;
    if (ki(this.atom_), Tr(this)) {
      var o = Or(this, {
        type: bo,
        object: this,
        newValue: r
      });
      if (!o)
        return this;
      r = o.newValue;
    }
    if (!this.has(r)) {
      Li(function() {
        i.data_.add(i.enhancer_(r, void 0)), i.atom_.reportChanged();
      });
      var a = process.env.NODE_ENV !== "production" && kn(), s = ri(this), l = s || a ? {
        observableKind: "set",
        debugObjectName: this.name_,
        type: bo,
        object: this,
        newValue: r
      } : null;
      a && process.env.NODE_ENV !== "production" && vr(l), s && ii(this, l), a && process.env.NODE_ENV !== "production" && gr();
    }
    return this;
  }, t.delete = function(r) {
    var i = this;
    if (Tr(this)) {
      var o = Or(this, {
        type: Od,
        object: this,
        oldValue: r
      });
      if (!o)
        return !1;
    }
    if (this.has(r)) {
      var a = process.env.NODE_ENV !== "production" && kn(), s = ri(this), l = s || a ? {
        observableKind: "set",
        debugObjectName: this.name_,
        type: Od,
        object: this,
        oldValue: r
      } : null;
      return a && process.env.NODE_ENV !== "production" && vr(l), Li(function() {
        i.atom_.reportChanged(), i.data_.delete(r);
      }), s && ii(this, l), a && process.env.NODE_ENV !== "production" && gr(), !0;
    }
    return !1;
  }, t.has = function(r) {
    return this.atom_.reportObserved(), this.data_.has(this.dehanceValue_(r));
  }, t.entries = function() {
    var r = this.values();
    return lE({
      next: function() {
        var o = r.next(), a = o.value, s = o.done;
        return s ? {
          value: void 0,
          done: s
        } : {
          value: [a, a],
          done: s
        };
      }
    });
  }, t.keys = function() {
    return this.values();
  }, t.values = function() {
    this.atom_.reportObserved();
    var r = this, i = this.data_.values();
    return lE({
      next: function() {
        var a = i.next(), s = a.value, l = a.done;
        return l ? {
          value: void 0,
          done: l
        } : {
          value: r.dehanceValue_(s),
          done: l
        };
      }
    });
  }, t.intersection = function(r) {
    if (zi(r) && !xi(r))
      return r.intersection(this);
    var i = new Set(this);
    return i.intersection(r);
  }, t.union = function(r) {
    if (zi(r) && !xi(r))
      return r.union(this);
    var i = new Set(this);
    return i.union(r);
  }, t.difference = function(r) {
    return new Set(this).difference(r);
  }, t.symmetricDifference = function(r) {
    if (zi(r) && !xi(r))
      return r.symmetricDifference(this);
    var i = new Set(this);
    return i.symmetricDifference(r);
  }, t.isSubsetOf = function(r) {
    return new Set(this).isSubsetOf(r);
  }, t.isSupersetOf = function(r) {
    return new Set(this).isSupersetOf(r);
  }, t.isDisjointFrom = function(r) {
    if (zi(r) && !xi(r))
      return r.isDisjointFrom(this);
    var i = new Set(this);
    return i.isDisjointFrom(r);
  }, t.replace = function(r) {
    var i = this;
    return xi(r) && (r = new Set(r)), Li(function() {
      Array.isArray(r) ? (i.clear(), r.forEach(function(o) {
        return i.add(o);
      })) : zi(r) ? (i.clear(), r.forEach(function(o) {
        return i.add(o);
      })) : r != null && Te("Cannot initialize set from " + r);
    }), this;
  }, t.observe_ = function(r, i) {
    return process.env.NODE_ENV !== "production" && i === !0 && Te("`observe` doesn't support fireImmediately=true in combination with sets."), cc(this, r);
  }, t.intercept_ = function(r) {
    return uc(this, r);
  }, t.toJSON = function() {
    return Array.from(this);
  }, t.toString = function() {
    return "[object ObservableSet]";
  }, t[Symbol.iterator] = function() {
    return this.values();
  }, dl(e, [{
    key: "size",
    get: function() {
      return this.atom_.reportObserved(), this.data_.size;
    }
  }, {
    key: Symbol.toStringTag,
    get: function() {
      return "Set";
    }
  }]);
})(), xi = /* @__PURE__ */ La("ObservableSet", $A);
function lE(e) {
  return e[Symbol.toStringTag] = "SetIterator", qb(e);
}
var uE = /* @__PURE__ */ Object.create(null), cE = "remove", mg = /* @__PURE__ */ (function() {
  function e(n, r, i, o) {
    r === void 0 && (r = /* @__PURE__ */ new Map()), o === void 0 && (o = GH), this.target_ = void 0, this.values_ = void 0, this.name_ = void 0, this.defaultAnnotation_ = void 0, this.keysAtom_ = void 0, this.changeListeners_ = void 0, this.interceptors_ = void 0, this.proxy_ = void 0, this.isPlainObject_ = void 0, this.appliedAnnotations_ = void 0, this.pendingKeys_ = void 0, this.lazyComputedKeys_ = void 0, this.lazyObservableKeys_ = void 0, this.target_ = n, this.values_ = r, this.name_ = i, this.defaultAnnotation_ = o, this.keysAtom_ = new Vo(process.env.NODE_ENV !== "production" ? this.name_ + ".keys" : "ObservableObject.keys"), this.isPlainObject_ = mr(this.target_), process.env.NODE_ENV !== "production" && !DA(this.defaultAnnotation_) && Te("defaultAnnotation must be valid annotation"), process.env.NODE_ENV !== "production" && (this.appliedAnnotations_ = {});
  }
  var t = e.prototype;
  return t.getObservablePropValue_ = function(r) {
    var i, o, a = (i = (o = this.values_.get(r)) != null ? o : this.materializeLazyComputed_(r)) != null ? i : this.materializeLazyObservable_(r);
    return a.get();
  }, t.materializeLazyComputed_ = function(r) {
    var i, o = (i = this.lazyComputedKeys_) == null ? void 0 : i.get(r);
    if (o) {
      this.lazyComputedKeys_.delete(r), this.lazyComputedKeys_.size === 0 && (this.lazyComputedKeys_ = void 0);
      var a = o();
      return this.values_.set(r, a), a;
    }
  }, t.materializeLazyObservable_ = function(r) {
    var i, o = (i = this.lazyObservableKeys_) == null ? void 0 : i.get(r);
    if (o) {
      this.lazyObservableKeys_.delete(r), this.lazyObservableKeys_.size === 0 && (this.lazyObservableKeys_ = void 0);
      var a = o();
      return this.values_.set(r, a), a;
    }
  }, t.setObservablePropValue_ = function(r, i) {
    var o, a, s = (o = (a = this.values_.get(r)) != null ? a : this.materializeLazyComputed_(r)) != null ? o : this.materializeLazyObservable_(r);
    if (s instanceof tr)
      return s.set(i), !0;
    if (Tr(this)) {
      var l = Or(this, {
        type: ti,
        object: this.proxy_ || this.target_,
        name: r,
        newValue: i
      });
      if (!l)
        return null;
      i = l.newValue;
    }
    if (i = s.prepareNewValue_(i), i !== he.UNCHANGED) {
      var u = ri(this), c = process.env.NODE_ENV !== "production" && kn(), f = u || c ? {
        type: ti,
        observableKind: "object",
        debugObjectName: this.name_,
        object: this.proxy_ || this.target_,
        oldValue: s.value_,
        name: r,
        newValue: i
      } : null;
      process.env.NODE_ENV !== "production" && c && vr(f), s.setNewValue_(i), u && ii(this, f), process.env.NODE_ENV !== "production" && c && gr();
    }
    return !0;
  }, t.get_ = function(r) {
    return he.trackingDerivation && !Nr(this.target_, r) && this.has_(r), this.target_[r];
  }, t.set_ = function(r, i, o) {
    return o === void 0 && (o = !1), Nr(this.target_, r) ? this.values_.has(r) ? this.setObservablePropValue_(r, i) : o ? Reflect.set(this.target_, r, i) : (this.target_[r] = i, !0) : this.extend_(r, {
      value: i,
      enumerable: !0,
      writable: !0,
      configurable: !0
    }, this.defaultAnnotation_, o);
  }, t.has_ = function(r) {
    if (!he.trackingDerivation)
      return r in this.target_;
    this.pendingKeys_ || (this.pendingKeys_ = /* @__PURE__ */ new Map());
    var i = this.pendingKeys_.get(r);
    return i || (i = new ya(r in this.target_, Tp, process.env.NODE_ENV !== "production" ? this.name_ + "." + og(r) + "?" : "ObservableObject.key?", !1), this.pendingKeys_.set(r, i)), i.get();
  }, t.make_ = function(r, i) {
    if (i === !0 && (i = this.defaultAnnotation_), i !== !1) {
      if (pE(this, i, r), !(r in this.target_)) {
        var o;
        if ((o = this.target_[Xn]) != null && o[r])
          return;
        Te(1, i.annotationType_, this.name_ + "." + r.toString());
      }
      for (var a = this.target_; a && a !== Sp; ) {
        var s = _d(a, r);
        if (s) {
          var l = i.make_(this, r, s, a);
          if (l === 0)
            return;
          if (l === 1)
            break;
        }
        a = Object.getPrototypeOf(a);
      }
      dE(this, i, r);
    }
  }, t.extend_ = function(r, i, o, a) {
    if (a === void 0 && (a = !1), o === !0 && (o = this.defaultAnnotation_), o === !1)
      return this.defineProperty_(r, i, a);
    pE(this, o, r);
    var s = o.extend_(this, r, i, a);
    return s && dE(this, o, r), s;
  }, t.defineProperty_ = function(r, i, o) {
    o === void 0 && (o = !1), ki(this.keysAtom_);
    try {
      Ar();
      var a = this.delete_(r);
      if (!a)
        return a;
      if (Tr(this)) {
        var s = Or(this, {
          object: this.proxy_ || this.target_,
          name: r,
          type: bo,
          newValue: i.value
        });
        if (!s)
          return null;
        var l = s.newValue;
        i.value !== l && (i = Gi({}, i, {
          value: l
        }));
      }
      if (o) {
        if (!Reflect.defineProperty(this.target_, r, i))
          return !1;
      } else
        Oi(this.target_, r, i);
      this.notifyPropertyAddition_(r, i.value);
    } finally {
      Dr();
    }
    return !0;
  }, t.defineObservableProperty_ = function(r, i, o, a) {
    a === void 0 && (a = !1), ki(this.keysAtom_);
    try {
      Ar();
      var s = this.delete_(r);
      if (!s)
        return s;
      if (Tr(this)) {
        var l = Or(this, {
          object: this.proxy_ || this.target_,
          name: r,
          type: bo,
          newValue: i
        });
        if (!l)
          return null;
        i = l.newValue;
      }
      var u = fE(r), c = {
        configurable: he.safeDescriptors ? this.isPlainObject_ : !0,
        enumerable: !0,
        get: u.get,
        set: u.set
      };
      if (a) {
        if (!Reflect.defineProperty(this.target_, r, c))
          return !1;
      } else
        Oi(this.target_, r, c);
      var f = new ya(i, o, process.env.NODE_ENV !== "production" ? this.name_ + "." + r.toString() : "ObservableObject.key", !1);
      this.values_.set(r, f), this.notifyPropertyAddition_(r, f.value_);
    } finally {
      Dr();
    }
    return !0;
  }, t.defineComputedProperty_ = function(r, i, o) {
    o === void 0 && (o = !1), ki(this.keysAtom_);
    try {
      Ar();
      var a = this.delete_(r);
      if (!a)
        return a;
      if (Tr(this)) {
        var s = Or(this, {
          object: this.proxy_ || this.target_,
          name: r,
          type: bo,
          newValue: void 0
        });
        if (!s)
          return null;
      }
      i.name || (i.name = process.env.NODE_ENV !== "production" ? this.name_ + "." + r.toString() : "ObservableObject.key"), i.context = this.proxy_ || this.target_;
      var l = fE(r), u = {
        configurable: he.safeDescriptors ? this.isPlainObject_ : !0,
        enumerable: !1,
        get: l.get,
        set: l.set
      };
      if (o) {
        if (!Reflect.defineProperty(this.target_, r, u))
          return !1;
      } else
        Oi(this.target_, r, u);
      this.values_.set(r, new tr(i)), this.notifyPropertyAddition_(r, void 0);
    } finally {
      Dr();
    }
    return !0;
  }, t.delete_ = function(r, i) {
    if (i === void 0 && (i = !1), ki(this.keysAtom_), !Nr(this.target_, r))
      return !0;
    if (Tr(this)) {
      var o = Or(this, {
        object: this.proxy_ || this.target_,
        name: r,
        type: cE
      });
      if (!o)
        return null;
    }
    try {
      var a;
      Ar();
      var s = ri(this), l = process.env.NODE_ENV !== "production" && kn(), u = this.values_.get(r), c = void 0;
      if (!u && (s || l)) {
        var f;
        c = (f = _d(this.target_, r)) == null ? void 0 : f.value;
      }
      if (i) {
        if (!Reflect.deleteProperty(this.target_, r))
          return !1;
      } else
        delete this.target_[r];
      if (process.env.NODE_ENV !== "production" && delete this.appliedAnnotations_[r], u && (this.values_.delete(r), u instanceof ya && (c = u.value_), dA(u)), this.keysAtom_.reportChanged(), (a = this.pendingKeys_) == null || (a = a.get(r)) == null || a.set(r in this.target_), s || l) {
        var d = {
          type: cE,
          observableKind: "object",
          object: this.proxy_ || this.target_,
          debugObjectName: this.name_,
          oldValue: c,
          name: r
        };
        process.env.NODE_ENV !== "production" && l && vr(d), s && ii(this, d), process.env.NODE_ENV !== "production" && l && gr();
      }
    } finally {
      Dr();
    }
    return !0;
  }, t.observe_ = function(r, i) {
    return process.env.NODE_ENV !== "production" && i === !0 && Te("`observe` doesn't support the fire immediately property for observable objects."), cc(this, r);
  }, t.intercept_ = function(r) {
    return uc(this, r);
  }, t.notifyPropertyAddition_ = function(r, i) {
    var o, a = ri(this), s = process.env.NODE_ENV !== "production" && kn();
    if (a || s) {
      var l = a || s ? {
        type: bo,
        observableKind: "object",
        debugObjectName: this.name_,
        object: this.proxy_ || this.target_,
        name: r,
        newValue: i
      } : null;
      process.env.NODE_ENV !== "production" && s && vr(l), a && ii(this, l), process.env.NODE_ENV !== "production" && s && gr();
    }
    (o = this.pendingKeys_) == null || (o = o.get(r)) == null || o.set(!0), this.keysAtom_.reportChanged();
  }, t.ownKeys_ = function() {
    return this.keysAtom_.reportObserved(), zs(this.target_);
  }, t.keys_ = function() {
    return this.keysAtom_.reportObserved(), Object.keys(this.target_);
  }, e;
})();
function Ba(e, t) {
  var n;
  if (process.env.NODE_ENV !== "production" && t && pl(e) && Te("Options can't be provided for already observable objects."), Nr(e, Ze))
    return process.env.NODE_ENV !== "production" && !(PA(e) instanceof mg) && Te("Cannot convert '" + Pd(e) + `' into observable object:
The target is already observable of different type.
Extending builtins is not supported.`), e;
  process.env.NODE_ENV !== "production" && !Object.isExtensible(e) && Te("Cannot make the designated object observable; it is not extensible");
  var r = (n = t?.name) != null ? n : process.env.NODE_ENV !== "production" ? (mr(e) ? "ObservableObject" : e.constructor.name) + "@" + ci() : "ObservableObject", i = new mg(e, /* @__PURE__ */ new Map(), String(r), aW(t));
  return oc(e, Ze, i), e;
}
var lZ = /* @__PURE__ */ La("ObservableObjectAdministration", mg);
function fE(e) {
  return uE[e] || (uE[e] = {
    get: function() {
      return this[Ze].getObservablePropValue_(e);
    },
    set: function(n) {
      return this[Ze].setObservablePropValue_(e, n);
    }
  });
}
function pl(e) {
  return $p(e) ? lZ(e[Ze]) : !1;
}
function dE(e, t, n) {
  var r;
  process.env.NODE_ENV !== "production" && (e.appliedAnnotations_[n] = t), (r = e.target_[Xn]) == null || delete r[n];
}
function pE(e, t, n) {
  if (process.env.NODE_ENV !== "production" && !DA(t) && Te("Cannot annotate '" + e.name_ + "." + n.toString() + "': Invalid annotation."), process.env.NODE_ENV !== "production" && !Ed(t) && Nr(e.appliedAnnotations_, n)) {
    var r = e.name_ + "." + n.toString(), i = e.appliedAnnotations_[n].annotationType_, o = t.annotationType_;
    Te("Cannot apply '" + o + "' to '" + r + "':" + (`
The field is already annotated with '` + i + "'.") + `
Re-annotating fields is not allowed.
Use 'override' annotation for methods overridden by subclass.`);
  }
}
var uZ = /* @__PURE__ */ TA(0), cZ = /* @__PURE__ */ (function() {
  var e = !1, t = {};
  return Object.defineProperty(t, "0", {
    set: function() {
      e = !0;
    }
  }), Object.create(t)[0] = 1, e === !1;
})(), rm = 0, kA = function() {
};
function fZ(e, t) {
  Object.setPrototypeOf ? Object.setPrototypeOf(e.prototype, t) : e.prototype.__proto__ !== void 0 ? e.prototype.__proto__ = t : e.prototype = t;
}
fZ(kA, Array.prototype);
var Ub = /* @__PURE__ */ (function(e) {
  function t(r, i, o, a) {
    var s;
    return o === void 0 && (o = process.env.NODE_ENV !== "production" ? "ObservableArray@" + ci() : "ObservableArray"), a === void 0 && (a = !1), s = e.call(this) || this, Ko(function() {
      var l = new Kb(o, i, a, !0);
      l.proxy_ = s, H4(s, Ze, l), r && r.length && s.spliceWithArray(0, 0, r), cZ && Object.defineProperty(s, "0", uZ);
    }), s;
  }
  Fb(t, e);
  var n = t.prototype;
  return n.concat = function() {
    this[Ze].atom_.reportObserved();
    for (var i = arguments.length, o = new Array(i), a = 0; a < i; a++)
      o[a] = arguments[a];
    return Array.prototype.concat.apply(
      this.slice(),
      //@ts-ignore
      o.map(function(s) {
        return Ip(s) ? s.slice() : s;
      })
    );
  }, n[Symbol.iterator] = function() {
    var r = this, i = 0;
    return qb({
      next: function() {
        return i < r.length ? {
          value: r[i++],
          done: !1
        } : {
          done: !0,
          value: void 0
        };
      }
    });
  }, dl(t, [{
    key: "length",
    get: function() {
      return this[Ze].getArrayLength_();
    },
    set: function(i) {
      this[Ze].setArrayLength_(i);
    }
  }, {
    key: Symbol.toStringTag,
    get: function() {
      return "Array";
    }
  }]);
})(kA);
Object.entries(Td).forEach(function(e) {
  var t = e[0], n = e[1];
  t !== "concat" && oc(Ub.prototype, t, n);
});
function TA(e) {
  return {
    enumerable: !1,
    configurable: !0,
    get: function() {
      return this[Ze].get_(e);
    },
    set: function(n) {
      this[Ze].set_(e, n);
    }
  };
}
function dZ(e) {
  Oi(Ub.prototype, "" + e, TA(e));
}
function OA(e) {
  if (e > rm) {
    for (var t = rm; t < e + 100; t++)
      dZ(t);
    rm = e;
  }
}
OA(1e3);
function pZ(e, t, n) {
  return new Ub(e, t, n);
}
function Vs(e, t) {
  if (typeof e == "object" && e !== null) {
    if (Ip(e))
      return t !== void 0 && Te(23), e[Ze].atom_;
    if (xi(e))
      return e.atom_;
    if (Bo(e)) {
      if (t === void 0)
        return e.keysAtom_;
      var n = e.data_.get(t) || e.hasMap_.get(t);
      return n || Te(25, t, Pd(e)), n;
    }
    if (pl(e)) {
      var r, i;
      if (!t)
        return Te(26);
      var o = e[Ze], a = (r = (i = o.values_.get(t)) != null ? i : o.materializeLazyComputed_(t)) != null ? r : o.materializeLazyObservable_(t);
      return a || Te(27, t, Pd(e)), a;
    }
    if (zb(e) || Cp(e) || kd(e))
      return e;
  } else if (vn(e) && kd(e[Ze]))
    return e[Ze];
  Te(28);
}
function PA(e, t) {
  if (e || Te(29), zb(e) || Cp(e) || kd(e) || Bo(e) || xi(e))
    return e;
  if (e[Ze])
    return e[Ze];
  Te(24, e);
}
function Pd(e, t) {
  var n;
  if (t !== void 0)
    n = Vs(e, t);
  else {
    if (Aa(e))
      return e.name;
    pl(e) || Bo(e) || xi(e) ? n = PA(e) : n = Vs(e);
  }
  return n.name_;
}
function Ko(e) {
  var t = Va(), n = Ap(!0);
  Ar();
  try {
    return e();
  } finally {
    Dr(), Dp(n), Ki(t);
  }
}
var hE = Sp.toString;
function AA(e, t, n) {
  return n === void 0 && (n = -1), vg(e, t, n);
}
function vg(e, t, n, r, i) {
  if (e === t)
    return e !== 0 || 1 / e === 1 / t;
  if (e == null || t == null)
    return !1;
  if (e !== e)
    return t !== t;
  var o = typeof e;
  if (o !== "function" && o !== "object" && typeof t != "object")
    return !1;
  var a = hE.call(e);
  if (a !== hE.call(t))
    return !1;
  switch (a) {
    // Strings, numbers, regular expressions, dates, and booleans are compared by value.
    case "[object RegExp]":
    // RegExps are coerced to strings for comparison (Note: '' + /a/i === '/a/i')
    case "[object String]":
      return "" + e == "" + t;
    case "[object Number]":
      return +e != +e ? +t != +t : +e == 0 ? 1 / +e === 1 / t : +e == +t;
    case "[object Date]":
    case "[object Boolean]":
      return +e == +t;
    case "[object Symbol]":
      return typeof Symbol < "u" && Symbol.valueOf.call(e) === Symbol.valueOf.call(t);
    case "[object Map]":
    case "[object Set]":
      n >= 0 && n++;
      break;
  }
  e = mE(e), t = mE(t);
  var s = a === "[object Array]";
  if (!s) {
    if (typeof e != "object" || typeof t != "object")
      return !1;
    var l = e.constructor, u = t.constructor;
    if (l !== u && !(vn(l) && l instanceof l && vn(u) && u instanceof u) && "constructor" in e && "constructor" in t)
      return !1;
  }
  if (n === 0)
    return !1;
  n < 0 && (n = -1), r = r || [], i = i || [];
  for (var c = r.length; c--; )
    if (r[c] === e)
      return i[c] === t;
  if (r.push(e), i.push(t), s) {
    if (c = e.length, c !== t.length)
      return !1;
    for (; c--; )
      if (!vg(e[c], t[c], n - 1, r, i))
        return !1;
  } else {
    var f = Object.keys(e), d = f.length;
    if (Object.keys(t).length !== d)
      return !1;
    for (var p = 0; p < d; p++) {
      var h = f[p];
      if (!(Nr(t, h) && vg(e[h], t[h], n - 1, r, i)))
        return !1;
    }
  }
  return r.pop(), i.pop(), !0;
}
function mE(e) {
  return Ip(e) ? e.slice() : fl(e) || Bo(e) || zi(e) || xi(e) ? Array.from(e.entries()) : e;
}
var vE, hZ = /* @__PURE__ */ Ep(), mZ = ((vE = hZ.Iterator) == null ? void 0 : vE.prototype) || {};
function qb(e) {
  return e[Symbol.iterator] = vZ, Object.assign(Object.create(mZ), e);
}
function vZ() {
  return this;
}
function DA(e) {
  return (
    // Can be function
    e instanceof Object && typeof e.annotationType_ == "string" && vn(e.make_) && vn(e.extend_)
  );
}
["Symbol", "Map", "Set"].forEach(function(e) {
  var t = Ep();
  typeof t[e] > "u" && Te("MobX requires global '" + e + "' to be available or polyfilled");
});
typeof __MOBX_DEVTOOLS_GLOBAL_HOOK__ == "object" && __MOBX_DEVTOOLS_GLOBAL_HOOK__.injectMobx({
  spy: PW,
  extras: {
    getDebugName: Pd
  },
  $mobx: Ze
});
if (!Ke)
  throw new Error("mobx-react-lite requires React with Hooks support");
if (!XW)
  throw new Error("mobx-react-lite@3 requires mobx at least version 6 to be available");
function gZ(e) {
  e();
}
function yZ(e) {
  e || (e = gZ, process.env.NODE_ENV !== "production" && console.warn("[MobX] Failed to get unstable_batched updates from react-dom / react-native")), KW({ reactionScheduler: e });
}
function bZ(e) {
  return wA(e);
}
var _Z = 1e4, wZ = 1e4, xZ = (
  /** @class */
  (function() {
    function e(t) {
      var n = this;
      Object.defineProperty(this, "finalize", {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: t
      }), Object.defineProperty(this, "registrations", {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: /* @__PURE__ */ new Map()
      }), Object.defineProperty(this, "sweepTimeout", {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: void 0
      }), Object.defineProperty(this, "sweep", {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: function(r) {
          r === void 0 && (r = _Z), clearTimeout(n.sweepTimeout), n.sweepTimeout = void 0;
          var i = Date.now();
          n.registrations.forEach(function(o, a) {
            i - o.registeredAt >= r && (n.finalize(o.value), n.registrations.delete(a));
          }), n.registrations.size > 0 && n.scheduleSweep();
        }
      }), Object.defineProperty(this, "finalizeAllImmediately", {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: function() {
          n.sweep(0);
        }
      });
    }
    return Object.defineProperty(e.prototype, "register", {
      enumerable: !1,
      configurable: !0,
      writable: !0,
      value: function(t, n, r) {
        this.registrations.set(r, {
          value: n,
          registeredAt: Date.now()
        }), this.scheduleSweep();
      }
    }), Object.defineProperty(e.prototype, "unregister", {
      enumerable: !1,
      configurable: !0,
      writable: !0,
      value: function(t) {
        this.registrations.delete(t);
      }
    }), Object.defineProperty(e.prototype, "scheduleSweep", {
      enumerable: !1,
      configurable: !0,
      writable: !0,
      value: function() {
        this.sweepTimeout === void 0 && (this.sweepTimeout = setTimeout(this.sweep, wZ));
      }
    }), e;
  })()
), EZ = typeof FinalizationRegistry < "u" ? FinalizationRegistry : xZ, Mu = new EZ(function(e) {
  var t;
  (t = e.reaction) === null || t === void 0 || t.dispose(), e.reaction = null;
});
function gE(e) {
  e.reaction = new Di("observer".concat(e.name), function() {
    var t;
    e.stateVersion = Symbol(), (t = e.onStoreChange) === null || t === void 0 || t.call(e);
  });
}
function SZ(e, t) {
  t === void 0 && (t = "observed");
  var n = H.useRef(null);
  if (!n.current) {
    var r = {
      reaction: null,
      onStoreChange: null,
      stateVersion: Symbol(),
      name: t,
      subscribe: function(s) {
        return Mu.unregister(r), r.onStoreChange = s, r.reaction || (gE(r), r.stateVersion = Symbol()), function() {
          var l;
          r.onStoreChange = null, (l = r.reaction) === null || l === void 0 || l.dispose(), r.reaction = null;
        };
      },
      getSnapshot: function() {
        return r.stateVersion;
      }
    };
    n.current = r;
  }
  var i = n.current;
  i.reaction || (gE(i), Mu.register(n, i, i)), H.useDebugValue(i.reaction, bZ), lO.useSyncExternalStore(
    // Both of these must be stable, otherwise it would keep resubscribing every render.
    i.subscribe,
    i.getSnapshot,
    i.getSnapshot
  );
  var o, a;
  if (i.reaction.track(function() {
    try {
      o = e();
    } catch (s) {
      a = s;
    }
  }), a)
    throw a;
  return o;
}
var im, om, $Z = !0, yE = !0, CA = typeof Symbol == "function" && Symbol.for, kZ = (om = (im = Object.getOwnPropertyDescriptor(function() {
}, "name")) === null || im === void 0 ? void 0 : im.configurable) !== null && om !== void 0 ? om : !1, bE = CA ? Symbol.for("react.forward_ref") : typeof fn == "function" && fn(function(e) {
  return null;
}).$$typeof, _E = CA ? Symbol.for("react.memo") : typeof Lm == "function" && Lm(function(e) {
  return null;
}).$$typeof;
function TZ(e, t) {
  var n;
  if (process.env.NODE_ENV, _E && e.$$typeof === _E)
    throw new Error("[mobx-react-lite] You are trying to use `observer` on a function component wrapped in either another `observer` or `React.memo`. The observer already applies 'React.memo' for you.");
  var r = (n = void 0) !== null && n !== void 0 ? n : !1, i = e, o = e.displayName || e.name;
  if (bE && e.$$typeof === bE && (r = !0, i = e.render, typeof i != "function"))
    throw new Error("[mobx-react-lite] `render` property of ForwardRef was not a function");
  var a = function(s, l) {
    return SZ(function() {
      return i(s, l);
    }, o);
  };
  return a.displayName = e.displayName, kZ && Object.defineProperty(a, "name", {
    value: e.name,
    writable: !0,
    configurable: !0
  }), e.contextTypes && (a.contextTypes = e.contextTypes, process.env.NODE_ENV !== "production" && yE && (yE = !1, console.warn("[mobx-react-lite] Support for Legacy Context in function components will be removed in the next major release."))), r && (a = fn(a)), a = Lm(a), PZ(e, a), process.env.NODE_ENV !== "production" && Object.defineProperty(a, "contextTypes", {
    set: function() {
      var s, l;
      throw new Error("[mobx-react-lite] `".concat(this.displayName || ((s = this.type) === null || s === void 0 ? void 0 : s.displayName) || ((l = this.type) === null || l === void 0 ? void 0 : l.name) || "Component", ".contextTypes` must be set before applying `observer`."));
    }
  }), a;
}
var OZ = {
  $$typeof: !0,
  render: !0,
  compare: !0,
  type: !0,
  // Don't redefine `displayName`,
  // it's defined as getter-setter pair on `memo` (see #3192).
  displayName: !0
};
function PZ(e, t) {
  Object.keys(e).forEach(function(n) {
    OZ[n] || Object.defineProperty(t, n, Object.getOwnPropertyDescriptor(e, n));
  });
}
process.env.NODE_ENV;
function AZ(e, t) {
  return Ke(function() {
    return hn(e(), t, { autoBind: !0 });
  })[0];
}
var am;
yZ(w6);
am = Mu.finalizeAllImmediately;
function DZ(e, t) {
  if (wE(e, t))
    return !0;
  if (typeof e != "object" || e === null || typeof t != "object" || t === null)
    return !1;
  var n = Object.keys(e), r = Object.keys(t);
  if (n.length !== r.length)
    return !1;
  for (var i = 0; i < n.length; i++)
    if (!Object.hasOwnProperty.call(t, n[i]) || !wE(e[n[i]], t[n[i]]))
      return !1;
  return !0;
}
function wE(e, t) {
  return e === t ? e !== 0 || 1 / e === 1 / t : e !== e && t !== t;
}
var xE = /* @__PURE__ */ Symbol("patchMixins"), IA = /* @__PURE__ */ Symbol("patchedDefinition");
function CZ(e, t) {
  var n = e[xE] = e[xE] || {}, r = n[t] = n[t] || {};
  return r.locks = r.locks || 0, r.methods = r.methods || [], r;
}
function EE(e, t) {
  for (var n = this, r = arguments.length, i = new Array(r > 2 ? r - 2 : 0), o = 2; o < r; o++)
    i[o - 2] = arguments[o];
  t.locks++;
  try {
    var a;
    return e != null && (a = e.apply(this, i)), a;
  } finally {
    t.locks--, t.locks === 0 && t.methods.forEach(function(s) {
      s.apply(n, i);
    });
  }
}
function SE(e, t) {
  var n = function() {
    for (var i = arguments.length, o = new Array(i), a = 0; a < i; a++)
      o[a] = arguments[a];
    EE.call.apply(EE, [this, e, t].concat(o));
  };
  return n;
}
function IZ(e, t, n) {
  var r = CZ(e, t);
  r.methods.indexOf(n) < 0 && r.methods.push(n);
  var i = Object.getOwnPropertyDescriptor(e, t);
  if (!(i && i[IA])) {
    var o = e[t], a = MA(e, t, i ? i.enumerable : void 0, r, o);
    Object.defineProperty(e, t, a);
  }
}
function MA(e, t, n, r, i) {
  var o, a = SE(i, r);
  return o = {}, o[IA] = !0, o.get = function() {
    return a;
  }, o.set = function(l) {
    if (this === e)
      a = SE(l, r);
    else {
      var u = MA(this, t, n, r, l);
      Object.defineProperty(this, t, u);
    }
  }, o.configurable = !0, o.enumerable = n, o;
}
var $E = /* @__PURE__ */ Symbol("ObserverAdministration"), kE = /* @__PURE__ */ Symbol("isMobXReactObserver"), RA;
process.env.NODE_ENV !== "production" && (RA = {
  props: /* @__PURE__ */ sm("props"),
  state: /* @__PURE__ */ sm("state"),
  context: /* @__PURE__ */ sm("context")
});
function Ru(e) {
  var t;
  return (t = e[$E]) != null ? t : e[$E] = {
    reaction: null,
    mounted: !1,
    reactionInvalidatedBeforeMount: !1,
    forceUpdate: null,
    name: Df(e.constructor),
    state: void 0,
    props: void 0,
    context: void 0
  };
}
function MZ(e) {
  var t = e.prototype;
  if (e[kE]) {
    var n = Df(e);
    throw new Error("The provided component class (" + n + ") has already been declared as an observer component.");
  } else
    e[kE] = !0;
  if (t.componentWillReact)
    throw new Error("The componentWillReact life-cycle event is no longer supported");
  if (e.__proto__ !== e$) {
    if (!t.shouldComponentUpdate)
      t.shouldComponentUpdate = TE;
    else if (t.shouldComponentUpdate !== TE)
      throw new Error("It is not allowed to use shouldComponentUpdate in observer based components.");
  }
  process.env.NODE_ENV !== "production" && Object.defineProperties(t, RA);
  var r = t.render;
  if (typeof r != "function") {
    var i = Df(e);
    throw new Error("[mobx-react] class component (" + i + ") is missing `render` method.\n`observer` requires `render` being a function defined on prototype.\n`render = () => {}` or `render = function() {}` is not supported.");
  }
  t.render = function() {
    return Object.defineProperty(this, "render", {
      // There is no safe way to replace render, therefore it's forbidden.
      configurable: !1,
      writable: !1,
      value: RZ.call(this, r)
    }), this.render();
  };
  var o = t.componentDidMount;
  return t.componentDidMount = function() {
    var a = this;
    if (process.env.NODE_ENV !== "production" && this.componentDidMount !== Object.getPrototypeOf(this).componentDidMount) {
      var s = Df(e);
      throw new Error("[mobx-react] `observer(" + s + ").componentDidMount` must be defined on prototype.\n`componentDidMount = () => {}` or `componentDidMount = function() {}` is not supported.");
    }
    var l = Ru(this);
    return l.mounted = !0, Mu.unregister(this), l.forceUpdate = function() {
      return a.forceUpdate();
    }, (!l.reaction || l.reactionInvalidatedBeforeMount) && l.forceUpdate(), o?.apply(this, arguments);
  }, IZ(t, "componentWillUnmount", function() {
    var a, s = Ru(this);
    (a = s.reaction) == null || a.dispose(), s.reaction = null, s.forceUpdate = null, s.mounted = !1, s.reactionInvalidatedBeforeMount = !1;
  }), e;
}
function Df(e) {
  return e.displayName || e.name || "<component>";
}
function RZ(e) {
  var t = e.bind(this), n = Ru(this);
  function r() {
    n.reaction || (n.reaction = NZ(n), n.mounted || Mu.register(this, n, this));
    var i = void 0, o = void 0;
    if (n.reaction.track(function() {
      try {
        o = vW(!1, t);
      } catch (a) {
        i = a;
      }
    }), i)
      throw i;
    return o;
  }
  return r;
}
function NZ(e) {
  return new Di(e.name + ".render()", function() {
    if (!e.mounted) {
      e.reactionInvalidatedBeforeMount = !0;
      return;
    }
    try {
      e.forceUpdate == null || e.forceUpdate();
    } catch {
      var t;
      (t = e.reaction) == null || t.dispose(), e.reaction = null;
    }
  });
}
function TE(e, t) {
  return this.state !== t ? !0 : !DZ(this.props, e);
}
function sm(e) {
  return {
    configurable: !0,
    enumerable: !0,
    get: function() {
      var n = Ru(this), r = xW().trackingDerivation;
      if (r && r !== n.reaction)
        throw new Error('[mobx-react] Cannot read "' + n.name + "." + e + `" in a reactive context, as it isn't observable.
                    Please use component lifecycle method to copy the value into a local observable first.
                    See https://github.com/mobxjs/mobx/blob/main/packages/mobx-react/README.md#note-on-using-props-and-state-in-derivations`);
      return n[e];
    },
    set: function(n) {
      Ru(this)[e] = n;
    }
  };
}
function NA(e, t) {
  return e.isMobxInjector === !0 && console.warn("Mobx observer: You are trying to use `observer` on a component that already has `inject`. Please apply `observer` before applying `inject`"), Object.prototype.isPrototypeOf.call(Wd, e) || Object.prototype.isPrototypeOf.call(e$, e) ? MZ(e) : TZ(e);
}
H.version;
if (!Wd)
  throw new Error("mobx-react requires React to be available");
if (!hn)
  throw new Error("mobx-react requires mobx to be available");
const jZ = Symbol.for("__REACT_DND_CONTEXT_INSTANCE__");
function FZ({
  children: e
}) {
  return /* @__PURE__ */ I.jsx(S6.Consumer, { children: ({ dragDropManager: t }) => {
    if (t)
      return /* @__PURE__ */ I.jsx(I.Fragment, { children: e });
    const r = (typeof globalThis < "u" ? globalThis : window)[jZ]?.dragDropManager;
    return r ? /* @__PURE__ */ I.jsx(h1, { manager: r, children: e }) : /* @__PURE__ */ I.jsx(h1, { backend: k6, children: e });
  } });
}
function Ka(e, t, n, r) {
  function i(o) {
    return o instanceof n ? o : new n(function(a) {
      a(o);
    });
  }
  return new (n || (n = Promise))(function(o, a) {
    function s(c) {
      try {
        u(r.next(c));
      } catch (f) {
        a(f);
      }
    }
    function l(c) {
      try {
        u(r.throw(c));
      } catch (f) {
        a(f);
      }
    }
    function u(c) {
      c.done ? o(c.value) : i(c.value).then(s, l);
    }
    u((r = r.apply(e, t || [])).next());
  });
}
const zZ = /* @__PURE__ */ new Map([
  // https://github.com/guzzle/psr7/blob/2d9260799e713f1c475d3c5fdc3d6561ff7441b2/src/MimeType.php
  ["1km", "application/vnd.1000minds.decision-model+xml"],
  ["3dml", "text/vnd.in3d.3dml"],
  ["3ds", "image/x-3ds"],
  ["3g2", "video/3gpp2"],
  ["3gp", "video/3gp"],
  ["3gpp", "video/3gpp"],
  ["3mf", "model/3mf"],
  ["7z", "application/x-7z-compressed"],
  ["7zip", "application/x-7z-compressed"],
  ["123", "application/vnd.lotus-1-2-3"],
  ["aab", "application/x-authorware-bin"],
  ["aac", "audio/x-acc"],
  ["aam", "application/x-authorware-map"],
  ["aas", "application/x-authorware-seg"],
  ["abw", "application/x-abiword"],
  ["ac", "application/vnd.nokia.n-gage.ac+xml"],
  ["ac3", "audio/ac3"],
  ["acc", "application/vnd.americandynamics.acc"],
  ["ace", "application/x-ace-compressed"],
  ["acu", "application/vnd.acucobol"],
  ["acutc", "application/vnd.acucorp"],
  ["adp", "audio/adpcm"],
  ["aep", "application/vnd.audiograph"],
  ["afm", "application/x-font-type1"],
  ["afp", "application/vnd.ibm.modcap"],
  ["ahead", "application/vnd.ahead.space"],
  ["ai", "application/pdf"],
  ["aif", "audio/x-aiff"],
  ["aifc", "audio/x-aiff"],
  ["aiff", "audio/x-aiff"],
  ["air", "application/vnd.adobe.air-application-installer-package+zip"],
  ["ait", "application/vnd.dvb.ait"],
  ["ami", "application/vnd.amiga.ami"],
  ["amr", "audio/amr"],
  ["apk", "application/vnd.android.package-archive"],
  ["apng", "image/apng"],
  ["appcache", "text/cache-manifest"],
  ["application", "application/x-ms-application"],
  ["apr", "application/vnd.lotus-approach"],
  ["arc", "application/x-freearc"],
  ["arj", "application/x-arj"],
  ["asc", "application/pgp-signature"],
  ["asf", "video/x-ms-asf"],
  ["asm", "text/x-asm"],
  ["aso", "application/vnd.accpac.simply.aso"],
  ["asx", "video/x-ms-asf"],
  ["atc", "application/vnd.acucorp"],
  ["atom", "application/atom+xml"],
  ["atomcat", "application/atomcat+xml"],
  ["atomdeleted", "application/atomdeleted+xml"],
  ["atomsvc", "application/atomsvc+xml"],
  ["atx", "application/vnd.antix.game-component"],
  ["au", "audio/x-au"],
  ["avi", "video/x-msvideo"],
  ["avif", "image/avif"],
  ["aw", "application/applixware"],
  ["azf", "application/vnd.airzip.filesecure.azf"],
  ["azs", "application/vnd.airzip.filesecure.azs"],
  ["azv", "image/vnd.airzip.accelerator.azv"],
  ["azw", "application/vnd.amazon.ebook"],
  ["b16", "image/vnd.pco.b16"],
  ["bat", "application/x-msdownload"],
  ["bcpio", "application/x-bcpio"],
  ["bdf", "application/x-font-bdf"],
  ["bdm", "application/vnd.syncml.dm+wbxml"],
  ["bdoc", "application/x-bdoc"],
  ["bed", "application/vnd.realvnc.bed"],
  ["bh2", "application/vnd.fujitsu.oasysprs"],
  ["bin", "application/octet-stream"],
  ["blb", "application/x-blorb"],
  ["blorb", "application/x-blorb"],
  ["bmi", "application/vnd.bmi"],
  ["bmml", "application/vnd.balsamiq.bmml+xml"],
  ["bmp", "image/bmp"],
  ["book", "application/vnd.framemaker"],
  ["box", "application/vnd.previewsystems.box"],
  ["boz", "application/x-bzip2"],
  ["bpk", "application/octet-stream"],
  ["bpmn", "application/octet-stream"],
  ["bsp", "model/vnd.valve.source.compiled-map"],
  ["btif", "image/prs.btif"],
  ["buffer", "application/octet-stream"],
  ["bz", "application/x-bzip"],
  ["bz2", "application/x-bzip2"],
  ["c", "text/x-c"],
  ["c4d", "application/vnd.clonk.c4group"],
  ["c4f", "application/vnd.clonk.c4group"],
  ["c4g", "application/vnd.clonk.c4group"],
  ["c4p", "application/vnd.clonk.c4group"],
  ["c4u", "application/vnd.clonk.c4group"],
  ["c11amc", "application/vnd.cluetrust.cartomobile-config"],
  ["c11amz", "application/vnd.cluetrust.cartomobile-config-pkg"],
  ["cab", "application/vnd.ms-cab-compressed"],
  ["caf", "audio/x-caf"],
  ["cap", "application/vnd.tcpdump.pcap"],
  ["car", "application/vnd.curl.car"],
  ["cat", "application/vnd.ms-pki.seccat"],
  ["cb7", "application/x-cbr"],
  ["cba", "application/x-cbr"],
  ["cbr", "application/x-cbr"],
  ["cbt", "application/x-cbr"],
  ["cbz", "application/x-cbr"],
  ["cc", "text/x-c"],
  ["cco", "application/x-cocoa"],
  ["cct", "application/x-director"],
  ["ccxml", "application/ccxml+xml"],
  ["cdbcmsg", "application/vnd.contact.cmsg"],
  ["cda", "application/x-cdf"],
  ["cdf", "application/x-netcdf"],
  ["cdfx", "application/cdfx+xml"],
  ["cdkey", "application/vnd.mediastation.cdkey"],
  ["cdmia", "application/cdmi-capability"],
  ["cdmic", "application/cdmi-container"],
  ["cdmid", "application/cdmi-domain"],
  ["cdmio", "application/cdmi-object"],
  ["cdmiq", "application/cdmi-queue"],
  ["cdr", "application/cdr"],
  ["cdx", "chemical/x-cdx"],
  ["cdxml", "application/vnd.chemdraw+xml"],
  ["cdy", "application/vnd.cinderella"],
  ["cer", "application/pkix-cert"],
  ["cfs", "application/x-cfs-compressed"],
  ["cgm", "image/cgm"],
  ["chat", "application/x-chat"],
  ["chm", "application/vnd.ms-htmlhelp"],
  ["chrt", "application/vnd.kde.kchart"],
  ["cif", "chemical/x-cif"],
  ["cii", "application/vnd.anser-web-certificate-issue-initiation"],
  ["cil", "application/vnd.ms-artgalry"],
  ["cjs", "application/node"],
  ["cla", "application/vnd.claymore"],
  ["class", "application/octet-stream"],
  ["clkk", "application/vnd.crick.clicker.keyboard"],
  ["clkp", "application/vnd.crick.clicker.palette"],
  ["clkt", "application/vnd.crick.clicker.template"],
  ["clkw", "application/vnd.crick.clicker.wordbank"],
  ["clkx", "application/vnd.crick.clicker"],
  ["clp", "application/x-msclip"],
  ["cmc", "application/vnd.cosmocaller"],
  ["cmdf", "chemical/x-cmdf"],
  ["cml", "chemical/x-cml"],
  ["cmp", "application/vnd.yellowriver-custom-menu"],
  ["cmx", "image/x-cmx"],
  ["cod", "application/vnd.rim.cod"],
  ["coffee", "text/coffeescript"],
  ["com", "application/x-msdownload"],
  ["conf", "text/plain"],
  ["cpio", "application/x-cpio"],
  ["cpp", "text/x-c"],
  ["cpt", "application/mac-compactpro"],
  ["crd", "application/x-mscardfile"],
  ["crl", "application/pkix-crl"],
  ["crt", "application/x-x509-ca-cert"],
  ["crx", "application/x-chrome-extension"],
  ["cryptonote", "application/vnd.rig.cryptonote"],
  ["csh", "application/x-csh"],
  ["csl", "application/vnd.citationstyles.style+xml"],
  ["csml", "chemical/x-csml"],
  ["csp", "application/vnd.commonspace"],
  ["csr", "application/octet-stream"],
  ["css", "text/css"],
  ["cst", "application/x-director"],
  ["csv", "text/csv"],
  ["cu", "application/cu-seeme"],
  ["curl", "text/vnd.curl"],
  ["cww", "application/prs.cww"],
  ["cxt", "application/x-director"],
  ["cxx", "text/x-c"],
  ["dae", "model/vnd.collada+xml"],
  ["daf", "application/vnd.mobius.daf"],
  ["dart", "application/vnd.dart"],
  ["dataless", "application/vnd.fdsn.seed"],
  ["davmount", "application/davmount+xml"],
  ["dbf", "application/vnd.dbf"],
  ["dbk", "application/docbook+xml"],
  ["dcr", "application/x-director"],
  ["dcurl", "text/vnd.curl.dcurl"],
  ["dd2", "application/vnd.oma.dd2+xml"],
  ["ddd", "application/vnd.fujixerox.ddd"],
  ["ddf", "application/vnd.syncml.dmddf+xml"],
  ["dds", "image/vnd.ms-dds"],
  ["deb", "application/x-debian-package"],
  ["def", "text/plain"],
  ["deploy", "application/octet-stream"],
  ["der", "application/x-x509-ca-cert"],
  ["dfac", "application/vnd.dreamfactory"],
  ["dgc", "application/x-dgc-compressed"],
  ["dic", "text/x-c"],
  ["dir", "application/x-director"],
  ["dis", "application/vnd.mobius.dis"],
  ["disposition-notification", "message/disposition-notification"],
  ["dist", "application/octet-stream"],
  ["distz", "application/octet-stream"],
  ["djv", "image/vnd.djvu"],
  ["djvu", "image/vnd.djvu"],
  ["dll", "application/octet-stream"],
  ["dmg", "application/x-apple-diskimage"],
  ["dmn", "application/octet-stream"],
  ["dmp", "application/vnd.tcpdump.pcap"],
  ["dms", "application/octet-stream"],
  ["dna", "application/vnd.dna"],
  ["doc", "application/msword"],
  ["docm", "application/vnd.ms-word.template.macroEnabled.12"],
  ["docx", "application/vnd.openxmlformats-officedocument.wordprocessingml.document"],
  ["dot", "application/msword"],
  ["dotm", "application/vnd.ms-word.template.macroEnabled.12"],
  ["dotx", "application/vnd.openxmlformats-officedocument.wordprocessingml.template"],
  ["dp", "application/vnd.osgi.dp"],
  ["dpg", "application/vnd.dpgraph"],
  ["dra", "audio/vnd.dra"],
  ["drle", "image/dicom-rle"],
  ["dsc", "text/prs.lines.tag"],
  ["dssc", "application/dssc+der"],
  ["dtb", "application/x-dtbook+xml"],
  ["dtd", "application/xml-dtd"],
  ["dts", "audio/vnd.dts"],
  ["dtshd", "audio/vnd.dts.hd"],
  ["dump", "application/octet-stream"],
  ["dvb", "video/vnd.dvb.file"],
  ["dvi", "application/x-dvi"],
  ["dwd", "application/atsc-dwd+xml"],
  ["dwf", "model/vnd.dwf"],
  ["dwg", "image/vnd.dwg"],
  ["dxf", "image/vnd.dxf"],
  ["dxp", "application/vnd.spotfire.dxp"],
  ["dxr", "application/x-director"],
  ["ear", "application/java-archive"],
  ["ecelp4800", "audio/vnd.nuera.ecelp4800"],
  ["ecelp7470", "audio/vnd.nuera.ecelp7470"],
  ["ecelp9600", "audio/vnd.nuera.ecelp9600"],
  ["ecma", "application/ecmascript"],
  ["edm", "application/vnd.novadigm.edm"],
  ["edx", "application/vnd.novadigm.edx"],
  ["efif", "application/vnd.picsel"],
  ["ei6", "application/vnd.pg.osasli"],
  ["elc", "application/octet-stream"],
  ["emf", "image/emf"],
  ["eml", "message/rfc822"],
  ["emma", "application/emma+xml"],
  ["emotionml", "application/emotionml+xml"],
  ["emz", "application/x-msmetafile"],
  ["eol", "audio/vnd.digital-winds"],
  ["eot", "application/vnd.ms-fontobject"],
  ["eps", "application/postscript"],
  ["epub", "application/epub+zip"],
  ["es", "application/ecmascript"],
  ["es3", "application/vnd.eszigno3+xml"],
  ["esa", "application/vnd.osgi.subsystem"],
  ["esf", "application/vnd.epson.esf"],
  ["et3", "application/vnd.eszigno3+xml"],
  ["etx", "text/x-setext"],
  ["eva", "application/x-eva"],
  ["evy", "application/x-envoy"],
  ["exe", "application/octet-stream"],
  ["exi", "application/exi"],
  ["exp", "application/express"],
  ["exr", "image/aces"],
  ["ext", "application/vnd.novadigm.ext"],
  ["ez", "application/andrew-inset"],
  ["ez2", "application/vnd.ezpix-album"],
  ["ez3", "application/vnd.ezpix-package"],
  ["f", "text/x-fortran"],
  ["f4v", "video/mp4"],
  ["f77", "text/x-fortran"],
  ["f90", "text/x-fortran"],
  ["fbs", "image/vnd.fastbidsheet"],
  ["fcdt", "application/vnd.adobe.formscentral.fcdt"],
  ["fcs", "application/vnd.isac.fcs"],
  ["fdf", "application/vnd.fdf"],
  ["fdt", "application/fdt+xml"],
  ["fe_launch", "application/vnd.denovo.fcselayout-link"],
  ["fg5", "application/vnd.fujitsu.oasysgp"],
  ["fgd", "application/x-director"],
  ["fh", "image/x-freehand"],
  ["fh4", "image/x-freehand"],
  ["fh5", "image/x-freehand"],
  ["fh7", "image/x-freehand"],
  ["fhc", "image/x-freehand"],
  ["fig", "application/x-xfig"],
  ["fits", "image/fits"],
  ["flac", "audio/x-flac"],
  ["fli", "video/x-fli"],
  ["flo", "application/vnd.micrografx.flo"],
  ["flv", "video/x-flv"],
  ["flw", "application/vnd.kde.kivio"],
  ["flx", "text/vnd.fmi.flexstor"],
  ["fly", "text/vnd.fly"],
  ["fm", "application/vnd.framemaker"],
  ["fnc", "application/vnd.frogans.fnc"],
  ["fo", "application/vnd.software602.filler.form+xml"],
  ["for", "text/x-fortran"],
  ["fpx", "image/vnd.fpx"],
  ["frame", "application/vnd.framemaker"],
  ["fsc", "application/vnd.fsc.weblaunch"],
  ["fst", "image/vnd.fst"],
  ["ftc", "application/vnd.fluxtime.clip"],
  ["fti", "application/vnd.anser-web-funds-transfer-initiation"],
  ["fvt", "video/vnd.fvt"],
  ["fxp", "application/vnd.adobe.fxp"],
  ["fxpl", "application/vnd.adobe.fxp"],
  ["fzs", "application/vnd.fuzzysheet"],
  ["g2w", "application/vnd.geoplan"],
  ["g3", "image/g3fax"],
  ["g3w", "application/vnd.geospace"],
  ["gac", "application/vnd.groove-account"],
  ["gam", "application/x-tads"],
  ["gbr", "application/rpki-ghostbusters"],
  ["gca", "application/x-gca-compressed"],
  ["gdl", "model/vnd.gdl"],
  ["gdoc", "application/vnd.google-apps.document"],
  ["geo", "application/vnd.dynageo"],
  ["geojson", "application/geo+json"],
  ["gex", "application/vnd.geometry-explorer"],
  ["ggb", "application/vnd.geogebra.file"],
  ["ggt", "application/vnd.geogebra.tool"],
  ["ghf", "application/vnd.groove-help"],
  ["gif", "image/gif"],
  ["gim", "application/vnd.groove-identity-message"],
  ["glb", "model/gltf-binary"],
  ["gltf", "model/gltf+json"],
  ["gml", "application/gml+xml"],
  ["gmx", "application/vnd.gmx"],
  ["gnumeric", "application/x-gnumeric"],
  ["gpg", "application/gpg-keys"],
  ["gph", "application/vnd.flographit"],
  ["gpx", "application/gpx+xml"],
  ["gqf", "application/vnd.grafeq"],
  ["gqs", "application/vnd.grafeq"],
  ["gram", "application/srgs"],
  ["gramps", "application/x-gramps-xml"],
  ["gre", "application/vnd.geometry-explorer"],
  ["grv", "application/vnd.groove-injector"],
  ["grxml", "application/srgs+xml"],
  ["gsf", "application/x-font-ghostscript"],
  ["gsheet", "application/vnd.google-apps.spreadsheet"],
  ["gslides", "application/vnd.google-apps.presentation"],
  ["gtar", "application/x-gtar"],
  ["gtm", "application/vnd.groove-tool-message"],
  ["gtw", "model/vnd.gtw"],
  ["gv", "text/vnd.graphviz"],
  ["gxf", "application/gxf"],
  ["gxt", "application/vnd.geonext"],
  ["gz", "application/gzip"],
  ["gzip", "application/gzip"],
  ["h", "text/x-c"],
  ["h261", "video/h261"],
  ["h263", "video/h263"],
  ["h264", "video/h264"],
  ["hal", "application/vnd.hal+xml"],
  ["hbci", "application/vnd.hbci"],
  ["hbs", "text/x-handlebars-template"],
  ["hdd", "application/x-virtualbox-hdd"],
  ["hdf", "application/x-hdf"],
  ["heic", "image/heic"],
  ["heics", "image/heic-sequence"],
  ["heif", "image/heif"],
  ["heifs", "image/heif-sequence"],
  ["hej2", "image/hej2k"],
  ["held", "application/atsc-held+xml"],
  ["hh", "text/x-c"],
  ["hjson", "application/hjson"],
  ["hlp", "application/winhlp"],
  ["hpgl", "application/vnd.hp-hpgl"],
  ["hpid", "application/vnd.hp-hpid"],
  ["hps", "application/vnd.hp-hps"],
  ["hqx", "application/mac-binhex40"],
  ["hsj2", "image/hsj2"],
  ["htc", "text/x-component"],
  ["htke", "application/vnd.kenameaapp"],
  ["htm", "text/html"],
  ["html", "text/html"],
  ["hvd", "application/vnd.yamaha.hv-dic"],
  ["hvp", "application/vnd.yamaha.hv-voice"],
  ["hvs", "application/vnd.yamaha.hv-script"],
  ["i2g", "application/vnd.intergeo"],
  ["icc", "application/vnd.iccprofile"],
  ["ice", "x-conference/x-cooltalk"],
  ["icm", "application/vnd.iccprofile"],
  ["ico", "image/x-icon"],
  ["ics", "text/calendar"],
  ["ief", "image/ief"],
  ["ifb", "text/calendar"],
  ["ifm", "application/vnd.shana.informed.formdata"],
  ["iges", "model/iges"],
  ["igl", "application/vnd.igloader"],
  ["igm", "application/vnd.insors.igm"],
  ["igs", "model/iges"],
  ["igx", "application/vnd.micrografx.igx"],
  ["iif", "application/vnd.shana.informed.interchange"],
  ["img", "application/octet-stream"],
  ["imp", "application/vnd.accpac.simply.imp"],
  ["ims", "application/vnd.ms-ims"],
  ["in", "text/plain"],
  ["ini", "text/plain"],
  ["ink", "application/inkml+xml"],
  ["inkml", "application/inkml+xml"],
  ["install", "application/x-install-instructions"],
  ["iota", "application/vnd.astraea-software.iota"],
  ["ipfix", "application/ipfix"],
  ["ipk", "application/vnd.shana.informed.package"],
  ["irm", "application/vnd.ibm.rights-management"],
  ["irp", "application/vnd.irepository.package+xml"],
  ["iso", "application/x-iso9660-image"],
  ["itp", "application/vnd.shana.informed.formtemplate"],
  ["its", "application/its+xml"],
  ["ivp", "application/vnd.immervision-ivp"],
  ["ivu", "application/vnd.immervision-ivu"],
  ["jad", "text/vnd.sun.j2me.app-descriptor"],
  ["jade", "text/jade"],
  ["jam", "application/vnd.jam"],
  ["jar", "application/java-archive"],
  ["jardiff", "application/x-java-archive-diff"],
  ["java", "text/x-java-source"],
  ["jhc", "image/jphc"],
  ["jisp", "application/vnd.jisp"],
  ["jls", "image/jls"],
  ["jlt", "application/vnd.hp-jlyt"],
  ["jng", "image/x-jng"],
  ["jnlp", "application/x-java-jnlp-file"],
  ["joda", "application/vnd.joost.joda-archive"],
  ["jp2", "image/jp2"],
  ["jpe", "image/jpeg"],
  ["jpeg", "image/jpeg"],
  ["jpf", "image/jpx"],
  ["jpg", "image/jpeg"],
  ["jpg2", "image/jp2"],
  ["jpgm", "video/jpm"],
  ["jpgv", "video/jpeg"],
  ["jph", "image/jph"],
  ["jpm", "video/jpm"],
  ["jpx", "image/jpx"],
  ["js", "application/javascript"],
  ["json", "application/json"],
  ["json5", "application/json5"],
  ["jsonld", "application/ld+json"],
  // https://jsonlines.org/
  ["jsonl", "application/jsonl"],
  ["jsonml", "application/jsonml+json"],
  ["jsx", "text/jsx"],
  ["jxr", "image/jxr"],
  ["jxra", "image/jxra"],
  ["jxrs", "image/jxrs"],
  ["jxs", "image/jxs"],
  ["jxsc", "image/jxsc"],
  ["jxsi", "image/jxsi"],
  ["jxss", "image/jxss"],
  ["kar", "audio/midi"],
  ["karbon", "application/vnd.kde.karbon"],
  ["kdb", "application/octet-stream"],
  ["kdbx", "application/x-keepass2"],
  ["key", "application/x-iwork-keynote-sffkey"],
  ["kfo", "application/vnd.kde.kformula"],
  ["kia", "application/vnd.kidspiration"],
  ["kml", "application/vnd.google-earth.kml+xml"],
  ["kmz", "application/vnd.google-earth.kmz"],
  ["kne", "application/vnd.kinar"],
  ["knp", "application/vnd.kinar"],
  ["kon", "application/vnd.kde.kontour"],
  ["kpr", "application/vnd.kde.kpresenter"],
  ["kpt", "application/vnd.kde.kpresenter"],
  ["kpxx", "application/vnd.ds-keypoint"],
  ["ksp", "application/vnd.kde.kspread"],
  ["ktr", "application/vnd.kahootz"],
  ["ktx", "image/ktx"],
  ["ktx2", "image/ktx2"],
  ["ktz", "application/vnd.kahootz"],
  ["kwd", "application/vnd.kde.kword"],
  ["kwt", "application/vnd.kde.kword"],
  ["lasxml", "application/vnd.las.las+xml"],
  ["latex", "application/x-latex"],
  ["lbd", "application/vnd.llamagraphics.life-balance.desktop"],
  ["lbe", "application/vnd.llamagraphics.life-balance.exchange+xml"],
  ["les", "application/vnd.hhe.lesson-player"],
  ["less", "text/less"],
  ["lgr", "application/lgr+xml"],
  ["lha", "application/octet-stream"],
  ["link66", "application/vnd.route66.link66+xml"],
  ["list", "text/plain"],
  ["list3820", "application/vnd.ibm.modcap"],
  ["listafp", "application/vnd.ibm.modcap"],
  ["litcoffee", "text/coffeescript"],
  ["lnk", "application/x-ms-shortcut"],
  ["log", "text/plain"],
  ["lostxml", "application/lost+xml"],
  ["lrf", "application/octet-stream"],
  ["lrm", "application/vnd.ms-lrm"],
  ["ltf", "application/vnd.frogans.ltf"],
  ["lua", "text/x-lua"],
  ["luac", "application/x-lua-bytecode"],
  ["lvp", "audio/vnd.lucent.voice"],
  ["lwp", "application/vnd.lotus-wordpro"],
  ["lzh", "application/octet-stream"],
  ["m1v", "video/mpeg"],
  ["m2a", "audio/mpeg"],
  ["m2v", "video/mpeg"],
  ["m3a", "audio/mpeg"],
  ["m3u", "text/plain"],
  ["m3u8", "application/vnd.apple.mpegurl"],
  ["m4a", "audio/x-m4a"],
  ["m4p", "application/mp4"],
  ["m4s", "video/iso.segment"],
  ["m4u", "application/vnd.mpegurl"],
  ["m4v", "video/x-m4v"],
  ["m13", "application/x-msmediaview"],
  ["m14", "application/x-msmediaview"],
  ["m21", "application/mp21"],
  ["ma", "application/mathematica"],
  ["mads", "application/mads+xml"],
  ["maei", "application/mmt-aei+xml"],
  ["mag", "application/vnd.ecowin.chart"],
  ["maker", "application/vnd.framemaker"],
  ["man", "text/troff"],
  ["manifest", "text/cache-manifest"],
  ["map", "application/json"],
  ["mar", "application/octet-stream"],
  ["markdown", "text/markdown"],
  ["mathml", "application/mathml+xml"],
  ["mb", "application/mathematica"],
  ["mbk", "application/vnd.mobius.mbk"],
  ["mbox", "application/mbox"],
  ["mc1", "application/vnd.medcalcdata"],
  ["mcd", "application/vnd.mcd"],
  ["mcurl", "text/vnd.curl.mcurl"],
  ["md", "text/markdown"],
  ["mdb", "application/x-msaccess"],
  ["mdi", "image/vnd.ms-modi"],
  ["mdx", "text/mdx"],
  ["me", "text/troff"],
  ["mesh", "model/mesh"],
  ["meta4", "application/metalink4+xml"],
  ["metalink", "application/metalink+xml"],
  ["mets", "application/mets+xml"],
  ["mfm", "application/vnd.mfmp"],
  ["mft", "application/rpki-manifest"],
  ["mgp", "application/vnd.osgeo.mapguide.package"],
  ["mgz", "application/vnd.proteus.magazine"],
  ["mid", "audio/midi"],
  ["midi", "audio/midi"],
  ["mie", "application/x-mie"],
  ["mif", "application/vnd.mif"],
  ["mime", "message/rfc822"],
  ["mj2", "video/mj2"],
  ["mjp2", "video/mj2"],
  ["mjs", "application/javascript"],
  ["mk3d", "video/x-matroska"],
  ["mka", "audio/x-matroska"],
  ["mkd", "text/x-markdown"],
  ["mks", "video/x-matroska"],
  ["mkv", "video/x-matroska"],
  ["mlp", "application/vnd.dolby.mlp"],
  ["mmd", "application/vnd.chipnuts.karaoke-mmd"],
  ["mmf", "application/vnd.smaf"],
  ["mml", "text/mathml"],
  ["mmr", "image/vnd.fujixerox.edmics-mmr"],
  ["mng", "video/x-mng"],
  ["mny", "application/x-msmoney"],
  ["mobi", "application/x-mobipocket-ebook"],
  ["mods", "application/mods+xml"],
  ["mov", "video/quicktime"],
  ["movie", "video/x-sgi-movie"],
  ["mp2", "audio/mpeg"],
  ["mp2a", "audio/mpeg"],
  ["mp3", "audio/mpeg"],
  ["mp4", "video/mp4"],
  ["mp4a", "audio/mp4"],
  ["mp4s", "application/mp4"],
  ["mp4v", "video/mp4"],
  ["mp21", "application/mp21"],
  ["mpc", "application/vnd.mophun.certificate"],
  ["mpd", "application/dash+xml"],
  ["mpe", "video/mpeg"],
  ["mpeg", "video/mpeg"],
  ["mpg", "video/mpeg"],
  ["mpg4", "video/mp4"],
  ["mpga", "audio/mpeg"],
  ["mpkg", "application/vnd.apple.installer+xml"],
  ["mpm", "application/vnd.blueice.multipass"],
  ["mpn", "application/vnd.mophun.application"],
  ["mpp", "application/vnd.ms-project"],
  ["mpt", "application/vnd.ms-project"],
  ["mpy", "application/vnd.ibm.minipay"],
  ["mqy", "application/vnd.mobius.mqy"],
  ["mrc", "application/marc"],
  ["mrcx", "application/marcxml+xml"],
  ["ms", "text/troff"],
  ["mscml", "application/mediaservercontrol+xml"],
  ["mseed", "application/vnd.fdsn.mseed"],
  ["mseq", "application/vnd.mseq"],
  ["msf", "application/vnd.epson.msf"],
  ["msg", "application/vnd.ms-outlook"],
  ["msh", "model/mesh"],
  ["msi", "application/x-msdownload"],
  ["msl", "application/vnd.mobius.msl"],
  ["msm", "application/octet-stream"],
  ["msp", "application/octet-stream"],
  ["msty", "application/vnd.muvee.style"],
  ["mtl", "model/mtl"],
  ["mts", "model/vnd.mts"],
  ["mus", "application/vnd.musician"],
  ["musd", "application/mmt-usd+xml"],
  ["musicxml", "application/vnd.recordare.musicxml+xml"],
  ["mvb", "application/x-msmediaview"],
  ["mvt", "application/vnd.mapbox-vector-tile"],
  ["mwf", "application/vnd.mfer"],
  ["mxf", "application/mxf"],
  ["mxl", "application/vnd.recordare.musicxml"],
  ["mxmf", "audio/mobile-xmf"],
  ["mxml", "application/xv+xml"],
  ["mxs", "application/vnd.triscape.mxs"],
  ["mxu", "video/vnd.mpegurl"],
  ["n-gage", "application/vnd.nokia.n-gage.symbian.install"],
  ["n3", "text/n3"],
  ["nb", "application/mathematica"],
  ["nbp", "application/vnd.wolfram.player"],
  ["nc", "application/x-netcdf"],
  ["ncx", "application/x-dtbncx+xml"],
  ["nfo", "text/x-nfo"],
  ["ngdat", "application/vnd.nokia.n-gage.data"],
  ["nitf", "application/vnd.nitf"],
  ["nlu", "application/vnd.neurolanguage.nlu"],
  ["nml", "application/vnd.enliven"],
  ["nnd", "application/vnd.noblenet-directory"],
  ["nns", "application/vnd.noblenet-sealer"],
  ["nnw", "application/vnd.noblenet-web"],
  ["npx", "image/vnd.net-fpx"],
  ["nq", "application/n-quads"],
  ["nsc", "application/x-conference"],
  ["nsf", "application/vnd.lotus-notes"],
  ["nt", "application/n-triples"],
  ["ntf", "application/vnd.nitf"],
  ["numbers", "application/x-iwork-numbers-sffnumbers"],
  ["nzb", "application/x-nzb"],
  ["oa2", "application/vnd.fujitsu.oasys2"],
  ["oa3", "application/vnd.fujitsu.oasys3"],
  ["oas", "application/vnd.fujitsu.oasys"],
  ["obd", "application/x-msbinder"],
  ["obgx", "application/vnd.openblox.game+xml"],
  ["obj", "model/obj"],
  ["oda", "application/oda"],
  ["odb", "application/vnd.oasis.opendocument.database"],
  ["odc", "application/vnd.oasis.opendocument.chart"],
  ["odf", "application/vnd.oasis.opendocument.formula"],
  ["odft", "application/vnd.oasis.opendocument.formula-template"],
  ["odg", "application/vnd.oasis.opendocument.graphics"],
  ["odi", "application/vnd.oasis.opendocument.image"],
  ["odm", "application/vnd.oasis.opendocument.text-master"],
  ["odp", "application/vnd.oasis.opendocument.presentation"],
  ["ods", "application/vnd.oasis.opendocument.spreadsheet"],
  ["odt", "application/vnd.oasis.opendocument.text"],
  ["oga", "audio/ogg"],
  ["ogex", "model/vnd.opengex"],
  ["ogg", "audio/ogg"],
  ["ogv", "video/ogg"],
  ["ogx", "application/ogg"],
  ["omdoc", "application/omdoc+xml"],
  ["onepkg", "application/onenote"],
  ["onetmp", "application/onenote"],
  ["onetoc", "application/onenote"],
  ["onetoc2", "application/onenote"],
  ["opf", "application/oebps-package+xml"],
  ["opml", "text/x-opml"],
  ["oprc", "application/vnd.palm"],
  ["opus", "audio/ogg"],
  ["org", "text/x-org"],
  ["osf", "application/vnd.yamaha.openscoreformat"],
  ["osfpvg", "application/vnd.yamaha.openscoreformat.osfpvg+xml"],
  ["osm", "application/vnd.openstreetmap.data+xml"],
  ["otc", "application/vnd.oasis.opendocument.chart-template"],
  ["otf", "font/otf"],
  ["otg", "application/vnd.oasis.opendocument.graphics-template"],
  ["oth", "application/vnd.oasis.opendocument.text-web"],
  ["oti", "application/vnd.oasis.opendocument.image-template"],
  ["otp", "application/vnd.oasis.opendocument.presentation-template"],
  ["ots", "application/vnd.oasis.opendocument.spreadsheet-template"],
  ["ott", "application/vnd.oasis.opendocument.text-template"],
  ["ova", "application/x-virtualbox-ova"],
  ["ovf", "application/x-virtualbox-ovf"],
  ["owl", "application/rdf+xml"],
  ["oxps", "application/oxps"],
  ["oxt", "application/vnd.openofficeorg.extension"],
  ["p", "text/x-pascal"],
  ["p7a", "application/x-pkcs7-signature"],
  ["p7b", "application/x-pkcs7-certificates"],
  ["p7c", "application/pkcs7-mime"],
  ["p7m", "application/pkcs7-mime"],
  ["p7r", "application/x-pkcs7-certreqresp"],
  ["p7s", "application/pkcs7-signature"],
  ["p8", "application/pkcs8"],
  ["p10", "application/x-pkcs10"],
  ["p12", "application/x-pkcs12"],
  ["pac", "application/x-ns-proxy-autoconfig"],
  ["pages", "application/x-iwork-pages-sffpages"],
  ["pas", "text/x-pascal"],
  ["paw", "application/vnd.pawaafile"],
  ["pbd", "application/vnd.powerbuilder6"],
  ["pbm", "image/x-portable-bitmap"],
  ["pcap", "application/vnd.tcpdump.pcap"],
  ["pcf", "application/x-font-pcf"],
  ["pcl", "application/vnd.hp-pcl"],
  ["pclxl", "application/vnd.hp-pclxl"],
  ["pct", "image/x-pict"],
  ["pcurl", "application/vnd.curl.pcurl"],
  ["pcx", "image/x-pcx"],
  ["pdb", "application/x-pilot"],
  ["pde", "text/x-processing"],
  ["pdf", "application/pdf"],
  ["pem", "application/x-x509-user-cert"],
  ["pfa", "application/x-font-type1"],
  ["pfb", "application/x-font-type1"],
  ["pfm", "application/x-font-type1"],
  ["pfr", "application/font-tdpfr"],
  ["pfx", "application/x-pkcs12"],
  ["pgm", "image/x-portable-graymap"],
  ["pgn", "application/x-chess-pgn"],
  ["pgp", "application/pgp"],
  ["php", "application/x-httpd-php"],
  ["php3", "application/x-httpd-php"],
  ["php4", "application/x-httpd-php"],
  ["phps", "application/x-httpd-php-source"],
  ["phtml", "application/x-httpd-php"],
  ["pic", "image/x-pict"],
  ["pkg", "application/octet-stream"],
  ["pki", "application/pkixcmp"],
  ["pkipath", "application/pkix-pkipath"],
  ["pkpass", "application/vnd.apple.pkpass"],
  ["pl", "application/x-perl"],
  ["plb", "application/vnd.3gpp.pic-bw-large"],
  ["plc", "application/vnd.mobius.plc"],
  ["plf", "application/vnd.pocketlearn"],
  ["pls", "application/pls+xml"],
  ["pm", "application/x-perl"],
  ["pml", "application/vnd.ctc-posml"],
  ["png", "image/png"],
  ["pnm", "image/x-portable-anymap"],
  ["portpkg", "application/vnd.macports.portpkg"],
  ["pot", "application/vnd.ms-powerpoint"],
  ["potm", "application/vnd.ms-powerpoint.presentation.macroEnabled.12"],
  ["potx", "application/vnd.openxmlformats-officedocument.presentationml.template"],
  ["ppa", "application/vnd.ms-powerpoint"],
  ["ppam", "application/vnd.ms-powerpoint.addin.macroEnabled.12"],
  ["ppd", "application/vnd.cups-ppd"],
  ["ppm", "image/x-portable-pixmap"],
  ["pps", "application/vnd.ms-powerpoint"],
  ["ppsm", "application/vnd.ms-powerpoint.slideshow.macroEnabled.12"],
  ["ppsx", "application/vnd.openxmlformats-officedocument.presentationml.slideshow"],
  ["ppt", "application/powerpoint"],
  ["pptm", "application/vnd.ms-powerpoint.presentation.macroEnabled.12"],
  ["pptx", "application/vnd.openxmlformats-officedocument.presentationml.presentation"],
  ["pqa", "application/vnd.palm"],
  ["prc", "application/x-pilot"],
  ["pre", "application/vnd.lotus-freelance"],
  ["prf", "application/pics-rules"],
  ["provx", "application/provenance+xml"],
  ["ps", "application/postscript"],
  ["psb", "application/vnd.3gpp.pic-bw-small"],
  ["psd", "application/x-photoshop"],
  ["psf", "application/x-font-linux-psf"],
  ["pskcxml", "application/pskc+xml"],
  ["pti", "image/prs.pti"],
  ["ptid", "application/vnd.pvi.ptid1"],
  ["pub", "application/x-mspublisher"],
  ["pvb", "application/vnd.3gpp.pic-bw-var"],
  ["pwn", "application/vnd.3m.post-it-notes"],
  ["pya", "audio/vnd.ms-playready.media.pya"],
  ["pyv", "video/vnd.ms-playready.media.pyv"],
  ["qam", "application/vnd.epson.quickanime"],
  ["qbo", "application/vnd.intu.qbo"],
  ["qfx", "application/vnd.intu.qfx"],
  ["qps", "application/vnd.publishare-delta-tree"],
  ["qt", "video/quicktime"],
  ["qwd", "application/vnd.quark.quarkxpress"],
  ["qwt", "application/vnd.quark.quarkxpress"],
  ["qxb", "application/vnd.quark.quarkxpress"],
  ["qxd", "application/vnd.quark.quarkxpress"],
  ["qxl", "application/vnd.quark.quarkxpress"],
  ["qxt", "application/vnd.quark.quarkxpress"],
  ["ra", "audio/x-realaudio"],
  ["ram", "audio/x-pn-realaudio"],
  ["raml", "application/raml+yaml"],
  ["rapd", "application/route-apd+xml"],
  ["rar", "application/x-rar"],
  ["ras", "image/x-cmu-raster"],
  ["rcprofile", "application/vnd.ipunplugged.rcprofile"],
  ["rdf", "application/rdf+xml"],
  ["rdz", "application/vnd.data-vision.rdz"],
  ["relo", "application/p2p-overlay+xml"],
  ["rep", "application/vnd.businessobjects"],
  ["res", "application/x-dtbresource+xml"],
  ["rgb", "image/x-rgb"],
  ["rif", "application/reginfo+xml"],
  ["rip", "audio/vnd.rip"],
  ["ris", "application/x-research-info-systems"],
  ["rl", "application/resource-lists+xml"],
  ["rlc", "image/vnd.fujixerox.edmics-rlc"],
  ["rld", "application/resource-lists-diff+xml"],
  ["rm", "audio/x-pn-realaudio"],
  ["rmi", "audio/midi"],
  ["rmp", "audio/x-pn-realaudio-plugin"],
  ["rms", "application/vnd.jcp.javame.midlet-rms"],
  ["rmvb", "application/vnd.rn-realmedia-vbr"],
  ["rnc", "application/relax-ng-compact-syntax"],
  ["rng", "application/xml"],
  ["roa", "application/rpki-roa"],
  ["roff", "text/troff"],
  ["rp9", "application/vnd.cloanto.rp9"],
  ["rpm", "audio/x-pn-realaudio-plugin"],
  ["rpss", "application/vnd.nokia.radio-presets"],
  ["rpst", "application/vnd.nokia.radio-preset"],
  ["rq", "application/sparql-query"],
  ["rs", "application/rls-services+xml"],
  ["rsa", "application/x-pkcs7"],
  ["rsat", "application/atsc-rsat+xml"],
  ["rsd", "application/rsd+xml"],
  ["rsheet", "application/urc-ressheet+xml"],
  ["rss", "application/rss+xml"],
  ["rtf", "text/rtf"],
  ["rtx", "text/richtext"],
  ["run", "application/x-makeself"],
  ["rusd", "application/route-usd+xml"],
  ["rv", "video/vnd.rn-realvideo"],
  ["s", "text/x-asm"],
  ["s3m", "audio/s3m"],
  ["saf", "application/vnd.yamaha.smaf-audio"],
  ["sass", "text/x-sass"],
  ["sbml", "application/sbml+xml"],
  ["sc", "application/vnd.ibm.secure-container"],
  ["scd", "application/x-msschedule"],
  ["scm", "application/vnd.lotus-screencam"],
  ["scq", "application/scvp-cv-request"],
  ["scs", "application/scvp-cv-response"],
  ["scss", "text/x-scss"],
  ["scurl", "text/vnd.curl.scurl"],
  ["sda", "application/vnd.stardivision.draw"],
  ["sdc", "application/vnd.stardivision.calc"],
  ["sdd", "application/vnd.stardivision.impress"],
  ["sdkd", "application/vnd.solent.sdkm+xml"],
  ["sdkm", "application/vnd.solent.sdkm+xml"],
  ["sdp", "application/sdp"],
  ["sdw", "application/vnd.stardivision.writer"],
  ["sea", "application/octet-stream"],
  ["see", "application/vnd.seemail"],
  ["seed", "application/vnd.fdsn.seed"],
  ["sema", "application/vnd.sema"],
  ["semd", "application/vnd.semd"],
  ["semf", "application/vnd.semf"],
  ["senmlx", "application/senml+xml"],
  ["sensmlx", "application/sensml+xml"],
  ["ser", "application/java-serialized-object"],
  ["setpay", "application/set-payment-initiation"],
  ["setreg", "application/set-registration-initiation"],
  ["sfd-hdstx", "application/vnd.hydrostatix.sof-data"],
  ["sfs", "application/vnd.spotfire.sfs"],
  ["sfv", "text/x-sfv"],
  ["sgi", "image/sgi"],
  ["sgl", "application/vnd.stardivision.writer-global"],
  ["sgm", "text/sgml"],
  ["sgml", "text/sgml"],
  ["sh", "application/x-sh"],
  ["shar", "application/x-shar"],
  ["shex", "text/shex"],
  ["shf", "application/shf+xml"],
  ["shtml", "text/html"],
  ["sid", "image/x-mrsid-image"],
  ["sieve", "application/sieve"],
  ["sig", "application/pgp-signature"],
  ["sil", "audio/silk"],
  ["silo", "model/mesh"],
  ["sis", "application/vnd.symbian.install"],
  ["sisx", "application/vnd.symbian.install"],
  ["sit", "application/x-stuffit"],
  ["sitx", "application/x-stuffitx"],
  ["siv", "application/sieve"],
  ["skd", "application/vnd.koan"],
  ["skm", "application/vnd.koan"],
  ["skp", "application/vnd.koan"],
  ["skt", "application/vnd.koan"],
  ["sldm", "application/vnd.ms-powerpoint.slide.macroenabled.12"],
  ["sldx", "application/vnd.openxmlformats-officedocument.presentationml.slide"],
  ["slim", "text/slim"],
  ["slm", "text/slim"],
  ["sls", "application/route-s-tsid+xml"],
  ["slt", "application/vnd.epson.salt"],
  ["sm", "application/vnd.stepmania.stepchart"],
  ["smf", "application/vnd.stardivision.math"],
  ["smi", "application/smil"],
  ["smil", "application/smil"],
  ["smv", "video/x-smv"],
  ["smzip", "application/vnd.stepmania.package"],
  ["snd", "audio/basic"],
  ["snf", "application/x-font-snf"],
  ["so", "application/octet-stream"],
  ["spc", "application/x-pkcs7-certificates"],
  ["spdx", "text/spdx"],
  ["spf", "application/vnd.yamaha.smaf-phrase"],
  ["spl", "application/x-futuresplash"],
  ["spot", "text/vnd.in3d.spot"],
  ["spp", "application/scvp-vp-response"],
  ["spq", "application/scvp-vp-request"],
  ["spx", "audio/ogg"],
  ["sql", "application/x-sql"],
  ["src", "application/x-wais-source"],
  ["srt", "application/x-subrip"],
  ["sru", "application/sru+xml"],
  ["srx", "application/sparql-results+xml"],
  ["ssdl", "application/ssdl+xml"],
  ["sse", "application/vnd.kodak-descriptor"],
  ["ssf", "application/vnd.epson.ssf"],
  ["ssml", "application/ssml+xml"],
  ["sst", "application/octet-stream"],
  ["st", "application/vnd.sailingtracker.track"],
  ["stc", "application/vnd.sun.xml.calc.template"],
  ["std", "application/vnd.sun.xml.draw.template"],
  ["stf", "application/vnd.wt.stf"],
  ["sti", "application/vnd.sun.xml.impress.template"],
  ["stk", "application/hyperstudio"],
  ["stl", "model/stl"],
  ["stpx", "model/step+xml"],
  ["stpxz", "model/step-xml+zip"],
  ["stpz", "model/step+zip"],
  ["str", "application/vnd.pg.format"],
  ["stw", "application/vnd.sun.xml.writer.template"],
  ["styl", "text/stylus"],
  ["stylus", "text/stylus"],
  ["sub", "text/vnd.dvb.subtitle"],
  ["sus", "application/vnd.sus-calendar"],
  ["susp", "application/vnd.sus-calendar"],
  ["sv4cpio", "application/x-sv4cpio"],
  ["sv4crc", "application/x-sv4crc"],
  ["svc", "application/vnd.dvb.service"],
  ["svd", "application/vnd.svd"],
  ["svg", "image/svg+xml"],
  ["svgz", "image/svg+xml"],
  ["swa", "application/x-director"],
  ["swf", "application/x-shockwave-flash"],
  ["swi", "application/vnd.aristanetworks.swi"],
  ["swidtag", "application/swid+xml"],
  ["sxc", "application/vnd.sun.xml.calc"],
  ["sxd", "application/vnd.sun.xml.draw"],
  ["sxg", "application/vnd.sun.xml.writer.global"],
  ["sxi", "application/vnd.sun.xml.impress"],
  ["sxm", "application/vnd.sun.xml.math"],
  ["sxw", "application/vnd.sun.xml.writer"],
  ["t", "text/troff"],
  ["t3", "application/x-t3vm-image"],
  ["t38", "image/t38"],
  ["taglet", "application/vnd.mynfc"],
  ["tao", "application/vnd.tao.intent-module-archive"],
  ["tap", "image/vnd.tencent.tap"],
  ["tar", "application/x-tar"],
  ["tcap", "application/vnd.3gpp2.tcap"],
  ["tcl", "application/x-tcl"],
  ["td", "application/urc-targetdesc+xml"],
  ["teacher", "application/vnd.smart.teacher"],
  ["tei", "application/tei+xml"],
  ["teicorpus", "application/tei+xml"],
  ["tex", "application/x-tex"],
  ["texi", "application/x-texinfo"],
  ["texinfo", "application/x-texinfo"],
  ["text", "text/plain"],
  ["tfi", "application/thraud+xml"],
  ["tfm", "application/x-tex-tfm"],
  ["tfx", "image/tiff-fx"],
  ["tga", "image/x-tga"],
  ["tgz", "application/x-tar"],
  ["thmx", "application/vnd.ms-officetheme"],
  ["tif", "image/tiff"],
  ["tiff", "image/tiff"],
  ["tk", "application/x-tcl"],
  ["tmo", "application/vnd.tmobile-livetv"],
  ["toml", "application/toml"],
  ["torrent", "application/x-bittorrent"],
  ["tpl", "application/vnd.groove-tool-template"],
  ["tpt", "application/vnd.trid.tpt"],
  ["tr", "text/troff"],
  ["tra", "application/vnd.trueapp"],
  ["trig", "application/trig"],
  ["trm", "application/x-msterminal"],
  ["ts", "video/mp2t"],
  ["tsd", "application/timestamped-data"],
  ["tsv", "text/tab-separated-values"],
  ["ttc", "font/collection"],
  ["ttf", "font/ttf"],
  ["ttl", "text/turtle"],
  ["ttml", "application/ttml+xml"],
  ["twd", "application/vnd.simtech-mindmapper"],
  ["twds", "application/vnd.simtech-mindmapper"],
  ["txd", "application/vnd.genomatix.tuxedo"],
  ["txf", "application/vnd.mobius.txf"],
  ["txt", "text/plain"],
  ["u8dsn", "message/global-delivery-status"],
  ["u8hdr", "message/global-headers"],
  ["u8mdn", "message/global-disposition-notification"],
  ["u8msg", "message/global"],
  ["u32", "application/x-authorware-bin"],
  ["ubj", "application/ubjson"],
  ["udeb", "application/x-debian-package"],
  ["ufd", "application/vnd.ufdl"],
  ["ufdl", "application/vnd.ufdl"],
  ["ulx", "application/x-glulx"],
  ["umj", "application/vnd.umajin"],
  ["unityweb", "application/vnd.unity"],
  ["uoml", "application/vnd.uoml+xml"],
  ["uri", "text/uri-list"],
  ["uris", "text/uri-list"],
  ["urls", "text/uri-list"],
  ["usdz", "model/vnd.usdz+zip"],
  ["ustar", "application/x-ustar"],
  ["utz", "application/vnd.uiq.theme"],
  ["uu", "text/x-uuencode"],
  ["uva", "audio/vnd.dece.audio"],
  ["uvd", "application/vnd.dece.data"],
  ["uvf", "application/vnd.dece.data"],
  ["uvg", "image/vnd.dece.graphic"],
  ["uvh", "video/vnd.dece.hd"],
  ["uvi", "image/vnd.dece.graphic"],
  ["uvm", "video/vnd.dece.mobile"],
  ["uvp", "video/vnd.dece.pd"],
  ["uvs", "video/vnd.dece.sd"],
  ["uvt", "application/vnd.dece.ttml+xml"],
  ["uvu", "video/vnd.uvvu.mp4"],
  ["uvv", "video/vnd.dece.video"],
  ["uvva", "audio/vnd.dece.audio"],
  ["uvvd", "application/vnd.dece.data"],
  ["uvvf", "application/vnd.dece.data"],
  ["uvvg", "image/vnd.dece.graphic"],
  ["uvvh", "video/vnd.dece.hd"],
  ["uvvi", "image/vnd.dece.graphic"],
  ["uvvm", "video/vnd.dece.mobile"],
  ["uvvp", "video/vnd.dece.pd"],
  ["uvvs", "video/vnd.dece.sd"],
  ["uvvt", "application/vnd.dece.ttml+xml"],
  ["uvvu", "video/vnd.uvvu.mp4"],
  ["uvvv", "video/vnd.dece.video"],
  ["uvvx", "application/vnd.dece.unspecified"],
  ["uvvz", "application/vnd.dece.zip"],
  ["uvx", "application/vnd.dece.unspecified"],
  ["uvz", "application/vnd.dece.zip"],
  ["vbox", "application/x-virtualbox-vbox"],
  ["vbox-extpack", "application/x-virtualbox-vbox-extpack"],
  ["vcard", "text/vcard"],
  ["vcd", "application/x-cdlink"],
  ["vcf", "text/x-vcard"],
  ["vcg", "application/vnd.groove-vcard"],
  ["vcs", "text/x-vcalendar"],
  ["vcx", "application/vnd.vcx"],
  ["vdi", "application/x-virtualbox-vdi"],
  ["vds", "model/vnd.sap.vds"],
  ["vhd", "application/x-virtualbox-vhd"],
  ["vis", "application/vnd.visionary"],
  ["viv", "video/vnd.vivo"],
  ["vlc", "application/videolan"],
  ["vmdk", "application/x-virtualbox-vmdk"],
  ["vob", "video/x-ms-vob"],
  ["vor", "application/vnd.stardivision.writer"],
  ["vox", "application/x-authorware-bin"],
  ["vrml", "model/vrml"],
  ["vsd", "application/vnd.visio"],
  ["vsf", "application/vnd.vsf"],
  ["vss", "application/vnd.visio"],
  ["vst", "application/vnd.visio"],
  ["vsw", "application/vnd.visio"],
  ["vtf", "image/vnd.valve.source.texture"],
  ["vtt", "text/vtt"],
  ["vtu", "model/vnd.vtu"],
  ["vxml", "application/voicexml+xml"],
  ["w3d", "application/x-director"],
  ["wad", "application/x-doom"],
  ["wadl", "application/vnd.sun.wadl+xml"],
  ["war", "application/java-archive"],
  ["wasm", "application/wasm"],
  ["wav", "audio/x-wav"],
  ["wax", "audio/x-ms-wax"],
  ["wbmp", "image/vnd.wap.wbmp"],
  ["wbs", "application/vnd.criticaltools.wbs+xml"],
  ["wbxml", "application/wbxml"],
  ["wcm", "application/vnd.ms-works"],
  ["wdb", "application/vnd.ms-works"],
  ["wdp", "image/vnd.ms-photo"],
  ["weba", "audio/webm"],
  ["webapp", "application/x-web-app-manifest+json"],
  ["webm", "video/webm"],
  ["webmanifest", "application/manifest+json"],
  ["webp", "image/webp"],
  ["wg", "application/vnd.pmi.widget"],
  ["wgt", "application/widget"],
  ["wks", "application/vnd.ms-works"],
  ["wm", "video/x-ms-wm"],
  ["wma", "audio/x-ms-wma"],
  ["wmd", "application/x-ms-wmd"],
  ["wmf", "image/wmf"],
  ["wml", "text/vnd.wap.wml"],
  ["wmlc", "application/wmlc"],
  ["wmls", "text/vnd.wap.wmlscript"],
  ["wmlsc", "application/vnd.wap.wmlscriptc"],
  ["wmv", "video/x-ms-wmv"],
  ["wmx", "video/x-ms-wmx"],
  ["wmz", "application/x-msmetafile"],
  ["woff", "font/woff"],
  ["woff2", "font/woff2"],
  ["word", "application/msword"],
  ["wpd", "application/vnd.wordperfect"],
  ["wpl", "application/vnd.ms-wpl"],
  ["wps", "application/vnd.ms-works"],
  ["wqd", "application/vnd.wqd"],
  ["wri", "application/x-mswrite"],
  ["wrl", "model/vrml"],
  ["wsc", "message/vnd.wfa.wsc"],
  ["wsdl", "application/wsdl+xml"],
  ["wspolicy", "application/wspolicy+xml"],
  ["wtb", "application/vnd.webturbo"],
  ["wvx", "video/x-ms-wvx"],
  ["x3d", "model/x3d+xml"],
  ["x3db", "model/x3d+fastinfoset"],
  ["x3dbz", "model/x3d+binary"],
  ["x3dv", "model/x3d-vrml"],
  ["x3dvz", "model/x3d+vrml"],
  ["x3dz", "model/x3d+xml"],
  ["x32", "application/x-authorware-bin"],
  ["x_b", "model/vnd.parasolid.transmit.binary"],
  ["x_t", "model/vnd.parasolid.transmit.text"],
  ["xaml", "application/xaml+xml"],
  ["xap", "application/x-silverlight-app"],
  ["xar", "application/vnd.xara"],
  ["xav", "application/xcap-att+xml"],
  ["xbap", "application/x-ms-xbap"],
  ["xbd", "application/vnd.fujixerox.docuworks.binder"],
  ["xbm", "image/x-xbitmap"],
  ["xca", "application/xcap-caps+xml"],
  ["xcs", "application/calendar+xml"],
  ["xdf", "application/xcap-diff+xml"],
  ["xdm", "application/vnd.syncml.dm+xml"],
  ["xdp", "application/vnd.adobe.xdp+xml"],
  ["xdssc", "application/dssc+xml"],
  ["xdw", "application/vnd.fujixerox.docuworks"],
  ["xel", "application/xcap-el+xml"],
  ["xenc", "application/xenc+xml"],
  ["xer", "application/patch-ops-error+xml"],
  ["xfdf", "application/vnd.adobe.xfdf"],
  ["xfdl", "application/vnd.xfdl"],
  ["xht", "application/xhtml+xml"],
  ["xhtml", "application/xhtml+xml"],
  ["xhvml", "application/xv+xml"],
  ["xif", "image/vnd.xiff"],
  ["xl", "application/excel"],
  ["xla", "application/vnd.ms-excel"],
  ["xlam", "application/vnd.ms-excel.addin.macroEnabled.12"],
  ["xlc", "application/vnd.ms-excel"],
  ["xlf", "application/xliff+xml"],
  ["xlm", "application/vnd.ms-excel"],
  ["xls", "application/vnd.ms-excel"],
  ["xlsb", "application/vnd.ms-excel.sheet.binary.macroEnabled.12"],
  ["xlsm", "application/vnd.ms-excel.sheet.macroEnabled.12"],
  ["xlsx", "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"],
  ["xlt", "application/vnd.ms-excel"],
  ["xltm", "application/vnd.ms-excel.template.macroEnabled.12"],
  ["xltx", "application/vnd.openxmlformats-officedocument.spreadsheetml.template"],
  ["xlw", "application/vnd.ms-excel"],
  ["xm", "audio/xm"],
  ["xml", "application/xml"],
  ["xns", "application/xcap-ns+xml"],
  ["xo", "application/vnd.olpc-sugar"],
  ["xop", "application/xop+xml"],
  ["xpi", "application/x-xpinstall"],
  ["xpl", "application/xproc+xml"],
  ["xpm", "image/x-xpixmap"],
  ["xpr", "application/vnd.is-xpr"],
  ["xps", "application/vnd.ms-xpsdocument"],
  ["xpw", "application/vnd.intercon.formnet"],
  ["xpx", "application/vnd.intercon.formnet"],
  ["xsd", "application/xml"],
  ["xsl", "application/xml"],
  ["xslt", "application/xslt+xml"],
  ["xsm", "application/vnd.syncml+xml"],
  ["xspf", "application/xspf+xml"],
  ["xul", "application/vnd.mozilla.xul+xml"],
  ["xvm", "application/xv+xml"],
  ["xvml", "application/xv+xml"],
  ["xwd", "image/x-xwindowdump"],
  ["xyz", "chemical/x-xyz"],
  ["xz", "application/x-xz"],
  ["yaml", "text/yaml"],
  ["yang", "application/yang"],
  ["yin", "application/yin+xml"],
  ["yml", "text/yaml"],
  ["ymp", "text/x-suse-ymp"],
  ["z", "application/x-compress"],
  ["z1", "application/x-zmachine"],
  ["z2", "application/x-zmachine"],
  ["z3", "application/x-zmachine"],
  ["z4", "application/x-zmachine"],
  ["z5", "application/x-zmachine"],
  ["z6", "application/x-zmachine"],
  ["z7", "application/x-zmachine"],
  ["z8", "application/x-zmachine"],
  ["zaz", "application/vnd.zzazz.deck+xml"],
  ["zip", "application/zip"],
  ["zir", "application/vnd.zul"],
  ["zirz", "application/vnd.zul"],
  ["zmm", "application/vnd.handheld-entertainment+xml"],
  ["zsh", "text/x-scriptzsh"]
]);
function Bs(e, t, n) {
  const r = LZ(e), { webkitRelativePath: i } = e, o = typeof t == "string" ? t : typeof i == "string" && i.length > 0 ? i : `./${e.name}`;
  return typeof r.path != "string" && OE(r, "path", o), OE(r, "relativePath", o), r;
}
function LZ(e) {
  const { name: t } = e;
  if (t && t.lastIndexOf(".") !== -1 && !e.type) {
    const r = t.split(".").pop().toLowerCase(), i = zZ.get(r);
    i && Object.defineProperty(e, "type", {
      value: i,
      writable: !1,
      configurable: !1,
      enumerable: !0
    });
  }
  return e;
}
function OE(e, t, n) {
  Object.defineProperty(e, t, {
    value: n,
    writable: !1,
    configurable: !1,
    enumerable: !0
  });
}
const VZ = [
  // Thumbnail cache files for macOS and Windows
  ".DS_Store",
  // macOs
  "Thumbs.db"
  // Windows
];
function BZ(e) {
  return Ka(this, void 0, void 0, function* () {
    return Ad(e) && KZ(e.dataTransfer) ? WZ(e.dataTransfer, e.type) : UZ(e) ? qZ(e) : Array.isArray(e) && e.every((t) => "getFile" in t && typeof t.getFile == "function") ? HZ(e) : [];
  });
}
function KZ(e) {
  return Ad(e);
}
function UZ(e) {
  return Ad(e) && Ad(e.target);
}
function Ad(e) {
  return typeof e == "object" && e !== null;
}
function qZ(e) {
  return gg(e.target.files).map((t) => Bs(t));
}
function HZ(e) {
  return Ka(this, void 0, void 0, function* () {
    return (yield Promise.all(e.map((n) => n.getFile()))).map((n) => Bs(n));
  });
}
function WZ(e, t) {
  return Ka(this, void 0, void 0, function* () {
    if (e.items) {
      const n = gg(e.items).filter((i) => i.kind === "file");
      if (t !== "drop")
        return n;
      const r = yield Promise.all(n.map(ZZ));
      return PE(jA(r));
    }
    return PE(gg(e.files).map((n) => Bs(n)));
  });
}
function PE(e) {
  return e.filter((t) => VZ.indexOf(t.name) === -1);
}
function gg(e) {
  if (e === null)
    return [];
  const t = [];
  for (let n = 0; n < e.length; n++) {
    const r = e[n];
    t.push(r);
  }
  return t;
}
function ZZ(e) {
  if (typeof e.webkitGetAsEntry != "function")
    return AE(e);
  const t = e.webkitGetAsEntry();
  return t && t.isDirectory ? FA(t) : AE(e, t);
}
function jA(e) {
  return e.reduce((t, n) => [
    ...t,
    ...Array.isArray(n) ? jA(n) : [n]
  ], []);
}
function AE(e, t) {
  return Ka(this, void 0, void 0, function* () {
    var n;
    if (globalThis.isSecureContext && typeof e.getAsFileSystemHandle == "function") {
      const o = yield e.getAsFileSystemHandle();
      if (o === null)
        throw new Error(`${e} is not a File`);
      if (o !== void 0) {
        const a = yield o.getFile();
        return a.handle = o, Bs(a);
      }
    }
    const r = e.getAsFile();
    if (!r)
      throw new Error(`${e} is not a File`);
    return Bs(r, (n = t?.fullPath) !== null && n !== void 0 ? n : void 0);
  });
}
function GZ(e) {
  return Ka(this, void 0, void 0, function* () {
    return e.isDirectory ? FA(e) : YZ(e);
  });
}
function FA(e) {
  const t = e.createReader();
  return new Promise((n, r) => {
    const i = [];
    function o() {
      t.readEntries((a) => Ka(this, void 0, void 0, function* () {
        if (a.length) {
          const s = Promise.all(a.map(GZ));
          i.push(s), o();
        } else
          try {
            const s = yield Promise.all(i);
            n(s);
          } catch (s) {
            r(s);
          }
      }), (a) => {
        r(a);
      });
    }
    o();
  });
}
function YZ(e) {
  return Ka(this, void 0, void 0, function* () {
    return new Promise((t, n) => {
      e.file((r) => {
        const i = Bs(r, e.fullPath);
        t(i);
      }, (r) => {
        n(r);
      });
    });
  });
}
var Gc = {}, DE;
function QZ() {
  return DE || (DE = 1, Gc.__esModule = !0, Gc.default = function(e, t) {
    if (e && t) {
      var n = Array.isArray(t) ? t : t.split(",");
      if (n.length === 0)
        return !0;
      var r = e.name || "", i = (e.type || "").toLowerCase(), o = i.replace(/\/.*$/, "");
      return n.some(function(a) {
        var s = a.trim().toLowerCase();
        return s.charAt(0) === "." ? r.toLowerCase().endsWith(s) : s.endsWith("/*") ? o === s.replace(/\/.*$/, "") : i === s;
      });
    }
    return !0;
  }), Gc;
}
var JZ = QZ();
const lm = /* @__PURE__ */ fy(JZ);
function CE(e) {
  return tG(e) || eG(e) || LA(e) || XZ();
}
function XZ() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function eG(e) {
  if (typeof Symbol < "u" && e[Symbol.iterator] != null || e["@@iterator"] != null) return Array.from(e);
}
function tG(e) {
  if (Array.isArray(e)) return yg(e);
}
function IE(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function(i) {
      return Object.getOwnPropertyDescriptor(e, i).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function ME(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? IE(Object(n), !0).forEach(function(r) {
      zA(e, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : IE(Object(n)).forEach(function(r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return e;
}
function zA(e, t, n) {
  return t in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = n, e;
}
function Nu(e, t) {
  return iG(e) || rG(e, t) || LA(e, t) || nG();
}
function nG() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function LA(e, t) {
  if (e) {
    if (typeof e == "string") return yg(e, t);
    var n = Object.prototype.toString.call(e).slice(8, -1);
    if (n === "Object" && e.constructor && (n = e.constructor.name), n === "Map" || n === "Set") return Array.from(e);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return yg(e, t);
  }
}
function yg(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var n = 0, r = new Array(t); n < t; n++)
    r[n] = e[n];
  return r;
}
function rG(e, t) {
  var n = e == null ? null : typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (n != null) {
    var r = [], i = !0, o = !1, a, s;
    try {
      for (n = n.call(e); !(i = (a = n.next()).done) && (r.push(a.value), !(t && r.length === t)); i = !0)
        ;
    } catch (l) {
      o = !0, s = l;
    } finally {
      try {
        !i && n.return != null && n.return();
      } finally {
        if (o) throw s;
      }
    }
    return r;
  }
}
function iG(e) {
  if (Array.isArray(e)) return e;
}
var oG = typeof lm == "function" ? lm : lm.default, aG = "file-invalid-type", sG = "file-too-large", lG = "file-too-small", uG = "too-many-files", cG = function() {
  var t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "", n = t.split(","), r = n.length > 1 ? "one of ".concat(n.join(", ")) : n[0];
  return {
    code: aG,
    message: "File type must be ".concat(r)
  };
}, RE = function(t) {
  return {
    code: sG,
    message: "File is larger than ".concat(t, " ").concat(t === 1 ? "byte" : "bytes")
  };
}, NE = function(t) {
  return {
    code: lG,
    message: "File is smaller than ".concat(t, " ").concat(t === 1 ? "byte" : "bytes")
  };
}, fG = {
  code: uG,
  message: "Too many files"
};
function dG(e) {
  return e.type === "" && typeof e.getAsFile == "function";
}
function VA(e, t) {
  var n = e.type === "application/x-moz-file" || oG(e, t) || dG(e);
  return [n, n ? null : cG(t)];
}
function BA(e, t, n) {
  if (ra(e.size))
    if (ra(t) && ra(n)) {
      if (e.size > n) return [!1, RE(n)];
      if (e.size < t) return [!1, NE(t)];
    } else {
      if (ra(t) && e.size < t) return [!1, NE(t)];
      if (ra(n) && e.size > n) return [!1, RE(n)];
    }
  return [!0, null];
}
function ra(e) {
  return e != null;
}
function pG(e) {
  var t = e.files, n = e.accept, r = e.minSize, i = e.maxSize, o = e.multiple, a = e.maxFiles, s = e.validator;
  return !o && t.length > 1 || o && a >= 1 && t.length > a ? !1 : t.every(function(l) {
    var u = VA(l, n), c = Nu(u, 1), f = c[0], d = BA(l, r, i), p = Nu(d, 1), h = p[0], v = s ? s(l) : null;
    return f && h && !v;
  });
}
function Dd(e) {
  return typeof e.isPropagationStopped == "function" ? e.isPropagationStopped() : typeof e.cancelBubble < "u" ? e.cancelBubble : !1;
}
function jl(e) {
  return e.dataTransfer ? Array.prototype.some.call(e.dataTransfer.types, function(t) {
    return t === "Files" || t === "application/x-moz-file";
  }) : !!e.target && !!e.target.files;
}
function jE(e) {
  e.preventDefault();
}
function hG(e) {
  return e.indexOf("MSIE") !== -1 || e.indexOf("Trident/") !== -1;
}
function mG(e) {
  return e.indexOf("Edge/") !== -1;
}
function vG() {
  var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : window.navigator.userAgent;
  return hG(e) || mG(e);
}
function gi() {
  for (var e = arguments.length, t = new Array(e), n = 0; n < e; n++)
    t[n] = arguments[n];
  return function(r) {
    for (var i = arguments.length, o = new Array(i > 1 ? i - 1 : 0), a = 1; a < i; a++)
      o[a - 1] = arguments[a];
    return t.some(function(s) {
      return !Dd(r) && s && s.apply(void 0, [r].concat(o)), Dd(r);
    });
  };
}
function gG() {
  return "showOpenFilePicker" in window;
}
function yG(e) {
  if (ra(e)) {
    var t = Object.entries(e).filter(function(n) {
      var r = Nu(n, 2), i = r[0], o = r[1], a = !0;
      return KA(i) || (console.warn('Skipped "'.concat(i, '" because it is not a valid MIME type. Check https://developer.mozilla.org/en-US/docs/Web/HTTP/Basics_of_HTTP/MIME_types/Common_types for a list of valid MIME types.')), a = !1), (!Array.isArray(o) || !o.every(UA)) && (console.warn('Skipped "'.concat(i, '" because an invalid file extension was provided.')), a = !1), a;
    }).reduce(function(n, r) {
      var i = Nu(r, 2), o = i[0], a = i[1];
      return ME(ME({}, n), {}, zA({}, o, a));
    }, {});
    return [{
      // description is required due to https://crbug.com/1264708
      description: "Files",
      accept: t
    }];
  }
  return e;
}
function bG(e) {
  if (ra(e))
    return Object.entries(e).reduce(function(t, n) {
      var r = Nu(n, 2), i = r[0], o = r[1];
      return [].concat(CE(t), [i], CE(o));
    }, []).filter(function(t) {
      return KA(t) || UA(t);
    }).join(",");
}
function _G(e) {
  return e instanceof DOMException && (e.name === "AbortError" || e.code === e.ABORT_ERR);
}
function wG(e) {
  return e instanceof DOMException && (e.name === "SecurityError" || e.code === e.SECURITY_ERR);
}
function KA(e) {
  return e === "audio/*" || e === "video/*" || e === "image/*" || e === "text/*" || e === "application/*" || /\w+\/[-+.\w]+/g.test(e);
}
function UA(e) {
  return /^.*\.[\w]+$/.test(e);
}
var xG = ["children"], EG = ["open"], SG = ["refKey", "role", "onKeyDown", "onFocus", "onBlur", "onClick", "onDragEnter", "onDragOver", "onDragLeave", "onDrop"], $G = ["refKey", "onChange", "onClick"];
function FE(e) {
  return OG(e) || TG(e) || qA(e) || kG();
}
function kG() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function TG(e) {
  if (typeof Symbol < "u" && e[Symbol.iterator] != null || e["@@iterator"] != null) return Array.from(e);
}
function OG(e) {
  if (Array.isArray(e)) return bg(e);
}
function um(e, t) {
  return DG(e) || AG(e, t) || qA(e, t) || PG();
}
function PG() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function qA(e, t) {
  if (e) {
    if (typeof e == "string") return bg(e, t);
    var n = Object.prototype.toString.call(e).slice(8, -1);
    if (n === "Object" && e.constructor && (n = e.constructor.name), n === "Map" || n === "Set") return Array.from(e);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return bg(e, t);
  }
}
function bg(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var n = 0, r = new Array(t); n < t; n++)
    r[n] = e[n];
  return r;
}
function AG(e, t) {
  var n = e == null ? null : typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (n != null) {
    var r = [], i = !0, o = !1, a, s;
    try {
      for (n = n.call(e); !(i = (a = n.next()).done) && (r.push(a.value), !(t && r.length === t)); i = !0)
        ;
    } catch (l) {
      o = !0, s = l;
    } finally {
      try {
        !i && n.return != null && n.return();
      } finally {
        if (o) throw s;
      }
    }
    return r;
  }
}
function DG(e) {
  if (Array.isArray(e)) return e;
}
function zE(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function(i) {
      return Object.getOwnPropertyDescriptor(e, i).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function It(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? zE(Object(n), !0).forEach(function(r) {
      _g(e, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : zE(Object(n)).forEach(function(r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return e;
}
function _g(e, t, n) {
  return t in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = n, e;
}
function Cd(e, t) {
  if (e == null) return {};
  var n = CG(e, t), r, i;
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    for (i = 0; i < o.length; i++)
      r = o[i], !(t.indexOf(r) >= 0) && Object.prototype.propertyIsEnumerable.call(e, r) && (n[r] = e[r]);
  }
  return n;
}
function CG(e, t) {
  if (e == null) return {};
  var n = {}, r = Object.keys(e), i, o;
  for (o = 0; o < r.length; o++)
    i = r[o], !(t.indexOf(i) >= 0) && (n[i] = e[i]);
  return n;
}
var Hb = /* @__PURE__ */ fn(function(e, t) {
  var n = e.children, r = Cd(e, xG), i = WA(r), o = i.open, a = Cd(i, EG);
  return b6(t, function() {
    return {
      open: o
    };
  }, [o]), /* @__PURE__ */ H.createElement(sy, null, n(It(It({}, a), {}, {
    open: o
  })));
});
Hb.displayName = "Dropzone";
var HA = {
  disabled: !1,
  getFilesFromEvent: BZ,
  maxSize: 1 / 0,
  minSize: 0,
  multiple: !0,
  maxFiles: 0,
  preventDropOnDocument: !0,
  noClick: !1,
  noKeyboard: !1,
  noDrag: !1,
  noDragEventsBubbling: !1,
  validator: null,
  useFsAccessApi: !1,
  autoFocus: !1
};
Hb.defaultProps = HA;
Hb.propTypes = {
  /**
   * Render function that exposes the dropzone state and prop getter fns
   *
   * @param {object} params
   * @param {Function} params.getRootProps Returns the props you should apply to the root drop container you render
   * @param {Function} params.getInputProps Returns the props you should apply to hidden file input you render
   * @param {Function} params.open Open the native file selection dialog
   * @param {boolean} params.isFocused Dropzone area is in focus
   * @param {boolean} params.isFileDialogActive File dialog is opened
   * @param {boolean} params.isDragActive Active drag is in progress
   * @param {boolean} params.isDragAccept Dragged files are accepted
   * @param {boolean} params.isDragReject Some dragged files are rejected
   * @param {boolean} params.isDragGlobal Files are being dragged anywhere on the document
   * @param {File[]} params.acceptedFiles Accepted files
   * @param {FileRejection[]} params.fileRejections Rejected files and why they were rejected
   */
  children: Ne.func,
  /**
   * Set accepted file types.
   * Checkout https://developer.mozilla.org/en-US/docs/Web/API/window/showOpenFilePicker types option for more information.
   * Keep in mind that mime type determination is not reliable across platforms. CSV files,
   * for example, are reported as text/plain under macOS but as application/vnd.ms-excel under
   * Windows. In some cases there might not be a mime type set at all (https://github.com/react-dropzone/react-dropzone/issues/276).
   */
  accept: Ne.objectOf(Ne.arrayOf(Ne.string)),
  /**
   * Allow drag 'n' drop (or selection from the file dialog) of multiple files
   */
  multiple: Ne.bool,
  /**
   * If false, allow dropped items to take over the current browser window
   */
  preventDropOnDocument: Ne.bool,
  /**
   * If true, disables click to open the native file selection dialog
   */
  noClick: Ne.bool,
  /**
   * If true, disables SPACE/ENTER to open the native file selection dialog.
   * Note that it also stops tracking the focus state.
   */
  noKeyboard: Ne.bool,
  /**
   * If true, disables drag 'n' drop
   */
  noDrag: Ne.bool,
  /**
   * If true, stops drag event propagation to parents
   */
  noDragEventsBubbling: Ne.bool,
  /**
   * Minimum file size (in bytes)
   */
  minSize: Ne.number,
  /**
   * Maximum file size (in bytes)
   */
  maxSize: Ne.number,
  /**
   * Maximum accepted number of files
   * The default value is 0 which means there is no limitation to how many files are accepted.
   */
  maxFiles: Ne.number,
  /**
   * Enable/disable the dropzone
   */
  disabled: Ne.bool,
  /**
   * Use this to provide a custom file aggregator
   *
   * @param {(DragEvent|Event|Array<FileSystemFileHandle>)} event A drag event or input change event (if files were selected via the file dialog)
   */
  getFilesFromEvent: Ne.func,
  /**
   * Cb for when closing the file dialog with no selection
   */
  onFileDialogCancel: Ne.func,
  /**
   * Cb for when opening the file dialog
   */
  onFileDialogOpen: Ne.func,
  /**
   * Set to true to use the https://developer.mozilla.org/en-US/docs/Web/API/File_System_Access_API
   * to open the file picker instead of using an `<input type="file">` click event.
   */
  useFsAccessApi: Ne.bool,
  /**
   * Set to true to focus the root element on render
   */
  autoFocus: Ne.bool,
  /**
   * Cb for when the `dragenter` event occurs.
   *
   * @param {DragEvent} event
   */
  onDragEnter: Ne.func,
  /**
   * Cb for when the `dragleave` event occurs
   *
   * @param {DragEvent} event
   */
  onDragLeave: Ne.func,
  /**
   * Cb for when the `dragover` event occurs
   *
   * @param {DragEvent} event
   */
  onDragOver: Ne.func,
  /**
   * Cb for when the `drop` event occurs.
   * Note that this callback is invoked after the `getFilesFromEvent` callback is done.
   *
   * Files are accepted or rejected based on the `accept`, `multiple`, `minSize` and `maxSize` props.
   * `accept` must be a valid [MIME type](http://www.iana.org/assignments/media-types/media-types.xhtml) according to [input element specification](https://www.w3.org/wiki/HTML/Elements/input/file) or a valid file extension.
   * If `multiple` is set to false and additional files are dropped,
   * all files besides the first will be rejected.
   * Any file which does not have a size in the [`minSize`, `maxSize`] range, will be rejected as well.
   *
   * Note that the `onDrop` callback will always be invoked regardless if the dropped files were accepted or rejected.
   * If you'd like to react to a specific scenario, use the `onDropAccepted`/`onDropRejected` props.
   *
   * `onDrop` will provide you with an array of [File](https://developer.mozilla.org/en-US/docs/Web/API/File) objects which you can then process and send to a server.
   * For example, with [SuperAgent](https://github.com/visionmedia/superagent) as a http/ajax library:
   *
   * ```js
   * function onDrop(acceptedFiles) {
   *   const req = request.post('/upload')
   *   acceptedFiles.forEach(file => {
   *     req.attach(file.name, file)
   *   })
   *   req.end(callback)
   * }
   * ```
   *
   * @param {File[]} acceptedFiles
   * @param {FileRejection[]} fileRejections
   * @param {(DragEvent|Event)} event A drag event or input change event (if files were selected via the file dialog)
   */
  onDrop: Ne.func,
  /**
   * Cb for when the `drop` event occurs.
   * Note that if no files are accepted, this callback is not invoked.
   *
   * @param {File[]} files
   * @param {(DragEvent|Event)} event
   */
  onDropAccepted: Ne.func,
  /**
   * Cb for when the `drop` event occurs.
   * Note that if no files are rejected, this callback is not invoked.
   *
   * @param {FileRejection[]} fileRejections
   * @param {(DragEvent|Event)} event
   */
  onDropRejected: Ne.func,
  /**
   * Cb for when there's some error from any of the promises.
   *
   * @param {Error} error
   */
  onError: Ne.func,
  /**
   * Custom validation function. It must return null if there's no errors.
   * @param {File} file
   * @returns {FileError|FileError[]|null}
   */
  validator: Ne.func
};
var wg = {
  isFocused: !1,
  isFileDialogActive: !1,
  isDragActive: !1,
  isDragAccept: !1,
  isDragReject: !1,
  isDragGlobal: !1,
  acceptedFiles: [],
  fileRejections: []
};
function WA() {
  var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, t = It(It({}, HA), e), n = t.accept, r = t.disabled, i = t.getFilesFromEvent, o = t.maxSize, a = t.minSize, s = t.multiple, l = t.maxFiles, u = t.onDragEnter, c = t.onDragLeave, f = t.onDragOver, d = t.onDrop, p = t.onDropAccepted, h = t.onDropRejected, v = t.onFileDialogCancel, m = t.onFileDialogOpen, g = t.useFsAccessApi, _ = t.autoFocus, x = t.preventDropOnDocument, w = t.noClick, $ = t.noKeyboard, k = t.noDrag, D = t.noDragEventsBubbling, E = t.onError, b = t.validator, y = Fe(function() {
    return bG(n);
  }, [n]), S = Fe(function() {
    return yG(n);
  }, [n]), P = Fe(function() {
    return typeof m == "function" ? m : LE;
  }, [m]), M = Fe(function() {
    return typeof v == "function" ? v : LE;
  }, [v]), T = ve(null), V = ve(null), z = JS(IG, wg), U = um(z, 2), B = U[0], N = U[1], C = B.isFocused, G = B.isFileDialogActive, re = ve(typeof window < "u" && window.isSecureContext && g && gG()), ie = function() {
    !re.current && G && setTimeout(function() {
      if (V.current) {
        var Ce = V.current.files;
        Ce.length || (N({
          type: "closeDialog"
        }), M());
      }
    }, 300);
  };
  ze(function() {
    return window.addEventListener("focus", ie, !1), function() {
      window.removeEventListener("focus", ie, !1);
    };
  }, [V, G, M, re]);
  var X = ve([]), Se = ve([]), me = function(Ce) {
    T.current && T.current.contains(Ce.target) || (Ce.preventDefault(), X.current = []);
  };
  ze(function() {
    return x && (document.addEventListener("dragover", jE, !1), document.addEventListener("drop", me, !1)), function() {
      x && (document.removeEventListener("dragover", jE), document.removeEventListener("drop", me));
    };
  }, [T, x]), ze(function() {
    var ge = function(F) {
      Se.current = [].concat(FE(Se.current), [F.target]), jl(F) && N({
        isDragGlobal: !0,
        type: "setDragGlobal"
      });
    }, Ce = function(F) {
      Se.current = Se.current.filter(function(K) {
        return K !== F.target && K !== null;
      }), !(Se.current.length > 0) && N({
        isDragGlobal: !1,
        type: "setDragGlobal"
      });
    }, Ye = function() {
      Se.current = [], N({
        isDragGlobal: !1,
        type: "setDragGlobal"
      });
    }, Xe = function() {
      Se.current = [], N({
        isDragGlobal: !1,
        type: "setDragGlobal"
      });
    };
    return document.addEventListener("dragenter", ge, !1), document.addEventListener("dragleave", Ce, !1), document.addEventListener("dragend", Ye, !1), document.addEventListener("drop", Xe, !1), function() {
      document.removeEventListener("dragenter", ge), document.removeEventListener("dragleave", Ce), document.removeEventListener("dragend", Ye), document.removeEventListener("drop", Xe);
    };
  }, [T]), ze(function() {
    return !r && _ && T.current && T.current.focus(), function() {
    };
  }, [T, _, r]);
  var fe = Le(function(ge) {
    E ? E(ge) : console.error(ge);
  }, [E]), Q = Le(function(ge) {
    ge.preventDefault(), ge.persist(), ce(ge), X.current = [].concat(FE(X.current), [ge.target]), jl(ge) && Promise.resolve(i(ge)).then(function(Ce) {
      if (!(Dd(ge) && !D)) {
        var Ye = Ce.length, Xe = Ye > 0 && pG({
          files: Ce,
          accept: y,
          minSize: a,
          maxSize: o,
          multiple: s,
          maxFiles: l,
          validator: b
        }), lt = Ye > 0 && !Xe;
        N({
          isDragAccept: Xe,
          isDragReject: lt,
          isDragActive: !0,
          type: "setDraggedFiles"
        }), u && u(ge);
      }
    }).catch(function(Ce) {
      return fe(Ce);
    });
  }, [i, u, fe, D, y, a, o, s, l, b]), A = Le(function(ge) {
    ge.preventDefault(), ge.persist(), ce(ge);
    var Ce = jl(ge);
    if (Ce && ge.dataTransfer)
      try {
        ge.dataTransfer.dropEffect = "copy";
      } catch {
      }
    return Ce && f && f(ge), !1;
  }, [f, D]), O = Le(function(ge) {
    ge.preventDefault(), ge.persist(), ce(ge);
    var Ce = X.current.filter(function(Xe) {
      return T.current && T.current.contains(Xe);
    }), Ye = Ce.indexOf(ge.target);
    Ye !== -1 && Ce.splice(Ye, 1), X.current = Ce, !(Ce.length > 0) && (N({
      type: "setDraggedFiles",
      isDragActive: !1,
      isDragAccept: !1,
      isDragReject: !1
    }), jl(ge) && c && c(ge));
  }, [T, c, D]), R = Le(function(ge, Ce) {
    var Ye = [], Xe = [];
    ge.forEach(function(lt) {
      var F = VA(lt, y), K = um(F, 2), W = K[0], le = K[1], pe = BA(lt, a, o), xe = um(pe, 2), _e = xe[0], $e = xe[1], We = b ? b(lt) : null;
      if (W && _e && !We)
        Ye.push(lt);
      else {
        var ft = [le, $e];
        We && (ft = ft.concat(We)), Xe.push({
          file: lt,
          errors: ft.filter(function(Qt) {
            return Qt;
          })
        });
      }
    }), (!s && Ye.length > 1 || s && l >= 1 && Ye.length > l) && (Ye.forEach(function(lt) {
      Xe.push({
        file: lt,
        errors: [fG]
      });
    }), Ye.splice(0)), N({
      acceptedFiles: Ye,
      fileRejections: Xe,
      isDragReject: Xe.length > 0,
      type: "setFiles"
    }), d && d(Ye, Xe, Ce), Xe.length > 0 && h && h(Xe, Ce), Ye.length > 0 && p && p(Ye, Ce);
  }, [N, s, y, a, o, l, d, p, h, b]), j = Le(function(ge) {
    ge.preventDefault(), ge.persist(), ce(ge), X.current = [], jl(ge) && Promise.resolve(i(ge)).then(function(Ce) {
      Dd(ge) && !D || R(Ce, ge);
    }).catch(function(Ce) {
      return fe(Ce);
    }), N({
      type: "reset"
    });
  }, [i, R, fe, D]), q = Le(function() {
    if (re.current) {
      N({
        type: "openDialog"
      }), P();
      var ge = {
        multiple: s,
        types: S
      };
      window.showOpenFilePicker(ge).then(function(Ce) {
        return i(Ce);
      }).then(function(Ce) {
        R(Ce, null), N({
          type: "closeDialog"
        });
      }).catch(function(Ce) {
        _G(Ce) ? (M(Ce), N({
          type: "closeDialog"
        })) : wG(Ce) ? (re.current = !1, V.current ? (V.current.value = null, V.current.click()) : fe(new Error("Cannot open the file picker because the https://developer.mozilla.org/en-US/docs/Web/API/File_System_Access_API is not supported and no <input> was provided."))) : fe(Ce);
      });
      return;
    }
    V.current && (N({
      type: "openDialog"
    }), P(), V.current.value = null, V.current.click());
  }, [N, P, M, g, R, fe, S, s]), Y = Le(function(ge) {
    !T.current || !T.current.isEqualNode(ge.target) || (ge.key === " " || ge.key === "Enter" || ge.keyCode === 32 || ge.keyCode === 13) && (ge.preventDefault(), q());
  }, [T, q]), ae = Le(function() {
    N({
      type: "focus"
    });
  }, []), te = Le(function() {
    N({
      type: "blur"
    });
  }, []), ue = Le(function() {
    w || (vG() ? setTimeout(q, 0) : q());
  }, [w, q]), Pe = function(Ce) {
    return r ? null : Ce;
  }, de = function(Ce) {
    return $ ? null : Pe(Ce);
  }, Ee = function(Ce) {
    return k ? null : Pe(Ce);
  }, ce = function(Ce) {
    D && Ce.stopPropagation();
  }, Ue = Fe(function() {
    return function() {
      var ge = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, Ce = ge.refKey, Ye = Ce === void 0 ? "ref" : Ce, Xe = ge.role, lt = ge.onKeyDown, F = ge.onFocus, K = ge.onBlur, W = ge.onClick, le = ge.onDragEnter, pe = ge.onDragOver, xe = ge.onDragLeave, _e = ge.onDrop, $e = Cd(ge, SG);
      return It(It(_g({
        onKeyDown: de(gi(lt, Y)),
        onFocus: de(gi(F, ae)),
        onBlur: de(gi(K, te)),
        onClick: Pe(gi(W, ue)),
        onDragEnter: Ee(gi(le, Q)),
        onDragOver: Ee(gi(pe, A)),
        onDragLeave: Ee(gi(xe, O)),
        onDrop: Ee(gi(_e, j)),
        role: typeof Xe == "string" && Xe !== "" ? Xe : "presentation"
      }, Ye, T), !r && !$ ? {
        tabIndex: 0
      } : {}), $e);
    };
  }, [T, Y, ae, te, ue, Q, A, O, j, $, k, r]), et = Le(function(ge) {
    ge.stopPropagation();
  }, []), gn = Fe(function() {
    return function() {
      var ge = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, Ce = ge.refKey, Ye = Ce === void 0 ? "ref" : Ce, Xe = ge.onChange, lt = ge.onClick, F = Cd(ge, $G), K = _g({
        accept: y,
        multiple: s,
        type: "file",
        style: {
          border: 0,
          clip: "rect(0, 0, 0, 0)",
          clipPath: "inset(50%)",
          height: "1px",
          margin: "0 -1px -1px 0",
          overflow: "hidden",
          padding: 0,
          position: "absolute",
          width: "1px",
          whiteSpace: "nowrap"
        },
        onChange: Pe(gi(Xe, j)),
        onClick: Pe(gi(lt, et)),
        tabIndex: -1
      }, Ye, V);
      return It(It({}, K), F);
    };
  }, [V, n, s, j, r]);
  return It(It({}, B), {}, {
    isFocused: C && !r,
    getRootProps: Ue,
    getInputProps: gn,
    rootRef: T,
    inputRef: V,
    open: Pe(q)
  });
}
function IG(e, t) {
  switch (t.type) {
    case "focus":
      return It(It({}, e), {}, {
        isFocused: !0
      });
    case "blur":
      return It(It({}, e), {}, {
        isFocused: !1
      });
    case "openDialog":
      return It(It({}, wg), {}, {
        isFileDialogActive: !0
      });
    case "closeDialog":
      return It(It({}, e), {}, {
        isFileDialogActive: !1
      });
    case "setDraggedFiles":
      return It(It({}, e), {}, {
        isDragActive: t.isDragActive,
        isDragAccept: t.isDragAccept,
        isDragReject: t.isDragReject
      });
    case "setFiles":
      return It(It({}, e), {}, {
        acceptedFiles: t.acceptedFiles,
        fileRejections: t.fileRejections,
        isDragReject: t.isDragReject
      });
    case "setDragGlobal":
      return It(It({}, e), {}, {
        isDragGlobal: t.isDragGlobal
      });
    case "reset":
      return It({}, wg);
    default:
      return e;
  }
}
function LE() {
}
const ZA = (e) => /* @__PURE__ */ I.jsx("input", { type: "checkbox", ...e, className: "bg-neutral-600 checkbox" });
var fc = (e) => e.type === "checkbox", da = (e) => e instanceof Date, Sn = (e) => e == null;
const GA = (e) => typeof e == "object";
var Wt = (e) => !Sn(e) && !Array.isArray(e) && GA(e) && !da(e), MG = (e) => Wt(e) && e.target ? fc(e.target) ? e.target.checked : e.target.value : e, RG = (e, t) => t.split(".").some((n, r, i) => !isNaN(Number(n)) && e.has(i.slice(0, r).join("."))), YA = (e) => {
  const t = e.constructor && e.constructor.prototype;
  return Wt(t) && t.hasOwnProperty("isPrototypeOf");
}, Mp = typeof window < "u" && typeof window.HTMLElement < "u" && typeof document < "u";
function en(e) {
  if (e instanceof Date)
    return new Date(e);
  const t = typeof FileList < "u" && e instanceof FileList;
  if (Mp && (e instanceof Blob || t))
    return e;
  const n = Array.isArray(e);
  if (!n && !(Wt(e) && YA(e)))
    return e;
  const r = n ? [] : Object.create(Object.getPrototypeOf(e));
  for (const i in e)
    Object.prototype.hasOwnProperty.call(e, i) && (r[i] = en(e[i]));
  return r;
}
const Ja = {
  BLUR: "blur",
  FOCUS_OUT: "focusout",
  SUBMIT: "submit",
  TRIGGER: "trigger",
  VALID: "valid"
}, Xr = {
  onBlur: "onBlur",
  onChange: "onChange",
  onSubmit: "onSubmit",
  onTouched: "onTouched",
  all: "all"
}, Yr = {
  max: "max",
  min: "min",
  maxLength: "maxLength",
  minLength: "minLength",
  pattern: "pattern",
  required: "required",
  validate: "validate"
}, QA = "root", JA = ["__proto__", "constructor", "prototype"], NG = /^\w*$/;
var dc = (e) => NG.test(e), Mt = (e) => e === void 0;
const jG = /[.[\]'"]/;
var Rp = (e) => e.split(jG).filter(Boolean), Ie = (e, t, n) => {
  if (!t || !Wt(e))
    return n;
  const r = dc(t) ? [t] : Rp(t);
  if (r.some((o) => JA.includes(o)))
    return n;
  const i = r.reduce((o, a) => Sn(o) ? void 0 : o[a], e);
  return Mt(i) || i === e ? Mt(e[t]) ? n : e[t] : i;
}, bi = (e) => typeof e == "boolean", kr = (e) => typeof e == "function", Ct = (e, t, n) => {
  let r = -1;
  const i = dc(t) ? [t] : Rp(t), o = i.length, a = o - 1;
  for (; ++r < o; ) {
    const s = i[r];
    let l = n;
    if (r !== a) {
      const u = e[s];
      l = Wt(u) || Array.isArray(u) ? u : isNaN(+i[r + 1]) ? {} : [];
    }
    if (JA.includes(s))
      return;
    e[s] = l, e = e[s];
  }
};
const FG = H.createContext(null);
FG.displayName = "HookFormControlContext";
var zG = (e, t, n, r = !0) => {
  const i = {};
  for (const o in e)
    Object.defineProperty(i, o, {
      get: () => {
        const a = o;
        return t._proxyFormState[a] !== Xr.all && (t._proxyFormState[a] = !r || Xr.all), e[a];
      }
    });
  return i;
};
const LG = Mp ? H.useLayoutEffect : H.useEffect;
var In = (e) => typeof e == "string", VG = (e, t, n, r, i) => In(e) ? (r && t.watch.add(e), Ie(n, e, i)) : Array.isArray(e) ? e.map((o) => (r && t.watch.add(o), Ie(n, o))) : (r && (t.watchAll = !0), n), xg = (e) => Sn(e) || !GA(e);
const VE = (e, t) => t.length === 0 && !Array.isArray(e) && !YA(e);
function _i(e, t, n = /* @__PURE__ */ new WeakMap()) {
  if (e === t)
    return !0;
  if (xg(e) || xg(t))
    return Object.is(e, t);
  if (da(e) && da(t))
    return Object.is(e.getTime(), t.getTime());
  const r = Object.keys(e), i = Object.keys(t);
  if (r.length !== i.length)
    return !1;
  if (VE(e, r) || VE(t, i))
    return Object.is(e, t);
  if (!r.length && Array.isArray(e) !== Array.isArray(t))
    return !1;
  const o = n.get(e);
  if (o && o.has(t))
    return !0;
  if (o)
    o.add(t);
  else {
    const a = /* @__PURE__ */ new WeakSet();
    a.add(t), n.set(e, a);
  }
  for (const a of r) {
    const s = e[a];
    if (!(a in t))
      return !1;
    if (a !== "ref") {
      const l = t[a];
      if (da(s) && da(l) || (Wt(s) || Array.isArray(s)) && (Wt(l) || Array.isArray(l)) ? !_i(s, l, n) : !Object.is(s, l))
        return !1;
    }
  }
  return !0;
}
const BG = H.createContext(null);
BG.displayName = "HookFormContext";
var KG = (e, t, n, r, i) => t ? {
  ...n[e],
  types: {
    ...n[e] && n[e].types ? n[e].types : {},
    [r]: i || !0
  }
} : {}, XA = (e) => Array.isArray(e) ? e.filter(Boolean) : [], Cf = (e) => Array.isArray(e) ? e : [e], BE = () => {
  let e = [];
  return {
    get observers() {
      return e;
    },
    next: (i) => {
      for (const o of e)
        o.next && o.next(i);
    },
    subscribe: (i) => (e.push(i), {
      unsubscribe: () => {
        e = e.filter((o) => o !== i);
      }
    }),
    unsubscribe: () => {
      e = [];
    }
  };
};
function eD(e, t) {
  const n = {};
  for (const r in e)
    if (e.hasOwnProperty(r)) {
      const i = e[r], o = t[r];
      if (i && Wt(i) && o) {
        const a = eD(i, o);
        Wt(a) && (n[r] = a);
      } else e[r] && (n[r] = o);
    }
  return n;
}
var xn = (e) => Wt(e) && !Object.keys(e).length, Wb = (e) => e.type === "file", Id = (e) => {
  if (!Mp)
    return !1;
  const t = e ? e.ownerDocument : 0;
  return e instanceof (t && t.defaultView ? t.defaultView.HTMLElement : HTMLElement);
}, tD = (e) => e.type === "select-multiple", Zb = (e) => e.type === "radio", UG = (e) => Zb(e) || fc(e), cm = (e) => Id(e) && e.isConnected;
function qG(e, t) {
  const n = t.slice(0, -1).length;
  let r = 0;
  for (; r < n; ) {
    if (Sn(e)) {
      e = void 0;
      break;
    }
    e = e[t[r]], r++;
  }
  return e;
}
function HG(e) {
  for (const t in e)
    if (e.hasOwnProperty(t) && !Mt(e[t]))
      return !1;
  return !0;
}
function ln(e, t) {
  if (In(t) && Object.prototype.hasOwnProperty.call(e, t))
    return delete e[t], e;
  const n = Array.isArray(t) ? t : dc(t) ? [t] : Rp(t), r = n.length === 1 ? e : qG(e, n), i = n.length - 1, o = n[i];
  return r && delete r[o], i !== 0 && (Wt(r) && xn(r) || Array.isArray(r) && HG(r)) && ln(e, n.slice(0, -1)), e;
}
var WG = (e) => {
  for (const t in e)
    if (kr(e[t]))
      return !0;
  return !1;
};
function nD(e) {
  return Array.isArray(e) || Wt(e) && !WG(e);
}
function Eg(e, t = {}) {
  for (const n in e) {
    const r = e[n];
    nD(r) ? (t[n] = Array.isArray(r) ? [] : {}, Eg(r, t[n])) : Mt(r) || (t[n] = !0);
  }
  return t;
}
function Sg(e) {
  if (e !== !1) {
    if (e === !0)
      return !0;
    if (Array.isArray(e)) {
      const t = e.map((n) => Sg(n));
      return t.some((n) => n !== void 0) ? t : void 0;
    }
    if (Wt(e)) {
      const t = {};
      for (const n in e) {
        const r = Sg(e[n]);
        Mt(r) || (t[n] = r);
      }
      return Object.keys(t).length ? t : void 0;
    }
  }
}
function ea(e, t, n) {
  n || (n = Eg(t));
  for (const r in e) {
    const i = e[r];
    if (nD(i))
      Mt(t) || xg(n[r]) ? n[r] = Eg(i, Array.isArray(i) ? [] : {}) : ea(i, Sn(t) ? {} : t[r], n[r]);
    else {
      const o = t[r];
      n[r] = !_i(i, o);
    }
  }
  return Sg(n) || {};
}
const KE = {
  value: !1,
  isValid: !1
}, UE = { value: !0, isValid: !0 };
var rD = (e) => {
  if (Array.isArray(e)) {
    if (e.length > 1) {
      const t = e.filter((n) => n && n.checked && !n.disabled).map((n) => n.value);
      return { value: t, isValid: !!t.length };
    }
    return e[0].checked && !e[0].disabled ? (
      // @ts-expect-error expected to work in the browser
      e[0].attributes && !Mt(e[0].attributes.value) ? Mt(e[0].value) || e[0].value === "" ? UE : { value: e[0].value, isValid: !0 } : UE
    ) : KE;
  }
  return KE;
}, iD = (e, { valueAsNumber: t, valueAsDate: n, setValueAs: r }) => Mt(e) ? e : t ? e === "" ? NaN : e && +e : n && In(e) ? new Date(e) : r ? r(e) : e;
const qE = {
  isValid: !1,
  value: null
};
var oD = (e) => Array.isArray(e) ? e.reduce((t, n) => n && n.checked && !n.disabled ? {
  isValid: !0,
  value: n.value
} : t, qE) : qE;
function HE(e) {
  const t = e.ref;
  return Wb(t) ? t.files : Zb(t) ? oD(e.refs).value : tD(t) ? [...t.selectedOptions].map(({ value: n }) => n) : fc(t) ? rD(e.refs).value : iD(Mt(t.value) ? e.ref.value : t.value, e);
}
var ZG = (e, t, n, r) => {
  const i = {};
  for (const o of e) {
    const a = Ie(t, o);
    a && Ct(i, o, a._f);
  }
  return {
    criteriaMode: n,
    names: [...e],
    fields: i,
    shouldUseNativeValidation: r
  };
}, Md = (e) => e instanceof RegExp, Fl = (e) => Mt(e) ? e : Md(e) ? e.source : Wt(e) ? Md(e.value) ? e.value.source : e.value : e, Yc = (e) => ({
  isOnSubmit: !e || e === Xr.onSubmit,
  isOnBlur: e === Xr.onBlur,
  isOnChange: e === Xr.onChange,
  isOnAll: e === Xr.all,
  isOnTouch: e === Xr.onTouched
});
const WE = "AsyncFunction";
var GG = (e) => {
  if (!e || !e.validate)
    return !1;
  if (kr(e.validate))
    return e.validate.constructor.name === WE;
  if (Wt(e.validate)) {
    for (const t in e.validate)
      if (e.validate[t].constructor.name === WE)
        return !0;
  }
  return !1;
}, YG = (e) => e.mount && (e.required || e.min || e.max || e.maxLength || e.minLength || e.pattern || e.validate), fm = (e, t, n) => {
  if (n)
    return !1;
  if (t.watchAll || t.watch.has(e))
    return !0;
  for (const r of t.watch)
    if (e.startsWith(r) && e.charAt(r.length) === ".")
      return !0;
  return !1;
};
const fu = (e, t, n, r) => {
  for (const i of n || Object.keys(e)) {
    const o = Ie(e, i);
    if (o) {
      const { _f: a, ...s } = o;
      if (a) {
        if (a.refs && a.refs[0] && t(a.refs[0], i) && !r)
          return !0;
        if (a.ref && t(a.ref, a.name) && !r)
          return !0;
        if (fu(s, t))
          break;
      } else if (Wt(s) && fu(s, t))
        break;
    }
  }
};
function ZE(e, t, n) {
  const r = Ie(e, n);
  if (r || dc(n))
    return {
      error: r,
      name: n
    };
  const i = n.split(".");
  for (; i.length; ) {
    const o = i.join("."), a = Ie(t, o), s = Ie(e, o);
    if (a && !Array.isArray(a) && n !== o)
      return { name: n };
    if (s && s.type)
      return {
        name: o,
        error: s
      };
    if (s && s.root && s.root.type)
      return {
        name: `${o}.root`,
        error: s.root
      };
    i.pop();
  }
  return {
    name: n
  };
}
var QG = (e, t, n, r) => {
  n(e);
  const { name: i, ...o } = e, a = Object.keys(o);
  return !a.length || r && a.length >= Object.keys(t).length || a.find((s) => t[s] === (!r || Xr.all));
}, JG = (e, t, n) => !e || !t || e === t || Cf(e).some((r) => r && (n ? r === t : r.startsWith(t) || t.startsWith(r))), XG = (e, t, n, r, i) => i.isOnAll ? !1 : !n && i.isOnTouch ? !(t || e) : (n ? r.isOnBlur : i.isOnBlur) ? !e : (n ? r.isOnChange : i.isOnChange) ? e : !0, eY = (e, t) => !XA(Ie(e, t)).length && ln(e, t), GE = (e, t, n) => {
  const r = Ie(e, n), i = Array.isArray(r) ? r : [];
  return Ct(i, QA, t[n]), Ct(e, n, i), e;
};
function YE(e, t, n = "validate") {
  if (In(e) || Array.isArray(e) && e.every(In) || bi(e) && !e)
    return {
      type: n,
      message: In(e) ? e : "",
      ref: t
    };
}
var Xa = (e) => Wt(e) && !Md(e) ? e : {
  value: e,
  message: ""
}, QE = async (e, t, n, r, i, o) => {
  const { ref: a, refs: s, required: l, maxLength: u, minLength: c, min: f, max: d, pattern: p, validate: h, name: v, valueAsNumber: m, mount: g } = e._f, _ = Ie(n, v);
  if (!g || t.has(v))
    return {};
  const x = s ? s[0] : a, w = (P) => {
    if (i && x.reportValidity) {
      const M = bi(P) ? "" : P || "";
      s ? s.forEach((T) => T.setCustomValidity(M)) : x.setCustomValidity(M), x.reportValidity();
    }
  }, $ = {}, k = Zb(a), D = fc(a), E = k || D, b = (m || Wb(a)) && Mt(a.value) && Mt(_) || Id(a) && a.value === "" || _ === "" || Array.isArray(_) && !_.length, y = KG.bind(null, v, r, $), S = (P, M, T, V = Yr.maxLength, z = Yr.minLength) => {
    const U = P ? M : T;
    $[v] = {
      type: P ? V : z,
      message: U,
      ref: a,
      ...y(P ? V : z, U)
    };
  };
  if (o ? !Array.isArray(_) || !_.length : l && (!E && (b || Sn(_)) || bi(_) && !_ || D && !rD(s).isValid || k && !oD(s).isValid)) {
    const { value: P, message: M } = In(l) ? { value: !!l, message: l } : Xa(l);
    if (P && ($[v] = {
      type: Yr.required,
      message: M,
      ref: x,
      ...y(Yr.required, M)
    }, !r))
      return w(M), $;
  }
  if (!b && (!Sn(f) || !Sn(d))) {
    let P, M;
    const T = Xa(d), V = Xa(f);
    if (!Sn(_) && !isNaN(_)) {
      const z = a.valueAsNumber || _ && +_;
      Sn(T.value) || (P = z > T.value), Sn(V.value) || (M = z < V.value);
    } else {
      const z = a.valueAsDate || new Date(_), U = (C) => /* @__PURE__ */ new Date((/* @__PURE__ */ new Date()).toDateString() + " " + C), B = a.type == "time", N = a.type == "week";
      In(T.value) && _ && (P = B ? U(_) > U(T.value) : N ? _ > T.value : z > new Date(T.value)), In(V.value) && _ && (M = B ? U(_) < U(V.value) : N ? _ < V.value : z < new Date(V.value));
    }
    if ((P || M) && (S(!!P, T.message, V.message, Yr.max, Yr.min), !r))
      return w($[v].message), $;
  }
  if ((u || c) && !b && (In(_) || o && Array.isArray(_))) {
    const P = Xa(u), M = Xa(c), T = !Sn(P.value) && _.length > +P.value, V = !Sn(M.value) && _.length < +M.value;
    if ((T || V) && (S(T, P.message, M.message), !r))
      return w($[v].message), $;
  }
  if (p && !b && In(_)) {
    const { value: P, message: M } = Xa(p);
    if (Md(P) && !_.match(P) && ($[v] = {
      type: Yr.pattern,
      message: M,
      ref: a,
      ...y(Yr.pattern, M)
    }, !r))
      return w(M), $;
  }
  if (h) {
    if (kr(h)) {
      const P = await h(_, n), M = YE(P, x);
      if (M && ($[v] = {
        ...M,
        ...y(Yr.validate, M.message)
      }, !r))
        return w(M.message), $;
    } else if (Wt(h)) {
      let P = {};
      for (const M in h) {
        if (!xn(P) && !r)
          break;
        const T = YE(await h[M](_, n), x, M);
        T && (P = {
          ...T,
          ...y(M, T.message)
        }, w(T.message), r && ($[v] = P));
      }
      if (!xn(P) && ($[v] = {
        ref: x,
        ...P
      }, !r))
        return $;
    }
  }
  return w(!0), $;
};
const tY = {
  mode: Xr.onSubmit,
  reValidateMode: Xr.onChange,
  shouldFocusError: !0
}, dm = "form", aD = {
  submitCount: 0,
  isDirty: !1,
  isReady: !1,
  isValidating: !1,
  isSubmitted: !1,
  isSubmitting: !1,
  isSubmitSuccessful: !1,
  isValid: !1,
  touchedFields: {},
  dirtyFields: {},
  validatingFields: {}
};
function nY(e = {}) {
  let t = {
    ...tY,
    ...e
  }, n = {
    ...en(aD),
    isLoading: kr(t.defaultValues),
    errors: t.errors || {},
    disabled: t.disabled || !1
  }, r = {}, i = Wt(t.defaultValues) || Wt(t.values) ? en(t.defaultValues || t.values) || {} : {}, o = t.shouldUnregister ? {} : en(i), a = {
    action: !1,
    mount: !1,
    watch: !1,
    keepIsValid: !1
  }, s = {
    mount: /* @__PURE__ */ new Set(),
    disabled: /* @__PURE__ */ new Set(),
    unMount: /* @__PURE__ */ new Set(),
    array: /* @__PURE__ */ new Set(),
    watch: /* @__PURE__ */ new Set(),
    registerName: /* @__PURE__ */ new Set()
  }, l, u = 0, c = 0, f = Yc(t.mode), d = Yc(t.reValidateMode);
  const p = {
    isDirty: !1,
    dirtyFields: !1,
    validatingFields: !1,
    touchedFields: !1,
    isValidating: !1,
    isValid: !1,
    errors: !1
  }, h = {
    ...p
  };
  let v = {
    ...h
  };
  const m = {
    array: BE(),
    state: BE()
  }, g = t.criteriaMode === Xr.all, _ = (F) => (K) => {
    clearTimeout(u), u = setTimeout(F, K);
  }, x = async (F) => {
    if (!a.keepIsValid && !t.disabled && (h.isValid || v.isValid || F)) {
      let K;
      t.resolver ? (K = xn((await M()).errors), w()) : K = await z({
        fields: r,
        onlyCheckValid: !0,
        eventType: Ja.VALID
      }), K !== n.isValid && m.state.next({
        isValid: K
      });
    }
  }, w = (F, K) => {
    !t.disabled && (h.isValidating || h.validatingFields || v.isValidating || v.validatingFields) && ((F || Array.from(s.mount)).forEach((W) => {
      W && (K ? Ct(n.validatingFields, W, K) : ln(n.validatingFields, W));
    }), m.state.next({
      validatingFields: n.validatingFields,
      isValidating: !xn(n.validatingFields)
    }));
  }, $ = () => {
    n.dirtyFields = ea(i, o);
  }, k = (F, K = [], W, le, pe = !0, xe = !0) => {
    if (le && W && !t.disabled) {
      if (a.action = !0, xe && Array.isArray(Ie(r, F))) {
        const _e = W(Ie(r, F), le.argA, le.argB);
        pe && Ct(r, F, _e);
      }
      if (xe && Array.isArray(Ie(n.errors, F))) {
        const _e = W(Ie(n.errors, F), le.argA, le.argB);
        pe && Ct(n.errors, F, _e), eY(n.errors, F);
      }
      if ((h.touchedFields || v.touchedFields) && xe && Array.isArray(Ie(n.touchedFields, F))) {
        const _e = W(Ie(n.touchedFields, F), le.argA, le.argB);
        pe && Ct(n.touchedFields, F, _e);
      }
      (h.dirtyFields || v.dirtyFields) && $(), m.state.next({
        name: F,
        isDirty: B(F, K),
        dirtyFields: n.dirtyFields,
        errors: n.errors,
        isValid: n.isValid
      });
    } else
      Ct(o, F, K);
  }, D = (F, K) => {
    Ct(n.errors, F, K), n.errors = { ...n.errors }, m.state.next({
      errors: n.errors
    });
  }, E = (F) => {
    n.errors = F, m.state.next({
      errors: n.errors,
      isValid: !1
    });
  }, b = (F) => {
    const K = dc(F) ? [F] : Rp(F);
    let W = o, le = i;
    for (let pe = 0; pe < K.length - 1; pe++) {
      const xe = K[pe];
      if (W = Sn(W) ? W : W[xe], le = Sn(le) ? le : le[xe], W === null && le !== null)
        return !0;
    }
    return !1;
  }, y = (F, K, W, le) => {
    const pe = Ie(r, F);
    if (pe) {
      if (b(F))
        return;
      const xe = Mt(Ie(o, F)), _e = Ie(o, F, Mt(W) ? Ie(i, F) : W);
      Mt(_e) || le && le.defaultChecked || K ? Ct(o, F, K ? _e : HE(pe._f)) : G(F, _e), a.mount && !a.action && (x(), xe && n.isDirty && (h.isDirty || v.isDirty) && (B() || (n.isDirty = !1, m.state.next({ ...n }))), e.shouldUnregister && xe && !Mt(Ie(o, F)) && fm(F, s) && (a.watch = !0));
    }
  }, S = (F, K, W, le, pe) => {
    let xe = !1, _e = !1;
    const $e = {
      name: F
    };
    if (!t.disabled) {
      if (!W || le) {
        const We = _i(Ie(i, F), K);
        (h.isDirty || v.isDirty) && (_e = n.isDirty, n.isDirty = $e.isDirty = !We || B(), xe = _e !== $e.isDirty), _e = !!Ie(n.dirtyFields, F), We !== n.isDirty ? n.dirtyFields = ea(i, o) : We ? ln(n.dirtyFields, F) : Ct(n.dirtyFields, F, !0), $e.dirtyFields = n.dirtyFields, xe = xe || (h.dirtyFields || v.dirtyFields) && _e !== !We;
      }
      if (W) {
        const We = Ie(n.touchedFields, F);
        We || (Ct(n.touchedFields, F, W), $e.touchedFields = n.touchedFields, xe = xe || (h.touchedFields || v.touchedFields) && We !== W);
      }
      xe && pe && m.state.next($e);
    }
    return xe ? $e : {};
  }, P = (F, K, W, le) => {
    const pe = Ie(n.errors, F), xe = (h.isValid || v.isValid) && bi(K) && n.isValid !== K;
    if (t.delayError && W ? (l = _(() => D(F, W)), l(t.delayError)) : (clearTimeout(u), l = null, W ? Ct(n.errors, F, W) : ln(n.errors, F), n.errors = { ...n.errors }), (W ? !_i(pe, W) : pe) || !xn(le) || xe) {
      const _e = {
        ...le,
        ...xe && bi(K) ? { isValid: K } : {},
        errors: n.errors,
        name: F
      };
      n = {
        ...n,
        ..._e
      }, m.state.next(_e);
    }
  }, M = async (F) => (w(F, !0), await t.resolver(o, t.context, ZG(F || s.mount, r, t.criteriaMode, t.shouldUseNativeValidation))), T = async (F) => {
    const { errors: K } = await M(F);
    if (w(F), F) {
      for (const W of F) {
        const le = Ie(K, W);
        le ? s.array.has(W) && Wt(le) && !Object.keys(le).some((pe) => !Number.isNaN(Number(pe))) ? GE(n.errors, { [W]: le }, W) : Ct(n.errors, W, le) : ln(n.errors, W);
      }
      n.errors = { ...n.errors };
    } else
      n.errors = K;
    return K;
  }, V = async ({ name: F, eventType: K }) => {
    if (e.validate) {
      const W = await e.validate({
        formValues: o,
        formState: n,
        name: F,
        eventType: K
      });
      if (Wt(W))
        for (const le in W) {
          const pe = W[le];
          pe && j(`${dm}.${le}`, {
            message: In(pe.message) ? pe.message : "",
            type: pe.type || Yr.validate
          });
        }
      else In(W) || !W ? j(dm, {
        message: W || "",
        type: Yr.validate
      }) : R(dm);
      return W;
    }
    return !0;
  }, z = async ({ fields: F, onlyCheckValid: K, name: W, eventType: le, context: pe = {
    valid: !0,
    runRootValidation: !1
  } }) => {
    if (e.validate && (pe.runRootValidation = !0, !await V({
      name: W,
      eventType: le
    }) && (pe.valid = !1, K)))
      return pe.valid;
    for (const xe in F) {
      const _e = F[xe];
      if (_e) {
        const { _f: $e, ...We } = _e;
        if ($e) {
          const ft = s.array.has($e.name), Qt = _e._f && GG(_e._f), hi = h.validatingFields || h.isValidating || v.validatingFields || v.isValidating;
          Qt && hi && w([$e.name], !0);
          const ur = await QE(_e, s.disabled, o, g, t.shouldUseNativeValidation && !K, ft);
          if (Qt && hi && w([$e.name]), ur[$e.name] && (pe.valid = !1, K) || (!K && (Ie(ur, $e.name) ? ft ? GE(n.errors, ur, $e.name) : Ct(n.errors, $e.name, ur[$e.name]) : ln(n.errors, $e.name)), e.shouldUseNativeValidation && ur[$e.name]))
            break;
        }
        !xn(We) && await z({
          context: pe,
          onlyCheckValid: K,
          fields: We,
          name: xe,
          eventType: le
        });
      }
    }
    return pe.valid;
  }, U = () => {
    for (const F of s.unMount) {
      const K = Ie(r, F);
      K && (K._f.refs ? K._f.refs.every((W) => !cm(W)) : !cm(K._f.ref)) && te(F);
    }
    s.unMount = /* @__PURE__ */ new Set();
  }, B = (F, K) => !t.disabled && (F && K && Ct(o, F, K), !_i(a.mount ? o : i, i)), N = (F, K, W) => VG(F, s, {
    ...a.mount ? o : Mt(K) ? i : In(F) ? { [F]: K } : K
  }, W, K), C = (F) => XA(Ie(a.mount ? o : i, F, t.shouldUnregister ? Ie(i, F, []) : [])), G = (F, K, W = {}, le = !1, pe = !1) => {
    const xe = Ie(r, F);
    let _e = K;
    if (xe) {
      const $e = xe._f;
      $e && (!$e.disabled && Ct(o, F, iD(K, $e)), _e = Id($e.ref) && Sn(K) ? "" : K, tD($e.ref) ? [...$e.ref.options].forEach((We) => We.selected = _e.includes(We.value)) : $e.refs ? fc($e.ref) ? $e.refs.forEach((We) => {
        (!We.defaultChecked || !We.disabled) && (Array.isArray(_e) ? We.checked = !!_e.find((ft) => ft === We.value) : We.checked = _e === We.value || !!_e);
      }) : $e.refs.forEach((We) => We.checked = We.value === _e) : Wb($e.ref) ? $e.ref.value = "" : ($e.ref.value = _e, !$e.ref.type && !pe && m.state.next({
        name: F,
        values: le ? o : en(o)
      })));
    }
    (W.shouldDirty || W.shouldTouch) && S(F, _e, W.shouldTouch, W.shouldDirty, !pe), W.shouldValidate && Q(F);
  }, re = (F, K, W, le = !1, pe = !1) => {
    for (const xe in K) {
      if (!K.hasOwnProperty(xe))
        return;
      const _e = K[xe], $e = F + "." + xe, We = Ie(r, $e);
      (s.array.has(F) || Wt(_e) || We && !We._f) && !da(_e) ? re($e, _e, W, le, pe) : G($e, _e, W, le, pe);
    }
  }, ie = (F, K, W, le, pe = !1) => {
    const xe = Ie(r, F), _e = s.array.has(F), $e = le ? K : en(K), We = Ie(o, F), ft = _i(We, $e);
    if (ft || Ct(o, F, $e), _e)
      m.array.next({
        name: F,
        values: le ? o : en(o)
      }), (h.isDirty || h.dirtyFields || v.isDirty || v.dirtyFields) && W.shouldDirty && ($(), pe || m.state.next({
        name: F,
        dirtyFields: n.dirtyFields,
        isDirty: B(F, $e)
      }));
    else {
      const Qt = Array.isArray($e) && !$e.length || xn($e);
      !xe || xe._f || Sn($e) || Qt ? G(F, $e, W, le, pe) : re(F, $e, W, le, pe);
    }
    if (!ft && !pe) {
      const Qt = fm(F, s), hi = le ? o : en(o);
      m.state.next({
        ...Qt && n,
        name: a.mount || Qt ? F : void 0,
        values: hi
      });
    }
  }, X = (F, K, W = {}) => ie(F, K, W, !1), Se = (F, K = {}) => {
    const W = kr(F) ? F(o) : F;
    if (!_i(o, W)) {
      o = {
        ...o,
        ...W
      };
      for (const le of s.mount)
        ie(le, Ie(W, le), K, !0, !0);
      m.state.next({
        ...n,
        name: void 0,
        type: void 0,
        ...c ? { values: o } : {}
      }), K.shouldValidate && x();
    }
  }, me = async (F) => {
    a.mount = !0;
    const K = F.target;
    let W = K.name, le = !0;
    const pe = Ie(r, W), xe = (_e) => {
      le = Number.isNaN(_e) || da(_e) && isNaN(_e.getTime()) || _i(_e, Ie(o, W, _e));
    };
    if (pe) {
      let _e, $e;
      const We = K.type ? HE(pe._f) : MG(F), ft = F.type === Ja.BLUR || F.type === Ja.FOCUS_OUT, Qt = !YG(pe._f) && !e.validate && !t.resolver && !Ie(n.errors, W) && !pe._f.deps, hi = Qt || XG(ft, Ie(n.touchedFields, W), n.isSubmitted, d, f), ur = fm(W, s, ft);
      Ct(o, W, We), ft ? (!K || !K.readOnly) && (pe._f.onBlur && pe._f.onBlur(F), l && l(0)) : pe._f.onChange && pe._f.onChange(F);
      const io = S(W, We, ft), oh = !xn(io) || ur;
      if (!ft && m.state.next({
        name: W,
        type: F.type,
        ...c ? { values: en(o) } : {}
      }), hi)
        return (!Qt || !n.isValid) && (h.isValid || v.isValid) && (t.mode === "onBlur" ? ft && x() : ft || x()), oh && m.state.next({ name: W, ...ur ? {} : io });
      if (!t.resolver && e.validate && await V({
        name: W,
        eventType: F.type
      }), !ft && ur && m.state.next({ ...n }), t.resolver) {
        const { errors: Tl } = await M([W]);
        if (w([W]), xe(We), !le) {
          !xn(io) && m.state.next(io);
          return;
        }
        const ah = ZE(n.errors, r, W), Ol = ZE(Tl, r, ah.name || W);
        _e = Ol.error, W = Ol.name, $e = xn(Tl);
      } else
        w([W], !0), _e = (await QE(pe, s.disabled, o, g, t.shouldUseNativeValidation))[W], w([W]), xe(We), le && (_e ? $e = !1 : (h.isValid || v.isValid) && ($e = await z({
          fields: r,
          onlyCheckValid: !0,
          name: W,
          eventType: F.type
        })));
      le && (pe._f.deps && (!Array.isArray(pe._f.deps) || pe._f.deps.length > 0) && Q(pe._f.deps), P(W, $e, _e, io));
    }
  }, fe = (F, K) => {
    if (Ie(n.errors, K) && F.focus)
      return F.focus(), 1;
  }, Q = async (F, K = {}) => {
    let W, le;
    const pe = Cf(F);
    if (t.resolver) {
      const xe = await T(Mt(F) ? F : pe);
      W = xn(xe), le = F ? !pe.some((_e) => Ie(xe, _e)) : W;
    } else F ? (le = (await Promise.all(pe.map(async (xe) => {
      const _e = Ie(r, xe);
      return await z({
        fields: _e && _e._f ? { [xe]: _e } : _e,
        eventType: Ja.TRIGGER
      });
    }))).every(Boolean), !(!le && !n.isValid) && x()) : le = W = await z({
      fields: r,
      name: F,
      eventType: Ja.TRIGGER
    });
    return m.state.next({
      ...!In(F) || (h.isValid || v.isValid) && W !== n.isValid ? {} : { name: F },
      ...t.resolver || !F ? { isValid: W } : {},
      errors: n.errors
    }), K.shouldFocus && !le && fu(r, fe, F ? pe : s.mount), le;
  }, A = (F, K) => {
    let W = {
      ...a.mount ? o : i
    };
    return K && (W = eD(K.dirtyFields ? n.dirtyFields : n.touchedFields, W)), Mt(F) ? W : In(F) ? Ie(W, F) : F.map((le) => Ie(W, le));
  }, O = (F, K) => ({
    invalid: !!Ie((K || n).errors, F),
    isDirty: !!Ie((K || n).dirtyFields, F),
    error: Ie((K || n).errors, F),
    isValidating: !!Ie(n.validatingFields, F),
    isTouched: !!Ie((K || n).touchedFields, F)
  }), R = (F) => {
    const K = F ? Cf(F) : void 0;
    K?.forEach((W) => ln(n.errors, W)), K ? K.forEach((W) => {
      m.state.next({
        name: W,
        errors: n.errors
      });
    }) : m.state.next({
      errors: {}
    });
  }, j = (F, K, W) => {
    const le = (Ie(r, F, { _f: {} })._f || {}).ref, pe = Ie(n.errors, F) || {}, { ref: xe, message: _e, type: $e, ...We } = pe;
    Ct(n.errors, F, {
      ...We,
      ...K,
      ref: le
    }), m.state.next({
      name: F,
      errors: n.errors,
      isValid: !1
    }), W && W.shouldFocus && le && le.focus && le.focus();
  }, q = (F, K) => {
    if (kr(F)) {
      c++;
      const { unsubscribe: W } = m.state.subscribe({
        next: (pe) => "values" in pe && F(pe.values || N(void 0, K), pe)
      });
      let le = !1;
      return {
        unsubscribe: () => {
          le || (le = !0, c--, W());
        }
      };
    }
    return N(F, K, !0);
  }, Y = (F) => {
    var K;
    const W = !!(!((K = F.formState) === null || K === void 0) && K.values);
    W && c++;
    const { unsubscribe: le } = m.state.subscribe({
      next: (xe) => {
        if (JG(F.name, xe.name, F.exact) && QG(xe, F.formState || h, Ce, F.reRenderRoot)) {
          const _e = { ...o };
          F.callback({
            values: _e,
            ...n,
            ...xe,
            defaultValues: i
          });
        }
      }
    });
    if (!W)
      return le;
    let pe = !1;
    return () => {
      pe || (pe = !0, c--, le());
    };
  }, ae = (F) => (a.mount = !0, v = {
    ...v,
    ...F.formState
  }, Y({
    ...F,
    formState: {
      ...p,
      ...F.formState
    }
  })), te = (F, K = {}) => {
    for (const W of F ? Cf(F) : s.mount)
      s.mount.delete(W), s.array.delete(W), K.keepValue || (ln(r, W), ln(o, W)), !K.keepError && ln(n.errors, W), !K.keepDirty && ln(n.dirtyFields, W), !K.keepTouched && ln(n.touchedFields, W), !K.keepIsValidating && ln(n.validatingFields, W), !t.shouldUnregister && !K.keepDefaultValue && ln(i, W);
    m.state.next({
      values: en(o)
    }), m.state.next({
      ...n,
      ...K.keepDirty ? { isDirty: B() } : {}
    }), !K.keepIsValid && x();
  }, ue = ({ disabled: F, name: K }) => {
    if (bi(F) && a.mount || F || s.disabled.has(K)) {
      const pe = s.disabled.has(K) !== !!F;
      F ? s.disabled.add(K) : s.disabled.delete(K), pe && a.mount && !a.action && x();
    }
  }, Pe = (F, K = {}) => {
    let W = Ie(r, F);
    const le = bi(K.disabled) || bi(t.disabled), pe = !s.registerName.has(F) && W && W._f && !W._f.mount;
    return Ct(r, F, {
      ...W || {},
      _f: {
        ...W && W._f ? W._f : { ref: { name: F } },
        name: F,
        mount: !0,
        ...K
      }
    }), s.mount.add(F), W && !pe ? ue({
      disabled: bi(K.disabled) ? K.disabled : t.disabled,
      name: F
    }) : y(F, !0, K.value), {
      ...le ? { disabled: K.disabled || t.disabled } : {},
      ...t.progressive ? {
        required: !!K.required,
        min: Fl(K.min),
        max: Fl(K.max),
        minLength: Fl(K.minLength),
        maxLength: Fl(K.maxLength),
        pattern: Fl(K.pattern)
      } : {},
      name: F,
      onChange: me,
      onBlur: me,
      ref: (xe) => {
        if (xe) {
          s.registerName.add(F), Pe(F, K), s.registerName.delete(F), W = Ie(r, F);
          const _e = Mt(xe.value) && xe.querySelectorAll && xe.querySelectorAll("input,select,textarea")[0] || xe, $e = UG(_e), We = W._f.refs || [];
          if ($e ? We.find((ft) => ft === _e) : _e === W._f.ref)
            return;
          Ct(r, F, {
            _f: {
              ...W._f,
              ...$e ? {
                refs: [
                  ...We.filter(cm),
                  _e,
                  ...Array.isArray(Ie(i, F)) ? [{}] : []
                ],
                ref: { type: _e.type, name: F }
              } : { ref: _e }
            }
          }), y(F, !1, void 0, _e);
        } else
          W = Ie(r, F, {}), W._f && (W._f.mount = !1), (t.shouldUnregister || K.shouldUnregister) && !(RG(s.array, F) && a.action) && s.unMount.add(F);
      }
    };
  }, de = () => t.shouldFocusError && !t.shouldUseNativeValidation && fu(r, fe, s.mount), Ee = (F) => {
    bi(F) && (m.state.next({ disabled: F }), fu(r, (K, W) => {
      const le = Ie(r, W);
      le && (K.disabled = le._f.disabled || F, Array.isArray(le._f.refs) && le._f.refs.forEach((pe) => {
        pe.disabled = le._f.disabled || F;
      }));
    }, 0, !1));
  }, ce = (F, K) => async (W) => {
    let le;
    W && (W.preventDefault && W.preventDefault(), W.persist && W.persist());
    let pe = en(o);
    if (m.state.next({
      isSubmitting: !0
    }), t.resolver) {
      const { errors: xe, values: _e } = await M();
      w(), n.errors = xe, pe = en(_e);
    } else
      await z({
        fields: r,
        eventType: Ja.SUBMIT
      });
    if (s.disabled.size)
      for (const xe of s.disabled)
        ln(pe, xe);
    if (ln(n.errors, QA), xn(n.errors)) {
      m.state.next({
        errors: {}
      });
      try {
        await F(pe, W);
      } catch (xe) {
        le = xe;
      }
    } else
      K && await K({ ...n.errors }, W), de(), setTimeout(de);
    if (m.state.next({
      isSubmitted: !0,
      isSubmitting: !1,
      isSubmitSuccessful: xn(n.errors) && !le,
      submitCount: n.submitCount + 1,
      errors: n.errors
    }), le)
      throw le;
  }, Ue = (F, K = {}) => {
    Ie(r, F) && (Mt(K.defaultValue) ? X(F, en(Ie(i, F))) : (X(F, K.defaultValue), Ct(i, F, en(K.defaultValue))), K.keepTouched || ln(n.touchedFields, F), K.keepDirty || (ln(n.dirtyFields, F), n.isDirty = K.defaultValue ? B(F, en(Ie(i, F))) : B()), K.keepError || (ln(n.errors, F), h.isValid && x()), m.state.next({ ...n }));
  }, et = (F, K = {}) => {
    const W = F ? en(F) : i, le = en(W), pe = xn(F), xe = le;
    if (K.keepDefaultValues || (i = W), !K.keepValues) {
      if (K.keepDirtyValues) {
        const _e = /* @__PURE__ */ new Set([
          ...s.mount,
          ...Object.keys(ea(i, o))
        ]);
        for (const $e of Array.from(_e)) {
          const We = Ie(n.dirtyFields, $e), ft = Ie(o, $e), Qt = Ie(xe, $e);
          We && !Mt(ft) ? Ct(xe, $e, ft) : !We && !Mt(Qt) && X($e, Qt);
        }
      } else {
        if (Mp && Mt(F))
          for (const _e of s.mount) {
            const $e = Ie(r, _e);
            if ($e && $e._f) {
              const We = Array.isArray($e._f.refs) ? $e._f.refs[0] : $e._f.ref;
              if (Id(We)) {
                const ft = We.closest("form");
                if (ft) {
                  ft.reset();
                  break;
                }
              }
            }
          }
        if (K.keepFieldsRef)
          for (const _e of s.mount)
            X(_e, Ie(xe, _e));
        else
          r = {};
      }
      if (t.shouldUnregister) {
        if (o = K.keepDefaultValues ? en(i) : {}, K.keepFieldsRef)
          for (const _e of s.mount)
            Ct(o, _e, Ie(xe, _e));
      } else
        o = en(xe);
      m.array.next({
        values: { ...xe }
      }), m.state.next({
        values: { ...xe }
      });
    }
    s = {
      mount: K.keepDirtyValues ? s.mount : /* @__PURE__ */ new Set(),
      unMount: /* @__PURE__ */ new Set(),
      array: /* @__PURE__ */ new Set(),
      registerName: /* @__PURE__ */ new Set(),
      disabled: /* @__PURE__ */ new Set(),
      watch: /* @__PURE__ */ new Set(),
      watchAll: !1,
      focus: ""
    }, a.mount = !h.isValid || !!K.keepIsValid || !!K.keepDirtyValues || !t.shouldUnregister && !xn(xe), a.watch = !!t.shouldUnregister, a.keepIsValid = !!K.keepIsValid, a.action = !1, K.keepErrors || (n.errors = {}), m.state.next({
      submitCount: K.keepSubmitCount ? n.submitCount : 0,
      isDirty: pe ? !1 : K.keepDirty ? n.isDirty : K.keepValues ? B() : !!(K.keepDefaultValues && !_i(F, i)),
      isSubmitted: K.keepIsSubmitted ? n.isSubmitted : !1,
      dirtyFields: pe ? {} : K.keepDirtyValues ? K.keepDefaultValues && o ? ea(i, o) : n.dirtyFields : K.keepDefaultValues && F ? ea(i, F) : K.keepDirty ? n.dirtyFields : {},
      touchedFields: K.keepTouched ? n.touchedFields : {},
      errors: K.keepErrors ? n.errors : {},
      isSubmitSuccessful: K.keepIsSubmitSuccessful ? n.isSubmitSuccessful : !1,
      isSubmitting: !1,
      defaultValues: i
    });
  }, gn = (F, K) => et(kr(F) ? F(o) : F, { ...t.resetOptions, ...K }), ge = (F, K = {}) => {
    const W = Ie(r, F), le = W && W._f;
    if (le) {
      const pe = le.refs ? le.refs[0] : le.ref;
      pe.focus && setTimeout(() => {
        pe.focus(), K.shouldSelect && kr(pe.select) && pe.select();
      });
    }
  }, Ce = (F) => {
    n = {
      ...n,
      ...F
    };
  }, lt = {
    control: {
      register: Pe,
      unregister: te,
      getFieldState: O,
      handleSubmit: ce,
      setError: j,
      _subscribe: Y,
      _runSchema: M,
      _updateIsValidating: w,
      _focusError: de,
      _getWatch: N,
      _getDirty: B,
      _setValid: x,
      _setFieldArray: k,
      _setDisabledField: ue,
      _setErrors: E,
      _getFieldArray: C,
      _reset: et,
      _resetDefaultValues: () => kr(t.defaultValues) && t.defaultValues().then((F) => {
        gn(F, t.resetOptions), m.state.next({
          isLoading: !1
        });
      }),
      _removeUnmounted: U,
      _disableForm: Ee,
      _subjects: m,
      _proxyFormState: h,
      get _fields() {
        return r;
      },
      get _formValues() {
        return o;
      },
      get _state() {
        return a;
      },
      set _state(F) {
        a = F;
      },
      get _defaultValues() {
        return i;
      },
      get _names() {
        return s;
      },
      set _names(F) {
        s = F;
      },
      get _formState() {
        return n;
      },
      get _options() {
        return t;
      },
      set _options(F) {
        t = {
          ...t,
          ...F
        }, f = Yc(t.mode), d = Yc(t.reValidateMode);
      }
    },
    subscribe: ae,
    trigger: Q,
    register: Pe,
    handleSubmit: ce,
    watch: q,
    setValue: X,
    setValues: Se,
    getValues: A,
    reset: gn,
    resetField: Ue,
    resetDefaultValues: (F, K = {}) => {
      if (i = en(F), !K.keepDirty) {
        const W = ea(i, o);
        n.dirtyFields = W, n.isDirty = !xn(W);
      }
      K.keepIsValid || x(), m.state.next({
        ...n,
        defaultValues: i
      });
    },
    clearErrors: R,
    unregister: te,
    setError: j,
    setFocus: ge,
    getFieldState: O
  };
  return {
    ...lt,
    formControl: lt
  };
}
function rY(e = {}) {
  const t = H.useRef(void 0), n = H.useRef(void 0), r = H.useRef(e.formControl), [i, o] = H.useState(() => ({
    ...en(aD),
    isLoading: kr(e.defaultValues),
    errors: e.errors || {},
    disabled: e.disabled || !1,
    defaultValues: kr(e.defaultValues) ? void 0 : e.defaultValues
  }));
  if (!t.current || e.formControl && r.current !== e.formControl)
    if (r.current = e.formControl, e.formControl)
      t.current = {
        ...e.formControl,
        formState: i
      }, e.defaultValues && !kr(e.defaultValues) && e.formControl.reset(e.defaultValues, e.resetOptions);
    else {
      const { formControl: s, ...l } = nY(e);
      t.current = {
        ...l,
        formState: i
      };
    }
  const a = t.current.control;
  return a._options = e, LG(() => {
    const s = a._subscribe({
      formState: a._proxyFormState,
      callback: () => o({
        ...a._formState,
        defaultValues: a._defaultValues
      }),
      reRenderRoot: !0
    });
    return o((l) => ({
      ...l,
      isReady: !0
    })), a._formState.isReady = !0, s;
  }, [a]), H.useEffect(() => a._disableForm(e.disabled), [a, e.disabled]), H.useEffect(() => {
    e.mode && (a._options.mode = e.mode), e.reValidateMode && (a._options.reValidateMode = e.reValidateMode);
  }, [a, e.mode, e.reValidateMode]), H.useEffect(() => {
    e.errors && (a._setErrors(e.errors), a._focusError());
  }, [a, e.errors]), H.useEffect(() => {
    e.shouldUnregister && a._subjects.state.next({
      values: a._getWatch()
    });
  }, [a, e.shouldUnregister]), H.useEffect(() => {
    if (a._proxyFormState.isDirty) {
      const s = a._getDirty();
      s !== i.isDirty && a._subjects.state.next({
        isDirty: s
      });
    }
  }, [a, i.isDirty]), H.useEffect(() => {
    var s;
    e.values && !_i(e.values, n.current) ? (a._reset(e.values, {
      keepFieldsRef: !0,
      ...a._options.resetOptions
    }), !((s = a._options.resetOptions) === null || s === void 0) && s.keepIsValid || a._setValid(), n.current = e.values, o((l) => ({ ...l }))) : a._resetDefaultValues();
  }, [a, e.values]), H.useEffect(() => {
    a._state.mount || (a._setValid(), a._state.mount = !0), a._state.watch && (a._state.watch = !1, a._subjects.state.next({ ...a._formState })), a._removeUnmounted();
  }), t.current.formState = H.useMemo(() => zG(i, a), [a, i]), t.current;
}
const iY = fn(
  ({ className: e, ...t }, n) => /* @__PURE__ */ I.jsx(
    "input",
    {
      ref: n,
      ...t,
      className: rr(
        "dark:bg-neutral-800 dark:text-neutral-200 bg-white text-black px-2 border-black border font-body",
        e
      )
    }
  )
), oY = (e, t) => {
  const n = (r) => {
    e.current && !e.current.contains(r.target) && t();
  };
  ze(() => (document.addEventListener("click", n), () => {
    document.removeEventListener("click", n);
  }));
};
function aY(e, t, n = 250) {
  const [r, i] = Ke(0);
  return ze(() => {
    const o = setTimeout(() => {
      i(0);
    }, n);
    return r === 2 && t(), () => clearTimeout(o);
  }, [r]), () => i((o) => o + 1);
}
var pc = "delete", Rt = 5, Cr = 1 << Rt, qn = Cr - 1, rt = {};
function $g() {
  return { value: !1 };
}
function Ir(e) {
  e && (e.value = !0);
}
function Gb() {
}
function Ks(e) {
  return e.size === void 0 && (e.size = e.__iterate(sD)), e.size;
}
function Ao(e, t) {
  if (typeof t != "number") {
    var n = t >>> 0;
    if ("" + n !== t || n === 4294967295)
      return NaN;
    t = n;
  }
  return t < 0 ? Ks(e) + t : t;
}
function sD() {
  return !0;
}
function Np(e, t, n) {
  return (e === 0 && !uD(e) || n !== void 0 && e <= -n) && (t === void 0 || n !== void 0 && t >= n);
}
function hc(e, t) {
  return lD(e, t, 0);
}
function jp(e, t) {
  return lD(e, t, t);
}
function lD(e, t, n) {
  return e === void 0 ? n : uD(e) ? t === 1 / 0 ? t : Math.max(0, t + e) | 0 : t === void 0 || t === e ? e : Math.min(t, e) | 0;
}
function uD(e) {
  return e < 0 || e === 0 && 1 / e === -1 / 0;
}
var cD = "@@__IMMUTABLE_ITERABLE__@@";
function or(e) {
  return !!(e && e[cD]);
}
var fD = "@@__IMMUTABLE_KEYED__@@";
function Ft(e) {
  return !!(e && e[fD]);
}
var dD = "@@__IMMUTABLE_INDEXED__@@";
function nr(e) {
  return !!(e && e[dD]);
}
function Fp(e) {
  return Ft(e) || nr(e);
}
var rn = function(e) {
  return or(e) ? e : br(e);
}, Kr = /* @__PURE__ */ (function(e) {
  function t(n) {
    return Ft(n) ? n : Uo(n);
  }
  return e && (t.__proto__ = e), t.prototype = Object.create(e && e.prototype), t.prototype.constructor = t, t;
})(rn), Ua = /* @__PURE__ */ (function(e) {
  function t(n) {
    return nr(n) ? n : di(n);
  }
  return e && (t.__proto__ = e), t.prototype = Object.create(e && e.prototype), t.prototype.constructor = t, t;
})(rn), hl = /* @__PURE__ */ (function(e) {
  function t(n) {
    return or(n) && !Fp(n) ? n : yl(n);
  }
  return e && (t.__proto__ = e), t.prototype = Object.create(e && e.prototype), t.prototype.constructor = t, t;
})(rn);
rn.Keyed = Kr;
rn.Indexed = Ua;
rn.Set = hl;
var pD = "@@__IMMUTABLE_SEQ__@@";
function Yb(e) {
  return !!(e && e[pD]);
}
var hD = "@@__IMMUTABLE_RECORD__@@";
function ml(e) {
  return !!(e && e[hD]);
}
function Mi(e) {
  return or(e) || ml(e);
}
var vl = "@@__IMMUTABLE_ORDERED__@@";
function oi(e) {
  return !!(e && e[vl]);
}
var mc = 0, si = 1, zr = 2, kg = typeof Symbol == "function" && Symbol.iterator, mD = "@@iterator", zp = kg || mD, pt = function(e) {
  this.next = e;
};
pt.prototype.toString = function() {
  return "[Iterator]";
};
pt.KEYS = mc;
pt.VALUES = si;
pt.ENTRIES = zr;
pt.prototype.inspect = pt.prototype.toSource = function() {
  return this.toString();
};
pt.prototype[zp] = function() {
  return this;
};
function Vt(e, t, n, r) {
  var i = e === 0 ? t : e === 1 ? n : [t, n];
  return r ? r.value = i : r = {
    value: i,
    done: !1
  }, r;
}
function ar() {
  return { value: void 0, done: !0 };
}
function vD(e) {
  return Array.isArray(e) ? !0 : !!Lp(e);
}
function JE(e) {
  return e && typeof e.next == "function";
}
function Tg(e) {
  var t = Lp(e);
  return t && t.call(e);
}
function Lp(e) {
  var t = e && (kg && e[kg] || e[mD]);
  if (typeof t == "function")
    return t;
}
function sY(e) {
  var t = Lp(e);
  return t && t === e.entries;
}
function lY(e) {
  var t = Lp(e);
  return t && t === e.keys;
}
var gl = Object.prototype.hasOwnProperty;
function gD(e) {
  return Array.isArray(e) || typeof e == "string" ? !0 : e && typeof e == "object" && Number.isInteger(e.length) && e.length >= 0 && (e.length === 0 ? Object.keys(e).length === 1 : e.hasOwnProperty(e.length - 1));
}
var br = /* @__PURE__ */ (function(e) {
  function t(n) {
    return n == null ? Jb() : Mi(n) ? n.toSeq() : cY(n);
  }
  return e && (t.__proto__ = e), t.prototype = Object.create(e && e.prototype), t.prototype.constructor = t, t.prototype.toSeq = function() {
    return this;
  }, t.prototype.toString = function() {
    return this.__toString("Seq {", "}");
  }, t.prototype.cacheResult = function() {
    return !this._cache && this.__iterateUncached && (this._cache = this.entrySeq().toArray(), this.size = this._cache.length), this;
  }, t.prototype.__iterate = function(n, r) {
    var i = this._cache;
    if (i) {
      for (var o = i.length, a = 0; a !== o; ) {
        var s = i[r ? o - ++a : a++];
        if (n(s[1], s[0], this) === !1)
          break;
      }
      return a;
    }
    return this.__iterateUncached(n, r);
  }, t.prototype.__iterator = function(n, r) {
    var i = this._cache;
    if (i) {
      var o = i.length, a = 0;
      return new pt(function() {
        if (a === o)
          return ar();
        var s = i[r ? o - ++a : a++];
        return Vt(n, s[0], s[1]);
      });
    }
    return this.__iteratorUncached(n, r);
  }, t;
})(rn), Uo = /* @__PURE__ */ (function(e) {
  function t(n) {
    return n == null ? Jb().toKeyedSeq() : or(n) ? Ft(n) ? n.toSeq() : n.fromEntrySeq() : ml(n) ? n.toSeq() : Xb(n);
  }
  return e && (t.__proto__ = e), t.prototype = Object.create(e && e.prototype), t.prototype.constructor = t, t.prototype.toKeyedSeq = function() {
    return this;
  }, t;
})(br), di = /* @__PURE__ */ (function(e) {
  function t(n) {
    return n == null ? Jb() : or(n) ? Ft(n) ? n.entrySeq() : n.toIndexedSeq() : ml(n) ? n.toSeq().entrySeq() : yD(n);
  }
  return e && (t.__proto__ = e), t.prototype = Object.create(e && e.prototype), t.prototype.constructor = t, t.of = function() {
    return t(arguments);
  }, t.prototype.toIndexedSeq = function() {
    return this;
  }, t.prototype.toString = function() {
    return this.__toString("Seq [", "]");
  }, t;
})(br), yl = /* @__PURE__ */ (function(e) {
  function t(n) {
    return (or(n) && !Fp(n) ? n : di(n)).toSetSeq();
  }
  return e && (t.__proto__ = e), t.prototype = Object.create(e && e.prototype), t.prototype.constructor = t, t.of = function() {
    return t(arguments);
  }, t.prototype.toSetSeq = function() {
    return this;
  }, t;
})(br);
br.isSeq = Yb;
br.Keyed = Uo;
br.Set = yl;
br.Indexed = di;
br.prototype[pD] = !0;
var Da = /* @__PURE__ */ (function(e) {
  function t(n) {
    this._array = n, this.size = n.length;
  }
  return e && (t.__proto__ = e), t.prototype = Object.create(e && e.prototype), t.prototype.constructor = t, t.prototype.get = function(n, r) {
    return this.has(n) ? this._array[Ao(this, n)] : r;
  }, t.prototype.__iterate = function(n, r) {
    for (var i = this._array, o = i.length, a = 0; a !== o; ) {
      var s = r ? o - ++a : a++;
      if (n(i[s], s, this) === !1)
        break;
    }
    return a;
  }, t.prototype.__iterator = function(n, r) {
    var i = this._array, o = i.length, a = 0;
    return new pt(function() {
      if (a === o)
        return ar();
      var s = r ? o - ++a : a++;
      return Vt(n, s, i[s]);
    });
  }, t;
})(di), Qb = /* @__PURE__ */ (function(e) {
  function t(n) {
    var r = Object.keys(n).concat(
      Object.getOwnPropertySymbols ? Object.getOwnPropertySymbols(n) : []
    );
    this._object = n, this._keys = r, this.size = r.length;
  }
  return e && (t.__proto__ = e), t.prototype = Object.create(e && e.prototype), t.prototype.constructor = t, t.prototype.get = function(n, r) {
    return r !== void 0 && !this.has(n) ? r : this._object[n];
  }, t.prototype.has = function(n) {
    return gl.call(this._object, n);
  }, t.prototype.__iterate = function(n, r) {
    for (var i = this._object, o = this._keys, a = o.length, s = 0; s !== a; ) {
      var l = o[r ? a - ++s : s++];
      if (n(i[l], l, this) === !1)
        break;
    }
    return s;
  }, t.prototype.__iterator = function(n, r) {
    var i = this._object, o = this._keys, a = o.length, s = 0;
    return new pt(function() {
      if (s === a)
        return ar();
      var l = o[r ? a - ++s : s++];
      return Vt(n, l, i[l]);
    });
  }, t;
})(Uo);
Qb.prototype[vl] = !0;
var uY = /* @__PURE__ */ (function(e) {
  function t(n) {
    this._collection = n, this.size = n.length || n.size;
  }
  return e && (t.__proto__ = e), t.prototype = Object.create(e && e.prototype), t.prototype.constructor = t, t.prototype.__iterateUncached = function(n, r) {
    if (r)
      return this.cacheResult().__iterate(n, r);
    var i = this._collection, o = Tg(i), a = 0;
    if (JE(o))
      for (var s; !(s = o.next()).done && n(s.value, a++, this) !== !1; )
        ;
    return a;
  }, t.prototype.__iteratorUncached = function(n, r) {
    if (r)
      return this.cacheResult().__iterator(n, r);
    var i = this._collection, o = Tg(i);
    if (!JE(o))
      return new pt(ar);
    var a = 0;
    return new pt(function() {
      var s = o.next();
      return s.done ? s : Vt(n, a++, s.value);
    });
  }, t;
})(di), XE;
function Jb() {
  return XE || (XE = new Da([]));
}
function Xb(e) {
  var t = e0(e);
  if (t)
    return t.fromEntrySeq();
  if (typeof e == "object")
    return new Qb(e);
  throw new TypeError(
    "Expected Array or collection object of [k, v] entries, or keyed object: " + e
  );
}
function yD(e) {
  var t = e0(e);
  if (t)
    return t;
  throw new TypeError(
    "Expected Array or collection object of values: " + e
  );
}
function cY(e) {
  var t = e0(e);
  if (t)
    return sY(e) ? t.fromEntrySeq() : lY(e) ? t.toSetSeq() : t;
  if (typeof e == "object")
    return new Qb(e);
  throw new TypeError(
    "Expected Array or collection object of values, or keyed object: " + e
  );
}
function e0(e) {
  return gD(e) ? new Da(e) : vD(e) ? new uY(e) : void 0;
}
var bD = "@@__IMMUTABLE_MAP__@@";
function t0(e) {
  return !!(e && e[bD]);
}
function _D(e) {
  return t0(e) && oi(e);
}
function e2(e) {
  return !!(e && typeof e.equals == "function" && typeof e.hashCode == "function");
}
function pr(e, t) {
  if (e === t || e !== e && t !== t)
    return !0;
  if (!e || !t)
    return !1;
  if (typeof e.valueOf == "function" && typeof t.valueOf == "function") {
    if (e = e.valueOf(), t = t.valueOf(), e === t || e !== e && t !== t)
      return !0;
    if (!e || !t)
      return !1;
  }
  return !!(e2(e) && e2(t) && e.equals(t));
}
var zl = typeof Math.imul == "function" && Math.imul(4294967295, 2) === -2 ? Math.imul : function(e, t) {
  e |= 0, t |= 0;
  var n = e & 65535, r = t & 65535;
  return n * r + ((e >>> 16) * r + n * (t >>> 16) << 16 >>> 0) | 0;
};
function Vp(e) {
  return e >>> 1 & 1073741824 | e & 3221225471;
}
var fY = Object.prototype.valueOf;
function Jn(e) {
  if (e == null)
    return t2(e);
  if (typeof e.hashCode == "function")
    return Vp(e.hashCode(e));
  var t = yY(e);
  if (t == null)
    return t2(t);
  switch (typeof t) {
    case "boolean":
      return t ? 1108378657 : 1108378656;
    case "number":
      return dY(t);
    case "string":
      return t.length > bY ? pY(t) : Og(t);
    case "object":
    case "function":
      return vY(t);
    case "symbol":
      return mY(t);
    default:
      if (typeof t.toString == "function")
        return Og(t.toString());
      throw new Error("Value type " + typeof t + " cannot be hashed.");
  }
}
function t2(e) {
  return e === null ? 1108378658 : 1108378659;
}
function dY(e) {
  if (e !== e || e === 1 / 0)
    return 0;
  var t = e | 0;
  for (t !== e && (t ^= e * 4294967295); e > 4294967295; )
    e /= 4294967295, t ^= e;
  return Vp(t);
}
function pY(e) {
  var t = mm[e];
  return t === void 0 && (t = Og(e), hm === _Y && (hm = 0, mm = {}), hm++, mm[e] = t), t;
}
function Og(e) {
  for (var t = 0, n = 0; n < e.length; n++)
    t = 31 * t + e.charCodeAt(n) | 0;
  return Vp(t);
}
var hY = (Math.random() * 1048576 | 1) % 1048576 || 40503;
function n0(e) {
  if (typeof e != "string")
    return Jn(e);
  for (var t = 0, n = 0; n < e.length; n++)
    t = hY * t + e.charCodeAt(n) | 0;
  return t;
}
function mY(e) {
  var t = i2[e];
  return t !== void 0 || (t = wD(), i2[e] = t), t;
}
function vY(e) {
  var t;
  if (Pg && (t = Ag.get(e), t !== void 0) || (t = e[ia], t !== void 0) || !r2 && (t = e.propertyIsEnumerable && e.propertyIsEnumerable[ia], t !== void 0 || (t = gY(e), t !== void 0)))
    return t;
  if (t = wD(), Pg)
    Ag.set(e, t);
  else {
    if (n2 !== void 0 && n2(e) === !1)
      throw new Error("Non-extensible objects are not allowed as keys.");
    if (r2)
      Object.defineProperty(e, ia, {
        enumerable: !1,
        configurable: !1,
        writable: !1,
        value: t
      });
    else if (e.propertyIsEnumerable !== void 0 && e.propertyIsEnumerable === e.constructor.prototype.propertyIsEnumerable)
      e.propertyIsEnumerable = function() {
        return this.constructor.prototype.propertyIsEnumerable.apply(
          this,
          arguments
        );
      }, e.propertyIsEnumerable[ia] = t;
    else if (e.nodeType !== void 0)
      e[ia] = t;
    else
      throw new Error("Unable to set a non-enumerable property on object.");
  }
  return t;
}
var n2 = Object.isExtensible, r2 = (function() {
  try {
    return Object.defineProperty({}, "@", {}), !0;
  } catch {
    return !1;
  }
})();
function gY(e) {
  if (e && e.nodeType > 0)
    switch (e.nodeType) {
      case 1:
        return e.uniqueID;
      case 9:
        return e.documentElement && e.documentElement.uniqueID;
    }
}
function yY(e) {
  return e.valueOf !== fY && typeof e.valueOf == "function" ? e.valueOf(e) : e;
}
function wD() {
  var e = ++pm;
  return pm & 1073741824 && (pm = 0), e;
}
var Pg = typeof WeakMap == "function", Ag;
Pg && (Ag = /* @__PURE__ */ new WeakMap());
var i2 = /* @__PURE__ */ Object.create(null), pm = 0, ia = "__immutablehash__";
typeof Symbol == "function" && (ia = Symbol(ia));
var bY = 16, _Y = 255, hm = 0, mm = {}, Bp = /* @__PURE__ */ (function(e) {
  function t(n, r) {
    this._iter = n, this._useKeys = r, this.size = n.size;
  }
  return e && (t.__proto__ = e), t.prototype = Object.create(e && e.prototype), t.prototype.constructor = t, t.prototype.get = function(n, r) {
    return this._iter.get(n, r);
  }, t.prototype.has = function(n) {
    return this._iter.has(n);
  }, t.prototype.valueSeq = function() {
    return this._iter.valueSeq();
  }, t.prototype.reverse = function() {
    var n = this, r = r0(this, !0);
    return this._useKeys || (r.valueSeq = function() {
      return n._iter.toSeq().reverse();
    }), r;
  }, t.prototype.map = function(n, r) {
    var i = this, o = kD(this, n, r);
    return this._useKeys || (o.valueSeq = function() {
      return i._iter.toSeq().map(n, r);
    }), o;
  }, t.prototype.__iterate = function(n, r) {
    var i = this;
    return this._iter.__iterate(function(o, a) {
      return n(o, a, i);
    }, r);
  }, t.prototype.__iterator = function(n, r) {
    return this._iter.__iterator(n, r);
  }, t;
})(Uo);
Bp.prototype[vl] = !0;
var xD = /* @__PURE__ */ (function(e) {
  function t(n) {
    this._iter = n, this.size = n.size;
  }
  return e && (t.__proto__ = e), t.prototype = Object.create(e && e.prototype), t.prototype.constructor = t, t.prototype.includes = function(n) {
    return this._iter.includes(n);
  }, t.prototype.__iterate = function(n, r) {
    var i = this, o = 0;
    return r && Ks(this), this._iter.__iterate(
      function(a) {
        return n(a, r ? i.size - ++o : o++, i);
      },
      r
    );
  }, t.prototype.__iterator = function(n, r) {
    var i = this, o = this._iter.__iterator(si, r), a = 0;
    return r && Ks(this), new pt(function() {
      var s = o.next();
      return s.done ? s : Vt(
        n,
        r ? i.size - ++a : a++,
        s.value,
        s
      );
    });
  }, t;
})(di), ED = /* @__PURE__ */ (function(e) {
  function t(n) {
    this._iter = n, this.size = n.size;
  }
  return e && (t.__proto__ = e), t.prototype = Object.create(e && e.prototype), t.prototype.constructor = t, t.prototype.has = function(n) {
    return this._iter.includes(n);
  }, t.prototype.__iterate = function(n, r) {
    var i = this;
    return this._iter.__iterate(function(o) {
      return n(o, o, i);
    }, r);
  }, t.prototype.__iterator = function(n, r) {
    var i = this._iter.__iterator(si, r);
    return new pt(function() {
      var o = i.next();
      return o.done ? o : Vt(n, o.value, o.value, o);
    });
  }, t;
})(yl), SD = /* @__PURE__ */ (function(e) {
  function t(n) {
    this._iter = n, this.size = n.size;
  }
  return e && (t.__proto__ = e), t.prototype = Object.create(e && e.prototype), t.prototype.constructor = t, t.prototype.entrySeq = function() {
    return this._iter.toSeq();
  }, t.prototype.__iterate = function(n, r) {
    var i = this;
    return this._iter.__iterate(function(o) {
      if (o) {
        a2(o);
        var a = or(o);
        return n(
          a ? o.get(1) : o[1],
          a ? o.get(0) : o[0],
          i
        );
      }
    }, r);
  }, t.prototype.__iterator = function(n, r) {
    var i = this._iter.__iterator(si, r);
    return new pt(function() {
      for (; ; ) {
        var o = i.next();
        if (o.done)
          return o;
        var a = o.value;
        if (a) {
          a2(a);
          var s = or(a);
          return Vt(
            n,
            s ? a.get(0) : a[0],
            s ? a.get(1) : a[1],
            o
          );
        }
      }
    });
  }, t;
})(Uo);
xD.prototype.cacheResult = Bp.prototype.cacheResult = ED.prototype.cacheResult = SD.prototype.cacheResult = a0;
function $D(e) {
  var t = Ri(e);
  return t._iter = e, t.size = e.size, t.flip = function() {
    return e;
  }, t.reverse = function() {
    var n = e.reverse.apply(this);
    return n.flip = function() {
      return e.reverse();
    }, n;
  }, t.has = function(n) {
    return e.includes(n);
  }, t.includes = function(n) {
    return e.has(n);
  }, t.cacheResult = a0, t.__iterateUncached = function(n, r) {
    var i = this;
    return e.__iterate(function(o, a) {
      return n(a, o, i) !== !1;
    }, r);
  }, t.__iteratorUncached = function(n, r) {
    if (n === zr) {
      var i = e.__iterator(n, r);
      return new pt(function() {
        var o = i.next();
        if (!o.done) {
          var a = o.value[0];
          o.value[0] = o.value[1], o.value[1] = a;
        }
        return o;
      });
    }
    return e.__iterator(
      n === si ? mc : si,
      r
    );
  }, t;
}
function kD(e, t, n) {
  var r = Ri(e);
  return r.size = e.size, r.has = function(i) {
    return e.has(i);
  }, r.get = function(i, o) {
    var a = e.get(i, rt);
    return a === rt ? o : t.call(n, a, i, e);
  }, r.__iterateUncached = function(i, o) {
    var a = this;
    return e.__iterate(
      function(s, l, u) {
        return i(t.call(n, s, l, u), l, a) !== !1;
      },
      o
    );
  }, r.__iteratorUncached = function(i, o) {
    var a = e.__iterator(zr, o);
    return new pt(function() {
      var s = a.next();
      if (s.done)
        return s;
      var l = s.value, u = l[0];
      return Vt(
        i,
        u,
        t.call(n, l[1], u, e),
        s
      );
    });
  }, r;
}
function r0(e, t) {
  var n = this, r = Ri(e);
  return r._iter = e, r.size = e.size, r.reverse = function() {
    return e;
  }, e.flip && (r.flip = function() {
    var i = $D(e);
    return i.reverse = function() {
      return e.flip();
    }, i;
  }), r.get = function(i, o) {
    return e.get(t ? i : -1 - i, o);
  }, r.has = function(i) {
    return e.has(t ? i : -1 - i);
  }, r.includes = function(i) {
    return e.includes(i);
  }, r.cacheResult = a0, r.__iterate = function(i, o) {
    var a = this, s = 0;
    return o && Ks(e), e.__iterate(
      function(l, u) {
        return i(l, t ? u : o ? a.size - ++s : s++, a);
      },
      !o
    );
  }, r.__iterator = function(i, o) {
    var a = 0;
    o && Ks(e);
    var s = e.__iterator(zr, !o);
    return new pt(function() {
      var l = s.next();
      if (l.done)
        return l;
      var u = l.value;
      return Vt(
        i,
        t ? u[0] : o ? n.size - ++a : a++,
        u[1],
        l
      );
    });
  }, r;
}
function TD(e, t, n, r) {
  var i = Ri(e);
  return r && (i.has = function(o) {
    var a = e.get(o, rt);
    return a !== rt && !!t.call(n, a, o, e);
  }, i.get = function(o, a) {
    var s = e.get(o, rt);
    return s !== rt && t.call(n, s, o, e) ? s : a;
  }), i.__iterateUncached = function(o, a) {
    var s = this, l = 0;
    return e.__iterate(function(u, c, f) {
      if (t.call(n, u, c, f))
        return l++, o(u, r ? c : l - 1, s);
    }, a), l;
  }, i.__iteratorUncached = function(o, a) {
    var s = e.__iterator(zr, a), l = 0;
    return new pt(function() {
      for (; ; ) {
        var u = s.next();
        if (u.done)
          return u;
        var c = u.value, f = c[0], d = c[1];
        if (t.call(n, d, f, e))
          return Vt(o, r ? f : l++, d, u);
      }
    });
  }, i;
}
function wY(e, t, n) {
  var r = _l().asMutable();
  return e.__iterate(function(i, o) {
    r.update(t.call(n, i, o, e), 0, function(a) {
      return a + 1;
    });
  }), r.asImmutable();
}
function xY(e, t, n) {
  var r = Ft(e), i = (oi(e) ? Qi() : _l()).asMutable();
  e.__iterate(function(a, s) {
    i.update(
      t.call(n, a, s, e),
      function(l) {
        return l = l || [], l.push(r ? [s, a] : a), l;
      }
    );
  });
  var o = o0(e);
  return i.map(function(a) {
    return xt(e, o(a));
  }).asImmutable();
}
function EY(e, t, n) {
  var r = Ft(e), i = [[], []];
  e.__iterate(function(a, s) {
    i[t.call(n, a, s, e) ? 1 : 0].push(
      r ? [s, a] : a
    );
  });
  var o = o0(e);
  return i.map(function(a) {
    return xt(e, o(a));
  });
}
function i0(e, t, n, r) {
  var i = e.size;
  if (Np(t, n, i))
    return e;
  if (typeof i > "u" && (t < 0 || n < 0))
    return i0(e.toSeq().cacheResult(), t, n, r);
  var o = hc(t, i), a = jp(n, i), s = a - o, l;
  s === s && (l = s < 0 ? 0 : s);
  var u = Ri(e);
  return u.size = l === 0 ? l : e.size && l || void 0, !r && Yb(e) && l >= 0 && (u.get = function(c, f) {
    return c = Ao(this, c), c >= 0 && c < l ? e.get(c + o, f) : f;
  }), u.__iterateUncached = function(c, f) {
    var d = this;
    if (l === 0)
      return 0;
    if (f)
      return this.cacheResult().__iterate(c, f);
    var p = 0, h = !0, v = 0;
    return e.__iterate(function(m, g) {
      if (!(h && (h = p++ < o)))
        return v++, c(m, r ? g : v - 1, d) !== !1 && v !== l;
    }), v;
  }, u.__iteratorUncached = function(c, f) {
    if (l !== 0 && f)
      return this.cacheResult().__iterator(c, f);
    if (l === 0)
      return new pt(ar);
    var d = e.__iterator(c, f), p = 0, h = 0;
    return new pt(function() {
      for (; p++ < o; )
        d.next();
      if (++h > l)
        return ar();
      var v = d.next();
      return r || c === si || v.done ? v : c === mc ? Vt(c, h - 1, void 0, v) : Vt(c, h - 1, v.value[1], v);
    });
  }, u;
}
function SY(e, t, n) {
  var r = Ri(e);
  return r.__iterateUncached = function(i, o) {
    var a = this;
    if (o)
      return this.cacheResult().__iterate(i, o);
    var s = 0;
    return e.__iterate(
      function(l, u, c) {
        return t.call(n, l, u, c) && ++s && i(l, u, a);
      }
    ), s;
  }, r.__iteratorUncached = function(i, o) {
    var a = this;
    if (o)
      return this.cacheResult().__iterator(i, o);
    var s = e.__iterator(zr, o), l = !0;
    return new pt(function() {
      if (!l)
        return ar();
      var u = s.next();
      if (u.done)
        return u;
      var c = u.value, f = c[0], d = c[1];
      return t.call(n, d, f, a) ? i === zr ? u : Vt(i, f, d, u) : (l = !1, ar());
    });
  }, r;
}
function OD(e, t, n, r) {
  var i = Ri(e);
  return i.__iterateUncached = function(o, a) {
    var s = this;
    if (a)
      return this.cacheResult().__iterate(o, a);
    var l = !0, u = 0;
    return e.__iterate(function(c, f, d) {
      if (!(l && (l = t.call(n, c, f, d))))
        return u++, o(c, r ? f : u - 1, s);
    }), u;
  }, i.__iteratorUncached = function(o, a) {
    var s = this;
    if (a)
      return this.cacheResult().__iterator(o, a);
    var l = e.__iterator(zr, a), u = !0, c = 0;
    return new pt(function() {
      var f, d, p;
      do {
        if (f = l.next(), f.done)
          return r || o === si ? f : o === mc ? Vt(o, c++, void 0, f) : Vt(o, c++, f.value[1], f);
        var h = f.value;
        d = h[0], p = h[1], u && (u = t.call(n, p, d, s));
      } while (u);
      return o === zr ? f : Vt(o, d, p, f);
    });
  }, i;
}
function $Y(e, t) {
  var n = Ft(e), r = [e].concat(t).map(function(a) {
    return or(a) ? n && (a = Kr(a)) : a = n ? Xb(a) : yD(Array.isArray(a) ? a : [a]), a;
  }).filter(function(a) {
    return a.size !== 0;
  });
  if (r.length === 0)
    return e;
  if (r.length === 1) {
    var i = r[0];
    if (i === e || n && Ft(i) || nr(e) && nr(i))
      return i;
  }
  var o = new Da(r);
  return n ? o = o.toKeyedSeq() : nr(e) || (o = o.toSetSeq()), o = o.flatten(!0), o.size = r.reduce(function(a, s) {
    if (a !== void 0) {
      var l = s.size;
      if (l !== void 0)
        return a + l;
    }
  }, 0), o;
}
function PD(e, t, n) {
  var r = Ri(e);
  return r.__iterateUncached = function(i, o) {
    if (o)
      return this.cacheResult().__iterate(i, o);
    var a = 0, s = !1;
    function l(u, c) {
      u.__iterate(function(f, d) {
        return (!t || c < t) && or(f) ? l(f, c + 1) : (a++, i(f, n ? d : a - 1, r) === !1 && (s = !0)), !s;
      }, o);
    }
    return l(e, 0), a;
  }, r.__iteratorUncached = function(i, o) {
    if (o)
      return this.cacheResult().__iterator(i, o);
    var a = e.__iterator(i, o), s = [], l = 0;
    return new pt(function() {
      for (; a; ) {
        var u = a.next();
        if (u.done !== !1) {
          a = s.pop();
          continue;
        }
        var c = u.value;
        if (i === zr && (c = c[1]), (!t || s.length < t) && or(c))
          s.push(a), a = c.__iterator(i, o);
        else
          return n ? u : Vt(i, l++, c, u);
      }
      return ar();
    });
  }, r;
}
function kY(e, t, n) {
  var r = o0(e);
  return e.toSeq().map(function(i, o) {
    return r(t.call(n, i, o, e));
  }).flatten(!0);
}
function TY(e, t) {
  var n = Ri(e);
  return n.size = e.size && e.size * 2 - 1, n.__iterateUncached = function(r, i) {
    var o = this, a = 0;
    return e.__iterate(
      function(s) {
        return (!a || r(t, a++, o) !== !1) && r(s, a++, o) !== !1;
      },
      i
    ), a;
  }, n.__iteratorUncached = function(r, i) {
    var o = e.__iterator(si, i), a = 0, s;
    return new pt(function() {
      return (!s || a % 2) && (s = o.next(), s.done) ? s : a % 2 ? Vt(r, a++, t) : Vt(r, a++, s.value, s);
    });
  }, n;
}
function Us(e, t, n) {
  t || (t = AD);
  var r = Ft(e), i = 0, o = e.toSeq().map(function(a, s) {
    return [s, a, i++, n ? n(a, s, e) : a];
  }).valueSeq().toArray();
  return o.sort(function(a, s) {
    return t(a[3], s[3]) || a[2] - s[2];
  }).forEach(
    r ? function(a, s) {
      o[s].length = 2;
    } : function(a, s) {
      o[s] = a[1];
    }
  ), r ? Uo(o) : nr(e) ? di(o) : yl(o);
}
function Qc(e, t, n) {
  if (t || (t = AD), n) {
    var r = e.toSeq().map(function(i, o) {
      return [i, n(i, o, e)];
    }).reduce(function(i, o) {
      return o2(t, i[1], o[1]) ? o : i;
    });
    return r && r[0];
  }
  return e.reduce(function(i, o) {
    return o2(t, i, o) ? o : i;
  });
}
function o2(e, t, n) {
  var r = e(n, t);
  return r === 0 && n !== t && (n == null || n !== n) || r > 0;
}
function Jc(e, t, n, r) {
  var i = Ri(e), o = new Da(n).map(function(a) {
    return a.size;
  });
  return i.size = r ? o.max() : o.min(), i.__iterate = function(a, s) {
    for (var l = this.__iterator(si, s), u, c = 0; !(u = l.next()).done && a(u.value, c++, this) !== !1; )
      ;
    return c;
  }, i.__iteratorUncached = function(a, s) {
    var l = n.map(
      function(f) {
        return f = rn(f), Tg(s ? f.reverse() : f);
      }
    ), u = 0, c = !1;
    return new pt(function() {
      var f;
      return c || (f = l.map(function(d) {
        return d.next();
      }), c = r ? f.every(function(d) {
        return d.done;
      }) : f.some(function(d) {
        return d.done;
      })), c ? ar() : Vt(
        a,
        u++,
        t.apply(
          null,
          f.map(function(d) {
            return d.value;
          })
        )
      );
    });
  }, i;
}
function xt(e, t) {
  return e === t ? e : Yb(e) ? t : e.constructor(t);
}
function a2(e) {
  if (e !== Object(e))
    throw new TypeError("Expected [K, V] tuple: " + e);
}
function o0(e) {
  return Ft(e) ? Kr : nr(e) ? Ua : hl;
}
function Ri(e) {
  return Object.create(
    (Ft(e) ? Uo : nr(e) ? di : yl).prototype
  );
}
function a0() {
  return this._iter.cacheResult ? (this._iter.cacheResult(), this.size = this._iter.size, this) : br.prototype.cacheResult.call(this);
}
function AD(e, t) {
  return e === void 0 && t === void 0 ? 0 : e === void 0 ? 1 : t === void 0 ? -1 : e > t ? 1 : e < t ? -1 : 0;
}
function Ei(e, t) {
  t = t || 0;
  for (var n = Math.max(0, e.length - t), r = new Array(n), i = 0; i < n; i++)
    r[i] = e[i + t];
  return r;
}
function s0(e, t) {
  if (!e)
    throw new Error(t);
}
function dr(e) {
  s0(
    e !== 1 / 0,
    "Cannot perform this action with an infinite size."
  );
}
function DD(e) {
  if (gD(e) && typeof e != "string")
    return e;
  if (oi(e))
    return e.toArray();
  throw new TypeError(
    "Invalid keyPath: expected Ordered Collection or Array: " + e
  );
}
var OY = Object.prototype.toString;
function PY(e) {
  if (!e || typeof e != "object" || OY.call(e) !== "[object Object]")
    return !1;
  var t = Object.getPrototypeOf(e);
  if (t === null)
    return !0;
  for (var n = t, r = Object.getPrototypeOf(t); r !== null; )
    n = r, r = Object.getPrototypeOf(n);
  return n === t;
}
function Do(e) {
  return typeof e == "object" && (Mi(e) || Array.isArray(e) || PY(e));
}
function ju(e) {
  try {
    return typeof e == "string" ? JSON.stringify(e) : String(e);
  } catch {
    return JSON.stringify(e);
  }
}
function AY(e, t) {
  return Mi(e) ? e.has(t) : Do(e) && gl.call(e, t);
}
function CD(e, t, n) {
  return Mi(e) ? e.get(t, n) : AY(e, t) ? typeof e.get == "function" ? e.get(t) : e[t] : n;
}
function vc(e) {
  return typeof e == "string" && (e === "__proto__" || e === "constructor");
}
function Rd(e) {
  if (Array.isArray(e))
    return Ei(e);
  var t = {};
  for (var n in e)
    vc(n) || gl.call(e, n) && (t[n] = e[n]);
  return t;
}
function DY(e, t) {
  if (!Do(e))
    throw new TypeError(
      "Cannot update non-data-structure value: " + e
    );
  if (Mi(e)) {
    if (!e.remove)
      throw new TypeError(
        "Cannot update immutable value without .remove() method: " + e
      );
    return e.remove(t);
  }
  if (!gl.call(e, t))
    return e;
  var n = Rd(e);
  return Array.isArray(n) ? n.splice(t, 1) : delete n[t], n;
}
function CY(e, t, n) {
  if (vc(t))
    return e;
  if (!Do(e))
    throw new TypeError(
      "Cannot update non-data-structure value: " + e
    );
  if (Mi(e)) {
    if (!e.set)
      throw new TypeError(
        "Cannot update immutable value without .set() method: " + e
      );
    return e.set(t, n);
  }
  if (gl.call(e, t) && n === e[t])
    return e;
  var r = Rd(e);
  return r[t] = n, r;
}
function bl(e, t, n, r) {
  r || (r = n, n = void 0);
  var i = ID(
    Mi(e),
    e,
    DD(t),
    0,
    n,
    r
  );
  return i === rt ? n : i;
}
function ID(e, t, n, r, i, o) {
  var a = t === rt;
  if (r === n.length) {
    var s = a ? i : t, l = o(s);
    return l === s ? t : l;
  }
  if (!a && !Do(t))
    throw new TypeError(
      "Cannot update within non-data-structure value in path [" + n.slice(0, r).map(ju) + "]: " + t
    );
  var u = n[r], c = a ? rt : CD(t, u, rt), f = ID(
    c === rt ? e : Mi(c),
    c,
    n,
    r + 1,
    i,
    o
  );
  return f === c ? t : f === rt ? DY(t, u) : CY(
    a ? e ? ei() : {} : t,
    u,
    f
  );
}
function IY(e, t, n) {
  return bl(e, t, rt, function() {
    return n;
  });
}
function l0(e, t) {
  return IY(this, e, t);
}
function MY(e, t) {
  return bl(e, t, function() {
    return rt;
  });
}
function u0(e) {
  return MY(this, e);
}
function MD(e, t, n, r) {
  return bl(e, [t], n, r);
}
function c0(e, t, n) {
  return arguments.length === 1 ? e(this) : MD(this, e, t, n);
}
function f0(e, t, n) {
  return bl(this, e, t, n);
}
function RD() {
  for (var e = [], t = arguments.length; t--; )
    e[t] = arguments[t];
  return jD(this, e);
}
function ND(e) {
  for (var t = [], n = arguments.length - 1; n-- > 0; )
    t[n] = arguments[n + 1];
  if (typeof e != "function")
    throw new TypeError("Invalid merger function: " + e);
  return jD(this, t, e);
}
function jD(e, t, n) {
  for (var r = [], i = 0; i < t.length; i++) {
    var o = Kr(t[i]);
    o.size !== 0 && r.push(o);
  }
  return r.length === 0 ? e : e.toSeq().size === 0 && !e.__ownerID && r.length === 1 ? e.constructor(r[0]) : e.withMutations(function(a) {
    for (var s = n ? function(u, c) {
      MD(
        a,
        c,
        rt,
        function(f) {
          return f === rt ? u : n(f, u, c);
        }
      );
    } : function(u, c) {
      a.set(c, u);
    }, l = 0; l < r.length; l++)
      r[l].forEach(s);
  });
}
function d0(e, t, n) {
  return p0(e, t, RY(n));
}
function p0(e, t, n) {
  if (!Do(e))
    throw new TypeError(
      "Cannot merge into non-data-structure value: " + e
    );
  if (Mi(e))
    return typeof n == "function" && e.mergeWith ? e.mergeWith.apply(e, [n].concat(t)) : e.merge ? e.merge.apply(e, t) : e.concat.apply(e, t);
  for (var r = Array.isArray(e), i = e, o = r ? Ua : Kr, a = r ? function(l) {
    i === e && (i = Rd(i)), i.push(l);
  } : function(l, u) {
    if (!vc(u)) {
      var c = gl.call(i, u), f = c && n ? n(i[u], l, u) : l;
      (!c || f !== i[u]) && (i === e && (i = Rd(i)), i[u] = f);
    }
  }, s = 0; s < t.length; s++)
    o(t[s]).forEach(a);
  return i;
}
function RY(e) {
  function t(n, r, i) {
    return Do(n) && Do(r) && NY(n, r) ? p0(n, [r], t) : e ? e(n, r, i) : r;
  }
  return t;
}
function NY(e, t) {
  var n = br(e), r = br(t);
  return nr(n) === nr(r) && Ft(n) === Ft(r);
}
function FD() {
  for (var e = [], t = arguments.length; t--; )
    e[t] = arguments[t];
  return d0(this, e);
}
function zD(e) {
  for (var t = [], n = arguments.length - 1; n-- > 0; )
    t[n] = arguments[n + 1];
  return d0(this, t, e);
}
function h0(e) {
  for (var t = [], n = arguments.length - 1; n-- > 0; )
    t[n] = arguments[n + 1];
  return bl(this, e, ei(), function(r) {
    return p0(r, t);
  });
}
function m0(e) {
  for (var t = [], n = arguments.length - 1; n-- > 0; )
    t[n] = arguments[n + 1];
  return bl(
    this,
    e,
    ei(),
    function(r) {
      return d0(r, t);
    }
  );
}
function gc(e) {
  var t = this.asMutable();
  return e(t), t.wasAltered() ? t.__ensureOwner(this.__ownerID) : this;
}
function yc() {
  return this.__ownerID ? this : this.__ensureOwner(new Gb());
}
function bc() {
  return this.__ensureOwner();
}
function v0() {
  return this.__altered;
}
var _l = /* @__PURE__ */ (function(e) {
  function t(n) {
    return n == null ? ei() : t0(n) && !oi(n) ? n : ei().withMutations(function(r) {
      var i = e(n);
      dr(i.size), i.forEach(function(o, a) {
        return r.set(a, o);
      });
    });
  }
  return e && (t.__proto__ = e), t.prototype = Object.create(e && e.prototype), t.prototype.constructor = t, t.of = function() {
    for (var n = [], r = arguments.length; r--; )
      n[r] = arguments[r];
    return ei().withMutations(function(i) {
      for (var o = 0; o < n.length; o += 2) {
        if (o + 1 >= n.length)
          throw new Error("Missing value for key: " + n[o]);
        i.set(n[o], n[o + 1]);
      }
    });
  }, t.prototype.toString = function() {
    return this.__toString("Map {", "}");
  }, t.prototype.get = function(n, r) {
    return this._root ? this._root.get(0, void 0, n, r) : r;
  }, t.prototype.set = function(n, r) {
    return u2(this, n, r);
  }, t.prototype.remove = function(n) {
    return u2(this, n, rt);
  }, t.prototype.deleteAll = function(n) {
    var r = rn(n);
    return r.size === 0 ? this : this.withMutations(function(i) {
      r.forEach(function(o) {
        return i.remove(o);
      });
    });
  }, t.prototype.clear = function() {
    return this.size === 0 ? this : this.__ownerID ? (this.size = 0, this._root = null, this.__hash = void 0, this.__altered = !0, this) : ei();
  }, t.prototype.sort = function(n) {
    return Qi(Us(this, n));
  }, t.prototype.sortBy = function(n, r) {
    return Qi(Us(this, r, n));
  }, t.prototype.map = function(n, r) {
    var i = this;
    return this.withMutations(function(o) {
      o.forEach(function(a, s) {
        o.set(s, n.call(r, a, s, i));
      });
    });
  }, t.prototype.__iterator = function(n, r) {
    return new jY(this, n, r);
  }, t.prototype.__iterate = function(n, r) {
    var i = this, o = 0;
    return this._root && this._root.iterate(function(a) {
      return o++, n(a[1], a[0], i);
    }, r), o;
  }, t.prototype.__ensureOwner = function(n) {
    return n === this.__ownerID ? this : n ? g0(this.size, this._root, n, this.__hash) : this.size === 0 ? ei() : (this.__ownerID = n, this.__altered = !1, this);
  }, t;
})(Kr);
_l.isMap = t0;
var jt = _l.prototype;
jt[bD] = !0;
jt[pc] = jt.remove;
jt.removeAll = jt.deleteAll;
jt.setIn = l0;
jt.removeIn = jt.deleteIn = u0;
jt.update = c0;
jt.updateIn = f0;
jt.merge = jt.concat = RD;
jt.mergeWith = ND;
jt.mergeDeep = FD;
jt.mergeDeepWith = zD;
jt.mergeIn = h0;
jt.mergeDeepIn = m0;
jt.withMutations = gc;
jt.wasAltered = v0;
jt.asImmutable = bc;
jt["@@transducer/init"] = jt.asMutable = yc;
jt["@@transducer/step"] = function(e, t) {
  return e.set(t[0], t[1]);
};
jt["@@transducer/result"] = function(e) {
  return e.asImmutable();
};
var Fu = function(e, t) {
  this.ownerID = e, this.entries = t;
};
Fu.prototype.get = function(e, t, n, r) {
  for (var i = this.entries, o = 0, a = i.length; o < a; o++)
    if (pr(n, i[o][0]))
      return i[o][1];
  return r;
};
Fu.prototype.update = function(e, t, n, r, i, o, a) {
  for (var s = i === rt, l = this.entries, u = 0, c = l.length; u < c && !pr(r, l[u][0]); u++)
    ;
  var f = u < c;
  if (f ? l[u][1] === i : s)
    return this;
  if (Ir(a), (s || !f) && Ir(o), !(s && l.length === 1)) {
    if (!f && !s && l.length >= KY)
      return FY(e, l, r, i);
    var d = e && e === this.ownerID, p = d ? l : Ei(l);
    return f ? s ? u === c - 1 ? p.pop() : p[u] = p.pop() : p[u] = [r, i] : p.push([r, i]), d ? (this.entries = p, this) : new Fu(e, p);
  }
};
var qs = function(e, t, n) {
  this.ownerID = e, this.bitmap = t, this.nodes = n;
};
qs.prototype.get = function(e, t, n, r) {
  t === void 0 && (t = Jn(n));
  var i = 1 << ((e === 0 ? t : t >>> e) & qn), o = this.bitmap;
  return (o & i) === 0 ? r : this.nodes[LD(o & i - 1)].get(
    e + Rt,
    t,
    n,
    r
  );
};
qs.prototype.update = function(e, t, n, r, i, o, a) {
  n === void 0 && (n = Jn(r));
  var s = (t === 0 ? n : n >>> t) & qn, l = 1 << s, u = this.bitmap, c = (u & l) !== 0;
  if (!c && i === rt)
    return this;
  var f = LD(u & l - 1), d = this.nodes, p = c ? d[f] : void 0, h = y0(
    p,
    e,
    t + Rt,
    n,
    r,
    i,
    o,
    a
  );
  if (h === p)
    return this;
  if (!c && h && d.length >= UY)
    return LY(e, d, u, s, h);
  if (c && !h && d.length === 2 && c2(d[f ^ 1]))
    return d[f ^ 1];
  if (c && h && d.length === 1 && c2(h))
    return h;
  var v = e && e === this.ownerID, m = c ? h ? u : u ^ l : u | l, g = c ? h ? VD(d, f, h, v) : BY(d, f, v) : VY(d, f, h, v);
  return v ? (this.bitmap = m, this.nodes = g, this) : new qs(e, m, g);
};
var zu = function(e, t, n) {
  this.ownerID = e, this.count = t, this.nodes = n;
};
zu.prototype.get = function(e, t, n, r) {
  t === void 0 && (t = Jn(n));
  var i = (e === 0 ? t : t >>> e) & qn, o = this.nodes[i];
  return o ? o.get(e + Rt, t, n, r) : r;
};
zu.prototype.update = function(e, t, n, r, i, o, a) {
  n === void 0 && (n = Jn(r));
  var s = (t === 0 ? n : n >>> t) & qn, l = i === rt, u = this.nodes, c = u[s];
  if (l && !c)
    return this;
  var f = y0(
    c,
    e,
    t + Rt,
    n,
    r,
    i,
    o,
    a
  );
  if (f === c)
    return this;
  var d = this.count;
  if (!c)
    d++;
  else if (!f && (d--, d < qY))
    return zY(e, u, d, s);
  var p = e && e === this.ownerID, h = VD(u, s, f, p);
  return p ? (this.count = d, this.nodes = h, this) : new zu(e, d, h);
};
var Co = function(e, t, n) {
  this.ownerID = e, this.keyHash = t, this.entries = n, this._index = void 0;
};
Co.prototype._positionOf = function(e, t) {
  var n = this.entries, r = this._index;
  if (r === void 0 && t && n.length >= HY && (r = this._buildIndex()), r !== void 0) {
    var i = r[n0(e)];
    if (i !== void 0)
      for (var o = 0; o < i.length; o++) {
        var a = i[o];
        if (pr(e, n[a][0]))
          return a;
      }
    return -1;
  }
  for (var s = 0, l = n.length; s < l; s++)
    if (pr(e, n[s][0]))
      return s;
  return -1;
};
Co.prototype._buildIndex = function() {
  for (var e = /* @__PURE__ */ Object.create(null), t = this.entries, n = 0, r = t.length; n < r; n++) {
    var i = n0(t[n][0]), o = e[i];
    o !== void 0 ? o.push(n) : e[i] = [n];
  }
  return this._index = e, e;
};
Co.prototype.get = function(e, t, n, r) {
  var i = this._positionOf(n, !0);
  return i === -1 ? r : this.entries[i][1];
};
Co.prototype.update = function(e, t, n, r, i, o, a) {
  n === void 0 && (n = Jn(r));
  var s = i === rt;
  if (n !== this.keyHash)
    return s ? this : (Ir(a), Ir(o), b0(this, e, t, n, [r, i]));
  var l = this.entries, u = l.length, c = e && e === this.ownerID, f = this._positionOf(r, c), d = f === -1 ? u : f, p = f !== -1;
  if (p ? l[d][1] === i : s)
    return this;
  if (Ir(a), (s || !p) && Ir(o), s && u === 2)
    return new Yi(e, this.keyHash, l[d ^ 1]);
  var h = c ? l : Ei(l);
  if (p)
    s ? (d === u - 1 ? h.pop() : h[d] = h.pop(), c && (this._index = void 0)) : h[d] = [r, i];
  else if (h.push([r, i]), c && this._index !== void 0) {
    var v = n0(r), m = this._index[v];
    m !== void 0 ? m.push(u) : this._index[v] = [u];
  }
  return c ? (this.entries = h, this) : new Co(e, this.keyHash, h);
};
var Yi = function(e, t, n) {
  this.ownerID = e, this.keyHash = t, this.entry = n;
};
Yi.prototype.get = function(e, t, n, r) {
  return pr(n, this.entry[0]) ? this.entry[1] : r;
};
Yi.prototype.update = function(e, t, n, r, i, o, a) {
  var s = i === rt, l = pr(r, this.entry[0]);
  if (l ? i === this.entry[1] : s)
    return this;
  if (Ir(a), s) {
    Ir(o);
    return;
  }
  return l ? e && e === this.ownerID ? (this.entry[1] = i, this) : new Yi(e, this.keyHash, [r, i]) : (Ir(o), b0(this, e, t, Jn(r), [r, i]));
};
Fu.prototype.iterate = Co.prototype.iterate = function(e, t) {
  for (var n = this.entries, r = 0, i = n.length - 1; r <= i; r++)
    if (e(n[t ? i - r : r]) === !1)
      return !1;
};
qs.prototype.iterate = zu.prototype.iterate = function(e, t) {
  for (var n = this.nodes, r = 0, i = n.length - 1; r <= i; r++) {
    var o = n[t ? i - r : r];
    if (o && o.iterate(e, t) === !1)
      return !1;
  }
};
Yi.prototype.iterate = function(e, t) {
  return e(this.entry);
};
var jY = /* @__PURE__ */ (function(e) {
  function t(n, r, i) {
    this._type = r, this._reverse = i, this._stack = n._root && s2(n._root);
  }
  return e && (t.__proto__ = e), t.prototype = Object.create(e && e.prototype), t.prototype.constructor = t, t.prototype.next = function() {
    for (var n = this._type, r = this._stack; r; ) {
      var i = r.node, o = r.index++, a = void 0;
      if (i.entry) {
        if (o === 0)
          return vm(n, i.entry);
      } else if (i.entries) {
        if (a = i.entries.length - 1, o <= a)
          return vm(
            n,
            i.entries[this._reverse ? a - o : o]
          );
      } else if (a = i.nodes.length - 1, o <= a) {
        var s = i.nodes[this._reverse ? a - o : o];
        if (s) {
          if (s.entry)
            return vm(n, s.entry);
          r = this._stack = s2(s, r);
        }
        continue;
      }
      r = this._stack = this._stack.__prev;
    }
    return ar();
  }, t;
})(pt);
function vm(e, t) {
  return Vt(e, t[0], t[1]);
}
function s2(e, t) {
  return {
    node: e,
    index: 0,
    __prev: t
  };
}
function g0(e, t, n, r) {
  var i = Object.create(jt);
  return i.size = e, i._root = t, i.__ownerID = n, i.__hash = r, i.__altered = !1, i;
}
var l2;
function ei() {
  return l2 || (l2 = g0(0));
}
function u2(e, t, n) {
  var r, i;
  if (e._root) {
    var o = $g(), a = $g();
    if (r = y0(
      e._root,
      e.__ownerID,
      0,
      void 0,
      t,
      n,
      o,
      a
    ), !a.value)
      return e;
    i = e.size + (o.value ? n === rt ? -1 : 1 : 0);
  } else {
    if (n === rt)
      return e;
    i = 1, r = new Fu(e.__ownerID, [[t, n]]);
  }
  return e.__ownerID ? (e.size = i, e._root = r, e.__hash = void 0, e.__altered = !0, e) : r ? g0(i, r) : ei();
}
function y0(e, t, n, r, i, o, a, s) {
  return e ? e.update(
    t,
    n,
    r,
    i,
    o,
    a,
    s
  ) : o === rt ? e : (Ir(s), Ir(a), new Yi(t, r, [i, o]));
}
function c2(e) {
  return e.constructor === Yi || e.constructor === Co;
}
function b0(e, t, n, r, i) {
  if (e.keyHash === r)
    return new Co(t, r, [e.entry, i]);
  var o = (n === 0 ? e.keyHash : e.keyHash >>> n) & qn, a = (n === 0 ? r : r >>> n) & qn, s, l = o === a ? [b0(e, t, n + Rt, r, i)] : (s = new Yi(t, r, i), o < a ? [e, s] : [s, e]);
  return new qs(t, 1 << o | 1 << a, l);
}
function FY(e, t, n, r) {
  e || (e = new Gb());
  for (var i = new Yi(e, Jn(n), [n, r]), o = 0; o < t.length; o++) {
    var a = t[o];
    i = i.update(e, 0, void 0, a[0], a[1]);
  }
  return i;
}
function zY(e, t, n, r) {
  for (var i = 0, o = 0, a = new Array(n), s = 0, l = 1, u = t.length; s < u; s++, l <<= 1) {
    var c = t[s];
    c !== void 0 && s !== r && (i |= l, a[o++] = c);
  }
  return new qs(e, i, a);
}
function LY(e, t, n, r, i) {
  for (var o = 0, a = new Array(Cr), s = 0; n !== 0; s++, n >>>= 1)
    a[s] = n & 1 ? t[o++] : void 0;
  return a[r] = i, new zu(e, o + 1, a);
}
function LD(e) {
  return e -= e >> 1 & 1431655765, e = (e & 858993459) + (e >> 2 & 858993459), e = e + (e >> 4) & 252645135, e += e >> 8, e += e >> 16, e & 127;
}
function VD(e, t, n, r) {
  var i = r ? e : Ei(e);
  return i[t] = n, i;
}
function VY(e, t, n, r) {
  var i = e.length + 1;
  if (r && t + 1 === i)
    return e[t] = n, e;
  for (var o = new Array(i), a = 0, s = 0; s < i; s++)
    s === t ? (o[s] = n, a = -1) : o[s] = e[s + a];
  return o;
}
function BY(e, t, n) {
  var r = e.length - 1;
  if (n && t === r)
    return e.pop(), e;
  for (var i = new Array(r), o = 0, a = 0; a < r; a++)
    a === t && (o = 1), i[a] = e[a + o];
  return i;
}
var KY = Cr / 4, UY = Cr / 2, qY = Cr / 4, HY = 16, BD = "@@__IMMUTABLE_LIST__@@";
function KD(e) {
  return !!(e && e[BD]);
}
var Kp = /* @__PURE__ */ (function(e) {
  function t(n) {
    var r = If();
    if (n == null)
      return r;
    if (KD(n))
      return n;
    var i = e(n), o = i.size;
    return o === 0 ? r : (dr(o), o > 0 && o < Cr ? Lu(0, o, Rt, null, new wo(i.toArray())) : r.withMutations(function(a) {
      a.setSize(o), i.forEach(function(s, l) {
        return a.set(l, s);
      });
    }));
  }
  return e && (t.__proto__ = e), t.prototype = Object.create(e && e.prototype), t.prototype.constructor = t, t.of = function() {
    return this(arguments);
  }, t.prototype.toString = function() {
    return this.__toString("List [", "]");
  }, t.prototype.get = function(n, r) {
    if (n = Ao(this, n), n >= 0 && n < this.size) {
      n += this._origin;
      var i = UD(this, n);
      return i && i.array[n & qn];
    }
    return r;
  }, t.prototype.set = function(n, r) {
    return WY(this, n, r);
  }, t.prototype.remove = function(n) {
    return this.has(n) ? n === 0 ? this.shift() : n === this.size - 1 ? this.pop() : this.splice(n, 1) : this;
  }, t.prototype.insert = function(n, r) {
    return this.splice(n, 0, r);
  }, t.prototype.clear = function() {
    return this.size === 0 ? this : this.__ownerID ? (this.size = this._origin = this._capacity = 0, this._level = Rt, this._root = this._tail = this.__hash = void 0, this.__altered = !0, this) : If();
  }, t.prototype.push = function() {
    var n = arguments, r = this.size;
    return this.withMutations(function(i) {
      uo(i, 0, r + n.length);
      for (var o = 0; o < n.length; o++)
        i.set(r + o, n[o]);
    });
  }, t.prototype.pop = function() {
    return uo(this, 0, -1);
  }, t.prototype.unshift = function() {
    var n = arguments;
    return this.withMutations(function(r) {
      uo(r, -n.length);
      for (var i = 0; i < n.length; i++)
        r.set(i, n[i]);
    });
  }, t.prototype.shift = function() {
    return uo(this, 1);
  }, t.prototype.concat = function() {
    for (var n = arguments, r = [], i = 0; i < arguments.length; i++) {
      var o = n[i], a = e(
        typeof o != "string" && vD(o) ? o : [o]
      );
      a.size !== 0 && r.push(a);
    }
    return r.length === 0 ? this : this.size === 0 && !this.__ownerID && r.length === 1 ? this.constructor(r[0]) : this.withMutations(function(s) {
      r.forEach(function(l) {
        return l.forEach(function(u) {
          return s.push(u);
        });
      });
    });
  }, t.prototype.setSize = function(n) {
    return uo(this, 0, n);
  }, t.prototype.map = function(n, r) {
    var i = this;
    return this.withMutations(function(o) {
      for (var a = 0; a < i.size; a++)
        o.set(a, n.call(r, o.get(a), a, i));
    });
  }, t.prototype.slice = function(n, r) {
    var i = this.size;
    return Np(n, r, i) ? this : uo(
      this,
      hc(n, i),
      jp(r, i)
    );
  }, t.prototype.__iterator = function(n, r) {
    var i = r ? this.size : 0, o = f2(this, r);
    return new pt(function() {
      var a = o();
      return a === du ? ar() : Vt(n, r ? --i : i++, a);
    });
  }, t.prototype.__iterate = function(n, r) {
    for (var i = r ? this.size : 0, o = f2(this, r), a; (a = o()) !== du && n(a, r ? --i : i++, this) !== !1; )
      ;
    return i;
  }, t.prototype.__ensureOwner = function(n) {
    return n === this.__ownerID ? this : n ? Lu(
      this._origin,
      this._capacity,
      this._level,
      this._root,
      this._tail,
      n,
      this.__hash
    ) : this.size === 0 ? If() : (this.__ownerID = n, this.__altered = !1, this);
  }, t;
})(Ua);
Kp.isList = KD;
var dn = Kp.prototype;
dn[BD] = !0;
dn[pc] = dn.remove;
dn.merge = dn.concat;
dn.setIn = l0;
dn.deleteIn = dn.removeIn = u0;
dn.update = c0;
dn.updateIn = f0;
dn.mergeIn = h0;
dn.mergeDeepIn = m0;
dn.withMutations = gc;
dn.wasAltered = v0;
dn.asImmutable = bc;
dn["@@transducer/init"] = dn.asMutable = yc;
dn["@@transducer/step"] = function(e, t) {
  return e.push(t);
};
dn["@@transducer/result"] = function(e) {
  return e.asImmutable();
};
var wo = function(e, t) {
  this.array = e, this.ownerID = t;
};
wo.prototype.removeBefore = function(e, t, n) {
  if (n === t ? 1 << t : this.array.length === 0)
    return this;
  var r = n >>> t & qn;
  if (r >= this.array.length)
    return new wo([], e);
  var i = r === 0, o;
  if (t > 0) {
    var a = this.array[r];
    if (o = a && a.removeBefore(e, t - Rt, n), o === a && i)
      return this;
  }
  if (i && !o)
    return this;
  var s = Hs(this, e);
  if (!i)
    for (var l = 0; l < r; l++)
      s.array[l] = void 0;
  return o && (s.array[r] = o), s;
};
wo.prototype.removeAfter = function(e, t, n) {
  if (n === (t ? 1 << t : 0) || this.array.length === 0)
    return this;
  var r = n - 1 >>> t & qn;
  if (r >= this.array.length)
    return this;
  var i;
  if (t > 0) {
    var o = this.array[r];
    if (i = o && o.removeAfter(e, t - Rt, n), i === o && r === this.array.length - 1)
      return this;
  }
  var a = Hs(this, e);
  return a.array.splice(r + 1), i && (a.array[r] = i), a;
};
var du = {};
function f2(e, t) {
  var n = e._origin, r = e._capacity, i = Vu(r), o = e._tail;
  return a(e._root, e._level, 0);
  function a(u, c, f) {
    return c === 0 ? s(u, f) : l(u, c, f);
  }
  function s(u, c) {
    var f = c === i ? o && o.array : u && u.array, d = c > n ? 0 : n - c, p = r - c;
    return p > Cr && (p = Cr), function() {
      if (d === p)
        return du;
      var h = t ? --p : d++;
      return f && f[h];
    };
  }
  function l(u, c, f) {
    var d, p = u && u.array, h = f > n ? 0 : n - f >> c, v = (r - f >> c) + 1;
    return v > Cr && (v = Cr), function() {
      for (; ; ) {
        if (d) {
          var m = d();
          if (m !== du)
            return m;
          d = null;
        }
        if (h === v)
          return du;
        var g = t ? --v : h++;
        d = a(
          p && p[g],
          c - Rt,
          f + (g << c)
        );
      }
    };
  }
}
function Lu(e, t, n, r, i, o, a) {
  var s = Object.create(dn);
  return s.size = t - e, s._origin = e, s._capacity = t, s._level = n, s._root = r, s._tail = i, s.__ownerID = o, s.__hash = a, s.__altered = !1, s;
}
var d2;
function If() {
  return d2 || (d2 = Lu(0, 0, Rt));
}
function WY(e, t, n) {
  if (t = Ao(e, t), t !== t)
    return e;
  if (t >= e.size || t < 0)
    return e.withMutations(function(a) {
      t < 0 ? uo(a, t).set(0, n) : uo(a, 0, t + 1).set(t, n);
    });
  t += e._origin;
  var r = e._tail, i = e._root, o = $g();
  return t >= Vu(e._capacity) ? r = Dg(r, e.__ownerID, 0, t, n, o) : i = Dg(
    i,
    e.__ownerID,
    e._level,
    t,
    n,
    o
  ), o.value ? e.__ownerID ? (e._root = i, e._tail = r, e.__hash = void 0, e.__altered = !0, e) : Lu(e._origin, e._capacity, e._level, i, r) : e;
}
function Dg(e, t, n, r, i, o) {
  var a = r >>> n & qn, s = e && a < e.array.length;
  if (!s && i === void 0)
    return e;
  var l;
  if (n > 0) {
    var u = e && e.array[a], c = Dg(
      u,
      t,
      n - Rt,
      r,
      i,
      o
    );
    return c === u ? e : (l = Hs(e, t), l.array[a] = c, l);
  }
  return s && e.array[a] === i ? e : (o && Ir(o), l = Hs(e, t), i === void 0 && a === l.array.length - 1 ? l.array.pop() : l.array[a] = i, l);
}
function Hs(e, t) {
  return t && e && t === e.ownerID ? e : new wo(e ? e.array.slice() : [], t);
}
function UD(e, t) {
  if (t >= Vu(e._capacity))
    return e._tail;
  if (t < 1 << e._level + Rt) {
    for (var n = e._root, r = e._level; n && r > 0; )
      n = n.array[t >>> r & qn], r -= Rt;
    return n;
  }
}
function ZY(e, t, n) {
  var r = e._origin + (t === void 0 ? 0 : t), i = n === void 0 ? e._capacity : n < 0 ? e._capacity + n : e._origin + n;
  if (Number.isFinite(i) && i > Xc || Number.isFinite(r) && r < -Xc || Number.isFinite(i) && Number.isFinite(r) && i - r > Xc)
    throw new RangeError(
      "Invalid List size: a List cannot hold more than " + Xc + " (2 ** 30) values."
    );
}
function uo(e, t, n) {
  ZY(e, t, n), t !== void 0 && (t |= 0), n !== void 0 && (n |= 0);
  var r = e.__ownerID || new Gb(), i = e._origin, o = e._capacity, a = i + t, s = n === void 0 ? o : n < 0 ? o + n : i + n;
  if (a === i && s === o)
    return e;
  if (a >= s)
    return e.clear();
  for (var l = e._level, u = e._root, c = 0; a + c < 0; )
    u = new wo(
      u && u.array.length ? [void 0, u] : [],
      r
    ), l += Rt, c += p2(l);
  c && (a += c, i += c, s += c, o += c);
  for (var f = Vu(o), d = Vu(s); d >= p2(l + Rt); )
    u = new wo(
      u && u.array.length ? [u] : [],
      r
    ), l += Rt;
  var p = e._tail, h = d < f ? UD(e, s - 1) : d > f ? new wo([], r) : p;
  if (p && d > f && a < o && p.array.length) {
    u = Hs(u, r);
    for (var v = u, m = l; m > Rt; m -= Rt) {
      var g = f >>> m & qn;
      v = v.array[g] = Hs(v.array[g], r);
    }
    v.array[f >>> Rt & qn] = p;
  }
  if (s < o && (h = h && h.removeAfter(r, 0, s)), a >= d)
    a -= d, s -= d, l = Rt, u = null, h = h && h.removeBefore(r, 0, a);
  else if (a > i || d < f) {
    for (c = 0; u; ) {
      var _ = a >>> l & qn;
      if (_ !== d >>> l & qn)
        break;
      _ && (c += (1 << l) * _), l -= Rt, u = u.array[_];
    }
    u && a > i && (u = u.removeBefore(r, l, a - c)), u && d < f && (u = u.removeAfter(
      r,
      l,
      d - c
    )), c && (a -= c, s -= c);
  }
  return e.__ownerID ? (e.size = s - a, e._origin = a, e._capacity = s, e._level = l, e._root = u, e._tail = h, e.__hash = void 0, e.__altered = !0, e) : Lu(a, s, l, u, h);
}
function Vu(e) {
  return e < Cr ? 0 : e - 1 >>> Rt << Rt;
}
var Xc = Math.pow(2, 30);
function p2(e) {
  return e < 31 ? 1 << e : Math.pow(2, e);
}
var Qi = /* @__PURE__ */ (function(e) {
  function t(n) {
    return n == null ? Yl() : _D(n) ? n : Yl().withMutations(function(r) {
      var i = Kr(n);
      dr(i.size), i.forEach(function(o, a) {
        return r.set(a, o);
      });
    });
  }
  return e && (t.__proto__ = e), t.prototype = Object.create(e && e.prototype), t.prototype.constructor = t, t.of = function() {
    return this(arguments);
  }, t.prototype.toString = function() {
    return this.__toString("OrderedMap {", "}");
  }, t.prototype.get = function(n, r) {
    var i = this._map.get(n);
    return i !== void 0 ? this._list.get(i)[1] : r;
  }, t.prototype.clear = function() {
    return this.size === 0 ? this : this.__ownerID ? (this.size = 0, this._map.clear(), this._list.clear(), this.__altered = !0, this) : Yl();
  }, t.prototype.set = function(n, r) {
    return m2(this, n, r);
  }, t.prototype.remove = function(n) {
    return m2(this, n, rt);
  }, t.prototype.__iterate = function(n, r) {
    var i = this;
    return this._list.__iterate(
      function(o) {
        return o && n(o[1], o[0], i);
      },
      r
    );
  }, t.prototype.__iterator = function(n, r) {
    return this._list.fromEntrySeq().__iterator(n, r);
  }, t.prototype.__ensureOwner = function(n) {
    if (n === this.__ownerID)
      return this;
    var r = this._map.__ensureOwner(n), i = this._list.__ensureOwner(n);
    return n ? _0(r, i, n, this.__hash) : this.size === 0 ? Yl() : (this.__ownerID = n, this.__altered = !1, this._map = r, this._list = i, this);
  }, t;
})(_l);
Qi.isOrderedMap = _D;
Qi.prototype[vl] = !0;
Qi.prototype[pc] = Qi.prototype.remove;
function _0(e, t, n, r) {
  var i = Object.create(Qi.prototype);
  return i.size = e ? e.size : 0, i._map = e, i._list = t, i.__ownerID = n, i.__hash = r, i.__altered = !1, i;
}
var h2;
function Yl() {
  return h2 || (h2 = _0(ei(), If()));
}
function m2(e, t, n) {
  var r = e._map, i = e._list, o = r.get(t), a = o !== void 0, s, l;
  if (n === rt) {
    if (!a)
      return e;
    i.size >= Cr && i.size >= r.size * 2 ? (l = i.filter(function(u, c) {
      return u !== void 0 && o !== c;
    }), s = l.toKeyedSeq().map(function(u) {
      return u[0];
    }).flip().toMap(), e.__ownerID && (s.__ownerID = l.__ownerID = e.__ownerID)) : (s = r.remove(t), l = o === i.size - 1 ? i.pop() : i.set(o, void 0));
  } else if (a) {
    if (n === i.get(o)[1])
      return e;
    s = r, l = i.set(o, [t, n]);
  } else
    s = r.set(t, i.size), l = i.set(i.size, [t, n]);
  return e.__ownerID ? (e.size = s.size, e._map = s, e._list = l, e.__hash = void 0, e.__altered = !0, e) : _0(s, l);
}
var qD = "@@__IMMUTABLE_STACK__@@";
function Cg(e) {
  return !!(e && e[qD]);
}
var w0 = /* @__PURE__ */ (function(e) {
  function t(n) {
    return n == null ? ef() : Cg(n) ? n : ef().pushAll(n);
  }
  return e && (t.__proto__ = e), t.prototype = Object.create(e && e.prototype), t.prototype.constructor = t, t.of = function() {
    return this(arguments);
  }, t.prototype.toString = function() {
    return this.__toString("Stack [", "]");
  }, t.prototype.get = function(n, r) {
    var i = this._head;
    for (n = Ao(this, n); i && n--; )
      i = i.next;
    return i ? i.value : r;
  }, t.prototype.peek = function() {
    return this._head && this._head.value;
  }, t.prototype.push = function() {
    var n = arguments;
    if (arguments.length === 0)
      return this;
    for (var r = this.size + arguments.length, i = this._head, o = arguments.length - 1; o >= 0; o--)
      i = {
        value: n[o],
        next: i
      };
    return this.__ownerID ? (this.size = r, this._head = i, this.__hash = void 0, this.__altered = !0, this) : Ql(r, i);
  }, t.prototype.pushAll = function(n) {
    if (n = e(n), n.size === 0)
      return this;
    if (this.size === 0 && Cg(n))
      return n;
    dr(n.size);
    var r = this.size, i = this._head;
    return n.__iterate(function(o) {
      r++, i = {
        value: o,
        next: i
      };
    }, !0), this.__ownerID ? (this.size = r, this._head = i, this.__hash = void 0, this.__altered = !0, this) : Ql(r, i);
  }, t.prototype.pop = function() {
    return this.slice(1);
  }, t.prototype.clear = function() {
    return this.size === 0 ? this : this.__ownerID ? (this.size = 0, this._head = void 0, this.__hash = void 0, this.__altered = !0, this) : ef();
  }, t.prototype.slice = function(n, r) {
    if (Np(n, r, this.size))
      return this;
    var i = hc(n, this.size), o = jp(r, this.size);
    if (o !== this.size)
      return e.prototype.slice.call(this, n, r);
    for (var a = this.size - i, s = this._head; i--; )
      s = s.next;
    return this.__ownerID ? (this.size = a, this._head = s, this.__hash = void 0, this.__altered = !0, this) : Ql(a, s);
  }, t.prototype.__ensureOwner = function(n) {
    return n === this.__ownerID ? this : n ? Ql(this.size, this._head, n, this.__hash) : this.size === 0 ? ef() : (this.__ownerID = n, this.__altered = !1, this);
  }, t.prototype.__iterate = function(n, r) {
    var i = this;
    if (r)
      return new Da(this.toArray()).__iterate(
        function(s, l) {
          return n(s, l, i);
        },
        r
      );
    for (var o = 0, a = this._head; a && n(a.value, o++, this) !== !1; )
      a = a.next;
    return o;
  }, t.prototype.__iterator = function(n, r) {
    if (r)
      return new Da(this.toArray()).__iterator(n, r);
    var i = 0, o = this._head;
    return new pt(function() {
      if (o) {
        var a = o.value;
        return o = o.next, Vt(n, i++, a);
      }
      return ar();
    });
  }, t;
})(Ua);
w0.isStack = Cg;
var Wn = w0.prototype;
Wn[qD] = !0;
Wn.shift = Wn.pop;
Wn.unshift = Wn.push;
Wn.unshiftAll = Wn.pushAll;
Wn.withMutations = gc;
Wn.wasAltered = v0;
Wn.asImmutable = bc;
Wn["@@transducer/init"] = Wn.asMutable = yc;
Wn["@@transducer/step"] = function(e, t) {
  return e.unshift(t);
};
Wn["@@transducer/result"] = function(e) {
  return e.asImmutable();
};
function Ql(e, t, n, r) {
  var i = Object.create(Wn);
  return i.size = e, i._head = t, i.__ownerID = n, i.__hash = r, i.__altered = !1, i;
}
var v2;
function ef() {
  return v2 || (v2 = Ql(0));
}
var HD = "@@__IMMUTABLE_SET__@@";
function x0(e) {
  return !!(e && e[HD]);
}
function WD(e) {
  return x0(e) && oi(e);
}
function ZD(e, t) {
  if (e === t)
    return !0;
  if (!or(t) || e.size !== void 0 && t.size !== void 0 && e.size !== t.size || e.__hash !== void 0 && t.__hash !== void 0 && e.__hash !== t.__hash || Ft(e) !== Ft(t) || nr(e) !== nr(t) || oi(e) !== oi(t))
    return !1;
  if (e.size === 0 && t.size === 0)
    return !0;
  var n = !Fp(e);
  if (oi(e)) {
    var r = e.entries();
    return t.every(function(l, u) {
      var c = r.next().value;
      return c && pr(c[1], l) && (n || pr(c[0], u));
    }) && r.next().done;
  }
  var i = !1;
  if (e.size === void 0)
    if (t.size === void 0)
      typeof e.cacheResult == "function" && e.cacheResult();
    else {
      i = !0;
      var o = e;
      e = t, t = o;
    }
  var a = !0, s = t.__iterate(function(l, u) {
    if (n ? !e.has(l) : i ? !pr(l, e.get(u, rt)) : !pr(e.get(u, rt), l))
      return a = !1, !1;
  });
  return a && e.size === s;
}
function qa(e, t) {
  var n = function(r) {
    e.prototype[r] = t[r];
  };
  return Object.keys(t).forEach(n), Object.getOwnPropertySymbols && Object.getOwnPropertySymbols(t).forEach(n), e;
}
function Nd(e) {
  if (!e || typeof e != "object")
    return e;
  if (!or(e)) {
    if (!Do(e))
      return e;
    e = br(e);
  }
  if (Ft(e)) {
    var t = {};
    return e.__iterate(function(r, i) {
      vc(i) || (t[i] = Nd(r));
    }), t;
  }
  var n = [];
  return e.__iterate(function(r) {
    n.push(Nd(r));
  }), n;
}
var Up = /* @__PURE__ */ (function(e) {
  function t(n) {
    return n == null ? Jl() : x0(n) && !oi(n) ? n : Jl().withMutations(function(r) {
      var i = e(n);
      dr(i.size), i.forEach(function(o) {
        return r.add(o);
      });
    });
  }
  return e && (t.__proto__ = e), t.prototype = Object.create(e && e.prototype), t.prototype.constructor = t, t.of = function() {
    return this(arguments);
  }, t.fromKeys = function(n) {
    return this(Kr(n).keySeq());
  }, t.intersect = function(n) {
    return n = rn(n).toArray(), n.length ? Tn.intersect.apply(t(n.pop()), n) : Jl();
  }, t.union = function(n) {
    return n = rn(n).toArray(), n.length ? Tn.union.apply(t(n.pop()), n) : Jl();
  }, t.prototype.toString = function() {
    return this.__toString("Set {", "}");
  }, t.prototype.has = function(n) {
    return this._map.has(n);
  }, t.prototype.add = function(n) {
    return tf(this, this._map.set(n, n));
  }, t.prototype.remove = function(n) {
    return tf(this, this._map.remove(n));
  }, t.prototype.clear = function() {
    return tf(this, this._map.clear());
  }, t.prototype.map = function(n, r) {
    var i = this, o = !1, a = tf(
      this,
      this._map.mapEntries(function(s) {
        var l = s[1], u = n.call(r, l, l, i);
        return u !== l && (o = !0), [u, u];
      }, r)
    );
    return o ? a : this;
  }, t.prototype.union = function() {
    for (var n = [], r = arguments.length; r--; )
      n[r] = arguments[r];
    return n = n.filter(function(i) {
      return i.size !== 0;
    }), n.length === 0 ? this : this.size === 0 && !this.__ownerID && n.length === 1 ? this.constructor(n[0]) : this.withMutations(function(i) {
      for (var o = 0; o < n.length; o++)
        typeof n[o] == "string" ? i.add(n[o]) : e(n[o]).forEach(function(a) {
          return i.add(a);
        });
    });
  }, t.prototype.intersect = function() {
    for (var n = [], r = arguments.length; r--; )
      n[r] = arguments[r];
    if (n.length === 0)
      return this;
    n = n.map(function(o) {
      return e(o);
    });
    var i = [];
    return this.forEach(function(o) {
      n.every(function(a) {
        return a.includes(o);
      }) || i.push(o);
    }), this.withMutations(function(o) {
      i.forEach(function(a) {
        o.remove(a);
      });
    });
  }, t.prototype.subtract = function() {
    for (var n = [], r = arguments.length; r--; )
      n[r] = arguments[r];
    if (n.length === 0)
      return this;
    n = n.map(function(o) {
      return e(o);
    });
    var i = [];
    return this.forEach(function(o) {
      n.some(function(a) {
        return a.includes(o);
      }) && i.push(o);
    }), this.withMutations(function(o) {
      i.forEach(function(a) {
        o.remove(a);
      });
    });
  }, t.prototype.sort = function(n) {
    return Bu(Us(this, n));
  }, t.prototype.sortBy = function(n, r) {
    return Bu(Us(this, r, n));
  }, t.prototype.wasAltered = function() {
    return this._map.wasAltered();
  }, t.prototype.__iterate = function(n, r) {
    var i = this;
    return this._map.__iterate(function(o) {
      return n(o, o, i);
    }, r);
  }, t.prototype.__iterator = function(n, r) {
    return this._map.__iterator(n, r);
  }, t.prototype.__ensureOwner = function(n) {
    if (n === this.__ownerID)
      return this;
    var r = this._map.__ensureOwner(n);
    return n ? this.__make(r, n) : this.size === 0 ? this.__empty() : (this.__ownerID = n, this._map = r, this);
  }, t;
})(hl);
Up.isSet = x0;
var Tn = Up.prototype;
Tn[HD] = !0;
Tn[pc] = Tn.remove;
Tn.merge = Tn.concat = Tn.union;
Tn.withMutations = gc;
Tn.asImmutable = bc;
Tn["@@transducer/init"] = Tn.asMutable = yc;
Tn["@@transducer/step"] = function(e, t) {
  return e.add(t);
};
Tn["@@transducer/result"] = function(e) {
  return e.asImmutable();
};
Tn.__empty = Jl;
Tn.__make = GD;
function tf(e, t) {
  return e.__ownerID ? (e.size = t.size, e._map = t, e) : t === e._map ? e : t.size === 0 ? e.__empty() : e.__make(t);
}
function GD(e, t) {
  var n = Object.create(Tn);
  return n.size = e ? e.size : 0, n._map = e, n.__ownerID = t, n;
}
var g2;
function Jl() {
  return g2 || (g2 = GD(ei()));
}
var GY = /* @__PURE__ */ (function(e) {
  function t(n, r, i) {
    if (!(this instanceof t))
      return new t(n, r, i);
    if (s0(i !== 0, "Cannot step a Range by 0"), n = n || 0, r === void 0 && (r = 1 / 0), i = i === void 0 ? 1 : Math.abs(i), r < n && (i = -i), this._start = n, this._end = r, this._step = i, this.size = Math.max(0, Math.ceil((r - n) / i - 1) + 1), this.size === 0) {
      if (gm)
        return gm;
      gm = this;
    }
  }
  return e && (t.__proto__ = e), t.prototype = Object.create(e && e.prototype), t.prototype.constructor = t, t.prototype.toString = function() {
    return this.size === 0 ? "Range []" : "Range [ " + this._start + "..." + this._end + (this._step !== 1 ? " by " + this._step : "") + " ]";
  }, t.prototype.get = function(n, r) {
    return this.has(n) ? this._start + Ao(this, n) * this._step : r;
  }, t.prototype.includes = function(n) {
    var r = (n - this._start) / this._step;
    return r >= 0 && r < this.size && r === Math.floor(r);
  }, t.prototype.slice = function(n, r) {
    return Np(n, r, this.size) ? this : (n = hc(n, this.size), r = jp(r, this.size), r <= n ? new t(0, 0) : new t(
      this.get(n, this._end),
      this.get(r, this._end),
      this._step
    ));
  }, t.prototype.indexOf = function(n) {
    var r = n - this._start;
    if (r % this._step === 0) {
      var i = r / this._step;
      if (i >= 0 && i < this.size)
        return i;
    }
    return -1;
  }, t.prototype.lastIndexOf = function(n) {
    return this.indexOf(n);
  }, t.prototype.__iterate = function(n, r) {
    for (var i = this.size, o = this._step, a = r ? this._start + (i - 1) * o : this._start, s = 0; s !== i && n(a, r ? i - ++s : s++, this) !== !1; )
      a += r ? -o : o;
    return s;
  }, t.prototype.__iterator = function(n, r) {
    var i = this.size, o = this._step, a = r ? this._start + (i - 1) * o : this._start, s = 0;
    return new pt(function() {
      if (s === i)
        return ar();
      var l = a;
      return a += r ? -o : o, Vt(n, r ? i - ++s : s++, l);
    });
  }, t.prototype.equals = function(n) {
    return n instanceof t ? this._start === n._start && this._end === n._end && this._step === n._step : ZD(this, n);
  }, t;
})(di), gm;
function YD(e, t, n) {
  for (var r = DD(t), i = 0; i !== r.length; )
    if (e = CD(e, r[i++], rt), e === rt)
      return n;
  return e;
}
function QD(e, t) {
  return YD(this, e, t);
}
function YY(e, t) {
  return YD(e, t, rt) !== rt;
}
function QY(e) {
  return YY(this, e);
}
function JD() {
  dr(this.size);
  var e = {};
  return this.__iterate(function(t, n) {
    vc(n) || (e[n] = t);
  }), e;
}
rn.isIterable = or;
rn.isKeyed = Ft;
rn.isIndexed = nr;
rn.isAssociative = Fp;
rn.isOrdered = oi;
rn.Iterator = pt;
qa(rn, {
  toArray: function() {
    dr(this.size);
    var e = new Array(this.size || 0), t = Ft(this), n = 0;
    return this.__iterate(function(r, i) {
      e[n++] = t ? [i, r] : r;
    }), e;
  },
  toIndexedSeq: function() {
    return new xD(this);
  },
  toJS: function() {
    return Nd(this);
  },
  toKeyedSeq: function() {
    return new Bp(this, !0);
  },
  toMap: function() {
    return _l(this.toKeyedSeq());
  },
  toObject: JD,
  toOrderedMap: function() {
    return Qi(this.toKeyedSeq());
  },
  toOrderedSet: function() {
    return Bu(Ft(this) ? this.valueSeq() : this);
  },
  toSet: function() {
    return Up(Ft(this) ? this.valueSeq() : this);
  },
  toSetSeq: function() {
    return new ED(this);
  },
  toSeq: function() {
    return nr(this) ? this.toIndexedSeq() : Ft(this) ? this.toKeyedSeq() : this.toSetSeq();
  },
  toStack: function() {
    return w0(Ft(this) ? this.valueSeq() : this);
  },
  toList: function() {
    return Kp(Ft(this) ? this.valueSeq() : this);
  },
  toString: function() {
    return "[Collection]";
  },
  __toString: function(e, t) {
    return this.size === 0 ? e + t : e + " " + this.toSeq().map(this.__toStringMapper).join(", ") + " " + t;
  },
  concat: function() {
    for (var e = [], t = arguments.length; t--; )
      e[t] = arguments[t];
    return xt(this, $Y(this, e));
  },
  includes: function(e) {
    return this.some(function(t) {
      return pr(t, e);
    });
  },
  entries: function() {
    return this.__iterator(zr);
  },
  every: function(e, t) {
    dr(this.size);
    var n = !0;
    return this.__iterate(function(r, i, o) {
      if (!e.call(t, r, i, o))
        return n = !1, !1;
    }), n;
  },
  filter: function(e, t) {
    return xt(this, TD(this, e, t, !0));
  },
  partition: function(e, t) {
    return EY(this, e, t);
  },
  find: function(e, t, n) {
    var r = this.findEntry(e, t);
    return r ? r[1] : n;
  },
  forEach: function(e, t) {
    return dr(this.size), this.__iterate(t ? e.bind(t) : e);
  },
  join: function(e) {
    dr(this.size), e = e !== void 0 ? "" + e : ",";
    var t = "", n = !0;
    return this.__iterate(function(r) {
      n ? n = !1 : t += e, t += r != null ? r.toString() : "";
    }), t;
  },
  keys: function() {
    return this.__iterator(mc);
  },
  map: function(e, t) {
    return xt(this, kD(this, e, t));
  },
  reduce: function(e, t, n) {
    return y2(
      this,
      e,
      t,
      n,
      arguments.length < 2,
      !1
    );
  },
  reduceRight: function(e, t, n) {
    return y2(
      this,
      e,
      t,
      n,
      arguments.length < 2,
      !0
    );
  },
  reverse: function() {
    return xt(this, r0(this, !0));
  },
  slice: function(e, t) {
    return xt(this, i0(this, e, t, !0));
  },
  some: function(e, t) {
    dr(this.size);
    var n = !1;
    return this.__iterate(function(r, i, o) {
      if (e.call(t, r, i, o))
        return n = !0, !1;
    }), n;
  },
  sort: function(e) {
    return xt(this, Us(this, e));
  },
  values: function() {
    return this.__iterator(si);
  },
  butLast: function() {
    return this.slice(0, -1);
  },
  isEmpty: function() {
    return this.size !== void 0 ? this.size === 0 : !this.some(function() {
      return !0;
    });
  },
  count: function(e, t) {
    return Ks(
      e ? this.toSeq().filter(e, t) : this
    );
  },
  countBy: function(e, t) {
    return wY(this, e, t);
  },
  equals: function(e) {
    return ZD(this, e);
  },
  entrySeq: function() {
    var e = this;
    if (e._cache)
      return new Da(e._cache);
    var t = e.toSeq().map(XY).toIndexedSeq();
    return t.fromEntrySeq = function() {
      return e.toSeq();
    }, t;
  },
  filterNot: function(e, t) {
    return this.filter(ym(e), t);
  },
  findEntry: function(e, t, n) {
    var r = n;
    return this.__iterate(function(i, o, a) {
      if (e.call(t, i, o, a))
        return r = [o, i], !1;
    }), r;
  },
  findKey: function(e, t) {
    var n = this.findEntry(e, t);
    return n && n[0];
  },
  findLast: function(e, t, n) {
    return this.toKeyedSeq().reverse().find(e, t, n);
  },
  findLastEntry: function(e, t, n) {
    return this.toKeyedSeq().reverse().findEntry(e, t, n);
  },
  findLastKey: function(e, t) {
    return this.toKeyedSeq().reverse().findKey(e, t);
  },
  first: function(e) {
    return this.find(sD, null, e);
  },
  flatMap: function(e, t) {
    return xt(this, kY(this, e, t));
  },
  flatten: function(e) {
    return xt(this, PD(this, e, !0));
  },
  fromEntrySeq: function() {
    return new SD(this);
  },
  get: function(e, t) {
    return this.find(function(n, r) {
      return pr(r, e);
    }, void 0, t);
  },
  getIn: QD,
  groupBy: function(e, t) {
    return xY(this, e, t);
  },
  has: function(e) {
    return this.get(e, rt) !== rt;
  },
  hasIn: QY,
  isSubset: function(e) {
    return e = typeof e.includes == "function" ? e : rn(e), this.every(function(t) {
      return e.includes(t);
    });
  },
  isSuperset: function(e) {
    return e = typeof e.isSubset == "function" ? e : rn(e), e.isSubset(this);
  },
  keyOf: function(e) {
    return this.findKey(function(t) {
      return pr(t, e);
    });
  },
  keySeq: function() {
    return this.toSeq().map(JY).toIndexedSeq();
  },
  last: function(e) {
    return this.toSeq().reverse().first(e);
  },
  lastKeyOf: function(e) {
    return this.toKeyedSeq().reverse().keyOf(e);
  },
  max: function(e) {
    return Qc(this, e);
  },
  maxBy: function(e, t) {
    return Qc(this, t, e);
  },
  min: function(e) {
    return Qc(
      this,
      e ? b2(e) : w2
    );
  },
  minBy: function(e, t) {
    return Qc(
      this,
      t ? b2(t) : w2,
      e
    );
  },
  rest: function() {
    return this.slice(1);
  },
  skip: function(e) {
    return e === 0 ? this : this.slice(Math.max(0, e));
  },
  skipLast: function(e) {
    return e === 0 ? this : this.slice(0, -Math.max(0, e));
  },
  skipWhile: function(e, t) {
    return xt(this, OD(this, e, t, !0));
  },
  skipUntil: function(e, t) {
    return this.skipWhile(ym(e), t);
  },
  sortBy: function(e, t) {
    return xt(this, Us(this, t, e));
  },
  take: function(e) {
    return this.slice(0, Math.max(0, e));
  },
  takeLast: function(e) {
    return this.slice(-Math.max(0, e));
  },
  takeWhile: function(e, t) {
    return xt(this, SY(this, e, t));
  },
  takeUntil: function(e, t) {
    return this.takeWhile(ym(e), t);
  },
  update: function(e) {
    return e(this);
  },
  valueSeq: function() {
    return this.toIndexedSeq();
  },
  hashCode: function() {
    return this.__hash || (this.__hash = eQ(this));
  }
});
var Nn = rn.prototype;
Nn[cD] = !0;
Nn[zp] = Nn.values;
Nn.toJSON = Nn.toArray;
Nn.__toStringMapper = ju;
Nn.inspect = Nn.toSource = function() {
  return this.toString();
};
Nn.chain = Nn.flatMap;
Nn.contains = Nn.includes;
qa(Kr, {
  flip: function() {
    return xt(this, $D(this));
  },
  mapEntries: function(e, t) {
    var n = this, r = 0;
    return xt(
      this,
      this.toSeq().map(function(i, o) {
        return e.call(t, [o, i], r++, n);
      }).fromEntrySeq()
    );
  },
  mapKeys: function(e, t) {
    var n = this;
    return xt(
      this,
      this.toSeq().flip().map(function(r, i) {
        return e.call(t, r, i, n);
      }).flip()
    );
  }
});
var _c = Kr.prototype;
_c[fD] = !0;
_c[zp] = Nn.entries;
_c.toJSON = JD;
_c.__toStringMapper = function(e, t) {
  return ju(t) + ": " + ju(e);
};
qa(Ua, {
  toKeyedSeq: function() {
    return new Bp(this, !1);
  },
  filter: function(e, t) {
    return xt(this, TD(this, e, t, !1));
  },
  findIndex: function(e, t) {
    var n = this.findEntry(e, t);
    return n ? n[0] : -1;
  },
  indexOf: function(e) {
    var t = this.keyOf(e);
    return t === void 0 ? -1 : t;
  },
  lastIndexOf: function(e) {
    var t = this.lastKeyOf(e);
    return t === void 0 ? -1 : t;
  },
  reverse: function() {
    return xt(this, r0(this, !1));
  },
  slice: function(e, t) {
    return xt(this, i0(this, e, t, !1));
  },
  splice: function(e, t) {
    var n = arguments.length;
    if (t = Math.max(t || 0, 0), n === 0 || n === 2 && !t)
      return this;
    e = hc(e, e < 0 ? this.count() : this.size);
    var r = this.slice(0, e);
    return xt(
      this,
      n === 1 ? r : r.concat(Ei(arguments, 2), this.slice(e + t))
    );
  },
  findLastIndex: function(e, t) {
    var n = this.findLastEntry(e, t);
    return n ? n[0] : -1;
  },
  first: function(e) {
    return this.get(0, e);
  },
  flatten: function(e) {
    return xt(this, PD(this, e, !1));
  },
  get: function(e, t) {
    return e = Ao(this, e), e < 0 || this.size === 1 / 0 || this.size !== void 0 && e > this.size ? t : this.find(function(n, r) {
      return r === e;
    }, void 0, t);
  },
  has: function(e) {
    return e = Ao(this, e), e >= 0 && (this.size !== void 0 ? this.size === 1 / 0 || e < this.size : this.indexOf(e) !== -1);
  },
  interpose: function(e) {
    return xt(this, TY(this, e));
  },
  interleave: function() {
    var e = [this].concat(Ei(arguments)), t = Jc(this.toSeq(), di.of, e), n = t.flatten(!0);
    return t.size && (n.size = t.size * e.length), xt(this, n);
  },
  keySeq: function() {
    return GY(0, this.size);
  },
  last: function(e) {
    return this.get(-1, e);
  },
  skipWhile: function(e, t) {
    return xt(this, OD(this, e, t, !1));
  },
  zip: function() {
    var e = [this].concat(Ei(arguments));
    return xt(this, Jc(this, _2, e));
  },
  zipAll: function() {
    var e = [this].concat(Ei(arguments));
    return xt(this, Jc(this, _2, e, !0));
  },
  zipWith: function(e) {
    var t = Ei(arguments);
    return t[0] = this, xt(this, Jc(this, e, t));
  }
});
var wl = Ua.prototype;
wl[dD] = !0;
wl[vl] = !0;
qa(hl, {
  get: function(e, t) {
    return this.has(e) ? e : t;
  },
  includes: function(e) {
    return this.has(e);
  },
  keySeq: function() {
    return this.valueSeq();
  }
});
var Ws = hl.prototype;
Ws.has = Nn.includes;
Ws.contains = Ws.includes;
Ws.keys = Ws.values;
qa(Uo, _c);
qa(di, wl);
qa(yl, Ws);
function y2(e, t, n, r, i, o) {
  return dr(e.size), e.__iterate(function(a, s, l) {
    i ? (i = !1, n = a) : n = t.call(r, n, a, s, l);
  }, o), n;
}
function JY(e, t) {
  return t;
}
function XY(e, t) {
  return [t, e];
}
function ym(e) {
  return function() {
    return !e.apply(this, arguments);
  };
}
function b2(e) {
  return function() {
    return -e.apply(this, arguments);
  };
}
function _2() {
  return Ei(arguments);
}
function w2(e, t) {
  return e < t ? 1 : e > t ? -1 : 0;
}
function eQ(e) {
  if (e.size === 1 / 0)
    return 0;
  var t = oi(e), n = Ft(e), r = t ? 1 : 0, i = e.__iterate(
    n ? t ? function(o, a) {
      r = 31 * r + x2(Jn(o), Jn(a)) | 0;
    } : function(o, a) {
      r = r + x2(Jn(o), Jn(a)) | 0;
    } : t ? function(o) {
      r = 31 * r + Jn(o) | 0;
    } : function(o) {
      r = r + Jn(o) | 0;
    }
  );
  return tQ(i, r);
}
function tQ(e, t) {
  return t = zl(t, 3432918353), t = zl(t << 15 | t >>> -15, 461845907), t = zl(t << 13 | t >>> -13, 5), t = (t + 3864292196 | 0) ^ e, t = zl(t ^ t >>> 16, 2246822507), t = zl(t ^ t >>> 13, 3266489909), t = Vp(t ^ t >>> 16), t;
}
function x2(e, t) {
  return e ^ t + 2654435769 + (e << 6) + (e >> 2) | 0;
}
var Bu = /* @__PURE__ */ (function(e) {
  function t(n) {
    return n == null ? Ig() : WD(n) ? n : Ig().withMutations(function(r) {
      var i = hl(n);
      dr(i.size), i.forEach(function(o) {
        return r.add(o);
      });
    });
  }
  return e && (t.__proto__ = e), t.prototype = Object.create(e && e.prototype), t.prototype.constructor = t, t.of = function() {
    return this(arguments);
  }, t.fromKeys = function(n) {
    return this(Kr(n).keySeq());
  }, t.prototype.toString = function() {
    return this.__toString("OrderedSet {", "}");
  }, t;
})(Up);
Bu.isOrderedSet = WD;
var Ha = Bu.prototype;
Ha[vl] = !0;
Ha.zip = wl.zip;
Ha.zipWith = wl.zipWith;
Ha.zipAll = wl.zipAll;
Ha.__empty = Ig;
Ha.__make = XD;
function XD(e, t) {
  var n = Object.create(Ha);
  return n.size = e ? e.size : 0, n._map = e, n.__ownerID = t, n;
}
var E2;
function Ig() {
  return E2 || (E2 = XD(Yl()));
}
function nQ(e) {
  if (ml(e))
    throw new Error(
      "Can not call `Record` with an immutable Record as default values. Use a plain javascript object instead."
    );
  if (Mi(e))
    throw new Error(
      "Can not call `Record` with an immutable Collection as default values. Use a plain javascript object instead."
    );
  if (e === null || typeof e != "object")
    throw new Error(
      "Can not call `Record` with a non-object as default values. Use a plain javascript object instead."
    );
}
var bn = function(e, t) {
  var n;
  nQ(e);
  var r = function(o) {
    var a = this;
    if (o instanceof r)
      return o;
    if (!(this instanceof r))
      return new r(o);
    if (!n) {
      n = !0;
      var s = Object.keys(e), l = i._indices = {};
      i._name = t, i._keys = s, i._defaultValues = e;
      for (var u = 0; u < s.length; u++) {
        var c = s[u];
        l[c] = u, i[c] ? typeof console == "object" && console.warn && console.warn(
          "Cannot define " + S0(this) + ' with property "' + c + '" since that property name is part of the Record API.'
        ) : rQ(i, c);
      }
    }
    return this.__ownerID = void 0, this._values = Kp().withMutations(function(f) {
      f.setSize(a._keys.length), Kr(o).forEach(function(d, p) {
        f.set(a._indices[p], d === a._defaultValues[p] ? void 0 : d);
      });
    }), this;
  }, i = r.prototype = Object.create(Tt);
  return i.constructor = r, t && (r.displayName = t), r;
};
bn.prototype.toString = function() {
  for (var e = S0(this) + " { ", t = this._keys, n, r = 0, i = t.length; r !== i; r++)
    n = t[r], e += (r ? ", " : "") + n + ": " + ju(this.get(n));
  return e + " }";
};
bn.prototype.equals = function(e) {
  return this === e || ml(e) && Zs(this).equals(Zs(e));
};
bn.prototype.hashCode = function() {
  return Zs(this).hashCode();
};
bn.prototype.has = function(e) {
  return this._indices.hasOwnProperty(e);
};
bn.prototype.get = function(e, t) {
  if (!this.has(e))
    return t;
  var n = this._indices[e], r = this._values.get(n);
  return r === void 0 ? this._defaultValues[e] : r;
};
bn.prototype.set = function(e, t) {
  if (this.has(e)) {
    var n = this._values.set(
      this._indices[e],
      t === this._defaultValues[e] ? void 0 : t
    );
    if (n !== this._values && !this.__ownerID)
      return E0(this, n);
  }
  return this;
};
bn.prototype.remove = function(e) {
  return this.set(e);
};
bn.prototype.clear = function() {
  var e = this._values.clear().setSize(this._keys.length);
  return this.__ownerID ? this : E0(this, e);
};
bn.prototype.wasAltered = function() {
  return this._values.wasAltered();
};
bn.prototype.toSeq = function() {
  return Zs(this);
};
bn.prototype.toJS = function() {
  return Nd(this);
};
bn.prototype.entries = function() {
  return this.__iterator(zr);
};
bn.prototype.__iterator = function(e, t) {
  return Zs(this).__iterator(e, t);
};
bn.prototype.__iterate = function(e, t) {
  return Zs(this).__iterate(e, t);
};
bn.prototype.__ensureOwner = function(e) {
  if (e === this.__ownerID)
    return this;
  var t = this._values.__ensureOwner(e);
  return e ? E0(this, t, e) : (this.__ownerID = e, this._values = t, this);
};
bn.isRecord = ml;
bn.getDescriptiveName = S0;
var Tt = bn.prototype;
Tt[hD] = !0;
Tt[pc] = Tt.remove;
Tt.deleteIn = Tt.removeIn = u0;
Tt.getIn = QD;
Tt.hasIn = Nn.hasIn;
Tt.merge = RD;
Tt.mergeWith = ND;
Tt.mergeIn = h0;
Tt.mergeDeep = FD;
Tt.mergeDeepWith = zD;
Tt.mergeDeepIn = m0;
Tt.setIn = l0;
Tt.update = c0;
Tt.updateIn = f0;
Tt.withMutations = gc;
Tt.asMutable = yc;
Tt.asImmutable = bc;
Tt[zp] = Tt.entries;
Tt.toJSON = Tt.toObject = Nn.toObject;
Tt.inspect = Tt.toSource = function() {
  return this.toString();
};
function E0(e, t, n) {
  var r = Object.create(Object.getPrototypeOf(e));
  return r._values = t, r.__ownerID = n, r;
}
function S0(e) {
  return e.constructor.displayName || e.constructor.name || "Record";
}
function Zs(e) {
  return Xb(e._keys.map(function(t) {
    return [t, e.get(t)];
  }));
}
function rQ(e, t) {
  try {
    Object.defineProperty(e, t, {
      get: function() {
        return this.get(t);
      },
      set: function(n) {
        s0(this.__ownerID, "Cannot set on an immutable record."), this.set(t, n);
      }
    });
  } catch {
  }
}
const eC = (e, t) => {
  ze(() => (document.addEventListener("keydown", (n) => {
    e[n.key] && e[n.key]();
  }), () => {
    document.removeEventListener("keydown", () => null);
  }), t || []);
}, iQ = Lr(
  [
    "dark:bg-neutral-900",
    "dark:text-neutral-200",
    "absolute",
    "transform",
    "shadow-sm",
    "border",
    "border-black",
    "top-1/2",
    "left-1/2",
    "bg-neutral-100",
    "max-h-[75vh]",
    "z-50"
  ],
  {
    variants: {
      size: {
        fit: ["w-auto", "h-auto"],
        sm: ["w-sm", "h-[50vh]"],
        md: ["w-md", "h-[50vh]"],
        lg: ["w-lg", "h-[50vh]"]
      }
    }
  }
), oQ = ({
  children: e,
  visible: t,
  onClose: n,
  className: r,
  containerClassName: i = "modal-root",
  variant: o = "lg"
}) => {
  const a = ve(null), { root: s } = aQ();
  return eC({
    Escape: n
  }), s ? t ? ba(
    /* @__PURE__ */ I.jsx(Cv, { children: /* @__PURE__ */ I.jsxs(I.Fragment, { children: [
      /* @__PURE__ */ I.jsx(
        Un.div,
        {
          className: rr(
            "fixed top-0 left-0 w-screen h-screen opacity-80 bg-neutral-700 z-40 overlay",
            r
          ),
          onClick: () => n(),
          initial: { opacity: 0 },
          animate: { opacity: 0.8 }
        }
      ),
      /* @__PURE__ */ I.jsx(
        Un.div,
        {
          className: rr(
            iQ({ size: o }),
            i
          ),
          ref: a,
          initial: {
            left: "50vw",
            opacity: 1,
            transform: "translateX(-50%) translateY(-50%)",
            top: "100vh"
          },
          animate: {
            left: "50vw",
            opacity: 1,
            transform: "translateX(-50%) translateY(-50%)",
            top: "50vh"
          },
          exit: {
            left: "50vw",
            opacity: 1,
            transform: "translateX(-50%) ",
            top: "100vh"
          },
          children: e
        }
      )
    ] }) }),
    s
  ) : null : (console.error("No root element found"), null);
}, tC = He({ root: null }), aQ = () => H.useContext(tC), fse = ({
  className: e = "modal-root",
  children: t
}) => {
  const [n, r] = H.useState(null);
  return /* @__PURE__ */ I.jsxs(tC.Provider, { value: { root: n }, children: [
    t,
    /* @__PURE__ */ I.jsx("div", { ref: r, className: e })
  ] });
}, sQ = ({
  visible: e,
  onClose: t,
  onCreateFolder: n
}) => {
  const { register: r, handleSubmit: i, reset: o } = rY({ defaultValues: { name: "" } }), { ref: a, ...s } = r("name"), [l, u] = Ke(null);
  return ze(() => {
    l && l.focus();
  }, [l]), /* @__PURE__ */ I.jsx(
    oQ,
    {
      visible: e,
      onClose: () => t(!1),
      variant: "fit",
      children: /* @__PURE__ */ I.jsxs("div", { className: "border-black border w-full h-full bg-white p-4", children: [
        /* @__PURE__ */ I.jsx("h1", { children: "create folder" }),
        /* @__PURE__ */ I.jsxs(
          "form",
          {
            className: "flex flex-col items-center justify-center gap-4",
            onSubmit: i((c) => {
              o(), n(c.name);
            }),
            children: [
              /* @__PURE__ */ I.jsx(
                iY,
                {
                  ref: (c) => {
                    a(c), u(c);
                  },
                  className: "block",
                  ...s,
                  type: "text",
                  placeholder: "folder name"
                }
              ),
              /* @__PURE__ */ I.jsx(u$, { children: "Create" })
            ]
          }
        )
      ] })
    }
  );
}, lQ = /* @__PURE__ */ new Map([
  [
    "bold",
    /* @__PURE__ */ ee.createElement(ee.Fragment, null, /* @__PURE__ */ ee.createElement("path", { d: "M216.49,79.52l-56-56A12,12,0,0,0,152,20H56A20,20,0,0,0,36,40V216a20,20,0,0,0,20,20H200a20,20,0,0,0,20-20V88A12,12,0,0,0,216.49,79.52ZM160,57l23,23H160ZM60,212V44h76V92a12,12,0,0,0,12,12h48V212Z" }))
  ],
  [
    "duotone",
    /* @__PURE__ */ ee.createElement(ee.Fragment, null, /* @__PURE__ */ ee.createElement("path", { d: "M208,88H152V32Z", opacity: "0.2" }), /* @__PURE__ */ ee.createElement("path", { d: "M213.66,82.34l-56-56A8,8,0,0,0,152,24H56A16,16,0,0,0,40,40V216a16,16,0,0,0,16,16H200a16,16,0,0,0,16-16V88A8,8,0,0,0,213.66,82.34ZM160,51.31,188.69,80H160ZM200,216H56V40h88V88a8,8,0,0,0,8,8h48V216Z" }))
  ],
  [
    "fill",
    /* @__PURE__ */ ee.createElement(ee.Fragment, null, /* @__PURE__ */ ee.createElement("path", { d: "M213.66,82.34l-56-56A8,8,0,0,0,152,24H56A16,16,0,0,0,40,40V216a16,16,0,0,0,16,16H200a16,16,0,0,0,16-16V88A8,8,0,0,0,213.66,82.34ZM152,88V44l44,44Z" }))
  ],
  [
    "light",
    /* @__PURE__ */ ee.createElement(ee.Fragment, null, /* @__PURE__ */ ee.createElement("path", { d: "M212.24,83.76l-56-56A6,6,0,0,0,152,26H56A14,14,0,0,0,42,40V216a14,14,0,0,0,14,14H200a14,14,0,0,0,14-14V88A6,6,0,0,0,212.24,83.76ZM158,46.48,193.52,82H158ZM200,218H56a2,2,0,0,1-2-2V40a2,2,0,0,1,2-2h90V88a6,6,0,0,0,6,6h50V216A2,2,0,0,1,200,218Z" }))
  ],
  [
    "regular",
    /* @__PURE__ */ ee.createElement(ee.Fragment, null, /* @__PURE__ */ ee.createElement("path", { d: "M213.66,82.34l-56-56A8,8,0,0,0,152,24H56A16,16,0,0,0,40,40V216a16,16,0,0,0,16,16H200a16,16,0,0,0,16-16V88A8,8,0,0,0,213.66,82.34ZM160,51.31,188.69,80H160ZM200,216H56V40h88V88a8,8,0,0,0,8,8h48V216Z" }))
  ],
  [
    "thin",
    /* @__PURE__ */ ee.createElement(ee.Fragment, null, /* @__PURE__ */ ee.createElement("path", { d: "M210.83,85.17l-56-56A4,4,0,0,0,152,28H56A12,12,0,0,0,44,40V216a12,12,0,0,0,12,12H200a12,12,0,0,0,12-12V88A4,4,0,0,0,210.83,85.17ZM156,41.65,198.34,84H156ZM200,220H56a4,4,0,0,1-4-4V40a4,4,0,0,1,4-4h92V88a4,4,0,0,0,4,4h52V216A4,4,0,0,1,200,220Z" }))
  ]
]), uQ = /* @__PURE__ */ new Map([
  [
    "bold",
    /* @__PURE__ */ ee.createElement(ee.Fragment, null, /* @__PURE__ */ ee.createElement("path", { d: "M216,68H133.39l-26-29.29a20,20,0,0,0-15-6.71H40A20,20,0,0,0,20,52V200.62A19.41,19.41,0,0,0,39.38,220H216.89A19.13,19.13,0,0,0,236,200.89V88A20,20,0,0,0,216,68ZM44,56H90.61l10.67,12H44ZM212,196H44V92H212Z" }))
  ],
  [
    "duotone",
    /* @__PURE__ */ ee.createElement(ee.Fragment, null, /* @__PURE__ */ ee.createElement(
      "path",
      {
        d: "M128,80H32V56a8,8,0,0,1,8-8H92.69a8,8,0,0,1,5.65,2.34Z",
        opacity: "0.2"
      }
    ), /* @__PURE__ */ ee.createElement("path", { d: "M216,72H131.31L104,44.69A15.86,15.86,0,0,0,92.69,40H40A16,16,0,0,0,24,56V200.62A15.4,15.4,0,0,0,39.38,216H216.89A15.13,15.13,0,0,0,232,200.89V88A16,16,0,0,0,216,72ZM92.69,56l16,16H40V56ZM216,200H40V88H216Z" }))
  ],
  [
    "fill",
    /* @__PURE__ */ ee.createElement(ee.Fragment, null, /* @__PURE__ */ ee.createElement("path", { d: "M216,72H131.31L104,44.69A15.88,15.88,0,0,0,92.69,40H40A16,16,0,0,0,24,56V200.62A15.41,15.41,0,0,0,39.39,216h177.5A15.13,15.13,0,0,0,232,200.89V88A16,16,0,0,0,216,72ZM40,56H92.69l16,16H40Z" }))
  ],
  [
    "light",
    /* @__PURE__ */ ee.createElement(ee.Fragment, null, /* @__PURE__ */ ee.createElement("path", { d: "M216,74H130.49l-27.9-27.9a13.94,13.94,0,0,0-9.9-4.1H40A14,14,0,0,0,26,56V200.62A13.39,13.39,0,0,0,39.38,214H216.89A13.12,13.12,0,0,0,230,200.89V88A14,14,0,0,0,216,74ZM40,54H92.69a2,2,0,0,1,1.41.59L113.51,74H38V56A2,2,0,0,1,40,54ZM218,200.89a1.11,1.11,0,0,1-1.11,1.11H39.38A1.4,1.4,0,0,1,38,200.62V86H216a2,2,0,0,1,2,2Z" }))
  ],
  [
    "regular",
    /* @__PURE__ */ ee.createElement(ee.Fragment, null, /* @__PURE__ */ ee.createElement("path", { d: "M216,72H131.31L104,44.69A15.86,15.86,0,0,0,92.69,40H40A16,16,0,0,0,24,56V200.62A15.4,15.4,0,0,0,39.38,216H216.89A15.13,15.13,0,0,0,232,200.89V88A16,16,0,0,0,216,72ZM40,56H92.69l16,16H40ZM216,200H40V88H216Z" }))
  ],
  [
    "thin",
    /* @__PURE__ */ ee.createElement(ee.Fragment, null, /* @__PURE__ */ ee.createElement("path", { d: "M216,76H129.66L101.17,47.52A11.9,11.9,0,0,0,92.69,44H40A12,12,0,0,0,28,56V200.62A11.4,11.4,0,0,0,39.38,212H216.89A11.12,11.12,0,0,0,228,200.89V88A12,12,0,0,0,216,76ZM36,56a4,4,0,0,1,4-4H92.69a4,4,0,0,1,2.82,1.17L118.34,76H36ZM220,200.89a3.12,3.12,0,0,1-3.11,3.11H39.38A3.39,3.39,0,0,1,36,200.62V84H216a4,4,0,0,1,4,4Z" }))
  ]
]), cQ = /* @__PURE__ */ new Map([
  [
    "bold",
    /* @__PURE__ */ ee.createElement(ee.Fragment, null, /* @__PURE__ */ ee.createElement("path", { d: "M216,68H133.39l-26-29.29a20,20,0,0,0-15-6.71H40A20,20,0,0,0,20,52V200.62A19.41,19.41,0,0,0,39.38,220H216.89A19.13,19.13,0,0,0,236,200.89V88A20,20,0,0,0,216,68ZM90.61,56l10.67,12H44V56ZM212,196H44V92H212Zm-72-76v12h12a12,12,0,0,1,0,24H140v12a12,12,0,0,1-24,0V156H104a12,12,0,0,1,0-24h12V120a12,12,0,0,1,24,0Z" }))
  ],
  [
    "duotone",
    /* @__PURE__ */ ee.createElement(ee.Fragment, null, /* @__PURE__ */ ee.createElement(
      "path",
      {
        d: "M128,80H32V56a8,8,0,0,1,8-8H92.69a8,8,0,0,1,5.65,2.34Z",
        opacity: "0.2"
      }
    ), /* @__PURE__ */ ee.createElement("path", { d: "M216,72H131.31L104,44.69A15.86,15.86,0,0,0,92.69,40H40A16,16,0,0,0,24,56V200.62A15.4,15.4,0,0,0,39.38,216H216.89A15.13,15.13,0,0,0,232,200.89V88A16,16,0,0,0,216,72ZM92.69,56l16,16H40V56ZM216,200H40V88H216Zm-88-88a8,8,0,0,1,8,8v16h16a8,8,0,0,1,0,16H136v16a8,8,0,0,1-16,0V152H104a8,8,0,0,1,0-16h16V120A8,8,0,0,1,128,112Z" }))
  ],
  [
    "fill",
    /* @__PURE__ */ ee.createElement(ee.Fragment, null, /* @__PURE__ */ ee.createElement("path", { d: "M216,72H131.31L104,44.69A15.88,15.88,0,0,0,92.69,40H40A16,16,0,0,0,24,56V200.62A15.41,15.41,0,0,0,39.39,216h177.5A15.13,15.13,0,0,0,232,200.89V88A16,16,0,0,0,216,72ZM40,56H92.69l16,16H40Zm112,96H136v16a8,8,0,0,1-16,0V152H104a8,8,0,0,1,0-16h16V120a8,8,0,0,1,16,0v16h16a8,8,0,0,1,0,16Z" }))
  ],
  [
    "light",
    /* @__PURE__ */ ee.createElement(ee.Fragment, null, /* @__PURE__ */ ee.createElement("path", { d: "M216,74H130.49l-27.9-27.9a13.94,13.94,0,0,0-9.9-4.1H40A14,14,0,0,0,26,56V200.62A13.39,13.39,0,0,0,39.38,214H216.89A13.12,13.12,0,0,0,230,200.89V88A14,14,0,0,0,216,74ZM40,54H92.69a2,2,0,0,1,1.41.59L113.51,74H38V56A2,2,0,0,1,40,54ZM218,200.89a1.11,1.11,0,0,1-1.11,1.11H39.38A1.4,1.4,0,0,1,38,200.62V86H216a2,2,0,0,1,2,2ZM158,144a6,6,0,0,1-6,6H134v18a6,6,0,0,1-12,0V150H104a6,6,0,0,1,0-12h18V120a6,6,0,0,1,12,0v18h18A6,6,0,0,1,158,144Z" }))
  ],
  [
    "regular",
    /* @__PURE__ */ ee.createElement(ee.Fragment, null, /* @__PURE__ */ ee.createElement("path", { d: "M216,72H131.31L104,44.69A15.86,15.86,0,0,0,92.69,40H40A16,16,0,0,0,24,56V200.62A15.4,15.4,0,0,0,39.38,216H216.89A15.13,15.13,0,0,0,232,200.89V88A16,16,0,0,0,216,72ZM92.69,56l16,16H40V56ZM216,200H40V88H216Zm-88-88a8,8,0,0,1,8,8v16h16a8,8,0,0,1,0,16H136v16a8,8,0,0,1-16,0V152H104a8,8,0,0,1,0-16h16V120A8,8,0,0,1,128,112Z" }))
  ],
  [
    "thin",
    /* @__PURE__ */ ee.createElement(ee.Fragment, null, /* @__PURE__ */ ee.createElement("path", { d: "M216,76H129.66L101.17,47.52A11.9,11.9,0,0,0,92.69,44H40A12,12,0,0,0,28,56V200.62A11.4,11.4,0,0,0,39.38,212H216.89A11.12,11.12,0,0,0,228,200.89V88A12,12,0,0,0,216,76ZM40,52H92.69a4,4,0,0,1,2.82,1.17L118.34,76H36V56A4,4,0,0,1,40,52ZM220,200.89a3.12,3.12,0,0,1-3.11,3.11H39.38A3.39,3.39,0,0,1,36,200.62V84H216a4,4,0,0,1,4,4ZM156,144a4,4,0,0,1-4,4H132v20a4,4,0,0,1-8,0V148H104a4,4,0,0,1,0-8h20V120a4,4,0,0,1,8,0v20h20A4,4,0,0,1,156,144Z" }))
  ]
]), fQ = /* @__PURE__ */ new Map([
  [
    "bold",
    /* @__PURE__ */ ee.createElement(ee.Fragment, null, /* @__PURE__ */ ee.createElement("path", { d: "M228,128a12,12,0,0,1-12,12H40a12,12,0,0,1,0-24H216A12,12,0,0,1,228,128ZM40,76H216a12,12,0,0,0,0-24H40a12,12,0,0,0,0,24ZM216,180H40a12,12,0,0,0,0,24H216a12,12,0,0,0,0-24Z" }))
  ],
  [
    "duotone",
    /* @__PURE__ */ ee.createElement(ee.Fragment, null, /* @__PURE__ */ ee.createElement("path", { d: "M216,64V192H40V64Z", opacity: "0.2" }), /* @__PURE__ */ ee.createElement("path", { d: "M224,128a8,8,0,0,1-8,8H40a8,8,0,0,1,0-16H216A8,8,0,0,1,224,128ZM40,72H216a8,8,0,0,0,0-16H40a8,8,0,0,0,0,16ZM216,184H40a8,8,0,0,0,0,16H216a8,8,0,0,0,0-16Z" }))
  ],
  [
    "fill",
    /* @__PURE__ */ ee.createElement(ee.Fragment, null, /* @__PURE__ */ ee.createElement("path", { d: "M208,32H48A16,16,0,0,0,32,48V208a16,16,0,0,0,16,16H208a16,16,0,0,0,16-16V48A16,16,0,0,0,208,32ZM192,184H64a8,8,0,0,1,0-16H192a8,8,0,0,1,0,16Zm0-48H64a8,8,0,0,1,0-16H192a8,8,0,0,1,0,16Zm0-48H64a8,8,0,0,1,0-16H192a8,8,0,0,1,0,16Z" }))
  ],
  [
    "light",
    /* @__PURE__ */ ee.createElement(ee.Fragment, null, /* @__PURE__ */ ee.createElement("path", { d: "M222,128a6,6,0,0,1-6,6H40a6,6,0,0,1,0-12H216A6,6,0,0,1,222,128ZM40,70H216a6,6,0,0,0,0-12H40a6,6,0,0,0,0,12ZM216,186H40a6,6,0,0,0,0,12H216a6,6,0,0,0,0-12Z" }))
  ],
  [
    "regular",
    /* @__PURE__ */ ee.createElement(ee.Fragment, null, /* @__PURE__ */ ee.createElement("path", { d: "M224,128a8,8,0,0,1-8,8H40a8,8,0,0,1,0-16H216A8,8,0,0,1,224,128ZM40,72H216a8,8,0,0,0,0-16H40a8,8,0,0,0,0,16ZM216,184H40a8,8,0,0,0,0,16H216a8,8,0,0,0,0-16Z" }))
  ],
  [
    "thin",
    /* @__PURE__ */ ee.createElement(ee.Fragment, null, /* @__PURE__ */ ee.createElement("path", { d: "M220,128a4,4,0,0,1-4,4H40a4,4,0,0,1,0-8H216A4,4,0,0,1,220,128ZM40,68H216a4,4,0,0,0,0-8H40a4,4,0,0,0,0,8ZM216,188H40a4,4,0,0,0,0,8H216a4,4,0,0,0,0-8Z" }))
  ]
]), dQ = /* @__PURE__ */ new Map([
  [
    "bold",
    /* @__PURE__ */ ee.createElement(ee.Fragment, null, /* @__PURE__ */ ee.createElement("path", { d: "M156,112a12,12,0,0,1-12,12H124v20a12,12,0,0,1-24,0V124H80a12,12,0,0,1,0-24h20V80a12,12,0,0,1,24,0v20h20A12,12,0,0,1,156,112Zm76.49,120.49a12,12,0,0,1-17,0L168,185a92.12,92.12,0,1,1,17-17l47.54,47.53A12,12,0,0,1,232.49,232.49ZM112,180a68,68,0,1,0-68-68A68.08,68.08,0,0,0,112,180Z" }))
  ],
  [
    "duotone",
    /* @__PURE__ */ ee.createElement(ee.Fragment, null, /* @__PURE__ */ ee.createElement("path", { d: "M192,112a80,80,0,1,1-80-80A80,80,0,0,1,192,112Z", opacity: "0.2" }), /* @__PURE__ */ ee.createElement("path", { d: "M229.66,218.34,179.6,168.28a88.21,88.21,0,1,0-11.32,11.31l50.06,50.07a8,8,0,0,0,11.32-11.32ZM40,112a72,72,0,1,1,72,72A72.08,72.08,0,0,1,40,112Zm112,0a8,8,0,0,1-8,8H120v24a8,8,0,0,1-16,0V120H80a8,8,0,0,1,0-16h24V80a8,8,0,0,1,16,0v24h24A8,8,0,0,1,152,112Z" }))
  ],
  [
    "fill",
    /* @__PURE__ */ ee.createElement(ee.Fragment, null, /* @__PURE__ */ ee.createElement("path", { d: "M229.66,218.34,179.6,168.28a88.21,88.21,0,1,0-11.32,11.31l50.06,50.07a8,8,0,0,0,11.32-11.32ZM144,120H120v24a8,8,0,0,1-16,0V120H80a8,8,0,0,1,0-16h24V80a8,8,0,0,1,16,0v24h24a8,8,0,0,1,0,16Z" }))
  ],
  [
    "light",
    /* @__PURE__ */ ee.createElement(ee.Fragment, null, /* @__PURE__ */ ee.createElement("path", { d: "M150,112a6,6,0,0,1-6,6H118v26a6,6,0,0,1-12,0V118H80a6,6,0,0,1,0-12h26V80a6,6,0,0,1,12,0v26h26A6,6,0,0,1,150,112Zm78.24,116.24a6,6,0,0,1-8.48,0l-51.38-51.38a86.15,86.15,0,1,1,8.48-8.48l51.38,51.38A6,6,0,0,1,228.24,228.24ZM112,186a74,74,0,1,0-74-74A74.09,74.09,0,0,0,112,186Z" }))
  ],
  [
    "regular",
    /* @__PURE__ */ ee.createElement(ee.Fragment, null, /* @__PURE__ */ ee.createElement("path", { d: "M152,112a8,8,0,0,1-8,8H120v24a8,8,0,0,1-16,0V120H80a8,8,0,0,1,0-16h24V80a8,8,0,0,1,16,0v24h24A8,8,0,0,1,152,112Zm77.66,117.66a8,8,0,0,1-11.32,0l-50.06-50.07a88.11,88.11,0,1,1,11.31-11.31l50.07,50.06A8,8,0,0,1,229.66,229.66ZM112,184a72,72,0,1,0-72-72A72.08,72.08,0,0,0,112,184Z" }))
  ],
  [
    "thin",
    /* @__PURE__ */ ee.createElement(ee.Fragment, null, /* @__PURE__ */ ee.createElement("path", { d: "M148,112a4,4,0,0,1-4,4H116v28a4,4,0,0,1-8,0V116H80a4,4,0,0,1,0-8h28V80a4,4,0,0,1,8,0v28h28A4,4,0,0,1,148,112Zm78.83,114.83a4,4,0,0,1-5.66,0l-52.7-52.7a84.1,84.1,0,1,1,5.66-5.66l52.7,52.7A4,4,0,0,1,226.83,226.83ZM112,188a76,76,0,1,0-76-76A76.08,76.08,0,0,0,112,188Z" }))
  ]
]), pQ = /* @__PURE__ */ new Map([
  [
    "bold",
    /* @__PURE__ */ ee.createElement(ee.Fragment, null, /* @__PURE__ */ ee.createElement("path", { d: "M228,144v64a12,12,0,0,1-12,12H40a12,12,0,0,1-12-12V144a12,12,0,0,1,24,0v52H204V144a12,12,0,0,1,24,0ZM96.49,80.49,116,61v83a12,12,0,0,0,24,0V61l19.51,19.52a12,12,0,1,0,17-17l-40-40a12,12,0,0,0-17,0l-40,40a12,12,0,1,0,17,17Z" }))
  ],
  [
    "duotone",
    /* @__PURE__ */ ee.createElement(ee.Fragment, null, /* @__PURE__ */ ee.createElement(
      "path",
      {
        d: "M216,48V208H40V48A16,16,0,0,1,56,32H200A16,16,0,0,1,216,48Z",
        opacity: "0.2"
      }
    ), /* @__PURE__ */ ee.createElement("path", { d: "M224,144v64a8,8,0,0,1-8,8H40a8,8,0,0,1-8-8V144a8,8,0,0,1,16,0v56H208V144a8,8,0,0,1,16,0ZM93.66,77.66,120,51.31V144a8,8,0,0,0,16,0V51.31l26.34,26.35a8,8,0,0,0,11.32-11.32l-40-40a8,8,0,0,0-11.32,0l-40,40A8,8,0,0,0,93.66,77.66Z" }))
  ],
  [
    "fill",
    /* @__PURE__ */ ee.createElement(ee.Fragment, null, /* @__PURE__ */ ee.createElement("path", { d: "M224,144v64a8,8,0,0,1-8,8H40a8,8,0,0,1-8-8V144a8,8,0,0,1,16,0v56H208V144a8,8,0,0,1,16,0ZM88,80h32v64a8,8,0,0,0,16,0V80h32a8,8,0,0,0,5.66-13.66l-40-40a8,8,0,0,0-11.32,0l-40,40A8,8,0,0,0,88,80Z" }))
  ],
  [
    "light",
    /* @__PURE__ */ ee.createElement(ee.Fragment, null, /* @__PURE__ */ ee.createElement("path", { d: "M222,144v64a6,6,0,0,1-6,6H40a6,6,0,0,1-6-6V144a6,6,0,0,1,12,0v58H210V144a6,6,0,0,1,12,0ZM92.24,76.24,122,46.49V144a6,6,0,0,0,12,0V46.49l29.76,29.75a6,6,0,0,0,8.48-8.48l-40-40a6,6,0,0,0-8.48,0l-40,40a6,6,0,0,0,8.48,8.48Z" }))
  ],
  [
    "regular",
    /* @__PURE__ */ ee.createElement(ee.Fragment, null, /* @__PURE__ */ ee.createElement("path", { d: "M224,144v64a8,8,0,0,1-8,8H40a8,8,0,0,1-8-8V144a8,8,0,0,1,16,0v56H208V144a8,8,0,0,1,16,0ZM93.66,77.66,120,51.31V144a8,8,0,0,0,16,0V51.31l26.34,26.35a8,8,0,0,0,11.32-11.32l-40-40a8,8,0,0,0-11.32,0l-40,40A8,8,0,0,0,93.66,77.66Z" }))
  ],
  [
    "thin",
    /* @__PURE__ */ ee.createElement(ee.Fragment, null, /* @__PURE__ */ ee.createElement("path", { d: "M220,144v64a4,4,0,0,1-4,4H40a4,4,0,0,1-4-4V144a4,4,0,0,1,8,0v60H212V144a4,4,0,0,1,8,0ZM90.83,74.83,124,41.66V144a4,4,0,0,0,8,0V41.66l33.17,33.17a4,4,0,1,0,5.66-5.66l-40-40a4,4,0,0,0-5.66,0l-40,40a4,4,0,0,0,5.66,5.66Z" }))
  ]
]), hQ = He({
  color: "currentColor",
  size: "1em",
  weight: "regular",
  mirrored: !1
}), Wa = ee.forwardRef(
  (e, t) => {
    const {
      alt: n,
      color: r,
      size: i,
      weight: o,
      mirrored: a,
      children: s,
      weights: l,
      ...u
    } = e, {
      color: c = "currentColor",
      size: f,
      weight: d = "regular",
      mirrored: p = !1,
      ...h
    } = ee.useContext(hQ);
    return /* @__PURE__ */ ee.createElement(
      "svg",
      {
        ref: t,
        xmlns: "http://www.w3.org/2000/svg",
        width: i ?? f,
        height: i ?? f,
        fill: r ?? c,
        viewBox: "0 0 256 256",
        transform: a || p ? "scale(-1, 1)" : void 0,
        ...h,
        ...u
      },
      !!n && /* @__PURE__ */ ee.createElement("title", null, n),
      s,
      l.get(o ?? d)
    );
  }
);
Wa.displayName = "IconBase";
const nC = ee.forwardRef((e, t) => /* @__PURE__ */ ee.createElement(Wa, { ref: t, ...e, weights: lQ }));
nC.displayName = "FileIcon";
const mQ = nC, rC = ee.forwardRef((e, t) => /* @__PURE__ */ ee.createElement(Wa, { ref: t, ...e, weights: uQ }));
rC.displayName = "FolderIcon";
const vQ = rC, iC = ee.forwardRef((e, t) => /* @__PURE__ */ ee.createElement(Wa, { ref: t, ...e, weights: cQ }));
iC.displayName = "FolderPlusIcon";
const gQ = iC, oC = ee.forwardRef((e, t) => /* @__PURE__ */ ee.createElement(Wa, { ref: t, ...e, weights: fQ }));
oC.displayName = "ListIcon";
const yQ = oC, aC = ee.forwardRef((e, t) => /* @__PURE__ */ ee.createElement(Wa, { ref: t, ...e, weights: dQ }));
aC.displayName = "MagnifyingGlassPlusIcon";
const sC = ee.forwardRef((e, t) => /* @__PURE__ */ ee.createElement(Wa, { ref: t, ...e, weights: pQ }));
sC.displayName = "UploadSimpleIcon";
const bQ = sC;
var bm, S2;
function _Q() {
  if (S2) return bm;
  S2 = 1;
  function e(i) {
    if (typeof i != "string")
      throw new TypeError("Path must be a string. Received " + JSON.stringify(i));
  }
  function t(i, o) {
    for (var a = "", s = 0, l = -1, u = 0, c, f = 0; f <= i.length; ++f) {
      if (f < i.length)
        c = i.charCodeAt(f);
      else {
        if (c === 47)
          break;
        c = 47;
      }
      if (c === 47) {
        if (!(l === f - 1 || u === 1)) if (l !== f - 1 && u === 2) {
          if (a.length < 2 || s !== 2 || a.charCodeAt(a.length - 1) !== 46 || a.charCodeAt(a.length - 2) !== 46) {
            if (a.length > 2) {
              var d = a.lastIndexOf("/");
              if (d !== a.length - 1) {
                d === -1 ? (a = "", s = 0) : (a = a.slice(0, d), s = a.length - 1 - a.lastIndexOf("/")), l = f, u = 0;
                continue;
              }
            } else if (a.length === 2 || a.length === 1) {
              a = "", s = 0, l = f, u = 0;
              continue;
            }
          }
          o && (a.length > 0 ? a += "/.." : a = "..", s = 2);
        } else
          a.length > 0 ? a += "/" + i.slice(l + 1, f) : a = i.slice(l + 1, f), s = f - l - 1;
        l = f, u = 0;
      } else c === 46 && u !== -1 ? ++u : u = -1;
    }
    return a;
  }
  function n(i, o) {
    var a = o.dir || o.root, s = o.base || (o.name || "") + (o.ext || "");
    return a ? a === o.root ? a + s : a + i + s : s;
  }
  var r = {
    // path.resolve([from ...], to)
    resolve: function() {
      for (var o = "", a = !1, s, l = arguments.length - 1; l >= -1 && !a; l--) {
        var u;
        l >= 0 ? u = arguments[l] : (s === void 0 && (s = process.cwd()), u = s), e(u), u.length !== 0 && (o = u + "/" + o, a = u.charCodeAt(0) === 47);
      }
      return o = t(o, !a), a ? o.length > 0 ? "/" + o : "/" : o.length > 0 ? o : ".";
    },
    normalize: function(o) {
      if (e(o), o.length === 0) return ".";
      var a = o.charCodeAt(0) === 47, s = o.charCodeAt(o.length - 1) === 47;
      return o = t(o, !a), o.length === 0 && !a && (o = "."), o.length > 0 && s && (o += "/"), a ? "/" + o : o;
    },
    isAbsolute: function(o) {
      return e(o), o.length > 0 && o.charCodeAt(0) === 47;
    },
    join: function() {
      if (arguments.length === 0)
        return ".";
      for (var o, a = 0; a < arguments.length; ++a) {
        var s = arguments[a];
        e(s), s.length > 0 && (o === void 0 ? o = s : o += "/" + s);
      }
      return o === void 0 ? "." : r.normalize(o);
    },
    relative: function(o, a) {
      if (e(o), e(a), o === a || (o = r.resolve(o), a = r.resolve(a), o === a)) return "";
      for (var s = 1; s < o.length && o.charCodeAt(s) === 47; ++s)
        ;
      for (var l = o.length, u = l - s, c = 1; c < a.length && a.charCodeAt(c) === 47; ++c)
        ;
      for (var f = a.length, d = f - c, p = u < d ? u : d, h = -1, v = 0; v <= p; ++v) {
        if (v === p) {
          if (d > p) {
            if (a.charCodeAt(c + v) === 47)
              return a.slice(c + v + 1);
            if (v === 0)
              return a.slice(c + v);
          } else u > p && (o.charCodeAt(s + v) === 47 ? h = v : v === 0 && (h = 0));
          break;
        }
        var m = o.charCodeAt(s + v), g = a.charCodeAt(c + v);
        if (m !== g)
          break;
        m === 47 && (h = v);
      }
      var _ = "";
      for (v = s + h + 1; v <= l; ++v)
        (v === l || o.charCodeAt(v) === 47) && (_.length === 0 ? _ += ".." : _ += "/..");
      return _.length > 0 ? _ + a.slice(c + h) : (c += h, a.charCodeAt(c) === 47 && ++c, a.slice(c));
    },
    _makeLong: function(o) {
      return o;
    },
    dirname: function(o) {
      if (e(o), o.length === 0) return ".";
      for (var a = o.charCodeAt(0), s = a === 47, l = -1, u = !0, c = o.length - 1; c >= 1; --c)
        if (a = o.charCodeAt(c), a === 47) {
          if (!u) {
            l = c;
            break;
          }
        } else
          u = !1;
      return l === -1 ? s ? "/" : "." : s && l === 1 ? "//" : o.slice(0, l);
    },
    basename: function(o, a) {
      if (a !== void 0 && typeof a != "string") throw new TypeError('"ext" argument must be a string');
      e(o);
      var s = 0, l = -1, u = !0, c;
      if (a !== void 0 && a.length > 0 && a.length <= o.length) {
        if (a.length === o.length && a === o) return "";
        var f = a.length - 1, d = -1;
        for (c = o.length - 1; c >= 0; --c) {
          var p = o.charCodeAt(c);
          if (p === 47) {
            if (!u) {
              s = c + 1;
              break;
            }
          } else
            d === -1 && (u = !1, d = c + 1), f >= 0 && (p === a.charCodeAt(f) ? --f === -1 && (l = c) : (f = -1, l = d));
        }
        return s === l ? l = d : l === -1 && (l = o.length), o.slice(s, l);
      } else {
        for (c = o.length - 1; c >= 0; --c)
          if (o.charCodeAt(c) === 47) {
            if (!u) {
              s = c + 1;
              break;
            }
          } else l === -1 && (u = !1, l = c + 1);
        return l === -1 ? "" : o.slice(s, l);
      }
    },
    extname: function(o) {
      e(o);
      for (var a = -1, s = 0, l = -1, u = !0, c = 0, f = o.length - 1; f >= 0; --f) {
        var d = o.charCodeAt(f);
        if (d === 47) {
          if (!u) {
            s = f + 1;
            break;
          }
          continue;
        }
        l === -1 && (u = !1, l = f + 1), d === 46 ? a === -1 ? a = f : c !== 1 && (c = 1) : a !== -1 && (c = -1);
      }
      return a === -1 || l === -1 || // We saw a non-dot character immediately before the dot
      c === 0 || // The (right-most) trimmed path component is exactly '..'
      c === 1 && a === l - 1 && a === s + 1 ? "" : o.slice(a, l);
    },
    format: function(o) {
      if (o === null || typeof o != "object")
        throw new TypeError('The "pathObject" argument must be of type Object. Received type ' + typeof o);
      return n("/", o);
    },
    parse: function(o) {
      e(o);
      var a = { root: "", dir: "", base: "", ext: "", name: "" };
      if (o.length === 0) return a;
      var s = o.charCodeAt(0), l = s === 47, u;
      l ? (a.root = "/", u = 1) : u = 0;
      for (var c = -1, f = 0, d = -1, p = !0, h = o.length - 1, v = 0; h >= u; --h) {
        if (s = o.charCodeAt(h), s === 47) {
          if (!p) {
            f = h + 1;
            break;
          }
          continue;
        }
        d === -1 && (p = !1, d = h + 1), s === 46 ? c === -1 ? c = h : v !== 1 && (v = 1) : c !== -1 && (v = -1);
      }
      return c === -1 || d === -1 || // We saw a non-dot character immediately before the dot
      v === 0 || // The (right-most) trimmed path component is exactly '..'
      v === 1 && c === d - 1 && c === f + 1 ? d !== -1 && (f === 0 && l ? a.base = a.name = o.slice(1, d) : a.base = a.name = o.slice(f, d)) : (f === 0 && l ? (a.name = o.slice(1, c), a.base = o.slice(1, d)) : (a.name = o.slice(f, c), a.base = o.slice(f, d)), a.ext = o.slice(c, d)), f > 0 ? a.dir = o.slice(0, f - 1) : l && (a.dir = "/"), a;
    },
    sep: "/",
    delimiter: ":",
    win32: null,
    posix: null
  };
  return r.posix = r, bm = r, bm;
}
var ks = _Q();
const lC = Lr([
  "dark:hover:bg-neutral-300",
  "dark:hover:text-neutral-700",
  "hover:bg-neutral-100",
  "p-1",
  "items-center",
  "gap-2",
  "whitespace-nowrap",
  "w-full",
  "flex",
  "text-left",
  "text-sm",
  "disabled:text-neutral-500",
  "disabled:hover:bg-none",
  "cursor-default"
]);
function pa({ className: e = "", ...t }) {
  return /* @__PURE__ */ I.jsx(AV, { ...t, className: lC({}) });
}
const wQ = Lr([
  "bg-white",
  "text-black",
  "border-b",
  "border",
  "shadow-md",
  "p-2"
]);
function $0({ children: e, button: t, className: n, isOpen: r, setOpen: i }) {
  return /* @__PURE__ */ I.jsxs(SV, { isOpen: r, onOpenChange: i, children: [
    /* @__PURE__ */ I.jsx(hb, { children: t || /* @__PURE__ */ I.jsx(
      yr,
      {
        className: "dark:text-neutral-300 text-neutral-700",
        icon: uI
      }
    ) }),
    /* @__PURE__ */ I.jsx(SP, { children: /* @__PURE__ */ I.jsx(kV, { className: rr(wQ({}), n), children: e }) })
  ] });
}
const xQ = NA(
  ({
    store: e,
    homeDirectory: t,
    searchDisabled: n,
    searchBarExtras: r
  }) => /* @__PURE__ */ I.jsxs("header", { className: "row-start-1 w-full", children: [
    /* @__PURE__ */ I.jsxs("div", { className: "px-2 flex w-full gap-4 border border-black", children: [
      /* @__PURE__ */ I.jsx("div", { className: "flex w-full", children: /* @__PURE__ */ I.jsx(
        "input",
        {
          disabled: n,
          value: e.searchQuery ?? "",
          onChange: (i) => e.setSearchQuery(i.target.value),
          className: "w-full p-1 rounded border-none h-6 my-auto flex-grow bg-white dark:bg-neutral-300 text-neutral-600 focus:outline-none",
          type: "text",
          placeholder: "search..."
        }
      ) }),
      /* @__PURE__ */ I.jsxs("div", { className: "flex gap-2", children: [
        /* @__PURE__ */ I.jsx(
          DV,
          {
            onSelect: (i) => {
              i && e.onDrop(Array.from(i));
            },
            children: /* @__PURE__ */ I.jsx(hb, { className: lC(), children: /* @__PURE__ */ I.jsx(bQ, { size: 18 }) })
          }
        ),
        r && r(e.searchQuery ?? ""),
        /* @__PURE__ */ I.jsx($0, { children: /* @__PURE__ */ I.jsxs(
          pa,
          {
            onAction: () => {
              e.setCreateFolderModalVisible(!0);
            },
            children: [
              /* @__PURE__ */ I.jsx(gQ, { size: 18 }),
              " Create Folder"
            ]
          }
        ) })
      ] })
    ] }),
    /* @__PURE__ */ I.jsxs(
      "button",
      {
        className: "inline text-black pb-2 hover:text-neutral-300 hover:fill-neutral-300",
        onClick: () => e.popToRoot(),
        children: [
          t,
          "/"
        ]
      }
    ),
    e.currentPath.map((i, o) => /* @__PURE__ */ I.jsxs(
      "button",
      {
        className: "inline text-black pb-2 hover:text-neutral-300",
        onClick: () => {
          o !== e.currentPath.length - 1 && e.popFolderHistoryToIndex(o);
        },
        children: [
          ks.basename(i),
          "/"
        ]
      },
      `${i}-${o}`
    ))
  ] })
);
function EQ({ files: e }) {
  return /* @__PURE__ */ I.jsxs("div", { children: [
    /* @__PURE__ */ I.jsx("p", { className: "m-2", children: "Uploading:" }),
    /* @__PURE__ */ I.jsx("ul", { children: e.map((t) => /* @__PURE__ */ I.jsx("li", { className: "pl-4 list-none", children: t.name }, t.name)) })
  ] });
}
class SQ {
  constructor(t) {
    mi(this, "searchQuery", null);
    mi(this, "currentPath", []);
    mi(this, "searchResults", null);
    mi(this, "createFolderModalVisible", !1);
    mi(this, "onSearch");
    mi(this, "onUpload");
    mi(this, "onNavigate");
    mi(this, "searchLoading", !1);
    t ? this.currentPath = t : this.currentPath = [], eZ(this), this.onDrop = this.onDrop.bind(this), this.pushPathPart = this.pushPathPart.bind(this), this.setCreateFolderModalVisible = this.setCreateFolderModalVisible.bind(this), this.setSearchQuery = this.setSearchQuery.bind(this), this.popFolderHistory = this.popFolderHistory.bind(this), this.popFolderHistoryToIndex = this.popFolderHistoryToIndex.bind(this), this.setSearchResults = this.setSearchResults.bind(this);
  }
  setCreateFolderModalVisible(t) {
    this.createFolderModalVisible = t;
  }
  pushPathPart(t) {
    this.currentPath.push(t);
  }
  popFolderHistory() {
    this.currentPath.pop(), this.onNavigate?.(
      this.currentPath
    );
  }
  popToRoot() {
    this.currentPath = [], this.onNavigate?.([]);
  }
  popFolderHistoryToIndex(t) {
    this.currentPath = this.currentPath.slice(0, t + 1), this.onNavigate?.(
      this.currentPath
    );
  }
  async setSearchResults(t) {
    this.searchResults = t;
  }
  async setSearchQuery(t) {
    if (this.searchQuery = t, t) {
      if (!this.onSearch)
        return;
    } else {
      this.searchResults = null, this.searchLoading = !1;
      return;
    }
    this.onSearch(t);
  }
  // get currentFolderPath() {
  //     if (this.currentPath.length === 0) {
  //         return "";
  //     }
  //     // return this.folderHistory.reduce((acc, f) => acc + f, "");
  //     return this.currentPath[this.currentPath.length - 1];
  // }
  async onDrop(t) {
    if (t[0].size / (1024 * 1024 * 1024) > 1)
      throw Er("File cannot be bigger than 1GB"), new Error("File cannot be bigger than 1GB");
    if (this.onUpload)
      try {
        const i = await this.onUpload(t);
        if (!i)
          return;
        const o = Er(/* @__PURE__ */ I.jsx(EQ, { files: t }), {
          progress: 0
        });
        i.subscribe({
          onProgress: (a) => {
            Er.update(o, {
              progress: a
            });
          },
          onError: (a) => {
            Er.error("Something went wrong!: " + a.message);
          },
          onComplete: () => {
            Er.dismiss(o);
          }
        });
      } catch (i) {
        Er.error("Something went wrong!: " + i);
      }
  }
}
function Xl(e, t) {
  return !!t.find(
    ({ path: n, isFolder: r }) => e.path === n && r === e.isFolder
  );
}
function $Q(e, t, n) {
  switch (n) {
    case Vn.ALL:
      return Xl(t, e) ? e.filter((r) => r.path !== t.path) : [...e, t];
    case Vn.FILE:
      return t.isFolder ? e : Xl(t, e) ? [] : [t];
    case Vn.DIR:
      return t.isFolder ? Xl(t, e) ? [] : [t] : e;
    case Vn.FILE_LIST:
      return t.isFolder ? e : Xl(t, e) ? e.filter((r) => r.path !== t.path) : [...e, t];
    case Vn.NONE:
    default:
      return e;
  }
}
const jd = () => /* @__PURE__ */ I.jsx("div", { className: "flex-grow" });
function uC({
  onDelete: e,
  path: t,
  onPreview: n,
  onDownload: r,
  onMoveUpAFolder: i,
  className: o = "",
  isOpen: a,
  setOpen: s
}) {
  return /* @__PURE__ */ I.jsxs(
    $0,
    {
      button: /* @__PURE__ */ I.jsx(yQ, { className: o, size: 18, "data-testid": `path-actions-${t.path}` }),
      isOpen: a,
      setOpen: s,
      children: [
        !t.isFolder && r && /* @__PURE__ */ I.jsx(
          pa,
          {
            onAction: async () => {
              r(t);
            },
            children: "Download"
          }
        ),
        i && /* @__PURE__ */ I.jsx(
          pa,
          {
            onAction: async () => {
              const l = ks.dirname(ks.dirname(t.path)), u = ks.basename(t.path), c = `${l}/${u}`;
              i(l === "." ? null : { path: t, parent: l, newPath: c });
            },
            children: "Move Up a Folder"
          }
        ),
        e && /* @__PURE__ */ I.jsx(pa, { onAction: () => e(), children: "Delete" }),
        !t.isFolder && n && /* @__PURE__ */ I.jsx(pa, { onAction: () => n(t), children: "Preview" })
      ]
    }
  );
}
const kQ = Lr(
  [
    "relative",
    "flex",
    "gap-2",
    "p-1",
    "select-none",
    "hover:bg-neutral-200",
    "dark:hover:bg-neutral-600",
    "items-center",
    "w-full",
    "group"
  ],
  {
    variants: {
      selected: {
        true: ["text-blue-500", "hover:after:h-0"],
        false: ["text-neutral-800", "dark:text-neutral-200"]
      },
      isOver: {
        true: ["bg-neutral-300", "dark:bg-neutral-600"],
        false: ["bg-transparent"]
      }
    }
  }
), cC = fn(
  (e, t) => {
    const {
      children: n,
      selected: r,
      showCheckbox: i = !0,
      style: o,
      onCheckboxValueChange: a,
      onClick: s,
      isOver: l,
      path: u
    } = e;
    return /* @__PURE__ */ I.jsxs(
      Un.div,
      {
        "data-testid": `file-${u}`,
        className: kQ({ selected: r, isOver: l }),
        ref: t,
        style: o,
        onClick: (c) => {
          c.stopPropagation, s?.(c);
        },
        layout: !0,
        children: [
          i && /* @__PURE__ */ I.jsx(
            ZA,
            {
              onClick: (c) => c.stopPropagation(),
              onChange: (c) => {
                a(c.currentTarget.checked);
              },
              className: "mr-2",
              checked: r
            }
          ),
          n
        ]
      }
    );
  }
), TQ = ({
  path: e,
  onClick: t,
  selected: n,
  readOnly: r = !1,
  showFullPath: i = !1,
  onDelete: o,
  style: a,
  onPreview: s,
  onDownload: l,
  onMoveUpAFolder: u,
  showCheckbox: c = !0
}) => {
  const [, f] = t$({
    canDrag: !r,
    type: "S3File",
    item: { ...e },
    collect: (v) => ({
      isDragging: v.isDragging()
    })
  }), d = ks.basename(e.path), [p, h] = Ke(!1);
  return /* @__PURE__ */ I.jsxs(
    cC,
    {
      path: e.path,
      style: { ...a },
      onClick: (v) => {
        v.stopPropagation();
      },
      showCheckbox: c,
      onCheckboxValueChange: () => t(e),
      selected: n,
      ref: f,
      children: [
        /* @__PURE__ */ I.jsx(mQ, { size: 18, className: "pr-1 flex-shrink-0" }),
        /* @__PURE__ */ I.jsx("div", { className: "flex flex-col justify-around flex-shrink h-full overflow-hidden", children: /* @__PURE__ */ I.jsx("p", { children: i ? e.path : d }) }),
        /* @__PURE__ */ I.jsx(jd, {}),
        /* @__PURE__ */ I.jsx(
          uC,
          {
            className: `${p ? "" : "opacity-0 focus:opacity-100"} group-hover:opacity-100 focus:opacity-100`,
            onPreview: s,
            path: e,
            onDelete: o ? () => o?.(e) : void 0,
            onMoveUpAFolder: u,
            onDownload: l,
            isOpen: p,
            setOpen: h
          }
        )
      ]
    }
  );
}, OQ = ({
  path: e,
  onClick: t,
  onDblClick: n,
  selected: r,
  onDrop: i,
  readOnly: o = !1,
  style: a,
  onDelete: s,
  showActions: l,
  onPreview: u,
  showFullPath: c,
  showCheckbox: f = !0
}) => {
  const d = aY(
    () => {
    },
    () => n(e)
  ), [, p] = t$({
    canDrag: !o,
    type: "S3Folder",
    item: { ...e },
    collect: (g) => ({
      isDragging: g.isDragging()
    })
  }), [h] = Ke(!1), [{ isOver: v }, m] = $6({
    canDrop: () => !o,
    accept: ["S3Folder", "S3File"],
    drop: (g) => i(g),
    collect: (g) => ({
      isOver: g.isOver()
    })
  });
  return /* @__PURE__ */ I.jsx("div", { ref: m, style: a, children: /* @__PURE__ */ I.jsxs(
    cC,
    {
      path: e.path,
      selected: r,
      isOver: v,
      onClick: (g) => {
        g.stopPropagation(), d();
      },
      ref: p,
      showCheckbox: f,
      onCheckboxValueChange: () => t(e),
      children: [
        /* @__PURE__ */ I.jsx(vQ, { size: 18, className: "pr-1 flex-shrink-0" }),
        /* @__PURE__ */ I.jsx("div", { className: "flex flex-col justify-around h-full", children: /* @__PURE__ */ I.jsx("p", { children: c ? e.path : ks.basename(e.path) }) }),
        /* @__PURE__ */ I.jsx(jd, {}),
        l && u && s && h && /* @__PURE__ */ I.jsx(
          uC,
          {
            onPreview: u,
            path: e,
            onDelete: s ? () => s(e) : void 0
          }
        )
      ]
    }
  ) });
};
function PQ(e, t) {
  ze(() => {
    for (const n in e)
      e.hasOwnProperty(n) && e[n] && (t[n] = e[n]);
  }, [e, t]);
}
const AQ = NA(
  ({
    selectionMode: e = Vn.NONE,
    // files,
    selection: t,
    onSelectionChange: n,
    readOnly: r = !1,
    className: i,
    showActions: o = !0,
    onDownload: a,
    onMoveUpAFolder: s,
    style: l,
    onPreview: u,
    onDelete: c,
    onMove: f,
    onCreateFolder: d,
    loading: p = !1,
    onSearch: h,
    searchDisabled: v = !1,
    onNavigate: m,
    filePathHomeDirectory: g = "~",
    onUpload: _,
    searchBarExtras: x,
    files: w,
    // getFiles,
    path: $
  }) => {
    const k = AZ(() => new SQ($)), { getRootProps: D, getInputProps: E, isDragActive: b } = WA({
      noClick: !0,
      onDrop: k.onDrop
    }), y = Le(
      (T) => $Q(t, T, e),
      [t, e]
    ), S = Le(async () => {
      k.searchLoading = !0;
      const T = k.searchQuery;
      if (!h || !T) {
        k.searchLoading = !1;
        return;
      }
      k.setSearchResults([]), setTimeout(async () => {
        if (k.searchQuery === T && T) {
          const V = await h(T);
          if (!V) return;
          k.setSearchResults(V), k.searchLoading = !1;
        }
      }, 500);
    }, [h, k.searchQuery]);
    ze(() => {
      k.onSearch = S;
    }, [S]), PQ(
      {
        onUpload: _,
        onNavigate: m,
        currentPath: $
      },
      k
    );
    const P = k.searchResults || w || [], M = ve(null);
    return /* @__PURE__ */ I.jsxs(
      "div",
      {
        className: rr(
          "grid-rows-[2rem 1fr] box-border relative flex flex-col justify-start flex-grow w-full gap-2 overflow-auto text-neutral-800 bg-white",
          i
        ),
        style: l,
        ...D(),
        children: [
          b && /* @__PURE__ */ I.jsx(
            "div",
            {
              style: { zIndex: 999 },
              className: "w-full h-full absolute top-0 left-0 flex justify-center items-center z-[999] bg-opacity-20 text-orange-2 pointer-events-none bg-white text-4xl",
              children: "Drop files here"
            }
          ),
          /* @__PURE__ */ I.jsx("input", { className: "z-50 bg-purple-500", ...E() }),
          /* @__PURE__ */ I.jsx("div", { children: /* @__PURE__ */ I.jsx(
            xQ,
            {
              searchDisabled: v,
              selection: t,
              store: k,
              homeDirectory: g,
              searchBarExtras: x
            }
          ) }),
          e !== Vn.NONE && /* @__PURE__ */ I.jsxs("div", { className: "mr-auto ml-1 flex items-center gap-2 text-neutral-400", children: [
            /* @__PURE__ */ I.jsx(
              ZA,
              {
                checked: t.length > 0,
                onChange: () => {
                  P && (t.length === 0 ? n?.([...t, ...P]) : n?.([]));
                }
              }
            ),
            /* @__PURE__ */ I.jsxs("p", { className: "text-xs", children: [
              t.length,
              " file",
              t.length !== 1 && "s",
              " selected"
            ] })
          ] }),
          /* @__PURE__ */ I.jsx(
            "div",
            {
              ref: M,
              className: "relative flex-grow overflow-auto",
              children: /* @__PURE__ */ I.jsx(FZ, { children: /* @__PURE__ */ I.jsxs("div", { className: "row-start-2 row-span-1 flex-grow relative", children: [
                p ? /* @__PURE__ */ I.jsx("p", { className: "py-2 italic text-neutral-600", children: "Loading..." }) : null,
                P?.length === 0 && !k.searchLoading && !p && /* @__PURE__ */ I.jsx("p", { className: "py-2 italic text-neutral-600", children: "No files" }),
                k.searchLoading && /* @__PURE__ */ I.jsx("p", { className: "py-2 italic text-neutral-600", children: "Searching..." }),
                P && P.length > 0 && P.map((T) => {
                  const V = {
                    key: DQ(T),
                    showActions: o,
                    readOnly: r,
                    onDelete: c ? () => {
                      c([T]), n?.([]);
                    } : void 0,
                    onClick: (z) => {
                      const U = y(z);
                      n?.(U);
                    },
                    showFullPath: !!k.searchQuery,
                    // show full path if searching
                    path: T,
                    selected: Xl(T, t),
                    onPreview: u
                  };
                  return T.isFolder ? /* @__PURE__ */ I.jsx(
                    OQ,
                    {
                      ...V,
                      showCheckbox: e !== Vn.NONE && e !== Vn.FILE && e !== Vn.FILE_LIST,
                      onDblClick: (z) => {
                        const U = z.path.split("/").filter(Boolean).pop();
                        U && (k.pushPathPart(U), m?.(k.currentPath));
                      },
                      onDrop: (z) => f?.(z, T)
                    }
                  ) : /* @__PURE__ */ I.jsx(
                    TQ,
                    {
                      ...V,
                      showCheckbox: e !== Vn.NONE && e !== Vn.DIR && e !== Vn.DIR_LIST,
                      onMoveUpAFolder: s,
                      onDownload: a
                    }
                  );
                })
              ] }) })
            }
          ),
          /* @__PURE__ */ I.jsx(
            sQ,
            {
              visible: k.createFolderModalVisible,
              onClose: () => k.setCreateFolderModalVisible(!1),
              onCreateFolder: async (T) => {
                d?.(T, k.currentPath), k.setCreateFolderModalVisible(!1);
              }
            }
          )
        ]
      }
    );
  }
), DQ = (e) => `${e.isFolder ? "folder" : "file"}-${e.path}`;
var CQ = Object.defineProperty, IQ = (e, t, n) => t in e ? CQ(e, t, { enumerable: !0, configurable: !0, writable: !0, value: n }) : e[t] = n, MQ = (e, t, n) => IQ(e, t + "", n), Mg = function(e, t) {
  return Mg = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(n, r) {
    n.__proto__ = r;
  } || function(n, r) {
    for (var i in r) Object.prototype.hasOwnProperty.call(r, i) && (n[i] = r[i]);
  }, Mg(e, t);
};
function pi(e, t) {
  if (typeof t != "function" && t !== null)
    throw new TypeError("Class extends value " + String(t) + " is not a constructor or null");
  Mg(e, t);
  function n() {
    this.constructor = e;
  }
  e.prototype = t === null ? Object.create(t) : (n.prototype = t.prototype, new n());
}
var Z = function() {
  return Z = Object.assign || function(e) {
    for (var t, n = 1, r = arguments.length; n < r; n++) {
      t = arguments[n];
      for (var i in t) Object.prototype.hasOwnProperty.call(t, i) && (e[i] = t[i]);
    }
    return e;
  }, Z.apply(this, arguments);
};
function Ui(e, t) {
  var n = {};
  for (var r in e) Object.prototype.hasOwnProperty.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var i = 0, r = Object.getOwnPropertySymbols(e); i < r.length; i++)
      t.indexOf(r[i]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[i]) && (n[r[i]] = e[r[i]]);
  return n;
}
function co(e, t, n, r) {
  function i(o) {
    return o instanceof n ? o : new n(function(a) {
      a(o);
    });
  }
  return new (n || (n = Promise))(function(o, a) {
    function s(c) {
      try {
        u(r.next(c));
      } catch (f) {
        a(f);
      }
    }
    function l(c) {
      try {
        u(r.throw(c));
      } catch (f) {
        a(f);
      }
    }
    function u(c) {
      c.done ? o(c.value) : i(c.value).then(s, l);
    }
    u((r = r.apply(e, t || [])).next());
  });
}
function fo(e, t) {
  var n = { label: 0, sent: function() {
    if (o[0] & 1) throw o[1];
    return o[1];
  }, trys: [], ops: [] }, r, i, o, a = Object.create((typeof Iterator == "function" ? Iterator : Object).prototype);
  return a.next = s(0), a.throw = s(1), a.return = s(2), typeof Symbol == "function" && (a[Symbol.iterator] = function() {
    return this;
  }), a;
  function s(u) {
    return function(c) {
      return l([u, c]);
    };
  }
  function l(u) {
    if (r) throw new TypeError("Generator is already executing.");
    for (; a && (a = 0, u[0] && (n = 0)), n; ) try {
      if (r = 1, i && (o = u[0] & 2 ? i.return : u[0] ? i.throw || ((o = i.return) && o.call(i), 0) : i.next) && !(o = o.call(i, u[1])).done) return o;
      switch (i = 0, o && (u = [u[0] & 2, o.value]), u[0]) {
        case 0:
        case 1:
          o = u;
          break;
        case 4:
          return n.label++, { value: u[1], done: !1 };
        case 5:
          n.label++, i = u[1], u = [0];
          continue;
        case 7:
          u = n.ops.pop(), n.trys.pop();
          continue;
        default:
          if (o = n.trys, !(o = o.length > 0 && o[o.length - 1]) && (u[0] === 6 || u[0] === 2)) {
            n = 0;
            continue;
          }
          if (u[0] === 3 && (!o || u[1] > o[0] && u[1] < o[3])) {
            n.label = u[1];
            break;
          }
          if (u[0] === 6 && n.label < o[1]) {
            n.label = o[1], o = u;
            break;
          }
          if (o && n.label < o[2]) {
            n.label = o[2], n.ops.push(u);
            break;
          }
          o[2] && n.ops.pop(), n.trys.pop();
          continue;
      }
      u = t.call(e, n);
    } catch (c) {
      u = [6, c], i = 0;
    } finally {
      r = o = 0;
    }
    if (u[0] & 5) throw u[1];
    return { value: u[0] ? u[1] : void 0, done: !0 };
  }
}
function On(e, t, n) {
  if (n || arguments.length === 2) for (var r = 0, i = t.length, o; r < i; r++)
    (o || !(r in t)) && (o || (o = Array.prototype.slice.call(t, 0, r)), o[r] = t[r]);
  return e.concat(o || Array.prototype.slice.call(t));
}
var _m = "Invariant Violation", $2 = Object.setPrototypeOf, RQ = $2 === void 0 ? function(e, t) {
  return e.__proto__ = t, e;
} : $2, fC = (
  /** @class */
  (function(e) {
    pi(t, e);
    function t(n) {
      n === void 0 && (n = _m);
      var r = e.call(this, typeof n == "number" ? _m + ": " + n + " (see https://github.com/apollographql/invariant-packages)" : n) || this;
      return r.framesToPop = 1, r.name = _m, RQ(r, t.prototype), r;
    }
    return t;
  })(Error)
);
function oa(e, t) {
  if (!e)
    throw new fC(t);
}
var dC = ["debug", "log", "warn", "error", "silent"], NQ = dC.indexOf("log");
function nf(e) {
  return function() {
    if (dC.indexOf(e) >= NQ) {
      var t = console[e] || console.log;
      return t.apply(console, arguments);
    }
  };
}
(function(e) {
  e.debug = nf("debug"), e.log = nf("log"), e.warn = nf("warn"), e.error = nf("error");
})(oa || (oa = {}));
var k0 = "3.14.1";
function Jr(e) {
  try {
    return e();
  } catch {
  }
}
const Fd = Jr(function() {
  return globalThis;
}) || Jr(function() {
  return window;
}) || Jr(function() {
  return self;
}) || Jr(function() {
  return global;
}) || // We don't expect the Function constructor ever to be invoked at runtime, as
// long as at least one of globalThis, window, self, or global is defined, so
// we are under no obligation to make it easy for static analysis tools to
// detect syntactic usage of the Function constructor. If you think you can
// improve your static analysis to detect this obfuscation, think again. This
// is an arms race you cannot win, at least not in JavaScript.
Jr(function() {
  return Jr.constructor("return this")();
});
var k2 = /* @__PURE__ */ new Map();
function Rg(e) {
  var t = k2.get(e) || 1;
  return k2.set(e, t + 1), "".concat(e, ":").concat(t, ":").concat(Math.random().toString(36).slice(2));
}
function pC(e, t) {
  t === void 0 && (t = 0);
  var n = Rg("stringifyForDisplay");
  return JSON.stringify(e, function(r, i) {
    return i === void 0 ? n : i;
  }, t).split(JSON.stringify(n)).join("<undefined>");
}
function rf(e) {
  return function(t) {
    for (var n = [], r = 1; r < arguments.length; r++)
      n[r - 1] = arguments[r];
    if (typeof t == "number") {
      var i = t;
      t = T0(i), t || (t = O0(i, n), n = []);
    }
    e.apply(void 0, [t].concat(n));
  };
}
var ke = Object.assign(function(e, t) {
  for (var n = [], r = 2; r < arguments.length; r++)
    n[r - 2] = arguments[r];
  e || oa(e, T0(t, n) || O0(t, n));
}, {
  debug: rf(oa.debug),
  log: rf(oa.log),
  warn: rf(oa.warn),
  error: rf(oa.error)
});
function Zn(e) {
  for (var t = [], n = 1; n < arguments.length; n++)
    t[n - 1] = arguments[n];
  return new fC(T0(e, t) || O0(e, t));
}
var T2 = Symbol.for("ApolloErrorMessageHandler_" + k0);
function hC(e) {
  if (typeof e == "string")
    return e;
  try {
    return pC(e, 2).slice(0, 1e3);
  } catch {
    return "<non-serializable>";
  }
}
function T0(e, t) {
  if (t === void 0 && (t = []), !!e)
    return Fd[T2] && Fd[T2](e, t.map(hC));
}
function O0(e, t) {
  if (t === void 0 && (t = []), !!e)
    return "An error occurred! For more details, see the full error text at https://go.apollo.dev/c/err#".concat(encodeURIComponent(JSON.stringify({
      version: k0,
      message: e,
      args: t.map(hC)
    })));
}
var Ht = Object.freeze({
  // Name
  NAME: "Name",
  // Document
  DOCUMENT: "Document",
  OPERATION_DEFINITION: "OperationDefinition",
  VARIABLE_DEFINITION: "VariableDefinition",
  SELECTION_SET: "SelectionSet",
  FIELD: "Field",
  ARGUMENT: "Argument",
  // Fragments
  FRAGMENT_SPREAD: "FragmentSpread",
  INLINE_FRAGMENT: "InlineFragment",
  FRAGMENT_DEFINITION: "FragmentDefinition",
  // Values
  VARIABLE: "Variable",
  INT: "IntValue",
  FLOAT: "FloatValue",
  STRING: "StringValue",
  BOOLEAN: "BooleanValue",
  NULL: "NullValue",
  ENUM: "EnumValue",
  LIST: "ListValue",
  OBJECT: "ObjectValue",
  OBJECT_FIELD: "ObjectField",
  // Directives
  DIRECTIVE: "Directive",
  // Types
  NAMED_TYPE: "NamedType",
  LIST_TYPE: "ListType",
  NON_NULL_TYPE: "NonNullType",
  // Type System Definitions
  SCHEMA_DEFINITION: "SchemaDefinition",
  OPERATION_TYPE_DEFINITION: "OperationTypeDefinition",
  // Type Definitions
  SCALAR_TYPE_DEFINITION: "ScalarTypeDefinition",
  OBJECT_TYPE_DEFINITION: "ObjectTypeDefinition",
  FIELD_DEFINITION: "FieldDefinition",
  INPUT_VALUE_DEFINITION: "InputValueDefinition",
  INTERFACE_TYPE_DEFINITION: "InterfaceTypeDefinition",
  UNION_TYPE_DEFINITION: "UnionTypeDefinition",
  ENUM_TYPE_DEFINITION: "EnumTypeDefinition",
  ENUM_VALUE_DEFINITION: "EnumValueDefinition",
  INPUT_OBJECT_TYPE_DEFINITION: "InputObjectTypeDefinition",
  // Directive Definitions
  DIRECTIVE_DEFINITION: "DirectiveDefinition",
  // Type System Extensions
  SCHEMA_EXTENSION: "SchemaExtension",
  // Type Extensions
  SCALAR_TYPE_EXTENSION: "ScalarTypeExtension",
  OBJECT_TYPE_EXTENSION: "ObjectTypeExtension",
  INTERFACE_TYPE_EXTENSION: "InterfaceTypeExtension",
  UNION_TYPE_EXTENSION: "UnionTypeExtension",
  ENUM_TYPE_EXTENSION: "EnumTypeExtension",
  INPUT_OBJECT_TYPE_EXTENSION: "InputObjectTypeExtension"
});
function jQ(e, t) {
  throw new Error("Unexpected invariant triggered.");
}
var Ng = typeof Symbol == "function" && typeof Symbol.for == "function" ? Symbol.for("nodejs.util.inspect.custom") : void 0;
function mC(e) {
  var t = e.prototype.toJSON;
  typeof t == "function" || jQ(), e.prototype.inspect = t, Ng && (e.prototype[Ng] = t);
}
var FQ = /* @__PURE__ */ (function() {
  function e(n, r, i) {
    this.start = n.start, this.end = r.end, this.startToken = n, this.endToken = r, this.source = i;
  }
  var t = e.prototype;
  return t.toJSON = function() {
    return {
      start: this.start,
      end: this.end
    };
  }, e;
})();
mC(FQ);
var zQ = /* @__PURE__ */ (function() {
  function e(n, r, i, o, a, s, l) {
    this.kind = n, this.start = r, this.end = i, this.line = o, this.column = a, this.value = l, this.prev = s, this.next = null;
  }
  var t = e.prototype;
  return t.toJSON = function() {
    return {
      kind: this.kind,
      value: this.value,
      line: this.line,
      column: this.column
    };
  }, e;
})();
mC(zQ);
function O2(e) {
  return e != null && typeof e.kind == "string";
}
function Mf(e) {
  "@babel/helpers - typeof";
  return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? Mf = function(t) {
    return typeof t;
  } : Mf = function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, Mf(e);
}
var LQ = 10, vC = 2;
function VQ(e) {
  return qp(e, []);
}
function qp(e, t) {
  switch (Mf(e)) {
    case "string":
      return JSON.stringify(e);
    case "function":
      return e.name ? "[function ".concat(e.name, "]") : "[function]";
    case "object":
      return e === null ? "null" : BQ(e, t);
    default:
      return String(e);
  }
}
function BQ(e, t) {
  if (t.indexOf(e) !== -1)
    return "[Circular]";
  var n = [].concat(t, [e]), r = qQ(e);
  if (r !== void 0) {
    var i = r.call(e);
    if (i !== e)
      return typeof i == "string" ? i : qp(i, n);
  } else if (Array.isArray(e))
    return UQ(e, n);
  return KQ(e, n);
}
function KQ(e, t) {
  var n = Object.keys(e);
  if (n.length === 0)
    return "{}";
  if (t.length > vC)
    return "[" + HQ(e) + "]";
  var r = n.map(function(i) {
    var o = qp(e[i], t);
    return i + ": " + o;
  });
  return "{ " + r.join(", ") + " }";
}
function UQ(e, t) {
  if (e.length === 0)
    return "[]";
  if (t.length > vC)
    return "[Array]";
  for (var n = Math.min(LQ, e.length), r = e.length - n, i = [], o = 0; o < n; ++o)
    i.push(qp(e[o], t));
  return r === 1 ? i.push("... 1 more item") : r > 1 && i.push("... ".concat(r, " more items")), "[" + i.join(", ") + "]";
}
function qQ(e) {
  var t = e[String(Ng)];
  if (typeof t == "function")
    return t;
  if (typeof e.inspect == "function")
    return e.inspect;
}
function HQ(e) {
  var t = Object.prototype.toString.call(e).replace(/^\[object /, "").replace(/]$/, "");
  if (t === "Object" && typeof e.constructor == "function") {
    var n = e.constructor.name;
    if (typeof n == "string" && n !== "")
      return n;
  }
  return t;
}
function WQ(e) {
  var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "", n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : !1, r = e.indexOf(`
`) === -1, i = e[0] === " " || e[0] === "	", o = e[e.length - 1] === '"', a = e[e.length - 1] === "\\", s = !r || o || a || n, l = "";
  return s && !(r && i) && (l += `
` + t), l += t ? e.replace(/\n/g, `
` + t) : e, s && (l += `
`), '"""' + l.replace(/"""/g, '\\"""') + '"""';
}
var ZQ = {
  Name: [],
  Document: ["definitions"],
  OperationDefinition: ["name", "variableDefinitions", "directives", "selectionSet"],
  VariableDefinition: ["variable", "type", "defaultValue", "directives"],
  Variable: ["name"],
  SelectionSet: ["selections"],
  Field: ["alias", "name", "arguments", "directives", "selectionSet"],
  Argument: ["name", "value"],
  FragmentSpread: ["name", "directives"],
  InlineFragment: ["typeCondition", "directives", "selectionSet"],
  FragmentDefinition: [
    "name",
    // Note: fragment variable definitions are experimental and may be changed
    // or removed in the future.
    "variableDefinitions",
    "typeCondition",
    "directives",
    "selectionSet"
  ],
  IntValue: [],
  FloatValue: [],
  StringValue: [],
  BooleanValue: [],
  NullValue: [],
  EnumValue: [],
  ListValue: ["values"],
  ObjectValue: ["fields"],
  ObjectField: ["name", "value"],
  Directive: ["name", "arguments"],
  NamedType: ["name"],
  ListType: ["type"],
  NonNullType: ["type"],
  SchemaDefinition: ["description", "directives", "operationTypes"],
  OperationTypeDefinition: ["type"],
  ScalarTypeDefinition: ["description", "name", "directives"],
  ObjectTypeDefinition: ["description", "name", "interfaces", "directives", "fields"],
  FieldDefinition: ["description", "name", "arguments", "type", "directives"],
  InputValueDefinition: ["description", "name", "type", "defaultValue", "directives"],
  InterfaceTypeDefinition: ["description", "name", "interfaces", "directives", "fields"],
  UnionTypeDefinition: ["description", "name", "directives", "types"],
  EnumTypeDefinition: ["description", "name", "directives", "values"],
  EnumValueDefinition: ["description", "name", "directives"],
  InputObjectTypeDefinition: ["description", "name", "directives", "fields"],
  DirectiveDefinition: ["description", "name", "arguments", "locations"],
  SchemaExtension: ["directives", "operationTypes"],
  ScalarTypeExtension: ["name", "directives"],
  ObjectTypeExtension: ["name", "interfaces", "directives", "fields"],
  InterfaceTypeExtension: ["name", "interfaces", "directives", "fields"],
  UnionTypeExtension: ["name", "directives", "types"],
  EnumTypeExtension: ["name", "directives", "values"],
  InputObjectTypeExtension: ["name", "directives", "fields"]
}, Hp = Object.freeze({});
function li(e, t) {
  var n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : ZQ, r = void 0, i = Array.isArray(e), o = [e], a = -1, s = [], l = void 0, u = void 0, c = void 0, f = [], d = [], p = e;
  do {
    a++;
    var h = a === o.length, v = h && s.length !== 0;
    if (h) {
      if (u = d.length === 0 ? void 0 : f[f.length - 1], l = c, c = d.pop(), v) {
        if (i)
          l = l.slice();
        else {
          for (var m = {}, g = 0, _ = Object.keys(l); g < _.length; g++) {
            var x = _[g];
            m[x] = l[x];
          }
          l = m;
        }
        for (var w = 0, $ = 0; $ < s.length; $++) {
          var k = s[$][0], D = s[$][1];
          i && (k -= w), i && D === null ? (l.splice(k, 1), w++) : l[k] = D;
        }
      }
      a = r.index, o = r.keys, s = r.edits, i = r.inArray, r = r.prev;
    } else {
      if (u = c ? i ? a : o[a] : void 0, l = c ? c[u] : p, l == null)
        continue;
      c && f.push(u);
    }
    var E = void 0;
    if (!Array.isArray(l)) {
      if (!O2(l))
        throw new Error("Invalid AST Node: ".concat(VQ(l), "."));
      var b = GQ(t, l.kind, h);
      if (b) {
        if (E = b.call(t, l, u, c, f, d), E === Hp)
          break;
        if (E === !1) {
          if (!h) {
            f.pop();
            continue;
          }
        } else if (E !== void 0 && (s.push([u, E]), !h))
          if (O2(E))
            l = E;
          else {
            f.pop();
            continue;
          }
      }
    }
    if (E === void 0 && v && s.push([u, l]), h)
      f.pop();
    else {
      var y;
      r = {
        inArray: i,
        index: a,
        keys: o,
        edits: s,
        prev: r
      }, i = Array.isArray(l), o = i ? l : (y = n[l.kind]) !== null && y !== void 0 ? y : [], a = -1, s = [], c && d.push(c), c = l;
    }
  } while (r !== void 0);
  return s.length !== 0 && (p = s[s.length - 1][1]), p;
}
function GQ(e, t, n) {
  var r = e[t];
  if (r) {
    if (!n && typeof r == "function")
      return r;
    var i = n ? r.leave : r.enter;
    if (typeof i == "function")
      return i;
  } else {
    var o = n ? e.leave : e.enter;
    if (o) {
      if (typeof o == "function")
        return o;
      var a = o[t];
      if (typeof a == "function")
        return a;
    }
  }
}
function YQ(e) {
  return li(e, {
    leave: JQ
  });
}
var QQ = 80, JQ = {
  Name: function(e) {
    return e.value;
  },
  Variable: function(e) {
    return "$" + e.name;
  },
  // Document
  Document: function(e) {
    return Me(e.definitions, `

`) + `
`;
  },
  OperationDefinition: function(e) {
    var t = e.operation, n = e.name, r = Ut("(", Me(e.variableDefinitions, ", "), ")"), i = Me(e.directives, " "), o = e.selectionSet;
    return !n && !i && !r && t === "query" ? o : Me([t, Me([n, r]), i, o], " ");
  },
  VariableDefinition: function(e) {
    var t = e.variable, n = e.type, r = e.defaultValue, i = e.directives;
    return t + ": " + n + Ut(" = ", r) + Ut(" ", Me(i, " "));
  },
  SelectionSet: function(e) {
    var t = e.selections;
    return Zr(t);
  },
  Field: function(e) {
    var t = e.alias, n = e.name, r = e.arguments, i = e.directives, o = e.selectionSet, a = Ut("", t, ": ") + n, s = a + Ut("(", Me(r, ", "), ")");
    return s.length > QQ && (s = a + Ut(`(
`, Rf(Me(r, `
`)), `
)`)), Me([s, Me(i, " "), o], " ");
  },
  Argument: function(e) {
    var t = e.name, n = e.value;
    return t + ": " + n;
  },
  // Fragments
  FragmentSpread: function(e) {
    var t = e.name, n = e.directives;
    return "..." + t + Ut(" ", Me(n, " "));
  },
  InlineFragment: function(e) {
    var t = e.typeCondition, n = e.directives, r = e.selectionSet;
    return Me(["...", Ut("on ", t), Me(n, " "), r], " ");
  },
  FragmentDefinition: function(e) {
    var t = e.name, n = e.typeCondition, r = e.variableDefinitions, i = e.directives, o = e.selectionSet;
    return (
      // Note: fragment variable definitions are experimental and may be changed
      // or removed in the future.
      "fragment ".concat(t).concat(Ut("(", Me(r, ", "), ")"), " ") + "on ".concat(n, " ").concat(Ut("", Me(i, " "), " ")) + o
    );
  },
  // Value
  IntValue: function(e) {
    var t = e.value;
    return t;
  },
  FloatValue: function(e) {
    var t = e.value;
    return t;
  },
  StringValue: function(e, t) {
    var n = e.value, r = e.block;
    return r ? WQ(n, t === "description" ? "" : "  ") : JSON.stringify(n);
  },
  BooleanValue: function(e) {
    var t = e.value;
    return t ? "true" : "false";
  },
  NullValue: function() {
    return "null";
  },
  EnumValue: function(e) {
    var t = e.value;
    return t;
  },
  ListValue: function(e) {
    var t = e.values;
    return "[" + Me(t, ", ") + "]";
  },
  ObjectValue: function(e) {
    var t = e.fields;
    return "{" + Me(t, ", ") + "}";
  },
  ObjectField: function(e) {
    var t = e.name, n = e.value;
    return t + ": " + n;
  },
  // Directive
  Directive: function(e) {
    var t = e.name, n = e.arguments;
    return "@" + t + Ut("(", Me(n, ", "), ")");
  },
  // Type
  NamedType: function(e) {
    var t = e.name;
    return t;
  },
  ListType: function(e) {
    var t = e.type;
    return "[" + t + "]";
  },
  NonNullType: function(e) {
    var t = e.type;
    return t + "!";
  },
  // Type System Definitions
  SchemaDefinition: Wr(function(e) {
    var t = e.directives, n = e.operationTypes;
    return Me(["schema", Me(t, " "), Zr(n)], " ");
  }),
  OperationTypeDefinition: function(e) {
    var t = e.operation, n = e.type;
    return t + ": " + n;
  },
  ScalarTypeDefinition: Wr(function(e) {
    var t = e.name, n = e.directives;
    return Me(["scalar", t, Me(n, " ")], " ");
  }),
  ObjectTypeDefinition: Wr(function(e) {
    var t = e.name, n = e.interfaces, r = e.directives, i = e.fields;
    return Me(["type", t, Ut("implements ", Me(n, " & ")), Me(r, " "), Zr(i)], " ");
  }),
  FieldDefinition: Wr(function(e) {
    var t = e.name, n = e.arguments, r = e.type, i = e.directives;
    return t + (P2(n) ? Ut(`(
`, Rf(Me(n, `
`)), `
)`) : Ut("(", Me(n, ", "), ")")) + ": " + r + Ut(" ", Me(i, " "));
  }),
  InputValueDefinition: Wr(function(e) {
    var t = e.name, n = e.type, r = e.defaultValue, i = e.directives;
    return Me([t + ": " + n, Ut("= ", r), Me(i, " ")], " ");
  }),
  InterfaceTypeDefinition: Wr(function(e) {
    var t = e.name, n = e.interfaces, r = e.directives, i = e.fields;
    return Me(["interface", t, Ut("implements ", Me(n, " & ")), Me(r, " "), Zr(i)], " ");
  }),
  UnionTypeDefinition: Wr(function(e) {
    var t = e.name, n = e.directives, r = e.types;
    return Me(["union", t, Me(n, " "), r && r.length !== 0 ? "= " + Me(r, " | ") : ""], " ");
  }),
  EnumTypeDefinition: Wr(function(e) {
    var t = e.name, n = e.directives, r = e.values;
    return Me(["enum", t, Me(n, " "), Zr(r)], " ");
  }),
  EnumValueDefinition: Wr(function(e) {
    var t = e.name, n = e.directives;
    return Me([t, Me(n, " ")], " ");
  }),
  InputObjectTypeDefinition: Wr(function(e) {
    var t = e.name, n = e.directives, r = e.fields;
    return Me(["input", t, Me(n, " "), Zr(r)], " ");
  }),
  DirectiveDefinition: Wr(function(e) {
    var t = e.name, n = e.arguments, r = e.repeatable, i = e.locations;
    return "directive @" + t + (P2(n) ? Ut(`(
`, Rf(Me(n, `
`)), `
)`) : Ut("(", Me(n, ", "), ")")) + (r ? " repeatable" : "") + " on " + Me(i, " | ");
  }),
  SchemaExtension: function(e) {
    var t = e.directives, n = e.operationTypes;
    return Me(["extend schema", Me(t, " "), Zr(n)], " ");
  },
  ScalarTypeExtension: function(e) {
    var t = e.name, n = e.directives;
    return Me(["extend scalar", t, Me(n, " ")], " ");
  },
  ObjectTypeExtension: function(e) {
    var t = e.name, n = e.interfaces, r = e.directives, i = e.fields;
    return Me(["extend type", t, Ut("implements ", Me(n, " & ")), Me(r, " "), Zr(i)], " ");
  },
  InterfaceTypeExtension: function(e) {
    var t = e.name, n = e.interfaces, r = e.directives, i = e.fields;
    return Me(["extend interface", t, Ut("implements ", Me(n, " & ")), Me(r, " "), Zr(i)], " ");
  },
  UnionTypeExtension: function(e) {
    var t = e.name, n = e.directives, r = e.types;
    return Me(["extend union", t, Me(n, " "), r && r.length !== 0 ? "= " + Me(r, " | ") : ""], " ");
  },
  EnumTypeExtension: function(e) {
    var t = e.name, n = e.directives, r = e.values;
    return Me(["extend enum", t, Me(n, " "), Zr(r)], " ");
  },
  InputObjectTypeExtension: function(e) {
    var t = e.name, n = e.directives, r = e.fields;
    return Me(["extend input", t, Me(n, " "), Zr(r)], " ");
  }
};
function Wr(e) {
  return function(t) {
    return Me([t.description, e(t)], `
`);
  };
}
function Me(e) {
  var t, n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "";
  return (t = e?.filter(function(r) {
    return r;
  }).join(n)) !== null && t !== void 0 ? t : "";
}
function Zr(e) {
  return Ut(`{
`, Rf(Me(e, `
`)), `
}`);
}
function Ut(e, t) {
  var n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "";
  return t != null && t !== "" ? e + t + n : "";
}
function Rf(e) {
  return Ut("  ", e.replace(/\n/g, `
  `));
}
function XQ(e) {
  return e.indexOf(`
`) !== -1;
}
function P2(e) {
  return e != null && e.some(XQ);
}
function A2(e) {
  return e.kind === Ht.FIELD || e.kind === Ht.FRAGMENT_SPREAD || e.kind === Ht.INLINE_FRAGMENT;
}
function wc(e, t) {
  var n = e.directives;
  return !n || !n.length ? !0 : nJ(n).every(function(r) {
    var i = r.directive, o = r.ifArgument, a = !1;
    return o.value.kind === "Variable" ? (a = t && t[o.value.name.value], ke(a !== void 0, 105, i.name.value)) : a = o.value.value, i.name.value === "skip" ? !a : a;
  });
}
function Ku(e, t, n) {
  var r = new Set(e), i = r.size;
  return li(t, {
    Directive: function(o) {
      if (r.delete(o.name.value) && (!n || !r.size))
        return Hp;
    }
  }), n ? !r.size : r.size < i;
}
function eJ(e) {
  return e && Ku(["client", "export"], e, !0);
}
function tJ(e) {
  var t = e.name.value;
  return t === "skip" || t === "include";
}
function nJ(e) {
  var t = [];
  return e && e.length && e.forEach(function(n) {
    if (tJ(n)) {
      var r = n.arguments, i = n.name.value;
      ke(r && r.length === 1, 106, i);
      var o = r[0];
      ke(o.name && o.name.value === "if", 107, i);
      var a = o.value;
      ke(a && (a.kind === "Variable" || a.kind === "BooleanValue"), 108, i), t.push({ directive: n, ifArgument: o });
    }
  }), t;
}
function rJ(e) {
  var t, n, r = (t = e.directives) === null || t === void 0 ? void 0 : t.find(function(o) {
    var a = o.name;
    return a.value === "unmask";
  });
  if (!r)
    return "mask";
  var i = (n = r.arguments) === null || n === void 0 ? void 0 : n.find(function(o) {
    var a = o.name;
    return a.value === "mode";
  });
  return globalThis.__DEV__ !== !1 && i && (i.value.kind === Ht.VARIABLE ? globalThis.__DEV__ !== !1 && ke.warn(109) : i.value.kind !== Ht.STRING ? globalThis.__DEV__ !== !1 && ke.warn(110) : i.value.value !== "migrate" && globalThis.__DEV__ !== !1 && ke.warn(111, i.value.value)), i && "value" in i.value && i.value.value === "migrate" ? "migrate" : "unmask";
}
const iJ = () => /* @__PURE__ */ Object.create(null), { forEach: oJ, slice: D2 } = Array.prototype, { hasOwnProperty: aJ } = Object.prototype;
class ro {
  constructor(t = !0, n = iJ) {
    this.weakness = t, this.makeData = n;
  }
  lookup() {
    return this.lookupArray(arguments);
  }
  lookupArray(t) {
    let n = this;
    return oJ.call(t, (r) => n = n.getChildTrie(r)), aJ.call(n, "data") ? n.data : n.data = this.makeData(D2.call(t));
  }
  peek() {
    return this.peekArray(arguments);
  }
  peekArray(t) {
    let n = this;
    for (let r = 0, i = t.length; n && r < i; ++r) {
      const o = n.mapFor(t[r], !1);
      n = o && o.get(t[r]);
    }
    return n && n.data;
  }
  remove() {
    return this.removeArray(arguments);
  }
  removeArray(t) {
    let n;
    if (t.length) {
      const r = t[0], i = this.mapFor(r, !1), o = i && i.get(r);
      o && (n = o.removeArray(D2.call(t, 1)), !o.data && !o.weak && !(o.strong && o.strong.size) && i.delete(r));
    } else
      n = this.data, delete this.data;
    return n;
  }
  getChildTrie(t) {
    const n = this.mapFor(t, !0);
    let r = n.get(t);
    return r || n.set(t, r = new ro(this.weakness, this.makeData)), r;
  }
  mapFor(t, n) {
    return this.weakness && sJ(t) ? this.weak || (n ? this.weak = /* @__PURE__ */ new WeakMap() : void 0) : this.strong || (n ? this.strong = /* @__PURE__ */ new Map() : void 0);
  }
}
function sJ(e) {
  switch (typeof e) {
    case "object":
      if (e === null)
        break;
    // Fall through to return true...
    case "function":
      return !0;
  }
  return !1;
}
var lJ = Jr(function() {
  return navigator.product;
}) == "ReactNative", Za = typeof WeakMap == "function" && !(lJ && !global.HermesInternal), P0 = typeof WeakSet == "function", gC = typeof Symbol == "function" && typeof Symbol.for == "function", Wp = gC && Symbol.asyncIterator;
Jr(function() {
  return window.document.createElement;
});
Jr(function() {
  return navigator.userAgent.indexOf("jsdom") >= 0;
});
function zt(e) {
  return e !== null && typeof e == "object";
}
function uJ(e, t) {
  var n = t, r = [];
  e.definitions.forEach(function(o) {
    if (o.kind === "OperationDefinition")
      throw Zn(
        112,
        o.operation,
        o.name ? " named '".concat(o.name.value, "'") : ""
      );
    o.kind === "FragmentDefinition" && r.push(o);
  }), typeof n > "u" && (ke(r.length === 1, 113, r.length), n = r[0].name.value);
  var i = Z(Z({}, e), { definitions: On([
    {
      kind: "OperationDefinition",
      // OperationTypeNode is an enum
      operation: "query",
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "FragmentSpread",
            name: {
              kind: "Name",
              value: n
            }
          }
        ]
      }
    }
  ], e.definitions, !0) });
  return i;
}
function xl(e) {
  e === void 0 && (e = []);
  var t = {};
  return e.forEach(function(n) {
    t[n.name.value] = n;
  }), t;
}
function Zp(e, t) {
  switch (e.kind) {
    case "InlineFragment":
      return e;
    case "FragmentSpread": {
      var n = e.name.value;
      if (typeof t == "function")
        return t(n);
      var r = t && t[n];
      return ke(r, 114, n), r || null;
    }
    default:
      return null;
  }
}
function cJ(e) {
  var t = !0;
  return li(e, {
    FragmentSpread: function(n) {
      if (t = !!n.directives && n.directives.some(function(r) {
        return r.name.value === "unmask";
      }), !t)
        return Hp;
    }
  }), t;
}
function fJ() {
}
class jg {
  constructor(t = 1 / 0, n = fJ) {
    this.max = t, this.dispose = n, this.map = /* @__PURE__ */ new Map(), this.newest = null, this.oldest = null;
  }
  has(t) {
    return this.map.has(t);
  }
  get(t) {
    const n = this.getNode(t);
    return n && n.value;
  }
  get size() {
    return this.map.size;
  }
  getNode(t) {
    const n = this.map.get(t);
    if (n && n !== this.newest) {
      const { older: r, newer: i } = n;
      i && (i.older = r), r && (r.newer = i), n.older = this.newest, n.older.newer = n, n.newer = null, this.newest = n, n === this.oldest && (this.oldest = i);
    }
    return n;
  }
  set(t, n) {
    let r = this.getNode(t);
    return r ? r.value = n : (r = {
      key: t,
      value: n,
      newer: null,
      older: this.newest
    }, this.newest && (this.newest.newer = r), this.newest = r, this.oldest = this.oldest || r, this.map.set(t, r), r.value);
  }
  clean() {
    for (; this.oldest && this.map.size > this.max; )
      this.delete(this.oldest.key);
  }
  delete(t) {
    const n = this.map.get(t);
    return n ? (n === this.newest && (this.newest = n.older), n === this.oldest && (this.oldest = n.newer), n.newer && (n.newer.older = n.older), n.older && (n.older.newer = n.newer), this.map.delete(t), this.dispose(n.value, t), !0) : !1;
  }
}
function Fg() {
}
const dJ = Fg, pJ = typeof WeakRef < "u" ? WeakRef : function(e) {
  return { deref: () => e };
}, hJ = typeof WeakMap < "u" ? WeakMap : Map, mJ = typeof FinalizationRegistry < "u" ? FinalizationRegistry : function() {
  return {
    register: Fg,
    unregister: Fg
  };
}, vJ = 10024;
class zd {
  constructor(t = 1 / 0, n = dJ) {
    this.max = t, this.dispose = n, this.map = new hJ(), this.newest = null, this.oldest = null, this.unfinalizedNodes = /* @__PURE__ */ new Set(), this.finalizationScheduled = !1, this.size = 0, this.finalize = () => {
      const r = this.unfinalizedNodes.values();
      for (let i = 0; i < vJ; i++) {
        const o = r.next().value;
        if (!o)
          break;
        this.unfinalizedNodes.delete(o);
        const a = o.key;
        delete o.key, o.keyRef = new pJ(a), this.registry.register(a, o, o);
      }
      this.unfinalizedNodes.size > 0 ? queueMicrotask(this.finalize) : this.finalizationScheduled = !1;
    }, this.registry = new mJ(this.deleteNode.bind(this));
  }
  has(t) {
    return this.map.has(t);
  }
  get(t) {
    const n = this.getNode(t);
    return n && n.value;
  }
  getNode(t) {
    const n = this.map.get(t);
    if (n && n !== this.newest) {
      const { older: r, newer: i } = n;
      i && (i.older = r), r && (r.newer = i), n.older = this.newest, n.older.newer = n, n.newer = null, this.newest = n, n === this.oldest && (this.oldest = i);
    }
    return n;
  }
  set(t, n) {
    let r = this.getNode(t);
    return r ? r.value = n : (r = {
      key: t,
      value: n,
      newer: null,
      older: this.newest
    }, this.newest && (this.newest.newer = r), this.newest = r, this.oldest = this.oldest || r, this.scheduleFinalization(r), this.map.set(t, r), this.size++, r.value);
  }
  clean() {
    for (; this.oldest && this.size > this.max; )
      this.deleteNode(this.oldest);
  }
  deleteNode(t) {
    t === this.newest && (this.newest = t.older), t === this.oldest && (this.oldest = t.newer), t.newer && (t.newer.older = t.older), t.older && (t.older.newer = t.newer), this.size--;
    const n = t.key || t.keyRef && t.keyRef.deref();
    this.dispose(t.value, n), t.keyRef ? this.registry.unregister(t) : this.unfinalizedNodes.delete(t), n && this.map.delete(n);
  }
  delete(t) {
    const n = this.map.get(t);
    return n ? (this.deleteNode(n), !0) : !1;
  }
  scheduleFinalization(t) {
    this.unfinalizedNodes.add(t), this.finalizationScheduled || (this.finalizationScheduled = !0, queueMicrotask(this.finalize));
  }
}
var wm = /* @__PURE__ */ new WeakSet();
function yC(e) {
  e.size <= (e.max || -1) || wm.has(e) || (wm.add(e), setTimeout(function() {
    e.clean(), wm.delete(e);
  }, 100));
}
var bC = function(e, t) {
  var n = new zd(e, t);
  return n.set = function(r, i) {
    var o = zd.prototype.set.call(this, r, i);
    return yC(this), o;
  }, n;
}, gJ = function(e, t) {
  var n = new jg(e, t);
  return n.set = function(r, i) {
    var o = jg.prototype.set.call(this, r, i);
    return yC(this), o;
  }, n;
}, yJ = Symbol.for("apollo.cacheSize"), Ji = Z({}, Fd[yJ]), ta = {};
function _C(e, t) {
  ta[e] = t;
}
var bJ = globalThis.__DEV__ !== !1 ? EJ : void 0, _J = globalThis.__DEV__ !== !1 ? SJ : void 0, wJ = globalThis.__DEV__ !== !1 ? wC : void 0;
function xJ() {
  var e = {
    parser: 1e3,
    canonicalStringify: 1e3,
    print: 2e3,
    "documentTransform.cache": 2e3,
    "queryManager.getDocumentInfo": 2e3,
    "PersistedQueryLink.persistedQueryHashes": 2e3,
    "fragmentRegistry.transform": 2e3,
    "fragmentRegistry.lookup": 1e3,
    "fragmentRegistry.findFragmentSpreads": 4e3,
    "cache.fragmentQueryDocuments": 1e3,
    "removeTypenameFromVariables.getVariableDefinitions": 2e3,
    "inMemoryCache.maybeBroadcastWatch": 5e3,
    "inMemoryCache.executeSelectionSet": 5e4,
    "inMemoryCache.executeSubSelectedArray": 1e4
  };
  return Object.fromEntries(Object.entries(e).map(function(t) {
    var n = t[0], r = t[1];
    return [
      n,
      Ji[n] || r
    ];
  }));
}
function EJ() {
  var e, t, n, r, i;
  if (globalThis.__DEV__ === !1)
    throw new Error("only supported in development mode");
  return {
    limits: xJ(),
    sizes: Z({ print: (e = ta.print) === null || e === void 0 ? void 0 : e.call(ta), parser: (t = ta.parser) === null || t === void 0 ? void 0 : t.call(ta), canonicalStringify: (n = ta.canonicalStringify) === null || n === void 0 ? void 0 : n.call(ta), links: Lg(this.link), queryManager: {
      getDocumentInfo: this.queryManager.transformCache.size,
      documentTransforms: EC(this.queryManager.documentTransform)
    } }, (i = (r = this.cache).getMemoryInternals) === null || i === void 0 ? void 0 : i.call(r))
  };
}
function wC() {
  return {
    cache: {
      fragmentQueryDocuments: po(this.getFragmentDoc)
    }
  };
}
function SJ() {
  var e = this.config.fragments;
  return Z(Z({}, wC.apply(this)), { addTypenameDocumentTransform: EC(this.addTypenameTransform), inMemoryCache: {
    executeSelectionSet: po(this.storeReader.executeSelectionSet),
    executeSubSelectedArray: po(this.storeReader.executeSubSelectedArray),
    maybeBroadcastWatch: po(this.maybeBroadcastWatch)
  }, fragmentRegistry: {
    findFragmentSpreads: po(e?.findFragmentSpreads),
    lookup: po(e?.lookup),
    transform: po(e?.transform)
  } });
}
function $J(e) {
  return !!e && "dirtyKey" in e;
}
function po(e) {
  return $J(e) ? e.size : void 0;
}
function xC(e) {
  return e != null;
}
function EC(e) {
  return zg(e).map(function(t) {
    return { cache: t };
  });
}
function zg(e) {
  return e ? On(On([
    po(e?.performWork)
  ], zg(e?.left), !0), zg(e?.right), !0).filter(xC) : [];
}
function Lg(e) {
  var t;
  return e ? On(On([
    (t = e?.getMemoryInternals) === null || t === void 0 ? void 0 : t.call(e)
  ], Lg(e?.left), !0), Lg(e?.right), !0).filter(xC) : [];
}
var xo = Object.assign(function(e) {
  return JSON.stringify(e, kJ);
}, {
  reset: function() {
    gs = new gJ(
      Ji.canonicalStringify || 1e3
      /* defaultCacheSizes.canonicalStringify */
    );
  }
});
globalThis.__DEV__ !== !1 && _C("canonicalStringify", function() {
  return gs.size;
});
var gs;
xo.reset();
function kJ(e, t) {
  if (t && typeof t == "object") {
    var n = Object.getPrototypeOf(t);
    if (n === Object.prototype || n === null) {
      var r = Object.keys(t);
      if (r.every(TJ))
        return t;
      var i = JSON.stringify(r), o = gs.get(i);
      if (!o) {
        r.sort();
        var a = JSON.stringify(r);
        o = gs.get(a) || r, gs.set(i, o), gs.set(a, o);
      }
      var s = Object.create(n);
      return o.forEach(function(l) {
        s[l] = t[l];
      }), s;
    }
  }
  return t;
}
function TJ(e, t, n) {
  return t === 0 || n[t - 1] <= e;
}
function Ts(e) {
  return { __ref: String(e) };
}
function yt(e) {
  return !!(e && typeof e == "object" && typeof e.__ref == "string");
}
function OJ(e) {
  return zt(e) && e.kind === "Document" && Array.isArray(e.definitions);
}
function PJ(e) {
  return e.kind === "StringValue";
}
function AJ(e) {
  return e.kind === "BooleanValue";
}
function DJ(e) {
  return e.kind === "IntValue";
}
function CJ(e) {
  return e.kind === "FloatValue";
}
function IJ(e) {
  return e.kind === "Variable";
}
function MJ(e) {
  return e.kind === "ObjectValue";
}
function RJ(e) {
  return e.kind === "ListValue";
}
function NJ(e) {
  return e.kind === "EnumValue";
}
function jJ(e) {
  return e.kind === "NullValue";
}
function Gs(e, t, n, r) {
  if (DJ(n) || CJ(n))
    e[t.value] = Number(n.value);
  else if (AJ(n) || PJ(n))
    e[t.value] = n.value;
  else if (MJ(n)) {
    var i = {};
    n.fields.map(function(a) {
      return Gs(i, a.name, a.value, r);
    }), e[t.value] = i;
  } else if (IJ(n)) {
    var o = (r || {})[n.name.value];
    e[t.value] = o;
  } else if (RJ(n))
    e[t.value] = n.values.map(function(a) {
      var s = {};
      return Gs(s, t, a, r), s[t.value];
    });
  else if (NJ(n))
    e[t.value] = n.value;
  else if (jJ(n))
    e[t.value] = null;
  else
    throw Zn(123, t.value, n.kind);
}
function FJ(e, t) {
  var n = null;
  e.directives && (n = {}, e.directives.forEach(function(i) {
    n[i.name.value] = {}, i.arguments && i.arguments.forEach(function(o) {
      var a = o.name, s = o.value;
      return Gs(n[i.name.value], a, s, t);
    });
  }));
  var r = null;
  return e.arguments && e.arguments.length && (r = {}, e.arguments.forEach(function(i) {
    var o = i.name, a = i.value;
    return Gs(r, o, a, t);
  })), SC(e.name.value, r, n);
}
var zJ = [
  "connection",
  "include",
  "skip",
  "client",
  "rest",
  "export",
  "nonreactive"
], Ll = xo, SC = Object.assign(function(e, t, n) {
  if (t && n && n.connection && n.connection.key)
    if (n.connection.filter && n.connection.filter.length > 0) {
      var r = n.connection.filter ? n.connection.filter : [];
      r.sort();
      var i = {};
      return r.forEach(function(s) {
        i[s] = t[s];
      }), "".concat(n.connection.key, "(").concat(Ll(i), ")");
    } else
      return n.connection.key;
  var o = e;
  if (t) {
    var a = Ll(t);
    o += "(".concat(a, ")");
  }
  return n && Object.keys(n).forEach(function(s) {
    zJ.indexOf(s) === -1 && (n[s] && Object.keys(n[s]).length ? o += "@".concat(s, "(").concat(Ll(n[s]), ")") : o += "@".concat(s));
  }), o;
}, {
  setStringify: function(e) {
    var t = Ll;
    return Ll = e, t;
  }
});
function Gp(e, t) {
  if (e.arguments && e.arguments.length) {
    var n = {};
    return e.arguments.forEach(function(r) {
      var i = r.name, o = r.value;
      return Gs(n, i, o, t);
    }), n;
  }
  return null;
}
function Xi(e) {
  return e.alias ? e.alias.value : e.name.value;
}
function Vg(e, t, n) {
  for (var r, i = 0, o = t.selections; i < o.length; i++) {
    var a = o[i];
    if (Io(a)) {
      if (a.name.value === "__typename")
        return e[Xi(a)];
    } else r ? r.push(a) : r = [a];
  }
  if (typeof e.__typename == "string")
    return e.__typename;
  if (r)
    for (var s = 0, l = r; s < l.length; s++) {
      var a = l[s], u = Vg(e, Zp(a, n).selectionSet, n);
      if (typeof u == "string")
        return u;
    }
}
function Io(e) {
  return e.kind === "Field";
}
function LJ(e) {
  return e.kind === "InlineFragment";
}
function El(e) {
  ke(e && e.kind === "Document", 115);
  var t = e.definitions.filter(function(n) {
    return n.kind !== "FragmentDefinition";
  }).map(function(n) {
    if (n.kind !== "OperationDefinition")
      throw Zn(116, n.kind);
    return n;
  });
  return ke(t.length <= 1, 117, t.length), e;
}
function Ca(e) {
  return El(e), e.definitions.filter(function(t) {
    return t.kind === "OperationDefinition";
  })[0];
}
function eu(e) {
  return e.definitions.filter(function(t) {
    return t.kind === "OperationDefinition" && !!t.name;
  }).map(function(t) {
    return t.name.value;
  })[0] || null;
}
function Sl(e) {
  return e.definitions.filter(function(t) {
    return t.kind === "FragmentDefinition";
  });
}
function $C(e) {
  var t = Ca(e);
  return ke(t && t.operation === "query", 118), t;
}
function kC(e) {
  ke(e.kind === "Document", 119), ke(e.definitions.length <= 1, 120);
  var t = e.definitions[0];
  return ke(t.kind === "FragmentDefinition", 121), t;
}
function xc(e) {
  El(e);
  for (var t, n = 0, r = e.definitions; n < r.length; n++) {
    var i = r[n];
    if (i.kind === "OperationDefinition") {
      var o = i.operation;
      if (o === "query" || o === "mutation" || o === "subscription")
        return i;
    }
    i.kind === "FragmentDefinition" && !t && (t = i);
  }
  if (t)
    return t;
  throw Zn(122);
}
function A0(e) {
  var t = /* @__PURE__ */ Object.create(null), n = e && e.variableDefinitions;
  return n && n.length && n.forEach(function(r) {
    r.defaultValue && Gs(t, r.variable.name, r.defaultValue);
  }), t;
}
let _n = null;
const C2 = {};
let VJ = 1;
const BJ = () => class {
  constructor() {
    this.id = [
      "slot",
      VJ++,
      Date.now(),
      Math.random().toString(36).slice(2)
    ].join(":");
  }
  hasValue() {
    for (let e = _n; e; e = e.parent)
      if (this.id in e.slots) {
        const t = e.slots[this.id];
        if (t === C2)
          break;
        return e !== _n && (_n.slots[this.id] = t), !0;
      }
    return _n && (_n.slots[this.id] = C2), !1;
  }
  getValue() {
    if (this.hasValue())
      return _n.slots[this.id];
  }
  withValue(e, t, n, r) {
    const i = {
      __proto__: null,
      [this.id]: e
    }, o = _n;
    _n = { parent: o, slots: i };
    try {
      return t.apply(r, n);
    } finally {
      _n = o;
    }
  }
  // Capture the current context and wrap a callback function so that it
  // reestablishes the captured context when called.
  static bind(e) {
    const t = _n;
    return function() {
      const n = _n;
      try {
        return _n = t, e.apply(this, arguments);
      } finally {
        _n = n;
      }
    };
  }
  // Immediately run a callback function without any captured context.
  static noContext(e, t, n) {
    if (_n) {
      const r = _n;
      try {
        return _n = null, e.apply(n, t);
      } finally {
        _n = r;
      }
    } else
      return e.apply(n, t);
  }
};
function I2(e) {
  try {
    return e();
  } catch {
  }
}
const xm = "@wry/context:Slot", KJ = (
  // Prefer globalThis when available.
  // https://github.com/benjamn/wryware/issues/347
  I2(() => globalThis) || // Fall back to global, which works in Node.js and may be converted by some
  // bundlers to the appropriate identifier (window, self, ...) depending on the
  // bundling target. https://github.com/endojs/endo/issues/576#issuecomment-1178515224
  I2(() => global) || // Otherwise, use a dummy host that's local to this module. We used to fall
  // back to using the Array constructor as a namespace, but that was flagged in
  // https://github.com/benjamn/wryware/issues/347, and can be avoided.
  /* @__PURE__ */ Object.create(null)
), M2 = KJ, $l = M2[xm] || // Earlier versions of this package stored the globalKey property on the Array
// constructor, so we check there as well, to prevent Slot class duplication.
Array[xm] || (function(e) {
  try {
    Object.defineProperty(M2, xm, {
      value: e,
      enumerable: !1,
      writable: !1,
      // When it was possible for globalHost to be the Array constructor (a
      // legacy Slot dedup strategy), it was important for the property to be
      // configurable:true so it could be deleted. That does not seem to be as
      // important when globalHost is the global object, but I don't want to
      // cause similar problems again, and configurable:true seems safest.
      // https://github.com/endojs/endo/issues/576#issuecomment-1178274008
      configurable: !0
    });
  } finally {
    return e;
  }
})(BJ()), { bind: dse, noContext: pse } = $l, Yp = new $l(), { hasOwnProperty: UJ } = Object.prototype, D0 = Array.from || function(e) {
  const t = [];
  return e.forEach((n) => t.push(n)), t;
};
function C0(e) {
  const { unsubscribe: t } = e;
  typeof t == "function" && (e.unsubscribe = void 0, t());
}
const Uu = [], qJ = 100;
function Ys(e, t) {
  if (!e)
    throw new Error(t || "assertion failure");
}
function TC(e, t) {
  const n = e.length;
  return (
    // Unknown values are not equal to each other.
    n > 0 && // Both values must be ordinary (or both exceptional) to be equal.
    n === t.length && // The underlying value or exception must be the same.
    e[n - 1] === t[n - 1]
  );
}
function OC(e) {
  switch (e.length) {
    case 0:
      throw new Error("unknown value");
    case 1:
      return e[0];
    case 2:
      throw e[1];
  }
}
function PC(e) {
  return e.slice(0);
}
class Qp {
  constructor(t) {
    this.fn = t, this.parents = /* @__PURE__ */ new Set(), this.childValues = /* @__PURE__ */ new Map(), this.dirtyChildren = null, this.dirty = !0, this.recomputing = !1, this.value = [], this.deps = null, ++Qp.count;
  }
  peek() {
    if (this.value.length === 1 && !Mo(this))
      return R2(this), this.value[0];
  }
  // This is the most important method of the Entry API, because it
  // determines whether the cached this.value can be returned immediately,
  // or must be recomputed. The overall performance of the caching system
  // depends on the truth of the following observations: (1) this.dirty is
  // usually false, (2) this.dirtyChildren is usually null/empty, and thus
  // (3) valueGet(this.value) is usually returned without recomputation.
  recompute(t) {
    return Ys(!this.recomputing, "already recomputing"), R2(this), Mo(this) ? HJ(this, t) : OC(this.value);
  }
  setDirty() {
    this.dirty || (this.dirty = !0, AC(this), C0(this));
  }
  dispose() {
    this.setDirty(), RC(this), I0(this, (t, n) => {
      t.setDirty(), NC(t, this);
    });
  }
  forget() {
    this.dispose();
  }
  dependOn(t) {
    t.add(this), this.deps || (this.deps = Uu.pop() || /* @__PURE__ */ new Set()), this.deps.add(t);
  }
  forgetDeps() {
    this.deps && (D0(this.deps).forEach((t) => t.delete(this)), this.deps.clear(), Uu.push(this.deps), this.deps = null);
  }
}
Qp.count = 0;
function R2(e) {
  const t = Yp.getValue();
  if (t)
    return e.parents.add(t), t.childValues.has(e) || t.childValues.set(e, []), Mo(e) ? CC(t, e) : IC(t, e), t;
}
function HJ(e, t) {
  return RC(e), Yp.withValue(e, WJ, [e, t]), GJ(e, t) && ZJ(e), OC(e.value);
}
function WJ(e, t) {
  e.recomputing = !0;
  const { normalizeResult: n } = e;
  let r;
  n && e.value.length === 1 && (r = PC(e.value)), e.value.length = 0;
  try {
    if (e.value[0] = e.fn.apply(null, t), n && r && !TC(r, e.value))
      try {
        e.value[0] = n(e.value[0], r[0]);
      } catch {
      }
  } catch (i) {
    e.value[1] = i;
  }
  e.recomputing = !1;
}
function Mo(e) {
  return e.dirty || !!(e.dirtyChildren && e.dirtyChildren.size);
}
function ZJ(e) {
  e.dirty = !1, !Mo(e) && DC(e);
}
function AC(e) {
  I0(e, CC);
}
function DC(e) {
  I0(e, IC);
}
function I0(e, t) {
  const n = e.parents.size;
  if (n) {
    const r = D0(e.parents);
    for (let i = 0; i < n; ++i)
      t(r[i], e);
  }
}
function CC(e, t) {
  Ys(e.childValues.has(t)), Ys(Mo(t));
  const n = !Mo(e);
  if (!e.dirtyChildren)
    e.dirtyChildren = Uu.pop() || /* @__PURE__ */ new Set();
  else if (e.dirtyChildren.has(t))
    return;
  e.dirtyChildren.add(t), n && AC(e);
}
function IC(e, t) {
  Ys(e.childValues.has(t)), Ys(!Mo(t));
  const n = e.childValues.get(t);
  n.length === 0 ? e.childValues.set(t, PC(t.value)) : TC(n, t.value) || e.setDirty(), MC(e, t), !Mo(e) && DC(e);
}
function MC(e, t) {
  const n = e.dirtyChildren;
  n && (n.delete(t), n.size === 0 && (Uu.length < qJ && Uu.push(n), e.dirtyChildren = null));
}
function RC(e) {
  e.childValues.size > 0 && e.childValues.forEach((t, n) => {
    NC(e, n);
  }), e.forgetDeps(), Ys(e.dirtyChildren === null);
}
function NC(e, t) {
  t.parents.delete(e), e.childValues.delete(t), MC(e, t);
}
function GJ(e, t) {
  if (typeof e.subscribe == "function")
    try {
      C0(e), e.unsubscribe = e.subscribe.apply(null, t);
    } catch {
      return e.setDirty(), !1;
    }
  return !0;
}
const YJ = {
  setDirty: !0,
  dispose: !0,
  forget: !0
  // Fully remove parent Entry from LRU cache and computation graph
};
function jC(e) {
  const t = /* @__PURE__ */ new Map();
  function n(r) {
    const i = Yp.getValue();
    if (i) {
      let o = t.get(r);
      o || t.set(r, o = /* @__PURE__ */ new Set()), i.dependOn(o);
    }
  }
  return n.dirty = function(r, i) {
    const o = t.get(r);
    if (o) {
      const a = i && UJ.call(YJ, i) ? i : "setDirty";
      D0(o).forEach((s) => s[a]()), t.delete(r), C0(o);
    }
  }, n;
}
let N2;
function QJ(...e) {
  return (N2 || (N2 = new ro(typeof WeakMap == "function"))).lookupArray(e);
}
const Em = /* @__PURE__ */ new Set();
function qu(e, { max: t = Math.pow(2, 16), keyArgs: n, makeCacheKey: r = QJ, normalizeResult: i, subscribe: o, cache: a = jg } = /* @__PURE__ */ Object.create(null)) {
  const s = typeof a == "function" ? new a(t, (d) => d.dispose()) : a, l = function() {
    const d = r.apply(null, n ? n.apply(null, arguments) : arguments);
    if (d === void 0)
      return e.apply(null, arguments);
    let p = s.get(d);
    p || (s.set(d, p = new Qp(e)), p.normalizeResult = i, p.subscribe = o, p.forget = () => s.delete(d));
    const h = p.recompute(Array.prototype.slice.call(arguments));
    return s.set(d, p), Em.add(s), Yp.hasValue() || (Em.forEach((v) => v.clean()), Em.clear()), h;
  };
  Object.defineProperty(l, "size", {
    get: () => s.size,
    configurable: !1,
    enumerable: !1
  }), Object.freeze(l.options = {
    max: t,
    keyArgs: n,
    makeCacheKey: r,
    normalizeResult: i,
    subscribe: o,
    cache: s
  });
  function u(d) {
    const p = d && s.get(d);
    p && p.setDirty();
  }
  l.dirtyKey = u, l.dirty = function() {
    u(r.apply(null, arguments));
  };
  function c(d) {
    const p = d && s.get(d);
    if (p)
      return p.peek();
  }
  l.peekKey = c, l.peek = function() {
    return c(r.apply(null, arguments));
  };
  function f(d) {
    return d ? s.delete(d) : !1;
  }
  return l.forgetKey = f, l.forget = function() {
    return f(r.apply(null, arguments));
  }, l.makeCacheKey = r, l.getKey = n ? function() {
    return r.apply(null, n.apply(null, arguments));
  } : r, Object.freeze(l);
}
function JJ(e) {
  return e;
}
var FC = (
  /** @class */
  (function() {
    function e(t, n) {
      n === void 0 && (n = /* @__PURE__ */ Object.create(null)), this.resultCache = P0 ? /* @__PURE__ */ new WeakSet() : /* @__PURE__ */ new Set(), this.transform = t, n.getCacheKey && (this.getCacheKey = n.getCacheKey), this.cached = n.cache !== !1, this.resetCache();
    }
    return e.prototype.getCacheKey = function(t) {
      return [t];
    }, e.identity = function() {
      return new e(JJ, { cache: !1 });
    }, e.split = function(t, n, r) {
      return r === void 0 && (r = e.identity()), Object.assign(new e(
        function(i) {
          var o = t(i) ? n : r;
          return o.transformDocument(i);
        },
        // Reasonably assume both `left` and `right` transforms handle their own caching
        { cache: !1 }
      ), { left: n, right: r });
    }, e.prototype.resetCache = function() {
      var t = this;
      if (this.cached) {
        var n = new ro(Za);
        this.performWork = qu(e.prototype.performWork.bind(this), {
          makeCacheKey: function(r) {
            var i = t.getCacheKey(r);
            if (i)
              return ke(Array.isArray(i), 104), n.lookupArray(i);
          },
          max: Ji["documentTransform.cache"],
          cache: zd
        });
      }
    }, e.prototype.performWork = function(t) {
      return El(t), this.transform(t);
    }, e.prototype.transformDocument = function(t) {
      if (this.resultCache.has(t))
        return t;
      var n = this.performWork(t);
      return this.resultCache.add(n), n;
    }, e.prototype.concat = function(t) {
      var n = this;
      return Object.assign(new e(
        function(r) {
          return t.transformDocument(n.transformDocument(r));
        },
        // Reasonably assume both transforms handle their own caching
        { cache: !1 }
      ), {
        left: this,
        right: t
      });
    }, e;
  })()
), pu, _o = Object.assign(function(e) {
  var t = pu.get(e);
  return t || (t = YQ(e), pu.set(e, t)), t;
}, {
  reset: function() {
    pu = new bC(
      Ji.print || 2e3
      /* defaultCacheSizes.print */
    );
  }
});
_o.reset();
globalThis.__DEV__ !== !1 && _C("print", function() {
  return pu ? pu.size : 0;
});
var Jt = Array.isArray;
function Ci(e) {
  return Array.isArray(e) && e.length > 0;
}
var j2 = {
  kind: Ht.FIELD,
  name: {
    kind: Ht.NAME,
    value: "__typename"
  }
};
function zC(e, t) {
  return !e || e.selectionSet.selections.every(function(n) {
    return n.kind === Ht.FRAGMENT_SPREAD && zC(t[n.name.value], t);
  });
}
function XJ(e) {
  return zC(Ca(e) || kC(e), xl(Sl(e))) ? null : e;
}
function eX(e) {
  var t = /* @__PURE__ */ new Map(), n = /* @__PURE__ */ new Map();
  return e.forEach(function(r) {
    r && (r.name ? t.set(r.name, r) : r.test && n.set(r.test, r));
  }), function(r) {
    var i = t.get(r.name.value);
    return !i && n.size && n.forEach(function(o, a) {
      a(r) && (i = o);
    }), i;
  };
}
function F2(e) {
  var t = /* @__PURE__ */ new Map();
  return function(n) {
    n === void 0 && (n = e);
    var r = t.get(n);
    return r || t.set(n, r = {
      // Variable and fragment spread names used directly within this
      // operation or fragment definition, as identified by key. These sets
      // will be populated during the first traversal of the document in
      // removeDirectivesFromDocument below.
      variables: /* @__PURE__ */ new Set(),
      fragmentSpreads: /* @__PURE__ */ new Set()
    }), r;
  };
}
function LC(e, t) {
  El(t);
  for (var n = F2(""), r = F2(""), i = function(g) {
    for (var _ = 0, x = void 0; _ < g.length && (x = g[_]); ++_)
      if (!Jt(x)) {
        if (x.kind === Ht.OPERATION_DEFINITION)
          return n(x.name && x.name.value);
        if (x.kind === Ht.FRAGMENT_DEFINITION)
          return r(x.name.value);
      }
    return globalThis.__DEV__ !== !1 && ke.error(124), null;
  }, o = 0, a = t.definitions.length - 1; a >= 0; --a)
    t.definitions[a].kind === Ht.OPERATION_DEFINITION && ++o;
  var s = eX(e), l = function(g) {
    return Ci(g) && g.map(s).some(function(_) {
      return _ && _.remove;
    });
  }, u = /* @__PURE__ */ new Map(), c = !1, f = {
    enter: function(g) {
      if (l(g.directives))
        return c = !0, null;
    }
  }, d = li(t, {
    // These two AST node types share the same implementation, defined above.
    Field: f,
    InlineFragment: f,
    VariableDefinition: {
      enter: function() {
        return !1;
      }
    },
    Variable: {
      enter: function(g, _, x, w, $) {
        var k = i($);
        k && k.variables.add(g.name.value);
      }
    },
    FragmentSpread: {
      enter: function(g, _, x, w, $) {
        if (l(g.directives))
          return c = !0, null;
        var k = i($);
        k && k.fragmentSpreads.add(g.name.value);
      }
    },
    FragmentDefinition: {
      enter: function(g, _, x, w) {
        u.set(JSON.stringify(w), g);
      },
      leave: function(g, _, x, w) {
        var $ = u.get(JSON.stringify(w));
        if (g === $)
          return g;
        if (
          // This logic applies only if the document contains one or more
          // operations, since removing all fragments from a document containing
          // only fragments makes the document useless.
          o > 0 && g.selectionSet.selections.every(function(k) {
            return k.kind === Ht.FIELD && k.name.value === "__typename";
          })
        )
          return r(g.name.value).removed = !0, c = !0, null;
      }
    },
    Directive: {
      leave: function(g) {
        if (s(g))
          return c = !0, null;
      }
    }
  });
  if (!c)
    return t;
  var p = function(g) {
    return g.transitiveVars || (g.transitiveVars = new Set(g.variables), g.removed || g.fragmentSpreads.forEach(function(_) {
      p(r(_)).transitiveVars.forEach(function(x) {
        g.transitiveVars.add(x);
      });
    })), g;
  }, h = /* @__PURE__ */ new Set();
  d.definitions.forEach(function(g) {
    g.kind === Ht.OPERATION_DEFINITION ? p(n(g.name && g.name.value)).fragmentSpreads.forEach(function(_) {
      h.add(_);
    }) : g.kind === Ht.FRAGMENT_DEFINITION && // If there are no operations in the document, then all fragment
    // definitions count as usages of their own fragment names. This heuristic
    // prevents accidentally removing all fragment definitions from the
    // document just because it contains no operations that use the fragments.
    o === 0 && !r(g.name.value).removed && h.add(g.name.value);
  }), h.forEach(function(g) {
    p(r(g)).fragmentSpreads.forEach(function(_) {
      h.add(_);
    });
  });
  var v = function(g) {
    return !!// A fragment definition will be removed if there are no spreads that refer
    // to it, or the fragment was explicitly removed because it had no fields
    // other than __typename.
    (!h.has(g) || r(g).removed);
  }, m = {
    enter: function(g) {
      if (v(g.name.value))
        return null;
    }
  };
  return XJ(li(d, {
    // If the fragment is going to be removed, then leaving any dangling
    // FragmentSpread nodes with the same name would be a mistake.
    FragmentSpread: m,
    // This is where the fragment definition is actually removed.
    FragmentDefinition: m,
    OperationDefinition: {
      leave: function(g) {
        if (g.variableDefinitions) {
          var _ = p(
            // If an operation is anonymous, we use the empty string as its key.
            n(g.name && g.name.value)
          ).transitiveVars;
          if (_.size < g.variableDefinitions.length)
            return Z(Z({}, g), { variableDefinitions: g.variableDefinitions.filter(function(x) {
              return _.has(x.variable.name.value);
            }) });
        }
      }
    }
  }));
}
var M0 = Object.assign(function(e) {
  return li(e, {
    SelectionSet: {
      enter: function(t, n, r) {
        if (!(r && r.kind === Ht.OPERATION_DEFINITION)) {
          var i = t.selections;
          if (i) {
            var o = i.some(function(s) {
              return Io(s) && (s.name.value === "__typename" || s.name.value.lastIndexOf("__", 0) === 0);
            });
            if (!o) {
              var a = r;
              if (!(Io(a) && a.directives && a.directives.some(function(s) {
                return s.name.value === "export";
              })))
                return Z(Z({}, t), { selections: On(On([], i, !0), [j2], !1) });
            }
          }
        }
      }
    }
  });
}, {
  added: function(e) {
    return e === j2;
  }
});
function tX(e) {
  var t = xc(e), n = t.operation;
  if (n === "query")
    return e;
  var r = li(e, {
    OperationDefinition: {
      enter: function(i) {
        return Z(Z({}, i), { operation: "query" });
      }
    }
  });
  return r;
}
function VC(e) {
  El(e);
  var t = LC([
    {
      test: function(n) {
        return n.name.value === "client";
      },
      remove: !0
    }
  ], e);
  return t;
}
function nX(e) {
  return El(e), li(e, {
    FragmentSpread: function(t) {
      var n;
      if (!(!((n = t.directives) === null || n === void 0) && n.some(function(r) {
        return r.name.value === "unmask";
      })))
        return Z(Z({}, t), { directives: On(On([], t.directives || [], !0), [
          {
            kind: Ht.DIRECTIVE,
            name: { kind: Ht.NAME, value: "nonreactive" }
          }
        ], !1) });
    }
  });
}
var rX = Object.prototype.hasOwnProperty;
function z2() {
  for (var e = [], t = 0; t < arguments.length; t++)
    e[t] = arguments[t];
  return Jp(e);
}
function Jp(e) {
  var t = e[0] || {}, n = e.length;
  if (n > 1)
    for (var r = new Ro(), i = 1; i < n; ++i)
      t = r.merge(t, e[i]);
  return t;
}
var iX = function(e, t, n) {
  return this.merge(e[n], t[n]);
}, Ro = (
  /** @class */
  (function() {
    function e(t) {
      t === void 0 && (t = iX), this.reconciler = t, this.isObject = zt, this.pastCopies = /* @__PURE__ */ new Set();
    }
    return e.prototype.merge = function(t, n) {
      for (var r = this, i = [], o = 2; o < arguments.length; o++)
        i[o - 2] = arguments[o];
      return zt(n) && zt(t) ? (Object.keys(n).forEach(function(a) {
        if (rX.call(t, a)) {
          var s = t[a];
          if (n[a] !== s) {
            var l = r.reconciler.apply(r, On([
              t,
              n,
              a
            ], i, !1));
            l !== s && (t = r.shallowCopyForMerge(t), t[a] = l);
          }
        } else
          t = r.shallowCopyForMerge(t), t[a] = n[a];
      }), t) : n;
    }, e.prototype.shallowCopyForMerge = function(t) {
      return zt(t) && (this.pastCopies.has(t) || (Array.isArray(t) ? t = t.slice(0) : t = Z({ __proto__: Object.getPrototypeOf(t) }, t), this.pastCopies.add(t))), t;
    }, e;
  })()
);
function oX(e, t) {
  var n = typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (n) return (n = n.call(e)).next.bind(n);
  if (Array.isArray(e) || (n = aX(e)) || t) {
    n && (e = n);
    var r = 0;
    return function() {
      return r >= e.length ? { done: !0 } : { done: !1, value: e[r++] };
    };
  }
  throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function aX(e, t) {
  if (e) {
    if (typeof e == "string") return L2(e, t);
    var n = Object.prototype.toString.call(e).slice(8, -1);
    if (n === "Object" && e.constructor && (n = e.constructor.name), n === "Map" || n === "Set") return Array.from(e);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return L2(e, t);
  }
}
function L2(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var n = 0, r = new Array(t); n < t; n++)
    r[n] = e[n];
  return r;
}
function V2(e, t) {
  for (var n = 0; n < t.length; n++) {
    var r = t[n];
    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
  }
}
function R0(e, t, n) {
  return t && V2(e.prototype, t), n && V2(e, n), Object.defineProperty(e, "prototype", { writable: !1 }), e;
}
var N0 = function() {
  return typeof Symbol == "function";
}, j0 = function(e) {
  return N0() && !!Symbol[e];
}, F0 = function(e) {
  return j0(e) ? Symbol[e] : "@@" + e;
};
N0() && !j0("observable") && (Symbol.observable = Symbol("observable"));
var sX = F0("iterator"), Bg = F0("observable"), BC = F0("species");
function Ld(e, t) {
  var n = e[t];
  if (n != null) {
    if (typeof n != "function") throw new TypeError(n + " is not a function");
    return n;
  }
}
function Vl(e) {
  var t = e.constructor;
  return t !== void 0 && (t = t[BC], t === null && (t = void 0)), t !== void 0 ? t : Et;
}
function lX(e) {
  return e instanceof Et;
}
function Qs(e) {
  Qs.log ? Qs.log(e) : setTimeout(function() {
    throw e;
  });
}
function Nf(e) {
  Promise.resolve().then(function() {
    try {
      e();
    } catch (t) {
      Qs(t);
    }
  });
}
function KC(e) {
  var t = e._cleanup;
  if (t !== void 0 && (e._cleanup = void 0, !!t))
    try {
      if (typeof t == "function")
        t();
      else {
        var n = Ld(t, "unsubscribe");
        n && n.call(t);
      }
    } catch (r) {
      Qs(r);
    }
}
function Kg(e) {
  e._observer = void 0, e._queue = void 0, e._state = "closed";
}
function uX(e) {
  var t = e._queue;
  if (t) {
    e._queue = void 0, e._state = "ready";
    for (var n = 0; n < t.length && (UC(e, t[n].type, t[n].value), e._state !== "closed"); ++n)
      ;
  }
}
function UC(e, t, n) {
  e._state = "running";
  var r = e._observer;
  try {
    var i = Ld(r, t);
    switch (t) {
      case "next":
        i && i.call(r, n);
        break;
      case "error":
        if (Kg(e), i) i.call(r, n);
        else throw n;
        break;
      case "complete":
        Kg(e), i && i.call(r);
        break;
    }
  } catch (o) {
    Qs(o);
  }
  e._state === "closed" ? KC(e) : e._state === "running" && (e._state = "ready");
}
function Sm(e, t, n) {
  if (e._state !== "closed") {
    if (e._state === "buffering") {
      e._queue.push({
        type: t,
        value: n
      });
      return;
    }
    if (e._state !== "ready") {
      e._state = "buffering", e._queue = [{
        type: t,
        value: n
      }], Nf(function() {
        return uX(e);
      });
      return;
    }
    UC(e, t, n);
  }
}
var cX = /* @__PURE__ */ (function() {
  function e(n, r) {
    this._cleanup = void 0, this._observer = n, this._queue = void 0, this._state = "initializing";
    var i = new fX(this);
    try {
      this._cleanup = r.call(void 0, i);
    } catch (o) {
      i.error(o);
    }
    this._state === "initializing" && (this._state = "ready");
  }
  var t = e.prototype;
  return t.unsubscribe = function() {
    this._state !== "closed" && (Kg(this), KC(this));
  }, R0(e, [{
    key: "closed",
    get: function() {
      return this._state === "closed";
    }
  }]), e;
})(), fX = /* @__PURE__ */ (function() {
  function e(n) {
    this._subscription = n;
  }
  var t = e.prototype;
  return t.next = function(n) {
    Sm(this._subscription, "next", n);
  }, t.error = function(n) {
    Sm(this._subscription, "error", n);
  }, t.complete = function() {
    Sm(this._subscription, "complete");
  }, R0(e, [{
    key: "closed",
    get: function() {
      return this._subscription._state === "closed";
    }
  }]), e;
})(), Et = /* @__PURE__ */ (function() {
  function e(n) {
    if (!(this instanceof e)) throw new TypeError("Observable cannot be called as a function");
    if (typeof n != "function") throw new TypeError("Observable initializer must be a function");
    this._subscriber = n;
  }
  var t = e.prototype;
  return t.subscribe = function(n) {
    return (typeof n != "object" || n === null) && (n = {
      next: n,
      error: arguments[1],
      complete: arguments[2]
    }), new cX(n, this._subscriber);
  }, t.forEach = function(n) {
    var r = this;
    return new Promise(function(i, o) {
      if (typeof n != "function") {
        o(new TypeError(n + " is not a function"));
        return;
      }
      function a() {
        s.unsubscribe(), i();
      }
      var s = r.subscribe({
        next: function(l) {
          try {
            n(l, a);
          } catch (u) {
            o(u), s.unsubscribe();
          }
        },
        error: o,
        complete: i
      });
    });
  }, t.map = function(n) {
    var r = this;
    if (typeof n != "function") throw new TypeError(n + " is not a function");
    var i = Vl(this);
    return new i(function(o) {
      return r.subscribe({
        next: function(a) {
          try {
            a = n(a);
          } catch (s) {
            return o.error(s);
          }
          o.next(a);
        },
        error: function(a) {
          o.error(a);
        },
        complete: function() {
          o.complete();
        }
      });
    });
  }, t.filter = function(n) {
    var r = this;
    if (typeof n != "function") throw new TypeError(n + " is not a function");
    var i = Vl(this);
    return new i(function(o) {
      return r.subscribe({
        next: function(a) {
          try {
            if (!n(a)) return;
          } catch (s) {
            return o.error(s);
          }
          o.next(a);
        },
        error: function(a) {
          o.error(a);
        },
        complete: function() {
          o.complete();
        }
      });
    });
  }, t.reduce = function(n) {
    var r = this;
    if (typeof n != "function") throw new TypeError(n + " is not a function");
    var i = Vl(this), o = arguments.length > 1, a = !1, s = arguments[1], l = s;
    return new i(function(u) {
      return r.subscribe({
        next: function(c) {
          var f = !a;
          if (a = !0, !f || o)
            try {
              l = n(l, c);
            } catch (d) {
              return u.error(d);
            }
          else
            l = c;
        },
        error: function(c) {
          u.error(c);
        },
        complete: function() {
          if (!a && !o) return u.error(new TypeError("Cannot reduce an empty sequence"));
          u.next(l), u.complete();
        }
      });
    });
  }, t.concat = function() {
    for (var n = this, r = arguments.length, i = new Array(r), o = 0; o < r; o++)
      i[o] = arguments[o];
    var a = Vl(this);
    return new a(function(s) {
      var l, u = 0;
      function c(f) {
        l = f.subscribe({
          next: function(d) {
            s.next(d);
          },
          error: function(d) {
            s.error(d);
          },
          complete: function() {
            u === i.length ? (l = void 0, s.complete()) : c(a.from(i[u++]));
          }
        });
      }
      return c(n), function() {
        l && (l.unsubscribe(), l = void 0);
      };
    });
  }, t.flatMap = function(n) {
    var r = this;
    if (typeof n != "function") throw new TypeError(n + " is not a function");
    var i = Vl(this);
    return new i(function(o) {
      var a = [], s = r.subscribe({
        next: function(u) {
          if (n)
            try {
              u = n(u);
            } catch (f) {
              return o.error(f);
            }
          var c = i.from(u).subscribe({
            next: function(f) {
              o.next(f);
            },
            error: function(f) {
              o.error(f);
            },
            complete: function() {
              var f = a.indexOf(c);
              f >= 0 && a.splice(f, 1), l();
            }
          });
          a.push(c);
        },
        error: function(u) {
          o.error(u);
        },
        complete: function() {
          l();
        }
      });
      function l() {
        s.closed && a.length === 0 && o.complete();
      }
      return function() {
        a.forEach(function(u) {
          return u.unsubscribe();
        }), s.unsubscribe();
      };
    });
  }, t[Bg] = function() {
    return this;
  }, e.from = function(n) {
    var r = typeof this == "function" ? this : e;
    if (n == null) throw new TypeError(n + " is not an object");
    var i = Ld(n, Bg);
    if (i) {
      var o = i.call(n);
      if (Object(o) !== o) throw new TypeError(o + " is not an object");
      return lX(o) && o.constructor === r ? o : new r(function(a) {
        return o.subscribe(a);
      });
    }
    if (j0("iterator") && (i = Ld(n, sX), i))
      return new r(function(a) {
        Nf(function() {
          if (!a.closed) {
            for (var s = oX(i.call(n)), l; !(l = s()).done; ) {
              var u = l.value;
              if (a.next(u), a.closed) return;
            }
            a.complete();
          }
        });
      });
    if (Array.isArray(n))
      return new r(function(a) {
        Nf(function() {
          if (!a.closed) {
            for (var s = 0; s < n.length; ++s)
              if (a.next(n[s]), a.closed) return;
            a.complete();
          }
        });
      });
    throw new TypeError(n + " is not observable");
  }, e.of = function() {
    for (var n = arguments.length, r = new Array(n), i = 0; i < n; i++)
      r[i] = arguments[i];
    var o = typeof this == "function" ? this : e;
    return new o(function(a) {
      Nf(function() {
        if (!a.closed) {
          for (var s = 0; s < r.length; ++s)
            if (a.next(r[s]), a.closed) return;
          a.complete();
        }
      });
    });
  }, R0(e, null, [{
    key: BC,
    get: function() {
      return this;
    }
  }]), e;
})();
N0() && Object.defineProperty(Et, Symbol("extensions"), {
  value: {
    symbol: Bg,
    hostReportError: Qs
  },
  configurable: !0
});
function dX(e) {
  var t, n = e.Symbol;
  if (typeof n == "function")
    if (n.observable)
      t = n.observable;
    else {
      typeof n.for == "function" ? t = n.for("https://github.com/benlesh/symbol-observable") : t = n("https://github.com/benlesh/symbol-observable");
      try {
        n.observable = t;
      } catch {
      }
    }
  else
    t = "@@observable";
  return t;
}
var rs;
typeof self < "u" ? rs = self : typeof window < "u" ? rs = window : typeof global < "u" ? rs = global : typeof module < "u" ? rs = module : rs = Function("return this")();
dX(rs);
var B2 = Et.prototype, K2 = "@@observable";
B2[K2] || (B2[K2] = function() {
  return this;
});
function pX(e) {
  return e.catch(function() {
  }), e;
}
var hX = Object.prototype.toString;
function qC(e) {
  return Ug(e);
}
function Ug(e, t) {
  switch (hX.call(e)) {
    case "[object Array]": {
      if (t = t || /* @__PURE__ */ new Map(), t.has(e))
        return t.get(e);
      var n = e.slice(0);
      return t.set(e, n), n.forEach(function(i, o) {
        n[o] = Ug(i, t);
      }), n;
    }
    case "[object Object]": {
      if (t = t || /* @__PURE__ */ new Map(), t.has(e))
        return t.get(e);
      var r = Object.create(Object.getPrototypeOf(e));
      return t.set(e, r), Object.keys(e).forEach(function(i) {
        r[i] = Ug(e[i], t);
      }), r;
    }
    default:
      return e;
  }
}
function mX(e) {
  var t = /* @__PURE__ */ new Set([e]);
  return t.forEach(function(n) {
    zt(n) && vX(n) === n && Object.getOwnPropertyNames(n).forEach(function(r) {
      zt(n[r]) && t.add(n[r]);
    });
  }), e;
}
function vX(e) {
  if (globalThis.__DEV__ !== !1 && !Object.isFrozen(e))
    try {
      Object.freeze(e);
    } catch (t) {
      if (t instanceof TypeError)
        return null;
      throw t;
    }
  return e;
}
function Vd(e) {
  return globalThis.__DEV__ !== !1 && mX(e), e;
}
function hu(e, t, n) {
  var r = [];
  e.forEach(function(i) {
    return i[t] && r.push(i);
  }), r.forEach(function(i) {
    return i[t](n);
  });
}
function $m(e, t, n) {
  return new Et(function(r) {
    var i = {
      // Normally we would initialize promiseQueue to Promise.resolve(), but
      // in this case, for backwards compatibility, we need to be careful to
      // invoke the first callback synchronously.
      then: function(l) {
        return new Promise(function(u) {
          return u(l());
        });
      }
    };
    function o(l, u) {
      return function(c) {
        if (l) {
          var f = function() {
            return r.closed ? (
              /* will be swallowed */
              0
            ) : l(c);
          };
          i = i.then(f, f).then(function(d) {
            return r.next(d);
          }, function(d) {
            return r.error(d);
          });
        } else
          r[u](c);
      };
    }
    var a = {
      next: o(t, "next"),
      error: o(n, "error"),
      complete: function() {
        i.then(function() {
          return r.complete();
        });
      }
    }, s = e.subscribe(a);
    return function() {
      return s.unsubscribe();
    };
  });
}
function HC(e) {
  function t(n) {
    Object.defineProperty(e, n, { value: Et });
  }
  return gC && Symbol.species && t(Symbol.species), t("@@species"), e;
}
function U2(e) {
  return e && typeof e.then == "function";
}
var is = (
  /** @class */
  (function(e) {
    pi(t, e);
    function t(n) {
      var r = e.call(this, function(i) {
        return r.addObserver(i), function() {
          return r.removeObserver(i);
        };
      }) || this;
      return r.observers = /* @__PURE__ */ new Set(), r.promise = new Promise(function(i, o) {
        r.resolve = i, r.reject = o;
      }), r.handlers = {
        next: function(i) {
          r.sub !== null && (r.latest = ["next", i], r.notify("next", i), hu(r.observers, "next", i));
        },
        error: function(i) {
          var o = r.sub;
          o !== null && (o && setTimeout(function() {
            return o.unsubscribe();
          }), r.sub = null, r.latest = ["error", i], r.reject(i), r.notify("error", i), hu(r.observers, "error", i));
        },
        complete: function() {
          var i = r, o = i.sub, a = i.sources, s = a === void 0 ? [] : a;
          if (o !== null) {
            var l = s.shift();
            l ? U2(l) ? l.then(function(u) {
              return r.sub = u.subscribe(r.handlers);
            }, r.handlers.error) : r.sub = l.subscribe(r.handlers) : (o && setTimeout(function() {
              return o.unsubscribe();
            }), r.sub = null, r.latest && r.latest[0] === "next" ? r.resolve(r.latest[1]) : r.resolve(), r.notify("complete"), hu(r.observers, "complete"));
          }
        }
      }, r.nextResultListeners = /* @__PURE__ */ new Set(), r.cancel = function(i) {
        r.reject(i), r.sources = [], r.handlers.error(i);
      }, r.promise.catch(function(i) {
      }), typeof n == "function" && (n = [new Et(n)]), U2(n) ? n.then(function(i) {
        return r.start(i);
      }, r.handlers.error) : r.start(n), r;
    }
    return t.prototype.start = function(n) {
      this.sub === void 0 && (this.sources = Array.from(n), this.handlers.complete());
    }, t.prototype.deliverLastMessage = function(n) {
      if (this.latest) {
        var r = this.latest[0], i = n[r];
        i && i.call(n, this.latest[1]), this.sub === null && r === "next" && n.complete && n.complete();
      }
    }, t.prototype.addObserver = function(n) {
      this.observers.has(n) || (this.deliverLastMessage(n), this.observers.add(n));
    }, t.prototype.removeObserver = function(n) {
      this.observers.delete(n) && this.observers.size < 1 && this.handlers.complete();
    }, t.prototype.notify = function(n, r) {
      var i = this.nextResultListeners;
      i.size && (this.nextResultListeners = /* @__PURE__ */ new Set(), i.forEach(function(o) {
        return o(n, r);
      }));
    }, t.prototype.beforeNext = function(n) {
      var r = !1;
      this.nextResultListeners.add(function(i, o) {
        r || (r = !0, n(i, o));
      });
    }, t;
  })(Et)
);
HC(is);
function Os(e) {
  return "incremental" in e;
}
function gX(e) {
  return "hasNext" in e && "data" in e;
}
function yX(e) {
  return Os(e) || gX(e);
}
function bX(e) {
  return zt(e) && "payload" in e;
}
function WC(e, t) {
  var n = e, r = new Ro();
  return Os(t) && Ci(t.incremental) && t.incremental.forEach(function(i) {
    for (var o = i.data, a = i.path, s = a.length - 1; s >= 0; --s) {
      var l = a[s], u = !isNaN(+l), c = u ? [] : {};
      c[l] = o, o = c;
    }
    n = r.merge(n, o);
  }), n;
}
function jf(e) {
  var t = qg(e);
  return Ci(t);
}
function qg(e) {
  var t = Ci(e.errors) ? e.errors.slice(0) : [];
  return Os(e) && Ci(e.incremental) && e.incremental.forEach(function(n) {
    n.errors && t.push.apply(t, n.errors);
  }), t;
}
function Js() {
  for (var e = [], t = 0; t < arguments.length; t++)
    e[t] = arguments[t];
  var n = /* @__PURE__ */ Object.create(null);
  return e.forEach(function(r) {
    r && Object.keys(r).forEach(function(i) {
      var o = r[i];
      o !== void 0 && (n[i] = o);
    });
  }), n;
}
function km(e, t) {
  return Js(e, t, t.variables && {
    variables: Js(Z(Z({}, e && e.variables), t.variables))
  });
}
var Tm, _X = Symbol.for("apollo.deprecations"), q2 = Symbol.for("apollo.deprecations.slot"), Hg = Fd, Wg = (Tm = Hg[q2]) !== null && Tm !== void 0 ? Tm : Hg[q2] = new $l();
function wX(e) {
  return Hg[_X] || (Wg.getValue() || []).includes(e);
}
function Cn(e) {
  for (var t = [], n = 1; n < arguments.length; n++)
    t[n - 1] = arguments[n];
  return Wg.withValue.apply(Wg, On([Array.isArray(e) ? e : [e]], t, !1));
}
function tn(e, t, n, r) {
  r === void 0 && (r = "Please remove this option."), aa(t, function() {
    t in e && globalThis.__DEV__ !== !1 && ke.warn(103, n, t, r);
  });
}
function aa(e, t) {
  wX(e) || t();
}
function Om(e) {
  return new Et(function(t) {
    t.error(e);
  });
}
var ZC = function(e, t, n) {
  var r = new Error(n);
  throw r.name = "ServerError", r.response = e, r.statusCode = e.status, r.result = t, r;
};
function xX(e) {
  for (var t = [
    "query",
    "operationName",
    "variables",
    "extensions",
    "context"
  ], n = 0, r = Object.keys(e); n < r.length; n++) {
    var i = r[n];
    if (t.indexOf(i) < 0)
      throw Zn(58, i);
  }
  return e;
}
function EX(e, t) {
  var n = Z({}, e), r = function(o) {
    typeof o == "function" ? n = Z(Z({}, n), o(n)) : n = Z(Z({}, n), o);
  }, i = function() {
    return Z({}, n);
  };
  return Object.defineProperty(t, "setContext", {
    enumerable: !1,
    value: r
  }), Object.defineProperty(t, "getContext", {
    enumerable: !1,
    value: i
  }), t;
}
function SX(e) {
  var t = {
    variables: e.variables || {},
    extensions: e.extensions || {},
    operationName: e.operationName,
    query: e.query
  };
  return t.operationName || (t.operationName = typeof t.query != "string" ? eu(t.query) || void 0 : ""), t;
}
function $X(e, t) {
  var n = Z({}, e), r = new Set(Object.keys(e));
  return li(t, {
    Variable: function(i, o, a) {
      a && a.kind !== "VariableDefinition" && r.delete(i.name.value);
    }
  }), r.forEach(function(i) {
    delete n[i];
  }), n;
}
function H2(e, t) {
  return t ? t(e) : Et.of();
}
function Bl(e) {
  return typeof e == "function" ? new qo(e) : e;
}
function of(e) {
  return e.request.length <= 1;
}
var qo = (
  /** @class */
  (function() {
    function e(t) {
      t && (this.request = t);
    }
    return e.empty = function() {
      return new e(function() {
        return Et.of();
      });
    }, e.from = function(t) {
      return t.length === 0 ? e.empty() : t.map(Bl).reduce(function(n, r) {
        return n.concat(r);
      });
    }, e.split = function(t, n, r) {
      var i = Bl(n), o = Bl(r || new e(H2)), a;
      return of(i) && of(o) ? a = new e(function(s) {
        return t(s) ? i.request(s) || Et.of() : o.request(s) || Et.of();
      }) : a = new e(function(s, l) {
        return t(s) ? i.request(s, l) || Et.of() : o.request(s, l) || Et.of();
      }), Object.assign(a, { left: i, right: o });
    }, e.execute = function(t, n) {
      return t.request(EX(n.context, SX(xX(n)))) || Et.of();
    }, e.concat = function(t, n) {
      var r = Bl(t);
      if (of(r))
        return globalThis.__DEV__ !== !1 && ke.warn(47, r), r;
      var i = Bl(n), o;
      return of(i) ? o = new e(function(a) {
        return r.request(a, function(s) {
          return i.request(s) || Et.of();
        }) || Et.of();
      }) : o = new e(function(a, s) {
        return r.request(a, function(l) {
          return i.request(l, s) || Et.of();
        }) || Et.of();
      }), Object.assign(o, { left: r, right: i });
    }, e.prototype.split = function(t, n, r) {
      return this.concat(e.split(t, n, r || new e(H2)));
    }, e.prototype.concat = function(t) {
      return e.concat(this, t);
    }, e.prototype.request = function(t, n) {
      throw Zn(48);
    }, e.prototype.onError = function(t, n) {
      if (globalThis.__DEV__ !== !1 && aa("onError", function() {
        globalThis.__DEV__ !== !1 && ke.warn(49);
      }), n && n.error)
        return n.error(t), !1;
      throw t;
    }, e.prototype.setOnError = function(t) {
      return globalThis.__DEV__ !== !1 && globalThis.__DEV__ !== !1 && ke.warn(50), this.onError = t, this;
    }, e;
  })()
);
qo.from;
qo.split;
var Zg = qo.execute;
function kX(e) {
  var t, n = e[Symbol.asyncIterator]();
  return t = {
    next: function() {
      return n.next();
    }
  }, t[Symbol.asyncIterator] = function() {
    return this;
  }, t;
}
function TX(e) {
  var t = null, n = null, r = !1, i = [], o = [];
  function a(f) {
    if (!n) {
      if (o.length) {
        var d = o.shift();
        if (Array.isArray(d) && d[0])
          return d[0]({ value: f, done: !1 });
      }
      i.push(f);
    }
  }
  function s(f) {
    n = f;
    var d = o.slice();
    d.forEach(function(p) {
      p[1](f);
    }), !t || t();
  }
  function l() {
    r = !0;
    var f = o.slice();
    f.forEach(function(d) {
      d[0]({ value: void 0, done: !0 });
    }), !t || t();
  }
  t = function() {
    t = null, e.removeListener("data", a), e.removeListener("error", s), e.removeListener("end", l), e.removeListener("finish", l), e.removeListener("close", l);
  }, e.on("data", a), e.on("error", s), e.on("end", l), e.on("finish", l), e.on("close", l);
  function u() {
    return new Promise(function(f, d) {
      if (n)
        return d(n);
      if (i.length)
        return f({ value: i.shift(), done: !1 });
      if (r)
        return f({ value: void 0, done: !0 });
      o.push([f, d]);
    });
  }
  var c = {
    next: function() {
      return u();
    }
  };
  return Wp && (c[Symbol.asyncIterator] = function() {
    return this;
  }), c;
}
function OX(e) {
  var t = !1, n = {
    next: function() {
      return t ? Promise.resolve({
        value: void 0,
        done: !0
      }) : (t = !0, new Promise(function(r, i) {
        e.then(function(o) {
          r({ value: o, done: !1 });
        }).catch(i);
      }));
    }
  };
  return Wp && (n[Symbol.asyncIterator] = function() {
    return this;
  }), n;
}
function W2(e) {
  var t = {
    next: function() {
      return e.read();
    }
  };
  return Wp && (t[Symbol.asyncIterator] = function() {
    return this;
  }), t;
}
function PX(e) {
  return !!e.body;
}
function AX(e) {
  return !!e.getReader;
}
function DX(e) {
  return !!(Wp && e[Symbol.asyncIterator]);
}
function CX(e) {
  return !!e.stream;
}
function IX(e) {
  return !!e.arrayBuffer;
}
function MX(e) {
  return !!e.pipe;
}
function RX(e) {
  var t = e;
  if (PX(e) && (t = e.body), DX(t))
    return kX(t);
  if (AX(t))
    return W2(t.getReader());
  if (CX(t))
    return W2(t.stream().getReader());
  if (IX(t))
    return OX(t.arrayBuffer());
  if (MX(t))
    return TX(t);
  throw new Error("Unknown body type for responseIterator. Please pass a streamable response.");
}
var z0 = Symbol();
function NX(e) {
  return e.extensions ? Array.isArray(e.extensions[z0]) : !1;
}
function GC(e) {
  return e.hasOwnProperty("graphQLErrors");
}
var jX = function(e) {
  var t = On(On(On([], e.graphQLErrors, !0), e.clientErrors, !0), e.protocolErrors, !0);
  return e.networkError && t.push(e.networkError), t.map(function(n) {
    return zt(n) && n.message || "Error message not found.";
  }).join(`
`);
}, ho = (
  /** @class */
  (function(e) {
    pi(t, e);
    function t(n) {
      var r = n.graphQLErrors, i = n.protocolErrors, o = n.clientErrors, a = n.networkError, s = n.errorMessage, l = n.extraInfo, u = e.call(this, s) || this;
      return u.name = "ApolloError", u.graphQLErrors = r || [], u.protocolErrors = i || [], u.clientErrors = o || [], u.networkError = a || null, u.message = s || jX(u), u.extraInfo = l, u.cause = On(On(On([
        a
      ], r || [], !0), i || [], !0), o || [], !0).find(function(c) {
        return !!c;
      }) || null, u.__proto__ = t.prototype, u;
    }
    return t;
  })(Error)
), Z2 = Object.prototype.hasOwnProperty;
function FX(e, t) {
  return co(this, void 0, void 0, function() {
    var n, r, i, o, a, s, l, u, c, f, d, p, h, v, m, g, _, x, w, $, k, D, E, b;
    return fo(this, function(y) {
      switch (y.label) {
        case 0:
          if (TextDecoder === void 0)
            throw new Error("TextDecoder must be defined in the environment: please import a polyfill.");
          n = new TextDecoder("utf-8"), r = (b = e.headers) === null || b === void 0 ? void 0 : b.get("content-type"), i = "boundary=", o = r != null && r.includes(i) ? r?.substring(r?.indexOf(i) + i.length).replace(/['"]/g, "").replace(/\;(.*)/gm, "").trim() : "-", a = `\r
--`.concat(o), s = "", l = RX(e), u = !0, y.label = 1;
        case 1:
          return u ? [4, l.next()] : [3, 3];
        case 2:
          for (c = y.sent(), f = c.value, d = c.done, p = typeof f == "string" ? f : n.decode(f), h = s.length - a.length + 1, u = !d, s += p, v = s.indexOf(a, h); v > -1; ) {
            if (m = void 0, D = [
              s.slice(0, v),
              s.slice(v + a.length)
            ], m = D[0], s = D[1], g = m.indexOf(`\r
\r
`), _ = zX(m.slice(0, g)), x = _["content-type"], x && x.toLowerCase().indexOf("application/json") === -1)
              throw new Error("Unsupported patch content type: application/json is required.");
            if (w = m.slice(g), w) {
              if ($ = YC(e, w), Object.keys($).length > 1 || "data" in $ || "incremental" in $ || "errors" in $ || "payload" in $)
                if (bX($)) {
                  if (k = {}, "payload" in $) {
                    if (Object.keys($).length === 1 && $.payload === null)
                      return [
                        2
                        /*return*/
                      ];
                    k = Z({}, $.payload);
                  }
                  "errors" in $ && (k = Z(Z({}, k), { extensions: Z(Z({}, "extensions" in k ? k.extensions : null), (E = {}, E[z0] = $.errors, E)) })), t(k);
                } else
                  t($);
              else if (
                // If the chunk contains only a "hasNext: false", we can call
                // observer.complete() immediately.
                Object.keys($).length === 1 && "hasNext" in $ && !$.hasNext
              )
                return [
                  2
                  /*return*/
                ];
            }
            v = s.indexOf(a);
          }
          return [3, 1];
        case 3:
          return [
            2
            /*return*/
          ];
      }
    });
  });
}
function zX(e) {
  var t = {};
  return e.split(`
`).forEach(function(n) {
    var r = n.indexOf(":");
    if (r > -1) {
      var i = n.slice(0, r).trim().toLowerCase(), o = n.slice(r + 1).trim();
      t[i] = o;
    }
  }), t;
}
function YC(e, t) {
  if (e.status >= 300) {
    var n = function() {
      try {
        return JSON.parse(t);
      } catch {
        return t;
      }
    };
    ZC(e, n(), "Response not successful: Received status code ".concat(e.status));
  }
  try {
    return JSON.parse(t);
  } catch (i) {
    var r = i;
    throw r.name = "ServerParseError", r.response = e, r.statusCode = e.status, r.bodyText = t, r;
  }
}
function LX(e, t) {
  e.result && e.result.errors && e.result.data && t.next(e.result), t.error(e);
}
function VX(e) {
  return function(t) {
    return t.text().then(function(n) {
      return YC(t, n);
    }).then(function(n) {
      return !Array.isArray(n) && !Z2.call(n, "data") && !Z2.call(n, "errors") && ZC(t, n, "Server response was missing for query '".concat(Array.isArray(e) ? e.map(function(r) {
        return r.operationName;
      }) : e.operationName, "'.")), n;
    });
  };
}
var Gg = function(e, t) {
  var n;
  try {
    n = JSON.stringify(e);
  } catch (i) {
    var r = Zn(54, t, i.message);
    throw r.parseError = i, r;
  }
  return n;
}, BX = {
  includeQuery: !0,
  includeExtensions: !1,
  preserveHeaderCase: !1
}, KX = {
  // headers are case insensitive (https://stackoverflow.com/a/5259004)
  accept: "*/*",
  // The content-type header describes the type of the body of the request, and
  // so it typically only is sent with requests that actually have bodies. One
  // could imagine that Apollo Client would remove this header when constructing
  // a GET request (which has no body), but we historically have not done that.
  // This means that browsers will preflight all Apollo Client requests (even
  // GET requests). Apollo Server's CSRF prevention feature (introduced in
  // AS3.7) takes advantage of this fact and does not block requests with this
  // header. If you want to drop this header from GET requests, then you should
  // probably replace it with a `apollo-require-preflight` header, or servers
  // with CSRF prevention enabled might block your GET request. See
  // https://www.apollographql.com/docs/apollo-server/security/cors/#preventing-cross-site-request-forgery-csrf
  // for more details.
  "content-type": "application/json"
}, UX = {
  method: "POST"
}, qX = {
  http: BX,
  headers: KX,
  options: UX
}, HX = function(e, t) {
  return t(e);
};
function WX(e, t) {
  for (var n = [], r = 2; r < arguments.length; r++)
    n[r - 2] = arguments[r];
  var i = {}, o = {};
  n.forEach(function(f) {
    i = Z(Z(Z({}, i), f.options), { headers: Z(Z({}, i.headers), f.headers) }), f.credentials && (i.credentials = f.credentials), o = Z(Z({}, o), f.http);
  }), i.headers && (i.headers = ZX(i.headers, o.preserveHeaderCase));
  var a = e.operationName, s = e.extensions, l = e.variables, u = e.query, c = { operationName: a, variables: l };
  return o.includeExtensions && (c.extensions = s), o.includeQuery && (c.query = t(u, _o)), {
    options: i,
    body: c
  };
}
function ZX(e, t) {
  if (!t) {
    var n = {};
    return Object.keys(Object(e)).forEach(function(o) {
      n[o.toLowerCase()] = e[o];
    }), n;
  }
  var r = {};
  Object.keys(Object(e)).forEach(function(o) {
    r[o.toLowerCase()] = {
      originalName: o,
      value: e[o]
    };
  });
  var i = {};
  return Object.keys(r).forEach(function(o) {
    i[r[o].originalName] = r[o].value;
  }), i;
}
var GX = function(e) {
  if (!e && typeof fetch > "u")
    throw Zn(51);
}, YX = function(e, t) {
  var n = e.getContext(), r = n.uri;
  return r || (typeof t == "function" ? t(e) : t || "/graphql");
};
function QX(e, t) {
  var n = [], r = function(f, d) {
    n.push("".concat(f, "=").concat(encodeURIComponent(d)));
  };
  if ("query" in t && r("query", t.query), t.operationName && r("operationName", t.operationName), t.variables) {
    var i = void 0;
    try {
      i = Gg(t.variables, "Variables map");
    } catch (f) {
      return { parseError: f };
    }
    r("variables", i);
  }
  if (t.extensions) {
    var o = void 0;
    try {
      o = Gg(t.extensions, "Extensions map");
    } catch (f) {
      return { parseError: f };
    }
    r("extensions", o);
  }
  var a = "", s = e, l = e.indexOf("#");
  l !== -1 && (a = e.substr(l), s = e.substr(0, l));
  var u = s.indexOf("?") === -1 ? "?" : "&", c = s + u + n.join("&") + a;
  return { newURI: c };
}
var G2 = Jr(function() {
  return fetch;
}), JX = function(e) {
  e === void 0 && (e = {});
  var t = e.uri, n = t === void 0 ? "/graphql" : t, r = e.fetch, i = e.print, o = i === void 0 ? HX : i, a = e.includeExtensions, s = e.preserveHeaderCase, l = e.useGETForQueries, u = e.includeUnusedVariables, c = u === void 0 ? !1 : u, f = Ui(e, ["uri", "fetch", "print", "includeExtensions", "preserveHeaderCase", "useGETForQueries", "includeUnusedVariables"]);
  globalThis.__DEV__ !== !1 && GX(r || G2);
  var d = {
    http: { includeExtensions: a, preserveHeaderCase: s },
    options: f.fetchOptions,
    credentials: f.credentials,
    headers: f.headers
  };
  return new qo(function(p) {
    var h = YX(p, n), v = p.getContext(), m = {};
    if (v.clientAwareness) {
      var g = v.clientAwareness, _ = g.name, x = g.version;
      _ && (m["apollographql-client-name"] = _), x && (m["apollographql-client-version"] = x);
    }
    var w = Z(Z({}, m), v.headers), $ = {
      http: v.http,
      options: v.fetchOptions,
      credentials: v.credentials,
      headers: w
    };
    if (Ku(["client"], p.query)) {
      globalThis.__DEV__ !== !1 && globalThis.__DEV__ !== !1 && ke.warn(52);
      var k = VC(p.query);
      if (!k)
        return Om(new Error("HttpLink: Trying to send a client-only query to the server. To send to the server, ensure a non-client field is added to the query or set the `transformOptions.removeClientFields` option to `true`."));
      p.query = k;
    }
    var D = WX(p, o, qX, d, $), E = D.options, b = D.body;
    b.variables && !c && (b.variables = $X(b.variables, p.query));
    var y;
    !E.signal && typeof AbortController < "u" && (y = new AbortController(), E.signal = y.signal);
    var S = function(N) {
      return N.kind === "OperationDefinition" && N.operation === "mutation";
    }, P = function(N) {
      return N.kind === "OperationDefinition" && N.operation === "subscription";
    }, M = P(xc(p.query)), T = Ku(["defer"], p.query);
    if (l && !p.query.definitions.some(S) && (E.method = "GET"), T || M) {
      E.headers = E.headers || {};
      var V = "multipart/mixed;";
      M && T && globalThis.__DEV__ !== !1 && ke.warn(53), M ? V += "boundary=graphql;subscriptionSpec=1.0,application/json" : T && (V += "deferSpec=20220824,application/json"), E.headers.accept = V;
    }
    if (E.method === "GET") {
      var z = QX(h, b), U = z.newURI, B = z.parseError;
      if (B)
        return Om(B);
      h = U;
    } else
      try {
        E.body = Gg(b, "Payload");
      } catch (N) {
        return Om(N);
      }
    return new Et(function(N) {
      var C = r || Jr(function() {
        return fetch;
      }) || G2, G = N.next.bind(N);
      return C(h, E).then(function(re) {
        var ie;
        p.setContext({ response: re });
        var X = (ie = re.headers) === null || ie === void 0 ? void 0 : ie.get("content-type");
        return X !== null && /^multipart\/mixed/i.test(X) ? FX(re, G) : VX(p)(re).then(G);
      }).then(function() {
        y = void 0, N.complete();
      }).catch(function(re) {
        y = void 0, LX(re, N);
      }), function() {
        y && y.abort();
      };
    });
  });
}, XX = (
  /** @class */
  (function(e) {
    pi(t, e);
    function t(n) {
      n === void 0 && (n = {});
      var r = e.call(this, JX(n).request) || this;
      return r.options = n, r;
    }
    return t;
  })(qo)
);
const { toString: Y2, hasOwnProperty: eee } = Object.prototype, Q2 = Function.prototype.toString, Yg = /* @__PURE__ */ new Map();
function $t(e, t) {
  try {
    return Qg(e, t);
  } finally {
    Yg.clear();
  }
}
function Qg(e, t) {
  if (e === t)
    return !0;
  const n = Y2.call(e), r = Y2.call(t);
  if (n !== r)
    return !1;
  switch (n) {
    case "[object Array]":
      if (e.length !== t.length)
        return !1;
    // Fall through to object case...
    case "[object Object]": {
      if (X2(e, t))
        return !0;
      const i = J2(e), o = J2(t), a = i.length;
      if (a !== o.length)
        return !1;
      for (let s = 0; s < a; ++s)
        if (!eee.call(t, i[s]))
          return !1;
      for (let s = 0; s < a; ++s) {
        const l = i[s];
        if (!Qg(e[l], t[l]))
          return !1;
      }
      return !0;
    }
    case "[object Error]":
      return e.name === t.name && e.message === t.message;
    case "[object Number]":
      if (e !== e)
        return t !== t;
    // Fall through to shared +a === +b case...
    case "[object Boolean]":
    case "[object Date]":
      return +e == +t;
    case "[object RegExp]":
    case "[object String]":
      return e == `${t}`;
    case "[object Map]":
    case "[object Set]": {
      if (e.size !== t.size)
        return !1;
      if (X2(e, t))
        return !0;
      const i = e.entries(), o = n === "[object Map]";
      for (; ; ) {
        const a = i.next();
        if (a.done)
          break;
        const [s, l] = a.value;
        if (!t.has(s) || o && !Qg(l, t.get(s)))
          return !1;
      }
      return !0;
    }
    case "[object Uint16Array]":
    case "[object Uint8Array]":
    // Buffer, in Node.js.
    case "[object Uint32Array]":
    case "[object Int32Array]":
    case "[object Int8Array]":
    case "[object Int16Array]":
    case "[object ArrayBuffer]":
      e = new Uint8Array(e), t = new Uint8Array(t);
    // Fall through...
    case "[object DataView]": {
      let i = e.byteLength;
      if (i === t.byteLength)
        for (; i-- && e[i] === t[i]; )
          ;
      return i === -1;
    }
    case "[object AsyncFunction]":
    case "[object GeneratorFunction]":
    case "[object AsyncGeneratorFunction]":
    case "[object Function]": {
      const i = Q2.call(e);
      return i !== Q2.call(t) ? !1 : !ree(i, nee);
    }
  }
  return !1;
}
function J2(e) {
  return Object.keys(e).filter(tee, e);
}
function tee(e) {
  return this[e] !== void 0;
}
const nee = "{ [native code] }";
function ree(e, t) {
  const n = e.length - t.length;
  return n >= 0 && e.indexOf(t, n) === n;
}
function X2(e, t) {
  let n = Yg.get(e);
  if (n) {
    if (n.has(t))
      return !0;
  } else
    Yg.set(e, n = /* @__PURE__ */ new Set());
  return n.add(t), !1;
}
function QC(e, t, n, r) {
  var i = t.data, o = Ui(t, ["data"]), a = n.data, s = Ui(n, ["data"]);
  return $t(o, s) && Ff(xc(e).selectionSet, i, a, {
    fragmentMap: xl(Sl(e)),
    variables: r
  });
}
function Ff(e, t, n, r) {
  if (t === n)
    return !0;
  var i = /* @__PURE__ */ new Set();
  return e.selections.every(function(o) {
    if (i.has(o) || (i.add(o), !wc(o, r.variables)) || eS(o))
      return !0;
    if (Io(o)) {
      var a = Xi(o), s = t && t[a], l = n && n[a], u = o.selectionSet;
      if (!u)
        return $t(s, l);
      var c = Array.isArray(s), f = Array.isArray(l);
      if (c !== f)
        return !1;
      if (c && f) {
        var d = s.length;
        if (l.length !== d)
          return !1;
        for (var p = 0; p < d; ++p)
          if (!Ff(u, s[p], l[p], r))
            return !1;
        return !0;
      }
      return Ff(u, s, l, r);
    } else {
      var h = Zp(o, r.fragmentMap);
      if (h)
        return eS(h) ? !0 : Ff(
          h.selectionSet,
          // Notice that we reuse the same aResult and bResult values here,
          // since the fragment ...spread does not specify a field name, but
          // consists of multiple fields (within the fragment's selection set)
          // that should be applied to the current result value(s).
          t,
          n,
          r
        );
    }
  });
}
function eS(e) {
  return !!e.directives && e.directives.some(iee);
}
function iee(e) {
  return e.name.value === "nonreactive";
}
var JC = Za ? WeakMap : Map, XC = P0 ? WeakSet : Set, L0 = new $l(), tS = !1;
function e3() {
  tS || (tS = !0, globalThis.__DEV__ !== !1 && ke.warn(64));
}
function t3(e, t, n) {
  return L0.withValue(!0, function() {
    var r = tu(e, t, n, !1);
    return Object.isFrozen(e) && Vd(r), r;
  });
}
function oee(e, t) {
  if (t.has(e))
    return t.get(e);
  var n = Array.isArray(e) ? [] : /* @__PURE__ */ Object.create(null);
  return t.set(e, n), n;
}
function tu(e, t, n, r, i) {
  var o, a = n.knownChanged, s = oee(e, n.mutableTargets);
  if (Array.isArray(e)) {
    for (var l = 0, u = Array.from(e.entries()); l < u.length; l++) {
      var c = u[l], f = c[0], d = c[1];
      if (d === null) {
        s[f] = null;
        continue;
      }
      var p = tu(d, t, n, r, globalThis.__DEV__ !== !1 ? "".concat(i || "", "[").concat(f, "]") : void 0);
      a.has(p) && a.add(s), s[f] = p;
    }
    return a.has(s) ? s : e;
  }
  for (var h = 0, v = t.selections; h < v.length; h++) {
    var m = v[h], g = void 0;
    if (r && a.add(s), m.kind === Ht.FIELD) {
      var _ = Xi(m), x = m.selectionSet;
      if (g = s[_] || e[_], g === void 0)
        continue;
      if (x && g !== null) {
        var p = tu(e[_], x, n, r, globalThis.__DEV__ !== !1 ? "".concat(i || "", ".").concat(_) : void 0);
        a.has(p) && (g = p);
      }
      globalThis.__DEV__ === !1 && (s[_] = g), globalThis.__DEV__ !== !1 && (r && _ !== "__typename" && // either the field is not present in the memo object
      // or it has a `get` descriptor, not a `value` descriptor
      // => it is a warning accessor and we can overwrite it
      // with another accessor
      !(!((o = Object.getOwnPropertyDescriptor(s, _)) === null || o === void 0) && o.value) ? Object.defineProperty(s, _, aee(_, g, i || "", n.operationName, n.operationType)) : (delete s[_], s[_] = g));
    }
    if (m.kind === Ht.INLINE_FRAGMENT && (!m.typeCondition || n.cache.fragmentMatches(m, e.__typename)) && (g = tu(e, m.selectionSet, n, r, i)), m.kind === Ht.FRAGMENT_SPREAD) {
      var w = m.name.value, $ = n.fragmentMap[w] || (n.fragmentMap[w] = n.cache.lookupFragment(w));
      ke($, 59, w);
      var k = rJ(m);
      k !== "mask" && (g = tu(e, $.selectionSet, n, k === "migrate", i));
    }
    a.has(g) && a.add(s);
  }
  return "__typename" in e && !("__typename" in s) && (s.__typename = e.__typename), Object.keys(s).length !== Object.keys(e).length && a.add(s), a.has(s) ? s : e;
}
function aee(e, t, n, r, i) {
  var o = function() {
    return L0.getValue() || (globalThis.__DEV__ !== !1 && ke.warn(60, r ? "".concat(i, " '").concat(r, "'") : "anonymous ".concat(i), "".concat(n, ".").concat(e).replace(/^\./, "")), o = function() {
      return t;
    }), t;
  };
  return {
    get: function() {
      return o();
    },
    set: function(a) {
      o = function() {
        return a;
      };
    },
    enumerable: !0,
    configurable: !0
  };
}
function n3(e, t, n, r) {
  if (!n.fragmentMatches)
    return globalThis.__DEV__ !== !1 && e3(), e;
  var i = t.definitions.filter(function(a) {
    return a.kind === Ht.FRAGMENT_DEFINITION;
  });
  typeof r > "u" && (ke(i.length === 1, 61, i.length), r = i[0].name.value);
  var o = i.find(function(a) {
    return a.name.value === r;
  });
  return ke(!!o, 62, r), e == null || $t(e, {}) ? e : t3(e, o.selectionSet, {
    operationType: "fragment",
    operationName: o.name.value,
    fragmentMap: xl(Sl(t)),
    cache: n,
    mutableTargets: new JC(),
    knownChanged: new XC()
  });
}
function see(e, t, n) {
  var r;
  if (!n.fragmentMatches)
    return globalThis.__DEV__ !== !1 && e3(), e;
  var i = Ca(t);
  return ke(i, 63), e == null ? e : t3(e, i.selectionSet, {
    operationType: i.operation,
    operationName: (r = i.name) === null || r === void 0 ? void 0 : r.value,
    fragmentMap: xl(Sl(t)),
    cache: n,
    mutableTargets: new JC(),
    knownChanged: new XC()
  });
}
var r3 = (
  /** @class */
  (function() {
    function e() {
      this.assumeImmutableResults = !1, this.getFragmentDoc = qu(uJ, {
        max: Ji["cache.fragmentQueryDocuments"] || 1e3,
        cache: zd
      });
    }
    return e.prototype.lookupFragment = function(t) {
      return null;
    }, e.prototype.batch = function(t) {
      var n = this, r = typeof t.optimistic == "string" ? t.optimistic : t.optimistic === !1 ? null : void 0, i;
      return this.performTransaction(function() {
        return i = t.update(n);
      }, r), i;
    }, e.prototype.recordOptimisticTransaction = function(t, n) {
      this.performTransaction(t, n);
    }, e.prototype.transformDocument = function(t) {
      return t;
    }, e.prototype.transformForLink = function(t) {
      return t;
    }, e.prototype.identify = function(t) {
    }, e.prototype.gc = function() {
      return [];
    }, e.prototype.modify = function(t) {
      return !1;
    }, e.prototype.readQuery = function(t, n) {
      var r = this;
      return n === void 0 && (n = !!t.optimistic), globalThis.__DEV__ !== !1 && tn(t, "canonizeResults", "cache.readQuery"), Cn("canonizeResults", function() {
        return r.read(Z(Z({}, t), { rootId: t.id || "ROOT_QUERY", optimistic: n }));
      });
    }, e.prototype.watchFragment = function(t) {
      var n = this, r = t.fragment, i = t.fragmentName, o = t.from, a = t.optimistic, s = a === void 0 ? !0 : a, l = Ui(t, ["fragment", "fragmentName", "from", "optimistic"]), u = this.getFragmentDoc(r, i), c = typeof o > "u" || typeof o == "string" ? o : this.identify(o), f = !!t[Symbol.for("apollo.dataMasking")];
      if (globalThis.__DEV__ !== !1) {
        var d = i || kC(r).name.value;
        c || globalThis.__DEV__ !== !1 && ke.warn(1, d);
      }
      var p = Z(Z({}, l), { returnPartialData: !0, id: c, query: u, optimistic: s }), h;
      return new Et(function(v) {
        return n.watch(Z(Z({}, p), { immediate: !0, callback: function(m) {
          var g = f ? n3(m.result, r, n, i) : m.result;
          if (
            // Always ensure we deliver the first result
            !(h && QC(
              u,
              { data: h.result },
              { data: g },
              // TODO: Fix the type on WatchFragmentOptions so that TVars
              // extends OperationVariables
              t.variables
            ))
          ) {
            var _ = {
              data: g,
              complete: !!m.complete
            };
            m.missing && (_.missing = Jp(m.missing.map(function(x) {
              return x.missing;
            }))), h = Z(Z({}, m), { result: g }), v.next(_);
          }
        } }));
      });
    }, e.prototype.readFragment = function(t, n) {
      var r = this;
      return n === void 0 && (n = !!t.optimistic), globalThis.__DEV__ !== !1 && tn(t, "canonizeResults", "cache.readFragment"), Cn("canonizeResults", function() {
        return r.read(Z(Z({}, t), { query: r.getFragmentDoc(t.fragment, t.fragmentName), rootId: t.id, optimistic: n }));
      });
    }, e.prototype.writeQuery = function(t) {
      var n = t.id, r = t.data, i = Ui(t, ["id", "data"]);
      return this.write(Object.assign(i, {
        dataId: n || "ROOT_QUERY",
        result: r
      }));
    }, e.prototype.writeFragment = function(t) {
      var n = t.id, r = t.data, i = t.fragment, o = t.fragmentName, a = Ui(t, ["id", "data", "fragment", "fragmentName"]);
      return this.write(Object.assign(a, {
        query: this.getFragmentDoc(i, o),
        dataId: n,
        result: r
      }));
    }, e.prototype.updateQuery = function(t, n) {
      return globalThis.__DEV__ !== !1 && tn(t, "canonizeResults", "cache.updateQuery"), this.batch({
        update: function(r) {
          var i = Cn("canonizeResults", function() {
            return r.readQuery(t);
          }), o = n(i);
          return o == null ? i : (r.writeQuery(Z(Z({}, t), { data: o })), o);
        }
      });
    }, e.prototype.updateFragment = function(t, n) {
      return globalThis.__DEV__ !== !1 && tn(t, "canonizeResults", "cache.updateFragment"), this.batch({
        update: function(r) {
          var i = Cn("canonizeResults", function() {
            return r.readFragment(t);
          }), o = n(i);
          return o == null ? i : (r.writeFragment(Z(Z({}, t), { data: o })), o);
        }
      });
    }, e;
  })()
);
globalThis.__DEV__ !== !1 && (r3.prototype.getMemoryInternals = wJ);
var i3 = (
  /** @class */
  (function(e) {
    pi(t, e);
    function t(n, r, i, o) {
      var a, s = e.call(this, n) || this;
      if (s.message = n, s.path = r, s.query = i, s.variables = o, Array.isArray(s.path)) {
        s.missing = s.message;
        for (var l = s.path.length - 1; l >= 0; --l)
          s.missing = (a = {}, a[s.path[l]] = s.missing, a);
      } else
        s.missing = s.path;
      return s.__proto__ = t.prototype, s;
    }
    return t;
  })(Error)
), yn = Object.prototype.hasOwnProperty;
function Kl(e) {
  return e == null;
}
function o3(e, t) {
  var n = e.__typename, r = e.id, i = e._id;
  if (typeof n == "string" && (t && (t.keyObject = Kl(r) ? Kl(i) ? void 0 : { _id: i } : { id: r }), Kl(r) && !Kl(i) && (r = i), !Kl(r)))
    return "".concat(n, ":").concat(typeof r == "number" || typeof r == "string" ? r : JSON.stringify(r));
}
var a3 = {
  dataIdFromObject: o3,
  addTypename: !0,
  resultCaching: !0,
  // Thanks to the shouldCanonizeResults helper, this should be the only line
  // you have to change to reenable canonization by default in the future.
  canonizeResults: !1
};
function lee(e) {
  return Js(a3, e);
}
function s3(e) {
  var t = e.canonizeResults;
  return t === void 0 ? a3.canonizeResults : t;
}
function uee(e, t) {
  return yt(t) ? e.get(t.__ref, "__typename") : t && t.__typename;
}
var l3 = /^[_a-z][_0-9a-z]*/i;
function No(e) {
  var t = e.match(l3);
  return t ? t[0] : e;
}
function Jg(e, t, n) {
  return zt(t) ? Jt(t) ? t.every(function(r) {
    return Jg(e, r, n);
  }) : e.selections.every(function(r) {
    if (Io(r) && wc(r, n)) {
      var i = Xi(r);
      return yn.call(t, i) && (!r.selectionSet || Jg(r.selectionSet, t[i], n));
    }
    return !0;
  }) : !1;
}
function ys(e) {
  return zt(e) && !yt(e) && !Jt(e);
}
function cee() {
  return new Ro();
}
function u3(e, t) {
  var n = xl(Sl(e));
  return {
    fragmentMap: n,
    lookupFragment: function(r) {
      var i = n[r];
      return !i && t && (i = t.lookup(r)), i || null;
    }
  };
}
var zf = /* @__PURE__ */ Object.create(null), Pm = function() {
  return zf;
}, nS = /* @__PURE__ */ Object.create(null), Hu = (
  /** @class */
  (function() {
    function e(t, n) {
      var r = this;
      this.policies = t, this.group = n, this.data = /* @__PURE__ */ Object.create(null), this.rootIds = /* @__PURE__ */ Object.create(null), this.refs = /* @__PURE__ */ Object.create(null), this.getFieldValue = function(i, o) {
        return Vd(yt(i) ? r.get(i.__ref, o) : i && i[o]);
      }, this.canRead = function(i) {
        return yt(i) ? r.has(i.__ref) : typeof i == "object";
      }, this.toReference = function(i, o) {
        if (typeof i == "string")
          return Ts(i);
        if (yt(i))
          return i;
        var a = r.policies.identify(i)[0];
        if (a) {
          var s = Ts(a);
          return o && r.merge(a, i), s;
        }
      };
    }
    return e.prototype.toObject = function() {
      return Z({}, this.data);
    }, e.prototype.has = function(t) {
      return this.lookup(t, !0) !== void 0;
    }, e.prototype.get = function(t, n) {
      if (this.group.depend(t, n), yn.call(this.data, t)) {
        var r = this.data[t];
        if (r && yn.call(r, n))
          return r[n];
      }
      if (n === "__typename" && yn.call(this.policies.rootTypenamesById, t))
        return this.policies.rootTypenamesById[t];
      if (this instanceof lo)
        return this.parent.get(t, n);
    }, e.prototype.lookup = function(t, n) {
      if (n && this.group.depend(t, "__exists"), yn.call(this.data, t))
        return this.data[t];
      if (this instanceof lo)
        return this.parent.lookup(t, n);
      if (this.policies.rootTypenamesById[t])
        return /* @__PURE__ */ Object.create(null);
    }, e.prototype.merge = function(t, n) {
      var r = this, i;
      yt(t) && (t = t.__ref), yt(n) && (n = n.__ref);
      var o = typeof t == "string" ? this.lookup(i = t) : t, a = typeof n == "string" ? this.lookup(i = n) : n;
      if (a) {
        ke(typeof i == "string", 2);
        var s = new Ro(dee).merge(o, a);
        if (this.data[i] = s, s !== o && (delete this.refs[i], this.group.caching)) {
          var l = /* @__PURE__ */ Object.create(null);
          o || (l.__exists = 1), Object.keys(a).forEach(function(u) {
            if (!o || o[u] !== s[u]) {
              l[u] = 1;
              var c = No(u);
              c !== u && !r.policies.hasKeyArgs(s.__typename, c) && (l[c] = 1), s[u] === void 0 && !(r instanceof lo) && delete s[u];
            }
          }), l.__typename && !(o && o.__typename) && // Since we return default root __typename strings
          // automatically from store.get, we don't need to dirty the
          // ROOT_QUERY.__typename field if merged.__typename is equal
          // to the default string (usually "Query").
          this.policies.rootTypenamesById[i] === s.__typename && delete l.__typename, Object.keys(l).forEach(function(u) {
            return r.group.dirty(i, u);
          });
        }
      }
    }, e.prototype.modify = function(t, n) {
      var r = this, i = this.lookup(t);
      if (i) {
        var o = /* @__PURE__ */ Object.create(null), a = !1, s = !0, l = {
          DELETE: zf,
          INVALIDATE: nS,
          isReference: yt,
          toReference: this.toReference,
          canRead: this.canRead,
          readField: function(u, c) {
            return r.policies.readField(typeof u == "string" ? {
              fieldName: u,
              from: c || Ts(t)
            } : u, { store: r });
          }
        };
        if (Object.keys(i).forEach(function(u) {
          var c = No(u), f = i[u];
          if (f !== void 0) {
            var d = typeof n == "function" ? n : n[u] || n[c];
            if (d) {
              var p = d === Pm ? zf : d(Vd(f), Z(Z({}, l), { fieldName: c, storeFieldName: u, storage: r.getStorage(t, u) }));
              if (p === nS)
                r.group.dirty(t, u);
              else if (p === zf && (p = void 0), p !== f && (o[u] = p, a = !0, f = p, globalThis.__DEV__ !== !1)) {
                var h = function($) {
                  if (r.lookup($.__ref) === void 0)
                    return globalThis.__DEV__ !== !1 && ke.warn(3, $), !0;
                };
                if (yt(p))
                  h(p);
                else if (Array.isArray(p))
                  for (var v = !1, m = void 0, g = 0, _ = p; g < _.length; g++) {
                    var x = _[g];
                    if (yt(x)) {
                      if (v = !0, h(x))
                        break;
                    } else if (typeof x == "object" && x) {
                      var w = r.policies.identify(x)[0];
                      w && (m = x);
                    }
                    if (v && m !== void 0) {
                      globalThis.__DEV__ !== !1 && ke.warn(4, m);
                      break;
                    }
                  }
              }
            }
            f !== void 0 && (s = !1);
          }
        }), a)
          return this.merge(t, o), s && (this instanceof lo ? this.data[t] = void 0 : delete this.data[t], this.group.dirty(t, "__exists")), !0;
      }
      return !1;
    }, e.prototype.delete = function(t, n, r) {
      var i, o = this.lookup(t);
      if (o) {
        var a = this.getFieldValue(o, "__typename"), s = n && r ? this.policies.getStoreFieldName({ typename: a, fieldName: n, args: r }) : n;
        return this.modify(t, s ? (i = {}, i[s] = Pm, i) : Pm);
      }
      return !1;
    }, e.prototype.evict = function(t, n) {
      var r = !1;
      return t.id && (yn.call(this.data, t.id) && (r = this.delete(t.id, t.fieldName, t.args)), this instanceof lo && this !== n && (r = this.parent.evict(t, n) || r), (t.fieldName || r) && this.group.dirty(t.id, t.fieldName || "__exists")), r;
    }, e.prototype.clear = function() {
      this.replace(null);
    }, e.prototype.extract = function() {
      var t = this, n = this.toObject(), r = [];
      return this.getRootIdSet().forEach(function(i) {
        yn.call(t.policies.rootTypenamesById, i) || r.push(i);
      }), r.length && (n.__META = { extraRootIds: r.sort() }), n;
    }, e.prototype.replace = function(t) {
      var n = this;
      if (Object.keys(this.data).forEach(function(o) {
        t && yn.call(t, o) || n.delete(o);
      }), t) {
        var r = t.__META, i = Ui(t, ["__META"]);
        Object.keys(i).forEach(function(o) {
          n.merge(o, i[o]);
        }), r && r.extraRootIds.forEach(this.retain, this);
      }
    }, e.prototype.retain = function(t) {
      return this.rootIds[t] = (this.rootIds[t] || 0) + 1;
    }, e.prototype.release = function(t) {
      if (this.rootIds[t] > 0) {
        var n = --this.rootIds[t];
        return n || delete this.rootIds[t], n;
      }
      return 0;
    }, e.prototype.getRootIdSet = function(t) {
      return t === void 0 && (t = /* @__PURE__ */ new Set()), Object.keys(this.rootIds).forEach(t.add, t), this instanceof lo ? this.parent.getRootIdSet(t) : Object.keys(this.policies.rootTypenamesById).forEach(t.add, t), t;
    }, e.prototype.gc = function() {
      var t = this, n = this.getRootIdSet(), r = this.toObject();
      n.forEach(function(a) {
        yn.call(r, a) && (Object.keys(t.findChildRefIds(a)).forEach(n.add, n), delete r[a]);
      });
      var i = Object.keys(r);
      if (i.length) {
        for (var o = this; o instanceof lo; )
          o = o.parent;
        i.forEach(function(a) {
          return o.delete(a);
        });
      }
      return i;
    }, e.prototype.findChildRefIds = function(t) {
      if (!yn.call(this.refs, t)) {
        var n = this.refs[t] = /* @__PURE__ */ Object.create(null), r = this.data[t];
        if (!r)
          return n;
        var i = /* @__PURE__ */ new Set([r]);
        i.forEach(function(o) {
          yt(o) && (n[o.__ref] = !0), zt(o) && Object.keys(o).forEach(function(a) {
            var s = o[a];
            zt(s) && i.add(s);
          });
        });
      }
      return this.refs[t];
    }, e.prototype.makeCacheKey = function() {
      return this.group.keyMaker.lookupArray(arguments);
    }, e;
  })()
), c3 = (
  /** @class */
  (function() {
    function e(t, n) {
      n === void 0 && (n = null), this.caching = t, this.parent = n, this.d = null, this.resetCaching();
    }
    return e.prototype.resetCaching = function() {
      this.d = this.caching ? jC() : null, this.keyMaker = new ro(Za);
    }, e.prototype.depend = function(t, n) {
      if (this.d) {
        this.d(Am(t, n));
        var r = No(n);
        r !== n && this.d(Am(t, r)), this.parent && this.parent.depend(t, n);
      }
    }, e.prototype.dirty = function(t, n) {
      this.d && this.d.dirty(
        Am(t, n),
        // When storeFieldName === "__exists", that means the entity identified
        // by dataId has either disappeared from the cache or was newly added,
        // so the result caching system would do well to "forget everything it
        // knows" about that object. To achieve that kind of invalidation, we
        // not only dirty the associated result cache entry, but also remove it
        // completely from the dependency graph. For the optimism implementation
        // details, see https://github.com/benjamn/optimism/pull/195.
        n === "__exists" ? "forget" : "setDirty"
      );
    }, e;
  })()
);
function Am(e, t) {
  return t + "#" + e;
}
function rS(e, t) {
  mu(e) && e.group.depend(t, "__exists");
}
(function(e) {
  var t = (
    /** @class */
    (function(n) {
      pi(r, n);
      function r(i) {
        var o = i.policies, a = i.resultCaching, s = a === void 0 ? !0 : a, l = i.seed, u = n.call(this, o, new c3(s)) || this;
        return u.stump = new fee(u), u.storageTrie = new ro(Za), l && u.replace(l), u;
      }
      return r.prototype.addLayer = function(i, o) {
        return this.stump.addLayer(i, o);
      }, r.prototype.removeLayer = function() {
        return this;
      }, r.prototype.getStorage = function() {
        return this.storageTrie.lookupArray(arguments);
      }, r;
    })(e)
  );
  e.Root = t;
})(Hu || (Hu = {}));
var lo = (
  /** @class */
  (function(e) {
    pi(t, e);
    function t(n, r, i, o) {
      var a = e.call(this, r.policies, o) || this;
      return a.id = n, a.parent = r, a.replay = i, a.group = o, i(a), a;
    }
    return t.prototype.addLayer = function(n, r) {
      return new t(n, this, r, this.group);
    }, t.prototype.removeLayer = function(n) {
      var r = this, i = this.parent.removeLayer(n);
      return n === this.id ? (this.group.caching && Object.keys(this.data).forEach(function(o) {
        var a = r.data[o], s = i.lookup(o);
        s ? a ? a !== s && Object.keys(a).forEach(function(l) {
          $t(a[l], s[l]) || r.group.dirty(o, l);
        }) : (r.group.dirty(o, "__exists"), Object.keys(s).forEach(function(l) {
          r.group.dirty(o, l);
        })) : r.delete(o);
      }), i) : i === this.parent ? this : i.addLayer(this.id, this.replay);
    }, t.prototype.toObject = function() {
      return Z(Z({}, this.parent.toObject()), this.data);
    }, t.prototype.findChildRefIds = function(n) {
      var r = this.parent.findChildRefIds(n);
      return yn.call(this.data, n) ? Z(Z({}, r), e.prototype.findChildRefIds.call(this, n)) : r;
    }, t.prototype.getStorage = function() {
      for (var n = this.parent; n.parent; )
        n = n.parent;
      return n.getStorage.apply(
        n,
        // @ts-expect-error
        arguments
      );
    }, t;
  })(Hu)
), fee = (
  /** @class */
  (function(e) {
    pi(t, e);
    function t(n) {
      return e.call(this, "EntityStore.Stump", n, function() {
      }, new c3(n.group.caching, n.group)) || this;
    }
    return t.prototype.removeLayer = function() {
      return this;
    }, t.prototype.merge = function(n, r) {
      return this.parent.merge(n, r);
    }, t;
  })(lo)
);
function dee(e, t, n) {
  var r = e[n], i = t[n];
  return $t(r, i) ? r : i;
}
function mu(e) {
  return !!(e instanceof Hu && e.group.caching);
}
function pee(e) {
  return zt(e) ? Jt(e) ? e.slice(0) : Z({ __proto__: Object.getPrototypeOf(e) }, e) : e;
}
var iS = (
  /** @class */
  (function() {
    function e() {
      this.known = new (P0 ? WeakSet : Set)(), this.pool = new ro(Za), this.passes = /* @__PURE__ */ new WeakMap(), this.keysByJSON = /* @__PURE__ */ new Map(), this.empty = this.admit({});
    }
    return e.prototype.isKnown = function(t) {
      return zt(t) && this.known.has(t);
    }, e.prototype.pass = function(t) {
      if (zt(t)) {
        var n = pee(t);
        return this.passes.set(n, t), n;
      }
      return t;
    }, e.prototype.admit = function(t) {
      var n = this;
      if (zt(t)) {
        var r = this.passes.get(t);
        if (r)
          return r;
        var i = Object.getPrototypeOf(t);
        switch (i) {
          case Array.prototype: {
            if (this.known.has(t))
              return t;
            var o = t.map(this.admit, this), a = this.pool.lookupArray(o);
            return a.array || (this.known.add(a.array = o), globalThis.__DEV__ !== !1 && Object.freeze(o)), a.array;
          }
          case null:
          case Object.prototype: {
            if (this.known.has(t))
              return t;
            var s = Object.getPrototypeOf(t), l = [s], u = this.sortedKeys(t);
            l.push(u.json);
            var c = l.length;
            u.sorted.forEach(function(p) {
              l.push(n.admit(t[p]));
            });
            var a = this.pool.lookupArray(l);
            if (!a.object) {
              var f = a.object = Object.create(s);
              this.known.add(f), u.sorted.forEach(function(p, h) {
                f[p] = l[c + h];
              }), globalThis.__DEV__ !== !1 && Object.freeze(f);
            }
            return a.object;
          }
        }
      }
      return t;
    }, e.prototype.sortedKeys = function(t) {
      var n = Object.keys(t), r = this.pool.lookupArray(n);
      if (!r.keys) {
        n.sort();
        var i = JSON.stringify(n);
        (r.keys = this.keysByJSON.get(i)) || this.keysByJSON.set(i, r.keys = { sorted: n, json: i });
      }
      return r.keys;
    }, e;
  })()
);
function oS(e) {
  return [
    e.selectionSet,
    e.objectOrReference,
    e.context,
    // We split out this property so we can pass different values
    // independently without modifying options.context itself.
    e.context.canonizeResults
  ];
}
var hee = (
  /** @class */
  (function() {
    function e(t) {
      var n = this;
      this.knownResults = new (Za ? WeakMap : Map)(), this.config = Js(t, {
        addTypename: t.addTypename !== !1,
        canonizeResults: s3(t)
      }), this.canon = t.canon || new iS(), this.executeSelectionSet = qu(function(r) {
        var i, o = r.context.canonizeResults, a = oS(r);
        a[3] = !o;
        var s = (i = n.executeSelectionSet).peek.apply(i, a);
        return s ? o ? Z(Z({}, s), {
          // If we previously read this result without canonizing it, we can
          // reuse that result simply by canonizing it now.
          result: n.canon.admit(s.result)
        }) : s : (rS(r.context.store, r.enclosingRef.__ref), n.execSelectionSetImpl(r));
      }, {
        max: this.config.resultCacheMaxSize || Ji["inMemoryCache.executeSelectionSet"] || 5e4,
        keyArgs: oS,
        // Note that the parameters of makeCacheKey are determined by the
        // array returned by keyArgs.
        makeCacheKey: function(r, i, o, a) {
          if (mu(o.store))
            return o.store.makeCacheKey(r, yt(i) ? i.__ref : i, o.varString, a);
        }
      }), this.executeSubSelectedArray = qu(function(r) {
        return rS(r.context.store, r.enclosingRef.__ref), n.execSubSelectedArrayImpl(r);
      }, {
        max: this.config.resultCacheMaxSize || Ji["inMemoryCache.executeSubSelectedArray"] || 1e4,
        makeCacheKey: function(r) {
          var i = r.field, o = r.array, a = r.context;
          if (mu(a.store))
            return a.store.makeCacheKey(i, o, a.varString);
        }
      });
    }
    return e.prototype.resetCanon = function() {
      this.canon = new iS();
    }, e.prototype.diffQueryAgainstStore = function(t) {
      var n = t.store, r = t.query, i = t.rootId, o = i === void 0 ? "ROOT_QUERY" : i, a = t.variables, s = t.returnPartialData, l = s === void 0 ? !0 : s, u = t.canonizeResults, c = u === void 0 ? this.config.canonizeResults : u, f = this.config.cache.policies;
      a = Z(Z({}, A0($C(r))), a);
      var d = Ts(o), p = this.executeSelectionSet({
        selectionSet: xc(r).selectionSet,
        objectOrReference: d,
        enclosingRef: d,
        context: Z({ store: n, query: r, policies: f, variables: a, varString: xo(a), canonizeResults: c }, u3(r, this.config.fragments))
      }), h;
      if (p.missing && (h = [
        new i3(mee(p.missing), p.missing, r, a)
      ], !l))
        throw h[0];
      return {
        result: p.result,
        complete: !h,
        missing: h
      };
    }, e.prototype.isFresh = function(t, n, r, i) {
      if (mu(i.store) && this.knownResults.get(t) === r) {
        var o = this.executeSelectionSet.peek(
          r,
          n,
          i,
          // If result is canonical, then it could only have been previously
          // cached by the canonizing version of executeSelectionSet, so we can
          // avoid checking both possibilities here.
          this.canon.isKnown(t)
        );
        if (o && t === o.result)
          return !0;
      }
      return !1;
    }, e.prototype.execSelectionSetImpl = function(t) {
      var n = this, r = t.selectionSet, i = t.objectOrReference, o = t.enclosingRef, a = t.context;
      if (yt(i) && !a.policies.rootTypenamesById[i.__ref] && !a.store.has(i.__ref))
        return {
          result: this.canon.empty,
          missing: "Dangling reference to missing ".concat(i.__ref, " object")
        };
      var s = a.variables, l = a.policies, u = a.store, c = u.getFieldValue(i, "__typename"), f = [], d, p = new Ro();
      this.config.addTypename && typeof c == "string" && !l.rootIdsByTypename[c] && f.push({ __typename: c });
      function h(x, w) {
        var $;
        return x.missing && (d = p.merge(d, ($ = {}, $[w] = x.missing, $))), x.result;
      }
      var v = new Set(r.selections);
      v.forEach(function(x) {
        var w, $;
        if (wc(x, s))
          if (Io(x)) {
            var k = l.readField({
              fieldName: x.name.value,
              field: x,
              variables: a.variables,
              from: i
            }, a), D = Xi(x);
            k === void 0 ? M0.added(x) || (d = p.merge(d, (w = {}, w[D] = "Can't find field '".concat(x.name.value, "' on ").concat(yt(i) ? i.__ref + " object" : "object " + JSON.stringify(i, null, 2)), w))) : Jt(k) ? k.length > 0 && (k = h(n.executeSubSelectedArray({
              field: x,
              array: k,
              enclosingRef: o,
              context: a
            }), D)) : x.selectionSet ? k != null && (k = h(n.executeSelectionSet({
              selectionSet: x.selectionSet,
              objectOrReference: k,
              enclosingRef: yt(k) ? k : o,
              context: a
            }), D)) : a.canonizeResults && (k = n.canon.pass(k)), k !== void 0 && f.push(($ = {}, $[D] = k, $));
          } else {
            var E = Zp(x, a.lookupFragment);
            if (!E && x.kind === Ht.FRAGMENT_SPREAD)
              throw Zn(10, x.name.value);
            E && l.fragmentMatches(E, c) && E.selectionSet.selections.forEach(v.add, v);
          }
      });
      var m = Jp(f), g = { result: m, missing: d }, _ = a.canonizeResults ? this.canon.admit(g) : Vd(g);
      return _.result && this.knownResults.set(_.result, r), _;
    }, e.prototype.execSubSelectedArrayImpl = function(t) {
      var n = this, r = t.field, i = t.array, o = t.enclosingRef, a = t.context, s, l = new Ro();
      function u(c, f) {
        var d;
        return c.missing && (s = l.merge(s, (d = {}, d[f] = c.missing, d))), c.result;
      }
      return r.selectionSet && (i = i.filter(a.store.canRead)), i = i.map(function(c, f) {
        return c === null ? null : Jt(c) ? u(n.executeSubSelectedArray({
          field: r,
          array: c,
          enclosingRef: o,
          context: a
        }), f) : r.selectionSet ? u(n.executeSelectionSet({
          selectionSet: r.selectionSet,
          objectOrReference: c,
          enclosingRef: yt(c) ? c : o,
          context: a
        }), f) : (globalThis.__DEV__ !== !1 && vee(a.store, r, c), c);
      }), {
        result: a.canonizeResults ? this.canon.admit(i) : i,
        missing: s
      };
    }, e;
  })()
);
function mee(e) {
  try {
    JSON.stringify(e, function(t, n) {
      if (typeof n == "string")
        throw n;
      return n;
    });
  } catch (t) {
    return t;
  }
}
function vee(e, t, n) {
  if (!t.selectionSet) {
    var r = /* @__PURE__ */ new Set([n]);
    r.forEach(function(i) {
      zt(i) && (ke(
        !yt(i),
        11,
        uee(e, i),
        t.name.value
      ), Object.values(i).forEach(r.add, r));
    });
  }
}
var V0 = new $l(), aS = /* @__PURE__ */ new WeakMap();
function vu(e) {
  var t = aS.get(e);
  return t || aS.set(e, t = {
    vars: /* @__PURE__ */ new Set(),
    dep: jC()
  }), t;
}
function sS(e) {
  vu(e).vars.forEach(function(t) {
    return t.forgetCache(e);
  });
}
function gee(e) {
  vu(e).vars.forEach(function(t) {
    return t.attachCache(e);
  });
}
function yee(e) {
  var t = /* @__PURE__ */ new Set(), n = /* @__PURE__ */ new Set(), r = function(o) {
    if (arguments.length > 0) {
      if (e !== o) {
        e = o, t.forEach(function(l) {
          vu(l).dep.dirty(r), bee(l);
        });
        var a = Array.from(n);
        n.clear(), a.forEach(function(l) {
          return l(e);
        });
      }
    } else {
      var s = V0.getValue();
      s && (i(s), vu(s).dep(r));
    }
    return e;
  };
  r.onNextChange = function(o) {
    return n.add(o), function() {
      n.delete(o);
    };
  };
  var i = r.attachCache = function(o) {
    return t.add(o), vu(o).vars.add(r), r;
  };
  return r.forgetCache = function(o) {
    return t.delete(o);
  }, r;
}
function bee(e) {
  e.broadcastWatches && e.broadcastWatches();
}
var lS = /* @__PURE__ */ Object.create(null);
function B0(e) {
  var t = JSON.stringify(e);
  return lS[t] || (lS[t] = /* @__PURE__ */ Object.create(null));
}
function uS(e) {
  var t = B0(e);
  return t.keyFieldsFn || (t.keyFieldsFn = function(n, r) {
    var i = function(a, s) {
      return r.readField(s, a);
    }, o = r.keyObject = K0(e, function(a) {
      var s = Ps(
        r.storeObject,
        a,
        // Using context.readField to extract paths from context.storeObject
        // allows the extraction to see through Reference objects and respect
        // custom read functions.
        i
      );
      return s === void 0 && n !== r.storeObject && yn.call(n, a[0]) && (s = Ps(n, a, d3)), ke(s !== void 0, 5, a.join("."), n), s;
    });
    return "".concat(r.typename, ":").concat(JSON.stringify(o));
  });
}
function cS(e) {
  var t = B0(e);
  return t.keyArgsFn || (t.keyArgsFn = function(n, r) {
    var i = r.field, o = r.variables, a = r.fieldName, s = K0(e, function(u) {
      var c = u[0], f = c.charAt(0);
      if (f === "@") {
        if (i && Ci(i.directives)) {
          var d = c.slice(1), p = i.directives.find(function(g) {
            return g.name.value === d;
          }), h = p && Gp(p, o);
          return h && Ps(
            h,
            // If keyPath.length === 1, this code calls extractKeyPath with an
            // empty path, which works because it uses directiveArgs as the
            // extracted value.
            u.slice(1)
          );
        }
        return;
      }
      if (f === "$") {
        var v = c.slice(1);
        if (o && yn.call(o, v)) {
          var m = u.slice(0);
          return m[0] = v, Ps(o, m);
        }
        return;
      }
      if (n)
        return Ps(n, u);
    }), l = JSON.stringify(s);
    return (n || l !== "{}") && (a += ":" + l), a;
  });
}
function K0(e, t) {
  var n = new Ro();
  return f3(e).reduce(function(r, i) {
    var o, a = t(i);
    if (a !== void 0) {
      for (var s = i.length - 1; s >= 0; --s)
        a = (o = {}, o[i[s]] = a, o);
      r = n.merge(r, a);
    }
    return r;
  }, /* @__PURE__ */ Object.create(null));
}
function f3(e) {
  var t = B0(e);
  if (!t.paths) {
    var n = t.paths = [], r = [];
    e.forEach(function(i, o) {
      Jt(i) ? (f3(i).forEach(function(a) {
        return n.push(r.concat(a));
      }), r.length = 0) : (r.push(i), Jt(e[o + 1]) || (n.push(r.slice(0)), r.length = 0));
    });
  }
  return t.paths;
}
function d3(e, t) {
  return e[t];
}
function Ps(e, t, n) {
  return n = n || d3, p3(t.reduce(function r(i, o) {
    return Jt(i) ? i.map(function(a) {
      return r(a, o);
    }) : i && n(i, o);
  }, e));
}
function p3(e) {
  return zt(e) ? Jt(e) ? e.map(p3) : K0(Object.keys(e).sort(), function(t) {
    return Ps(e, t);
  }) : e;
}
function Xg(e) {
  return e.args !== void 0 ? e.args : e.field ? Gp(e.field, e.variables) : null;
}
var _ee = function() {
}, fS = function(e, t) {
  return t.fieldName;
}, dS = function(e, t, n) {
  var r = n.mergeObjects;
  return r(e, t);
}, pS = function(e, t) {
  return t;
}, wee = (
  /** @class */
  (function() {
    function e(t) {
      this.config = t, this.typePolicies = /* @__PURE__ */ Object.create(null), this.toBeAdded = /* @__PURE__ */ Object.create(null), this.supertypeMap = /* @__PURE__ */ new Map(), this.fuzzySubtypes = /* @__PURE__ */ new Map(), this.rootIdsByTypename = /* @__PURE__ */ Object.create(null), this.rootTypenamesById = /* @__PURE__ */ Object.create(null), this.usingPossibleTypes = !1, this.config = Z({ dataIdFromObject: o3 }, t), this.cache = this.config.cache, this.setRootTypename("Query"), this.setRootTypename("Mutation"), this.setRootTypename("Subscription"), t.possibleTypes && this.addPossibleTypes(t.possibleTypes), t.typePolicies && this.addTypePolicies(t.typePolicies);
    }
    return e.prototype.identify = function(t, n) {
      var r, i = this, o = n && (n.typename || ((r = n.storeObject) === null || r === void 0 ? void 0 : r.__typename)) || t.__typename;
      if (o === this.rootTypenamesById.ROOT_QUERY)
        return ["ROOT_QUERY"];
      var a = n && n.storeObject || t, s = Z(Z({}, n), { typename: o, storeObject: a, readField: n && n.readField || function() {
        var f = U0(arguments, a);
        return i.readField(f, {
          store: i.cache.data,
          variables: f.variables
        });
      } }), l, u = o && this.getTypePolicy(o), c = u && u.keyFn || this.config.dataIdFromObject;
      return L0.withValue(!0, function() {
        for (; c; ) {
          var f = c(Z(Z({}, t), a), s);
          if (Jt(f))
            c = uS(f);
          else {
            l = f;
            break;
          }
        }
      }), l = l ? String(l) : void 0, s.keyObject ? [l, s.keyObject] : [l];
    }, e.prototype.addTypePolicies = function(t) {
      var n = this;
      Object.keys(t).forEach(function(r) {
        var i = t[r], o = i.queryType, a = i.mutationType, s = i.subscriptionType, l = Ui(i, ["queryType", "mutationType", "subscriptionType"]);
        o && n.setRootTypename("Query", r), a && n.setRootTypename("Mutation", r), s && n.setRootTypename("Subscription", r), yn.call(n.toBeAdded, r) ? n.toBeAdded[r].push(l) : n.toBeAdded[r] = [l];
      });
    }, e.prototype.updateTypePolicy = function(t, n, r) {
      var i = this.getTypePolicy(t), o = n.keyFields, a = n.fields;
      function s(l, u) {
        l.merge = typeof u == "function" ? u : u === !0 ? dS : u === !1 ? pS : l.merge;
      }
      s(i, n.merge), i.keyFn = // Pass false to disable normalization for this typename.
      o === !1 ? _ee : Jt(o) ? uS(o) : typeof o == "function" ? o : i.keyFn, a && Object.keys(a).forEach(function(l) {
        var u = r[l];
        (!u || u?.typename !== t) && (u = r[l] = { typename: t });
        var c = a[l];
        if (typeof c == "function")
          u.read = c;
        else {
          var f = c.keyArgs, d = c.read, p = c.merge;
          u.keyFn = // Pass false to disable argument-based differentiation of
          // field identities.
          f === !1 ? fS : Jt(f) ? cS(f) : typeof f == "function" ? f : u.keyFn, typeof d == "function" && (u.read = d), s(u, p);
        }
        u.read && u.merge && (u.keyFn = u.keyFn || fS);
      });
    }, e.prototype.setRootTypename = function(t, n) {
      n === void 0 && (n = t);
      var r = "ROOT_" + t.toUpperCase(), i = this.rootTypenamesById[r];
      n !== i && (ke(!i || i === t, 6, t), i && delete this.rootIdsByTypename[i], this.rootIdsByTypename[n] = r, this.rootTypenamesById[r] = n);
    }, e.prototype.addPossibleTypes = function(t) {
      var n = this;
      this.usingPossibleTypes = !0, Object.keys(t).forEach(function(r) {
        n.getSupertypeSet(r, !0), t[r].forEach(function(i) {
          n.getSupertypeSet(i, !0).add(r);
          var o = i.match(l3);
          (!o || o[0] !== i) && n.fuzzySubtypes.set(i, new RegExp(i));
        });
      });
    }, e.prototype.getTypePolicy = function(t) {
      var n = this;
      if (!yn.call(this.typePolicies, t)) {
        var r = this.typePolicies[t] = /* @__PURE__ */ Object.create(null);
        r.fields = /* @__PURE__ */ Object.create(null);
        var i = this.supertypeMap.get(t);
        !i && this.fuzzySubtypes.size && (i = this.getSupertypeSet(t, !0), this.fuzzySubtypes.forEach(function(a, s) {
          if (a.test(t)) {
            var l = n.supertypeMap.get(s);
            l && l.forEach(function(u) {
              return i.add(u);
            });
          }
        })), i && i.size && i.forEach(function(a) {
          var s = n.getTypePolicy(a), l = s.fields, u = Ui(s, ["fields"]);
          Object.assign(r, u), Object.assign(r.fields, l);
        });
      }
      var o = this.toBeAdded[t];
      return o && o.length && o.splice(0).forEach(function(a) {
        n.updateTypePolicy(t, a, n.typePolicies[t].fields);
      }), this.typePolicies[t];
    }, e.prototype.getFieldPolicy = function(t, n) {
      if (t)
        return this.getTypePolicy(t).fields[n];
    }, e.prototype.getSupertypeSet = function(t, n) {
      var r = this.supertypeMap.get(t);
      return !r && n && this.supertypeMap.set(t, r = /* @__PURE__ */ new Set()), r;
    }, e.prototype.fragmentMatches = function(t, n, r, i) {
      var o = this;
      if (!t.typeCondition)
        return !0;
      if (!n)
        return !1;
      var a = t.typeCondition.name.value;
      if (n === a)
        return !0;
      if (this.usingPossibleTypes && this.supertypeMap.has(a))
        for (var s = this.getSupertypeSet(n, !0), l = [s], u = function(h) {
          var v = o.getSupertypeSet(h, !1);
          v && v.size && l.indexOf(v) < 0 && l.push(v);
        }, c = !!(r && this.fuzzySubtypes.size), f = !1, d = 0; d < l.length; ++d) {
          var p = l[d];
          if (p.has(a))
            return s.has(a) || (f && globalThis.__DEV__ !== !1 && ke.warn(7, n, a), s.add(a)), !0;
          p.forEach(u), c && // Start checking fuzzy subtypes only after exhausting all
          // non-fuzzy subtypes (after the final iteration of the loop).
          d === l.length - 1 && // We could wait to compare fragment.selectionSet to result
          // after we verify the supertype, but this check is often less
          // expensive than that search, and we will have to do the
          // comparison anyway whenever we find a potential match.
          Jg(t.selectionSet, r, i) && (c = !1, f = !0, this.fuzzySubtypes.forEach(function(h, v) {
            var m = n.match(h);
            m && m[0] === n && u(v);
          }));
        }
      return !1;
    }, e.prototype.hasKeyArgs = function(t, n) {
      var r = this.getFieldPolicy(t, n);
      return !!(r && r.keyFn);
    }, e.prototype.getStoreFieldName = function(t) {
      var n = t.typename, r = t.fieldName, i = this.getFieldPolicy(n, r), o, a = i && i.keyFn;
      if (a && n)
        for (var s = {
          typename: n,
          fieldName: r,
          field: t.field || null,
          variables: t.variables
        }, l = Xg(t); a; ) {
          var u = a(l, s);
          if (Jt(u))
            a = cS(u);
          else {
            o = u || r;
            break;
          }
        }
      return o === void 0 && (o = t.field ? FJ(t.field, t.variables) : SC(r, Xg(t))), o === !1 ? r : r === No(o) ? o : r + ":" + o;
    }, e.prototype.readField = function(t, n) {
      var r = t.from;
      if (r) {
        var i = t.field || t.fieldName;
        if (i) {
          if (t.typename === void 0) {
            var o = n.store.getFieldValue(r, "__typename");
            o && (t.typename = o);
          }
          var a = this.getStoreFieldName(t), s = No(a), l = n.store.getFieldValue(r, a), u = this.getFieldPolicy(t.typename, s), c = u && u.read;
          if (c) {
            var f = hS(this, r, t, n, n.store.getStorage(yt(r) ? r.__ref : r, a));
            return V0.withValue(this.cache, c, [
              l,
              f
            ]);
          }
          return l;
        }
      }
    }, e.prototype.getReadFunction = function(t, n) {
      var r = this.getFieldPolicy(t, n);
      return r && r.read;
    }, e.prototype.getMergeFunction = function(t, n, r) {
      var i = this.getFieldPolicy(t, n), o = i && i.merge;
      return !o && r && (i = this.getTypePolicy(r), o = i && i.merge), o;
    }, e.prototype.runMergeFunction = function(t, n, r, i, o) {
      var a = r.field, s = r.typename, l = r.merge;
      return l === dS ? h3(i.store)(t, n) : l === pS ? n : (i.overwrite && (t = void 0), l(t, n, hS(
        this,
        // Unlike options.readField for read functions, we do not fall
        // back to the current object if no foreignObjOrRef is provided,
        // because it's not clear what the current object should be for
        // merge functions: the (possibly undefined) existing object, or
        // the incoming object? If you think your merge function needs
        // to read sibling fields in order to produce a new value for
        // the current field, you might want to rethink your strategy,
        // because that's a recipe for making merge behavior sensitive
        // to the order in which fields are written into the cache.
        // However, readField(name, ref) is useful for merge functions
        // that need to deduplicate child objects and references.
        void 0,
        {
          typename: s,
          fieldName: a.name.value,
          field: a,
          variables: i.variables
        },
        i,
        o || /* @__PURE__ */ Object.create(null)
      )));
    }, e;
  })()
);
function hS(e, t, n, r, i) {
  var o = e.getStoreFieldName(n), a = No(o), s = n.variables || r.variables, l = r.store, u = l.toReference, c = l.canRead;
  return {
    args: Xg(n),
    field: n.field || null,
    fieldName: a,
    storeFieldName: o,
    variables: s,
    isReference: yt,
    toReference: u,
    storage: i,
    cache: e.cache,
    canRead: c,
    readField: function() {
      return e.readField(U0(arguments, t, s), r);
    },
    mergeObjects: h3(r.store)
  };
}
function U0(e, t, n) {
  var r = e[0], i = e[1], o = e.length, a;
  return typeof r == "string" ? a = {
    fieldName: r,
    // Default to objectOrReference only when no second argument was
    // passed for the from parameter, not when undefined is explicitly
    // passed as the second argument.
    from: o > 1 ? i : t
  } : (a = Z({}, r), yn.call(a, "from") || (a.from = t)), globalThis.__DEV__ !== !1 && a.from === void 0 && globalThis.__DEV__ !== !1 && ke.warn(8, pC(Array.from(e))), a.variables === void 0 && (a.variables = n), a;
}
function h3(e) {
  return function(t, n) {
    if (Jt(t) || Jt(n))
      throw Zn(9);
    if (zt(t) && zt(n)) {
      var r = e.getFieldValue(t, "__typename"), i = e.getFieldValue(n, "__typename"), o = r && i && r !== i;
      if (o)
        return n;
      if (yt(t) && ys(n))
        return e.merge(t.__ref, n), t;
      if (ys(t) && yt(n))
        return e.merge(t, n.__ref), n;
      if (ys(t) && ys(n))
        return Z(Z({}, t), n);
    }
    return n;
  };
}
function Dm(e, t, n) {
  var r = "".concat(t).concat(n), i = e.flavors.get(r);
  return i || e.flavors.set(r, i = e.clientOnly === t && e.deferred === n ? e : Z(Z({}, e), { clientOnly: t, deferred: n })), i;
}
var xee = (
  /** @class */
  (function() {
    function e(t, n, r) {
      this.cache = t, this.reader = n, this.fragments = r;
    }
    return e.prototype.writeToStore = function(t, n) {
      var r = this, i = n.query, o = n.result, a = n.dataId, s = n.variables, l = n.overwrite, u = Ca(i), c = cee();
      s = Z(Z({}, A0(u)), s);
      var f = Z(Z({ store: t, written: /* @__PURE__ */ Object.create(null), merge: function(p, h) {
        return c.merge(p, h);
      }, variables: s, varString: xo(s) }, u3(i, this.fragments)), { overwrite: !!l, incomingById: /* @__PURE__ */ new Map(), clientOnly: !1, deferred: !1, flavors: /* @__PURE__ */ new Map() }), d = this.processSelectionSet({
        result: o || /* @__PURE__ */ Object.create(null),
        dataId: a,
        selectionSet: u.selectionSet,
        mergeTree: { map: /* @__PURE__ */ new Map() },
        context: f
      });
      if (!yt(d))
        throw Zn(12, o);
      return f.incomingById.forEach(function(p, h) {
        var v = p.storeObject, m = p.mergeTree, g = p.fieldNodeSet, _ = Ts(h);
        if (m && m.map.size) {
          var x = r.applyMerges(m, _, v, f);
          if (yt(x))
            return;
          v = x;
        }
        if (globalThis.__DEV__ !== !1 && !f.overwrite) {
          var w = /* @__PURE__ */ Object.create(null);
          g.forEach(function(D) {
            D.selectionSet && (w[D.name.value] = !0);
          });
          var $ = function(D) {
            return w[No(D)] === !0;
          }, k = function(D) {
            var E = m && m.map.get(D);
            return !!(E && E.info && E.info.merge);
          };
          Object.keys(v).forEach(function(D) {
            $(D) && !k(D) && Eee(_, v, D, f.store);
          });
        }
        t.merge(h, v);
      }), t.retain(d.__ref), d;
    }, e.prototype.processSelectionSet = function(t) {
      var n = this, r = t.dataId, i = t.result, o = t.selectionSet, a = t.context, s = t.mergeTree, l = this.cache.policies, u = /* @__PURE__ */ Object.create(null), c = r && l.rootTypenamesById[r] || Vg(i, o, a.fragmentMap) || r && a.store.get(r, "__typename");
      typeof c == "string" && (u.__typename = c);
      var f = function() {
        var x = U0(arguments, u, a.variables);
        if (yt(x.from)) {
          var w = a.incomingById.get(x.from.__ref);
          if (w) {
            var $ = l.readField(Z(Z({}, x), { from: w.storeObject }), a);
            if ($ !== void 0)
              return $;
          }
        }
        return l.readField(x, a);
      }, d = /* @__PURE__ */ new Set();
      this.flattenFields(
        o,
        i,
        // This WriteContext will be the default context value for fields returned
        // by the flattenFields method, but some fields may be assigned a modified
        // context, depending on the presence of @client and other directives.
        a,
        c
      ).forEach(function(x, w) {
        var $, k = Xi(w), D = i[k];
        if (d.add(w), D !== void 0) {
          var E = l.getStoreFieldName({
            typename: c,
            fieldName: w.name.value,
            field: w,
            variables: x.variables
          }), b = mS(s, E), y = n.processFieldValue(
            D,
            w,
            // Reset context.clientOnly and context.deferred to their default
            // values before processing nested selection sets.
            w.selectionSet ? Dm(x, !1, !1) : x,
            b
          ), S = void 0;
          w.selectionSet && (yt(y) || ys(y)) && (S = f("__typename", y));
          var P = l.getMergeFunction(c, w.name.value, S);
          P ? b.info = {
            // TODO Check compatibility against any existing childTree.field?
            field: w,
            typename: c,
            merge: P
          } : vS(s, E), u = x.merge(u, ($ = {}, $[E] = y, $));
        } else globalThis.__DEV__ !== !1 && !x.clientOnly && !x.deferred && !M0.added(w) && // If the field has a read function, it may be a synthetic field or
        // provide a default value, so its absence from the written data should
        // not be cause for alarm.
        !l.getReadFunction(c, w.name.value) && globalThis.__DEV__ !== !1 && ke.error(13, Xi(w), i);
      });
      try {
        var p = l.identify(i, {
          typename: c,
          selectionSet: o,
          fragmentMap: a.fragmentMap,
          storeObject: u,
          readField: f
        }), h = p[0], v = p[1];
        r = r || h, v && (u = a.merge(u, v));
      } catch (x) {
        if (!r)
          throw x;
      }
      if (typeof r == "string") {
        var m = Ts(r), g = a.written[r] || (a.written[r] = []);
        if (g.indexOf(o) >= 0 || (g.push(o), this.reader && this.reader.isFresh(i, m, o, a)))
          return m;
        var _ = a.incomingById.get(r);
        return _ ? (_.storeObject = a.merge(_.storeObject, u), _.mergeTree = ey(_.mergeTree, s), d.forEach(function(x) {
          return _.fieldNodeSet.add(x);
        })) : a.incomingById.set(r, {
          storeObject: u,
          // Save a reference to mergeTree only if it is not empty, because
          // empty MergeTrees may be recycled by maybeRecycleChildMergeTree and
          // reused for entirely different parts of the result tree.
          mergeTree: Bd(s) ? void 0 : s,
          fieldNodeSet: d
        }), m;
      }
      return u;
    }, e.prototype.processFieldValue = function(t, n, r, i) {
      var o = this;
      return !n.selectionSet || t === null ? globalThis.__DEV__ !== !1 ? qC(t) : t : Jt(t) ? t.map(function(a, s) {
        var l = o.processFieldValue(a, n, r, mS(i, s));
        return vS(i, s), l;
      }) : this.processSelectionSet({
        result: t,
        selectionSet: n.selectionSet,
        context: r,
        mergeTree: i
      });
    }, e.prototype.flattenFields = function(t, n, r, i) {
      i === void 0 && (i = Vg(n, t, r.fragmentMap));
      var o = /* @__PURE__ */ new Map(), a = this.cache.policies, s = new ro(!1);
      return (function l(u, c) {
        var f = s.lookup(
          u,
          // Because we take inheritedClientOnly and inheritedDeferred into
          // consideration here (in addition to selectionSet), it's possible for
          // the same selection set to be flattened more than once, if it appears
          // in the query with different @client and/or @directive configurations.
          c.clientOnly,
          c.deferred
        );
        f.visited || (f.visited = !0, u.selections.forEach(function(d) {
          if (wc(d, r.variables)) {
            var p = c.clientOnly, h = c.deferred;
            if (
              // Since the presence of @client or @defer on this field can only
              // cause clientOnly or deferred to become true, we can skip the
              // forEach loop if both clientOnly and deferred are already true.
              !(p && h) && Ci(d.directives) && d.directives.forEach(function(g) {
                var _ = g.name.value;
                if (_ === "client" && (p = !0), _ === "defer") {
                  var x = Gp(g, r.variables);
                  (!x || x.if !== !1) && (h = !0);
                }
              }), Io(d)
            ) {
              var v = o.get(d);
              v && (p = p && v.clientOnly, h = h && v.deferred), o.set(d, Dm(r, p, h));
            } else {
              var m = Zp(d, r.lookupFragment);
              if (!m && d.kind === Ht.FRAGMENT_SPREAD)
                throw Zn(14, d.name.value);
              m && a.fragmentMatches(m, i, n, r.variables) && l(m.selectionSet, Dm(r, p, h));
            }
          }
        }));
      })(t, r), o;
    }, e.prototype.applyMerges = function(t, n, r, i, o) {
      var a, s = this;
      if (t.map.size && !yt(r)) {
        var l = (
          // Items in the same position in different arrays are not
          // necessarily related to each other, so when incoming is an array
          // we process its elements as if there was no existing data.
          !Jt(r) && // Likewise, existing must be either a Reference or a StoreObject
          // in order for its fields to be safe to merge with the fields of
          // the incoming object.
          (yt(n) || ys(n)) ? n : void 0
        ), u = r;
        l && !o && (o = [yt(l) ? l.__ref : l]);
        var c, f = function(d, p) {
          return Jt(d) ? typeof p == "number" ? d[p] : void 0 : i.store.getFieldValue(d, String(p));
        };
        t.map.forEach(function(d, p) {
          var h = f(l, p), v = f(u, p);
          if (v !== void 0) {
            o && o.push(p);
            var m = s.applyMerges(d, h, v, i, o);
            m !== v && (c = c || /* @__PURE__ */ new Map(), c.set(p, m)), o && ke(o.pop() === p);
          }
        }), c && (r = Jt(u) ? u.slice(0) : Z({}, u), c.forEach(function(d, p) {
          r[p] = d;
        }));
      }
      return t.info ? this.cache.policies.runMergeFunction(n, r, t.info, i, o && (a = i.store).getStorage.apply(a, o)) : r;
    }, e;
  })()
), m3 = [];
function mS(e, t) {
  var n = e.map;
  return n.has(t) || n.set(t, m3.pop() || { map: /* @__PURE__ */ new Map() }), n.get(t);
}
function ey(e, t) {
  if (e === t || !t || Bd(t))
    return e;
  if (!e || Bd(e))
    return t;
  var n = e.info && t.info ? Z(Z({}, e.info), t.info) : e.info || t.info, r = e.map.size && t.map.size, i = r ? /* @__PURE__ */ new Map() : e.map.size ? e.map : t.map, o = { info: n, map: i };
  if (r) {
    var a = new Set(t.map.keys());
    e.map.forEach(function(s, l) {
      o.map.set(l, ey(s, t.map.get(l))), a.delete(l);
    }), a.forEach(function(s) {
      o.map.set(s, ey(t.map.get(s), e.map.get(s)));
    });
  }
  return o;
}
function Bd(e) {
  return !e || !(e.info || e.map.size);
}
function vS(e, t) {
  var n = e.map, r = n.get(t);
  r && Bd(r) && (m3.push(r), n.delete(t));
}
var gS = /* @__PURE__ */ new Set();
function Eee(e, t, n, r) {
  var i = function(f) {
    var d = r.getFieldValue(f, n);
    return typeof d == "object" && d;
  }, o = i(e);
  if (o) {
    var a = i(t);
    if (a && !yt(o) && !$t(o, a) && !Object.keys(o).every(function(f) {
      return r.getFieldValue(a, f) !== void 0;
    })) {
      var s = r.getFieldValue(e, "__typename") || r.getFieldValue(t, "__typename"), l = No(n), u = "".concat(s, ".").concat(l);
      if (!gS.has(u)) {
        gS.add(u);
        var c = [];
        !Jt(o) && !Jt(a) && [o, a].forEach(function(f) {
          var d = r.getFieldValue(f, "__typename");
          typeof d == "string" && !c.includes(d) && c.push(d);
        }), globalThis.__DEV__ !== !1 && ke.warn(15, l, s, c.length ? "either ensure all objects of type " + c.join(" and ") + " have an ID or a custom merge function, or " : "", u, Z({}, o), Z({}, a));
      }
    }
  }
}
var See = (
  /** @class */
  (function(e) {
    pi(t, e);
    function t(n) {
      n === void 0 && (n = {});
      var r = e.call(this) || this;
      return r.watches = /* @__PURE__ */ new Set(), r.addTypenameTransform = new FC(M0), r.assumeImmutableResults = !0, r.makeVar = yee, r.txCount = 0, globalThis.__DEV__ !== !1 && (tn(n, "addTypename", "InMemoryCache", "Please remove the `addTypename` option when initializing `InMemoryCache`."), tn(n, "canonizeResults", "InMemoryCache", "Please remove the `canonizeResults` option when initializing `InMemoryCache`.")), r.config = lee(n), r.addTypename = !!r.config.addTypename, r.policies = new wee({
        cache: r,
        dataIdFromObject: r.config.dataIdFromObject,
        possibleTypes: r.config.possibleTypes,
        typePolicies: r.config.typePolicies
      }), r.init(), r;
    }
    return t.prototype.init = function() {
      var n = this.data = new Hu.Root({
        policies: this.policies,
        resultCaching: this.config.resultCaching
      });
      this.optimisticData = n.stump, this.resetResultCache();
    }, t.prototype.resetResultCache = function(n) {
      var r = this, i = this.storeReader, o = this.config.fragments;
      this.addTypenameTransform.resetCache(), o?.resetCaches(), this.storeWriter = new xee(this, this.storeReader = new hee({
        cache: this,
        addTypename: this.addTypename,
        resultCacheMaxSize: this.config.resultCacheMaxSize,
        canonizeResults: s3(this.config),
        canon: n ? void 0 : i && i.canon,
        fragments: o
      }), o), this.maybeBroadcastWatch = qu(function(a, s) {
        return r.broadcastWatch(a, s);
      }, {
        max: this.config.resultCacheMaxSize || Ji["inMemoryCache.maybeBroadcastWatch"] || 5e3,
        makeCacheKey: function(a) {
          var s = a.optimistic ? r.optimisticData : r.data;
          if (mu(s)) {
            var l = a.optimistic, u = a.id, c = a.variables;
            return s.makeCacheKey(
              a.query,
              // Different watches can have the same query, optimistic
              // status, rootId, and variables, but if their callbacks are
              // different, the (identical) result needs to be delivered to
              // each distinct callback. The easiest way to achieve that
              // separation is to include c.callback in the cache key for
              // maybeBroadcastWatch calls. See issue #5733.
              a.callback,
              xo({ optimistic: l, id: u, variables: c })
            );
          }
        }
      }), (/* @__PURE__ */ new Set([this.data.group, this.optimisticData.group])).forEach(function(a) {
        return a.resetCaching();
      });
    }, t.prototype.restore = function(n) {
      return this.init(), n && this.data.replace(n), this;
    }, t.prototype.extract = function(n) {
      return n === void 0 && (n = !1), (n ? this.optimisticData : this.data).extract();
    }, t.prototype.read = function(n) {
      globalThis.__DEV__ !== !1 && tn(n, "canonizeResults", "cache.read");
      var r = n.returnPartialData, i = r === void 0 ? !1 : r;
      try {
        return this.storeReader.diffQueryAgainstStore(Z(Z({}, n), { store: n.optimistic ? this.optimisticData : this.data, config: this.config, returnPartialData: i })).result || null;
      } catch (o) {
        if (o instanceof i3)
          return null;
        throw o;
      }
    }, t.prototype.write = function(n) {
      try {
        return ++this.txCount, this.storeWriter.writeToStore(this.data, n);
      } finally {
        !--this.txCount && n.broadcast !== !1 && this.broadcastWatches();
      }
    }, t.prototype.modify = function(n) {
      if (yn.call(n, "id") && !n.id)
        return !1;
      var r = n.optimistic ? this.optimisticData : this.data;
      try {
        return ++this.txCount, r.modify(n.id || "ROOT_QUERY", n.fields);
      } finally {
        !--this.txCount && n.broadcast !== !1 && this.broadcastWatches();
      }
    }, t.prototype.diff = function(n) {
      return globalThis.__DEV__ !== !1 && tn(n, "canonizeResults", "cache.diff"), this.storeReader.diffQueryAgainstStore(Z(Z({}, n), { store: n.optimistic ? this.optimisticData : this.data, rootId: n.id || "ROOT_QUERY", config: this.config }));
    }, t.prototype.watch = function(n) {
      var r = this;
      return this.watches.size || gee(this), this.watches.add(n), n.immediate && this.maybeBroadcastWatch(n), function() {
        r.watches.delete(n) && !r.watches.size && sS(r), r.maybeBroadcastWatch.forget(n);
      };
    }, t.prototype.gc = function(n) {
      globalThis.__DEV__ !== !1 && tn(n || {}, "resetResultIdentities", "cache.gc", "First ensure all usages of `canonizeResults` are removed, then remove this option."), xo.reset(), _o.reset();
      var r = this.optimisticData.gc();
      return n && !this.txCount && (n.resetResultCache ? this.resetResultCache(n.resetResultIdentities) : n.resetResultIdentities && this.storeReader.resetCanon()), r;
    }, t.prototype.retain = function(n, r) {
      return (r ? this.optimisticData : this.data).retain(n);
    }, t.prototype.release = function(n, r) {
      return (r ? this.optimisticData : this.data).release(n);
    }, t.prototype.identify = function(n) {
      if (yt(n))
        return n.__ref;
      try {
        return this.policies.identify(n)[0];
      } catch (r) {
        globalThis.__DEV__ !== !1 && ke.warn(r);
      }
    }, t.prototype.evict = function(n) {
      if (!n.id) {
        if (yn.call(n, "id"))
          return !1;
        n = Z(Z({}, n), { id: "ROOT_QUERY" });
      }
      try {
        return ++this.txCount, this.optimisticData.evict(n, this.data);
      } finally {
        !--this.txCount && n.broadcast !== !1 && this.broadcastWatches();
      }
    }, t.prototype.reset = function(n) {
      var r = this;
      return this.init(), xo.reset(), n && n.discardWatches ? (this.watches.forEach(function(i) {
        return r.maybeBroadcastWatch.forget(i);
      }), this.watches.clear(), sS(this)) : this.broadcastWatches(), Promise.resolve();
    }, t.prototype.removeOptimistic = function(n) {
      var r = this.optimisticData.removeLayer(n);
      r !== this.optimisticData && (this.optimisticData = r, this.broadcastWatches());
    }, t.prototype.batch = function(n) {
      var r = this, i = n.update, o = n.optimistic, a = o === void 0 ? !0 : o, s = n.removeOptimistic, l = n.onWatchUpdated, u, c = function(d) {
        var p = r, h = p.data, v = p.optimisticData;
        ++r.txCount, d && (r.data = r.optimisticData = d);
        try {
          return u = i(r);
        } finally {
          --r.txCount, r.data = h, r.optimisticData = v;
        }
      }, f = /* @__PURE__ */ new Set();
      return l && !this.txCount && this.broadcastWatches(Z(Z({}, n), { onWatchUpdated: function(d) {
        return f.add(d), !1;
      } })), typeof a == "string" ? this.optimisticData = this.optimisticData.addLayer(a, c) : a === !1 ? c(this.data) : c(), typeof s == "string" && (this.optimisticData = this.optimisticData.removeLayer(s)), l && f.size ? (this.broadcastWatches(Z(Z({}, n), { onWatchUpdated: function(d, p) {
        var h = l.call(this, d, p);
        return h !== !1 && f.delete(d), h;
      } })), f.size && f.forEach(function(d) {
        return r.maybeBroadcastWatch.dirty(d);
      })) : this.broadcastWatches(n), u;
    }, t.prototype.performTransaction = function(n, r) {
      return this.batch({
        update: n,
        optimistic: r || r !== null
      });
    }, t.prototype.transformDocument = function(n) {
      return this.addTypenameToDocument(this.addFragmentsToDocument(n));
    }, t.prototype.fragmentMatches = function(n, r) {
      return this.policies.fragmentMatches(n, r);
    }, t.prototype.lookupFragment = function(n) {
      var r;
      return ((r = this.config.fragments) === null || r === void 0 ? void 0 : r.lookup(n)) || null;
    }, t.prototype.broadcastWatches = function(n) {
      var r = this;
      this.txCount || this.watches.forEach(function(i) {
        return r.maybeBroadcastWatch(i, n);
      });
    }, t.prototype.addFragmentsToDocument = function(n) {
      var r = this.config.fragments;
      return r ? r.transform(n) : n;
    }, t.prototype.addTypenameToDocument = function(n) {
      return this.addTypename ? this.addTypenameTransform.transformDocument(n) : n;
    }, t.prototype.broadcastWatch = function(n, r) {
      var i = this, o = n.lastDiff, a = Cn("canonizeResults", function() {
        return i.diff(n);
      });
      r && (n.optimistic && typeof r.optimistic == "string" && (a.fromOptimisticTransaction = !0), r.onWatchUpdated && r.onWatchUpdated.call(this, n, a, o) === !1) || (!o || !$t(o.result, a.result)) && n.callback(n.lastDiff = a, o);
    }, t;
  })(r3)
);
globalThis.__DEV__ !== !1 && (See.prototype.getMemoryInternals = _J);
var gt;
(function(e) {
  e[e.loading = 1] = "loading", e[e.setVariables = 2] = "setVariables", e[e.fetchMore = 3] = "fetchMore", e[e.refetch = 4] = "refetch", e[e.poll = 6] = "poll", e[e.ready = 7] = "ready", e[e.error = 8] = "error";
})(gt || (gt = {}));
function bs(e) {
  return e ? e < 7 : !1;
}
var yS = Object.assign, $ee = Object.hasOwnProperty, Lf = (
  /** @class */
  (function(e) {
    pi(t, e);
    function t(n) {
      var r = n.queryManager, i = n.queryInfo, o = n.options, a = this, s = t.inactiveOnCreation.getValue();
      a = e.call(this, function(g) {
        a._getOrCreateQuery();
        try {
          var _ = g._subscription._observer;
          _ && !_.error && (_.error = kee);
        } catch {
        }
        var x = !a.observers.size;
        a.observers.add(g);
        var w = a.last;
        return w && w.error ? g.error && g.error(w.error) : w && w.result && g.next && g.next(a.maskResult(w.result)), x && a.reobserve().catch(function() {
        }), function() {
          a.observers.delete(g) && !a.observers.size && a.tearDownQuery();
        };
      }) || this, a.observers = /* @__PURE__ */ new Set(), a.subscriptions = /* @__PURE__ */ new Set(), a.dirty = !1, a._getOrCreateQuery = function() {
        return s && (r.queries.set(a.queryId, i), s = !1), a.queryManager.getOrCreateQuery(a.queryId);
      }, a.queryInfo = i, a.queryManager = r, a.waitForOwnResult = Cm(o.fetchPolicy), a.isTornDown = !1, a.subscribeToMore = a.subscribeToMore.bind(a), a.maskResult = a.maskResult.bind(a);
      var l = r.defaultOptions.watchQuery, u = l === void 0 ? {} : l, c = u.fetchPolicy, f = c === void 0 ? "cache-first" : c, d = o.fetchPolicy, p = d === void 0 ? f : d, h = o.initialFetchPolicy, v = h === void 0 ? p === "standby" ? f : p : h;
      a.options = Z(Z({}, o), {
        // Remember the initial options.fetchPolicy so we can revert back to this
        // policy when variables change. This information can also be specified
        // (or overridden) by providing options.initialFetchPolicy explicitly.
        initialFetchPolicy: v,
        // This ensures this.options.fetchPolicy always has a string value, in
        // case options.fetchPolicy was not provided.
        fetchPolicy: p
      }), a.queryId = i.queryId || r.generateQueryId();
      var m = Ca(a.query);
      return a.queryName = m && m.name && m.name.value, a;
    }
    return Object.defineProperty(t.prototype, "query", {
      // The `query` computed property will always reflect the document transformed
      // by the last run query. `this.options.query` will always reflect the raw
      // untransformed query to ensure document transforms with runtime conditionals
      // are run on the original document.
      get: function() {
        return this.lastQuery || this.options.query;
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(t.prototype, "variables", {
      // Computed shorthand for this.options.variables, preserved for
      // backwards compatibility.
      /**
       * An object containing the variables that were provided for the query.
       */
      get: function() {
        return this.options.variables;
      },
      enumerable: !1,
      configurable: !0
    }), t.prototype.result = function() {
      var n = this;
      return globalThis.__DEV__ !== !1 && aa("observableQuery.result", function() {
        globalThis.__DEV__ !== !1 && ke.warn(23);
      }), new Promise(function(r, i) {
        var o = {
          next: function(s) {
            r(s), n.observers.delete(o), n.observers.size || n.queryManager.removeQuery(n.queryId), setTimeout(function() {
              a.unsubscribe();
            }, 0);
          },
          error: i
        }, a = n.subscribe(o);
      });
    }, t.prototype.resetDiff = function() {
      this.queryInfo.resetDiff();
    }, t.prototype.getCurrentFullResult = function(n) {
      var r = this;
      n === void 0 && (n = !0);
      var i = Cn("getLastResult", function() {
        return r.getLastResult(!0);
      }), o = this.queryInfo.networkStatus || i && i.networkStatus || gt.ready, a = Z(Z({}, i), { loading: bs(o), networkStatus: o }), s = this.options.fetchPolicy, l = s === void 0 ? "cache-first" : s;
      if (
        // These fetch policies should never deliver data from the cache, unless
        // redelivering a previously delivered result.
        !(Cm(l) || // If this.options.query has @client(always: true) fields, we cannot
        // trust diff.result, since it was read from the cache without running
        // local resolvers (and it's too late to run resolvers now, since we must
        // return a result synchronously).
        this.queryManager.getDocumentInfo(this.query).hasForcedResolvers)
      ) if (this.waitForOwnResult)
        this.queryInfo.updateWatch();
      else {
        var u = this.queryInfo.getDiff();
        (u.complete || this.options.returnPartialData) && (a.data = u.result), $t(a.data, {}) && (a.data = void 0), u.complete ? (delete a.partial, u.complete && a.networkStatus === gt.loading && (l === "cache-first" || l === "cache-only") && (a.networkStatus = gt.ready, a.loading = !1)) : a.partial = !0, a.networkStatus === gt.ready && (a.error || a.errors) && (a.networkStatus = gt.error), globalThis.__DEV__ !== !1 && !u.complete && !this.options.partialRefetch && !a.loading && !a.data && !a.error && v3(u.missing);
      }
      return n && this.updateLastResult(a), a;
    }, t.prototype.getCurrentResult = function(n) {
      return n === void 0 && (n = !0), this.maskResult(this.getCurrentFullResult(n));
    }, t.prototype.isDifferentFromLastResult = function(n, r) {
      if (!this.last)
        return !0;
      var i = this.queryManager.getDocumentInfo(this.query), o = this.queryManager.dataMasking, a = o ? i.nonReactiveQuery : this.query, s = o || i.hasNonreactiveDirective ? !QC(a, this.last.result, n, this.variables) : !$t(this.last.result, n);
      return s || r && !$t(this.last.variables, r);
    }, t.prototype.getLast = function(n, r) {
      var i = this.last;
      if (i && i[n] && (!r || $t(i.variables, this.variables)))
        return i[n];
    }, t.prototype.getLastResult = function(n) {
      return globalThis.__DEV__ !== !1 && aa("getLastResult", function() {
        globalThis.__DEV__ !== !1 && ke.warn(24);
      }), this.getLast("result", n);
    }, t.prototype.getLastError = function(n) {
      return globalThis.__DEV__ !== !1 && aa("getLastError", function() {
        globalThis.__DEV__ !== !1 && ke.warn(25);
      }), this.getLast("error", n);
    }, t.prototype.resetLastResults = function() {
      globalThis.__DEV__ !== !1 && aa("resetLastResults", function() {
        globalThis.__DEV__ !== !1 && ke.warn(26);
      }), delete this.last, this.isTornDown = !1;
    }, t.prototype.resetQueryStoreErrors = function() {
      globalThis.__DEV__ !== !1 && globalThis.__DEV__ !== !1 && ke.warn(27), this.queryManager.resetErrors(this.queryId);
    }, t.prototype.refetch = function(n) {
      var r, i = {
        // Always disable polling for refetches.
        pollInterval: 0
      }, o = this.options.fetchPolicy;
      if (o === "no-cache" ? i.fetchPolicy = "no-cache" : i.fetchPolicy = "network-only", globalThis.__DEV__ !== !1 && n && $ee.call(n, "variables")) {
        var a = $C(this.query), s = a.variableDefinitions;
        (!s || !s.some(function(l) {
          return l.variable.name.value === "variables";
        })) && globalThis.__DEV__ !== !1 && ke.warn(
          28,
          n,
          ((r = a.name) === null || r === void 0 ? void 0 : r.value) || a
        );
      }
      return n && !$t(this.options.variables, n) && (i.variables = this.options.variables = Z(Z({}, this.options.variables), n)), this.queryInfo.resetLastWrite(), this.reobserve(i, gt.refetch);
    }, t.prototype.fetchMore = function(n) {
      var r = this, i = Z(Z({}, n.query ? n : Z(Z(Z(Z({}, this.options), { query: this.options.query }), n), { variables: Z(Z({}, this.options.variables), n.variables) })), {
        // The fetchMore request goes immediately to the network and does
        // not automatically write its result to the cache (hence no-cache
        // instead of network-only), because we allow the caller of
        // fetchMore to provide an updateQuery callback that determines how
        // the data gets written to the cache.
        fetchPolicy: "no-cache"
      });
      i.query = this.transformDocument(i.query);
      var o = this.queryManager.generateQueryId();
      this.lastQuery = n.query ? this.transformDocument(this.options.query) : i.query;
      var a = this.queryInfo, s = a.networkStatus;
      a.networkStatus = gt.fetchMore, i.notifyOnNetworkStatusChange && this.observe();
      var l = /* @__PURE__ */ new Set(), u = n?.updateQuery, c = this.options.fetchPolicy !== "no-cache";
      return c || ke(u, 29), this.queryManager.fetchQuery(o, i, gt.fetchMore).then(function(f) {
        if (r.queryManager.removeQuery(o), a.networkStatus === gt.fetchMore && (a.networkStatus = s), c)
          r.queryManager.cache.batch({
            update: function(h) {
              var v = n.updateQuery;
              v ? h.updateQuery({
                query: r.query,
                variables: r.variables,
                returnPartialData: !0,
                optimistic: !1
              }, function(m) {
                return v(m, {
                  fetchMoreResult: f.data,
                  variables: i.variables
                });
              }) : h.writeQuery({
                query: i.query,
                variables: i.variables,
                data: f.data
              });
            },
            onWatchUpdated: function(h) {
              l.add(h.query);
            }
          });
        else {
          var d = r.getLast("result"), p = u(d.data, {
            fetchMoreResult: f.data,
            variables: i.variables
          });
          r.reportResult(Z(Z({}, d), { networkStatus: s, loading: bs(s), data: p }), r.variables);
        }
        return r.maskResult(f);
      }).finally(function() {
        c && !l.has(r.query) && r.reobserveCacheFirst();
      });
    }, t.prototype.subscribeToMore = function(n) {
      var r = this, i = this.queryManager.startGraphQLSubscription({
        query: n.document,
        variables: n.variables,
        context: n.context
      }).subscribe({
        next: function(o) {
          var a = n.updateQuery;
          a && r.updateQuery(function(s, l) {
            return a(s, Z({ subscriptionData: o }, l));
          });
        },
        error: function(o) {
          if (n.onError) {
            n.onError(o);
            return;
          }
          globalThis.__DEV__ !== !1 && ke.error(30, o);
        }
      });
      return this.subscriptions.add(i), function() {
        r.subscriptions.delete(i) && i.unsubscribe();
      };
    }, t.prototype.setOptions = function(n) {
      return globalThis.__DEV__ !== !1 && (tn(n, "canonizeResults", "setOptions"), aa("setOptions", function() {
        globalThis.__DEV__ !== !1 && ke.warn(31);
      })), this.reobserve(n);
    }, t.prototype.silentSetOptions = function(n) {
      var r = Js(this.options, n || {});
      yS(this.options, r);
    }, t.prototype.setVariables = function(n) {
      var r = this;
      return $t(this.variables, n) ? this.observers.size ? Cn("observableQuery.result", function() {
        return r.result();
      }) : Promise.resolve() : (this.options.variables = n, this.observers.size ? this.reobserve({
        // Reset options.fetchPolicy to its original value.
        fetchPolicy: this.options.initialFetchPolicy,
        variables: n
      }, gt.setVariables) : Promise.resolve());
    }, t.prototype.updateQuery = function(n) {
      var r = this.queryManager, i = r.cache.diff({
        query: this.options.query,
        variables: this.variables,
        returnPartialData: !0,
        optimistic: !1
      }), o = i.result, a = i.complete, s = n(o, {
        variables: this.variables,
        complete: !!a,
        previousData: o
      });
      s && (r.cache.writeQuery({
        query: this.options.query,
        data: s,
        variables: this.variables
      }), r.broadcastQueries());
    }, t.prototype.startPolling = function(n) {
      this.options.pollInterval = n, this.updatePolling();
    }, t.prototype.stopPolling = function() {
      this.options.pollInterval = 0, this.updatePolling();
    }, t.prototype.applyNextFetchPolicy = function(n, r) {
      if (r.nextFetchPolicy) {
        var i = r.fetchPolicy, o = i === void 0 ? "cache-first" : i, a = r.initialFetchPolicy, s = a === void 0 ? o : a;
        o === "standby" || (typeof r.nextFetchPolicy == "function" ? r.fetchPolicy = r.nextFetchPolicy(o, {
          reason: n,
          options: r,
          observable: this,
          initialFetchPolicy: s
        }) : n === "variables-changed" ? r.fetchPolicy = s : r.fetchPolicy = r.nextFetchPolicy);
      }
      return r.fetchPolicy;
    }, t.prototype.fetch = function(n, r, i) {
      var o = this._getOrCreateQuery();
      return o.setObservableQuery(this), this.queryManager.fetchConcastWithInfo(o, n, r, i);
    }, t.prototype.updatePolling = function() {
      var n = this;
      if (!this.queryManager.ssrMode) {
        var r = this, i = r.pollingInfo, o = r.options.pollInterval;
        if (!o || !this.hasObservers()) {
          i && (clearTimeout(i.timeout), delete this.pollingInfo);
          return;
        }
        if (!(i && i.interval === o)) {
          ke(o, 32);
          var a = i || (this.pollingInfo = {});
          a.interval = o;
          var s = function() {
            var u, c;
            n.pollingInfo && (!bs(n.queryInfo.networkStatus) && !(!((c = (u = n.options).skipPollAttempt) === null || c === void 0) && c.call(u)) ? n.reobserve({
              // Most fetchPolicy options don't make sense to use in a polling context, as
              // users wouldn't want to be polling the cache directly. However, network-only and
              // no-cache are both useful for when the user wants to control whether or not the
              // polled results are written to the cache.
              fetchPolicy: n.options.initialFetchPolicy === "no-cache" ? "no-cache" : "network-only"
            }, gt.poll).then(l, l) : l());
          }, l = function() {
            var u = n.pollingInfo;
            u && (clearTimeout(u.timeout), u.timeout = setTimeout(s, u.interval));
          };
          l();
        }
      }
    }, t.prototype.updateLastResult = function(n, r) {
      var i = this;
      r === void 0 && (r = this.variables);
      var o = Cn("getLastError", function() {
        return i.getLastError();
      });
      return o && this.last && !$t(r, this.last.variables) && (o = void 0), this.last = Z({ result: this.queryManager.assumeImmutableResults ? n : qC(n), variables: r }, o ? { error: o } : null);
    }, t.prototype.reobserveAsConcast = function(n, r) {
      var i = this;
      this.isTornDown = !1;
      var o = (
        // Refetching uses a disposable Concast to allow refetches using different
        // options/variables, without permanently altering the options of the
        // original ObservableQuery.
        r === gt.refetch || // The fetchMore method does not actually call the reobserve method, but,
        // if it did, it would definitely use a disposable Concast.
        r === gt.fetchMore || // Polling uses a disposable Concast so the polling options (which force
        // fetchPolicy to be "network-only" or "no-cache") won't override the original options.
        r === gt.poll
      ), a = this.options.variables, s = this.options.fetchPolicy, l = Js(this.options, n || {}), u = o ? (
        // Disposable Concast fetches receive a shallow copy of this.options
        // (merged with newOptions), leaving this.options unmodified.
        l
      ) : yS(this.options, l), c = this.transformDocument(u.query);
      this.lastQuery = c, o || (this.updatePolling(), n && n.variables && !$t(n.variables, a) && // Don't mess with the fetchPolicy if it's currently "standby".
      u.fetchPolicy !== "standby" && // If we're changing the fetchPolicy anyway, don't try to change it here
      // using applyNextFetchPolicy. The explicit options.fetchPolicy wins.
      (u.fetchPolicy === s || // A `nextFetchPolicy` function has even higher priority, though,
      // so in that case `applyNextFetchPolicy` must be called.
      typeof u.nextFetchPolicy == "function") && (this.applyNextFetchPolicy("variables-changed", u), r === void 0 && (r = gt.setVariables))), this.waitForOwnResult && (this.waitForOwnResult = Cm(u.fetchPolicy));
      var f = function() {
        i.concast === h && (i.waitForOwnResult = !1);
      }, d = u.variables && Z({}, u.variables), p = this.fetch(u, r, c), h = p.concast, v = p.fromLink, m = {
        next: function(g) {
          $t(i.variables, d) && (f(), i.reportResult(g, d));
        },
        error: function(g) {
          $t(i.variables, d) && (GC(g) || (g = new ho({ networkError: g })), f(), i.reportError(g, d));
        }
      };
      return !o && (v || !this.concast) && (this.concast && this.observer && this.concast.removeObserver(this.observer), this.concast = h, this.observer = m), h.addObserver(m), h;
    }, t.prototype.reobserve = function(n, r) {
      return pX(this.reobserveAsConcast(n, r).promise.then(this.maskResult));
    }, t.prototype.resubscribeAfterError = function() {
      for (var n = this, r = [], i = 0; i < arguments.length; i++)
        r[i] = arguments[i];
      var o = this.last;
      Cn("resetLastResults", function() {
        return n.resetLastResults();
      });
      var a = this.subscribe.apply(this, r);
      return this.last = o, a;
    }, t.prototype.observe = function() {
      this.reportResult(
        // Passing false is important so that this.getCurrentResult doesn't
        // save the fetchMore result as this.lastResult, causing it to be
        // ignored due to the this.isDifferentFromLastResult check in
        // this.reportResult.
        this.getCurrentFullResult(!1),
        this.variables
      );
    }, t.prototype.reportResult = function(n, r) {
      var i = this, o = Cn("getLastError", function() {
        return i.getLastError();
      }), a = this.isDifferentFromLastResult(n, r);
      (o || !n.partial || this.options.returnPartialData) && this.updateLastResult(n, r), (o || a) && hu(this.observers, "next", this.maskResult(n));
    }, t.prototype.reportError = function(n, r) {
      var i = this, o = Z(Z({}, Cn("getLastResult", function() {
        return i.getLastResult();
      })), { error: n, errors: n.graphQLErrors, networkStatus: gt.error, loading: !1 });
      this.updateLastResult(o, r), hu(this.observers, "error", this.last.error = n);
    }, t.prototype.hasObservers = function() {
      return this.observers.size > 0;
    }, t.prototype.tearDownQuery = function() {
      this.isTornDown || (this.concast && this.observer && (this.concast.removeObserver(this.observer), delete this.concast, delete this.observer), this.stopPolling(), this.subscriptions.forEach(function(n) {
        return n.unsubscribe();
      }), this.subscriptions.clear(), this.queryManager.stopQuery(this.queryId), this.observers.clear(), this.isTornDown = !0);
    }, t.prototype.transformDocument = function(n) {
      return this.queryManager.transform(n);
    }, t.prototype.maskResult = function(n) {
      return n && "data" in n ? Z(Z({}, n), { data: this.queryManager.maskOperation({
        document: this.query,
        data: n.data,
        fetchPolicy: this.options.fetchPolicy,
        id: this.queryId
      }) }) : n;
    }, t.prototype.resetNotifications = function() {
      this.cancelNotifyTimeout(), this.dirty = !1;
    }, t.prototype.cancelNotifyTimeout = function() {
      this.notifyTimeout && (clearTimeout(this.notifyTimeout), this.notifyTimeout = void 0);
    }, t.prototype.scheduleNotify = function() {
      var n = this;
      this.dirty || (this.dirty = !0, this.notifyTimeout || (this.notifyTimeout = setTimeout(function() {
        return n.notify();
      }, 0)));
    }, t.prototype.notify = function() {
      if (this.cancelNotifyTimeout(), this.dirty && (this.options.fetchPolicy == "cache-only" || this.options.fetchPolicy == "cache-and-network" || !bs(this.queryInfo.networkStatus))) {
        var n = this.queryInfo.getDiff();
        n.fromOptimisticTransaction ? this.observe() : this.reobserveCacheFirst();
      }
      this.dirty = !1;
    }, t.prototype.reobserveCacheFirst = function() {
      var n = this.options, r = n.fetchPolicy, i = n.nextFetchPolicy;
      return r === "cache-and-network" || r === "network-only" ? this.reobserve({
        fetchPolicy: "cache-first",
        // Use a temporary nextFetchPolicy function that replaces itself with the
        // previous nextFetchPolicy value and returns the original fetchPolicy.
        nextFetchPolicy: function(o, a) {
          return this.nextFetchPolicy = i, typeof this.nextFetchPolicy == "function" ? this.nextFetchPolicy(o, a) : r;
        }
      }) : this.reobserve();
    }, t.inactiveOnCreation = new $l(), t;
  })(Et)
);
HC(Lf);
function kee(e) {
  globalThis.__DEV__ !== !1 && ke.error(33, e.message, e.stack);
}
function v3(e) {
  globalThis.__DEV__ !== !1 && e && globalThis.__DEV__ !== !1 && ke.debug(34, e);
}
function Cm(e) {
  return e === "network-only" || e === "no-cache" || e === "standby";
}
var _s = new (Za ? WeakMap : Map)();
function Im(e, t) {
  var n = e[t];
  typeof n == "function" && (e[t] = function() {
    return _s.set(
      e,
      // The %1e15 allows the count to wrap around to 0 safely every
      // quadrillion evictions, so there's no risk of overflow. To be
      // clear, this is more of a pedantic principle than something
      // that matters in any conceivable practical scenario.
      (_s.get(e) + 1) % 1e15
    ), n.apply(this, arguments);
  });
}
var Mm = (
  /** @class */
  (function() {
    function e(t, n) {
      n === void 0 && (n = t.generateQueryId()), this.queryId = n, this.document = null, this.lastRequestId = 1, this.stopped = !1, this.observableQuery = null;
      var r = this.cache = t.cache;
      _s.has(r) || (_s.set(r, 0), Im(r, "evict"), Im(r, "modify"), Im(r, "reset"));
    }
    return e.prototype.init = function(t) {
      var n = t.networkStatus || gt.loading;
      return this.variables && this.networkStatus !== gt.loading && !$t(this.variables, t.variables) && (n = gt.setVariables), $t(t.variables, this.variables) || (this.lastDiff = void 0, this.cancel()), Object.assign(this, {
        document: t.document,
        variables: t.variables,
        networkError: null,
        graphQLErrors: this.graphQLErrors || [],
        networkStatus: n
      }), t.observableQuery && this.setObservableQuery(t.observableQuery), t.lastRequestId && (this.lastRequestId = t.lastRequestId), this;
    }, e.prototype.resetDiff = function() {
      this.lastDiff = void 0;
    }, e.prototype.getDiff = function() {
      var t = this, n = this.getDiffOptions();
      if (this.lastDiff && $t(n, this.lastDiff.options))
        return this.lastDiff.diff;
      this.updateWatch(this.variables);
      var r = this.observableQuery;
      if (r && r.options.fetchPolicy === "no-cache")
        return { complete: !1 };
      var i = Cn("canonizeResults", function() {
        return t.cache.diff(n);
      });
      return this.updateLastDiff(i, n), i;
    }, e.prototype.updateLastDiff = function(t, n) {
      this.lastDiff = t ? {
        diff: t,
        options: n || this.getDiffOptions()
      } : void 0;
    }, e.prototype.getDiffOptions = function(t) {
      var n;
      return t === void 0 && (t = this.variables), {
        query: this.document,
        variables: t,
        returnPartialData: !0,
        optimistic: !0,
        canonizeResults: (n = this.observableQuery) === null || n === void 0 ? void 0 : n.options.canonizeResults
      };
    }, e.prototype.setDiff = function(t) {
      var n = this, r, i = this.lastDiff && this.lastDiff.diff;
      t && !t.complete && Cn("getLastError", function() {
        var o;
        return (o = n.observableQuery) === null || o === void 0 ? void 0 : o.getLastError();
      }) || (this.updateLastDiff(t), $t(i && i.result, t && t.result) || (r = this.observableQuery) === null || r === void 0 || r.scheduleNotify());
    }, e.prototype.setObservableQuery = function(t) {
      t !== this.observableQuery && (this.observableQuery = t, t && (t.queryInfo = this));
    }, e.prototype.stop = function() {
      var t;
      if (!this.stopped) {
        this.stopped = !0, (t = this.observableQuery) === null || t === void 0 || t.resetNotifications(), this.cancel();
        var n = this.observableQuery;
        n && n.stopPolling();
      }
    }, e.prototype.cancel = function() {
      var t;
      (t = this.cancelWatch) === null || t === void 0 || t.call(this), this.cancelWatch = void 0;
    }, e.prototype.updateWatch = function(t) {
      var n = this;
      t === void 0 && (t = this.variables);
      var r = this.observableQuery;
      if (!(r && r.options.fetchPolicy === "no-cache")) {
        var i = Z(Z({}, this.getDiffOptions(t)), { watcher: this, callback: function(o) {
          return n.setDiff(o);
        } });
        (!this.lastWatch || !$t(i, this.lastWatch)) && (this.cancel(), this.cancelWatch = this.cache.watch(this.lastWatch = i));
      }
    }, e.prototype.resetLastWrite = function() {
      this.lastWrite = void 0;
    }, e.prototype.shouldWrite = function(t, n) {
      var r = this.lastWrite;
      return !(r && // If cache.evict has been called since the last time we wrote this
      // data into the cache, there's a chance writing this result into
      // the cache will repair what was evicted.
      r.dmCount === _s.get(this.cache) && $t(n, r.variables) && $t(t.data, r.result.data));
    }, e.prototype.markResult = function(t, n, r, i) {
      var o = this, a, s = new Ro(), l = Ci(t.errors) ? t.errors.slice(0) : [];
      if ((a = this.observableQuery) === null || a === void 0 || a.resetNotifications(), "incremental" in t && Ci(t.incremental)) {
        var u = WC(this.getDiff().result, t);
        t.data = u;
      } else if ("hasNext" in t && t.hasNext) {
        var c = this.getDiff();
        t.data = s.merge(c.result, t.data);
      }
      this.graphQLErrors = l, r.fetchPolicy === "no-cache" ? this.updateLastDiff({ result: t.data, complete: !0 }, this.getDiffOptions(r.variables)) : i !== 0 && (ty(t, r.errorPolicy) ? this.cache.performTransaction(function(f) {
        if (o.shouldWrite(t, r.variables))
          f.writeQuery({
            query: n,
            data: t.data,
            variables: r.variables,
            overwrite: i === 1
          }), o.lastWrite = {
            result: t,
            variables: r.variables,
            dmCount: _s.get(o.cache)
          };
        else if (o.lastDiff && o.lastDiff.diff.complete) {
          t.data = o.lastDiff.diff.result;
          return;
        }
        var d = o.getDiffOptions(r.variables), p = Cn("canonizeResults", function() {
          return f.diff(d);
        });
        !o.stopped && $t(o.variables, r.variables) && o.updateWatch(r.variables), o.updateLastDiff(p, d), p.complete && (t.data = p.result);
      }) : this.lastWrite = void 0);
    }, e.prototype.markReady = function() {
      return this.networkError = null, this.networkStatus = gt.ready;
    }, e.prototype.markError = function(t) {
      var n;
      return this.networkStatus = gt.error, this.lastWrite = void 0, (n = this.observableQuery) === null || n === void 0 || n.resetNotifications(), t.graphQLErrors && (this.graphQLErrors = t.graphQLErrors), t.networkError && (this.networkError = t.networkError), t;
    }, e;
  })()
);
function ty(e, t) {
  t === void 0 && (t = "none");
  var n = t === "ignore" || t === "all", r = !jf(e);
  return !r && n && e.data && (r = !0), r;
}
var Tee = Object.prototype.hasOwnProperty, bS = /* @__PURE__ */ Object.create(null), Oee = (
  /** @class */
  (function() {
    function e(t) {
      var n = this;
      this.clientAwareness = {}, this.queries = /* @__PURE__ */ new Map(), this.fetchCancelFns = /* @__PURE__ */ new Map(), this.transformCache = new bC(
        Ji["queryManager.getDocumentInfo"] || 2e3
        /* defaultCacheSizes["queryManager.getDocumentInfo"] */
      ), this.queryIdCounter = 1, this.requestIdCounter = 1, this.mutationIdCounter = 1, this.inFlightLinkObservables = new ro(!1), this.noCacheWarningsByQueryId = /* @__PURE__ */ new Set();
      var r = new FC(
        function(o) {
          return n.cache.transformDocument(o);
        },
        // Allow the apollo cache to manage its own transform caches
        { cache: !1 }
      );
      this.cache = t.cache, this.link = t.link, this.defaultOptions = t.defaultOptions, this.queryDeduplication = t.queryDeduplication, this.clientAwareness = t.clientAwareness, this.localState = t.localState, this.ssrMode = t.ssrMode, this.assumeImmutableResults = t.assumeImmutableResults, this.dataMasking = t.dataMasking;
      var i = t.documentTransform;
      this.documentTransform = i ? r.concat(i).concat(r) : r, this.defaultContext = t.defaultContext || /* @__PURE__ */ Object.create(null), (this.onBroadcast = t.onBroadcast) && (this.mutationStore = /* @__PURE__ */ Object.create(null));
    }
    return e.prototype.stop = function() {
      var t = this;
      this.queries.forEach(function(n, r) {
        t.stopQueryNoBroadcast(r);
      }), this.cancelPendingFetches(Zn(35));
    }, e.prototype.cancelPendingFetches = function(t) {
      this.fetchCancelFns.forEach(function(n) {
        return n(t);
      }), this.fetchCancelFns.clear();
    }, e.prototype.mutate = function(t) {
      return co(this, arguments, void 0, function(n) {
        var r, i, o, a, s, l, u, c = n.mutation, f = n.variables, d = n.optimisticResponse, p = n.updateQueries, h = n.refetchQueries, v = h === void 0 ? [] : h, m = n.awaitRefetchQueries, g = m === void 0 ? !1 : m, _ = n.update, x = n.onQueryUpdated, w = n.fetchPolicy, $ = w === void 0 ? ((l = this.defaultOptions.mutate) === null || l === void 0 ? void 0 : l.fetchPolicy) || "network-only" : w, k = n.errorPolicy, D = k === void 0 ? ((u = this.defaultOptions.mutate) === null || u === void 0 ? void 0 : u.errorPolicy) || "none" : k, E = n.keepRootFields, b = n.context;
        return fo(this, function(y) {
          switch (y.label) {
            case 0:
              return ke(c, 36), ke($ === "network-only" || $ === "no-cache", 37), r = this.generateMutationId(), c = this.cache.transformForLink(this.transform(c)), i = this.getDocumentInfo(c).hasClientExports, f = this.getVariables(c, f), i ? [4, this.localState.addExportedVariables(c, f, b)] : [3, 2];
            case 1:
              f = y.sent(), y.label = 2;
            case 2:
              return o = this.mutationStore && (this.mutationStore[r] = {
                mutation: c,
                variables: f,
                loading: !0,
                error: null
              }), a = d && this.markMutationOptimistic(d, {
                mutationId: r,
                document: c,
                variables: f,
                fetchPolicy: $,
                errorPolicy: D,
                context: b,
                updateQueries: p,
                update: _,
                keepRootFields: E
              }), this.broadcastQueries(), s = this, [2, new Promise(function(S, P) {
                return $m(s.getObservableFromLink(c, Z(Z({}, b), { optimisticResponse: a ? d : void 0 }), f, {}, !1), function(M) {
                  if (jf(M) && D === "none")
                    throw new ho({
                      graphQLErrors: qg(M)
                    });
                  o && (o.loading = !1, o.error = null);
                  var T = Z({}, M);
                  return typeof v == "function" && (v = v(T)), D === "ignore" && jf(T) && delete T.errors, s.markMutationResult({
                    mutationId: r,
                    result: T,
                    document: c,
                    variables: f,
                    fetchPolicy: $,
                    errorPolicy: D,
                    context: b,
                    update: _,
                    updateQueries: p,
                    awaitRefetchQueries: g,
                    refetchQueries: v,
                    removeOptimistic: a ? r : void 0,
                    onQueryUpdated: x,
                    keepRootFields: E
                  });
                }).subscribe({
                  next: function(M) {
                    s.broadcastQueries(), (!("hasNext" in M) || M.hasNext === !1) && S(Z(Z({}, M), { data: s.maskOperation({
                      document: c,
                      data: M.data,
                      fetchPolicy: $,
                      id: r
                    }) }));
                  },
                  error: function(M) {
                    o && (o.loading = !1, o.error = M), a && s.cache.removeOptimistic(r), s.broadcastQueries(), P(M instanceof ho ? M : new ho({
                      networkError: M
                    }));
                  }
                });
              })];
          }
        });
      });
    }, e.prototype.markMutationResult = function(t, n) {
      var r = this;
      n === void 0 && (n = this.cache);
      var i = t.result, o = [], a = t.fetchPolicy === "no-cache";
      if (!a && ty(i, t.errorPolicy)) {
        if (Os(i) || o.push({
          result: i.data,
          dataId: "ROOT_MUTATION",
          query: t.document,
          variables: t.variables
        }), Os(i) && Ci(i.incremental)) {
          var s = n.diff({
            id: "ROOT_MUTATION",
            // The cache complains if passed a mutation where it expects a
            // query, so we transform mutations and subscriptions to queries
            // (only once, thanks to this.transformCache).
            query: this.getDocumentInfo(t.document).asQuery,
            variables: t.variables,
            optimistic: !1,
            returnPartialData: !0
          }), l = void 0;
          s.result && (l = WC(s.result, i)), typeof l < "u" && (i.data = l, o.push({
            result: l,
            dataId: "ROOT_MUTATION",
            query: t.document,
            variables: t.variables
          }));
        }
        var u = t.updateQueries;
        u && this.queries.forEach(function(f, d) {
          var p = f.observableQuery, h = p && p.queryName;
          if (!(!h || !Tee.call(u, h))) {
            var v = u[h], m = r.queries.get(d), g = m.document, _ = m.variables, x = n.diff({
              query: g,
              variables: _,
              returnPartialData: !0,
              optimistic: !1
            }), w = x.result, $ = x.complete;
            if ($ && w) {
              var k = v(w, {
                mutationResult: i,
                queryName: g && eu(g) || void 0,
                queryVariables: _
              });
              k && o.push({
                result: k,
                dataId: "ROOT_QUERY",
                query: g,
                variables: _
              });
            }
          }
        });
      }
      if (o.length > 0 || (t.refetchQueries || "").length > 0 || t.update || t.onQueryUpdated || t.removeOptimistic) {
        var c = [];
        if (this.refetchQueries({
          updateCache: function(f) {
            a || o.forEach(function(v) {
              return f.write(v);
            });
            var d = t.update, p = !yX(i) || Os(i) && !i.hasNext;
            if (d) {
              if (!a) {
                var h = f.diff({
                  id: "ROOT_MUTATION",
                  // The cache complains if passed a mutation where it expects a
                  // query, so we transform mutations and subscriptions to queries
                  // (only once, thanks to this.transformCache).
                  query: r.getDocumentInfo(t.document).asQuery,
                  variables: t.variables,
                  optimistic: !1,
                  returnPartialData: !0
                });
                h.complete && (i = Z(Z({}, i), { data: h.result }), "incremental" in i && delete i.incremental, "hasNext" in i && delete i.hasNext);
              }
              p && d(f, i, {
                context: t.context,
                variables: t.variables
              });
            }
            !a && !t.keepRootFields && p && f.modify({
              id: "ROOT_MUTATION",
              fields: function(v, m) {
                var g = m.fieldName, _ = m.DELETE;
                return g === "__typename" ? v : _;
              }
            });
          },
          include: t.refetchQueries,
          // Write the final mutation.result to the root layer of the cache.
          optimistic: !1,
          // Remove the corresponding optimistic layer at the same time as we
          // write the final non-optimistic result.
          removeOptimistic: t.removeOptimistic,
          // Let the caller of client.mutate optionally determine the refetching
          // behavior for watched queries after the mutation.update function runs.
          // If no onQueryUpdated function was provided for this mutation, pass
          // null instead of undefined to disable the default refetching behavior.
          onQueryUpdated: t.onQueryUpdated || null
        }).forEach(function(f) {
          return c.push(f);
        }), t.awaitRefetchQueries || t.onQueryUpdated)
          return Promise.all(c).then(function() {
            return i;
          });
      }
      return Promise.resolve(i);
    }, e.prototype.markMutationOptimistic = function(t, n) {
      var r = this, i = typeof t == "function" ? t(n.variables, { IGNORE: bS }) : t;
      return i === bS ? !1 : (this.cache.recordOptimisticTransaction(function(o) {
        try {
          r.markMutationResult(Z(Z({}, n), { result: { data: i } }), o);
        } catch (a) {
          globalThis.__DEV__ !== !1 && ke.error(a);
        }
      }, n.mutationId), !0);
    }, e.prototype.fetchQuery = function(t, n, r) {
      return this.fetchConcastWithInfo(this.getOrCreateQuery(t), n, r).concast.promise;
    }, e.prototype.getQueryStore = function() {
      var t = /* @__PURE__ */ Object.create(null);
      return this.queries.forEach(function(n, r) {
        t[r] = {
          variables: n.variables,
          networkStatus: n.networkStatus,
          networkError: n.networkError,
          graphQLErrors: n.graphQLErrors
        };
      }), t;
    }, e.prototype.resetErrors = function(t) {
      var n = this.queries.get(t);
      n && (n.networkError = void 0, n.graphQLErrors = []);
    }, e.prototype.transform = function(t) {
      return this.documentTransform.transformDocument(t);
    }, e.prototype.getDocumentInfo = function(t) {
      var n = this.transformCache;
      if (!n.has(t)) {
        var r = {
          // TODO These three calls (hasClientExports, shouldForceResolvers, and
          // usesNonreactiveDirective) are performing independent full traversals
          // of the transformed document. We should consider merging these
          // traversals into a single pass in the future, though the work is
          // cached after the first time.
          hasClientExports: eJ(t),
          hasForcedResolvers: this.localState.shouldForceResolvers(t),
          hasNonreactiveDirective: Ku(["nonreactive"], t),
          nonReactiveQuery: nX(t),
          clientQuery: this.localState.clientQuery(t),
          serverQuery: LC([
            { name: "client", remove: !0 },
            { name: "connection" },
            { name: "nonreactive" },
            { name: "unmask" }
          ], t),
          defaultVars: A0(Ca(t)),
          // Transform any mutation or subscription operations to query operations
          // so we can read/write them from/to the cache.
          asQuery: Z(Z({}, t), { definitions: t.definitions.map(function(i) {
            return i.kind === "OperationDefinition" && i.operation !== "query" ? Z(Z({}, i), { operation: "query" }) : i;
          }) })
        };
        n.set(t, r);
      }
      return n.get(t);
    }, e.prototype.getVariables = function(t, n) {
      return Z(Z({}, this.getDocumentInfo(t).defaultVars), n);
    }, e.prototype.watchQuery = function(t) {
      var n = this.transform(t.query);
      t = Z(Z({}, t), { variables: this.getVariables(n, t.variables) }), typeof t.notifyOnNetworkStatusChange > "u" && (t.notifyOnNetworkStatusChange = !1);
      var r = new Mm(this), i = new Lf({
        queryManager: this,
        queryInfo: r,
        options: t
      });
      return i.lastQuery = n, Lf.inactiveOnCreation.getValue() || this.queries.set(i.queryId, r), r.init({
        document: n,
        observableQuery: i,
        variables: i.variables
      }), i;
    }, e.prototype.query = function(t, n) {
      var r = this;
      n === void 0 && (n = this.generateQueryId()), ke(t.query, 38), ke(t.query.kind === "Document", 39), ke(!t.returnPartialData, 40), ke(!t.pollInterval, 41);
      var i = this.transform(t.query);
      return this.fetchQuery(n, Z(Z({}, t), { query: i })).then(function(o) {
        return o && Z(Z({}, o), { data: r.maskOperation({
          document: i,
          data: o.data,
          fetchPolicy: t.fetchPolicy,
          id: n
        }) });
      }).finally(function() {
        return r.stopQuery(n);
      });
    }, e.prototype.generateQueryId = function() {
      return String(this.queryIdCounter++);
    }, e.prototype.generateRequestId = function() {
      return this.requestIdCounter++;
    }, e.prototype.generateMutationId = function() {
      return String(this.mutationIdCounter++);
    }, e.prototype.stopQueryInStore = function(t) {
      this.stopQueryInStoreNoBroadcast(t), this.broadcastQueries();
    }, e.prototype.stopQueryInStoreNoBroadcast = function(t) {
      var n = this.queries.get(t);
      n && n.stop();
    }, e.prototype.clearStore = function(t) {
      return t === void 0 && (t = {
        discardWatches: !0
      }), this.cancelPendingFetches(Zn(42)), this.queries.forEach(function(n) {
        n.observableQuery ? n.networkStatus = gt.loading : n.stop();
      }), this.mutationStore && (this.mutationStore = /* @__PURE__ */ Object.create(null)), this.cache.reset(t);
    }, e.prototype.getObservableQueries = function(t) {
      var n = this;
      t === void 0 && (t = "active");
      var r = /* @__PURE__ */ new Map(), i = /* @__PURE__ */ new Map(), o = /* @__PURE__ */ new Map(), a = /* @__PURE__ */ new Set();
      return Array.isArray(t) && t.forEach(function(s) {
        if (typeof s == "string")
          i.set(s, s), o.set(s, !1);
        else if (OJ(s)) {
          var l = _o(n.transform(s));
          i.set(l, eu(s)), o.set(l, !1);
        } else zt(s) && s.query && a.add(s);
      }), this.queries.forEach(function(s, l) {
        var u = s.observableQuery, c = s.document;
        if (u) {
          if (t === "all") {
            r.set(l, u);
            return;
          }
          var f = u.queryName, d = u.options.fetchPolicy;
          if (d === "standby" || t === "active" && !u.hasObservers())
            return;
          (t === "active" || f && o.has(f) || c && o.has(_o(c))) && (r.set(l, u), f && o.set(f, !0), c && o.set(_o(c), !0));
        }
      }), a.size && a.forEach(function(s) {
        var l = Rg("legacyOneTimeQuery"), u = n.getOrCreateQuery(l).init({
          document: s.query,
          variables: s.variables
        }), c = new Lf({
          queryManager: n,
          queryInfo: u,
          options: Z(Z({}, s), { fetchPolicy: "network-only" })
        });
        ke(c.queryId === l), u.setObservableQuery(c), r.set(l, c);
      }), globalThis.__DEV__ !== !1 && o.size && o.forEach(function(s, l) {
        if (!s) {
          var u = i.get(l);
          u ? globalThis.__DEV__ !== !1 && ke.warn(43, u) : globalThis.__DEV__ !== !1 && ke.warn(44);
        }
      }), r;
    }, e.prototype.reFetchObservableQueries = function(t) {
      var n = this;
      t === void 0 && (t = !1);
      var r = [];
      return this.getObservableQueries(t ? "all" : "active").forEach(function(i, o) {
        var a = i.options.fetchPolicy;
        Cn("resetLastResults", function() {
          return i.resetLastResults();
        }), (t || a !== "standby" && a !== "cache-only") && r.push(i.refetch()), (n.queries.get(o) || i.queryInfo).setDiff(null);
      }), this.broadcastQueries(), Promise.all(r);
    }, e.prototype.startGraphQLSubscription = function(t) {
      var n = this, r = t.query, i = t.variables, o = t.fetchPolicy, a = t.errorPolicy, s = a === void 0 ? "none" : a, l = t.context, u = l === void 0 ? {} : l, c = t.extensions, f = c === void 0 ? {} : c;
      r = this.transform(r), i = this.getVariables(r, i);
      var d = function(h) {
        return n.getObservableFromLink(r, u, h, f).map(function(v) {
          o !== "no-cache" && (ty(v, s) && n.cache.write({
            query: r,
            result: v.data,
            dataId: "ROOT_SUBSCRIPTION",
            variables: h
          }), n.broadcastQueries());
          var m = jf(v), g = NX(v);
          if (m || g) {
            var _ = {};
            if (m && (_.graphQLErrors = v.errors), g && (_.protocolErrors = v.extensions[z0]), s === "none" || g)
              throw new ho(_);
          }
          return s === "ignore" && delete v.errors, v;
        });
      };
      if (this.getDocumentInfo(r).hasClientExports) {
        var p = this.localState.addExportedVariables(r, i, u).then(d);
        return new Et(function(h) {
          var v = null;
          return p.then(function(m) {
            return v = m.subscribe(h);
          }, h.error), function() {
            return v && v.unsubscribe();
          };
        });
      }
      return d(i);
    }, e.prototype.stopQuery = function(t) {
      this.stopQueryNoBroadcast(t), this.broadcastQueries();
    }, e.prototype.stopQueryNoBroadcast = function(t) {
      this.stopQueryInStoreNoBroadcast(t), this.removeQuery(t);
    }, e.prototype.removeQuery = function(t) {
      var n;
      this.fetchCancelFns.delete(t), this.queries.has(t) && ((n = this.queries.get(t)) === null || n === void 0 || n.stop(), this.queries.delete(t));
    }, e.prototype.broadcastQueries = function() {
      this.onBroadcast && this.onBroadcast(), this.queries.forEach(function(t) {
        var n;
        return (n = t.observableQuery) === null || n === void 0 ? void 0 : n.notify();
      });
    }, e.prototype.getLocalState = function() {
      return this.localState;
    }, e.prototype.getObservableFromLink = function(t, n, r, i, o) {
      var a = this, s;
      o === void 0 && (o = (s = n?.queryDeduplication) !== null && s !== void 0 ? s : this.queryDeduplication);
      var l, u = this.getDocumentInfo(t), c = u.serverQuery, f = u.clientQuery;
      if (c) {
        var d = this, p = d.inFlightLinkObservables, h = d.link, v = {
          query: c,
          variables: r,
          operationName: eu(c) || void 0,
          context: this.prepareContext(Z(Z({}, n), { forceFetch: !o })),
          extensions: i
        };
        if (n = v.context, o) {
          var m = _o(c), g = xo(r), _ = p.lookup(m, g);
          if (l = _.observable, !l) {
            var x = new is([
              Zg(h, v)
            ]);
            l = _.observable = x, x.beforeNext(function w($, k) {
              $ === "next" && "hasNext" in k && k.hasNext ? x.beforeNext(w) : p.remove(m, g);
            });
          }
        } else
          l = new is([
            Zg(h, v)
          ]);
      } else
        l = new is([Et.of({ data: {} })]), n = this.prepareContext(n);
      return f && (l = $m(l, function(w) {
        return a.localState.runResolvers({
          document: f,
          remoteResult: w,
          context: n,
          variables: r
        });
      })), l;
    }, e.prototype.getResultsFromLink = function(t, n, r) {
      var i = t.lastRequestId = this.generateRequestId(), o = this.cache.transformForLink(r.query);
      return $m(this.getObservableFromLink(o, r.context, r.variables), function(a) {
        var s = qg(a), l = s.length > 0, u = r.errorPolicy;
        if (i >= t.lastRequestId) {
          if (l && u === "none")
            throw t.markError(new ho({
              graphQLErrors: s
            }));
          t.markResult(a, o, r, n), t.markReady();
        }
        var c = {
          data: a.data,
          loading: !1,
          networkStatus: gt.ready
        };
        return l && u === "none" && (c.data = void 0), l && u !== "ignore" && (c.errors = s, c.networkStatus = gt.error), c;
      }, function(a) {
        var s = GC(a) ? a : new ho({ networkError: a });
        throw i >= t.lastRequestId && t.markError(s), s;
      });
    }, e.prototype.fetchConcastWithInfo = function(t, n, r, i) {
      var o = this;
      r === void 0 && (r = gt.loading), i === void 0 && (i = n.query);
      var a = this.getVariables(i, n.variables), s = this.defaultOptions.watchQuery, l = n.fetchPolicy, u = l === void 0 ? s && s.fetchPolicy || "cache-first" : l, c = n.errorPolicy, f = c === void 0 ? s && s.errorPolicy || "none" : c, d = n.returnPartialData, p = d === void 0 ? !1 : d, h = n.notifyOnNetworkStatusChange, v = h === void 0 ? !1 : h, m = n.context, g = m === void 0 ? {} : m, _ = Object.assign({}, n, {
        query: i,
        variables: a,
        fetchPolicy: u,
        errorPolicy: f,
        returnPartialData: p,
        notifyOnNetworkStatusChange: v,
        context: g
      }), x = function(E) {
        _.variables = E;
        var b = o.fetchQueryByPolicy(t, _, r);
        return (
          // If we're in standby, postpone advancing options.fetchPolicy using
          // applyNextFetchPolicy.
          _.fetchPolicy !== "standby" && // The "standby" policy currently returns [] from fetchQueryByPolicy, so
          // this is another way to detect when nothing was done/fetched.
          b.sources.length > 0 && t.observableQuery && t.observableQuery.applyNextFetchPolicy("after-fetch", n), b
        );
      }, w = function() {
        return o.fetchCancelFns.delete(t.queryId);
      };
      this.fetchCancelFns.set(t.queryId, function(E) {
        w(), setTimeout(function() {
          return $.cancel(E);
        });
      });
      var $, k;
      if (this.getDocumentInfo(_.query).hasClientExports)
        $ = new is(this.localState.addExportedVariables(_.query, _.variables, _.context).then(x).then(function(E) {
          return E.sources;
        })), k = !0;
      else {
        var D = x(_.variables);
        k = D.fromLink, $ = new is(D.sources);
      }
      return $.promise.then(w, w), {
        concast: $,
        fromLink: k
      };
    }, e.prototype.refetchQueries = function(t) {
      var n = this, r = t.updateCache, i = t.include, o = t.optimistic, a = o === void 0 ? !1 : o, s = t.removeOptimistic, l = s === void 0 ? a ? Rg("refetchQueries") : void 0 : s, u = t.onQueryUpdated, c = /* @__PURE__ */ new Map();
      i && this.getObservableQueries(i).forEach(function(d, p) {
        c.set(p, {
          oq: d,
          lastDiff: (n.queries.get(p) || d.queryInfo).getDiff()
        });
      });
      var f = /* @__PURE__ */ new Map();
      return r && this.cache.batch({
        update: r,
        // Since you can perform any combination of cache reads and/or writes in
        // the cache.batch update function, its optimistic option can be either
        // a boolean or a string, representing three distinct modes of
        // operation:
        //
        // * false: read/write only the root layer
        // * true: read/write the topmost layer
        // * string: read/write a fresh optimistic layer with that ID string
        //
        // When typeof optimistic === "string", a new optimistic layer will be
        // temporarily created within cache.batch with that string as its ID. If
        // we then pass that same string as the removeOptimistic option, we can
        // make cache.batch immediately remove the optimistic layer after
        // running the updateCache function, triggering only one broadcast.
        //
        // However, the refetchQueries method accepts only true or false for its
        // optimistic option (not string). We interpret true to mean a temporary
        // optimistic layer should be created, to allow efficiently rolling back
        // the effect of the updateCache function, which involves passing a
        // string instead of true as the optimistic option to cache.batch, when
        // refetchQueries receives optimistic: true.
        //
        // In other words, we are deliberately not supporting the use case of
        // writing to an *existing* optimistic layer (using the refetchQueries
        // updateCache function), since that would potentially interfere with
        // other optimistic updates in progress. Instead, you can read/write
        // only the root layer by passing optimistic: false to refetchQueries,
        // or you can read/write a brand new optimistic layer that will be
        // automatically removed by passing optimistic: true.
        optimistic: a && l || !1,
        // The removeOptimistic option can also be provided by itself, even if
        // optimistic === false, to remove some previously-added optimistic
        // layer safely and efficiently, like we do in markMutationResult.
        //
        // If an explicit removeOptimistic string is provided with optimistic:
        // true, the removeOptimistic string will determine the ID of the
        // temporary optimistic layer, in case that ever matters.
        removeOptimistic: l,
        onWatchUpdated: function(d, p, h) {
          var v = d.watcher instanceof Mm && d.watcher.observableQuery;
          if (v) {
            if (u) {
              c.delete(v.queryId);
              var m = u(v, p, h);
              return m === !0 && (m = v.refetch()), m !== !1 && f.set(v, m), m;
            }
            u !== null && c.set(v.queryId, { oq: v, lastDiff: h, diff: p });
          }
        }
      }), c.size && c.forEach(function(d, p) {
        var h = d.oq, v = d.lastDiff, m = d.diff, g;
        u && (m || (m = Cn("canonizeResults", function() {
          return n.cache.diff(h.queryInfo.getDiffOptions());
        })), g = u(h, m, v)), (!u || g === !0) && (g = h.refetch()), g !== !1 && f.set(h, g), p.indexOf("legacyOneTimeQuery") >= 0 && n.stopQueryNoBroadcast(p);
      }), l && this.cache.removeOptimistic(l), f;
    }, e.prototype.maskOperation = function(t) {
      var n, r, i, o = t.document, a = t.data;
      if (globalThis.__DEV__ !== !1) {
        var s = t.fetchPolicy, l = t.id, u = (n = Ca(o)) === null || n === void 0 ? void 0 : n.operation, c = ((r = u?.[0]) !== null && r !== void 0 ? r : "o") + l;
        this.dataMasking && s === "no-cache" && !cJ(o) && !this.noCacheWarningsByQueryId.has(c) && (this.noCacheWarningsByQueryId.add(c), globalThis.__DEV__ !== !1 && ke.warn(
          45,
          (i = eu(o)) !== null && i !== void 0 ? i : "Unnamed ".concat(u ?? "operation")
        ));
      }
      return this.dataMasking ? see(a, o, this.cache) : a;
    }, e.prototype.maskFragment = function(t) {
      var n = t.data, r = t.fragment, i = t.fragmentName;
      return this.dataMasking ? n3(n, r, this.cache, i) : n;
    }, e.prototype.fetchQueryByPolicy = function(t, n, r) {
      var i = this, o = n.query, a = n.variables, s = n.fetchPolicy, l = n.refetchWritePolicy, u = n.errorPolicy, c = n.returnPartialData, f = n.context, d = n.notifyOnNetworkStatusChange, p = t.networkStatus;
      t.init({
        document: o,
        variables: a,
        networkStatus: r
      });
      var h = function() {
        return t.getDiff();
      }, v = function(w, $) {
        $ === void 0 && ($ = t.networkStatus || gt.loading);
        var k = w.result;
        globalThis.__DEV__ !== !1 && !c && !$t(k, {}) && v3(w.missing);
        var D = function(E) {
          return Et.of(Z({ data: E, loading: bs($), networkStatus: $ }, w.complete ? null : { partial: !0 }));
        };
        return k && i.getDocumentInfo(o).hasForcedResolvers ? i.localState.runResolvers({
          document: o,
          remoteResult: { data: k },
          context: f,
          variables: a,
          onlyRunForcedResolvers: !0
        }).then(function(E) {
          return D(E.data || void 0);
        }) : u === "none" && $ === gt.refetch && Array.isArray(w.missing) ? D(void 0) : D(k);
      }, m = s === "no-cache" ? 0 : r === gt.refetch && l !== "merge" ? 1 : 2, g = function() {
        return i.getResultsFromLink(t, m, {
          query: o,
          variables: a,
          context: f,
          fetchPolicy: s,
          errorPolicy: u
        });
      }, _ = d && typeof p == "number" && p !== r && bs(r);
      switch (s) {
        default:
        case "cache-first": {
          var x = h();
          return x.complete ? {
            fromLink: !1,
            sources: [v(x, t.markReady())]
          } : c || _ ? {
            fromLink: !0,
            sources: [v(x), g()]
          } : { fromLink: !0, sources: [g()] };
        }
        case "cache-and-network": {
          var x = h();
          return x.complete || c || _ ? {
            fromLink: !0,
            sources: [v(x), g()]
          } : { fromLink: !0, sources: [g()] };
        }
        case "cache-only":
          return {
            fromLink: !1,
            sources: [v(h(), t.markReady())]
          };
        case "network-only":
          return _ ? {
            fromLink: !0,
            sources: [v(h()), g()]
          } : { fromLink: !0, sources: [g()] };
        case "no-cache":
          return _ ? {
            fromLink: !0,
            // Note that queryInfo.getDiff() for no-cache queries does not call
            // cache.diff, but instead returns a { complete: false } stub result
            // when there is no queryInfo.diff already defined.
            sources: [v(t.getDiff()), g()]
          } : { fromLink: !0, sources: [g()] };
        case "standby":
          return { fromLink: !1, sources: [] };
      }
    }, e.prototype.getOrCreateQuery = function(t) {
      return t && !this.queries.has(t) && this.queries.set(t, new Mm(this, t)), this.queries.get(t);
    }, e.prototype.prepareContext = function(t) {
      t === void 0 && (t = {});
      var n = this.localState.prepareContext(t);
      return Z(Z(Z({}, this.defaultContext), n), { clientAwareness: this.clientAwareness });
    }, e;
  })()
), Pee = (
  /** @class */
  (function() {
    function e(t) {
      var n = t.cache, r = t.client, i = t.resolvers, o = t.fragmentMatcher;
      this.selectionsToResolveCache = /* @__PURE__ */ new WeakMap(), this.cache = n, r && (this.client = r), i && this.addResolvers(i), o && this.setFragmentMatcher(o);
    }
    return e.prototype.addResolvers = function(t) {
      var n = this;
      this.resolvers = this.resolvers || {}, Array.isArray(t) ? t.forEach(function(r) {
        n.resolvers = z2(n.resolvers, r);
      }) : this.resolvers = z2(this.resolvers, t);
    }, e.prototype.setResolvers = function(t) {
      this.resolvers = {}, this.addResolvers(t);
    }, e.prototype.getResolvers = function() {
      return this.resolvers || {};
    }, e.prototype.runResolvers = function(t) {
      return co(this, arguments, void 0, function(n) {
        var r = n.document, i = n.remoteResult, o = n.context, a = n.variables, s = n.onlyRunForcedResolvers, l = s === void 0 ? !1 : s;
        return fo(this, function(u) {
          return r ? [2, this.resolveDocument(r, i.data, o, a, this.fragmentMatcher, l).then(function(c) {
            return Z(Z({}, i), { data: c.result });
          })] : [2, i];
        });
      });
    }, e.prototype.setFragmentMatcher = function(t) {
      this.fragmentMatcher = t;
    }, e.prototype.getFragmentMatcher = function() {
      return this.fragmentMatcher;
    }, e.prototype.clientQuery = function(t) {
      return Ku(["client"], t) && this.resolvers ? t : null;
    }, e.prototype.serverQuery = function(t) {
      return VC(t);
    }, e.prototype.prepareContext = function(t) {
      var n = this.cache;
      return Z(Z({}, t), {
        cache: n,
        // Getting an entry's cache key is useful for local state resolvers.
        getCacheKey: function(r) {
          return n.identify(r);
        }
      });
    }, e.prototype.addExportedVariables = function(t) {
      return co(this, arguments, void 0, function(n, r, i) {
        return r === void 0 && (r = {}), i === void 0 && (i = {}), fo(this, function(o) {
          return n ? [2, this.resolveDocument(n, this.buildRootValueFromCache(n, r) || {}, this.prepareContext(i), r).then(function(a) {
            return Z(Z({}, r), a.exportedVariables);
          })] : [2, Z({}, r)];
        });
      });
    }, e.prototype.shouldForceResolvers = function(t) {
      var n = !1;
      return li(t, {
        Directive: {
          enter: function(r) {
            if (r.name.value === "client" && r.arguments && (n = r.arguments.some(function(i) {
              return i.name.value === "always" && i.value.kind === "BooleanValue" && i.value.value === !0;
            }), n))
              return Hp;
          }
        }
      }), n;
    }, e.prototype.buildRootValueFromCache = function(t, n) {
      return this.cache.diff({
        query: tX(t),
        variables: n,
        returnPartialData: !0,
        optimistic: !1
      }).result;
    }, e.prototype.resolveDocument = function(t, n) {
      return co(this, arguments, void 0, function(r, i, o, a, s, l) {
        var u, c, f, d, p, h, v, m, g, _, x;
        return o === void 0 && (o = {}), a === void 0 && (a = {}), s === void 0 && (s = function() {
          return !0;
        }), l === void 0 && (l = !1), fo(this, function(w) {
          return u = xc(r), c = Sl(r), f = xl(c), d = this.collectSelectionsToResolve(u, f), p = u.operation, h = p ? p.charAt(0).toUpperCase() + p.slice(1) : "Query", v = this, m = v.cache, g = v.client, _ = {
            fragmentMap: f,
            context: Z(Z({}, o), { cache: m, client: g }),
            variables: a,
            fragmentMatcher: s,
            defaultOperationType: h,
            exportedVariables: {},
            selectionsToResolve: d,
            onlyRunForcedResolvers: l
          }, x = !1, [2, this.resolveSelectionSet(u.selectionSet, x, i, _).then(function($) {
            return {
              result: $,
              exportedVariables: _.exportedVariables
            };
          })];
        });
      });
    }, e.prototype.resolveSelectionSet = function(t, n, r, i) {
      return co(this, void 0, void 0, function() {
        var o, a, s, l, u, c = this;
        return fo(this, function(f) {
          return o = i.fragmentMap, a = i.context, s = i.variables, l = [r], u = function(d) {
            return co(c, void 0, void 0, function() {
              var p, h;
              return fo(this, function(v) {
                return !n && !i.selectionsToResolve.has(d) ? [
                  2
                  /*return*/
                ] : wc(d, s) ? Io(d) ? [2, this.resolveField(d, n, r, i).then(function(m) {
                  var g;
                  typeof m < "u" && l.push((g = {}, g[Xi(d)] = m, g));
                })] : (LJ(d) ? p = d : (p = o[d.name.value], ke(p, 21, d.name.value)), p && p.typeCondition && (h = p.typeCondition.name.value, i.fragmentMatcher(r, h, a)) ? [2, this.resolveSelectionSet(p.selectionSet, n, r, i).then(function(m) {
                  l.push(m);
                })] : [
                  2
                  /*return*/
                ]) : [
                  2
                  /*return*/
                ];
              });
            });
          }, [2, Promise.all(t.selections.map(u)).then(function() {
            return Jp(l);
          })];
        });
      });
    }, e.prototype.resolveField = function(t, n, r, i) {
      return co(this, void 0, void 0, function() {
        var o, a, s, l, u, c, f, d, p, h = this;
        return fo(this, function(v) {
          return r ? (o = i.variables, a = t.name.value, s = Xi(t), l = a !== s, u = r[s] || r[a], c = Promise.resolve(u), (!i.onlyRunForcedResolvers || this.shouldForceResolvers(t)) && (f = r.__typename || i.defaultOperationType, d = this.resolvers && this.resolvers[f], d && (p = d[l ? a : s], p && (c = Promise.resolve(
            // In case the resolve function accesses reactive variables,
            // set cacheSlot to the current cache instance.
            V0.withValue(this.cache, p, [
              r,
              Gp(t, o),
              i.context,
              { field: t, fragmentMap: i.fragmentMap }
            ])
          )))), [2, c.then(function(m) {
            var g, _;
            if (m === void 0 && (m = u), t.directives && t.directives.forEach(function(w) {
              w.name.value === "export" && w.arguments && w.arguments.forEach(function($) {
                $.name.value === "as" && $.value.kind === "StringValue" && (i.exportedVariables[$.value.value] = m);
              });
            }), !t.selectionSet || m == null)
              return m;
            var x = (_ = (g = t.directives) === null || g === void 0 ? void 0 : g.some(function(w) {
              return w.name.value === "client";
            })) !== null && _ !== void 0 ? _ : !1;
            if (Array.isArray(m))
              return h.resolveSubSelectedArray(t, n || x, m, i);
            if (t.selectionSet)
              return h.resolveSelectionSet(t.selectionSet, n || x, m, i);
          })]) : [2, null];
        });
      });
    }, e.prototype.resolveSubSelectedArray = function(t, n, r, i) {
      var o = this;
      return Promise.all(r.map(function(a) {
        if (a === null)
          return null;
        if (Array.isArray(a))
          return o.resolveSubSelectedArray(t, n, a, i);
        if (t.selectionSet)
          return o.resolveSelectionSet(t.selectionSet, n, a, i);
      }));
    }, e.prototype.collectSelectionsToResolve = function(t, n) {
      var r = function(a) {
        return !Array.isArray(a);
      }, i = this.selectionsToResolveCache;
      function o(a) {
        if (!i.has(a)) {
          var s = /* @__PURE__ */ new Set();
          i.set(a, s), li(a, {
            Directive: function(l, u, c, f, d) {
              l.name.value === "client" && d.forEach(function(p) {
                r(p) && A2(p) && s.add(p);
              });
            },
            FragmentSpread: function(l, u, c, f, d) {
              var p = n[l.name.value];
              ke(p, 22, l.name.value);
              var h = o(p);
              h.size > 0 && (d.forEach(function(v) {
                r(v) && A2(v) && s.add(v);
              }), s.add(l), h.forEach(function(v) {
                s.add(v);
              }));
            }
          });
        }
        return i.get(a);
      }
      return o(t);
    }, e;
  })()
), _S = !1, Aee = (
  /** @class */
  (function() {
    function e(t) {
      var n = this, r, i, o;
      if (this.resetStoreCallbacks = [], this.clearStoreCallbacks = [], !t.cache)
        throw Zn(16);
      var a = t.uri, s = t.credentials, l = t.headers, u = t.cache, c = t.documentTransform, f = t.ssrMode, d = f === void 0 ? !1 : f, p = t.ssrForceFetchDelay, h = p === void 0 ? 0 : p, v = t.connectToDevTools, m = t.queryDeduplication, g = m === void 0 ? !0 : m, _ = t.defaultOptions, x = t.defaultContext, w = t.assumeImmutableResults, $ = w === void 0 ? u.assumeImmutableResults : w, k = t.resolvers, D = t.typeDefs, E = t.fragmentMatcher, b = t.clientAwareness, y = t.name, S = t.version, P = t.devtools, M = t.dataMasking;
      globalThis.__DEV__ !== !1 && (tn(t, "connectToDevTools", "ApolloClient", "Please use `devtools.enabled` instead."), tn(t, "uri", "ApolloClient", "Please initialize an instance of `HttpLink` with `uri` instead."), tn(t, "credentials", "ApolloClient", "Please initialize an instance of `HttpLink` with `credentials` instead."), tn(t, "headers", "ApolloClient", "Please initialize an instance of `HttpLink` with `headers` instead."), tn(t, "name", "ApolloClient", "Please use the `clientAwareness.name` option instead."), tn(t, "version", "ApolloClient", "Please use the `clientAwareness.version` option instead."), tn(t, "typeDefs", "ApolloClient"), t.link || globalThis.__DEV__ !== !1 && ke.warn(17));
      var T = t.link;
      T || (T = a ? new XX({ uri: a, credentials: s, headers: l }) : qo.empty()), this.link = T, this.cache = u, this.disableNetworkFetches = d || h > 0, this.queryDeduplication = g, this.defaultOptions = _ || /* @__PURE__ */ Object.create(null), this.typeDefs = D, this.devtoolsConfig = Z(Z({}, P), { enabled: (r = P?.enabled) !== null && r !== void 0 ? r : v }), this.devtoolsConfig.enabled === void 0 && (this.devtoolsConfig.enabled = globalThis.__DEV__ !== !1), h && setTimeout(function() {
        return n.disableNetworkFetches = !1;
      }, h), this.watchQuery = this.watchQuery.bind(this), this.query = this.query.bind(this), this.mutate = this.mutate.bind(this), this.watchFragment = this.watchFragment.bind(this), this.resetStore = this.resetStore.bind(this), this.reFetchObservableQueries = this.reFetchObservableQueries.bind(this), this.version = k0, this.localState = new Pee({
        cache: u,
        client: this,
        resolvers: k,
        fragmentMatcher: E
      }), this.queryManager = new Oee({
        cache: this.cache,
        link: this.link,
        defaultOptions: this.defaultOptions,
        defaultContext: x,
        documentTransform: c,
        queryDeduplication: g,
        ssrMode: d,
        dataMasking: !!M,
        clientAwareness: {
          name: (i = b?.name) !== null && i !== void 0 ? i : y,
          version: (o = b?.version) !== null && o !== void 0 ? o : S
        },
        localState: this.localState,
        assumeImmutableResults: $,
        onBroadcast: this.devtoolsConfig.enabled ? function() {
          n.devToolsHookCb && n.devToolsHookCb({
            action: {},
            state: {
              queries: n.queryManager.getQueryStore(),
              mutations: n.queryManager.mutationStore || {}
            },
            dataWithOptimisticResults: n.cache.extract(!0)
          });
        } : void 0
      }), this.devtoolsConfig.enabled && this.connectToDevTools();
    }
    return Object.defineProperty(e.prototype, "prioritizeCacheValues", {
      /**
       * Whether to prioritize cache values over network results when `query` or `watchQuery` is called.
       * This will essentially turn a `"network-only"` or `"cache-and-network"` fetchPolicy into a `"cache-first"` fetchPolicy,
       * but without influencing the `fetchPolicy` of the created `ObservableQuery` long-term.
       *
       * This can e.g. be used to prioritize the cache during the first render after SSR.
       */
      get: function() {
        return this.disableNetworkFetches;
      },
      set: function(t) {
        this.disableNetworkFetches = t;
      },
      enumerable: !1,
      configurable: !0
    }), e.prototype.connectToDevTools = function() {
      if (!(typeof window > "u")) {
        var t = window, n = Symbol.for("apollo.devtools");
        (t[n] = t[n] || []).push(this), t.__APOLLO_CLIENT__ = this, !_S && globalThis.__DEV__ !== !1 && (_S = !0, window.document && window.top === window.self && /^(https?|file):$/.test(window.location.protocol) && setTimeout(function() {
          if (!window.__APOLLO_DEVTOOLS_GLOBAL_HOOK__) {
            var r = window.navigator, i = r && r.userAgent, o = void 0;
            typeof i == "string" && (i.indexOf("Chrome/") > -1 ? o = "https://chrome.google.com/webstore/detail/apollo-client-developer-t/jdkknkkbebbapilgoeccciglkfbmbnfm" : i.indexOf("Firefox/") > -1 && (o = "https://addons.mozilla.org/en-US/firefox/addon/apollo-developer-tools/")), o && globalThis.__DEV__ !== !1 && ke.log("Download the Apollo DevTools for a better development experience: %s", o);
          }
        }, 1e4));
      }
    }, Object.defineProperty(e.prototype, "documentTransform", {
      /**
       * The `DocumentTransform` used to modify GraphQL documents before a request
       * is made. If a custom `DocumentTransform` is not provided, this will be the
       * default document transform.
       */
      get: function() {
        return this.queryManager.documentTransform;
      },
      enumerable: !1,
      configurable: !0
    }), e.prototype.stop = function() {
      this.queryManager.stop();
    }, e.prototype.watchQuery = function(t) {
      return this.defaultOptions.watchQuery && (t = km(this.defaultOptions.watchQuery, t)), this.disableNetworkFetches && (t.fetchPolicy === "network-only" || t.fetchPolicy === "cache-and-network") && (t = Z(Z({}, t), { fetchPolicy: "cache-first" })), globalThis.__DEV__ !== !1 && (tn(t, "canonizeResults", "client.watchQuery"), tn(t, "partialRefetch", "client.watchQuery")), this.queryManager.watchQuery(t);
    }, e.prototype.query = function(t) {
      return this.defaultOptions.query && (t = km(this.defaultOptions.query, t)), ke(t.fetchPolicy !== "cache-and-network", 18), this.disableNetworkFetches && t.fetchPolicy === "network-only" && (t = Z(Z({}, t), { fetchPolicy: "cache-first" })), globalThis.__DEV__ !== !1 && (tn(t, "canonizeResults", "client.query"), tn(t, "notifyOnNetworkStatusChange", "client.query", "This option does not affect `client.query` and can be safely removed."), t.fetchPolicy === "standby" && globalThis.__DEV__ !== !1 && ke.warn(19)), this.queryManager.query(t);
    }, e.prototype.mutate = function(t) {
      return this.defaultOptions.mutate && (t = km(this.defaultOptions.mutate, t)), this.queryManager.mutate(t);
    }, e.prototype.subscribe = function(t) {
      var n = this, r = this.queryManager.generateQueryId();
      return this.queryManager.startGraphQLSubscription(t).map(function(i) {
        return Z(Z({}, i), { data: n.queryManager.maskOperation({
          document: t.query,
          data: i.data,
          fetchPolicy: t.fetchPolicy,
          id: r
        }) });
      });
    }, e.prototype.readQuery = function(t, n) {
      return n === void 0 && (n = !1), this.cache.readQuery(t, n);
    }, e.prototype.watchFragment = function(t) {
      var n;
      return this.cache.watchFragment(Z(Z({}, t), (n = {}, n[Symbol.for("apollo.dataMasking")] = this.queryManager.dataMasking, n)));
    }, e.prototype.readFragment = function(t, n) {
      return n === void 0 && (n = !1), this.cache.readFragment(t, n);
    }, e.prototype.writeQuery = function(t) {
      var n = this.cache.writeQuery(t);
      return t.broadcast !== !1 && this.queryManager.broadcastQueries(), n;
    }, e.prototype.writeFragment = function(t) {
      var n = this.cache.writeFragment(t);
      return t.broadcast !== !1 && this.queryManager.broadcastQueries(), n;
    }, e.prototype.__actionHookForDevTools = function(t) {
      this.devToolsHookCb = t;
    }, e.prototype.__requestRaw = function(t) {
      return Zg(this.link, t);
    }, e.prototype.resetStore = function() {
      var t = this;
      return Promise.resolve().then(function() {
        return t.queryManager.clearStore({
          discardWatches: !1
        });
      }).then(function() {
        return Promise.all(t.resetStoreCallbacks.map(function(n) {
          return n();
        }));
      }).then(function() {
        return t.reFetchObservableQueries();
      });
    }, e.prototype.clearStore = function() {
      var t = this;
      return Promise.resolve().then(function() {
        return t.queryManager.clearStore({
          discardWatches: !0
        });
      }).then(function() {
        return Promise.all(t.clearStoreCallbacks.map(function(n) {
          return n();
        }));
      });
    }, e.prototype.onResetStore = function(t) {
      var n = this;
      return this.resetStoreCallbacks.push(t), function() {
        n.resetStoreCallbacks = n.resetStoreCallbacks.filter(function(r) {
          return r !== t;
        });
      };
    }, e.prototype.onClearStore = function(t) {
      var n = this;
      return this.clearStoreCallbacks.push(t), function() {
        n.clearStoreCallbacks = n.clearStoreCallbacks.filter(function(r) {
          return r !== t;
        });
      };
    }, e.prototype.reFetchObservableQueries = function(t) {
      return this.queryManager.reFetchObservableQueries(t);
    }, e.prototype.refetchQueries = function(t) {
      var n = this.queryManager.refetchQueries(t), r = [], i = [];
      n.forEach(function(a, s) {
        r.push(s), i.push(a);
      });
      var o = Promise.all(i);
      return o.queries = r, o.results = i, o.catch(function(a) {
        globalThis.__DEV__ !== !1 && ke.debug(20, a);
      }), o;
    }, e.prototype.getObservableQueries = function(t) {
      return t === void 0 && (t = "active"), this.queryManager.getObservableQueries(t);
    }, e.prototype.extract = function(t) {
      return this.cache.extract(t);
    }, e.prototype.restore = function(t) {
      return this.cache.restore(t);
    }, e.prototype.addResolvers = function(t) {
      this.localState.addResolvers(t);
    }, e.prototype.setResolvers = function(t) {
      this.localState.setResolvers(t);
    }, e.prototype.getResolvers = function() {
      return this.localState.getResolvers();
    }, e.prototype.setLocalStateFragmentMatcher = function(t) {
      this.localState.setFragmentMatcher(t);
    }, e.prototype.setLink = function(t) {
      this.link = this.queryManager.link = t;
    }, Object.defineProperty(e.prototype, "defaultContext", {
      get: function() {
        return this.queryManager.defaultContext;
      },
      enumerable: !1,
      configurable: !0
    }), e;
  })()
);
globalThis.__DEV__ !== !1 && (Aee.prototype.getMemoryInternals = bJ);
function Dee(e) {
  return zt(e) && "code" in e && "reason" in e;
}
function Cee(e) {
  var t;
  return zt(e) && ((t = e.target) === null || t === void 0 ? void 0 : t.readyState) === WebSocket.CLOSED;
}
/** @class */
(function(e) {
  pi(t, e);
  function t(n) {
    var r = e.call(this) || this;
    return r.client = n, r;
  }
  return t.prototype.request = function(n) {
    var r = this;
    return new Et(function(i) {
      return r.client.subscribe(Z(Z({}, n), { query: _o(n.query) }), {
        next: i.next.bind(i),
        complete: i.complete.bind(i),
        error: function(o) {
          if (o instanceof Error)
            return i.error(o);
          var a = Dee(o);
          return a || Cee(o) ? i.error(
            // reason will be available on clean closes
            new Error("Socket closed".concat(a ? " with event ".concat(o.code) : "").concat(a ? " ".concat(o.reason) : ""))
          ) : i.error(new ho({
            graphQLErrors: Array.isArray(o) ? o : [o]
          }));
        }
        // casting around a wrong type in graphql-ws, which incorrectly expects `Sink<ExecutionResult>`
      });
    });
  }, t;
})(qo);
var wS;
(function(e) {
  e[e.InternalServerError = 4500] = "InternalServerError", e[e.InternalClientError = 4005] = "InternalClientError", e[e.BadRequest = 4400] = "BadRequest", e[e.BadResponse = 4004] = "BadResponse", e[e.Unauthorized = 4401] = "Unauthorized", e[e.Forbidden = 4403] = "Forbidden", e[e.SubprotocolNotAcceptable = 4406] = "SubprotocolNotAcceptable", e[e.ConnectionInitialisationTimeout = 4408] = "ConnectionInitialisationTimeout", e[e.ConnectionAcknowledgementTimeout = 4504] = "ConnectionAcknowledgementTimeout", e[e.SubscriberAlreadyExists = 4409] = "SubscriberAlreadyExists", e[e.TooManyInitialisationRequests = 4429] = "TooManyInitialisationRequests";
})(wS || (wS = {}));
var xS;
(function(e) {
  e.ConnectionInit = "connection_init", e.ConnectionAck = "connection_ack", e.Ping = "ping", e.Pong = "pong", e.Subscribe = "subscribe", e.Next = "next", e.Error = "error", e.Complete = "complete";
})(xS || (xS = {}));
function oe(e, t, n) {
  function r(s, l) {
    if (s._zod || Object.defineProperty(s, "_zod", {
      value: {
        def: l,
        constr: a,
        traits: /* @__PURE__ */ new Set()
      },
      enumerable: !1
    }), s._zod.traits.has(e))
      return;
    s._zod.traits.add(e), t(s, l);
    const u = a.prototype, c = Object.keys(u);
    for (let f = 0; f < c.length; f++) {
      const d = c[f];
      d in s || (s[d] = u[d].bind(s));
    }
  }
  const i = n?.Parent ?? Object;
  class o extends i {
  }
  Object.defineProperty(o, "name", { value: e });
  function a(s) {
    var l;
    const u = n != null && n.Parent ? new o() : this;
    r(u, s), (l = u._zod).deferred ?? (l.deferred = []);
    for (const c of u._zod.deferred)
      c();
    return u;
  }
  return Object.defineProperty(a, "init", { value: r }), Object.defineProperty(a, Symbol.hasInstance, {
    value: (s) => {
      var l, u;
      return n != null && n.Parent && s instanceof n.Parent ? !0 : (u = (l = s?._zod) == null ? void 0 : l.traits) == null ? void 0 : u.has(e);
    }
  }), Object.defineProperty(a, "name", { value: e }), a;
}
class As extends Error {
  constructor() {
    super("Encountered Promise during synchronous parse. Use .parseAsync() instead.");
  }
}
class g3 extends Error {
  constructor(t) {
    super(`Encountered unidirectional transform during encode: ${t}`), this.name = "ZodEncodeError";
  }
}
const y3 = {};
function Ia(e) {
  return y3;
}
function b3(e) {
  const t = Object.values(e).filter((n) => typeof n == "number");
  return Object.entries(e).filter(([n, r]) => t.indexOf(+n) === -1).map(([n, r]) => r);
}
function ny(e, t) {
  return typeof t == "bigint" ? t.toString() : t;
}
function q0(e) {
  return {
    get value() {
      {
        const t = e();
        return Object.defineProperty(this, "value", { value: t }), t;
      }
    }
  };
}
function H0(e) {
  return e == null;
}
function W0(e) {
  const t = e.startsWith("^") ? 1 : 0, n = e.endsWith("$") ? e.length - 1 : e.length;
  return e.slice(t, n);
}
function Iee(e, t) {
  const n = (e.toString().split(".")[1] || "").length, r = t.toString();
  let i = (r.split(".")[1] || "").length;
  if (i === 0 && /\d?e-\d?/.test(r)) {
    const l = r.match(/\d?e-(\d?)/);
    l != null && l[1] && (i = Number.parseInt(l[1]));
  }
  const o = n > i ? n : i, a = Number.parseInt(e.toFixed(o).replace(".", "")), s = Number.parseInt(t.toFixed(o).replace(".", ""));
  return a % s / 10 ** o;
}
const ES = Symbol("evaluating");
function bt(e, t, n) {
  let r;
  Object.defineProperty(e, t, {
    get() {
      if (r !== ES)
        return r === void 0 && (r = ES, r = n()), r;
    },
    set(i) {
      Object.defineProperty(e, t, {
        value: i
        // configurable: true,
      });
    },
    configurable: !0
  });
}
function Ga(e, t, n) {
  Object.defineProperty(e, t, {
    value: n,
    writable: !0,
    enumerable: !0,
    configurable: !0
  });
}
function Ho(...e) {
  const t = {};
  for (const n of e) {
    const r = Object.getOwnPropertyDescriptors(n);
    Object.assign(t, r);
  }
  return Object.defineProperties({}, t);
}
function SS(e) {
  return JSON.stringify(e);
}
function Mee(e) {
  return e.toLowerCase().trim().replace(/[^\w\s-]/g, "").replace(/[\s_-]+/g, "-").replace(/^-+|-+$/g, "");
}
const _3 = "captureStackTrace" in Error ? Error.captureStackTrace : (...e) => {
};
function Kd(e) {
  return typeof e == "object" && e !== null && !Array.isArray(e);
}
const Ree = q0(() => {
  var e;
  if (typeof navigator < "u" && (e = navigator?.userAgent) != null && e.includes("Cloudflare"))
    return !1;
  try {
    const t = Function;
    return new t(""), !0;
  } catch {
    return !1;
  }
});
function Wu(e) {
  if (Kd(e) === !1)
    return !1;
  const t = e.constructor;
  if (t === void 0 || typeof t != "function")
    return !0;
  const n = t.prototype;
  return !(Kd(n) === !1 || Object.prototype.hasOwnProperty.call(n, "isPrototypeOf") === !1);
}
function w3(e) {
  return Wu(e) ? { ...e } : Array.isArray(e) ? [...e] : e;
}
const Nee = /* @__PURE__ */ new Set(["string", "number", "symbol"]);
function Xp(e) {
  return e.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
}
function Wo(e, t, n) {
  const r = new e._zod.constr(t ?? e._zod.def);
  return (!t || n != null && n.parent) && (r._zod.parent = e), r;
}
function qe(e) {
  const t = e;
  if (!t)
    return {};
  if (typeof t == "string")
    return { error: () => t };
  if (t?.message !== void 0) {
    if (t?.error !== void 0)
      throw new Error("Cannot specify both `message` and `error` params");
    t.error = t.message;
  }
  return delete t.message, typeof t.error == "string" ? { ...t, error: () => t.error } : t;
}
function jee(e) {
  return Object.keys(e).filter((t) => e[t]._zod.optin === "optional" && e[t]._zod.optout === "optional");
}
const Fee = {
  safeint: [Number.MIN_SAFE_INTEGER, Number.MAX_SAFE_INTEGER],
  int32: [-2147483648, 2147483647],
  uint32: [0, 4294967295],
  float32: [-34028234663852886e22, 34028234663852886e22],
  float64: [-Number.MAX_VALUE, Number.MAX_VALUE]
};
function zee(e, t) {
  const n = e._zod.def, r = n.checks;
  if (r && r.length > 0)
    throw new Error(".pick() cannot be used on object schemas containing refinements");
  const i = Ho(e._zod.def, {
    get shape() {
      const o = {};
      for (const a in t) {
        if (!(a in n.shape))
          throw new Error(`Unrecognized key: "${a}"`);
        t[a] && (o[a] = n.shape[a]);
      }
      return Ga(this, "shape", o), o;
    },
    checks: []
  });
  return Wo(e, i);
}
function Lee(e, t) {
  const n = e._zod.def, r = n.checks;
  if (r && r.length > 0)
    throw new Error(".omit() cannot be used on object schemas containing refinements");
  const i = Ho(e._zod.def, {
    get shape() {
      const o = { ...e._zod.def.shape };
      for (const a in t) {
        if (!(a in n.shape))
          throw new Error(`Unrecognized key: "${a}"`);
        t[a] && delete o[a];
      }
      return Ga(this, "shape", o), o;
    },
    checks: []
  });
  return Wo(e, i);
}
function Vee(e, t) {
  if (!Wu(t))
    throw new Error("Invalid input to extend: expected a plain object");
  const n = e._zod.def.checks;
  if (n && n.length > 0) {
    const i = e._zod.def.shape;
    for (const o in t)
      if (Object.getOwnPropertyDescriptor(i, o) !== void 0)
        throw new Error("Cannot overwrite keys on object schemas containing refinements. Use `.safeExtend()` instead.");
  }
  const r = Ho(e._zod.def, {
    get shape() {
      const i = { ...e._zod.def.shape, ...t };
      return Ga(this, "shape", i), i;
    }
  });
  return Wo(e, r);
}
function Bee(e, t) {
  if (!Wu(t))
    throw new Error("Invalid input to safeExtend: expected a plain object");
  const n = Ho(e._zod.def, {
    get shape() {
      const r = { ...e._zod.def.shape, ...t };
      return Ga(this, "shape", r), r;
    }
  });
  return Wo(e, n);
}
function Kee(e, t) {
  const n = Ho(e._zod.def, {
    get shape() {
      const r = { ...e._zod.def.shape, ...t._zod.def.shape };
      return Ga(this, "shape", r), r;
    },
    get catchall() {
      return t._zod.def.catchall;
    },
    checks: []
    // delete existing checks
  });
  return Wo(e, n);
}
function Uee(e, t, n) {
  const r = t._zod.def.checks;
  if (r && r.length > 0)
    throw new Error(".partial() cannot be used on object schemas containing refinements");
  const i = Ho(t._zod.def, {
    get shape() {
      const o = t._zod.def.shape, a = { ...o };
      if (n)
        for (const s in n) {
          if (!(s in o))
            throw new Error(`Unrecognized key: "${s}"`);
          n[s] && (a[s] = e ? new e({
            type: "optional",
            innerType: o[s]
          }) : o[s]);
        }
      else
        for (const s in o)
          a[s] = e ? new e({
            type: "optional",
            innerType: o[s]
          }) : o[s];
      return Ga(this, "shape", a), a;
    },
    checks: []
  });
  return Wo(t, i);
}
function qee(e, t, n) {
  const r = Ho(t._zod.def, {
    get shape() {
      const i = t._zod.def.shape, o = { ...i };
      if (n)
        for (const a in n) {
          if (!(a in o))
            throw new Error(`Unrecognized key: "${a}"`);
          n[a] && (o[a] = new e({
            type: "nonoptional",
            innerType: i[a]
          }));
        }
      else
        for (const a in i)
          o[a] = new e({
            type: "nonoptional",
            innerType: i[a]
          });
      return Ga(this, "shape", o), o;
    }
  });
  return Wo(t, r);
}
function ws(e, t = 0) {
  var n;
  if (e.aborted === !0)
    return !0;
  for (let r = t; r < e.issues.length; r++)
    if (((n = e.issues[r]) == null ? void 0 : n.continue) !== !0)
      return !0;
  return !1;
}
function x3(e, t) {
  return t.map((n) => {
    var r;
    return (r = n).path ?? (r.path = []), n.path.unshift(e), n;
  });
}
function af(e) {
  return typeof e == "string" ? e : e?.message;
}
function Ma(e, t, n) {
  var r, i, o, a, s, l;
  const u = { ...e, path: e.path ?? [] };
  if (!e.message) {
    const c = af((o = (i = (r = e.inst) == null ? void 0 : r._zod.def) == null ? void 0 : i.error) == null ? void 0 : o.call(i, e)) ?? af((a = t?.error) == null ? void 0 : a.call(t, e)) ?? af((s = n.customError) == null ? void 0 : s.call(n, e)) ?? af((l = n.localeError) == null ? void 0 : l.call(n, e)) ?? "Invalid input";
    u.message = c;
  }
  return delete u.inst, delete u.continue, t != null && t.reportInput || delete u.input, u;
}
function Z0(e) {
  return Array.isArray(e) ? "array" : typeof e == "string" ? "string" : "unknown";
}
function Zu(...e) {
  const [t, n, r] = e;
  return typeof t == "string" ? {
    message: t,
    code: "custom",
    input: n,
    inst: r
  } : { ...t };
}
const E3 = (e, t) => {
  e.name = "$ZodError", Object.defineProperty(e, "_zod", {
    value: e._zod,
    enumerable: !1
  }), Object.defineProperty(e, "issues", {
    value: t,
    enumerable: !1
  }), e.message = JSON.stringify(t, ny, 2), Object.defineProperty(e, "toString", {
    value: () => e.message,
    enumerable: !1
  });
}, S3 = oe("$ZodError", E3), $3 = oe("$ZodError", E3, { Parent: Error });
function Hee(e, t = (n) => n.message) {
  const n = {}, r = [];
  for (const i of e.issues)
    i.path.length > 0 ? (n[i.path[0]] = n[i.path[0]] || [], n[i.path[0]].push(t(i))) : r.push(t(i));
  return { formErrors: r, fieldErrors: n };
}
function Wee(e, t = (n) => n.message) {
  const n = { _errors: [] }, r = (i) => {
    for (const o of i.issues)
      if (o.code === "invalid_union" && o.errors.length)
        o.errors.map((a) => r({ issues: a }));
      else if (o.code === "invalid_key")
        r({ issues: o.issues });
      else if (o.code === "invalid_element")
        r({ issues: o.issues });
      else if (o.path.length === 0)
        n._errors.push(t(o));
      else {
        let a = n, s = 0;
        for (; s < o.path.length; ) {
          const l = o.path[s];
          s === o.path.length - 1 ? (a[l] = a[l] || { _errors: [] }, a[l]._errors.push(t(o))) : a[l] = a[l] || { _errors: [] }, a = a[l], s++;
        }
      }
  };
  return r(e), n;
}
const G0 = (e) => (t, n, r, i) => {
  const o = r ? Object.assign(r, { async: !1 }) : { async: !1 }, a = t._zod.run({ value: n, issues: [] }, o);
  if (a instanceof Promise)
    throw new As();
  if (a.issues.length) {
    const s = new (i?.Err ?? e)(a.issues.map((l) => Ma(l, o, Ia())));
    throw _3(s, i?.callee), s;
  }
  return a.value;
}, Y0 = (e) => async (t, n, r, i) => {
  const o = r ? Object.assign(r, { async: !0 }) : { async: !0 };
  let a = t._zod.run({ value: n, issues: [] }, o);
  if (a instanceof Promise && (a = await a), a.issues.length) {
    const s = new (i?.Err ?? e)(a.issues.map((l) => Ma(l, o, Ia())));
    throw _3(s, i?.callee), s;
  }
  return a.value;
}, eh = (e) => (t, n, r) => {
  const i = r ? { ...r, async: !1 } : { async: !1 }, o = t._zod.run({ value: n, issues: [] }, i);
  if (o instanceof Promise)
    throw new As();
  return o.issues.length ? {
    success: !1,
    error: new (e ?? S3)(o.issues.map((a) => Ma(a, i, Ia())))
  } : { success: !0, data: o.value };
}, Zee = /* @__PURE__ */ eh($3), th = (e) => async (t, n, r) => {
  const i = r ? Object.assign(r, { async: !0 }) : { async: !0 };
  let o = t._zod.run({ value: n, issues: [] }, i);
  return o instanceof Promise && (o = await o), o.issues.length ? {
    success: !1,
    error: new e(o.issues.map((a) => Ma(a, i, Ia())))
  } : { success: !0, data: o.value };
}, Gee = /* @__PURE__ */ th($3), Yee = (e) => (t, n, r) => {
  const i = r ? Object.assign(r, { direction: "backward" }) : { direction: "backward" };
  return G0(e)(t, n, i);
}, Qee = (e) => (t, n, r) => G0(e)(t, n, r), Jee = (e) => async (t, n, r) => {
  const i = r ? Object.assign(r, { direction: "backward" }) : { direction: "backward" };
  return Y0(e)(t, n, i);
}, Xee = (e) => async (t, n, r) => Y0(e)(t, n, r), ete = (e) => (t, n, r) => {
  const i = r ? Object.assign(r, { direction: "backward" }) : { direction: "backward" };
  return eh(e)(t, n, i);
}, tte = (e) => (t, n, r) => eh(e)(t, n, r), nte = (e) => async (t, n, r) => {
  const i = r ? Object.assign(r, { direction: "backward" }) : { direction: "backward" };
  return th(e)(t, n, i);
}, rte = (e) => async (t, n, r) => th(e)(t, n, r), ite = /^[cC][^\s-]{8,}$/, ote = /^[0-9a-z]+$/, ate = /^[0-9A-HJKMNP-TV-Za-hjkmnp-tv-z]{26}$/, ste = /^[0-9a-vA-V]{20}$/, lte = /^[A-Za-z0-9]{27}$/, ute = /^[a-zA-Z0-9_-]{21}$/, cte = /^P(?:(\d+W)|(?!.*W)(?=\d|T\d)(\d+Y)?(\d+M)?(\d+D)?(T(?=\d)(\d+H)?(\d+M)?(\d+([.,]\d+)?S)?)?)$/, fte = /^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12})$/, $S = (e) => e ? new RegExp(`^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-${e}[0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12})$`) : /^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$/, dte = /^(?!\.)(?!.*\.\.)([A-Za-z0-9_'+\-\.]*)[A-Za-z0-9_+-]@([A-Za-z0-9][A-Za-z0-9\-]*\.)+[A-Za-z]{2,}$/, pte = "^(\\p{Extended_Pictographic}|\\p{Emoji_Component})+$";
function hte() {
  return new RegExp(pte, "u");
}
const mte = /^(?:(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])\.){3}(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])$/, vte = /^(([0-9a-fA-F]{1,4}:){7}[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,7}:|([0-9a-fA-F]{1,4}:){1,6}:[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,5}(:[0-9a-fA-F]{1,4}){1,2}|([0-9a-fA-F]{1,4}:){1,4}(:[0-9a-fA-F]{1,4}){1,3}|([0-9a-fA-F]{1,4}:){1,3}(:[0-9a-fA-F]{1,4}){1,4}|([0-9a-fA-F]{1,4}:){1,2}(:[0-9a-fA-F]{1,4}){1,5}|[0-9a-fA-F]{1,4}:((:[0-9a-fA-F]{1,4}){1,6})|:((:[0-9a-fA-F]{1,4}){1,7}|:))$/, gte = /^((25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])\.){3}(25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])\/([0-9]|[1-2][0-9]|3[0-2])$/, yte = /^(([0-9a-fA-F]{1,4}:){7}[0-9a-fA-F]{1,4}|::|([0-9a-fA-F]{1,4})?::([0-9a-fA-F]{1,4}:?){0,6})\/(12[0-8]|1[01][0-9]|[1-9]?[0-9])$/, bte = /^$|^(?:[0-9a-zA-Z+/]{4})*(?:(?:[0-9a-zA-Z+/]{2}==)|(?:[0-9a-zA-Z+/]{3}=))?$/, k3 = /^[A-Za-z0-9_-]*$/, _te = /^\+[1-9]\d{6,14}$/, T3 = "(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))", wte = /* @__PURE__ */ new RegExp(`^${T3}$`);
function O3(e) {
  const t = "(?:[01]\\d|2[0-3]):[0-5]\\d";
  return typeof e.precision == "number" ? e.precision === -1 ? `${t}` : e.precision === 0 ? `${t}:[0-5]\\d` : `${t}:[0-5]\\d\\.\\d{${e.precision}}` : `${t}(?::[0-5]\\d(?:\\.\\d+)?)?`;
}
function xte(e) {
  return new RegExp(`^${O3(e)}$`);
}
function Ete(e) {
  const t = O3({ precision: e.precision }), n = ["Z"];
  e.local && n.push(""), e.offset && n.push("([+-](?:[01]\\d|2[0-3]):[0-5]\\d)");
  const r = `${t}(?:${n.join("|")})`;
  return new RegExp(`^${T3}T(?:${r})$`);
}
const Ste = (e) => {
  const t = e ? `[\\s\\S]{${e?.minimum ?? 0},${e?.maximum ?? ""}}` : "[\\s\\S]*";
  return new RegExp(`^${t}$`);
}, $te = /^-?\d+$/, kte = /^-?\d+(?:\.\d+)?$/, Tte = /^(?:true|false)$/i, Ote = /^[^A-Z]*$/, Pte = /^[^a-z]*$/, lr = /* @__PURE__ */ oe("$ZodCheck", (e, t) => {
  var n;
  e._zod ?? (e._zod = {}), e._zod.def = t, (n = e._zod).onattach ?? (n.onattach = []);
}), P3 = {
  number: "number",
  bigint: "bigint",
  object: "date"
}, A3 = /* @__PURE__ */ oe("$ZodCheckLessThan", (e, t) => {
  lr.init(e, t);
  const n = P3[typeof t.value];
  e._zod.onattach.push((r) => {
    const i = r._zod.bag, o = (t.inclusive ? i.maximum : i.exclusiveMaximum) ?? Number.POSITIVE_INFINITY;
    t.value < o && (t.inclusive ? i.maximum = t.value : i.exclusiveMaximum = t.value);
  }), e._zod.check = (r) => {
    (t.inclusive ? r.value <= t.value : r.value < t.value) || r.issues.push({
      origin: n,
      code: "too_big",
      maximum: typeof t.value == "object" ? t.value.getTime() : t.value,
      input: r.value,
      inclusive: t.inclusive,
      inst: e,
      continue: !t.abort
    });
  };
}), D3 = /* @__PURE__ */ oe("$ZodCheckGreaterThan", (e, t) => {
  lr.init(e, t);
  const n = P3[typeof t.value];
  e._zod.onattach.push((r) => {
    const i = r._zod.bag, o = (t.inclusive ? i.minimum : i.exclusiveMinimum) ?? Number.NEGATIVE_INFINITY;
    t.value > o && (t.inclusive ? i.minimum = t.value : i.exclusiveMinimum = t.value);
  }), e._zod.check = (r) => {
    (t.inclusive ? r.value >= t.value : r.value > t.value) || r.issues.push({
      origin: n,
      code: "too_small",
      minimum: typeof t.value == "object" ? t.value.getTime() : t.value,
      input: r.value,
      inclusive: t.inclusive,
      inst: e,
      continue: !t.abort
    });
  };
}), Ate = /* @__PURE__ */ oe("$ZodCheckMultipleOf", (e, t) => {
  lr.init(e, t), e._zod.onattach.push((n) => {
    var r;
    (r = n._zod.bag).multipleOf ?? (r.multipleOf = t.value);
  }), e._zod.check = (n) => {
    if (typeof n.value != typeof t.value)
      throw new Error("Cannot mix number and bigint in multiple_of check.");
    (typeof n.value == "bigint" ? n.value % t.value === BigInt(0) : Iee(n.value, t.value) === 0) || n.issues.push({
      origin: typeof n.value,
      code: "not_multiple_of",
      divisor: t.value,
      input: n.value,
      inst: e,
      continue: !t.abort
    });
  };
}), Dte = /* @__PURE__ */ oe("$ZodCheckNumberFormat", (e, t) => {
  var n;
  lr.init(e, t), t.format = t.format || "float64";
  const r = (n = t.format) == null ? void 0 : n.includes("int"), i = r ? "int" : "number", [o, a] = Fee[t.format];
  e._zod.onattach.push((s) => {
    const l = s._zod.bag;
    l.format = t.format, l.minimum = o, l.maximum = a, r && (l.pattern = $te);
  }), e._zod.check = (s) => {
    const l = s.value;
    if (r) {
      if (!Number.isInteger(l)) {
        s.issues.push({
          expected: i,
          format: t.format,
          code: "invalid_type",
          continue: !1,
          input: l,
          inst: e
        });
        return;
      }
      if (!Number.isSafeInteger(l)) {
        l > 0 ? s.issues.push({
          input: l,
          code: "too_big",
          maximum: Number.MAX_SAFE_INTEGER,
          note: "Integers must be within the safe integer range.",
          inst: e,
          origin: i,
          inclusive: !0,
          continue: !t.abort
        }) : s.issues.push({
          input: l,
          code: "too_small",
          minimum: Number.MIN_SAFE_INTEGER,
          note: "Integers must be within the safe integer range.",
          inst: e,
          origin: i,
          inclusive: !0,
          continue: !t.abort
        });
        return;
      }
    }
    l < o && s.issues.push({
      origin: "number",
      input: l,
      code: "too_small",
      minimum: o,
      inclusive: !0,
      inst: e,
      continue: !t.abort
    }), l > a && s.issues.push({
      origin: "number",
      input: l,
      code: "too_big",
      maximum: a,
      inclusive: !0,
      inst: e,
      continue: !t.abort
    });
  };
}), Cte = /* @__PURE__ */ oe("$ZodCheckMaxLength", (e, t) => {
  var n;
  lr.init(e, t), (n = e._zod.def).when ?? (n.when = (r) => {
    const i = r.value;
    return !H0(i) && i.length !== void 0;
  }), e._zod.onattach.push((r) => {
    const i = r._zod.bag.maximum ?? Number.POSITIVE_INFINITY;
    t.maximum < i && (r._zod.bag.maximum = t.maximum);
  }), e._zod.check = (r) => {
    const i = r.value;
    if (i.length <= t.maximum)
      return;
    const o = Z0(i);
    r.issues.push({
      origin: o,
      code: "too_big",
      maximum: t.maximum,
      inclusive: !0,
      input: i,
      inst: e,
      continue: !t.abort
    });
  };
}), Ite = /* @__PURE__ */ oe("$ZodCheckMinLength", (e, t) => {
  var n;
  lr.init(e, t), (n = e._zod.def).when ?? (n.when = (r) => {
    const i = r.value;
    return !H0(i) && i.length !== void 0;
  }), e._zod.onattach.push((r) => {
    const i = r._zod.bag.minimum ?? Number.NEGATIVE_INFINITY;
    t.minimum > i && (r._zod.bag.minimum = t.minimum);
  }), e._zod.check = (r) => {
    const i = r.value;
    if (i.length >= t.minimum)
      return;
    const o = Z0(i);
    r.issues.push({
      origin: o,
      code: "too_small",
      minimum: t.minimum,
      inclusive: !0,
      input: i,
      inst: e,
      continue: !t.abort
    });
  };
}), Mte = /* @__PURE__ */ oe("$ZodCheckLengthEquals", (e, t) => {
  var n;
  lr.init(e, t), (n = e._zod.def).when ?? (n.when = (r) => {
    const i = r.value;
    return !H0(i) && i.length !== void 0;
  }), e._zod.onattach.push((r) => {
    const i = r._zod.bag;
    i.minimum = t.length, i.maximum = t.length, i.length = t.length;
  }), e._zod.check = (r) => {
    const i = r.value, o = i.length;
    if (o === t.length)
      return;
    const a = Z0(i), s = o > t.length;
    r.issues.push({
      origin: a,
      ...s ? { code: "too_big", maximum: t.length } : { code: "too_small", minimum: t.length },
      inclusive: !0,
      exact: !0,
      input: r.value,
      inst: e,
      continue: !t.abort
    });
  };
}), nh = /* @__PURE__ */ oe("$ZodCheckStringFormat", (e, t) => {
  var n, r;
  lr.init(e, t), e._zod.onattach.push((i) => {
    const o = i._zod.bag;
    o.format = t.format, t.pattern && (o.patterns ?? (o.patterns = /* @__PURE__ */ new Set()), o.patterns.add(t.pattern));
  }), t.pattern ? (n = e._zod).check ?? (n.check = (i) => {
    t.pattern.lastIndex = 0, !t.pattern.test(i.value) && i.issues.push({
      origin: "string",
      code: "invalid_format",
      format: t.format,
      input: i.value,
      ...t.pattern ? { pattern: t.pattern.toString() } : {},
      inst: e,
      continue: !t.abort
    });
  }) : (r = e._zod).check ?? (r.check = () => {
  });
}), Rte = /* @__PURE__ */ oe("$ZodCheckRegex", (e, t) => {
  nh.init(e, t), e._zod.check = (n) => {
    t.pattern.lastIndex = 0, !t.pattern.test(n.value) && n.issues.push({
      origin: "string",
      code: "invalid_format",
      format: "regex",
      input: n.value,
      pattern: t.pattern.toString(),
      inst: e,
      continue: !t.abort
    });
  };
}), Nte = /* @__PURE__ */ oe("$ZodCheckLowerCase", (e, t) => {
  t.pattern ?? (t.pattern = Ote), nh.init(e, t);
}), jte = /* @__PURE__ */ oe("$ZodCheckUpperCase", (e, t) => {
  t.pattern ?? (t.pattern = Pte), nh.init(e, t);
}), Fte = /* @__PURE__ */ oe("$ZodCheckIncludes", (e, t) => {
  lr.init(e, t);
  const n = Xp(t.includes), r = new RegExp(typeof t.position == "number" ? `^.{${t.position}}${n}` : n);
  t.pattern = r, e._zod.onattach.push((i) => {
    const o = i._zod.bag;
    o.patterns ?? (o.patterns = /* @__PURE__ */ new Set()), o.patterns.add(r);
  }), e._zod.check = (i) => {
    i.value.includes(t.includes, t.position) || i.issues.push({
      origin: "string",
      code: "invalid_format",
      format: "includes",
      includes: t.includes,
      input: i.value,
      inst: e,
      continue: !t.abort
    });
  };
}), zte = /* @__PURE__ */ oe("$ZodCheckStartsWith", (e, t) => {
  lr.init(e, t);
  const n = new RegExp(`^${Xp(t.prefix)}.*`);
  t.pattern ?? (t.pattern = n), e._zod.onattach.push((r) => {
    const i = r._zod.bag;
    i.patterns ?? (i.patterns = /* @__PURE__ */ new Set()), i.patterns.add(n);
  }), e._zod.check = (r) => {
    r.value.startsWith(t.prefix) || r.issues.push({
      origin: "string",
      code: "invalid_format",
      format: "starts_with",
      prefix: t.prefix,
      input: r.value,
      inst: e,
      continue: !t.abort
    });
  };
}), Lte = /* @__PURE__ */ oe("$ZodCheckEndsWith", (e, t) => {
  lr.init(e, t);
  const n = new RegExp(`.*${Xp(t.suffix)}$`);
  t.pattern ?? (t.pattern = n), e._zod.onattach.push((r) => {
    const i = r._zod.bag;
    i.patterns ?? (i.patterns = /* @__PURE__ */ new Set()), i.patterns.add(n);
  }), e._zod.check = (r) => {
    r.value.endsWith(t.suffix) || r.issues.push({
      origin: "string",
      code: "invalid_format",
      format: "ends_with",
      suffix: t.suffix,
      input: r.value,
      inst: e,
      continue: !t.abort
    });
  };
}), Vte = /* @__PURE__ */ oe("$ZodCheckOverwrite", (e, t) => {
  lr.init(e, t), e._zod.check = (n) => {
    n.value = t.tx(n.value);
  };
});
class Bte {
  constructor(t = []) {
    this.content = [], this.indent = 0, this && (this.args = t);
  }
  indented(t) {
    this.indent += 1, t(this), this.indent -= 1;
  }
  write(t) {
    if (typeof t == "function") {
      t(this, { execution: "sync" }), t(this, { execution: "async" });
      return;
    }
    const n = t.split(`
`).filter((o) => o), r = Math.min(...n.map((o) => o.length - o.trimStart().length)), i = n.map((o) => o.slice(r)).map((o) => " ".repeat(this.indent * 2) + o);
    for (const o of i)
      this.content.push(o);
  }
  compile() {
    const t = Function, n = this == null ? void 0 : this.args, r = [...((this == null ? void 0 : this.content) ?? [""]).map((i) => `  ${i}`)];
    return new t(...n, r.join(`
`));
  }
}
const Kte = {
  major: 4,
  minor: 3,
  patch: 6
}, on = /* @__PURE__ */ oe("$ZodType", (e, t) => {
  var n, r;
  e ?? (e = {}), e._zod.def = t, e._zod.bag = e._zod.bag || {}, e._zod.version = Kte;
  const i = [...e._zod.def.checks ?? []];
  e._zod.traits.has("$ZodCheck") && i.unshift(e);
  for (const o of i)
    for (const a of o._zod.onattach)
      a(e);
  if (i.length === 0)
    (r = e._zod).deferred ?? (r.deferred = []), (n = e._zod.deferred) == null || n.push(() => {
      e._zod.run = e._zod.parse;
    });
  else {
    const o = (s, l, u) => {
      let c = ws(s), f;
      for (const d of l) {
        if (d._zod.def.when) {
          if (!d._zod.def.when(s))
            continue;
        } else if (c)
          continue;
        const p = s.issues.length, h = d._zod.check(s);
        if (h instanceof Promise && u?.async === !1)
          throw new As();
        if (f || h instanceof Promise)
          f = (f ?? Promise.resolve()).then(async () => {
            await h, s.issues.length !== p && (c || (c = ws(s, p)));
          });
        else {
          if (s.issues.length === p)
            continue;
          c || (c = ws(s, p));
        }
      }
      return f ? f.then(() => s) : s;
    }, a = (s, l, u) => {
      if (ws(s))
        return s.aborted = !0, s;
      const c = o(l, i, u);
      if (c instanceof Promise) {
        if (u.async === !1)
          throw new As();
        return c.then((f) => e._zod.parse(f, u));
      }
      return e._zod.parse(c, u);
    };
    e._zod.run = (s, l) => {
      if (l.skipChecks)
        return e._zod.parse(s, l);
      if (l.direction === "backward") {
        const c = e._zod.parse({ value: s.value, issues: [] }, { ...l, skipChecks: !0 });
        return c instanceof Promise ? c.then((f) => a(f, s, l)) : a(c, s, l);
      }
      const u = e._zod.parse(s, l);
      if (u instanceof Promise) {
        if (l.async === !1)
          throw new As();
        return u.then((c) => o(c, i, l));
      }
      return o(u, i, l);
    };
  }
  bt(e, "~standard", () => ({
    validate: (o) => {
      var a;
      try {
        const s = Zee(e, o);
        return s.success ? { value: s.data } : { issues: (a = s.error) == null ? void 0 : a.issues };
      } catch {
        return Gee(e, o).then((s) => {
          var l;
          return s.success ? { value: s.data } : { issues: (l = s.error) == null ? void 0 : l.issues };
        });
      }
    },
    vendor: "zod",
    version: 1
  }));
}), Q0 = /* @__PURE__ */ oe("$ZodString", (e, t) => {
  var n;
  on.init(e, t), e._zod.pattern = [...((n = e?._zod.bag) == null ? void 0 : n.patterns) ?? []].pop() ?? Ste(e._zod.bag), e._zod.parse = (r, i) => {
    if (t.coerce)
      try {
        r.value = String(r.value);
      } catch {
      }
    return typeof r.value == "string" || r.issues.push({
      expected: "string",
      code: "invalid_type",
      input: r.value,
      inst: e
    }), r;
  };
}), Kt = /* @__PURE__ */ oe("$ZodStringFormat", (e, t) => {
  nh.init(e, t), Q0.init(e, t);
}), Ute = /* @__PURE__ */ oe("$ZodGUID", (e, t) => {
  t.pattern ?? (t.pattern = fte), Kt.init(e, t);
}), qte = /* @__PURE__ */ oe("$ZodUUID", (e, t) => {
  if (t.version) {
    const n = {
      v1: 1,
      v2: 2,
      v3: 3,
      v4: 4,
      v5: 5,
      v6: 6,
      v7: 7,
      v8: 8
    }[t.version];
    if (n === void 0)
      throw new Error(`Invalid UUID version: "${t.version}"`);
    t.pattern ?? (t.pattern = $S(n));
  } else
    t.pattern ?? (t.pattern = $S());
  Kt.init(e, t);
}), Hte = /* @__PURE__ */ oe("$ZodEmail", (e, t) => {
  t.pattern ?? (t.pattern = dte), Kt.init(e, t);
}), Wte = /* @__PURE__ */ oe("$ZodURL", (e, t) => {
  Kt.init(e, t), e._zod.check = (n) => {
    try {
      const r = n.value.trim(), i = new URL(r);
      t.hostname && (t.hostname.lastIndex = 0, t.hostname.test(i.hostname) || n.issues.push({
        code: "invalid_format",
        format: "url",
        note: "Invalid hostname",
        pattern: t.hostname.source,
        input: n.value,
        inst: e,
        continue: !t.abort
      })), t.protocol && (t.protocol.lastIndex = 0, t.protocol.test(i.protocol.endsWith(":") ? i.protocol.slice(0, -1) : i.protocol) || n.issues.push({
        code: "invalid_format",
        format: "url",
        note: "Invalid protocol",
        pattern: t.protocol.source,
        input: n.value,
        inst: e,
        continue: !t.abort
      })), t.normalize ? n.value = i.href : n.value = r;
      return;
    } catch {
      n.issues.push({
        code: "invalid_format",
        format: "url",
        input: n.value,
        inst: e,
        continue: !t.abort
      });
    }
  };
}), Zte = /* @__PURE__ */ oe("$ZodEmoji", (e, t) => {
  t.pattern ?? (t.pattern = hte()), Kt.init(e, t);
}), Gte = /* @__PURE__ */ oe("$ZodNanoID", (e, t) => {
  t.pattern ?? (t.pattern = ute), Kt.init(e, t);
}), Yte = /* @__PURE__ */ oe("$ZodCUID", (e, t) => {
  t.pattern ?? (t.pattern = ite), Kt.init(e, t);
}), Qte = /* @__PURE__ */ oe("$ZodCUID2", (e, t) => {
  t.pattern ?? (t.pattern = ote), Kt.init(e, t);
}), Jte = /* @__PURE__ */ oe("$ZodULID", (e, t) => {
  t.pattern ?? (t.pattern = ate), Kt.init(e, t);
}), Xte = /* @__PURE__ */ oe("$ZodXID", (e, t) => {
  t.pattern ?? (t.pattern = ste), Kt.init(e, t);
}), ene = /* @__PURE__ */ oe("$ZodKSUID", (e, t) => {
  t.pattern ?? (t.pattern = lte), Kt.init(e, t);
}), tne = /* @__PURE__ */ oe("$ZodISODateTime", (e, t) => {
  t.pattern ?? (t.pattern = Ete(t)), Kt.init(e, t);
}), nne = /* @__PURE__ */ oe("$ZodISODate", (e, t) => {
  t.pattern ?? (t.pattern = wte), Kt.init(e, t);
}), rne = /* @__PURE__ */ oe("$ZodISOTime", (e, t) => {
  t.pattern ?? (t.pattern = xte(t)), Kt.init(e, t);
}), ine = /* @__PURE__ */ oe("$ZodISODuration", (e, t) => {
  t.pattern ?? (t.pattern = cte), Kt.init(e, t);
}), one = /* @__PURE__ */ oe("$ZodIPv4", (e, t) => {
  t.pattern ?? (t.pattern = mte), Kt.init(e, t), e._zod.bag.format = "ipv4";
}), ane = /* @__PURE__ */ oe("$ZodIPv6", (e, t) => {
  t.pattern ?? (t.pattern = vte), Kt.init(e, t), e._zod.bag.format = "ipv6", e._zod.check = (n) => {
    try {
      new URL(`http://[${n.value}]`);
    } catch {
      n.issues.push({
        code: "invalid_format",
        format: "ipv6",
        input: n.value,
        inst: e,
        continue: !t.abort
      });
    }
  };
}), sne = /* @__PURE__ */ oe("$ZodCIDRv4", (e, t) => {
  t.pattern ?? (t.pattern = gte), Kt.init(e, t);
}), lne = /* @__PURE__ */ oe("$ZodCIDRv6", (e, t) => {
  t.pattern ?? (t.pattern = yte), Kt.init(e, t), e._zod.check = (n) => {
    const r = n.value.split("/");
    try {
      if (r.length !== 2)
        throw new Error();
      const [i, o] = r;
      if (!o)
        throw new Error();
      const a = Number(o);
      if (`${a}` !== o)
        throw new Error();
      if (a < 0 || a > 128)
        throw new Error();
      new URL(`http://[${i}]`);
    } catch {
      n.issues.push({
        code: "invalid_format",
        format: "cidrv6",
        input: n.value,
        inst: e,
        continue: !t.abort
      });
    }
  };
});
function C3(e) {
  if (e === "")
    return !0;
  if (e.length % 4 !== 0)
    return !1;
  try {
    return atob(e), !0;
  } catch {
    return !1;
  }
}
const une = /* @__PURE__ */ oe("$ZodBase64", (e, t) => {
  t.pattern ?? (t.pattern = bte), Kt.init(e, t), e._zod.bag.contentEncoding = "base64", e._zod.check = (n) => {
    C3(n.value) || n.issues.push({
      code: "invalid_format",
      format: "base64",
      input: n.value,
      inst: e,
      continue: !t.abort
    });
  };
});
function cne(e) {
  if (!k3.test(e))
    return !1;
  const t = e.replace(/[-_]/g, (r) => r === "-" ? "+" : "/"), n = t.padEnd(Math.ceil(t.length / 4) * 4, "=");
  return C3(n);
}
const fne = /* @__PURE__ */ oe("$ZodBase64URL", (e, t) => {
  t.pattern ?? (t.pattern = k3), Kt.init(e, t), e._zod.bag.contentEncoding = "base64url", e._zod.check = (n) => {
    cne(n.value) || n.issues.push({
      code: "invalid_format",
      format: "base64url",
      input: n.value,
      inst: e,
      continue: !t.abort
    });
  };
}), dne = /* @__PURE__ */ oe("$ZodE164", (e, t) => {
  t.pattern ?? (t.pattern = _te), Kt.init(e, t);
});
function pne(e, t = null) {
  try {
    const n = e.split(".");
    if (n.length !== 3)
      return !1;
    const [r] = n;
    if (!r)
      return !1;
    const i = JSON.parse(atob(r));
    return !("typ" in i && i?.typ !== "JWT" || !i.alg || t && (!("alg" in i) || i.alg !== t));
  } catch {
    return !1;
  }
}
const hne = /* @__PURE__ */ oe("$ZodJWT", (e, t) => {
  Kt.init(e, t), e._zod.check = (n) => {
    pne(n.value, t.alg) || n.issues.push({
      code: "invalid_format",
      format: "jwt",
      input: n.value,
      inst: e,
      continue: !t.abort
    });
  };
}), I3 = /* @__PURE__ */ oe("$ZodNumber", (e, t) => {
  on.init(e, t), e._zod.pattern = e._zod.bag.pattern ?? kte, e._zod.parse = (n, r) => {
    if (t.coerce)
      try {
        n.value = Number(n.value);
      } catch {
      }
    const i = n.value;
    if (typeof i == "number" && !Number.isNaN(i) && Number.isFinite(i))
      return n;
    const o = typeof i == "number" ? Number.isNaN(i) ? "NaN" : Number.isFinite(i) ? void 0 : "Infinity" : void 0;
    return n.issues.push({
      expected: "number",
      code: "invalid_type",
      input: i,
      inst: e,
      ...o ? { received: o } : {}
    }), n;
  };
}), mne = /* @__PURE__ */ oe("$ZodNumberFormat", (e, t) => {
  Dte.init(e, t), I3.init(e, t);
}), vne = /* @__PURE__ */ oe("$ZodBoolean", (e, t) => {
  on.init(e, t), e._zod.pattern = Tte, e._zod.parse = (n, r) => {
    if (t.coerce)
      try {
        n.value = !!n.value;
      } catch {
      }
    const i = n.value;
    return typeof i == "boolean" || n.issues.push({
      expected: "boolean",
      code: "invalid_type",
      input: i,
      inst: e
    }), n;
  };
}), gne = /* @__PURE__ */ oe("$ZodUnknown", (e, t) => {
  on.init(e, t), e._zod.parse = (n) => n;
}), yne = /* @__PURE__ */ oe("$ZodNever", (e, t) => {
  on.init(e, t), e._zod.parse = (n, r) => (n.issues.push({
    expected: "never",
    code: "invalid_type",
    input: n.value,
    inst: e
  }), n);
});
function kS(e, t, n) {
  e.issues.length && t.issues.push(...x3(n, e.issues)), t.value[n] = e.value;
}
const bne = /* @__PURE__ */ oe("$ZodArray", (e, t) => {
  on.init(e, t), e._zod.parse = (n, r) => {
    const i = n.value;
    if (!Array.isArray(i))
      return n.issues.push({
        expected: "array",
        code: "invalid_type",
        input: i,
        inst: e
      }), n;
    n.value = Array(i.length);
    const o = [];
    for (let a = 0; a < i.length; a++) {
      const s = i[a], l = t.element._zod.run({
        value: s,
        issues: []
      }, r);
      l instanceof Promise ? o.push(l.then((u) => kS(u, n, a))) : kS(l, n, a);
    }
    return o.length ? Promise.all(o).then(() => n) : n;
  };
});
function Ud(e, t, n, r, i) {
  if (e.issues.length) {
    if (i && !(n in r))
      return;
    t.issues.push(...x3(n, e.issues));
  }
  e.value === void 0 ? n in r && (t.value[n] = void 0) : t.value[n] = e.value;
}
function M3(e) {
  var t, n, r, i;
  const o = Object.keys(e.shape);
  for (const s of o)
    if (!((i = (r = (n = (t = e.shape) == null ? void 0 : t[s]) == null ? void 0 : n._zod) == null ? void 0 : r.traits) != null && i.has("$ZodType")))
      throw new Error(`Invalid element at key "${s}": expected a Zod schema`);
  const a = jee(e.shape);
  return {
    ...e,
    keys: o,
    keySet: new Set(o),
    numKeys: o.length,
    optionalKeys: new Set(a)
  };
}
function R3(e, t, n, r, i, o) {
  const a = [], s = i.keySet, l = i.catchall._zod, u = l.def.type, c = l.optout === "optional";
  for (const f in t) {
    if (s.has(f))
      continue;
    if (u === "never") {
      a.push(f);
      continue;
    }
    const d = l.run({ value: t[f], issues: [] }, r);
    d instanceof Promise ? e.push(d.then((p) => Ud(p, n, f, t, c))) : Ud(d, n, f, t, c);
  }
  return a.length && n.issues.push({
    code: "unrecognized_keys",
    keys: a,
    input: t,
    inst: o
  }), e.length ? Promise.all(e).then(() => n) : n;
}
const _ne = /* @__PURE__ */ oe("$ZodObject", (e, t) => {
  on.init(e, t);
  const n = Object.getOwnPropertyDescriptor(t, "shape");
  if (!(n != null && n.get)) {
    const s = t.shape;
    Object.defineProperty(t, "shape", {
      get: () => {
        const l = { ...s };
        return Object.defineProperty(t, "shape", {
          value: l
        }), l;
      }
    });
  }
  const r = q0(() => M3(t));
  bt(e._zod, "propValues", () => {
    const s = t.shape, l = {};
    for (const u in s) {
      const c = s[u]._zod;
      if (c.values) {
        l[u] ?? (l[u] = /* @__PURE__ */ new Set());
        for (const f of c.values)
          l[u].add(f);
      }
    }
    return l;
  });
  const i = Kd, o = t.catchall;
  let a;
  e._zod.parse = (s, l) => {
    a ?? (a = r.value);
    const u = s.value;
    if (!i(u))
      return s.issues.push({
        expected: "object",
        code: "invalid_type",
        input: u,
        inst: e
      }), s;
    s.value = {};
    const c = [], f = a.shape;
    for (const d of a.keys) {
      const p = f[d], h = p._zod.optout === "optional", v = p._zod.run({ value: u[d], issues: [] }, l);
      v instanceof Promise ? c.push(v.then((m) => Ud(m, s, d, u, h))) : Ud(v, s, d, u, h);
    }
    return o ? R3(c, u, s, l, r.value, e) : c.length ? Promise.all(c).then(() => s) : s;
  };
}), wne = /* @__PURE__ */ oe("$ZodObjectJIT", (e, t) => {
  _ne.init(e, t);
  const n = e._zod.parse, r = q0(() => M3(t)), i = (f) => {
    var d;
    const p = new Bte(["shape", "payload", "ctx"]), h = r.value, v = (x) => {
      const w = SS(x);
      return `shape[${w}]._zod.run({ value: input[${w}], issues: [] }, ctx)`;
    };
    p.write("const input = payload.value;");
    const m = /* @__PURE__ */ Object.create(null);
    let g = 0;
    for (const x of h.keys)
      m[x] = `key_${g++}`;
    p.write("const newResult = {};");
    for (const x of h.keys) {
      const w = m[x], $ = SS(x), k = f[x], D = ((d = k?._zod) == null ? void 0 : d.optout) === "optional";
      p.write(`const ${w} = ${v(x)};`), D ? p.write(`
        if (${w}.issues.length) {
          if (${$} in input) {
            payload.issues = payload.issues.concat(${w}.issues.map(iss => ({
              ...iss,
              path: iss.path ? [${$}, ...iss.path] : [${$}]
            })));
          }
        }
        
        if (${w}.value === undefined) {
          if (${$} in input) {
            newResult[${$}] = undefined;
          }
        } else {
          newResult[${$}] = ${w}.value;
        }
        
      `) : p.write(`
        if (${w}.issues.length) {
          payload.issues = payload.issues.concat(${w}.issues.map(iss => ({
            ...iss,
            path: iss.path ? [${$}, ...iss.path] : [${$}]
          })));
        }
        
        if (${w}.value === undefined) {
          if (${$} in input) {
            newResult[${$}] = undefined;
          }
        } else {
          newResult[${$}] = ${w}.value;
        }
        
      `);
    }
    p.write("payload.value = newResult;"), p.write("return payload;");
    const _ = p.compile();
    return (x, w) => _(f, x, w);
  };
  let o;
  const a = Kd, s = !y3.jitless, l = s && Ree.value, u = t.catchall;
  let c;
  e._zod.parse = (f, d) => {
    c ?? (c = r.value);
    const p = f.value;
    return a(p) ? s && l && d?.async === !1 && d.jitless !== !0 ? (o || (o = i(t.shape)), f = o(f, d), u ? R3([], p, f, d, c, e) : f) : n(f, d) : (f.issues.push({
      expected: "object",
      code: "invalid_type",
      input: p,
      inst: e
    }), f);
  };
});
function TS(e, t, n, r) {
  for (const o of e)
    if (o.issues.length === 0)
      return t.value = o.value, t;
  const i = e.filter((o) => !ws(o));
  return i.length === 1 ? (t.value = i[0].value, i[0]) : (t.issues.push({
    code: "invalid_union",
    input: t.value,
    inst: n,
    errors: e.map((o) => o.issues.map((a) => Ma(a, r, Ia())))
  }), t);
}
const xne = /* @__PURE__ */ oe("$ZodUnion", (e, t) => {
  on.init(e, t), bt(e._zod, "optin", () => t.options.some((i) => i._zod.optin === "optional") ? "optional" : void 0), bt(e._zod, "optout", () => t.options.some((i) => i._zod.optout === "optional") ? "optional" : void 0), bt(e._zod, "values", () => {
    if (t.options.every((i) => i._zod.values))
      return new Set(t.options.flatMap((i) => Array.from(i._zod.values)));
  }), bt(e._zod, "pattern", () => {
    if (t.options.every((i) => i._zod.pattern)) {
      const i = t.options.map((o) => o._zod.pattern);
      return new RegExp(`^(${i.map((o) => W0(o.source)).join("|")})$`);
    }
  });
  const n = t.options.length === 1, r = t.options[0]._zod.run;
  e._zod.parse = (i, o) => {
    if (n)
      return r(i, o);
    let a = !1;
    const s = [];
    for (const l of t.options) {
      const u = l._zod.run({
        value: i.value,
        issues: []
      }, o);
      if (u instanceof Promise)
        s.push(u), a = !0;
      else {
        if (u.issues.length === 0)
          return u;
        s.push(u);
      }
    }
    return a ? Promise.all(s).then((l) => TS(l, i, e, o)) : TS(s, i, e, o);
  };
}), Ene = /* @__PURE__ */ oe("$ZodIntersection", (e, t) => {
  on.init(e, t), e._zod.parse = (n, r) => {
    const i = n.value, o = t.left._zod.run({ value: i, issues: [] }, r), a = t.right._zod.run({ value: i, issues: [] }, r);
    return o instanceof Promise || a instanceof Promise ? Promise.all([o, a]).then(([s, l]) => OS(n, s, l)) : OS(n, o, a);
  };
});
function ry(e, t) {
  if (e === t)
    return { valid: !0, data: e };
  if (e instanceof Date && t instanceof Date && +e == +t)
    return { valid: !0, data: e };
  if (Wu(e) && Wu(t)) {
    const n = Object.keys(t), r = Object.keys(e).filter((o) => n.indexOf(o) !== -1), i = { ...e, ...t };
    for (const o of r) {
      const a = ry(e[o], t[o]);
      if (!a.valid)
        return {
          valid: !1,
          mergeErrorPath: [o, ...a.mergeErrorPath]
        };
      i[o] = a.data;
    }
    return { valid: !0, data: i };
  }
  if (Array.isArray(e) && Array.isArray(t)) {
    if (e.length !== t.length)
      return { valid: !1, mergeErrorPath: [] };
    const n = [];
    for (let r = 0; r < e.length; r++) {
      const i = e[r], o = t[r], a = ry(i, o);
      if (!a.valid)
        return {
          valid: !1,
          mergeErrorPath: [r, ...a.mergeErrorPath]
        };
      n.push(a.data);
    }
    return { valid: !0, data: n };
  }
  return { valid: !1, mergeErrorPath: [] };
}
function OS(e, t, n) {
  const r = /* @__PURE__ */ new Map();
  let i;
  for (const s of t.issues)
    if (s.code === "unrecognized_keys") {
      i ?? (i = s);
      for (const l of s.keys)
        r.has(l) || r.set(l, {}), r.get(l).l = !0;
    } else
      e.issues.push(s);
  for (const s of n.issues)
    if (s.code === "unrecognized_keys")
      for (const l of s.keys)
        r.has(l) || r.set(l, {}), r.get(l).r = !0;
    else
      e.issues.push(s);
  const o = [...r].filter(([, s]) => s.l && s.r).map(([s]) => s);
  if (o.length && i && e.issues.push({ ...i, keys: o }), ws(e))
    return e;
  const a = ry(t.value, n.value);
  if (!a.valid)
    throw new Error(`Unmergable intersection. Error path: ${JSON.stringify(a.mergeErrorPath)}`);
  return e.value = a.data, e;
}
const Sne = /* @__PURE__ */ oe("$ZodEnum", (e, t) => {
  on.init(e, t);
  const n = b3(t.entries), r = new Set(n);
  e._zod.values = r, e._zod.pattern = new RegExp(`^(${n.filter((i) => Nee.has(typeof i)).map((i) => typeof i == "string" ? Xp(i) : i.toString()).join("|")})$`), e._zod.parse = (i, o) => {
    const a = i.value;
    return r.has(a) || i.issues.push({
      code: "invalid_value",
      values: n,
      input: a,
      inst: e
    }), i;
  };
}), $ne = /* @__PURE__ */ oe("$ZodTransform", (e, t) => {
  on.init(e, t), e._zod.parse = (n, r) => {
    if (r.direction === "backward")
      throw new g3(e.constructor.name);
    const i = t.transform(n.value, n);
    if (r.async)
      return (i instanceof Promise ? i : Promise.resolve(i)).then((o) => (n.value = o, n));
    if (i instanceof Promise)
      throw new As();
    return n.value = i, n;
  };
});
function PS(e, t) {
  return e.issues.length && t === void 0 ? { issues: [], value: void 0 } : e;
}
const N3 = /* @__PURE__ */ oe("$ZodOptional", (e, t) => {
  on.init(e, t), e._zod.optin = "optional", e._zod.optout = "optional", bt(e._zod, "values", () => t.innerType._zod.values ? /* @__PURE__ */ new Set([...t.innerType._zod.values, void 0]) : void 0), bt(e._zod, "pattern", () => {
    const n = t.innerType._zod.pattern;
    return n ? new RegExp(`^(${W0(n.source)})?$`) : void 0;
  }), e._zod.parse = (n, r) => {
    if (t.innerType._zod.optin === "optional") {
      const i = t.innerType._zod.run(n, r);
      return i instanceof Promise ? i.then((o) => PS(o, n.value)) : PS(i, n.value);
    }
    return n.value === void 0 ? n : t.innerType._zod.run(n, r);
  };
}), kne = /* @__PURE__ */ oe("$ZodExactOptional", (e, t) => {
  N3.init(e, t), bt(e._zod, "values", () => t.innerType._zod.values), bt(e._zod, "pattern", () => t.innerType._zod.pattern), e._zod.parse = (n, r) => t.innerType._zod.run(n, r);
}), Tne = /* @__PURE__ */ oe("$ZodNullable", (e, t) => {
  on.init(e, t), bt(e._zod, "optin", () => t.innerType._zod.optin), bt(e._zod, "optout", () => t.innerType._zod.optout), bt(e._zod, "pattern", () => {
    const n = t.innerType._zod.pattern;
    return n ? new RegExp(`^(${W0(n.source)}|null)$`) : void 0;
  }), bt(e._zod, "values", () => t.innerType._zod.values ? /* @__PURE__ */ new Set([...t.innerType._zod.values, null]) : void 0), e._zod.parse = (n, r) => n.value === null ? n : t.innerType._zod.run(n, r);
}), One = /* @__PURE__ */ oe("$ZodDefault", (e, t) => {
  on.init(e, t), e._zod.optin = "optional", bt(e._zod, "values", () => t.innerType._zod.values), e._zod.parse = (n, r) => {
    if (r.direction === "backward")
      return t.innerType._zod.run(n, r);
    if (n.value === void 0)
      return n.value = t.defaultValue, n;
    const i = t.innerType._zod.run(n, r);
    return i instanceof Promise ? i.then((o) => AS(o, t)) : AS(i, t);
  };
});
function AS(e, t) {
  return e.value === void 0 && (e.value = t.defaultValue), e;
}
const Pne = /* @__PURE__ */ oe("$ZodPrefault", (e, t) => {
  on.init(e, t), e._zod.optin = "optional", bt(e._zod, "values", () => t.innerType._zod.values), e._zod.parse = (n, r) => (r.direction === "backward" || n.value === void 0 && (n.value = t.defaultValue), t.innerType._zod.run(n, r));
}), Ane = /* @__PURE__ */ oe("$ZodNonOptional", (e, t) => {
  on.init(e, t), bt(e._zod, "values", () => {
    const n = t.innerType._zod.values;
    return n ? new Set([...n].filter((r) => r !== void 0)) : void 0;
  }), e._zod.parse = (n, r) => {
    const i = t.innerType._zod.run(n, r);
    return i instanceof Promise ? i.then((o) => DS(o, e)) : DS(i, e);
  };
});
function DS(e, t) {
  return !e.issues.length && e.value === void 0 && e.issues.push({
    code: "invalid_type",
    expected: "nonoptional",
    input: e.value,
    inst: t
  }), e;
}
const Dne = /* @__PURE__ */ oe("$ZodCatch", (e, t) => {
  on.init(e, t), bt(e._zod, "optin", () => t.innerType._zod.optin), bt(e._zod, "optout", () => t.innerType._zod.optout), bt(e._zod, "values", () => t.innerType._zod.values), e._zod.parse = (n, r) => {
    if (r.direction === "backward")
      return t.innerType._zod.run(n, r);
    const i = t.innerType._zod.run(n, r);
    return i instanceof Promise ? i.then((o) => (n.value = o.value, o.issues.length && (n.value = t.catchValue({
      ...n,
      error: {
        issues: o.issues.map((a) => Ma(a, r, Ia()))
      },
      input: n.value
    }), n.issues = []), n)) : (n.value = i.value, i.issues.length && (n.value = t.catchValue({
      ...n,
      error: {
        issues: i.issues.map((o) => Ma(o, r, Ia()))
      },
      input: n.value
    }), n.issues = []), n);
  };
}), Cne = /* @__PURE__ */ oe("$ZodPipe", (e, t) => {
  on.init(e, t), bt(e._zod, "values", () => t.in._zod.values), bt(e._zod, "optin", () => t.in._zod.optin), bt(e._zod, "optout", () => t.out._zod.optout), bt(e._zod, "propValues", () => t.in._zod.propValues), e._zod.parse = (n, r) => {
    if (r.direction === "backward") {
      const o = t.out._zod.run(n, r);
      return o instanceof Promise ? o.then((a) => sf(a, t.in, r)) : sf(o, t.in, r);
    }
    const i = t.in._zod.run(n, r);
    return i instanceof Promise ? i.then((o) => sf(o, t.out, r)) : sf(i, t.out, r);
  };
});
function sf(e, t, n) {
  return e.issues.length ? (e.aborted = !0, e) : t._zod.run({ value: e.value, issues: e.issues }, n);
}
const Ine = /* @__PURE__ */ oe("$ZodReadonly", (e, t) => {
  on.init(e, t), bt(e._zod, "propValues", () => t.innerType._zod.propValues), bt(e._zod, "values", () => t.innerType._zod.values), bt(e._zod, "optin", () => {
    var n, r;
    return (r = (n = t.innerType) == null ? void 0 : n._zod) == null ? void 0 : r.optin;
  }), bt(e._zod, "optout", () => {
    var n, r;
    return (r = (n = t.innerType) == null ? void 0 : n._zod) == null ? void 0 : r.optout;
  }), e._zod.parse = (n, r) => {
    if (r.direction === "backward")
      return t.innerType._zod.run(n, r);
    const i = t.innerType._zod.run(n, r);
    return i instanceof Promise ? i.then(CS) : CS(i);
  };
});
function CS(e) {
  return e.value = Object.freeze(e.value), e;
}
const Mne = /* @__PURE__ */ oe("$ZodCustom", (e, t) => {
  lr.init(e, t), on.init(e, t), e._zod.parse = (n, r) => n, e._zod.check = (n) => {
    const r = n.value, i = t.fn(r);
    if (i instanceof Promise)
      return i.then((o) => IS(o, n, r, e));
    IS(i, n, r, e);
  };
});
function IS(e, t, n, r) {
  if (!e) {
    const i = {
      code: "custom",
      input: n,
      inst: r,
      // incorporates params.error into issue reporting
      path: [...r._zod.def.path ?? []],
      // incorporates params.error into issue reporting
      continue: !r._zod.def.abort
      // params: inst._zod.def.params,
    };
    r._zod.def.params && (i.params = r._zod.def.params), t.issues.push(Zu(i));
  }
}
var MS;
class Rne {
  constructor() {
    this._map = /* @__PURE__ */ new WeakMap(), this._idmap = /* @__PURE__ */ new Map();
  }
  add(t, ...n) {
    const r = n[0];
    return this._map.set(t, r), r && typeof r == "object" && "id" in r && this._idmap.set(r.id, t), this;
  }
  clear() {
    return this._map = /* @__PURE__ */ new WeakMap(), this._idmap = /* @__PURE__ */ new Map(), this;
  }
  remove(t) {
    const n = this._map.get(t);
    return n && typeof n == "object" && "id" in n && this._idmap.delete(n.id), this._map.delete(t), this;
  }
  get(t) {
    const n = t._zod.parent;
    if (n) {
      const r = { ...this.get(n) ?? {} };
      delete r.id;
      const i = { ...r, ...this._map.get(t) };
      return Object.keys(i).length ? i : void 0;
    }
    return this._map.get(t);
  }
  has(t) {
    return this._map.has(t);
  }
}
function Nne() {
  return new Rne();
}
(MS = globalThis).__zod_globalRegistry ?? (MS.__zod_globalRegistry = Nne());
const nu = globalThis.__zod_globalRegistry;
// @__NO_SIDE_EFFECTS__
function jne(e, t) {
  return new e({
    type: "string",
    ...qe(t)
  });
}
// @__NO_SIDE_EFFECTS__
function Fne(e, t) {
  return new e({
    type: "string",
    format: "email",
    check: "string_format",
    abort: !1,
    ...qe(t)
  });
}
// @__NO_SIDE_EFFECTS__
function RS(e, t) {
  return new e({
    type: "string",
    format: "guid",
    check: "string_format",
    abort: !1,
    ...qe(t)
  });
}
// @__NO_SIDE_EFFECTS__
function zne(e, t) {
  return new e({
    type: "string",
    format: "uuid",
    check: "string_format",
    abort: !1,
    ...qe(t)
  });
}
// @__NO_SIDE_EFFECTS__
function Lne(e, t) {
  return new e({
    type: "string",
    format: "uuid",
    check: "string_format",
    abort: !1,
    version: "v4",
    ...qe(t)
  });
}
// @__NO_SIDE_EFFECTS__
function Vne(e, t) {
  return new e({
    type: "string",
    format: "uuid",
    check: "string_format",
    abort: !1,
    version: "v6",
    ...qe(t)
  });
}
// @__NO_SIDE_EFFECTS__
function Bne(e, t) {
  return new e({
    type: "string",
    format: "uuid",
    check: "string_format",
    abort: !1,
    version: "v7",
    ...qe(t)
  });
}
// @__NO_SIDE_EFFECTS__
function Kne(e, t) {
  return new e({
    type: "string",
    format: "url",
    check: "string_format",
    abort: !1,
    ...qe(t)
  });
}
// @__NO_SIDE_EFFECTS__
function Une(e, t) {
  return new e({
    type: "string",
    format: "emoji",
    check: "string_format",
    abort: !1,
    ...qe(t)
  });
}
// @__NO_SIDE_EFFECTS__
function qne(e, t) {
  return new e({
    type: "string",
    format: "nanoid",
    check: "string_format",
    abort: !1,
    ...qe(t)
  });
}
// @__NO_SIDE_EFFECTS__
function Hne(e, t) {
  return new e({
    type: "string",
    format: "cuid",
    check: "string_format",
    abort: !1,
    ...qe(t)
  });
}
// @__NO_SIDE_EFFECTS__
function Wne(e, t) {
  return new e({
    type: "string",
    format: "cuid2",
    check: "string_format",
    abort: !1,
    ...qe(t)
  });
}
// @__NO_SIDE_EFFECTS__
function Zne(e, t) {
  return new e({
    type: "string",
    format: "ulid",
    check: "string_format",
    abort: !1,
    ...qe(t)
  });
}
// @__NO_SIDE_EFFECTS__
function Gne(e, t) {
  return new e({
    type: "string",
    format: "xid",
    check: "string_format",
    abort: !1,
    ...qe(t)
  });
}
// @__NO_SIDE_EFFECTS__
function Yne(e, t) {
  return new e({
    type: "string",
    format: "ksuid",
    check: "string_format",
    abort: !1,
    ...qe(t)
  });
}
// @__NO_SIDE_EFFECTS__
function Qne(e, t) {
  return new e({
    type: "string",
    format: "ipv4",
    check: "string_format",
    abort: !1,
    ...qe(t)
  });
}
// @__NO_SIDE_EFFECTS__
function Jne(e, t) {
  return new e({
    type: "string",
    format: "ipv6",
    check: "string_format",
    abort: !1,
    ...qe(t)
  });
}
// @__NO_SIDE_EFFECTS__
function Xne(e, t) {
  return new e({
    type: "string",
    format: "cidrv4",
    check: "string_format",
    abort: !1,
    ...qe(t)
  });
}
// @__NO_SIDE_EFFECTS__
function ere(e, t) {
  return new e({
    type: "string",
    format: "cidrv6",
    check: "string_format",
    abort: !1,
    ...qe(t)
  });
}
// @__NO_SIDE_EFFECTS__
function tre(e, t) {
  return new e({
    type: "string",
    format: "base64",
    check: "string_format",
    abort: !1,
    ...qe(t)
  });
}
// @__NO_SIDE_EFFECTS__
function nre(e, t) {
  return new e({
    type: "string",
    format: "base64url",
    check: "string_format",
    abort: !1,
    ...qe(t)
  });
}
// @__NO_SIDE_EFFECTS__
function rre(e, t) {
  return new e({
    type: "string",
    format: "e164",
    check: "string_format",
    abort: !1,
    ...qe(t)
  });
}
// @__NO_SIDE_EFFECTS__
function ire(e, t) {
  return new e({
    type: "string",
    format: "jwt",
    check: "string_format",
    abort: !1,
    ...qe(t)
  });
}
// @__NO_SIDE_EFFECTS__
function ore(e, t) {
  return new e({
    type: "string",
    format: "datetime",
    check: "string_format",
    offset: !1,
    local: !1,
    precision: null,
    ...qe(t)
  });
}
// @__NO_SIDE_EFFECTS__
function are(e, t) {
  return new e({
    type: "string",
    format: "date",
    check: "string_format",
    ...qe(t)
  });
}
// @__NO_SIDE_EFFECTS__
function sre(e, t) {
  return new e({
    type: "string",
    format: "time",
    check: "string_format",
    precision: null,
    ...qe(t)
  });
}
// @__NO_SIDE_EFFECTS__
function lre(e, t) {
  return new e({
    type: "string",
    format: "duration",
    check: "string_format",
    ...qe(t)
  });
}
// @__NO_SIDE_EFFECTS__
function ure(e, t) {
  return new e({
    type: "number",
    checks: [],
    ...qe(t)
  });
}
// @__NO_SIDE_EFFECTS__
function cre(e, t) {
  return new e({
    type: "number",
    check: "number_format",
    abort: !1,
    format: "safeint",
    ...qe(t)
  });
}
// @__NO_SIDE_EFFECTS__
function fre(e, t) {
  return new e({
    type: "boolean",
    ...qe(t)
  });
}
// @__NO_SIDE_EFFECTS__
function dre(e) {
  return new e({
    type: "unknown"
  });
}
// @__NO_SIDE_EFFECTS__
function pre(e, t) {
  return new e({
    type: "never",
    ...qe(t)
  });
}
// @__NO_SIDE_EFFECTS__
function NS(e, t) {
  return new A3({
    check: "less_than",
    ...qe(t),
    value: e,
    inclusive: !1
  });
}
// @__NO_SIDE_EFFECTS__
function Rm(e, t) {
  return new A3({
    check: "less_than",
    ...qe(t),
    value: e,
    inclusive: !0
  });
}
// @__NO_SIDE_EFFECTS__
function jS(e, t) {
  return new D3({
    check: "greater_than",
    ...qe(t),
    value: e,
    inclusive: !1
  });
}
// @__NO_SIDE_EFFECTS__
function Nm(e, t) {
  return new D3({
    check: "greater_than",
    ...qe(t),
    value: e,
    inclusive: !0
  });
}
// @__NO_SIDE_EFFECTS__
function FS(e, t) {
  return new Ate({
    check: "multiple_of",
    ...qe(t),
    value: e
  });
}
// @__NO_SIDE_EFFECTS__
function j3(e, t) {
  return new Cte({
    check: "max_length",
    ...qe(t),
    maximum: e
  });
}
// @__NO_SIDE_EFFECTS__
function qd(e, t) {
  return new Ite({
    check: "min_length",
    ...qe(t),
    minimum: e
  });
}
// @__NO_SIDE_EFFECTS__
function F3(e, t) {
  return new Mte({
    check: "length_equals",
    ...qe(t),
    length: e
  });
}
// @__NO_SIDE_EFFECTS__
function hre(e, t) {
  return new Rte({
    check: "string_format",
    format: "regex",
    ...qe(t),
    pattern: e
  });
}
// @__NO_SIDE_EFFECTS__
function mre(e) {
  return new Nte({
    check: "string_format",
    format: "lowercase",
    ...qe(e)
  });
}
// @__NO_SIDE_EFFECTS__
function vre(e) {
  return new jte({
    check: "string_format",
    format: "uppercase",
    ...qe(e)
  });
}
// @__NO_SIDE_EFFECTS__
function gre(e, t) {
  return new Fte({
    check: "string_format",
    format: "includes",
    ...qe(t),
    includes: e
  });
}
// @__NO_SIDE_EFFECTS__
function yre(e, t) {
  return new zte({
    check: "string_format",
    format: "starts_with",
    ...qe(t),
    prefix: e
  });
}
// @__NO_SIDE_EFFECTS__
function bre(e, t) {
  return new Lte({
    check: "string_format",
    format: "ends_with",
    ...qe(t),
    suffix: e
  });
}
// @__NO_SIDE_EFFECTS__
function kl(e) {
  return new Vte({
    check: "overwrite",
    tx: e
  });
}
// @__NO_SIDE_EFFECTS__
function _re(e) {
  return /* @__PURE__ */ kl((t) => t.normalize(e));
}
// @__NO_SIDE_EFFECTS__
function wre() {
  return /* @__PURE__ */ kl((e) => e.trim());
}
// @__NO_SIDE_EFFECTS__
function xre() {
  return /* @__PURE__ */ kl((e) => e.toLowerCase());
}
// @__NO_SIDE_EFFECTS__
function Ere() {
  return /* @__PURE__ */ kl((e) => e.toUpperCase());
}
// @__NO_SIDE_EFFECTS__
function Sre() {
  return /* @__PURE__ */ kl((e) => Mee(e));
}
// @__NO_SIDE_EFFECTS__
function $re(e, t, n) {
  return new e({
    type: "array",
    element: t,
    // get element() {
    //   return element;
    // },
    ...qe(n)
  });
}
// @__NO_SIDE_EFFECTS__
function kre(e, t, n) {
  return new e({
    type: "custom",
    check: "custom",
    fn: t,
    ...qe(n)
  });
}
// @__NO_SIDE_EFFECTS__
function Tre(e) {
  const t = /* @__PURE__ */ Ore((n) => (n.addIssue = (r) => {
    if (typeof r == "string")
      n.issues.push(Zu(r, n.value, t._zod.def));
    else {
      const i = r;
      i.fatal && (i.continue = !1), i.code ?? (i.code = "custom"), i.input ?? (i.input = n.value), i.inst ?? (i.inst = t), i.continue ?? (i.continue = !t._zod.def.abort), n.issues.push(Zu(i));
    }
  }, e(n.value, n)));
  return t;
}
// @__NO_SIDE_EFFECTS__
function Ore(e, t) {
  const n = new lr({
    check: "custom",
    ...qe(t)
  });
  return n._zod.check = e, n;
}
function z3(e) {
  let t = e?.target ?? "draft-2020-12";
  return t === "draft-4" && (t = "draft-04"), t === "draft-7" && (t = "draft-07"), {
    processors: e.processors ?? {},
    metadataRegistry: e?.metadata ?? nu,
    target: t,
    unrepresentable: e?.unrepresentable ?? "throw",
    override: e?.override ?? (() => {
    }),
    io: e?.io ?? "output",
    counter: 0,
    seen: /* @__PURE__ */ new Map(),
    cycles: e?.cycles ?? "ref",
    reused: e?.reused ?? "inline",
    external: e?.external ?? void 0
  };
}
function An(e, t, n = { path: [], schemaPath: [] }) {
  var r, i, o;
  const a = e._zod.def, s = t.seen.get(e);
  if (s)
    return s.count++, n.schemaPath.includes(e) && (s.cycle = n.path), s.schema;
  const l = { schema: {}, count: 1, cycle: void 0, path: n.path };
  t.seen.set(e, l);
  const u = (i = (r = e._zod).toJSONSchema) == null ? void 0 : i.call(r);
  if (u)
    l.schema = u;
  else {
    const f = {
      ...n,
      schemaPath: [...n.schemaPath, e],
      path: n.path
    };
    if (e._zod.processJSONSchema)
      e._zod.processJSONSchema(t, l.schema, f);
    else {
      const p = l.schema, h = t.processors[a.type];
      if (!h)
        throw new Error(`[toJSONSchema]: Non-representable type encountered: ${a.type}`);
      h(e, t, p, f);
    }
    const d = e._zod.parent;
    d && (l.ref || (l.ref = d), An(d, t, f), t.seen.get(d).isParent = !0);
  }
  const c = t.metadataRegistry.get(e);
  return c && Object.assign(l.schema, c), t.io === "input" && Ln(e) && (delete l.schema.examples, delete l.schema.default), t.io === "input" && l.schema._prefault && ((o = l.schema).default ?? (o.default = l.schema._prefault)), delete l.schema._prefault, t.seen.get(e).schema;
}
function L3(e, t) {
  var n, r, i, o;
  const a = e.seen.get(t);
  if (!a)
    throw new Error("Unprocessed schema. This is a bug in Zod.");
  const s = /* @__PURE__ */ new Map();
  for (const c of e.seen.entries()) {
    const f = (n = e.metadataRegistry.get(c[0])) == null ? void 0 : n.id;
    if (f) {
      const d = s.get(f);
      if (d && d !== c[0])
        throw new Error(`Duplicate schema id "${f}" detected during JSON Schema conversion. Two different schemas cannot share the same id when converted together.`);
      s.set(f, c[0]);
    }
  }
  const l = (c) => {
    var f;
    const d = e.target === "draft-2020-12" ? "$defs" : "definitions";
    if (e.external) {
      const v = (f = e.external.registry.get(c[0])) == null ? void 0 : f.id, m = e.external.uri ?? ((_) => _);
      if (v)
        return { ref: m(v) };
      const g = c[1].defId ?? c[1].schema.id ?? `schema${e.counter++}`;
      return c[1].defId = g, { defId: g, ref: `${m("__shared")}#/${d}/${g}` };
    }
    if (c[1] === a)
      return { ref: "#" };
    const p = `#/${d}/`, h = c[1].schema.id ?? `__schema${e.counter++}`;
    return { defId: h, ref: p + h };
  }, u = (c) => {
    if (c[1].schema.$ref)
      return;
    const f = c[1], { ref: d, defId: p } = l(c);
    f.def = { ...f.schema }, p && (f.defId = p);
    const h = f.schema;
    for (const v in h)
      delete h[v];
    h.$ref = d;
  };
  if (e.cycles === "throw")
    for (const c of e.seen.entries()) {
      const f = c[1];
      if (f.cycle)
        throw new Error(`Cycle detected: #/${(r = f.cycle) == null ? void 0 : r.join("/")}/<root>

Set the \`cycles\` parameter to \`"ref"\` to resolve cyclical schemas with defs.`);
    }
  for (const c of e.seen.entries()) {
    const f = c[1];
    if (t === c[0]) {
      u(c);
      continue;
    }
    if (e.external) {
      const d = (i = e.external.registry.get(c[0])) == null ? void 0 : i.id;
      if (t !== c[0] && d) {
        u(c);
        continue;
      }
    }
    if ((o = e.metadataRegistry.get(c[0])) != null && o.id) {
      u(c);
      continue;
    }
    if (f.cycle) {
      u(c);
      continue;
    }
    if (f.count > 1 && e.reused === "ref") {
      u(c);
      continue;
    }
  }
}
function V3(e, t) {
  var n, r, i;
  const o = e.seen.get(t);
  if (!o)
    throw new Error("Unprocessed schema. This is a bug in Zod.");
  const a = (u) => {
    const c = e.seen.get(u);
    if (c.ref === null)
      return;
    const f = c.def ?? c.schema, d = { ...f }, p = c.ref;
    if (c.ref = null, p) {
      a(p);
      const v = e.seen.get(p), m = v.schema;
      if (m.$ref && (e.target === "draft-07" || e.target === "draft-04" || e.target === "openapi-3.0") ? (f.allOf = f.allOf ?? [], f.allOf.push(m)) : Object.assign(f, m), Object.assign(f, d), u._zod.parent === p)
        for (const g in f)
          g === "$ref" || g === "allOf" || g in d || delete f[g];
      if (m.$ref && v.def)
        for (const g in f)
          g === "$ref" || g === "allOf" || g in v.def && JSON.stringify(f[g]) === JSON.stringify(v.def[g]) && delete f[g];
    }
    const h = u._zod.parent;
    if (h && h !== p) {
      a(h);
      const v = e.seen.get(h);
      if (v != null && v.schema.$ref && (f.$ref = v.schema.$ref, v.def))
        for (const m in f)
          m === "$ref" || m === "allOf" || m in v.def && JSON.stringify(f[m]) === JSON.stringify(v.def[m]) && delete f[m];
    }
    e.override({
      zodSchema: u,
      jsonSchema: f,
      path: c.path ?? []
    });
  };
  for (const u of [...e.seen.entries()].reverse())
    a(u[0]);
  const s = {};
  if (e.target === "draft-2020-12" ? s.$schema = "https://json-schema.org/draft/2020-12/schema" : e.target === "draft-07" ? s.$schema = "http://json-schema.org/draft-07/schema#" : e.target === "draft-04" ? s.$schema = "http://json-schema.org/draft-04/schema#" : e.target, (n = e.external) != null && n.uri) {
    const u = (r = e.external.registry.get(t)) == null ? void 0 : r.id;
    if (!u)
      throw new Error("Schema is missing an `id` property");
    s.$id = e.external.uri(u);
  }
  Object.assign(s, o.def ?? o.schema);
  const l = ((i = e.external) == null ? void 0 : i.defs) ?? {};
  for (const u of e.seen.entries()) {
    const c = u[1];
    c.def && c.defId && (l[c.defId] = c.def);
  }
  e.external || Object.keys(l).length > 0 && (e.target === "draft-2020-12" ? s.$defs = l : s.definitions = l);
  try {
    const u = JSON.parse(JSON.stringify(s));
    return Object.defineProperty(u, "~standard", {
      value: {
        ...t["~standard"],
        jsonSchema: {
          input: Hd(t, "input", e.processors),
          output: Hd(t, "output", e.processors)
        }
      },
      enumerable: !1,
      writable: !1
    }), u;
  } catch {
    throw new Error("Error converting schema to JSON.");
  }
}
function Ln(e, t) {
  const n = t ?? { seen: /* @__PURE__ */ new Set() };
  if (n.seen.has(e))
    return !1;
  n.seen.add(e);
  const r = e._zod.def;
  if (r.type === "transform")
    return !0;
  if (r.type === "array")
    return Ln(r.element, n);
  if (r.type === "set")
    return Ln(r.valueType, n);
  if (r.type === "lazy")
    return Ln(r.getter(), n);
  if (r.type === "promise" || r.type === "optional" || r.type === "nonoptional" || r.type === "nullable" || r.type === "readonly" || r.type === "default" || r.type === "prefault")
    return Ln(r.innerType, n);
  if (r.type === "intersection")
    return Ln(r.left, n) || Ln(r.right, n);
  if (r.type === "record" || r.type === "map")
    return Ln(r.keyType, n) || Ln(r.valueType, n);
  if (r.type === "pipe")
    return Ln(r.in, n) || Ln(r.out, n);
  if (r.type === "object") {
    for (const i in r.shape)
      if (Ln(r.shape[i], n))
        return !0;
    return !1;
  }
  if (r.type === "union") {
    for (const i of r.options)
      if (Ln(i, n))
        return !0;
    return !1;
  }
  if (r.type === "tuple") {
    for (const i of r.items)
      if (Ln(i, n))
        return !0;
    return !!(r.rest && Ln(r.rest, n));
  }
  return !1;
}
const Pre = (e, t = {}) => (n) => {
  const r = z3({ ...n, processors: t });
  return An(e, r), L3(r, e), V3(r, e);
}, Hd = (e, t, n = {}) => (r) => {
  const { libraryOptions: i, target: o } = r ?? {}, a = z3({ ...i ?? {}, target: o, io: t, processors: n });
  return An(e, a), L3(a, e), V3(a, e);
}, Are = {
  guid: "uuid",
  url: "uri",
  datetime: "date-time",
  json_string: "json-string",
  regex: ""
  // do not set
}, Dre = (e, t, n, r) => {
  const i = n;
  i.type = "string";
  const { minimum: o, maximum: a, format: s, patterns: l, contentEncoding: u } = e._zod.bag;
  if (typeof o == "number" && (i.minLength = o), typeof a == "number" && (i.maxLength = a), s && (i.format = Are[s] ?? s, i.format === "" && delete i.format, s === "time" && delete i.format), u && (i.contentEncoding = u), l && l.size > 0) {
    const c = [...l];
    c.length === 1 ? i.pattern = c[0].source : c.length > 1 && (i.allOf = [
      ...c.map((f) => ({
        ...t.target === "draft-07" || t.target === "draft-04" || t.target === "openapi-3.0" ? { type: "string" } : {},
        pattern: f.source
      }))
    ]);
  }
}, Cre = (e, t, n, r) => {
  const i = n, { minimum: o, maximum: a, format: s, multipleOf: l, exclusiveMaximum: u, exclusiveMinimum: c } = e._zod.bag;
  typeof s == "string" && s.includes("int") ? i.type = "integer" : i.type = "number", typeof c == "number" && (t.target === "draft-04" || t.target === "openapi-3.0" ? (i.minimum = c, i.exclusiveMinimum = !0) : i.exclusiveMinimum = c), typeof o == "number" && (i.minimum = o, typeof c == "number" && t.target !== "draft-04" && (c >= o ? delete i.minimum : delete i.exclusiveMinimum)), typeof u == "number" && (t.target === "draft-04" || t.target === "openapi-3.0" ? (i.maximum = u, i.exclusiveMaximum = !0) : i.exclusiveMaximum = u), typeof a == "number" && (i.maximum = a, typeof u == "number" && t.target !== "draft-04" && (u <= a ? delete i.maximum : delete i.exclusiveMaximum)), typeof l == "number" && (i.multipleOf = l);
}, Ire = (e, t, n, r) => {
  n.type = "boolean";
}, Mre = (e, t, n, r) => {
  n.not = {};
}, Rre = (e, t, n, r) => {
}, Nre = (e, t, n, r) => {
  const i = e._zod.def, o = b3(i.entries);
  o.every((a) => typeof a == "number") && (n.type = "number"), o.every((a) => typeof a == "string") && (n.type = "string"), n.enum = o;
}, jre = (e, t, n, r) => {
  if (t.unrepresentable === "throw")
    throw new Error("Custom types cannot be represented in JSON Schema");
}, Fre = (e, t, n, r) => {
  if (t.unrepresentable === "throw")
    throw new Error("Transforms cannot be represented in JSON Schema");
}, zre = (e, t, n, r) => {
  const i = n, o = e._zod.def, { minimum: a, maximum: s } = e._zod.bag;
  typeof a == "number" && (i.minItems = a), typeof s == "number" && (i.maxItems = s), i.type = "array", i.items = An(o.element, t, { ...r, path: [...r.path, "items"] });
}, Lre = (e, t, n, r) => {
  var i;
  const o = n, a = e._zod.def;
  o.type = "object", o.properties = {};
  const s = a.shape;
  for (const c in s)
    o.properties[c] = An(s[c], t, {
      ...r,
      path: [...r.path, "properties", c]
    });
  const l = new Set(Object.keys(s)), u = new Set([...l].filter((c) => {
    const f = a.shape[c]._zod;
    return t.io === "input" ? f.optin === void 0 : f.optout === void 0;
  }));
  u.size > 0 && (o.required = Array.from(u)), ((i = a.catchall) == null ? void 0 : i._zod.def.type) === "never" ? o.additionalProperties = !1 : a.catchall ? a.catchall && (o.additionalProperties = An(a.catchall, t, {
    ...r,
    path: [...r.path, "additionalProperties"]
  })) : t.io === "output" && (o.additionalProperties = !1);
}, Vre = (e, t, n, r) => {
  const i = e._zod.def, o = i.inclusive === !1, a = i.options.map((s, l) => An(s, t, {
    ...r,
    path: [...r.path, o ? "oneOf" : "anyOf", l]
  }));
  o ? n.oneOf = a : n.anyOf = a;
}, Bre = (e, t, n, r) => {
  const i = e._zod.def, o = An(i.left, t, {
    ...r,
    path: [...r.path, "allOf", 0]
  }), a = An(i.right, t, {
    ...r,
    path: [...r.path, "allOf", 1]
  }), s = (u) => "allOf" in u && Object.keys(u).length === 1, l = [
    ...s(o) ? o.allOf : [o],
    ...s(a) ? a.allOf : [a]
  ];
  n.allOf = l;
}, Kre = (e, t, n, r) => {
  const i = e._zod.def, o = An(i.innerType, t, r), a = t.seen.get(e);
  t.target === "openapi-3.0" ? (a.ref = i.innerType, n.nullable = !0) : n.anyOf = [o, { type: "null" }];
}, Ure = (e, t, n, r) => {
  const i = e._zod.def;
  An(i.innerType, t, r);
  const o = t.seen.get(e);
  o.ref = i.innerType;
}, qre = (e, t, n, r) => {
  const i = e._zod.def;
  An(i.innerType, t, r);
  const o = t.seen.get(e);
  o.ref = i.innerType, n.default = JSON.parse(JSON.stringify(i.defaultValue));
}, Hre = (e, t, n, r) => {
  const i = e._zod.def;
  An(i.innerType, t, r);
  const o = t.seen.get(e);
  o.ref = i.innerType, t.io === "input" && (n._prefault = JSON.parse(JSON.stringify(i.defaultValue)));
}, Wre = (e, t, n, r) => {
  const i = e._zod.def;
  An(i.innerType, t, r);
  const o = t.seen.get(e);
  o.ref = i.innerType;
  let a;
  try {
    a = i.catchValue(void 0);
  } catch {
    throw new Error("Dynamic catch values are not supported in JSON Schema");
  }
  n.default = a;
}, Zre = (e, t, n, r) => {
  const i = e._zod.def, o = t.io === "input" ? i.in._zod.def.type === "transform" ? i.out : i.in : i.out;
  An(o, t, r);
  const a = t.seen.get(e);
  a.ref = o;
}, Gre = (e, t, n, r) => {
  const i = e._zod.def;
  An(i.innerType, t, r);
  const o = t.seen.get(e);
  o.ref = i.innerType, n.readOnly = !0;
}, B3 = (e, t, n, r) => {
  const i = e._zod.def;
  An(i.innerType, t, r);
  const o = t.seen.get(e);
  o.ref = i.innerType;
}, Yre = /* @__PURE__ */ oe("ZodISODateTime", (e, t) => {
  tne.init(e, t), Yt.init(e, t);
});
function Qre(e) {
  return /* @__PURE__ */ ore(Yre, e);
}
const Jre = /* @__PURE__ */ oe("ZodISODate", (e, t) => {
  nne.init(e, t), Yt.init(e, t);
});
function Xre(e) {
  return /* @__PURE__ */ are(Jre, e);
}
const eie = /* @__PURE__ */ oe("ZodISOTime", (e, t) => {
  rne.init(e, t), Yt.init(e, t);
});
function tie(e) {
  return /* @__PURE__ */ sre(eie, e);
}
const nie = /* @__PURE__ */ oe("ZodISODuration", (e, t) => {
  ine.init(e, t), Yt.init(e, t);
});
function rie(e) {
  return /* @__PURE__ */ lre(nie, e);
}
const iie = (e, t) => {
  S3.init(e, t), e.name = "ZodError", Object.defineProperties(e, {
    format: {
      value: (n) => Wee(e, n)
      // enumerable: false,
    },
    flatten: {
      value: (n) => Hee(e, n)
      // enumerable: false,
    },
    addIssue: {
      value: (n) => {
        e.issues.push(n), e.message = JSON.stringify(e.issues, ny, 2);
      }
      // enumerable: false,
    },
    addIssues: {
      value: (n) => {
        e.issues.push(...n), e.message = JSON.stringify(e.issues, ny, 2);
      }
      // enumerable: false,
    },
    isEmpty: {
      get() {
        return e.issues.length === 0;
      }
      // enumerable: false,
    }
  });
}, Ur = oe("ZodError", iie, {
  Parent: Error
}), oie = /* @__PURE__ */ G0(Ur), aie = /* @__PURE__ */ Y0(Ur), sie = /* @__PURE__ */ eh(Ur), lie = /* @__PURE__ */ th(Ur), uie = /* @__PURE__ */ Yee(Ur), cie = /* @__PURE__ */ Qee(Ur), fie = /* @__PURE__ */ Jee(Ur), die = /* @__PURE__ */ Xee(Ur), pie = /* @__PURE__ */ ete(Ur), hie = /* @__PURE__ */ tte(Ur), mie = /* @__PURE__ */ nte(Ur), vie = /* @__PURE__ */ rte(Ur), an = /* @__PURE__ */ oe("ZodType", (e, t) => (on.init(e, t), Object.assign(e["~standard"], {
  jsonSchema: {
    input: Hd(e, "input"),
    output: Hd(e, "output")
  }
}), e.toJSONSchema = Pre(e, {}), e.def = t, e.type = t.type, Object.defineProperty(e, "_def", { value: t }), e.check = (...n) => e.clone(Ho(t, {
  checks: [
    ...t.checks ?? [],
    ...n.map((r) => typeof r == "function" ? { _zod: { check: r, def: { check: "custom" }, onattach: [] } } : r)
  ]
}), {
  parent: !0
}), e.with = e.check, e.clone = (n, r) => Wo(e, n, r), e.brand = () => e, e.register = ((n, r) => (n.add(e, r), e)), e.parse = (n, r) => oie(e, n, r, { callee: e.parse }), e.safeParse = (n, r) => sie(e, n, r), e.parseAsync = async (n, r) => aie(e, n, r, { callee: e.parseAsync }), e.safeParseAsync = async (n, r) => lie(e, n, r), e.spa = e.safeParseAsync, e.encode = (n, r) => uie(e, n, r), e.decode = (n, r) => cie(e, n, r), e.encodeAsync = async (n, r) => fie(e, n, r), e.decodeAsync = async (n, r) => die(e, n, r), e.safeEncode = (n, r) => pie(e, n, r), e.safeDecode = (n, r) => hie(e, n, r), e.safeEncodeAsync = async (n, r) => mie(e, n, r), e.safeDecodeAsync = async (n, r) => vie(e, n, r), e.refine = (n, r) => e.check(loe(n, r)), e.superRefine = (n) => e.check(uoe(n)), e.overwrite = (n) => e.check(/* @__PURE__ */ kl(n)), e.optional = () => VS(e), e.exactOptional = () => Gie(e), e.nullable = () => BS(e), e.nullish = () => VS(BS(e)), e.nonoptional = (n) => toe(e, n), e.array = () => ut(e), e.or = (n) => Kie([e, n]), e.and = (n) => qie(e, n), e.transform = (n) => KS(e, Wie(n)), e.default = (n) => Jie(e, n), e.prefault = (n) => eoe(e, n), e.catch = (n) => roe(e, n), e.pipe = (n) => KS(e, n), e.readonly = () => aoe(e), e.describe = (n) => {
  const r = e.clone();
  return nu.add(r, { description: n }), r;
}, Object.defineProperty(e, "description", {
  get() {
    var n;
    return (n = nu.get(e)) == null ? void 0 : n.description;
  },
  configurable: !0
}), e.meta = (...n) => {
  if (n.length === 0)
    return nu.get(e);
  const r = e.clone();
  return nu.add(r, n[0]), r;
}, e.isOptional = () => e.safeParse(void 0).success, e.isNullable = () => e.safeParse(null).success, e.apply = (n) => n(e), e)), K3 = /* @__PURE__ */ oe("_ZodString", (e, t) => {
  Q0.init(e, t), an.init(e, t), e._zod.processJSONSchema = (r, i, o) => Dre(e, r, i);
  const n = e._zod.bag;
  e.format = n.format ?? null, e.minLength = n.minimum ?? null, e.maxLength = n.maximum ?? null, e.regex = (...r) => e.check(/* @__PURE__ */ hre(...r)), e.includes = (...r) => e.check(/* @__PURE__ */ gre(...r)), e.startsWith = (...r) => e.check(/* @__PURE__ */ yre(...r)), e.endsWith = (...r) => e.check(/* @__PURE__ */ bre(...r)), e.min = (...r) => e.check(/* @__PURE__ */ qd(...r)), e.max = (...r) => e.check(/* @__PURE__ */ j3(...r)), e.length = (...r) => e.check(/* @__PURE__ */ F3(...r)), e.nonempty = (...r) => e.check(/* @__PURE__ */ qd(1, ...r)), e.lowercase = (r) => e.check(/* @__PURE__ */ mre(r)), e.uppercase = (r) => e.check(/* @__PURE__ */ vre(r)), e.trim = () => e.check(/* @__PURE__ */ wre()), e.normalize = (...r) => e.check(/* @__PURE__ */ _re(...r)), e.toLowerCase = () => e.check(/* @__PURE__ */ xre()), e.toUpperCase = () => e.check(/* @__PURE__ */ Ere()), e.slugify = () => e.check(/* @__PURE__ */ Sre());
}), gie = /* @__PURE__ */ oe("ZodString", (e, t) => {
  Q0.init(e, t), K3.init(e, t), e.email = (n) => e.check(/* @__PURE__ */ Fne(yie, n)), e.url = (n) => e.check(/* @__PURE__ */ Kne(bie, n)), e.jwt = (n) => e.check(/* @__PURE__ */ ire(Mie, n)), e.emoji = (n) => e.check(/* @__PURE__ */ Une(_ie, n)), e.guid = (n) => e.check(/* @__PURE__ */ RS(zS, n)), e.uuid = (n) => e.check(/* @__PURE__ */ zne(lf, n)), e.uuidv4 = (n) => e.check(/* @__PURE__ */ Lne(lf, n)), e.uuidv6 = (n) => e.check(/* @__PURE__ */ Vne(lf, n)), e.uuidv7 = (n) => e.check(/* @__PURE__ */ Bne(lf, n)), e.nanoid = (n) => e.check(/* @__PURE__ */ qne(wie, n)), e.guid = (n) => e.check(/* @__PURE__ */ RS(zS, n)), e.cuid = (n) => e.check(/* @__PURE__ */ Hne(xie, n)), e.cuid2 = (n) => e.check(/* @__PURE__ */ Wne(Eie, n)), e.ulid = (n) => e.check(/* @__PURE__ */ Zne(Sie, n)), e.base64 = (n) => e.check(/* @__PURE__ */ tre(Die, n)), e.base64url = (n) => e.check(/* @__PURE__ */ nre(Cie, n)), e.xid = (n) => e.check(/* @__PURE__ */ Gne($ie, n)), e.ksuid = (n) => e.check(/* @__PURE__ */ Yne(kie, n)), e.ipv4 = (n) => e.check(/* @__PURE__ */ Qne(Tie, n)), e.ipv6 = (n) => e.check(/* @__PURE__ */ Jne(Oie, n)), e.cidrv4 = (n) => e.check(/* @__PURE__ */ Xne(Pie, n)), e.cidrv6 = (n) => e.check(/* @__PURE__ */ ere(Aie, n)), e.e164 = (n) => e.check(/* @__PURE__ */ rre(Iie, n)), e.datetime = (n) => e.check(Qre(n)), e.date = (n) => e.check(Xre(n)), e.time = (n) => e.check(tie(n)), e.duration = (n) => e.check(rie(n));
});
function J(e) {
  return /* @__PURE__ */ jne(gie, e);
}
const Yt = /* @__PURE__ */ oe("ZodStringFormat", (e, t) => {
  Kt.init(e, t), K3.init(e, t);
}), yie = /* @__PURE__ */ oe("ZodEmail", (e, t) => {
  Hte.init(e, t), Yt.init(e, t);
}), zS = /* @__PURE__ */ oe("ZodGUID", (e, t) => {
  Ute.init(e, t), Yt.init(e, t);
}), lf = /* @__PURE__ */ oe("ZodUUID", (e, t) => {
  qte.init(e, t), Yt.init(e, t);
}), bie = /* @__PURE__ */ oe("ZodURL", (e, t) => {
  Wte.init(e, t), Yt.init(e, t);
}), _ie = /* @__PURE__ */ oe("ZodEmoji", (e, t) => {
  Zte.init(e, t), Yt.init(e, t);
}), wie = /* @__PURE__ */ oe("ZodNanoID", (e, t) => {
  Gte.init(e, t), Yt.init(e, t);
}), xie = /* @__PURE__ */ oe("ZodCUID", (e, t) => {
  Yte.init(e, t), Yt.init(e, t);
}), Eie = /* @__PURE__ */ oe("ZodCUID2", (e, t) => {
  Qte.init(e, t), Yt.init(e, t);
}), Sie = /* @__PURE__ */ oe("ZodULID", (e, t) => {
  Jte.init(e, t), Yt.init(e, t);
}), $ie = /* @__PURE__ */ oe("ZodXID", (e, t) => {
  Xte.init(e, t), Yt.init(e, t);
}), kie = /* @__PURE__ */ oe("ZodKSUID", (e, t) => {
  ene.init(e, t), Yt.init(e, t);
}), Tie = /* @__PURE__ */ oe("ZodIPv4", (e, t) => {
  one.init(e, t), Yt.init(e, t);
}), Oie = /* @__PURE__ */ oe("ZodIPv6", (e, t) => {
  ane.init(e, t), Yt.init(e, t);
}), Pie = /* @__PURE__ */ oe("ZodCIDRv4", (e, t) => {
  sne.init(e, t), Yt.init(e, t);
}), Aie = /* @__PURE__ */ oe("ZodCIDRv6", (e, t) => {
  lne.init(e, t), Yt.init(e, t);
}), Die = /* @__PURE__ */ oe("ZodBase64", (e, t) => {
  une.init(e, t), Yt.init(e, t);
}), Cie = /* @__PURE__ */ oe("ZodBase64URL", (e, t) => {
  fne.init(e, t), Yt.init(e, t);
}), Iie = /* @__PURE__ */ oe("ZodE164", (e, t) => {
  dne.init(e, t), Yt.init(e, t);
}), Mie = /* @__PURE__ */ oe("ZodJWT", (e, t) => {
  hne.init(e, t), Yt.init(e, t);
}), U3 = /* @__PURE__ */ oe("ZodNumber", (e, t) => {
  I3.init(e, t), an.init(e, t), e._zod.processJSONSchema = (r, i, o) => Cre(e, r, i), e.gt = (r, i) => e.check(/* @__PURE__ */ jS(r, i)), e.gte = (r, i) => e.check(/* @__PURE__ */ Nm(r, i)), e.min = (r, i) => e.check(/* @__PURE__ */ Nm(r, i)), e.lt = (r, i) => e.check(/* @__PURE__ */ NS(r, i)), e.lte = (r, i) => e.check(/* @__PURE__ */ Rm(r, i)), e.max = (r, i) => e.check(/* @__PURE__ */ Rm(r, i)), e.int = (r) => e.check(LS(r)), e.safe = (r) => e.check(LS(r)), e.positive = (r) => e.check(/* @__PURE__ */ jS(0, r)), e.nonnegative = (r) => e.check(/* @__PURE__ */ Nm(0, r)), e.negative = (r) => e.check(/* @__PURE__ */ NS(0, r)), e.nonpositive = (r) => e.check(/* @__PURE__ */ Rm(0, r)), e.multipleOf = (r, i) => e.check(/* @__PURE__ */ FS(r, i)), e.step = (r, i) => e.check(/* @__PURE__ */ FS(r, i)), e.finite = () => e;
  const n = e._zod.bag;
  e.minValue = Math.max(n.minimum ?? Number.NEGATIVE_INFINITY, n.exclusiveMinimum ?? Number.NEGATIVE_INFINITY) ?? null, e.maxValue = Math.min(n.maximum ?? Number.POSITIVE_INFINITY, n.exclusiveMaximum ?? Number.POSITIVE_INFINITY) ?? null, e.isInt = (n.format ?? "").includes("int") || Number.isSafeInteger(n.multipleOf ?? 0.5), e.isFinite = !0, e.format = n.format ?? null;
});
function Oe(e) {
  return /* @__PURE__ */ ure(U3, e);
}
const Rie = /* @__PURE__ */ oe("ZodNumberFormat", (e, t) => {
  mne.init(e, t), U3.init(e, t);
});
function LS(e) {
  return /* @__PURE__ */ cre(Rie, e);
}
const Nie = /* @__PURE__ */ oe("ZodBoolean", (e, t) => {
  vne.init(e, t), an.init(e, t), e._zod.processJSONSchema = (n, r, i) => Ire(e, n, r);
});
function Gn(e) {
  return /* @__PURE__ */ fre(Nie, e);
}
const jie = /* @__PURE__ */ oe("ZodUnknown", (e, t) => {
  gne.init(e, t), an.init(e, t), e._zod.processJSONSchema = (n, r, i) => Rre();
});
function Gu() {
  return /* @__PURE__ */ dre(jie);
}
const Fie = /* @__PURE__ */ oe("ZodNever", (e, t) => {
  yne.init(e, t), an.init(e, t), e._zod.processJSONSchema = (n, r, i) => Mre(e, n, r);
});
function zie(e) {
  return /* @__PURE__ */ pre(Fie, e);
}
const Lie = /* @__PURE__ */ oe("ZodArray", (e, t) => {
  bne.init(e, t), an.init(e, t), e._zod.processJSONSchema = (n, r, i) => zre(e, n, r, i), e.element = t.element, e.min = (n, r) => e.check(/* @__PURE__ */ qd(n, r)), e.nonempty = (n) => e.check(/* @__PURE__ */ qd(1, n)), e.max = (n, r) => e.check(/* @__PURE__ */ j3(n, r)), e.length = (n, r) => e.check(/* @__PURE__ */ F3(n, r)), e.unwrap = () => e.element;
});
function ut(e, t) {
  return /* @__PURE__ */ $re(Lie, e, t);
}
const Vie = /* @__PURE__ */ oe("ZodObject", (e, t) => {
  wne.init(e, t), an.init(e, t), e._zod.processJSONSchema = (n, r, i) => Lre(e, n, r, i), bt(e, "shape", () => t.shape), e.keyof = () => Ni(Object.keys(e._zod.def.shape)), e.catchall = (n) => e.clone({ ...e._zod.def, catchall: n }), e.passthrough = () => e.clone({ ...e._zod.def, catchall: Gu() }), e.loose = () => e.clone({ ...e._zod.def, catchall: Gu() }), e.strict = () => e.clone({ ...e._zod.def, catchall: zie() }), e.strip = () => e.clone({ ...e._zod.def, catchall: void 0 }), e.extend = (n) => Vee(e, n), e.safeExtend = (n) => Bee(e, n), e.merge = (n) => Kee(e, n), e.pick = (n) => zee(e, n), e.omit = (n) => Lee(e, n), e.partial = (...n) => Uee(q3, e, n[0]), e.required = (...n) => qee(H3, e, n[0]);
});
function se(e, t) {
  const n = {
    type: "object",
    shape: e ?? {},
    ...qe(t)
  };
  return new Vie(n);
}
const Bie = /* @__PURE__ */ oe("ZodUnion", (e, t) => {
  xne.init(e, t), an.init(e, t), e._zod.processJSONSchema = (n, r, i) => Vre(e, n, r, i), e.options = t.options;
});
function Kie(e, t) {
  return new Bie({
    type: "union",
    options: e,
    ...qe(t)
  });
}
const Uie = /* @__PURE__ */ oe("ZodIntersection", (e, t) => {
  Ene.init(e, t), an.init(e, t), e._zod.processJSONSchema = (n, r, i) => Bre(e, n, r, i);
});
function qie(e, t) {
  return new Uie({
    type: "intersection",
    left: e,
    right: t
  });
}
const iy = /* @__PURE__ */ oe("ZodEnum", (e, t) => {
  Sne.init(e, t), an.init(e, t), e._zod.processJSONSchema = (r, i, o) => Nre(e, r, i), e.enum = t.entries, e.options = Object.values(t.entries);
  const n = new Set(Object.keys(t.entries));
  e.extract = (r, i) => {
    const o = {};
    for (const a of r)
      if (n.has(a))
        o[a] = t.entries[a];
      else
        throw new Error(`Key ${a} not found in enum`);
    return new iy({
      ...t,
      checks: [],
      ...qe(i),
      entries: o
    });
  }, e.exclude = (r, i) => {
    const o = { ...t.entries };
    for (const a of r)
      if (n.has(a))
        delete o[a];
      else
        throw new Error(`Key ${a} not found in enum`);
    return new iy({
      ...t,
      checks: [],
      ...qe(i),
      entries: o
    });
  };
});
function Ni(e, t) {
  const n = Array.isArray(e) ? Object.fromEntries(e.map((r) => [r, r])) : e;
  return new iy({
    type: "enum",
    entries: n,
    ...qe(t)
  });
}
const Hie = /* @__PURE__ */ oe("ZodTransform", (e, t) => {
  $ne.init(e, t), an.init(e, t), e._zod.processJSONSchema = (n, r, i) => Fre(e, n), e._zod.parse = (n, r) => {
    if (r.direction === "backward")
      throw new g3(e.constructor.name);
    n.addIssue = (o) => {
      if (typeof o == "string")
        n.issues.push(Zu(o, n.value, t));
      else {
        const a = o;
        a.fatal && (a.continue = !1), a.code ?? (a.code = "custom"), a.input ?? (a.input = n.value), a.inst ?? (a.inst = e), n.issues.push(Zu(a));
      }
    };
    const i = t.transform(n.value, n);
    return i instanceof Promise ? i.then((o) => (n.value = o, n)) : (n.value = i, n);
  };
});
function Wie(e) {
  return new Hie({
    type: "transform",
    transform: e
  });
}
const q3 = /* @__PURE__ */ oe("ZodOptional", (e, t) => {
  N3.init(e, t), an.init(e, t), e._zod.processJSONSchema = (n, r, i) => B3(e, n, r, i), e.unwrap = () => e._zod.def.innerType;
});
function VS(e) {
  return new q3({
    type: "optional",
    innerType: e
  });
}
const Zie = /* @__PURE__ */ oe("ZodExactOptional", (e, t) => {
  kne.init(e, t), an.init(e, t), e._zod.processJSONSchema = (n, r, i) => B3(e, n, r, i), e.unwrap = () => e._zod.def.innerType;
});
function Gie(e) {
  return new Zie({
    type: "optional",
    innerType: e
  });
}
const Yie = /* @__PURE__ */ oe("ZodNullable", (e, t) => {
  Tne.init(e, t), an.init(e, t), e._zod.processJSONSchema = (n, r, i) => Kre(e, n, r, i), e.unwrap = () => e._zod.def.innerType;
});
function BS(e) {
  return new Yie({
    type: "nullable",
    innerType: e
  });
}
const Qie = /* @__PURE__ */ oe("ZodDefault", (e, t) => {
  One.init(e, t), an.init(e, t), e._zod.processJSONSchema = (n, r, i) => qre(e, n, r, i), e.unwrap = () => e._zod.def.innerType, e.removeDefault = e.unwrap;
});
function Jie(e, t) {
  return new Qie({
    type: "default",
    innerType: e,
    get defaultValue() {
      return typeof t == "function" ? t() : w3(t);
    }
  });
}
const Xie = /* @__PURE__ */ oe("ZodPrefault", (e, t) => {
  Pne.init(e, t), an.init(e, t), e._zod.processJSONSchema = (n, r, i) => Hre(e, n, r, i), e.unwrap = () => e._zod.def.innerType;
});
function eoe(e, t) {
  return new Xie({
    type: "prefault",
    innerType: e,
    get defaultValue() {
      return typeof t == "function" ? t() : w3(t);
    }
  });
}
const H3 = /* @__PURE__ */ oe("ZodNonOptional", (e, t) => {
  Ane.init(e, t), an.init(e, t), e._zod.processJSONSchema = (n, r, i) => Ure(e, n, r, i), e.unwrap = () => e._zod.def.innerType;
});
function toe(e, t) {
  return new H3({
    type: "nonoptional",
    innerType: e,
    ...qe(t)
  });
}
const noe = /* @__PURE__ */ oe("ZodCatch", (e, t) => {
  Dne.init(e, t), an.init(e, t), e._zod.processJSONSchema = (n, r, i) => Wre(e, n, r, i), e.unwrap = () => e._zod.def.innerType, e.removeCatch = e.unwrap;
});
function roe(e, t) {
  return new noe({
    type: "catch",
    innerType: e,
    catchValue: typeof t == "function" ? t : () => t
  });
}
const ioe = /* @__PURE__ */ oe("ZodPipe", (e, t) => {
  Cne.init(e, t), an.init(e, t), e._zod.processJSONSchema = (n, r, i) => Zre(e, n, r, i), e.in = t.in, e.out = t.out;
});
function KS(e, t) {
  return new ioe({
    type: "pipe",
    in: e,
    out: t
    // ...util.normalizeParams(params),
  });
}
const ooe = /* @__PURE__ */ oe("ZodReadonly", (e, t) => {
  Ine.init(e, t), an.init(e, t), e._zod.processJSONSchema = (n, r, i) => Gre(e, n, r, i), e.unwrap = () => e._zod.def.innerType;
});
function aoe(e) {
  return new ooe({
    type: "readonly",
    innerType: e
  });
}
const soe = /* @__PURE__ */ oe("ZodCustom", (e, t) => {
  Mne.init(e, t), an.init(e, t), e._zod.processJSONSchema = (n, r, i) => jre(e, n);
});
function loe(e, t = {}) {
  return /* @__PURE__ */ kre(soe, e, t);
}
function uoe(e) {
  return /* @__PURE__ */ Tre(e);
}
const coe = se({
  id: J(),
  name: J(),
  slug: J(),
  status: Ni(["PENDING", "COMPLETED", "FAILED", "CANCELLED"]),
  input: se({}).partial().passthrough(),
  output: se({}).partial().passthrough().nullable(),
  createdAt: J(),
  startedAt: J().nullable(),
  endedAt: J().nullable()
}).passthrough();
se({ analyses: ut(coe) }).passthrough();
se({
  name: J().min(1).max(100),
  outputLocation: se({ s3BucketId: Oe(), path: J().optional() }).passthrough(),
  analysisSchemaId: Oe().int().gt(0).lte(9007199254740991),
  version: Oe(),
  input: Gu(),
  labId: Oe().optional()
}).passthrough();
se({
  analysisId: J().nullable(),
  analysisSlug: J().nullable(),
  success: Gn()
}).passthrough();
const foe = se({ id: Oe(), name: J(), versions: ut(Oe()) }).passthrough();
se({ analysisSchemas: ut(foe) }).passthrough();
const W3 = se({
  id: Oe(),
  name: J(),
  schema: se({}).partial().passthrough()
}).passthrough(), US = se({ id: Oe(), name: J(), valueSchema: W3 }).passthrough(), doe = se({
  analysisSchemaId: Oe(),
  version: Oe(),
  createdAt: J(),
  description: se({ short: J().nullable(), long: J().nullable() }).partial().passthrough(),
  inputs: ut(US),
  outputs: ut(US)
}).passthrough();
se({ versions: ut(doe) }).passthrough();
se({ logs: ut(J()) }).passthrough();
const poe = se({
  id: J(),
  taskArn: J(),
  name: J(),
  status: J(),
  analysisId: J(),
  startedAt: J(),
  endedAt: J(),
  memory: Oe(),
  vcpus: Oe()
}).passthrough();
se({ tasks: ut(poe) }).passthrough();
se({
  totalCost: Oe(),
  tasks: ut(
    se({ name: J(), cost: Oe() }).passthrough()
  ),
  runner: Oe(),
  storageCost: Oe(),
  vpcCost: Oe()
}).passthrough();
const hoe = se({
  analysisSchemaId: Oe(),
  version: Oe(),
  name: J()
}).passthrough();
se({ next: ut(hoe) }).passthrough();
const moe = se({ success: Gn() }).passthrough();
se({ valueSchemas: ut(W3) }).passthrough();
const voe = Ni([
  "ADMIN",
  "USER",
  "PROFESSOR",
  "PREMIUM_USER",
  "FREE_USER"
]), Z3 = Ni([
  "admin",
  "credits_unlimited",
  "files_read",
  "keypair_read",
  "lab_create",
  "labmember_read",
  "labmember_write",
  "lab_read",
  "notebook_read",
  "notebook_write",
  "plexus_read",
  "plexus_write",
  "tinkerbox_launch",
  "tinkerbox_read",
  "user_update"
]), G3 = se({
  id: J(),
  firstname: J().nullable(),
  lastname: J().nullable(),
  email: J().nullable(),
  keyPairId: Oe(),
  roles: ut(voe),
  permissions: ut(Z3)
}).passthrough();
se({ user: G3 }).partial().passthrough();
se({ email: J() }).passthrough();
se({ success: Gn() }).passthrough();
se({ otp: J() }).passthrough();
se({ success: Gn() }).passthrough();
se({ token: J() }).passthrough();
se({ token: J() }).passthrough();
se({ valid: Gn() }).passthrough();
se({ name: J(), permissions: ut(Z3) }).passthrough();
const goe = se({
  id: Oe(),
  instanceProfile: J().nullable(),
  securityGroup: J().nullable()
}).passthrough(), rh = se({
  id: Oe(),
  name: J(),
  labId: Oe().nullish(),
  userId: J().nullish(),
  status: Ni([
    "pending",
    "running",
    "stopping",
    "stopped",
    "shutting_down",
    "terminated"
  ]),
  ipAddress: J().nullish(),
  lastLogin: J().nullish(),
  keypairId: Oe().nullish()
}).passthrough();
se({
  infra: ut(goe),
  keyPairs: ut(J()),
  tinkerBoxes: ut(rh)
}).passthrough();
se({ count: Oe().gte(1).lte(15) }).passthrough();
se({
  firstname: J().min(1),
  lastname: J().min(1),
  email: J().regex(
    /^(?!\.)(?!.*\.\.)([A-Za-z0-9_'+\-\.]*)[A-Za-z0-9_+-]@([A-Za-z0-9][A-Za-z0-9\-]*\.)+[A-Za-z]{2,}$/
  ).email(),
  password: J().min(8)
}).passthrough();
se({ users: ut(G3) }).passthrough();
se({
  firstname: J().nullable(),
  lastname: J().nullable(),
  email: J().nullable()
}).partial().passthrough();
const yoe = se({ tinkerBox: rh, keyMaterial: J() }).passthrough();
se({ tinkerBoxes: ut(yoe) }).passthrough();
const boe = se({
  labName: J(),
  ec2Cost: Oe(),
  s3Cost: Oe(),
  efsCost: Oe(),
  totalCost: Oe()
}).passthrough();
se({ clients: ut(boe) }).passthrough();
const _oe = se({
  name: J(),
  labName: J(),
  usage: J(),
  cost: Oe()
}).passthrough();
se({ tinkerBoxes: ut(_oe) }).passthrough();
se({ tinkerboxes: ut(rh) }).passthrough();
se({ tinkerBox: rh }).passthrough();
se({ name: J() }).passthrough();
const woe = se({
  id: Oe(),
  date: J(),
  tinkerBoxName: J(),
  lastLoginDate: J().nullable(),
  lastCommandDate: J().nullable(),
  lastCommand: J().nullable(),
  activeProcesses: Gn(),
  status: Ni([
    "pending",
    "running",
    "stopping",
    "stopped",
    "shutting_down",
    "terminated"
  ]),
  tinkerBoxId: Oe(),
  autoStopTime: J().nullable()
}).passthrough();
se({ allLastActivity: ut(woe) }).passthrough();
se({ name: J().nullable() }).partial().passthrough();
const xoe = se({
  id: Oe(),
  name: J(),
  s3BucketId: Oe(),
  keyPairId: Oe()
}).passthrough();
se({ labs: ut(xoe) }).passthrough();
se({
  name: J(),
  numTinkerBoxes: Oe().optional().default(1)
}).passthrough();
se({ labId: Oe(), taskId: J() }).passthrough();
se({ id: J(), labId: Oe(), logs: J() }).passthrough();
const Y3 = se({
  id: Oe(),
  labId: Oe(),
  userId: J(),
  role: Ni(["OWNER", "MEMBER"]),
  user: se({
    firstname: J().nullable(),
    lastname: J().nullable(),
    email: J().nullable(),
    id: J()
  }).partial().passthrough()
}).passthrough();
se({ labMember: Y3.nullable() }).passthrough();
se({ labMembers: ut(Y3) }).passthrough();
const Eoe = se({
  id: Oe(),
  labId: Oe(),
  userId: J(),
  role: Ni(["OWNER", "MEMBER"])
}).passthrough();
se({ labMember: Eoe }).passthrough();
se({ role: J() }).passthrough();
se({ labMemberId: Oe(), role: J() }).passthrough();
se({ success: Gn() }).passthrough();
se({
  client_secret: J().nullable(),
  status: J().nullable(),
  payment_status: J()
}).passthrough();
se({
  name: J(),
  email: J().regex(
    /^(?!\.)(?!.*\.\.)([A-Za-z0-9_'+\-\.]*)[A-Za-z0-9_+-]@([A-Za-z0-9][A-Za-z0-9\-]*\.)+[A-Za-z]{2,}$/
  ).email(),
  message: J()
}).passthrough();
se({ path: J(), s3BucketId: Oe().optional() }).passthrough();
const Soe = se({ success: Gn() }).passthrough(), $oe = se({ url: J() }).passthrough(), koe = se({
  isFolder: Gn(),
  bucketId: Oe().optional(),
  path: J()
}).passthrough(), Toe = se({ contents: ut(koe) }).passthrough(), Ooe = se({ files: ut(J()) }).passthrough();
se({
  buckets: ut(
    se({
      id: Oe().int().gte(-9007199254740991).lte(9007199254740991),
      bucket: J(),
      region: J(),
      prefix: J().nullish()
    }).passthrough()
  )
}).passthrough();
se({
  source: se({
    isFolder: Gn(),
    bucketId: Oe().optional(),
    path: J()
  }).passthrough(),
  target: se({
    isFolder: Gn(),
    bucketId: Oe().optional(),
    path: J()
  }).passthrough()
}).passthrough();
const Poe = se({
  fileTransfers: ut(
    se({
      id: Oe().int().gte(-9007199254740991).lte(9007199254740991),
      name: J(),
      userId: J(),
      progress: Oe(),
      user: Gu()
    })
  )
}).passthrough(), Aoe = se({
  id: Oe(),
  name: J(),
  analysisSchemaId: Oe(),
  analysisSchemaVersion: Oe(),
  config: se({}).partial().passthrough()
}).passthrough();
se({ templates: ut(Aoe) }).passthrough();
se({
  name: J().min(1).max(255),
  analysisSchemaId: Oe().int().gte(-9007199254740991).lte(9007199254740991),
  analysisSchemaVersion: Oe().int().gt(0).lte(9007199254740991),
  triggerLocation: se({
    bucketId: Oe().int().gt(0).lte(9007199254740991),
    folderPath: J().max(2048)
  }).passthrough(),
  config: Gu()
}).passthrough();
se({
  id: Oe(),
  name: J(),
  s3BucketId: Oe(),
  triggerFolder: J(),
  analysisSchemaId: Oe(),
  analysisSchemaVersion: Oe(),
  config: se({}).partial().passthrough()
}).passthrough();
se({
  id: Oe(),
  name: J(),
  schema: se({}).partial().passthrough()
}).passthrough();
se({
  id: Oe(),
  formId: Oe(),
  data: se({}).partial().passthrough(),
  dateCreated: J()
}).passthrough();
se({
  id: Oe(),
  name: J(),
  displayName: J(),
  hichip: J(),
  source: J(),
  bucket: J(),
  bedpeKey: J(),
  hicKey: J(),
  category: J()
}).passthrough();
se({
  id: Oe(),
  sampleId: Oe(),
  cluster: J(),
  chr: J(),
  start: Oe(),
  end: Oe(),
  size: Oe(),
  genes: J()
}).passthrough();
se({
  plotId: J(),
  status: Ni(["PENDING", "COMPLETED", "FAILED", "CANCELLED"]),
  outputBucket: J(),
  outputKey: J(),
  inputs: se({}).partial().passthrough(),
  endedAt: J().nullable(),
  downloadUrl: J().nullable()
}).passthrough();
se({
  sample: J(),
  range: J(),
  genomeBuild: Ni(["hg19", "hg38"]),
  color: J().regex(/^#?([A-Fa-f0-9]{6}|[A-Fa-f0-9]{3})$/),
  inherent: J(),
  flank: Oe(),
  bedpe: J()
}).passthrough();
const Q3 = se({
  id: Oe(),
  title: J(),
  content: J(),
  createdAt: J(),
  updatedAt: J(),
  isActive: Gn()
}).passthrough();
se({ announcements: ut(Q3) }).passthrough();
se({ announcement: Q3.nullable() }).passthrough();
const Doe = se({
  id: J(),
  title: J(),
  createdAt: J(),
  updatedAt: J(),
  language: J(),
  userId: J().nullable(),
  readonly: Gn()
}).passthrough();
se({ notebooks: ut(Doe) }).passthrough();
se({ language: J() }).passthrough();
const J3 = se({
  id: J(),
  title: J(),
  createdAt: J(),
  updatedAt: J(),
  language: J(),
  content: J(),
  userId: J().nullable(),
  readonly: Gn()
}).passthrough();
se({ notebook: J3 }).passthrough();
se({ success: Gn() }).passthrough();
se({ content: J() }).passthrough();
se({ title: J() }).passthrough();
se({ notebook: J3 }).passthrough();
se({ title: J() }).passthrough();
const jo = {
  SuccessDto: moe,
  CreateDirectoryResponse: Soe,
  PresignedUrlResponse: $oe,
  ContentsResponse: Toe,
  DeleteFilesResponse: Ooe,
  FileTransfersResponse: Poe
};
class jm {
  constructor(t) {
    MQ(this, "fetch"), this.fetch = t;
  }
  async download(t, n, r = null, i = !0) {
    let o = `/files/presigned/${encodeURIComponent(n)}/url?method=download`;
    t && (o += `&bucket=${t}`), r && (o += `&limit=${r}`);
    const a = (await this.fetch(
      o,
      { method: "GET" },
      jo.PresignedUrlResponse
    )).url;
    if (i) {
      const s = document.createElement("a");
      s.href = a, s.download = "", s.target = "_blank", s.click(), document.body.appendChild(s), s.click(), setTimeout(() => {
        document.body.removeChild(s);
      });
    }
    return a;
  }
  async upload(t, n, r) {
    const i = [];
    let o = `/files/presigned/${encodeURIComponent(r)}/url?method=upload`;
    n && (o = o += `&bucket=${n}`);
    const a = (await this.fetch(
      o,
      { method: "GET" },
      jo.PresignedUrlResponse
    )).url, s = new XMLHttpRequest();
    return s.open("PUT", a), s.addEventListener("error", () => {
      for (const l of i)
        l.onError(new Error("Failed to upload file"));
    }), s.onerror = () => {
      for (const l of i)
        l.onError(new Error("Failed to upload file"));
    }, s.upload.addEventListener("progress", (l) => {
      const u = l.loaded / l.total;
      for (const c of i)
        c.onProgress(u);
    }), s.upload.addEventListener("load", () => {
      for (const l of i)
        l.onComplete();
      s.upload.removeEventListener("progress", () => null);
    }), s.send(t), {
      subscribe(l) {
        i.push(l);
      }
    };
  }
}
const X3 = ({ className: e = "" }) => /* @__PURE__ */ I.jsx(
  "svg",
  {
    className: `${e} block`,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 260.81 296.2",
    children: /* @__PURE__ */ I.jsx("g", { children: /* @__PURE__ */ I.jsx("path", { d: "M64.3,112.5C28.5,174.6-.4,225.4,0,225.6s34.7-9.2,76.2-20.7,76.3-21.1,77.4-21.3c1.8-.3,2.3,2.8,9.6,56,4.2,31,7.8,56.5,8,56.6s20.5-15.2,45.2-34.3c29.3-22.7,44.6-35.1,44.4-36.1C260.2,223.6,131.2.4,130.2,0,129.8-.1,100.1,50.5,64.3,112.5Z" }) })
  }
);
function qS(e) {
  ze(() => {
    e && Er.error(e.toString());
  }, [e]);
}
async function Coe(e, t, n) {
  await e(
    "/files/directory",
    {
      method: "POST",
      body: JSON.stringify({ s3BucketId: t, path: n })
    },
    jo.CreateDirectoryResponse
  );
}
const Ioe = (e) => {
  const t = uy({
    mutationKey: ["createFolder"],
    mutationFn: async (n) => Coe(e, n.s3BucketId, n.path)
  });
  return { ...t, createFolder: t.mutateAsync };
};
async function Moe(e, t, n) {
  let i = `/files/${encodeURIComponent(t)}?`;
  return n && (i += `&bucket=${n}`), await e(
    i,
    { method: "DELETE" },
    jo.DeleteFilesResponse
  );
}
const Roe = (e) => {
  const t = uy({
    mutationKey: ["deleteFiles"],
    mutationFn: (n) => Moe(e, n.path, n.s3BucketId)
  });
  return { ...t, deleteFiles: t.mutateAsync };
};
async function Noe(e) {
  return e(
    "/file-transfer",
    { method: "GET" },
    jo.FileTransfersResponse
  );
}
const joe = (e, t) => Zd({
  queryKey: ["file-transfers"],
  queryFn: () => Noe(t),
  refetchInterval: 500,
  enabled: e
}), Foe = async (e, t, n) => await n(
  `/files/?search=${t}&bucket=${e}`,
  {},
  jo.ContentsResponse
), zoe = async (e, t, n) => {
  let i = `/files/${encodeURIComponent(t || "")}?`;
  return e && (i += `bucket=${e}`), await n(i, { method: "GET" }, jo.ContentsResponse);
}, Loe = (e, t, n) => Zd({
  queryKey: ["files", e, t],
  queryFn: async () => zoe(e, t, n),
  refetchInterval: 2e3
});
async function Voe(e, t, n) {
  return n(
    "/files/move",
    {
      method: "POST",
      body: JSON.stringify({ source: e, target: t })
    },
    jo.SuccessDto
  );
}
function Boe(e) {
  const t = uy({
    mutationKey: ["moveFiles"],
    mutationFn: ({ src: n, dest: r }) => Voe(n, r, e)
  });
  return { ...t, moveFiles: t.mutateAsync };
}
function Koe({
  s3BucketId: e,
  fetch: t,
  selectionMode: n,
  onSelectionChange: r,
  path: i,
  setPath: o,
  readOnly: a = !1,
  selection: s = [],
  className: l = ""
}) {
  const {
    data: u,
    error: c,
    refetch: f
  } = Loe(e, i.join("/"), t), [d, p] = Ke(!1), { createFolder: h } = Ioe(t), { deleteFiles: v, error: m } = Roe(t), { moveFiles: g, error: _ } = Boe(t), { data: x, error: w } = joe(d, t);
  ze(() => {
    x?.fileTransfers && x.fileTransfers.length > 0;
  }, [x]), qS(_), qS(w), Uoe(x), ze(() => {
    c && Er.error(c.message), m && Er.error(m.message);
  }, [c, m]);
  const $ = u?.contents ?? [], k = i.length > 0 ? `/${i.join("/")}` : "/";
  return /* @__PURE__ */ I.jsx(
    AQ,
    {
      className: l,
      selectionMode: n,
      filePathHomeDirectory: /* @__PURE__ */ I.jsx(X3, { className: "inline w-3 h-3" }),
      files: $,
      selection: s,
      readOnly: a,
      onSelectionChange: r,
      onDownload: async (D) => {
        await new jm(t).download(e, D.path, null, !0), f();
      },
      onMoveUpAFolder: async (D) => {
        if (!D) {
          Er.error("Already at root folder");
          return;
        }
        const { path: E, parent: b } = D;
        await g({
          src: E,
          dest: { isFolder: !0, path: b, bucketId: E.bucketId }
        }), p(!0), await f();
      },
      path: i,
      onNavigate: (D) => {
        o(D);
      },
      onMove: async (D, E) => {
        if (!E.isFolder) {
          Er.error("Target must be a folder");
          return;
        }
        await g({ src: D, dest: E }), await f(), p(!0);
      },
      onSearch: async (D) => (await Foe(e, D, t)).contents,
      onUpload: function(D) {
        const E = new jm(t), b = `${k}/${D[0].name}`;
        return E.upload(D[0], e, b);
      },
      onDelete: async (D) => {
        await v({ s3BucketId: e, path: D[0].path }), await f();
      },
      onCreateFolder: async (D) => {
        await h({ s3BucketId: e, path: D }), await f();
      },
      onPreview: async (D) => {
        await new jm(t).download(e, D.path), f();
      }
    }
  );
}
const Uoe = (e) => {
  ze(() => {
    if (e?.fileTransfers.length)
      for (const t of e.fileTransfers)
        Er(t.name, {
          progress: t.progress,
          toastId: t.id
        });
  }, [e]);
};
function hse(e) {
  return /* @__PURE__ */ I.jsx(T6, { client: e.queryClient, children: /* @__PURE__ */ I.jsx(Koe, { ...e }) });
}
var uf, qoe = new Uint8Array(16);
function Hoe() {
  if (!uf && (uf = typeof crypto < "u" && crypto.getRandomValues && crypto.getRandomValues.bind(crypto) || typeof msCrypto < "u" && typeof msCrypto.getRandomValues == "function" && msCrypto.getRandomValues.bind(msCrypto), !uf))
    throw new Error("crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported");
  return uf(qoe);
}
const Woe = /^(?:[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}|00000000-0000-0000-0000-000000000000)$/i;
function Zoe(e) {
  return typeof e == "string" && Woe.test(e);
}
var wn = [];
for (var Fm = 0; Fm < 256; ++Fm)
  wn.push((Fm + 256).toString(16).substr(1));
function Goe(e) {
  var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0, n = (wn[e[t + 0]] + wn[e[t + 1]] + wn[e[t + 2]] + wn[e[t + 3]] + "-" + wn[e[t + 4]] + wn[e[t + 5]] + "-" + wn[e[t + 6]] + wn[e[t + 7]] + "-" + wn[e[t + 8]] + wn[e[t + 9]] + "-" + wn[e[t + 10]] + wn[e[t + 11]] + wn[e[t + 12]] + wn[e[t + 13]] + wn[e[t + 14]] + wn[e[t + 15]]).toLowerCase();
  if (!Zoe(n))
    throw TypeError("Stringified UUID is invalid");
  return n;
}
function Yoe(e, t, n) {
  e = e || {};
  var r = e.random || (e.rng || Hoe)();
  return r[6] = r[6] & 15 | 64, r[8] = r[8] & 63 | 128, Goe(r);
}
const Qoe = (e) => {
  const t = [];
  for (let n = 0; n < e.length; n++) {
    const r = e.item(n);
    r && t.push(r);
  }
  return t;
}, mse = ({
  children: e,
  onChange: t,
  className: n
}) => {
  const r = ve(Yoe());
  return /* @__PURE__ */ I.jsxs("div", { className: `${n} cursor-pointer`, children: [
    /* @__PURE__ */ I.jsx(
      "label",
      {
        htmlFor: r.current,
        onClick: (i) => i.stopPropagation(),
        className: "cursor-pointer",
        onKeyDown: (i) => {
          i.key === "Enter" && i.stopPropagation();
        },
        children: e
      }
    ),
    /* @__PURE__ */ I.jsx(
      "input",
      {
        onClick: (i) => i.stopPropagation(),
        onChange: (i) => {
          t(i.target.files ? Qoe(i.target.files) : []);
        },
        className: "absolute w-0 h-0",
        type: "file",
        id: r.current
      }
    )
  ] });
}, vse = ({ name: e, ...t }) => {
  const [n, r] = O6(e), { capture: i, ...o } = t;
  return /* @__PURE__ */ I.jsxs("div", { children: [
    /* @__PURE__ */ I.jsx(pd, { ...o, ...n, placeholder: t.placeholder || e }),
    r.touched && r.error && /* @__PURE__ */ I.jsx(UV, { children: r.error })
  ] });
};
function gse({ area: e, children: t, className: n }) {
  return /* @__PURE__ */ I.jsx("div", { className: `${n || ""}`, style: { gridArea: e }, children: t });
}
var Vf = { exports: {} }, Joe = Vf.exports, HS;
function Xoe() {
  return HS || (HS = 1, (function(e, t) {
    (function(r, i) {
      e.exports = i(H);
    })(Joe, (n) => (
      /******/
      (() => {
        var r = {
          /***/
          "./node_modules/css-mediaquery/index.js": (
            /*!**********************************************!*\
              !*** ./node_modules/css-mediaquery/index.js ***!
              \**********************************************/
            /***/
            ((s, l) => {
              l.match = h, l.parse = v;
              var u = /(?:(only|not)?\s*([^\s\(\)]+)(?:\s*and)?\s*)?(.+)?/i, c = /\(\s*([^\s\:\)]+)\s*(?:\:\s*([^\s\)]+))?\s*\)/, f = /^(?:(min|max)-)?(.+)/, d = /(em|rem|px|cm|mm|in|pt|pc)?$/, p = /(dpi|dpcm|dppx)?$/;
              function h(x, w) {
                return v(x).some(function($) {
                  var k = $.inverse, D = $.type === "all" || w.type === $.type;
                  if (D && k || !(D || k))
                    return !1;
                  var E = $.expressions.every(function(b) {
                    var y = b.feature, S = b.modifier, P = b.value, M = w[y];
                    if (!M)
                      return !1;
                    switch (y) {
                      case "orientation":
                      case "scan":
                        return M.toLowerCase() === P.toLowerCase();
                      case "width":
                      case "height":
                      case "device-width":
                      case "device-height":
                        P = _(P), M = _(M);
                        break;
                      case "resolution":
                        P = g(P), M = g(M);
                        break;
                      case "aspect-ratio":
                      case "device-aspect-ratio":
                      case /* Deprecated */
                      "device-pixel-ratio":
                        P = m(P), M = m(M);
                        break;
                      case "grid":
                      case "color":
                      case "color-index":
                      case "monochrome":
                        P = parseInt(P, 10) || 1, M = parseInt(M, 10) || 0;
                        break;
                    }
                    switch (S) {
                      case "min":
                        return M >= P;
                      case "max":
                        return M <= P;
                      default:
                        return M === P;
                    }
                  });
                  return E && !k || !E && k;
                });
              }
              function v(x) {
                return x.split(",").map(function(w) {
                  w = w.trim();
                  var $ = w.match(u), k = $[1], D = $[2], E = $[3] || "", b = {};
                  return b.inverse = !!k && k.toLowerCase() === "not", b.type = D ? D.toLowerCase() : "all", E = E.match(/\([^\)]+\)/g) || [], b.expressions = E.map(function(y) {
                    var S = y.match(c), P = S[1].toLowerCase().match(f);
                    return {
                      modifier: P[1],
                      feature: P[2],
                      value: S[2]
                    };
                  }), b;
                });
              }
              function m(x) {
                var w = Number(x), $;
                return w || ($ = x.match(/^(\d+)\s*\/\s*(\d+)$/), w = $[1] / $[2]), w;
              }
              function g(x) {
                var w = parseFloat(x), $ = String(x).match(p)[1];
                switch ($) {
                  case "dpcm":
                    return w / 2.54;
                  case "dppx":
                    return w * 96;
                  default:
                    return w;
                }
              }
              function _(x) {
                var w = parseFloat(x), $ = String(x).match(d)[1];
                switch ($) {
                  case "em":
                    return w * 16;
                  case "rem":
                    return w * 16;
                  case "cm":
                    return w * 96 / 2.54;
                  case "mm":
                    return w * 96 / 2.54 / 10;
                  case "in":
                    return w * 96;
                  case "pt":
                    return w * 72;
                  case "pc":
                    return w * 72 / 12;
                  default:
                    return w;
                }
              }
            })
          ),
          /***/
          "./node_modules/hyphenate-style-name/index.js": (
            /*!****************************************************!*\
              !*** ./node_modules/hyphenate-style-name/index.js ***!
              \****************************************************/
            /***/
            ((s, l, u) => {
              u.r(l), u.d(l, {
                /* harmony export */
                default: () => v
                /* harmony export */
              });
              var c = /[A-Z]/g, f = /^ms-/, d = {};
              function p(m) {
                return "-" + m.toLowerCase();
              }
              function h(m) {
                if (d.hasOwnProperty(m))
                  return d[m];
                var g = m.replace(c, p);
                return d[m] = f.test(g) ? "-" + g : g;
              }
              const v = h;
            })
          ),
          /***/
          "./node_modules/matchmediaquery/index.js": (
            /*!***********************************************!*\
              !*** ./node_modules/matchmediaquery/index.js ***!
              \***********************************************/
            /***/
            ((s, l, u) => {
              var c = u(
                /*! css-mediaquery */
                "./node_modules/css-mediaquery/index.js"
              ).match, f = typeof window < "u" ? window.matchMedia : null;
              function d(h, v, m) {
                var g = this;
                if (f && !m) {
                  var _ = f.call(window, h);
                  this.matches = _.matches, this.media = _.media, _.addListener($);
                } else
                  this.matches = c(h, v), this.media = h;
                this.addListener = x, this.removeListener = w, this.dispose = k;
                function x(D) {
                  _ && _.addListener(D);
                }
                function w(D) {
                  _ && _.removeListener(D);
                }
                function $(D) {
                  g.matches = D.matches, g.media = D.media;
                }
                function k() {
                  _ && _.removeListener($);
                }
              }
              function p(h, v, m) {
                return new d(h, v, m);
              }
              s.exports = p;
            })
          ),
          /***/
          "./node_modules/object-assign/index.js": (
            /*!*********************************************!*\
              !*** ./node_modules/object-assign/index.js ***!
              \*********************************************/
            /***/
            ((s) => {
              /*
              object-assign
              (c) Sindre Sorhus
              @license MIT
              */
              var l = Object.getOwnPropertySymbols, u = Object.prototype.hasOwnProperty, c = Object.prototype.propertyIsEnumerable;
              function f(p) {
                if (p == null)
                  throw new TypeError("Object.assign cannot be called with null or undefined");
                return Object(p);
              }
              function d() {
                try {
                  if (!Object.assign)
                    return !1;
                  var p = new String("abc");
                  if (p[5] = "de", Object.getOwnPropertyNames(p)[0] === "5")
                    return !1;
                  for (var h = {}, v = 0; v < 10; v++)
                    h["_" + String.fromCharCode(v)] = v;
                  var m = Object.getOwnPropertyNames(h).map(function(_) {
                    return h[_];
                  });
                  if (m.join("") !== "0123456789")
                    return !1;
                  var g = {};
                  return "abcdefghijklmnopqrst".split("").forEach(function(_) {
                    g[_] = _;
                  }), Object.keys(Object.assign({}, g)).join("") === "abcdefghijklmnopqrst";
                } catch {
                  return !1;
                }
              }
              s.exports = d() ? Object.assign : function(p, h) {
                for (var v, m = f(p), g, _ = 1; _ < arguments.length; _++) {
                  v = Object(arguments[_]);
                  for (var x in v)
                    u.call(v, x) && (m[x] = v[x]);
                  if (l) {
                    g = l(v);
                    for (var w = 0; w < g.length; w++)
                      c.call(v, g[w]) && (m[g[w]] = v[g[w]]);
                  }
                }
                return m;
              };
            })
          ),
          /***/
          "./node_modules/prop-types/checkPropTypes.js": (
            /*!***************************************************!*\
              !*** ./node_modules/prop-types/checkPropTypes.js ***!
              \***************************************************/
            /***/
            ((s, l, u) => {
              var c = function() {
              };
              {
                var f = u(
                  /*! ./lib/ReactPropTypesSecret */
                  "./node_modules/prop-types/lib/ReactPropTypesSecret.js"
                ), d = {}, p = u(
                  /*! ./lib/has */
                  "./node_modules/prop-types/lib/has.js"
                );
                c = function(v) {
                  var m = "Warning: " + v;
                  typeof console < "u" && console.error(m);
                  try {
                    throw new Error(m);
                  } catch {
                  }
                };
              }
              function h(v, m, g, _, x) {
                for (var w in v)
                  if (p(v, w)) {
                    var $;
                    try {
                      if (typeof v[w] != "function") {
                        var k = Error(
                          (_ || "React class") + ": " + g + " type `" + w + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof v[w] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`."
                        );
                        throw k.name = "Invariant Violation", k;
                      }
                      $ = v[w](m, w, _, g, null, f);
                    } catch (E) {
                      $ = E;
                    }
                    if ($ && !($ instanceof Error) && c(
                      (_ || "React class") + ": type specification of " + g + " `" + w + "` is invalid; the type checker function must return `null` or an `Error` but returned a " + typeof $ + ". You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument)."
                    ), $ instanceof Error && !($.message in d)) {
                      d[$.message] = !0;
                      var D = x ? x() : "";
                      c(
                        "Failed " + g + " type: " + $.message + (D ?? "")
                      );
                    }
                  }
              }
              h.resetWarningCache = function() {
                d = {};
              }, s.exports = h;
            })
          ),
          /***/
          "./node_modules/prop-types/factoryWithTypeCheckers.js": (
            /*!************************************************************!*\
              !*** ./node_modules/prop-types/factoryWithTypeCheckers.js ***!
              \************************************************************/
            /***/
            ((s, l, u) => {
              var c = u(
                /*! react-is */
                "./node_modules/react-is/index.js"
              ), f = u(
                /*! object-assign */
                "./node_modules/object-assign/index.js"
              ), d = u(
                /*! ./lib/ReactPropTypesSecret */
                "./node_modules/prop-types/lib/ReactPropTypesSecret.js"
              ), p = u(
                /*! ./lib/has */
                "./node_modules/prop-types/lib/has.js"
              ), h = u(
                /*! ./checkPropTypes */
                "./node_modules/prop-types/checkPropTypes.js"
              ), v = function() {
              };
              v = function(g) {
                var _ = "Warning: " + g;
                typeof console < "u" && console.error(_);
                try {
                  throw new Error(_);
                } catch {
                }
              };
              function m() {
                return null;
              }
              s.exports = function(g, _) {
                var x = typeof Symbol == "function" && Symbol.iterator, w = "@@iterator";
                function $(O) {
                  var R = O && (x && O[x] || O[w]);
                  if (typeof R == "function")
                    return R;
                }
                var k = "<<anonymous>>", D = {
                  array: S("array"),
                  bigint: S("bigint"),
                  bool: S("boolean"),
                  func: S("function"),
                  number: S("number"),
                  object: S("object"),
                  string: S("string"),
                  symbol: S("symbol"),
                  any: P(),
                  arrayOf: M,
                  element: T(),
                  elementType: V(),
                  instanceOf: z,
                  node: C(),
                  objectOf: B,
                  oneOf: U,
                  oneOfType: N,
                  shape: re,
                  exact: ie
                };
                function E(O, R) {
                  return O === R ? O !== 0 || 1 / O === 1 / R : O !== O && R !== R;
                }
                function b(O, R) {
                  this.message = O, this.data = R && typeof R == "object" ? R : {}, this.stack = "";
                }
                b.prototype = Error.prototype;
                function y(O) {
                  var R = {}, j = 0;
                  function q(ae, te, ue, Pe, de, Ee, ce) {
                    if (Pe = Pe || k, Ee = Ee || ue, ce !== d) {
                      if (_) {
                        var Ue = new Error(
                          "Calling PropTypes validators directly is not supported by the `prop-types` package. Use `PropTypes.checkPropTypes()` to call them. Read more at http://fb.me/use-check-prop-types"
                        );
                        throw Ue.name = "Invariant Violation", Ue;
                      } else if (typeof console < "u") {
                        var et = Pe + ":" + ue;
                        !R[et] && // Avoid spamming the console because they are often not actionable except for lib authors
                        j < 3 && (v(
                          "You are manually calling a React.PropTypes validation function for the `" + Ee + "` prop on `" + Pe + "`. This is deprecated and will throw in the standalone `prop-types` package. You may be seeing this warning due to a third-party PropTypes library. See https://fb.me/react-warning-dont-call-proptypes for details."
                        ), R[et] = !0, j++);
                      }
                    }
                    return te[ue] == null ? ae ? te[ue] === null ? new b("The " + de + " `" + Ee + "` is marked as required " + ("in `" + Pe + "`, but its value is `null`.")) : new b("The " + de + " `" + Ee + "` is marked as required in " + ("`" + Pe + "`, but its value is `undefined`.")) : null : O(te, ue, Pe, de, Ee);
                  }
                  var Y = q.bind(null, !1);
                  return Y.isRequired = q.bind(null, !0), Y;
                }
                function S(O) {
                  function R(j, q, Y, ae, te, ue) {
                    var Pe = j[q], de = me(Pe);
                    if (de !== O) {
                      var Ee = fe(Pe);
                      return new b(
                        "Invalid " + ae + " `" + te + "` of type " + ("`" + Ee + "` supplied to `" + Y + "`, expected ") + ("`" + O + "`."),
                        { expectedType: O }
                      );
                    }
                    return null;
                  }
                  return y(R);
                }
                function P() {
                  return y(m);
                }
                function M(O) {
                  function R(j, q, Y, ae, te) {
                    if (typeof O != "function")
                      return new b("Property `" + te + "` of component `" + Y + "` has invalid PropType notation inside arrayOf.");
                    var ue = j[q];
                    if (!Array.isArray(ue)) {
                      var Pe = me(ue);
                      return new b("Invalid " + ae + " `" + te + "` of type " + ("`" + Pe + "` supplied to `" + Y + "`, expected an array."));
                    }
                    for (var de = 0; de < ue.length; de++) {
                      var Ee = O(ue, de, Y, ae, te + "[" + de + "]", d);
                      if (Ee instanceof Error)
                        return Ee;
                    }
                    return null;
                  }
                  return y(R);
                }
                function T() {
                  function O(R, j, q, Y, ae) {
                    var te = R[j];
                    if (!g(te)) {
                      var ue = me(te);
                      return new b("Invalid " + Y + " `" + ae + "` of type " + ("`" + ue + "` supplied to `" + q + "`, expected a single ReactElement."));
                    }
                    return null;
                  }
                  return y(O);
                }
                function V() {
                  function O(R, j, q, Y, ae) {
                    var te = R[j];
                    if (!c.isValidElementType(te)) {
                      var ue = me(te);
                      return new b("Invalid " + Y + " `" + ae + "` of type " + ("`" + ue + "` supplied to `" + q + "`, expected a single ReactElement type."));
                    }
                    return null;
                  }
                  return y(O);
                }
                function z(O) {
                  function R(j, q, Y, ae, te) {
                    if (!(j[q] instanceof O)) {
                      var ue = O.name || k, Pe = A(j[q]);
                      return new b("Invalid " + ae + " `" + te + "` of type " + ("`" + Pe + "` supplied to `" + Y + "`, expected ") + ("instance of `" + ue + "`."));
                    }
                    return null;
                  }
                  return y(R);
                }
                function U(O) {
                  if (!Array.isArray(O))
                    return arguments.length > 1 ? v(
                      "Invalid arguments supplied to oneOf, expected an array, got " + arguments.length + " arguments. A common mistake is to write oneOf(x, y, z) instead of oneOf([x, y, z])."
                    ) : v("Invalid argument supplied to oneOf, expected an array."), m;
                  function R(j, q, Y, ae, te) {
                    for (var ue = j[q], Pe = 0; Pe < O.length; Pe++)
                      if (E(ue, O[Pe]))
                        return null;
                    var de = JSON.stringify(O, function(ce, Ue) {
                      var et = fe(Ue);
                      return et === "symbol" ? String(Ue) : Ue;
                    });
                    return new b("Invalid " + ae + " `" + te + "` of value `" + String(ue) + "` " + ("supplied to `" + Y + "`, expected one of " + de + "."));
                  }
                  return y(R);
                }
                function B(O) {
                  function R(j, q, Y, ae, te) {
                    if (typeof O != "function")
                      return new b("Property `" + te + "` of component `" + Y + "` has invalid PropType notation inside objectOf.");
                    var ue = j[q], Pe = me(ue);
                    if (Pe !== "object")
                      return new b("Invalid " + ae + " `" + te + "` of type " + ("`" + Pe + "` supplied to `" + Y + "`, expected an object."));
                    for (var de in ue)
                      if (p(ue, de)) {
                        var Ee = O(ue, de, Y, ae, te + "." + de, d);
                        if (Ee instanceof Error)
                          return Ee;
                      }
                    return null;
                  }
                  return y(R);
                }
                function N(O) {
                  if (!Array.isArray(O))
                    return v("Invalid argument supplied to oneOfType, expected an instance of array."), m;
                  for (var R = 0; R < O.length; R++) {
                    var j = O[R];
                    if (typeof j != "function")
                      return v(
                        "Invalid argument supplied to oneOfType. Expected an array of check functions, but received " + Q(j) + " at index " + R + "."
                      ), m;
                  }
                  function q(Y, ae, te, ue, Pe) {
                    for (var de = [], Ee = 0; Ee < O.length; Ee++) {
                      var ce = O[Ee], Ue = ce(Y, ae, te, ue, Pe, d);
                      if (Ue == null)
                        return null;
                      Ue.data && p(Ue.data, "expectedType") && de.push(Ue.data.expectedType);
                    }
                    var et = de.length > 0 ? ", expected one of type [" + de.join(", ") + "]" : "";
                    return new b("Invalid " + ue + " `" + Pe + "` supplied to " + ("`" + te + "`" + et + "."));
                  }
                  return y(q);
                }
                function C() {
                  function O(R, j, q, Y, ae) {
                    return X(R[j]) ? null : new b("Invalid " + Y + " `" + ae + "` supplied to " + ("`" + q + "`, expected a ReactNode."));
                  }
                  return y(O);
                }
                function G(O, R, j, q, Y) {
                  return new b(
                    (O || "React class") + ": " + R + " type `" + j + "." + q + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + Y + "`."
                  );
                }
                function re(O) {
                  function R(j, q, Y, ae, te) {
                    var ue = j[q], Pe = me(ue);
                    if (Pe !== "object")
                      return new b("Invalid " + ae + " `" + te + "` of type `" + Pe + "` " + ("supplied to `" + Y + "`, expected `object`."));
                    for (var de in O) {
                      var Ee = O[de];
                      if (typeof Ee != "function")
                        return G(Y, ae, te, de, fe(Ee));
                      var ce = Ee(ue, de, Y, ae, te + "." + de, d);
                      if (ce)
                        return ce;
                    }
                    return null;
                  }
                  return y(R);
                }
                function ie(O) {
                  function R(j, q, Y, ae, te) {
                    var ue = j[q], Pe = me(ue);
                    if (Pe !== "object")
                      return new b("Invalid " + ae + " `" + te + "` of type `" + Pe + "` " + ("supplied to `" + Y + "`, expected `object`."));
                    var de = f({}, j[q], O);
                    for (var Ee in de) {
                      var ce = O[Ee];
                      if (p(O, Ee) && typeof ce != "function")
                        return G(Y, ae, te, Ee, fe(ce));
                      if (!ce)
                        return new b(
                          "Invalid " + ae + " `" + te + "` key `" + Ee + "` supplied to `" + Y + "`.\nBad object: " + JSON.stringify(j[q], null, "  ") + `
Valid keys: ` + JSON.stringify(Object.keys(O), null, "  ")
                        );
                      var Ue = ce(ue, Ee, Y, ae, te + "." + Ee, d);
                      if (Ue)
                        return Ue;
                    }
                    return null;
                  }
                  return y(R);
                }
                function X(O) {
                  switch (typeof O) {
                    case "number":
                    case "string":
                    case "undefined":
                      return !0;
                    case "boolean":
                      return !O;
                    case "object":
                      if (Array.isArray(O))
                        return O.every(X);
                      if (O === null || g(O))
                        return !0;
                      var R = $(O);
                      if (R) {
                        var j = R.call(O), q;
                        if (R !== O.entries) {
                          for (; !(q = j.next()).done; )
                            if (!X(q.value))
                              return !1;
                        } else
                          for (; !(q = j.next()).done; ) {
                            var Y = q.value;
                            if (Y && !X(Y[1]))
                              return !1;
                          }
                      } else
                        return !1;
                      return !0;
                    default:
                      return !1;
                  }
                }
                function Se(O, R) {
                  return O === "symbol" ? !0 : R ? R["@@toStringTag"] === "Symbol" || typeof Symbol == "function" && R instanceof Symbol : !1;
                }
                function me(O) {
                  var R = typeof O;
                  return Array.isArray(O) ? "array" : O instanceof RegExp ? "object" : Se(R, O) ? "symbol" : R;
                }
                function fe(O) {
                  if (typeof O > "u" || O === null)
                    return "" + O;
                  var R = me(O);
                  if (R === "object") {
                    if (O instanceof Date)
                      return "date";
                    if (O instanceof RegExp)
                      return "regexp";
                  }
                  return R;
                }
                function Q(O) {
                  var R = fe(O);
                  switch (R) {
                    case "array":
                    case "object":
                      return "an " + R;
                    case "boolean":
                    case "date":
                    case "regexp":
                      return "a " + R;
                    default:
                      return R;
                  }
                }
                function A(O) {
                  return !O.constructor || !O.constructor.name ? k : O.constructor.name;
                }
                return D.checkPropTypes = h, D.resetWarningCache = h.resetWarningCache, D.PropTypes = D, D;
              };
            })
          ),
          /***/
          "./node_modules/prop-types/index.js": (
            /*!******************************************!*\
              !*** ./node_modules/prop-types/index.js ***!
              \******************************************/
            /***/
            ((s, l, u) => {
              {
                var c = u(
                  /*! react-is */
                  "./node_modules/react-is/index.js"
                ), f = !0;
                s.exports = u(
                  /*! ./factoryWithTypeCheckers */
                  "./node_modules/prop-types/factoryWithTypeCheckers.js"
                )(c.isElement, f);
              }
            })
          ),
          /***/
          "./node_modules/prop-types/lib/ReactPropTypesSecret.js": (
            /*!*************************************************************!*\
              !*** ./node_modules/prop-types/lib/ReactPropTypesSecret.js ***!
              \*************************************************************/
            /***/
            ((s) => {
              var l = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
              s.exports = l;
            })
          ),
          /***/
          "./node_modules/prop-types/lib/has.js": (
            /*!********************************************!*\
              !*** ./node_modules/prop-types/lib/has.js ***!
              \********************************************/
            /***/
            ((s) => {
              s.exports = Function.call.bind(Object.prototype.hasOwnProperty);
            })
          ),
          /***/
          "./node_modules/react-is/cjs/react-is.development.js": (
            /*!***********************************************************!*\
              !*** ./node_modules/react-is/cjs/react-is.development.js ***!
              \***********************************************************/
            /***/
            ((s, l) => {
              /** @license React v16.13.1
               * react-is.development.js
               *
               * Copyright (c) Facebook, Inc. and its affiliates.
               *
               * This source code is licensed under the MIT license found in the
               * LICENSE file in the root directory of this source tree.
               */
              (function() {
                var u = typeof Symbol == "function" && Symbol.for, c = u ? Symbol.for("react.element") : 60103, f = u ? Symbol.for("react.portal") : 60106, d = u ? Symbol.for("react.fragment") : 60107, p = u ? Symbol.for("react.strict_mode") : 60108, h = u ? Symbol.for("react.profiler") : 60114, v = u ? Symbol.for("react.provider") : 60109, m = u ? Symbol.for("react.context") : 60110, g = u ? Symbol.for("react.async_mode") : 60111, _ = u ? Symbol.for("react.concurrent_mode") : 60111, x = u ? Symbol.for("react.forward_ref") : 60112, w = u ? Symbol.for("react.suspense") : 60113, $ = u ? Symbol.for("react.suspense_list") : 60120, k = u ? Symbol.for("react.memo") : 60115, D = u ? Symbol.for("react.lazy") : 60116, E = u ? Symbol.for("react.block") : 60121, b = u ? Symbol.for("react.fundamental") : 60117, y = u ? Symbol.for("react.responder") : 60118, S = u ? Symbol.for("react.scope") : 60119;
                function P(ce) {
                  return typeof ce == "string" || typeof ce == "function" || // Note: its typeof might be other than 'symbol' or 'number' if it's a polyfill.
                  ce === d || ce === _ || ce === h || ce === p || ce === w || ce === $ || typeof ce == "object" && ce !== null && (ce.$$typeof === D || ce.$$typeof === k || ce.$$typeof === v || ce.$$typeof === m || ce.$$typeof === x || ce.$$typeof === b || ce.$$typeof === y || ce.$$typeof === S || ce.$$typeof === E);
                }
                function M(ce) {
                  if (typeof ce == "object" && ce !== null) {
                    var Ue = ce.$$typeof;
                    switch (Ue) {
                      case c:
                        var et = ce.type;
                        switch (et) {
                          case g:
                          case _:
                          case d:
                          case h:
                          case p:
                          case w:
                            return et;
                          default:
                            var gn = et && et.$$typeof;
                            switch (gn) {
                              case m:
                              case x:
                              case D:
                              case k:
                              case v:
                                return gn;
                              default:
                                return Ue;
                            }
                        }
                      case f:
                        return Ue;
                    }
                  }
                }
                var T = g, V = _, z = m, U = v, B = c, N = x, C = d, G = D, re = k, ie = f, X = h, Se = p, me = w, fe = !1;
                function Q(ce) {
                  return fe || (fe = !0, console.warn("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 17+. Update your code to use ReactIs.isConcurrentMode() instead. It has the exact same API.")), A(ce) || M(ce) === g;
                }
                function A(ce) {
                  return M(ce) === _;
                }
                function O(ce) {
                  return M(ce) === m;
                }
                function R(ce) {
                  return M(ce) === v;
                }
                function j(ce) {
                  return typeof ce == "object" && ce !== null && ce.$$typeof === c;
                }
                function q(ce) {
                  return M(ce) === x;
                }
                function Y(ce) {
                  return M(ce) === d;
                }
                function ae(ce) {
                  return M(ce) === D;
                }
                function te(ce) {
                  return M(ce) === k;
                }
                function ue(ce) {
                  return M(ce) === f;
                }
                function Pe(ce) {
                  return M(ce) === h;
                }
                function de(ce) {
                  return M(ce) === p;
                }
                function Ee(ce) {
                  return M(ce) === w;
                }
                l.AsyncMode = T, l.ConcurrentMode = V, l.ContextConsumer = z, l.ContextProvider = U, l.Element = B, l.ForwardRef = N, l.Fragment = C, l.Lazy = G, l.Memo = re, l.Portal = ie, l.Profiler = X, l.StrictMode = Se, l.Suspense = me, l.isAsyncMode = Q, l.isConcurrentMode = A, l.isContextConsumer = O, l.isContextProvider = R, l.isElement = j, l.isForwardRef = q, l.isFragment = Y, l.isLazy = ae, l.isMemo = te, l.isPortal = ue, l.isProfiler = Pe, l.isStrictMode = de, l.isSuspense = Ee, l.isValidElementType = P, l.typeOf = M;
              })();
            })
          ),
          /***/
          "./node_modules/react-is/index.js": (
            /*!****************************************!*\
              !*** ./node_modules/react-is/index.js ***!
              \****************************************/
            /***/
            ((s, l, u) => {
              s.exports = u(
                /*! ./cjs/react-is.development.js */
                "./node_modules/react-is/cjs/react-is.development.js"
              );
            })
          ),
          /***/
          "./node_modules/shallow-equal/dist/index.esm.js": (
            /*!******************************************************!*\
              !*** ./node_modules/shallow-equal/dist/index.esm.js ***!
              \******************************************************/
            /***/
            ((s, l, u) => {
              u.r(l), u.d(l, {
                /* harmony export */
                shallowEqualArrays: () => (
                  /* binding */
                  f
                ),
                /* harmony export */
                shallowEqualObjects: () => (
                  /* binding */
                  c
                )
                /* harmony export */
              });
              function c(d, p) {
                if (d === p)
                  return !0;
                if (!d || !p)
                  return !1;
                var h = Object.keys(d), v = Object.keys(p), m = h.length;
                if (v.length !== m)
                  return !1;
                for (var g = 0; g < m; g++) {
                  var _ = h[g];
                  if (d[_] !== p[_] || !Object.prototype.hasOwnProperty.call(p, _))
                    return !1;
                }
                return !0;
              }
              function f(d, p) {
                if (d === p)
                  return !0;
                if (!d || !p)
                  return !1;
                var h = d.length;
                if (p.length !== h)
                  return !1;
                for (var v = 0; v < h; v++)
                  if (d[v] !== p[v])
                    return !1;
                return !0;
              }
            })
          ),
          /***/
          "./src/Component.ts": (
            /*!**************************!*\
              !*** ./src/Component.ts ***!
              \**************************/
            /***/
            (function(s, l, u) {
              var c = this && this.__rest || function(h, v) {
                var m = {};
                for (var g in h) Object.prototype.hasOwnProperty.call(h, g) && v.indexOf(g) < 0 && (m[g] = h[g]);
                if (h != null && typeof Object.getOwnPropertySymbols == "function")
                  for (var _ = 0, g = Object.getOwnPropertySymbols(h); _ < g.length; _++)
                    v.indexOf(g[_]) < 0 && Object.prototype.propertyIsEnumerable.call(h, g[_]) && (m[g[_]] = h[g[_]]);
                return m;
              }, f = this && this.__importDefault || function(h) {
                return h && h.__esModule ? h : { default: h };
              };
              Object.defineProperty(l, "__esModule", { value: !0 });
              var d = f(u(
                /*! ./useMediaQuery */
                "./src/useMediaQuery.ts"
              )), p = function(h) {
                var v = h.children, m = h.device, g = h.onChange, _ = c(h, ["children", "device", "onChange"]), x = (0, d.default)(_, m, g);
                return typeof v == "function" ? v(x) : x ? v : null;
              };
              l.default = p;
            })
          ),
          /***/
          "./src/Context.ts": (
            /*!************************!*\
              !*** ./src/Context.ts ***!
              \************************/
            /***/
            ((s, l, u) => {
              Object.defineProperty(l, "__esModule", { value: !0 });
              var c = u(
                /*! react */
                "react"
              ), f = (0, c.createContext)(void 0);
              l.default = f;
            })
          ),
          /***/
          "./src/index.ts": (
            /*!**********************!*\
              !*** ./src/index.ts ***!
              \**********************/
            /***/
            (function(s, l, u) {
              var c = this && this.__importDefault || function(v) {
                return v && v.__esModule ? v : { default: v };
              };
              Object.defineProperty(l, "__esModule", { value: !0 }), l.Context = l.toQuery = l.useMediaQuery = l.default = void 0;
              var f = c(u(
                /*! ./useMediaQuery */
                "./src/useMediaQuery.ts"
              ));
              l.useMediaQuery = f.default;
              var d = c(u(
                /*! ./Component */
                "./src/Component.ts"
              ));
              l.default = d.default;
              var p = c(u(
                /*! ./toQuery */
                "./src/toQuery.ts"
              ));
              l.toQuery = p.default;
              var h = c(u(
                /*! ./Context */
                "./src/Context.ts"
              ));
              l.Context = h.default;
            })
          ),
          /***/
          "./src/mediaQuery.ts": (
            /*!***************************!*\
              !*** ./src/mediaQuery.ts ***!
              \***************************/
            /***/
            (function(s, l, u) {
              var c = this && this.__assign || function() {
                return c = Object.assign || function(w) {
                  for (var $, k = 1, D = arguments.length; k < D; k++) {
                    $ = arguments[k];
                    for (var E in $) Object.prototype.hasOwnProperty.call($, E) && (w[E] = $[E]);
                  }
                  return w;
                }, c.apply(this, arguments);
              }, f = this && this.__rest || function(w, $) {
                var k = {};
                for (var D in w) Object.prototype.hasOwnProperty.call(w, D) && $.indexOf(D) < 0 && (k[D] = w[D]);
                if (w != null && typeof Object.getOwnPropertySymbols == "function")
                  for (var E = 0, D = Object.getOwnPropertySymbols(w); E < D.length; E++)
                    $.indexOf(D[E]) < 0 && Object.prototype.propertyIsEnumerable.call(w, D[E]) && (k[D[E]] = w[D[E]]);
                return k;
              }, d = this && this.__importDefault || function(w) {
                return w && w.__esModule ? w : { default: w };
              };
              Object.defineProperty(l, "__esModule", { value: !0 });
              var p = d(u(
                /*! prop-types */
                "./node_modules/prop-types/index.js"
              )), h = p.default.oneOfType([
                p.default.string,
                p.default.number
              ]), v = {
                all: p.default.bool,
                grid: p.default.bool,
                aural: p.default.bool,
                braille: p.default.bool,
                handheld: p.default.bool,
                print: p.default.bool,
                projection: p.default.bool,
                screen: p.default.bool,
                tty: p.default.bool,
                tv: p.default.bool,
                embossed: p.default.bool
              }, m = {
                orientation: p.default.oneOf([
                  "portrait",
                  "landscape"
                ]),
                scan: p.default.oneOf([
                  "progressive",
                  "interlace"
                ]),
                aspectRatio: p.default.string,
                deviceAspectRatio: p.default.string,
                height: h,
                deviceHeight: h,
                width: h,
                deviceWidth: h,
                color: p.default.bool,
                colorIndex: p.default.bool,
                monochrome: p.default.bool,
                resolution: h,
                type: Object.keys(v)
              };
              m.type;
              var g = f(
                m,
                ["type"]
              ), _ = c({ minAspectRatio: p.default.string, maxAspectRatio: p.default.string, minDeviceAspectRatio: p.default.string, maxDeviceAspectRatio: p.default.string, minHeight: h, maxHeight: h, minDeviceHeight: h, maxDeviceHeight: h, minWidth: h, maxWidth: h, minDeviceWidth: h, maxDeviceWidth: h, minColor: p.default.number, maxColor: p.default.number, minColorIndex: p.default.number, maxColorIndex: p.default.number, minMonochrome: p.default.number, maxMonochrome: p.default.number, minResolution: h, maxResolution: h }, g), x = c(c({}, v), _);
              l.default = {
                all: x,
                types: v,
                matchers: m,
                features: _
              };
            })
          ),
          /***/
          "./src/toQuery.ts": (
            /*!************************!*\
              !*** ./src/toQuery.ts ***!
              \************************/
            /***/
            (function(s, l, u) {
              var c = this && this.__importDefault || function(g) {
                return g && g.__esModule ? g : { default: g };
              };
              Object.defineProperty(l, "__esModule", { value: !0 });
              var f = c(u(
                /*! hyphenate-style-name */
                "./node_modules/hyphenate-style-name/index.js"
              )), d = c(u(
                /*! ./mediaQuery */
                "./src/mediaQuery.ts"
              )), p = function(g) {
                return "not ".concat(g);
              }, h = function(g, _) {
                var x = (0, f.default)(g);
                return typeof _ == "number" && (_ = "".concat(_, "px")), _ === !0 ? x : _ === !1 ? p(x) : "(".concat(x, ": ").concat(_, ")");
              }, v = function(g) {
                return g.join(" and ");
              }, m = function(g) {
                var _ = [];
                return Object.keys(d.default.all).forEach(function(x) {
                  var w = g[x];
                  w != null && _.push(h(x, w));
                }), v(_);
              };
              l.default = m;
            })
          ),
          /***/
          "./src/useMediaQuery.ts": (
            /*!******************************!*\
              !*** ./src/useMediaQuery.ts ***!
              \******************************/
            /***/
            (function(s, l, u) {
              var c = this && this.__importDefault || function(b) {
                return b && b.__esModule ? b : { default: b };
              };
              Object.defineProperty(l, "__esModule", { value: !0 });
              var f = u(
                /*! react */
                "react"
              ), d = c(u(
                /*! matchmediaquery */
                "./node_modules/matchmediaquery/index.js"
              )), p = c(u(
                /*! hyphenate-style-name */
                "./node_modules/hyphenate-style-name/index.js"
              )), h = u(
                /*! shallow-equal */
                "./node_modules/shallow-equal/dist/index.esm.js"
              ), v = c(u(
                /*! ./toQuery */
                "./src/toQuery.ts"
              )), m = c(u(
                /*! ./Context */
                "./src/Context.ts"
              )), g = function(b) {
                return b.query || (0, v.default)(b);
              }, _ = function(b) {
                if (b) {
                  var y = Object.keys(b);
                  return y.reduce(function(S, P) {
                    return S[(0, p.default)(P)] = b[P], S;
                  }, {});
                }
              }, x = function() {
                var b = (0, f.useRef)(!1);
                return (0, f.useEffect)(function() {
                  b.current = !0;
                }, []), b.current;
              }, w = function(b) {
                var y = (0, f.useContext)(m.default), S = function() {
                  return _(b) || _(y);
                }, P = (0, f.useState)(S), M = P[0], T = P[1];
                return (0, f.useEffect)(function() {
                  var V = S();
                  (0, h.shallowEqualObjects)(M, V) || T(V);
                }, [b, y]), M;
              }, $ = function(b) {
                var y = function() {
                  return g(b);
                }, S = (0, f.useState)(y), P = S[0], M = S[1];
                return (0, f.useEffect)(function() {
                  var T = y();
                  P !== T && M(T);
                }, [b]), P;
              }, k = function(b, y) {
                var S = function() {
                  return (0, d.default)(b, y || {}, !!y);
                }, P = (0, f.useState)(S), M = P[0], T = P[1], V = x();
                return (0, f.useEffect)(function() {
                  if (V) {
                    var z = S();
                    return T(z), function() {
                      z && z.dispose();
                    };
                  }
                }, [b, y]), M;
              }, D = function(b) {
                var y = (0, f.useState)(b.matches), S = y[0], P = y[1];
                return (0, f.useEffect)(function() {
                  var M = function(T) {
                    P(T.matches);
                  };
                  return b.addListener(M), P(b.matches), function() {
                    b.removeListener(M);
                  };
                }, [b]), S;
              }, E = function(b, y, S) {
                var P = w(y), M = $(b);
                if (!M)
                  throw new Error("Invalid or missing MediaQuery!");
                var T = k(M, P), V = D(T), z = x();
                return (0, f.useEffect)(function() {
                  z && S && S(V);
                }, [V]), (0, f.useEffect)(function() {
                  return function() {
                    T && T.dispose();
                  };
                }, []), V;
              };
              l.default = E;
            })
          ),
          /***/
          react: (
            /*!**************************************************************************************!*\
              !*** external {"commonjs":"react","commonjs2":"react","amd":"react","root":"React"} ***!
              \**************************************************************************************/
            /***/
            ((s) => {
              s.exports = n;
            })
          )
          /******/
        }, i = {};
        function o(s) {
          var l = i[s];
          if (l !== void 0)
            return l.exports;
          var u = i[s] = {
            /******/
            // no module.id needed
            /******/
            // no module.loaded needed
            /******/
            exports: {}
            /******/
          };
          return r[s].call(u.exports, u, u.exports, o), u.exports;
        }
        o.d = (s, l) => {
          for (var u in l)
            o.o(l, u) && !o.o(s, u) && Object.defineProperty(s, u, { enumerable: !0, get: l[u] });
        }, o.o = (s, l) => Object.prototype.hasOwnProperty.call(s, l), o.r = (s) => {
          typeof Symbol < "u" && Symbol.toStringTag && Object.defineProperty(s, Symbol.toStringTag, { value: "Module" }), Object.defineProperty(s, "__esModule", { value: !0 });
        };
        var a = o("./src/index.ts");
        return a;
      })()
    ));
  })(Vf)), Vf.exports;
}
var eae = /* @__PURE__ */ Xoe();
const tae = {
  sm: 640,
  md: 768,
  lg: 1024,
  xl: 1280,
  "2xl": 1536
}, e6 = (e) => eae.useMediaQuery({ minWidth: tae[e] }), t6 = He({}), J0 = () => je(t6), nae = ({
  children: e,
  className: t = "",
  style: n = {},
  hideDrawerButton: r = !0
}) => {
  const { menuVisible: i, onMenuToggle: o, layoutRef: a } = J0(), s = e6("sm");
  return a ? ba(
    /* @__PURE__ */ I.jsxs(
      "nav",
      {
        className: rr(
          "col-span-full bg-blue-500 flex justify-start items-center text-white px-4 col-start-1 row-span-1 w-full h-full",
          t
        ),
        style: n,
        children: [
          s && !r && /* @__PURE__ */ I.jsx(
            Rv,
            {
              className: "mr-8",
              sideBarVisible: i,
              onClick: () => o?.(!i)
            }
          ),
          e,
          !s && /* @__PURE__ */ I.jsx(I.Fragment, { children: /* @__PURE__ */ I.jsx(
            Rv,
            {
              sideBarVisible: i,
              onClick: () => o?.(!i)
            }
          ) })
        ]
      }
    ),
    a
  ) : null;
}, rae = ({ children: e }) => {
  const { layoutRef: t } = J0();
  return t ? ba(
    /* @__PURE__ */ I.jsx("main", { className: "w-full h-full overflow-hidden row-start-2 col-start-2 col-span-full", children: e }),
    t
  ) : null;
}, WS = Lr(
  [
    "bg-neutral-200",
    "h-full",
    "overflow-auto",
    "row-start-2",
    "col-span-1",
    "col-start-1"
  ],
  {
    variants: {
      size: {
        sm: ["sm:hidden", "block", "z-50"],
        lg: ["sm:block"]
      }
    }
  }
), iae = ({ children: e }) => {
  const { onMenuToggle: t, menuVisible: n, layoutRef: r } = J0(), i = e6("sm");
  return r ? i ? n ? ba(
    /* @__PURE__ */ I.jsx(
      "aside",
      {
        className: WS({ size: "lg" }),
        children: e
      },
      "app-layout-menu"
    ),
    r
  ) : null : n ? ba(
    /* @__PURE__ */ I.jsxs(
      "aside",
      {
        className: WS({ size: "sm" }),
        children: [
          /* @__PURE__ */ I.jsx(
            "button",
            {
              onClick: () => t?.(!1),
              className: "ml-auto text-neutral-700",
              children: /* @__PURE__ */ I.jsx(yr, { icon: hI, size: "sm" })
            }
          ),
          e
        ]
      },
      "app-layout-menu"
    ),
    r
  ) : null : null;
};
function oae({
  to: e,
  icon: t,
  name: n,
  hasNotifications: r,
  children: i,
  href: o,
  linkProps: a
}) {
  if (!o && !e)
    throw new Error("to or href is required");
  return /* @__PURE__ */ I.jsx(Mj, { children: /* @__PURE__ */ I.jsx("div", { className: "flex flex-col my-2", children: o ? /* @__PURE__ */ I.jsxs(
    "a",
    {
      className: "flex p-2 my-2 list-none rounded-md cursor-pointer hover:bg-neutral-500",
      href: o,
      target: "_blank",
      rel: "noreferrer",
      children: [
        /* @__PURE__ */ I.jsxs("div", { className: "flex align-middle ", children: [
          r && /* @__PURE__ */ I.jsx("div", { className: "absolute w-2.5 h-2.5 transform -translate-x-2 -translate-y-2 bg-red-400 rounded-full" }),
          /* @__PURE__ */ I.jsx(
            yr,
            {
              icon: t,
              color: "gray",
              className: "my-auto mr-6",
              size: "1x"
            }
          ),
          /* @__PURE__ */ I.jsx("p", { children: n })
        ] }),
        /* @__PURE__ */ I.jsx(jd, {}),
        i
      ]
    }
  ) : /* @__PURE__ */ I.jsxs(
    es,
    {
      to: e,
      ...a || {},
      className: "flex p-2 my-2 list-none rounded-md cursor-pointer hover:bg-neutral-500",
      children: [
        /* @__PURE__ */ I.jsxs("div", { className: "flex align-middle ", children: [
          r && /* @__PURE__ */ I.jsx("div", { className: "absolute w-2.5 h-2.5 transform -translate-x-2 -translate-y-2 bg-red-400 rounded-full" }),
          /* @__PURE__ */ I.jsx(
            yr,
            {
              icon: t,
              color: "gray",
              className: "my-auto mr-6",
              size: "1x"
            }
          ),
          /* @__PURE__ */ I.jsx("p", { children: n })
        ] }),
        /* @__PURE__ */ I.jsx(jd, {}),
        i
      ]
    }
  ) }) });
}
const aae = Lr([
  "grid",
  "w-screen",
  "h-screen",
  "overflow-hidden",
  "bg-neutral-100",
  "flex-col",
  "app-layout",
  "grid-cols-[min-content_minmax(0,1fr)]",
  "grid-rows-[6rem_minmax(0,1fr)]"
]), ih = ({
  menuVisible: e = !1,
  children: t,
  onMenuToggle: n
}) => {
  const [r, i] = H.useState(null), [o, a] = H.useState(null), [s, l] = H.useState(null);
  return /* @__PURE__ */ I.jsx(
    t6.Provider,
    {
      value: {
        menuVisible: e,
        menuRef: s,
        onMenuToggle: n,
        layoutRef: r,
        headerRef: o
      },
      children: /* @__PURE__ */ I.jsx(
        "div",
        {
          className: aae(),
          ref: i,
          children: t
        }
      )
    }
  );
};
ih.Header = nae;
ih.Body = rae;
ih.Menu = iae;
ih.Link = oae;
const sae = ({
  onClick: e,
  sideBarVisible: t,
  className: n,
  showMenu: r = !0,
  isLoggedIn: i = !1,
  children: o
}) => /* @__PURE__ */ I.jsxs(
  "nav",
  {
    className: rr(
      "w-screen h-full flex justify-between col-span-12 row-span-1 px-4 bg-blue-500",
      n
    ),
    children: [
      /* @__PURE__ */ I.jsxs("div", { className: "flex", children: [
        r && /* @__PURE__ */ I.jsx(
          Rv,
          {
            sideBarVisible: t,
            onClick: e || (() => null)
          }
        ),
        /* @__PURE__ */ I.jsx(es, { to: "/app", className: "block mx-4 my-auto h-1/2", children: /* @__PURE__ */ I.jsx(X3, { className: "w-8 h-8" }) }),
        /* @__PURE__ */ I.jsx("h1", { className: "my-auto text-xl text-white uppercase font-terminal ", children: o })
      ] }),
      /* @__PURE__ */ I.jsxs(
        $0,
        {
          className: "my-auto",
          button: /* @__PURE__ */ I.jsx(yr, { color: "white", size: "1x", icon: pI }),
          children: [
            i && /* @__PURE__ */ I.jsxs(I.Fragment, { children: [
              /* @__PURE__ */ I.jsx("p", { className: "mb-8 border-b border-opacity-30 border-b-black" }),
              /* @__PURE__ */ I.jsx(es, { className: "menu-item", to: "/app/account", children: "Account" }),
              /* @__PURE__ */ I.jsx(es, { className: "menu-item", to: "/app/account/change-password", children: "Change Password" }),
              /* @__PURE__ */ I.jsx(es, { className: "menu-item", to: "/app/account/tokens", children: "CLI Tokens" }),
              /* @__PURE__ */ I.jsx(
                pa,
                {
                  onAction: async () => {
                  },
                  children: "Logout"
                }
              )
            ] }),
            !i && /* @__PURE__ */ I.jsx(es, { to: "/login", children: /* @__PURE__ */ I.jsx(pa, { children: "Login" }) })
          ]
        }
      )
    ]
  }
), X0 = {};
ui`
    mutation CreateFolder($newFolder: String!, $currentFolder: String!, $s3BucketId: Float) {
  createFolder(
    newFolder: $newFolder
    currentFolder: $currentFolder
    s3BucketId: $s3BucketId
  )
}
    `;
ui`
    mutation DeleteFiles($paths: [S3ObjectInput!]!) {
  deleteFilesResolver(paths: $paths)
}
    `;
ui`
    mutation MoveS3Files($target: S3ObjectInput!, $source: S3ObjectInput!) {
  moveS3Files(target: $target, source: $source)
}
    `;
ui`
    mutation MoveUpAFolder($moveUpAFolderPath: S3ObjectInput!) {
  moveUpAFolder(path: $moveUpAFolderPath)
}
    `;
ui`
    query FileTransfers {
  fileTransfers {
    name
    progress
    id
  }
}
    `;
ui`
    query FolderContents($s3BucketId: Float, $folder: String) {
  folderContents(s3BucketId: $s3BucketId, folder: $folder) {
    contents {
      key
      name
      isFolder
      fullPath
      bucket
    }
    errors
  }
  me {
    id
    awsUsername
  }
}
    `;
ui`
    query folderContentsSearch($search: String!, $s3BucketId: Int) {
  fileSearch(search: $search, s3BucketId: $s3BucketId) {
    results {
      fullPath
      key
      name
      isFolder
      bucket
    }
    errors
  }
}
    `;
const n6 = ui`
    query Me {
  me {
    id
    email
    awsUsername
    firstname
    lastname
    roles {
      role
    }
  }
}
    `;
function lae(e) {
  const t = { ...X0, ...e };
  return cy.useQuery(n6, t);
}
function uae(e) {
  const t = { ...X0, ...e };
  return cy.useLazyQuery(n6, t);
}
ui`
    query PresignedDownloadUrl($bucket: String!, $key: String!, $limit: Float) {
  presignedDownloadUrl(bucket: $bucket, key: $key, limit: $limit)
}
    `;
ui`
    subscription FileTranfersUpdated {
  fileTransfersUpdated {
    progress
    id
    name
  }
}
    `;
const cae = ui`
    subscription TaskQueueLogs($jobId: String!) {
  taskQueueLogs(jobId: $jobId) {
    message
    timestamp
  }
}
    `;
function fae(e) {
  const t = { ...X0, ...e };
  return cy.useSubscription(cae, t);
}
const yse = ({ appBarTitle: e }) => {
  const { data: t } = lae();
  return /* @__PURE__ */ I.jsxs(Un.div, { className: "grid w-screen h-screen bg-neutral-300 grid-rows-[4rem minmax(0, 1fr)] grid-cols-1", children: [
    /* @__PURE__ */ I.jsx(
      sae,
      {
        className: "h-16 bg-blue-600 ",
        onClick: () => null,
        sideBarVisible: !1,
        showMenu: !1,
        isLoggedIn: !!t?.me,
        children: e
      }
    ),
    /* @__PURE__ */ I.jsx("div", { className: "flex justify-around w-full h-full ", children: /* @__PURE__ */ I.jsx("div", { className: "w-full h-full max-w-6xl p-4 overflow-scroll bg-neutral-100", children: /* @__PURE__ */ I.jsx(P6, {}) }) })
  ] });
}, dae = {
  initial: {
    opacity: 0
  },
  in: {
    opacity: 1
  },
  out: {
    opacity: 0
  }
}, pae = ({
  children: e,
  className: t
}) => /* @__PURE__ */ I.jsx(
  Un.div,
  {
    className: rr("w-full min-h-full overflow-scroll", t),
    initial: "initial",
    animate: "in",
    exit: "out",
    variants: dae,
    children: e
  }
), hae = (e) => /* @__PURE__ */ I.jsx("h1", { className: "text-2xl flex-grow border-opacity-25", children: e.children }), mae = ({ children: e, title: t, className: n }) => /* @__PURE__ */ I.jsx("div", { className: `flex py-2 mb-4 border-b border-black ${n}`, children: /* @__PURE__ */ I.jsxs(I.Fragment, { children: [
  typeof t == "string" ? /* @__PURE__ */ I.jsx(hae, { children: t }) : t,
  e
] }) }), bse = () => /* @__PURE__ */ I.jsx(pae, { children: /* @__PURE__ */ I.jsx(mae, { title: "Page not found" }) }), cf = ({ url: e, classname: t }) => /* @__PURE__ */ I.jsx("div", { className: `${t}`, children: /* @__PURE__ */ I.jsx("img", { src: e }) });
m1.GlobalWorkerOptions.workerSrc = `//unpkg.com/pdfjs-dist@${m1.version}/build/pdf.worker.min.mjs`;
const vae = { withCredentials: !0 }, gae = ({ url: e, classname: t }) => {
  const [n, r] = Ke("1.0");
  return /* @__PURE__ */ I.jsxs("div", { children: [
    /* @__PURE__ */ I.jsxs("div", { className: "flex items-center gap-2", children: [
      /* @__PURE__ */ I.jsx(aC, { size: 20 }),
      /* @__PURE__ */ I.jsx(
        "input",
        {
          className: "accent-black",
          type: "range",
          min: "1.0",
          max: "4.0",
          step: 0.25,
          value: n,
          onChange: (i) => r(i.target.value)
        }
      )
    ] }),
    /* @__PURE__ */ I.jsx("div", { className: `${t} w-full overflow-auto self-baseline`, children: /* @__PURE__ */ I.jsx(A6, { file: e, options: vae, children: /* @__PURE__ */ I.jsx(
      D6,
      {
        pageNumber: 1,
        renderTextLayer: !1,
        renderAnnotationLayer: !1,
        canvasBackground: "#F3F4F6",
        scale: parseInt(n)
      }
    ) }) })
  ] });
}, yae = ({ url: e, classname: t }) => {
  const { data: n, error: r } = Zd({
    queryKey: ["download", e],
    queryFn: async () => {
      try {
        return await fetch(e, {
          method: "GET",
          credentials: "include"
        });
      } catch (s) {
        console.error(s);
      }
    }
  }), [i, o] = Ke(null), a = async () => {
    const s = await n?.text();
    s && o(s);
  };
  return ze(() => {
    a();
  }, [n]), i ? /* @__PURE__ */ I.jsx("div", { className: `${t}`, children: /* @__PURE__ */ I.jsx("div", { dangerouslySetInnerHTML: { __html: i } }) }) : /* @__PURE__ */ I.jsx("div", { children: "Sorry, couldn't load this svg" });
};
var Bf = { exports: {} };
/* @license
Papa Parse
v5.5.4
https://github.com/mholt/PapaParse
License: MIT
*/
var bae = Bf.exports, ZS;
function _ae() {
  return ZS || (ZS = 1, (function(e, t) {
    ((n, r) => {
      e.exports = r();
    })(bae, function n() {
      var r = typeof self < "u" ? self : typeof window < "u" ? window : r !== void 0 ? r : {}, i, o = !r.document && !!r.postMessage, a = r.IS_PAPA_WORKER || !1, s = {}, l = 0, u = {};
      function c(b) {
        return b.charCodeAt(0) === 65279 ? b.slice(1) : b;
      }
      function f(b) {
        this._handle = null, this._finished = !1, this._completed = !1, this._halted = !1, this._input = null, this._baseIndex = 0, this._partialLine = "", this._rowCount = 0, this._start = 0, this._nextChunk = null, this.isFirstChunk = !0, this._completeResults = { data: [], errors: [], meta: {} }, function(y) {
          var S = k(y);
          S.chunkSize = parseInt(S.chunkSize), y.step || y.chunk || (S.chunkSize = null), this._handle = new m(S), (this._handle.streamer = this)._config = S;
        }.call(this, b), this.parseChunk = function(y, S) {
          var P = parseInt(this._config.skipFirstNLines) || 0;
          if (this.isFirstChunk && 0 < P) {
            let T = this._config.newline;
            T || (M = this._config.quoteChar || '"', T = this._handle.guessLineEndings(y, M)), y = [...y.split(T).slice(P)].join(T);
          }
          this.isFirstChunk && E(this._config.beforeFirstChunk) && (M = this._config.beforeFirstChunk(y)) !== void 0 && (y = M), this.isFirstChunk = !1, this._halted = !1;
          var P = this._partialLine + y, M = (this._partialLine = "", this._handle.parse(P, this._baseIndex, !this._finished));
          if (!this._handle.paused() && !this._handle.aborted()) {
            if (y = M.meta.cursor, P = (this._finished || (this._partialLine = P.substring(y - this._baseIndex), this._baseIndex = y), M && M.data && (this._rowCount += M.data.length), this._finished || this._config.preview && this._rowCount >= this._config.preview), a) r.postMessage({ results: M, workerId: u.WORKER_ID, finished: P });
            else if (E(this._config.chunk) && !S) {
              if (this._config.chunk(M, this._handle), this._handle.paused() || this._handle.aborted()) return void (this._halted = !0);
              this._completeResults = M = void 0;
            }
            return this._config.step || this._config.chunk || (this._completeResults.data = this._completeResults.data.concat(M.data), this._completeResults.errors = this._completeResults.errors.concat(M.errors), this._completeResults.meta = M.meta), this._completed || !P || !E(this._config.complete) || M && M.meta.aborted || (this._config.complete(this._completeResults, this._input), this._completed = !0), P || M && M.meta.paused || this._nextChunk(), M;
          }
          this._halted = !0;
        }, this._sendError = function(y) {
          E(this._config.error) ? this._config.error(y) : a && this._config.error && r.postMessage({ workerId: u.WORKER_ID, error: y, finished: !1 });
        };
      }
      function d(b) {
        var y;
        (b = b || {}).chunkSize || (b.chunkSize = u.RemoteChunkSize), f.call(this, b), this._nextChunk = o ? function() {
          this._readChunk(), this._chunkLoaded();
        } : function() {
          this._readChunk();
        }, this.stream = function(S) {
          this._input = S, this._nextChunk();
        }, this._readChunk = function() {
          if (this._finished) this._chunkLoaded();
          else {
            if (y = new XMLHttpRequest(), this._config.withCredentials && (y.withCredentials = this._config.withCredentials), o || (y.onload = D(this._chunkLoaded, this), y.onerror = D(this._chunkError, this)), y.open(this._config.downloadRequestBody ? "POST" : "GET", this._input, !o), this._config.downloadRequestHeaders) {
              var S, P = this._config.downloadRequestHeaders;
              for (S in P) y.setRequestHeader(S, P[S]);
            }
            var M;
            this._config.chunkSize && (M = this._start + this._config.chunkSize - 1, y.setRequestHeader("Range", "bytes=" + this._start + "-" + M));
            try {
              y.send(this._config.downloadRequestBody);
            } catch (T) {
              this._chunkError(T.message);
            }
            o && y.status === 0 && this._chunkError();
          }
        }, this._chunkLoaded = function() {
          y.readyState === 4 && (y.status < 200 || 400 <= y.status ? this._chunkError() : (this._start += this._config.chunkSize || y.responseText.length, this._finished = !this._config.chunkSize || this._start >= ((S) => (S = S.getResponseHeader("Content-Range")) !== null ? parseInt(S.substring(S.lastIndexOf("/") + 1)) : -1)(y), this.parseChunk(y.responseText)));
        }, this._chunkError = function(S) {
          S = y.statusText || S, this._sendError(new Error(S));
        };
      }
      function p(b) {
        (b = b || {}).chunkSize || (b.chunkSize = u.LocalChunkSize), f.call(this, b);
        var y, S, P = typeof FileReader < "u";
        this.stream = function(M) {
          this._input = M, S = M.slice || M.webkitSlice || M.mozSlice, P ? ((y = new FileReader()).onload = D(this._chunkLoaded, this), y.onerror = D(this._chunkError, this)) : y = new FileReaderSync(), this._nextChunk();
        }, this._nextChunk = function() {
          this._finished || this._config.preview && !(this._rowCount < this._config.preview) || this._readChunk();
        }, this._readChunk = function() {
          var M = this._input, T = (this._config.chunkSize && (T = Math.min(this._start + this._config.chunkSize, this._input.size), M = S.call(M, this._start, T)), y.readAsText(M, this._config.encoding));
          P || this._chunkLoaded({ target: { result: T } });
        }, this._chunkLoaded = function(M) {
          this._start += this._config.chunkSize, this._finished = !this._config.chunkSize || this._start >= this._input.size, this.parseChunk(M.target.result);
        }, this._chunkError = function() {
          this._sendError(y.error);
        };
      }
      function h(b) {
        var y;
        f.call(this, b = b || {}), this.stream = function(S) {
          return y = S, this._nextChunk();
        }, this._nextChunk = function() {
          var S, P;
          if (!this._finished) return S = this._config.chunkSize, y = S ? (P = y.substring(0, S), y.substring(S)) : (P = y, ""), this._finished = !y, this.parseChunk(P);
        };
      }
      function v(b) {
        f.call(this, b = b || {});
        var y = [], S = !0, P = !1;
        this.pause = function() {
          f.prototype.pause.apply(this, arguments), this._input.pause();
        }, this.resume = function() {
          f.prototype.resume.apply(this, arguments), this._input.resume();
        }, this.stream = function(M) {
          this._input = M, this._input.on("data", this._streamData), this._input.on("end", this._streamEnd), this._input.on("error", this._streamError);
        }, this._checkIsFinished = function() {
          P && y.length === 1 && (this._finished = !0);
        }, this._nextChunk = function() {
          this._checkIsFinished(), y.length ? this.parseChunk(y.shift()) : S = !0;
        }, this._streamData = D(function(M) {
          try {
            y.push(typeof M == "string" ? M : M.toString(this._config.encoding)), S && (S = !1, this._checkIsFinished(), this.parseChunk(y.shift()));
          } catch (T) {
            this._streamError(T);
          }
        }, this), this._streamError = D(function(M) {
          this._streamCleanUp(), this._sendError(M);
        }, this), this._streamEnd = D(function() {
          this._streamCleanUp(), P = !0, this._streamData("");
        }, this), this._streamCleanUp = D(function() {
          this._input.removeListener("data", this._streamData), this._input.removeListener("end", this._streamEnd), this._input.removeListener("error", this._streamError);
        }, this);
      }
      function m(b) {
        var y, S, P, M, T = Math.pow(2, 53), V = -T, z = /^\s*-?(\d+\.?|\.\d+|\d+\.\d+)([eE][-+]?\d+)?\s*$/, U = /^((\d{4}-[01]\d-[0-3]\dT[0-2]\d:[0-5]\d:[0-5]\d\.\d+([+-][0-2]\d:[0-5]\d|Z))|(\d{4}-[01]\d-[0-3]\dT[0-2]\d:[0-5]\d:[0-5]\d([+-][0-2]\d:[0-5]\d|Z))|(\d{4}-[01]\d-[0-3]\dT[0-2]\d:[0-5]\d([+-][0-2]\d:[0-5]\d|Z)))$/, B = this, N = 0, C = 0, G = !1, re = !1, ie = [], X = { data: [], errors: [], meta: {} };
        function Se(A) {
          return b.skipEmptyLines === "greedy" ? A.join("").trim() === "" : A.length === 1 && A[0].length === 0;
        }
        function me() {
          if (X && P && (Q("Delimiter", "UndetectableDelimiter", "Unable to auto-detect delimiting character; defaulted to '" + u.DefaultDelimiter + "'"), P = !1), b.skipEmptyLines && (X.data = X.data.filter(function(j) {
            return !Se(j);
          })), fe()) {
            let j = function(q, Y) {
              q = c(q), E(b.transformHeader) && (q = b.transformHeader(q, Y)), ie.push(q);
            };
            if (X) if (Array.isArray(X.data[0])) {
              for (var A = 0; fe() && A < X.data.length; A++) X.data[A].forEach(j);
              X.data.splice(0, 1);
            } else X.data.forEach(j);
          }
          function O(j, q) {
            for (var Y = b.header ? {} : [], ae = 0; ae < j.length; ae++) {
              var te = ae, ue = j[ae], ue = ((Pe, de) => ((Ee) => (b.dynamicTypingFunction && b.dynamicTyping[Ee] === void 0 && (b.dynamicTyping[Ee] = b.dynamicTypingFunction(Ee)), (b.dynamicTyping[Ee] || b.dynamicTyping) === !0))(Pe) ? de === "true" || de === "TRUE" || de !== "false" && de !== "FALSE" && (((Ee) => {
                if (z.test(Ee) && (Ee = parseFloat(Ee), V < Ee && Ee < T))
                  return 1;
              })(de) ? parseFloat(de) : U.test(de) ? new Date(de) : de === "" ? null : de) : de)(te = b.header ? ae >= ie.length ? "__parsed_extra" : ie[ae] : te, ue = b.transform ? b.transform(ue, te) : ue);
              te === "__parsed_extra" ? (Y[te] = Y[te] || [], Y[te].push(ue)) : Y[te] = ue;
            }
            return b.header && (ae > ie.length ? Q("FieldMismatch", "TooManyFields", "Too many fields: expected " + ie.length + " fields but parsed " + ae, C + q) : ae < ie.length && Q("FieldMismatch", "TooFewFields", "Too few fields: expected " + ie.length + " fields but parsed " + ae, C + q)), Y;
          }
          var R;
          X && (b.header || b.dynamicTyping || b.transform) && (R = 1, !X.data.length || Array.isArray(X.data[0]) ? (X.data = X.data.map(O), R = X.data.length) : X.data = O(X.data, 0), b.header && X.meta && (X.meta.fields = ie), C += R);
        }
        function fe() {
          return b.header && ie.length === 0;
        }
        function Q(A, O, R, j) {
          A = { type: A, code: O, message: R }, j !== void 0 && (A.row = j), X.errors.push(A);
        }
        E(b.step) && (M = b.step, b.step = function(A) {
          X = A, fe() ? me() : (me(), X.data.length !== 0 && (N += A.data.length, b.preview && N > b.preview ? S.abort() : (X.data = X.data[0], M(X, B))));
        }), this.parse = function(A, O, R) {
          var j = b.quoteChar || '"', j = (b.newline || (b.newline = this.guessLineEndings(A, j)), P = !1, b.delimiter ? E(b.delimiter) && (b.delimiter = b.delimiter(A), X.meta.delimiter = b.delimiter) : ((j = ((q, Y, ae, te, ue) => {
            var Pe, de, Ee, ce;
            ue = ue || [",", "	", "|", ";", u.RECORD_SEP, u.UNIT_SEP];
            for (var Ue = 0; Ue < ue.length; Ue++) {
              for (var et, gn = ue[Ue], ge = 0, Ce = 0, Ye = 0, Xe = (Ee = void 0, new _({ comments: te, delimiter: gn, newline: Y, preview: 10 }).parse(q)), lt = 0; lt < Xe.data.length; lt++) ae && Se(Xe.data[lt]) ? Ye++ : (et = Xe.data[lt].length, Ce += et, Ee === void 0 ? Ee = et : 0 < et && (ge += Math.abs(et - Ee), Ee = et));
              0 < Xe.data.length && (Ce /= Xe.data.length - Ye), (de === void 0 || ge <= de) && (ce === void 0 || ce < Ce) && 1.99 < Ce && (de = ge, Pe = gn, ce = Ce);
            }
            return { successful: !!(b.delimiter = Pe), bestDelimiter: Pe };
          })(A, b.newline, b.skipEmptyLines, b.comments, b.delimitersToGuess)).successful ? b.delimiter = j.bestDelimiter : (P = !0, b.delimiter = u.DefaultDelimiter), X.meta.delimiter = b.delimiter), k(b));
          return b.preview && b.header && j.preview++, y = A, S = new _(j), X = S.parse(y, O, R), me(), G ? { meta: { paused: !0 } } : X || { meta: { paused: !1 } };
        }, this.paused = function() {
          return G;
        }, this.pause = function() {
          G = !0, S.abort(), y = E(b.chunk) ? "" : y.substring(S.getCharIndex());
        }, this.resume = function() {
          B.streamer._halted ? (G = !1, B.streamer.parseChunk(y, !0)) : setTimeout(B.resume, 3);
        }, this.aborted = function() {
          return re;
        }, this.abort = function() {
          re = !0, S.abort(), X.meta.aborted = !0, E(b.complete) && b.complete(X), y = "";
        }, this.guessLineEndings = function(q, j) {
          q = q.substring(0, 1048576);
          var j = new RegExp(g(j) + "([^]*?)" + g(j), "gm"), R = (q = q.replace(j, "")).split("\r"), j = q.split(`
`), q = 1 < j.length && j[0].length < R[0].length;
          if (R.length === 1 || q) return `
`;
          for (var Y = 0, ae = 0; ae < R.length; ae++) R[ae][0] === `
` && Y++;
          return Y >= R.length / 2 ? `\r
` : "\r";
        };
      }
      function g(b) {
        return b.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
      }
      function _(b) {
        var y = (b = b || {}).delimiter, S = b.newline, P = b.comments, M = b.step, T = b.preview, V = b.fastMode, z = null, U = !1, B = b.quoteChar == null ? '"' : b.quoteChar, N = B;
        if (b.escapeChar !== void 0 && (N = b.escapeChar), (typeof y != "string" || -1 < u.BAD_DELIMITERS.indexOf(y)) && (y = ","), P === y) throw new Error("Comment character same as delimiter");
        P === !0 ? P = "#" : (typeof P != "string" || -1 < u.BAD_DELIMITERS.indexOf(P)) && (P = !1), S !== `
` && S !== "\r" && S !== `\r
` && (S = `
`);
        var C = 0, G = !1;
        this.parse = function(re, ie, X) {
          if (typeof re != "string") throw new Error("Input must be a string");
          var Se = re.length, me = y.length, fe = S.length, Q = P.length, A = E(M), O = [], R = [], j = [], q = C = 0;
          if (!re) return ge();
          if (V || V !== !1 && re.indexOf(B) === -1) {
            for (var Y = re.split(S), ae = 0; ae < Y.length; ae++) {
              if (j = Y[ae], C += j.length, ae !== Y.length - 1) C += S.length;
              else if (X) return ge();
              if (!P || j.substring(0, Q) !== P) {
                if (A) {
                  if (O = [], ce(j.split(y)), Ce(), G) return ge();
                } else ce(j.split(y));
                if (T && T <= ae) return O = O.slice(0, T), ge(!0);
              }
            }
            return ge();
          }
          for (var te = re.indexOf(y, C), ue = re.indexOf(S, C), Pe = new RegExp(g(N) + g(B), "g"), de = re.indexOf(B, C); ; ) if (re[C] === B) for (de = C, C++; ; ) {
            if ((de = re.indexOf(B, de + 1)) === -1) return X || R.push({ type: "Quotes", code: "MissingQuotes", message: "Quoted field unterminated", row: O.length, index: C }), et();
            if (de === Se - 1) return et(re.substring(C, de).replace(Pe, B));
            if (B === N && re[de + 1] === N) de++;
            else if (B === N || de === 0 || re[de - 1] !== N) {
              te !== -1 && te < de + 1 && (te = re.indexOf(y, de + 1));
              var Ee = Ue((ue = ue !== -1 && ue < de + 1 ? re.indexOf(S, de + 1) : ue) === -1 ? te : Math.min(te, ue));
              if (re.substr(de + 1 + Ee, me) === y) {
                j.push(re.substring(C, de).replace(Pe, B)), re[C = de + 1 + Ee + me] !== B && (de = re.indexOf(B, C)), te = re.indexOf(y, C), ue = re.indexOf(S, C);
                break;
              }
              if (Ee = Ue(ue), re.substring(de + 1 + Ee, de + 1 + Ee + fe) === S) {
                if (j.push(re.substring(C, de).replace(Pe, B)), gn(de + 1 + Ee + fe), te = re.indexOf(y, C), de = re.indexOf(B, C), A && (Ce(), G)) return ge();
                if (T && O.length >= T) return ge(!0);
                break;
              }
              R.push({ type: "Quotes", code: "InvalidQuotes", message: "Trailing quote on quoted field is malformed", row: O.length, index: C }), de++;
            }
          }
          else if (P && j.length === 0 && re.substring(C, C + Q) === P) {
            if (ue === -1) return ge();
            C = ue + fe, ue = re.indexOf(S, C), te = re.indexOf(y, C);
          } else if (te !== -1 && (te < ue || ue === -1)) j.push(re.substring(C, te)), C = te + me, te = re.indexOf(y, C);
          else {
            if (ue === -1) break;
            if (j.push(re.substring(C, ue)), gn(ue + fe), A && (Ce(), G)) return ge();
            if (T && O.length >= T) return ge(!0);
          }
          return et();
          function ce(Ye) {
            O.push(Ye), q = C;
          }
          function Ue(Ye) {
            var Xe = 0;
            return Xe = Ye !== -1 && (Ye = re.substring(de + 1, Ye)) && Ye.trim() === "" ? Ye.length : Xe;
          }
          function et(Ye) {
            return X || (Ye === void 0 && (Ye = re.substring(C)), j.push(Ye), C = Se, ce(j), A && Ce()), ge();
          }
          function gn(Ye) {
            C = Ye, ce(j), j = [], ue = re.indexOf(S, C);
          }
          function ge(Ye) {
            if (b.header && !ie && O.length && !U) {
              var Xe = O[0], lt = /* @__PURE__ */ Object.create(null), F = new Set(Xe);
              let K = !1;
              for (let W = 0; W < Xe.length; W++) {
                let le = c(Xe[W]);
                if (lt[le = E(b.transformHeader) ? b.transformHeader(le, W) : le]) {
                  let pe, xe = lt[le];
                  for (; pe = le + "_" + xe, xe++, F.has(pe); ) ;
                  F.add(pe), Xe[W] = pe, lt[le]++, K = !0, (z = z === null ? {} : z)[pe] = le;
                } else lt[le] = 1, Xe[W] = le;
                F.add(le);
              }
              K && console.warn("Duplicate headers found and renamed."), U = !0;
            }
            return { data: O, errors: R, meta: { delimiter: y, linebreak: S, aborted: G, truncated: !!Ye, cursor: q + (ie || 0), renamedHeaders: z } };
          }
          function Ce() {
            M(ge()), O = [], R = [];
          }
        }, this.abort = function() {
          G = !0;
        }, this.getCharIndex = function() {
          return C;
        };
      }
      function x(b) {
        var y = b.data, S = s[y.workerId], P = !1;
        if (y.error) S.userError(y.error, y.file);
        else if (y.results && y.results.data) {
          var M = { abort: function() {
            P = !0, w(y.workerId, { data: [], errors: [], meta: { aborted: !0 } });
          }, pause: $, resume: $ };
          if (E(S.userStep)) {
            for (var T = 0; T < y.results.data.length && (S.userStep({ data: y.results.data[T], errors: y.results.errors, meta: y.results.meta }, M), !P); T++) ;
            delete y.results;
          } else E(S.userChunk) && (S.userChunk(y.results, M, y.file), delete y.results);
        }
        y.finished && !P && w(y.workerId, y.results);
      }
      function w(b, y) {
        var S = s[b];
        E(S.userComplete) && S.userComplete(y), S.terminate(), delete s[b];
      }
      function $() {
        throw new Error("Not implemented.");
      }
      function k(b) {
        if (typeof b != "object" || b === null) return b;
        var y, S = Array.isArray(b) ? [] : {};
        for (y in b) S[y] = k(b[y]);
        return S;
      }
      function D(b, y) {
        return function() {
          b.apply(y, arguments);
        };
      }
      function E(b) {
        return typeof b == "function";
      }
      return u.parse = function(b, y) {
        var S = (y = y || {}).dynamicTyping || !1;
        if (E(S) && (y.dynamicTypingFunction = S, S = {}), y.dynamicTyping = S, y.transform = !!E(y.transform) && y.transform, !y.worker || !u.WORKERS_SUPPORTED) return S = null, u.NODE_STREAM_INPUT, typeof b == "string" ? (b = c(b), S = new (y.download ? d : h)(y)) : b.readable === !0 && E(b.read) && E(b.on) ? S = new v(y) : (r.File && b instanceof File || b instanceof Object) && (S = new p(y)), S.stream(b);
        (S = (() => {
          var P;
          return !!u.WORKERS_SUPPORTED && (P = (() => {
            var M = r.URL || r.webkitURL || null, T = n.toString();
            return u.BLOB_URL || (u.BLOB_URL = M.createObjectURL(new Blob(["var global = (function() { if (typeof self !== 'undefined') { return self; } if (typeof window !== 'undefined') { return window; } if (typeof global !== 'undefined') { return global; } return {}; })(); global.IS_PAPA_WORKER=true; ", "(", T, ")();"], { type: "text/javascript" })));
          })(), (P = new r.Worker(P)).onmessage = x, P.id = l++, s[P.id] = P);
        })()).userStep = y.step, S.userChunk = y.chunk, S.userComplete = y.complete, S.userError = y.error, y.step = E(y.step), y.chunk = E(y.chunk), y.complete = E(y.complete), y.error = E(y.error), delete y.worker, S.postMessage({ input: b, config: y, workerId: S.id });
      }, u.unparse = function(b, y) {
        var S = !1, P = !0, M = ",", T = `\r
`, V = '"', z = V + V, U = !1, B = null, N = !1, C = ((() => {
          if (typeof y == "object") {
            if (typeof y.delimiter != "string" || u.BAD_DELIMITERS.filter(function(ie) {
              return y.delimiter.indexOf(ie) !== -1;
            }).length || (M = y.delimiter), typeof y.quotes != "boolean" && typeof y.quotes != "function" && !Array.isArray(y.quotes) || (S = y.quotes), typeof y.skipEmptyLines != "boolean" && typeof y.skipEmptyLines != "string" || (U = y.skipEmptyLines), typeof y.newline == "string" && (T = y.newline), typeof y.quoteChar == "string" && (V = y.quoteChar, z = V + V), typeof y.header == "boolean" && (P = y.header), Array.isArray(y.columns)) {
              if (y.columns.length === 0) throw new Error("Option columns is empty");
              B = y.columns;
            }
            y.escapeChar !== void 0 && (z = y.escapeChar + V), y.escapeFormulae instanceof RegExp ? N = y.escapeFormulae : typeof y.escapeFormulae == "boolean" && y.escapeFormulae && (N = /^[=+\-@\t\r].*$/);
          }
        })(), new RegExp(g(V), "g"));
        if (typeof b == "string" && (b = JSON.parse(b)), Array.isArray(b)) {
          if (!b.length || Array.isArray(b[0])) return G(null, b, U);
          if (typeof b[0] == "object") return G(B || Object.keys(b[0]), b, U);
        } else if (typeof b == "object") return typeof b.data == "string" && (b.data = JSON.parse(b.data)), Array.isArray(b.data) && (b.fields || (b.fields = b.meta && b.meta.fields || B), b.fields || (b.fields = Array.isArray(b.data[0]) ? b.fields : typeof b.data[0] == "object" ? Object.keys(b.data[0]) : []), Array.isArray(b.data[0]) || typeof b.data[0] == "object" || (b.data = [b.data])), G(b.fields || [], b.data || [], U);
        throw new Error("Unable to serialize unrecognized input");
        function G(ie, X, Se) {
          var me = "", fe = (typeof ie == "string" && (ie = JSON.parse(ie)), typeof X == "string" && (X = JSON.parse(X)), Array.isArray(ie) && 0 < ie.length), Q = !Array.isArray(X[0]);
          if (fe && P) {
            for (var A = 0; A < ie.length; A++) 0 < A && (me += M), me += re(ie[A], A);
            0 < X.length && (me += T);
          }
          for (var O = 0; O < X.length; O++) {
            var R = (fe ? ie : X[O]).length, j = !1, q = fe ? Object.keys(X[O]).length === 0 : X[O].length === 0;
            if (Se && !fe && (j = Se === "greedy" ? X[O].join("").trim() === "" : X[O].length === 1 && X[O][0].length === 0), Se === "greedy" && fe) {
              for (var Y = [], ae = 0; ae < R; ae++) {
                var te = Q ? ie[ae] : ae;
                Y.push(X[O][te]);
              }
              j = Y.join("").trim() === "";
            }
            if (!j) {
              for (var ue = 0; ue < R; ue++) {
                0 < ue && !q && (me += M);
                var Pe = fe && Q ? ie[ue] : ue;
                me += re(X[O][Pe], ue);
              }
              O < X.length - 1 && (!Se || 0 < R && !q) && (me += T);
            }
          }
          return me;
        }
        function re(ie, X) {
          var Se, me, fe;
          return ie == null ? "" : ie.constructor === Date ? JSON.stringify(ie).slice(1, 25) : (fe = !1, N && typeof ie == "string" && N.test(ie) && (ie = "'" + ie, fe = !0), me = (Se = ie.toString()).replace(C, z), (fe = fe || S === !0 || typeof S == "function" && S(ie, X) || Array.isArray(S) && S[X] || ((Q, A) => {
            for (var O = 0; O < A.length; O++) if (-1 < Q.indexOf(A[O])) return !0;
            return !1;
          })(me, u.BAD_DELIMITERS) || -1 < me.indexOf(M) || -1 < Se.indexOf(V) || me.charAt(0) === " " || me.charAt(me.length - 1) === " ") ? V + me + V : me);
        }
      }, u.RECORD_SEP = "", u.UNIT_SEP = "", u.BYTE_ORDER_MARK = "\uFEFF", u.BAD_DELIMITERS = ["\r", `
`, '"', u.BYTE_ORDER_MARK], u.WORKERS_SUPPORTED = !o && !!r.Worker, u.NODE_STREAM_INPUT = 1, u.LocalChunkSize = 10485760, u.RemoteChunkSize = 5242880, u.DefaultDelimiter = ",", u.Parser = _, u.ParserHandle = m, u.NetworkStreamer = d, u.FileStreamer = p, u.StringStreamer = h, u.ReadableStreamStreamer = v, r.jQuery && ((i = r.jQuery).fn.parse = function(b) {
        var y = b.config || {}, S = [];
        return this.each(function(T) {
          if (!(i(this).prop("tagName").toUpperCase() === "INPUT" && i(this).attr("type").toLowerCase() === "file" && r.FileReader) || !this.files || this.files.length === 0) return !0;
          for (var V = 0; V < this.files.length; V++) S.push({ file: this.files[V], inputElem: this, instanceConfig: i.extend({}, y) });
        }), P(), this;
        function P() {
          if (S.length === 0) E(b.complete) && b.complete();
          else {
            var T, V, z, U, B = S[0];
            if (E(b.before)) {
              var N = b.before(B.file, B.inputElem);
              if (typeof N == "object") {
                if (N.action === "abort") return T = "AbortError", V = B.file, z = B.inputElem, U = N.reason, void (E(b.error) && b.error({ name: T }, V, z, U));
                if (N.action === "skip") return void M();
                typeof N.config == "object" && (B.instanceConfig = i.extend(B.instanceConfig, N.config));
              } else if (N === "skip") return void M();
            }
            var C = B.instanceConfig.complete;
            B.instanceConfig.complete = function(G) {
              E(C) && C(G, B.file, B.inputElem), M();
            }, u.parse(B.file, B.instanceConfig);
          }
        }
        function M() {
          S.splice(0, 1), P();
        }
      }), a && (r.onmessage = function(b) {
        b = b.data, u.WORKER_ID === void 0 && b && (u.WORKER_ID = b.workerId), typeof b.input == "string" ? r.postMessage({ workerId: u.WORKER_ID, results: u.parse(b.input, b.config), finished: !0 }) : (r.File && b.input instanceof File || b.input instanceof Object) && (b = u.parse(b.input, b.config)) && r.postMessage({ workerId: u.WORKER_ID, results: b, finished: !0 });
      }), (d.prototype = Object.create(f.prototype)).constructor = d, (p.prototype = Object.create(f.prototype)).constructor = p, (h.prototype = Object.create(h.prototype)).constructor = h, (v.prototype = Object.create(f.prototype)).constructor = v, u;
    });
  })(Bf)), Bf.exports;
}
var wae = _ae();
const xae = (e) => /* @__PURE__ */ I.jsx(
  "table",
  {
    className: "bg-gray-100 border-collapse border-gray-300",
    ...e
  }
), GS = ({ url: e, classname: t }) => {
  const { data: n, error: r } = Zd({
    queryKey: ["download", e],
    queryFn: async () => {
      try {
        return await fetch(e, {
          method: "GET",
          credentials: "include"
        });
      } catch (s) {
        console.error(s);
      }
    }
  }), [i, o] = Ke(null), a = async () => {
    const s = await n?.text();
    s && wae.parse(s, {
      complete: (l) => o(l.data)
    });
  };
  return ze(() => {
    a();
  }, [n]), i ? /* @__PURE__ */ I.jsx("div", { className: `${t}`, children: /* @__PURE__ */ I.jsx(xae, { children: /* @__PURE__ */ I.jsx("tbody", { children: i.map((s, l) => /* @__PURE__ */ I.jsx("tr", { children: Object.keys(s).map((u, c) => /* @__PURE__ */ I.jsx("td", { children: s[u] }, `cell-${l * c}`)) }, `row-${l}`)) }) }) }) : /* @__PURE__ */ I.jsx("div", { className: "grid w-full h-full place-items-center", children: /* @__PURE__ */ I.jsx("p", { children: "Loading table preview..." }) });
}, _se = ({ filePath: e, classname: t }) => {
  if (!e)
    return /* @__PURE__ */ I.jsx("div", { children: "Invalid URL" });
  const r = e.split(".").pop();
  let i;
  switch (r) {
    case "svg":
      i = /* @__PURE__ */ I.jsx(yae, { url: e, classname: t });
      break;
    case "csv":
      i = /* @__PURE__ */ I.jsx(GS, { url: e, classname: t });
      break;
    case "bed":
    case "fastq":
    case "tsv":
      i = /* @__PURE__ */ I.jsx(GS, { url: e, classname: t });
      break;
    case "jpg":
      i = /* @__PURE__ */ I.jsx(cf, { url: e, classname: t });
      break;
    case "jpeg":
      i = /* @__PURE__ */ I.jsx(cf, { url: e, classname: t });
      break;
    case "png":
      i = /* @__PURE__ */ I.jsx(cf, { url: e, classname: t });
      break;
    case "gif":
    case "bmp":
    case "webp":
    case "tiff":
    case "tif":
    case "ico":
    case "jfif":
      i = /* @__PURE__ */ I.jsx(cf, { url: e, classname: t });
      break;
    case "pdf":
      i = /* @__PURE__ */ I.jsx(gae, { url: e, classname: t });
      break;
    default:
      i = /* @__PURE__ */ I.jsx("div", { children: "Preview not available for this file type" });
      break;
  }
  return /* @__PURE__ */ I.jsx("div", { children: i });
}, Eae = ({
  validate: e,
  children: t,
  onFailure: n
}) => {
  const [r, i] = Ke(!0), o = Le(async () => {
    await e() ? i(!1) : n();
  }, []);
  return ze(() => {
    o();
  }, []), r ? null : /* @__PURE__ */ I.jsx(I.Fragment, { children: t });
};
function Sae(e, t) {
  return t.some(
    (n) => e.some((r) => r.role === n)
  );
}
const wse = ({
  roles: e,
  children: t,
  loginUrl: n
}) => {
  const [r] = uae({ fetchPolicy: "cache-first" });
  return /* @__PURE__ */ I.jsx(
    Eae,
    {
      onFailure: () => {
        window.location.href = `${n}?redirect=${encodeURIComponent(
          window.location.href
        )}`;
      },
      validate: async () => {
        const i = await r();
        return !(!i.data?.me || !Sae(i.data.me.roles || [], e));
      },
      children: t
    }
  );
}, xse = ({
  path: e,
  className: t,
  children: n,
  endpoint: r
}) => {
  const i = `${r}/download?bucket=${e}&key=${e}&isFolder=${e.isFolder ? 1 : 0}`;
  return /* @__PURE__ */ I.jsx("a", { className: t, href: i, download: "asfdkl", children: n });
};
function ff(e) {
  throw new Error('Could not dynamically require "' + e + '". Please configure the dynamicRequireTargets or/and ignoreDynamicRequires option of @rollup/plugin-commonjs appropriately for this require call to work.');
}
var zm = { exports: {} }, YS;
function $ae() {
  return YS || (YS = 1, (function(e, t) {
    (function(n) {
      e.exports = n();
    })(function() {
      return (function n(r, i, o) {
        function a(u, c) {
          if (!i[u]) {
            if (!r[u]) {
              var f = typeof ff == "function" && ff;
              if (!c && f) return f(u, !0);
              if (s) return s(u, !0);
              throw new Error("Cannot find module '" + u + "'");
            }
            c = i[u] = { exports: {} }, r[u][0].call(c.exports, function(d) {
              var p = r[u][1][d];
              return a(p || d);
            }, c, c.exports, n, r, i, o);
          }
          return i[u].exports;
        }
        for (var s = typeof ff == "function" && ff, l = 0; l < o.length; l++) a(o[l]);
        return a;
      })({ 1: [function(n, r, i) {
        (function(o, a, s, l, u, c, f, d, p) {
          var h = n("crypto");
          function v(k, D) {
            D = _(k, D);
            var E;
            return (E = D.algorithm !== "passthrough" ? h.createHash(D.algorithm) : new $()).write === void 0 && (E.write = E.update, E.end = E.update), w(D, E).dispatch(k), E.update || E.end(""), E.digest ? E.digest(D.encoding === "buffer" ? void 0 : D.encoding) : (k = E.read(), D.encoding !== "buffer" ? k.toString(D.encoding) : k);
          }
          (i = r.exports = v).sha1 = function(k) {
            return v(k);
          }, i.keys = function(k) {
            return v(k, { excludeValues: !0, algorithm: "sha1", encoding: "hex" });
          }, i.MD5 = function(k) {
            return v(k, { algorithm: "md5", encoding: "hex" });
          }, i.keysMD5 = function(k) {
            return v(k, { algorithm: "md5", encoding: "hex", excludeValues: !0 });
          };
          var m = h.getHashes ? h.getHashes().slice() : ["sha1", "md5"], g = (m.push("passthrough"), ["buffer", "hex", "binary", "base64"]);
          function _(k, D) {
            var E = {};
            if (E.algorithm = (D = D || {}).algorithm || "sha1", E.encoding = D.encoding || "hex", E.excludeValues = !!D.excludeValues, E.algorithm = E.algorithm.toLowerCase(), E.encoding = E.encoding.toLowerCase(), E.ignoreUnknown = D.ignoreUnknown === !0, E.respectType = D.respectType !== !1, E.respectFunctionNames = D.respectFunctionNames !== !1, E.respectFunctionProperties = D.respectFunctionProperties !== !1, E.unorderedArrays = D.unorderedArrays === !0, E.unorderedSets = D.unorderedSets !== !1, E.unorderedObjects = D.unorderedObjects !== !1, E.replacer = D.replacer || void 0, E.excludeKeys = D.excludeKeys || void 0, k === void 0) throw new Error("Object argument required.");
            for (var b = 0; b < m.length; ++b) m[b].toLowerCase() === E.algorithm.toLowerCase() && (E.algorithm = m[b]);
            if (m.indexOf(E.algorithm) === -1) throw new Error('Algorithm "' + E.algorithm + '"  not supported. supported values: ' + m.join(", "));
            if (g.indexOf(E.encoding) === -1 && E.algorithm !== "passthrough") throw new Error('Encoding "' + E.encoding + '"  not supported. supported values: ' + g.join(", "));
            return E;
          }
          function x(k) {
            if (typeof k == "function") return /^function\s+\w*\s*\(\s*\)\s*{\s+\[native code\]\s+}$/i.exec(Function.prototype.toString.call(k)) != null;
          }
          function w(k, D, E) {
            E = E || [];
            function b(y) {
              return D.update ? D.update(y, "utf8") : D.write(y, "utf8");
            }
            return { dispatch: function(y) {
              return this["_" + ((y = k.replacer ? k.replacer(y) : y) === null ? "null" : typeof y)](y);
            }, _object: function(y) {
              var S, P = Object.prototype.toString.call(y), M = /\[object (.*)\]/i.exec(P);
              if (M = (M = M ? M[1] : "unknown:[" + P + "]").toLowerCase(), 0 <= (P = E.indexOf(y))) return this.dispatch("[CIRCULAR:" + P + "]");
              if (E.push(y), s !== void 0 && s.isBuffer && s.isBuffer(y)) return b("buffer:"), b(y);
              if (M === "object" || M === "function" || M === "asyncfunction") return P = Object.keys(y), k.unorderedObjects && (P = P.sort()), k.respectType === !1 || x(y) || P.splice(0, 0, "prototype", "__proto__", "constructor"), k.excludeKeys && (P = P.filter(function(T) {
                return !k.excludeKeys(T);
              })), b("object:" + P.length + ":"), S = this, P.forEach(function(T) {
                S.dispatch(T), b(":"), k.excludeValues || S.dispatch(y[T]), b(",");
              });
              if (!this["_" + M]) {
                if (k.ignoreUnknown) return b("[" + M + "]");
                throw new Error('Unknown object type "' + M + '"');
              }
              this["_" + M](y);
            }, _array: function(y, T) {
              T = T !== void 0 ? T : k.unorderedArrays !== !1;
              var P = this;
              if (b("array:" + y.length + ":"), !T || y.length <= 1) return y.forEach(function(V) {
                return P.dispatch(V);
              });
              var M = [], T = y.map(function(V) {
                var z = new $(), U = E.slice();
                return w(k, z, U).dispatch(V), M = M.concat(U.slice(E.length)), z.read().toString();
              });
              return E = E.concat(M), T.sort(), this._array(T, !1);
            }, _date: function(y) {
              return b("date:" + y.toJSON());
            }, _symbol: function(y) {
              return b("symbol:" + y.toString());
            }, _error: function(y) {
              return b("error:" + y.toString());
            }, _boolean: function(y) {
              return b("bool:" + y.toString());
            }, _string: function(y) {
              b("string:" + y.length + ":"), b(y.toString());
            }, _function: function(y) {
              b("fn:"), x(y) ? this.dispatch("[native]") : this.dispatch(y.toString()), k.respectFunctionNames !== !1 && this.dispatch("function-name:" + String(y.name)), k.respectFunctionProperties && this._object(y);
            }, _number: function(y) {
              return b("number:" + y.toString());
            }, _xml: function(y) {
              return b("xml:" + y.toString());
            }, _null: function() {
              return b("Null");
            }, _undefined: function() {
              return b("Undefined");
            }, _regexp: function(y) {
              return b("regex:" + y.toString());
            }, _uint8array: function(y) {
              return b("uint8array:"), this.dispatch(Array.prototype.slice.call(y));
            }, _uint8clampedarray: function(y) {
              return b("uint8clampedarray:"), this.dispatch(Array.prototype.slice.call(y));
            }, _int8array: function(y) {
              return b("int8array:"), this.dispatch(Array.prototype.slice.call(y));
            }, _uint16array: function(y) {
              return b("uint16array:"), this.dispatch(Array.prototype.slice.call(y));
            }, _int16array: function(y) {
              return b("int16array:"), this.dispatch(Array.prototype.slice.call(y));
            }, _uint32array: function(y) {
              return b("uint32array:"), this.dispatch(Array.prototype.slice.call(y));
            }, _int32array: function(y) {
              return b("int32array:"), this.dispatch(Array.prototype.slice.call(y));
            }, _float32array: function(y) {
              return b("float32array:"), this.dispatch(Array.prototype.slice.call(y));
            }, _float64array: function(y) {
              return b("float64array:"), this.dispatch(Array.prototype.slice.call(y));
            }, _arraybuffer: function(y) {
              return b("arraybuffer:"), this.dispatch(new Uint8Array(y));
            }, _url: function(y) {
              return b("url:" + y.toString());
            }, _map: function(y) {
              return b("map:"), y = Array.from(y), this._array(y, k.unorderedSets !== !1);
            }, _set: function(y) {
              return b("set:"), y = Array.from(y), this._array(y, k.unorderedSets !== !1);
            }, _file: function(y) {
              return b("file:"), this.dispatch([y.name, y.size, y.type, y.lastModfied]);
            }, _blob: function() {
              if (k.ignoreUnknown) return b("[blob]");
              throw Error(`Hashing Blob objects is currently not supported
(see https://github.com/puleos/object-hash/issues/26)
Use "options.replacer" or "options.ignoreUnknown"
`);
            }, _domwindow: function() {
              return b("domwindow");
            }, _bigint: function(y) {
              return b("bigint:" + y.toString());
            }, _process: function() {
              return b("process");
            }, _timer: function() {
              return b("timer");
            }, _pipe: function() {
              return b("pipe");
            }, _tcp: function() {
              return b("tcp");
            }, _udp: function() {
              return b("udp");
            }, _tty: function() {
              return b("tty");
            }, _statwatcher: function() {
              return b("statwatcher");
            }, _securecontext: function() {
              return b("securecontext");
            }, _connection: function() {
              return b("connection");
            }, _zlib: function() {
              return b("zlib");
            }, _context: function() {
              return b("context");
            }, _nodescript: function() {
              return b("nodescript");
            }, _httpparser: function() {
              return b("httpparser");
            }, _dataview: function() {
              return b("dataview");
            }, _signal: function() {
              return b("signal");
            }, _fsevent: function() {
              return b("fsevent");
            }, _tlswrap: function() {
              return b("tlswrap");
            } };
          }
          function $() {
            return { buf: "", write: function(k) {
              this.buf += k;
            }, end: function(k) {
              this.buf += k;
            }, read: function() {
              return this.buf;
            } };
          }
          i.writeToStream = function(k, D, E) {
            return E === void 0 && (E = D, D = {}), w(D = _(k, D), E).dispatch(k);
          };
        }).call(this, n("lYpoI2"), typeof self < "u" ? self : typeof window < "u" ? window : {}, n("buffer").Buffer, arguments[3], arguments[4], arguments[5], arguments[6], "/fake_9a5aa49d.js", "/");
      }, { buffer: 3, crypto: 5, lYpoI2: 11 }], 2: [function(n, r, i) {
        (function(o, a, s, l, u, c, f, d, p) {
          (function(h) {
            var v = typeof Uint8Array < "u" ? Uint8Array : Array, m = 43, g = 47, _ = 48, x = 97, w = 65, $ = 45, k = 95;
            function D(E) {
              return E = E.charCodeAt(0), E === m || E === $ ? 62 : E === g || E === k ? 63 : E < _ ? -1 : E < _ + 10 ? E - _ + 26 + 26 : E < w + 26 ? E - w : E < x + 26 ? E - x + 26 : void 0;
            }
            h.toByteArray = function(E) {
              var b, y;
              if (0 < E.length % 4) throw new Error("Invalid string. Length must be a multiple of 4");
              var S = E.length, S = E.charAt(S - 2) === "=" ? 2 : E.charAt(S - 1) === "=" ? 1 : 0, P = new v(3 * E.length / 4 - S), M = 0 < S ? E.length - 4 : E.length, T = 0;
              function V(z) {
                P[T++] = z;
              }
              for (b = 0; b < M; b += 4, 0) V((16711680 & (y = D(E.charAt(b)) << 18 | D(E.charAt(b + 1)) << 12 | D(E.charAt(b + 2)) << 6 | D(E.charAt(b + 3)))) >> 16), V((65280 & y) >> 8), V(255 & y);
              return S == 2 ? V(255 & (y = D(E.charAt(b)) << 2 | D(E.charAt(b + 1)) >> 4)) : S == 1 && (V((y = D(E.charAt(b)) << 10 | D(E.charAt(b + 1)) << 4 | D(E.charAt(b + 2)) >> 2) >> 8 & 255), V(255 & y)), P;
            }, h.fromByteArray = function(E) {
              var b, y, S, P, M = E.length % 3, T = "";
              function V(z) {
                return "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/".charAt(z);
              }
              for (b = 0, S = E.length - M; b < S; b += 3) y = (E[b] << 16) + (E[b + 1] << 8) + E[b + 2], T += V((P = y) >> 18 & 63) + V(P >> 12 & 63) + V(P >> 6 & 63) + V(63 & P);
              switch (M) {
                case 1:
                  T = (T += V((y = E[E.length - 1]) >> 2)) + V(y << 4 & 63) + "==";
                  break;
                case 2:
                  T = (T = (T += V((y = (E[E.length - 2] << 8) + E[E.length - 1]) >> 10)) + V(y >> 4 & 63)) + V(y << 2 & 63) + "=";
              }
              return T;
            };
          })(i === void 0 ? this.base64js = {} : i);
        }).call(this, n("lYpoI2"), typeof self < "u" ? self : typeof window < "u" ? window : {}, n("buffer").Buffer, arguments[3], arguments[4], arguments[5], arguments[6], "/node_modules/gulp-browserify/node_modules/base64-js/lib/b64.js", "/node_modules/gulp-browserify/node_modules/base64-js/lib");
      }, { buffer: 3, lYpoI2: 11 }], 3: [function(n, r, i) {
        (function(o, a, m, l, u, c, f, d, p) {
          var h = n("base64-js"), v = n("ieee754");
          function m(A, O, R) {
            if (!(this instanceof m)) return new m(A, O, R);
            var j, q, Y, ae, te = typeof A;
            if (O === "base64" && te == "string") for (A = (ae = A).trim ? ae.trim() : ae.replace(/^\s+|\s+$/g, ""); A.length % 4 != 0; ) A += "=";
            if (te == "number") j = B(A);
            else if (te == "string") j = m.byteLength(A, O);
            else {
              if (te != "object") throw new Error("First argument needs to be a number, array or string.");
              j = B(A.length);
            }
            if (m._useTypedArrays ? q = m._augment(new Uint8Array(j)) : ((q = this).length = j, q._isBuffer = !0), m._useTypedArrays && typeof A.byteLength == "number") q._set(A);
            else if (N(ae = A) || m.isBuffer(ae) || ae && typeof ae == "object" && typeof ae.length == "number") for (Y = 0; Y < j; Y++) m.isBuffer(A) ? q[Y] = A.readUInt8(Y) : q[Y] = A[Y];
            else if (te == "string") q.write(A, 0, O);
            else if (te == "number" && !m._useTypedArrays && !R) for (Y = 0; Y < j; Y++) q[Y] = 0;
            return q;
          }
          function g(A, O, R, j) {
            return m._charsWritten = ie((function(q) {
              for (var Y = [], ae = 0; ae < q.length; ae++) Y.push(255 & q.charCodeAt(ae));
              return Y;
            })(O), A, R, j);
          }
          function _(A, O, R, j) {
            return m._charsWritten = ie((function(q) {
              for (var Y, ae, te = [], ue = 0; ue < q.length; ue++) ae = q.charCodeAt(ue), Y = ae >> 8, ae = ae % 256, te.push(ae), te.push(Y);
              return te;
            })(O), A, R, j);
          }
          function x(A, O, R) {
            var j = "";
            R = Math.min(A.length, R);
            for (var q = O; q < R; q++) j += String.fromCharCode(A[q]);
            return j;
          }
          function w(A, O, R, Y) {
            Y || (Q(typeof R == "boolean", "missing or invalid endian"), Q(O != null, "missing offset"), Q(O + 1 < A.length, "Trying to read beyond buffer length"));
            var q, Y = A.length;
            if (!(Y <= O)) return R ? (q = A[O], O + 1 < Y && (q |= A[O + 1] << 8)) : (q = A[O] << 8, O + 1 < Y && (q |= A[O + 1])), q;
          }
          function $(A, O, R, Y) {
            Y || (Q(typeof R == "boolean", "missing or invalid endian"), Q(O != null, "missing offset"), Q(O + 3 < A.length, "Trying to read beyond buffer length"));
            var q, Y = A.length;
            if (!(Y <= O)) return R ? (O + 2 < Y && (q = A[O + 2] << 16), O + 1 < Y && (q |= A[O + 1] << 8), q |= A[O], O + 3 < Y && (q += A[O + 3] << 24 >>> 0)) : (O + 1 < Y && (q = A[O + 1] << 16), O + 2 < Y && (q |= A[O + 2] << 8), O + 3 < Y && (q |= A[O + 3]), q += A[O] << 24 >>> 0), q;
          }
          function k(A, O, R, j) {
            if (j || (Q(typeof R == "boolean", "missing or invalid endian"), Q(O != null, "missing offset"), Q(O + 1 < A.length, "Trying to read beyond buffer length")), !(A.length <= O)) return j = w(A, O, R, !0), 32768 & j ? -1 * (65535 - j + 1) : j;
          }
          function D(A, O, R, j) {
            if (j || (Q(typeof R == "boolean", "missing or invalid endian"), Q(O != null, "missing offset"), Q(O + 3 < A.length, "Trying to read beyond buffer length")), !(A.length <= O)) return j = $(A, O, R, !0), 2147483648 & j ? -1 * (4294967295 - j + 1) : j;
          }
          function E(A, O, R, j) {
            return j || (Q(typeof R == "boolean", "missing or invalid endian"), Q(O + 3 < A.length, "Trying to read beyond buffer length")), v.read(A, O, R, 23, 4);
          }
          function b(A, O, R, j) {
            return j || (Q(typeof R == "boolean", "missing or invalid endian"), Q(O + 7 < A.length, "Trying to read beyond buffer length")), v.read(A, O, R, 52, 8);
          }
          function y(A, O, R, j, q) {
            if (q || (Q(O != null, "missing value"), Q(typeof j == "boolean", "missing or invalid endian"), Q(R != null, "missing offset"), Q(R + 1 < A.length, "trying to write beyond buffer length"), Se(O, 65535)), q = A.length, !(q <= R)) for (var Y = 0, ae = Math.min(q - R, 2); Y < ae; Y++) A[R + Y] = (O & 255 << 8 * (j ? Y : 1 - Y)) >>> 8 * (j ? Y : 1 - Y);
          }
          function S(A, O, R, j, q) {
            if (q || (Q(O != null, "missing value"), Q(typeof j == "boolean", "missing or invalid endian"), Q(R != null, "missing offset"), Q(R + 3 < A.length, "trying to write beyond buffer length"), Se(O, 4294967295)), q = A.length, !(q <= R)) for (var Y = 0, ae = Math.min(q - R, 4); Y < ae; Y++) A[R + Y] = O >>> 8 * (j ? Y : 3 - Y) & 255;
          }
          function P(A, O, R, j, q) {
            q || (Q(O != null, "missing value"), Q(typeof j == "boolean", "missing or invalid endian"), Q(R != null, "missing offset"), Q(R + 1 < A.length, "Trying to write beyond buffer length"), me(O, 32767, -32768)), A.length <= R || y(A, 0 <= O ? O : 65535 + O + 1, R, j, q);
          }
          function M(A, O, R, j, q) {
            q || (Q(O != null, "missing value"), Q(typeof j == "boolean", "missing or invalid endian"), Q(R != null, "missing offset"), Q(R + 3 < A.length, "Trying to write beyond buffer length"), me(O, 2147483647, -2147483648)), A.length <= R || S(A, 0 <= O ? O : 4294967295 + O + 1, R, j, q);
          }
          function T(A, O, R, j, q) {
            q || (Q(O != null, "missing value"), Q(typeof j == "boolean", "missing or invalid endian"), Q(R != null, "missing offset"), Q(R + 3 < A.length, "Trying to write beyond buffer length"), fe(O, 34028234663852886e22, -34028234663852886e22)), A.length <= R || v.write(A, O, R, j, 23, 4);
          }
          function V(A, O, R, j, q) {
            q || (Q(O != null, "missing value"), Q(typeof j == "boolean", "missing or invalid endian"), Q(R != null, "missing offset"), Q(R + 7 < A.length, "Trying to write beyond buffer length"), fe(O, 17976931348623157e292, -17976931348623157e292)), A.length <= R || v.write(A, O, R, j, 52, 8);
          }
          i.Buffer = m, i.SlowBuffer = m, i.INSPECT_MAX_BYTES = 50, m.poolSize = 8192, m._useTypedArrays = (function() {
            try {
              var A = new ArrayBuffer(0), O = new Uint8Array(A);
              return O.foo = function() {
                return 42;
              }, O.foo() === 42 && typeof O.subarray == "function";
            } catch {
              return !1;
            }
          })(), m.isEncoding = function(A) {
            switch (String(A).toLowerCase()) {
              case "hex":
              case "utf8":
              case "utf-8":
              case "ascii":
              case "binary":
              case "base64":
              case "raw":
              case "ucs2":
              case "ucs-2":
              case "utf16le":
              case "utf-16le":
                return !0;
              default:
                return !1;
            }
          }, m.isBuffer = function(A) {
            return !(A == null || !A._isBuffer);
          }, m.byteLength = function(A, O) {
            var R;
            switch (A += "", O || "utf8") {
              case "hex":
                R = A.length / 2;
                break;
              case "utf8":
              case "utf-8":
                R = G(A).length;
                break;
              case "ascii":
              case "binary":
              case "raw":
                R = A.length;
                break;
              case "base64":
                R = re(A).length;
                break;
              case "ucs2":
              case "ucs-2":
              case "utf16le":
              case "utf-16le":
                R = 2 * A.length;
                break;
              default:
                throw new Error("Unknown encoding");
            }
            return R;
          }, m.concat = function(A, O) {
            if (Q(N(A), `Usage: Buffer.concat(list, [totalLength])
list should be an Array.`), A.length === 0) return new m(0);
            if (A.length === 1) return A[0];
            if (typeof O != "number") for (q = O = 0; q < A.length; q++) O += A[q].length;
            for (var R = new m(O), j = 0, q = 0; q < A.length; q++) {
              var Y = A[q];
              Y.copy(R, j), j += Y.length;
            }
            return R;
          }, m.prototype.write = function(A, O, R, j) {
            isFinite(O) ? isFinite(R) || (j = R, R = void 0) : (ue = j, j = O, O = R, R = ue), O = Number(O) || 0;
            var q, Y, ae, te, ue = this.length - O;
            switch ((!R || ue < (R = Number(R))) && (R = ue), j = String(j || "utf8").toLowerCase()) {
              case "hex":
                q = (function(Pe, de, Ee, ce) {
                  Ee = Number(Ee) || 0;
                  var Ue = Pe.length - Ee;
                  (!ce || Ue < (ce = Number(ce))) && (ce = Ue), Q((Ue = de.length) % 2 == 0, "Invalid hex string"), Ue / 2 < ce && (ce = Ue / 2);
                  for (var et = 0; et < ce; et++) {
                    var gn = parseInt(de.substr(2 * et, 2), 16);
                    Q(!isNaN(gn), "Invalid hex string"), Pe[Ee + et] = gn;
                  }
                  return m._charsWritten = 2 * et, et;
                })(this, A, O, R);
                break;
              case "utf8":
              case "utf-8":
                Y = this, ae = O, te = R, q = m._charsWritten = ie(G(A), Y, ae, te);
                break;
              case "ascii":
              case "binary":
                q = g(this, A, O, R);
                break;
              case "base64":
                Y = this, ae = O, te = R, q = m._charsWritten = ie(re(A), Y, ae, te);
                break;
              case "ucs2":
              case "ucs-2":
              case "utf16le":
              case "utf-16le":
                q = _(this, A, O, R);
                break;
              default:
                throw new Error("Unknown encoding");
            }
            return q;
          }, m.prototype.toString = function(A, O, R) {
            var j, q, Y, ae, te = this;
            if (A = String(A || "utf8").toLowerCase(), O = Number(O) || 0, (R = R !== void 0 ? Number(R) : te.length) === O) return "";
            switch (A) {
              case "hex":
                j = (function(ue, Pe, de) {
                  var Ee = ue.length;
                  (!Pe || Pe < 0) && (Pe = 0), (!de || de < 0 || Ee < de) && (de = Ee);
                  for (var ce = "", Ue = Pe; Ue < de; Ue++) ce += C(ue[Ue]);
                  return ce;
                })(te, O, R);
                break;
              case "utf8":
              case "utf-8":
                j = (function(ue, Pe, de) {
                  var Ee = "", ce = "";
                  de = Math.min(ue.length, de);
                  for (var Ue = Pe; Ue < de; Ue++) ue[Ue] <= 127 ? (Ee += X(ce) + String.fromCharCode(ue[Ue]), ce = "") : ce += "%" + ue[Ue].toString(16);
                  return Ee + X(ce);
                })(te, O, R);
                break;
              case "ascii":
              case "binary":
                j = x(te, O, R);
                break;
              case "base64":
                q = te, ae = R, j = (Y = O) === 0 && ae === q.length ? h.fromByteArray(q) : h.fromByteArray(q.slice(Y, ae));
                break;
              case "ucs2":
              case "ucs-2":
              case "utf16le":
              case "utf-16le":
                j = (function(ue, Pe, de) {
                  for (var Ee = ue.slice(Pe, de), ce = "", Ue = 0; Ue < Ee.length; Ue += 2) ce += String.fromCharCode(Ee[Ue] + 256 * Ee[Ue + 1]);
                  return ce;
                })(te, O, R);
                break;
              default:
                throw new Error("Unknown encoding");
            }
            return j;
          }, m.prototype.toJSON = function() {
            return { type: "Buffer", data: Array.prototype.slice.call(this._arr || this, 0) };
          }, m.prototype.copy = function(A, O, R, j) {
            if (O = O || 0, (j = j || j === 0 ? j : this.length) !== (R = R || 0) && A.length !== 0 && this.length !== 0) {
              Q(R <= j, "sourceEnd < sourceStart"), Q(0 <= O && O < A.length, "targetStart out of bounds"), Q(0 <= R && R < this.length, "sourceStart out of bounds"), Q(0 <= j && j <= this.length, "sourceEnd out of bounds"), j > this.length && (j = this.length);
              var q = (j = A.length - O < j - R ? A.length - O + R : j) - R;
              if (q < 100 || !m._useTypedArrays) for (var Y = 0; Y < q; Y++) A[Y + O] = this[Y + R];
              else A._set(this.subarray(R, R + q), O);
            }
          }, m.prototype.slice = function(A, O) {
            var R = this.length;
            if (A = U(A, R, 0), O = U(O, R, R), m._useTypedArrays) return m._augment(this.subarray(A, O));
            for (var j = O - A, q = new m(j, void 0, !0), Y = 0; Y < j; Y++) q[Y] = this[Y + A];
            return q;
          }, m.prototype.get = function(A) {
            return console.log(".get() is deprecated. Access using array indexes instead."), this.readUInt8(A);
          }, m.prototype.set = function(A, O) {
            return console.log(".set() is deprecated. Access using array indexes instead."), this.writeUInt8(A, O);
          }, m.prototype.readUInt8 = function(A, O) {
            if (O || (Q(A != null, "missing offset"), Q(A < this.length, "Trying to read beyond buffer length")), !(A >= this.length)) return this[A];
          }, m.prototype.readUInt16LE = function(A, O) {
            return w(this, A, !0, O);
          }, m.prototype.readUInt16BE = function(A, O) {
            return w(this, A, !1, O);
          }, m.prototype.readUInt32LE = function(A, O) {
            return $(this, A, !0, O);
          }, m.prototype.readUInt32BE = function(A, O) {
            return $(this, A, !1, O);
          }, m.prototype.readInt8 = function(A, O) {
            if (O || (Q(A != null, "missing offset"), Q(A < this.length, "Trying to read beyond buffer length")), !(A >= this.length)) return 128 & this[A] ? -1 * (255 - this[A] + 1) : this[A];
          }, m.prototype.readInt16LE = function(A, O) {
            return k(this, A, !0, O);
          }, m.prototype.readInt16BE = function(A, O) {
            return k(this, A, !1, O);
          }, m.prototype.readInt32LE = function(A, O) {
            return D(this, A, !0, O);
          }, m.prototype.readInt32BE = function(A, O) {
            return D(this, A, !1, O);
          }, m.prototype.readFloatLE = function(A, O) {
            return E(this, A, !0, O);
          }, m.prototype.readFloatBE = function(A, O) {
            return E(this, A, !1, O);
          }, m.prototype.readDoubleLE = function(A, O) {
            return b(this, A, !0, O);
          }, m.prototype.readDoubleBE = function(A, O) {
            return b(this, A, !1, O);
          }, m.prototype.writeUInt8 = function(A, O, R) {
            R || (Q(A != null, "missing value"), Q(O != null, "missing offset"), Q(O < this.length, "trying to write beyond buffer length"), Se(A, 255)), O >= this.length || (this[O] = A);
          }, m.prototype.writeUInt16LE = function(A, O, R) {
            y(this, A, O, !0, R);
          }, m.prototype.writeUInt16BE = function(A, O, R) {
            y(this, A, O, !1, R);
          }, m.prototype.writeUInt32LE = function(A, O, R) {
            S(this, A, O, !0, R);
          }, m.prototype.writeUInt32BE = function(A, O, R) {
            S(this, A, O, !1, R);
          }, m.prototype.writeInt8 = function(A, O, R) {
            R || (Q(A != null, "missing value"), Q(O != null, "missing offset"), Q(O < this.length, "Trying to write beyond buffer length"), me(A, 127, -128)), O >= this.length || (0 <= A ? this.writeUInt8(A, O, R) : this.writeUInt8(255 + A + 1, O, R));
          }, m.prototype.writeInt16LE = function(A, O, R) {
            P(this, A, O, !0, R);
          }, m.prototype.writeInt16BE = function(A, O, R) {
            P(this, A, O, !1, R);
          }, m.prototype.writeInt32LE = function(A, O, R) {
            M(this, A, O, !0, R);
          }, m.prototype.writeInt32BE = function(A, O, R) {
            M(this, A, O, !1, R);
          }, m.prototype.writeFloatLE = function(A, O, R) {
            T(this, A, O, !0, R);
          }, m.prototype.writeFloatBE = function(A, O, R) {
            T(this, A, O, !1, R);
          }, m.prototype.writeDoubleLE = function(A, O, R) {
            V(this, A, O, !0, R);
          }, m.prototype.writeDoubleBE = function(A, O, R) {
            V(this, A, O, !1, R);
          }, m.prototype.fill = function(A, O, R) {
            if (O = O || 0, R = R || this.length, Q(typeof (A = typeof (A = A || 0) == "string" ? A.charCodeAt(0) : A) == "number" && !isNaN(A), "value is not a number"), Q(O <= R, "end < start"), R !== O && this.length !== 0) {
              Q(0 <= O && O < this.length, "start out of bounds"), Q(0 <= R && R <= this.length, "end out of bounds");
              for (var j = O; j < R; j++) this[j] = A;
            }
          }, m.prototype.inspect = function() {
            for (var A = [], O = this.length, R = 0; R < O; R++) if (A[R] = C(this[R]), R === i.INSPECT_MAX_BYTES) {
              A[R + 1] = "...";
              break;
            }
            return "<Buffer " + A.join(" ") + ">";
          }, m.prototype.toArrayBuffer = function() {
            if (typeof Uint8Array > "u") throw new Error("Buffer.toArrayBuffer not supported in this browser");
            if (m._useTypedArrays) return new m(this).buffer;
            for (var A = new Uint8Array(this.length), O = 0, R = A.length; O < R; O += 1) A[O] = this[O];
            return A.buffer;
          };
          var z = m.prototype;
          function U(A, O, R) {
            return typeof A != "number" ? R : O <= (A = ~~A) ? O : 0 <= A || 0 <= (A += O) ? A : 0;
          }
          function B(A) {
            return (A = ~~Math.ceil(+A)) < 0 ? 0 : A;
          }
          function N(A) {
            return (Array.isArray || function(O) {
              return Object.prototype.toString.call(O) === "[object Array]";
            })(A);
          }
          function C(A) {
            return A < 16 ? "0" + A.toString(16) : A.toString(16);
          }
          function G(A) {
            for (var O = [], R = 0; R < A.length; R++) {
              var j = A.charCodeAt(R);
              if (j <= 127) O.push(A.charCodeAt(R));
              else for (var q = R, Y = (55296 <= j && j <= 57343 && R++, encodeURIComponent(A.slice(q, R + 1)).substr(1).split("%")), ae = 0; ae < Y.length; ae++) O.push(parseInt(Y[ae], 16));
            }
            return O;
          }
          function re(A) {
            return h.toByteArray(A);
          }
          function ie(A, O, R, j) {
            for (var q = 0; q < j && !(q + R >= O.length || q >= A.length); q++) O[q + R] = A[q];
            return q;
          }
          function X(A) {
            try {
              return decodeURIComponent(A);
            } catch {
              return "�";
            }
          }
          function Se(A, O) {
            Q(typeof A == "number", "cannot write a non-number as a number"), Q(0 <= A, "specified a negative value for writing an unsigned value"), Q(A <= O, "value is larger than maximum value for type"), Q(Math.floor(A) === A, "value has a fractional component");
          }
          function me(A, O, R) {
            Q(typeof A == "number", "cannot write a non-number as a number"), Q(A <= O, "value larger than maximum allowed value"), Q(R <= A, "value smaller than minimum allowed value"), Q(Math.floor(A) === A, "value has a fractional component");
          }
          function fe(A, O, R) {
            Q(typeof A == "number", "cannot write a non-number as a number"), Q(A <= O, "value larger than maximum allowed value"), Q(R <= A, "value smaller than minimum allowed value");
          }
          function Q(A, O) {
            if (!A) throw new Error(O || "Failed assertion");
          }
          m._augment = function(A) {
            return A._isBuffer = !0, A._get = A.get, A._set = A.set, A.get = z.get, A.set = z.set, A.write = z.write, A.toString = z.toString, A.toLocaleString = z.toString, A.toJSON = z.toJSON, A.copy = z.copy, A.slice = z.slice, A.readUInt8 = z.readUInt8, A.readUInt16LE = z.readUInt16LE, A.readUInt16BE = z.readUInt16BE, A.readUInt32LE = z.readUInt32LE, A.readUInt32BE = z.readUInt32BE, A.readInt8 = z.readInt8, A.readInt16LE = z.readInt16LE, A.readInt16BE = z.readInt16BE, A.readInt32LE = z.readInt32LE, A.readInt32BE = z.readInt32BE, A.readFloatLE = z.readFloatLE, A.readFloatBE = z.readFloatBE, A.readDoubleLE = z.readDoubleLE, A.readDoubleBE = z.readDoubleBE, A.writeUInt8 = z.writeUInt8, A.writeUInt16LE = z.writeUInt16LE, A.writeUInt16BE = z.writeUInt16BE, A.writeUInt32LE = z.writeUInt32LE, A.writeUInt32BE = z.writeUInt32BE, A.writeInt8 = z.writeInt8, A.writeInt16LE = z.writeInt16LE, A.writeInt16BE = z.writeInt16BE, A.writeInt32LE = z.writeInt32LE, A.writeInt32BE = z.writeInt32BE, A.writeFloatLE = z.writeFloatLE, A.writeFloatBE = z.writeFloatBE, A.writeDoubleLE = z.writeDoubleLE, A.writeDoubleBE = z.writeDoubleBE, A.fill = z.fill, A.inspect = z.inspect, A.toArrayBuffer = z.toArrayBuffer, A;
          };
        }).call(this, n("lYpoI2"), typeof self < "u" ? self : typeof window < "u" ? window : {}, n("buffer").Buffer, arguments[3], arguments[4], arguments[5], arguments[6], "/node_modules/gulp-browserify/node_modules/buffer/index.js", "/node_modules/gulp-browserify/node_modules/buffer");
      }, { "base64-js": 2, buffer: 3, ieee754: 10, lYpoI2: 11 }], 4: [function(n, r, i) {
        (function(o, a, h, l, u, c, f, d, p) {
          var h = n("buffer").Buffer, v = 4, m = new h(v);
          m.fill(0), r.exports = { hash: function(g, _, x, w) {
            for (var $ = _((function(y, S) {
              y.length % v != 0 && (P = y.length + (v - y.length % v), y = h.concat([y, m], P));
              for (var P, M = [], T = S ? y.readInt32BE : y.readInt32LE, V = 0; V < y.length; V += v) M.push(T.call(y, V));
              return M;
            })(g = h.isBuffer(g) ? g : new h(g), w), 8 * g.length), _ = w, k = new h(x), D = _ ? k.writeInt32BE : k.writeInt32LE, E = 0; E < $.length; E++) D.call(k, $[E], 4 * E, !0);
            return k;
          } };
        }).call(this, n("lYpoI2"), typeof self < "u" ? self : typeof window < "u" ? window : {}, n("buffer").Buffer, arguments[3], arguments[4], arguments[5], arguments[6], "/node_modules/gulp-browserify/node_modules/crypto-browserify/helpers.js", "/node_modules/gulp-browserify/node_modules/crypto-browserify");
      }, { buffer: 3, lYpoI2: 11 }], 5: [function(n, r, i) {
        (function(o, a, h, l, u, c, f, d, p) {
          var h = n("buffer").Buffer, v = n("./sha"), m = n("./sha256"), g = n("./rng"), _ = { sha1: v, sha256: m, md5: n("./md5") }, x = 64, w = new h(x);
          function $(y, S) {
            var P = _[y = y || "sha1"], M = [];
            return P || k("algorithm:", y, "is not yet supported"), { update: function(T) {
              return h.isBuffer(T) || (T = new h(T)), M.push(T), T.length, this;
            }, digest: function(T) {
              var V = h.concat(M), V = S ? (function(z, U, B) {
                h.isBuffer(U) || (U = new h(U)), h.isBuffer(B) || (B = new h(B)), U.length > x ? U = z(U) : U.length < x && (U = h.concat([U, w], x));
                for (var N = new h(x), C = new h(x), G = 0; G < x; G++) N[G] = 54 ^ U[G], C[G] = 92 ^ U[G];
                return B = z(h.concat([N, B])), z(h.concat([C, B]));
              })(P, S, V) : P(V);
              return M = null, T ? V.toString(T) : V;
            } };
          }
          function k() {
            var y = [].slice.call(arguments).join(" ");
            throw new Error([y, "we accept pull requests", "http://github.com/dominictarr/crypto-browserify"].join(`
`));
          }
          w.fill(0), i.createHash = function(y) {
            return $(y);
          }, i.createHmac = $, i.randomBytes = function(y, S) {
            if (!S || !S.call) return new h(g(y));
            try {
              S.call(this, void 0, new h(g(y)));
            } catch (P) {
              S(P);
            }
          };
          var D, E = ["createCredentials", "createCipher", "createCipheriv", "createDecipher", "createDecipheriv", "createSign", "createVerify", "createDiffieHellman", "pbkdf2"], b = function(y) {
            i[y] = function() {
              k("sorry,", y, "is not implemented yet");
            };
          };
          for (D in E) b(E[D]);
        }).call(this, n("lYpoI2"), typeof self < "u" ? self : typeof window < "u" ? window : {}, n("buffer").Buffer, arguments[3], arguments[4], arguments[5], arguments[6], "/node_modules/gulp-browserify/node_modules/crypto-browserify/index.js", "/node_modules/gulp-browserify/node_modules/crypto-browserify");
      }, { "./md5": 6, "./rng": 7, "./sha": 8, "./sha256": 9, buffer: 3, lYpoI2: 11 }], 6: [function(n, r, i) {
        (function(o, a, s, l, u, c, f, d, p) {
          var h = n("./helpers");
          function v(k, D) {
            k[D >> 5] |= 128 << D % 32, k[14 + (D + 64 >>> 9 << 4)] = D;
            for (var E = 1732584193, b = -271733879, y = -1732584194, S = 271733878, P = 0; P < k.length; P += 16) {
              var M = E, T = b, V = y, z = S, E = g(E, b, y, S, k[P + 0], 7, -680876936), S = g(S, E, b, y, k[P + 1], 12, -389564586), y = g(y, S, E, b, k[P + 2], 17, 606105819), b = g(b, y, S, E, k[P + 3], 22, -1044525330);
              E = g(E, b, y, S, k[P + 4], 7, -176418897), S = g(S, E, b, y, k[P + 5], 12, 1200080426), y = g(y, S, E, b, k[P + 6], 17, -1473231341), b = g(b, y, S, E, k[P + 7], 22, -45705983), E = g(E, b, y, S, k[P + 8], 7, 1770035416), S = g(S, E, b, y, k[P + 9], 12, -1958414417), y = g(y, S, E, b, k[P + 10], 17, -42063), b = g(b, y, S, E, k[P + 11], 22, -1990404162), E = g(E, b, y, S, k[P + 12], 7, 1804603682), S = g(S, E, b, y, k[P + 13], 12, -40341101), y = g(y, S, E, b, k[P + 14], 17, -1502002290), E = _(E, b = g(b, y, S, E, k[P + 15], 22, 1236535329), y, S, k[P + 1], 5, -165796510), S = _(S, E, b, y, k[P + 6], 9, -1069501632), y = _(y, S, E, b, k[P + 11], 14, 643717713), b = _(b, y, S, E, k[P + 0], 20, -373897302), E = _(E, b, y, S, k[P + 5], 5, -701558691), S = _(S, E, b, y, k[P + 10], 9, 38016083), y = _(y, S, E, b, k[P + 15], 14, -660478335), b = _(b, y, S, E, k[P + 4], 20, -405537848), E = _(E, b, y, S, k[P + 9], 5, 568446438), S = _(S, E, b, y, k[P + 14], 9, -1019803690), y = _(y, S, E, b, k[P + 3], 14, -187363961), b = _(b, y, S, E, k[P + 8], 20, 1163531501), E = _(E, b, y, S, k[P + 13], 5, -1444681467), S = _(S, E, b, y, k[P + 2], 9, -51403784), y = _(y, S, E, b, k[P + 7], 14, 1735328473), E = x(E, b = _(b, y, S, E, k[P + 12], 20, -1926607734), y, S, k[P + 5], 4, -378558), S = x(S, E, b, y, k[P + 8], 11, -2022574463), y = x(y, S, E, b, k[P + 11], 16, 1839030562), b = x(b, y, S, E, k[P + 14], 23, -35309556), E = x(E, b, y, S, k[P + 1], 4, -1530992060), S = x(S, E, b, y, k[P + 4], 11, 1272893353), y = x(y, S, E, b, k[P + 7], 16, -155497632), b = x(b, y, S, E, k[P + 10], 23, -1094730640), E = x(E, b, y, S, k[P + 13], 4, 681279174), S = x(S, E, b, y, k[P + 0], 11, -358537222), y = x(y, S, E, b, k[P + 3], 16, -722521979), b = x(b, y, S, E, k[P + 6], 23, 76029189), E = x(E, b, y, S, k[P + 9], 4, -640364487), S = x(S, E, b, y, k[P + 12], 11, -421815835), y = x(y, S, E, b, k[P + 15], 16, 530742520), E = w(E, b = x(b, y, S, E, k[P + 2], 23, -995338651), y, S, k[P + 0], 6, -198630844), S = w(S, E, b, y, k[P + 7], 10, 1126891415), y = w(y, S, E, b, k[P + 14], 15, -1416354905), b = w(b, y, S, E, k[P + 5], 21, -57434055), E = w(E, b, y, S, k[P + 12], 6, 1700485571), S = w(S, E, b, y, k[P + 3], 10, -1894986606), y = w(y, S, E, b, k[P + 10], 15, -1051523), b = w(b, y, S, E, k[P + 1], 21, -2054922799), E = w(E, b, y, S, k[P + 8], 6, 1873313359), S = w(S, E, b, y, k[P + 15], 10, -30611744), y = w(y, S, E, b, k[P + 6], 15, -1560198380), b = w(b, y, S, E, k[P + 13], 21, 1309151649), E = w(E, b, y, S, k[P + 4], 6, -145523070), S = w(S, E, b, y, k[P + 11], 10, -1120210379), y = w(y, S, E, b, k[P + 2], 15, 718787259), b = w(b, y, S, E, k[P + 9], 21, -343485551), E = $(E, M), b = $(b, T), y = $(y, V), S = $(S, z);
            }
            return Array(E, b, y, S);
          }
          function m(k, D, E, b, y, S) {
            return $((D = $($(D, k), $(b, S))) << y | D >>> 32 - y, E);
          }
          function g(k, D, E, b, y, S, P) {
            return m(D & E | ~D & b, k, D, y, S, P);
          }
          function _(k, D, E, b, y, S, P) {
            return m(D & b | E & ~b, k, D, y, S, P);
          }
          function x(k, D, E, b, y, S, P) {
            return m(D ^ E ^ b, k, D, y, S, P);
          }
          function w(k, D, E, b, y, S, P) {
            return m(E ^ (D | ~b), k, D, y, S, P);
          }
          function $(k, D) {
            var E = (65535 & k) + (65535 & D);
            return (k >> 16) + (D >> 16) + (E >> 16) << 16 | 65535 & E;
          }
          r.exports = function(k) {
            return h.hash(k, v, 16);
          };
        }).call(this, n("lYpoI2"), typeof self < "u" ? self : typeof window < "u" ? window : {}, n("buffer").Buffer, arguments[3], arguments[4], arguments[5], arguments[6], "/node_modules/gulp-browserify/node_modules/crypto-browserify/md5.js", "/node_modules/gulp-browserify/node_modules/crypto-browserify");
      }, { "./helpers": 4, buffer: 3, lYpoI2: 11 }], 7: [function(n, r, i) {
        (function(o, a, s, l, u, c, f, d, p) {
          r.exports = function(h) {
            for (var v, m = new Array(h), g = 0; g < h; g++) (3 & g) == 0 && (v = 4294967296 * Math.random()), m[g] = v >>> ((3 & g) << 3) & 255;
            return m;
          };
        }).call(this, n("lYpoI2"), typeof self < "u" ? self : typeof window < "u" ? window : {}, n("buffer").Buffer, arguments[3], arguments[4], arguments[5], arguments[6], "/node_modules/gulp-browserify/node_modules/crypto-browserify/rng.js", "/node_modules/gulp-browserify/node_modules/crypto-browserify");
      }, { buffer: 3, lYpoI2: 11 }], 8: [function(n, r, i) {
        (function(o, a, s, l, u, c, f, d, p) {
          var h = n("./helpers");
          function v(_, x) {
            _[x >> 5] |= 128 << 24 - x % 32, _[15 + (x + 64 >> 9 << 4)] = x;
            for (var w, $, k, D = Array(80), E = 1732584193, b = -271733879, y = -1732584194, S = 271733878, P = -1009589776, M = 0; M < _.length; M += 16) {
              for (var T = E, V = b, z = y, U = S, B = P, N = 0; N < 80; N++) {
                D[N] = N < 16 ? _[M + N] : g(D[N - 3] ^ D[N - 8] ^ D[N - 14] ^ D[N - 16], 1);
                var C = m(m(g(E, 5), (C = b, $ = y, k = S, (w = N) < 20 ? C & $ | ~C & k : !(w < 40) && w < 60 ? C & $ | C & k | $ & k : C ^ $ ^ k)), m(m(P, D[N]), (w = N) < 20 ? 1518500249 : w < 40 ? 1859775393 : w < 60 ? -1894007588 : -899497514)), P = S, S = y, y = g(b, 30), b = E, E = C;
              }
              E = m(E, T), b = m(b, V), y = m(y, z), S = m(S, U), P = m(P, B);
            }
            return Array(E, b, y, S, P);
          }
          function m(_, x) {
            var w = (65535 & _) + (65535 & x);
            return (_ >> 16) + (x >> 16) + (w >> 16) << 16 | 65535 & w;
          }
          function g(_, x) {
            return _ << x | _ >>> 32 - x;
          }
          r.exports = function(_) {
            return h.hash(_, v, 20, !0);
          };
        }).call(this, n("lYpoI2"), typeof self < "u" ? self : typeof window < "u" ? window : {}, n("buffer").Buffer, arguments[3], arguments[4], arguments[5], arguments[6], "/node_modules/gulp-browserify/node_modules/crypto-browserify/sha.js", "/node_modules/gulp-browserify/node_modules/crypto-browserify");
      }, { "./helpers": 4, buffer: 3, lYpoI2: 11 }], 9: [function(n, r, i) {
        (function(o, a, s, l, u, c, f, d, p) {
          function h(x, w) {
            var $ = (65535 & x) + (65535 & w);
            return (x >> 16) + (w >> 16) + ($ >> 16) << 16 | 65535 & $;
          }
          function v(x, w) {
            var $, k = new Array(1116352408, 1899447441, 3049323471, 3921009573, 961987163, 1508970993, 2453635748, 2870763221, 3624381080, 310598401, 607225278, 1426881987, 1925078388, 2162078206, 2614888103, 3248222580, 3835390401, 4022224774, 264347078, 604807628, 770255983, 1249150122, 1555081692, 1996064986, 2554220882, 2821834349, 2952996808, 3210313671, 3336571891, 3584528711, 113926993, 338241895, 666307205, 773529912, 1294757372, 1396182291, 1695183700, 1986661051, 2177026350, 2456956037, 2730485921, 2820302411, 3259730800, 3345764771, 3516065817, 3600352804, 4094571909, 275423344, 430227734, 506948616, 659060556, 883997877, 958139571, 1322822218, 1537002063, 1747873779, 1955562222, 2024104815, 2227730452, 2361852424, 2428436474, 2756734187, 3204031479, 3329325298), D = new Array(1779033703, 3144134277, 1013904242, 2773480762, 1359893119, 2600822924, 528734635, 1541459225), E = new Array(64);
            x[w >> 5] |= 128 << 24 - w % 32, x[15 + (w + 64 >> 9 << 4)] = w;
            for (var b, y, S = 0; S < x.length; S += 16) {
              for (var P = D[0], M = D[1], T = D[2], V = D[3], z = D[4], U = D[5], B = D[6], N = D[7], C = 0; C < 64; C++) E[C] = C < 16 ? x[C + S] : h(h(h((y = E[C - 2], g(y, 17) ^ g(y, 19) ^ _(y, 10)), E[C - 7]), (y = E[C - 15], g(y, 7) ^ g(y, 18) ^ _(y, 3))), E[C - 16]), $ = h(h(h(h(N, g(y = z, 6) ^ g(y, 11) ^ g(y, 25)), z & U ^ ~z & B), k[C]), E[C]), b = h(g(b = P, 2) ^ g(b, 13) ^ g(b, 22), P & M ^ P & T ^ M & T), N = B, B = U, U = z, z = h(V, $), V = T, T = M, M = P, P = h($, b);
              D[0] = h(P, D[0]), D[1] = h(M, D[1]), D[2] = h(T, D[2]), D[3] = h(V, D[3]), D[4] = h(z, D[4]), D[5] = h(U, D[5]), D[6] = h(B, D[6]), D[7] = h(N, D[7]);
            }
            return D;
          }
          var m = n("./helpers"), g = function(x, w) {
            return x >>> w | x << 32 - w;
          }, _ = function(x, w) {
            return x >>> w;
          };
          r.exports = function(x) {
            return m.hash(x, v, 32, !0);
          };
        }).call(this, n("lYpoI2"), typeof self < "u" ? self : typeof window < "u" ? window : {}, n("buffer").Buffer, arguments[3], arguments[4], arguments[5], arguments[6], "/node_modules/gulp-browserify/node_modules/crypto-browserify/sha256.js", "/node_modules/gulp-browserify/node_modules/crypto-browserify");
      }, { "./helpers": 4, buffer: 3, lYpoI2: 11 }], 10: [function(n, r, i) {
        (function(o, a, s, l, u, c, f, d, p) {
          i.read = function(h, v, m, g, S) {
            var x, w, $ = 8 * S - g - 1, k = (1 << $) - 1, D = k >> 1, E = -7, b = m ? S - 1 : 0, y = m ? -1 : 1, S = h[v + b];
            for (b += y, x = S & (1 << -E) - 1, S >>= -E, E += $; 0 < E; x = 256 * x + h[v + b], b += y, E -= 8) ;
            for (w = x & (1 << -E) - 1, x >>= -E, E += g; 0 < E; w = 256 * w + h[v + b], b += y, E -= 8) ;
            if (x === 0) x = 1 - D;
            else {
              if (x === k) return w ? NaN : 1 / 0 * (S ? -1 : 1);
              w += Math.pow(2, g), x -= D;
            }
            return (S ? -1 : 1) * w * Math.pow(2, x - g);
          }, i.write = function(h, v, m, g, _, P) {
            var w, $, k = 8 * P - _ - 1, D = (1 << k) - 1, E = D >> 1, b = _ === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0, y = g ? 0 : P - 1, S = g ? 1 : -1, P = v < 0 || v === 0 && 1 / v < 0 ? 1 : 0;
            for (v = Math.abs(v), isNaN(v) || v === 1 / 0 ? ($ = isNaN(v) ? 1 : 0, w = D) : (w = Math.floor(Math.log(v) / Math.LN2), v * (g = Math.pow(2, -w)) < 1 && (w--, g *= 2), 2 <= (v += 1 <= w + E ? b / g : b * Math.pow(2, 1 - E)) * g && (w++, g /= 2), D <= w + E ? ($ = 0, w = D) : 1 <= w + E ? ($ = (v * g - 1) * Math.pow(2, _), w += E) : ($ = v * Math.pow(2, E - 1) * Math.pow(2, _), w = 0)); 8 <= _; h[m + y] = 255 & $, y += S, $ /= 256, _ -= 8) ;
            for (w = w << _ | $, k += _; 0 < k; h[m + y] = 255 & w, y += S, w /= 256, k -= 8) ;
            h[m + y - S] |= 128 * P;
          };
        }).call(this, n("lYpoI2"), typeof self < "u" ? self : typeof window < "u" ? window : {}, n("buffer").Buffer, arguments[3], arguments[4], arguments[5], arguments[6], "/node_modules/gulp-browserify/node_modules/ieee754/index.js", "/node_modules/gulp-browserify/node_modules/ieee754");
      }, { buffer: 3, lYpoI2: 11 }], 11: [function(n, r, i) {
        (function(o, a, s, l, u, c, f, d, p) {
          var h, v, m;
          function g() {
          }
          (o = r.exports = {}).nextTick = (v = typeof window < "u" && window.setImmediate, m = typeof window < "u" && window.postMessage && window.addEventListener, v ? function(_) {
            return window.setImmediate(_);
          } : m ? (h = [], window.addEventListener("message", function(_) {
            var x = _.source;
            x !== window && x !== null || _.data !== "process-tick" || (_.stopPropagation(), 0 < h.length && h.shift()());
          }, !0), function(_) {
            h.push(_), window.postMessage("process-tick", "*");
          }) : function(_) {
            setTimeout(_, 0);
          }), o.title = "browser", o.browser = !0, o.env = {}, o.argv = [], o.on = g, o.addListener = g, o.once = g, o.off = g, o.removeListener = g, o.removeAllListeners = g, o.emit = g, o.binding = function(_) {
            throw new Error("process.binding is not supported");
          }, o.cwd = function() {
            return "/";
          }, o.chdir = function(_) {
            throw new Error("process.chdir is not supported");
          };
        }).call(this, n("lYpoI2"), typeof self < "u" ? self : typeof window < "u" ? window : {}, n("buffer").Buffer, arguments[3], arguments[4], arguments[5], arguments[6], "/node_modules/gulp-browserify/node_modules/process/browser.js", "/node_modules/gulp-browserify/node_modules/process");
      }, { buffer: 3, lYpoI2: 11 }] }, {}, [1])(1);
    });
  })(zm)), zm.exports;
}
var kae = $ae();
const na = /* @__PURE__ */ fy(kae), Tae = ({
  children: e,
  showMenu: t
}) => /* @__PURE__ */ I.jsx(
  "div",
  {
    className: `absolute left-0 right-0 z-50 overflow-scroll rounded max-h-40 ${t ? "block" : "hidden"}`,
    children: e
  }
);
function Ese({
  options: e,
  onSelect: t,
  displayKey: n
}) {
  const [r, i] = Ke(!1), o = ve(null), a = () => i(!0), [s, l] = Ke(""), u = Fe(() => {
    if (!s) return e;
    const c = new RegExp(s, "i");
    return e.filter((f) => n ? f[n].match(c) : f.match(c));
  }, [s, e]);
  return oY(o, () => i(!1)), eC(
    {
      Escape: () => i(!1)
    },
    [i]
  ), /* @__PURE__ */ I.jsxs("div", { className: "relative", onFocus: a, children: [
    /* @__PURE__ */ I.jsx(
      pd,
      {
        autoComplete: "off",
        ref: o,
        type: "text",
        onChange: (c) => l(c.target.value),
        value: s
      }
    ),
    /* @__PURE__ */ I.jsx(Tae, { showMenu: r, children: /* @__PURE__ */ I.jsxs(
      Un.ul,
      {
        className: "flex flex-col w-full h-full p-2 rounded shadow-lg bg-neutral-200",
        layout: !0,
        children: [
          u.length > 0 && u.map((c) => /* @__PURE__ */ I.jsx("li", { className: "hover:text-blue-500", children: /* @__PURE__ */ I.jsx(
            "button",
            {
              onClick: () => {
                t(c), l(
                  n ? c[n] : c
                );
              },
              children: n ? c[n] : c
            }
          ) }, na(c))),
          r && u.length === 0 && /* @__PURE__ */ I.jsx("p", { className: "italic", children: "No Results" })
        ]
      }
    ) })
  ] });
}
const Sse = () => /* @__PURE__ */ I.jsx("div", { className: "loader" }), $se = () => /* @__PURE__ */ I.jsx("p", { children: "Loading..." });
function kse({
  row: e,
  data: t,
  extras: n = [],
  hide: r,
  transform: i,
  editable: o = !1,
  onEdit: a,
  defaultSortKey: s,
  className: l = "",
  render: u,
  renderHeading: c,
  cell: f
}) {
  const [d, p] = Ke(s ?? ""), [h, v] = Ke(
    "desc"
    /* Descending */
  ), [m, g] = Ke({
    key: "",
    newValue: "",
    value: "",
    hashedRow: ""
  }), _ = Fe(() => [...t], [t]), x = ve(null), w = Fe(() => d ? _.sort((S, P) => {
    const M = S[d] ?? "", T = P[d] ?? "";
    return M < T ? h === "asc" ? -1 : 1 : M > T ? h === "asc" ? 1 : -1 : 0;
  }) : _, [d, _, h]), $ = Fe(() => _.length === 0 ? [] : Object.getOwnPropertyNames(_[0]).reduce((P, M) => {
    if (r?.[M])
      return P;
    if (i && i[M]) {
      const T = i[M](M);
      return [
        ...P,
        {
          key: M,
          transformed: T
        }
      ];
    } else
      return console.log(
        `No transform for column ${M}, using key as transformed value`
      ), [...P, { key: M, transformed: M }];
  }, []), [_]), k = Le(
    (S, P) => u?.[S] ? u[S](P) : S === m.key && na(P) === m.hashedRow && o ? /* @__PURE__ */ I.jsxs(I.Fragment, { children: [
      /* @__PURE__ */ I.jsx(
        "form",
        {
          className: "absolute left-0 right-0 top-0 bottom-0",
          onSubmit: (M) => {
            M.preventDefault(), a && a({
              column: m.key,
              newValue: m.newValue,
              oldValue: m.value,
              rowData: P
            }), g({
              key: "",
              value: "",
              newValue: "",
              hashedRow: ""
            }), x.current?.blur();
          },
          children: /* @__PURE__ */ I.jsx(
            "textarea",
            {
              className: "w-full h-full",
              onBlur: () => {
                a?.({
                  column: m.key,
                  newValue: m.newValue,
                  oldValue: m.value,
                  rowData: P
                }), g({
                  key: "",
                  value: "",
                  newValue: "",
                  hashedRow: ""
                });
              },
              ref: x,
              autoFocus: !0,
              value: m.newValue,
              onChange: (M) => g({
                key: S,
                value: P[S],
                newValue: M.target.value,
                hashedRow: na(P)
              })
            },
            `${na(P)}}-${S}-${P[S]}-input`
          )
        }
      ),
      /* @__PURE__ */ I.jsx("p", { className: "invisible", children: P[S] })
    ] }) : /* @__PURE__ */ I.jsx("div", { children: P[S] }),
    [m, u]
  ), D = e ?? ((S) => /* @__PURE__ */ I.jsx("tr", { ...S })), E = (S) => c ? /* @__PURE__ */ I.jsx(I.Fragment, { children: c(S.children) }) : /* @__PURE__ */ I.jsx("tr", { ...S });
  let b = !0;
  Oae(c) && (c ? b = !0 : b = !1);
  const y = f ?? "td";
  return /* @__PURE__ */ I.jsxs("table", { className: l, children: [
    b && /* @__PURE__ */ I.jsx("thead", { children: /* @__PURE__ */ I.jsxs(E, { children: [
      $.map(
        ({ key: S, transformed: P }) => !r?.[S] && /* @__PURE__ */ I.jsx(
          "th",
          {
            onClick: () => {
              d == S ? v(
                () => h === "asc" ? "desc" : "asc"
                /* Ascending */
              ) : (p(S), v(
                "asc"
                /* Ascending */
              ));
            },
            children: /* @__PURE__ */ I.jsxs("div", { className: "flex justify-start items-center", children: [
              P,
              S === d && h === "asc" && /* @__PURE__ */ I.jsx(
                yr,
                {
                  className: "mx-1",
                  size: "sm",
                  icon: cI
                }
              ),
              S === d && h === "desc" && /* @__PURE__ */ I.jsx(
                yr,
                {
                  className: "mx-1",
                  size: "sm",
                  icon: c$
                }
              )
            ] })
          },
          S
        )
      ),
      (n || []).map(({ key: S }, P) => /* @__PURE__ */ I.jsx("th", { children: S }, `extras-${S}-${P}`))
    ] }) }),
    /* @__PURE__ */ I.jsx("tbody", { children: w.map(
      (S) => D(
        {
          key: na(S),
          children: Object.entries(S).map(([P, M]) => r?.[P] ? null : !r?.[P] && /* @__PURE__ */ I.jsx(
            y,
            {
              title: M,
              onClick: () => {
                o && !u?.[P] && g({
                  key: P,
                  value: M,
                  newValue: M,
                  hashedRow: na(S)
                });
              },
              children: k(P, S)
            },
            `${na(S)}}-${P}-${M}`
          ))
        },
        S
      )
    ) })
  ] });
}
function Oae(e) {
  return typeof e == "boolean";
}
const r6 = He(
  {}
);
function Pae(e) {
  return /* @__PURE__ */ I.jsx(r6.Provider, { value: e.value, children: e.children });
}
const e1 = () => je(r6);
function Aae({ items: e }) {
  const { activeTab: t, setActiveTab: n } = e1();
  return /* @__PURE__ */ I.jsx(
    "div",
    {
      className: "flex w-full bg-black overflow-x-scroll self-baseline tabs-list overflow-y-hidden",
      children: e.map((r) => /* @__PURE__ */ I.jsx(
        Cae,
        {
          label: r.label,
          active: t === r.value,
          value: r.value,
          onClick: (i) => {
            n(i);
          }
        },
        `tab-${r.value}`
      ))
    }
  );
}
const Dae = Lr(
  [
    "last:border-none",
    "border-r",
    "flex-shrink-0",
    "px-4",
    "pb-4",
    "hover:bg-gray-200",
    "whitespace-nowrap",
    "overflow-hidden",
    "text-ellipsis",
    "self-baseline"
  ],
  {
    variants: {
      active: {
        false: "bg-black text-white",
        true: "bg-white text-black"
      }
    }
  }
);
function Cae(e) {
  return /* @__PURE__ */ I.jsx(
    "button",
    {
      onClick: () => e.onClick(e.value),
      className: Dae({ active: e.active }),
      children: e.label
    }
  );
}
function Iae({
  children: e,
  className: t,
  value: n
}) {
  const { activeTab: r, contentRef: i } = e1();
  return r !== n || !i ? null : ba(
    /* @__PURE__ */ I.jsx("div", { className: `flex flex-col flex-grow h-full w-full ${t || ""} overflow-hidden`, children: e }),
    i
  );
}
const Mae = (({
  children: e,
  items: t,
  onChange: n,
  activeTab: r
}) => {
  const [i, o] = Ke(null);
  return /* @__PURE__ */ I.jsx(
    Pae,
    {
      value: {
        activeTab: r,
        setActiveTab: (a) => {
          n?.(a);
        },
        contentRef: i
      },
      children: /* @__PURE__ */ I.jsxs("div", { className: "flex flex-col tabs h-full overflow-hidden", children: [
        /* @__PURE__ */ I.jsx(Aae, { items: t }),
        /* @__PURE__ */ I.jsx(
          "div",
          {
            className: "flex flex-col flex-grow-[2] h-full w-full overflow-hidden",
            ref: o,
            children: e
          }
        )
      ] })
    }
  );
});
Mae.Tab = Iae;
const Rae = Lr([
  "rounded",
  "px-4",
  "py-2",
  "bg-neutral-50",
  "mr-1",
  "hover:bg-neutral-100",
  "hover:text-black",
  "text-neutral-800"
], {
  variants: {
    active: {
      true: ["bg-black", "hover:bg-black", "text-white"],
      false: []
    }
  }
}), Tse = ({ value: e, children: t }) => {
  const { activeTab: n, setActiveTab: r } = e1();
  return /* @__PURE__ */ I.jsx(
    "button",
    {
      className: Rae({ active: n === e }),
      onClick: () => r(e),
      children: t
    }
  );
}, Ose = ({
  jobId: e,
  className: t = ""
}) => {
  const { data: n } = fae({ variables: { jobId: e } }), [r, i] = Ke([]);
  return ze(() => {
    n?.taskQueueLogs && i((o) => [...o, n.taskQueueLogs]);
  }, [n]), /* @__PURE__ */ I.jsx(
    "div",
    {
      className: `${t} relative h-full p-4 overflow-y-scroll rounded bg-neutral-200 text-neutral-800`,
      children: r.map((o, a) => /* @__PURE__ */ I.jsx("pre", { children: o.message }, `task-queue-${e}-${o.timestamp}-${a}`))
    }
  );
}, i6 = He({}), Pse = () => je(i6), Nae = (e = !1) => {
  const [t, n] = Ke(e);
  return ze(() => {
    const r = localStorage.getItem("darkMode");
    try {
      const i = JSON.parse(r || "");
      n(i.darkMode);
    } catch {
      localStorage.setItem(
        "darkMode",
        JSON.stringify({ darkMode: e })
      );
    }
  }, [n]), ze(() => {
    localStorage.setItem("darkMode", JSON.stringify({ darkMode: t }));
  }, [t]), {
    darkMode: !1,
    // disable dark mode for now
    setDarkMode: (r) => {
      localStorage.setItem("darkMode", JSON.stringify({ darkMode: !r })), n(r);
    }
  };
}, Ase = ({ children: e }) => {
  const { darkMode: t, setDarkMode: n } = Nae();
  return ze(() => {
    const r = document.querySelector("body");
    r && r.classList.remove("dark");
  }, [t]), /* @__PURE__ */ I.jsx(i6.Provider, { value: { darkMode: t, setDarkMode: n }, children: /* @__PURE__ */ I.jsx("div", { className: "", children: e }) });
}, Dse = ({
  order: e,
  children: t,
  className: n = ""
}) => {
  function r(i, o) {
    switch (i) {
      case 1:
        return /* @__PURE__ */ I.jsx("h1", { className: `${n} text-2xl text-brand-500`, children: o });
      case 2:
        return /* @__PURE__ */ I.jsx("h2", { className: `${n} text-xl text-brand-600`, children: o });
      case 3:
        return /* @__PURE__ */ I.jsx("h3", { className: `${n} text-brand-800`, children: o });
      case 4:
        return /* @__PURE__ */ I.jsx("h4", { children: o });
      case 5:
        return /* @__PURE__ */ I.jsx("h5", { children: o });
      default:
      case 6:
        return /* @__PURE__ */ I.jsx("h6", { children: o });
    }
  }
  return r(e, t);
};
function Cse({ on: e, onChange: t, className: n = "" }) {
  return /* @__PURE__ */ I.jsx(
    Un.button,
    {
      layout: !0,
      onClick: () => t(!e),
      className: `
                w-12 h-4 p-1 items-center ${n} flex rounded transition-colors 
                ${e ? "justify-end bg-black" : "justify-start bg-neutral-100"}
            `,
      children: /* @__PURE__ */ I.jsx(
        Un.div,
        {
          layout: !0,
          className: `w-4 h-2 rounded-sm transition-colors ${e ? "bg-neutral-100" : "bg-neutral-800"}`
        }
      )
    }
  );
}
const Ise = fn(
  ({ className: e, ...t }, n) => /* @__PURE__ */ I.jsx("textarea", { ref: n, ...t, className: rr(
    "dark:bg-neutral-800 dark:text-neutral-200 bg-white text-black px-2 border-black border font-body",
    e
  ) })
);
export {
  ih as AppLayout,
  u$ as Button,
  $se as CircleSpinner,
  Jae as CopyButton,
  ese as Delete,
  tse as Divider,
  nse as Drawer,
  Rv as DrawerButton,
  rse as Dropdown,
  ise as DynamicFormInput,
  ose as Ellipses,
  UV as Error,
  ase as ErrorBoundary,
  pd as Field,
  AQ as FileBrowser,
  mse as FileInput,
  Qae as FlexBox,
  vse as FormikField,
  gse as GridArea,
  cf as ImagePreview,
  iY as Input,
  X3 as Logo,
  $0 as Menu,
  pa as MenuItem,
  lC as MenuItemStyle,
  wQ as MenuStyle,
  oQ as Modal,
  fse as ModalContainer,
  bse as NotFound,
  Yae as Note,
  gae as PDFPreview,
  pae as Page,
  mae as PageHeader,
  hae as PageHeaderTitle,
  _se as Preview,
  Eae as Protected,
  yse as ReaderLayout,
  wse as RequireRoles,
  xse as S3DownloadLink,
  hse as S3FileBrowser,
  yae as SVGPreview,
  BV as Select,
  Ese as SelectionSearch,
  jd as Spacer,
  Sse as Spinner,
  Tse as Tab,
  Iae as TabContent,
  kse as Table,
  GS as TablePreview,
  Mae as Tabs,
  Aae as TabsList,
  Ose as TaskQueueLogs,
  Ise as Textarea,
  i6 as ThemeContext,
  Ase as ThemeProvider,
  Dse as Title,
  Cse as Toggle,
  EQ as UploadToast,
  Koe as _S3FileBrowser,
  Qoe as fileListToArray,
  dae as pageVariants,
  aQ as useModalContext,
  e6 as useTailwindBreakpoint,
  Pse as useTheme
};
//# sourceMappingURL=components.js.map
